/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(27);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {/* Riot v3.5.1, @license MIT */
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.riot = global.riot || {})));
	}(this, (function (exports) { 'use strict';
	
	var __TAGS_CACHE = [];
	var __TAG_IMPL = {};
	var GLOBAL_MIXIN = '__global_mixin';
	var ATTRS_PREFIX = 'riot-';
	var REF_DIRECTIVES = ['ref', 'data-ref'];
	var IS_DIRECTIVE = 'data-is';
	var CONDITIONAL_DIRECTIVE = 'if';
	var LOOP_DIRECTIVE = 'each';
	var LOOP_NO_REORDER_DIRECTIVE = 'no-reorder';
	var SHOW_DIRECTIVE = 'show';
	var HIDE_DIRECTIVE = 'hide';
	var RIOT_EVENTS_KEY = '__riot-events__';
	var T_STRING = 'string';
	var T_OBJECT = 'object';
	var T_UNDEF  = 'undefined';
	var T_FUNCTION = 'function';
	var XLINK_NS = 'http://www.w3.org/1999/xlink';
	var SVG_NS = 'http://www.w3.org/2000/svg';
	var XLINK_REGEX = /^xlink:(\w+)/;
	var WIN = typeof window === T_UNDEF ? undefined : window;
	var RE_SPECIAL_TAGS = /^(?:t(?:body|head|foot|[rhd])|caption|col(?:group)?|opt(?:ion|group))$/;
	var RE_SPECIAL_TAGS_NO_OPTION = /^(?:t(?:body|head|foot|[rhd])|caption|col(?:group)?)$/;
	var RE_EVENTS_PREFIX = /^on/;
	var RE_RESERVED_NAMES = /^(?:_(?:item|id|parent)|update|root|(?:un)?mount|mixin|is(?:Mounted|Loop)|tags|refs|parent|opts|trigger|o(?:n|ff|ne))$/;
	var RE_HTML_ATTRS = /([-\w]+) ?= ?(?:"([^"]*)|'([^']*)|({[^}]*}))/g;
	var CASE_SENSITIVE_ATTRIBUTES = { 'viewbox': 'viewBox' };
	var RE_BOOL_ATTRS = /^(?:disabled|checked|readonly|required|allowfullscreen|auto(?:focus|play)|compact|controls|default|formnovalidate|hidden|ismap|itemscope|loop|multiple|muted|no(?:resize|shade|validate|wrap)?|open|reversed|seamless|selected|sortable|truespeed|typemustmatch)$/;
	var IE_VERSION = (WIN && WIN.document || {}).documentMode | 0;
	
	/**
	 * Check Check if the passed argument is undefined
	 * @param   { String } value -
	 * @returns { Boolean } -
	 */
	function isBoolAttr(value) {
	  return RE_BOOL_ATTRS.test(value)
	}
	
	/**
	 * Check if passed argument is a function
	 * @param   { * } value -
	 * @returns { Boolean } -
	 */
	function isFunction(value) {
	  return typeof value === T_FUNCTION
	}
	
	/**
	 * Check if passed argument is an object, exclude null
	 * NOTE: use isObject(x) && !isArray(x) to excludes arrays.
	 * @param   { * } value -
	 * @returns { Boolean } -
	 */
	function isObject(value) {
	  return value && typeof value === T_OBJECT // typeof null is 'object'
	}
	
	/**
	 * Check if passed argument is undefined
	 * @param   { * } value -
	 * @returns { Boolean } -
	 */
	function isUndefined(value) {
	  return typeof value === T_UNDEF
	}
	
	/**
	 * Check if passed argument is a string
	 * @param   { * } value -
	 * @returns { Boolean } -
	 */
	function isString(value) {
	  return typeof value === T_STRING
	}
	
	/**
	 * Check if passed argument is empty. Different from falsy, because we dont consider 0 or false to be blank
	 * @param { * } value -
	 * @returns { Boolean } -
	 */
	function isBlank(value) {
	  return isUndefined(value) || value === null || value === ''
	}
	
	/**
	 * Check if passed argument is a kind of array
	 * @param   { * } value -
	 * @returns { Boolean } -
	 */
	function isArray(value) {
	  return Array.isArray(value) || value instanceof Array
	}
	
	/**
	 * Check whether object's property could be overridden
	 * @param   { Object }  obj - source object
	 * @param   { String }  key - object property
	 * @returns { Boolean } -
	 */
	function isWritable(obj, key) {
	  var descriptor = Object.getOwnPropertyDescriptor(obj, key);
	  return isUndefined(obj[key]) || descriptor && descriptor.writable
	}
	
	/**
	 * Check if passed argument is a reserved name
	 * @param   { String } value -
	 * @returns { Boolean } -
	 */
	function isReservedName(value) {
	  return RE_RESERVED_NAMES.test(value)
	}
	
	var check = Object.freeze({
		isBoolAttr: isBoolAttr,
		isFunction: isFunction,
		isObject: isObject,
		isUndefined: isUndefined,
		isString: isString,
		isBlank: isBlank,
		isArray: isArray,
		isWritable: isWritable,
		isReservedName: isReservedName
	});
	
	/**
	 * Shorter and fast way to select multiple nodes in the DOM
	 * @param   { String } selector - DOM selector
	 * @param   { Object } ctx - DOM node where the targets of our search will is located
	 * @returns { Object } dom nodes found
	 */
	function $$(selector, ctx) {
	  return Array.prototype.slice.call((ctx || document).querySelectorAll(selector))
	}
	
	/**
	 * Shorter and fast way to select a single node in the DOM
	 * @param   { String } selector - unique dom selector
	 * @param   { Object } ctx - DOM node where the target of our search will is located
	 * @returns { Object } dom node found
	 */
	function $(selector, ctx) {
	  return (ctx || document).querySelector(selector)
	}
	
	/**
	 * Create a document fragment
	 * @returns { Object } document fragment
	 */
	function createFrag() {
	  return document.createDocumentFragment()
	}
	
	/**
	 * Create a document text node
	 * @returns { Object } create a text node to use as placeholder
	 */
	function createDOMPlaceholder() {
	  return document.createTextNode('')
	}
	
	/**
	 * Check if a DOM node is an svg tag
	 * @param   { HTMLElement }  el - node we want to test
	 * @returns {Boolean} true if it's an svg node
	 */
	function isSvg(el) {
	  return !!el.ownerSVGElement
	}
	
	/**
	 * Create a generic DOM node
	 * @param   { String } name - name of the DOM node we want to create
	 * @param   { Boolean } isSvg - true if we need to use an svg node
	 * @returns { Object } DOM node just created
	 */
	function mkEl(name) {
	  return name === 'svg' ? document.createElementNS(SVG_NS, name) : document.createElement(name)
	}
	
	/**
	 * Set the inner html of any DOM node SVGs included
	 * @param { Object } container - DOM node where we'll inject new html
	 * @param { String } html - html to inject
	 */
	/* istanbul ignore next */
	function setInnerHTML(container, html) {
	  if (!isUndefined(container.innerHTML))
	    { container.innerHTML = html; }
	    // some browsers do not support innerHTML on the SVGs tags
	  else {
	    var doc = new DOMParser().parseFromString(html, 'application/xml');
	    var node = container.ownerDocument.importNode(doc.documentElement, true);
	    container.appendChild(node);
	  }
	}
	
	/**
	 * Toggle the visibility of any DOM node
	 * @param   { Object }  dom - DOM node we want to hide
	 * @param   { Boolean } show - do we want to show it?
	 */
	
	function toggleVisibility(dom, show) {
	  dom.style.display = show ? '' : 'none';
	  dom['hidden'] = show ? false : true;
	}
	
	/**
	 * Remove any DOM attribute from a node
	 * @param   { Object } dom - DOM node we want to update
	 * @param   { String } name - name of the property we want to remove
	 */
	function remAttr(dom, name) {
	  dom.removeAttribute(name);
	}
	
	/**
	 * Convert a style object to a string
	 * @param   { Object } style - style object we need to parse
	 * @returns { String } resulting css string
	 * @example
	 * styleObjectToString({ color: 'red', height: '10px'}) // => 'color: red; height: 10px'
	 */
	function styleObjectToString(style) {
	  return Object.keys(style).reduce(function (acc, prop) {
	    return (acc + " " + prop + ": " + (style[prop]) + ";")
	  }, '')
	}
	
	/**
	 * Get the value of any DOM attribute on a node
	 * @param   { Object } dom - DOM node we want to parse
	 * @param   { String } name - name of the attribute we want to get
	 * @returns { String | undefined } name of the node attribute whether it exists
	 */
	function getAttr(dom, name) {
	  return dom.getAttribute(name)
	}
	
	/**
	 * Set any DOM attribute
	 * @param { Object } dom - DOM node we want to update
	 * @param { String } name - name of the property we want to set
	 * @param { String } val - value of the property we want to set
	 */
	function setAttr(dom, name, val) {
	  var xlink = XLINK_REGEX.exec(name);
	  if (xlink && xlink[1])
	    { dom.setAttributeNS(XLINK_NS, xlink[1], val); }
	  else
	    { dom.setAttribute(name, val); }
	}
	
	/**
	 * Insert safely a tag to fix #1962 #1649
	 * @param   { HTMLElement } root - children container
	 * @param   { HTMLElement } curr - node to insert
	 * @param   { HTMLElement } next - node that should preceed the current node inserted
	 */
	function safeInsert(root, curr, next) {
	  root.insertBefore(curr, next.parentNode && next);
	}
	
	/**
	 * Minimize risk: only zero or one _space_ between attr & value
	 * @param   { String }   html - html string we want to parse
	 * @param   { Function } fn - callback function to apply on any attribute found
	 */
	function walkAttrs(html, fn) {
	  if (!html)
	    { return }
	  var m;
	  while (m = RE_HTML_ATTRS.exec(html))
	    { fn(m[1].toLowerCase(), m[2] || m[3] || m[4]); }
	}
	
	/**
	 * Walk down recursively all the children tags starting dom node
	 * @param   { Object }   dom - starting node where we will start the recursion
	 * @param   { Function } fn - callback to transform the child node just found
	 * @param   { Object }   context - fn can optionally return an object, which is passed to children
	 */
	function walkNodes(dom, fn, context) {
	  if (dom) {
	    var res = fn(dom, context);
	    var next;
	    // stop the recursion
	    if (res === false) { return }
	
	    dom = dom.firstChild;
	
	    while (dom) {
	      next = dom.nextSibling;
	      walkNodes(dom, fn, res);
	      dom = next;
	    }
	  }
	}
	
	var dom = Object.freeze({
		$$: $$,
		$: $,
		createFrag: createFrag,
		createDOMPlaceholder: createDOMPlaceholder,
		isSvg: isSvg,
		mkEl: mkEl,
		setInnerHTML: setInnerHTML,
		toggleVisibility: toggleVisibility,
		remAttr: remAttr,
		styleObjectToString: styleObjectToString,
		getAttr: getAttr,
		setAttr: setAttr,
		safeInsert: safeInsert,
		walkAttrs: walkAttrs,
		walkNodes: walkNodes
	});
	
	var styleNode;
	var cssTextProp;
	var byName = {};
	var remainder = [];
	var needsInject = false;
	
	// skip the following code on the server
	if (WIN) {
	  styleNode = (function () {
	    // create a new style element with the correct type
	    var newNode = mkEl('style');
	    setAttr(newNode, 'type', 'text/css');
	
	    // replace any user node or insert the new one into the head
	    var userNode = $('style[type=riot]');
	    /* istanbul ignore next */
	    if (userNode) {
	      if (userNode.id) { newNode.id = userNode.id; }
	      userNode.parentNode.replaceChild(newNode, userNode);
	    }
	    else { document.getElementsByTagName('head')[0].appendChild(newNode); }
	
	    return newNode
	  })();
	  cssTextProp = styleNode.styleSheet;
	}
	
	/**
	 * Object that will be used to inject and manage the css of every tag instance
	 */
	var styleManager = {
	  styleNode: styleNode,
	  /**
	   * Save a tag style to be later injected into DOM
	   * @param { String } css - css string
	   * @param { String } name - if it's passed we will map the css to a tagname
	   */
	  add: function add(css, name) {
	    if (name) { byName[name] = css; }
	    else { remainder.push(css); }
	    needsInject = true;
	  },
	  /**
	   * Inject all previously saved tag styles into DOM
	   * innerHTML seems slow: http://jsperf.com/riot-insert-style
	   */
	  inject: function inject() {
	    if (!WIN || !needsInject) { return }
	    needsInject = false;
	    var style = Object.keys(byName)
	      .map(function(k) { return byName[k] })
	      .concat(remainder).join('\n');
	    /* istanbul ignore next */
	    if (cssTextProp) { cssTextProp.cssText = style; }
	    else { styleNode.innerHTML = style; }
	  }
	};
	
	/**
	 * The riot template engine
	 * @version v3.0.5
	 */
	/**
	 * riot.util.brackets
	 *
	 * - `brackets    ` - Returns a string or regex based on its parameter
	 * - `brackets.set` - Change the current riot brackets
	 *
	 * @module
	 */
	
	/* global riot */
	
	/* istanbul ignore next */
	var brackets = (function (UNDEF) {
	
	  var
	    REGLOB = 'g',
	
	    R_MLCOMMS = /\/\*[^*]*\*+(?:[^*\/][^*]*\*+)*\//g,
	
	    R_STRINGS = /"[^"\\]*(?:\\[\S\s][^"\\]*)*"|'[^'\\]*(?:\\[\S\s][^'\\]*)*'|`[^`\\]*(?:\\[\S\s][^`\\]*)*`/g,
	
	    S_QBLOCKS = R_STRINGS.source + '|' +
	      /(?:\breturn\s+|(?:[$\w\)\]]|\+\+|--)\s*(\/)(?![*\/]))/.source + '|' +
	      /\/(?=[^*\/])[^[\/\\]*(?:(?:\[(?:\\.|[^\]\\]*)*\]|\\.)[^[\/\\]*)*?([^<]\/)[gim]*/.source,
	
	    UNSUPPORTED = RegExp('[\\' + 'x00-\\x1F<>a-zA-Z0-9\'",;\\\\]'),
	
	    NEED_ESCAPE = /(?=[[\]()*+?.^$|])/g,
	
	    FINDBRACES = {
	      '(': RegExp('([()])|'   + S_QBLOCKS, REGLOB),
	      '[': RegExp('([[\\]])|' + S_QBLOCKS, REGLOB),
	      '{': RegExp('([{}])|'   + S_QBLOCKS, REGLOB)
	    },
	
	    DEFAULT = '{ }';
	
	  var _pairs = [
	    '{', '}',
	    '{', '}',
	    /{[^}]*}/,
	    /\\([{}])/g,
	    /\\({)|{/g,
	    RegExp('\\\\(})|([[({])|(})|' + S_QBLOCKS, REGLOB),
	    DEFAULT,
	    /^\s*{\^?\s*([$\w]+)(?:\s*,\s*(\S+))?\s+in\s+(\S.*)\s*}/,
	    /(^|[^\\]){=[\S\s]*?}/
	  ];
	
	  var
	    cachedBrackets = UNDEF,
	    _regex,
	    _cache = [],
	    _settings;
	
	  function _loopback (re) { return re }
	
	  function _rewrite (re, bp) {
	    if (!bp) { bp = _cache; }
	    return new RegExp(
	      re.source.replace(/{/g, bp[2]).replace(/}/g, bp[3]), re.global ? REGLOB : ''
	    )
	  }
	
	  function _create (pair) {
	    if (pair === DEFAULT) { return _pairs }
	
	    var arr = pair.split(' ');
	
	    if (arr.length !== 2 || UNSUPPORTED.test(pair)) {
	      throw new Error('Unsupported brackets "' + pair + '"')
	    }
	    arr = arr.concat(pair.replace(NEED_ESCAPE, '\\').split(' '));
	
	    arr[4] = _rewrite(arr[1].length > 1 ? /{[\S\s]*?}/ : _pairs[4], arr);
	    arr[5] = _rewrite(pair.length > 3 ? /\\({|})/g : _pairs[5], arr);
	    arr[6] = _rewrite(_pairs[6], arr);
	    arr[7] = RegExp('\\\\(' + arr[3] + ')|([[({])|(' + arr[3] + ')|' + S_QBLOCKS, REGLOB);
	    arr[8] = pair;
	    return arr
	  }
	
	  function _brackets (reOrIdx) {
	    return reOrIdx instanceof RegExp ? _regex(reOrIdx) : _cache[reOrIdx]
	  }
	
	  _brackets.split = function split (str, tmpl, _bp) {
	    // istanbul ignore next: _bp is for the compiler
	    if (!_bp) { _bp = _cache; }
	
	    var
	      parts = [],
	      match,
	      isexpr,
	      start,
	      pos,
	      re = _bp[6];
	
	    isexpr = start = re.lastIndex = 0;
	
	    while ((match = re.exec(str))) {
	
	      pos = match.index;
	
	      if (isexpr) {
	
	        if (match[2]) {
	          re.lastIndex = skipBraces(str, match[2], re.lastIndex);
	          continue
	        }
	        if (!match[3]) {
	          continue
	        }
	      }
	
	      if (!match[1]) {
	        unescapeStr(str.slice(start, pos));
	        start = re.lastIndex;
	        re = _bp[6 + (isexpr ^= 1)];
	        re.lastIndex = start;
	      }
	    }
	
	    if (str && start < str.length) {
	      unescapeStr(str.slice(start));
	    }
	
	    return parts
	
	    function unescapeStr (s) {
	      if (tmpl || isexpr) {
	        parts.push(s && s.replace(_bp[5], '$1'));
	      } else {
	        parts.push(s);
	      }
	    }
	
	    function skipBraces (s, ch, ix) {
	      var
	        match,
	        recch = FINDBRACES[ch];
	
	      recch.lastIndex = ix;
	      ix = 1;
	      while ((match = recch.exec(s))) {
	        if (match[1] &&
	          !(match[1] === ch ? ++ix : --ix)) { break }
	      }
	      return ix ? s.length : recch.lastIndex
	    }
	  };
	
	  _brackets.hasExpr = function hasExpr (str) {
	    return _cache[4].test(str)
	  };
	
	  _brackets.loopKeys = function loopKeys (expr) {
	    var m = expr.match(_cache[9]);
	
	    return m
	      ? { key: m[1], pos: m[2], val: _cache[0] + m[3].trim() + _cache[1] }
	      : { val: expr.trim() }
	  };
	
	  _brackets.array = function array (pair) {
	    return pair ? _create(pair) : _cache
	  };
	
	  function _reset (pair) {
	    if ((pair || (pair = DEFAULT)) !== _cache[8]) {
	      _cache = _create(pair);
	      _regex = pair === DEFAULT ? _loopback : _rewrite;
	      _cache[9] = _regex(_pairs[9]);
	    }
	    cachedBrackets = pair;
	  }
	
	  function _setSettings (o) {
	    var b;
	
	    o = o || {};
	    b = o.brackets;
	    Object.defineProperty(o, 'brackets', {
	      set: _reset,
	      get: function () { return cachedBrackets },
	      enumerable: true
	    });
	    _settings = o;
	    _reset(b);
	  }
	
	  Object.defineProperty(_brackets, 'settings', {
	    set: _setSettings,
	    get: function () { return _settings }
	  });
	
	  /* istanbul ignore next: in the browser riot is always in the scope */
	  _brackets.settings = typeof riot !== 'undefined' && riot.settings || {};
	  _brackets.set = _reset;
	
	  _brackets.R_STRINGS = R_STRINGS;
	  _brackets.R_MLCOMMS = R_MLCOMMS;
	  _brackets.S_QBLOCKS = S_QBLOCKS;
	
	  return _brackets
	
	})();
	
	/**
	 * @module tmpl
	 *
	 * tmpl          - Root function, returns the template value, render with data
	 * tmpl.hasExpr  - Test the existence of a expression inside a string
	 * tmpl.loopKeys - Get the keys for an 'each' loop (used by `_each`)
	 */
	
	/* istanbul ignore next */
	var tmpl = (function () {
	
	  var _cache = {};
	
	  function _tmpl (str, data) {
	    if (!str) { return str }
	
	    return (_cache[str] || (_cache[str] = _create(str))).call(
	      data, _logErr.bind({
	        data: data,
	        tmpl: str
	      })
	    )
	  }
	
	  _tmpl.hasExpr = brackets.hasExpr;
	
	  _tmpl.loopKeys = brackets.loopKeys;
	
	  // istanbul ignore next
	  _tmpl.clearCache = function () { _cache = {}; };
	
	  _tmpl.errorHandler = null;
	
	  function _logErr (err, ctx) {
	
	    err.riotData = {
	      tagName: ctx && ctx.__ && ctx.__.tagName,
	      _riot_id: ctx && ctx._riot_id  //eslint-disable-line camelcase
	    };
	
	    if (_tmpl.errorHandler) { _tmpl.errorHandler(err); }
	    else if (
	      typeof console !== 'undefined' &&
	      typeof console.error === 'function'
	    ) {
	      console.error(err.message);
	      console.log('<%s> %s', err.riotData.tagName || 'Unknown tag', this.tmpl); // eslint-disable-line
	      console.log(this.data); // eslint-disable-line
	    }
	  }
	
	  function _create (str) {
	    var expr = _getTmpl(str);
	
	    if (expr.slice(0, 11) !== 'try{return ') { expr = 'return ' + expr; }
	
	    return new Function('E', expr + ';')    // eslint-disable-line no-new-func
	  }
	
	  var
	    CH_IDEXPR = String.fromCharCode(0x2057),
	    RE_CSNAME = /^(?:(-?[_A-Za-z\xA0-\xFF][-\w\xA0-\xFF]*)|\u2057(\d+)~):/,
	    RE_QBLOCK = RegExp(brackets.S_QBLOCKS, 'g'),
	    RE_DQUOTE = /\u2057/g,
	    RE_QBMARK = /\u2057(\d+)~/g;
	
	  function _getTmpl (str) {
	    var
	      qstr = [],
	      expr,
	      parts = brackets.split(str.replace(RE_DQUOTE, '"'), 1);
	
	    if (parts.length > 2 || parts[0]) {
	      var i, j, list = [];
	
	      for (i = j = 0; i < parts.length; ++i) {
	
	        expr = parts[i];
	
	        if (expr && (expr = i & 1
	
	            ? _parseExpr(expr, 1, qstr)
	
	            : '"' + expr
	                .replace(/\\/g, '\\\\')
	                .replace(/\r\n?|\n/g, '\\n')
	                .replace(/"/g, '\\"') +
	              '"'
	
	          )) { list[j++] = expr; }
	
	      }
	
	      expr = j < 2 ? list[0]
	           : '[' + list.join(',') + '].join("")';
	
	    } else {
	
	      expr = _parseExpr(parts[1], 0, qstr);
	    }
	
	    if (qstr[0]) {
	      expr = expr.replace(RE_QBMARK, function (_, pos) {
	        return qstr[pos]
	          .replace(/\r/g, '\\r')
	          .replace(/\n/g, '\\n')
	      });
	    }
	    return expr
	  }
	
	  var
	    RE_BREND = {
	      '(': /[()]/g,
	      '[': /[[\]]/g,
	      '{': /[{}]/g
	    };
	
	  function _parseExpr (expr, asText, qstr) {
	
	    expr = expr
	          .replace(RE_QBLOCK, function (s, div) {
	            return s.length > 2 && !div ? CH_IDEXPR + (qstr.push(s) - 1) + '~' : s
	          })
	          .replace(/\s+/g, ' ').trim()
	          .replace(/\ ?([[\({},?\.:])\ ?/g, '$1');
	
	    if (expr) {
	      var
	        list = [],
	        cnt = 0,
	        match;
	
	      while (expr &&
	            (match = expr.match(RE_CSNAME)) &&
	            !match.index
	        ) {
	        var
	          key,
	          jsb,
	          re = /,|([[{(])|$/g;
	
	        expr = RegExp.rightContext;
	        key  = match[2] ? qstr[match[2]].slice(1, -1).trim().replace(/\s+/g, ' ') : match[1];
	
	        while (jsb = (match = re.exec(expr))[1]) { skipBraces(jsb, re); }
	
	        jsb  = expr.slice(0, match.index);
	        expr = RegExp.rightContext;
	
	        list[cnt++] = _wrapExpr(jsb, 1, key);
	      }
	
	      expr = !cnt ? _wrapExpr(expr, asText)
	           : cnt > 1 ? '[' + list.join(',') + '].join(" ").trim()' : list[0];
	    }
	    return expr
	
	    function skipBraces (ch, re) {
	      var
	        mm,
	        lv = 1,
	        ir = RE_BREND[ch];
	
	      ir.lastIndex = re.lastIndex;
	      while (mm = ir.exec(expr)) {
	        if (mm[0] === ch) { ++lv; }
	        else if (!--lv) { break }
	      }
	      re.lastIndex = lv ? expr.length : ir.lastIndex;
	    }
	  }
	
	  // istanbul ignore next: not both
	  var // eslint-disable-next-line max-len
	    JS_CONTEXT = '"in this?this:' + (typeof window !== 'object' ? 'global' : 'window') + ').',
	    JS_VARNAME = /[,{][\$\w]+(?=:)|(^ *|[^$\w\.{])(?!(?:typeof|true|false|null|undefined|in|instanceof|is(?:Finite|NaN)|void|NaN|new|Date|RegExp|Math)(?![$\w]))([$_A-Za-z][$\w]*)/g,
	    JS_NOPROPS = /^(?=(\.[$\w]+))\1(?:[^.[(]|$)/;
	
	  function _wrapExpr (expr, asText, key) {
	    var tb;
	
	    expr = expr.replace(JS_VARNAME, function (match, p, mvar, pos, s) {
	      if (mvar) {
	        pos = tb ? 0 : pos + match.length;
	
	        if (mvar !== 'this' && mvar !== 'global' && mvar !== 'window') {
	          match = p + '("' + mvar + JS_CONTEXT + mvar;
	          if (pos) { tb = (s = s[pos]) === '.' || s === '(' || s === '['; }
	        } else if (pos) {
	          tb = !JS_NOPROPS.test(s.slice(pos));
	        }
	      }
	      return match
	    });
	
	    if (tb) {
	      expr = 'try{return ' + expr + '}catch(e){E(e,this)}';
	    }
	
	    if (key) {
	
	      expr = (tb
	          ? 'function(){' + expr + '}.call(this)' : '(' + expr + ')'
	        ) + '?"' + key + '":""';
	
	    } else if (asText) {
	
	      expr = 'function(v){' + (tb
	          ? expr.replace('return ', 'v=') : 'v=(' + expr + ')'
	        ) + ';return v||v===0?v:""}.call(this)';
	    }
	
	    return expr
	  }
	
	  _tmpl.version = brackets.version = 'v3.0.5';
	
	  return _tmpl
	
	})();
	
	/* istanbul ignore next */
	var observable$1 = function(el) {
	
	  /**
	   * Extend the original object or create a new empty one
	   * @type { Object }
	   */
	
	  el = el || {};
	
	  /**
	   * Private variables
	   */
	  var callbacks = {},
	    slice = Array.prototype.slice;
	
	  /**
	   * Public Api
	   */
	
	  // extend the el object adding the observable methods
	  Object.defineProperties(el, {
	    /**
	     * Listen to the given `event` ands
	     * execute the `callback` each time an event is triggered.
	     * @param  { String } event - event id
	     * @param  { Function } fn - callback function
	     * @returns { Object } el
	     */
	    on: {
	      value: function(event, fn) {
	        if (typeof fn == 'function')
	          { (callbacks[event] = callbacks[event] || []).push(fn); }
	        return el
	      },
	      enumerable: false,
	      writable: false,
	      configurable: false
	    },
	
	    /**
	     * Removes the given `event` listeners
	     * @param   { String } event - event id
	     * @param   { Function } fn - callback function
	     * @returns { Object } el
	     */
	    off: {
	      value: function(event, fn) {
	        if (event == '*' && !fn) { callbacks = {}; }
	        else {
	          if (fn) {
	            var arr = callbacks[event];
	            for (var i = 0, cb; cb = arr && arr[i]; ++i) {
	              if (cb == fn) { arr.splice(i--, 1); }
	            }
	          } else { delete callbacks[event]; }
	        }
	        return el
	      },
	      enumerable: false,
	      writable: false,
	      configurable: false
	    },
	
	    /**
	     * Listen to the given `event` and
	     * execute the `callback` at most once
	     * @param   { String } event - event id
	     * @param   { Function } fn - callback function
	     * @returns { Object } el
	     */
	    one: {
	      value: function(event, fn) {
	        function on() {
	          el.off(event, on);
	          fn.apply(el, arguments);
	        }
	        return el.on(event, on)
	      },
	      enumerable: false,
	      writable: false,
	      configurable: false
	    },
	
	    /**
	     * Execute all callback functions that listen to
	     * the given `event`
	     * @param   { String } event - event id
	     * @returns { Object } el
	     */
	    trigger: {
	      value: function(event) {
	        var arguments$1 = arguments;
	
	
	        // getting the arguments
	        var arglen = arguments.length - 1,
	          args = new Array(arglen),
	          fns,
	          fn,
	          i;
	
	        for (i = 0; i < arglen; i++) {
	          args[i] = arguments$1[i + 1]; // skip first argument
	        }
	
	        fns = slice.call(callbacks[event] || [], 0);
	
	        for (i = 0; fn = fns[i]; ++i) {
	          fn.apply(el, args);
	        }
	
	        if (callbacks['*'] && event != '*')
	          { el.trigger.apply(el, ['*', event].concat(args)); }
	
	        return el
	      },
	      enumerable: false,
	      writable: false,
	      configurable: false
	    }
	  });
	
	  return el
	
	};
	
	/**
	 * Specialized function for looping an array-like collection with `each={}`
	 * @param   { Array } list - collection of items
	 * @param   {Function} fn - callback function
	 * @returns { Array } the array looped
	 */
	function each(list, fn) {
	  var len = list ? list.length : 0;
	  var i = 0;
	  for (; i < len; ++i) {
	    fn(list[i], i);
	  }
	  return list
	}
	
	/**
	 * Check whether an array contains an item
	 * @param   { Array } array - target array
	 * @param   { * } item - item to test
	 * @returns { Boolean } -
	 */
	function contains(array, item) {
	  return array.indexOf(item) !== -1
	}
	
	/**
	 * Convert a string containing dashes to camel case
	 * @param   { String } str - input string
	 * @returns { String } my-string -> myString
	 */
	function toCamel(str) {
	  return str.replace(/-(\w)/g, function (_, c) { return c.toUpperCase(); })
	}
	
	/**
	 * Faster String startsWith alternative
	 * @param   { String } str - source string
	 * @param   { String } value - test string
	 * @returns { Boolean } -
	 */
	function startsWith(str, value) {
	  return str.slice(0, value.length) === value
	}
	
	/**
	 * Helper function to set an immutable property
	 * @param   { Object } el - object where the new property will be set
	 * @param   { String } key - object key where the new property will be stored
	 * @param   { * } value - value of the new property
	 * @param   { Object } options - set the propery overriding the default options
	 * @returns { Object } - the initial object
	 */
	function defineProperty(el, key, value, options) {
	  Object.defineProperty(el, key, extend({
	    value: value,
	    enumerable: false,
	    writable: false,
	    configurable: true
	  }, options));
	  return el
	}
	
	/**
	 * Extend any object with other properties
	 * @param   { Object } src - source object
	 * @returns { Object } the resulting extended object
	 *
	 * var obj = { foo: 'baz' }
	 * extend(obj, {bar: 'bar', foo: 'bar'})
	 * console.log(obj) => {bar: 'bar', foo: 'bar'}
	 *
	 */
	function extend(src) {
	  var obj, args = arguments;
	  for (var i = 1; i < args.length; ++i) {
	    if (obj = args[i]) {
	      for (var key in obj) {
	        // check if this property of the source object could be overridden
	        if (isWritable(src, key))
	          { src[key] = obj[key]; }
	      }
	    }
	  }
	  return src
	}
	
	var misc = Object.freeze({
		each: each,
		contains: contains,
		toCamel: toCamel,
		startsWith: startsWith,
		defineProperty: defineProperty,
		extend: extend
	});
	
	var settings$1 = extend(Object.create(brackets.settings), {
	  skipAnonymousTags: true
	});
	
	/**
	 * Trigger DOM events
	 * @param   { HTMLElement } dom - dom element target of the event
	 * @param   { Function } handler - user function
	 * @param   { Object } e - event object
	 */
	function handleEvent(dom, handler, e) {
	  var ptag = this.__.parent,
	    item = this.__.item;
	
	  if (!item)
	    { while (ptag && !item) {
	      item = ptag.__.item;
	      ptag = ptag.__.parent;
	    } }
	
	  // override the event properties
	  /* istanbul ignore next */
	  if (isWritable(e, 'currentTarget')) { e.currentTarget = dom; }
	  /* istanbul ignore next */
	  if (isWritable(e, 'target')) { e.target = e.srcElement; }
	  /* istanbul ignore next */
	  if (isWritable(e, 'which')) { e.which = e.charCode || e.keyCode; }
	
	  e.item = item;
	
	  handler.call(this, e);
	
	  if (!e.preventUpdate) {
	    var p = getImmediateCustomParentTag(this);
	    // fixes #2083
	    if (p.isMounted) { p.update(); }
	  }
	}
	
	/**
	 * Attach an event to a DOM node
	 * @param { String } name - event name
	 * @param { Function } handler - event callback
	 * @param { Object } dom - dom node
	 * @param { Tag } tag - tag instance
	 */
	function setEventHandler(name, handler, dom, tag) {
	  var eventName,
	    cb = handleEvent.bind(tag, dom, handler);
	
	  // avoid to bind twice the same event
	  // possible fix for #2332
	  dom[name] = null;
	
	  // normalize event name
	  eventName = name.replace(RE_EVENTS_PREFIX, '');
	
	  // cache the listener into the listeners array
	  if (!contains(tag.__.listeners, dom)) { tag.__.listeners.push(dom); }
	  if (!dom[RIOT_EVENTS_KEY]) { dom[RIOT_EVENTS_KEY] = {}; }
	  if (dom[RIOT_EVENTS_KEY][name]) { dom.removeEventListener(eventName, dom[RIOT_EVENTS_KEY][name]); }
	
	  dom[RIOT_EVENTS_KEY][name] = cb;
	  dom.addEventListener(eventName, cb, false);
	}
	
	/**
	 * Update dynamically created data-is tags with changing expressions
	 * @param { Object } expr - expression tag and expression info
	 * @param { Tag }    parent - parent for tag creation
	 * @param { String } tagName - tag implementation we want to use
	 */
	function updateDataIs(expr, parent, tagName) {
	  var conf, isVirtual, head, ref;
	
	  if (expr.tag && expr.tagName === tagName) {
	    expr.tag.update();
	    return
	  }
	
	  isVirtual = expr.dom.tagName === 'VIRTUAL';
	  // sync _parent to accommodate changing tagnames
	  if (expr.tag) {
	    // need placeholder before unmount
	    if(isVirtual) {
	      head = expr.tag.__.head;
	      ref = createDOMPlaceholder();
	      head.parentNode.insertBefore(ref, head);
	    }
	
	    expr.tag.unmount(true);
	  }
	
	  if (!isString(tagName)) { return }
	
	  expr.impl = __TAG_IMPL[tagName];
	  conf = {root: expr.dom, parent: parent, hasImpl: true, tagName: tagName};
	  expr.tag = initChildTag(expr.impl, conf, expr.dom.innerHTML, parent);
	  each(expr.attrs, function (a) { return setAttr(expr.tag.root, a.name, a.value); });
	  expr.tagName = tagName;
	  expr.tag.mount();
	  if (isVirtual)
	    { makeReplaceVirtual(expr.tag, ref || expr.tag.root); } // root exist first time, after use placeholder
	
	  // parent is the placeholder tag, not the dynamic tag so clean up
	  parent.__.onUnmount = function() {
	    var delName = expr.tag.opts.dataIs,
	      tags = expr.tag.parent.tags,
	      _tags = expr.tag.__.parent.tags;
	    arrayishRemove(tags, delName, expr.tag);
	    arrayishRemove(_tags, delName, expr.tag);
	    expr.tag.unmount();
	  };
	}
	
	/**
	 * Nomalize any attribute removing the "riot-" prefix
	 * @param   { String } attrName - original attribute name
	 * @returns { String } valid html attribute name
	 */
	function normalizeAttrName(attrName) {
	  if (!attrName) { return null }
	  attrName = attrName.replace(ATTRS_PREFIX, '');
	  if (CASE_SENSITIVE_ATTRIBUTES[attrName]) { attrName = CASE_SENSITIVE_ATTRIBUTES[attrName]; }
	  return attrName
	}
	
	/**
	 * Update on single tag expression
	 * @this Tag
	 * @param { Object } expr - expression logic
	 * @returns { undefined }
	 */
	function updateExpression(expr) {
	  if (this.root && getAttr(this.root,'virtualized')) { return }
	
	  var dom = expr.dom,
	    // remove the riot- prefix
	    attrName = normalizeAttrName(expr.attr),
	    isToggle = contains([SHOW_DIRECTIVE, HIDE_DIRECTIVE], attrName),
	    isVirtual = expr.root && expr.root.tagName === 'VIRTUAL',
	    parent = dom && (expr.parent || dom.parentNode),
	    // detect the style attributes
	    isStyleAttr = attrName === 'style',
	    isClassAttr = attrName === 'class',
	    hasValue,
	    isObj,
	    value;
	
	  // if it's a tag we could totally skip the rest
	  if (expr._riot_id) {
	    if (expr.isMounted) {
	      expr.update();
	    // if it hasn't been mounted yet, do that now.
	    } else {
	      expr.mount();
	      if (isVirtual) {
	        makeReplaceVirtual(expr, expr.root);
	      }
	    }
	    return
	  }
	  // if this expression has the update method it means it can handle the DOM changes by itself
	  if (expr.update) { return expr.update() }
	
	  // ...it seems to be a simple expression so we try to calculat its value
	  value = tmpl(expr.expr, isToggle ? extend({}, Object.create(this.parent), this) : this);
	  hasValue = !isBlank(value);
	  isObj = isObject(value);
	
	  // convert the style/class objects to strings
	  if (isObj) {
	    isObj = !isClassAttr && !isStyleAttr;
	    if (isClassAttr) {
	      value = tmpl(JSON.stringify(value), this);
	    } else if (isStyleAttr) {
	      value = styleObjectToString(value);
	    }
	  }
	
	  // remove original attribute
	  if (expr.attr && (!expr.isAttrRemoved || !hasValue || value === false)) {
	    remAttr(dom, expr.attr);
	    expr.isAttrRemoved = true;
	  }
	
	  // for the boolean attributes we don't need the value
	  // we can convert it to checked=true to checked=checked
	  if (expr.bool) { value = value ? attrName : false; }
	  if (expr.isRtag) { return updateDataIs(expr, this, value) }
	  if (expr.wasParsedOnce && expr.value === value) { return }
	
	  // update the expression value
	  expr.value = value;
	  expr.wasParsedOnce = true;
	
	  // if the value is an object we can not do much more with it
	  if (isObj && !isToggle) { return }
	  // avoid to render undefined/null values
	  if (isBlank(value)) { value = ''; }
	
	  // textarea and text nodes have no attribute name
	  if (!attrName) {
	    // about #815 w/o replace: the browser converts the value to a string,
	    // the comparison by "==" does too, but not in the server
	    value += '';
	    // test for parent avoids error with invalid assignment to nodeValue
	    if (parent) {
	      // cache the parent node because somehow it will become null on IE
	      // on the next iteration
	      expr.parent = parent;
	      if (parent.tagName === 'TEXTAREA') {
	        parent.value = value;                    // #1113
	        if (!IE_VERSION) { dom.nodeValue = value; }  // #1625 IE throws here, nodeValue
	      }                                         // will be available on 'updated'
	      else { dom.nodeValue = value; }
	    }
	    return
	  }
	
	
	  // event handler
	  if (isFunction(value)) {
	    setEventHandler(attrName, value, dom, this);
	  // show / hide
	  } else if (isToggle) {
	    toggleVisibility(dom, attrName === HIDE_DIRECTIVE ? !value : value);
	  // handle attributes
	  } else {
	    if (expr.bool) {
	      dom[attrName] = value;
	    }
	
	    if (attrName === 'value' && dom.value !== value) {
	      dom.value = value;
	    }
	
	    if (hasValue && value !== false) {
	      setAttr(dom, attrName, value);
	    }
	
	    // make sure that in case of style changes
	    // the element stays hidden
	    if (isStyleAttr && dom.hidden) { toggleVisibility(dom, false); }
	  }
	}
	
	/**
	 * Update all the expressions in a Tag instance
	 * @this Tag
	 * @param { Array } expressions - expression that must be re evaluated
	 */
	function updateAllExpressions(expressions) {
	  each(expressions, updateExpression.bind(this));
	}
	
	var IfExpr = {
	  init: function init(dom, tag, expr) {
	    remAttr(dom, CONDITIONAL_DIRECTIVE);
	    this.tag = tag;
	    this.expr = expr;
	    this.stub = document.createTextNode('');
	    this.pristine = dom;
	
	    var p = dom.parentNode;
	    p.insertBefore(this.stub, dom);
	    p.removeChild(dom);
	
	    return this
	  },
	  update: function update() {
	    this.value = tmpl(this.expr, this.tag);
	
	    if (this.value && !this.current) { // insert
	      this.current = this.pristine.cloneNode(true);
	      this.stub.parentNode.insertBefore(this.current, this.stub);
	      this.expressions = [];
	      parseExpressions.apply(this.tag, [this.current, this.expressions, true]);
	    } else if (!this.value && this.current) { // remove
	      unmountAll(this.expressions);
	      if (this.current._tag) {
	        this.current._tag.unmount();
	      } else if (this.current.parentNode) {
	        this.current.parentNode.removeChild(this.current);
	      }
	      this.current = null;
	      this.expressions = [];
	    }
	
	    if (this.value) { updateAllExpressions.call(this.tag, this.expressions); }
	  },
	  unmount: function unmount() {
	    unmountAll(this.expressions || []);
	  }
	};
	
	var RefExpr = {
	  init: function init(dom, parent, attrName, attrValue) {
	    this.dom = dom;
	    this.attr = attrName;
	    this.rawValue = attrValue;
	    this.parent = parent;
	    this.hasExp = tmpl.hasExpr(attrValue);
	    return this
	  },
	  update: function update() {
	    var old = this.value;
	    var customParent = this.parent && getImmediateCustomParentTag(this.parent);
	    // if the referenced element is a custom tag, then we set the tag itself, rather than DOM
	    var tagOrDom = this.dom.__ref || this.tag || this.dom;
	
	    this.value = this.hasExp ? tmpl(this.rawValue, this.parent) : this.rawValue;
	
	    // the name changed, so we need to remove it from the old key (if present)
	    if (!isBlank(old) && customParent) { arrayishRemove(customParent.refs, old, tagOrDom); }
	    if (!isBlank(this.value) && isString(this.value)) {
	      // add it to the refs of parent tag (this behavior was changed >=3.0)
	      if (customParent) { arrayishAdd(
	        customParent.refs,
	        this.value,
	        tagOrDom,
	        // use an array if it's a looped node and the ref is not an expression
	        null,
	        this.parent.__.index
	      ); }
	
	      if (this.value !== old) {
	        setAttr(this.dom, this.attr, this.value);
	      }
	    } else {
	      remAttr(this.dom, this.attr);
	    }
	
	    // cache the ref bound to this dom node
	    // to reuse it in future (see also #2329)
	    if (!this.dom.__ref) { this.dom.__ref = tagOrDom; }
	  },
	  unmount: function unmount() {
	    var tagOrDom = this.tag || this.dom;
	    var customParent = this.parent && getImmediateCustomParentTag(this.parent);
	    if (!isBlank(this.value) && customParent)
	      { arrayishRemove(customParent.refs, this.value, tagOrDom); }
	  }
	};
	
	/**
	 * Convert the item looped into an object used to extend the child tag properties
	 * @param   { Object } expr - object containing the keys used to extend the children tags
	 * @param   { * } key - value to assign to the new object returned
	 * @param   { * } val - value containing the position of the item in the array
	 * @param   { Object } base - prototype object for the new item
	 * @returns { Object } - new object containing the values of the original item
	 *
	 * The variables 'key' and 'val' are arbitrary.
	 * They depend on the collection type looped (Array, Object)
	 * and on the expression used on the each tag
	 *
	 */
	function mkitem(expr, key, val, base) {
	  var item = base ? Object.create(base) : {};
	  item[expr.key] = key;
	  if (expr.pos) { item[expr.pos] = val; }
	  return item
	}
	
	/**
	 * Unmount the redundant tags
	 * @param   { Array } items - array containing the current items to loop
	 * @param   { Array } tags - array containing all the children tags
	 */
	function unmountRedundant(items, tags) {
	  var i = tags.length,
	    j = items.length;
	
	  while (i > j) {
	    i--;
	    remove.apply(tags[i], [tags, i]);
	  }
	}
	
	
	/**
	 * Remove a child tag
	 * @this Tag
	 * @param   { Array } tags - tags collection
	 * @param   { Number } i - index of the tag to remove
	 */
	function remove(tags, i) {
	  tags.splice(i, 1);
	  this.unmount();
	  arrayishRemove(this.parent, this, this.__.tagName, true);
	}
	
	/**
	 * Move the nested custom tags in non custom loop tags
	 * @this Tag
	 * @param   { Number } i - current position of the loop tag
	 */
	function moveNestedTags(i) {
	  var this$1 = this;
	
	  each(Object.keys(this.tags), function (tagName) {
	    moveChildTag.apply(this$1.tags[tagName], [tagName, i]);
	  });
	}
	
	/**
	 * Move a child tag
	 * @this Tag
	 * @param   { HTMLElement } root - dom node containing all the loop children
	 * @param   { Tag } nextTag - instance of the next tag preceding the one we want to move
	 * @param   { Boolean } isVirtual - is it a virtual tag?
	 */
	function move(root, nextTag, isVirtual) {
	  if (isVirtual)
	    { moveVirtual.apply(this, [root, nextTag]); }
	  else
	    { safeInsert(root, this.root, nextTag.root); }
	}
	
	/**
	 * Insert and mount a child tag
	 * @this Tag
	 * @param   { HTMLElement } root - dom node containing all the loop children
	 * @param   { Tag } nextTag - instance of the next tag preceding the one we want to insert
	 * @param   { Boolean } isVirtual - is it a virtual tag?
	 */
	function insert(root, nextTag, isVirtual) {
	  if (isVirtual)
	    { makeVirtual.apply(this, [root, nextTag]); }
	  else
	    { safeInsert(root, this.root, nextTag.root); }
	}
	
	/**
	 * Append a new tag into the DOM
	 * @this Tag
	 * @param   { HTMLElement } root - dom node containing all the loop children
	 * @param   { Boolean } isVirtual - is it a virtual tag?
	 */
	function append(root, isVirtual) {
	  if (isVirtual)
	    { makeVirtual.call(this, root); }
	  else
	    { root.appendChild(this.root); }
	}
	
	/**
	 * Manage tags having the 'each'
	 * @param   { HTMLElement } dom - DOM node we need to loop
	 * @param   { Tag } parent - parent tag instance where the dom node is contained
	 * @param   { String } expr - string contained in the 'each' attribute
	 * @returns { Object } expression object for this each loop
	 */
	function _each(dom, parent, expr) {
	
	  // remove the each property from the original tag
	  remAttr(dom, LOOP_DIRECTIVE);
	
	  var mustReorder = typeof getAttr(dom, LOOP_NO_REORDER_DIRECTIVE) !== T_STRING || remAttr(dom, LOOP_NO_REORDER_DIRECTIVE),
	    tagName = getTagName(dom),
	    impl = __TAG_IMPL[tagName],
	    parentNode = dom.parentNode,
	    placeholder = createDOMPlaceholder(),
	    child = getTag(dom),
	    ifExpr = getAttr(dom, CONDITIONAL_DIRECTIVE),
	    tags = [],
	    oldItems = [],
	    hasKeys,
	    isLoop = true,
	    isAnonymous = !__TAG_IMPL[tagName],
	    isVirtual = dom.tagName === 'VIRTUAL';
	
	  // parse the each expression
	  expr = tmpl.loopKeys(expr);
	  expr.isLoop = true;
	
	  if (ifExpr) { remAttr(dom, CONDITIONAL_DIRECTIVE); }
	
	  // insert a marked where the loop tags will be injected
	  parentNode.insertBefore(placeholder, dom);
	  parentNode.removeChild(dom);
	
	  expr.update = function updateEach() {
	    // get the new items collection
	    expr.value = tmpl(expr.val, parent);
	
	    var frag = createFrag(),
	      items = expr.value,
	      isObject$$1 = !isArray(items) && !isString(items),
	      root = placeholder.parentNode;
	
	    // if this DOM was removed the update here is useless
	    // this condition fixes also a weird async issue on IE in our unit test
	    if (!root) { return }
	
	    // object loop. any changes cause full redraw
	    if (isObject$$1) {
	      hasKeys = items || false;
	      items = hasKeys ?
	        Object.keys(items).map(function (key) {
	          return mkitem(expr, items[key], key)
	        }) : [];
	    } else {
	      hasKeys = false;
	    }
	
	    if (ifExpr) {
	      items = items.filter(function(item, i) {
	        if (expr.key && !isObject$$1)
	          { return !!tmpl(ifExpr, mkitem(expr, item, i, parent)) }
	
	        return !!tmpl(ifExpr, extend(Object.create(parent), item))
	      });
	    }
	
	    // loop all the new items
	    each(items, function(item, i) {
	      // reorder only if the items are objects
	      var
	        doReorder = mustReorder && typeof item === T_OBJECT && !hasKeys,
	        oldPos = oldItems.indexOf(item),
	        isNew = oldPos === -1,
	        pos = !isNew && doReorder ? oldPos : i,
	        // does a tag exist in this position?
	        tag = tags[pos],
	        mustAppend = i >= oldItems.length,
	        mustCreate =  doReorder && isNew || !doReorder && !tag;
	
	      item = !hasKeys && expr.key ? mkitem(expr, item, i) : item;
	
	      // new tag
	      if (mustCreate) {
	        tag = new Tag$1(impl, {
	          parent: parent,
	          isLoop: isLoop,
	          isAnonymous: isAnonymous,
	          tagName: tagName,
	          root: dom.cloneNode(isAnonymous),
	          item: item,
	          index: i,
	        }, dom.innerHTML);
	
	        // mount the tag
	        tag.mount();
	
	        if (mustAppend)
	          { append.apply(tag, [frag || root, isVirtual]); }
	        else
	          { insert.apply(tag, [root, tags[i], isVirtual]); }
	
	        if (!mustAppend) { oldItems.splice(i, 0, item); }
	        tags.splice(i, 0, tag);
	        if (child) { arrayishAdd(parent.tags, tagName, tag, true); }
	      } else if (pos !== i && doReorder) {
	        // move
	        if (contains(items, oldItems[pos])) {
	          move.apply(tag, [root, tags[i], isVirtual]);
	          // move the old tag instance
	          tags.splice(i, 0, tags.splice(pos, 1)[0]);
	          // move the old item
	          oldItems.splice(i, 0, oldItems.splice(pos, 1)[0]);
	        }
	
	        // update the position attribute if it exists
	        if (expr.pos) { tag[expr.pos] = i; }
	
	        // if the loop tags are not custom
	        // we need to move all their custom tags into the right position
	        if (!child && tag.tags) { moveNestedTags.call(tag, i); }
	      }
	
	      // cache the original item to use it in the events bound to this node
	      // and its children
	      tag.__.item = item;
	      tag.__.index = i;
	      tag.__.parent = parent;
	
	      if (!mustCreate) { tag.update(item); }
	    });
	
	    // remove the redundant tags
	    unmountRedundant(items, tags);
	
	    // clone the items array
	    oldItems = items.slice();
	
	    // this condition is weird u
	    root.insertBefore(frag, placeholder);
	  };
	
	  expr.unmount = function() {
	    each(tags, function(t) { t.unmount(); });
	  };
	
	  return expr
	}
	
	/**
	 * Walk the tag DOM to detect the expressions to evaluate
	 * @this Tag
	 * @param   { HTMLElement } root - root tag where we will start digging the expressions
	 * @param   { Array } expressions - empty array where the expressions will be added
	 * @param   { Boolean } mustIncludeRoot - flag to decide whether the root must be parsed as well
	 * @returns { Object } an object containing the root noode and the dom tree
	 */
	function parseExpressions(root, expressions, mustIncludeRoot) {
	  var this$1 = this;
	
	  var tree = {parent: {children: expressions}};
	
	  walkNodes(root, function (dom, ctx) {
	    var type = dom.nodeType, parent = ctx.parent, attr, expr, tagImpl;
	    if (!mustIncludeRoot && dom === root) { return {parent: parent} }
	
	    // text node
	    if (type === 3 && dom.parentNode.tagName !== 'STYLE' && tmpl.hasExpr(dom.nodeValue))
	      { parent.children.push({dom: dom, expr: dom.nodeValue}); }
	
	    if (type !== 1) { return ctx } // not an element
	
	    var isVirtual = dom.tagName === 'VIRTUAL';
	
	    // loop. each does it's own thing (for now)
	    if (attr = getAttr(dom, LOOP_DIRECTIVE)) {
	      if(isVirtual) { setAttr(dom, 'loopVirtual', true); } // ignore here, handled in _each
	      parent.children.push(_each(dom, this$1, attr));
	      return false
	    }
	
	    // if-attrs become the new parent. Any following expressions (either on the current
	    // element, or below it) become children of this expression.
	    if (attr = getAttr(dom, CONDITIONAL_DIRECTIVE)) {
	      parent.children.push(Object.create(IfExpr).init(dom, this$1, attr));
	      return false
	    }
	
	    if (expr = getAttr(dom, IS_DIRECTIVE)) {
	      if (tmpl.hasExpr(expr)) {
	        parent.children.push({isRtag: true, expr: expr, dom: dom, attrs: [].slice.call(dom.attributes)});
	        return false
	      }
	    }
	
	    // if this is a tag, stop traversing here.
	    // we ignore the root, since parseExpressions is called while we're mounting that root
	    tagImpl = getTag(dom);
	    if(isVirtual) {
	      if(getAttr(dom, 'virtualized')) {dom.parentElement.removeChild(dom); } // tag created, remove from dom
	      if(!tagImpl && !getAttr(dom, 'virtualized') && !getAttr(dom, 'loopVirtual'))  // ok to create virtual tag
	        { tagImpl = { tmpl: dom.outerHTML }; }
	    }
	
	    if (tagImpl && (dom !== root || mustIncludeRoot)) {
	      if(isVirtual && !getAttr(dom, IS_DIRECTIVE)) { // handled in update
	        // can not remove attribute like directives
	        // so flag for removal after creation to prevent maximum stack error
	        setAttr(dom, 'virtualized', true);
	
	        var tag = new Tag$1({ tmpl: dom.outerHTML },
	          {root: dom, parent: this$1},
	          dom.innerHTML);
	        parent.children.push(tag); // no return, anonymous tag, keep parsing
	      } else {
	        var conf = {root: dom, parent: this$1, hasImpl: true};
	        parent.children.push(initChildTag(tagImpl, conf, dom.innerHTML, this$1));
	        return false
	      }
	    }
	
	    // attribute expressions
	    parseAttributes.apply(this$1, [dom, dom.attributes, function(attr, expr) {
	      if (!expr) { return }
	      parent.children.push(expr);
	    }]);
	
	    // whatever the parent is, all child elements get the same parent.
	    // If this element had an if-attr, that's the parent for all child elements
	    return {parent: parent}
	  }, tree);
	}
	
	/**
	 * Calls `fn` for every attribute on an element. If that attr has an expression,
	 * it is also passed to fn.
	 * @this Tag
	 * @param   { HTMLElement } dom - dom node to parse
	 * @param   { Array } attrs - array of attributes
	 * @param   { Function } fn - callback to exec on any iteration
	 */
	function parseAttributes(dom, attrs, fn) {
	  var this$1 = this;
	
	  each(attrs, function (attr) {
	    if (!attr) { return false }
	
	    var name = attr.name, bool = isBoolAttr(name), expr;
	
	    if (contains(REF_DIRECTIVES, name)) {
	      expr =  Object.create(RefExpr).init(dom, this$1, name, attr.value);
	    } else if (tmpl.hasExpr(attr.value)) {
	      expr = {dom: dom, expr: attr.value, attr: name, bool: bool};
	    }
	
	    fn(attr, expr);
	  });
	}
	
	/*
	  Includes hacks needed for the Internet Explorer version 9 and below
	  See: http://kangax.github.io/compat-table/es5/#ie8
	       http://codeplanet.io/dropping-ie8/
	*/
	
	var reHasYield  = /<yield\b/i;
	var reYieldAll  = /<yield\s*(?:\/>|>([\S\s]*?)<\/yield\s*>|>)/ig;
	var reYieldSrc  = /<yield\s+to=['"]([^'">]*)['"]\s*>([\S\s]*?)<\/yield\s*>/ig;
	var reYieldDest = /<yield\s+from=['"]?([-\w]+)['"]?\s*(?:\/>|>([\S\s]*?)<\/yield\s*>)/ig;
	var rootEls = { tr: 'tbody', th: 'tr', td: 'tr', col: 'colgroup' };
	var tblTags = IE_VERSION && IE_VERSION < 10 ? RE_SPECIAL_TAGS : RE_SPECIAL_TAGS_NO_OPTION;
	var GENERIC = 'div';
	var SVG = 'svg';
	
	
	/*
	  Creates the root element for table or select child elements:
	  tr/th/td/thead/tfoot/tbody/caption/col/colgroup/option/optgroup
	*/
	function specialTags(el, tmpl, tagName) {
	
	  var
	    select = tagName[0] === 'o',
	    parent = select ? 'select>' : 'table>';
	
	  // trim() is important here, this ensures we don't have artifacts,
	  // so we can check if we have only one element inside the parent
	  el.innerHTML = '<' + parent + tmpl.trim() + '</' + parent;
	  parent = el.firstChild;
	
	  // returns the immediate parent if tr/th/td/col is the only element, if not
	  // returns the whole tree, as this can include additional elements
	  /* istanbul ignore next */
	  if (select) {
	    parent.selectedIndex = -1;  // for IE9, compatible w/current riot behavior
	  } else {
	    // avoids insertion of cointainer inside container (ex: tbody inside tbody)
	    var tname = rootEls[tagName];
	    if (tname && parent.childElementCount === 1) { parent = $(tname, parent); }
	  }
	  return parent
	}
	
	/*
	  Replace the yield tag from any tag template with the innerHTML of the
	  original tag in the page
	*/
	function replaceYield(tmpl, html) {
	  // do nothing if no yield
	  if (!reHasYield.test(tmpl)) { return tmpl }
	
	  // be careful with #1343 - string on the source having `$1`
	  var src = {};
	
	  html = html && html.replace(reYieldSrc, function (_, ref, text) {
	    src[ref] = src[ref] || text;   // preserve first definition
	    return ''
	  }).trim();
	
	  return tmpl
	    .replace(reYieldDest, function (_, ref, def) {  // yield with from - to attrs
	      return src[ref] || def || ''
	    })
	    .replace(reYieldAll, function (_, def) {        // yield without any "from"
	      return html || def || ''
	    })
	}
	
	/**
	 * Creates a DOM element to wrap the given content. Normally an `DIV`, but can be
	 * also a `TABLE`, `SELECT`, `TBODY`, `TR`, or `COLGROUP` element.
	 *
	 * @param   { String } tmpl  - The template coming from the custom tag definition
	 * @param   { String } html - HTML content that comes from the DOM element where you
	 *           will mount the tag, mostly the original tag in the page
	 * @param   { Boolean } isSvg - true if the root node is an svg
	 * @returns { HTMLElement } DOM element with _tmpl_ merged through `YIELD` with the _html_.
	 */
	function mkdom(tmpl, html, isSvg$$1) {
	  var match   = tmpl && tmpl.match(/^\s*<([-\w]+)/),
	    tagName = match && match[1].toLowerCase(),
	    el = mkEl(isSvg$$1 ? SVG : GENERIC);
	
	  // replace all the yield tags with the tag inner html
	  tmpl = replaceYield(tmpl, html);
	
	  /* istanbul ignore next */
	  if (tblTags.test(tagName))
	    { el = specialTags(el, tmpl, tagName); }
	  else
	    { setInnerHTML(el, tmpl); }
	
	  return el
	}
	
	/**
	 * Another way to create a riot tag a bit more es6 friendly
	 * @param { HTMLElement } el - tag DOM selector or DOM node/s
	 * @param { Object } opts - tag logic
	 * @returns { Tag } new riot tag instance
	 */
	function Tag$2(el, opts) {
	  // get the tag properties from the class constructor
	  var ref = this;
	  var name = ref.name;
	  var tmpl = ref.tmpl;
	  var css = ref.css;
	  var attrs = ref.attrs;
	  var onCreate = ref.onCreate;
	  // register a new tag and cache the class prototype
	  if (!__TAG_IMPL[name]) {
	    tag$1(name, tmpl, css, attrs, onCreate);
	    // cache the class constructor
	    __TAG_IMPL[name].class = this.constructor;
	  }
	
	  // mount the tag using the class instance
	  mountTo(el, name, opts, this);
	  // inject the component css
	  if (css) { styleManager.inject(); }
	
	  return this
	}
	
	/**
	 * Create a new riot tag implementation
	 * @param   { String }   name - name/id of the new riot tag
	 * @param   { String }   tmpl - tag template
	 * @param   { String }   css - custom tag css
	 * @param   { String }   attrs - root tag attributes
	 * @param   { Function } fn - user function
	 * @returns { String } name/id of the tag just created
	 */
	function tag$1(name, tmpl, css, attrs, fn) {
	  if (isFunction(attrs)) {
	    fn = attrs;
	
	    if (/^[\w\-]+\s?=/.test(css)) {
	      attrs = css;
	      css = '';
	    } else
	      { attrs = ''; }
	  }
	
	  if (css) {
	    if (isFunction(css))
	      { fn = css; }
	    else
	      { styleManager.add(css); }
	  }
	
	  name = name.toLowerCase();
	  __TAG_IMPL[name] = { name: name, tmpl: tmpl, attrs: attrs, fn: fn };
	
	  return name
	}
	
	/**
	 * Create a new riot tag implementation (for use by the compiler)
	 * @param   { String }   name - name/id of the new riot tag
	 * @param   { String }   tmpl - tag template
	 * @param   { String }   css - custom tag css
	 * @param   { String }   attrs - root tag attributes
	 * @param   { Function } fn - user function
	 * @returns { String } name/id of the tag just created
	 */
	function tag2$1(name, tmpl, css, attrs, fn) {
	  if (css) { styleManager.add(css, name); }
	
	  __TAG_IMPL[name] = { name: name, tmpl: tmpl, attrs: attrs, fn: fn };
	
	  return name
	}
	
	/**
	 * Mount a tag using a specific tag implementation
	 * @param   { * } selector - tag DOM selector or DOM node/s
	 * @param   { String } tagName - tag implementation name
	 * @param   { Object } opts - tag logic
	 * @returns { Array } new tags instances
	 */
	function mount$1(selector, tagName, opts) {
	  var tags = [];
	  var elem, allTags;
	
	  function pushTagsTo(root) {
	    if (root.tagName) {
	      var riotTag = getAttr(root, IS_DIRECTIVE), tag;
	
	      // have tagName? force riot-tag to be the same
	      if (tagName && riotTag !== tagName) {
	        riotTag = tagName;
	        setAttr(root, IS_DIRECTIVE, tagName);
	      }
	
	      tag = mountTo(root, riotTag || root.tagName.toLowerCase(), opts);
	
	      if (tag)
	        { tags.push(tag); }
	    } else if (root.length)
	      { each(root, pushTagsTo); } // assume nodeList
	  }
	
	  // inject styles into DOM
	  styleManager.inject();
	
	  if (isObject(tagName)) {
	    opts = tagName;
	    tagName = 0;
	  }
	
	  // crawl the DOM to find the tag
	  if (isString(selector)) {
	    selector = selector === '*' ?
	      // select all registered tags
	      // & tags found with the riot-tag attribute set
	      allTags = selectTags() :
	      // or just the ones named like the selector
	      selector + selectTags(selector.split(/, */));
	
	    // make sure to pass always a selector
	    // to the querySelectorAll function
	    elem = selector ? $$(selector) : [];
	  }
	  else
	    // probably you have passed already a tag or a NodeList
	    { elem = selector; }
	
	  // select all the registered and mount them inside their root elements
	  if (tagName === '*') {
	    // get all custom tags
	    tagName = allTags || selectTags();
	    // if the root els it's just a single tag
	    if (elem.tagName)
	      { elem = $$(tagName, elem); }
	    else {
	      // select all the children for all the different root elements
	      var nodeList = [];
	
	      each(elem, function (_el) { return nodeList.push($$(tagName, _el)); });
	
	      elem = nodeList;
	    }
	    // get rid of the tagName
	    tagName = 0;
	  }
	
	  pushTagsTo(elem);
	
	  return tags
	}
	
	// Create a mixin that could be globally shared across all the tags
	var mixins = {};
	var globals = mixins[GLOBAL_MIXIN] = {};
	var mixins_id = 0;
	
	/**
	 * Create/Return a mixin by its name
	 * @param   { String }  name - mixin name (global mixin if object)
	 * @param   { Object }  mix - mixin logic
	 * @param   { Boolean } g - is global?
	 * @returns { Object }  the mixin logic
	 */
	function mixin$1(name, mix, g) {
	  // Unnamed global
	  if (isObject(name)) {
	    mixin$1(("__" + (mixins_id++) + "__"), name, true);
	    return
	  }
	
	  var store = g ? globals : mixins;
	
	  // Getter
	  if (!mix) {
	    if (isUndefined(store[name]))
	      { throw new Error(("Unregistered mixin: " + name)) }
	
	    return store[name]
	  }
	
	  // Setter
	  store[name] = isFunction(mix) ?
	    extend(mix.prototype, store[name] || {}) && mix :
	    extend(store[name] || {}, mix);
	}
	
	/**
	 * Update all the tags instances created
	 * @returns { Array } all the tags instances
	 */
	function update$1() {
	  return each(__TAGS_CACHE, function (tag) { return tag.update(); })
	}
	
	function unregister$1(name) {
	  __TAG_IMPL[name] = null;
	}
	
	var version$1 = 'v3.5.1';
	
	
	var core = Object.freeze({
		Tag: Tag$2,
		tag: tag$1,
		tag2: tag2$1,
		mount: mount$1,
		mixin: mixin$1,
		update: update$1,
		unregister: unregister$1,
		version: version$1
	});
	
	// counter to give a unique id to all the Tag instances
	var __uid = 0;
	
	/**
	 * We need to update opts for this tag. That requires updating the expressions
	 * in any attributes on the tag, and then copying the result onto opts.
	 * @this Tag
	 * @param   {Boolean} isLoop - is it a loop tag?
	 * @param   { Tag }  parent - parent tag node
	 * @param   { Boolean }  isAnonymous - is it a tag without any impl? (a tag not registered)
	 * @param   { Object }  opts - tag options
	 * @param   { Array }  instAttrs - tag attributes array
	 */
	function updateOpts(isLoop, parent, isAnonymous, opts, instAttrs) {
	  // isAnonymous `each` tags treat `dom` and `root` differently. In this case
	  // (and only this case) we don't need to do updateOpts, because the regular parse
	  // will update those attrs. Plus, isAnonymous tags don't need opts anyway
	  if (isLoop && isAnonymous) { return }
	
	  var ctx = !isAnonymous && isLoop ? this : parent || this;
	  each(instAttrs, function (attr) {
	    if (attr.expr) { updateAllExpressions.call(ctx, [attr.expr]); }
	    // normalize the attribute names
	    opts[toCamel(attr.name).replace(ATTRS_PREFIX, '')] = attr.expr ? attr.expr.value : attr.value;
	  });
	}
	
	
	/**
	 * Tag class
	 * @constructor
	 * @param { Object } impl - it contains the tag template, and logic
	 * @param { Object } conf - tag options
	 * @param { String } innerHTML - html that eventually we need to inject in the tag
	 */
	function Tag$1(impl, conf, innerHTML) {
	  if ( impl === void 0 ) impl = {};
	  if ( conf === void 0 ) conf = {};
	
	  var opts = extend({}, conf.opts),
	    parent = conf.parent,
	    isLoop = conf.isLoop,
	    isAnonymous = !!conf.isAnonymous,
	    skipAnonymous = settings$1.skipAnonymousTags && isAnonymous,
	    item = cleanUpData(conf.item),
	    index = conf.index, // available only for the looped nodes
	    instAttrs = [], // All attributes on the Tag when it's first parsed
	    implAttrs = [], // expressions on this type of Tag
	    expressions = [],
	    root = conf.root,
	    tagName = conf.tagName || getTagName(root),
	    isVirtual = tagName === 'virtual',
	    isInline = !isVirtual && !impl.tmpl,
	    propsInSyncWithParent = [],
	    dom;
	
	  // make this tag observable
	  if (!skipAnonymous) { observable$1(this); }
	  // only call unmount if we have a valid __TAG_IMPL (has name property)
	  if (impl.name && root._tag) { root._tag.unmount(true); }
	
	  // not yet mounted
	  this.isMounted = false;
	
	  defineProperty(this, '__', {
	    isAnonymous: isAnonymous,
	    instAttrs: instAttrs,
	    innerHTML: innerHTML,
	    tagName: tagName,
	    index: index,
	    isLoop: isLoop,
	    isInline: isInline,
	    // tags having event listeners
	    // it would be better to use weak maps here but we can not introduce breaking changes now
	    listeners: [],
	    // these vars will be needed only for the virtual tags
	    virts: [],
	    tail: null,
	    head: null,
	    parent: null,
	    item: null
	  });
	
	  // create a unique id to this tag
	  // it could be handy to use it also to improve the virtual dom rendering speed
	  defineProperty(this, '_riot_id', ++__uid); // base 1 allows test !t._riot_id
	  defineProperty(this, 'root', root);
	  extend(this, { opts: opts }, item);
	  // protect the "tags" and "refs" property from being overridden
	  defineProperty(this, 'parent', parent || null);
	  defineProperty(this, 'tags', {});
	  defineProperty(this, 'refs', {});
	
	  if (isInline || isLoop && isAnonymous) {
	    dom = root;
	  } else {
	    if (!isVirtual) { root.innerHTML = ''; }
	    dom = mkdom(impl.tmpl, innerHTML, isSvg(root));
	  }
	
	  /**
	   * Update the tag expressions and options
	   * @param   { * }  data - data we want to use to extend the tag properties
	   * @returns { Tag } the current tag instance
	   */
	  defineProperty(this, 'update', function tagUpdate(data) {
	    var nextOpts = {},
	      canTrigger = this.isMounted && !skipAnonymous;
	
	    // make sure the data passed will not override
	    // the component core methods
	    data = cleanUpData(data);
	    extend(this, data);
	    updateOpts.apply(this, [isLoop, parent, isAnonymous, nextOpts, instAttrs]);
	
	    if (canTrigger && this.isMounted && isFunction(this.shouldUpdate) && !this.shouldUpdate(data, nextOpts)) {
	      return this
	    }
	
	    // inherit properties from the parent, but only for isAnonymous tags
	    if (isLoop && isAnonymous) { inheritFrom.apply(this, [this.parent, propsInSyncWithParent]); }
	    extend(opts, nextOpts);
	    if (canTrigger) { this.trigger('update', data); }
	    updateAllExpressions.call(this, expressions);
	    if (canTrigger) { this.trigger('updated'); }
	
	    return this
	
	  }.bind(this));
	
	  /**
	   * Add a mixin to this tag
	   * @returns { Tag } the current tag instance
	   */
	  defineProperty(this, 'mixin', function tagMixin() {
	    var this$1 = this;
	
	    each(arguments, function (mix) {
	      var instance, obj;
	      var props = [];
	
	      // properties blacklisted and will not be bound to the tag instance
	      var propsBlacklist = ['init', '__proto__'];
	
	      mix = isString(mix) ? mixin$1(mix) : mix;
	
	      // check if the mixin is a function
	      if (isFunction(mix)) {
	        // create the new mixin instance
	        instance = new mix();
	      } else { instance = mix; }
	
	      var proto = Object.getPrototypeOf(instance);
	
	      // build multilevel prototype inheritance chain property list
	      do { props = props.concat(Object.getOwnPropertyNames(obj || instance)); }
	      while (obj = Object.getPrototypeOf(obj || instance))
	
	      // loop the keys in the function prototype or the all object keys
	      each(props, function (key) {
	        // bind methods to this
	        // allow mixins to override other properties/parent mixins
	        if (!contains(propsBlacklist, key)) {
	          // check for getters/setters
	          var descriptor = Object.getOwnPropertyDescriptor(instance, key) || Object.getOwnPropertyDescriptor(proto, key);
	          var hasGetterSetter = descriptor && (descriptor.get || descriptor.set);
	
	          // apply method only if it does not already exist on the instance
	          if (!this$1.hasOwnProperty(key) && hasGetterSetter) {
	            Object.defineProperty(this$1, key, descriptor);
	          } else {
	            this$1[key] = isFunction(instance[key]) ?
	              instance[key].bind(this$1) :
	              instance[key];
	          }
	        }
	      });
	
	      // init method will be called automatically
	      if (instance.init)
	        { instance.init.bind(this$1)(); }
	    });
	    return this
	  }.bind(this));
	
	  /**
	   * Mount the current tag instance
	   * @returns { Tag } the current tag instance
	   */
	  defineProperty(this, 'mount', function tagMount() {
	    var this$1 = this;
	
	    root._tag = this; // keep a reference to the tag just created
	
	    // Read all the attrs on this instance. This give us the info we need for updateOpts
	    parseAttributes.apply(parent, [root, root.attributes, function (attr, expr) {
	      if (!isAnonymous && RefExpr.isPrototypeOf(expr)) { expr.tag = this$1; }
	      attr.expr = expr;
	      instAttrs.push(attr);
	    }]);
	
	    // update the root adding custom attributes coming from the compiler
	    implAttrs = [];
	    walkAttrs(impl.attrs, function (k, v) { implAttrs.push({name: k, value: v}); });
	    parseAttributes.apply(this, [root, implAttrs, function (attr, expr) {
	      if (expr) { expressions.push(expr); }
	      else { setAttr(root, attr.name, attr.value); }
	    }]);
	
	    // initialiation
	    updateOpts.apply(this, [isLoop, parent, isAnonymous, opts, instAttrs]);
	
	    // add global mixins
	    var globalMixin = mixin$1(GLOBAL_MIXIN);
	
	    if (globalMixin && !skipAnonymous) {
	      for (var i in globalMixin) {
	        if (globalMixin.hasOwnProperty(i)) {
	          this$1.mixin(globalMixin[i]);
	        }
	      }
	    }
	
	    if (impl.fn) { impl.fn.call(this, opts); }
	
	    if (!skipAnonymous) { this.trigger('before-mount'); }
	
	    // parse layout after init. fn may calculate args for nested custom tags
	    parseExpressions.apply(this, [dom, expressions, isAnonymous]);
	
	    this.update(item);
	
	    if (!isAnonymous && !isInline) {
	      while (dom.firstChild) { root.appendChild(dom.firstChild); }
	    }
	
	    defineProperty(this, 'root', root);
	    defineProperty(this, 'isMounted', true);
	
	    if (skipAnonymous) { return }
	
	    // if it's not a child tag we can trigger its mount event
	    if (!this.parent) {
	      this.trigger('mount');
	    }
	    // otherwise we need to wait that the parent "mount" or "updated" event gets triggered
	    else {
	      var p = getImmediateCustomParentTag(this.parent);
	      p.one(!p.isMounted ? 'mount' : 'updated', function () {
	        this$1.trigger('mount');
	      });
	    }
	
	    return this
	
	  }.bind(this));
	
	  /**
	   * Unmount the tag instance
	   * @param { Boolean } mustKeepRoot - if it's true the root node will not be removed
	   * @returns { Tag } the current tag instance
	   */
	  defineProperty(this, 'unmount', function tagUnmount(mustKeepRoot) {
	    var this$1 = this;
	
	    var el = this.root,
	      p = el.parentNode,
	      ptag,
	      tagIndex = __TAGS_CACHE.indexOf(this);
	
	    if (!skipAnonymous) { this.trigger('before-unmount'); }
	
	    // clear all attributes coming from the mounted tag
	    walkAttrs(impl.attrs, function (name) {
	      if (startsWith(name, ATTRS_PREFIX))
	        { name = name.slice(ATTRS_PREFIX.length); }
	
	      remAttr(root, name);
	    });
	
	    // remove all the event listeners
	    this.__.listeners.forEach(function (dom) {
	      Object.keys(dom[RIOT_EVENTS_KEY]).forEach(function (eventName) {
	        dom.removeEventListener(eventName, dom[RIOT_EVENTS_KEY][eventName]);
	      });
	    });
	
	    // remove this tag instance from the global virtualDom variable
	    if (tagIndex !== -1)
	      { __TAGS_CACHE.splice(tagIndex, 1); }
	
	    if (p || isVirtual) {
	      if (parent) {
	        ptag = getImmediateCustomParentTag(parent);
	
	        if (isVirtual) {
	          Object.keys(this.tags).forEach(function (tagName) {
	            arrayishRemove(ptag.tags, tagName, this$1.tags[tagName]);
	          });
	        } else {
	          arrayishRemove(ptag.tags, tagName, this);
	          // remove from _parent too
	          if(parent !== ptag) {
	            arrayishRemove(parent.tags, tagName, this);
	          }
	        }
	      } else {
	        // remove the tag contents
	        setInnerHTML(el, '');
	      }
	
	      if (p && !mustKeepRoot) { p.removeChild(el); }
	    }
	
	    if (this.__.virts) {
	      each(this.__.virts, function (v) {
	        if (v.parentNode) { v.parentNode.removeChild(v); }
	      });
	    }
	
	    // allow expressions to unmount themselves
	    unmountAll(expressions);
	    each(instAttrs, function (a) { return a.expr && a.expr.unmount && a.expr.unmount(); });
	
	    // custom internal unmount function to avoid relying on the observable
	    if (this.__.onUnmount) { this.__.onUnmount(); }
	
	    if (!skipAnonymous) {
	      this.trigger('unmount');
	      this.off('*');
	    }
	
	    defineProperty(this, 'isMounted', false);
	
	    delete this.root._tag;
	
	    return this
	
	  }.bind(this));
	}
	
	/**
	 * Detect the tag implementation by a DOM node
	 * @param   { Object } dom - DOM node we need to parse to get its tag implementation
	 * @returns { Object } it returns an object containing the implementation of a custom tag (template and boot function)
	 */
	function getTag(dom) {
	  return dom.tagName && __TAG_IMPL[getAttr(dom, IS_DIRECTIVE) ||
	    getAttr(dom, IS_DIRECTIVE) || dom.tagName.toLowerCase()]
	}
	
	/**
	 * Inherit properties from a target tag instance
	 * @this Tag
	 * @param   { Tag } target - tag where we will inherit properties
	 * @param   { Array } propsInSyncWithParent - array of properties to sync with the target
	 */
	function inheritFrom(target, propsInSyncWithParent) {
	  var this$1 = this;
	
	  each(Object.keys(target), function (k) {
	    // some properties must be always in sync with the parent tag
	    var mustSync = !isReservedName(k) && contains(propsInSyncWithParent, k);
	
	    if (isUndefined(this$1[k]) || mustSync) {
	      // track the property to keep in sync
	      // so we can keep it updated
	      if (!mustSync) { propsInSyncWithParent.push(k); }
	      this$1[k] = target[k];
	    }
	  });
	}
	
	/**
	 * Move the position of a custom tag in its parent tag
	 * @this Tag
	 * @param   { String } tagName - key where the tag was stored
	 * @param   { Number } newPos - index where the new tag will be stored
	 */
	function moveChildTag(tagName, newPos) {
	  var parent = this.parent,
	    tags;
	  // no parent no move
	  if (!parent) { return }
	
	  tags = parent.tags[tagName];
	
	  if (isArray(tags))
	    { tags.splice(newPos, 0, tags.splice(tags.indexOf(this), 1)[0]); }
	  else { arrayishAdd(parent.tags, tagName, this); }
	}
	
	/**
	 * Create a new child tag including it correctly into its parent
	 * @param   { Object } child - child tag implementation
	 * @param   { Object } opts - tag options containing the DOM node where the tag will be mounted
	 * @param   { String } innerHTML - inner html of the child node
	 * @param   { Object } parent - instance of the parent tag including the child custom tag
	 * @returns { Object } instance of the new child tag just created
	 */
	function initChildTag(child, opts, innerHTML, parent) {
	  var tag = new Tag$1(child, opts, innerHTML),
	    tagName = opts.tagName || getTagName(opts.root, true),
	    ptag = getImmediateCustomParentTag(parent);
	  // fix for the parent attribute in the looped elements
	  defineProperty(tag, 'parent', ptag);
	  // store the real parent tag
	  // in some cases this could be different from the custom parent tag
	  // for example in nested loops
	  tag.__.parent = parent;
	
	  // add this tag to the custom parent tag
	  arrayishAdd(ptag.tags, tagName, tag);
	
	  // and also to the real parent tag
	  if (ptag !== parent)
	    { arrayishAdd(parent.tags, tagName, tag); }
	
	  return tag
	}
	
	/**
	 * Loop backward all the parents tree to detect the first custom parent tag
	 * @param   { Object } tag - a Tag instance
	 * @returns { Object } the instance of the first custom parent tag found
	 */
	function getImmediateCustomParentTag(tag) {
	  var ptag = tag;
	  while (ptag.__.isAnonymous) {
	    if (!ptag.parent) { break }
	    ptag = ptag.parent;
	  }
	  return ptag
	}
	
	/**
	 * Trigger the unmount method on all the expressions
	 * @param   { Array } expressions - DOM expressions
	 */
	function unmountAll(expressions) {
	  each(expressions, function(expr) {
	    if (expr instanceof Tag$1) { expr.unmount(true); }
	    else if (expr.tagName) { expr.tag.unmount(true); }
	    else if (expr.unmount) { expr.unmount(); }
	  });
	}
	
	/**
	 * Get the tag name of any DOM node
	 * @param   { Object } dom - DOM node we want to parse
	 * @param   { Boolean } skipDataIs - hack to ignore the data-is attribute when attaching to parent
	 * @returns { String } name to identify this dom node in riot
	 */
	function getTagName(dom, skipDataIs) {
	  var child = getTag(dom),
	    namedTag = !skipDataIs && getAttr(dom, IS_DIRECTIVE);
	  return namedTag && !tmpl.hasExpr(namedTag) ?
	                namedTag :
	              child ? child.name : dom.tagName.toLowerCase()
	}
	
	/**
	 * With this function we avoid that the internal Tag methods get overridden
	 * @param   { Object } data - options we want to use to extend the tag instance
	 * @returns { Object } clean object without containing the riot internal reserved words
	 */
	function cleanUpData(data) {
	  if (!(data instanceof Tag$1) && !(data && isFunction(data.trigger)))
	    { return data }
	
	  var o = {};
	  for (var key in data) {
	    if (!RE_RESERVED_NAMES.test(key)) { o[key] = data[key]; }
	  }
	  return o
	}
	
	/**
	 * Set the property of an object for a given key. If something already
	 * exists there, then it becomes an array containing both the old and new value.
	 * @param { Object } obj - object on which to set the property
	 * @param { String } key - property name
	 * @param { Object } value - the value of the property to be set
	 * @param { Boolean } ensureArray - ensure that the property remains an array
	 * @param { Number } index - add the new item in a certain array position
	 */
	function arrayishAdd(obj, key, value, ensureArray, index) {
	  var dest = obj[key];
	  var isArr = isArray(dest);
	  var hasIndex = !isUndefined(index);
	
	  if (dest && dest === value) { return }
	
	  // if the key was never set, set it once
	  if (!dest && ensureArray) { obj[key] = [value]; }
	  else if (!dest) { obj[key] = value; }
	  // if it was an array and not yet set
	  else {
	    if (isArr) {
	      var oldIndex = dest.indexOf(value);
	      // this item never changed its position
	      if (oldIndex === index) { return }
	      // remove the item from its old position
	      if (oldIndex !== -1) { dest.splice(oldIndex, 1); }
	      // move or add the item
	      if (hasIndex) {
	        dest.splice(index, 0, value);
	      } else {
	        dest.push(value);
	      }
	    } else { obj[key] = [dest, value]; }
	  }
	}
	
	/**
	 * Removes an item from an object at a given key. If the key points to an array,
	 * then the item is just removed from the array.
	 * @param { Object } obj - object on which to remove the property
	 * @param { String } key - property name
	 * @param { Object } value - the value of the property to be removed
	 * @param { Boolean } ensureArray - ensure that the property remains an array
	*/
	function arrayishRemove(obj, key, value, ensureArray) {
	  if (isArray(obj[key])) {
	    var index = obj[key].indexOf(value);
	    if (index !== -1) { obj[key].splice(index, 1); }
	    if (!obj[key].length) { delete obj[key]; }
	    else if (obj[key].length === 1 && !ensureArray) { obj[key] = obj[key][0]; }
	  } else
	    { delete obj[key]; } // otherwise just delete the key
	}
	
	/**
	 * Mount a tag creating new Tag instance
	 * @param   { Object } root - dom node where the tag will be mounted
	 * @param   { String } tagName - name of the riot tag we want to mount
	 * @param   { Object } opts - options to pass to the Tag instance
	 * @param   { Object } ctx - optional context that will be used to extend an existing class ( used in riot.Tag )
	 * @returns { Tag } a new Tag instance
	 */
	function mountTo(root, tagName, opts, ctx) {
	  var impl = __TAG_IMPL[tagName],
	    implClass = __TAG_IMPL[tagName].class,
	    tag = ctx || (implClass ? Object.create(implClass.prototype) : {}),
	    // cache the inner HTML to fix #855
	    innerHTML = root._innerHTML = root._innerHTML || root.innerHTML;
	
	  var conf = extend({ root: root, opts: opts }, { parent: opts ? opts.parent : null });
	
	  if (impl && root) { Tag$1.apply(tag, [impl, conf, innerHTML]); }
	
	  if (tag && tag.mount) {
	    tag.mount(true);
	    // add this tag to the virtualDom variable
	    if (!contains(__TAGS_CACHE, tag)) { __TAGS_CACHE.push(tag); }
	  }
	
	  return tag
	}
	
	/**
	 * makes a tag virtual and replaces a reference in the dom
	 * @this Tag
	 * @param { tag } the tag to make virtual
	 * @param { ref } the dom reference location
	 */
	function makeReplaceVirtual(tag, ref) {
	  var frag = createFrag();
	  makeVirtual.call(tag, frag);
	  ref.parentNode.replaceChild(frag, ref);
	}
	
	/**
	 * Adds the elements for a virtual tag
	 * @this Tag
	 * @param { Node } src - the node that will do the inserting or appending
	 * @param { Tag } target - only if inserting, insert before this tag's first child
	 */
	function makeVirtual(src, target) {
	  var this$1 = this;
	
	  var head = createDOMPlaceholder(),
	    tail = createDOMPlaceholder(),
	    frag = createFrag(),
	    sib, el;
	
	  this.root.insertBefore(head, this.root.firstChild);
	  this.root.appendChild(tail);
	
	  this.__.head = el = head;
	  this.__.tail = tail;
	
	  while (el) {
	    sib = el.nextSibling;
	    frag.appendChild(el);
	    this$1.__.virts.push(el); // hold for unmounting
	    el = sib;
	  }
	
	  if (target)
	    { src.insertBefore(frag, target.__.head); }
	  else
	    { src.appendChild(frag); }
	}
	
	/**
	 * Move virtual tag and all child nodes
	 * @this Tag
	 * @param { Node } src  - the node that will do the inserting
	 * @param { Tag } target - insert before this tag's first child
	 */
	function moveVirtual(src, target) {
	  var this$1 = this;
	
	  var el = this.__.head,
	    frag = createFrag(),
	    sib;
	
	  while (el) {
	    sib = el.nextSibling;
	    frag.appendChild(el);
	    el = sib;
	    if (el === this$1.__.tail) {
	      frag.appendChild(el);
	      src.insertBefore(frag, target.__.head);
	      break
	    }
	  }
	}
	
	/**
	 * Get selectors for tags
	 * @param   { Array } tags - tag names to select
	 * @returns { String } selector
	 */
	function selectTags(tags) {
	  // select all tags
	  if (!tags) {
	    var keys = Object.keys(__TAG_IMPL);
	    return keys + selectTags(keys)
	  }
	
	  return tags
	    .filter(function (t) { return !/[^-\w]/.test(t); })
	    .reduce(function (list, t) {
	      var name = t.trim().toLowerCase();
	      return list + ",[" + IS_DIRECTIVE + "=\"" + name + "\"]"
	    }, '')
	}
	
	
	var tags = Object.freeze({
		getTag: getTag,
		inheritFrom: inheritFrom,
		moveChildTag: moveChildTag,
		initChildTag: initChildTag,
		getImmediateCustomParentTag: getImmediateCustomParentTag,
		unmountAll: unmountAll,
		getTagName: getTagName,
		cleanUpData: cleanUpData,
		arrayishAdd: arrayishAdd,
		arrayishRemove: arrayishRemove,
		mountTo: mountTo,
		makeReplaceVirtual: makeReplaceVirtual,
		makeVirtual: makeVirtual,
		moveVirtual: moveVirtual,
		selectTags: selectTags
	});
	
	/**
	 * Riot public api
	 */
	var settings = settings$1;
	var util = {
	  tmpl: tmpl,
	  brackets: brackets,
	  styleManager: styleManager,
	  vdom: __TAGS_CACHE,
	  styleNode: styleManager.styleNode,
	  // export the riot internal utils as well
	  dom: dom,
	  check: check,
	  misc: misc,
	  tags: tags
	};
	
	// export the core props/methods
	var Tag$$1 = Tag$2;
	var tag$$1 = tag$1;
	var tag2$$1 = tag2$1;
	var mount$$1 = mount$1;
	var mixin$$1 = mixin$1;
	var update$$1 = update$1;
	var unregister$$1 = unregister$1;
	var version$$1 = version$1;
	var observable = observable$1;
	
	var riot$1 = extend({}, core, {
	  observable: observable$1,
	  settings: settings,
	  util: util,
	});
	
	exports.settings = settings;
	exports.util = util;
	exports.Tag = Tag$$1;
	exports.tag = tag$$1;
	exports.tag2 = tag2$$1;
	exports.mount = mount$$1;
	exports.mixin = mixin$$1;
	exports.update = update$$1;
	exports.unregister = unregister$$1;
	exports.version = version$$1;
	exports.observable = observable;
	exports['default'] = riot$1;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _d3Axis = __webpack_require__(32);
	
	Object.defineProperty(exports, 'axisLeft', {
	  enumerable: true,
	  get: function get() {
	    return _d3Axis.axisLeft;
	  }
	});
	Object.defineProperty(exports, 'axisBottom', {
	  enumerable: true,
	  get: function get() {
	    return _d3Axis.axisBottom;
	  }
	});
	Object.defineProperty(exports, 'axisTop', {
	  enumerable: true,
	  get: function get() {
	    return _d3Axis.axisTop;
	  }
	});
	
	var _d3Shape = __webpack_require__(39);
	
	Object.defineProperty(exports, 'curveStep', {
	  enumerable: true,
	  get: function get() {
	    return _d3Shape.curveStep;
	  }
	});
	Object.defineProperty(exports, 'line', {
	  enumerable: true,
	  get: function get() {
	    return _d3Shape.line;
	  }
	});
	
	var _d3Array = __webpack_require__(11);
	
	Object.defineProperty(exports, 'extent', {
	  enumerable: true,
	  get: function get() {
	    return _d3Array.extent;
	  }
	});
	Object.defineProperty(exports, 'max', {
	  enumerable: true,
	  get: function get() {
	    return _d3Array.max;
	  }
	});
	
	var _d3Scale = __webpack_require__(37);
	
	Object.defineProperty(exports, 'scaleBand', {
	  enumerable: true,
	  get: function get() {
	    return _d3Scale.scaleBand;
	  }
	});
	Object.defineProperty(exports, 'scaleLinear', {
	  enumerable: true,
	  get: function get() {
	    return _d3Scale.scaleLinear;
	  }
	});
	Object.defineProperty(exports, 'scaleOrdinal', {
	  enumerable: true,
	  get: function get() {
	    return _d3Scale.scaleOrdinal;
	  }
	});
	Object.defineProperty(exports, 'scaleTime', {
	  enumerable: true,
	  get: function get() {
	    return _d3Scale.scaleTime;
	  }
	});
	
	var _d3Selection = __webpack_require__(38);
	
	Object.defineProperty(exports, 'select', {
	  enumerable: true,
	  get: function get() {
	    return _d3Selection.select;
	  }
	});
	Object.defineProperty(exports, 'selectAll', {
	  enumerable: true,
	  get: function get() {
	    return _d3Selection.selectAll;
	  }
	});
	
	var _d3TimeFormat = __webpack_require__(13);
	
	Object.defineProperty(exports, 'timeParse', {
	  enumerable: true,
	  get: function get() {
	    return _d3TimeFormat.timeParse;
	  }
	});
	Object.defineProperty(exports, 'timeFormat', {
	  enumerable: true,
	  get: function get() {
	    return _d3TimeFormat.timeFormat;
	  }
	});
	
	var _d3Color = __webpack_require__(6);
	
	Object.defineProperty(exports, 'rgb', {
	  enumerable: true,
	  get: function get() {
	    return _d3Color.rgb;
	  }
	});

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _d = __webpack_require__(2);
	
	var d3 = _interopRequireWildcard(_d);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var measurements = __webpack_require__(43);
	var measurementsHistory = __webpack_require__(42);
	
	exports.default = Object.keys(measurements).filter(function (k) {
	  return !!k;
	}).map(function (k) {
	  var _measurements = measurements[k].stations.map(function (m) {
	    m.history = measurementsHistory[m.mstnr];
	    m.city = k;
	    return m;
	  });
	  return {
	    name: k,
	    plz: measurements[k].plz,
	    mVal: d3.max(_measurements.map(function (d) {
	      return d.value;
	    })),
	    measurements: _measurements
	  };
	}).sort(function (a, b) {
	  return +b.mVal - +a.mVal;
	});

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	__webpack_require__(8);
	
	riot.tag2('close-button', '<button class="btn button button--close"> <entypo-svg symbol="close"></entypo-svg> </button>', '', '', function (opts) {}); /*
	                                                                                                                                                        * reusable close button element that needs a handler via `opts`
	                                                                                                                                                        */
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _d = __webpack_require__(2);
	
	var d3 = _interopRequireWildcard(_d);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var formatDate = d3.timeFormat('%d.%m.%Y');
	var parseDate = d3.timeParse('%Y-%m-%d');
	
	module.exports = {
	  fromDate: function fromDate(date) {
	    return formatDate(date);
	  },
	  toDate: function toDate(str) {
	    return parseDate(str);
	  },
	  convertDate: function convertDate(str) {
	    return formatDate(parseDate(str));
	  }
	};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-color/ Version 1.0.3. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var define = function(constructor, factory, prototype) {
	  constructor.prototype = factory.prototype = prototype;
	  prototype.constructor = constructor;
	};
	
	function extend(parent, definition) {
	  var prototype = Object.create(parent.prototype);
	  for (var key in definition) prototype[key] = definition[key];
	  return prototype;
	}
	
	function Color() {}
	
	var darker = 0.7;
	var brighter = 1 / darker;
	
	var reI = "\\s*([+-]?\\d+)\\s*";
	var reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*";
	var reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*";
	var reHex3 = /^#([0-9a-f]{3})$/;
	var reHex6 = /^#([0-9a-f]{6})$/;
	var reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$");
	var reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$");
	var reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$");
	var reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$");
	var reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$");
	var reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");
	
	var named = {
	  aliceblue: 0xf0f8ff,
	  antiquewhite: 0xfaebd7,
	  aqua: 0x00ffff,
	  aquamarine: 0x7fffd4,
	  azure: 0xf0ffff,
	  beige: 0xf5f5dc,
	  bisque: 0xffe4c4,
	  black: 0x000000,
	  blanchedalmond: 0xffebcd,
	  blue: 0x0000ff,
	  blueviolet: 0x8a2be2,
	  brown: 0xa52a2a,
	  burlywood: 0xdeb887,
	  cadetblue: 0x5f9ea0,
	  chartreuse: 0x7fff00,
	  chocolate: 0xd2691e,
	  coral: 0xff7f50,
	  cornflowerblue: 0x6495ed,
	  cornsilk: 0xfff8dc,
	  crimson: 0xdc143c,
	  cyan: 0x00ffff,
	  darkblue: 0x00008b,
	  darkcyan: 0x008b8b,
	  darkgoldenrod: 0xb8860b,
	  darkgray: 0xa9a9a9,
	  darkgreen: 0x006400,
	  darkgrey: 0xa9a9a9,
	  darkkhaki: 0xbdb76b,
	  darkmagenta: 0x8b008b,
	  darkolivegreen: 0x556b2f,
	  darkorange: 0xff8c00,
	  darkorchid: 0x9932cc,
	  darkred: 0x8b0000,
	  darksalmon: 0xe9967a,
	  darkseagreen: 0x8fbc8f,
	  darkslateblue: 0x483d8b,
	  darkslategray: 0x2f4f4f,
	  darkslategrey: 0x2f4f4f,
	  darkturquoise: 0x00ced1,
	  darkviolet: 0x9400d3,
	  deeppink: 0xff1493,
	  deepskyblue: 0x00bfff,
	  dimgray: 0x696969,
	  dimgrey: 0x696969,
	  dodgerblue: 0x1e90ff,
	  firebrick: 0xb22222,
	  floralwhite: 0xfffaf0,
	  forestgreen: 0x228b22,
	  fuchsia: 0xff00ff,
	  gainsboro: 0xdcdcdc,
	  ghostwhite: 0xf8f8ff,
	  gold: 0xffd700,
	  goldenrod: 0xdaa520,
	  gray: 0x808080,
	  green: 0x008000,
	  greenyellow: 0xadff2f,
	  grey: 0x808080,
	  honeydew: 0xf0fff0,
	  hotpink: 0xff69b4,
	  indianred: 0xcd5c5c,
	  indigo: 0x4b0082,
	  ivory: 0xfffff0,
	  khaki: 0xf0e68c,
	  lavender: 0xe6e6fa,
	  lavenderblush: 0xfff0f5,
	  lawngreen: 0x7cfc00,
	  lemonchiffon: 0xfffacd,
	  lightblue: 0xadd8e6,
	  lightcoral: 0xf08080,
	  lightcyan: 0xe0ffff,
	  lightgoldenrodyellow: 0xfafad2,
	  lightgray: 0xd3d3d3,
	  lightgreen: 0x90ee90,
	  lightgrey: 0xd3d3d3,
	  lightpink: 0xffb6c1,
	  lightsalmon: 0xffa07a,
	  lightseagreen: 0x20b2aa,
	  lightskyblue: 0x87cefa,
	  lightslategray: 0x778899,
	  lightslategrey: 0x778899,
	  lightsteelblue: 0xb0c4de,
	  lightyellow: 0xffffe0,
	  lime: 0x00ff00,
	  limegreen: 0x32cd32,
	  linen: 0xfaf0e6,
	  magenta: 0xff00ff,
	  maroon: 0x800000,
	  mediumaquamarine: 0x66cdaa,
	  mediumblue: 0x0000cd,
	  mediumorchid: 0xba55d3,
	  mediumpurple: 0x9370db,
	  mediumseagreen: 0x3cb371,
	  mediumslateblue: 0x7b68ee,
	  mediumspringgreen: 0x00fa9a,
	  mediumturquoise: 0x48d1cc,
	  mediumvioletred: 0xc71585,
	  midnightblue: 0x191970,
	  mintcream: 0xf5fffa,
	  mistyrose: 0xffe4e1,
	  moccasin: 0xffe4b5,
	  navajowhite: 0xffdead,
	  navy: 0x000080,
	  oldlace: 0xfdf5e6,
	  olive: 0x808000,
	  olivedrab: 0x6b8e23,
	  orange: 0xffa500,
	  orangered: 0xff4500,
	  orchid: 0xda70d6,
	  palegoldenrod: 0xeee8aa,
	  palegreen: 0x98fb98,
	  paleturquoise: 0xafeeee,
	  palevioletred: 0xdb7093,
	  papayawhip: 0xffefd5,
	  peachpuff: 0xffdab9,
	  peru: 0xcd853f,
	  pink: 0xffc0cb,
	  plum: 0xdda0dd,
	  powderblue: 0xb0e0e6,
	  purple: 0x800080,
	  rebeccapurple: 0x663399,
	  red: 0xff0000,
	  rosybrown: 0xbc8f8f,
	  royalblue: 0x4169e1,
	  saddlebrown: 0x8b4513,
	  salmon: 0xfa8072,
	  sandybrown: 0xf4a460,
	  seagreen: 0x2e8b57,
	  seashell: 0xfff5ee,
	  sienna: 0xa0522d,
	  silver: 0xc0c0c0,
	  skyblue: 0x87ceeb,
	  slateblue: 0x6a5acd,
	  slategray: 0x708090,
	  slategrey: 0x708090,
	  snow: 0xfffafa,
	  springgreen: 0x00ff7f,
	  steelblue: 0x4682b4,
	  tan: 0xd2b48c,
	  teal: 0x008080,
	  thistle: 0xd8bfd8,
	  tomato: 0xff6347,
	  turquoise: 0x40e0d0,
	  violet: 0xee82ee,
	  wheat: 0xf5deb3,
	  white: 0xffffff,
	  whitesmoke: 0xf5f5f5,
	  yellow: 0xffff00,
	  yellowgreen: 0x9acd32
	};
	
	define(Color, color, {
	  displayable: function() {
	    return this.rgb().displayable();
	  },
	  toString: function() {
	    return this.rgb() + "";
	  }
	});
	
	function color(format) {
	  var m;
	  format = (format + "").trim().toLowerCase();
	  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
	      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
	      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
	      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
	      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
	      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
	      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
	      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
	      : named.hasOwnProperty(format) ? rgbn(named[format])
	      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
	      : null;
	}
	
	function rgbn(n) {
	  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
	}
	
	function rgba(r, g, b, a) {
	  if (a <= 0) r = g = b = NaN;
	  return new Rgb(r, g, b, a);
	}
	
	function rgbConvert(o) {
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Rgb;
	  o = o.rgb();
	  return new Rgb(o.r, o.g, o.b, o.opacity);
	}
	
	function rgb(r, g, b, opacity) {
	  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
	}
	
	function Rgb(r, g, b, opacity) {
	  this.r = +r;
	  this.g = +g;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Rgb, rgb, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  rgb: function() {
	    return this;
	  },
	  displayable: function() {
	    return (0 <= this.r && this.r <= 255)
	        && (0 <= this.g && this.g <= 255)
	        && (0 <= this.b && this.b <= 255)
	        && (0 <= this.opacity && this.opacity <= 1);
	  },
	  toString: function() {
	    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	    return (a === 1 ? "rgb(" : "rgba(")
	        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
	        + (a === 1 ? ")" : ", " + a + ")");
	  }
	}));
	
	function hsla(h, s, l, a) {
	  if (a <= 0) h = s = l = NaN;
	  else if (l <= 0 || l >= 1) h = s = NaN;
	  else if (s <= 0) h = NaN;
	  return new Hsl(h, s, l, a);
	}
	
	function hslConvert(o) {
	  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Hsl;
	  if (o instanceof Hsl) return o;
	  o = o.rgb();
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      h = NaN,
	      s = max - min,
	      l = (max + min) / 2;
	  if (s) {
	    if (r === max) h = (g - b) / s + (g < b) * 6;
	    else if (g === max) h = (b - r) / s + 2;
	    else h = (r - g) / s + 4;
	    s /= l < 0.5 ? max + min : 2 - max - min;
	    h *= 60;
	  } else {
	    s = l > 0 && l < 1 ? 0 : h;
	  }
	  return new Hsl(h, s, l, o.opacity);
	}
	
	function hsl(h, s, l, opacity) {
	  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Hsl(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hsl, hsl, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = this.h % 360 + (this.h < 0) * 360,
	        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
	        l = this.l,
	        m2 = l + (l < 0.5 ? l : 1 - l) * s,
	        m1 = 2 * l - m2;
	    return new Rgb(
	      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
	      hsl2rgb(h, m1, m2),
	      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
	      this.opacity
	    );
	  },
	  displayable: function() {
	    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
	        && (0 <= this.l && this.l <= 1)
	        && (0 <= this.opacity && this.opacity <= 1);
	  }
	}));
	
	/* From FvD 13.37, CSS Color Module Level 3 */
	function hsl2rgb(h, m1, m2) {
	  return (h < 60 ? m1 + (m2 - m1) * h / 60
	      : h < 180 ? m2
	      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
	      : m1) * 255;
	}
	
	var deg2rad = Math.PI / 180;
	var rad2deg = 180 / Math.PI;
	
	var Kn = 18;
	var Xn = 0.950470;
	var Yn = 1;
	var Zn = 1.088830;
	var t0 = 4 / 29;
	var t1 = 6 / 29;
	var t2 = 3 * t1 * t1;
	var t3 = t1 * t1 * t1;
	
	function labConvert(o) {
	  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
	  if (o instanceof Hcl) {
	    var h = o.h * deg2rad;
	    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
	  }
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var b = rgb2xyz(o.r),
	      a = rgb2xyz(o.g),
	      l = rgb2xyz(o.b),
	      x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
	      y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
	      z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
	  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
	}
	
	function lab(l, a, b, opacity) {
	  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
	}
	
	function Lab(l, a, b, opacity) {
	  this.l = +l;
	  this.a = +a;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Lab, lab, extend(Color, {
	  brighter: function(k) {
	    return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  darker: function(k) {
	    return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  rgb: function() {
	    var y = (this.l + 16) / 116,
	        x = isNaN(this.a) ? y : y + this.a / 500,
	        z = isNaN(this.b) ? y : y - this.b / 200;
	    y = Yn * lab2xyz(y);
	    x = Xn * lab2xyz(x);
	    z = Zn * lab2xyz(z);
	    return new Rgb(
	      xyz2rgb( 3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
	      xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z),
	      xyz2rgb( 0.0556434 * x - 0.2040259 * y + 1.0572252 * z),
	      this.opacity
	    );
	  }
	}));
	
	function xyz2lab(t) {
	  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
	}
	
	function lab2xyz(t) {
	  return t > t1 ? t * t * t : t2 * (t - t0);
	}
	
	function xyz2rgb(x) {
	  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
	}
	
	function rgb2xyz(x) {
	  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
	}
	
	function hclConvert(o) {
	  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
	  if (!(o instanceof Lab)) o = labConvert(o);
	  var h = Math.atan2(o.b, o.a) * rad2deg;
	  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
	}
	
	function hcl(h, c, l, opacity) {
	  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function Hcl(h, c, l, opacity) {
	  this.h = +h;
	  this.c = +c;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hcl, hcl, extend(Color, {
	  brighter: function(k) {
	    return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k), this.opacity);
	  },
	  darker: function(k) {
	    return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k), this.opacity);
	  },
	  rgb: function() {
	    return labConvert(this).rgb();
	  }
	}));
	
	var A = -0.14861;
	var B = +1.78277;
	var C = -0.29227;
	var D = -0.90649;
	var E = +1.97294;
	var ED = E * D;
	var EB = E * B;
	var BC_DA = B * C - D * A;
	
	function cubehelixConvert(o) {
	  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
	      bl = b - l,
	      k = (E * (g - l) - C * bl) / D,
	      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
	      h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
	  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
	}
	
	function cubehelix(h, s, l, opacity) {
	  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Cubehelix(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Cubehelix, cubehelix, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
	        l = +this.l,
	        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
	        cosh = Math.cos(h),
	        sinh = Math.sin(h);
	    return new Rgb(
	      255 * (l + a * (A * cosh + B * sinh)),
	      255 * (l + a * (C * cosh + D * sinh)),
	      255 * (l + a * (E * cosh)),
	      this.opacity
	    );
	  }
	}));
	
	exports.color = color;
	exports.rgb = rgb;
	exports.hsl = hsl;
	exports.lab = lab;
	exports.hcl = hcl;
	exports.cubehelix = cubehelix;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	var _d = __webpack_require__(2);
	
	var d3 = _interopRequireWildcard(_d);
	
	var _get_color = __webpack_require__(9);
	
	var _get_color2 = _interopRequireDefault(_get_color);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	riot.tag2('bullet', '', '', 'class="bullet" riot-style="left:{opts.data.value / 3}%;background-color:{fillColor};border-color:{strokeColor};" onclick="{onClick}" onmouseover="{onClick}"', function (opts) {
	  var _this = this;
	
	  this.fillColor = (0, _get_color2.default)(this.opts.data.value);
	  this.strokeColor = d3.rgb(this.fillColor).darker(1);
	  this.onClick = function () {
	    return !_this.opts.data.legend && riot.control.trigger(riot.EVT.updateStationInfobox, _this.opts.data);
	  };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	var symbols = {
	  goTop: __webpack_require__(45),
	  goBottom: __webpack_require__(44),
	  goBack: __webpack_require__(47),
	  goForth: __webpack_require__(46),
	  reverse: __webpack_require__(48),
	  close: __webpack_require__(50),
	  info: __webpack_require__(49)
	};
	
	riot.tag2('entypo-svg', '', '', 'class="entypo-svg"', function (opts) {
	  var _this = this;
	
	  this.updateContent = function () {
	    _this.root.innerHTML = symbols[_this.opts.symbol];
	  };
	
	  this.on('update', function () {
	    _this.updateContent();
	  });
	
	  this.updateContent();
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _d3ScaleChromatic = __webpack_require__(36);
	
	var _d = __webpack_require__(2);
	
	var d3 = _interopRequireWildcard(_d);
	
	var _datasets = __webpack_require__(3);
	
	var _datasets2 = _interopRequireDefault(_datasets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var colorDomain = [0, d3.max(_datasets2.default.map(function (d) {
	  return d.mVal;
	}))]; /* show color based on measured value */
	
	var cScale = d3.scaleLinear().range([0, 1]).domain(colorDomain);
	
	exports.default = function (val) {
	  return (0, _d3ScaleChromatic.interpolateYlOrRd)(cScale(val));
	};

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (_ref) {
	  var selection = _ref.selection,
	      x = _ref.x,
	      y = _ref.y,
	      height = _ref.height;
	
	  selection.append('rect').attr('class', 'history-chart__bar').attr('x', function (d) {
	    return x(d.date);
	  }).attr('y', function (d) {
	    return y(d.value);
	  }).attr('width', 3).attr('height', function (d) {
	    return height - y(d.value);
	  });
	};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-array/ Version 1.2.0. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var ascending = function(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	};
	
	var bisector = function(compare) {
	  if (compare.length === 1) compare = ascendingComparator(compare);
	  return {
	    left: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) < 0) lo = mid + 1;
	        else hi = mid;
	      }
	      return lo;
	    },
	    right: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) > 0) hi = mid;
	        else lo = mid + 1;
	      }
	      return lo;
	    }
	  };
	};
	
	function ascendingComparator(f) {
	  return function(d, x) {
	    return ascending(f(d), x);
	  };
	}
	
	var ascendingBisect = bisector(ascending);
	var bisectRight = ascendingBisect.right;
	var bisectLeft = ascendingBisect.left;
	
	var pairs = function(array, f) {
	  if (f == null) f = pair;
	  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
	  while (i < n) pairs[i] = f(p, p = array[++i]);
	  return pairs;
	};
	
	function pair(a, b) {
	  return [a, b];
	}
	
	var cross = function(values0, values1, reduce) {
	  var n0 = values0.length,
	      n1 = values1.length,
	      values = new Array(n0 * n1),
	      i0,
	      i1,
	      i,
	      value0;
	
	  if (reduce == null) reduce = pair;
	
	  for (i0 = i = 0; i0 < n0; ++i0) {
	    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
	      values[i] = reduce(value0, values1[i1]);
	    }
	  }
	
	  return values;
	};
	
	var descending = function(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	};
	
	var number = function(x) {
	  return x === null ? NaN : +x;
	};
	
	var variance = function(values, valueof) {
	  var n = values.length,
	      m = 0,
	      i = -1,
	      mean = 0,
	      value,
	      delta,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  if (m > 1) return sum / (m - 1);
	};
	
	var deviation = function(array, f) {
	  var v = variance(array, f);
	  return v ? Math.sqrt(v) : v;
	};
	
	var extent = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return [min, max];
	};
	
	var array = Array.prototype;
	
	var slice = array.slice;
	var map = array.map;
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var identity = function(x) {
	  return x;
	};
	
	var range = function(start, stop, step) {
	  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
	
	  var i = -1,
	      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
	      range = new Array(n);
	
	  while (++i < n) {
	    range[i] = start + i * step;
	  }
	
	  return range;
	};
	
	var e10 = Math.sqrt(50);
	var e5 = Math.sqrt(10);
	var e2 = Math.sqrt(2);
	
	var ticks = function(start, stop, count) {
	  var reverse = stop < start,
	      i = -1,
	      n,
	      ticks,
	      step;
	
	  if (reverse) n = start, start = stop, stop = n;
	
	  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
	
	  if (step > 0) {
	    start = Math.ceil(start / step);
	    stop = Math.floor(stop / step);
	    ticks = new Array(n = Math.ceil(stop - start + 1));
	    while (++i < n) ticks[i] = (start + i) * step;
	  } else {
	    start = Math.floor(start * step);
	    stop = Math.ceil(stop * step);
	    ticks = new Array(n = Math.ceil(start - stop + 1));
	    while (++i < n) ticks[i] = (start - i) / step;
	  }
	
	  if (reverse) ticks.reverse();
	
	  return ticks;
	};
	
	function tickIncrement(start, stop, count) {
	  var step = (stop - start) / Math.max(0, count),
	      power = Math.floor(Math.log(step) / Math.LN10),
	      error = step / Math.pow(10, power);
	  return power >= 0
	      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
	      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
	}
	
	function tickStep(start, stop, count) {
	  var step0 = Math.abs(stop - start) / Math.max(0, count),
	      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
	      error = step0 / step1;
	  if (error >= e10) step1 *= 10;
	  else if (error >= e5) step1 *= 5;
	  else if (error >= e2) step1 *= 2;
	  return stop < start ? -step1 : step1;
	}
	
	var sturges = function(values) {
	  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
	};
	
	var histogram = function() {
	  var value = identity,
	      domain = extent,
	      threshold = sturges;
	
	  function histogram(data) {
	    var i,
	        n = data.length,
	        x,
	        values = new Array(n);
	
	    for (i = 0; i < n; ++i) {
	      values[i] = value(data[i], i, data);
	    }
	
	    var xz = domain(values),
	        x0 = xz[0],
	        x1 = xz[1],
	        tz = threshold(values, x0, x1);
	
	    // Convert number of thresholds into uniform thresholds.
	    if (!Array.isArray(tz)) {
	      tz = tickStep(x0, x1, tz);
	      tz = range(Math.ceil(x0 / tz) * tz, Math.floor(x1 / tz) * tz, tz); // exclusive
	    }
	
	    // Remove any thresholds outside the domain.
	    var m = tz.length;
	    while (tz[0] <= x0) tz.shift(), --m;
	    while (tz[m - 1] > x1) tz.pop(), --m;
	
	    var bins = new Array(m + 1),
	        bin;
	
	    // Initialize bins.
	    for (i = 0; i <= m; ++i) {
	      bin = bins[i] = [];
	      bin.x0 = i > 0 ? tz[i - 1] : x0;
	      bin.x1 = i < m ? tz[i] : x1;
	    }
	
	    // Assign data to bins by value, ignoring any outside the domain.
	    for (i = 0; i < n; ++i) {
	      x = values[i];
	      if (x0 <= x && x <= x1) {
	        bins[bisectRight(tz, x, 0, m)].push(data[i]);
	      }
	    }
	
	    return bins;
	  }
	
	  histogram.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
	  };
	
	  histogram.domain = function(_) {
	    return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
	  };
	
	  histogram.thresholds = function(_) {
	    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
	  };
	
	  return histogram;
	};
	
	var quantile = function(values, p, valueof) {
	  if (valueof == null) valueof = number;
	  if (!(n = values.length)) return;
	  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
	  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
	  var n,
	      i = (n - 1) * p,
	      i0 = Math.floor(i),
	      value0 = +valueof(values[i0], i0, values),
	      value1 = +valueof(values[i0 + 1], i0 + 1, values);
	  return value0 + (value1 - value0) * (i - i0);
	};
	
	var freedmanDiaconis = function(values, min, max) {
	  values = map.call(values, number).sort(ascending);
	  return Math.ceil((max - min) / (2 * (quantile(values, 0.75) - quantile(values, 0.25)) * Math.pow(values.length, -1 / 3)));
	};
	
	var scott = function(values, min, max) {
	  return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
	};
	
	var max = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return max;
	};
	
	var mean = function(values, valueof) {
	  var n = values.length,
	      m = n,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) sum += value;
	      else --m;
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) sum += value;
	      else --m;
	    }
	  }
	
	  if (m) return sum / m;
	};
	
	var median = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      numbers = [];
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  return quantile(numbers.sort(ascending), 0.5);
	};
	
	var merge = function(arrays) {
	  var n = arrays.length,
	      m,
	      i = -1,
	      j = 0,
	      merged,
	      array;
	
	  while (++i < n) j += arrays[i].length;
	  merged = new Array(j);
	
	  while (--n >= 0) {
	    array = arrays[n];
	    m = array.length;
	    while (--m >= 0) {
	      merged[--j] = array[m];
	    }
	  }
	
	  return merged;
	};
	
	var min = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  return min;
	};
	
	var permute = function(array, indexes) {
	  var i = indexes.length, permutes = new Array(i);
	  while (i--) permutes[i] = array[indexes[i]];
	  return permutes;
	};
	
	var scan = function(values, compare) {
	  if (!(n = values.length)) return;
	  var n,
	      i = 0,
	      j = 0,
	      xi,
	      xj = values[j];
	
	  if (compare == null) compare = ascending;
	
	  while (++i < n) {
	    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
	      xj = xi, j = i;
	    }
	  }
	
	  if (compare(xj, xj) === 0) return j;
	};
	
	var shuffle = function(array, i0, i1) {
	  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
	      t,
	      i;
	
	  while (m) {
	    i = Math.random() * m-- | 0;
	    t = array[m + i0];
	    array[m + i0] = array[i + i0];
	    array[i + i0] = t;
	  }
	
	  return array;
	};
	
	var sum = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (value = +valueof(values[i], i, values)) sum += value;
	    }
	  }
	
	  return sum;
	};
	
	var transpose = function(matrix) {
	  if (!(n = matrix.length)) return [];
	  for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
	    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
	      row[j] = matrix[j][i];
	    }
	  }
	  return transpose;
	};
	
	function length(d) {
	  return d.length;
	}
	
	var zip = function() {
	  return transpose(arguments);
	};
	
	exports.bisect = bisectRight;
	exports.bisectRight = bisectRight;
	exports.bisectLeft = bisectLeft;
	exports.ascending = ascending;
	exports.bisector = bisector;
	exports.cross = cross;
	exports.descending = descending;
	exports.deviation = deviation;
	exports.extent = extent;
	exports.histogram = histogram;
	exports.thresholdFreedmanDiaconis = freedmanDiaconis;
	exports.thresholdScott = scott;
	exports.thresholdSturges = sturges;
	exports.max = max;
	exports.mean = mean;
	exports.median = median;
	exports.merge = merge;
	exports.min = min;
	exports.pairs = pairs;
	exports.permute = permute;
	exports.quantile = quantile;
	exports.range = range;
	exports.scan = scan;
	exports.shuffle = shuffle;
	exports.sum = sum;
	exports.ticks = ticks;
	exports.tickIncrement = tickIncrement;
	exports.tickStep = tickStep;
	exports.transpose = transpose;
	exports.variance = variance;
	exports.zip = zip;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-interpolate/ Version 1.1.5. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(6)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-color'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Color) { 'use strict';
	
	function basis(t1, v0, v1, v2, v3) {
	  var t2 = t1 * t1, t3 = t2 * t1;
	  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
	      + (4 - 6 * t2 + 3 * t3) * v1
	      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
	      + t3 * v3) / 6;
	}
	
	var basis$1 = function(values) {
	  var n = values.length - 1;
	  return function(t) {
	    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
	        v1 = values[i],
	        v2 = values[i + 1],
	        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
	        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	};
	
	var basisClosed = function(values) {
	  var n = values.length;
	  return function(t) {
	    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
	        v0 = values[(i + n - 1) % n],
	        v1 = values[i % n],
	        v2 = values[(i + 1) % n],
	        v3 = values[(i + 2) % n];
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	};
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function linear(a, d) {
	  return function(t) {
	    return a + t * d;
	  };
	}
	
	function exponential(a, b, y) {
	  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
	    return Math.pow(a + t * b, y);
	  };
	}
	
	function hue(a, b) {
	  var d = b - a;
	  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
	}
	
	function gamma(y) {
	  return (y = +y) === 1 ? nogamma : function(a, b) {
	    return b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
	  };
	}
	
	function nogamma(a, b) {
	  var d = b - a;
	  return d ? linear(a, d) : constant(isNaN(a) ? b : a);
	}
	
	var rgb$1 = ((function rgbGamma(y) {
	  var color$$1 = gamma(y);
	
	  function rgb$$1(start, end) {
	    var r = color$$1((start = d3Color.rgb(start)).r, (end = d3Color.rgb(end)).r),
	        g = color$$1(start.g, end.g),
	        b = color$$1(start.b, end.b),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.r = r(t);
	      start.g = g(t);
	      start.b = b(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	
	  rgb$$1.gamma = rgbGamma;
	
	  return rgb$$1;
	}))(1);
	
	function rgbSpline(spline) {
	  return function(colors) {
	    var n = colors.length,
	        r = new Array(n),
	        g = new Array(n),
	        b = new Array(n),
	        i, color$$1;
	    for (i = 0; i < n; ++i) {
	      color$$1 = d3Color.rgb(colors[i]);
	      r[i] = color$$1.r || 0;
	      g[i] = color$$1.g || 0;
	      b[i] = color$$1.b || 0;
	    }
	    r = spline(r);
	    g = spline(g);
	    b = spline(b);
	    color$$1.opacity = 1;
	    return function(t) {
	      color$$1.r = r(t);
	      color$$1.g = g(t);
	      color$$1.b = b(t);
	      return color$$1 + "";
	    };
	  };
	}
	
	var rgbBasis = rgbSpline(basis$1);
	var rgbBasisClosed = rgbSpline(basisClosed);
	
	var array = function(a, b) {
	  var nb = b ? b.length : 0,
	      na = a ? Math.min(nb, a.length) : 0,
	      x = new Array(nb),
	      c = new Array(nb),
	      i;
	
	  for (i = 0; i < na; ++i) x[i] = value(a[i], b[i]);
	  for (; i < nb; ++i) c[i] = b[i];
	
	  return function(t) {
	    for (i = 0; i < na; ++i) c[i] = x[i](t);
	    return c;
	  };
	};
	
	var date = function(a, b) {
	  var d = new Date;
	  return a = +a, b -= a, function(t) {
	    return d.setTime(a + b * t), d;
	  };
	};
	
	var number = function(a, b) {
	  return a = +a, b -= a, function(t) {
	    return a + b * t;
	  };
	};
	
	var object = function(a, b) {
	  var i = {},
	      c = {},
	      k;
	
	  if (a === null || typeof a !== "object") a = {};
	  if (b === null || typeof b !== "object") b = {};
	
	  for (k in b) {
	    if (k in a) {
	      i[k] = value(a[k], b[k]);
	    } else {
	      c[k] = b[k];
	    }
	  }
	
	  return function(t) {
	    for (k in i) c[k] = i[k](t);
	    return c;
	  };
	};
	
	var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g;
	var reB = new RegExp(reA.source, "g");
	
	function zero(b) {
	  return function() {
	    return b;
	  };
	}
	
	function one(b) {
	  return function(t) {
	    return b(t) + "";
	  };
	}
	
	var string = function(a, b) {
	  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
	      am, // current match in a
	      bm, // current match in b
	      bs, // string preceding current number in b, if any
	      i = -1, // index in s
	      s = [], // string constants and placeholders
	      q = []; // number interpolators
	
	  // Coerce inputs to strings.
	  a = a + "", b = b + "";
	
	  // Interpolate pairs of numbers in a & b.
	  while ((am = reA.exec(a))
	      && (bm = reB.exec(b))) {
	    if ((bs = bm.index) > bi) { // a string precedes the next number in b
	      bs = b.slice(bi, bs);
	      if (s[i]) s[i] += bs; // coalesce with previous string
	      else s[++i] = bs;
	    }
	    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
	      if (s[i]) s[i] += bm; // coalesce with previous string
	      else s[++i] = bm;
	    } else { // interpolate non-matching numbers
	      s[++i] = null;
	      q.push({i: i, x: number(am, bm)});
	    }
	    bi = reB.lastIndex;
	  }
	
	  // Add remains of b.
	  if (bi < b.length) {
	    bs = b.slice(bi);
	    if (s[i]) s[i] += bs; // coalesce with previous string
	    else s[++i] = bs;
	  }
	
	  // Special optimization for only a single match.
	  // Otherwise, interpolate each of the numbers and rejoin the string.
	  return s.length < 2 ? (q[0]
	      ? one(q[0].x)
	      : zero(b))
	      : (b = q.length, function(t) {
	          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	          return s.join("");
	        });
	};
	
	var value = function(a, b) {
	  var t = typeof b, c;
	  return b == null || t === "boolean" ? constant(b)
	      : (t === "number" ? number
	      : t === "string" ? ((c = d3Color.color(b)) ? (b = c, rgb$1) : string)
	      : b instanceof d3Color.color ? rgb$1
	      : b instanceof Date ? date
	      : Array.isArray(b) ? array
	      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
	      : number)(a, b);
	};
	
	var round = function(a, b) {
	  return a = +a, b -= a, function(t) {
	    return Math.round(a + b * t);
	  };
	};
	
	var degrees = 180 / Math.PI;
	
	var identity = {
	  translateX: 0,
	  translateY: 0,
	  rotate: 0,
	  skewX: 0,
	  scaleX: 1,
	  scaleY: 1
	};
	
	var decompose = function(a, b, c, d, e, f) {
	  var scaleX, scaleY, skewX;
	  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
	  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
	  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
	  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
	  return {
	    translateX: e,
	    translateY: f,
	    rotate: Math.atan2(b, a) * degrees,
	    skewX: Math.atan(skewX) * degrees,
	    scaleX: scaleX,
	    scaleY: scaleY
	  };
	};
	
	var cssNode;
	var cssRoot;
	var cssView;
	var svgNode;
	
	function parseCss(value) {
	  if (value === "none") return identity;
	  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
	  cssNode.style.transform = value;
	  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
	  cssRoot.removeChild(cssNode);
	  value = value.slice(7, -1).split(",");
	  return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
	}
	
	function parseSvg(value) {
	  if (value == null) return identity;
	  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
	  svgNode.setAttribute("transform", value);
	  if (!(value = svgNode.transform.baseVal.consolidate())) return identity;
	  value = value.matrix;
	  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
	}
	
	function interpolateTransform(parse, pxComma, pxParen, degParen) {
	
	  function pop(s) {
	    return s.length ? s.pop() + " " : "";
	  }
	
	  function translate(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push("translate(", null, pxComma, null, pxParen);
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb || yb) {
	      s.push("translate(" + xb + pxComma + yb + pxParen);
	    }
	  }
	
	  function rotate(a, b, s, q) {
	    if (a !== b) {
	      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
	      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "rotate(" + b + degParen);
	    }
	  }
	
	  function skewX(a, b, s, q) {
	    if (a !== b) {
	      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "skewX(" + b + degParen);
	    }
	  }
	
	  function scale(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb !== 1 || yb !== 1) {
	      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
	    }
	  }
	
	  return function(a, b) {
	    var s = [], // string constants and placeholders
	        q = []; // number interpolators
	    a = parse(a), b = parse(b);
	    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
	    rotate(a.rotate, b.rotate, s, q);
	    skewX(a.skewX, b.skewX, s, q);
	    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
	    a = b = null; // gc
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  };
	}
	
	var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
	var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
	
	var rho = Math.SQRT2;
	var rho2 = 2;
	var rho4 = 4;
	var epsilon2 = 1e-12;
	
	function cosh(x) {
	  return ((x = Math.exp(x)) + 1 / x) / 2;
	}
	
	function sinh(x) {
	  return ((x = Math.exp(x)) - 1 / x) / 2;
	}
	
	function tanh(x) {
	  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	}
	
	// p0 = [ux0, uy0, w0]
	// p1 = [ux1, uy1, w1]
	var zoom = function(p0, p1) {
	  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
	      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
	      dx = ux1 - ux0,
	      dy = uy1 - uy0,
	      d2 = dx * dx + dy * dy,
	      i,
	      S;
	
	  // Special case for u0 ≅ u1.
	  if (d2 < epsilon2) {
	    S = Math.log(w1 / w0) / rho;
	    i = function(t) {
	      return [
	        ux0 + t * dx,
	        uy0 + t * dy,
	        w0 * Math.exp(rho * t * S)
	      ];
	    };
	  }
	
	  // General case.
	  else {
	    var d1 = Math.sqrt(d2),
	        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
	        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
	        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
	        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	    S = (r1 - r0) / rho;
	    i = function(t) {
	      var s = t * S,
	          coshr0 = cosh(r0),
	          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
	      return [
	        ux0 + u * dx,
	        uy0 + u * dy,
	        w0 * coshr0 / cosh(rho * s + r0)
	      ];
	    };
	  }
	
	  i.duration = S * 1000;
	
	  return i;
	};
	
	function hsl$1(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hsl(start)).h, (end = d3Color.hsl(end)).h),
	        s = nogamma(start.s, end.s),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.s = s(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hsl$2 = hsl$1(hue);
	var hslLong = hsl$1(nogamma);
	
	function lab$1(start, end) {
	  var l = nogamma((start = d3Color.lab(start)).l, (end = d3Color.lab(end)).l),
	      a = nogamma(start.a, end.a),
	      b = nogamma(start.b, end.b),
	      opacity = nogamma(start.opacity, end.opacity);
	  return function(t) {
	    start.l = l(t);
	    start.a = a(t);
	    start.b = b(t);
	    start.opacity = opacity(t);
	    return start + "";
	  };
	}
	
	function hcl$1(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hcl(start)).h, (end = d3Color.hcl(end)).h),
	        c = nogamma(start.c, end.c),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.c = c(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hcl$2 = hcl$1(hue);
	var hclLong = hcl$1(nogamma);
	
	function cubehelix$1(hue$$1) {
	  return (function cubehelixGamma(y) {
	    y = +y;
	
	    function cubehelix$$1(start, end) {
	      var h = hue$$1((start = d3Color.cubehelix(start)).h, (end = d3Color.cubehelix(end)).h),
	          s = nogamma(start.s, end.s),
	          l = nogamma(start.l, end.l),
	          opacity = nogamma(start.opacity, end.opacity);
	      return function(t) {
	        start.h = h(t);
	        start.s = s(t);
	        start.l = l(Math.pow(t, y));
	        start.opacity = opacity(t);
	        return start + "";
	      };
	    }
	
	    cubehelix$$1.gamma = cubehelixGamma;
	
	    return cubehelix$$1;
	  })(1);
	}
	
	var cubehelix$2 = cubehelix$1(hue);
	var cubehelixLong = cubehelix$1(nogamma);
	
	var quantize = function(interpolator, n) {
	  var samples = new Array(n);
	  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
	  return samples;
	};
	
	exports.interpolate = value;
	exports.interpolateArray = array;
	exports.interpolateBasis = basis$1;
	exports.interpolateBasisClosed = basisClosed;
	exports.interpolateDate = date;
	exports.interpolateNumber = number;
	exports.interpolateObject = object;
	exports.interpolateRound = round;
	exports.interpolateString = string;
	exports.interpolateTransformCss = interpolateTransformCss;
	exports.interpolateTransformSvg = interpolateTransformSvg;
	exports.interpolateZoom = zoom;
	exports.interpolateRgb = rgb$1;
	exports.interpolateRgbBasis = rgbBasis;
	exports.interpolateRgbBasisClosed = rgbBasisClosed;
	exports.interpolateHsl = hsl$2;
	exports.interpolateHslLong = hslLong;
	exports.interpolateLab = lab$1;
	exports.interpolateHcl = hcl$2;
	exports.interpolateHclLong = hclLong;
	exports.interpolateCubehelix = cubehelix$2;
	exports.interpolateCubehelixLong = cubehelixLong;
	exports.quantize = quantize;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time-format/ Version 2.0.5. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(14)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-time'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Time) { 'use strict';
	
	function localDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
	    date.setFullYear(d.y);
	    return date;
	  }
	  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
	}
	
	function utcDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
	    date.setUTCFullYear(d.y);
	    return date;
	  }
	  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
	}
	
	function newYear(y) {
	  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
	}
	
	function formatLocale(locale) {
	  var locale_dateTime = locale.dateTime,
	      locale_date = locale.date,
	      locale_time = locale.time,
	      locale_periods = locale.periods,
	      locale_weekdays = locale.days,
	      locale_shortWeekdays = locale.shortDays,
	      locale_months = locale.months,
	      locale_shortMonths = locale.shortMonths;
	
	  var periodRe = formatRe(locale_periods),
	      periodLookup = formatLookup(locale_periods),
	      weekdayRe = formatRe(locale_weekdays),
	      weekdayLookup = formatLookup(locale_weekdays),
	      shortWeekdayRe = formatRe(locale_shortWeekdays),
	      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
	      monthRe = formatRe(locale_months),
	      monthLookup = formatLookup(locale_months),
	      shortMonthRe = formatRe(locale_shortMonths),
	      shortMonthLookup = formatLookup(locale_shortMonths);
	
	  var formats = {
	    "a": formatShortWeekday,
	    "A": formatWeekday,
	    "b": formatShortMonth,
	    "B": formatMonth,
	    "c": null,
	    "d": formatDayOfMonth,
	    "e": formatDayOfMonth,
	    "H": formatHour24,
	    "I": formatHour12,
	    "j": formatDayOfYear,
	    "L": formatMilliseconds,
	    "m": formatMonthNumber,
	    "M": formatMinutes,
	    "p": formatPeriod,
	    "S": formatSeconds,
	    "U": formatWeekNumberSunday,
	    "w": formatWeekdayNumber,
	    "W": formatWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatYear,
	    "Y": formatFullYear,
	    "Z": formatZone,
	    "%": formatLiteralPercent
	  };
	
	  var utcFormats = {
	    "a": formatUTCShortWeekday,
	    "A": formatUTCWeekday,
	    "b": formatUTCShortMonth,
	    "B": formatUTCMonth,
	    "c": null,
	    "d": formatUTCDayOfMonth,
	    "e": formatUTCDayOfMonth,
	    "H": formatUTCHour24,
	    "I": formatUTCHour12,
	    "j": formatUTCDayOfYear,
	    "L": formatUTCMilliseconds,
	    "m": formatUTCMonthNumber,
	    "M": formatUTCMinutes,
	    "p": formatUTCPeriod,
	    "S": formatUTCSeconds,
	    "U": formatUTCWeekNumberSunday,
	    "w": formatUTCWeekdayNumber,
	    "W": formatUTCWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatUTCYear,
	    "Y": formatUTCFullYear,
	    "Z": formatUTCZone,
	    "%": formatLiteralPercent
	  };
	
	  var parses = {
	    "a": parseShortWeekday,
	    "A": parseWeekday,
	    "b": parseShortMonth,
	    "B": parseMonth,
	    "c": parseLocaleDateTime,
	    "d": parseDayOfMonth,
	    "e": parseDayOfMonth,
	    "H": parseHour24,
	    "I": parseHour24,
	    "j": parseDayOfYear,
	    "L": parseMilliseconds,
	    "m": parseMonthNumber,
	    "M": parseMinutes,
	    "p": parsePeriod,
	    "S": parseSeconds,
	    "U": parseWeekNumberSunday,
	    "w": parseWeekdayNumber,
	    "W": parseWeekNumberMonday,
	    "x": parseLocaleDate,
	    "X": parseLocaleTime,
	    "y": parseYear,
	    "Y": parseFullYear,
	    "Z": parseZone,
	    "%": parseLiteralPercent
	  };
	
	  // These recursive directive definitions must be deferred.
	  formats.x = newFormat(locale_date, formats);
	  formats.X = newFormat(locale_time, formats);
	  formats.c = newFormat(locale_dateTime, formats);
	  utcFormats.x = newFormat(locale_date, utcFormats);
	  utcFormats.X = newFormat(locale_time, utcFormats);
	  utcFormats.c = newFormat(locale_dateTime, utcFormats);
	
	  function newFormat(specifier, formats) {
	    return function(date) {
	      var string = [],
	          i = -1,
	          j = 0,
	          n = specifier.length,
	          c,
	          pad,
	          format;
	
	      if (!(date instanceof Date)) date = new Date(+date);
	
	      while (++i < n) {
	        if (specifier.charCodeAt(i) === 37) {
	          string.push(specifier.slice(j, i));
	          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
	          else pad = c === "e" ? " " : "0";
	          if (format = formats[c]) c = format(date, pad);
	          string.push(c);
	          j = i + 1;
	        }
	      }
	
	      string.push(specifier.slice(j, i));
	      return string.join("");
	    };
	  }
	
	  function newParse(specifier, newDate) {
	    return function(string) {
	      var d = newYear(1900),
	          i = parseSpecifier(d, specifier, string += "", 0);
	      if (i != string.length) return null;
	
	      // The am-pm flag is 0 for AM, and 1 for PM.
	      if ("p" in d) d.H = d.H % 12 + d.p * 12;
	
	      // Convert day-of-week and week-of-year to day-of-year.
	      if ("W" in d || "U" in d) {
	        if (!("w" in d)) d.w = "W" in d ? 1 : 0;
	        var day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
	        d.m = 0;
	        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
	      }
	
	      // If a time zone is specified, all fields are interpreted as UTC and then
	      // offset according to the specified time zone.
	      if ("Z" in d) {
	        d.H += d.Z / 100 | 0;
	        d.M += d.Z % 100;
	        return utcDate(d);
	      }
	
	      // Otherwise, all fields are in local time.
	      return newDate(d);
	    };
	  }
	
	  function parseSpecifier(d, specifier, string, j) {
	    var i = 0,
	        n = specifier.length,
	        m = string.length,
	        c,
	        parse;
	
	    while (i < n) {
	      if (j >= m) return -1;
	      c = specifier.charCodeAt(i++);
	      if (c === 37) {
	        c = specifier.charAt(i++);
	        parse = parses[c in pads ? specifier.charAt(i++) : c];
	        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
	      } else if (c != string.charCodeAt(j++)) {
	        return -1;
	      }
	    }
	
	    return j;
	  }
	
	  function parsePeriod(d, string, i) {
	    var n = periodRe.exec(string.slice(i));
	    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortWeekday(d, string, i) {
	    var n = shortWeekdayRe.exec(string.slice(i));
	    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseWeekday(d, string, i) {
	    var n = weekdayRe.exec(string.slice(i));
	    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortMonth(d, string, i) {
	    var n = shortMonthRe.exec(string.slice(i));
	    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseMonth(d, string, i) {
	    var n = monthRe.exec(string.slice(i));
	    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseLocaleDateTime(d, string, i) {
	    return parseSpecifier(d, locale_dateTime, string, i);
	  }
	
	  function parseLocaleDate(d, string, i) {
	    return parseSpecifier(d, locale_date, string, i);
	  }
	
	  function parseLocaleTime(d, string, i) {
	    return parseSpecifier(d, locale_time, string, i);
	  }
	
	  function formatShortWeekday(d) {
	    return locale_shortWeekdays[d.getDay()];
	  }
	
	  function formatWeekday(d) {
	    return locale_weekdays[d.getDay()];
	  }
	
	  function formatShortMonth(d) {
	    return locale_shortMonths[d.getMonth()];
	  }
	
	  function formatMonth(d) {
	    return locale_months[d.getMonth()];
	  }
	
	  function formatPeriod(d) {
	    return locale_periods[+(d.getHours() >= 12)];
	  }
	
	  function formatUTCShortWeekday(d) {
	    return locale_shortWeekdays[d.getUTCDay()];
	  }
	
	  function formatUTCWeekday(d) {
	    return locale_weekdays[d.getUTCDay()];
	  }
	
	  function formatUTCShortMonth(d) {
	    return locale_shortMonths[d.getUTCMonth()];
	  }
	
	  function formatUTCMonth(d) {
	    return locale_months[d.getUTCMonth()];
	  }
	
	  function formatUTCPeriod(d) {
	    return locale_periods[+(d.getUTCHours() >= 12)];
	  }
	
	  return {
	    format: function(specifier) {
	      var f = newFormat(specifier += "", formats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    parse: function(specifier) {
	      var p = newParse(specifier += "", localDate);
	      p.toString = function() { return specifier; };
	      return p;
	    },
	    utcFormat: function(specifier) {
	      var f = newFormat(specifier += "", utcFormats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    utcParse: function(specifier) {
	      var p = newParse(specifier, utcDate);
	      p.toString = function() { return specifier; };
	      return p;
	    }
	  };
	}
	
	var pads = {"-": "", "_": " ", "0": "0"};
	var numberRe = /^\s*\d+/;
	var percentRe = /^%/;
	var requoteRe = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	
	function pad(value, fill, width) {
	  var sign = value < 0 ? "-" : "",
	      string = (sign ? -value : value) + "",
	      length = string.length;
	  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	}
	
	function requote(s) {
	  return s.replace(requoteRe, "\\$&");
	}
	
	function formatRe(names) {
	  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
	}
	
	function formatLookup(names) {
	  var map = {}, i = -1, n = names.length;
	  while (++i < n) map[names[i].toLowerCase()] = i;
	  return map;
	}
	
	function parseWeekdayNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.w = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.U = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.W = +n[0], i + n[0].length) : -1;
	}
	
	function parseFullYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 4));
	  return n ? (d.y = +n[0], i + n[0].length) : -1;
	}
	
	function parseYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
	}
	
	function parseZone(d, string, i) {
	  var n = /^(Z)|([+-]\d\d)(?:\:?(\d\d))?/.exec(string.slice(i, i + 6));
	  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
	}
	
	function parseMonthNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
	}
	
	function parseDayOfMonth(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseDayOfYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseHour24(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.H = +n[0], i + n[0].length) : -1;
	}
	
	function parseMinutes(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.M = +n[0], i + n[0].length) : -1;
	}
	
	function parseSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.S = +n[0], i + n[0].length) : -1;
	}
	
	function parseMilliseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.L = +n[0], i + n[0].length) : -1;
	}
	
	function parseLiteralPercent(d, string, i) {
	  var n = percentRe.exec(string.slice(i, i + 1));
	  return n ? i + n[0].length : -1;
	}
	
	function formatDayOfMonth(d, p) {
	  return pad(d.getDate(), p, 2);
	}
	
	function formatHour24(d, p) {
	  return pad(d.getHours(), p, 2);
	}
	
	function formatHour12(d, p) {
	  return pad(d.getHours() % 12 || 12, p, 2);
	}
	
	function formatDayOfYear(d, p) {
	  return pad(1 + d3Time.timeDay.count(d3Time.timeYear(d), d), p, 3);
	}
	
	function formatMilliseconds(d, p) {
	  return pad(d.getMilliseconds(), p, 3);
	}
	
	function formatMonthNumber(d, p) {
	  return pad(d.getMonth() + 1, p, 2);
	}
	
	function formatMinutes(d, p) {
	  return pad(d.getMinutes(), p, 2);
	}
	
	function formatSeconds(d, p) {
	  return pad(d.getSeconds(), p, 2);
	}
	
	function formatWeekNumberSunday(d, p) {
	  return pad(d3Time.timeSunday.count(d3Time.timeYear(d), d), p, 2);
	}
	
	function formatWeekdayNumber(d) {
	  return d.getDay();
	}
	
	function formatWeekNumberMonday(d, p) {
	  return pad(d3Time.timeMonday.count(d3Time.timeYear(d), d), p, 2);
	}
	
	function formatYear(d, p) {
	  return pad(d.getFullYear() % 100, p, 2);
	}
	
	function formatFullYear(d, p) {
	  return pad(d.getFullYear() % 10000, p, 4);
	}
	
	function formatZone(d) {
	  var z = d.getTimezoneOffset();
	  return (z > 0 ? "-" : (z *= -1, "+"))
	      + pad(z / 60 | 0, "0", 2)
	      + pad(z % 60, "0", 2);
	}
	
	function formatUTCDayOfMonth(d, p) {
	  return pad(d.getUTCDate(), p, 2);
	}
	
	function formatUTCHour24(d, p) {
	  return pad(d.getUTCHours(), p, 2);
	}
	
	function formatUTCHour12(d, p) {
	  return pad(d.getUTCHours() % 12 || 12, p, 2);
	}
	
	function formatUTCDayOfYear(d, p) {
	  return pad(1 + d3Time.utcDay.count(d3Time.utcYear(d), d), p, 3);
	}
	
	function formatUTCMilliseconds(d, p) {
	  return pad(d.getUTCMilliseconds(), p, 3);
	}
	
	function formatUTCMonthNumber(d, p) {
	  return pad(d.getUTCMonth() + 1, p, 2);
	}
	
	function formatUTCMinutes(d, p) {
	  return pad(d.getUTCMinutes(), p, 2);
	}
	
	function formatUTCSeconds(d, p) {
	  return pad(d.getUTCSeconds(), p, 2);
	}
	
	function formatUTCWeekNumberSunday(d, p) {
	  return pad(d3Time.utcSunday.count(d3Time.utcYear(d), d), p, 2);
	}
	
	function formatUTCWeekdayNumber(d) {
	  return d.getUTCDay();
	}
	
	function formatUTCWeekNumberMonday(d, p) {
	  return pad(d3Time.utcMonday.count(d3Time.utcYear(d), d), p, 2);
	}
	
	function formatUTCYear(d, p) {
	  return pad(d.getUTCFullYear() % 100, p, 2);
	}
	
	function formatUTCFullYear(d, p) {
	  return pad(d.getUTCFullYear() % 10000, p, 4);
	}
	
	function formatUTCZone() {
	  return "+0000";
	}
	
	function formatLiteralPercent() {
	  return "%";
	}
	
	var locale$1;
	
	
	
	
	
	defaultLocale({
	  dateTime: "%x, %X",
	  date: "%-m/%-d/%Y",
	  time: "%-I:%M:%S %p",
	  periods: ["AM", "PM"],
	  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
	});
	
	function defaultLocale(definition) {
	  locale$1 = formatLocale(definition);
	  exports.timeFormat = locale$1.format;
	  exports.timeParse = locale$1.parse;
	  exports.utcFormat = locale$1.utcFormat;
	  exports.utcParse = locale$1.utcParse;
	  return locale$1;
	}
	
	var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
	
	function formatIsoNative(date) {
	  return date.toISOString();
	}
	
	var formatIso = Date.prototype.toISOString
	    ? formatIsoNative
	    : exports.utcFormat(isoSpecifier);
	
	function parseIsoNative(string) {
	  var date = new Date(string);
	  return isNaN(date) ? null : date;
	}
	
	var parseIso = +new Date("2000-01-01T00:00:00.000Z")
	    ? parseIsoNative
	    : exports.utcParse(isoSpecifier);
	
	exports.timeFormatDefaultLocale = defaultLocale;
	exports.timeFormatLocale = formatLocale;
	exports.isoFormat = formatIso;
	exports.isoParse = parseIso;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time/ Version 1.0.6. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var t0 = new Date;
	var t1 = new Date;
	
	function newInterval(floori, offseti, count, field) {
	
	  function interval(date) {
	    return floori(date = new Date(+date)), date;
	  }
	
	  interval.floor = interval;
	
	  interval.ceil = function(date) {
	    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
	  };
	
	  interval.round = function(date) {
	    var d0 = interval(date),
	        d1 = interval.ceil(date);
	    return date - d0 < d1 - date ? d0 : d1;
	  };
	
	  interval.offset = function(date, step) {
	    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
	  };
	
	  interval.range = function(start, stop, step) {
	    var range = [];
	    start = interval.ceil(start);
	    step = step == null ? 1 : Math.floor(step);
	    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
	    do range.push(new Date(+start)); while (offseti(start, step), floori(start), start < stop)
	    return range;
	  };
	
	  interval.filter = function(test) {
	    return newInterval(function(date) {
	      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
	    }, function(date, step) {
	      if (date >= date) while (--step >= 0) while (offseti(date, 1), !test(date)) {} // eslint-disable-line no-empty
	    });
	  };
	
	  if (count) {
	    interval.count = function(start, end) {
	      t0.setTime(+start), t1.setTime(+end);
	      floori(t0), floori(t1);
	      return Math.floor(count(t0, t1));
	    };
	
	    interval.every = function(step) {
	      step = Math.floor(step);
	      return !isFinite(step) || !(step > 0) ? null
	          : !(step > 1) ? interval
	          : interval.filter(field
	              ? function(d) { return field(d) % step === 0; }
	              : function(d) { return interval.count(0, d) % step === 0; });
	    };
	  }
	
	  return interval;
	}
	
	var millisecond = newInterval(function() {
	  // noop
	}, function(date, step) {
	  date.setTime(+date + step);
	}, function(start, end) {
	  return end - start;
	});
	
	// An optimized implementation for this simple case.
	millisecond.every = function(k) {
	  k = Math.floor(k);
	  if (!isFinite(k) || !(k > 0)) return null;
	  if (!(k > 1)) return millisecond;
	  return newInterval(function(date) {
	    date.setTime(Math.floor(date / k) * k);
	  }, function(date, step) {
	    date.setTime(+date + step * k);
	  }, function(start, end) {
	    return (end - start) / k;
	  });
	};
	
	var milliseconds = millisecond.range;
	
	var durationSecond = 1e3;
	var durationMinute = 6e4;
	var durationHour = 36e5;
	var durationDay = 864e5;
	var durationWeek = 6048e5;
	
	var second = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationSecond) * durationSecond);
	}, function(date, step) {
	  date.setTime(+date + step * durationSecond);
	}, function(start, end) {
	  return (end - start) / durationSecond;
	}, function(date) {
	  return date.getUTCSeconds();
	});
	
	var seconds = second.range;
	
	var minute = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationMinute) * durationMinute);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getMinutes();
	});
	
	var minutes = minute.range;
	
	var hour = newInterval(function(date) {
	  var offset = date.getTimezoneOffset() * durationMinute % durationHour;
	  if (offset < 0) offset += durationHour;
	  date.setTime(Math.floor((+date - offset) / durationHour) * durationHour + offset);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getHours();
	});
	
	var hours = hour.range;
	
	var day = newInterval(function(date) {
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setDate(date.getDate() + step);
	}, function(start, end) {
	  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay;
	}, function(date) {
	  return date.getDate() - 1;
	});
	
	var days = day.range;
	
	function weekday(i) {
	  return newInterval(function(date) {
	    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setDate(date.getDate() + step * 7);
	  }, function(start, end) {
	    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
	  });
	}
	
	var sunday = weekday(0);
	var monday = weekday(1);
	var tuesday = weekday(2);
	var wednesday = weekday(3);
	var thursday = weekday(4);
	var friday = weekday(5);
	var saturday = weekday(6);
	
	var sundays = sunday.range;
	var mondays = monday.range;
	var tuesdays = tuesday.range;
	var wednesdays = wednesday.range;
	var thursdays = thursday.range;
	var fridays = friday.range;
	var saturdays = saturday.range;
	
	var month = newInterval(function(date) {
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setMonth(date.getMonth() + step);
	}, function(start, end) {
	  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
	}, function(date) {
	  return date.getMonth();
	});
	
	var months = month.range;
	
	var year = newInterval(function(date) {
	  date.setMonth(0, 1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setFullYear(date.getFullYear() + step);
	}, function(start, end) {
	  return end.getFullYear() - start.getFullYear();
	}, function(date) {
	  return date.getFullYear();
	});
	
	// An optimized implementation for this simple case.
	year.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
	    date.setMonth(0, 1);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setFullYear(date.getFullYear() + step * k);
	  });
	};
	
	var years = year.range;
	
	var utcMinute = newInterval(function(date) {
	  date.setUTCSeconds(0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getUTCMinutes();
	});
	
	var utcMinutes = utcMinute.range;
	
	var utcHour = newInterval(function(date) {
	  date.setUTCMinutes(0, 0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getUTCHours();
	});
	
	var utcHours = utcHour.range;
	
	var utcDay = newInterval(function(date) {
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCDate(date.getUTCDate() + step);
	}, function(start, end) {
	  return (end - start) / durationDay;
	}, function(date) {
	  return date.getUTCDate() - 1;
	});
	
	var utcDays = utcDay.range;
	
	function utcWeekday(i) {
	  return newInterval(function(date) {
	    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCDate(date.getUTCDate() + step * 7);
	  }, function(start, end) {
	    return (end - start) / durationWeek;
	  });
	}
	
	var utcSunday = utcWeekday(0);
	var utcMonday = utcWeekday(1);
	var utcTuesday = utcWeekday(2);
	var utcWednesday = utcWeekday(3);
	var utcThursday = utcWeekday(4);
	var utcFriday = utcWeekday(5);
	var utcSaturday = utcWeekday(6);
	
	var utcSundays = utcSunday.range;
	var utcMondays = utcMonday.range;
	var utcTuesdays = utcTuesday.range;
	var utcWednesdays = utcWednesday.range;
	var utcThursdays = utcThursday.range;
	var utcFridays = utcFriday.range;
	var utcSaturdays = utcSaturday.range;
	
	var utcMonth = newInterval(function(date) {
	  date.setUTCDate(1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCMonth(date.getUTCMonth() + step);
	}, function(start, end) {
	  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
	}, function(date) {
	  return date.getUTCMonth();
	});
	
	var utcMonths = utcMonth.range;
	
	var utcYear = newInterval(function(date) {
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCFullYear(date.getUTCFullYear() + step);
	}, function(start, end) {
	  return end.getUTCFullYear() - start.getUTCFullYear();
	}, function(date) {
	  return date.getUTCFullYear();
	});
	
	// An optimized implementation for this simple case.
	utcYear.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
	    date.setUTCMonth(0, 1);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCFullYear(date.getUTCFullYear() + step * k);
	  });
	};
	
	var utcYears = utcYear.range;
	
	exports.timeInterval = newInterval;
	exports.timeMillisecond = millisecond;
	exports.timeMilliseconds = milliseconds;
	exports.utcMillisecond = millisecond;
	exports.utcMilliseconds = milliseconds;
	exports.timeSecond = second;
	exports.timeSeconds = seconds;
	exports.utcSecond = second;
	exports.utcSeconds = seconds;
	exports.timeMinute = minute;
	exports.timeMinutes = minutes;
	exports.timeHour = hour;
	exports.timeHours = hours;
	exports.timeDay = day;
	exports.timeDays = days;
	exports.timeWeek = sunday;
	exports.timeWeeks = sundays;
	exports.timeSunday = sunday;
	exports.timeSundays = sundays;
	exports.timeMonday = monday;
	exports.timeMondays = mondays;
	exports.timeTuesday = tuesday;
	exports.timeTuesdays = tuesdays;
	exports.timeWednesday = wednesday;
	exports.timeWednesdays = wednesdays;
	exports.timeThursday = thursday;
	exports.timeThursdays = thursdays;
	exports.timeFriday = friday;
	exports.timeFridays = fridays;
	exports.timeSaturday = saturday;
	exports.timeSaturdays = saturdays;
	exports.timeMonth = month;
	exports.timeMonths = months;
	exports.timeYear = year;
	exports.timeYears = years;
	exports.utcMinute = utcMinute;
	exports.utcMinutes = utcMinutes;
	exports.utcHour = utcHour;
	exports.utcHours = utcHours;
	exports.utcDay = utcDay;
	exports.utcDays = utcDays;
	exports.utcWeek = utcSunday;
	exports.utcWeeks = utcSundays;
	exports.utcSunday = utcSunday;
	exports.utcSundays = utcSundays;
	exports.utcMonday = utcMonday;
	exports.utcMondays = utcMondays;
	exports.utcTuesday = utcTuesday;
	exports.utcTuesdays = utcTuesdays;
	exports.utcWednesday = utcWednesday;
	exports.utcWednesdays = utcWednesdays;
	exports.utcThursday = utcThursday;
	exports.utcThursdays = utcThursdays;
	exports.utcFriday = utcFriday;
	exports.utcFridays = utcFridays;
	exports.utcSaturday = utcSaturday;
	exports.utcSaturdays = utcSaturdays;
	exports.utcMonth = utcMonth;
	exports.utcMonths = utcMonths;
	exports.utcYear = utcYear;
	exports.utcYears = utcYears;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	__webpack_require__(7);
	
	riot.tag2('bullet-bar', '<h4 class="bullet-bar__label" onclick="{onClick}">{opts.data.name}</h4> <div class="bullet-bar__bar-wrapper"> <div class="bullet-bar__spacer"></div> <div class="bullet-bar__bar" riot-style="width:{value / 3}%;" onclick="{onClick}"></div> <span each="{tick in ticks}" if="{value > tick}" class="bullet-bar__tick {bullet-bar__tick--50 : tick === 50}" riot-style="left:{tick / 3}%;"> <span>{tick}&nbsp;mg</span> </span> <bullet each="{meas in opts.measurements}" data="{meas}"></bullet> </div>', '', 'class="bullet-bar"', function (opts) {
	  var _this = this;
	
	  this.value = this.opts.data.mVal;
	  this.ticks = [50, 100, 150, 200, 250];
	  this.onClick = function () {
	    return riot.control.trigger(riot.EVT.updateCityInfobox, _this.opts.data);
	  };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	var _get_color = __webpack_require__(9);
	
	var _get_color2 = _interopRequireDefault(_get_color);
	
	__webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	riot.tag2('city-infobox', '<close-button if="{data}" onclick="{close}"></close-button> <h3 class="infobox__title">{data.name}</h3> <p>Klicke auf eine Messstation, um ihre Nitrat-Werte zu sehen.</p> <ul class="city-infobox__station-list"> <li each="{station in data.measurements}" class="city-infobox__station" riot-style="background-color:{getColor(station.value)};" onclick="{onClick}"> {station.mstbez} </li> </ul>', '', 'if="{data}" class="infobox city-infobox {-visible: visible}"', function (opts) {
	  var _this = this;
	
	  this.data = false;
	  this.visible = false;
	  this.getColor = _get_color2.default;
	
	  riot.control.on(riot.EVT.updateCityInfobox, function (data) {
	    _this.update({ data: data, visible: true });
	  });
	
	  riot.control.on(riot.EVT.hideCityInfobox, function () {
	    _this.update({ visible: false });
	  });
	
	  this.close = function () {
	    riot.control.trigger(riot.EVT.hideCityInfobox);
	  };
	
	  this.onClick = function (e) {
	    _this.close();
	    riot.control.trigger(riot.EVT.updateStationInfobox, e.item.station);
	  };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	__webpack_require__(4);
	
	__webpack_require__(7);
	
	riot.tag2('viz-legend', '<close-button onclick="{close}"></close-button> <h3>Legende</h3> <p>Jeder Punkt ist eine Messstelle. Die Position auf der Skala gibt den zuletzt gemessenen Wert an. Klicke auf einen Punkt, um Informationen zu dieser Messstelle zu sehen. Klicke auf eine Gemeinde oder einen Balken, um alle Messstellen dieser Gemeinde zu sehen.</p> <div class="bullet-bar"> <div class="bullet-bar__bar-wrapper"> <div class="bullet-bar__spacer"></div> <div class="bullet-bar__bar" riot-style="width:{75}%;" onclick="{null}"></div> <span class="bullet-bar__tick bullet-bar__tick--50" riot-style="left:{50 / 3}%;"> <span>Grenzwert</span> </span> <span class="bullet-bar__tick legend__tick" riot-style="left:{150 / 3}%;"> <span>Messstelle</span> </span> <span class="bullet-bar__tick legend__tick --hidden" riot-style="left:{75}%;"> <span class="--top">Messstelle mit höchstem<br>Wert für ihre Stadt</span> </span> <bullet data="{data.example}" onclick="{null}"></bullet> <bullet data="{data.maxData}" onclick="{null}"></bullet> </div> </div>', '', 'class="infobox legend {-visible: visible}"', function (opts) {
	  var _this = this;
	
	  this.visible = true;
	  this.data = {
	    example: {
	      value: 150,
	      legend: true
	    },
	    maxData: {
	      value: 75 * 3,
	      legend: true
	    }
	  };
	
	  this.close = function () {
	    return _this.update({ visible: false });
	  };
	
	  riot.control.on(riot.EVT.showLegend, function () {
	    _this.update({ visible: true });
	  });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	__webpack_require__(8);
	
	__webpack_require__(21);
	
	__webpack_require__(19);
	
	__webpack_require__(16);
	
	__webpack_require__(15);
	
	__webpack_require__(17);
	
	var _datasets = __webpack_require__(3);
	
	var _datasets2 = _interopRequireDefault(_datasets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	riot.tag2('control-button', '<button class="btn controls__btn" onclick="{action}" disabled="{opts.disabled}"> <entypo-svg symbol="{opts.action}"></entypo-svg> </button>', '', '', function (opts) {
	
	  this.action = this.parent.parent[this.opts.action];
	});
	
	riot.tag2('control-buttons', '<control-button action="info"></control-button> <control-button action="reverse"></control-button> <control-button action="goTop" disabled="{parent.start === 0}"></control-button> <control-button action="goBack" disabled="{parent.start === 0}"></control-button> <control-button action="goForth" disabled="{parent.end === parent.length}"></control-button> <control-button action="goBottom" disabled="{parent.end === parent.length}"></control-button>', '', 'class="controls"', function (opts) {});
	
	riot.tag2('measurement-viz', '<section class="measurement-viz__section--info"> <station-infobox></station-infobox> <city-infobox></city-infobox> </section> <section class="measurement-viz__section--viz"> <searchbox></searchbox> <viz-legend></viz-legend> <control-buttons></control-buttons> <section class="bullet-bars"> <bullet-bar each="{city in cities}" data="{city}" measurements="{city.measurements}"></bullet-bar> </section> <control-buttons></control-buttons> </section>', '', 'class="measurement-viz__wrapper"', function (opts) {
	  var _this = this;
	
	  this.reversed = false;
	  this.cities = _datasets2.default.slice(0, 10);
	  this.start = 0;
	  this.end = 10;
	  this.length = _datasets2.default.length;
	
	  riot.control.on(riot.EVT.jumpTo, function (city) {
	    var i = _datasets2.default.indexOf(city);
	    var start = i,
	        end = i + 10;
	
	    var cities = _datasets2.default.slice(start, end);
	    _this.update({ cities: cities, start: start, end: end });
	  });
	
	  this.reverse = function () {
	    _this.update({
	      cities: _this.cities.reverse(),
	      reversed: !_this.reversed
	    });
	  };
	
	  this.goTop = function () {
	    _this._updateSlice(0, 10);
	  };
	
	  this.goBottom = function () {
	    _this._updateSlice(_this.length - 10, _this.length);
	  };
	
	  this.goBack = function () {
	    if (_this.start > 0) {
	      _this._updateSlice(_this.start - 1, _this.end - 1);
	    }
	  };
	
	  this.goForth = function () {
	    if (_this.end < _datasets2.default.length) {
	      _this._updateSlice(_this.start + 1, _this.end + 1);
	    }
	  };
	
	  this.info = function () {
	    riot.control.trigger(riot.EVT.showLegend);
	  };
	
	  this._updateSlice = function (start, end) {
	    var cities = _datasets2.default.slice(start, end);
	    if (_this.reversed) cities = cities.reverse();
	    _this.update({ cities: cities, start: start, end: end });
	  };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	var _search = __webpack_require__(26);
	
	var _search2 = _interopRequireDefault(_search);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	riot.tag2('searchbox', '<input type="text" oninput="{doSearch}" class="searchbox__input" placeholder="Suche nach Deiner Stadt oder Postleitzahl..."> <ul if="{results.length}" class="searchbox__result-list"> <li each="{results}" class="searchbox__result-list-item" onclick="{handleClick}"> {name} <span>{plz}</span> </li> </ul>', '', 'class="searchbox"', function (opts) {
	  var _this = this;
	
	  this.results = [];
	
	  this.doSearch = function (e) {
	    var str = e.target.value.toLowerCase();
	    if (str > 0 && str.length > 1 || str.length > 2) {
	      _this.update({ results: (0, _search2.default)(str) });
	    } else {
	      _this.clearResults();
	    }
	  };
	
	  this.handleClick = function (e) {
	    _this.clearResults();
	    riot.control.trigger(riot.EVT.jumpTo, e.item);
	  };
	
	  this.clearResults = function () {
	    _this.update({ results: [] });
	  };
	
	  riot.control.on(riot.EVT.clearResults, function () {
	    _this.clearResults();
	  });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	var _init_chart = __webpack_require__(23);
	
	var _init_chart2 = _interopRequireDefault(_init_chart);
	
	var _update_bars = __webpack_require__(25);
	
	var _update_bars2 = _interopRequireDefault(_update_bars);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	riot.tag2('history-chart', '', '', 'class="history-chart"', function (opts) {
	  var _this = this;
	
	  this.on('mount', function () {
	    _this.opts.element = _this.root;
	    _this.chartOpts = (0, _init_chart2.default)(_this.opts);
	  });
	
	  this.on('update', function () {
	    if (_this.chartOpts) (0, _update_bars2.default)(_this.chartOpts, _this.opts.data);
	  });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	var _datasets = __webpack_require__(3);
	
	var _datasets2 = _interopRequireDefault(_datasets);
	
	var _date = __webpack_require__(5);
	
	var _transform_history_data = __webpack_require__(24);
	
	var _transform_history_data2 = _interopRequireDefault(_transform_history_data);
	
	__webpack_require__(20);
	
	__webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	riot.tag2('station-infobox', '<close-button onclick="{close}"></close-button> <h3 class="infobox__title">{data.city}</h3> <section class="station-infobox__section"> <p>Messstelle: {data.mstbez}</p> <p>Letzte Messung:<br><strong>{data.value} mg</strong> am {convertDate(data.date)}</p> </section> <section class="station-infobox__section"> <h4>Entwicklung seit 2000</h4> <history-chart if="{data}" data="{transform(data.history)}" width="{root.parentNode.clientWidth - 40}"></history-chart> <div if="{exceeded.length > 0}"> <p>Der EU-Grenzwert von 50 mg wurde seit dem Jahr 2000 <strong class="exceeded">{exceeded.length} mal</strong> überschritten.</p> </div> <a class="city-link" onclick="{showCity}">Alle Stationen in {data.city}</a> </section>', '', 'if="{data}" class="infobox station-infobox {-visible: visible}"', function (opts) {
	  var _this = this;
	
	  this.data = false;
	  this.exceeded = [];
	  this.convertDate = _date.convertDate;
	  this.fromDate = _date.fromDate;
	  this.visible = false;
	  this.transform = _transform_history_data2.default;
	
	  riot.control.on(riot.EVT.updateStationInfobox, function (data) {
	    var exceeded = data.history.filter(function (d) {
	      return d[1] > 50;
	    });
	    _this.update({ data: data, exceeded: exceeded, visible: true });
	  });
	
	  riot.control.on(riot.EVT.hideStationInfobox, function () {
	    _this.update({ visible: false });
	  });
	
	  this.close = function () {
	    riot.control.trigger(riot.EVT.hideStationInfobox);
	  };
	
	  this.showCity = function () {
	    var city = _datasets2.default.find(function (d) {
	      return d.name === _this.data.city;
	    });
	    _this.close();
	    riot.control.trigger(riot.EVT.updateCityInfobox, city);
	  };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	/*
	 * render exceed line for given `svg`, `y` and `width`
	 */
	exports.default = function (_ref) {
	  var svg = _ref.svg,
	      y = _ref.y,
	      width = _ref.width;
	
	  var _y = y(50);
	  svg.append('g').append('line').attr('class', 'history-chart__exceed-line').attr('x1', 0).attr('x2', width).attr('y1', _y).attr('y2', _y);
	};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _d = __webpack_require__(2);
	
	var d3 = _interopRequireWildcard(_d);
	
	var _draw_bars = __webpack_require__(10);
	
	var _draw_bars2 = _interopRequireDefault(_draw_bars);
	
	var _draw_exceed_line = __webpack_require__(22);
	
	var _draw_exceed_line2 = _interopRequireDefault(_draw_exceed_line);
	
	var _date = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/* setup measurements history chart and draw initial bars
	 *
	 * after that, the bar data is updated via `./update_bars.js`
	 *
	 */
	
	exports.default = function (_ref) {
	  var element = _ref.element,
	      data = _ref.data,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 100 : _ref$height,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 200 : _ref$width,
	      _ref$margin = _ref.margin,
	      margin = _ref$margin === undefined ? {
	    top: 20,
	    right: 10,
	    bottom: 20,
	    left: 25
	  } : _ref$margin;
	
	  width = width - margin.left - margin.right;
	
	  var x = d3.scaleTime().rangeRound([0, width]).domain([(0, _date.toDate)('2000-01-01'), (0, _date.toDate)('2016-01-01')]);
	  var y = d3.scaleLinear().rangeRound([height, 0]).domain([0, 500]);
	
	  var svg = d3.select(element).append('svg').attr('width', width + margin.left + margin.right).attr('height', height + margin.top + margin.bottom).attr('class', 'history-chart__svg').append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
	
	  svg.append('g').attr('class', 'axis axis--x').attr('transform', 'translate(0,' + height + ')').call(d3.axisBottom(x).ticks(4));
	
	  svg.append('g').attr('class', 'axis axis--y').call(d3.axisLeft(y).tickValues([50, 250, 500])).append('text').attr('transform', 'rotate(-90)').attr('y', 6).attr('dy', '0.71em').style('text-anchor', 'end').text('mg Nitrat');
	
	  // draw initial bars and return chart stuff
	  var selection = svg.selectAll('.history-chart__bar').data(data).enter();
	  (0, _draw_bars2.default)({ selection: selection, x: x, y: y, height: height });
	
	  // draw exceeding line
	  (0, _draw_exceed_line2.default)({ svg: svg, y: y, width: width });
	
	  return { svg: svg, x: x, y: y, height: height, width: width };
	};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _date = __webpack_require__(5);
	
	exports.default = function (data) {
	  return data.map(function (d) {
	    return {
	      date: (0, _date.toDate)(d[0]),
	      value: d[1]
	    };
	  });
	}; /*
	    * source data is 2d-array of [date, value]
	    *
	    * convert it to use like `d.value` instead of `d[1]`,
	    * parse dates and sort by date
	    */

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _draw_bars = __webpack_require__(10);
	
	var _draw_bars2 = _interopRequireDefault(_draw_bars);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import drawExceedLine from './draw_exceed_line.js'
	
	exports.default = function (_ref, data) {
	  var svg = _ref.svg,
	      x = _ref.x,
	      y = _ref.y,
	      height = _ref.height,
	      width = _ref.width;
	
	  // FIXME use general d3 update pattern
	  // https://bl.ocks.org/mbostock/3808218
	  svg.selectAll('.history-chart__bar').remove();
	  // svg.select('.history-chart__exceed-line').remove()
	  var selection = svg.selectAll('.history-chart__bar').data(data).enter();
	  (0, _draw_bars2.default)({ selection: selection, x: x, y: y, height: height });
	  // drawExceedLine({svg, y, width})
	}; /*
	    * update existing bars
	    */

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _datasets = __webpack_require__(3);
	
	var _datasets2 = _interopRequireDefault(_datasets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (str) {
	  return _datasets2.default.filter(function (d) {
	    return d.name.toLowerCase().indexOf(str) > -1 || d.plz.indexOf(str) === 0;
	  });
	};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(28);
	
	__webpack_require__(40);
	
	__webpack_require__(30);
	
	__webpack_require__(18);
	
	var _render_viz = __webpack_require__(29);
	
	var _render_viz2 = _interopRequireDefault(_render_viz);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (false) {
	  module.hot.accept();
	}
	
	// import 'babel-polyfill'
	// polyfills:
	
	
	// style
	
	
	// riot init
	
	
	// visualization component
	
	
	// main function to render viz
	
	
	// this should later go into the script tag
	(0, _render_viz2.default)({});
	// window.renderViz = renderViz

/***/ }),
/* 28 */
/***/ (function(module, exports) {

	'use strict';
	
	// https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
	if (typeof Object.assign != 'function') {
	  Object.assign = function (target, varArgs) {
	    // .length of function is 2
	    'use strict';
	
	    if (target == null) {
	      // TypeError if undefined or null
	      throw new TypeError('Cannot convert undefined or null to object');
	    }
	
	    var to = Object(target);
	
	    for (var index = 1; index < arguments.length; index++) {
	      var nextSource = arguments[index];
	
	      if (nextSource != null) {
	        // Skip over if undefined or null
	        for (var nextKey in nextSource) {
	          // Avoid bugs when hasOwnProperty is shadowed
	          if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
	            to[nextKey] = nextSource[nextKey];
	          }
	        }
	      }
	    }
	    return to;
	  };
	}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _d = __webpack_require__(2);
	
	var d3 = _interopRequireWildcard(_d);
	
	var _responsive = __webpack_require__(31);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// load config
	var CONFIG = __webpack_require__(41);
	
	/*
	 * main entry point for render visualization
	 *
	 * @param {object} opts - options that will override the ones in '../config.json
	 *
	 */
	
	exports.default = function (opts) {
	  // merge options with defaults
	  var options = Object.assign({}, CONFIG, opts);
	
	  // set initial breakpoint and make function available
	  var getActiveBreakpoint = (0, _responsive.getActiveBreakpointFunc)(options.breakpoints);
	  riot.STORE.breakpoint = getActiveBreakpoint((0, _responsive.getWindowWidth)());
	  riot.STORE.getActiveBreakpoint = getActiveBreakpoint;
	
	  // mount riot into with options
	  riot.mount(options.elementSelector, 'measurement-viz', options);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	// store
	var S = {};
	
	// events
	var E = {
	  updateStationInfobox: 'usi',
	  updateCityInfobox: 'uci',
	  hideStationInfobox: 'hsi',
	  hideCityInfobox: 'hci',
	  windowResize: 'wr',
	  breakpointChanged: 'bc',
	  clearResults: 'cr',
	  jumpTo: 'jt',
	  showLegend: 'sl'
	};
	
	// event bus
	var C = riot.observable();
	
	C.on(E.windowResize, function (width) {
	  var bp = S.getActiveBreakpoint(width);
	  if (S.breakpoint !== bp) {
	    S.breakpoint = bp;
	    C.trigger(E.breakpointChanged, bp);
	  }
	});
	
	// make sure only one infobox is shown
	C.on(E.updateCityInfobox, function () {
	  return C.trigger(E.hideStationInfobox);
	});
	C.on(E.updateStationInfobox, function () {
	  return C.trigger(E.hideCityInfobox);
	});
	
	// open city infobox on jumpTo event on bigger screens
	C.on(E.jumpTo, function (data) {
	  if (['xsmall', 'small'].indexOf(S.breakpoint) < 0) {
	    C.trigger(E.updateCityInfobox, data);
	  }
	});
	
	// make global available
	riot.EVT = E;
	riot.STORE = S;
	riot.control = C;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	/*
	 * utils for responsive handling of this visualization.
	 *
	 */
	
	var getWindowWidth = function getWindowWidth() {
	  var w = window,
	      d = document,
	      e = d.documentElement,
	      g = d.getElementsByTagName('body')[0];
	  return w.innerWidth || e.clientWidth || g.clientWidth;
	};
	
	// FIXME where to do this!?
	var timeout = void 0;
	var doResize = function doResize() {
	  return riot.control.trigger(riot.EVT.windowResize, getWindowWidth());
	};
	window.onresize = function (e) {
	  clearTimeout(timeout);
	  timeout = setTimeout(doResize, 100);
	};
	
	/*
	 * get function for getting active breakpoint based on given `width`
	 */
	var getActiveBreakpointFunc = function getActiveBreakpointFunc(breakpoints) {
	  var bp = [];
	  for (var name in breakpoints) {
	    var value = breakpoints[name];
	    bp.push({ name: name, value: value });
	  }
	  bp = bp.sort(function (a, b) {
	    return a.value - b.value;
	  });
	  var lg = bp[bp.length - 1]; // largest breakpoint as fallback
	  return function (width) {
	    return width <= lg.value ? bp.find(function (el) {
	      return el.value >= width;
	    }).name : lg.name;
	  };
	};
	
	module.exports = {
	  getActiveBreakpointFunc: getActiveBreakpointFunc,
	  getWindowWidth: getWindowWidth
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-axis/ Version 1.0.7. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var slice = Array.prototype.slice;
	
	var identity = function(x) {
	  return x;
	};
	
	var top = 1;
	var right = 2;
	var bottom = 3;
	var left = 4;
	var epsilon = 1e-6;
	
	function translateX(x) {
	  return "translate(" + (x + 0.5) + ",0)";
	}
	
	function translateY(y) {
	  return "translate(0," + (y + 0.5) + ")";
	}
	
	function center(scale) {
	  var offset = Math.max(0, scale.bandwidth() - 1) / 2; // Adjust for 0.5px offset.
	  if (scale.round()) offset = Math.round(offset);
	  return function(d) {
	    return scale(d) + offset;
	  };
	}
	
	function entering() {
	  return !this.__axis;
	}
	
	function axis(orient, scale) {
	  var tickArguments = [],
	      tickValues = null,
	      tickFormat = null,
	      tickSizeInner = 6,
	      tickSizeOuter = 6,
	      tickPadding = 3,
	      k = orient === top || orient === left ? -1 : 1,
	      x = orient === left || orient === right ? "x" : "y",
	      transform = orient === top || orient === bottom ? translateX : translateY;
	
	  function axis(context) {
	    var values = tickValues == null ? (scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain()) : tickValues,
	        format = tickFormat == null ? (scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : identity) : tickFormat,
	        spacing = Math.max(tickSizeInner, 0) + tickPadding,
	        range = scale.range(),
	        range0 = range[0] + 0.5,
	        range1 = range[range.length - 1] + 0.5,
	        position = (scale.bandwidth ? center : identity)(scale.copy()),
	        selection = context.selection ? context.selection() : context,
	        path = selection.selectAll(".domain").data([null]),
	        tick = selection.selectAll(".tick").data(values, scale).order(),
	        tickExit = tick.exit(),
	        tickEnter = tick.enter().append("g").attr("class", "tick"),
	        line = tick.select("line"),
	        text = tick.select("text");
	
	    path = path.merge(path.enter().insert("path", ".tick")
	        .attr("class", "domain")
	        .attr("stroke", "#000"));
	
	    tick = tick.merge(tickEnter);
	
	    line = line.merge(tickEnter.append("line")
	        .attr("stroke", "#000")
	        .attr(x + "2", k * tickSizeInner));
	
	    text = text.merge(tickEnter.append("text")
	        .attr("fill", "#000")
	        .attr(x, k * spacing)
	        .attr("dy", orient === top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));
	
	    if (context !== selection) {
	      path = path.transition(context);
	      tick = tick.transition(context);
	      line = line.transition(context);
	      text = text.transition(context);
	
	      tickExit = tickExit.transition(context)
	          .attr("opacity", epsilon)
	          .attr("transform", function(d) { return isFinite(d = position(d)) ? transform(d) : this.getAttribute("transform"); });
	
	      tickEnter
	          .attr("opacity", epsilon)
	          .attr("transform", function(d) { var p = this.parentNode.__axis; return transform(p && isFinite(p = p(d)) ? p : position(d)); });
	    }
	
	    tickExit.remove();
	
	    path
	        .attr("d", orient === left || orient == right
	            ? "M" + k * tickSizeOuter + "," + range0 + "H0.5V" + range1 + "H" + k * tickSizeOuter
	            : "M" + range0 + "," + k * tickSizeOuter + "V0.5H" + range1 + "V" + k * tickSizeOuter);
	
	    tick
	        .attr("opacity", 1)
	        .attr("transform", function(d) { return transform(position(d)); });
	
	    line
	        .attr(x + "2", k * tickSizeInner);
	
	    text
	        .attr(x, k * spacing)
	        .text(format);
	
	    selection.filter(entering)
	        .attr("fill", "none")
	        .attr("font-size", 10)
	        .attr("font-family", "sans-serif")
	        .attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");
	
	    selection
	        .each(function() { this.__axis = position; });
	  }
	
	  axis.scale = function(_) {
	    return arguments.length ? (scale = _, axis) : scale;
	  };
	
	  axis.ticks = function() {
	    return tickArguments = slice.call(arguments), axis;
	  };
	
	  axis.tickArguments = function(_) {
	    return arguments.length ? (tickArguments = _ == null ? [] : slice.call(_), axis) : tickArguments.slice();
	  };
	
	  axis.tickValues = function(_) {
	    return arguments.length ? (tickValues = _ == null ? null : slice.call(_), axis) : tickValues && tickValues.slice();
	  };
	
	  axis.tickFormat = function(_) {
	    return arguments.length ? (tickFormat = _, axis) : tickFormat;
	  };
	
	  axis.tickSize = function(_) {
	    return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
	  };
	
	  axis.tickSizeInner = function(_) {
	    return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
	  };
	
	  axis.tickSizeOuter = function(_) {
	    return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
	  };
	
	  axis.tickPadding = function(_) {
	    return arguments.length ? (tickPadding = +_, axis) : tickPadding;
	  };
	
	  return axis;
	}
	
	function axisTop(scale) {
	  return axis(top, scale);
	}
	
	function axisRight(scale) {
	  return axis(right, scale);
	}
	
	function axisBottom(scale) {
	  return axis(bottom, scale);
	}
	
	function axisLeft(scale) {
	  return axis(left, scale);
	}
	
	exports.axisTop = axisTop;
	exports.axisRight = axisRight;
	exports.axisBottom = axisBottom;
	exports.axisLeft = axisLeft;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-collection/ Version 1.0.3. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var prefix = "$";
	
	function Map() {}
	
	Map.prototype = map.prototype = {
	  constructor: Map,
	  has: function(key) {
	    return (prefix + key) in this;
	  },
	  get: function(key) {
	    return this[prefix + key];
	  },
	  set: function(key, value) {
	    this[prefix + key] = value;
	    return this;
	  },
	  remove: function(key) {
	    var property = prefix + key;
	    return property in this && delete this[property];
	  },
	  clear: function() {
	    for (var property in this) if (property[0] === prefix) delete this[property];
	  },
	  keys: function() {
	    var keys = [];
	    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
	    return keys;
	  },
	  values: function() {
	    var values = [];
	    for (var property in this) if (property[0] === prefix) values.push(this[property]);
	    return values;
	  },
	  entries: function() {
	    var entries = [];
	    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
	    return entries;
	  },
	  size: function() {
	    var size = 0;
	    for (var property in this) if (property[0] === prefix) ++size;
	    return size;
	  },
	  empty: function() {
	    for (var property in this) if (property[0] === prefix) return false;
	    return true;
	  },
	  each: function(f) {
	    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
	  }
	};
	
	function map(object, f) {
	  var map = new Map;
	
	  // Copy constructor.
	  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });
	
	  // Index array by numeric index or specified key function.
	  else if (Array.isArray(object)) {
	    var i = -1,
	        n = object.length,
	        o;
	
	    if (f == null) while (++i < n) map.set(i, object[i]);
	    else while (++i < n) map.set(f(o = object[i], i, object), o);
	  }
	
	  // Convert object to map.
	  else if (object) for (var key in object) map.set(key, object[key]);
	
	  return map;
	}
	
	var nest = function() {
	  var keys = [],
	      sortKeys = [],
	      sortValues,
	      rollup,
	      nest;
	
	  function apply(array, depth, createResult, setResult) {
	    if (depth >= keys.length) return rollup != null
	        ? rollup(array) : (sortValues != null
	        ? array.sort(sortValues)
	        : array);
	
	    var i = -1,
	        n = array.length,
	        key = keys[depth++],
	        keyValue,
	        value,
	        valuesByKey = map(),
	        values,
	        result = createResult();
	
	    while (++i < n) {
	      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
	        values.push(value);
	      } else {
	        valuesByKey.set(keyValue, [value]);
	      }
	    }
	
	    valuesByKey.each(function(values, key) {
	      setResult(result, key, apply(values, depth, createResult, setResult));
	    });
	
	    return result;
	  }
	
	  function entries(map$$1, depth) {
	    if (++depth > keys.length) return map$$1;
	    var array, sortKey = sortKeys[depth - 1];
	    if (rollup != null && depth >= keys.length) array = map$$1.entries();
	    else array = [], map$$1.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
	    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
	  }
	
	  return nest = {
	    object: function(array) { return apply(array, 0, createObject, setObject); },
	    map: function(array) { return apply(array, 0, createMap, setMap); },
	    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
	    key: function(d) { keys.push(d); return nest; },
	    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
	    sortValues: function(order) { sortValues = order; return nest; },
	    rollup: function(f) { rollup = f; return nest; }
	  };
	};
	
	function createObject() {
	  return {};
	}
	
	function setObject(object, key, value) {
	  object[key] = value;
	}
	
	function createMap() {
	  return map();
	}
	
	function setMap(map$$1, key, value) {
	  map$$1.set(key, value);
	}
	
	function Set() {}
	
	var proto = map.prototype;
	
	Set.prototype = set.prototype = {
	  constructor: Set,
	  has: proto.has,
	  add: function(value) {
	    value += "";
	    this[prefix + value] = value;
	    return this;
	  },
	  remove: proto.remove,
	  clear: proto.clear,
	  values: proto.keys,
	  size: proto.size,
	  empty: proto.empty,
	  each: proto.each
	};
	
	function set(object, f) {
	  var set = new Set;
	
	  // Copy constructor.
	  if (object instanceof Set) object.each(function(value) { set.add(value); });
	
	  // Otherwise, assume it’s an array.
	  else if (object) {
	    var i = -1, n = object.length;
	    if (f == null) while (++i < n) set.add(object[i]);
	    else while (++i < n) set.add(f(object[i], i, object));
	  }
	
	  return set;
	}
	
	var keys = function(map) {
	  var keys = [];
	  for (var key in map) keys.push(key);
	  return keys;
	};
	
	var values = function(map) {
	  var values = [];
	  for (var key in map) values.push(map[key]);
	  return values;
	};
	
	var entries = function(map) {
	  var entries = [];
	  for (var key in map) entries.push({key: key, value: map[key]});
	  return entries;
	};
	
	exports.nest = nest;
	exports.set = set;
	exports.map = map;
	exports.keys = keys;
	exports.values = values;
	exports.entries = entries;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-format/ Version 1.2.0. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	// Computes the decimal coefficient and exponent of the specified number x with
	// significant digits p, where x is positive and p is in [1, 21] or undefined.
	// For example, formatDecimal(1.23) returns ["123", 0].
	var formatDecimal = function(x, p) {
	  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
	  var i, coefficient = x.slice(0, i);
	
	  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
	  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
	  return [
	    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
	    +x.slice(i + 1)
	  ];
	};
	
	var exponent = function(x) {
	  return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
	};
	
	var formatGroup = function(grouping, thousands) {
	  return function(value, width) {
	    var i = value.length,
	        t = [],
	        j = 0,
	        g = grouping[0],
	        length = 0;
	
	    while (i > 0 && g > 0) {
	      if (length + g + 1 > width) g = Math.max(1, width - length);
	      t.push(value.substring(i -= g, i + g));
	      if ((length += g + 1) > width) break;
	      g = grouping[j = (j + 1) % grouping.length];
	    }
	
	    return t.reverse().join(thousands);
	  };
	};
	
	var formatNumerals = function(numerals) {
	  return function(value) {
	    return value.replace(/[0-9]/g, function(i) {
	      return numerals[+i];
	    });
	  };
	};
	
	var formatDefault = function(x, p) {
	  x = x.toPrecision(p);
	
	  out: for (var n = x.length, i = 1, i0 = -1, i1; i < n; ++i) {
	    switch (x[i]) {
	      case ".": i0 = i1 = i; break;
	      case "0": if (i0 === 0) i0 = i; i1 = i; break;
	      case "e": break out;
	      default: if (i0 > 0) i0 = 0; break;
	    }
	  }
	
	  return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
	};
	
	var prefixExponent;
	
	var formatPrefixAuto = function(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1],
	      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
	      n = coefficient.length;
	  return i === n ? coefficient
	      : i > n ? coefficient + new Array(i - n + 1).join("0")
	      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
	      : "0." + new Array(1 - i).join("0") + formatDecimal(x, Math.max(0, p + i - 1))[0]; // less than 1y!
	};
	
	var formatRounded = function(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1];
	  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
	      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
	      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
	};
	
	var formatTypes = {
	  "": formatDefault,
	  "%": function(x, p) { return (x * 100).toFixed(p); },
	  "b": function(x) { return Math.round(x).toString(2); },
	  "c": function(x) { return x + ""; },
	  "d": function(x) { return Math.round(x).toString(10); },
	  "e": function(x, p) { return x.toExponential(p); },
	  "f": function(x, p) { return x.toFixed(p); },
	  "g": function(x, p) { return x.toPrecision(p); },
	  "o": function(x) { return Math.round(x).toString(8); },
	  "p": function(x, p) { return formatRounded(x * 100, p); },
	  "r": formatRounded,
	  "s": formatPrefixAuto,
	  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
	  "x": function(x) { return Math.round(x).toString(16); }
	};
	
	// [[fill]align][sign][symbol][0][width][,][.precision][type]
	var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;
	
	function formatSpecifier(specifier) {
	  return new FormatSpecifier(specifier);
	}
	
	formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
	
	function FormatSpecifier(specifier) {
	  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
	
	  var match,
	      fill = match[1] || " ",
	      align = match[2] || ">",
	      sign = match[3] || "-",
	      symbol = match[4] || "",
	      zero = !!match[5],
	      width = match[6] && +match[6],
	      comma = !!match[7],
	      precision = match[8] && +match[8].slice(1),
	      type = match[9] || "";
	
	  // The "n" type is an alias for ",g".
	  if (type === "n") comma = true, type = "g";
	
	  // Map invalid types to the default format.
	  else if (!formatTypes[type]) type = "";
	
	  // If zero fill is specified, padding goes after sign and before digits.
	  if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";
	
	  this.fill = fill;
	  this.align = align;
	  this.sign = sign;
	  this.symbol = symbol;
	  this.zero = zero;
	  this.width = width;
	  this.comma = comma;
	  this.precision = precision;
	  this.type = type;
	}
	
	FormatSpecifier.prototype.toString = function() {
	  return this.fill
	      + this.align
	      + this.sign
	      + this.symbol
	      + (this.zero ? "0" : "")
	      + (this.width == null ? "" : Math.max(1, this.width | 0))
	      + (this.comma ? "," : "")
	      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
	      + this.type;
	};
	
	var identity = function(x) {
	  return x;
	};
	
	var prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];
	
	var formatLocale = function(locale) {
	  var group = locale.grouping && locale.thousands ? formatGroup(locale.grouping, locale.thousands) : identity,
	      currency = locale.currency,
	      decimal = locale.decimal,
	      numerals = locale.numerals ? formatNumerals(locale.numerals) : identity,
	      percent = locale.percent || "%";
	
	  function newFormat(specifier) {
	    specifier = formatSpecifier(specifier);
	
	    var fill = specifier.fill,
	        align = specifier.align,
	        sign = specifier.sign,
	        symbol = specifier.symbol,
	        zero = specifier.zero,
	        width = specifier.width,
	        comma = specifier.comma,
	        precision = specifier.precision,
	        type = specifier.type;
	
	    // Compute the prefix and suffix.
	    // For SI-prefix, the suffix is lazily computed.
	    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
	        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";
	
	    // What format function should we use?
	    // Is this an integer type?
	    // Can this type generate exponential notation?
	    var formatType = formatTypes[type],
	        maybeSuffix = !type || /[defgprs%]/.test(type);
	
	    // Set the default precision if not specified,
	    // or clamp the specified precision to the supported range.
	    // For significant precision, it must be in [1, 21].
	    // For fixed precision, it must be in [0, 20].
	    precision = precision == null ? (type ? 6 : 12)
	        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
	        : Math.max(0, Math.min(20, precision));
	
	    function format(value) {
	      var valuePrefix = prefix,
	          valueSuffix = suffix,
	          i, n, c;
	
	      if (type === "c") {
	        valueSuffix = formatType(value) + valueSuffix;
	        value = "";
	      } else {
	        value = +value;
	
	        // Perform the initial formatting.
	        var valueNegative = value < 0;
	        value = formatType(Math.abs(value), precision);
	
	        // If a negative value rounds to zero during formatting, treat as positive.
	        if (valueNegative && +value === 0) valueNegative = false;
	
	        // Compute the prefix and suffix.
	        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
	        valueSuffix = valueSuffix + (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + (valueNegative && sign === "(" ? ")" : "");
	
	        // Break the formatted value into the integer “value” part that can be
	        // grouped, and fractional or exponential “suffix” part that is not.
	        if (maybeSuffix) {
	          i = -1, n = value.length;
	          while (++i < n) {
	            if (c = value.charCodeAt(i), 48 > c || c > 57) {
	              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
	              value = value.slice(0, i);
	              break;
	            }
	          }
	        }
	      }
	
	      // If the fill character is not "0", grouping is applied before padding.
	      if (comma && !zero) value = group(value, Infinity);
	
	      // Compute the padding.
	      var length = valuePrefix.length + value.length + valueSuffix.length,
	          padding = length < width ? new Array(width - length + 1).join(fill) : "";
	
	      // If the fill character is "0", grouping is applied after padding.
	      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
	
	      // Reconstruct the final output based on the desired alignment.
	      switch (align) {
	        case "<": value = valuePrefix + value + valueSuffix + padding; break;
	        case "=": value = valuePrefix + padding + value + valueSuffix; break;
	        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
	        default: value = padding + valuePrefix + value + valueSuffix; break;
	      }
	
	      return numerals(value);
	    }
	
	    format.toString = function() {
	      return specifier + "";
	    };
	
	    return format;
	  }
	
	  function formatPrefix(specifier, value) {
	    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
	        e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
	        k = Math.pow(10, -e),
	        prefix = prefixes[8 + e / 3];
	    return function(value) {
	      return f(k * value) + prefix;
	    };
	  }
	
	  return {
	    format: newFormat,
	    formatPrefix: formatPrefix
	  };
	};
	
	var locale;
	
	
	
	defaultLocale({
	  decimal: ".",
	  thousands: ",",
	  grouping: [3],
	  currency: ["$", ""]
	});
	
	function defaultLocale(definition) {
	  locale = formatLocale(definition);
	  exports.format = locale.format;
	  exports.formatPrefix = locale.formatPrefix;
	  return locale;
	}
	
	var precisionFixed = function(step) {
	  return Math.max(0, -exponent(Math.abs(step)));
	};
	
	var precisionPrefix = function(step, value) {
	  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
	};
	
	var precisionRound = function(step, max) {
	  step = Math.abs(step), max = Math.abs(max) - step;
	  return Math.max(0, exponent(max) - exponent(step)) + 1;
	};
	
	exports.formatDefaultLocale = defaultLocale;
	exports.formatLocale = formatLocale;
	exports.formatSpecifier = formatSpecifier;
	exports.precisionFixed = precisionFixed;
	exports.precisionPrefix = precisionPrefix;
	exports.precisionRound = precisionRound;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-path/ Version 1.0.5. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var pi = Math.PI;
	var tau = 2 * pi;
	var epsilon = 1e-6;
	var tauEpsilon = tau - epsilon;
	
	function Path() {
	  this._x0 = this._y0 = // start of current subpath
	  this._x1 = this._y1 = null; // end of current subpath
	  this._ = "";
	}
	
	function path() {
	  return new Path;
	}
	
	Path.prototype = path.prototype = {
	  constructor: Path,
	  moveTo: function(x, y) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
	  },
	  closePath: function() {
	    if (this._x1 !== null) {
	      this._x1 = this._x0, this._y1 = this._y0;
	      this._ += "Z";
	    }
	  },
	  lineTo: function(x, y) {
	    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  quadraticCurveTo: function(x1, y1, x, y) {
	    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
	    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  arcTo: function(x1, y1, x2, y2, r) {
	    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
	    var x0 = this._x1,
	        y0 = this._y1,
	        x21 = x2 - x1,
	        y21 = y2 - y1,
	        x01 = x0 - x1,
	        y01 = y0 - y1,
	        l01_2 = x01 * x01 + y01 * y01;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x1,y1).
	    if (this._x1 === null) {
	      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
	    else if (!(l01_2 > epsilon)) {}
	
	    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
	    // Equivalently, is (x1,y1) coincident with (x2,y2)?
	    // Or, is the radius zero? Line to (x1,y1).
	    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
	      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Otherwise, draw an arc!
	    else {
	      var x20 = x2 - x0,
	          y20 = y2 - y0,
	          l21_2 = x21 * x21 + y21 * y21,
	          l20_2 = x20 * x20 + y20 * y20,
	          l21 = Math.sqrt(l21_2),
	          l01 = Math.sqrt(l01_2),
	          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
	          t01 = l / l01,
	          t21 = l / l21;
	
	      // If the start tangent is not coincident with (x0,y0), line to.
	      if (Math.abs(t01 - 1) > epsilon) {
	        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
	      }
	
	      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
	    }
	  },
	  arc: function(x, y, r, a0, a1, ccw) {
	    x = +x, y = +y, r = +r;
	    var dx = r * Math.cos(a0),
	        dy = r * Math.sin(a0),
	        x0 = x + dx,
	        y0 = y + dy,
	        cw = 1 ^ ccw,
	        da = ccw ? a0 - a1 : a1 - a0;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x0,y0).
	    if (this._x1 === null) {
	      this._ += "M" + x0 + "," + y0;
	    }
	
	    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
	    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
	      this._ += "L" + x0 + "," + y0;
	    }
	
	    // Is this arc empty? We’re done.
	    if (!r) return;
	
	    // Does the angle go the wrong way? Flip the direction.
	    if (da < 0) da = da % tau + tau;
	
	    // Is this a complete circle? Draw two arcs to complete the circle.
	    if (da > tauEpsilon) {
	      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
	    }
	
	    // Is this arc non-empty? Draw an arc!
	    else if (da > epsilon) {
	      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
	    }
	  },
	  rect: function(x, y, w, h) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
	  },
	  toString: function() {
	    return this._;
	  }
	};
	
	exports.path = path;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-scale-chromatic/ Version 1.1.1. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(12)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-interpolate'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Interpolate) { 'use strict';
	
	var colors = function(specifier) {
	  var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
	  while (i < n) colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
	  return colors;
	};
	
	var Accent = colors("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");
	
	var Dark2 = colors("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");
	
	var Paired = colors("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");
	
	var Pastel1 = colors("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");
	
	var Pastel2 = colors("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");
	
	var Set1 = colors("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999");
	
	var Set2 = colors("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");
	
	var Set3 = colors("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");
	
	var ramp = function(scheme) {
	  return d3Interpolate.interpolateRgbBasis(scheme[scheme.length - 1]);
	};
	
	var scheme = new Array(3).concat(
	  "d8b365f5f5f55ab4ac",
	  "a6611adfc27d80cdc1018571",
	  "a6611adfc27df5f5f580cdc1018571",
	  "8c510ad8b365f6e8c3c7eae55ab4ac01665e",
	  "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e",
	  "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e",
	  "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e",
	  "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30",
	  "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30"
	).map(colors);
	
	var BrBG = ramp(scheme);
	
	var scheme$1 = new Array(3).concat(
	  "af8dc3f7f7f77fbf7b",
	  "7b3294c2a5cfa6dba0008837",
	  "7b3294c2a5cff7f7f7a6dba0008837",
	  "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837",
	  "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837",
	  "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837",
	  "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837",
	  "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b",
	  "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b"
	).map(colors);
	
	var PRGn = ramp(scheme$1);
	
	var scheme$2 = new Array(3).concat(
	  "e9a3c9f7f7f7a1d76a",
	  "d01c8bf1b6dab8e1864dac26",
	  "d01c8bf1b6daf7f7f7b8e1864dac26",
	  "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221",
	  "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221",
	  "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221",
	  "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221",
	  "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419",
	  "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419"
	).map(colors);
	
	var PiYG = ramp(scheme$2);
	
	var scheme$3 = new Array(3).concat(
	  "998ec3f7f7f7f1a340",
	  "5e3c99b2abd2fdb863e66101",
	  "5e3c99b2abd2f7f7f7fdb863e66101",
	  "542788998ec3d8daebfee0b6f1a340b35806",
	  "542788998ec3d8daebf7f7f7fee0b6f1a340b35806",
	  "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806",
	  "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806",
	  "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08",
	  "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08"
	).map(colors);
	
	var PuOr = ramp(scheme$3);
	
	var scheme$4 = new Array(3).concat(
	  "ef8a62f7f7f767a9cf",
	  "ca0020f4a58292c5de0571b0",
	  "ca0020f4a582f7f7f792c5de0571b0",
	  "b2182bef8a62fddbc7d1e5f067a9cf2166ac",
	  "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac",
	  "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac",
	  "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac",
	  "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061",
	  "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061"
	).map(colors);
	
	var RdBu = ramp(scheme$4);
	
	var scheme$5 = new Array(3).concat(
	  "ef8a62ffffff999999",
	  "ca0020f4a582bababa404040",
	  "ca0020f4a582ffffffbababa404040",
	  "b2182bef8a62fddbc7e0e0e09999994d4d4d",
	  "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d",
	  "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d",
	  "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d",
	  "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a",
	  "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a"
	).map(colors);
	
	var RdGy = ramp(scheme$5);
	
	var scheme$6 = new Array(3).concat(
	  "fc8d59ffffbf91bfdb",
	  "d7191cfdae61abd9e92c7bb6",
	  "d7191cfdae61ffffbfabd9e92c7bb6",
	  "d73027fc8d59fee090e0f3f891bfdb4575b4",
	  "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4",
	  "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4",
	  "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4",
	  "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695",
	  "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695"
	).map(colors);
	
	var RdYlBu = ramp(scheme$6);
	
	var scheme$7 = new Array(3).concat(
	  "fc8d59ffffbf91cf60",
	  "d7191cfdae61a6d96a1a9641",
	  "d7191cfdae61ffffbfa6d96a1a9641",
	  "d73027fc8d59fee08bd9ef8b91cf601a9850",
	  "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850",
	  "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850",
	  "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850",
	  "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837",
	  "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837"
	).map(colors);
	
	var RdYlGn = ramp(scheme$7);
	
	var scheme$8 = new Array(3).concat(
	  "fc8d59ffffbf99d594",
	  "d7191cfdae61abdda42b83ba",
	  "d7191cfdae61ffffbfabdda42b83ba",
	  "d53e4ffc8d59fee08be6f59899d5943288bd",
	  "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd",
	  "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd",
	  "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd",
	  "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2",
	  "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2"
	).map(colors);
	
	var Spectral = ramp(scheme$8);
	
	var scheme$9 = new Array(3).concat(
	  "e5f5f999d8c92ca25f",
	  "edf8fbb2e2e266c2a4238b45",
	  "edf8fbb2e2e266c2a42ca25f006d2c",
	  "edf8fbccece699d8c966c2a42ca25f006d2c",
	  "edf8fbccece699d8c966c2a441ae76238b45005824",
	  "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824",
	  "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b"
	).map(colors);
	
	var BuGn = ramp(scheme$9);
	
	var scheme$10 = new Array(3).concat(
	  "e0ecf49ebcda8856a7",
	  "edf8fbb3cde38c96c688419d",
	  "edf8fbb3cde38c96c68856a7810f7c",
	  "edf8fbbfd3e69ebcda8c96c68856a7810f7c",
	  "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b",
	  "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b",
	  "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b"
	).map(colors);
	
	var BuPu = ramp(scheme$10);
	
	var scheme$11 = new Array(3).concat(
	  "e0f3dba8ddb543a2ca",
	  "f0f9e8bae4bc7bccc42b8cbe",
	  "f0f9e8bae4bc7bccc443a2ca0868ac",
	  "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac",
	  "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e",
	  "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e",
	  "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081"
	).map(colors);
	
	var GnBu = ramp(scheme$11);
	
	var scheme$12 = new Array(3).concat(
	  "fee8c8fdbb84e34a33",
	  "fef0d9fdcc8afc8d59d7301f",
	  "fef0d9fdcc8afc8d59e34a33b30000",
	  "fef0d9fdd49efdbb84fc8d59e34a33b30000",
	  "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000",
	  "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000",
	  "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000"
	).map(colors);
	
	var OrRd = ramp(scheme$12);
	
	var scheme$13 = new Array(3).concat(
	  "ece2f0a6bddb1c9099",
	  "f6eff7bdc9e167a9cf02818a",
	  "f6eff7bdc9e167a9cf1c9099016c59",
	  "f6eff7d0d1e6a6bddb67a9cf1c9099016c59",
	  "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450",
	  "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450",
	  "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636"
	).map(colors);
	
	var PuBuGn = ramp(scheme$13);
	
	var scheme$14 = new Array(3).concat(
	  "ece7f2a6bddb2b8cbe",
	  "f1eef6bdc9e174a9cf0570b0",
	  "f1eef6bdc9e174a9cf2b8cbe045a8d",
	  "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d",
	  "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b",
	  "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b",
	  "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858"
	).map(colors);
	
	var PuBu = ramp(scheme$14);
	
	var scheme$15 = new Array(3).concat(
	  "e7e1efc994c7dd1c77",
	  "f1eef6d7b5d8df65b0ce1256",
	  "f1eef6d7b5d8df65b0dd1c77980043",
	  "f1eef6d4b9dac994c7df65b0dd1c77980043",
	  "f1eef6d4b9dac994c7df65b0e7298ace125691003f",
	  "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f",
	  "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f"
	).map(colors);
	
	var PuRd = ramp(scheme$15);
	
	var scheme$16 = new Array(3).concat(
	  "fde0ddfa9fb5c51b8a",
	  "feebe2fbb4b9f768a1ae017e",
	  "feebe2fbb4b9f768a1c51b8a7a0177",
	  "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177",
	  "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177",
	  "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177",
	  "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a"
	).map(colors);
	
	var RdPu = ramp(scheme$16);
	
	var scheme$17 = new Array(3).concat(
	  "edf8b17fcdbb2c7fb8",
	  "ffffcca1dab441b6c4225ea8",
	  "ffffcca1dab441b6c42c7fb8253494",
	  "ffffccc7e9b47fcdbb41b6c42c7fb8253494",
	  "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84",
	  "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84",
	  "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58"
	).map(colors);
	
	var YlGnBu = ramp(scheme$17);
	
	var scheme$18 = new Array(3).concat(
	  "f7fcb9addd8e31a354",
	  "ffffccc2e69978c679238443",
	  "ffffccc2e69978c67931a354006837",
	  "ffffccd9f0a3addd8e78c67931a354006837",
	  "ffffccd9f0a3addd8e78c67941ab5d238443005a32",
	  "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32",
	  "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529"
	).map(colors);
	
	var YlGn = ramp(scheme$18);
	
	var scheme$19 = new Array(3).concat(
	  "fff7bcfec44fd95f0e",
	  "ffffd4fed98efe9929cc4c02",
	  "ffffd4fed98efe9929d95f0e993404",
	  "ffffd4fee391fec44ffe9929d95f0e993404",
	  "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04",
	  "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04",
	  "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506"
	).map(colors);
	
	var YlOrBr = ramp(scheme$19);
	
	var scheme$20 = new Array(3).concat(
	  "ffeda0feb24cf03b20",
	  "ffffb2fecc5cfd8d3ce31a1c",
	  "ffffb2fecc5cfd8d3cf03b20bd0026",
	  "ffffb2fed976feb24cfd8d3cf03b20bd0026",
	  "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026",
	  "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026",
	  "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026"
	).map(colors);
	
	var YlOrRd = ramp(scheme$20);
	
	var scheme$21 = new Array(3).concat(
	  "deebf79ecae13182bd",
	  "eff3ffbdd7e76baed62171b5",
	  "eff3ffbdd7e76baed63182bd08519c",
	  "eff3ffc6dbef9ecae16baed63182bd08519c",
	  "eff3ffc6dbef9ecae16baed64292c62171b5084594",
	  "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594",
	  "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b"
	).map(colors);
	
	var Blues = ramp(scheme$21);
	
	var scheme$22 = new Array(3).concat(
	  "e5f5e0a1d99b31a354",
	  "edf8e9bae4b374c476238b45",
	  "edf8e9bae4b374c47631a354006d2c",
	  "edf8e9c7e9c0a1d99b74c47631a354006d2c",
	  "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32",
	  "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32",
	  "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b"
	).map(colors);
	
	var Greens = ramp(scheme$22);
	
	var scheme$23 = new Array(3).concat(
	  "f0f0f0bdbdbd636363",
	  "f7f7f7cccccc969696525252",
	  "f7f7f7cccccc969696636363252525",
	  "f7f7f7d9d9d9bdbdbd969696636363252525",
	  "f7f7f7d9d9d9bdbdbd969696737373525252252525",
	  "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525",
	  "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000"
	).map(colors);
	
	var Greys = ramp(scheme$23);
	
	var scheme$24 = new Array(3).concat(
	  "efedf5bcbddc756bb1",
	  "f2f0f7cbc9e29e9ac86a51a3",
	  "f2f0f7cbc9e29e9ac8756bb154278f",
	  "f2f0f7dadaebbcbddc9e9ac8756bb154278f",
	  "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486",
	  "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486",
	  "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d"
	).map(colors);
	
	var Purples = ramp(scheme$24);
	
	var scheme$25 = new Array(3).concat(
	  "fee0d2fc9272de2d26",
	  "fee5d9fcae91fb6a4acb181d",
	  "fee5d9fcae91fb6a4ade2d26a50f15",
	  "fee5d9fcbba1fc9272fb6a4ade2d26a50f15",
	  "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d",
	  "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d",
	  "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d"
	).map(colors);
	
	var Reds = ramp(scheme$25);
	
	var scheme$26 = new Array(3).concat(
	  "fee6cefdae6be6550d",
	  "feeddefdbe85fd8d3cd94701",
	  "feeddefdbe85fd8d3ce6550da63603",
	  "feeddefdd0a2fdae6bfd8d3ce6550da63603",
	  "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04",
	  "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04",
	  "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704"
	).map(colors);
	
	var Oranges = ramp(scheme$26);
	
	exports.schemeAccent = Accent;
	exports.schemeDark2 = Dark2;
	exports.schemePaired = Paired;
	exports.schemePastel1 = Pastel1;
	exports.schemePastel2 = Pastel2;
	exports.schemeSet1 = Set1;
	exports.schemeSet2 = Set2;
	exports.schemeSet3 = Set3;
	exports.interpolateBrBG = BrBG;
	exports.schemeBrBG = scheme;
	exports.interpolatePRGn = PRGn;
	exports.schemePRGn = scheme$1;
	exports.interpolatePiYG = PiYG;
	exports.schemePiYG = scheme$2;
	exports.interpolatePuOr = PuOr;
	exports.schemePuOr = scheme$3;
	exports.interpolateRdBu = RdBu;
	exports.schemeRdBu = scheme$4;
	exports.interpolateRdGy = RdGy;
	exports.schemeRdGy = scheme$5;
	exports.interpolateRdYlBu = RdYlBu;
	exports.schemeRdYlBu = scheme$6;
	exports.interpolateRdYlGn = RdYlGn;
	exports.schemeRdYlGn = scheme$7;
	exports.interpolateSpectral = Spectral;
	exports.schemeSpectral = scheme$8;
	exports.interpolateBuGn = BuGn;
	exports.schemeBuGn = scheme$9;
	exports.interpolateBuPu = BuPu;
	exports.schemeBuPu = scheme$10;
	exports.interpolateGnBu = GnBu;
	exports.schemeGnBu = scheme$11;
	exports.interpolateOrRd = OrRd;
	exports.schemeOrRd = scheme$12;
	exports.interpolatePuBuGn = PuBuGn;
	exports.schemePuBuGn = scheme$13;
	exports.interpolatePuBu = PuBu;
	exports.schemePuBu = scheme$14;
	exports.interpolatePuRd = PuRd;
	exports.schemePuRd = scheme$15;
	exports.interpolateRdPu = RdPu;
	exports.schemeRdPu = scheme$16;
	exports.interpolateYlGnBu = YlGnBu;
	exports.schemeYlGnBu = scheme$17;
	exports.interpolateYlGn = YlGn;
	exports.schemeYlGn = scheme$18;
	exports.interpolateYlOrBr = YlOrBr;
	exports.schemeYlOrBr = scheme$19;
	exports.interpolateYlOrRd = YlOrRd;
	exports.schemeYlOrRd = scheme$20;
	exports.interpolateBlues = Blues;
	exports.schemeBlues = scheme$21;
	exports.interpolateGreens = Greens;
	exports.schemeGreens = scheme$22;
	exports.interpolateGreys = Greys;
	exports.schemeGreys = scheme$23;
	exports.interpolatePurples = Purples;
	exports.schemePurples = scheme$24;
	exports.interpolateReds = Reds;
	exports.schemeReds = scheme$25;
	exports.interpolateOranges = Oranges;
	exports.schemeOranges = scheme$26;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-scale/ Version 1.0.6. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(11), __webpack_require__(33), __webpack_require__(12), __webpack_require__(34), __webpack_require__(14), __webpack_require__(13), __webpack_require__(6)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-array', 'd3-collection', 'd3-interpolate', 'd3-format', 'd3-time', 'd3-time-format', 'd3-color'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3,global.d3,global.d3,global.d3,global.d3));
	}(this, (function (exports,d3Array,d3Collection,d3Interpolate,d3Format,d3Time,d3TimeFormat,d3Color) { 'use strict';
	
	var array = Array.prototype;
	
	var map$1 = array.map;
	var slice = array.slice;
	
	var implicit = {name: "implicit"};
	
	function ordinal(range$$1) {
	  var index = d3Collection.map(),
	      domain = [],
	      unknown = implicit;
	
	  range$$1 = range$$1 == null ? [] : slice.call(range$$1);
	
	  function scale(d) {
	    var key = d + "", i = index.get(key);
	    if (!i) {
	      if (unknown !== implicit) return unknown;
	      index.set(key, i = domain.push(d));
	    }
	    return range$$1[(i - 1) % range$$1.length];
	  }
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [], index = d3Collection.map();
	    var i = -1, n = _.length, d, key;
	    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
	    return scale;
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), scale) : range$$1.slice();
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function() {
	    return ordinal()
	        .domain(domain)
	        .range(range$$1)
	        .unknown(unknown);
	  };
	
	  return scale;
	}
	
	function band() {
	  var scale = ordinal().unknown(undefined),
	      domain = scale.domain,
	      ordinalRange = scale.range,
	      range$$1 = [0, 1],
	      step,
	      bandwidth,
	      round = false,
	      paddingInner = 0,
	      paddingOuter = 0,
	      align = 0.5;
	
	  delete scale.unknown;
	
	  function rescale() {
	    var n = domain().length,
	        reverse = range$$1[1] < range$$1[0],
	        start = range$$1[reverse - 0],
	        stop = range$$1[1 - reverse];
	    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
	    if (round) step = Math.floor(step);
	    start += (stop - start - step * (n - paddingInner)) * align;
	    bandwidth = step * (1 - paddingInner);
	    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
	    var values = d3Array.range(n).map(function(i) { return start + step * i; });
	    return ordinalRange(reverse ? values.reverse() : values);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = [+_[0], +_[1]], rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = [+_[0], +_[1]], round = true, rescale();
	  };
	
	  scale.bandwidth = function() {
	    return bandwidth;
	  };
	
	  scale.step = function() {
	    return step;
	  };
	
	  scale.round = function(_) {
	    return arguments.length ? (round = !!_, rescale()) : round;
	  };
	
	  scale.padding = function(_) {
	    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingInner = function(_) {
	    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingOuter = function(_) {
	    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
	  };
	
	  scale.align = function(_) {
	    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
	  };
	
	  scale.copy = function() {
	    return band()
	        .domain(domain())
	        .range(range$$1)
	        .round(round)
	        .paddingInner(paddingInner)
	        .paddingOuter(paddingOuter)
	        .align(align);
	  };
	
	  return rescale();
	}
	
	function pointish(scale) {
	  var copy = scale.copy;
	
	  scale.padding = scale.paddingOuter;
	  delete scale.paddingInner;
	  delete scale.paddingOuter;
	
	  scale.copy = function() {
	    return pointish(copy());
	  };
	
	  return scale;
	}
	
	function point() {
	  return pointish(band().paddingInner(1));
	}
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var number = function(x) {
	  return +x;
	};
	
	var unit = [0, 1];
	
	function deinterpolateLinear(a, b) {
	  return (b -= (a = +a))
	      ? function(x) { return (x - a) / b; }
	      : constant(b);
	}
	
	function deinterpolateClamp(deinterpolate) {
	  return function(a, b) {
	    var d = deinterpolate(a = +a, b = +b);
	    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
	  };
	}
	
	function reinterpolateClamp(reinterpolate) {
	  return function(a, b) {
	    var r = reinterpolate(a = +a, b = +b);
	    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
	  };
	}
	
	function bimap(domain, range$$1, deinterpolate, reinterpolate) {
	  var d0 = domain[0], d1 = domain[1], r0 = range$$1[0], r1 = range$$1[1];
	  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
	  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
	  return function(x) { return r0(d0(x)); };
	}
	
	function polymap(domain, range$$1, deinterpolate, reinterpolate) {
	  var j = Math.min(domain.length, range$$1.length) - 1,
	      d = new Array(j),
	      r = new Array(j),
	      i = -1;
	
	  // Reverse descending domains.
	  if (domain[j] < domain[0]) {
	    domain = domain.slice().reverse();
	    range$$1 = range$$1.slice().reverse();
	  }
	
	  while (++i < j) {
	    d[i] = deinterpolate(domain[i], domain[i + 1]);
	    r[i] = reinterpolate(range$$1[i], range$$1[i + 1]);
	  }
	
	  return function(x) {
	    var i = d3Array.bisect(domain, x, 1, j) - 1;
	    return r[i](d[i](x));
	  };
	}
	
	function copy(source, target) {
	  return target
	      .domain(source.domain())
	      .range(source.range())
	      .interpolate(source.interpolate())
	      .clamp(source.clamp());
	}
	
	// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
	// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
	function continuous(deinterpolate, reinterpolate) {
	  var domain = unit,
	      range$$1 = unit,
	      interpolate$$1 = d3Interpolate.interpolate,
	      clamp = false,
	      piecewise,
	      output,
	      input;
	
	  function rescale() {
	    piecewise = Math.min(domain.length, range$$1.length) > 2 ? polymap : bimap;
	    output = input = null;
	    return scale;
	  }
	
	  function scale(x) {
	    return (output || (output = piecewise(domain, range$$1, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate$$1)))(+x);
	  }
	
	  scale.invert = function(y) {
	    return (input || (input = piecewise(range$$1, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = map$1.call(_, number), rescale()) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = slice.call(_), interpolate$$1 = d3Interpolate.interpolateRound, rescale();
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, rescale()) : clamp;
	  };
	
	  scale.interpolate = function(_) {
	    return arguments.length ? (interpolate$$1 = _, rescale()) : interpolate$$1;
	  };
	
	  return rescale();
	}
	
	var tickFormat = function(domain, count, specifier) {
	  var start = domain[0],
	      stop = domain[domain.length - 1],
	      step = d3Array.tickStep(start, stop, count == null ? 10 : count),
	      precision;
	  specifier = d3Format.formatSpecifier(specifier == null ? ",f" : specifier);
	  switch (specifier.type) {
	    case "s": {
	      var value = Math.max(Math.abs(start), Math.abs(stop));
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionPrefix(step, value))) specifier.precision = precision;
	      return d3Format.formatPrefix(specifier, value);
	    }
	    case "":
	    case "e":
	    case "g":
	    case "p":
	    case "r": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
	      break;
	    }
	    case "f":
	    case "%": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
	      break;
	    }
	  }
	  return d3Format.format(specifier);
	};
	
	function linearish(scale) {
	  var domain = scale.domain;
	
	  scale.ticks = function(count) {
	    var d = domain();
	    return d3Array.ticks(d[0], d[d.length - 1], count == null ? 10 : count);
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return tickFormat(domain(), count, specifier);
	  };
	
	  scale.nice = function(count) {
	    if (count == null) count = 10;
	
	    var d = domain(),
	        i0 = 0,
	        i1 = d.length - 1,
	        start = d[i0],
	        stop = d[i1],
	        step;
	
	    if (stop < start) {
	      step = start, start = stop, stop = step;
	      step = i0, i0 = i1, i1 = step;
	    }
	
	    step = d3Array.tickIncrement(start, stop, count);
	
	    if (step > 0) {
	      start = Math.floor(start / step) * step;
	      stop = Math.ceil(stop / step) * step;
	      step = d3Array.tickIncrement(start, stop, count);
	    } else if (step < 0) {
	      start = Math.ceil(start * step) / step;
	      stop = Math.floor(stop * step) / step;
	      step = d3Array.tickIncrement(start, stop, count);
	    }
	
	    if (step > 0) {
	      d[i0] = Math.floor(start / step) * step;
	      d[i1] = Math.ceil(stop / step) * step;
	      domain(d);
	    } else if (step < 0) {
	      d[i0] = Math.ceil(start * step) / step;
	      d[i1] = Math.floor(stop * step) / step;
	      domain(d);
	    }
	
	    return scale;
	  };
	
	  return scale;
	}
	
	function linear() {
	  var scale = continuous(deinterpolateLinear, d3Interpolate.interpolateNumber);
	
	  scale.copy = function() {
	    return copy(scale, linear());
	  };
	
	  return linearish(scale);
	}
	
	function identity() {
	  var domain = [0, 1];
	
	  function scale(x) {
	    return +x;
	  }
	
	  scale.invert = scale;
	
	  scale.domain = scale.range = function(_) {
	    return arguments.length ? (domain = map$1.call(_, number), scale) : domain.slice();
	  };
	
	  scale.copy = function() {
	    return identity().domain(domain);
	  };
	
	  return linearish(scale);
	}
	
	var nice = function(domain, interval) {
	  domain = domain.slice();
	
	  var i0 = 0,
	      i1 = domain.length - 1,
	      x0 = domain[i0],
	      x1 = domain[i1],
	      t;
	
	  if (x1 < x0) {
	    t = i0, i0 = i1, i1 = t;
	    t = x0, x0 = x1, x1 = t;
	  }
	
	  domain[i0] = interval.floor(x0);
	  domain[i1] = interval.ceil(x1);
	  return domain;
	};
	
	function deinterpolate(a, b) {
	  return (b = Math.log(b / a))
	      ? function(x) { return Math.log(x / a) / b; }
	      : constant(b);
	}
	
	function reinterpolate(a, b) {
	  return a < 0
	      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
	      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
	}
	
	function pow10(x) {
	  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
	}
	
	function powp(base) {
	  return base === 10 ? pow10
	      : base === Math.E ? Math.exp
	      : function(x) { return Math.pow(base, x); };
	}
	
	function logp(base) {
	  return base === Math.E ? Math.log
	      : base === 10 && Math.log10
	      || base === 2 && Math.log2
	      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
	}
	
	function reflect(f) {
	  return function(x) {
	    return -f(-x);
	  };
	}
	
	function log() {
	  var scale = continuous(deinterpolate, reinterpolate).domain([1, 10]),
	      domain = scale.domain,
	      base = 10,
	      logs = logp(10),
	      pows = powp(10);
	
	  function rescale() {
	    logs = logp(base), pows = powp(base);
	    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
	    return scale;
	  }
	
	  scale.base = function(_) {
	    return arguments.length ? (base = +_, rescale()) : base;
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.ticks = function(count) {
	    var d = domain(),
	        u = d[0],
	        v = d[d.length - 1],
	        r;
	
	    if (r = v < u) i = u, u = v, v = i;
	
	    var i = logs(u),
	        j = logs(v),
	        p,
	        k,
	        t,
	        n = count == null ? 10 : +count,
	        z = [];
	
	    if (!(base % 1) && j - i < n) {
	      i = Math.round(i) - 1, j = Math.round(j) + 1;
	      if (u > 0) for (; i < j; ++i) {
	        for (k = 1, p = pows(i); k < base; ++k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      } else for (; i < j; ++i) {
	        for (k = base - 1, p = pows(i); k >= 1; --k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      }
	    } else {
	      z = d3Array.ticks(i, j, Math.min(j - i, n)).map(pows);
	    }
	
	    return r ? z.reverse() : z;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
	    if (typeof specifier !== "function") specifier = d3Format.format(specifier);
	    if (count === Infinity) return specifier;
	    if (count == null) count = 10;
	    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
	    return function(d) {
	      var i = d / pows(Math.round(logs(d)));
	      if (i * base < base - 0.5) i *= base;
	      return i <= k ? specifier(d) : "";
	    };
	  };
	
	  scale.nice = function() {
	    return domain(nice(domain(), {
	      floor: function(x) { return pows(Math.floor(logs(x))); },
	      ceil: function(x) { return pows(Math.ceil(logs(x))); }
	    }));
	  };
	
	  scale.copy = function() {
	    return copy(scale, log().base(base));
	  };
	
	  return scale;
	}
	
	function raise(x, exponent) {
	  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
	}
	
	function pow() {
	  var exponent = 1,
	      scale = continuous(deinterpolate, reinterpolate),
	      domain = scale.domain;
	
	  function deinterpolate(a, b) {
	    return (b = raise(b, exponent) - (a = raise(a, exponent)))
	        ? function(x) { return (raise(x, exponent) - a) / b; }
	        : constant(b);
	  }
	
	  function reinterpolate(a, b) {
	    b = raise(b, exponent) - (a = raise(a, exponent));
	    return function(t) { return raise(a + b * t, 1 / exponent); };
	  }
	
	  scale.exponent = function(_) {
	    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
	  };
	
	  scale.copy = function() {
	    return copy(scale, pow().exponent(exponent));
	  };
	
	  return linearish(scale);
	}
	
	function sqrt() {
	  return pow().exponent(0.5);
	}
	
	function quantile$1() {
	  var domain = [],
	      range$$1 = [],
	      thresholds = [];
	
	  function rescale() {
	    var i = 0, n = Math.max(1, range$$1.length);
	    thresholds = new Array(n - 1);
	    while (++i < n) thresholds[i - 1] = d3Array.quantile(domain, i / n);
	    return scale;
	  }
	
	  function scale(x) {
	    if (!isNaN(x = +x)) return range$$1[d3Array.bisect(thresholds, x)];
	  }
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN] : [
	      i > 0 ? thresholds[i - 1] : domain[0],
	      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
	    ];
	  };
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [];
	    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
	    domain.sort(d3Array.ascending);
	    return rescale();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.quantiles = function() {
	    return thresholds.slice();
	  };
	
	  scale.copy = function() {
	    return quantile$1()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	function quantize() {
	  var x0 = 0,
	      x1 = 1,
	      n = 1,
	      domain = [0.5],
	      range$$1 = [0, 1];
	
	  function scale(x) {
	    if (x <= x) return range$$1[d3Array.bisect(domain, x, 0, n)];
	  }
	
	  function rescale() {
	    var i = -1;
	    domain = new Array(n);
	    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
	    return scale;
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (n = (range$$1 = slice.call(_)).length - 1, rescale()) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN]
	        : i < 1 ? [x0, domain[0]]
	        : i >= n ? [domain[n - 1], x1]
	        : [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return quantize()
	        .domain([x0, x1])
	        .range(range$$1);
	  };
	
	  return linearish(scale);
	}
	
	function threshold() {
	  var domain = [0.5],
	      range$$1 = [0, 1],
	      n = 1;
	
	  function scale(x) {
	    if (x <= x) return range$$1[d3Array.bisect(domain, x, 0, n)];
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = slice.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return threshold()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	var durationSecond = 1000;
	var durationMinute = durationSecond * 60;
	var durationHour = durationMinute * 60;
	var durationDay = durationHour * 24;
	var durationWeek = durationDay * 7;
	var durationMonth = durationDay * 30;
	var durationYear = durationDay * 365;
	
	function date(t) {
	  return new Date(t);
	}
	
	function number$1(t) {
	  return t instanceof Date ? +t : +new Date(+t);
	}
	
	function calendar(year, month, week, day, hour, minute, second, millisecond, format$$1) {
	  var scale = continuous(deinterpolateLinear, d3Interpolate.interpolateNumber),
	      invert = scale.invert,
	      domain = scale.domain;
	
	  var formatMillisecond = format$$1(".%L"),
	      formatSecond = format$$1(":%S"),
	      formatMinute = format$$1("%I:%M"),
	      formatHour = format$$1("%I %p"),
	      formatDay = format$$1("%a %d"),
	      formatWeek = format$$1("%b %d"),
	      formatMonth = format$$1("%B"),
	      formatYear = format$$1("%Y");
	
	  var tickIntervals = [
	    [second,  1,      durationSecond],
	    [second,  5,  5 * durationSecond],
	    [second, 15, 15 * durationSecond],
	    [second, 30, 30 * durationSecond],
	    [minute,  1,      durationMinute],
	    [minute,  5,  5 * durationMinute],
	    [minute, 15, 15 * durationMinute],
	    [minute, 30, 30 * durationMinute],
	    [  hour,  1,      durationHour  ],
	    [  hour,  3,  3 * durationHour  ],
	    [  hour,  6,  6 * durationHour  ],
	    [  hour, 12, 12 * durationHour  ],
	    [   day,  1,      durationDay   ],
	    [   day,  2,  2 * durationDay   ],
	    [  week,  1,      durationWeek  ],
	    [ month,  1,      durationMonth ],
	    [ month,  3,  3 * durationMonth ],
	    [  year,  1,      durationYear  ]
	  ];
	
	  function tickFormat(date) {
	    return (second(date) < date ? formatMillisecond
	        : minute(date) < date ? formatSecond
	        : hour(date) < date ? formatMinute
	        : day(date) < date ? formatHour
	        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
	        : year(date) < date ? formatMonth
	        : formatYear)(date);
	  }
	
	  function tickInterval(interval, start, stop, step) {
	    if (interval == null) interval = 10;
	
	    // If a desired tick count is specified, pick a reasonable tick interval
	    // based on the extent of the domain and a rough estimate of tick size.
	    // Otherwise, assume interval is already a time interval and use it.
	    if (typeof interval === "number") {
	      var target = Math.abs(stop - start) / interval,
	          i = d3Array.bisector(function(i) { return i[2]; }).right(tickIntervals, target);
	      if (i === tickIntervals.length) {
	        step = d3Array.tickStep(start / durationYear, stop / durationYear, interval);
	        interval = year;
	      } else if (i) {
	        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
	        step = i[1];
	        interval = i[0];
	      } else {
	        step = d3Array.tickStep(start, stop, interval);
	        interval = millisecond;
	      }
	    }
	
	    return step == null ? interval : interval.every(step);
	  }
	
	  scale.invert = function(y) {
	    return new Date(invert(y));
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? domain(map$1.call(_, number$1)) : domain().map(date);
	  };
	
	  scale.ticks = function(interval, step) {
	    var d = domain(),
	        t0 = d[0],
	        t1 = d[d.length - 1],
	        r = t1 < t0,
	        t;
	    if (r) t = t0, t0 = t1, t1 = t;
	    t = tickInterval(interval, t0, t1, step);
	    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
	    return r ? t.reverse() : t;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return specifier == null ? tickFormat : format$$1(specifier);
	  };
	
	  scale.nice = function(interval, step) {
	    var d = domain();
	    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
	        ? domain(nice(d, interval))
	        : scale;
	  };
	
	  scale.copy = function() {
	    return copy(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format$$1));
	  };
	
	  return scale;
	}
	
	var time = function() {
	  return calendar(d3Time.timeYear, d3Time.timeMonth, d3Time.timeWeek, d3Time.timeDay, d3Time.timeHour, d3Time.timeMinute, d3Time.timeSecond, d3Time.timeMillisecond, d3TimeFormat.timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
	};
	
	var utcTime = function() {
	  return calendar(d3Time.utcYear, d3Time.utcMonth, d3Time.utcWeek, d3Time.utcDay, d3Time.utcHour, d3Time.utcMinute, d3Time.utcSecond, d3Time.utcMillisecond, d3TimeFormat.utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
	};
	
	var colors = function(s) {
	  return s.match(/.{6}/g).map(function(x) {
	    return "#" + x;
	  });
	};
	
	var category10 = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");
	
	var category20b = colors("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6");
	
	var category20c = colors("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9");
	
	var category20 = colors("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5");
	
	var cubehelix$1 = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(300, 0.5, 0.0), d3Color.cubehelix(-240, 0.5, 1.0));
	
	var warm = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(-100, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	var cool = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(260, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	var rainbow = d3Color.cubehelix();
	
	var rainbow$1 = function(t) {
	  if (t < 0 || t > 1) t -= Math.floor(t);
	  var ts = Math.abs(t - 0.5);
	  rainbow.h = 360 * t - 100;
	  rainbow.s = 1.5 - 1.5 * ts;
	  rainbow.l = 0.8 - 0.9 * ts;
	  return rainbow + "";
	};
	
	function ramp(range$$1) {
	  var n = range$$1.length;
	  return function(t) {
	    return range$$1[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	  };
	}
	
	var viridis = ramp(colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
	
	var magma = ramp(colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
	
	var inferno = ramp(colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
	
	var plasma = ramp(colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
	
	function sequential(interpolator) {
	  var x0 = 0,
	      x1 = 1,
	      clamp = false;
	
	  function scale(x) {
	    var t = (x - x0) / (x1 - x0);
	    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, scale) : clamp;
	  };
	
	  scale.interpolator = function(_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.copy = function() {
	    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
	  };
	
	  return linearish(scale);
	}
	
	exports.scaleBand = band;
	exports.scalePoint = point;
	exports.scaleIdentity = identity;
	exports.scaleLinear = linear;
	exports.scaleLog = log;
	exports.scaleOrdinal = ordinal;
	exports.scaleImplicit = implicit;
	exports.scalePow = pow;
	exports.scaleSqrt = sqrt;
	exports.scaleQuantile = quantile$1;
	exports.scaleQuantize = quantize;
	exports.scaleThreshold = threshold;
	exports.scaleTime = time;
	exports.scaleUtc = utcTime;
	exports.schemeCategory10 = category10;
	exports.schemeCategory20b = category20b;
	exports.schemeCategory20c = category20c;
	exports.schemeCategory20 = category20;
	exports.interpolateCubehelixDefault = cubehelix$1;
	exports.interpolateRainbow = rainbow$1;
	exports.interpolateWarm = warm;
	exports.interpolateCool = cool;
	exports.interpolateViridis = viridis;
	exports.interpolateMagma = magma;
	exports.interpolateInferno = inferno;
	exports.interpolatePlasma = plasma;
	exports.scaleSequential = sequential;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-selection/ Version 1.1.0. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var xhtml = "http://www.w3.org/1999/xhtml";
	
	var namespaces = {
	  svg: "http://www.w3.org/2000/svg",
	  xhtml: xhtml,
	  xlink: "http://www.w3.org/1999/xlink",
	  xml: "http://www.w3.org/XML/1998/namespace",
	  xmlns: "http://www.w3.org/2000/xmlns/"
	};
	
	var namespace = function(name) {
	  var prefix = name += "", i = prefix.indexOf(":");
	  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
	  return namespaces.hasOwnProperty(prefix) ? {space: namespaces[prefix], local: name} : name;
	};
	
	function creatorInherit(name) {
	  return function() {
	    var document = this.ownerDocument,
	        uri = this.namespaceURI;
	    return uri === xhtml && document.documentElement.namespaceURI === xhtml
	        ? document.createElement(name)
	        : document.createElementNS(uri, name);
	  };
	}
	
	function creatorFixed(fullname) {
	  return function() {
	    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
	  };
	}
	
	var creator = function(name) {
	  var fullname = namespace(name);
	  return (fullname.local
	      ? creatorFixed
	      : creatorInherit)(fullname);
	};
	
	var nextId = 0;
	
	function local() {
	  return new Local;
	}
	
	function Local() {
	  this._ = "@" + (++nextId).toString(36);
	}
	
	Local.prototype = local.prototype = {
	  constructor: Local,
	  get: function(node) {
	    var id = this._;
	    while (!(id in node)) if (!(node = node.parentNode)) return;
	    return node[id];
	  },
	  set: function(node, value) {
	    return node[this._] = value;
	  },
	  remove: function(node) {
	    return this._ in node && delete node[this._];
	  },
	  toString: function() {
	    return this._;
	  }
	};
	
	var matcher = function(selector) {
	  return function() {
	    return this.matches(selector);
	  };
	};
	
	if (typeof document !== "undefined") {
	  var element = document.documentElement;
	  if (!element.matches) {
	    var vendorMatches = element.webkitMatchesSelector
	        || element.msMatchesSelector
	        || element.mozMatchesSelector
	        || element.oMatchesSelector;
	    matcher = function(selector) {
	      return function() {
	        return vendorMatches.call(this, selector);
	      };
	    };
	  }
	}
	
	var matcher$1 = matcher;
	
	var filterEvents = {};
	
	exports.event = null;
	
	if (typeof document !== "undefined") {
	  var element$1 = document.documentElement;
	  if (!("onmouseenter" in element$1)) {
	    filterEvents = {mouseenter: "mouseover", mouseleave: "mouseout"};
	  }
	}
	
	function filterContextListener(listener, index, group) {
	  listener = contextListener(listener, index, group);
	  return function(event) {
	    var related = event.relatedTarget;
	    if (!related || (related !== this && !(related.compareDocumentPosition(this) & 8))) {
	      listener.call(this, event);
	    }
	  };
	}
	
	function contextListener(listener, index, group) {
	  return function(event1) {
	    var event0 = exports.event; // Events can be reentrant (e.g., focus).
	    exports.event = event1;
	    try {
	      listener.call(this, this.__data__, index, group);
	    } finally {
	      exports.event = event0;
	    }
	  };
	}
	
	function parseTypenames(typenames) {
	  return typenames.trim().split(/^|\s+/).map(function(t) {
	    var name = "", i = t.indexOf(".");
	    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
	    return {type: t, name: name};
	  });
	}
	
	function onRemove(typename) {
	  return function() {
	    var on = this.__on;
	    if (!on) return;
	    for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
	      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
	        this.removeEventListener(o.type, o.listener, o.capture);
	      } else {
	        on[++i] = o;
	      }
	    }
	    if (++i) on.length = i;
	    else delete this.__on;
	  };
	}
	
	function onAdd(typename, value, capture) {
	  var wrap = filterEvents.hasOwnProperty(typename.type) ? filterContextListener : contextListener;
	  return function(d, i, group) {
	    var on = this.__on, o, listener = wrap(value, i, group);
	    if (on) for (var j = 0, m = on.length; j < m; ++j) {
	      if ((o = on[j]).type === typename.type && o.name === typename.name) {
	        this.removeEventListener(o.type, o.listener, o.capture);
	        this.addEventListener(o.type, o.listener = listener, o.capture = capture);
	        o.value = value;
	        return;
	      }
	    }
	    this.addEventListener(typename.type, listener, capture);
	    o = {type: typename.type, name: typename.name, value: value, listener: listener, capture: capture};
	    if (!on) this.__on = [o];
	    else on.push(o);
	  };
	}
	
	var selection_on = function(typename, value, capture) {
	  var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;
	
	  if (arguments.length < 2) {
	    var on = this.node().__on;
	    if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
	      for (i = 0, o = on[j]; i < n; ++i) {
	        if ((t = typenames[i]).type === o.type && t.name === o.name) {
	          return o.value;
	        }
	      }
	    }
	    return;
	  }
	
	  on = value ? onAdd : onRemove;
	  if (capture == null) capture = false;
	  for (i = 0; i < n; ++i) this.each(on(typenames[i], value, capture));
	  return this;
	};
	
	function customEvent(event1, listener, that, args) {
	  var event0 = exports.event;
	  event1.sourceEvent = exports.event;
	  exports.event = event1;
	  try {
	    return listener.apply(that, args);
	  } finally {
	    exports.event = event0;
	  }
	}
	
	var sourceEvent = function() {
	  var current = exports.event, source;
	  while (source = current.sourceEvent) current = source;
	  return current;
	};
	
	var point = function(node, event) {
	  var svg = node.ownerSVGElement || node;
	
	  if (svg.createSVGPoint) {
	    var point = svg.createSVGPoint();
	    point.x = event.clientX, point.y = event.clientY;
	    point = point.matrixTransform(node.getScreenCTM().inverse());
	    return [point.x, point.y];
	  }
	
	  var rect = node.getBoundingClientRect();
	  return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
	};
	
	var mouse = function(node) {
	  var event = sourceEvent();
	  if (event.changedTouches) event = event.changedTouches[0];
	  return point(node, event);
	};
	
	function none() {}
	
	var selector = function(selector) {
	  return selector == null ? none : function() {
	    return this.querySelector(selector);
	  };
	};
	
	var selection_select = function(select) {
	  if (typeof select !== "function") select = selector(select);
	
	  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
	      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
	        if ("__data__" in node) subnode.__data__ = node.__data__;
	        subgroup[i] = subnode;
	      }
	    }
	  }
	
	  return new Selection(subgroups, this._parents);
	};
	
	function empty() {
	  return [];
	}
	
	var selectorAll = function(selector) {
	  return selector == null ? empty : function() {
	    return this.querySelectorAll(selector);
	  };
	};
	
	var selection_selectAll = function(select) {
	  if (typeof select !== "function") select = selectorAll(select);
	
	  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        subgroups.push(select.call(node, node.__data__, i, group));
	        parents.push(node);
	      }
	    }
	  }
	
	  return new Selection(subgroups, parents);
	};
	
	var selection_filter = function(match) {
	  if (typeof match !== "function") match = matcher$1(match);
	
	  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
	      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
	        subgroup.push(node);
	      }
	    }
	  }
	
	  return new Selection(subgroups, this._parents);
	};
	
	var sparse = function(update) {
	  return new Array(update.length);
	};
	
	var selection_enter = function() {
	  return new Selection(this._enter || this._groups.map(sparse), this._parents);
	};
	
	function EnterNode(parent, datum) {
	  this.ownerDocument = parent.ownerDocument;
	  this.namespaceURI = parent.namespaceURI;
	  this._next = null;
	  this._parent = parent;
	  this.__data__ = datum;
	}
	
	EnterNode.prototype = {
	  constructor: EnterNode,
	  appendChild: function(child) { return this._parent.insertBefore(child, this._next); },
	  insertBefore: function(child, next) { return this._parent.insertBefore(child, next); },
	  querySelector: function(selector) { return this._parent.querySelector(selector); },
	  querySelectorAll: function(selector) { return this._parent.querySelectorAll(selector); }
	};
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var keyPrefix = "$"; // Protect against keys like “__proto__”.
	
	function bindIndex(parent, group, enter, update, exit, data) {
	  var i = 0,
	      node,
	      groupLength = group.length,
	      dataLength = data.length;
	
	  // Put any non-null nodes that fit into update.
	  // Put any null nodes into enter.
	  // Put any remaining data into enter.
	  for (; i < dataLength; ++i) {
	    if (node = group[i]) {
	      node.__data__ = data[i];
	      update[i] = node;
	    } else {
	      enter[i] = new EnterNode(parent, data[i]);
	    }
	  }
	
	  // Put any non-null nodes that don’t fit into exit.
	  for (; i < groupLength; ++i) {
	    if (node = group[i]) {
	      exit[i] = node;
	    }
	  }
	}
	
	function bindKey(parent, group, enter, update, exit, data, key) {
	  var i,
	      node,
	      nodeByKeyValue = {},
	      groupLength = group.length,
	      dataLength = data.length,
	      keyValues = new Array(groupLength),
	      keyValue;
	
	  // Compute the key for each node.
	  // If multiple nodes have the same key, the duplicates are added to exit.
	  for (i = 0; i < groupLength; ++i) {
	    if (node = group[i]) {
	      keyValues[i] = keyValue = keyPrefix + key.call(node, node.__data__, i, group);
	      if (keyValue in nodeByKeyValue) {
	        exit[i] = node;
	      } else {
	        nodeByKeyValue[keyValue] = node;
	      }
	    }
	  }
	
	  // Compute the key for each datum.
	  // If there a node associated with this key, join and add it to update.
	  // If there is not (or the key is a duplicate), add it to enter.
	  for (i = 0; i < dataLength; ++i) {
	    keyValue = keyPrefix + key.call(parent, data[i], i, data);
	    if (node = nodeByKeyValue[keyValue]) {
	      update[i] = node;
	      node.__data__ = data[i];
	      nodeByKeyValue[keyValue] = null;
	    } else {
	      enter[i] = new EnterNode(parent, data[i]);
	    }
	  }
	
	  // Add any remaining nodes that were not bound to data to exit.
	  for (i = 0; i < groupLength; ++i) {
	    if ((node = group[i]) && (nodeByKeyValue[keyValues[i]] === node)) {
	      exit[i] = node;
	    }
	  }
	}
	
	var selection_data = function(value, key) {
	  if (!value) {
	    data = new Array(this.size()), j = -1;
	    this.each(function(d) { data[++j] = d; });
	    return data;
	  }
	
	  var bind = key ? bindKey : bindIndex,
	      parents = this._parents,
	      groups = this._groups;
	
	  if (typeof value !== "function") value = constant(value);
	
	  for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
	    var parent = parents[j],
	        group = groups[j],
	        groupLength = group.length,
	        data = value.call(parent, parent && parent.__data__, j, parents),
	        dataLength = data.length,
	        enterGroup = enter[j] = new Array(dataLength),
	        updateGroup = update[j] = new Array(dataLength),
	        exitGroup = exit[j] = new Array(groupLength);
	
	    bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
	
	    // Now connect the enter nodes to their following update node, such that
	    // appendChild can insert the materialized enter node before this node,
	    // rather than at the end of the parent node.
	    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
	      if (previous = enterGroup[i0]) {
	        if (i0 >= i1) i1 = i0 + 1;
	        while (!(next = updateGroup[i1]) && ++i1 < dataLength);
	        previous._next = next || null;
	      }
	    }
	  }
	
	  update = new Selection(update, parents);
	  update._enter = enter;
	  update._exit = exit;
	  return update;
	};
	
	var selection_exit = function() {
	  return new Selection(this._exit || this._groups.map(sparse), this._parents);
	};
	
	var selection_merge = function(selection) {
	
	  for (var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
	    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
	      if (node = group0[i] || group1[i]) {
	        merge[i] = node;
	      }
	    }
	  }
	
	  for (; j < m0; ++j) {
	    merges[j] = groups0[j];
	  }
	
	  return new Selection(merges, this._parents);
	};
	
	var selection_order = function() {
	
	  for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
	    for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
	      if (node = group[i]) {
	        if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
	        next = node;
	      }
	    }
	  }
	
	  return this;
	};
	
	var selection_sort = function(compare) {
	  if (!compare) compare = ascending;
	
	  function compareNode(a, b) {
	    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
	  }
	
	  for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        sortgroup[i] = node;
	      }
	    }
	    sortgroup.sort(compareNode);
	  }
	
	  return new Selection(sortgroups, this._parents).order();
	};
	
	function ascending(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	}
	
	var selection_call = function() {
	  var callback = arguments[0];
	  arguments[0] = this;
	  callback.apply(null, arguments);
	  return this;
	};
	
	var selection_nodes = function() {
	  var nodes = new Array(this.size()), i = -1;
	  this.each(function() { nodes[++i] = this; });
	  return nodes;
	};
	
	var selection_node = function() {
	
	  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
	    for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
	      var node = group[i];
	      if (node) return node;
	    }
	  }
	
	  return null;
	};
	
	var selection_size = function() {
	  var size = 0;
	  this.each(function() { ++size; });
	  return size;
	};
	
	var selection_empty = function() {
	  return !this.node();
	};
	
	var selection_each = function(callback) {
	
	  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
	    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
	      if (node = group[i]) callback.call(node, node.__data__, i, group);
	    }
	  }
	
	  return this;
	};
	
	function attrRemove(name) {
	  return function() {
	    this.removeAttribute(name);
	  };
	}
	
	function attrRemoveNS(fullname) {
	  return function() {
	    this.removeAttributeNS(fullname.space, fullname.local);
	  };
	}
	
	function attrConstant(name, value) {
	  return function() {
	    this.setAttribute(name, value);
	  };
	}
	
	function attrConstantNS(fullname, value) {
	  return function() {
	    this.setAttributeNS(fullname.space, fullname.local, value);
	  };
	}
	
	function attrFunction(name, value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) this.removeAttribute(name);
	    else this.setAttribute(name, v);
	  };
	}
	
	function attrFunctionNS(fullname, value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
	    else this.setAttributeNS(fullname.space, fullname.local, v);
	  };
	}
	
	var selection_attr = function(name, value) {
	  var fullname = namespace(name);
	
	  if (arguments.length < 2) {
	    var node = this.node();
	    return fullname.local
	        ? node.getAttributeNS(fullname.space, fullname.local)
	        : node.getAttribute(fullname);
	  }
	
	  return this.each((value == null
	      ? (fullname.local ? attrRemoveNS : attrRemove) : (typeof value === "function"
	      ? (fullname.local ? attrFunctionNS : attrFunction)
	      : (fullname.local ? attrConstantNS : attrConstant)))(fullname, value));
	};
	
	var defaultView = function(node) {
	  return (node.ownerDocument && node.ownerDocument.defaultView) // node is a Node
	      || (node.document && node) // node is a Window
	      || node.defaultView; // node is a Document
	};
	
	function styleRemove(name) {
	  return function() {
	    this.style.removeProperty(name);
	  };
	}
	
	function styleConstant(name, value, priority) {
	  return function() {
	    this.style.setProperty(name, value, priority);
	  };
	}
	
	function styleFunction(name, value, priority) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) this.style.removeProperty(name);
	    else this.style.setProperty(name, v, priority);
	  };
	}
	
	var selection_style = function(name, value, priority) {
	  return arguments.length > 1
	      ? this.each((value == null
	            ? styleRemove : typeof value === "function"
	            ? styleFunction
	            : styleConstant)(name, value, priority == null ? "" : priority))
	      : styleValue(this.node(), name);
	};
	
	function styleValue(node, name) {
	  return node.style.getPropertyValue(name)
	      || defaultView(node).getComputedStyle(node, null).getPropertyValue(name);
	}
	
	function propertyRemove(name) {
	  return function() {
	    delete this[name];
	  };
	}
	
	function propertyConstant(name, value) {
	  return function() {
	    this[name] = value;
	  };
	}
	
	function propertyFunction(name, value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) delete this[name];
	    else this[name] = v;
	  };
	}
	
	var selection_property = function(name, value) {
	  return arguments.length > 1
	      ? this.each((value == null
	          ? propertyRemove : typeof value === "function"
	          ? propertyFunction
	          : propertyConstant)(name, value))
	      : this.node()[name];
	};
	
	function classArray(string) {
	  return string.trim().split(/^|\s+/);
	}
	
	function classList(node) {
	  return node.classList || new ClassList(node);
	}
	
	function ClassList(node) {
	  this._node = node;
	  this._names = classArray(node.getAttribute("class") || "");
	}
	
	ClassList.prototype = {
	  add: function(name) {
	    var i = this._names.indexOf(name);
	    if (i < 0) {
	      this._names.push(name);
	      this._node.setAttribute("class", this._names.join(" "));
	    }
	  },
	  remove: function(name) {
	    var i = this._names.indexOf(name);
	    if (i >= 0) {
	      this._names.splice(i, 1);
	      this._node.setAttribute("class", this._names.join(" "));
	    }
	  },
	  contains: function(name) {
	    return this._names.indexOf(name) >= 0;
	  }
	};
	
	function classedAdd(node, names) {
	  var list = classList(node), i = -1, n = names.length;
	  while (++i < n) list.add(names[i]);
	}
	
	function classedRemove(node, names) {
	  var list = classList(node), i = -1, n = names.length;
	  while (++i < n) list.remove(names[i]);
	}
	
	function classedTrue(names) {
	  return function() {
	    classedAdd(this, names);
	  };
	}
	
	function classedFalse(names) {
	  return function() {
	    classedRemove(this, names);
	  };
	}
	
	function classedFunction(names, value) {
	  return function() {
	    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
	  };
	}
	
	var selection_classed = function(name, value) {
	  var names = classArray(name + "");
	
	  if (arguments.length < 2) {
	    var list = classList(this.node()), i = -1, n = names.length;
	    while (++i < n) if (!list.contains(names[i])) return false;
	    return true;
	  }
	
	  return this.each((typeof value === "function"
	      ? classedFunction : value
	      ? classedTrue
	      : classedFalse)(names, value));
	};
	
	function textRemove() {
	  this.textContent = "";
	}
	
	function textConstant(value) {
	  return function() {
	    this.textContent = value;
	  };
	}
	
	function textFunction(value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    this.textContent = v == null ? "" : v;
	  };
	}
	
	var selection_text = function(value) {
	  return arguments.length
	      ? this.each(value == null
	          ? textRemove : (typeof value === "function"
	          ? textFunction
	          : textConstant)(value))
	      : this.node().textContent;
	};
	
	function htmlRemove() {
	  this.innerHTML = "";
	}
	
	function htmlConstant(value) {
	  return function() {
	    this.innerHTML = value;
	  };
	}
	
	function htmlFunction(value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    this.innerHTML = v == null ? "" : v;
	  };
	}
	
	var selection_html = function(value) {
	  return arguments.length
	      ? this.each(value == null
	          ? htmlRemove : (typeof value === "function"
	          ? htmlFunction
	          : htmlConstant)(value))
	      : this.node().innerHTML;
	};
	
	function raise() {
	  if (this.nextSibling) this.parentNode.appendChild(this);
	}
	
	var selection_raise = function() {
	  return this.each(raise);
	};
	
	function lower() {
	  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
	}
	
	var selection_lower = function() {
	  return this.each(lower);
	};
	
	var selection_append = function(name) {
	  var create = typeof name === "function" ? name : creator(name);
	  return this.select(function() {
	    return this.appendChild(create.apply(this, arguments));
	  });
	};
	
	function constantNull() {
	  return null;
	}
	
	var selection_insert = function(name, before) {
	  var create = typeof name === "function" ? name : creator(name),
	      select = before == null ? constantNull : typeof before === "function" ? before : selector(before);
	  return this.select(function() {
	    return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
	  });
	};
	
	function remove() {
	  var parent = this.parentNode;
	  if (parent) parent.removeChild(this);
	}
	
	var selection_remove = function() {
	  return this.each(remove);
	};
	
	var selection_datum = function(value) {
	  return arguments.length
	      ? this.property("__data__", value)
	      : this.node().__data__;
	};
	
	function dispatchEvent(node, type, params) {
	  var window = defaultView(node),
	      event = window.CustomEvent;
	
	  if (typeof event === "function") {
	    event = new event(type, params);
	  } else {
	    event = window.document.createEvent("Event");
	    if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
	    else event.initEvent(type, false, false);
	  }
	
	  node.dispatchEvent(event);
	}
	
	function dispatchConstant(type, params) {
	  return function() {
	    return dispatchEvent(this, type, params);
	  };
	}
	
	function dispatchFunction(type, params) {
	  return function() {
	    return dispatchEvent(this, type, params.apply(this, arguments));
	  };
	}
	
	var selection_dispatch = function(type, params) {
	  return this.each((typeof params === "function"
	      ? dispatchFunction
	      : dispatchConstant)(type, params));
	};
	
	var root = [null];
	
	function Selection(groups, parents) {
	  this._groups = groups;
	  this._parents = parents;
	}
	
	function selection() {
	  return new Selection([[document.documentElement]], root);
	}
	
	Selection.prototype = selection.prototype = {
	  constructor: Selection,
	  select: selection_select,
	  selectAll: selection_selectAll,
	  filter: selection_filter,
	  data: selection_data,
	  enter: selection_enter,
	  exit: selection_exit,
	  merge: selection_merge,
	  order: selection_order,
	  sort: selection_sort,
	  call: selection_call,
	  nodes: selection_nodes,
	  node: selection_node,
	  size: selection_size,
	  empty: selection_empty,
	  each: selection_each,
	  attr: selection_attr,
	  style: selection_style,
	  property: selection_property,
	  classed: selection_classed,
	  text: selection_text,
	  html: selection_html,
	  raise: selection_raise,
	  lower: selection_lower,
	  append: selection_append,
	  insert: selection_insert,
	  remove: selection_remove,
	  datum: selection_datum,
	  on: selection_on,
	  dispatch: selection_dispatch
	};
	
	var select = function(selector) {
	  return typeof selector === "string"
	      ? new Selection([[document.querySelector(selector)]], [document.documentElement])
	      : new Selection([[selector]], root);
	};
	
	var selectAll = function(selector) {
	  return typeof selector === "string"
	      ? new Selection([document.querySelectorAll(selector)], [document.documentElement])
	      : new Selection([selector == null ? [] : selector], root);
	};
	
	var touch = function(node, touches, identifier) {
	  if (arguments.length < 3) identifier = touches, touches = sourceEvent().changedTouches;
	
	  for (var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i) {
	    if ((touch = touches[i]).identifier === identifier) {
	      return point(node, touch);
	    }
	  }
	
	  return null;
	};
	
	var touches = function(node, touches) {
	  if (touches == null) touches = sourceEvent().touches;
	
	  for (var i = 0, n = touches ? touches.length : 0, points = new Array(n); i < n; ++i) {
	    points[i] = point(node, touches[i]);
	  }
	
	  return points;
	};
	
	exports.creator = creator;
	exports.local = local;
	exports.matcher = matcher$1;
	exports.mouse = mouse;
	exports.namespace = namespace;
	exports.namespaces = namespaces;
	exports.select = select;
	exports.selectAll = selectAll;
	exports.selection = selection;
	exports.selector = selector;
	exports.selectorAll = selectorAll;
	exports.style = styleValue;
	exports.touch = touch;
	exports.touches = touches;
	exports.window = defaultView;
	exports.customEvent = customEvent;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-shape/ Version 1.1.1. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(35)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-path'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Path) { 'use strict';
	
	var constant = function(x) {
	  return function constant() {
	    return x;
	  };
	};
	
	var abs = Math.abs;
	var atan2 = Math.atan2;
	var cos = Math.cos;
	var max = Math.max;
	var min = Math.min;
	var sin = Math.sin;
	var sqrt = Math.sqrt;
	
	var epsilon = 1e-12;
	var pi = Math.PI;
	var halfPi = pi / 2;
	var tau = 2 * pi;
	
	function acos(x) {
	  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
	}
	
	function asin(x) {
	  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
	}
	
	function arcInnerRadius(d) {
	  return d.innerRadius;
	}
	
	function arcOuterRadius(d) {
	  return d.outerRadius;
	}
	
	function arcStartAngle(d) {
	  return d.startAngle;
	}
	
	function arcEndAngle(d) {
	  return d.endAngle;
	}
	
	function arcPadAngle(d) {
	  return d && d.padAngle; // Note: optional!
	}
	
	function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
	  var x10 = x1 - x0, y10 = y1 - y0,
	      x32 = x3 - x2, y32 = y3 - y2,
	      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
	  return [x0 + t * x10, y0 + t * y10];
	}
	
	// Compute perpendicular offset line of length rc.
	// http://mathworld.wolfram.com/Circle-LineIntersection.html
	function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
	  var x01 = x0 - x1,
	      y01 = y0 - y1,
	      lo = (cw ? rc : -rc) / sqrt(x01 * x01 + y01 * y01),
	      ox = lo * y01,
	      oy = -lo * x01,
	      x11 = x0 + ox,
	      y11 = y0 + oy,
	      x10 = x1 + ox,
	      y10 = y1 + oy,
	      x00 = (x11 + x10) / 2,
	      y00 = (y11 + y10) / 2,
	      dx = x10 - x11,
	      dy = y10 - y11,
	      d2 = dx * dx + dy * dy,
	      r = r1 - rc,
	      D = x11 * y10 - x10 * y11,
	      d = (dy < 0 ? -1 : 1) * sqrt(max(0, r * r * d2 - D * D)),
	      cx0 = (D * dy - dx * d) / d2,
	      cy0 = (-D * dx - dy * d) / d2,
	      cx1 = (D * dy + dx * d) / d2,
	      cy1 = (-D * dx + dy * d) / d2,
	      dx0 = cx0 - x00,
	      dy0 = cy0 - y00,
	      dx1 = cx1 - x00,
	      dy1 = cy1 - y00;
	
	  // Pick the closer of the two intersection points.
	  // TODO Is there a faster way to determine which intersection to use?
	  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	
	  return {
	    cx: cx0,
	    cy: cy0,
	    x01: -ox,
	    y01: -oy,
	    x11: cx0 * (r1 / r - 1),
	    y11: cy0 * (r1 / r - 1)
	  };
	}
	
	var arc = function() {
	  var innerRadius = arcInnerRadius,
	      outerRadius = arcOuterRadius,
	      cornerRadius = constant(0),
	      padRadius = null,
	      startAngle = arcStartAngle,
	      endAngle = arcEndAngle,
	      padAngle = arcPadAngle,
	      context = null;
	
	  function arc() {
	    var buffer,
	        r,
	        r0 = +innerRadius.apply(this, arguments),
	        r1 = +outerRadius.apply(this, arguments),
	        a0 = startAngle.apply(this, arguments) - halfPi,
	        a1 = endAngle.apply(this, arguments) - halfPi,
	        da = abs(a1 - a0),
	        cw = a1 > a0;
	
	    if (!context) context = buffer = d3Path.path();
	
	    // Ensure that the outer radius is always larger than the inner radius.
	    if (r1 < r0) r = r1, r1 = r0, r0 = r;
	
	    // Is it a point?
	    if (!(r1 > epsilon)) context.moveTo(0, 0);
	
	    // Or is it a circle or annulus?
	    else if (da > tau - epsilon) {
	      context.moveTo(r1 * cos(a0), r1 * sin(a0));
	      context.arc(0, 0, r1, a0, a1, !cw);
	      if (r0 > epsilon) {
	        context.moveTo(r0 * cos(a1), r0 * sin(a1));
	        context.arc(0, 0, r0, a1, a0, cw);
	      }
	    }
	
	    // Or is it a circular or annular sector?
	    else {
	      var a01 = a0,
	          a11 = a1,
	          a00 = a0,
	          a10 = a1,
	          da0 = da,
	          da1 = da,
	          ap = padAngle.apply(this, arguments) / 2,
	          rp = (ap > epsilon) && (padRadius ? +padRadius.apply(this, arguments) : sqrt(r0 * r0 + r1 * r1)),
	          rc = min(abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
	          rc0 = rc,
	          rc1 = rc,
	          t0,
	          t1;
	
	      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
	      if (rp > epsilon) {
	        var p0 = asin(rp / r0 * sin(ap)),
	            p1 = asin(rp / r1 * sin(ap));
	        if ((da0 -= p0 * 2) > epsilon) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
	        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
	        if ((da1 -= p1 * 2) > epsilon) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
	        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
	      }
	
	      var x01 = r1 * cos(a01),
	          y01 = r1 * sin(a01),
	          x10 = r0 * cos(a10),
	          y10 = r0 * sin(a10);
	
	      // Apply rounded corners?
	      if (rc > epsilon) {
	        var x11 = r1 * cos(a11),
	            y11 = r1 * sin(a11),
	            x00 = r0 * cos(a00),
	            y00 = r0 * sin(a00);
	
	        // Restrict the corner radius according to the sector angle.
	        if (da < pi) {
	          var oc = da0 > epsilon ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
	              ax = x01 - oc[0],
	              ay = y01 - oc[1],
	              bx = x11 - oc[0],
	              by = y11 - oc[1],
	              kc = 1 / sin(acos((ax * bx + ay * by) / (sqrt(ax * ax + ay * ay) * sqrt(bx * bx + by * by))) / 2),
	              lc = sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = min(rc, (r0 - lc) / (kc - 1));
	          rc1 = min(rc, (r1 - lc) / (kc + 1));
	        }
	      }
	
	      // Is the sector collapsed to a line?
	      if (!(da1 > epsilon)) context.moveTo(x01, y01);
	
	      // Does the sector’s outer ring have rounded corners?
	      else if (rc1 > epsilon) {
	        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
	        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
	
	        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r1, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
	          context.arc(t1.cx, t1.cy, rc1, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the outer ring just a circular arc?
	      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
	
	      // Is there no inner ring, and it’s a circular sector?
	      // Or perhaps it’s an annular sector collapsed due to padding?
	      if (!(r0 > epsilon) || !(da0 > epsilon)) context.lineTo(x10, y10);
	
	      // Does the sector’s inner ring (or point) have rounded corners?
	      else if (rc0 > epsilon) {
	        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
	        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
	
	        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r0, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
	          context.arc(t1.cx, t1.cy, rc0, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the inner ring just a circular arc?
	      else context.arc(0, 0, r0, a10, a00, cw);
	    }
	
	    context.closePath();
	
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  arc.centroid = function() {
	    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
	        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi / 2;
	    return [cos(a) * r, sin(a) * r];
	  };
	
	  arc.innerRadius = function(_) {
	    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant(+_), arc) : innerRadius;
	  };
	
	  arc.outerRadius = function(_) {
	    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant(+_), arc) : outerRadius;
	  };
	
	  arc.cornerRadius = function(_) {
	    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant(+_), arc) : cornerRadius;
	  };
	
	  arc.padRadius = function(_) {
	    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant(+_), arc) : padRadius;
	  };
	
	  arc.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), arc) : startAngle;
	  };
	
	  arc.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), arc) : endAngle;
	  };
	
	  arc.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), arc) : padAngle;
	  };
	
	  arc.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
	  };
	
	  return arc;
	};
	
	function Linear(context) {
	  this._context = context;
	}
	
	Linear.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: this._context.lineTo(x, y); break;
	    }
	  }
	};
	
	var curveLinear = function(context) {
	  return new Linear(context);
	};
	
	function x(p) {
	  return p[0];
	}
	
	function y(p) {
	  return p[1];
	}
	
	var line = function() {
	  var x$$1 = x,
	      y$$1 = y,
	      defined = constant(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function line(data) {
	    var i,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer;
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) output.lineStart();
	        else output.lineEnd();
	      }
	      if (defined0) output.point(+x$$1(d, i, data), +y$$1(d, i, data));
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  line.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant(+_), line) : x$$1;
	  };
	
	  line.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant(+_), line) : y$$1;
	  };
	
	  line.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), line) : defined;
	  };
	
	  line.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
	  };
	
	  line.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
	  };
	
	  return line;
	};
	
	var area = function() {
	  var x0 = x,
	      x1 = null,
	      y0 = constant(0),
	      y1 = y,
	      defined = constant(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function area(data) {
	    var i,
	        j,
	        k,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer,
	        x0z = new Array(n),
	        y0z = new Array(n);
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) {
	          j = i;
	          output.areaStart();
	          output.lineStart();
	        } else {
	          output.lineEnd();
	          output.lineStart();
	          for (k = i - 1; k >= j; --k) {
	            output.point(x0z[k], y0z[k]);
	          }
	          output.lineEnd();
	          output.areaEnd();
	        }
	      }
	      if (defined0) {
	        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
	        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
	      }
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  function arealine() {
	    return line().defined(defined).curve(curve).context(context);
	  }
	
	  area.x = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), x1 = null, area) : x0;
	  };
	
	  area.x0 = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), area) : x0;
	  };
	
	  area.x1 = function(_) {
	    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : x1;
	  };
	
	  area.y = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), y1 = null, area) : y0;
	  };
	
	  area.y0 = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), area) : y0;
	  };
	
	  area.y1 = function(_) {
	    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : y1;
	  };
	
	  area.lineX0 =
	  area.lineY0 = function() {
	    return arealine().x(x0).y(y0);
	  };
	
	  area.lineY1 = function() {
	    return arealine().x(x0).y(y1);
	  };
	
	  area.lineX1 = function() {
	    return arealine().x(x1).y(y0);
	  };
	
	  area.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), area) : defined;
	  };
	
	  area.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
	  };
	
	  area.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
	  };
	
	  return area;
	};
	
	var descending = function(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	};
	
	var identity = function(d) {
	  return d;
	};
	
	var pie = function() {
	  var value = identity,
	      sortValues = descending,
	      sort = null,
	      startAngle = constant(0),
	      endAngle = constant(tau),
	      padAngle = constant(0);
	
	  function pie(data) {
	    var i,
	        n = data.length,
	        j,
	        k,
	        sum = 0,
	        index = new Array(n),
	        arcs = new Array(n),
	        a0 = +startAngle.apply(this, arguments),
	        da = Math.min(tau, Math.max(-tau, endAngle.apply(this, arguments) - a0)),
	        a1,
	        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
	        pa = p * (da < 0 ? -1 : 1),
	        v;
	
	    for (i = 0; i < n; ++i) {
	      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
	        sum += v;
	      }
	    }
	
	    // Optionally sort the arcs by previously-computed values or by data.
	    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
	    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });
	
	    // Compute the arcs! They are stored in the original data's order.
	    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
	      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
	        data: data[j],
	        index: i,
	        value: v,
	        startAngle: a0,
	        endAngle: a1,
	        padAngle: p
	      };
	    }
	
	    return arcs;
	  }
	
	  pie.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), pie) : value;
	  };
	
	  pie.sortValues = function(_) {
	    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
	  };
	
	  pie.sort = function(_) {
	    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
	  };
	
	  pie.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), pie) : startAngle;
	  };
	
	  pie.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), pie) : endAngle;
	  };
	
	  pie.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), pie) : padAngle;
	  };
	
	  return pie;
	};
	
	var curveRadialLinear = curveRadial(curveLinear);
	
	function Radial(curve) {
	  this._curve = curve;
	}
	
	Radial.prototype = {
	  areaStart: function() {
	    this._curve.areaStart();
	  },
	  areaEnd: function() {
	    this._curve.areaEnd();
	  },
	  lineStart: function() {
	    this._curve.lineStart();
	  },
	  lineEnd: function() {
	    this._curve.lineEnd();
	  },
	  point: function(a, r) {
	    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
	  }
	};
	
	function curveRadial(curve) {
	
	  function radial(context) {
	    return new Radial(curve(context));
	  }
	
	  radial._curve = curve;
	
	  return radial;
	}
	
	function radialLine(l) {
	  var c = l.curve;
	
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	
	  l.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return l;
	}
	
	var radialLine$1 = function() {
	  return radialLine(line().curve(curveRadialLinear));
	};
	
	var radialArea = function() {
	  var a = area().curve(curveRadialLinear),
	      c = a.curve,
	      x0 = a.lineX0,
	      x1 = a.lineX1,
	      y0 = a.lineY0,
	      y1 = a.lineY1;
	
	  a.angle = a.x, delete a.x;
	  a.startAngle = a.x0, delete a.x0;
	  a.endAngle = a.x1, delete a.x1;
	  a.radius = a.y, delete a.y;
	  a.innerRadius = a.y0, delete a.y0;
	  a.outerRadius = a.y1, delete a.y1;
	  a.lineStartAngle = function() { return radialLine(x0()); }, delete a.lineX0;
	  a.lineEndAngle = function() { return radialLine(x1()); }, delete a.lineX1;
	  a.lineInnerRadius = function() { return radialLine(y0()); }, delete a.lineY0;
	  a.lineOuterRadius = function() { return radialLine(y1()); }, delete a.lineY1;
	
	  a.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return a;
	};
	
	var slice = Array.prototype.slice;
	
	var radialPoint = function(x, y) {
	  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
	};
	
	function linkSource(d) {
	  return d.source;
	}
	
	function linkTarget(d) {
	  return d.target;
	}
	
	function link(curve) {
	  var source = linkSource,
	      target = linkTarget,
	      x$$1 = x,
	      y$$1 = y,
	      context = null;
	
	  function link() {
	    var buffer, argv = slice.call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
	    if (!context) context = buffer = d3Path.path();
	    curve(context, +x$$1.apply(this, (argv[0] = s, argv)), +y$$1.apply(this, argv), +x$$1.apply(this, (argv[0] = t, argv)), +y$$1.apply(this, argv));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  link.source = function(_) {
	    return arguments.length ? (source = _, link) : source;
	  };
	
	  link.target = function(_) {
	    return arguments.length ? (target = _, link) : target;
	  };
	
	  link.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant(+_), link) : x$$1;
	  };
	
	  link.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant(+_), link) : y$$1;
	  };
	
	  link.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), link) : context;
	  };
	
	  return link;
	}
	
	function curveHorizontal(context, x0, y0, x1, y1) {
	  context.moveTo(x0, y0);
	  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
	}
	
	function curveVertical(context, x0, y0, x1, y1) {
	  context.moveTo(x0, y0);
	  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
	}
	
	function curveRadial$1(context, x0, y0, x1, y1) {
	  var p0 = radialPoint(x0, y0),
	      p1 = radialPoint(x0, y0 = (y0 + y1) / 2),
	      p2 = radialPoint(x1, y0),
	      p3 = radialPoint(x1, y1);
	  context.moveTo(p0[0], p0[1]);
	  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
	}
	
	function linkHorizontal() {
	  return link(curveHorizontal);
	}
	
	function linkVertical() {
	  return link(curveVertical);
	}
	
	function linkRadial() {
	  var l = link(curveRadial$1);
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	  return l;
	}
	
	var circle = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / pi);
	    context.moveTo(r, 0);
	    context.arc(0, 0, r, 0, tau);
	  }
	};
	
	var cross = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / 5) / 2;
	    context.moveTo(-3 * r, -r);
	    context.lineTo(-r, -r);
	    context.lineTo(-r, -3 * r);
	    context.lineTo(r, -3 * r);
	    context.lineTo(r, -r);
	    context.lineTo(3 * r, -r);
	    context.lineTo(3 * r, r);
	    context.lineTo(r, r);
	    context.lineTo(r, 3 * r);
	    context.lineTo(-r, 3 * r);
	    context.lineTo(-r, r);
	    context.lineTo(-3 * r, r);
	    context.closePath();
	  }
	};
	
	var tan30 = Math.sqrt(1 / 3);
	var tan30_2 = tan30 * 2;
	
	var diamond = {
	  draw: function(context, size) {
	    var y = Math.sqrt(size / tan30_2),
	        x = y * tan30;
	    context.moveTo(0, -y);
	    context.lineTo(x, 0);
	    context.lineTo(0, y);
	    context.lineTo(-x, 0);
	    context.closePath();
	  }
	};
	
	var ka = 0.89081309152928522810;
	var kr = Math.sin(pi / 10) / Math.sin(7 * pi / 10);
	var kx = Math.sin(tau / 10) * kr;
	var ky = -Math.cos(tau / 10) * kr;
	
	var star = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size * ka),
	        x = kx * r,
	        y = ky * r;
	    context.moveTo(0, -r);
	    context.lineTo(x, y);
	    for (var i = 1; i < 5; ++i) {
	      var a = tau * i / 5,
	          c = Math.cos(a),
	          s = Math.sin(a);
	      context.lineTo(s * r, -c * r);
	      context.lineTo(c * x - s * y, s * x + c * y);
	    }
	    context.closePath();
	  }
	};
	
	var square = {
	  draw: function(context, size) {
	    var w = Math.sqrt(size),
	        x = -w / 2;
	    context.rect(x, x, w, w);
	  }
	};
	
	var sqrt3 = Math.sqrt(3);
	
	var triangle = {
	  draw: function(context, size) {
	    var y = -Math.sqrt(size / (sqrt3 * 3));
	    context.moveTo(0, y * 2);
	    context.lineTo(-sqrt3 * y, -y);
	    context.lineTo(sqrt3 * y, -y);
	    context.closePath();
	  }
	};
	
	var c = -0.5;
	var s = Math.sqrt(3) / 2;
	var k = 1 / Math.sqrt(12);
	var a = (k / 2 + 1) * 3;
	
	var wye = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / a),
	        x0 = r / 2,
	        y0 = r * k,
	        x1 = x0,
	        y1 = r * k + r,
	        x2 = -x1,
	        y2 = y1;
	    context.moveTo(x0, y0);
	    context.lineTo(x1, y1);
	    context.lineTo(x2, y2);
	    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
	    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
	    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
	    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
	    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
	    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
	    context.closePath();
	  }
	};
	
	var symbols = [
	  circle,
	  cross,
	  diamond,
	  square,
	  star,
	  triangle,
	  wye
	];
	
	var symbol = function() {
	  var type = constant(circle),
	      size = constant(64),
	      context = null;
	
	  function symbol() {
	    var buffer;
	    if (!context) context = buffer = d3Path.path();
	    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  symbol.type = function(_) {
	    return arguments.length ? (type = typeof _ === "function" ? _ : constant(_), symbol) : type;
	  };
	
	  symbol.size = function(_) {
	    return arguments.length ? (size = typeof _ === "function" ? _ : constant(+_), symbol) : size;
	  };
	
	  symbol.context = function(_) {
	    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
	  };
	
	  return symbol;
	};
	
	var noop = function() {};
	
	function point(that, x, y) {
	  that._context.bezierCurveTo(
	    (2 * that._x0 + that._x1) / 3,
	    (2 * that._y0 + that._y1) / 3,
	    (that._x0 + 2 * that._x1) / 3,
	    (that._y0 + 2 * that._y1) / 3,
	    (that._x0 + 4 * that._x1 + x) / 6,
	    (that._y0 + 4 * that._y1 + y) / 6
	  );
	}
	
	function Basis(context) {
	  this._context = context;
	}
	
	Basis.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 3: point(this, this._x1, this._y1); // proceed
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basis = function(context) {
	  return new Basis(context);
	};
	
	function BasisClosed(context) {
	  this._context = context;
	}
	
	BasisClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x2, this._y2);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
	        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x2, this._y2);
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
	      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
	      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basisClosed = function(context) {
	  return new BasisClosed(context);
	};
	
	function BasisOpen(context) {
	  this._context = context;
	}
	
	BasisOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
	      case 3: this._point = 4; // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basisOpen = function(context) {
	  return new BasisOpen(context);
	};
	
	function Bundle(context, beta) {
	  this._basis = new Basis(context);
	  this._beta = beta;
	}
	
	Bundle.prototype = {
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	    this._basis.lineStart();
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        j = x.length - 1;
	
	    if (j > 0) {
	      var x0 = x[0],
	          y0 = y[0],
	          dx = x[j] - x0,
	          dy = y[j] - y0,
	          i = -1,
	          t;
	
	      while (++i <= j) {
	        t = i / j;
	        this._basis.point(
	          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
	          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
	        );
	      }
	    }
	
	    this._x = this._y = null;
	    this._basis.lineEnd();
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	var bundle = ((function custom(beta) {
	
	  function bundle(context) {
	    return beta === 1 ? new Basis(context) : new Bundle(context, beta);
	  }
	
	  bundle.beta = function(beta) {
	    return custom(+beta);
	  };
	
	  return bundle;
	}))(0.85);
	
	function point$1(that, x, y) {
	  that._context.bezierCurveTo(
	    that._x1 + that._k * (that._x2 - that._x0),
	    that._y1 + that._k * (that._y2 - that._y0),
	    that._x2 + that._k * (that._x1 - x),
	    that._y2 + that._k * (that._y1 - y),
	    that._x2,
	    that._y2
	  );
	}
	
	function Cardinal(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	Cardinal.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: point$1(this, this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
	      case 2: this._point = 3; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinal = ((function custom(tension) {
	
	  function cardinal(context) {
	    return new Cardinal(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	}))(0);
	
	function CardinalClosed(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalClosed = ((function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalClosed(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	}))(0);
	
	function CardinalOpen(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalOpen = ((function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalOpen(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	}))(0);
	
	function point$2(that, x, y) {
	  var x1 = that._x1,
	      y1 = that._y1,
	      x2 = that._x2,
	      y2 = that._y2;
	
	  if (that._l01_a > epsilon) {
	    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
	        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
	    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
	    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
	  }
	
	  if (that._l23_a > epsilon) {
	    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
	        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
	    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
	    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
	  }
	
	  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
	}
	
	function CatmullRom(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRom.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: this.point(this._x2, this._y2); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRom = ((function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	}))(0.5);
	
	function CatmullRomClosed(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomClosed = ((function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	}))(0.5);
	
	function CatmullRomOpen(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomOpen = ((function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	}))(0.5);
	
	function LinearClosed(context) {
	  this._context = context;
	}
	
	LinearClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._point) this._context.closePath();
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    if (this._point) this._context.lineTo(x, y);
	    else this._point = 1, this._context.moveTo(x, y);
	  }
	};
	
	var linearClosed = function(context) {
	  return new LinearClosed(context);
	};
	
	function sign(x) {
	  return x < 0 ? -1 : 1;
	}
	
	// Calculate the slopes of the tangents (Hermite-type interpolation) based on
	// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
	// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
	// NOV(II), P. 443, 1990.
	function slope3(that, x2, y2) {
	  var h0 = that._x1 - that._x0,
	      h1 = x2 - that._x1,
	      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
	      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
	      p = (s0 * h1 + s1 * h0) / (h0 + h1);
	  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
	}
	
	// Calculate a one-sided slope.
	function slope2(that, t) {
	  var h = that._x1 - that._x0;
	  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
	}
	
	// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
	// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
	// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
	function point$3(that, t0, t1) {
	  var x0 = that._x0,
	      y0 = that._y0,
	      x1 = that._x1,
	      y1 = that._y1,
	      dx = (x1 - x0) / 3;
	  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
	}
	
	function MonotoneX(context) {
	  this._context = context;
	}
	
	MonotoneX.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 =
	    this._t0 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	      case 3: point$3(this, this._t0, slope2(this, this._t0)); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    var t1 = NaN;
	
	    x = +x, y = +y;
	    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; point$3(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
	      default: point$3(this, this._t0, t1 = slope3(this, x, y)); break;
	    }
	
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	    this._t0 = t1;
	  }
	};
	
	function MonotoneY(context) {
	  this._context = new ReflectContext(context);
	}
	
	(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
	  MonotoneX.prototype.point.call(this, y, x);
	};
	
	function ReflectContext(context) {
	  this._context = context;
	}
	
	ReflectContext.prototype = {
	  moveTo: function(x, y) { this._context.moveTo(y, x); },
	  closePath: function() { this._context.closePath(); },
	  lineTo: function(x, y) { this._context.lineTo(y, x); },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
	};
	
	function monotoneX(context) {
	  return new MonotoneX(context);
	}
	
	function monotoneY(context) {
	  return new MonotoneY(context);
	}
	
	function Natural(context) {
	  this._context = context;
	}
	
	Natural.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        n = x.length;
	
	    if (n) {
	      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
	      if (n === 2) {
	        this._context.lineTo(x[1], y[1]);
	      } else {
	        var px = controlPoints(x),
	            py = controlPoints(y);
	        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
	          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
	        }
	      }
	    }
	
	    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	    this._x = this._y = null;
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
	function controlPoints(x) {
	  var i,
	      n = x.length - 1,
	      m,
	      a = new Array(n),
	      b = new Array(n),
	      r = new Array(n);
	  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
	  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
	  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
	  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
	  a[n - 1] = r[n - 1] / b[n - 1];
	  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
	  b[n - 1] = (x[n] + a[n - 1]) / 2;
	  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
	  return [a, b];
	}
	
	var natural = function(context) {
	  return new Natural(context);
	};
	
	function Step(context, t) {
	  this._context = context;
	  this._t = t;
	}
	
	Step.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = this._y = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: {
	        if (this._t <= 0) {
	          this._context.lineTo(this._x, y);
	          this._context.lineTo(x, y);
	        } else {
	          var x1 = this._x * (1 - this._t) + x * this._t;
	          this._context.lineTo(x1, this._y);
	          this._context.lineTo(x1, y);
	        }
	        break;
	      }
	    }
	    this._x = x, this._y = y;
	  }
	};
	
	var step = function(context) {
	  return new Step(context, 0.5);
	};
	
	function stepBefore(context) {
	  return new Step(context, 0);
	}
	
	function stepAfter(context) {
	  return new Step(context, 1);
	}
	
	var none = function(series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
	    s0 = s1, s1 = series[order[i]];
	    for (j = 0; j < m; ++j) {
	      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
	    }
	  }
	};
	
	var none$1 = function(series) {
	  var n = series.length, o = new Array(n);
	  while (--n >= 0) o[n] = n;
	  return o;
	};
	
	function stackValue(d, key) {
	  return d[key];
	}
	
	var stack = function() {
	  var keys = constant([]),
	      order = none$1,
	      offset = none,
	      value = stackValue;
	
	  function stack(data) {
	    var kz = keys.apply(this, arguments),
	        i,
	        m = data.length,
	        n = kz.length,
	        sz = new Array(n),
	        oz;
	
	    for (i = 0; i < n; ++i) {
	      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
	        si[j] = sij = [0, +value(data[j], ki, j, data)];
	        sij.data = data[j];
	      }
	      si.key = ki;
	    }
	
	    for (i = 0, oz = order(sz); i < n; ++i) {
	      sz[oz[i]].index = i;
	    }
	
	    offset(sz, oz);
	    return sz;
	  }
	
	  stack.keys = function(_) {
	    return arguments.length ? (keys = typeof _ === "function" ? _ : constant(slice.call(_)), stack) : keys;
	  };
	
	  stack.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), stack) : value;
	  };
	
	  stack.order = function(_) {
	    return arguments.length ? (order = _ == null ? none$1 : typeof _ === "function" ? _ : constant(slice.call(_)), stack) : order;
	  };
	
	  stack.offset = function(_) {
	    return arguments.length ? (offset = _ == null ? none : _, stack) : offset;
	  };
	
	  return stack;
	};
	
	var expand = function(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
	    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
	    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
	  }
	  none(series, order);
	};
	
	var diverging = function(series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
	    for (yp = yn = 0, i = 0; i < n; ++i) {
	      if ((dy = (d = series[order[i]][j])[1] - d[0]) >= 0) {
	        d[0] = yp, d[1] = yp += dy;
	      } else if (dy < 0) {
	        d[1] = yn, d[0] = yn += dy;
	      } else {
	        d[0] = yp;
	      }
	    }
	  }
	};
	
	var silhouette = function(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
	    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
	    s0[j][1] += s0[j][0] = -y / 2;
	  }
	  none(series, order);
	};
	
	var wiggle = function(series, order) {
	  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
	  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
	    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
	      var si = series[order[i]],
	          sij0 = si[j][1] || 0,
	          sij1 = si[j - 1][1] || 0,
	          s3 = (sij0 - sij1) / 2;
	      for (var k = 0; k < i; ++k) {
	        var sk = series[order[k]],
	            skj0 = sk[j][1] || 0,
	            skj1 = sk[j - 1][1] || 0;
	        s3 += skj0 - skj1;
	      }
	      s1 += sij0, s2 += s3 * sij0;
	    }
	    s0[j - 1][1] += s0[j - 1][0] = y;
	    if (s1) y -= s2 / s1;
	  }
	  s0[j - 1][1] += s0[j - 1][0] = y;
	  none(series, order);
	};
	
	var ascending = function(series) {
	  var sums = series.map(sum);
	  return none$1(series).sort(function(a, b) { return sums[a] - sums[b]; });
	};
	
	function sum(series) {
	  var s = 0, i = -1, n = series.length, v;
	  while (++i < n) if (v = +series[i][1]) s += v;
	  return s;
	}
	
	var descending$1 = function(series) {
	  return ascending(series).reverse();
	};
	
	var insideOut = function(series) {
	  var n = series.length,
	      i,
	      j,
	      sums = series.map(sum),
	      order = none$1(series).sort(function(a, b) { return sums[b] - sums[a]; }),
	      top = 0,
	      bottom = 0,
	      tops = [],
	      bottoms = [];
	
	  for (i = 0; i < n; ++i) {
	    j = order[i];
	    if (top < bottom) {
	      top += sums[j];
	      tops.push(j);
	    } else {
	      bottom += sums[j];
	      bottoms.push(j);
	    }
	  }
	
	  return bottoms.reverse().concat(tops);
	};
	
	var reverse = function(series) {
	  return none$1(series).reverse();
	};
	
	exports.arc = arc;
	exports.area = area;
	exports.line = line;
	exports.pie = pie;
	exports.radialArea = radialArea;
	exports.radialLine = radialLine$1;
	exports.linkHorizontal = linkHorizontal;
	exports.linkVertical = linkVertical;
	exports.linkRadial = linkRadial;
	exports.symbol = symbol;
	exports.symbols = symbols;
	exports.symbolCircle = circle;
	exports.symbolCross = cross;
	exports.symbolDiamond = diamond;
	exports.symbolSquare = square;
	exports.symbolStar = star;
	exports.symbolTriangle = triangle;
	exports.symbolWye = wye;
	exports.curveBasisClosed = basisClosed;
	exports.curveBasisOpen = basisOpen;
	exports.curveBasis = basis;
	exports.curveBundle = bundle;
	exports.curveCardinalClosed = cardinalClosed;
	exports.curveCardinalOpen = cardinalOpen;
	exports.curveCardinal = cardinal;
	exports.curveCatmullRomClosed = catmullRomClosed;
	exports.curveCatmullRomOpen = catmullRomOpen;
	exports.curveCatmullRom = catmullRom;
	exports.curveLinearClosed = linearClosed;
	exports.curveLinear = curveLinear;
	exports.curveMonotoneX = monotoneX;
	exports.curveMonotoneY = monotoneY;
	exports.curveNatural = natural;
	exports.curveStep = step;
	exports.curveStepAfter = stepAfter;
	exports.curveStepBefore = stepBefore;
	exports.stack = stack;
	exports.stackOffsetExpand = expand;
	exports.stackOffsetDiverging = diverging;
	exports.stackOffsetNone = none;
	exports.stackOffsetSilhouette = silhouette;
	exports.stackOffsetWiggle = wiggle;
	exports.stackOrderAscending = ascending;
	exports.stackOrderDescending = descending$1;
	exports.stackOrderInsideOut = insideOut;
	exports.stackOrderNone = none$1;
	exports.stackOrderReverse = reverse;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 40 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 41 */
/***/ (function(module, exports) {

	module.exports = {
		"elementSelector": "[data-riot-mount=\"ddjnrw-app\"]",
		"containerClass": "measurement-viz__container",
		"infobox": {
			"cssClass": "measurement-viz__infobox",
			"width": 300,
			"position": {
				"top": 10,
				"left": 10
			}
		},
		"mainChart": {
			"width": 700,
			"itemHeight": 25,
			"nItems": 25,
			"margin": {
				"top": 20,
				"right": 20,
				"bottom": 20,
				"left": 120
			}
		},
		"breakpoints": {
			"small": 600,
			"medium": 768,
			"large": 1280
		}
	};

/***/ }),
/* 42 */
/***/ (function(module, exports) {

	module.exports = {
		"10200411": [
			[
				"2000-02-02",
				3.54
			],
			[
				"2001-07-18",
				7.09
			],
			[
				"2002-05-29",
				4.43
			],
			[
				"2003-08-14",
				8.86
			],
			[
				"2004-01-15",
				10.63
			],
			[
				"2005-06-28",
				6.64
			],
			[
				"2006-03-13",
				7.09
			],
			[
				"2007-02-14",
				5.98
			],
			[
				"2008-07-10",
				7.79
			],
			[
				"2013-06-24",
				8.41
			],
			[
				"2014-06-12",
				12.09
			],
			[
				"2015-03-19",
				5.93
			],
			[
				"2010-04-12",
				5.4
			],
			[
				"2011-12-09",
				9.7
			],
			[
				"2012-06-22",
				10.76
			]
		],
		"10200691": [
			[
				"2000-02-23",
				27.46
			],
			[
				"2001-03-13",
				54.91
			],
			[
				"2002-05-02",
				56.24
			],
			[
				"2003-04-10",
				31.44
			],
			[
				"2004-01-08",
				59.79
			],
			[
				"2005-06-28",
				53.14
			],
			[
				"2006-02-24",
				45.17
			],
			[
				"2007-01-04",
				41.89
			],
			[
				"2008-07-08",
				41.23
			],
			[
				"2013-06-10",
				81.49
			],
			[
				"2014-04-09",
				77.5
			],
			[
				"2015-04-23",
				110.27
			],
			[
				"2010-06-11",
				62.44
			],
			[
				"2011-11-14",
				79.71
			],
			[
				"2012-11-16",
				63.77
			]
		],
		"10200710": [
			[
				"2000-05-24",
				0.44
			],
			[
				"2001-07-23",
				0.44
			],
			[
				"2002-06-17",
				0.44
			],
			[
				"2004-04-28",
				0.44
			],
			[
				"2005-07-11",
				0.44
			],
			[
				"2006-10-27",
				0.84
			],
			[
				"2008-03-27",
				0.44
			],
			[
				"2013-09-16",
				1.33
			],
			[
				"2014-08-14",
				0.13
			],
			[
				"2015-05-13",
				1.33
			],
			[
				"2010-12-10",
				0.13
			],
			[
				"2011-02-14",
				0.13
			],
			[
				"2012-04-20",
				0.13
			]
		],
		"10201026": [
			[
				"2000-02-23",
				22.59
			],
			[
				"2001-03-13",
				8.41
			],
			[
				"2002-03-08",
				10.63
			],
			[
				"2003-04-02",
				10.19
			],
			[
				"2004-01-07",
				13.29
			],
			[
				"2005-04-01",
				19.49
			],
			[
				"2006-02-22",
				21.7
			],
			[
				"2007-02-13",
				19.88
			],
			[
				"2008-03-26",
				10.63
			],
			[
				"2013-09-27",
				11.51
			],
			[
				"2014-03-10",
				7.17
			],
			[
				"2015-05-06",
				20.64
			],
			[
				"2009-07-20",
				12.71
			],
			[
				"2011-01-31",
				14.97
			],
			[
				"2012-11-16",
				11.03
			]
		],
		"10201117": [
			[
				"2000-02-29",
				53.14
			],
			[
				"2001-08-08",
				54.47
			],
			[
				"2002-03-08",
				54.47
			],
			[
				"2003-12-11",
				58.01
			],
			[
				"2004-01-21",
				57.13
			],
			[
				"2005-07-15",
				61.11
			],
			[
				"2006-03-13",
				63.33
			],
			[
				"2007-01-03",
				67.76
			],
			[
				"2008-03-26",
				62.44
			],
			[
				"2010-09-07",
				61.22
			],
			[
				"2011-05-05",
				54.22
			],
			[
				"2012-10-08",
				61.82
			],
			[
				"2013-04-29",
				60.72
			],
			[
				"2014-11-26",
				64.02
			],
			[
				"2015-05-11",
				66.02
			],
			[
				"2013-06-10",
				62
			],
			[
				"2014-06-12",
				61.56
			],
			[
				"2015-03-19",
				65.54
			],
			[
				"2009-07-20",
				60.23
			],
			[
				"2011-01-31",
				56.24
			],
			[
				"2012-06-22",
				60.23
			]
		],
		"10201282": [
			[
				"2000-08-07",
				22.94
			],
			[
				"2001-04-26",
				19.04
			],
			[
				"2002-09-24",
				35.87
			],
			[
				"2003-08-18",
				46.94
			],
			[
				"2004-01-23",
				52.26
			],
			[
				"2005-07-06",
				37.64
			],
			[
				"2007-01-10",
				32.15
			],
			[
				"2013-04-15",
				51.37
			],
			[
				"2014-03-10",
				57.13
			],
			[
				"2015-05-13",
				47.39
			],
			[
				"2016-03-17",
				66.43
			],
			[
				"2006-03-23",
				31.44
			],
			[
				"2008-07-15",
				7.93
			],
			[
				"2009-05-15",
				35.52
			],
			[
				"2011-01-28",
				81.93
			],
			[
				"2012-03-30",
				69.97
			]
		],
		"10201312": [
			[
				"2000-11-03",
				75.29
			],
			[
				"2001-07-23",
				81.93
			],
			[
				"2002-09-25",
				119.57
			],
			[
				"2003-03-27",
				54.03
			],
			[
				"2004-03-05",
				11.96
			],
			[
				"2005-07-11",
				25.24
			],
			[
				"2007-01-10",
				50.49
			],
			[
				"2013-06-28",
				102.3
			],
			[
				"2013-08-09",
				107.17
			],
			[
				"2014-02-03",
				94.77
			],
			[
				"2015-03-16",
				67.31
			],
			[
				"2006-03-22",
				84.59
			],
			[
				"2008-07-14",
				89.01
			],
			[
				"2009-11-06",
				74.84
			],
			[
				"2011-01-28",
				58.01
			],
			[
				"2012-03-19",
				82.37
			]
		],
		"10201415": [
			[
				"2001-10-16",
				84.63
			],
			[
				"2001-04-10",
				88.53
			],
			[
				"2002-04-16",
				89.93
			],
			[
				"2002-10-15",
				87.23
			],
			[
				"2000-10-17",
				75.33
			],
			[
				"2000-04-12",
				78.23
			],
			[
				"2004-10-19",
				77.53
			],
			[
				"2004-04-06",
				18.31
			],
			[
				"2005-04-11",
				77.53
			],
			[
				"2005-10-26",
				67.72
			],
			[
				"2006-04-04",
				72.23
			],
			[
				"2006-11-07",
				68.22
			],
			[
				"2007-10-22",
				56.72
			],
			[
				"2010-10-11",
				73.07
			],
			[
				"2011-04-26",
				74.4
			],
			[
				"2011-10-10",
				75.73
			],
			[
				"2012-04-24",
				76.61
			],
			[
				"2012-10-22",
				77.06
			],
			[
				"2013-04-08",
				77.94
			],
			[
				"2013-10-28",
				79.27
			],
			[
				"2014-04-14",
				80.16
			],
			[
				"2014-10-29",
				79.71
			],
			[
				"2015-04-07",
				79.71
			],
			[
				"2015-10-06",
				77.06
			],
			[
				"2013-04-15",
				77.06
			],
			[
				"2014-03-27",
				81.93
			],
			[
				"2008-04-14",
				72.23
			],
			[
				"2010-07-02",
				73.07
			],
			[
				"2011-02-14",
				35.38
			],
			[
				"2012-04-20",
				76.17
			]
		],
		"10201518": [
			[
				"2000-05-25",
				65.54
			],
			[
				"2001-04-23",
				46.94
			],
			[
				"2002-06-19",
				46.94
			],
			[
				"2003-11-24",
				63.77
			],
			[
				"2005-03-21",
				65.54
			],
			[
				"2004-03-16",
				77.06
			],
			[
				"2006-02-16",
				80.6
			],
			[
				"2007-02-26",
				33.75
			],
			[
				"2008-07-07",
				43.18
			],
			[
				"2013-09-09",
				66.43
			],
			[
				"2014-05-08",
				72.63
			],
			[
				"2015-10-15",
				73.96
			],
			[
				"2009-11-06",
				34.32
			],
			[
				"2011-10-10",
				23.47
			],
			[
				"2012-06-18",
				86.36
			]
		],
		"10201531": [
			[
				"2005-05-19",
				86.36
			],
			[
				"2000-01-14",
				49.12
			],
			[
				"2001-03-13",
				53.62
			],
			[
				"2001-09-20",
				59.82
			],
			[
				"2002-02-25",
				68.62
			],
			[
				"2002-09-09",
				66.02
			],
			[
				"2003-05-13",
				64.62
			],
			[
				"2003-09-25",
				70.42
			],
			[
				"2004-02-26",
				71.33
			],
			[
				"2004-10-04",
				76.63
			],
			[
				"2005-04-25",
				75.33
			],
			[
				"2006-02-14",
				79.73
			],
			[
				"2006-08-31",
				90.34
			],
			[
				"2006-07-24",
				86.33
			],
			[
				"2007-01-10",
				91.23
			],
			[
				"2007-02-02",
				90.33
			],
			[
				"2008-07-15",
				98.76
			],
			[
				"2013-04-15",
				115.14
			],
			[
				"2013-08-28",
				137.29
			],
			[
				"2014-02-24",
				115.14
			],
			[
				"2015-03-16",
				15.19
			],
			[
				"2007-10-01",
				91.63
			],
			[
				"2008-06-23",
				87.23
			],
			[
				"2010-01-29",
				105.4
			],
			[
				"2010-03-19",
				112.49
			],
			[
				"2011-04-01",
				118.24
			],
			[
				"2012-06-01",
				108.5
			]
		],
		"10202201": [
			[
				"2014-08-18",
				19.62
			],
			[
				"2015-05-20",
				27.68
			],
			[
				"2012-11-09",
				22.41
			]
		],
		"10202330": [
			[
				"2010-09-07",
				6
			],
			[
				"2011-05-05",
				56.42
			],
			[
				"2012-10-08",
				13.1
			],
			[
				"2013-04-29",
				26.01
			],
			[
				"2014-11-26",
				40.01
			],
			[
				"2015-10-05",
				1
			]
		],
		"10202341": [
			[
				"2010-09-07",
				31.71
			],
			[
				"2011-05-05",
				25.51
			],
			[
				"2012-10-08",
				15.51
			],
			[
				"2013-04-29",
				62.62
			],
			[
				"2014-11-26",
				0.5
			],
			[
				"2015-05-11",
				38.01
			]
		],
		"10202663": [
			[
				"2010-09-07",
				69.42
			],
			[
				"2011-05-05",
				66.92
			],
			[
				"2012-10-08",
				68.12
			],
			[
				"2013-04-29",
				67.42
			],
			[
				"2014-11-26",
				45.02
			],
			[
				"2015-05-11",
				61.02
			]
		],
		"10202675": [
			[
				"2010-09-07",
				28.81
			],
			[
				"2011-05-05",
				30.21
			],
			[
				"2012-10-08",
				33.41
			],
			[
				"2013-04-29",
				30.21
			],
			[
				"2014-11-26",
				38.01
			],
			[
				"2015-05-11",
				35.01
			]
		],
		"10202791": [
			[
				"2000-02-28",
				77.5
			],
			[
				"2001-04-20",
				89.46
			],
			[
				"2002-06-19",
				122.67
			],
			[
				"2003-03-21",
				102.3
			],
			[
				"2004-01-26",
				100.97
			],
			[
				"2005-05-17",
				104.07
			],
			[
				"2007-02-26",
				107.17
			],
			[
				"2008-07-07",
				87.24
			],
			[
				"2013-08-30",
				101.86
			],
			[
				"2014-03-17",
				102.74
			],
			[
				"2015-03-12",
				89.01
			],
			[
				"2016-02-29",
				84.14
			],
			[
				"2006-03-30",
				116.91
			],
			[
				"2009-07-27",
				81.49
			],
			[
				"2011-05-23",
				94.33
			],
			[
				"2012-04-23",
				96.54
			],
			[
				"2013-03-01",
				103.63
			]
		],
		"10202808": [
			[
				"2000-02-28",
				30.56
			],
			[
				"2001-04-20",
				30.56
			],
			[
				"2002-10-07",
				28.79
			],
			[
				"2003-03-21",
				32.33
			],
			[
				"2004-01-21",
				26.13
			],
			[
				"2005-03-22",
				20.81
			],
			[
				"2005-09-26",
				22.14
			],
			[
				"2007-02-13",
				20.02
			],
			[
				"2008-07-01",
				26.08
			],
			[
				"2013-08-26",
				34.99
			],
			[
				"2014-02-24",
				33.75
			],
			[
				"2014-07-04",
				35.12
			],
			[
				"2015-06-10",
				35.03
			],
			[
				"2006-03-30",
				21.26
			],
			[
				"2009-03-20",
				28.48
			],
			[
				"2011-01-17",
				30.11
			],
			[
				"2012-01-23",
				36.45
			],
			[
				"2012-03-30",
				35.16
			],
			[
				"2013-03-01",
				34.99
			]
		],
		"10202810": [
			[
				"2000-10-31",
				117.36
			],
			[
				"2001-08-03",
				111.16
			],
			[
				"2002-10-08",
				142.6
			],
			[
				"2003-11-07",
				117.8
			],
			[
				"2004-06-16",
				126.66
			],
			[
				"2005-07-12",
				148.36
			],
			[
				"2006-10-27",
				116.47
			],
			[
				"2008-07-01",
				116.03
			],
			[
				"2014-03-24",
				165.63
			],
			[
				"2015-04-09",
				176.26
			],
			[
				"2009-05-25",
				78.83
			],
			[
				"2011-04-15",
				92.11
			],
			[
				"2012-04-23",
				88.13
			],
			[
				"2013-03-11",
				122.23
			]
		],
		"10202821": [
			[
				"2000-05-24",
				92.56
			],
			[
				"2002-06-17",
				105.4
			],
			[
				"2003-04-01",
				83.7
			],
			[
				"2004-03-05",
				93
			],
			[
				"2005-05-17",
				79.27
			],
			[
				"2006-11-07",
				100.97
			],
			[
				"2007-06-18",
				105.4
			],
			[
				"2008-03-27",
				107.61
			],
			[
				"2013-06-28",
				134.19
			],
			[
				"2013-08-09",
				146.14
			],
			[
				"2014-02-03",
				141.27
			],
			[
				"2015-03-26",
				80.6
			],
			[
				"2016-03-17",
				101.86
			],
			[
				"2006-03-22",
				81.49
			],
			[
				"2009-03-16",
				123.11
			],
			[
				"2011-01-14",
				131.53
			],
			[
				"2012-03-05",
				170.06
			]
		],
		"10203187": [
			[
				"2000-06-27",
				67.76
			],
			[
				"2001-08-03",
				58.01
			],
			[
				"2002-06-19",
				64.21
			],
			[
				"2003-05-06",
				65.99
			],
			[
				"2004-05-24",
				58.46
			],
			[
				"2005-05-17",
				64.66
			],
			[
				"2006-10-05",
				71.3
			],
			[
				"2007-01-15",
				65.54
			],
			[
				"2008-10-15",
				54.03
			],
			[
				"2013-04-22",
				59.79
			],
			[
				"2014-03-17",
				60.23
			],
			[
				"2015-03-12",
				58.46
			],
			[
				"2009-08-17",
				49.16
			],
			[
				"2011-11-07",
				53.59
			]
		],
		"10203199": [
			[
				"2000-06-26",
				60.67
			],
			[
				"2001-08-03",
				57.13
			],
			[
				"2002-10-07",
				49.16
			],
			[
				"2003-05-06",
				50.49
			],
			[
				"2004-05-24",
				53.59
			],
			[
				"2005-07-05",
				57.13
			],
			[
				"2005-09-21",
				57.57
			],
			[
				"2006-03-30",
				54.47
			],
			[
				"2007-01-03",
				51.37
			],
			[
				"2008-07-01",
				52.7
			],
			[
				"2014-02-26",
				40.34
			],
			[
				"2015-03-12",
				45.61
			],
			[
				"2009-05-25",
				64.21
			],
			[
				"2011-01-17",
				46.5
			],
			[
				"2012-10-26",
				41.54
			],
			[
				"2013-03-11",
				41.81
			]
		],
		"10203217": [
			[
				"2000-02-21",
				36.31
			],
			[
				"2001-04-27",
				36.31
			],
			[
				"2002-05-02",
				41.19
			],
			[
				"2003-04-01",
				39.86
			],
			[
				"2004-01-22",
				41.63
			],
			[
				"2005-06-16",
				38.53
			],
			[
				"2006-03-16",
				36.76
			],
			[
				"2007-01-04",
				41.63
			],
			[
				"2008-07-04",
				39.59
			],
			[
				"2011-12-12",
				35.47
			],
			[
				"2013-07-12",
				38.71
			],
			[
				"2014-08-12",
				35.74
			],
			[
				"2015-06-15",
				37.86
			],
			[
				"2005-12-02",
				36.91
			],
			[
				"2006-12-14",
				36.91
			],
			[
				"2007-02-02",
				36.01
			],
			[
				"2007-09-20",
				42.92
			],
			[
				"2008-07-11",
				36.41
			],
			[
				"2008-09-24",
				38.51
			],
			[
				"2009-05-05",
				39.71
			],
			[
				"2010-06-07",
				37.29
			],
			[
				"2011-02-04",
				38.48
			],
			[
				"2012-05-07",
				37.95
			],
			[
				"2012-09-10",
				39.28
			]
		],
		"10203230": [
			[
				"2000-02-03",
				52.26
			],
			[
				"2001-03-15",
				70.41
			],
			[
				"2002-03-21",
				82.81
			],
			[
				"2003-03-28",
				82.37
			],
			[
				"2004-01-16",
				49.16
			],
			[
				"2005-03-29",
				76.17
			],
			[
				"2006-02-21",
				23.03
			],
			[
				"2007-01-02",
				38.31
			],
			[
				"2008-06-04",
				81.04
			],
			[
				"2008-07-11",
				82.81
			],
			[
				"2010-04-12",
				77.94
			],
			[
				"2012-10-17",
				44.73
			],
			[
				"2013-08-27",
				79.71
			],
			[
				"2014-05-22",
				42.51
			],
			[
				"2015-06-15",
				77.5
			],
			[
				"2010-02-18",
				56.69
			],
			[
				"2011-02-04",
				72.19
			]
		],
		"10203254": [
			[
				"2000-02-24",
				62.44
			],
			[
				"2001-03-20",
				59.79
			],
			[
				"2002-03-13",
				62.44
			],
			[
				"2003-03-25",
				62
			],
			[
				"2004-01-09",
				60.23
			],
			[
				"2005-03-30",
				60.67
			],
			[
				"2006-02-22",
				62
			],
			[
				"2007-03-07",
				62.89
			],
			[
				"2008-07-03",
				65.1
			],
			[
				"2011-06-22",
				61.11
			],
			[
				"2012-05-25",
				61.55
			],
			[
				"2013-05-13",
				63.77
			],
			[
				"2014-05-14",
				59.34
			],
			[
				"2015-05-11",
				61.55
			],
			[
				"2013-07-12",
				61.56
			],
			[
				"2014-05-22",
				59.79
			],
			[
				"2015-08-10",
				58.01
			],
			[
				"2010-03-09",
				58.45
			],
			[
				"2010-06-07",
				61.11
			],
			[
				"2011-03-11",
				60.67
			],
			[
				"2012-05-07",
				61.11
			],
			[
				"2012-09-10",
				55.36
			]
		],
		"10203266": [
			[
				"2000-02-24",
				24.36
			],
			[
				"2001-03-20",
				16.83
			],
			[
				"2002-03-13",
				29.23
			],
			[
				"2003-03-25",
				17.71
			],
			[
				"2004-01-09",
				25.24
			],
			[
				"2005-03-30",
				26.13
			],
			[
				"2006-02-22",
				22.59
			],
			[
				"2007-01-17",
				20.46
			],
			[
				"2007-05-08",
				20.59
			],
			[
				"2008-02-07",
				27.24
			],
			[
				"2011-06-22",
				24.05
			],
			[
				"2014-05-14",
				29.45
			],
			[
				"2014-05-14",
				29.45
			],
			[
				"2015-05-11",
				29.14
			],
			[
				"2010-03-09",
				30.47
			]
		],
		"10203436": [
			[
				"2001-03-14",
				52.26
			],
			[
				"2002-05-24",
				56.24
			],
			[
				"2003-02-26",
				53.14
			],
			[
				"2004-01-08",
				61.11
			],
			[
				"2005-06-21",
				59.79
			],
			[
				"2008-09-29",
				63.77
			],
			[
				"2013-12-17",
				62.44
			],
			[
				"2014-09-30",
				69.97
			],
			[
				"2015-04-23",
				62.44
			],
			[
				"2006-03-20",
				63.77
			],
			[
				"2010-09-13",
				56.24
			],
			[
				"2011-02-18",
				56.24
			],
			[
				"2012-09-17",
				59.79
			]
		],
		"10203588": [
			[
				"2000-12-18",
				23.91
			],
			[
				"2001-09-12",
				23.91
			],
			[
				"2002-11-05",
				23.47
			],
			[
				"2003-02-25",
				23.91
			],
			[
				"2004-05-17",
				23.91
			],
			[
				"2005-07-11",
				26.57
			],
			[
				"2007-02-21",
				25.29
			],
			[
				"2008-07-02",
				10.81
			],
			[
				"2013-06-07",
				9.39
			],
			[
				"2014-08-14",
				9.3
			],
			[
				"2015-06-10",
				8.19
			],
			[
				"2010-10-01",
				9.48
			],
			[
				"2011-04-01",
				7.93
			],
			[
				"2012-12-03",
				9.39
			]
		],
		"10203862": [
			[
				"2013-04-22",
				115.59
			],
			[
				"2014-03-24",
				95.66
			],
			[
				"2015-04-09",
				114.7
			],
			[
				"2010-07-02",
				65.54
			],
			[
				"2011-05-23",
				93.89
			],
			[
				"2012-12-03",
				111.6
			]
		],
		"10204003": [
			[
				"2010-09-07",
				25.31
			],
			[
				"2011-05-05",
				18.91
			],
			[
				"2013-04-29",
				14
			],
			[
				"2014-11-26",
				4.2
			],
			[
				"2015-05-11",
				11
			]
		],
		"10205561": [
			[
				"2000-11-30",
				0.89
			],
			[
				"2001-06-28",
				0.44
			],
			[
				"2002-11-06",
				0.44
			],
			[
				"2004-06-15",
				0.44
			],
			[
				"2005-07-08",
				0.44
			],
			[
				"2006-08-07",
				0.44
			],
			[
				"2007-02-21",
				0.44
			],
			[
				"2008-07-14",
				0.44
			],
			[
				"2013-09-16",
				1.33
			],
			[
				"2014-03-27",
				1.33
			],
			[
				"2015-03-16",
				0.4
			],
			[
				"2009-03-27",
				1.33
			],
			[
				"2011-04-01",
				0.13
			],
			[
				"2012-12-03",
				0.13
			]
		],
		"10300570": [
			[
				"2000-11-23",
				16.83
			],
			[
				"2001-06-08",
				12.4
			],
			[
				"2003-11-06",
				10.19
			],
			[
				"2004-05-25",
				9.74
			],
			[
				"2005-07-20",
				8.41
			],
			[
				"2006-10-05",
				8.41
			],
			[
				"2007-02-13",
				10.63
			],
			[
				"2008-03-26",
				13.42
			],
			[
				"2014-03-06",
				7.13
			],
			[
				"2015-03-23",
				6.78
			],
			[
				"2009-03-20",
				9.79
			],
			[
				"2011-01-21",
				10.27
			],
			[
				"2012-04-27",
				7.71
			],
			[
				"2012-10-26",
				7.31
			],
			[
				"2013-03-15",
				7
			]
		],
		"10301574": [
			[
				"2000-06-26",
				28.34
			],
			[
				"2001-04-20",
				28.79
			],
			[
				"2002-09-26",
				32.33
			],
			[
				"2003-11-04",
				32.33
			],
			[
				"2004-01-26",
				34.99
			],
			[
				"2005-07-28",
				32.77
			],
			[
				"2007-01-03",
				31
			],
			[
				"2013-06-05",
				27.01
			],
			[
				"2014-03-06",
				27.68
			],
			[
				"2015-03-23",
				25.51
			],
			[
				"2006-03-29",
				33.66
			],
			[
				"2008-07-09",
				28.43
			],
			[
				"2009-07-27",
				28.83
			],
			[
				"2011-11-07",
				29.1
			],
			[
				"2012-04-27",
				28.83
			],
			[
				"2012-11-19",
				27.01
			]
		],
		"10303650": [
			[
				"2003-11-10",
				0.89
			],
			[
				"2002-07-24",
				2.21
			],
			[
				"2002-07-30",
				1.11
			],
			[
				"2007-11-08",
				4.38
			],
			[
				"2013-09-20",
				6.6
			],
			[
				"2014-08-27",
				21.35
			],
			[
				"2015-06-01",
				7
			],
			[
				"2010-08-30",
				9.57
			],
			[
				"2011-11-07",
				5.31
			],
			[
				"2012-11-19",
				8.15
			]
		],
		"10306237": [
			[
				"2004-07-23",
				43.84
			],
			[
				"2004-10-28",
				48.71
			],
			[
				"2005-04-06",
				44.29
			],
			[
				"2006-03-31",
				36.31
			],
			[
				"2006-10-25",
				1
			],
			[
				"2007-04-03",
				41.19
			],
			[
				"2007-06-18",
				42.47
			],
			[
				"2007-10-23",
				41.19
			],
			[
				"2013-06-07",
				33.66
			],
			[
				"2014-03-27",
				34.94
			],
			[
				"2015-05-11",
				38.66
			],
			[
				"2008-04-02",
				33.21
			],
			[
				"2008-10-31",
				37.64
			],
			[
				"2009-03-31",
				36.31
			],
			[
				"2009-10-30",
				42.96
			],
			[
				"2010-03-30",
				36.31
			],
			[
				"2010-10-20",
				38.97
			],
			[
				"2011-04-05",
				30.11
			],
			[
				"2011-10-04",
				38.97
			],
			[
				"2012-03-29",
				30.56
			],
			[
				"2012-10-29",
				34.1
			],
			[
				"2013-03-26",
				31.89
			],
			[
				"2013-10-28",
				32.33
			],
			[
				"2014-03-27",
				31.89
			],
			[
				"2014-10-29",
				32.33
			],
			[
				"2015-03-11",
				34.1
			],
			[
				"2015-10-26",
				38.53
			],
			[
				"2008-07-21",
				39.95
			],
			[
				"2011-01-14",
				26.31
			],
			[
				"2012-11-09",
				36.36
			]
		],
		"10307217": [
			[
				"2000-05-24",
				73.13
			],
			[
				"2001-05-16",
				95.73
			],
			[
				"2006-05-09",
				13
			],
			[
				"2007-01-08",
				42.47
			],
			[
				"2013-09-23",
				110.27
			],
			[
				"2014-04-07",
				87.24
			],
			[
				"2015-04-15",
				77.06
			],
			[
				"2010-06-28",
				12.71
			],
			[
				"2011-11-02",
				31
			]
		],
		"10307229": [
			[
				"2000-05-24",
				24.21
			],
			[
				"2001-05-16",
				24.71
			],
			[
				"2006-05-09",
				17.31
			],
			[
				"2008-09-16",
				8.1
			],
			[
				"2013-09-23",
				23.91
			],
			[
				"2014-04-07",
				11.87
			],
			[
				"2015-04-15",
				18.82
			],
			[
				"2010-06-28",
				27.63
			],
			[
				"2011-11-02",
				14.97
			]
		],
		"10403048": [
			[
				"2000-05-25",
				60.67
			],
			[
				"2001-06-25",
				56.69
			],
			[
				"2002-08-16",
				52.7
			],
			[
				"2003-08-20",
				50.04
			],
			[
				"2004-03-16",
				52.7
			],
			[
				"2005-07-07",
				48.71
			],
			[
				"2006-05-12",
				50.93
			],
			[
				"2007-10-11",
				51.37
			],
			[
				"2008-03-27",
				53.14
			],
			[
				"2013-04-29",
				68.64
			],
			[
				"2015-10-15",
				5.85
			],
			[
				"2009-03-16",
				66.43
			],
			[
				"2011-02-14",
				60.23
			],
			[
				"2012-06-25",
				65.1
			]
		],
		"10403127": [
			[
				"2001-06-25",
				14.17
			],
			[
				"2003-08-20",
				40.74
			],
			[
				"2003-11-03",
				31.89
			],
			[
				"2004-02-10",
				45.61
			],
			[
				"2005-07-12",
				51.37
			],
			[
				"2006-01-13",
				33.41
			],
			[
				"2006-08-29",
				33.21
			],
			[
				"2007-02-26",
				32.55
			],
			[
				"2007-01-30",
				39.31
			],
			[
				"2007-07-30",
				47.82
			],
			[
				"2008-07-21",
				61.11
			],
			[
				"2012-03-07",
				33.43
			],
			[
				"2014-04-28",
				38.57
			],
			[
				"2015-06-01",
				82.81
			],
			[
				"2008-06-19",
				50.02
			],
			[
				"2008-11-04",
				51.42
			],
			[
				"2009-04-08",
				39.41
			],
			[
				"2012-06-04",
				34.76
			]
		],
		"10403474": [
			[
				"2000-05-31",
				48.32
			],
			[
				"2000-07-31",
				46.02
			],
			[
				"2000-10-11",
				46.42
			],
			[
				"2000-12-28",
				45.42
			],
			[
				"2003-12-10",
				47.42
			],
			[
				"2004-03-02",
				50.22
			],
			[
				"2004-07-01",
				43.22
			],
			[
				"2004-12-15",
				49.52
			],
			[
				"2004-09-29",
				47.32
			],
			[
				"2003-08-27",
				48.22
			],
			[
				"2005-10-21",
				2.25
			],
			[
				"2005-09-14",
				1.18
			],
			[
				"2005-07-12",
				1.22
			],
			[
				"2006-08-22",
				49.22
			],
			[
				"2006-05-09",
				51.82
			],
			[
				"2006-11-28",
				55.42
			],
			[
				"2007-05-14",
				58.9
			],
			[
				"2014-04-28",
				1.33
			],
			[
				"2015-03-09",
				44.06
			],
			[
				"2008-02-19",
				39.01
			],
			[
				"2008-05-06",
				54.32
			],
			[
				"2008-08-12",
				47.42
			],
			[
				"2008-11-11",
				54.92
			],
			[
				"2011-08-24",
				56.32
			],
			[
				"2011-05-10",
				61.12
			],
			[
				"2011-02-08",
				55.02
			],
			[
				"2010-11-10",
				58.52
			],
			[
				"2010-08-18",
				58.42
			],
			[
				"2010-05-18",
				56.32
			],
			[
				"2010-02-10",
				60.22
			],
			[
				"2009-11-16",
				43.92
			],
			[
				"2009-05-12",
				53.62
			],
			[
				"2009-03-02",
				37.21
			],
			[
				"2012-02-13",
				57.12
			],
			[
				"2012-05-09",
				55.02
			],
			[
				"2012-08-29",
				58.02
			],
			[
				"2014-06-03",
				20.81
			],
			[
				"2014-08-20",
				56.72
			],
			[
				"2014-11-05",
				42.31
			],
			[
				"2008-09-08",
				55.8
			],
			[
				"2009-08-10",
				52.7
			],
			[
				"2011-10-10",
				48.27
			]
		],
		"10403528": [
			[
				"2000-07-31",
				21.71
			],
			[
				"2004-07-01",
				20.51
			],
			[
				"2006-05-08",
				22.19
			],
			[
				"2008-09-08",
				23.21
			],
			[
				"2014-04-28",
				20.42
			],
			[
				"2013-05-24",
				19.4
			],
			[
				"2015-03-09",
				20.19
			],
			[
				"2009-08-10",
				20.59
			],
			[
				"2011-10-10",
				20.81
			],
			[
				"2012-06-25",
				19.97
			]
		],
		"10403590": [
			[
				"2000-03-08",
				29.71
			],
			[
				"2000-07-17",
				29.11
			],
			[
				"2000-11-22",
				27.71
			],
			[
				"2002-04-09",
				30.51
			],
			[
				"2001-04-30",
				29.01
			],
			[
				"2001-07-03",
				29.11
			],
			[
				"2001-11-19",
				29.71
			],
			[
				"2002-04-15",
				29.23
			],
			[
				"2003-04-24",
				30.21
			],
			[
				"2003-07-16",
				28.71
			],
			[
				"2004-04-27",
				30.71
			],
			[
				"2004-07-13",
				29.81
			],
			[
				"2004-11-23",
				32.91
			],
			[
				"2005-11-07",
				33.61
			],
			[
				"2005-04-27",
				31.61
			],
			[
				"2005-07-26",
				35.11
			],
			[
				"2006-05-08",
				31.13
			],
			[
				"2006-04-11",
				29.61
			],
			[
				"2006-07-10",
				31.11
			],
			[
				"2006-11-21",
				31.01
			],
			[
				"2007-04-23",
				30.31
			],
			[
				"2007-07-10",
				30.41
			],
			[
				"2007-11-19",
				28.41
			],
			[
				"2008-07-14",
				32.11
			],
			[
				"2008-11-20",
				31.11
			],
			[
				"2010-11-15",
				29.09
			],
			[
				"2011-04-18",
				30.6
			],
			[
				"2011-07-18",
				30.78
			],
			[
				"2011-11-22",
				33.17
			],
			[
				"2012-04-03",
				32.24
			],
			[
				"2012-07-17",
				33.96
			],
			[
				"2012-11-26",
				29.85
			],
			[
				"2013-04-02",
				30.29
			],
			[
				"2013-07-15",
				32.15
			],
			[
				"2013-11-18",
				31.88
			],
			[
				"2014-05-05",
				31.71
			],
			[
				"2014-07-21",
				32.86
			],
			[
				"2014-12-15",
				30.91
			],
			[
				"2015-04-21",
				31.44
			],
			[
				"2015-07-28",
				33.21
			],
			[
				"2015-11-24",
				31.13
			],
			[
				"2008-04-28",
				30.71
			],
			[
				"2009-04-27",
				29.11
			],
			[
				"2009-07-01",
				28.91
			],
			[
				"2009-11-24",
				29.51
			],
			[
				"2010-04-27",
				29.61
			],
			[
				"2010-07-26",
				32.24
			],
			[
				"2007-04-23",
				32.42
			]
		],
		"10403814": [
			[
				"2000-11-14",
				8.41
			],
			[
				"2000-10-26",
				8.9
			],
			[
				"2000-04-17",
				7.7
			],
			[
				"2001-12-27",
				9.3
			],
			[
				"2001-03-28",
				8.5
			],
			[
				"2002-04-02",
				7.6
			],
			[
				"2002-12-02",
				9.1
			],
			[
				"2003-04-30",
				10.4
			],
			[
				"2004-10-26",
				7.97
			],
			[
				"2004-04-27",
				9.3
			],
			[
				"2006-04-06",
				7.5
			],
			[
				"2006-05-22",
				9.21
			],
			[
				"2009-03-24",
				8.41
			],
			[
				"2010-12-15",
				7.7
			],
			[
				"2011-03-28",
				11.2
			],
			[
				"2011-11-23",
				6.6
			],
			[
				"2013-04-02",
				8.2
			],
			[
				"2013-11-27",
				7.9
			],
			[
				"2014-12-03",
				7.75
			],
			[
				"2015-09-17",
				7.97
			],
			[
				"2007-12-07",
				5.9
			],
			[
				"2008-03-18",
				9.5
			],
			[
				"2012-03-26",
				7.6
			],
			[
				"2000-11-14",
				8.41
			],
			[
				"2001-12-27",
				9.3
			],
			[
				"2004-10-26",
				7.97
			],
			[
				"2007-10-08",
				8.59
			],
			[
				"2008-10-20",
				9.12
			],
			[
				"2010-09-17",
				7.48
			]
		],
		"10403978": [
			[
				"2000-04-27",
				31.01
			],
			[
				"2000-11-13",
				30.51
			],
			[
				"2001-04-23",
				31.51
			],
			[
				"2001-11-13",
				33.21
			],
			[
				"2002-03-06",
				33.81
			],
			[
				"2002-10-16",
				32.77
			],
			[
				"2002-11-19",
				33.31
			],
			[
				"2003-03-12",
				30.61
			],
			[
				"2003-11-26",
				32.01
			],
			[
				"2005-03-08",
				35.11
			],
			[
				"2005-11-09",
				32.31
			],
			[
				"2006-03-15",
				32.21
			],
			[
				"2006-05-15",
				34.45
			],
			[
				"2006-11-20",
				33.61
			],
			[
				"2004-03-03",
				20.91
			],
			[
				"2004-11-09",
				36.61
			],
			[
				"2007-03-13",
				34.91
			],
			[
				"2007-11-21",
				16.51
			],
			[
				"2008-11-18",
				35.91
			],
			[
				"2010-11-22",
				34.63
			],
			[
				"2011-03-23",
				32.81
			],
			[
				"2012-03-05",
				33.12
			],
			[
				"2012-11-13",
				30.69
			],
			[
				"2013-03-05",
				32.28
			],
			[
				"2013-11-13",
				19.84
			],
			[
				"2014-04-08",
				32.1
			],
			[
				"2014-12-01",
				28.78
			],
			[
				"2015-03-18",
				27.46
			],
			[
				"2015-11-17",
				30.91
			],
			[
				"2008-03-05",
				34.41
			],
			[
				"2009-03-18",
				34.81
			],
			[
				"2009-11-23",
				33.41
			],
			[
				"2010-03-09",
				34.81
			]
		],
		"10404338": [
			[
				"2000-10-02",
				3.3
			],
			[
				"2000-05-15",
				3.7
			],
			[
				"2001-05-21",
				3.6
			],
			[
				"2001-10-10",
				4
			],
			[
				"2002-06-10",
				3.8
			],
			[
				"2002-10-16",
				3.2
			],
			[
				"2003-05-14",
				3
			],
			[
				"2003-10-15",
				3.1
			],
			[
				"2005-05-12",
				2.8
			],
			[
				"2006-05-24",
				3.3
			],
			[
				"2007-05-23",
				4.1
			],
			[
				"2004-05-19",
				2.8
			],
			[
				"2004-09-27",
				2.9
			],
			[
				"2006-10-16",
				3.2
			],
			[
				"2007-10-17",
				2.9
			],
			[
				"2008-10-22",
				3.4
			],
			[
				"2010-11-10",
				3.5
			],
			[
				"2011-05-11",
				3.45
			],
			[
				"2011-10-26",
				3.67
			],
			[
				"2012-05-09",
				2.92
			],
			[
				"2012-10-08",
				3.63
			],
			[
				"2013-10-15",
				3.72
			],
			[
				"2014-05-14",
				3.72
			],
			[
				"2014-10-15",
				3.14
			],
			[
				"2015-06-17",
				3.28
			],
			[
				"2015-10-27",
				3.59
			],
			[
				"2008-05-14",
				16.21
			],
			[
				"2009-05-13",
				4.9
			],
			[
				"2009-10-21",
				3.3
			],
			[
				"2010-06-09",
				3.14
			]
		],
		"10404491": [
			[
				"2000-03-27",
				0.5
			],
			[
				"2000-12-04",
				0.5
			],
			[
				"2001-03-12",
				1
			],
			[
				"2001-06-25",
				0.89
			],
			[
				"2001-09-24",
				1
			],
			[
				"2001-12-10",
				1
			],
			[
				"2002-03-11",
				1
			],
			[
				"2002-06-17",
				1
			],
			[
				"2002-09-16",
				1
			],
			[
				"2002-12-02",
				2
			],
			[
				"2003-03-10",
				2
			],
			[
				"2003-04-07",
				2
			],
			[
				"2003-05-05",
				2
			],
			[
				"2004-01-12",
				2
			],
			[
				"2004-02-02",
				2
			],
			[
				"2004-05-10",
				2
			],
			[
				"2004-09-06",
				2
			],
			[
				"2004-10-04",
				0.3
			],
			[
				"2004-12-13",
				2
			],
			[
				"2005-03-07",
				2
			],
			[
				"2005-06-20",
				2
			],
			[
				"2005-09-12",
				0.5
			],
			[
				"2005-11-21",
				0.5
			],
			[
				"2005-12-12",
				0.5
			],
			[
				"2006-09-26",
				0.5
			],
			[
				"2010-02-09",
				0.5
			],
			[
				"2010-05-17",
				0.5
			],
			[
				"2010-10-11",
				0.5
			],
			[
				"2010-11-02",
				0.5
			],
			[
				"2011-05-16",
				0.4
			],
			[
				"2011-09-12",
				0.5
			],
			[
				"2011-11-14",
				0.5
			],
			[
				"2012-02-13",
				0.5
			],
			[
				"2012-05-21",
				0.5
			],
			[
				"2012-09-17",
				0.5
			],
			[
				"2012-11-12",
				0.5
			],
			[
				"2013-02-18",
				0.5
			],
			[
				"2013-05-13",
				0.65
			],
			[
				"2013-09-16",
				0.2
			],
			[
				"2014-02-10",
				0.5
			],
			[
				"2014-05-12",
				0.5
			],
			[
				"2014-09-15",
				0.5
			],
			[
				"2014-11-10",
				0.5
			],
			[
				"2015-05-18",
				0.5
			],
			[
				"2015-09-14",
				2.7
			],
			[
				"2015-12-14",
				0.5
			],
			[
				"2007-10-15",
				0.18
			],
			[
				"2008-08-04",
				0.5
			],
			[
				"2008-09-08",
				0.5
			],
			[
				"2008-11-03",
				0.5
			],
			[
				"2009-02-02",
				0.5
			],
			[
				"2009-05-11",
				0.5
			],
			[
				"2009-09-14",
				0.5
			],
			[
				"2009-11-09",
				0.5
			],
			[
				"2008-09-23",
				0.44
			]
		],
		"10406426": [
			[
				"2006-07-05",
				13.46
			],
			[
				"2007-01-31",
				7.7
			],
			[
				"2007-07-26",
				9
			],
			[
				"2008-10-08",
				4.12
			],
			[
				"2011-01-13",
				14.62
			],
			[
				"2013-08-20",
				9.3
			],
			[
				"2014-10-06",
				9.25
			],
			[
				"2015-08-17",
				7.39
			],
			[
				"2013-09-27",
				8.86
			],
			[
				"2014-08-13",
				8.06
			],
			[
				"2015-05-06",
				9.48
			],
			[
				"2008-05-26",
				15.31
			],
			[
				"2008-10-08",
				11.6
			],
			[
				"2009-04-14",
				10.8
			],
			[
				"2009-07-24",
				11.74
			],
			[
				"2011-11-25",
				7.93
			],
			[
				"2012-12-14",
				6.51
			]
		],
		"10407121": [
			[
				"2000-11-09",
				76.63
			],
			[
				"2001-11-15",
				69.72
			],
			[
				"2001-04-03",
				70.63
			],
			[
				"2003-11-05",
				75.73
			],
			[
				"2002-03-27",
				76.23
			],
			[
				"2002-11-20",
				73.13
			],
			[
				"2003-11-20",
				67.82
			],
			[
				"2003-04-02",
				73.33
			],
			[
				"2004-04-28",
				69.72
			],
			[
				"2004-12-02",
				68.12
			],
			[
				"2005-04-21",
				73.03
			],
			[
				"2005-11-14",
				71.23
			],
			[
				"2006-10-09",
				77.06
			],
			[
				"2006-04-11",
				72.03
			],
			[
				"2006-11-22",
				71.33
			],
			[
				"2007-05-14",
				76.17
			],
			[
				"2007-04-05",
				62.62
			],
			[
				"2010-06-02",
				93.23
			],
			[
				"2010-11-10",
				79.43
			],
			[
				"2011-09-28",
				76.73
			],
			[
				"2011-05-05",
				74.23
			],
			[
				"2012-10-08",
				83.33
			],
			[
				"2012-05-14",
				74.03
			],
			[
				"2013-04-29",
				75.73
			],
			[
				"2013-10-15",
				79.63
			],
			[
				"2015-10-05",
				75.03
			],
			[
				"2015-05-11",
				70.02
			],
			[
				"2007-11-08",
				76.13
			],
			[
				"2008-04-16",
				73.53
			],
			[
				"2008-11-17",
				76.83
			],
			[
				"2009-04-20",
				78.03
			],
			[
				"2009-11-04",
				65.32
			],
			[
				"2008-10-08",
				63.77
			]
		],
		"10407194": [
			[
				"2006-10-18",
				7.04
			],
			[
				"2007-04-27",
				8.24
			],
			[
				"2008-01-11",
				13.55
			],
			[
				"2013-10-16",
				7.09
			],
			[
				"2014-07-31",
				7.62
			],
			[
				"2015-10-13",
				7.09
			],
			[
				"2009-12-07",
				5.89
			]
		],
		"10407200": [
			[
				"2000-09-27",
				8
			],
			[
				"2000-04-04",
				10.3
			],
			[
				"2007-03-22",
				7.35
			],
			[
				"2008-01-11",
				6.2
			],
			[
				"2013-10-16",
				5.76
			],
			[
				"2014-07-31",
				1.33
			],
			[
				"2015-10-13",
				5.27
			],
			[
				"2006-11-29",
				7.22
			],
			[
				"2010-10-25",
				5.67
			],
			[
				"2011-11-24",
				5.85
			]
		],
		"10407212": [
			[
				"2000-09-27",
				13
			],
			[
				"2000-04-04",
				12.3
			],
			[
				"2002-04-15",
				13
			],
			[
				"2001-12-11",
				12
			],
			[
				"2001-04-10",
				12
			],
			[
				"2002-12-11",
				11
			],
			[
				"2003-06-24",
				5.2
			],
			[
				"2004-12-14",
				12
			],
			[
				"2004-06-01",
				12
			],
			[
				"2005-12-15",
				11.3
			],
			[
				"2005-03-15",
				12
			],
			[
				"2007-03-22",
				14.84
			],
			[
				"2006-12-12",
				11.7
			],
			[
				"2006-06-19",
				13
			],
			[
				"2008-01-11",
				16.87
			],
			[
				"2010-12-20",
				13.9
			],
			[
				"2010-06-01",
				14.61
			],
			[
				"2011-12-01",
				13.1
			],
			[
				"2011-06-16",
				14
			],
			[
				"2012-12-13",
				13
			],
			[
				"2012-05-31",
				12.8
			],
			[
				"2013-12-10",
				14.41
			],
			[
				"2013-06-25",
				13.4
			],
			[
				"2014-12-16",
				10
			],
			[
				"2014-06-24",
				14
			],
			[
				"2015-12-14",
				12.3
			],
			[
				"2015-06-18",
				13
			],
			[
				"2008-07-21",
				16.11
			],
			[
				"2007-12-17",
				14.91
			],
			[
				"2007-05-23",
				13.7
			],
			[
				"2008-12-22",
				11.8
			],
			[
				"2009-06-16",
				14.81
			],
			[
				"2009-12-15",
				12.3
			],
			[
				"2006-11-29",
				12.27
			]
		],
		"10407297": [
			[
				"2000-05-08",
				24.01
			],
			[
				"2001-07-17",
				20.81
			],
			[
				"2000-10-11",
				21.21
			],
			[
				"2001-06-25",
				21.91
			],
			[
				"2001-10-29",
				21.31
			],
			[
				"2002-05-07",
				22.71
			],
			[
				"2002-10-21",
				21.31
			],
			[
				"2003-05-13",
				21.21
			],
			[
				"2003-10-22",
				20.31
			],
			[
				"2004-10-27",
				21.51
			],
			[
				"2004-10-12",
				20.81
			],
			[
				"2004-05-26",
				19.31
			],
			[
				"2005-05-09",
				21.01
			],
			[
				"2005-10-04",
				20.91
			],
			[
				"2006-05-10",
				20.91
			],
			[
				"2006-10-30",
				21.01
			],
			[
				"2007-05-07",
				19.31
			],
			[
				"2007-10-29",
				19.71
			],
			[
				"2008-10-14",
				20.51
			],
			[
				"2010-10-25",
				20.42
			],
			[
				"2011-05-03",
				20.55
			],
			[
				"2011-10-24",
				19.66
			],
			[
				"2012-05-08",
				19.09
			],
			[
				"2012-10-10",
				17.89
			],
			[
				"2013-10-08",
				17.67
			],
			[
				"2014-05-12",
				18.12
			],
			[
				"2014-10-27",
				18.2
			],
			[
				"2015-07-01",
				18.96
			],
			[
				"2015-10-14",
				18.78
			],
			[
				"2014-12-04",
				18.69
			],
			[
				"2008-05-07",
				21.91
			],
			[
				"2009-05-11",
				20.31
			],
			[
				"2009-10-27",
				19.31
			],
			[
				"2010-05-18",
				19.31
			],
			[
				"2007-10-16",
				21.43
			],
			[
				"2008-09-25",
				24
			],
			[
				"2011-05-26",
				20.9
			],
			[
				"2011-10-07",
				20.28
			]
		],
		"10407339": [
			[
				"2000-08-30",
				9.3
			],
			[
				"2000-03-27",
				11.2
			],
			[
				"2000-11-20",
				11.2
			],
			[
				"2002-07-18",
				7.97
			],
			[
				"2002-11-04",
				7.97
			],
			[
				"2001-03-12",
				11.21
			],
			[
				"2001-05-07",
				13.11
			],
			[
				"2001-09-24",
				8.31
			],
			[
				"2001-11-19",
				8.71
			],
			[
				"2002-03-11",
				9.41
			],
			[
				"2002-06-17",
				11.11
			],
			[
				"2002-08-19",
				8.11
			],
			[
				"2002-09-16",
				10.61
			],
			[
				"2002-10-14",
				9.51
			],
			[
				"2002-11-18",
				10.21
			],
			[
				"2002-12-02",
				6.9
			],
			[
				"2003-01-13",
				6.7
			],
			[
				"2003-02-10",
				21.82
			],
			[
				"2003-03-10",
				11.21
			],
			[
				"2003-04-07",
				7.71
			],
			[
				"2003-05-05",
				6.51
			],
			[
				"2003-06-23",
				6.4
			],
			[
				"2003-09-08",
				6.2
			],
			[
				"2003-10-06",
				6.2
			],
			[
				"2003-11-03",
				4.9
			],
			[
				"2003-12-01",
				5.2
			],
			[
				"2003-08-11",
				7.01
			],
			[
				"2003-05-14",
				7.09
			],
			[
				"2004-10-11",
				4.87
			],
			[
				"2004-01-12",
				4.9
			],
			[
				"2004-02-02",
				6
			],
			[
				"2004-03-08",
				4.6
			],
			[
				"2004-04-19",
				5.5
			],
			[
				"2004-05-10",
				4.9
			],
			[
				"2004-06-14",
				5.5
			],
			[
				"2004-07-12",
				5
			],
			[
				"2004-08-09",
				4.8
			],
			[
				"2004-09-06",
				4.7
			],
			[
				"2004-10-04",
				4.8
			],
			[
				"2004-11-15",
				3.7
			],
			[
				"2004-12-13",
				4.4
			],
			[
				"2005-01-10",
				5.5
			],
			[
				"2005-02-21",
				11.3
			],
			[
				"2005-03-07",
				6.3
			],
			[
				"2005-04-18",
				4.6
			],
			[
				"2005-05-02",
				4.6
			],
			[
				"2005-06-20",
				4.1
			],
			[
				"2005-07-11",
				4.4
			],
			[
				"2005-08-22",
				7.4
			],
			[
				"2005-09-12",
				4.3
			],
			[
				"2007-01-15",
				9
			],
			[
				"2007-02-26",
				5.9
			],
			[
				"2007-03-19",
				12.3
			],
			[
				"2007-04-16",
				12.8
			],
			[
				"2007-05-21",
				8.3
			],
			[
				"2007-06-25",
				5.4
			],
			[
				"2006-01-09",
				14.51
			],
			[
				"2006-02-20",
				4.8
			],
			[
				"2006-03-13",
				5.1
			],
			[
				"2006-04-03",
				6.4
			],
			[
				"2006-05-08",
				4.7
			],
			[
				"2006-06-26",
				4.7
			],
			[
				"2006-07-17",
				4.8
			],
			[
				"2006-08-14",
				4.8
			],
			[
				"2006-09-25",
				5.2
			],
			[
				"2006-10-24",
				5.2
			],
			[
				"2006-11-20",
				6.3
			],
			[
				"2006-12-04",
				13.3
			],
			[
				"2010-01-11",
				13
			],
			[
				"2010-02-09",
				9.5
			],
			[
				"2010-03-08",
				16.91
			],
			[
				"2010-04-12",
				7.5
			],
			[
				"2010-05-17",
				5.2
			],
			[
				"2010-06-14",
				11.1
			],
			[
				"2010-07-12",
				4.8
			],
			[
				"2010-08-09",
				5.2
			],
			[
				"2010-09-20",
				5
			],
			[
				"2010-11-02",
				20.41
			],
			[
				"2010-12-13",
				11.2
			],
			[
				"2011-01-17",
				9.2
			],
			[
				"2011-02-14",
				7.2
			],
			[
				"2011-03-21",
				6.5
			],
			[
				"2011-04-11",
				6
			],
			[
				"2011-05-16",
				5.8
			],
			[
				"2011-06-14",
				5.4
			],
			[
				"2011-07-11",
				7.4
			],
			[
				"2011-08-08",
				5.1
			],
			[
				"2011-09-12",
				4.8
			],
			[
				"2011-10-10",
				4.2
			],
			[
				"2011-11-14",
				4
			],
			[
				"2011-12-12",
				4.3
			],
			[
				"2012-01-09",
				9.2
			],
			[
				"2012-02-13",
				4.6
			],
			[
				"2012-03-12",
				5.5
			],
			[
				"2012-04-10",
				7.2
			],
			[
				"2012-05-21",
				8.8
			],
			[
				"2012-06-18",
				3.9
			],
			[
				"2012-07-09",
				3.9
			],
			[
				"2012-08-13",
				5.9
			],
			[
				"2012-09-17",
				3.7
			],
			[
				"2012-10-15",
				3.9
			],
			[
				"2012-11-12",
				3.9
			],
			[
				"2012-12-10",
				3.5
			],
			[
				"2013-01-14",
				3.7
			],
			[
				"2013-02-18",
				4.4
			],
			[
				"2013-03-11",
				4.3
			],
			[
				"2013-04-15",
				10.3
			],
			[
				"2013-05-13",
				4.2
			],
			[
				"2013-06-17",
				7.4
			],
			[
				"2013-07-15",
				4.2
			],
			[
				"2013-08-12",
				4.1
			],
			[
				"2013-09-16",
				8.2
			],
			[
				"2013-10-14",
				3.8
			],
			[
				"2013-11-11",
				3.9
			],
			[
				"2013-12-09",
				4
			],
			[
				"2014-01-13",
				5.3
			],
			[
				"2014-02-10",
				3.8
			],
			[
				"2014-03-17",
				3.7
			],
			[
				"2014-04-14",
				7.9
			],
			[
				"2014-05-12",
				3.5
			],
			[
				"2014-06-10",
				3.4
			],
			[
				"2014-07-14",
				4.1
			],
			[
				"2014-08-11",
				3.7
			],
			[
				"2014-09-15",
				3.8
			],
			[
				"2014-10-13",
				3.5
			],
			[
				"2014-11-10",
				3.4
			],
			[
				"2014-12-15",
				3.3
			],
			[
				"2015-01-12",
				14.31
			],
			[
				"2015-02-09",
				7.4
			],
			[
				"2015-02-23",
				3.8
			],
			[
				"2015-03-16",
				4
			],
			[
				"2015-04-13",
				5.9
			],
			[
				"2015-05-18",
				3.3
			],
			[
				"2015-06-08",
				4.4
			],
			[
				"2015-07-01",
				4.2
			],
			[
				"2015-07-08",
				4.2
			],
			[
				"2015-07-13",
				5.5
			],
			[
				"2015-08-10",
				4.1
			],
			[
				"2015-09-14",
				4.2
			],
			[
				"2015-10-12",
				4.5
			],
			[
				"2015-11-09",
				4
			],
			[
				"2015-12-14",
				4.4
			],
			[
				"2007-07-23",
				13.9
			],
			[
				"2007-08-13",
				13.6
			],
			[
				"2007-09-10",
				5.5
			],
			[
				"2007-10-15",
				5.7
			],
			[
				"2007-11-19",
				6.7
			],
			[
				"2007-12-10",
				5.9
			],
			[
				"2008-01-14",
				6.3
			],
			[
				"2008-02-18",
				7.5
			],
			[
				"2008-03-03",
				7
			],
			[
				"2008-04-21",
				7.7
			],
			[
				"2008-05-26",
				6.7
			],
			[
				"2008-06-16",
				7
			],
			[
				"2008-07-14",
				7
			],
			[
				"2008-08-04",
				7
			],
			[
				"2008-09-08",
				8.3
			],
			[
				"2008-10-06",
				6.8
			],
			[
				"2008-11-03",
				5.6
			],
			[
				"2008-12-08",
				6.9
			],
			[
				"2009-01-12",
				7.6
			],
			[
				"2009-02-02",
				6.7
			],
			[
				"2009-03-09",
				7.6
			],
			[
				"2009-04-06",
				7.2
			],
			[
				"2009-05-11",
				6.4
			],
			[
				"2009-06-15",
				6
			],
			[
				"2009-07-13",
				7.3
			],
			[
				"2009-08-10",
				5.3
			],
			[
				"2009-09-14",
				5.3
			],
			[
				"2009-10-12",
				5.3
			],
			[
				"2009-11-09",
				5.4
			],
			[
				"2009-12-14",
				4.6
			],
			[
				"2003-05-14",
				7.09
			],
			[
				"2007-10-09",
				7.31
			],
			[
				"2008-09-23",
				6.86
			]
		],
		"10407340": [
			[
				"2000-11-07",
				9.74
			],
			[
				"2000-03-27",
				12.4
			],
			[
				"2000-11-20",
				9
			],
			[
				"2002-07-18",
				11.96
			],
			[
				"2002-11-04",
				8.86
			],
			[
				"2001-03-12",
				9.91
			],
			[
				"2001-05-07",
				11.81
			],
			[
				"2001-09-24",
				8.71
			],
			[
				"2001-11-19",
				8.11
			],
			[
				"2002-03-11",
				13.11
			],
			[
				"2002-06-17",
				12.11
			],
			[
				"2002-08-19",
				9.71
			],
			[
				"2002-09-16",
				8.51
			],
			[
				"2002-10-14",
				8.21
			],
			[
				"2002-11-18",
				8.11
			],
			[
				"2002-12-02",
				9.41
			],
			[
				"2003-01-13",
				9.71
			],
			[
				"2003-02-10",
				11.51
			],
			[
				"2003-03-10",
				10.71
			],
			[
				"2003-04-07",
				10.31
			],
			[
				"2003-05-05",
				9.91
			],
			[
				"2003-06-23",
				8.61
			],
			[
				"2003-07-14",
				8.91
			],
			[
				"2003-08-11",
				7.91
			],
			[
				"2003-09-08",
				7.61
			],
			[
				"2003-10-06",
				7.01
			],
			[
				"2003-11-03",
				7.21
			],
			[
				"2003-12-01",
				7.01
			],
			[
				"2004-10-11",
				6.64
			],
			[
				"2004-01-12",
				6.5
			],
			[
				"2004-03-08",
				7.3
			],
			[
				"2004-04-19",
				8.2
			],
			[
				"2004-05-10",
				7.8
			],
			[
				"2004-06-14",
				7.8
			],
			[
				"2004-07-12",
				7.5
			],
			[
				"2004-08-09",
				7.3
			],
			[
				"2004-09-06",
				6.9
			],
			[
				"2004-10-04",
				6.7
			],
			[
				"2004-11-15",
				6.4
			],
			[
				"2004-12-13",
				6.3
			],
			[
				"2005-01-10",
				7
			],
			[
				"2005-02-21",
				7.7
			],
			[
				"2005-03-07",
				8.7
			],
			[
				"2005-04-18",
				8.5
			],
			[
				"2005-05-09",
				8.7
			],
			[
				"2005-06-20",
				8.4
			],
			[
				"2005-07-11",
				8.3
			],
			[
				"2005-08-22",
				7.9
			],
			[
				"2005-09-12",
				7.9
			],
			[
				"2005-10-24",
				7.2
			],
			[
				"2005-11-21",
				6.8
			],
			[
				"2005-12-12",
				6.8
			],
			[
				"2006-01-09",
				6.5
			],
			[
				"2006-02-20",
				6.9
			],
			[
				"2006-03-13",
				7.3
			],
			[
				"2006-04-03",
				9.2
			],
			[
				"2006-05-08",
				7.9
			],
			[
				"2006-06-26",
				7.9
			],
			[
				"2006-07-17",
				8.1
			],
			[
				"2006-08-14",
				7.6
			],
			[
				"2006-09-25",
				7.6
			],
			[
				"2006-10-24",
				7.5
			],
			[
				"2006-11-20",
				6.9
			],
			[
				"2006-12-04",
				6.8
			],
			[
				"2007-01-15",
				6.8
			],
			[
				"2007-02-26",
				7.7
			],
			[
				"2007-03-19",
				8.3
			],
			[
				"2007-04-16",
				8.5
			],
			[
				"2007-05-21",
				8.3
			],
			[
				"2007-06-25",
				7.8
			],
			[
				"2010-01-11",
				7.8
			],
			[
				"2010-02-09",
				8
			],
			[
				"2010-03-08",
				9.3
			],
			[
				"2010-04-12",
				8.9
			],
			[
				"2010-05-17",
				8
			],
			[
				"2010-06-14",
				8.4
			],
			[
				"2010-07-12",
				8.4
			],
			[
				"2010-08-09",
				7.9
			],
			[
				"2010-09-20",
				7.7
			],
			[
				"2010-10-11",
				7.3
			],
			[
				"2010-11-02",
				7.9
			],
			[
				"2010-12-13",
				7.7
			],
			[
				"2011-01-17",
				10.7
			],
			[
				"2011-02-14",
				11.2
			],
			[
				"2011-03-21",
				11
			],
			[
				"2011-04-11",
				9.7
			],
			[
				"2011-05-16",
				8.8
			],
			[
				"2011-06-14",
				8.4
			],
			[
				"2011-07-11",
				8
			],
			[
				"2011-08-08",
				7.9
			],
			[
				"2011-09-12",
				8.7
			],
			[
				"2011-10-10",
				8.7
			],
			[
				"2011-11-14",
				8.6
			],
			[
				"2011-12-12",
				8.7
			],
			[
				"2012-01-09",
				9.9
			],
			[
				"2012-02-13",
				10.1
			],
			[
				"2012-03-12",
				10.5
			],
			[
				"2012-04-10",
				10
			],
			[
				"2012-05-21",
				9.8
			],
			[
				"2012-06-18",
				9.3
			],
			[
				"2012-07-09",
				9.4
			],
			[
				"2012-08-13",
				8.8
			],
			[
				"2012-09-17",
				8.7
			],
			[
				"2012-10-15",
				8.9
			],
			[
				"2012-11-12",
				8.4
			],
			[
				"2012-12-10",
				7.4
			],
			[
				"2013-01-14",
				9.3
			],
			[
				"2013-02-18",
				9.8
			],
			[
				"2013-03-11",
				10.8
			],
			[
				"2013-04-15",
				10.9
			],
			[
				"2013-05-13",
				10.4
			],
			[
				"2013-06-17",
				9.7
			],
			[
				"2013-07-15",
				9.5
			],
			[
				"2013-08-12",
				9.3
			],
			[
				"2013-09-16",
				8.8
			],
			[
				"2013-10-14",
				8.2
			],
			[
				"2013-11-11",
				8.5
			],
			[
				"2013-12-09",
				8.6
			],
			[
				"2014-01-13",
				8.5
			],
			[
				"2014-02-10",
				8.8
			],
			[
				"2014-03-17",
				8.3
			],
			[
				"2014-04-14",
				8.3
			],
			[
				"2014-05-12",
				7.9
			],
			[
				"2014-06-10",
				7.7
			],
			[
				"2014-07-14",
				7.4
			],
			[
				"2014-08-11",
				7.3
			],
			[
				"2014-09-15",
				7.8
			],
			[
				"2014-10-13",
				7.8
			],
			[
				"2014-11-10",
				7.9
			],
			[
				"2014-12-15",
				7.6
			],
			[
				"2015-01-12",
				8.8
			],
			[
				"2015-02-09",
				8.7
			],
			[
				"2015-02-23",
				9.3
			],
			[
				"2015-03-16",
				10.6
			],
			[
				"2015-04-13",
				9.4
			],
			[
				"2015-05-18",
				8.5
			],
			[
				"2015-06-08",
				9.4
			],
			[
				"2015-07-01",
				9.1
			],
			[
				"2015-07-08",
				8.7
			],
			[
				"2015-07-13",
				9.1
			],
			[
				"2015-08-10",
				8.5
			],
			[
				"2015-09-14",
				8
			],
			[
				"2015-10-12",
				8.5
			],
			[
				"2015-11-09",
				7.9
			],
			[
				"2015-12-14",
				8.2
			],
			[
				"2007-07-23",
				7.5
			],
			[
				"2007-08-13",
				7.3
			],
			[
				"2007-09-10",
				7.1
			],
			[
				"2007-10-15",
				7.6
			],
			[
				"2007-11-19",
				8.6
			],
			[
				"2007-12-10",
				8.9
			],
			[
				"2008-01-14",
				9.4
			],
			[
				"2008-02-18",
				10.4
			],
			[
				"2008-03-03",
				10.2
			],
			[
				"2008-04-21",
				11.6
			],
			[
				"2008-05-26",
				11.2
			],
			[
				"2008-06-16",
				11.1
			],
			[
				"2008-07-14",
				10.9
			],
			[
				"2008-08-04",
				10.5
			],
			[
				"2008-09-08",
				10
			],
			[
				"2008-10-06",
				9.4
			],
			[
				"2008-11-03",
				9.1
			],
			[
				"2008-12-08",
				9.1
			],
			[
				"2009-01-12",
				9.3
			],
			[
				"2009-02-02",
				9.9
			],
			[
				"2009-03-09",
				10.4
			],
			[
				"2009-04-06",
				10.9
			],
			[
				"2009-05-11",
				10.9
			],
			[
				"2009-06-15",
				10
			],
			[
				"2009-07-13",
				9.5
			],
			[
				"2009-08-10",
				8.8
			],
			[
				"2009-09-14",
				8.4
			],
			[
				"2009-10-12",
				8.3
			],
			[
				"2009-11-09",
				7.7
			],
			[
				"2009-12-14",
				7.3
			],
			[
				"2007-10-09",
				7.93
			],
			[
				"2008-09-23",
				10.14
			]
		],
		"10407388": [
			[
				"2000-05-23",
				19.31
			],
			[
				"2000-08-29",
				19.93
			],
			[
				"2000-12-04",
				18.16
			],
			[
				"2000-10-31",
				20.11
			],
			[
				"2001-05-21",
				19.49
			],
			[
				"2001-05-16",
				19.49
			],
			[
				"2001-05-14",
				20.31
			],
			[
				"2001-10-04",
				8.41
			],
			[
				"2001-10-04",
				16.21
			],
			[
				"2002-05-15",
				18.81
			],
			[
				"2002-10-24",
				14.91
			],
			[
				"2003-05-19",
				17.27
			],
			[
				"2003-05-08",
				16.51
			],
			[
				"2003-11-13",
				14.11
			],
			[
				"2004-05-10",
				12.9
			],
			[
				"2004-10-06",
				13.29
			],
			[
				"2004-11-09",
				12.4
			],
			[
				"2004-10-25",
				14
			],
			[
				"2005-10-17",
				14.61
			],
			[
				"2005-04-19",
				15.61
			],
			[
				"2006-04-11",
				12.8
			],
			[
				"2006-10-23",
				12.8
			],
			[
				"2007-05-07",
				14.84
			],
			[
				"2010-05-10",
				12.5
			],
			[
				"2010-10-25",
				10
			],
			[
				"2011-04-05",
				12.5
			],
			[
				"2011-10-12",
				11
			],
			[
				"2012-04-23",
				11.8
			],
			[
				"2012-09-24",
				10.7
			],
			[
				"2013-05-27",
				12.5
			],
			[
				"2013-09-23",
				11.2
			],
			[
				"2014-05-26",
				9.4
			],
			[
				"2014-11-24",
				9.3
			],
			[
				"2015-04-15",
				12.8
			],
			[
				"2015-10-26",
				10.1
			],
			[
				"2007-10-22",
				13.1
			],
			[
				"2008-04-14",
				16.71
			],
			[
				"2008-10-27",
				17.11
			],
			[
				"2009-05-18",
				15.21
			],
			[
				"2009-10-20",
				12.53
			],
			[
				"2006-03-27",
				15.06
			],
			[
				"2008-10-06",
				15.77
			]
		],
		"10407390": [
			[
				"2000-05-23",
				2
			],
			[
				"2000-10-24",
				0.44
			],
			[
				"2000-10-31",
				2
			],
			[
				"2001-05-14",
				2
			],
			[
				"2001-10-04",
				2
			],
			[
				"2002-10-24",
				2
			],
			[
				"2002-05-15",
				2
			],
			[
				"2003-05-07",
				2
			],
			[
				"2003-11-12",
				2
			],
			[
				"2004-05-10",
				2
			],
			[
				"2004-10-06",
				0.44
			],
			[
				"2004-10-25",
				2
			],
			[
				"2005-10-24",
				0.44
			],
			[
				"2005-04-19",
				2
			],
			[
				"2005-09-26",
				2
			],
			[
				"2006-04-11",
				2
			],
			[
				"2006-10-24",
				2
			],
			[
				"2007-05-07",
				0.44
			],
			[
				"2010-05-10",
				1
			],
			[
				"2010-10-25",
				1
			],
			[
				"2011-04-05",
				1
			],
			[
				"2011-10-12",
				1
			],
			[
				"2012-04-24",
				2
			],
			[
				"2012-09-24",
				2
			],
			[
				"2013-05-28",
				2
			],
			[
				"2013-09-24",
				2
			],
			[
				"2014-05-27",
				2
			],
			[
				"2014-11-25",
				2
			],
			[
				"2015-04-15",
				2
			],
			[
				"2015-10-27",
				2
			],
			[
				"2007-11-19",
				4
			],
			[
				"2008-04-14",
				4
			],
			[
				"2008-11-04",
				2
			],
			[
				"2009-05-12",
				1
			],
			[
				"2009-10-20",
				1
			],
			[
				"2006-03-27",
				0.44
			],
			[
				"2008-10-06",
				0.44
			]
		],
		"10407406": [
			[
				"2000-05-23",
				2
			],
			[
				"2000-08-29",
				4.43
			],
			[
				"2000-12-04",
				3.54
			],
			[
				"2000-10-31",
				4
			],
			[
				"2001-05-14",
				4.7
			],
			[
				"2001-12-11",
				3.1
			],
			[
				"2001-10-04",
				2.6
			],
			[
				"2002-05-15",
				3.5
			],
			[
				"2002-10-24",
				2
			],
			[
				"2003-05-19",
				2.21
			],
			[
				"2003-05-08",
				2.2
			],
			[
				"2003-11-13",
				2
			],
			[
				"2004-05-11",
				2
			],
			[
				"2004-10-26",
				2
			],
			[
				"2005-09-27",
				3.1
			],
			[
				"2005-04-20",
				3
			],
			[
				"2006-04-12",
				2
			],
			[
				"2006-10-23",
				2.1
			],
			[
				"2007-05-07",
				2.17
			],
			[
				"2010-05-10",
				2.7
			],
			[
				"2010-10-25",
				1.7
			],
			[
				"2011-04-05",
				2.5
			],
			[
				"2011-10-12",
				1.7
			],
			[
				"2012-04-24",
				2.8
			],
			[
				"2012-09-25",
				2.1
			],
			[
				"2013-05-28",
				2.6
			],
			[
				"2013-09-24",
				2
			],
			[
				"2014-05-27",
				2
			],
			[
				"2014-11-25",
				2
			],
			[
				"2015-04-14",
				2.9
			],
			[
				"2015-10-27",
				2
			],
			[
				"2007-10-22",
				4
			],
			[
				"2008-04-14",
				4
			],
			[
				"2008-10-27",
				3.7
			],
			[
				"2009-05-12",
				2.4
			],
			[
				"2009-10-20",
				2.13
			],
			[
				"2006-03-27",
				1.77
			],
			[
				"2008-10-06",
				3.59
			]
		],
		"10407418": [
			[
				"2000-05-23",
				21.61
			],
			[
				"2000-08-29",
				23.47
			],
			[
				"2000-12-04",
				20.81
			],
			[
				"2000-10-31",
				23.21
			],
			[
				"2001-05-14",
				22.81
			],
			[
				"2001-12-11",
				20.81
			],
			[
				"2001-10-04",
				18.21
			],
			[
				"2002-05-15",
				23.61
			],
			[
				"2002-10-24",
				20.41
			],
			[
				"2003-05-19",
				22.14
			],
			[
				"2003-05-08",
				21.31
			],
			[
				"2003-11-13",
				20.21
			],
			[
				"2004-05-11",
				25.81
			],
			[
				"2004-10-06",
				19.93
			],
			[
				"2004-10-26",
				20.01
			],
			[
				"2005-04-20",
				22.11
			],
			[
				"2005-09-27",
				19.21
			],
			[
				"2006-04-12",
				23.71
			],
			[
				"2006-10-24",
				22.31
			],
			[
				"2007-05-07",
				24.18
			],
			[
				"2010-05-10",
				19.51
			],
			[
				"2010-10-25",
				17.11
			],
			[
				"2011-10-12",
				19.71
			],
			[
				"2012-04-23",
				19.31
			],
			[
				"2012-09-24",
				19.21
			],
			[
				"2013-05-27",
				18.71
			],
			[
				"2013-09-23",
				18.51
			],
			[
				"2014-05-26",
				18.01
			],
			[
				"2014-11-24",
				17.61
			],
			[
				"2015-04-15",
				16.91
			],
			[
				"2015-10-26",
				16.21
			],
			[
				"2007-10-22",
				19.41
			],
			[
				"2008-04-14",
				21.11
			],
			[
				"2008-10-27",
				22.41
			],
			[
				"2009-05-12",
				19.51
			],
			[
				"2009-10-20",
				17.38
			],
			[
				"2008-10-06",
				21.79
			]
		],
		"10407431": [
			[
				"2002-03-18",
				15.71
			],
			[
				"2002-10-16",
				14.11
			],
			[
				"2013-10-16",
				14.17
			],
			[
				"2014-11-12",
				13.42
			],
			[
				"2015-10-13",
				10.85
			],
			[
				"2007-10-08",
				16.47
			],
			[
				"2008-11-12",
				13.24
			],
			[
				"2010-06-14",
				14.66
			]
		],
		"10407467": [
			[
				"2000-04-17",
				31.41
			],
			[
				"2000-10-26",
				33.71
			],
			[
				"2001-03-28",
				27.71
			],
			[
				"2002-04-02",
				28.91
			],
			[
				"2002-12-02",
				31.41
			],
			[
				"2003-04-30",
				29.71
			],
			[
				"2004-04-27",
				29.41
			],
			[
				"2005-05-25",
				27.81
			],
			[
				"2006-11-30",
				29.27
			],
			[
				"2007-04-17",
				28.21
			],
			[
				"2008-01-11",
				27.72
			],
			[
				"2013-04-24",
				24.71
			],
			[
				"2014-04-10",
				24.49
			],
			[
				"2015-09-17",
				22.81
			],
			[
				"2010-04-01",
				24.67
			],
			[
				"2011-05-12",
				22.59
			],
			[
				"2012-08-27",
				22.81
			]
		],
		"10407479": [
			[
				"2000-04-17",
				5
			],
			[
				"2000-10-26",
				5.2
			],
			[
				"2001-03-28",
				5.6
			],
			[
				"2002-04-02",
				6.1
			],
			[
				"2002-12-01",
				5.8
			],
			[
				"2003-04-30",
				5.7
			],
			[
				"2004-04-27",
				6.2
			],
			[
				"2005-05-24",
				6.9
			],
			[
				"2006-04-06",
				6.8
			],
			[
				"2006-11-30",
				5.36
			],
			[
				"2007-03-28",
				7.26
			],
			[
				"2008-08-28",
				6.07
			],
			[
				"2009-03-24",
				3
			],
			[
				"2010-12-15",
				6.3
			],
			[
				"2011-03-28",
				16.41
			],
			[
				"2011-11-23",
				5
			],
			[
				"2014-12-03",
				5.76
			],
			[
				"2015-09-17",
				6.42
			],
			[
				"2007-12-07",
				5.8
			],
			[
				"2008-03-18",
				8.2
			],
			[
				"2010-03-29",
				6.7
			],
			[
				"2010-08-24",
				6
			],
			[
				"2010-09-17",
				6.16
			],
			[
				"2011-10-27",
				5.49
			],
			[
				"2012-08-27",
				5.4
			]
		],
		"10407522": [
			[
				"2001-10-16",
				89.43
			],
			[
				"2001-04-10",
				76.63
			],
			[
				"2002-04-15",
				90.73
			],
			[
				"2002-10-29",
				88.13
			],
			[
				"2003-10-21",
				83.23
			],
			[
				"2003-04-15",
				56.72
			],
			[
				"2002-10-15",
				93.43
			],
			[
				"2000-10-17",
				76.53
			],
			[
				"2000-04-12",
				78.43
			],
			[
				"2004-10-20",
				84.63
			],
			[
				"2004-04-06",
				77.93
			],
			[
				"2005-04-11",
				83.23
			],
			[
				"2005-10-26",
				86.33
			],
			[
				"2006-04-05",
				79.23
			],
			[
				"2006-11-06",
				83.23
			],
			[
				"2007-04-17",
				79.73
			],
			[
				"2007-10-23",
				78.43
			],
			[
				"2010-10-12",
				68.64
			],
			[
				"2011-04-27",
				72.19
			],
			[
				"2011-10-11",
				70.41
			],
			[
				"2012-04-24",
				69.96
			],
			[
				"2012-10-23",
				67.75
			],
			[
				"2013-04-09",
				66.86
			],
			[
				"2013-10-29",
				65.98
			],
			[
				"2014-04-15",
				63.32
			],
			[
				"2014-10-29",
				62.88
			],
			[
				"2015-04-08",
				61.55
			],
			[
				"2015-10-07",
				63.32
			],
			[
				"2008-10-21",
				77.93
			],
			[
				"2008-04-15",
				77.03
			],
			[
				"2009-04-07",
				75.73
			],
			[
				"2009-10-20",
				68.62
			],
			[
				"2010-04-27",
				73.03
			],
			[
				"2008-09-08",
				79.27
			]
		],
		"10407649": [
			[
				"2001-10-15",
				76.13
			],
			[
				"2001-04-09",
				75.33
			],
			[
				"2002-04-16",
				76.63
			],
			[
				"2002-04-08",
				71.74
			],
			[
				"2003-10-20",
				68.22
			],
			[
				"2003-04-14",
				69.52
			],
			[
				"2002-10-14",
				74.83
			],
			[
				"2000-10-17",
				74.23
			],
			[
				"2000-04-12",
				74.03
			],
			[
				"2004-10-18",
				67.32
			],
			[
				"2004-04-05",
				66.02
			],
			[
				"2005-04-11",
				66.02
			],
			[
				"2005-10-25",
				68.22
			],
			[
				"2006-04-04",
				69.52
			],
			[
				"2006-11-06",
				66.82
			],
			[
				"2007-04-16",
				71.73
			],
			[
				"2007-10-22",
				72.63
			],
			[
				"2010-10-11",
				87.24
			],
			[
				"2011-04-26",
				86.8
			],
			[
				"2011-10-10",
				85.02
			],
			[
				"2012-04-23",
				85.47
			],
			[
				"2012-10-22",
				77.5
			],
			[
				"2013-10-28",
				95.65
			],
			[
				"2014-04-14",
				84.58
			],
			[
				"2014-10-28",
				78.83
			],
			[
				"2015-04-07",
				81.48
			],
			[
				"2015-10-06",
				81.48
			],
			[
				"2008-10-20",
				85.93
			],
			[
				"2008-04-14",
				72.63
			],
			[
				"2009-04-06",
				87.73
			],
			[
				"2010-04-26",
				90.73
			],
			[
				"2007-12-03",
				83.26
			],
			[
				"2008-08-29",
				85.47
			]
		],
		"10407777": [
			[
				"2000-05-24",
				8
			],
			[
				"2000-11-16",
				10
			],
			[
				"2001-03-15",
				8.3
			],
			[
				"2001-11-08",
				7.8
			],
			[
				"2002-05-16",
				7.2
			],
			[
				"2006-12-06",
				11.29
			],
			[
				"2007-01-26",
				9.57
			],
			[
				"2007-03-28",
				8.28
			],
			[
				"2008-03-25",
				9.88
			],
			[
				"2013-11-28",
				7.88
			],
			[
				"2014-08-04",
				9.65
			],
			[
				"2015-11-26",
				9.88
			],
			[
				"2016-01-21",
				7.97
			],
			[
				"2010-04-29",
				7.57
			]
		],
		"10408216": [
			[
				"2000-09-27",
				14
			],
			[
				"2002-04-15",
				15.01
			],
			[
				"2000-04-04",
				15.01
			],
			[
				"2001-12-11",
				14
			],
			[
				"2001-04-10",
				15.01
			],
			[
				"2002-12-11",
				14
			],
			[
				"2003-06-24",
				5.2
			],
			[
				"2005-12-15",
				14.41
			],
			[
				"2005-03-15",
				15.01
			],
			[
				"2006-12-12",
				15.41
			],
			[
				"2006-06-19",
				14
			],
			[
				"2010-12-20",
				15.21
			],
			[
				"2010-06-01",
				14.51
			],
			[
				"2011-12-01",
				15.31
			],
			[
				"2011-06-16",
				15.51
			],
			[
				"2012-12-13",
				14.81
			],
			[
				"2012-05-31",
				14.91
			],
			[
				"2013-12-10",
				17.71
			],
			[
				"2013-06-25",
				15.51
			],
			[
				"2014-12-16",
				16.01
			],
			[
				"2014-06-24",
				16.01
			],
			[
				"2015-12-14",
				15.01
			],
			[
				"2015-06-18",
				15.01
			],
			[
				"2008-07-21",
				15.21
			],
			[
				"2007-12-17",
				15.01
			],
			[
				"2007-05-23",
				14.81
			],
			[
				"2008-12-22",
				14.91
			],
			[
				"2009-06-16",
				15.21
			],
			[
				"2009-12-15",
				14.41
			],
			[
				"2007-10-16",
				15.72
			]
		],
		"10408230": [
			[
				"2015-10-13",
				10.58
			],
			[
				"2007-10-08",
				8.55
			],
			[
				"2008-08-28",
				9.52
			],
			[
				"2010-06-14",
				10.23
			],
			[
				"2011-11-24",
				10.05
			]
		],
		"10408241": [
			[
				"2002-10-16",
				6.1
			],
			[
				"2002-03-18",
				6.2
			],
			[
				"2003-11-12",
				6
			],
			[
				"2003-05-26",
				6.3
			],
			[
				"2004-12-08",
				6.9
			],
			[
				"2004-05-12",
				6.2
			],
			[
				"2005-06-07",
				5
			],
			[
				"2006-11-21",
				6.7
			],
			[
				"2006-05-22",
				6.5
			],
			[
				"2010-05-05",
				6.5
			],
			[
				"2011-11-21",
				7.2
			],
			[
				"2011-05-16",
				9.9
			],
			[
				"2012-11-08",
				8.3
			],
			[
				"2012-05-16",
				8
			],
			[
				"2013-11-25",
				9.3
			],
			[
				"2013-05-08",
				9.7
			],
			[
				"2014-11-18",
				8.6
			],
			[
				"2014-05-19",
				8.5
			],
			[
				"2015-12-17",
				8.8
			],
			[
				"2015-05-05",
				8.3
			],
			[
				"2014-11-12",
				8.86
			],
			[
				"2015-10-13",
				7.79
			],
			[
				"2008-05-27",
				3
			],
			[
				"2007-11-13",
				7
			],
			[
				"2007-05-09",
				5.8
			],
			[
				"2008-11-04",
				7.1
			],
			[
				"2009-05-04",
				7.1
			],
			[
				"2009-12-14",
				7.9
			],
			[
				"2007-10-08",
				8.15
			],
			[
				"2008-08-28",
				7.13
			],
			[
				"2010-06-14",
				7.22
			],
			[
				"2011-11-24",
				7.57
			]
		],
		"10408381": [
			[
				"2000-05-12",
				39.11
			],
			[
				"2000-11-28",
				39.41
			],
			[
				"2000-10-16",
				43.62
			],
			[
				"2001-05-30",
				41.01
			],
			[
				"2002-05-06",
				43.02
			],
			[
				"2002-11-18",
				39.86
			],
			[
				"2002-10-22",
				41.01
			],
			[
				"2003-05-20",
				41.61
			],
			[
				"2003-11-04",
				43.84
			],
			[
				"2003-10-13",
				44.72
			],
			[
				"2004-03-24",
				41.19
			],
			[
				"2004-05-18",
				43.82
			],
			[
				"2004-10-26",
				43.22
			],
			[
				"2005-03-14",
				41.61
			],
			[
				"2005-04-11",
				42.07
			],
			[
				"2005-10-24",
				43.92
			],
			[
				"2006-03-27",
				40.21
			],
			[
				"2006-09-26",
				46.92
			],
			[
				"2007-03-19",
				47.82
			],
			[
				"2007-04-23",
				50.93
			],
			[
				"2007-09-11",
				46.92
			],
			[
				"2008-10-06",
				44.02
			],
			[
				"2010-12-13",
				37.9
			],
			[
				"2011-04-18",
				37.9
			],
			[
				"2011-10-19",
				37.81
			],
			[
				"2012-04-30",
				38.12
			],
			[
				"2012-10-24",
				37.68
			],
			[
				"2013-04-22",
				45.17
			],
			[
				"2013-10-16",
				37.24
			],
			[
				"2014-03-18",
				41.18
			],
			[
				"2014-10-08",
				38.26
			],
			[
				"2015-04-27",
				44.73
			],
			[
				"2015-10-19",
				40.38
			],
			[
				"2014-08-12",
				41.63
			],
			[
				"2008-03-31",
				52.22
			],
			[
				"2009-04-27",
				39.71
			],
			[
				"2009-10-07",
				37.51
			],
			[
				"2010-04-12",
				36.71
			]
		],
		"10408411": [
			[
				"2000-05-03",
				55.32
			],
			[
				"2000-10-04",
				54.42
			],
			[
				"2001-10-17",
				54.92
			],
			[
				"2001-04-11",
				54.02
			],
			[
				"2005-04-04",
				54.92
			],
			[
				"2005-10-12",
				55.32
			],
			[
				"2006-04-26",
				54.02
			],
			[
				"2006-10-11",
				56.22
			],
			[
				"2004-04-26",
				56.22
			],
			[
				"2004-10-13",
				54.92
			],
			[
				"2007-04-18",
				57.52
			],
			[
				"2007-05-14",
				57.57
			],
			[
				"2008-10-08",
				59.82
			],
			[
				"2011-04-06",
				61.11
			],
			[
				"2011-10-19",
				60.67
			],
			[
				"2012-05-14",
				61.55
			],
			[
				"2012-12-05",
				59.78
			],
			[
				"2013-04-23",
				58.45
			],
			[
				"2013-10-23",
				57.57
			],
			[
				"2014-04-02",
				60.67
			],
			[
				"2014-03-18",
				62.52
			],
			[
				"2014-10-22",
				57.57
			],
			[
				"2015-04-21",
				59.34
			],
			[
				"2015-04-21",
				60.32
			],
			[
				"2015-10-28",
				58.9
			],
			[
				"2008-04-08",
				62.42
			],
			[
				"2007-10-10",
				57.52
			],
			[
				"2009-04-29",
				61.52
			],
			[
				"2009-10-28",
				59.32
			],
			[
				"2010-04-14",
				58.92
			]
		],
		"10408782": [
			[
				"2000-03-24",
				9.7
			],
			[
				"2000-11-13",
				9.6
			],
			[
				"2001-03-15",
				9.1
			],
			[
				"2001-11-28",
				8.9
			],
			[
				"2003-04-16",
				7.1
			],
			[
				"2003-11-19",
				8.6
			],
			[
				"2002-11-20",
				8.4
			],
			[
				"2002-04-03",
				9.3
			],
			[
				"2004-04-28",
				7.2
			],
			[
				"2004-11-29",
				8.6
			],
			[
				"2002-11-18",
				8.41
			],
			[
				"2004-10-04",
				7.97
			],
			[
				"2004-12-20",
				7.09
			],
			[
				"2004-12-27",
				6.64
			],
			[
				"2005-10-17",
				9.3
			],
			[
				"2005-11-15",
				9
			],
			[
				"2006-04-24",
				6.64
			],
			[
				"2005-05-10",
				7.2
			],
			[
				"2006-11-22",
				8.3
			],
			[
				"2007-05-07",
				8.9
			],
			[
				"2007-04-17",
				8.9
			],
			[
				"2008-11-19",
				8.8
			],
			[
				"2010-11-23",
				6.2
			],
			[
				"2011-04-27",
				4.7
			],
			[
				"2011-11-29",
				6.8
			],
			[
				"2012-04-25",
				6.9
			],
			[
				"2012-12-11",
				7.8
			],
			[
				"2013-04-24",
				6.3
			],
			[
				"2013-11-26",
				5.6
			],
			[
				"2014-04-23",
				4.4
			],
			[
				"2014-12-09",
				2.8
			],
			[
				"2015-05-04",
				4.2
			],
			[
				"2007-11-27",
				8.3
			],
			[
				"2008-04-15",
				9.8
			],
			[
				"2009-04-22",
				8.2
			],
			[
				"2009-11-23",
				6.3
			],
			[
				"2010-04-14",
				4.4
			],
			[
				"2008-09-23",
				7.66
			]
		],
		"10409014": [
			[
				"2000-07-06",
				18.16
			],
			[
				"2001-05-03",
				16.83
			],
			[
				"2002-07-02",
				17.71
			],
			[
				"2003-04-28",
				17.71
			],
			[
				"2005-02-01",
				15.94
			],
			[
				"2004-01-29",
				19.93
			],
			[
				"2006-01-19",
				18.6
			],
			[
				"2007-01-16",
				19.66
			],
			[
				"2008-01-09",
				18.33
			],
			[
				"2013-04-24",
				19.44
			],
			[
				"2014-02-20",
				15.68
			],
			[
				"2015-06-18",
				18.87
			],
			[
				"2016-01-25",
				15.06
			],
			[
				"2000-04-19",
				18.6
			],
			[
				"2009-10-09",
				17.27
			],
			[
				"2011-02-07",
				18.42
			],
			[
				"2012-06-25",
				17.18
			]
		],
		"10409038": [
			[
				"2000-03-30",
				52.26
			],
			[
				"2001-05-04",
				51.37
			],
			[
				"2002-07-02",
				50.49
			],
			[
				"2003-04-28",
				53.14
			],
			[
				"2005-02-01",
				50.93
			],
			[
				"2004-02-05",
				53.14
			],
			[
				"2006-01-19",
				54.91
			],
			[
				"2007-01-26",
				54.91
			],
			[
				"2008-03-28",
				56.69
			],
			[
				"2013-04-24",
				53.14
			],
			[
				"2014-08-11",
				47.83
			],
			[
				"2015-03-05",
				52.7
			],
			[
				"2016-03-07",
				53.14
			],
			[
				"2009-07-16",
				58.46
			],
			[
				"2010-05-03",
				53.59
			],
			[
				"2011-03-14",
				52.26
			],
			[
				"2012-06-25",
				51.81
			]
		],
		"10409051": [
			[
				"2000-08-23",
				18.6
			],
			[
				"2001-08-02",
				19.49
			],
			[
				"2002-10-09",
				19.49
			],
			[
				"2003-07-02",
				19.93
			],
			[
				"2005-01-31",
				19.49
			],
			[
				"2004-03-12",
				18.6
			],
			[
				"2007-01-24",
				16.21
			],
			[
				"2008-04-29",
				17.18
			],
			[
				"2014-08-04",
				12.71
			],
			[
				"2015-02-09",
				13.02
			],
			[
				"2016-01-20",
				13.73
			],
			[
				"2006-03-31",
				18.6
			],
			[
				"2010-03-04",
				14.75
			],
			[
				"2011-02-17",
				14.61
			],
			[
				"2012-05-31",
				13.64
			],
			[
				"2013-03-07",
				13.95
			]
		],
		"10409063": [
			[
				"2000-08-31",
				47.83
			],
			[
				"2001-07-31",
				47.83
			],
			[
				"2003-10-17",
				52.26
			],
			[
				"2005-01-31",
				50.04
			],
			[
				"2004-03-10",
				54.47
			],
			[
				"2007-01-16",
				49.6
			],
			[
				"2008-01-10",
				50.04
			],
			[
				"2015-12-18",
				37.73
			],
			[
				"2016-01-20",
				44.29
			],
			[
				"2006-03-31",
				51.37
			]
		],
		"10409087": [
			[
				"2000-10-02",
				17.01
			],
			[
				"2000-05-15",
				17.41
			],
			[
				"2001-05-21",
				17.11
			],
			[
				"2002-06-10",
				18.01
			],
			[
				"2002-10-16",
				19.71
			],
			[
				"2003-05-14",
				19.31
			],
			[
				"2003-10-15",
				20.41
			],
			[
				"2005-05-12",
				20.71
			],
			[
				"2007-05-08",
				22.14
			],
			[
				"2001-10-10",
				18.91
			],
			[
				"2008-01-14",
				22.9
			],
			[
				"2008-07-29",
				22.01
			],
			[
				"2013-08-02",
				22.59
			],
			[
				"2014-12-04",
				22.23
			],
			[
				"2015-11-12",
				20.81
			],
			[
				"2010-05-03",
				22.19
			],
			[
				"2011-06-20",
				23.29
			],
			[
				"2011-10-27",
				23.03
			]
		],
		"10409105": [
			[
				"2000-04-12",
				71.73
			],
			[
				"2000-07-19",
				72.63
			],
			[
				"2000-11-08",
				69.52
			],
			[
				"2001-04-04",
				71.73
			],
			[
				"2001-07-25",
				75.33
			],
			[
				"2001-11-14",
				75.33
			],
			[
				"2002-04-17",
				79.23
			],
			[
				"2002-07-17",
				77.53
			],
			[
				"2002-11-20",
				77.53
			],
			[
				"2003-04-23",
				71.33
			],
			[
				"2003-07-23",
				69.92
			],
			[
				"2003-11-19",
				68.22
			],
			[
				"2004-12-08",
				68.62
			],
			[
				"2004-07-14",
				67.32
			],
			[
				"2004-04-14",
				68.62
			],
			[
				"2005-04-26",
				67.32
			],
			[
				"2005-07-06",
				68.62
			],
			[
				"2005-11-16",
				67.72
			],
			[
				"2006-03-29",
				66.82
			],
			[
				"2006-07-12",
				66.82
			],
			[
				"2006-11-15",
				68.62
			],
			[
				"2007-05-09",
				68.62
			],
			[
				"2007-07-18",
				67.72
			],
			[
				"2007-11-14",
				66.82
			],
			[
				"2008-07-23",
				73.03
			],
			[
				"2008-11-12",
				75.33
			],
			[
				"2008-01-14",
				81.04
			],
			[
				"2008-07-24",
				75.73
			],
			[
				"2010-11-17",
				68.64
			],
			[
				"2011-04-19",
				70.86
			],
			[
				"2011-07-06",
				69.96
			],
			[
				"2011-11-02",
				73.96
			],
			[
				"2012-04-25",
				69.08
			],
			[
				"2012-07-18",
				67.75
			],
			[
				"2012-11-21",
				69.96
			],
			[
				"2013-07-31",
				69.08
			],
			[
				"2014-01-08",
				69.52
			],
			[
				"2014-03-05",
				68.19
			],
			[
				"2014-08-13",
				68.19
			],
			[
				"2014-12-10",
				64.65
			],
			[
				"2015-04-22",
				67.31
			],
			[
				"2015-07-08",
				66.42
			],
			[
				"2015-11-25",
				58.45
			],
			[
				"2008-04-09",
				73.53
			],
			[
				"2009-04-15",
				72.63
			],
			[
				"2009-07-08",
				73.03
			],
			[
				"2009-11-11",
				68.22
			],
			[
				"2010-04-07",
				68.62
			],
			[
				"2010-07-14",
				69.96
			],
			[
				"2007-01-25",
				64.21
			]
		],
		"10409129": [
			[
				"2000-04-10",
				56.22
			],
			[
				"2000-11-06",
				70.86
			],
			[
				"2001-07-16",
				80.13
			],
			[
				"2002-11-14",
				74.84
			],
			[
				"2001-11-27",
				79.73
			],
			[
				"2002-07-16",
				89.43
			],
			[
				"2002-11-12",
				81.03
			],
			[
				"2003-07-22",
				77.93
			],
			[
				"2003-11-18",
				74.43
			],
			[
				"2004-11-08",
				69.92
			],
			[
				"2005-04-13",
				66.82
			],
			[
				"2005-11-08",
				71.73
			],
			[
				"2006-04-10",
				67.72
			],
			[
				"2006-07-19",
				72.23
			],
			[
				"2006-11-22",
				71.73
			],
			[
				"2004-04-13",
				71.33
			],
			[
				"2004-07-12",
				70.83
			],
			[
				"2007-01-11",
				71.3
			],
			[
				"2007-05-08",
				68.62
			],
			[
				"2007-11-27",
				66.42
			],
			[
				"2008-07-21",
				80.63
			],
			[
				"2008-11-11",
				85.43
			],
			[
				"2008-01-14",
				46.06
			],
			[
				"2008-07-24",
				83.7
			],
			[
				"2010-11-09",
				75.29
			],
			[
				"2011-04-04",
				79.71
			],
			[
				"2011-07-04",
				80.6
			],
			[
				"2011-11-08",
				79.27
			],
			[
				"2012-04-10",
				73.51
			],
			[
				"2012-07-23",
				71.3
			],
			[
				"2012-11-14",
				69.96
			],
			[
				"2013-04-03",
				71.74
			],
			[
				"2013-07-17",
				79.27
			],
			[
				"2013-11-20",
				76.61
			],
			[
				"2014-03-12",
				75.73
			],
			[
				"2014-07-16",
				68.19
			],
			[
				"2014-11-26",
				64.21
			],
			[
				"2015-04-28",
				74.4
			],
			[
				"2015-07-29",
				78.83
			],
			[
				"2015-11-18",
				74.4
			],
			[
				"2008-04-07",
				70.42
			],
			[
				"2009-04-28",
				77.93
			],
			[
				"2009-07-15",
				80.13
			],
			[
				"2009-11-10",
				80.13
			],
			[
				"2010-04-06",
				73.93
			],
			[
				"2010-07-13",
				73.96
			]
		],
		"10409142": [
			[
				"2008-09-18",
				20.81
			],
			[
				"2014-06-27",
				13.06
			],
			[
				"2015-02-09",
				16.7
			],
			[
				"2011-02-17",
				19.88
			],
			[
				"2012-08-27",
				15.01
			],
			[
				"2013-03-22",
				16.21
			]
		],
		"10409154": [
			[
				"2000-03-16",
				22.71
			],
			[
				"2000-04-03",
				22.91
			],
			[
				"2000-11-15",
				22.61
			],
			[
				"2001-03-13",
				22.01
			],
			[
				"2001-11-19",
				23.41
			],
			[
				"2003-03-18",
				20.91
			],
			[
				"2003-11-18",
				22.21
			],
			[
				"2002-03-19",
				20.91
			],
			[
				"2002-11-26",
				22.51
			],
			[
				"2005-03-09",
				22.41
			],
			[
				"2005-11-08",
				22.21
			],
			[
				"2006-02-07",
				25.24
			],
			[
				"2006-11-22",
				24.31
			],
			[
				"2004-03-08",
				22.51
			],
			[
				"2004-11-17",
				23.61
			],
			[
				"2007-01-24",
				24.67
			],
			[
				"2007-11-26",
				21.81
			],
			[
				"2008-11-11",
				22.41
			],
			[
				"2008-01-14",
				23.6
			],
			[
				"2010-11-23",
				23.25
			],
			[
				"2011-03-14",
				23.29
			],
			[
				"2011-11-16",
				22.28
			],
			[
				"2012-03-07",
				22.68
			],
			[
				"2012-11-28",
				21.52
			],
			[
				"2013-03-11",
				20.73
			],
			[
				"2013-11-06",
				20.42
			],
			[
				"2014-03-11",
				20.11
			],
			[
				"2014-11-10",
				20.64
			],
			[
				"2015-03-24",
				19.36
			],
			[
				"2015-11-16",
				20.15
			],
			[
				"2013-06-18",
				21.26
			],
			[
				"2014-07-31",
				22.05
			],
			[
				"2015-03-05",
				20.28
			],
			[
				"2006-03-28",
				21.41
			],
			[
				"2008-03-10",
				23.31
			],
			[
				"2009-03-23",
				22.11
			],
			[
				"2009-11-24",
				22.21
			],
			[
				"2010-03-16",
				21.21
			],
			[
				"2010-04-22",
				21.74
			],
			[
				"2011-06-10",
				22.72
			],
			[
				"2012-08-28",
				21.52
			]
		],
		"10409270": [
			[
				"2005-08-08",
				17.91
			],
			[
				"2005-12-13",
				17.11
			],
			[
				"2006-02-07",
				19.93
			],
			[
				"2006-04-11",
				17.11
			],
			[
				"2006-08-29",
				18.01
			],
			[
				"2007-01-18",
				44.29
			],
			[
				"2007-12-04",
				16.31
			],
			[
				"2008-08-18",
				17.51
			],
			[
				"2008-12-08",
				17.11
			],
			[
				"2008-04-04",
				7.53
			],
			[
				"2010-08-16",
				18.03
			],
			[
				"2010-12-14",
				17.27
			],
			[
				"2011-04-18",
				16.92
			],
			[
				"2011-08-22",
				15.95
			],
			[
				"2011-12-07",
				17.58
			],
			[
				"2012-04-02",
				17.32
			],
			[
				"2012-08-21",
				15.5
			],
			[
				"2012-12-11",
				15.64
			],
			[
				"2013-04-03",
				15.19
			],
			[
				"2013-08-05",
				16.39
			],
			[
				"2013-12-16",
				14.62
			],
			[
				"2014-04-02",
				14.71
			],
			[
				"2014-08-25",
				13.9
			],
			[
				"2014-12-09",
				14.88
			],
			[
				"2015-04-27",
				14.62
			],
			[
				"2015-08-31",
				15.64
			],
			[
				"2015-12-09",
				14.84
			],
			[
				"2014-04-10",
				16.16
			],
			[
				"2015-03-05",
				15.19
			],
			[
				"2008-04-02",
				0.2
			],
			[
				"2009-04-28",
				15.41
			],
			[
				"2009-08-12",
				16.41
			],
			[
				"2009-12-08",
				17.91
			],
			[
				"2010-04-12",
				73.53
			],
			[
				"2010-04-22",
				16.16
			],
			[
				"2011-04-28",
				16.56
			],
			[
				"2012-06-25",
				17.45
			],
			[
				"2013-03-28",
				15.72
			]
		],
		"10409312": [
			[
				"2000-10-02",
				32.61
			],
			[
				"2000-05-15",
				34.21
			],
			[
				"2001-05-21",
				34.51
			],
			[
				"2001-12-18",
				32.33
			],
			[
				"2003-11-18",
				38.09
			],
			[
				"2004-10-18",
				35.87
			],
			[
				"2005-05-12",
				35.61
			],
			[
				"2005-10-10",
				35.91
			],
			[
				"2006-05-24",
				35.61
			],
			[
				"2006-10-16",
				38.21
			],
			[
				"2004-09-27",
				37.51
			],
			[
				"2007-05-23",
				36.01
			],
			[
				"2008-10-22",
				38.31
			],
			[
				"2010-11-10",
				38.21
			],
			[
				"2011-05-11",
				34.94
			],
			[
				"2011-10-26",
				36.35
			],
			[
				"2012-05-09",
				37.42
			],
			[
				"2012-10-08",
				37.95
			],
			[
				"2013-10-15",
				36.13
			],
			[
				"2014-05-14",
				37.42
			],
			[
				"2014-10-15",
				34.58
			],
			[
				"2015-06-17",
				37.37
			],
			[
				"2015-10-27",
				35.87
			],
			[
				"2014-12-04",
				37.11
			],
			[
				"2008-05-14",
				36.71
			],
			[
				"2009-05-13",
				35.91
			],
			[
				"2009-10-21",
				37.51
			],
			[
				"2010-06-09",
				34.58
			],
			[
				"2007-10-16",
				37.73
			],
			[
				"2008-10-21",
				38.17
			],
			[
				"2010-06-07",
				36.71
			]
		],
		"10409324": [
			[
				"2002-05-14",
				43.92
			],
			[
				"2006-07-11",
				42.72
			],
			[
				"2006-12-06",
				45.17
			],
			[
				"2000-04-03",
				41.81
			],
			[
				"2000-10-25",
				42.82
			],
			[
				"2001-04-04",
				43.12
			],
			[
				"2001-11-28",
				42.01
			],
			[
				"2002-04-02",
				43.92
			],
			[
				"2002-11-19",
				43.52
			],
			[
				"2003-04-30",
				46.62
			],
			[
				"2003-11-25",
				43.92
			],
			[
				"2007-04-17",
				45.17
			],
			[
				"2007-03-12",
				45.22
			],
			[
				"2007-07-11",
				44.72
			],
			[
				"2007-11-12",
				42.92
			],
			[
				"2008-07-15",
				49.12
			],
			[
				"2008-11-10",
				50.52
			],
			[
				"2008-06-12",
				50.49
			],
			[
				"2010-11-16",
				47.39
			],
			[
				"2011-03-15",
				49.6
			],
			[
				"2011-07-27",
				48.71
			],
			[
				"2011-11-09",
				48.27
			],
			[
				"2012-03-12",
				48.27
			],
			[
				"2012-07-16",
				48.27
			],
			[
				"2012-11-20",
				45.17
			],
			[
				"2013-03-25",
				46.06
			],
			[
				"2013-07-29",
				47.83
			],
			[
				"2013-11-12",
				46.5
			],
			[
				"2014-04-07",
				47.83
			],
			[
				"2014-07-22",
				47.83
			],
			[
				"2014-11-17",
				47.83
			],
			[
				"2015-03-16",
				46.06
			],
			[
				"2015-06-08",
				50.49
			],
			[
				"2015-11-03",
				46.5
			],
			[
				"2014-08-11",
				45.17
			],
			[
				"2015-11-12",
				43.75
			],
			[
				"2008-03-04",
				44.72
			],
			[
				"2009-03-17",
				46.92
			],
			[
				"2009-07-06",
				46.52
			],
			[
				"2009-11-16",
				47.42
			],
			[
				"2010-03-08",
				45.62
			],
			[
				"2010-07-13",
				45.62
			],
			[
				"2008-07-29",
				49.16
			],
			[
				"2010-05-03",
				48.71
			],
			[
				"2012-08-28",
				43.67
			]
		],
		"10409336": [
			[
				"2002-04-02",
				33.21
			],
			[
				"2006-12-06",
				35.21
			],
			[
				"2007-03-12",
				35.81
			],
			[
				"2007-07-11",
				36.41
			],
			[
				"2007-11-12",
				32.81
			],
			[
				"2008-07-15",
				34.91
			],
			[
				"2008-11-10",
				36.91
			],
			[
				"2010-11-16",
				33.39
			],
			[
				"2011-03-15",
				33.03
			],
			[
				"2011-07-27",
				33.12
			],
			[
				"2011-11-09",
				32.64
			],
			[
				"2012-03-12",
				34.1
			],
			[
				"2012-07-16",
				35.11
			],
			[
				"2012-11-20",
				32.77
			],
			[
				"2013-03-25",
				35.11
			],
			[
				"2013-07-29",
				33.3
			],
			[
				"2013-11-12",
				35.82
			],
			[
				"2014-04-07",
				33.74
			],
			[
				"2014-07-22",
				33.34
			],
			[
				"2014-11-17",
				33.79
			],
			[
				"2015-03-16",
				33.7
			],
			[
				"2015-06-08",
				35.16
			],
			[
				"2015-11-03",
				34.01
			],
			[
				"2008-03-04",
				34.21
			],
			[
				"2009-03-17",
				32.81
			],
			[
				"2009-07-06",
				33.01
			],
			[
				"2009-11-16",
				32.31
			],
			[
				"2010-03-08",
				31.61
			],
			[
				"2010-07-13",
				31.48
			]
		],
		"10409348": [
			[
				"2002-04-02",
				24.71
			],
			[
				"2006-11-03",
				25.69
			],
			[
				"2007-01-24",
				26.53
			],
			[
				"2007-03-12",
				26.81
			],
			[
				"2007-07-11",
				27.01
			],
			[
				"2007-11-12",
				24.61
			],
			[
				"2008-07-15",
				26.01
			],
			[
				"2008-11-10",
				26.11
			],
			[
				"2008-04-29",
				26.88
			],
			[
				"2010-11-16",
				25.95
			],
			[
				"2011-03-15",
				25.46
			],
			[
				"2011-07-27",
				25.38
			],
			[
				"2011-11-09",
				25.02
			],
			[
				"2012-03-12",
				26.84
			],
			[
				"2012-07-16",
				28.7
			],
			[
				"2012-11-20",
				26.57
			],
			[
				"2013-03-25",
				25.95
			],
			[
				"2013-07-29",
				27.01
			],
			[
				"2013-11-12",
				27.77
			],
			[
				"2014-04-07",
				27.28
			],
			[
				"2014-07-22",
				25.82
			],
			[
				"2014-11-17",
				26.22
			],
			[
				"2015-03-16",
				27.19
			],
			[
				"2015-06-08",
				26.39
			],
			[
				"2015-11-03",
				27.06
			],
			[
				"2008-03-04",
				25.51
			],
			[
				"2009-03-17",
				26.61
			],
			[
				"2009-07-06",
				24.51
			],
			[
				"2009-11-16",
				23.91
			],
			[
				"2010-03-08",
				24.91
			],
			[
				"2010-07-13",
				25.33
			]
		],
		"10409385": [
			[
				"2000-03-20",
				9
			],
			[
				"2000-11-13",
				8.41
			],
			[
				"2000-07-18",
				9.5
			],
			[
				"2000-11-07",
				9.2
			],
			[
				"2001-01-30",
				8.6
			],
			[
				"2001-03-12",
				8.7
			],
			[
				"2001-07-12",
				9.6
			],
			[
				"2001-11-12",
				8.8
			],
			[
				"2002-03-05",
				9.7
			],
			[
				"2003-03-10",
				9.2
			],
			[
				"2003-07-14",
				9.3
			],
			[
				"2003-11-24",
				9
			],
			[
				"2005-04-05",
				8.7
			],
			[
				"2004-03-02",
				8.7
			],
			[
				"2004-07-06",
				7.8
			],
			[
				"2004-11-22",
				9.9
			],
			[
				"2005-07-05",
				8.7
			],
			[
				"2005-11-03",
				8.1
			],
			[
				"2006-04-10",
				8.86
			],
			[
				"2006-03-13",
				8.2
			],
			[
				"2006-07-11",
				7.9
			],
			[
				"2006-11-29",
				8.3
			],
			[
				"2007-03-12",
				8.3
			],
			[
				"2007-07-11",
				7.6
			],
			[
				"2007-11-12",
				7.4
			],
			[
				"2008-07-15",
				8.6
			],
			[
				"2008-11-10",
				8.6
			],
			[
				"2010-11-16",
				9.47
			],
			[
				"2011-03-15",
				10.14
			],
			[
				"2011-07-27",
				9.47
			],
			[
				"2011-11-09",
				8.81
			],
			[
				"2012-03-12",
				8.54
			],
			[
				"2012-07-16",
				9.52
			],
			[
				"2012-11-20",
				8.1
			],
			[
				"2013-03-25",
				8.37
			],
			[
				"2013-07-29",
				8.77
			],
			[
				"2013-11-12",
				8.37
			],
			[
				"2014-04-07",
				7.61
			],
			[
				"2014-07-22",
				7.92
			],
			[
				"2014-11-17",
				7.92
			],
			[
				"2015-03-16",
				8.06
			],
			[
				"2015-06-08",
				8.32
			],
			[
				"2015-11-03",
				8.77
			],
			[
				"2008-03-04",
				8.3
			],
			[
				"2009-03-17",
				8.9
			],
			[
				"2009-07-06",
				8.7
			],
			[
				"2009-11-16",
				8.5
			],
			[
				"2010-03-08",
				8.8
			],
			[
				"2010-07-13",
				8.41
			],
			[
				"2008-09-12",
				7.26
			]
		],
		"10409397": [
			[
				"2000-03-20",
				6.6
			],
			[
				"2000-11-13",
				3.99
			],
			[
				"2000-07-18",
				4.5
			],
			[
				"2000-11-07",
				5.1
			],
			[
				"2001-03-12",
				7.4
			],
			[
				"2001-07-12",
				7.4
			],
			[
				"2001-11-12",
				7.2
			],
			[
				"2002-03-05",
				8.9
			],
			[
				"2003-03-10",
				10.8
			],
			[
				"2003-07-14",
				6.9
			],
			[
				"2003-11-24",
				7.5
			],
			[
				"2005-04-05",
				9.9
			],
			[
				"2004-03-02",
				9
			],
			[
				"2004-07-06",
				4.9
			],
			[
				"2004-11-22",
				7.7
			],
			[
				"2005-07-05",
				7.1
			],
			[
				"2005-11-03",
				4.3
			],
			[
				"2006-03-13",
				6.6
			],
			[
				"2006-07-11",
				7.2
			],
			[
				"2007-03-12",
				7
			],
			[
				"2007-07-11",
				8.8
			],
			[
				"2007-04-17",
				8.24
			],
			[
				"2007-11-12",
				4.7
			],
			[
				"2008-07-15",
				5.8
			],
			[
				"2008-11-10",
				4.4
			],
			[
				"2010-11-16",
				9.34
			],
			[
				"2011-03-15",
				11.64
			],
			[
				"2011-07-27",
				10.05
			],
			[
				"2011-11-09",
				9.12
			],
			[
				"2012-03-12",
				13.24
			],
			[
				"2012-07-16",
				14.44
			],
			[
				"2012-11-20",
				12
			],
			[
				"2013-03-25",
				12.35
			],
			[
				"2013-07-29",
				12.26
			],
			[
				"2013-11-12",
				8.77
			],
			[
				"2014-04-07",
				11.33
			],
			[
				"2014-07-22",
				11.16
			],
			[
				"2014-11-17",
				8.68
			],
			[
				"2015-03-16",
				10.31
			],
			[
				"2015-06-08",
				12.04
			],
			[
				"2015-11-03",
				9.25
			],
			[
				"2014-08-11",
				12.44
			],
			[
				"2015-11-12",
				10.19
			],
			[
				"2008-03-04",
				6.7
			],
			[
				"2009-03-17",
				5.7
			],
			[
				"2009-07-06",
				6.2
			],
			[
				"2010-03-08",
				8.2
			],
			[
				"2010-07-13",
				10.31
			],
			[
				"2008-09-12",
				1.33
			],
			[
				"2011-03-14",
				11.82
			],
			[
				"2012-08-28",
				12.4
			]
		],
		"10409403": [
			[
				"2002-08-23",
				16.83
			],
			[
				"2004-02-05",
				26.57
			],
			[
				"2005-09-30",
				17.27
			],
			[
				"2006-01-30",
				20.37
			],
			[
				"2007-01-11",
				32.9
			],
			[
				"2008-04-04",
				18.16
			],
			[
				"2014-12-03",
				4.43
			],
			[
				"2015-09-17",
				5.49
			],
			[
				"2010-11-17",
				8.41
			],
			[
				"2011-05-12",
				5.85
			]
		],
		"10409415": [
			[
				"2000-05-23",
				72.63
			],
			[
				"2001-06-01",
				65.99
			],
			[
				"2002-06-18",
				65.99
			],
			[
				"2003-05-28",
				60.67
			],
			[
				"2005-02-01",
				58.46
			],
			[
				"2004-02-04",
				59.79
			],
			[
				"2006-01-18",
				59.34
			],
			[
				"2007-01-11",
				66.43
			],
			[
				"2008-06-06",
				60.67
			],
			[
				"2014-06-27",
				80.16
			],
			[
				"2015-02-24",
				77.94
			],
			[
				"2016-01-21",
				93
			],
			[
				"2010-03-18",
				60.23
			],
			[
				"2011-03-14",
				62
			],
			[
				"2012-06-25",
				69.09
			],
			[
				"2013-03-28",
				72.19
			]
		],
		"10409488": [
			[
				"2000-07-10",
				36.76
			],
			[
				"2001-05-04",
				36.31
			],
			[
				"2002-05-06",
				27.01
			],
			[
				"2003-06-10",
				33.66
			],
			[
				"2005-03-02",
				33.21
			],
			[
				"2004-02-04",
				36.31
			],
			[
				"2006-01-24",
				36.31
			],
			[
				"2007-01-24",
				35.21
			],
			[
				"2008-04-04",
				35.34
			],
			[
				"2014-04-10",
				32.06
			],
			[
				"2015-03-05",
				30.6
			],
			[
				"2016-01-21",
				30.56
			],
			[
				"2010-03-29",
				32.24
			],
			[
				"2011-06-10",
				32.42
			],
			[
				"2012-04-19",
				29.1
			],
			[
				"2013-03-28",
				29.58
			]
		],
		"10409580": [
			[
				"2000-05-23",
				31.44
			],
			[
				"2001-05-10",
				25.24
			],
			[
				"2002-06-18",
				30.11
			],
			[
				"2003-04-28",
				32.33
			],
			[
				"2005-03-02",
				28.79
			],
			[
				"2004-02-03",
				28.34
			],
			[
				"2006-02-09",
				31.89
			],
			[
				"2007-01-18",
				26.75
			],
			[
				"2008-06-06",
				26.22
			],
			[
				"2013-07-18",
				14.17
			],
			[
				"2015-11-17",
				11.2
			],
			[
				"2010-04-15",
				12.93
			],
			[
				"2011-10-27",
				14.97
			]
		],
		"10409609": [
			[
				"2000-04-10",
				10.63
			],
			[
				"2001-05-04",
				12.4
			],
			[
				"2002-05-06",
				14.17
			],
			[
				"2003-10-17",
				9.74
			],
			[
				"2004-02-04",
				17.27
			],
			[
				"2005-03-11",
				12.4
			],
			[
				"2006-01-16",
				12.4
			],
			[
				"2007-01-26",
				17.09
			],
			[
				"2008-04-02",
				13.02
			],
			[
				"2013-05-03",
				6.55
			],
			[
				"2014-04-03",
				7.53
			],
			[
				"2015-11-17",
				4.07
			],
			[
				"2010-03-11",
				12.4
			],
			[
				"2011-05-12",
				9.43
			],
			[
				"2012-03-15",
				8.06
			]
		],
		"10409610": [
			[
				"2000-04-10",
				21.7
			],
			[
				"2001-05-04",
				22.14
			],
			[
				"2002-05-06",
				19.04
			],
			[
				"2003-04-28",
				19.49
			],
			[
				"2005-03-02",
				18.6
			],
			[
				"2004-01-29",
				19.93
			],
			[
				"2006-01-16",
				15.06
			],
			[
				"2007-01-25",
				18.82
			],
			[
				"2008-04-02",
				19.13
			],
			[
				"2014-10-23",
				15.15
			],
			[
				"2015-12-10",
				15.19
			],
			[
				"2010-03-11",
				17.18
			],
			[
				"2011-04-08",
				16.92
			],
			[
				"2012-03-15",
				16.74
			],
			[
				"2013-03-04",
				16.16
			]
		],
		"10409622": [
			[
				"2004-02-06",
				17.71
			],
			[
				"2005-03-11",
				15.94
			],
			[
				"2006-01-24",
				17.71
			],
			[
				"2007-01-18",
				16.39
			],
			[
				"2008-06-06",
				15.19
			],
			[
				"2013-11-28",
				12.71
			],
			[
				"2014-02-20",
				12.4
			],
			[
				"2015-12-10",
				12.53
			],
			[
				"2016-01-25",
				12.4
			],
			[
				"2010-11-17",
				13.73
			]
		],
		"10409646": [
			[
				"2000-03-30",
				15.94
			],
			[
				"2001-05-03",
				21.26
			],
			[
				"2002-07-09",
				19.49
			],
			[
				"2003-05-28",
				22.59
			],
			[
				"2004-02-04",
				23.91
			],
			[
				"2005-03-11",
				25.24
			],
			[
				"2007-02-07",
				23.69
			],
			[
				"2007-04-17",
				20.06
			],
			[
				"2008-04-04",
				25.11
			],
			[
				"2015-04-16",
				18.25
			],
			[
				"2010-04-29",
				14.79
			],
			[
				"2011-04-28",
				18.56
			],
			[
				"2013-03-04",
				22.01
			]
		],
		"10409658": [
			[
				"2000-07-10",
				45.61
			],
			[
				"2001-05-03",
				45.17
			],
			[
				"2002-05-06",
				46.5
			],
			[
				"2003-05-28",
				52.26
			],
			[
				"2004-02-03",
				54.91
			],
			[
				"2005-06-20",
				50.04
			],
			[
				"2006-01-16",
				57.13
			],
			[
				"2007-01-05",
				32.46
			],
			[
				"2008-03-31",
				41.01
			],
			[
				"2014-04-10",
				35.52
			],
			[
				"2015-04-16",
				29.05
			],
			[
				"2016-01-27",
				31.89
			],
			[
				"2009-08-27",
				42.03
			],
			[
				"2011-03-31",
				37.64
			],
			[
				"2012-04-26",
				39.55
			],
			[
				"2013-03-04",
				35.07
			]
		],
		"10409671": [
			[
				"2000-08-23",
				5.31
			],
			[
				"2001-05-10",
				4.43
			],
			[
				"2002-08-23",
				4.87
			],
			[
				"2003-06-10",
				4.43
			],
			[
				"2005-02-28",
				4.87
			],
			[
				"2004-02-06",
				5.31
			],
			[
				"2006-01-25",
				5.31
			],
			[
				"2007-01-24",
				6.02
			],
			[
				"2008-03-19",
				9.74
			],
			[
				"2014-10-23",
				4.43
			],
			[
				"2015-11-24",
				3.99
			],
			[
				"2016-01-20",
				3.94
			],
			[
				"2009-03-13",
				6.86
			],
			[
				"2011-02-17",
				4.3
			],
			[
				"2012-04-26",
				4.21
			],
			[
				"2013-03-22",
				3.76
			]
		],
		"10409683": [
			[
				"2006-10-18",
				76.17
			],
			[
				"2008-03-31",
				80.16
			],
			[
				"2013-05-03",
				79.71
			],
			[
				"2015-04-16",
				81.04
			],
			[
				"2010-04-22",
				75.73
			],
			[
				"2011-07-21",
				77.94
			],
			[
				"2012-04-19",
				79.27
			]
		],
		"10409695": [
			[
				"2000-08-31",
				9.3
			],
			[
				"2001-08-01",
				10.19
			],
			[
				"2002-10-09",
				6.2
			],
			[
				"2003-07-02",
				7.97
			],
			[
				"2005-02-28",
				37.2
			],
			[
				"2004-03-12",
				12.4
			],
			[
				"2006-01-25",
				3.54
			],
			[
				"2007-01-24",
				10.81
			],
			[
				"2008-04-29",
				26.97
			],
			[
				"2013-08-02",
				8.41
			],
			[
				"2014-08-04",
				15.15
			],
			[
				"2015-02-09",
				22.1
			],
			[
				"2016-01-20",
				9.3
			],
			[
				"2010-05-31",
				12.75
			],
			[
				"2011-09-12",
				7.4
			],
			[
				"2012-11-22",
				3.85
			]
		],
		"10409701": [
			[
				"2000-05-23",
				37.2
			],
			[
				"2001-08-01",
				38.09
			],
			[
				"2002-06-18",
				40.3
			],
			[
				"2003-07-03",
				37.64
			],
			[
				"2003-10-17",
				37.64
			],
			[
				"2005-02-28",
				34.1
			],
			[
				"2004-03-12",
				37.2
			],
			[
				"2006-02-06",
				37.2
			],
			[
				"2007-01-11",
				36.85
			],
			[
				"2008-04-29",
				39.46
			],
			[
				"2014-06-27",
				30.38
			],
			[
				"2015-02-24",
				30.38
			],
			[
				"2010-03-04",
				32.55
			],
			[
				"2011-10-27",
				33.04
			],
			[
				"2012-11-22",
				31.49
			],
			[
				"2013-03-07",
				32.77
			]
		],
		"10409865": [
			[
				"2000-04-10",
				17.71
			],
			[
				"2001-07-16",
				17.27
			],
			[
				"2002-07-02",
				17.71
			],
			[
				"2003-06-10",
				14.61
			],
			[
				"2005-03-10",
				15.06
			],
			[
				"2004-02-02",
				16.39
			],
			[
				"2006-01-24",
				14.61
			],
			[
				"2007-01-09",
				15.1
			],
			[
				"2008-01-09",
				21.39
			],
			[
				"2013-06-18",
				13.33
			],
			[
				"2014-04-03",
				13.24
			],
			[
				"2015-04-16",
				13.64
			],
			[
				"2016-01-21",
				10.63
			],
			[
				"2009-12-07",
				25.51
			],
			[
				"2011-04-08",
				19.13
			],
			[
				"2012-03-22",
				17.36
			]
		],
		"10409919": [
			[
				"2000-07-13",
				43.4
			],
			[
				"2001-07-30",
				41.19
			],
			[
				"2002-08-22",
				36.31
			],
			[
				"2003-06-11",
				42.07
			],
			[
				"2005-03-09",
				53.59
			],
			[
				"2004-02-03",
				67.31
			],
			[
				"2006-01-18",
				56.24
			],
			[
				"2007-01-26",
				63.77
			],
			[
				"2008-04-02",
				62.44
			],
			[
				"2013-05-03",
				60.67
			],
			[
				"2014-04-03",
				54.47
			],
			[
				"2015-03-09",
				54.47
			],
			[
				"2010-04-15",
				46.06
			],
			[
				"2011-05-12",
				47.83
			],
			[
				"2012-03-29",
				65.1
			]
		],
		"10409920": [
			[
				"2001-07-26",
				14.61
			],
			[
				"2006-04-05",
				17.27
			],
			[
				"2007-01-05",
				12.31
			],
			[
				"2008-03-25",
				14.35
			],
			[
				"2015-04-16",
				4.83
			],
			[
				"2000-04-19",
				11.96
			],
			[
				"2009-08-27",
				7.57
			],
			[
				"2011-05-20",
				6.55
			]
		],
		"10409956": [
			[
				"2000-07-18",
				23.91
			],
			[
				"2001-07-26",
				17.71
			],
			[
				"2002-08-22",
				20.37
			],
			[
				"2005-03-07",
				23.47
			],
			[
				"2004-02-03",
				27.46
			],
			[
				"2006-01-19",
				27.01
			],
			[
				"2007-01-09",
				29.54
			],
			[
				"2008-03-18",
				26
			],
			[
				"2014-07-14",
				39.41
			],
			[
				"2015-02-18",
				34.81
			],
			[
				"2003-07-01",
				19.04
			],
			[
				"2009-03-13",
				20.06
			],
			[
				"2009-08-06",
				16.56
			],
			[
				"2011-02-17",
				20.55
			],
			[
				"2012-03-22",
				23.65
			],
			[
				"2013-03-07",
				25.86
			]
		],
		"10409968": [
			[
				"2000-07-18",
				24.36
			],
			[
				"2001-07-26",
				14.17
			],
			[
				"2002-08-22",
				13.73
			],
			[
				"2005-03-10",
				23.91
			],
			[
				"2004-02-12",
				52.26
			],
			[
				"2006-03-03",
				26.13
			],
			[
				"2007-01-09",
				39.81
			],
			[
				"2008-03-18",
				42.29
			],
			[
				"2015-02-18",
				30.2
			],
			[
				"2003-07-01",
				6.2
			],
			[
				"2010-03-04",
				42.82
			],
			[
				"2011-03-10",
				40.08
			],
			[
				"2012-03-22",
				39.86
			],
			[
				"2013-03-07",
				42.07
			]
		],
		"10409993": [
			[
				"2003-06-11",
				13.29
			],
			[
				"2005-03-07",
				13.29
			],
			[
				"2004-02-02",
				13.73
			],
			[
				"2006-02-06",
				15.06
			],
			[
				"2007-01-23",
				17.01
			],
			[
				"2008-01-28",
				16.96
			],
			[
				"2015-06-18",
				11.07
			],
			[
				"2011-07-21",
				11.82
			],
			[
				"2012-12-06",
				11.12
			]
		],
		"10410004": [
			[
				"2004-02-02",
				13.73
			],
			[
				"2006-01-18",
				16.83
			],
			[
				"2007-01-25",
				14.39
			],
			[
				"2008-08-25",
				11.47
			],
			[
				"2015-12-10",
				10.94
			],
			[
				"2010-03-25",
				10.41
			]
		],
		"10410030": [
			[
				"2004-02-05",
				11.51
			],
			[
				"2005-06-20",
				10.63
			],
			[
				"2006-02-23",
				12.84
			],
			[
				"2007-04-27",
				11.25
			],
			[
				"2008-03-31",
				16.21
			],
			[
				"2013-06-25",
				8.68
			],
			[
				"2015-09-17",
				8.68
			],
			[
				"2000-04-19",
				11.07
			],
			[
				"2010-11-17",
				10.58
			],
			[
				"2011-10-27",
				8.24
			],
			[
				"2012-11-22",
				8.77
			]
		],
		"10410041": [
			[
				"2000-07-13",
				31.44
			],
			[
				"2001-07-30",
				26.57
			],
			[
				"2002-08-19",
				23.91
			],
			[
				"2003-06-11",
				23.47
			],
			[
				"2005-03-10",
				23.47
			],
			[
				"2004-02-05",
				26.57
			],
			[
				"2006-03-09",
				27.9
			],
			[
				"2007-01-25",
				44.29
			],
			[
				"2008-04-04",
				36.76
			],
			[
				"2013-06-25",
				21.43
			],
			[
				"2015-08-12",
				20.46
			],
			[
				"2016-01-25",
				26.57
			],
			[
				"2011-12-23",
				19
			],
			[
				"2012-11-22",
				22.14
			]
		],
		"10410053": [
			[
				"2000-04-10",
				24.8
			],
			[
				"2001-06-27",
				26.13
			],
			[
				"2002-06-18",
				25.69
			],
			[
				"2003-10-20",
				28.34
			],
			[
				"2005-03-10",
				20.37
			],
			[
				"2004-02-11",
				19.04
			],
			[
				"2006-01-24",
				25.24
			],
			[
				"2007-01-11",
				21.79
			],
			[
				"2008-04-07",
				25.15
			],
			[
				"2014-08-11",
				14.35
			],
			[
				"2015-03-05",
				20.19
			],
			[
				"2010-03-29",
				18.82
			],
			[
				"2011-04-28",
				21.83
			],
			[
				"2012-03-29",
				22.14
			],
			[
				"2013-03-28",
				16.87
			]
		],
		"10410077": [
			[
				"2001-06-27",
				1.33
			],
			[
				"2003-07-24",
				0.44
			],
			[
				"2005-03-03",
				0.44
			],
			[
				"2004-02-11",
				1.77
			],
			[
				"2006-02-20",
				0.44
			],
			[
				"2007-01-05",
				0.44
			],
			[
				"2008-03-19",
				1.73
			],
			[
				"2013-07-19",
				84.14
			],
			[
				"2014-07-31",
				1.33
			],
			[
				"2015-10-28",
				0.13
			],
			[
				"2016-01-21",
				0.44
			],
			[
				"2010-09-17",
				0.35
			],
			[
				"2011-03-10",
				0.27
			],
			[
				"2012-06-11",
				0.31
			]
		],
		"10410089": [
			[
				"2001-06-27",
				11.07
			],
			[
				"2002-08-19",
				8.41
			],
			[
				"2004-02-12",
				8.86
			],
			[
				"2005-06-20",
				9.74
			],
			[
				"2006-03-03",
				11.07
			],
			[
				"2007-01-23",
				9.43
			],
			[
				"2008-03-31",
				7.04
			],
			[
				"2015-11-17",
				5.23
			],
			[
				"2000-04-19",
				8.86
			],
			[
				"2010-09-16",
				6.86
			]
		],
		"10410090": [
			[
				"2000-08-23",
				15.94
			],
			[
				"2001-06-01",
				16.39
			],
			[
				"2002-08-19",
				12.84
			],
			[
				"2003-06-11",
				14.17
			],
			[
				"2005-03-08",
				19.93
			],
			[
				"2004-02-05",
				25.69
			],
			[
				"2006-02-06",
				19.49
			],
			[
				"2007-01-25",
				22.05
			],
			[
				"2008-05-29",
				14.88
			],
			[
				"2014-02-20",
				12.36
			],
			[
				"2015-06-18",
				11.34
			],
			[
				"2016-01-25",
				12.4
			],
			[
				"2010-06-10",
				13.2
			],
			[
				"2011-05-20",
				12.49
			],
			[
				"2012-06-11",
				12.44
			],
			[
				"2013-03-08",
				11.2
			]
		],
		"10410132": [
			[
				"2000-11-10",
				30.11
			],
			[
				"2001-08-02",
				26.13
			],
			[
				"2003-07-24",
				16.83
			],
			[
				"2004-06-18",
				13.73
			],
			[
				"2005-07-19",
				18.6
			],
			[
				"2007-03-28",
				25.46
			],
			[
				"2008-03-19",
				19.97
			],
			[
				"2014-07-14",
				17.18
			],
			[
				"2015-02-18",
				17.36
			],
			[
				"2006-03-31",
				37.2
			],
			[
				"2010-09-02",
				17.23
			],
			[
				"2011-03-10",
				17.71
			],
			[
				"2012-06-11",
				17.71
			],
			[
				"2013-03-08",
				16.7
			]
		],
		"10410193": [
			[
				"2005-03-03",
				18.16
			],
			[
				"2004-07-05",
				20.81
			],
			[
				"2006-01-30",
				20.37
			],
			[
				"2007-01-26",
				19.4
			],
			[
				"2008-04-02",
				18.42
			],
			[
				"2008-06-06",
				19.57
			],
			[
				"2014-02-20",
				15.01
			],
			[
				"2015-03-09",
				15.1
			],
			[
				"2016-01-25",
				15.5
			],
			[
				"2009-09-25",
				16.08
			],
			[
				"2011-02-07",
				15.72
			],
			[
				"2012-04-19",
				16.12
			],
			[
				"2013-03-08",
				15.32
			]
		],
		"10410211": [
			[
				"2004-07-05",
				12.4
			],
			[
				"2005-03-09",
				17.71
			],
			[
				"2006-03-09",
				23.03
			],
			[
				"2007-01-23",
				26.84
			],
			[
				"2008-03-31",
				25.86
			],
			[
				"2015-11-17",
				10.81
			],
			[
				"2010-09-24",
				17.45
			],
			[
				"2011-10-07",
				8.99
			],
			[
				"2012-12-21",
				17.32
			]
		],
		"10410235": [
			[
				"2006-11-30",
				16.56
			],
			[
				"2007-03-28",
				16.52
			],
			[
				"2008-10-21",
				12.84
			],
			[
				"2013-07-19",
				11.07
			],
			[
				"2014-07-14",
				12.27
			],
			[
				"2015-02-18",
				10.01
			],
			[
				"2009-08-06",
				2.92
			],
			[
				"2011-07-21",
				12.22
			]
		],
		"10410247": [
			[
				"2006-11-30",
				17.49
			],
			[
				"2007-03-29",
				16.47
			],
			[
				"2008-10-21",
				16.25
			],
			[
				"2015-10-28",
				10.98
			],
			[
				"2010-09-02",
				13.55
			],
			[
				"2011-12-16",
				12.93
			]
		],
		"10421361": [
			[
				"2014-06-24",
				3.8
			],
			[
				"2014-10-21",
				4.4
			],
			[
				"2015-06-10",
				7.2
			],
			[
				"2015-08-26",
				4.7
			],
			[
				"2003-08-13",
				3
			],
			[
				"2005-11-16",
				1.7
			],
			[
				"2006-10-18",
				3.5
			],
			[
				"2007-03-20",
				5.3
			],
			[
				"2006-12-06",
				2
			],
			[
				"2007-11-06",
				4.5
			],
			[
				"2008-06-24",
				8.1
			],
			[
				"2008-10-28",
				6.5
			],
			[
				"2009-10-31",
				8.9
			],
			[
				"2009-11-17",
				3
			],
			[
				"2010-11-09",
				4.6
			],
			[
				"2011-05-11",
				8.9
			],
			[
				"2011-09-28",
				5.5
			],
			[
				"2012-05-08",
				7.3
			],
			[
				"2012-10-24",
				3.2
			]
		],
		"10421373": [
			[
				"2003-05-13",
				31.44
			],
			[
				"2004-10-06",
				33.21
			],
			[
				"2014-10-21",
				29.31
			],
			[
				"2015-06-10",
				27.71
			],
			[
				"2015-08-26",
				23.71
			],
			[
				"2003-08-13",
				22.61
			],
			[
				"2004-05-11",
				32.01
			],
			[
				"2005-11-16",
				22.91
			],
			[
				"2006-12-06",
				30.61
			],
			[
				"2007-03-20",
				32.81
			],
			[
				"2007-11-06",
				32.41
			],
			[
				"2008-06-24",
				31.51
			],
			[
				"2008-10-29",
				30.51
			],
			[
				"2009-03-31",
				32.21
			],
			[
				"2010-04-14",
				31.31
			],
			[
				"2010-11-09",
				30.81
			],
			[
				"2011-05-11",
				29.91
			],
			[
				"2011-08-28",
				31.51
			],
			[
				"2012-05-08",
				30.81
			],
			[
				"2012-10-24",
				30.51
			]
		],
		"10421397": [
			[
				"2003-05-13",
				36.31
			],
			[
				"2004-10-07",
				33.21
			],
			[
				"2014-06-24",
				24.91
			],
			[
				"2014-10-21",
				24.01
			],
			[
				"2015-06-10",
				24.21
			],
			[
				"2015-08-26",
				24.11
			],
			[
				"2003-08-13",
				36.21
			],
			[
				"2004-05-11",
				36.21
			],
			[
				"2005-11-23",
				34.11
			],
			[
				"2006-10-18",
				31.01
			],
			[
				"2007-03-21",
				32.61
			],
			[
				"2007-11-06",
				32.51
			],
			[
				"2008-06-25",
				29.21
			],
			[
				"2008-10-28",
				28.91
			],
			[
				"2009-03-31",
				29.51
			],
			[
				"2009-11-17",
				28.01
			],
			[
				"2010-04-13",
				27.51
			],
			[
				"2011-07-27",
				27.51
			],
			[
				"2011-09-27",
				28.71
			],
			[
				"2012-05-09",
				27.21
			],
			[
				"2012-10-23",
				27.71
			]
		],
		"10421403": [
			[
				"2014-10-21",
				2.8
			],
			[
				"2015-06-10",
				4.6
			],
			[
				"2015-08-26",
				4.7
			],
			[
				"2003-08-20",
				3.3
			],
			[
				"2005-11-23",
				1.4
			],
			[
				"2006-12-06",
				1.2
			],
			[
				"2007-03-21",
				4.6
			],
			[
				"2007-11-07",
				3
			],
			[
				"2006-06-24",
				109.04
			],
			[
				"2008-10-29",
				4.2
			],
			[
				"2009-03-31",
				3
			],
			[
				"2010-04-14",
				3.2
			],
			[
				"2010-11-09",
				1.5
			],
			[
				"2011-05-10",
				4.3
			],
			[
				"2011-09-28",
				3.8
			],
			[
				"2012-05-09",
				6.6
			],
			[
				"2012-10-24",
				4
			]
		],
		"10421415": [
			[
				"2003-05-15",
				238.26
			],
			[
				"2014-06-24",
				154.05
			],
			[
				"2014-10-21",
				2.2
			],
			[
				"2015-06-10",
				144.05
			],
			[
				"2015-08-26",
				114.04
			],
			[
				"2003-08-20",
				231.08
			],
			[
				"2003-10-30",
				225.08
			],
			[
				"2004-12-08",
				183.06
			],
			[
				"2005-11-23",
				164.06
			],
			[
				"2006-10-18",
				115.04
			],
			[
				"2007-03-21",
				6
			],
			[
				"2007-11-06",
				85.03
			],
			[
				"2008-06-25",
				5.3
			],
			[
				"2008-10-28",
				130.05
			],
			[
				"2009-04-01",
				99.24
			],
			[
				"2009-11-18",
				157.06
			],
			[
				"2010-04-13",
				159.06
			],
			[
				"2010-11-10",
				25.81
			],
			[
				"2011-05-10",
				186.07
			],
			[
				"2011-09-27",
				169.06
			],
			[
				"2012-05-08",
				178.06
			],
			[
				"2012-10-23",
				180.06
			]
		],
		"10421427": [
			[
				"2003-05-15",
				27.9
			],
			[
				"2014-06-24",
				21.31
			],
			[
				"2014-10-21",
				25.01
			],
			[
				"2015-06-10",
				23.51
			],
			[
				"2015-08-26",
				25.41
			],
			[
				"2003-08-20",
				26.21
			],
			[
				"2004-12-08",
				15.71
			],
			[
				"2005-11-23",
				9.3
			],
			[
				"2006-10-18",
				14.11
			],
			[
				"2007-03-21",
				18.01
			],
			[
				"2007-11-07",
				20.71
			],
			[
				"2008-06-25",
				30.11
			],
			[
				"2008-10-29",
				27.71
			],
			[
				"2009-11-18",
				54.32
			],
			[
				"2010-04-13",
				33.51
			],
			[
				"2009-04-01",
				31.21
			],
			[
				"2010-11-10",
				17.11
			],
			[
				"2011-05-10",
				38.21
			],
			[
				"2011-09-27",
				23.71
			],
			[
				"2012-05-08",
				27.31
			],
			[
				"2012-10-23",
				26.81
			]
		],
		"10421439": [
			[
				"2003-05-13",
				16.83
			],
			[
				"2004-10-07",
				0.89
			],
			[
				"2014-06-24",
				0.7
			],
			[
				"2014-10-21",
				173.06
			],
			[
				"2015-06-10",
				25.31
			],
			[
				"2015-08-26",
				10.1
			],
			[
				"2003-08-20",
				2.4
			],
			[
				"2005-11-16",
				1.4
			],
			[
				"2006-10-18",
				9.6
			],
			[
				"2007-03-20",
				7.2
			],
			[
				"2007-11-06",
				16.81
			],
			[
				"2008-06-24",
				34.21
			],
			[
				"2008-10-28",
				30.31
			],
			[
				"2009-04-01",
				52.72
			],
			[
				"2009-11-17",
				21.21
			],
			[
				"2010-04-13",
				23.01
			],
			[
				"2010-11-10",
				162.06
			],
			[
				"2011-05-10",
				26.31
			],
			[
				"2011-09-27",
				13.5
			],
			[
				"2012-05-09",
				15.81
			],
			[
				"2012-10-23",
				3.1
			]
		],
		"10424120": [
			[
				"2011-11-15",
				0.2
			],
			[
				"2012-03-05",
				0.2
			],
			[
				"2012-11-13",
				0.2
			],
			[
				"2013-03-05",
				0.2
			],
			[
				"2013-11-13",
				0.2
			],
			[
				"2014-04-08",
				0.2
			],
			[
				"2014-12-01",
				0.2
			],
			[
				"2015-03-18",
				0.89
			]
		],
		"10424167": [
			[
				"2011-11-15",
				0.2
			],
			[
				"2012-03-05",
				0.2
			],
			[
				"2012-11-13",
				0.2
			],
			[
				"2013-03-05",
				0.2
			],
			[
				"2013-11-13",
				0.2
			],
			[
				"2014-04-08",
				0.2
			],
			[
				"2015-03-18",
				0.89
			]
		],
		"10424210": [
			[
				"2011-11-30",
				0.2
			],
			[
				"2012-03-05",
				0.2
			],
			[
				"2012-11-13",
				0.2
			],
			[
				"2013-03-05",
				0.2
			],
			[
				"2013-11-13",
				0.2
			],
			[
				"2014-04-08",
				0.2
			],
			[
				"2014-12-01",
				0.2
			],
			[
				"2015-03-18",
				0.89
			]
		],
		"11002268": [
			[
				"2000-02-28",
				44.73
			],
			[
				"2001-07-23",
				48.27
			],
			[
				"2002-09-26",
				50.04
			],
			[
				"2003-04-11",
				47.83
			],
			[
				"2004-02-10",
				50.04
			],
			[
				"2005-04-22",
				52.7
			],
			[
				"2006-08-29",
				46.94
			],
			[
				"2006-11-07",
				46.94
			],
			[
				"2008-03-20",
				60.23
			],
			[
				"2013-04-26",
				54.03
			],
			[
				"2014-03-24",
				50.04
			],
			[
				"2015-03-26",
				50.93
			],
			[
				"2016-02-29",
				44.29
			],
			[
				"2009-05-15",
				50.04
			],
			[
				"2011-01-21",
				45.61
			],
			[
				"2012-05-11",
				54.03
			],
			[
				"2012-10-19",
				49.6
			]
		],
		"11005154": [
			[
				"2000-02-24",
				77.06
			],
			[
				"2001-07-12",
				81.49
			],
			[
				"2002-08-26",
				85.91
			],
			[
				"2003-08-14",
				88.13
			],
			[
				"2003-06-03",
				81.03
			],
			[
				"2004-03-25",
				85.43
			],
			[
				"2004-01-15",
				101.86
			],
			[
				"2005-06-28",
				99.2
			],
			[
				"2005-05-13",
				92.13
			],
			[
				"2006-03-13",
				97.43
			],
			[
				"2006-06-19",
				89.43
			],
			[
				"2008-09-16",
				86.36
			],
			[
				"2010-06-09",
				75.29
			],
			[
				"2011-08-16",
				91.22
			],
			[
				"2012-07-16",
				76.61
			],
			[
				"2013-11-05",
				85.02
			],
			[
				"2014-05-19",
				75.73
			],
			[
				"2015-08-24",
				85.91
			],
			[
				"2013-04-19",
				59.34
			],
			[
				"2013-08-27",
				84.14
			],
			[
				"2014-08-13",
				80.6
			],
			[
				"2008-09-23",
				88.13
			],
			[
				"2011-06-06",
				81.93
			],
			[
				"2012-08-24",
				73.07
			]
		],
		"11006936": [
			[
				"2000-02-25",
				40.74
			],
			[
				"2001-06-07",
				22.59
			],
			[
				"2002-08-26",
				17.27
			],
			[
				"2003-08-13",
				17.27
			],
			[
				"2004-01-22",
				31.89
			],
			[
				"2005-06-16",
				22.59
			],
			[
				"2006-02-24",
				31
			],
			[
				"2007-03-08",
				22.67
			],
			[
				"2008-03-28",
				25.6
			],
			[
				"2008-09-29",
				10.36
			],
			[
				"2013-09-18",
				9.3
			],
			[
				"2015-11-19",
				8.46
			],
			[
				"2010-04-16",
				13.77
			],
			[
				"2010-09-10",
				11.56
			],
			[
				"2011-05-27",
				12
			],
			[
				"2011-09-23",
				9.03
			],
			[
				"2012-03-23",
				25.64
			]
		],
		"11006985": [
			[
				"2000-02-02",
				0.44
			],
			[
				"2001-03-21",
				0.44
			],
			[
				"2002-03-12",
				0.44
			],
			[
				"2003-08-12",
				2.66
			],
			[
				"2004-01-20",
				4.87
			],
			[
				"2005-06-21",
				4.43
			],
			[
				"2006-02-17",
				3.1
			],
			[
				"2007-03-07",
				1.51
			],
			[
				"2008-07-11",
				0.44
			],
			[
				"2013-09-18",
				6.64
			],
			[
				"2014-04-09",
				3.85
			],
			[
				"2015-09-07",
				2.26
			],
			[
				"2016-01-26",
				5.31
			],
			[
				"2010-09-13",
				58.9
			],
			[
				"2011-03-11",
				1.06
			],
			[
				"2012-03-23",
				0.93
			]
		],
		"11007023": [
			[
				"2000-11-29",
				80.6
			],
			[
				"2001-03-22",
				73.51
			],
			[
				"2002-03-19",
				95.66
			],
			[
				"2004-01-27",
				108.06
			],
			[
				"2005-06-29",
				93
			],
			[
				"2006-03-07",
				138.17
			],
			[
				"2007-03-19",
				120.01
			],
			[
				"2007-02-23",
				117.36
			],
			[
				"2008-01-24",
				116.47
			],
			[
				"2008-09-29",
				94.33
			],
			[
				"2013-10-10",
				70.86
			],
			[
				"2015-08-10",
				52.26
			],
			[
				"2016-01-26",
				79.71
			],
			[
				"2011-05-27",
				85.47
			],
			[
				"2011-09-23",
				73.51
			],
			[
				"2012-08-24",
				69.09
			]
		],
		"11050020": [
			[
				"2000-02-03",
				3.54
			],
			[
				"2001-03-22",
				14.17
			],
			[
				"2002-03-12",
				5.76
			],
			[
				"2003-08-14",
				4.87
			],
			[
				"2004-01-20",
				5.76
			],
			[
				"2005-03-29",
				3.99
			],
			[
				"2006-03-06",
				10.63
			],
			[
				"2007-03-07",
				2.08
			],
			[
				"2008-07-10",
				5.14
			],
			[
				"2013-09-19",
				5.58
			],
			[
				"2015-08-10",
				2.21
			],
			[
				"2016-01-27",
				4.07
			],
			[
				"2010-04-16",
				4.65
			],
			[
				"2010-09-10",
				0.13
			]
		],
		"11050093": [
			[
				"2000-02-29",
				62.89
			],
			[
				"2001-04-19",
				72.19
			],
			[
				"2002-03-19",
				86.36
			],
			[
				"2004-01-15",
				77.94
			],
			[
				"2005-07-15",
				77.5
			],
			[
				"2006-03-06",
				58.9
			],
			[
				"2007-01-08",
				52.7
			],
			[
				"2008-07-08",
				70.86
			],
			[
				"2013-09-19",
				29.63
			],
			[
				"2014-04-09",
				44.29
			],
			[
				"2015-05-20",
				74.84
			],
			[
				"2011-11-14",
				53.59
			],
			[
				"2012-11-23",
				25.02
			]
		],
		"16000614": [
			[
				"2000-08-17",
				1.77
			],
			[
				"2001-06-26",
				1.77
			],
			[
				"2002-08-14",
				0.44
			],
			[
				"2003-08-21",
				0.89
			],
			[
				"2004-02-09",
				0.44
			],
			[
				"2005-07-01",
				0.44
			],
			[
				"2006-08-15",
				0.44
			],
			[
				"2007-01-12",
				0.44
			],
			[
				"2008-03-20",
				2.97
			],
			[
				"2014-05-15",
				14.22
			],
			[
				"2015-05-07",
				12
			],
			[
				"2009-03-23",
				12.4
			],
			[
				"2011-05-30",
				14.92
			],
			[
				"2012-06-15",
				19.97
			]
		],
		"16000651": [
			[
				"2000-08-17",
				16.39
			],
			[
				"2001-06-26",
				16.83
			],
			[
				"2002-08-14",
				15.06
			],
			[
				"2003-08-21",
				17.27
			],
			[
				"2004-02-09",
				13.29
			],
			[
				"2005-07-01",
				8.86
			],
			[
				"2006-08-15",
				10.27
			],
			[
				"2007-01-12",
				12.27
			],
			[
				"2008-03-20",
				6.91
			],
			[
				"2013-06-14",
				6.91
			],
			[
				"2014-05-15",
				10.94
			],
			[
				"2015-05-07",
				8.64
			],
			[
				"2009-03-23",
				15.23
			],
			[
				"2011-04-15",
				6.24
			],
			[
				"2012-04-16",
				11.43
			]
		],
		"16000997": [
			[
				"2008-09-15",
				138.17
			],
			[
				"2013-06-14",
				100.53
			],
			[
				"2014-05-15",
				103.63
			],
			[
				"2015-04-20",
				100.09
			],
			[
				"2009-03-23",
				124.44
			],
			[
				"2011-04-15",
				122.23
			],
			[
				"2012-04-16",
				111.16
			]
		],
		"16001606": [
			[
				"2012-11-26",
				100.53
			],
			[
				"2013-11-20",
				98.76
			],
			[
				"2014-08-19",
				90.78
			],
			[
				"2000-09-06",
				85.47
			],
			[
				"2000-09-19",
				88.57
			],
			[
				"2000-10-04",
				85.03
			],
			[
				"2000-11-06",
				85.91
			],
			[
				"2000-12-04",
				89.46
			],
			[
				"2001-01-10",
				88.57
			],
			[
				"2001-02-07",
				84.59
			],
			[
				"2001-03-05",
				85.91
			],
			[
				"2001-04-10",
				87.69
			],
			[
				"2001-06-05",
				80.6
			],
			[
				"2001-07-04",
				92.11
			],
			[
				"2001-08-21",
				94.77
			],
			[
				"2004-10-20",
				30.11
			],
			[
				"2005-11-16",
				75.29
			],
			[
				"2006-10-12",
				79.71
			],
			[
				"2014-10-06",
				110.27
			],
			[
				"2015-09-07",
				106.73
			],
			[
				"2016-01-26",
				106.29
			],
			[
				"2008-04-25",
				94.33
			],
			[
				"2010-02-09",
				105.84
			],
			[
				"2010-07-05",
				97.86
			],
			[
				"2011-02-17",
				109.39
			],
			[
				"2012-03-06",
				109.83
			]
		],
		"16001813": [
			[
				"2001-10-15",
				86.8
			],
			[
				"2003-11-10",
				21.83
			],
			[
				"2002-10-17",
				21.04
			],
			[
				"2004-11-09",
				19.93
			],
			[
				"2004-10-09",
				19.93
			],
			[
				"2005-11-04",
				20.37
			],
			[
				"2006-10-10",
				19.13
			],
			[
				"2007-10-11",
				19.26
			],
			[
				"2008-10-22",
				22.23
			],
			[
				"2009-10-30",
				22.54
			],
			[
				"2010-10-29",
				22.14
			],
			[
				"2011-10-21",
				22.14
			],
			[
				"2012-10-18",
				13.29
			],
			[
				"2013-11-04",
				12.84
			],
			[
				"2014-11-24",
				15.94
			],
			[
				"2015-11-23",
				20.37
			]
		],
		"16003706": [
			[
				"2007-03-20",
				14.39
			],
			[
				"2013-04-26",
				22.72
			],
			[
				"2014-03-10",
				27.1
			],
			[
				"2015-03-26",
				18.25
			],
			[
				"2008-12-17",
				9.7
			],
			[
				"2008-07-09",
				10.72
			],
			[
				"2009-07-20",
				20.02
			],
			[
				"2011-01-31",
				12
			],
			[
				"2012-06-15",
				33.52
			]
		],
		"16003998": [
			[
				"2008-09-18",
				28.65
			],
			[
				"2013-05-27",
				25.82
			],
			[
				"2015-02-11",
				23.96
			],
			[
				"2016-01-27",
				23.03
			],
			[
				"2009-08-17",
				24.67
			],
			[
				"2011-11-04",
				22.67
			]
		],
		"20002129": [
			[
				"2000-11-29",
				128.43
			],
			[
				"2001-04-06",
				119.57
			],
			[
				"2001-10-23",
				112.49
			],
			[
				"2002-10-31",
				108.06
			],
			[
				"2002-09-18",
				110.27
			],
			[
				"2003-04-24",
				101.86
			],
			[
				"2004-04-08",
				93
			],
			[
				"2004-06-01",
				84.14
			],
			[
				"2005-08-11",
				84.14
			],
			[
				"2005-08-31",
				84.14
			],
			[
				"2006-05-24",
				75.29
			],
			[
				"2007-06-29",
				79.71
			],
			[
				"2008-04-25",
				66.43
			],
			[
				"2015-07-22",
				60.23
			],
			[
				"2009-06-16",
				79.71
			],
			[
				"2010-04-14",
				106.29
			],
			[
				"2003-10-15",
				77.06
			],
			[
				"2011-06-15",
				93
			],
			[
				"2012-11-29",
				79.71
			]
		],
		"20060208": [
			[
				"2000-11-21",
				2.21
			],
			[
				"2003-06-13",
				2.21
			],
			[
				"2004-03-11",
				13.51
			],
			[
				"2005-07-07",
				2.21
			],
			[
				"2006-04-18",
				7.53
			],
			[
				"2007-06-21",
				2.21
			],
			[
				"2008-04-04",
				2.21
			],
			[
				"2013-06-27",
				2.21
			],
			[
				"2014-05-15",
				2.21
			],
			[
				"2015-07-02",
				2.97
			],
			[
				"2016-04-14",
				39.86
			],
			[
				"2009-06-17",
				2.21
			],
			[
				"2010-04-06",
				9.3
			],
			[
				"2011-05-12",
				5.76
			],
			[
				"2012-06-21",
				2.21
			]
		],
		"20101120": [
			[
				"2001-11-06",
				110.27
			],
			[
				"2002-11-06",
				84.14
			],
			[
				"2004-07-06",
				89.01
			],
			[
				"2005-07-19",
				106.29
			],
			[
				"2006-10-17",
				84.14
			],
			[
				"2007-06-20",
				88.57
			],
			[
				"2008-12-04",
				88.57
			],
			[
				"2013-09-10",
				199.29
			],
			[
				"2014-07-01",
				220.99
			],
			[
				"2015-08-06",
				271.03
			],
			[
				"2009-10-05",
				106.29
			],
			[
				"2010-09-07",
				137.29
			],
			[
				"2011-05-11",
				141.71
			],
			[
				"2012-10-17",
				181.57
			]
		],
		"20102082": [
			[
				"2000-11-16",
				2.21
			],
			[
				"2001-06-20",
				2.21
			],
			[
				"2003-04-30",
				2.21
			],
			[
				"2004-04-08",
				2.21
			],
			[
				"2005-08-11",
				2.21
			],
			[
				"2006-05-31",
				2.21
			],
			[
				"2007-07-27",
				2.21
			],
			[
				"2008-04-25",
				2.21
			],
			[
				"2013-07-22",
				2.21
			],
			[
				"2014-07-10",
				1.33
			],
			[
				"2015-10-15",
				2.61
			],
			[
				"2009-10-22",
				2.21
			],
			[
				"2010-04-14",
				2.21
			],
			[
				"2011-06-15",
				2.21
			],
			[
				"2012-08-01",
				2.21
			]
		],
		"20103037": [
			[
				"2000-10-19",
				2.21
			],
			[
				"2001-03-29",
				2.21
			],
			[
				"2002-08-21",
				8.81
			],
			[
				"2003-03-28",
				5.93
			],
			[
				"2004-02-26",
				2.92
			],
			[
				"2005-07-22",
				2.21
			],
			[
				"2006-05-22",
				5.76
			],
			[
				"2007-06-28",
				4.34
			],
			[
				"2008-04-11",
				3.23
			],
			[
				"2013-07-03",
				13.29
			],
			[
				"2014-06-25",
				19.93
			],
			[
				"2015-07-15",
				14.92
			],
			[
				"2009-07-06",
				10.63
			],
			[
				"2010-04-07",
				17.71
			],
			[
				"2011-03-31",
				12.84
			],
			[
				"2012-07-05",
				14.17
			]
		],
		"20103062": [
			[
				"2002-07-03",
				34.14
			],
			[
				"2002-08-28",
				26.75
			],
			[
				"2003-04-02",
				28.65
			],
			[
				"2004-03-12",
				79.27
			],
			[
				"2005-07-08",
				33.66
			],
			[
				"2006-04-10",
				75.29
			],
			[
				"2007-07-20",
				38.09
			],
			[
				"2013-07-02",
				163.86
			],
			[
				"2014-06-24",
				75.29
			],
			[
				"2015-07-14",
				40.52
			],
			[
				"2009-07-06",
				53.14
			],
			[
				"2010-07-15",
				70.86
			],
			[
				"2008-04-03",
				115.14
			],
			[
				"2011-04-04",
				70.86
			],
			[
				"2012-05-23",
				97.43
			]
		],
		"20103074": [
			[
				"2000-11-16",
				23.03
			],
			[
				"2001-06-20",
				29.41
			],
			[
				"2002-08-28",
				18.56
			],
			[
				"2003-04-04",
				29.41
			],
			[
				"2004-03-19",
				6.24
			],
			[
				"2005-07-01",
				19.49
			],
			[
				"2006-04-10",
				2.21
			],
			[
				"2007-07-20",
				13.29
			],
			[
				"2008-04-03",
				15.06
			],
			[
				"2013-07-02",
				27.9
			],
			[
				"2014-06-25",
				30.56
			],
			[
				"2015-07-14",
				29.76
			],
			[
				"2009-07-06",
				21.26
			],
			[
				"2010-07-15",
				19.49
			],
			[
				"2011-08-24",
				29.23
			],
			[
				"2012-06-26",
				19.93
			]
		],
		"20103165": [
			[
				"2000-10-19",
				2.21
			],
			[
				"2001-06-26",
				2.21
			],
			[
				"2002-05-15",
				2.21
			],
			[
				"2003-04-30",
				2.21
			],
			[
				"2004-04-16",
				2.21
			],
			[
				"2005-07-22",
				2.21
			],
			[
				"2006-04-13",
				2.21
			],
			[
				"2007-06-28",
				2.21
			],
			[
				"2008-04-11",
				2.21
			],
			[
				"2013-07-03",
				2.21
			],
			[
				"2014-07-03",
				1.33
			],
			[
				"2015-07-15",
				1.33
			],
			[
				"2009-07-13",
				2.21
			],
			[
				"2010-06-16",
				2.21
			],
			[
				"2011-03-31",
				2.21
			],
			[
				"2012-05-30",
				2.21
			]
		],
		"20103177": [
			[
				"2000-10-19",
				2.21
			],
			[
				"2001-06-26",
				2.21
			],
			[
				"2002-05-15",
				2.21
			],
			[
				"2003-04-30",
				2.21
			],
			[
				"2004-04-16",
				1.73
			],
			[
				"2005-07-22",
				2.21
			],
			[
				"2006-04-13",
				2.21
			],
			[
				"2007-06-28",
				2.21
			],
			[
				"2008-04-11",
				2.21
			],
			[
				"2013-07-03",
				2.21
			],
			[
				"2014-07-03",
				25.07
			],
			[
				"2015-07-15",
				1.33
			],
			[
				"2009-07-13",
				2.21
			],
			[
				"2010-06-17",
				2.21
			],
			[
				"2010-09-09",
				2.21
			],
			[
				"2011-03-31",
				2.21
			],
			[
				"2012-05-30",
				2.21
			]
		],
		"20104030": [
			[
				"2000-11-07",
				2.21
			],
			[
				"2001-06-20",
				2.21
			],
			[
				"2002-06-24",
				2.21
			],
			[
				"2003-06-27",
				2.21
			],
			[
				"2004-03-25",
				2.21
			],
			[
				"2005-07-14",
				2.21
			],
			[
				"2006-10-19",
				2.21
			],
			[
				"2007-06-29",
				2.21
			],
			[
				"2008-03-27",
				2.21
			],
			[
				"2013-07-23",
				27.46
			],
			[
				"2014-07-24",
				1.33
			],
			[
				"2015-10-15",
				1.33
			],
			[
				"2009-05-26",
				2.21
			],
			[
				"2010-05-06",
				2.21
			],
			[
				"2011-07-20",
				2.21
			],
			[
				"2012-11-06",
				2.21
			]
		],
		"20104042": [
			[
				"2003-03-28",
				51.37
			],
			[
				"2006-05-31",
				57.57
			],
			[
				"2007-06-04",
				38.09
			],
			[
				"2013-07-18",
				48.71
			],
			[
				"2014-07-08",
				51.37
			],
			[
				"2015-09-22",
				45.17
			],
			[
				"2009-10-07",
				42.96
			],
			[
				"2008-04-29",
				48.71
			],
			[
				"2010-07-14",
				42.07
			],
			[
				"2010-10-14",
				41.63
			],
			[
				"2011-04-27",
				42.51
			],
			[
				"2012-11-13",
				38.09
			]
		],
		"20104054": [
			[
				"2000-11-15",
				53.14
			],
			[
				"2001-02-20",
				53.14
			],
			[
				"2001-10-24",
				59.34
			],
			[
				"2002-08-28",
				68.2
			],
			[
				"2002-09-18",
				67.76
			],
			[
				"2003-03-28",
				67.76
			],
			[
				"2003-10-13",
				61.56
			],
			[
				"2004-02-27",
				56.69
			],
			[
				"2004-06-01",
				60.23
			],
			[
				"2005-08-11",
				62
			],
			[
				"2005-09-01",
				66.43
			],
			[
				"2006-05-31",
				62
			],
			[
				"2007-06-04",
				48.71
			],
			[
				"2008-04-29",
				48.71
			],
			[
				"2013-07-18",
				57.57
			],
			[
				"2014-07-08",
				56.69
			],
			[
				"2015-09-22",
				42.87
			],
			[
				"2009-10-21",
				48.71
			],
			[
				"2010-07-14",
				57.57
			],
			[
				"2011-04-27",
				57.57
			],
			[
				"2012-11-06",
				57.57
			]
		],
		"20104224": [
			[
				"2000-11-07",
				2.21
			],
			[
				"2001-04-11",
				2.21
			],
			[
				"2002-06-24",
				2.21
			],
			[
				"2003-06-27",
				2.21
			],
			[
				"2004-03-25",
				2.21
			],
			[
				"2005-07-14",
				2.21
			],
			[
				"2006-11-17",
				79.71
			],
			[
				"2007-05-16",
				2.21
			],
			[
				"2008-03-27",
				2.21
			],
			[
				"2013-07-24",
				2.21
			],
			[
				"2014-07-24",
				1.33
			],
			[
				"2015-11-03",
				1.33
			],
			[
				"2009-06-16",
				2.21
			],
			[
				"2010-05-06",
				2.21
			],
			[
				"2011-07-20",
				2.21
			],
			[
				"2012-08-01",
				2.21
			]
		],
		"20104303": [
			[
				"2000-11-21",
				36.31
			],
			[
				"2001-10-25",
				45.17
			],
			[
				"2002-07-17",
				95.21
			],
			[
				"2002-08-28",
				93
			],
			[
				"2002-09-18",
				94.77
			],
			[
				"2003-06-25",
				85.91
			],
			[
				"2003-10-13",
				67.31
			],
			[
				"2004-03-11",
				75.29
			],
			[
				"2004-06-03",
				56.24
			],
			[
				"2005-07-07",
				57.57
			],
			[
				"2005-09-01",
				66.43
			],
			[
				"2006-04-18",
				66.43
			],
			[
				"2007-06-22",
				93
			],
			[
				"2008-04-10",
				124
			],
			[
				"2013-07-16",
				75.29
			],
			[
				"2014-06-26",
				64.21
			],
			[
				"2015-06-30",
				69.09
			],
			[
				"2009-06-30",
				53.14
			],
			[
				"2010-04-07",
				75.29
			],
			[
				"2011-07-14",
				62
			],
			[
				"2012-06-26",
				62
			]
		],
		"20104315": [
			[
				"2000-11-08",
				121.79
			],
			[
				"2002-07-17",
				123.56
			],
			[
				"2003-04-02",
				92.56
			],
			[
				"2004-03-12",
				57.13
			],
			[
				"2005-07-08",
				79.71
			],
			[
				"2006-04-12",
				93
			],
			[
				"2007-06-22",
				110.71
			],
			[
				"2008-04-04",
				97.43
			],
			[
				"2013-07-17",
				128.43
			],
			[
				"2014-05-15",
				114.7
			],
			[
				"2015-07-14",
				146.59
			],
			[
				"2009-06-29",
				110.71
			],
			[
				"2010-06-09",
				88.57
			],
			[
				"2011-04-05",
				110.71
			],
			[
				"2012-06-21",
				115.14
			]
		],
		"20104327": [
			[
				"2000-11-15",
				50.04
			],
			[
				"2001-10-25",
				61.11
			],
			[
				"2002-05-15",
				49.6
			],
			[
				"2002-08-28",
				47.83
			],
			[
				"2002-09-18",
				58.01
			],
			[
				"2003-05-22",
				35.12
			],
			[
				"2003-10-13",
				50.49
			],
			[
				"2004-04-16",
				42.91
			],
			[
				"2004-06-03",
				14.53
			],
			[
				"2005-09-01",
				57.57
			],
			[
				"2005-11-03",
				30.56
			],
			[
				"2006-04-13",
				53.14
			],
			[
				"2007-06-21",
				48.71
			],
			[
				"2008-04-03",
				53.14
			],
			[
				"2013-07-16",
				2.21
			],
			[
				"2014-05-06",
				7.97
			],
			[
				"2015-06-30",
				8.77
			],
			[
				"2009-06-17",
				27.9
			],
			[
				"2010-04-06",
				2.21
			],
			[
				"2011-07-14",
				35.43
			],
			[
				"2012-05-30",
				39.86
			]
		],
		"20104546": [
			[
				"2000-02-14",
				14
			],
			[
				"2000-06-15",
				13
			],
			[
				"2001-03-26",
				15.01
			],
			[
				"2001-06-28",
				14
			],
			[
				"2001-11-06",
				15.01
			],
			[
				"2002-02-25",
				13
			],
			[
				"2002-07-22",
				13
			],
			[
				"2002-10-10",
				13
			],
			[
				"2004-09-29",
				13.8
			],
			[
				"2004-03-23",
				13
			],
			[
				"2005-10-24",
				14.11
			],
			[
				"2010-04-27",
				13.5
			],
			[
				"2010-11-16",
				13
			],
			[
				"2011-03-29",
				12.8
			],
			[
				"2011-11-22",
				13.3
			],
			[
				"2012-10-17",
				12.9
			],
			[
				"2012-05-07",
				12.2
			],
			[
				"2013-04-03",
				12.2
			],
			[
				"2013-12-10",
				12.9
			],
			[
				"2014-09-08",
				12.4
			],
			[
				"2014-05-27",
				12.3
			],
			[
				"2015-03-09",
				12.3
			],
			[
				"2015-09-08",
				12.2
			],
			[
				"2006-09-14",
				13.5
			],
			[
				"2007-03-21",
				13.2
			],
			[
				"2007-09-17",
				13.6
			],
			[
				"2008-04-16",
				13.3
			],
			[
				"2008-09-15",
				13.8
			],
			[
				"2009-04-09",
				13.4
			],
			[
				"2009-10-27",
				13.8
			]
		],
		"20161517": [
			[
				"2000-11-21",
				6.2
			],
			[
				"2003-06-25",
				17.67
			],
			[
				"2004-07-01",
				10.85
			],
			[
				"2006-06-13",
				20.37
			],
			[
				"2013-07-16",
				17.27
			],
			[
				"2014-07-01",
				20.37
			],
			[
				"2015-06-30",
				19.62
			],
			[
				"2009-10-22",
				9.3
			],
			[
				"2010-07-21",
				12.84
			],
			[
				"2011-07-07",
				19.49
			],
			[
				"2012-08-10",
				16.83
			]
		],
		"20751011": [
			[
				"2000-03-07",
				28.81
			],
			[
				"2000-09-19",
				28.61
			],
			[
				"2001-03-06",
				28.31
			],
			[
				"2001-09-18",
				28.71
			],
			[
				"2002-03-05",
				30.61
			],
			[
				"2002-09-17",
				28.71
			],
			[
				"2003-03-03",
				28.91
			],
			[
				"2003-09-16",
				28.21
			],
			[
				"2004-03-30",
				32.31
			],
			[
				"2004-09-28",
				29.91
			],
			[
				"2005-04-12",
				31.81
			],
			[
				"2005-09-27",
				27.11
			],
			[
				"2010-09-27",
				28.11
			],
			[
				"2011-03-21",
				30.81
			],
			[
				"2011-09-19",
				28.91
			],
			[
				"2012-03-26",
				29.31
			],
			[
				"2012-09-18",
				28.11
			],
			[
				"2013-03-19",
				28.01
			],
			[
				"2013-09-24",
				27.01
			],
			[
				"2014-03-11",
				26.61
			],
			[
				"2014-09-29",
				26.01
			],
			[
				"2015-03-10",
				28.81
			],
			[
				"2015-09-15",
				27.51
			],
			[
				"2006-04-26",
				31.01
			],
			[
				"2006-10-23",
				28.71
			],
			[
				"2007-03-28",
				33.81
			],
			[
				"2007-10-08",
				33.81
			],
			[
				"2008-03-04",
				32.51
			],
			[
				"2008-10-20",
				28.31
			],
			[
				"2009-03-16",
				30.31
			],
			[
				"2009-09-21",
				27.31
			],
			[
				"2010-03-16",
				29.21
			]
		],
		"20752349": [
			[
				"2000-10-24",
				32.01
			],
			[
				"2000-03-28",
				32.91
			],
			[
				"2001-10-23",
				28.21
			],
			[
				"2001-03-27",
				34.11
			],
			[
				"2002-10-22",
				35.61
			],
			[
				"2002-03-26",
				33.41
			],
			[
				"2003-03-25",
				31.81
			],
			[
				"2003-10-28",
				28.51
			],
			[
				"2004-03-23",
				33.31
			],
			[
				"2004-09-21",
				31.11
			],
			[
				"2005-04-05",
				33.01
			],
			[
				"2005-09-20",
				28.71
			],
			[
				"2010-09-13",
				28.81
			],
			[
				"2011-03-15",
				31.21
			],
			[
				"2011-09-12",
				25.21
			],
			[
				"2012-03-19",
				27.61
			],
			[
				"2012-09-17",
				27.71
			],
			[
				"2013-03-26",
				26.01
			],
			[
				"2013-09-17",
				25.71
			],
			[
				"2014-03-05",
				28.01
			],
			[
				"2014-09-15",
				26.61
			],
			[
				"2015-03-04",
				25.81
			],
			[
				"2015-09-01",
				27.81
			],
			[
				"2006-04-25",
				30.61
			],
			[
				"2006-10-16",
				30.11
			],
			[
				"2007-03-19",
				32.01
			],
			[
				"2007-10-22",
				32.21
			],
			[
				"2008-03-03",
				30.81
			],
			[
				"2008-10-13",
				29.81
			],
			[
				"2009-03-02",
				30.01
			],
			[
				"2009-09-14",
				31.71
			],
			[
				"2010-03-01",
				30.31
			]
		],
		"20753019": [
			[
				"2000-03-07",
				20.51
			],
			[
				"2000-09-19",
				17.31
			],
			[
				"2001-03-06",
				20.61
			],
			[
				"2001-09-18",
				19.51
			],
			[
				"2002-03-05",
				18.71
			],
			[
				"2002-09-17",
				20.41
			],
			[
				"2003-03-03",
				21.41
			],
			[
				"2003-09-16",
				18.41
			],
			[
				"2004-03-30",
				24.01
			],
			[
				"2004-09-28",
				21.01
			],
			[
				"2005-04-12",
				23.51
			],
			[
				"2005-09-27",
				17.91
			],
			[
				"2006-10-23",
				19.81
			],
			[
				"2006-04-26",
				23.51
			],
			[
				"2010-09-27",
				19.41
			],
			[
				"2011-03-21",
				23.81
			],
			[
				"2011-09-19",
				18.71
			],
			[
				"2012-03-26",
				20.41
			],
			[
				"2012-09-18",
				19.51
			],
			[
				"2013-03-19",
				24.51
			],
			[
				"2013-09-24",
				19.71
			],
			[
				"2014-03-11",
				24.01
			],
			[
				"2014-09-29",
				21.21
			],
			[
				"2015-03-10",
				27.91
			],
			[
				"2015-09-15",
				21.01
			],
			[
				"2007-03-28",
				23.01
			],
			[
				"2007-10-08",
				23.31
			],
			[
				"2008-03-04",
				20.21
			],
			[
				"2008-10-20",
				19.41
			],
			[
				"2009-03-16",
				22.71
			],
			[
				"2009-09-21",
				20.41
			],
			[
				"2010-03-16",
				24.91
			]
		],
		"20780369": [
			[
				"2000-03-06",
				39.01
			],
			[
				"2001-04-02",
				37.01
			],
			[
				"2002-04-04",
				36.01
			],
			[
				"2010-03-18",
				30.01
			],
			[
				"2012-03-27",
				31.01
			],
			[
				"2014-04-08",
				28.01
			],
			[
				"2015-03-05",
				27.01
			],
			[
				"2006-04-26",
				31.01
			],
			[
				"2007-03-12",
				35.01
			],
			[
				"2008-03-05",
				31.01
			],
			[
				"2004-04-19",
				35.01
			],
			[
				"2003-04-04",
				34.01
			],
			[
				"2005-03-21",
				36.01
			],
			[
				"2009-03-25",
				32.01
			],
			[
				"2011-03-07",
				30.01
			]
		],
		"20780370": [
			[
				"2000-10-24",
				5
			],
			[
				"2001-10-09",
				5
			],
			[
				"2010-09-23",
				2
			],
			[
				"2012-09-25",
				1
			],
			[
				"2013-10-18",
				1
			],
			[
				"2014-09-08",
				2
			],
			[
				"2015-09-01",
				2
			],
			[
				"2006-09-28",
				1
			],
			[
				"2007-09-17",
				3
			],
			[
				"2008-09-29",
				2
			],
			[
				"2004-09-14",
				3
			],
			[
				"2003-09-10",
				5
			],
			[
				"2005-09-29",
				3
			],
			[
				"2009-09-23",
				2
			],
			[
				"2002-09-20",
				4
			],
			[
				"2011-09-09",
				1
			]
		],
		"20781052": [
			[
				"2002-04-05",
				23.01
			],
			[
				"2000-10-27",
				24.01
			],
			[
				"2001-10-10",
				22.01
			],
			[
				"2001-04-10",
				33.01
			],
			[
				"2005-09-13",
				11
			],
			[
				"2005-04-06",
				14
			],
			[
				"2010-03-30",
				5.6
			],
			[
				"2010-10-26",
				6
			],
			[
				"2011-05-23",
				9
			],
			[
				"2011-11-02",
				6.2
			],
			[
				"2012-04-03",
				6.7
			],
			[
				"2012-10-30",
				8
			],
			[
				"2013-04-03",
				7.2
			],
			[
				"2013-10-30",
				11
			],
			[
				"2014-05-13",
				13
			],
			[
				"2014-11-13",
				9.5
			],
			[
				"2015-04-21",
				12
			],
			[
				"2015-11-16",
				11
			],
			[
				"2006-05-19",
				9
			],
			[
				"2006-09-28",
				8
			],
			[
				"2007-10-10",
				14
			],
			[
				"2007-04-11",
				8
			],
			[
				"2008-04-03",
				17.01
			],
			[
				"2008-09-17",
				16.01
			],
			[
				"2002-10-22",
				13
			],
			[
				"2003-10-08",
				8
			],
			[
				"2004-03-31",
				6
			],
			[
				"2004-09-21",
				12
			],
			[
				"2003-04-02",
				22.01
			]
		],
		"20781246": [
			[
				"2000-03-23",
				31.01
			],
			[
				"2001-04-24",
				32.01
			],
			[
				"2002-03-20",
				34.99
			],
			[
				"2010-03-09",
				25.01
			],
			[
				"2010-08-09",
				22.01
			],
			[
				"2010-11-11",
				25.01
			],
			[
				"2012-10-10",
				21.01
			],
			[
				"2012-03-20",
				22.01
			],
			[
				"2013-11-11",
				21.01
			],
			[
				"2013-08-06",
				21.01
			],
			[
				"2013-03-12",
				21.01
			],
			[
				"2013-02-19",
				21.01
			],
			[
				"2014-10-27",
				19.01
			],
			[
				"2014-07-14",
				20.01
			],
			[
				"2014-04-09",
				21.01
			],
			[
				"2014-02-19",
				21.01
			],
			[
				"2015-10-16",
				18.01
			],
			[
				"2015-06-18",
				22.01
			],
			[
				"2015-03-11",
				21.01
			],
			[
				"2015-02-13",
				21.01
			],
			[
				"2006-04-19",
				27.01
			],
			[
				"2007-03-14",
				27.01
			],
			[
				"2008-04-21",
				27.01
			],
			[
				"2009-03-23",
				28.01
			],
			[
				"2009-06-05",
				27.01
			]
		],
		"20781532": [
			[
				"2000-05-09",
				1.5
			],
			[
				"2000-08-29",
				0.8
			],
			[
				"2001-05-08",
				2.9
			],
			[
				"2001-09-25",
				1.6
			],
			[
				"2002-08-20",
				1.3
			],
			[
				"2002-05-21",
				0.1
			],
			[
				"2003-05-20",
				2.7
			],
			[
				"2004-03-10",
				1.1
			],
			[
				"2004-09-15",
				0.9
			],
			[
				"2005-03-09",
				0.6
			],
			[
				"2005-09-13",
				0.6
			],
			[
				"2010-09-28",
				1.4
			],
			[
				"2011-03-28",
				2.1
			],
			[
				"2011-09-26",
				2.2
			],
			[
				"2012-04-25",
				1.6
			],
			[
				"2012-10-17",
				1.8
			],
			[
				"2013-04-09",
				0.5
			],
			[
				"2013-10-08",
				1.6
			],
			[
				"2014-03-26",
				1.6
			],
			[
				"2014-10-28",
				0.6
			],
			[
				"2015-03-25",
				1.8
			],
			[
				"2015-10-27",
				2
			],
			[
				"2006-03-08",
				0.7
			],
			[
				"2006-09-13",
				0.6
			],
			[
				"2007-03-14",
				0.5
			],
			[
				"2007-09-12",
				0.5
			],
			[
				"2008-03-12",
				1.2
			],
			[
				"2008-09-10",
				1.8
			],
			[
				"2009-03-10",
				0.5
			],
			[
				"2009-10-14",
				1.1
			],
			[
				"2010-03-09",
				1.2
			]
		],
		"20781878": [
			[
				"2005-09-13",
				0.5
			],
			[
				"2011-09-20",
				2
			],
			[
				"2012-03-27",
				0.5
			],
			[
				"2013-09-17",
				0.8
			],
			[
				"2014-04-01",
				2.4
			],
			[
				"2015-03-23",
				5.3
			],
			[
				"2006-03-08",
				0.5
			],
			[
				"2007-10-24",
				2.4
			],
			[
				"2008-11-04",
				0.9
			],
			[
				"2009-03-10",
				0.5
			],
			[
				"2009-09-22",
				4.3
			],
			[
				"2010-03-16",
				4.8
			]
		],
		"20782317": [
			[
				"2000-04-10",
				19.01
			],
			[
				"2001-04-09",
				13
			],
			[
				"2004-04-02",
				14
			],
			[
				"2005-04-13",
				12
			],
			[
				"2003-04-10",
				6
			],
			[
				"2006-04-24",
				14
			],
			[
				"2010-04-12",
				10
			],
			[
				"2015-04-13",
				10
			],
			[
				"2014-04-04",
				8
			],
			[
				"2013-04-11",
				6
			],
			[
				"2012-04-26",
				6
			],
			[
				"2007-04-10",
				16.01
			],
			[
				"2008-04-25",
				8
			],
			[
				"2009-03-20",
				11
			]
		],
		"20782925": [
			[
				"2003-04-04",
				38.48
			],
			[
				"2004-03-19",
				37.55
			],
			[
				"2000-11-06",
				101.86
			],
			[
				"2001-03-27",
				54.47
			],
			[
				"2002-01-15",
				59.79
			],
			[
				"2005-11-03",
				66.43
			],
			[
				"2006-04-10",
				25.24
			],
			[
				"2007-07-20",
				27.9
			],
			[
				"2010-03-29",
				18.01
			],
			[
				"2011-05-25",
				24.01
			],
			[
				"2012-04-04",
				24.01
			],
			[
				"2013-04-05",
				27.01
			],
			[
				"2014-05-13",
				30.01
			],
			[
				"2015-04-23",
				32.01
			],
			[
				"2013-07-02",
				26.13
			],
			[
				"2014-06-26",
				28.34
			],
			[
				"2015-07-14",
				28.92
			],
			[
				"2009-07-06",
				35.43
			],
			[
				"2008-04-03",
				23.91
			],
			[
				"2010-07-15",
				26.57
			],
			[
				"2010-09-09",
				24.8
			],
			[
				"2011-08-24",
				23.91
			],
			[
				"2012-07-05",
				25.69
			]
		],
		"20790302": [
			[
				"2000-05-16",
				44.02
			],
			[
				"2000-11-13",
				37.01
			],
			[
				"2001-05-10",
				42.01
			],
			[
				"2001-09-24",
				36.01
			],
			[
				"2002-04-16",
				42.01
			],
			[
				"2002-09-26",
				41.01
			],
			[
				"2003-05-13",
				37.01
			],
			[
				"2003-11-12",
				35.01
			],
			[
				"2004-03-16",
				44.02
			],
			[
				"2004-11-09",
				37.01
			],
			[
				"2005-04-20",
				42.01
			],
			[
				"2006-10-04",
				34.01
			],
			[
				"2006-05-03",
				40.01
			],
			[
				"2010-09-30",
				26.01
			],
			[
				"2011-05-19",
				36.01
			],
			[
				"2011-09-27",
				33.01
			],
			[
				"2012-03-01",
				44.02
			],
			[
				"2012-04-25",
				38.01
			],
			[
				"2012-11-22",
				29.01
			],
			[
				"2013-05-23",
				37.01
			],
			[
				"2013-12-03",
				33.01
			],
			[
				"2014-05-28",
				32.01
			],
			[
				"2014-10-30",
				30.01
			],
			[
				"2015-05-28",
				40.01
			],
			[
				"2015-11-03",
				31.01
			],
			[
				"2007-05-23",
				39.01
			],
			[
				"2007-09-25",
				42.01
			],
			[
				"2008-04-23",
				42.01
			],
			[
				"2008-10-02",
				36.01
			],
			[
				"2009-05-05",
				39.01
			],
			[
				"2009-09-23",
				31.01
			],
			[
				"2010-04-13",
				51.02
			]
		],
		"20790624": [
			[
				"2000-03-07",
				27.21
			],
			[
				"2000-09-19",
				27.61
			],
			[
				"2001-03-06",
				25.91
			],
			[
				"2001-09-18",
				27.31
			],
			[
				"2002-03-05",
				28.61
			],
			[
				"2002-09-17",
				28.01
			],
			[
				"2003-03-03",
				26.61
			],
			[
				"2003-09-16",
				27.71
			],
			[
				"2004-03-30",
				28.81
			],
			[
				"2004-09-28",
				29.41
			],
			[
				"2005-04-12",
				29.21
			],
			[
				"2005-09-27",
				27.11
			],
			[
				"2006-04-26",
				28.01
			],
			[
				"2006-10-23",
				28.01
			],
			[
				"2010-09-27",
				28.41
			],
			[
				"2011-03-21",
				29.01
			],
			[
				"2011-09-19",
				28.91
			],
			[
				"2012-03-26",
				27.61
			],
			[
				"2012-09-18",
				28.41
			],
			[
				"2013-03-19",
				27.71
			],
			[
				"2013-09-24",
				27.91
			],
			[
				"2014-03-11",
				29.21
			],
			[
				"2014-09-29",
				28.81
			],
			[
				"2015-03-10",
				29.91
			],
			[
				"2015-09-15",
				29.11
			],
			[
				"2007-03-28",
				28.41
			],
			[
				"2007-10-08",
				27.51
			],
			[
				"2008-03-04",
				29.01
			],
			[
				"2008-10-20",
				29.01
			],
			[
				"2009-03-16",
				29.11
			],
			[
				"2009-09-21",
				29.31
			],
			[
				"2010-03-16",
				28.81
			]
		],
		"20791215": [
			[
				"2000-10-24",
				21.81
			],
			[
				"2000-03-28",
				13
			],
			[
				"2001-10-23",
				18.81
			],
			[
				"2001-03-27",
				12.9
			],
			[
				"2002-10-22",
				13.7
			],
			[
				"2002-03-26",
				12.5
			],
			[
				"2010-09-13",
				14.61
			],
			[
				"2011-03-15",
				12.7
			],
			[
				"2011-09-12",
				17.01
			],
			[
				"2012-03-19",
				10.7
			],
			[
				"2012-09-17",
				13.1
			],
			[
				"2013-03-26",
				11.1
			],
			[
				"2013-09-17",
				14.41
			],
			[
				"2014-03-05",
				11.9
			],
			[
				"2014-09-15",
				15.61
			],
			[
				"2015-03-04",
				11.1
			],
			[
				"2015-09-01",
				16.51
			],
			[
				"2003-03-25",
				11.2
			],
			[
				"2003-10-28",
				19.91
			],
			[
				"2004-03-23",
				14.11
			],
			[
				"2004-09-21",
				17.81
			],
			[
				"2005-04-05",
				12.6
			],
			[
				"2005-09-20",
				16.01
			],
			[
				"2006-04-25",
				12.9
			],
			[
				"2007-03-19",
				12.9
			],
			[
				"2007-10-22",
				12.4
			],
			[
				"2008-03-03",
				12.7
			],
			[
				"2008-10-13",
				16.61
			],
			[
				"2009-03-02",
				14
			],
			[
				"2009-09-14",
				18.81
			],
			[
				"2010-03-01",
				12.2
			]
		],
		"20791318": [
			[
				"2000-10-24",
				27.21
			],
			[
				"2000-03-28",
				27.91
			],
			[
				"2001-10-23",
				25.91
			],
			[
				"2001-03-27",
				28.31
			],
			[
				"2002-10-22",
				25.41
			],
			[
				"2002-03-26",
				28.21
			],
			[
				"2003-03-25",
				23.61
			],
			[
				"2003-10-28",
				25.11
			],
			[
				"2004-03-23",
				26.91
			],
			[
				"2004-09-21",
				25.01
			],
			[
				"2005-04-05",
				26.41
			],
			[
				"2005-09-20",
				24.01
			],
			[
				"2010-09-13",
				24.01
			],
			[
				"2011-03-15",
				24.91
			],
			[
				"2011-09-12",
				23.71
			],
			[
				"2012-03-19",
				23.41
			],
			[
				"2012-09-17",
				23.61
			],
			[
				"2013-03-26",
				24.41
			],
			[
				"2013-09-17",
				23.41
			],
			[
				"2014-03-05",
				24.61
			],
			[
				"2014-09-15",
				24.11
			],
			[
				"2015-03-04",
				26.71
			],
			[
				"2015-09-01",
				25.01
			],
			[
				"2006-04-25",
				27.21
			],
			[
				"2006-10-16",
				24.31
			],
			[
				"2007-03-19",
				26.21
			],
			[
				"2007-10-22",
				24.31
			],
			[
				"2008-03-03",
				24.31
			],
			[
				"2008-10-13",
				22.21
			],
			[
				"2009-03-02",
				25.11
			],
			[
				"2009-09-14",
				26.71
			],
			[
				"2010-03-01",
				25.71
			]
		],
		"20791410": [
			[
				"2000-10-24",
				47.22
			],
			[
				"2000-03-28",
				44.62
			],
			[
				"2001-10-23",
				46.72
			],
			[
				"2001-03-27",
				46.72
			],
			[
				"2002-10-22",
				43.72
			],
			[
				"2002-03-26",
				45.52
			],
			[
				"2003-03-25",
				41.31
			],
			[
				"2003-10-28",
				44.02
			],
			[
				"2004-03-23",
				44.82
			],
			[
				"2004-09-21",
				46.22
			],
			[
				"2010-09-13",
				43.32
			],
			[
				"2011-03-15",
				43.02
			],
			[
				"2011-09-12",
				43.02
			],
			[
				"2012-03-19",
				41.01
			],
			[
				"2012-09-17",
				44.02
			],
			[
				"2013-03-26",
				43.02
			],
			[
				"2013-09-17",
				41.21
			],
			[
				"2014-03-05",
				43.52
			],
			[
				"2014-09-15",
				42.72
			],
			[
				"2015-03-04",
				43.72
			],
			[
				"2015-09-01",
				44.32
			],
			[
				"2005-04-05",
				45.62
			],
			[
				"2005-09-20",
				44.22
			],
			[
				"2006-04-25",
				44.42
			],
			[
				"2006-10-16",
				44.62
			],
			[
				"2007-03-19",
				43.82
			],
			[
				"2007-10-22",
				41.21
			],
			[
				"2008-03-03",
				44.62
			],
			[
				"2008-10-13",
				42.21
			],
			[
				"2009-03-02",
				42.21
			],
			[
				"2009-09-14",
				46.12
			],
			[
				"2010-03-01",
				41.61
			]
		],
		"21000049": [
			[
				"2000-11-15",
				55.36
			],
			[
				"2001-03-29",
				35.61
			],
			[
				"2002-08-07",
				36.85
			],
			[
				"2003-03-28",
				35.07
			],
			[
				"2004-04-16",
				40.08
			],
			[
				"2005-11-03",
				44.29
			],
			[
				"2006-04-13",
				34.54
			],
			[
				"2007-07-27",
				48.71
			],
			[
				"2008-04-10",
				32.33
			],
			[
				"2013-06-26",
				31.89
			],
			[
				"2014-06-25",
				31.44
			],
			[
				"2015-07-02",
				34.59
			],
			[
				"2009-06-16",
				31
			],
			[
				"2010-04-07",
				26.57
			],
			[
				"2011-07-07",
				31
			],
			[
				"2012-07-05",
				37.64
			]
		],
		"21000086": [
			[
				"2002-10-23",
				2.21
			],
			[
				"2003-10-29",
				2.21
			],
			[
				"2004-07-07",
				2.21
			],
			[
				"2005-07-20",
				2.21
			],
			[
				"2006-08-09",
				2.21
			],
			[
				"2007-06-18",
				2.21
			],
			[
				"2008-12-02",
				2.21
			],
			[
				"2013-07-30",
				2.21
			],
			[
				"2014-05-22",
				2.21
			],
			[
				"2015-07-21",
				1.33
			],
			[
				"2009-09-18",
				2.21
			],
			[
				"2010-06-24",
				2.21
			],
			[
				"2011-04-26",
				2.21
			],
			[
				"2012-07-25",
				2.21
			]
		],
		"21000153": [
			[
				"2000-11-09",
				15.06
			],
			[
				"2001-03-29",
				7.88
			],
			[
				"2002-08-07",
				2.21
			],
			[
				"2003-03-28",
				7
			],
			[
				"2004-02-26",
				21.35
			],
			[
				"2005-11-17",
				10.63
			],
			[
				"2005-07-22",
				5.31
			],
			[
				"2007-06-28",
				2.21
			],
			[
				"2008-04-17",
				2.21
			],
			[
				"2013-07-16",
				2.21
			],
			[
				"2014-06-26",
				2.83
			],
			[
				"2015-10-15",
				5.49
			],
			[
				"2009-07-29",
				16.83
			],
			[
				"2006-05-29",
				2.21
			],
			[
				"2010-07-22",
				2.21
			],
			[
				"2011-05-18",
				2.21
			],
			[
				"2012-08-10",
				3.19
			]
		],
		"21000268": [
			[
				"2000-07-11",
				2.21
			],
			[
				"2001-02-15",
				4.25
			],
			[
				"2002-05-22",
				2.21
			],
			[
				"2002-08-21",
				2.21
			],
			[
				"2003-03-21",
				2.21
			],
			[
				"2004-02-27",
				5.05
			],
			[
				"2005-07-21",
				2.21
			],
			[
				"2007-05-30",
				4.87
			],
			[
				"2008-08-25",
				2.21
			],
			[
				"2013-10-29",
				2.21
			],
			[
				"2014-07-23",
				1.33
			],
			[
				"2015-10-28",
				3.99
			],
			[
				"2009-07-09",
				2.21
			],
			[
				"2010-06-17",
				2.21
			],
			[
				"2006-05-24",
				6.64
			],
			[
				"2008-04-29",
				2.21
			],
			[
				"2011-07-05",
				2.21
			],
			[
				"2012-08-14",
				2.21
			]
		],
		"21000300": [
			[
				"2000-09-19",
				16.83
			],
			[
				"2001-03-01",
				54.03
			],
			[
				"2002-05-16",
				40.48
			],
			[
				"2003-07-04",
				2.21
			],
			[
				"2004-03-26",
				187.33
			],
			[
				"2005-07-21",
				79.71
			],
			[
				"2006-04-19",
				101.86
			],
			[
				"2007-06-04",
				128.43
			],
			[
				"2013-07-22",
				39.41
			],
			[
				"2014-07-08",
				29.41
			],
			[
				"2015-09-23",
				34.68
			],
			[
				"2009-08-17",
				4.38
			],
			[
				"2008-05-14",
				23.03
			],
			[
				"2010-07-29",
				2.21
			],
			[
				"2011-10-05",
				15.5
			],
			[
				"2012-09-12",
				20.81
			]
		],
		"21000347": [
			[
				"2000-09-19",
				113.37
			],
			[
				"2001-04-05",
				109.83
			],
			[
				"2002-05-16",
				2.21
			],
			[
				"2003-04-24",
				102.3
			],
			[
				"2004-04-08",
				90.79
			],
			[
				"2005-08-11",
				84.14
			],
			[
				"2006-05-29",
				88.57
			],
			[
				"2007-05-30",
				97.43
			],
			[
				"2008-04-29",
				79.71
			],
			[
				"2013-07-22",
				84.14
			],
			[
				"2014-07-10",
				94.77
			],
			[
				"2015-10-15",
				80.6
			],
			[
				"2009-07-09",
				75.29
			],
			[
				"2010-04-14",
				2.21
			],
			[
				"2011-06-15",
				75.29
			],
			[
				"2012-08-01",
				79.71
			]
		],
		"21000426": [
			[
				"2000-09-19",
				2.21
			],
			[
				"2001-02-15",
				2.21
			],
			[
				"2002-08-21",
				2.21
			],
			[
				"2003-04-24",
				2.21
			],
			[
				"2004-04-08",
				2.21
			],
			[
				"2005-08-11",
				2.21
			],
			[
				"2005-11-10",
				2.21
			],
			[
				"2007-05-30",
				2.21
			],
			[
				"2013-07-22",
				2.21
			],
			[
				"2014-07-16",
				1.33
			],
			[
				"2015-10-28",
				1.33
			],
			[
				"2009-08-17",
				2.21
			],
			[
				"2006-05-29",
				2.21
			],
			[
				"2008-03-27",
				4.34
			],
			[
				"2008-05-14",
				2.21
			],
			[
				"2010-07-27",
				2.21
			],
			[
				"2011-08-24",
				2.21
			],
			[
				"2012-05-24",
				2.21
			]
		],
		"21000440": [
			[
				"2000-11-09",
				2.21
			],
			[
				"2001-10-18",
				3.23
			],
			[
				"2002-05-22",
				2.21
			],
			[
				"2003-07-04",
				2.21
			],
			[
				"2004-03-26",
				2.21
			],
			[
				"2005-07-21",
				2.3
			],
			[
				"2006-04-19",
				2.21
			],
			[
				"2007-07-12",
				2.21
			],
			[
				"2008-04-18",
				2.21
			],
			[
				"2013-07-23",
				2.21
			],
			[
				"2014-08-20",
				1.33
			],
			[
				"2015-10-22",
				13.2
			],
			[
				"2009-07-29",
				2.21
			],
			[
				"2010-09-09",
				2.21
			],
			[
				"2011-07-27",
				2.21
			],
			[
				"2012-08-15",
				2.21
			]
		],
		"21000610": [
			[
				"2000-06-07",
				13.29
			],
			[
				"2001-04-11",
				14.44
			],
			[
				"2002-06-24",
				33.75
			],
			[
				"2003-06-27",
				33.88
			],
			[
				"2004-03-25",
				29.14
			],
			[
				"2005-07-14",
				25.24
			],
			[
				"2006-10-19",
				23.47
			],
			[
				"2007-06-29",
				25.69
			],
			[
				"2008-03-27",
				35.43
			],
			[
				"2013-07-23",
				7.53
			],
			[
				"2014-07-24",
				12.05
			],
			[
				"2015-10-28",
				18.2
			],
			[
				"2009-08-17",
				29.23
			],
			[
				"2010-05-06",
				26.57
			],
			[
				"2011-07-20",
				17.71
			]
		],
		"21001352": [
			[
				"2000-11-09",
				26.13
			],
			[
				"2001-06-27",
				26.22
			],
			[
				"2002-05-22",
				28.34
			],
			[
				"2003-07-04",
				28.87
			],
			[
				"2004-03-26",
				31.13
			],
			[
				"2005-07-21",
				28.34
			],
			[
				"2006-04-19",
				27.01
			],
			[
				"2007-07-19",
				25.24
			],
			[
				"2013-07-23",
				23.91
			],
			[
				"2014-10-16",
				15.19
			],
			[
				"2015-10-22",
				8.86
			],
			[
				"2009-07-29",
				23.03
			],
			[
				"2010-06-22",
				27.01
			],
			[
				"2008-05-14",
				25.69
			],
			[
				"2011-04-27",
				29.23
			],
			[
				"2012-11-29",
				21.7
			]
		],
		"21001698": [
			[
				"2000-11-21",
				2.21
			],
			[
				"2002-07-03",
				5.23
			],
			[
				"2003-06-25",
				4.47
			],
			[
				"2004-03-11",
				4.47
			],
			[
				"2005-07-07",
				2.21
			],
			[
				"2006-04-18",
				2.26
			],
			[
				"2007-06-22",
				2.21
			],
			[
				"2013-06-27",
				2.21
			],
			[
				"2014-07-03",
				3.72
			],
			[
				"2015-07-14",
				1.33
			],
			[
				"2009-06-30",
				5.76
			],
			[
				"2008-04-04",
				5.76
			],
			[
				"2010-07-15",
				3.01
			],
			[
				"2011-07-14",
				7.97
			],
			[
				"2012-05-23",
				5.31
			]
		],
		"21001728": [
			[
				"2000-11-08",
				2.21
			],
			[
				"2001-02-27",
				2.21
			],
			[
				"2002-07-03",
				2.21
			],
			[
				"2003-06-13",
				2.21
			],
			[
				"2004-03-11",
				2.21
			],
			[
				"2005-07-07",
				2.21
			],
			[
				"2006-04-12",
				2.21
			],
			[
				"2007-06-21",
				2.21
			],
			[
				"2013-06-26",
				2.21
			],
			[
				"2014-06-25",
				1.33
			],
			[
				"2015-07-02",
				1.33
			],
			[
				"2009-06-29",
				2.21
			],
			[
				"2008-04-10",
				2.21
			],
			[
				"2010-07-27",
				2.21
			],
			[
				"2011-05-12",
				2.21
			],
			[
				"2012-08-10",
				2.21
			]
		],
		"21001730": [
			[
				"2000-11-08",
				84.14
			],
			[
				"2001-02-27",
				85.03
			],
			[
				"2003-06-13",
				80.6
			],
			[
				"2004-03-11",
				76.17
			],
			[
				"2005-07-07",
				84.14
			],
			[
				"2006-04-12",
				79.71
			],
			[
				"2007-06-21",
				79.71
			],
			[
				"2008-04-10",
				43.84
			],
			[
				"2013-06-26",
				110.71
			],
			[
				"2014-07-03",
				104.96
			],
			[
				"2015-07-02",
				82.37
			],
			[
				"2009-06-17",
				79.71
			],
			[
				"2010-07-27",
				128.43
			],
			[
				"2011-05-12",
				101.86
			],
			[
				"2012-06-26",
				155
			]
		],
		"21001765": [
			[
				"2000-10-19",
				34.54
			],
			[
				"2001-03-01",
				65.54
			],
			[
				"2002-05-15",
				49.16
			],
			[
				"2003-04-30",
				39.37
			],
			[
				"2004-02-26",
				43.49
			],
			[
				"2005-07-22",
				48.71
			],
			[
				"2007-06-28",
				79.71
			],
			[
				"2013-07-03",
				70.86
			],
			[
				"2014-06-24",
				79.71
			],
			[
				"2015-07-15",
				75.29
			],
			[
				"2009-07-13",
				75.29
			],
			[
				"2006-05-22",
				62
			],
			[
				"2008-04-11",
				66.43
			],
			[
				"2010-07-14",
				70.86
			],
			[
				"2011-04-04",
				62
			],
			[
				"2012-08-03",
				75.29
			]
		],
		"21001777": [
			[
				"2000-10-19",
				19.93
			],
			[
				"2001-03-01",
				14.61
			],
			[
				"2002-05-15",
				12.84
			],
			[
				"2003-04-30",
				12.67
			],
			[
				"2004-02-26",
				15.32
			],
			[
				"2005-07-22",
				15.06
			],
			[
				"2006-05-22",
				15.06
			],
			[
				"2007-06-28",
				10.63
			],
			[
				"2008-04-11",
				5.76
			],
			[
				"2013-07-03",
				16.39
			],
			[
				"2014-06-24",
				13.73
			],
			[
				"2015-07-15",
				9.34
			],
			[
				"2009-07-13",
				25.24
			],
			[
				"2010-06-16",
				15.5
			],
			[
				"2011-04-04",
				7.53
			],
			[
				"2012-08-03",
				19.49
			]
		],
		"21001789": [
			[
				"2001-11-07",
				2.21
			],
			[
				"2002-11-12",
				2.21
			],
			[
				"2004-09-20",
				2.21
			],
			[
				"2005-07-25",
				2.21
			],
			[
				"2006-10-25",
				2.21
			],
			[
				"2007-07-03",
				2.21
			],
			[
				"2008-12-09",
				2.21
			],
			[
				"2013-07-31",
				2.21
			],
			[
				"2014-08-12",
				1.33
			],
			[
				"2015-09-29",
				1.33
			],
			[
				"2009-10-01",
				2.21
			],
			[
				"2010-09-06",
				2.21
			],
			[
				"2011-09-13",
				2.21
			],
			[
				"2012-09-04",
				2.21
			]
		],
		"21001790": [
			[
				"2001-11-16",
				13.29
			],
			[
				"2004-09-29",
				11.91
			],
			[
				"2005-07-26",
				22.59
			],
			[
				"2006-09-18",
				24.36
			],
			[
				"2007-07-10",
				27.46
			],
			[
				"2013-07-08",
				31.89
			],
			[
				"2014-08-07",
				31.13
			],
			[
				"2015-07-21",
				30.38
			],
			[
				"2009-09-22",
				25.69
			],
			[
				"2010-10-18",
				32.33
			],
			[
				"2011-05-03",
				34.99
			],
			[
				"2012-09-06",
				33.21
			]
		],
		"21150011": [
			[
				"2001-11-14",
				6.33
			],
			[
				"2002-10-22",
				3.45
			],
			[
				"2003-03-12",
				3.81
			],
			[
				"2004-06-28",
				2.21
			],
			[
				"2005-07-06",
				2.97
			],
			[
				"2006-09-25",
				3.45
			],
			[
				"2007-06-25",
				2.61
			],
			[
				"2008-12-05",
				6.2
			],
			[
				"2013-07-02",
				5.76
			],
			[
				"2014-06-17",
				3.99
			],
			[
				"2015-08-11",
				3.63
			],
			[
				"2009-10-19",
				5.31
			],
			[
				"2010-07-28",
				3.59
			],
			[
				"2011-03-30",
				6.2
			],
			[
				"2012-06-14",
				5.31
			]
		],
		"21150023": [
			[
				"2001-11-15",
				2.21
			],
			[
				"2002-10-09",
				2.21
			],
			[
				"2003-04-08",
				2.21
			],
			[
				"2004-06-29",
				2.21
			],
			[
				"2005-07-12",
				2.21
			],
			[
				"2006-10-02",
				2.21
			],
			[
				"2007-06-27",
				2.21
			],
			[
				"2008-12-08",
				2.21
			],
			[
				"2013-09-19",
				2.21
			],
			[
				"2014-07-03",
				1.33
			],
			[
				"2015-08-04",
				1.86
			],
			[
				"2009-10-19",
				2.21
			],
			[
				"2010-10-26",
				2.88
			],
			[
				"2011-05-25",
				2.21
			],
			[
				"2012-10-10",
				2.21
			]
		],
		"21150035": [
			[
				"2001-11-13",
				2.21
			],
			[
				"2002-10-08",
				2.57
			],
			[
				"2003-10-01",
				2.21
			],
			[
				"2004-07-05",
				2.21
			],
			[
				"2005-07-18",
				2.21
			],
			[
				"2006-09-27",
				2.21
			],
			[
				"2007-06-26",
				2.21
			],
			[
				"2008-12-03",
				2.21
			],
			[
				"2013-09-17",
				4.87
			],
			[
				"2014-07-15",
				1.33
			],
			[
				"2015-08-04",
				1.33
			],
			[
				"2009-10-20",
				2.21
			],
			[
				"2010-09-21",
				2.21
			],
			[
				"2011-04-20",
				2.21
			],
			[
				"2012-07-31",
				2.21
			]
		],
		"21161501": [
			[
				"2000-11-14",
				175.37
			],
			[
				"2001-06-12",
				161.2
			],
			[
				"2002-07-30",
				120.9
			],
			[
				"2003-03-13",
				68.64
			],
			[
				"2003-06-26",
				100.97
			],
			[
				"2004-05-06",
				60.67
			],
			[
				"2005-07-28",
				66.43
			],
			[
				"2006-11-17",
				2.21
			],
			[
				"2007-05-16",
				62
			],
			[
				"2008-03-26",
				70.86
			],
			[
				"2013-07-25",
				34.54
			],
			[
				"2014-08-20",
				14.53
			],
			[
				"2015-11-03",
				16.47
			],
			[
				"2009-08-18",
				37.64
			],
			[
				"2010-07-29",
				39.86
			],
			[
				"2011-05-19",
				88.57
			],
			[
				"2012-06-28",
				36.31
			]
		],
		"21171403": [
			[
				"2000-11-20",
				54.91
			],
			[
				"2001-06-12",
				56.69
			],
			[
				"2001-10-24",
				51.37
			],
			[
				"2002-07-30",
				49.6
			],
			[
				"2002-09-17",
				46.94
			],
			[
				"2003-03-13",
				50.49
			],
			[
				"2003-06-26",
				48.71
			],
			[
				"2003-10-14",
				47.39
			],
			[
				"2004-06-02",
				42.34
			],
			[
				"2004-05-06",
				55.36
			],
			[
				"2005-07-28",
				48.71
			],
			[
				"2005-08-31",
				48.71
			],
			[
				"2006-10-27",
				48.71
			],
			[
				"2007-05-16",
				48.71
			],
			[
				"2008-03-20",
				42.07
			],
			[
				"2013-07-25",
				48.71
			],
			[
				"2013-08-19",
				48.71
			],
			[
				"2014-10-16",
				50.49
			],
			[
				"2015-10-07",
				46.06
			],
			[
				"2009-09-30",
				48.71
			],
			[
				"2010-09-02",
				44.29
			],
			[
				"2011-07-12",
				53.14
			],
			[
				"2012-07-18",
				53.14
			]
		],
		"21172810": [
			[
				"2013-07-24",
				2.21
			],
			[
				"2000-11-14",
				2.21
			],
			[
				"2001-06-12",
				2.21
			],
			[
				"2002-07-30",
				2.21
			],
			[
				"2003-03-13",
				2.21
			],
			[
				"2003-06-26",
				2.21
			],
			[
				"2004-05-06",
				2.21
			],
			[
				"2005-07-28",
				2.21
			],
			[
				"2005-11-10",
				2.21
			],
			[
				"2006-10-26",
				2.21
			],
			[
				"2007-05-24",
				2.21
			],
			[
				"2008-03-26",
				2.21
			],
			[
				"2014-08-20",
				1.33
			],
			[
				"2015-10-08",
				5.8
			]
		],
		"21173709": [
			[
				"2000-11-20",
				2.21
			],
			[
				"2001-06-19",
				2.21
			],
			[
				"2002-07-30",
				2.21
			],
			[
				"2003-03-13",
				2.21
			],
			[
				"2003-06-26",
				2.21
			],
			[
				"2004-05-06",
				2.21
			],
			[
				"2005-07-28",
				2.21
			],
			[
				"2006-10-27",
				2.21
			],
			[
				"2008-03-11",
				2.21
			],
			[
				"2007-05-16",
				2.21
			],
			[
				"2013-08-22",
				2.52
			],
			[
				"2014-10-28",
				1.33
			],
			[
				"2015-11-03",
				1.33
			],
			[
				"2009-09-29",
				2.21
			],
			[
				"2010-09-02",
				2.48
			],
			[
				"2011-04-28",
				2.21
			],
			[
				"2012-06-28",
				2.21
			]
		],
		"21175603": [
			[
				"2000-11-14",
				2.79
			],
			[
				"2001-06-19",
				2.21
			],
			[
				"2002-07-30",
				2.21
			],
			[
				"2003-06-26",
				2.21
			],
			[
				"2004-05-06",
				2.21
			],
			[
				"2005-07-28",
				2.21
			],
			[
				"2006-10-26",
				2.21
			],
			[
				"2007-05-24",
				2.21
			],
			[
				"2008-04-17",
				2.21
			],
			[
				"2013-07-26",
				2.21
			],
			[
				"2014-07-01",
				1.33
			],
			[
				"2015-10-08",
				1.33
			],
			[
				"2009-11-11",
				2.21
			],
			[
				"2010-08-26",
				2.21
			],
			[
				"2011-08-31",
				2.21
			],
			[
				"2012-07-18",
				2.21
			]
		],
		"21175706": [
			[
				"2003-08-07",
				26.26
			],
			[
				"2004-05-17",
				30.42
			],
			[
				"2005-07-28",
				15.5
			],
			[
				"2006-10-26",
				10.19
			],
			[
				"2007-05-29",
				8.41
			],
			[
				"2008-02-28",
				39.41
			],
			[
				"2005-08-02",
				36.09
			],
			[
				"2009-02-03",
				14.48
			],
			[
				"2006-11-27",
				12.09
			],
			[
				"2007-11-26",
				14.08
			],
			[
				"2013-07-26",
				5.76
			],
			[
				"2014-08-19",
				14.57
			],
			[
				"2015-10-08",
				27.41
			],
			[
				"2009-06-24",
				16.08
			],
			[
				"2005-11-07",
				10.05
			],
			[
				"2010-09-02",
				6.42
			],
			[
				"2010-11-15",
				5.27
			],
			[
				"2009-05-18",
				13.29
			],
			[
				"2009-10-07",
				8.86
			],
			[
				"2010-07-30",
				6.64
			],
			[
				"2011-11-08",
				5.67
			],
			[
				"2011-06-29",
				5.31
			],
			[
				"2012-07-18",
				6.64
			]
		],
		"21175809": [
			[
				"2001-07-18",
				2.21
			],
			[
				"2002-07-30",
				2.21
			],
			[
				"2003-07-17",
				2.21
			],
			[
				"2004-05-06",
				2.21
			],
			[
				"2005-07-28",
				2.21
			],
			[
				"2006-10-26",
				2.21
			],
			[
				"2007-05-24",
				2.21
			],
			[
				"2013-07-26",
				2.21
			],
			[
				"2014-08-19",
				1.33
			],
			[
				"2015-10-08",
				1.33
			],
			[
				"2009-09-29",
				2.21
			],
			[
				"2008-03-26",
				3.14
			],
			[
				"2010-07-30",
				2.21
			],
			[
				"2011-06-29",
				2.21
			],
			[
				"2012-05-24",
				2.21
			]
		],
		"21176103": [
			[
				"2006-10-27",
				2.21
			],
			[
				"2007-05-24",
				2.39
			],
			[
				"2008-03-26",
				2.21
			],
			[
				"2013-07-26",
				2.21
			],
			[
				"2014-08-19",
				4.34
			],
			[
				"2015-10-08",
				3.14
			],
			[
				"2009-09-29",
				2.21
			],
			[
				"2010-07-30",
				2.21
			],
			[
				"2011-06-29",
				2.21
			],
			[
				"2012-05-24",
				2.21
			]
		],
		"21184008": [
			[
				"2002-07-31",
				36.45
			],
			[
				"2004-04-15",
				41.76
			],
			[
				"2005-10-20",
				34.99
			],
			[
				"2007-06-05",
				29.67
			],
			[
				"2007-08-31",
				32.33
			],
			[
				"2013-09-03",
				32.33
			],
			[
				"2014-07-15",
				33.57
			],
			[
				"2015-12-03",
				46.06
			],
			[
				"2009-05-12",
				30.56
			],
			[
				"2009-09-17",
				14.17
			],
			[
				"2010-04-21",
				29.67
			],
			[
				"2011-05-04",
				31.44
			],
			[
				"2012-08-15",
				32.77
			]
		],
		"21184306": [
			[
				"2002-07-31",
				25.55
			],
			[
				"2003-07-17",
				25.64
			],
			[
				"2004-04-15",
				28.52
			],
			[
				"2005-07-29",
				25.69
			],
			[
				"2006-11-24",
				24.8
			],
			[
				"2007-05-24",
				23.03
			],
			[
				"2013-09-03",
				25.24
			],
			[
				"2014-11-19",
				25.02
			],
			[
				"2015-10-27",
				24.76
			],
			[
				"2008-04-17",
				25.24
			],
			[
				"2009-05-18",
				23.91
			],
			[
				"2010-08-26",
				20.81
			],
			[
				"2011-08-31",
				24.8
			],
			[
				"2012-08-15",
				26.57
			]
		],
		"21190707": [
			[
				"2006-11-15",
				13.73
			],
			[
				"2013-09-03",
				17.71
			],
			[
				"2014-08-14",
				19.88
			],
			[
				"2015-10-07",
				19.04
			],
			[
				"2009-10-15",
				17.27
			],
			[
				"2010-10-06",
				18.6
			],
			[
				"2011-04-07",
				18.16
			],
			[
				"2012-07-19",
				18.16
			]
		],
		"22520156": [
			[
				"2001-07-12",
				13.55
			],
			[
				"2003-10-31",
				12.93
			],
			[
				"2004-07-23",
				10.72
			],
			[
				"2005-10-21",
				14.17
			],
			[
				"2007-06-14",
				6.64
			],
			[
				"2013-06-25",
				9.3
			],
			[
				"2014-08-13",
				10.54
			],
			[
				"2015-07-16",
				11.69
			],
			[
				"2009-10-14",
				11.51
			],
			[
				"2008-05-07",
				7.09
			],
			[
				"2010-09-22",
				11.51
			],
			[
				"2011-09-15",
				11.51
			],
			[
				"2012-08-04",
				11.96
			]
		],
		"22520223": [
			[
				"2001-07-19",
				73.96
			],
			[
				"2003-10-31",
				73.96
			],
			[
				"2004-07-15",
				70.86
			],
			[
				"2005-10-21",
				75.29
			],
			[
				"2006-12-07",
				66.43
			],
			[
				"2007-06-14",
				70.86
			],
			[
				"2008-05-07",
				79.71
			],
			[
				"2013-06-25",
				86.8
			],
			[
				"2014-08-13",
				68.64
			],
			[
				"2015-07-16",
				76.61
			],
			[
				"2009-10-14",
				70.86
			],
			[
				"2010-10-06",
				75.29
			],
			[
				"2011-09-15",
				53.14
			],
			[
				"2012-08-04",
				75.29
			]
		],
		"23002785": [
			[
				"2010-11-24",
				20.61
			],
			[
				"2011-11-10",
				21.71
			],
			[
				"2013-12-03",
				19.51
			],
			[
				"2014-09-10",
				18.11
			],
			[
				"2015-09-09",
				16.01
			],
			[
				"2000-11-06",
				24.01
			],
			[
				"2001-10-24",
				25.01
			],
			[
				"2002-11-06",
				23.01
			],
			[
				"2004-09-28",
				24.11
			],
			[
				"2003-10-28",
				23.81
			],
			[
				"2005-10-12",
				24.81
			],
			[
				"2006-09-07",
				24.21
			],
			[
				"2007-09-13",
				24.21
			],
			[
				"2006-02-28",
				24.21
			],
			[
				"2006-05-02",
				23.91
			],
			[
				"2006-08-29",
				24.31
			],
			[
				"2006-11-13",
				23.31
			],
			[
				"2007-03-20",
				23.31
			],
			[
				"2007-06-25",
				24.01
			],
			[
				"2007-11-06",
				23.01
			]
		],
		"23006456": [
			[
				"2001-11-07",
				4.3
			],
			[
				"2005-10-25",
				4.4
			],
			[
				"2004-03-22",
				4.6
			],
			[
				"2011-11-29",
				5.5
			],
			[
				"2012-10-22",
				5.4
			],
			[
				"2013-12-12",
				5.8
			],
			[
				"2014-08-28",
				4.8
			],
			[
				"2015-09-10",
				3.5
			],
			[
				"2006-09-11",
				3.7
			],
			[
				"2008-09-16",
				3.9
			],
			[
				"2009-11-09",
				5.9
			]
		],
		"23007114": [
			[
				"2001-11-07",
				6.6
			],
			[
				"2011-11-23",
				5.4
			],
			[
				"2012-10-24",
				4.5
			],
			[
				"2013-12-04",
				4.9
			],
			[
				"2014-09-30",
				4.8
			],
			[
				"2015-09-15",
				4.7
			],
			[
				"2006-04-06",
				5.5
			],
			[
				"2008-09-25",
				5.4
			],
			[
				"2009-10-01",
				5.7
			]
		],
		"23061870": [
			[
				"2001-10-24",
				3.37
			],
			[
				"2002-09-18",
				2.21
			],
			[
				"2002-11-29",
				2.21
			],
			[
				"2003-04-17",
				2.35
			],
			[
				"2003-10-15",
				2.21
			],
			[
				"2004-03-18",
				2.92
			],
			[
				"2004-06-01",
				2.21
			],
			[
				"2005-09-01",
				2.21
			],
			[
				"2005-07-15",
				2.21
			],
			[
				"2004-08-09",
				0.9
			],
			[
				"2006-06-12",
				2.21
			],
			[
				"2007-06-04",
				11.51
			],
			[
				"2008-04-28",
				6.2
			],
			[
				"2010-07-08",
				1
			],
			[
				"2011-07-07",
				1
			],
			[
				"2012-08-22",
				1
			],
			[
				"2013-06-19",
				2.3
			],
			[
				"2014-08-11",
				1
			],
			[
				"2015-05-20",
				4.3
			],
			[
				"2013-07-18",
				10.63
			],
			[
				"2014-07-22",
				1.33
			],
			[
				"2015-09-09",
				2.17
			],
			[
				"2006-08-01",
				1
			],
			[
				"2007-07-03",
				5.8
			],
			[
				"2009-07-06",
				1
			],
			[
				"2009-08-26",
				5.76
			],
			[
				"2010-07-22",
				2.21
			],
			[
				"2011-05-20",
				3.23
			],
			[
				"2012-08-02",
				2.21
			]
		],
		"23061881": [
			[
				"2002-11-29",
				2.21
			],
			[
				"2003-04-17",
				2.21
			],
			[
				"2004-03-18",
				3.01
			],
			[
				"2005-11-10",
				2.21
			],
			[
				"2007-06-04",
				2.21
			],
			[
				"2008-04-28",
				2.21
			],
			[
				"2010-07-08",
				9.5
			],
			[
				"2011-07-07",
				9.3
			],
			[
				"2012-08-22",
				9.9
			],
			[
				"2013-06-19",
				10.2
			],
			[
				"2014-08-11",
				8.6
			],
			[
				"2015-05-20",
				8.2
			],
			[
				"2013-07-18",
				4.07
			],
			[
				"2014-07-22",
				7.93
			],
			[
				"2015-09-09",
				8.81
			],
			[
				"2006-08-01",
				1.4
			],
			[
				"2007-07-03",
				9.5
			],
			[
				"2009-07-06",
				9.5
			],
			[
				"2009-08-26",
				8.86
			],
			[
				"2006-06-12",
				2.21
			],
			[
				"2010-07-22",
				8.86
			],
			[
				"2011-05-20",
				8.86
			],
			[
				"2012-08-02",
				9.74
			]
		],
		"23062850": [
			[
				"2000-01-27",
				10.63
			],
			[
				"2001-03-01",
				14.17
			],
			[
				"2002-06-19",
				13.68
			],
			[
				"2003-03-21",
				9.08
			],
			[
				"2004-03-18",
				6.91
			],
			[
				"2005-07-15",
				2.21
			],
			[
				"2006-06-09",
				9.3
			],
			[
				"2007-07-12",
				11.07
			],
			[
				"2008-04-28",
				2.21
			],
			[
				"2013-09-16",
				8.86
			],
			[
				"2014-07-16",
				9.34
			],
			[
				"2015-07-29",
				10.01
			],
			[
				"2009-08-26",
				11.07
			],
			[
				"2010-07-21",
				9.74
			],
			[
				"2011-05-18",
				9.3
			],
			[
				"2012-09-12",
				7.97
			]
		],
		"23062861": [
			[
				"2000-01-27",
				12.84
			],
			[
				"2001-03-01",
				9.74
			],
			[
				"2002-06-19",
				2.21
			],
			[
				"2003-03-21",
				2.21
			],
			[
				"2004-03-18",
				2.21
			],
			[
				"2005-07-15",
				9.3
			],
			[
				"2006-06-09",
				2.21
			],
			[
				"2007-07-12",
				2.21
			],
			[
				"2013-09-16",
				2.21
			],
			[
				"2014-07-23",
				1.33
			],
			[
				"2015-07-29",
				20.46
			],
			[
				"2009-08-26",
				2.21
			],
			[
				"2008-04-28",
				10.63
			],
			[
				"2010-07-21",
				2.21
			],
			[
				"2011-05-18",
				2.21
			],
			[
				"2012-09-12",
				2.21
			]
		],
		"23063075": [
			[
				"2001-11-28",
				26.93
			],
			[
				"2002-11-13",
				26
			],
			[
				"2003-11-05",
				25.64
			],
			[
				"2004-09-22",
				19.88
			],
			[
				"2005-07-05",
				22.59
			],
			[
				"2006-09-20",
				28.79
			],
			[
				"2007-07-11",
				36.76
			],
			[
				"2008-12-08",
				23.91
			],
			[
				"2013-10-08",
				22.59
			],
			[
				"2014-06-24",
				26.57
			],
			[
				"2015-09-29",
				25.29
			],
			[
				"2009-08-11",
				20.81
			],
			[
				"2010-08-10",
				18.6
			],
			[
				"2011-04-06",
				19.49
			],
			[
				"2012-08-28",
				19.93
			]
		],
		"23160925": [
			[
				"2000-05-09",
				9
			],
			[
				"2000-10-30",
				10
			],
			[
				"2001-05-28",
				10
			],
			[
				"2001-11-06",
				9
			],
			[
				"2002-04-22",
				8
			],
			[
				"2002-11-07",
				8
			],
			[
				"2003-05-06",
				10
			],
			[
				"2003-10-28",
				2
			],
			[
				"2003-10-29",
				9
			],
			[
				"2003-10-30",
				10
			],
			[
				"2003-10-31",
				11
			],
			[
				"2003-11-03",
				11
			],
			[
				"2003-11-13",
				11
			],
			[
				"2004-05-05",
				11
			],
			[
				"2004-10-20",
				14
			],
			[
				"2005-10-20",
				16.01
			],
			[
				"2006-08-28",
				19.01
			],
			[
				"2006-09-11",
				16.01
			],
			[
				"2006-10-09",
				19.01
			],
			[
				"2006-10-23",
				15.01
			],
			[
				"2006-11-06",
				18.01
			],
			[
				"2006-11-20",
				16.01
			],
			[
				"2006-11-24",
				14
			],
			[
				"2006-05-11",
				15.01
			],
			[
				"2010-10-05",
				11
			],
			[
				"2011-05-09",
				14
			],
			[
				"2011-11-10",
				14
			],
			[
				"2012-05-08",
				15.01
			],
			[
				"2012-10-29",
				12
			],
			[
				"2013-05-08",
				16.01
			],
			[
				"2013-11-11",
				17.01
			],
			[
				"2014-05-15",
				14
			],
			[
				"2014-11-06",
				12
			],
			[
				"2015-04-23",
				12
			],
			[
				"2015-10-20",
				12
			],
			[
				"2007-06-06",
				11
			],
			[
				"2007-10-22",
				11
			],
			[
				"2008-04-17",
				12
			],
			[
				"2008-10-20",
				15.01
			],
			[
				"2009-05-06",
				9
			],
			[
				"2009-10-15",
				14
			],
			[
				"2010-04-07",
				13
			]
		],
		"23160949": [
			[
				"2000-05-11",
				24.01
			],
			[
				"2000-11-07",
				25.01
			],
			[
				"2001-05-30",
				24.01
			],
			[
				"2001-11-08",
				23.01
			],
			[
				"2002-04-25",
				24.01
			],
			[
				"2002-10-28",
				28.01
			],
			[
				"2003-05-07",
				29.01
			],
			[
				"2003-10-31",
				22.01
			],
			[
				"2003-11-10",
				27.01
			],
			[
				"2003-11-18",
				7
			],
			[
				"2003-11-19",
				12
			],
			[
				"2003-11-20",
				26.01
			],
			[
				"2003-11-24",
				27.01
			],
			[
				"2004-05-06",
				28.01
			],
			[
				"2004-10-21",
				27.01
			],
			[
				"2005-10-21",
				28.01
			],
			[
				"2006-08-28",
				27.01
			],
			[
				"2006-09-11",
				28.01
			],
			[
				"2006-10-09",
				27.01
			],
			[
				"2006-10-23",
				28.01
			],
			[
				"2006-11-06",
				27.01
			],
			[
				"2006-11-07",
				27.01
			],
			[
				"2006-11-20",
				25.01
			],
			[
				"2006-05-08",
				25.01
			],
			[
				"2010-10-07",
				31.01
			],
			[
				"2011-05-11",
				32.01
			],
			[
				"2011-11-07",
				32.01
			],
			[
				"2012-05-23",
				28.01
			],
			[
				"2012-11-07",
				28.01
			],
			[
				"2013-04-22",
				25.01
			],
			[
				"2013-11-13",
				27.01
			],
			[
				"2014-05-12",
				27.01
			],
			[
				"2014-10-28",
				27.01
			],
			[
				"2015-05-20",
				26.01
			],
			[
				"2015-10-29",
				24.01
			],
			[
				"2007-06-01",
				25.01
			],
			[
				"2007-10-29",
				27.01
			],
			[
				"2008-04-14",
				32.01
			],
			[
				"2008-10-23",
				41.01
			],
			[
				"2009-05-15",
				31.01
			],
			[
				"2009-10-12",
				32.01
			],
			[
				"2010-03-29",
				27.01
			]
		],
		"23161437": [
			[
				"2001-11-06",
				86.03
			],
			[
				"2002-04-22",
				78.03
			],
			[
				"2002-11-07",
				132.05
			],
			[
				"2003-05-06",
				110.04
			],
			[
				"2003-11-13",
				115.04
			],
			[
				"2004-05-05",
				107.04
			],
			[
				"2004-10-20",
				135.05
			],
			[
				"2005-05-18",
				110.04
			],
			[
				"2005-11-24",
				120.04
			],
			[
				"2006-11-24",
				76.03
			],
			[
				"2006-05-11",
				141.05
			],
			[
				"2010-10-05",
				106.04
			],
			[
				"2011-05-09",
				100.04
			],
			[
				"2011-11-10",
				147.05
			],
			[
				"2012-05-08",
				127.05
			],
			[
				"2012-10-29",
				121.04
			],
			[
				"2013-05-08",
				113.04
			],
			[
				"2013-11-11",
				128.05
			],
			[
				"2014-05-15",
				128.05
			],
			[
				"2014-11-06",
				113.04
			],
			[
				"2015-04-23",
				101.04
			],
			[
				"2015-10-20",
				131.05
			],
			[
				"2007-06-06",
				83.03
			],
			[
				"2007-10-22",
				67.02
			],
			[
				"2008-04-17",
				39.01
			],
			[
				"2008-10-21",
				57.02
			],
			[
				"2009-05-06",
				30.01
			],
			[
				"2009-10-15",
				32.01
			],
			[
				"2010-04-07",
				98.03
			]
		],
		"23163227": [
			[
				"2000-01-25",
				2.94
			],
			[
				"2000-03-24",
				2.96
			],
			[
				"2000-05-18",
				2.97
			],
			[
				"2000-07-19",
				3.33
			],
			[
				"2000-10-16",
				3.6
			],
			[
				"2000-11-29",
				3.6
			],
			[
				"2001-07-23",
				3.1
			],
			[
				"2001-03-19",
				3.15
			],
			[
				"2001-05-28",
				3.1
			],
			[
				"2001-09-24",
				3.06
			],
			[
				"2001-11-26",
				3.03
			],
			[
				"2001-01-22",
				3.05
			],
			[
				"2002-01-21",
				2.6
			],
			[
				"2002-09-24",
				4
			],
			[
				"2002-03-27",
				2.5
			],
			[
				"2002-05-28",
				2.8
			],
			[
				"2002-07-25",
				3.7
			],
			[
				"2002-11-20",
				2.9
			],
			[
				"2003-07-29",
				3.5
			],
			[
				"2003-03-25",
				3.1
			],
			[
				"2003-09-23",
				4.2
			],
			[
				"2003-05-13",
				3
			],
			[
				"2003-12-01",
				4.1
			],
			[
				"2003-01-21",
				3
			],
			[
				"2004-01-28",
				4
			],
			[
				"2004-01-28",
				4
			],
			[
				"2013-12-03",
				5
			],
			[
				"2014-03-05",
				4
			],
			[
				"2014-09-02",
				3
			],
			[
				"2015-03-09",
				3
			],
			[
				"2015-09-29",
				3
			],
			[
				"2008-04-22",
				3
			],
			[
				"2004-02-07",
				4
			],
			[
				"2004-10-14",
				3
			],
			[
				"2004-04-27",
				3
			],
			[
				"2005-05-25",
				3
			],
			[
				"2005-07-27",
				3
			],
			[
				"2005-11-30",
				3
			],
			[
				"2006-08-07",
				3
			],
			[
				"2006-09-25",
				3
			],
			[
				"2006-03-27",
				2
			],
			[
				"2006-11-29",
				3
			],
			[
				"2007-08-02",
				3
			],
			[
				"2007-04-05",
				3
			],
			[
				"2007-02-06",
				2
			],
			[
				"2007-05-24",
				2
			],
			[
				"2008-06-04",
				3
			],
			[
				"2008-10-08",
				0.2
			],
			[
				"2008-03-19",
				3
			],
			[
				"2009-06-03",
				0.2
			],
			[
				"2009-11-11",
				3
			],
			[
				"2009-08-19",
				3
			],
			[
				"2009-09-01",
				3.5
			],
			[
				"2010-09-01",
				3.8
			],
			[
				"2010-03-03",
				3.2
			]
		],
		"23163239": [
			[
				"2000-01-25",
				2.73
			],
			[
				"2000-03-24",
				2.82
			],
			[
				"2000-05-18",
				2.98
			],
			[
				"2000-07-19",
				3.08
			],
			[
				"2000-10-16",
				3.2
			],
			[
				"2000-11-29",
				3.2
			],
			[
				"2001-07-23",
				3
			],
			[
				"2001-03-19",
				2.82
			],
			[
				"2001-05-28",
				3.1
			],
			[
				"2001-09-24",
				2.97
			],
			[
				"2001-11-26",
				3.04
			],
			[
				"2001-01-22",
				2.86
			],
			[
				"2002-01-21",
				2.7
			],
			[
				"2002-09-24",
				2.8
			],
			[
				"2002-03-27",
				2.7
			],
			[
				"2002-05-28",
				2.8
			],
			[
				"2002-07-25",
				3.7
			],
			[
				"2002-11-20",
				3.1
			],
			[
				"2003-07-29",
				3.3
			],
			[
				"2003-03-25",
				3.2
			],
			[
				"2003-09-23",
				3.5
			],
			[
				"2003-05-13",
				3
			],
			[
				"2003-12-01",
				3.9
			],
			[
				"2003-01-21",
				3
			],
			[
				"2004-01-28",
				3
			],
			[
				"2004-01-28",
				3.1
			],
			[
				"2013-12-03",
				6
			],
			[
				"2014-03-04",
				4
			],
			[
				"2014-09-02",
				4
			],
			[
				"2015-03-04",
				4
			],
			[
				"2015-09-24",
				4
			],
			[
				"2008-04-22",
				4
			],
			[
				"2008-10-14",
				4
			],
			[
				"2004-02-07",
				4
			],
			[
				"2004-10-14",
				3
			],
			[
				"2004-04-27",
				4
			],
			[
				"2005-06-01",
				3
			],
			[
				"2005-07-27",
				4
			],
			[
				"2005-11-30",
				4
			],
			[
				"2006-08-07",
				3
			],
			[
				"2006-09-25",
				4
			],
			[
				"2006-03-27",
				3
			],
			[
				"2006-11-29",
				4
			],
			[
				"2007-08-02",
				4
			],
			[
				"2007-02-06",
				3
			],
			[
				"2007-05-24",
				4
			],
			[
				"2009-06-03",
				0.2
			],
			[
				"2009-11-11",
				3
			],
			[
				"2009-08-19",
				4
			],
			[
				"2009-09-01",
				4.1
			],
			[
				"2010-09-01",
				4.2
			],
			[
				"2010-03-03",
				4.1
			],
			[
				"2010-06-10",
				4.3
			]
		],
		"23163495": [
			[
				"2000-04-11",
				16.01
			],
			[
				"2000-02-25",
				15.01
			],
			[
				"2000-10-17",
				10
			],
			[
				"2001-10-16",
				12
			],
			[
				"2001-04-10",
				13
			],
			[
				"2001-02-20",
				13
			],
			[
				"2004-04-26",
				15.01
			],
			[
				"2003-03-24",
				16.01
			],
			[
				"2003-10-27",
				15.01
			],
			[
				"2002-06-18",
				14
			],
			[
				"2002-08-14",
				16.01
			],
			[
				"2002-10-07",
				17.01
			],
			[
				"2004-10-25",
				18.01
			],
			[
				"2012-03-29",
				14
			],
			[
				"2012-10-09",
				12
			],
			[
				"2013-03-28",
				16.01
			],
			[
				"2013-11-25",
				13
			],
			[
				"2014-03-26",
				13
			],
			[
				"2014-09-22",
				14
			],
			[
				"2015-10-27",
				15.01
			],
			[
				"2007-03-07",
				13
			],
			[
				"2007-10-17",
				15.01
			],
			[
				"2008-03-05",
				16.01
			],
			[
				"2008-10-31",
				10
			],
			[
				"2009-03-30",
				15.01
			],
			[
				"2009-10-06",
				12
			],
			[
				"2010-03-17",
				15.01
			]
		],
		"24170070": [
			[
				"2000-05-15",
				54.02
			],
			[
				"2000-10-09",
				52.02
			],
			[
				"2001-05-21",
				51.02
			],
			[
				"2001-10-09",
				52.02
			],
			[
				"2001-10-23",
				54.03
			],
			[
				"2002-05-06",
				50.02
			],
			[
				"2002-09-17",
				50.04
			],
			[
				"2002-10-21",
				49.02
			],
			[
				"2003-05-14",
				44.02
			],
			[
				"2003-10-14",
				47.83
			],
			[
				"2003-11-13",
				46.02
			],
			[
				"2004-02-25",
				45.02
			],
			[
				"2004-04-08",
				46.02
			],
			[
				"2004-04-26",
				47.02
			],
			[
				"2004-05-26",
				47.02
			],
			[
				"2004-06-22",
				46.02
			],
			[
				"2004-06-02",
				41.05
			],
			[
				"2004-07-28",
				47.02
			],
			[
				"2004-08-26",
				46.02
			],
			[
				"2004-09-28",
				45.02
			],
			[
				"2004-10-18",
				52.02
			],
			[
				"2004-11-10",
				56.02
			],
			[
				"2004-12-09",
				69.02
			],
			[
				"2005-08-30",
				48.71
			],
			[
				"2005-01-25",
				52.02
			],
			[
				"2005-02-17",
				48.02
			],
			[
				"2005-03-10",
				49.02
			],
			[
				"2005-04-13",
				46.02
			],
			[
				"2005-04-21",
				47.02
			],
			[
				"2005-10-25",
				40.01
			],
			[
				"2005-11-14",
				45.02
			],
			[
				"2005-12-08",
				47.02
			],
			[
				"2006-07-18",
				46.02
			],
			[
				"2006-08-08",
				50.02
			],
			[
				"2006-09-28",
				46.02
			],
			[
				"2006-10-18",
				44.02
			],
			[
				"2006-11-14",
				45.02
			],
			[
				"2006-12-12",
				46.02
			],
			[
				"2006-01-18",
				48.02
			],
			[
				"2006-02-15",
				47.02
			],
			[
				"2006-03-09",
				46.02
			],
			[
				"2006-04-25",
				48.02
			],
			[
				"2006-05-04",
				46.02
			],
			[
				"2006-05-24",
				46.02
			],
			[
				"2006-06-26",
				47.02
			],
			[
				"2010-07-06",
				47.02
			],
			[
				"2010-08-03",
				46.02
			],
			[
				"2010-09-01",
				45.02
			],
			[
				"2010-10-04",
				46.02
			],
			[
				"2010-10-06",
				46.02
			],
			[
				"2010-11-04",
				45.02
			],
			[
				"2010-12-07",
				46.02
			],
			[
				"2011-01-10",
				44.02
			],
			[
				"2011-02-07",
				44.02
			],
			[
				"2011-02-28",
				45.02
			],
			[
				"2011-04-04",
				44.02
			],
			[
				"2011-04-27",
				43.02
			],
			[
				"2011-05-10",
				48.02
			],
			[
				"2011-06-09",
				46.02
			],
			[
				"2011-07-05",
				44.02
			],
			[
				"2011-08-02",
				44.02
			],
			[
				"2011-09-05",
				40.01
			],
			[
				"2011-09-29",
				43.02
			],
			[
				"2011-10-04",
				43.02
			],
			[
				"2011-11-03",
				45.02
			],
			[
				"2011-11-30",
				43.02
			],
			[
				"2012-01-09",
				44.02
			],
			[
				"2012-02-14",
				46.02
			],
			[
				"2012-03-06",
				46.02
			],
			[
				"2012-04-11",
				45.02
			],
			[
				"2012-04-18",
				46.02
			],
			[
				"2012-05-08",
				45.02
			],
			[
				"2012-06-14",
				43.02
			],
			[
				"2012-07-04",
				43.02
			],
			[
				"2012-08-08",
				45.02
			],
			[
				"2012-09-06",
				44.02
			],
			[
				"2012-10-16",
				43.02
			],
			[
				"2012-11-15",
				43.02
			],
			[
				"2012-12-04",
				42.01
			],
			[
				"2013-01-14",
				44.02
			],
			[
				"2013-02-06",
				46.02
			],
			[
				"2013-03-06",
				47.02
			],
			[
				"2013-04-03",
				49.02
			],
			[
				"2013-05-13",
				46.02
			],
			[
				"2013-06-06",
				44.02
			],
			[
				"2013-07-01",
				46.02
			],
			[
				"2013-08-13",
				46.02
			],
			[
				"2013-09-03",
				45.02
			],
			[
				"2013-10-08",
				44.02
			],
			[
				"2013-11-05",
				43.02
			],
			[
				"2013-12-06",
				45.02
			],
			[
				"2014-01-08",
				46.02
			],
			[
				"2014-02-03",
				46.02
			],
			[
				"2014-03-05",
				46.02
			],
			[
				"2014-04-07",
				46.02
			],
			[
				"2014-05-07",
				42.01
			],
			[
				"2014-06-02",
				43.02
			],
			[
				"2014-07-01",
				42.01
			],
			[
				"2014-08-06",
				46.02
			],
			[
				"2014-09-18",
				47.02
			],
			[
				"2015-05-27",
				48.02
			],
			[
				"2015-06-17",
				47.02
			],
			[
				"2015-07-14",
				44.02
			],
			[
				"2015-11-04",
				44.02
			],
			[
				"2015-12-15",
				48.02
			],
			[
				"2007-01-18",
				49.02
			],
			[
				"2007-02-08",
				48.02
			],
			[
				"2007-03-12",
				46.02
			],
			[
				"2007-04-10",
				46.02
			],
			[
				"2007-05-24",
				48.02
			],
			[
				"2007-06-12",
				48.02
			],
			[
				"2007-07-19",
				47.02
			],
			[
				"2007-08-14",
				45.02
			],
			[
				"2007-09-20",
				46.02
			],
			[
				"2007-10-11",
				44.02
			],
			[
				"2007-10-25",
				48.02
			],
			[
				"2007-11-08",
				46.02
			],
			[
				"2007-12-03",
				45.02
			],
			[
				"2008-05-06",
				45.02
			],
			[
				"2008-06-12",
				46.02
			],
			[
				"2008-01-10",
				48.02
			],
			[
				"2008-02-07",
				44.02
			],
			[
				"2008-03-04",
				46.02
			],
			[
				"2008-04-08",
				44.02
			],
			[
				"2008-04-15",
				43.02
			],
			[
				"2008-08-06",
				45.02
			],
			[
				"2008-09-02",
				44.02
			],
			[
				"2008-10-08",
				42.01
			],
			[
				"2008-11-11",
				44.02
			],
			[
				"2008-12-03",
				46.02
			],
			[
				"2009-01-05",
				46.02
			],
			[
				"2009-02-03",
				45.02
			],
			[
				"2009-03-05",
				42.01
			],
			[
				"2009-04-08",
				47.02
			],
			[
				"2009-05-04",
				46.02
			],
			[
				"2009-05-06",
				45.02
			],
			[
				"2009-06-03",
				46.02
			],
			[
				"2009-07-13",
				44.02
			],
			[
				"2009-08-04",
				42.01
			],
			[
				"2009-09-09",
				45.02
			],
			[
				"2009-09-28",
				43.02
			],
			[
				"2009-10-08",
				43.02
			],
			[
				"2009-11-03",
				42.01
			],
			[
				"2009-12-03",
				47.02
			],
			[
				"2010-01-11",
				45.02
			],
			[
				"2010-03-02",
				42.01
			],
			[
				"2010-04-08",
				45.02
			],
			[
				"2010-04-26",
				49.02
			],
			[
				"2010-05-03",
				46.02
			],
			[
				"2010-06-08",
				45.02
			],
			[
				"2012-11-13",
				44.29
			]
		],
		"24170148": [
			[
				"2000-05-15",
				27.01
			],
			[
				"2000-10-24",
				24.01
			],
			[
				"2001-05-21",
				24.01
			],
			[
				"2001-10-09",
				24.01
			],
			[
				"2002-06-06",
				25.01
			],
			[
				"2002-11-04",
				26.01
			],
			[
				"2003-05-14",
				26.01
			],
			[
				"2003-11-10",
				25.01
			],
			[
				"2004-04-26",
				23.01
			],
			[
				"2004-11-10",
				20.01
			],
			[
				"2005-04-21",
				26.01
			],
			[
				"2006-09-28",
				23.01
			],
			[
				"2006-05-04",
				25.01
			],
			[
				"2010-10-06",
				24.01
			],
			[
				"2011-04-27",
				23.01
			],
			[
				"2011-09-29",
				24.01
			],
			[
				"2012-03-27",
				24.01
			],
			[
				"2012-11-08",
				24.01
			],
			[
				"2013-04-18",
				23.01
			],
			[
				"2013-10-08",
				24.01
			],
			[
				"2013-12-03",
				23.01
			],
			[
				"2014-05-08",
				24.01
			],
			[
				"2014-10-13",
				23.01
			],
			[
				"2015-04-15",
				25.01
			],
			[
				"2015-10-14",
				22.01
			],
			[
				"2007-05-24",
				25.01
			],
			[
				"2007-10-11",
				25.01
			],
			[
				"2008-04-15",
				24.01
			],
			[
				"2008-10-08",
				24.01
			],
			[
				"2009-05-12",
				22.01
			],
			[
				"2009-09-28",
				24.01
			],
			[
				"2010-04-26",
				27.01
			]
		],
		"24170150": [
			[
				"2000-07-12",
				22.59
			],
			[
				"2000-11-20",
				21.7
			],
			[
				"2001-07-04",
				20.64
			],
			[
				"2002-04-05",
				30.42
			],
			[
				"2003-07-03",
				19.71
			],
			[
				"2004-02-06",
				33.66
			],
			[
				"2004-06-17",
				18.95
			],
			[
				"2005-10-07",
				22.14
			],
			[
				"2006-07-24",
				21.7
			],
			[
				"2008-03-11",
				31
			],
			[
				"2007-05-25",
				23.03
			],
			[
				"2008-08-08",
				20.81
			],
			[
				"2013-05-28",
				23.91
			],
			[
				"2014-04-15",
				19.93
			],
			[
				"2015-03-18",
				25.73
			],
			[
				"2015-10-05",
				21.43
			],
			[
				"2016-02-17",
				30.11
			],
			[
				"2009-07-14",
				15.5
			],
			[
				"2010-06-22",
				22.59
			],
			[
				"2003-02-28",
				31.97
			],
			[
				"2011-04-28",
				21.7
			],
			[
				"2012-04-26",
				22.14
			]
		],
		"24170173": [
			[
				"2003-06-10",
				40.01
			],
			[
				"2003-06-12",
				39.01
			],
			[
				"2003-06-13",
				39.01
			],
			[
				"2003-06-15",
				39.01
			],
			[
				"2003-06-18",
				40.01
			],
			[
				"2003-06-20",
				39.01
			],
			[
				"2003-06-23",
				39.01
			],
			[
				"2003-06-30",
				39.01
			],
			[
				"2003-06-25",
				39.01
			],
			[
				"2003-06-27",
				39.01
			],
			[
				"2003-10-24",
				38.01
			],
			[
				"2004-07-01",
				41.01
			],
			[
				"2004-10-01",
				40.01
			],
			[
				"2006-03-23",
				38.01
			],
			[
				"2006-04-04",
				38.01
			],
			[
				"2006-04-25",
				38.01
			],
			[
				"2006-08-21",
				38.01
			],
			[
				"2007-05-24",
				40.01
			],
			[
				"2007-10-11",
				39.01
			],
			[
				"2008-04-15",
				38.01
			],
			[
				"2008-10-08",
				38.01
			],
			[
				"2009-04-22",
				37.01
			],
			[
				"2009-09-28",
				37.01
			],
			[
				"2010-04-26",
				37.01
			],
			[
				"2010-10-06",
				37.01
			],
			[
				"2011-04-27",
				36.01
			],
			[
				"2011-09-29",
				37.01
			],
			[
				"2012-03-27",
				36.01
			],
			[
				"2012-11-08",
				37.01
			],
			[
				"2013-04-18",
				35.01
			],
			[
				"2013-10-08",
				38.01
			],
			[
				"2013-12-03",
				34.01
			],
			[
				"2014-05-08",
				35.01
			],
			[
				"2014-10-13",
				35.01
			],
			[
				"2015-04-15",
				36.01
			],
			[
				"2015-10-14",
				34.01
			]
		],
		"24180026": [
			[
				"2000-07-12",
				26.57
			],
			[
				"2000-11-22",
				26.13
			],
			[
				"2001-07-04",
				24.27
			],
			[
				"2002-04-05",
				27.59
			],
			[
				"2003-07-03",
				23.78
			],
			[
				"2004-01-22",
				36.18
			],
			[
				"2005-10-07",
				26.13
			],
			[
				"2006-07-24",
				25.24
			],
			[
				"2008-03-06",
				29.23
			],
			[
				"2007-05-25",
				24.8
			],
			[
				"2008-08-08",
				25.24
			],
			[
				"2013-05-28",
				30.11
			],
			[
				"2014-01-28",
				29.67
			],
			[
				"2015-03-18",
				25.51
			],
			[
				"2016-01-28",
				29.67
			],
			[
				"2009-07-14",
				24.8
			],
			[
				"2010-05-12",
				26.13
			],
			[
				"2003-02-28",
				29.05
			],
			[
				"2011-04-07",
				26.57
			],
			[
				"2012-04-26",
				24.36
			]
		],
		"24180063": [
			[
				"2000-07-12",
				24.36
			],
			[
				"2001-07-17",
				23.52
			],
			[
				"2002-08-14",
				24.18
			],
			[
				"2003-07-03",
				23.43
			],
			[
				"2004-01-22",
				32.15
			],
			[
				"2005-10-14",
				39.86
			],
			[
				"2007-05-25",
				24.36
			],
			[
				"2008-03-06",
				41.19
			],
			[
				"2008-08-26",
				25.24
			],
			[
				"2013-08-22",
				26.57
			],
			[
				"2014-09-23",
				22.14
			],
			[
				"2015-10-05",
				26.13
			],
			[
				"2009-09-30",
				28.34
			],
			[
				"2010-10-13",
				38.53
			],
			[
				"2011-05-19",
				30.11
			],
			[
				"2012-08-08",
				24.36
			]
		],
		"24180087": [
			[
				"2000-07-12",
				28.79
			],
			[
				"2000-11-20",
				28.79
			],
			[
				"2001-07-04",
				27.5
			],
			[
				"2001-10-23",
				29.18
			],
			[
				"2002-04-05",
				30.34
			],
			[
				"2002-09-17",
				32.28
			],
			[
				"2003-07-03",
				27.55
			],
			[
				"2003-10-14",
				38.44
			],
			[
				"2004-01-22",
				43.71
			],
			[
				"2004-06-02",
				24.62
			],
			[
				"2005-08-30",
				31.44
			],
			[
				"2005-10-07",
				30.56
			],
			[
				"2006-07-24",
				28.34
			],
			[
				"2008-03-06",
				31.44
			],
			[
				"2007-05-25",
				27.9
			],
			[
				"2008-08-08",
				29.23
			],
			[
				"2013-05-27",
				30.11
			],
			[
				"2014-01-28",
				33.21
			],
			[
				"2015-03-18",
				30.96
			],
			[
				"2016-01-28",
				34.1
			],
			[
				"2009-07-14",
				27.46
			],
			[
				"2010-05-12",
				31
			],
			[
				"2003-02-25",
				27.9
			],
			[
				"2011-04-07",
				29.67
			],
			[
				"2012-04-26",
				28.34
			]
		],
		"24180166": [
			[
				"2006-11-24",
				29.23
			],
			[
				"2007-05-24",
				24.36
			],
			[
				"2008-03-05",
				26.57
			],
			[
				"2008-08-19",
				24.36
			],
			[
				"2013-05-28",
				29.67
			],
			[
				"2014-01-28",
				24.36
			],
			[
				"2015-03-18",
				28.65
			],
			[
				"2016-02-17",
				29.23
			],
			[
				"2010-05-04",
				26.71
			],
			[
				"2009-05-04",
				25.91
			],
			[
				"2010-10-12",
				25.81
			],
			[
				"2013-05-21",
				29.21
			],
			[
				"2014-05-20",
				24.81
			],
			[
				"2009-09-10",
				23.91
			],
			[
				"2010-05-12",
				26.57
			],
			[
				"2011-04-28",
				23.47
			],
			[
				"2012-04-26",
				23.91
			]
		],
		"24180403": [
			[
				"2000-05-16",
				31.44
			],
			[
				"2000-08-23",
				26.01
			],
			[
				"2000-11-22",
				2.61
			],
			[
				"2000-09-04",
				14.79
			],
			[
				"2001-06-21",
				29.49
			],
			[
				"2001-08-29",
				24.01
			],
			[
				"2002-01-16",
				32.33
			],
			[
				"2002-10-31",
				31.93
			],
			[
				"2003-02-25",
				31.84
			],
			[
				"2003-09-02",
				25.01
			],
			[
				"2003-07-11",
				29.67
			],
			[
				"2004-01-13",
				33.26
			],
			[
				"2002-10-10",
				26.01
			],
			[
				"2004-08-12",
				27.01
			],
			[
				"2011-08-29",
				29.01
			],
			[
				"2013-08-21",
				27.01
			],
			[
				"2013-12-12",
				27.01
			],
			[
				"2014-09-22",
				25.01
			],
			[
				"2015-08-10",
				25.01
			],
			[
				"2005-08-17",
				28.01
			],
			[
				"2006-08-29",
				28.01
			],
			[
				"2008-08-28",
				29.01
			],
			[
				"2009-08-24",
				27.01
			],
			[
				"2010-08-23",
				27.01
			],
			[
				"2012-06-05",
				27.01
			]
		],
		"24180439": [
			[
				"2000-07-13",
				11.51
			],
			[
				"2000-11-22",
				11.07
			],
			[
				"2000-09-04",
				13.29
			],
			[
				"2001-06-21",
				14.08
			],
			[
				"2002-01-16",
				12.89
			],
			[
				"2003-02-25",
				11.96
			],
			[
				"2003-07-11",
				11.07
			],
			[
				"2004-01-13",
				10.19
			],
			[
				"2004-04-29",
				10.98
			],
			[
				"2010-10-06",
				12
			],
			[
				"2011-05-04",
				11
			],
			[
				"2011-10-13",
				11
			],
			[
				"2012-05-14",
				11
			],
			[
				"2012-10-08",
				11
			],
			[
				"2013-06-18",
				13
			],
			[
				"2013-10-08",
				11
			],
			[
				"2014-08-11",
				12
			],
			[
				"2014-10-06",
				11
			],
			[
				"2015-08-18",
				10
			],
			[
				"2015-10-01",
				11
			],
			[
				"2008-10-22",
				11
			],
			[
				"2009-05-27",
				12
			],
			[
				"2009-10-21",
				11
			],
			[
				"2010-05-04",
				12
			]
		],
		"24180452": [
			[
				"2000-02-03",
				6.63
			],
			[
				"2000-03-28",
				6.95
			],
			[
				"2000-05-30",
				6.2
			],
			[
				"2000-07-19",
				6.33
			],
			[
				"2000-11-30",
				6.74
			],
			[
				"2000-10-10",
				7.31
			],
			[
				"2001-03-29",
				7.21
			],
			[
				"2001-05-31",
				5.5
			],
			[
				"2001-11-27",
				5.91
			],
			[
				"2001-01-30",
				7.43
			],
			[
				"2002-03-26",
				6.3
			],
			[
				"2002-09-25",
				5.3
			],
			[
				"2002-11-28",
				5.7
			],
			[
				"2003-08-05",
				7.1
			],
			[
				"2003-03-27",
				6.5
			],
			[
				"2003-09-29",
				6
			],
			[
				"2003-05-15",
				6.5
			],
			[
				"2003-12-01",
				7.8
			],
			[
				"2004-01-29",
				8
			],
			[
				"2004-01-29",
				7.5
			],
			[
				"2013-12-03",
				7
			],
			[
				"2014-03-04",
				6
			],
			[
				"2014-09-02",
				2
			],
			[
				"2015-03-05",
				6
			],
			[
				"2015-09-24",
				7
			],
			[
				"2008-04-22",
				6
			],
			[
				"2008-10-14",
				5
			],
			[
				"2004-10-14",
				5
			],
			[
				"2004-04-27",
				7
			],
			[
				"2005-07-27",
				6
			],
			[
				"2005-11-30",
				6
			],
			[
				"2006-08-07",
				6
			],
			[
				"2006-08-26",
				6
			],
			[
				"2006-11-30",
				6
			],
			[
				"2007-08-02",
				6
			],
			[
				"2007-10-04",
				6
			],
			[
				"2007-04-05",
				6
			],
			[
				"2007-02-06",
				6
			],
			[
				"2007-05-24",
				6
			],
			[
				"2009-09-01",
				6
			],
			[
				"2009-06-03",
				6
			]
		],
		"24180762": [
			[
				"2000-12-12",
				3.1
			],
			[
				"2001-05-15",
				41.01
			],
			[
				"2002-05-08",
				42.01
			],
			[
				"2003-05-19",
				36.01
			],
			[
				"2004-05-27",
				43.02
			],
			[
				"2005-05-23",
				40.01
			],
			[
				"2014-10-28",
				31.58
			],
			[
				"2015-10-27",
				35.16
			],
			[
				"2006-05-16",
				39.01
			],
			[
				"2007-06-13",
				41.01
			]
		],
		"24180853": [
			[
				"2003-07-10",
				45.17
			],
			[
				"2003-08-07",
				46.5
			],
			[
				"2004-05-17",
				38.97
			],
			[
				"2005-10-06",
				44.29
			],
			[
				"2006-10-26",
				42.07
			],
			[
				"2008-02-28",
				44.29
			],
			[
				"2007-05-29",
				44.29
			],
			[
				"2013-08-22",
				41.63
			],
			[
				"2014-09-01",
				41.63
			],
			[
				"2015-12-03",
				44.02
			],
			[
				"2009-05-19",
				31
			],
			[
				"2009-10-07",
				43.84
			],
			[
				"2010-10-13",
				43.84
			],
			[
				"2011-04-28",
				43.4
			],
			[
				"2012-11-07",
				42.51
			]
		],
		"24180865": [
			[
				"2003-07-10",
				38.66
			],
			[
				"2003-08-07",
				38.93
			],
			[
				"2004-05-17",
				15.77
			],
			[
				"2005-10-06",
				37.64
			],
			[
				"2006-10-26",
				35.43
			],
			[
				"2008-02-28",
				32.33
			],
			[
				"2007-05-29",
				31
			],
			[
				"2013-08-22",
				35.43
			],
			[
				"2014-10-16",
				33.39
			],
			[
				"2015-10-07",
				33.7
			],
			[
				"2009-05-19",
				31
			],
			[
				"2009-10-07",
				35.87
			],
			[
				"2010-05-12",
				34.1
			],
			[
				"2011-03-29",
				26.57
			],
			[
				"2012-08-08",
				32.33
			]
		],
		"24180919": [
			[
				"2006-10-27",
				19.49
			],
			[
				"2008-03-05",
				21.7
			],
			[
				"2007-09-27",
				16.39
			],
			[
				"2013-05-28",
				16.83
			],
			[
				"2014-04-15",
				19.04
			],
			[
				"2015-03-19",
				23.69
			],
			[
				"2016-02-17",
				22.59
			],
			[
				"2009-09-10",
				20.37
			],
			[
				"2010-04-21",
				23.03
			],
			[
				"2008-08-15",
				20.37
			],
			[
				"2011-05-04",
				19.93
			],
			[
				"2012-07-21",
				21.26
			]
		],
		"24180920": [
			[
				"2006-10-27",
				16.39
			],
			[
				"2007-09-27",
				20.37
			],
			[
				"2008-03-05",
				17.71
			],
			[
				"2013-05-28",
				16.83
			],
			[
				"2014-01-28",
				18.16
			],
			[
				"2015-03-19",
				19.97
			],
			[
				"2016-02-17",
				22.14
			],
			[
				"2009-08-18",
				17.71
			],
			[
				"2010-04-21",
				19.93
			],
			[
				"2008-08-19",
				18.6
			],
			[
				"2011-05-04",
				19.04
			],
			[
				"2012-07-21",
				16.83
			]
		],
		"24180968": [
			[
				"2002-08-14",
				15.59
			],
			[
				"2004-04-15",
				17.36
			],
			[
				"2005-10-20",
				16.39
			],
			[
				"2007-06-05",
				17.27
			],
			[
				"2007-08-31",
				17.27
			],
			[
				"2013-09-05",
				13.73
			],
			[
				"2014-07-14",
				19
			],
			[
				"2015-12-03",
				16.52
			],
			[
				"2009-05-12",
				14.61
			],
			[
				"2009-09-17",
				7.09
			],
			[
				"2010-04-21",
				14.61
			],
			[
				"2011-05-04",
				13.29
			],
			[
				"2012-08-08",
				15.06
			]
		],
		"24190032": [
			[
				"2002-05-06",
				15.01
			],
			[
				"2002-11-04",
				15.01
			],
			[
				"2003-05-26",
				15.01
			],
			[
				"2003-11-17",
				16.01
			],
			[
				"2004-05-06",
				16.01
			],
			[
				"2004-11-16",
				22.01
			],
			[
				"2005-11-11",
				16.01
			],
			[
				"2006-11-13",
				16.01
			],
			[
				"2006-06-08",
				15.01
			],
			[
				"2010-10-07",
				16.01
			],
			[
				"2011-06-08",
				16.01
			],
			[
				"2011-11-08",
				16.01
			],
			[
				"2012-05-30",
				16.01
			],
			[
				"2012-11-07",
				16.01
			],
			[
				"2013-05-27",
				17.01
			],
			[
				"2013-10-30",
				16.01
			],
			[
				"2014-06-10",
				15.01
			],
			[
				"2014-11-12",
				18.01
			],
			[
				"2015-10-20",
				15.01
			],
			[
				"2007-05-29",
				16.01
			],
			[
				"2007-10-04",
				15.01
			],
			[
				"2008-05-09",
				15.01
			],
			[
				"2008-11-06",
				16.01
			],
			[
				"2009-05-18",
				15.01
			],
			[
				"2009-10-21",
				16.01
			],
			[
				"2010-06-01",
				16.01
			]
		],
		"24190068": [
			[
				"2000-05-22",
				15.01
			],
			[
				"2000-11-20",
				14
			],
			[
				"2001-05-31",
				15.01
			],
			[
				"2001-11-12",
				14
			],
			[
				"2002-05-08",
				13
			],
			[
				"2002-11-07",
				13
			],
			[
				"2003-05-20",
				14
			],
			[
				"2003-10-29",
				13
			],
			[
				"2004-03-17",
				14
			],
			[
				"2004-11-17",
				17.01
			],
			[
				"2005-02-03",
				18.01
			],
			[
				"2005-04-28",
				16.01
			],
			[
				"2006-11-23",
				15.01
			],
			[
				"2010-10-19",
				15.01
			],
			[
				"2011-05-18",
				14
			],
			[
				"2011-11-16",
				15.01
			],
			[
				"2012-05-15",
				15.01
			],
			[
				"2012-11-26",
				15.01
			],
			[
				"2013-05-28",
				13
			],
			[
				"2013-11-21",
				16.01
			],
			[
				"2014-05-27",
				15.01
			],
			[
				"2014-11-27",
				15.01
			],
			[
				"2015-05-28",
				15.01
			],
			[
				"2015-10-26",
				14
			],
			[
				"2007-05-24",
				17.01
			],
			[
				"2007-11-07",
				16.01
			],
			[
				"2008-04-21",
				18.01
			],
			[
				"2008-09-30",
				15.01
			],
			[
				"2009-05-12",
				16.01
			],
			[
				"2009-09-29",
				16.01
			],
			[
				"2010-05-20",
				17.01
			]
		],
		"24190123": [
			[
				"2000-03-29",
				19.01
			],
			[
				"2001-05-30",
				18.01
			],
			[
				"2001-10-22",
				18.01
			],
			[
				"2002-05-06",
				16.01
			],
			[
				"2002-11-04",
				18.01
			],
			[
				"2003-05-26",
				19.01
			],
			[
				"2003-11-17",
				18.01
			],
			[
				"2004-05-06",
				18.01
			],
			[
				"2004-08-02",
				19.01
			],
			[
				"2004-08-04",
				19.01
			],
			[
				"2004-08-09",
				19.01
			],
			[
				"2004-08-11",
				19.01
			],
			[
				"2004-08-16",
				17.01
			],
			[
				"2004-08-18",
				16.01
			],
			[
				"2004-08-23",
				19.01
			],
			[
				"2004-08-25",
				18.01
			],
			[
				"2004-11-16",
				18.01
			],
			[
				"2005-11-11",
				15.01
			],
			[
				"2006-11-13",
				16.01
			],
			[
				"2006-06-08",
				16.01
			],
			[
				"2010-10-07",
				16.01
			],
			[
				"2011-06-08",
				18.01
			],
			[
				"2011-11-08",
				16.01
			],
			[
				"2012-05-30",
				16.01
			],
			[
				"2012-11-07",
				16.01
			],
			[
				"2013-05-27",
				15.01
			],
			[
				"2013-10-30",
				16.01
			],
			[
				"2014-06-10",
				15.01
			],
			[
				"2014-11-12",
				16.01
			],
			[
				"2015-05-27",
				18.01
			],
			[
				"2015-10-20",
				15.01
			],
			[
				"2007-05-29",
				17.01
			],
			[
				"2007-10-04",
				18.01
			],
			[
				"2008-05-09",
				16.01
			],
			[
				"2008-11-06",
				17.01
			],
			[
				"2009-05-18",
				17.01
			],
			[
				"2009-10-21",
				15.01
			],
			[
				"2010-06-01",
				17.01
			]
		],
		"24190147": [
			[
				"2000-03-29",
				1
			],
			[
				"2000-11-21",
				1
			],
			[
				"2001-05-30",
				1
			],
			[
				"2001-07-26",
				16.01
			],
			[
				"2001-10-22",
				1
			],
			[
				"2002-05-06",
				2
			],
			[
				"2002-11-04",
				3
			],
			[
				"2003-05-26",
				2
			],
			[
				"2003-11-17",
				1
			],
			[
				"2004-05-06",
				1
			],
			[
				"2004-11-16",
				1
			],
			[
				"2005-11-11",
				2
			],
			[
				"2006-11-13",
				1
			],
			[
				"2006-06-08",
				1
			],
			[
				"2010-10-07",
				2
			],
			[
				"2011-06-08",
				1
			],
			[
				"2011-11-08",
				1
			],
			[
				"2012-05-30",
				1
			],
			[
				"2012-11-07",
				1
			],
			[
				"2013-05-27",
				1
			],
			[
				"2013-10-30",
				4
			],
			[
				"2014-06-10",
				1
			],
			[
				"2014-11-12",
				2
			],
			[
				"2015-05-27",
				2
			],
			[
				"2015-10-20",
				2
			],
			[
				"2007-05-29",
				1
			],
			[
				"2007-10-04",
				1
			],
			[
				"2008-05-09",
				1
			],
			[
				"2008-11-06",
				1
			],
			[
				"2009-05-18",
				1
			],
			[
				"2009-10-21",
				1
			],
			[
				"2010-06-01",
				1
			]
		],
		"24190251": [
			[
				"2002-05-06",
				15.01
			],
			[
				"2003-05-26",
				15.01
			],
			[
				"2003-11-17",
				15.01
			],
			[
				"2004-05-06",
				15.01
			],
			[
				"2004-11-16",
				15.01
			],
			[
				"2005-11-11",
				15.01
			],
			[
				"2006-11-13",
				15.01
			],
			[
				"2006-06-08",
				15.01
			],
			[
				"2010-10-07",
				14
			],
			[
				"2011-06-08",
				14
			],
			[
				"2011-11-08",
				14
			],
			[
				"2012-05-30",
				14
			],
			[
				"2012-11-07",
				14
			],
			[
				"2013-05-27",
				14
			],
			[
				"2013-10-30",
				14
			],
			[
				"2014-06-10",
				14
			],
			[
				"2014-11-12",
				15.01
			],
			[
				"2015-05-27",
				14
			],
			[
				"2015-10-20",
				13
			],
			[
				"2007-05-29",
				15.01
			],
			[
				"2007-10-04",
				15.01
			],
			[
				"2008-05-09",
				15.01
			],
			[
				"2008-11-06",
				15.01
			],
			[
				"2009-05-18",
				14
			],
			[
				"2009-10-21",
				15.01
			],
			[
				"2010-06-01",
				17.01
			]
		],
		"26490742": [
			[
				"2000-03-29",
				10.4
			],
			[
				"2000-11-07",
				11.5
			],
			[
				"2001-11-28",
				8.7
			],
			[
				"2001-04-24",
				10
			],
			[
				"2002-04-30",
				9.1
			],
			[
				"2003-10-02",
				6.8
			],
			[
				"2003-03-31",
				8.4
			],
			[
				"2004-02-05",
				5
			],
			[
				"2004-12-14",
				4.6
			],
			[
				"2004-10-12",
				7.4
			],
			[
				"2005-05-04",
				8
			],
			[
				"2005-11-08",
				4.7
			],
			[
				"2005-08-10",
				7.6
			],
			[
				"2005-08-17",
				8.3
			],
			[
				"2010-03-03",
				4.6
			],
			[
				"2010-10-21",
				3.8
			],
			[
				"2011-02-15",
				3.8
			],
			[
				"2011-11-03",
				5.8
			],
			[
				"2012-03-06",
				5
			],
			[
				"2012-10-31",
				6.2
			],
			[
				"2013-03-19",
				6.3
			],
			[
				"2013-10-15",
				7.5
			],
			[
				"2014-04-07",
				7.2
			],
			[
				"2014-10-01",
				5.6
			],
			[
				"2015-02-02",
				7.1
			],
			[
				"2006-03-07",
				5.2
			],
			[
				"2006-11-07",
				8
			],
			[
				"2007-10-02",
				7.8
			],
			[
				"2007-02-15",
				6.6
			],
			[
				"2008-02-06",
				7.1
			],
			[
				"2008-10-14",
				7.6
			],
			[
				"2009-11-10",
				4.7
			],
			[
				"2009-02-18",
				5
			]
		],
		"26490766": [
			[
				"2004-01-28",
				3.8
			],
			[
				"2004-03-10",
				2.5
			],
			[
				"2004-06-07",
				1.3
			],
			[
				"2004-04-26",
				1.8
			],
			[
				"2004-02-18",
				3.2
			],
			[
				"2004-11-30",
				0.5
			],
			[
				"2004-09-13",
				0.5
			],
			[
				"2005-02-01",
				0.5
			],
			[
				"2005-11-08",
				1
			],
			[
				"2010-03-03",
				1
			],
			[
				"2010-10-21",
				1
			],
			[
				"2011-02-15",
				1.2
			],
			[
				"2011-10-27",
				1.8
			],
			[
				"2012-03-06",
				1.6
			],
			[
				"2012-10-31",
				2.3
			],
			[
				"2013-03-26",
				1.8
			],
			[
				"2013-10-29",
				2.6
			],
			[
				"2014-10-01",
				1
			],
			[
				"2014-04-07",
				1
			],
			[
				"2015-02-02",
				1
			],
			[
				"2006-03-08",
				1
			],
			[
				"2006-09-14",
				1
			],
			[
				"2007-10-02",
				1
			],
			[
				"2007-02-14",
				1
			],
			[
				"2008-02-13",
				1
			],
			[
				"2008-11-26",
				1
			],
			[
				"2008-11-06",
				1
			],
			[
				"2008-10-16",
				1
			],
			[
				"2009-11-10",
				1
			],
			[
				"2009-02-04",
				1
			]
		],
		"26490997": [
			[
				"2000-04-11",
				59.62
			],
			[
				"2000-10-25",
				48.52
			],
			[
				"2001-11-13",
				52.12
			],
			[
				"2001-05-16",
				62.32
			],
			[
				"2002-11-26",
				55.72
			],
			[
				"2002-06-05",
				53.92
			],
			[
				"2003-09-23",
				55.02
			],
			[
				"2003-04-02",
				50.22
			],
			[
				"2004-02-04",
				50.22
			],
			[
				"2004-09-27",
				52.02
			],
			[
				"2005-01-31",
				47.62
			],
			[
				"2005-10-10",
				45.62
			],
			[
				"2010-02-23",
				36.31
			],
			[
				"2010-10-05",
				34.51
			],
			[
				"2011-02-08",
				43.92
			],
			[
				"2011-10-05",
				48.92
			],
			[
				"2012-03-15",
				43.62
			],
			[
				"2012-09-20",
				39.51
			],
			[
				"2012-12-05",
				47.32
			],
			[
				"2013-02-28",
				35.31
			],
			[
				"2013-10-09",
				35.61
			],
			[
				"2014-10-28",
				31.91
			],
			[
				"2014-04-09",
				34.91
			],
			[
				"2015-05-20",
				13.6
			],
			[
				"2006-02-13",
				43.92
			],
			[
				"2006-09-25",
				40.51
			],
			[
				"2007-02-19",
				42.31
			],
			[
				"2007-10-30",
				44.62
			],
			[
				"2009-10-13",
				38.51
			]
		],
		"26491448": [
			[
				"2000-05-31",
				2.8
			],
			[
				"2000-11-08",
				3.5
			],
			[
				"2001-05-30",
				1.9
			],
			[
				"2001-11-14",
				3.6
			],
			[
				"2002-04-24",
				2.3
			],
			[
				"2003-09-18",
				3.4
			],
			[
				"2003-05-14",
				2.9
			],
			[
				"2004-03-03",
				2.5
			],
			[
				"2004-10-18",
				2.7
			],
			[
				"2005-03-10",
				2.9
			],
			[
				"2005-10-17",
				2.7
			],
			[
				"2010-11-09",
				2.8
			],
			[
				"2011-03-03",
				2.7
			],
			[
				"2011-10-27",
				1.1
			],
			[
				"2012-04-02",
				2.2
			],
			[
				"2012-10-11",
				1.9
			],
			[
				"2013-04-16",
				1.3
			],
			[
				"2013-11-25",
				1.4
			],
			[
				"2014-03-17",
				1
			],
			[
				"2014-10-20",
				1
			],
			[
				"2015-03-11",
				1
			],
			[
				"2006-03-14",
				2.5
			],
			[
				"2006-10-16",
				2.3
			],
			[
				"2007-10-22",
				2.1
			],
			[
				"2007-03-06",
				2
			],
			[
				"2008-03-13",
				1.9
			],
			[
				"2008-10-13",
				2.9
			],
			[
				"2009-10-21",
				2.7
			],
			[
				"2009-03-03",
				3.1
			]
		],
		"26492064": [
			[
				"2000-04-05",
				0.6
			],
			[
				"2000-10-17",
				1.2
			],
			[
				"2001-10-16",
				0.9
			],
			[
				"2001-03-20",
				0.8
			],
			[
				"2002-10-15",
				1
			],
			[
				"2003-05-27",
				5.2
			],
			[
				"2003-09-01",
				1.8
			],
			[
				"2004-05-12",
				1.7
			],
			[
				"2004-10-26",
				1.2
			],
			[
				"2005-05-18",
				2
			],
			[
				"2005-10-04",
				1
			],
			[
				"2010-09-08",
				0.9
			],
			[
				"2011-03-07",
				0.8
			],
			[
				"2011-09-13",
				0.5
			],
			[
				"2012-04-11",
				0.5
			],
			[
				"2012-09-11",
				0.5
			],
			[
				"2013-04-24",
				0.5
			],
			[
				"2013-10-23",
				1
			],
			[
				"2014-04-09",
				0.7
			],
			[
				"2014-10-29",
				0.7
			],
			[
				"2015-03-24",
				1.2
			],
			[
				"2015-10-28",
				2.7
			],
			[
				"2006-03-22",
				0.5
			],
			[
				"2006-09-27",
				0.5
			],
			[
				"2007-09-26",
				0.5
			],
			[
				"2008-04-09",
				0.5
			],
			[
				"2008-12-17",
				0.5
			],
			[
				"2009-03-25",
				0.7
			],
			[
				"2009-09-23",
				0.5
			],
			[
				"2010-03-22",
				0.6
			]
		],
		"26495028": [
			[
				"2000-07-10",
				18.6
			],
			[
				"2001-06-27",
				17.54
			],
			[
				"2002-04-18",
				20.33
			],
			[
				"2003-02-26",
				20.02
			],
			[
				"2003-08-18",
				17.71
			],
			[
				"2006-10-19",
				21.7
			],
			[
				"2007-07-12",
				21.7
			],
			[
				"2008-05-19",
				21.26
			],
			[
				"2010-04-07",
				19.91
			],
			[
				"2014-02-04",
				16.83
			],
			[
				"2015-03-19",
				19.49
			],
			[
				"2007-07-26",
				19.71
			],
			[
				"2009-12-17",
				21.31
			],
			[
				"2009-09-17",
				31.89
			],
			[
				"2010-06-21",
				18.16
			],
			[
				"2011-05-18",
				17.71
			],
			[
				"2012-04-25",
				17.27
			],
			[
				"2013-04-04",
				17.71
			]
		],
		"26500012": [
			[
				"2000-11-29",
				15.5
			],
			[
				"2000-08-30",
				17.01
			],
			[
				"2001-07-10",
				11.16
			],
			[
				"2001-11-09",
				17.89
			],
			[
				"2002-03-22",
				19.22
			],
			[
				"2003-07-24",
				16.83
			],
			[
				"2004-02-13",
				16.74
			],
			[
				"2004-07-23",
				10.72
			],
			[
				"2005-09-30",
				15.94
			],
			[
				"2006-11-23",
				18.6
			],
			[
				"2007-06-15",
				16.83
			],
			[
				"2008-05-07",
				16.83
			],
			[
				"2008-08-07",
				17.27
			],
			[
				"2013-05-27",
				26.57
			],
			[
				"2014-04-15",
				14.17
			],
			[
				"2015-02-25",
				17.14
			],
			[
				"2016-01-28",
				15.94
			],
			[
				"2009-10-15",
				18.16
			],
			[
				"2010-09-22",
				15.94
			],
			[
				"2011-07-28",
				16.39
			],
			[
				"2012-06-27",
				15.94
			]
		],
		"26500036": [
			[
				"2000-08-31",
				38.97
			],
			[
				"2001-07-11",
				39.68
			],
			[
				"2002-03-26",
				38.62
			],
			[
				"2003-07-18",
				43.58
			],
			[
				"2004-02-13",
				53.59
			],
			[
				"2004-07-30",
				38.93
			],
			[
				"2005-10-20",
				43.4
			],
			[
				"2006-11-23",
				43.84
			],
			[
				"2007-06-14",
				43.84
			],
			[
				"2008-05-08",
				41.19
			],
			[
				"2014-04-29",
				37.2
			],
			[
				"2015-02-12",
				37.2
			],
			[
				"2016-01-26",
				38.97
			],
			[
				"2009-10-14",
				43.84
			],
			[
				"2008-08-14",
				44.29
			],
			[
				"2010-09-15",
				41.63
			],
			[
				"2011-06-16",
				40.74
			],
			[
				"2012-07-12",
				42.51
			]
		],
		"26500115": [
			[
				"2000-09-01",
				14.97
			],
			[
				"2001-11-09",
				14.88
			],
			[
				"2002-03-26",
				39.33
			],
			[
				"2003-07-23",
				14.53
			],
			[
				"2004-01-23",
				32.55
			],
			[
				"2004-07-30",
				12.62
			],
			[
				"2006-10-24",
				15.5
			],
			[
				"2007-06-14",
				17.27
			],
			[
				"2008-05-08",
				15.94
			],
			[
				"2013-05-27",
				16.39
			],
			[
				"2014-04-15",
				10.63
			],
			[
				"2015-02-12",
				19.09
			],
			[
				"2016-01-26",
				18.6
			],
			[
				"2009-10-14",
				16.83
			],
			[
				"2005-09-30",
				30.56
			],
			[
				"2008-08-14",
				16.83
			],
			[
				"2010-09-15",
				16.83
			],
			[
				"2011-06-16",
				15.5
			],
			[
				"2012-07-12",
				17.27
			]
		],
		"26500139": [
			[
				"2000-11-29",
				16.39
			],
			[
				"2000-08-31",
				17.49
			],
			[
				"2001-07-10",
				13.29
			],
			[
				"2001-10-23",
				16.3
			],
			[
				"2002-03-22",
				16.74
			],
			[
				"2002-09-17",
				18.33
			],
			[
				"2003-07-24",
				15.37
			],
			[
				"2003-10-14",
				33.61
			],
			[
				"2004-02-13",
				19.53
			],
			[
				"2004-06-02",
				13.33
			],
			[
				"2004-06-18",
				15.19
			],
			[
				"2005-08-30",
				19.49
			],
			[
				"2006-11-23",
				31
			],
			[
				"2007-06-15",
				17.71
			],
			[
				"2008-05-07",
				16.39
			],
			[
				"2013-05-27",
				16.39
			],
			[
				"2014-02-04",
				15.5
			],
			[
				"2015-02-25",
				17.4
			],
			[
				"2016-01-28",
				19.04
			],
			[
				"2009-10-15",
				25.69
			],
			[
				"2005-09-30",
				17.27
			],
			[
				"2008-08-07",
				16.83
			],
			[
				"2010-09-22",
				19.49
			],
			[
				"2011-07-28",
				16.83
			],
			[
				"2012-06-27",
				16.83
			]
		],
		"26500140": [
			[
				"2000-08-31",
				31
			],
			[
				"2001-07-10",
				31.75
			],
			[
				"2001-10-23",
				30.78
			],
			[
				"2002-03-22",
				29.8
			],
			[
				"2002-09-17",
				29.98
			],
			[
				"2003-07-18",
				30.78
			],
			[
				"2003-10-14",
				29.67
			],
			[
				"2004-01-23",
				31.35
			],
			[
				"2004-06-18",
				24.14
			],
			[
				"2004-06-02",
				24.98
			],
			[
				"2005-08-30",
				29.23
			],
			[
				"2005-10-20",
				30.56
			],
			[
				"2006-11-23",
				31.44
			],
			[
				"2007-06-15",
				28.79
			],
			[
				"2008-05-08",
				28.79
			],
			[
				"2008-08-07",
				29.23
			],
			[
				"2013-05-27",
				29.23
			],
			[
				"2014-02-04",
				27.01
			],
			[
				"2015-02-25",
				30.65
			],
			[
				"2016-01-28",
				29.67
			],
			[
				"2009-10-14",
				30.11
			],
			[
				"2010-09-22",
				28.34
			],
			[
				"2011-07-28",
				28.34
			],
			[
				"2012-07-21",
				29.23
			]
		],
		"26501302": [
			[
				"2000-05-16",
				20.01
			],
			[
				"2000-11-21",
				17.01
			],
			[
				"2002-05-07",
				20.01
			],
			[
				"2002-11-06",
				16.01
			],
			[
				"2003-05-19",
				19.01
			],
			[
				"2003-11-17",
				17.01
			],
			[
				"2004-05-11",
				18.01
			],
			[
				"2004-11-16",
				16.01
			],
			[
				"2006-11-15",
				15.01
			],
			[
				"2006-05-31",
				17.01
			],
			[
				"2010-09-23",
				16.01
			],
			[
				"2011-05-23",
				16.01
			],
			[
				"2011-10-26",
				14
			],
			[
				"2012-03-29",
				17.01
			],
			[
				"2012-11-08",
				14
			],
			[
				"2013-04-29",
				17.01
			],
			[
				"2013-11-13",
				15.01
			],
			[
				"2014-05-06",
				15.01
			],
			[
				"2014-11-13",
				14
			],
			[
				"2015-05-20",
				17.01
			],
			[
				"2015-10-21",
				12
			],
			[
				"2007-05-30",
				17.01
			],
			[
				"2007-11-15",
				16.01
			],
			[
				"2008-05-14",
				18.01
			],
			[
				"2008-11-11",
				16.01
			],
			[
				"2009-05-14",
				17.01
			],
			[
				"2009-10-21",
				15.01
			],
			[
				"2010-03-24",
				18.01
			]
		],
		"26501405": [
			[
				"2000-05-16",
				31.01
			],
			[
				"2000-11-21",
				27.01
			],
			[
				"2001-05-28",
				29.01
			],
			[
				"2001-10-18",
				26.01
			],
			[
				"2002-05-07",
				30.01
			],
			[
				"2002-11-06",
				27.01
			],
			[
				"2003-05-19",
				30.01
			],
			[
				"2003-11-17",
				30.01
			],
			[
				"2004-05-11",
				30.01
			],
			[
				"2004-11-16",
				24.01
			],
			[
				"2006-11-15",
				23.01
			],
			[
				"2006-05-31",
				28.01
			],
			[
				"2010-09-23",
				30.01
			],
			[
				"2011-05-23",
				23.01
			],
			[
				"2011-10-26",
				25.01
			],
			[
				"2012-03-29",
				26.01
			],
			[
				"2012-11-08",
				25.01
			],
			[
				"2013-04-29",
				25.01
			],
			[
				"2013-11-13",
				23.01
			],
			[
				"2014-05-06",
				23.01
			],
			[
				"2014-11-13",
				23.01
			],
			[
				"2015-05-20",
				15.01
			],
			[
				"2015-10-21",
				17.01
			],
			[
				"2007-05-30",
				26.01
			],
			[
				"2007-11-15",
				6
			],
			[
				"2008-05-14",
				32.01
			],
			[
				"2008-11-11",
				27.01
			],
			[
				"2009-05-14",
				27.01
			],
			[
				"2009-10-21",
				22.01
			],
			[
				"2010-03-24",
				27.01
			]
		],
		"26501417": [
			[
				"2000-05-16",
				28.01
			],
			[
				"2000-11-21",
				19.01
			],
			[
				"2001-05-28",
				25.01
			],
			[
				"2001-10-18",
				19.01
			],
			[
				"2002-04-04",
				25.01
			],
			[
				"2002-05-07",
				30.01
			],
			[
				"2002-11-06",
				27.01
			],
			[
				"2003-05-19",
				29.01
			],
			[
				"2003-11-17",
				16.01
			],
			[
				"2004-05-11",
				28.01
			],
			[
				"2004-11-16",
				15.01
			],
			[
				"2006-11-15",
				14
			],
			[
				"2006-05-31",
				21.01
			],
			[
				"2010-09-23",
				19.01
			],
			[
				"2011-06-27",
				22.01
			],
			[
				"2011-10-26",
				14
			],
			[
				"2012-03-29",
				19.01
			],
			[
				"2012-11-08",
				16.01
			],
			[
				"2013-04-29",
				24.01
			],
			[
				"2013-11-13",
				19.01
			],
			[
				"2014-05-06",
				19.01
			],
			[
				"2014-11-13",
				16.01
			],
			[
				"2015-05-20",
				25.01
			],
			[
				"2015-10-21",
				15.01
			],
			[
				"2007-05-30",
				23.01
			],
			[
				"2007-11-15",
				17.01
			],
			[
				"2008-05-14",
				27.01
			],
			[
				"2008-11-11",
				16.01
			],
			[
				"2009-05-14",
				20.01
			],
			[
				"2009-10-21",
				15.01
			],
			[
				"2010-03-24",
				21.01
			]
		],
		"26501429": [
			[
				"2000-05-16",
				19.01
			],
			[
				"2000-11-21",
				18.01
			],
			[
				"2001-05-28",
				21.01
			],
			[
				"2001-10-18",
				18.01
			],
			[
				"2002-05-07",
				19.01
			],
			[
				"2002-11-06",
				17.01
			],
			[
				"2003-05-19",
				19.01
			],
			[
				"2003-11-17",
				18.01
			],
			[
				"2004-05-11",
				20.01
			],
			[
				"2004-11-16",
				20.01
			],
			[
				"2006-11-15",
				17.01
			],
			[
				"2006-05-31",
				18.01
			],
			[
				"2010-09-23",
				17.01
			],
			[
				"2011-05-23",
				18.01
			],
			[
				"2011-10-26",
				17.01
			],
			[
				"2012-03-29",
				19.01
			],
			[
				"2012-11-08",
				15.01
			],
			[
				"2013-04-29",
				18.01
			],
			[
				"2013-11-13",
				18.01
			],
			[
				"2014-05-06",
				18.01
			],
			[
				"2014-11-13",
				17.01
			],
			[
				"2015-05-20",
				21.01
			],
			[
				"2015-10-21",
				17.01
			],
			[
				"2007-05-30",
				19.01
			],
			[
				"2007-11-15",
				16.01
			],
			[
				"2008-05-14",
				18.01
			],
			[
				"2008-11-11",
				18.01
			],
			[
				"2009-05-14",
				17.01
			],
			[
				"2009-10-21",
				15.01
			],
			[
				"2010-03-24",
				19.01
			]
		],
		"26501430": [
			[
				"2000-05-16",
				48.02
			],
			[
				"2000-11-21",
				36.01
			],
			[
				"2001-05-28",
				49.02
			],
			[
				"2001-10-18",
				38.01
			],
			[
				"2002-05-07",
				65.02
			],
			[
				"2002-11-06",
				25.01
			],
			[
				"2003-05-19",
				44.02
			],
			[
				"2003-11-17",
				37.01
			],
			[
				"2004-05-11",
				40.01
			],
			[
				"2004-11-16",
				31.01
			],
			[
				"2006-11-15",
				32.01
			],
			[
				"2006-05-31",
				45.02
			],
			[
				"2010-09-23",
				26.01
			],
			[
				"2011-03-03",
				41.01
			],
			[
				"2011-05-23",
				25.01
			],
			[
				"2011-10-26",
				19.01
			],
			[
				"2012-03-29",
				31.01
			],
			[
				"2012-11-08",
				27.01
			],
			[
				"2013-04-29",
				42.01
			],
			[
				"2013-11-13",
				25.01
			],
			[
				"2014-05-06",
				22.01
			],
			[
				"2014-11-13",
				18.01
			],
			[
				"2015-05-20",
				45.02
			],
			[
				"2015-10-21",
				44.02
			],
			[
				"2007-05-30",
				53.02
			],
			[
				"2007-11-15",
				48.02
			],
			[
				"2008-05-14",
				50.02
			],
			[
				"2008-11-11",
				34.01
			],
			[
				"2009-05-14",
				33.01
			],
			[
				"2009-10-21",
				24.01
			],
			[
				"2010-03-24",
				43.02
			]
		],
		"26501454": [
			[
				"2000-05-16",
				19.01
			],
			[
				"2000-11-21",
				20.01
			],
			[
				"2002-05-07",
				18.01
			],
			[
				"2002-11-06",
				14
			],
			[
				"2003-05-19",
				18.01
			],
			[
				"2003-11-17",
				20.01
			],
			[
				"2004-05-11",
				19.01
			],
			[
				"2004-11-16",
				19.01
			],
			[
				"2006-11-15",
				19.01
			],
			[
				"2006-05-31",
				19.01
			],
			[
				"2010-09-23",
				20.01
			],
			[
				"2011-05-23",
				18.01
			],
			[
				"2011-10-26",
				20.01
			],
			[
				"2012-03-29",
				19.01
			],
			[
				"2012-11-08",
				21.01
			],
			[
				"2013-04-29",
				20.01
			],
			[
				"2013-11-13",
				20.01
			],
			[
				"2014-05-06",
				20.01
			],
			[
				"2014-11-13",
				21.01
			],
			[
				"2015-05-20",
				19.01
			],
			[
				"2015-10-21",
				19.01
			],
			[
				"2007-05-30",
				19.01
			],
			[
				"2007-11-15",
				18.01
			],
			[
				"2008-05-14",
				19.01
			],
			[
				"2008-11-11",
				19.01
			],
			[
				"2009-05-14",
				19.01
			],
			[
				"2009-10-21",
				20.01
			],
			[
				"2010-03-24",
				19.01
			]
		],
		"26501480": [
			[
				"2002-05-07",
				1
			],
			[
				"2002-11-06",
				1
			],
			[
				"2003-05-19",
				1
			],
			[
				"2003-11-17",
				1
			],
			[
				"2004-05-11",
				1
			],
			[
				"2004-11-16",
				1
			],
			[
				"2006-11-15",
				1
			],
			[
				"2006-05-31",
				1
			],
			[
				"2010-09-23",
				1
			],
			[
				"2011-05-23",
				1
			],
			[
				"2011-10-26",
				1
			],
			[
				"2012-01-12",
				1
			],
			[
				"2012-03-29",
				1
			],
			[
				"2012-11-08",
				1
			],
			[
				"2013-04-29",
				1
			],
			[
				"2013-11-13",
				5
			],
			[
				"2014-05-12",
				1
			],
			[
				"2014-11-13",
				1
			],
			[
				"2015-05-20",
				1
			],
			[
				"2015-10-21",
				1
			],
			[
				"2007-05-30",
				1
			],
			[
				"2007-11-15",
				1
			],
			[
				"2008-04-07",
				1
			],
			[
				"2008-11-11",
				1
			],
			[
				"2009-05-14",
				1
			],
			[
				"2009-10-21",
				1
			],
			[
				"2010-03-24",
				1
			]
		],
		"26501491": [
			[
				"2000-05-16",
				10
			],
			[
				"2000-11-21",
				10
			],
			[
				"2001-05-28",
				10
			],
			[
				"2001-10-18",
				12
			],
			[
				"2002-05-07",
				10
			],
			[
				"2002-05-16",
				10
			],
			[
				"2002-11-06",
				10
			],
			[
				"2003-05-19",
				11
			],
			[
				"2003-11-17",
				10
			],
			[
				"2004-05-11",
				10
			],
			[
				"2004-11-16",
				10
			],
			[
				"2006-11-15",
				9
			],
			[
				"2006-05-31",
				10
			],
			[
				"2010-09-23",
				9
			],
			[
				"2011-05-23",
				8
			],
			[
				"2011-10-26",
				8
			],
			[
				"2012-03-29",
				9
			],
			[
				"2012-11-08",
				9
			],
			[
				"2013-04-29",
				8
			],
			[
				"2013-11-13",
				9
			],
			[
				"2014-05-06",
				9
			],
			[
				"2014-11-13",
				8
			],
			[
				"2015-05-20",
				8
			],
			[
				"2015-10-21",
				7
			],
			[
				"2007-05-30",
				9
			],
			[
				"2007-11-15",
				29.01
			],
			[
				"2008-05-14",
				10
			],
			[
				"2008-11-11",
				9
			],
			[
				"2009-05-14",
				9
			],
			[
				"2009-10-21",
				8
			],
			[
				"2010-03-24",
				9
			]
		],
		"26501818": [
			[
				"2000-10-11",
				10
			],
			[
				"2000-05-23",
				11
			],
			[
				"2002-06-03",
				11
			],
			[
				"2002-11-05",
				12
			],
			[
				"2003-05-19",
				10
			],
			[
				"2003-11-12",
				12
			],
			[
				"2004-04-28",
				11
			],
			[
				"2004-11-15",
				12
			],
			[
				"2005-04-19",
				11
			],
			[
				"2006-11-16",
				11
			],
			[
				"2006-06-07",
				11
			],
			[
				"2010-09-27",
				11
			],
			[
				"2011-05-31",
				11
			],
			[
				"2011-10-25",
				12
			],
			[
				"2012-05-15",
				11
			],
			[
				"2012-11-07",
				11
			],
			[
				"2013-04-25",
				11
			],
			[
				"2013-11-11",
				13
			],
			[
				"2014-04-29",
				10
			],
			[
				"2014-11-10",
				11
			],
			[
				"2015-03-24",
				9
			],
			[
				"2015-10-07",
				10
			],
			[
				"2007-05-29",
				11
			],
			[
				"2007-11-14",
				10
			],
			[
				"2008-05-15",
				11
			],
			[
				"2008-11-06",
				11
			],
			[
				"2009-05-18",
				11
			],
			[
				"2009-10-21",
				12
			],
			[
				"2010-04-28",
				11
			]
		],
		"26501820": [
			[
				"2000-05-23",
				33.01
			],
			[
				"2002-12-04",
				33.01
			],
			[
				"2003-05-19",
				26.01
			],
			[
				"2003-11-12",
				30.01
			],
			[
				"2004-04-28",
				28.01
			],
			[
				"2004-11-15",
				32.01
			],
			[
				"2005-04-19",
				28.01
			],
			[
				"2006-11-16",
				28.01
			],
			[
				"2006-06-07",
				28.01
			],
			[
				"2010-09-27",
				29.01
			],
			[
				"2011-05-31",
				30.01
			],
			[
				"2011-10-25",
				26.01
			],
			[
				"2012-05-15",
				30.01
			],
			[
				"2012-11-07",
				29.01
			],
			[
				"2013-04-25",
				31.01
			],
			[
				"2013-11-11",
				32.01
			],
			[
				"2014-04-29",
				28.01
			],
			[
				"2014-11-10",
				28.01
			],
			[
				"2015-03-24",
				27.01
			],
			[
				"2015-10-07",
				30.01
			],
			[
				"2007-05-29",
				30.01
			],
			[
				"2007-11-14",
				29.01
			],
			[
				"2008-05-15",
				29.01
			],
			[
				"2008-11-06",
				28.01
			],
			[
				"2009-05-18",
				29.01
			],
			[
				"2009-10-21",
				28.01
			],
			[
				"2010-04-28",
				32.01
			]
		],
		"26502173": [
			[
				"2000-05-16",
				46.02
			],
			[
				"2000-11-13",
				43.02
			],
			[
				"2001-05-10",
				47.02
			],
			[
				"2001-09-24",
				46.02
			],
			[
				"2002-04-16",
				48.02
			],
			[
				"2002-09-26",
				46.02
			],
			[
				"2003-05-13",
				44.02
			],
			[
				"2003-11-12",
				42.01
			],
			[
				"2004-03-16",
				49.02
			],
			[
				"2004-11-09",
				47.02
			],
			[
				"2005-04-20",
				48.02
			],
			[
				"2006-10-04",
				45.02
			],
			[
				"2006-05-03",
				43.02
			],
			[
				"2010-09-30",
				46.02
			],
			[
				"2011-05-19",
				43.02
			],
			[
				"2011-09-27",
				43.02
			],
			[
				"2012-04-25",
				43.02
			],
			[
				"2012-11-22",
				39.01
			],
			[
				"2013-05-23",
				45.02
			],
			[
				"2013-12-03",
				42.01
			],
			[
				"2014-05-28",
				41.01
			],
			[
				"2014-10-30",
				39.01
			],
			[
				"2015-05-28",
				46.02
			],
			[
				"2015-11-03",
				31.01
			],
			[
				"2007-05-23",
				48.02
			],
			[
				"2007-09-25",
				47.02
			],
			[
				"2008-04-23",
				48.02
			],
			[
				"2008-10-02",
				45.02
			],
			[
				"2009-05-05",
				46.02
			],
			[
				"2009-09-23",
				44.02
			],
			[
				"2010-04-13",
				50.02
			]
		],
		"26502185": [
			[
				"2000-05-16",
				37.01
			],
			[
				"2000-11-13",
				35.01
			],
			[
				"2001-07-11",
				47.02
			],
			[
				"2001-09-24",
				47.02
			],
			[
				"2002-04-16",
				37.01
			],
			[
				"2002-09-26",
				30.01
			],
			[
				"2003-05-13",
				41.01
			],
			[
				"2003-11-12",
				31.01
			],
			[
				"2004-03-16",
				42.01
			],
			[
				"2004-11-09",
				49.02
			],
			[
				"2005-04-20",
				39.01
			],
			[
				"2006-10-04",
				25.01
			],
			[
				"2006-05-03",
				37.01
			],
			[
				"2010-09-30",
				42.01
			],
			[
				"2011-05-19",
				36.01
			],
			[
				"2011-09-27",
				37.01
			],
			[
				"2012-04-25",
				33.01
			],
			[
				"2012-11-22",
				34.01
			],
			[
				"2013-05-23",
				37.01
			],
			[
				"2013-12-03",
				35.01
			],
			[
				"2014-05-28",
				31.01
			],
			[
				"2014-10-30",
				31.01
			],
			[
				"2015-05-28",
				23.01
			],
			[
				"2015-11-03",
				26.01
			],
			[
				"2007-05-23",
				32.01
			],
			[
				"2007-09-25",
				27.01
			],
			[
				"2008-04-23",
				34.01
			],
			[
				"2008-10-02",
				45.02
			],
			[
				"2009-05-05",
				31.01
			],
			[
				"2009-09-23",
				38.01
			],
			[
				"2010-04-13",
				39.01
			]
		],
		"26502264": [
			[
				"2001-05-08",
				10
			],
			[
				"2001-09-24",
				9
			],
			[
				"2002-04-16",
				9
			],
			[
				"2002-10-01",
				9
			],
			[
				"2003-05-13",
				9
			],
			[
				"2003-11-11",
				8
			],
			[
				"2004-03-16",
				9
			],
			[
				"2004-11-09",
				8
			],
			[
				"2005-04-25",
				8
			],
			[
				"2006-10-04",
				9
			],
			[
				"2006-05-02",
				9
			],
			[
				"2010-09-28",
				8
			],
			[
				"2011-05-17",
				7
			],
			[
				"2011-09-27",
				7
			],
			[
				"2012-05-03",
				7
			],
			[
				"2012-10-29",
				7
			],
			[
				"2013-04-25",
				8
			],
			[
				"2013-10-24",
				9
			],
			[
				"2014-04-24",
				7
			],
			[
				"2014-10-23",
				8
			],
			[
				"2015-04-14",
				7
			],
			[
				"2015-10-13",
				8
			],
			[
				"2007-05-23",
				9
			],
			[
				"2007-09-26",
				9
			],
			[
				"2008-04-23",
				10
			],
			[
				"2008-09-30",
				8
			],
			[
				"2009-04-23",
				8
			],
			[
				"2009-09-29",
				8
			],
			[
				"2010-04-13",
				11
			]
		],
		"26502392": [
			[
				"2000-10-23",
				1
			],
			[
				"2001-03-26",
				1
			],
			[
				"2002-03-18",
				1
			],
			[
				"2001-10-19",
				1
			],
			[
				"2010-09-21",
				1
			],
			[
				"2012-09-21",
				1
			],
			[
				"2012-03-20",
				1
			],
			[
				"2013-09-18",
				1
			],
			[
				"2013-03-15",
				1
			],
			[
				"2014-09-16",
				1
			],
			[
				"2014-03-17",
				1
			],
			[
				"2015-09-21",
				1
			],
			[
				"2015-03-23",
				1
			],
			[
				"2006-09-18",
				1
			],
			[
				"2006-04-27",
				1
			],
			[
				"2007-09-21",
				1
			],
			[
				"2008-03-10",
				1
			],
			[
				"2008-09-24",
				1
			],
			[
				"2009-03-04",
				1
			],
			[
				"2009-09-14",
				1
			]
		],
		"26502884": [
			[
				"2000-05-22",
				30.01
			],
			[
				"2000-11-15",
				29.01
			],
			[
				"2001-05-07",
				24.01
			],
			[
				"2001-10-15",
				24.01
			],
			[
				"2002-04-15",
				24.01
			],
			[
				"2002-09-24",
				23.01
			],
			[
				"2003-05-12",
				20.01
			],
			[
				"2003-11-03",
				20.01
			],
			[
				"2004-03-15",
				20.01
			],
			[
				"2004-11-08",
				28.01
			],
			[
				"2005-04-26",
				18.01
			],
			[
				"2006-09-27",
				17.01
			],
			[
				"2006-05-18",
				17.01
			],
			[
				"2010-09-28",
				12
			],
			[
				"2011-05-18",
				12
			],
			[
				"2011-09-28",
				12
			],
			[
				"2012-03-28",
				12
			],
			[
				"2012-11-22",
				12
			],
			[
				"2013-06-05",
				11
			],
			[
				"2013-11-21",
				13
			],
			[
				"2014-05-22",
				12
			],
			[
				"2014-11-18",
				11
			],
			[
				"2015-06-09",
				12
			],
			[
				"2015-10-20",
				11
			],
			[
				"2007-05-15",
				16.01
			],
			[
				"2007-09-24",
				17.01
			],
			[
				"2008-04-22",
				15.01
			],
			[
				"2008-09-29",
				15.01
			],
			[
				"2009-04-20",
				12
			],
			[
				"2009-09-24",
				13
			],
			[
				"2010-04-15",
				21.01
			]
		],
		"26502896": [
			[
				"2000-05-22",
				5
			],
			[
				"2000-11-15",
				5
			],
			[
				"2001-05-07",
				5
			],
			[
				"2001-10-15",
				4
			],
			[
				"2002-04-15",
				5
			],
			[
				"2002-09-24",
				4
			],
			[
				"2003-05-12",
				4
			],
			[
				"2003-11-03",
				4
			],
			[
				"2004-03-15",
				6
			],
			[
				"2004-11-08",
				4
			],
			[
				"2005-04-26",
				5
			],
			[
				"2006-09-27",
				4
			],
			[
				"2006-05-18",
				5
			],
			[
				"2010-09-28",
				4
			],
			[
				"2011-05-18",
				3
			],
			[
				"2011-09-28",
				3
			],
			[
				"2012-03-28",
				4
			],
			[
				"2012-11-22",
				3
			],
			[
				"2013-06-05",
				4
			],
			[
				"2013-11-21",
				8
			],
			[
				"2014-05-22",
				4
			],
			[
				"2014-11-18",
				5
			],
			[
				"2015-06-09",
				5
			],
			[
				"2015-10-20",
				4
			],
			[
				"2007-05-15",
				4
			],
			[
				"2008-04-22",
				5
			],
			[
				"2008-09-29",
				4
			],
			[
				"2009-04-20",
				4
			],
			[
				"2009-09-24",
				3
			],
			[
				"2010-04-15",
				5
			]
		],
		"26502902": [
			[
				"2000-11-15",
				12
			],
			[
				"2001-05-07",
				10
			],
			[
				"2001-10-15",
				13
			],
			[
				"2002-04-15",
				13
			],
			[
				"2003-05-12",
				13
			],
			[
				"2003-11-03",
				14
			],
			[
				"2004-03-15",
				12
			],
			[
				"2004-11-08",
				11
			],
			[
				"2005-04-26",
				12
			],
			[
				"2006-09-27",
				14
			],
			[
				"2006-05-18",
				14
			],
			[
				"2010-09-28",
				9
			],
			[
				"2011-05-18",
				12
			],
			[
				"2011-09-28",
				14
			],
			[
				"2012-03-28",
				12
			],
			[
				"2012-11-22",
				13
			],
			[
				"2013-06-05",
				11
			],
			[
				"2013-11-21",
				14
			],
			[
				"2014-05-22",
				11
			],
			[
				"2014-11-18",
				9
			],
			[
				"2015-06-09",
				13
			],
			[
				"2015-10-20",
				12
			],
			[
				"2007-05-15",
				11
			],
			[
				"2007-09-24",
				15.01
			],
			[
				"2008-04-22",
				14
			],
			[
				"2008-09-29",
				15.01
			],
			[
				"2009-04-20",
				13
			],
			[
				"2009-09-24",
				13
			],
			[
				"2010-04-15",
				14
			]
		],
		"26502926": [
			[
				"2000-05-23",
				8
			],
			[
				"2000-11-16",
				8
			],
			[
				"2001-05-08",
				9
			],
			[
				"2001-10-15",
				8
			],
			[
				"2002-04-15",
				8
			],
			[
				"2002-09-24",
				8
			],
			[
				"2003-05-12",
				8
			],
			[
				"2003-11-03",
				8
			],
			[
				"2004-03-15",
				9
			],
			[
				"2004-11-08",
				8
			],
			[
				"2005-04-26",
				9
			],
			[
				"2006-09-27",
				8
			],
			[
				"2006-05-18",
				9
			],
			[
				"2010-09-30",
				8
			],
			[
				"2011-05-18",
				7
			],
			[
				"2011-09-28",
				6
			],
			[
				"2012-03-28",
				7
			],
			[
				"2012-11-22",
				6
			],
			[
				"2013-06-05",
				7
			],
			[
				"2013-11-21",
				10
			],
			[
				"2014-05-22",
				8
			],
			[
				"2014-11-18",
				7
			],
			[
				"2015-06-09",
				7
			],
			[
				"2015-10-20",
				6
			],
			[
				"2007-05-15",
				8
			],
			[
				"2007-09-24",
				10
			],
			[
				"2008-04-22",
				8
			],
			[
				"2008-09-29",
				8
			],
			[
				"2009-04-20",
				8
			],
			[
				"2009-09-24",
				6
			],
			[
				"2010-04-15",
				9
			]
		],
		"26503153": [
			[
				"2001-10-12",
				16.01
			],
			[
				"2002-03-18",
				18
			],
			[
				"2000-03-22",
				15.99
			],
			[
				"2001-03-29",
				13.02
			],
			[
				"2010-09-01",
				11
			],
			[
				"2010-03-03",
				9
			],
			[
				"2012-09-06",
				11
			],
			[
				"2012-03-21",
				11
			],
			[
				"2013-09-23",
				9
			],
			[
				"2013-03-11",
				8
			],
			[
				"2014-09-03",
				10
			],
			[
				"2014-03-24",
				13
			],
			[
				"2015-09-07",
				12
			],
			[
				"2015-03-09",
				9
			],
			[
				"2009-03-24",
				12
			],
			[
				"2009-09-14",
				7
			]
		],
		"26503219": [
			[
				"2000-05-23",
				36.01
			],
			[
				"2002-06-06",
				33.01
			],
			[
				"2003-05-20",
				32.01
			],
			[
				"2003-11-11",
				29.01
			],
			[
				"2004-04-28",
				33.01
			],
			[
				"2004-11-08",
				31.01
			],
			[
				"2005-04-19",
				34.01
			],
			[
				"2006-10-05",
				29.01
			],
			[
				"2006-05-08",
				33.01
			],
			[
				"2010-09-29",
				30.01
			],
			[
				"2011-05-17",
				30.01
			],
			[
				"2011-10-26",
				27.01
			],
			[
				"2012-05-15",
				30.01
			],
			[
				"2012-11-29",
				27.01
			],
			[
				"2013-04-29",
				33.01
			],
			[
				"2013-12-04",
				29.01
			],
			[
				"2014-04-23",
				31.01
			],
			[
				"2014-05-13",
				15.01
			],
			[
				"2014-10-22",
				29.01
			],
			[
				"2015-03-25",
				38.01
			],
			[
				"2015-10-26",
				28.01
			],
			[
				"2007-05-23",
				32.01
			],
			[
				"2007-10-17",
				32.01
			],
			[
				"2008-04-21",
				35.01
			],
			[
				"2008-10-01",
				28.01
			],
			[
				"2009-04-21",
				33.01
			],
			[
				"2009-10-06",
				29.01
			],
			[
				"2010-03-22",
				34.01
			]
		],
		"26504212": [
			[
				"2000-05-16",
				46.02
			],
			[
				"2000-11-13",
				34.01
			],
			[
				"2001-05-10",
				39.01
			],
			[
				"2001-09-24",
				33.01
			],
			[
				"2002-04-16",
				39.01
			],
			[
				"2002-09-26",
				39.01
			],
			[
				"2003-05-13",
				39.01
			],
			[
				"2003-11-12",
				31.01
			],
			[
				"2004-03-16",
				39.01
			],
			[
				"2004-11-09",
				33.01
			],
			[
				"2005-04-20",
				38.01
			],
			[
				"2006-10-04",
				31.01
			],
			[
				"2006-05-03",
				34.01
			],
			[
				"2010-09-30",
				35.01
			],
			[
				"2011-05-19",
				38.01
			],
			[
				"2011-09-27",
				33.01
			],
			[
				"2011-10-13",
				33.01
			],
			[
				"2012-04-25",
				40.01
			],
			[
				"2012-05-21",
				43.02
			],
			[
				"2013-05-16",
				43.02
			],
			[
				"2013-07-15",
				49.02
			],
			[
				"2014-06-02",
				36.01
			],
			[
				"2014-08-07",
				34.01
			],
			[
				"2015-02-09",
				35.01
			],
			[
				"2015-05-28",
				44.02
			],
			[
				"2015-11-03",
				33.01
			],
			[
				"2007-05-23",
				38.01
			],
			[
				"2007-09-25",
				36.01
			],
			[
				"2008-04-23",
				36.01
			],
			[
				"2008-10-14",
				34.01
			],
			[
				"2009-05-05",
				36.01
			],
			[
				"2009-09-23",
				31.01
			],
			[
				"2010-04-13",
				39.01
			]
		],
		"26504261": [
			[
				"2000-05-16",
				42.01
			],
			[
				"2001-07-11",
				46.02
			],
			[
				"2003-11-12",
				41.01
			],
			[
				"2004-03-16",
				47.02
			],
			[
				"2004-11-09",
				44.02
			],
			[
				"2005-04-20",
				41.01
			],
			[
				"2006-10-04",
				41.01
			],
			[
				"2006-05-03",
				41.01
			],
			[
				"2010-09-30",
				44.02
			],
			[
				"2011-05-19",
				38.01
			],
			[
				"2011-09-27",
				41.01
			],
			[
				"2012-04-25",
				41.01
			],
			[
				"2012-11-22",
				37.01
			],
			[
				"2013-05-23",
				42.01
			],
			[
				"2013-06-04",
				43.02
			],
			[
				"2013-12-03",
				40.01
			],
			[
				"2014-05-28",
				40.01
			],
			[
				"2014-10-30",
				38.01
			],
			[
				"2015-05-28",
				39.01
			],
			[
				"2015-11-03",
				40.01
			],
			[
				"2007-05-23",
				40.01
			],
			[
				"2007-09-25",
				39.01
			],
			[
				"2008-06-04",
				38.01
			],
			[
				"2008-10-02",
				42.01
			],
			[
				"2009-05-05",
				43.02
			],
			[
				"2009-09-23",
				41.01
			],
			[
				"2010-05-04",
				47.02
			]
		],
		"26504327": [
			[
				"2000-03-29",
				52.02
			],
			[
				"2000-09-28",
				51.02
			],
			[
				"2001-05-09",
				51.02
			],
			[
				"2003-03-18",
				53.02
			],
			[
				"2003-11-11",
				51.02
			],
			[
				"2004-03-17",
				49.02
			],
			[
				"2004-11-18",
				48.02
			],
			[
				"2005-04-19",
				48.02
			],
			[
				"2006-09-26",
				44.02
			],
			[
				"2006-05-08",
				34.01
			],
			[
				"2010-09-29",
				33.01
			],
			[
				"2011-05-16",
				33.01
			],
			[
				"2011-10-06",
				31.01
			],
			[
				"2012-04-26",
				39.01
			],
			[
				"2012-10-11",
				36.01
			],
			[
				"2013-04-24",
				38.01
			],
			[
				"2013-10-08",
				37.01
			],
			[
				"2014-04-22",
				32.01
			],
			[
				"2014-07-08",
				35.01
			],
			[
				"2014-08-13",
				36.01
			],
			[
				"2014-09-23",
				36.01
			],
			[
				"2014-10-13",
				37.01
			],
			[
				"2014-10-29",
				29.01
			],
			[
				"2014-11-04",
				35.01
			],
			[
				"2014-12-03",
				36.01
			],
			[
				"2015-01-08",
				37.01
			],
			[
				"2015-02-09",
				38.01
			],
			[
				"2015-03-03",
				34.01
			],
			[
				"2015-04-07",
				37.01
			],
			[
				"2015-05-11",
				39.01
			],
			[
				"2015-06-08",
				39.01
			],
			[
				"2015-07-13",
				38.01
			],
			[
				"2015-08-04",
				38.01
			],
			[
				"2015-09-22",
				37.01
			],
			[
				"2015-10-26",
				36.01
			],
			[
				"2015-11-05",
				37.01
			],
			[
				"2015-12-02",
				37.01
			],
			[
				"2007-05-14",
				37.01
			],
			[
				"2007-10-17",
				34.01
			],
			[
				"2008-04-21",
				34.01
			],
			[
				"2008-10-01",
				35.01
			],
			[
				"2009-04-21",
				40.01
			],
			[
				"2009-09-22",
				33.01
			],
			[
				"2010-03-23",
				38.01
			]
		],
		"26504339": [
			[
				"2000-03-29",
				25.01
			],
			[
				"2000-09-28",
				26.01
			],
			[
				"2001-05-09",
				25.01
			],
			[
				"2001-09-25",
				27.01
			],
			[
				"2002-04-17",
				24.01
			],
			[
				"2003-03-18",
				23.01
			],
			[
				"2003-11-11",
				25.01
			],
			[
				"2004-03-17",
				26.01
			],
			[
				"2004-11-18",
				25.01
			],
			[
				"2005-04-19",
				25.01
			],
			[
				"2006-09-26",
				24.01
			],
			[
				"2006-05-08",
				24.01
			],
			[
				"2010-09-29",
				25.01
			],
			[
				"2011-05-16",
				24.01
			],
			[
				"2011-10-06",
				25.01
			],
			[
				"2012-04-26",
				26.01
			],
			[
				"2012-10-11",
				25.01
			],
			[
				"2013-04-24",
				25.01
			],
			[
				"2013-10-08",
				25.01
			],
			[
				"2014-04-22",
				25.01
			],
			[
				"2014-10-29",
				24.01
			],
			[
				"2015-05-11",
				25.01
			],
			[
				"2015-10-26",
				25.01
			],
			[
				"2007-05-14",
				25.01
			],
			[
				"2007-10-17",
				24.01
			],
			[
				"2008-04-21",
				24.01
			],
			[
				"2008-10-01",
				25.01
			],
			[
				"2009-04-21",
				25.01
			],
			[
				"2009-09-22",
				25.01
			],
			[
				"2010-03-23",
				28.01
			]
		],
		"26504352": [
			[
				"2000-03-29",
				18.01
			],
			[
				"2000-09-28",
				17.01
			],
			[
				"2001-05-09",
				17.01
			],
			[
				"2001-09-25",
				16.01
			],
			[
				"2002-04-17",
				18.01
			],
			[
				"2002-09-30",
				18.01
			],
			[
				"2003-03-18",
				17.01
			],
			[
				"2003-11-11",
				15.01
			],
			[
				"2004-03-17",
				18.01
			],
			[
				"2004-11-18",
				11
			],
			[
				"2005-04-19",
				18.01
			],
			[
				"2006-09-26",
				15.01
			],
			[
				"2006-05-08",
				18.01
			],
			[
				"2010-09-29",
				15.01
			],
			[
				"2011-05-16",
				18.01
			],
			[
				"2011-10-06",
				18.01
			],
			[
				"2012-04-26",
				18.01
			],
			[
				"2012-10-11",
				13
			],
			[
				"2013-04-24",
				17.01
			],
			[
				"2013-10-08",
				17.01
			],
			[
				"2014-04-22",
				15.01
			],
			[
				"2014-10-29",
				12
			],
			[
				"2015-05-11",
				19.01
			],
			[
				"2015-10-26",
				14
			],
			[
				"2007-05-14",
				19.01
			],
			[
				"2007-10-17",
				17.01
			],
			[
				"2008-04-21",
				17.01
			],
			[
				"2008-10-01",
				19.01
			],
			[
				"2009-04-21",
				18.01
			],
			[
				"2009-09-22",
				13
			],
			[
				"2010-03-23",
				18.01
			]
		],
		"26504388": [
			[
				"2000-03-29",
				18.01
			],
			[
				"2000-09-28",
				16.01
			],
			[
				"2001-05-09",
				18.01
			],
			[
				"2001-09-25",
				17.01
			],
			[
				"2002-04-17",
				20.01
			],
			[
				"2002-09-30",
				18.01
			],
			[
				"2003-03-18",
				18.01
			],
			[
				"2003-11-11",
				15.01
			],
			[
				"2004-03-17",
				16.01
			],
			[
				"2004-11-18",
				18.01
			],
			[
				"2005-04-19",
				20.01
			],
			[
				"2006-09-26",
				17.01
			],
			[
				"2006-05-08",
				17.01
			],
			[
				"2010-09-29",
				16.01
			],
			[
				"2011-11-18",
				21.01
			],
			[
				"2012-04-26",
				19.01
			],
			[
				"2012-10-11",
				17.01
			],
			[
				"2013-04-24",
				17.01
			],
			[
				"2013-10-08",
				19.01
			],
			[
				"2014-04-22",
				17.01
			],
			[
				"2014-10-29",
				16.01
			],
			[
				"2015-05-11",
				19.01
			],
			[
				"2015-10-26",
				16.01
			],
			[
				"2007-05-14",
				19.01
			],
			[
				"2007-10-17",
				19.01
			],
			[
				"2008-04-21",
				21.01
			],
			[
				"2008-10-01",
				19.01
			],
			[
				"2009-04-21",
				16.01
			],
			[
				"2009-09-22",
				17.01
			],
			[
				"2010-03-23",
				17.01
			]
		],
		"26504613": [
			[
				"2000-05-16",
				61.02
			],
			[
				"2000-11-14",
				60.02
			],
			[
				"2001-05-08",
				59.02
			],
			[
				"2001-09-24",
				60.02
			],
			[
				"2002-04-16",
				58.02
			],
			[
				"2002-10-01",
				57.02
			],
			[
				"2003-05-13",
				56.02
			],
			[
				"2003-11-11",
				57.02
			],
			[
				"2004-03-16",
				59.02
			],
			[
				"2004-11-09",
				61.02
			],
			[
				"2005-04-25",
				55.02
			],
			[
				"2006-10-04",
				54.02
			],
			[
				"2006-05-02",
				57.02
			],
			[
				"2010-09-28",
				52.02
			],
			[
				"2011-05-17",
				52.02
			],
			[
				"2011-09-27",
				51.02
			],
			[
				"2012-05-03",
				50.02
			],
			[
				"2012-10-29",
				49.02
			],
			[
				"2013-04-25",
				52.02
			],
			[
				"2013-10-24",
				49.02
			],
			[
				"2014-04-24",
				48.02
			],
			[
				"2014-10-23",
				30.01
			],
			[
				"2015-04-14",
				50.02
			],
			[
				"2015-10-13",
				52.02
			],
			[
				"2007-05-23",
				56.02
			],
			[
				"2007-09-26",
				55.02
			],
			[
				"2008-04-23",
				56.02
			],
			[
				"2008-09-30",
				53.02
			],
			[
				"2009-04-23",
				50.02
			],
			[
				"2009-09-29",
				52.02
			],
			[
				"2010-04-13",
				56.02
			]
		],
		"26504625": [
			[
				"2000-05-16",
				39.01
			],
			[
				"2000-11-14",
				42.01
			],
			[
				"2001-05-08",
				39.01
			],
			[
				"2001-09-24",
				39.01
			],
			[
				"2002-04-16",
				37.01
			],
			[
				"2002-10-01",
				43.02
			],
			[
				"2003-05-13",
				39.01
			],
			[
				"2003-11-11",
				41.01
			],
			[
				"2004-03-16",
				39.01
			],
			[
				"2004-11-09",
				44.02
			],
			[
				"2005-04-25",
				40.01
			],
			[
				"2006-10-04",
				38.01
			],
			[
				"2006-05-02",
				41.01
			],
			[
				"2010-09-28",
				41.01
			],
			[
				"2011-05-17",
				37.01
			],
			[
				"2011-09-27",
				38.01
			],
			[
				"2012-05-03",
				36.01
			],
			[
				"2012-10-29",
				37.01
			],
			[
				"2013-04-25",
				38.01
			],
			[
				"2013-10-24",
				35.01
			],
			[
				"2014-04-24",
				36.01
			],
			[
				"2014-10-23",
				36.01
			],
			[
				"2015-04-14",
				35.01
			],
			[
				"2015-10-13",
				37.01
			],
			[
				"2007-05-23",
				40.01
			],
			[
				"2007-09-26",
				40.01
			],
			[
				"2008-04-23",
				39.01
			],
			[
				"2008-09-30",
				39.01
			],
			[
				"2009-04-23",
				38.01
			],
			[
				"2009-09-29",
				39.01
			],
			[
				"2010-04-13",
				40.01
			]
		],
		"26504820": [
			[
				"2000-05-23",
				18.01
			],
			[
				"2000-11-22",
				17.01
			],
			[
				"2001-05-29",
				15.01
			],
			[
				"2001-10-16",
				22.01
			],
			[
				"2002-06-03",
				23.01
			],
			[
				"2002-11-05",
				22.01
			],
			[
				"2003-05-19",
				22.01
			],
			[
				"2003-11-12",
				20.01
			],
			[
				"2004-04-28",
				21.01
			],
			[
				"2004-11-15",
				3
			],
			[
				"2005-04-19",
				26.01
			],
			[
				"2006-11-16",
				22.01
			],
			[
				"2006-06-07",
				6
			],
			[
				"2010-09-16",
				3
			],
			[
				"2010-09-27",
				2
			],
			[
				"2011-05-31",
				29.01
			],
			[
				"2011-10-25",
				13
			],
			[
				"2012-05-15",
				16.01
			],
			[
				"2012-11-07",
				27.01
			],
			[
				"2013-04-25",
				21.01
			],
			[
				"2013-11-11",
				30.01
			],
			[
				"2014-04-29",
				13
			],
			[
				"2014-11-10",
				30.01
			],
			[
				"2015-03-24",
				27.01
			],
			[
				"2015-10-07",
				20.01
			],
			[
				"2007-05-29",
				25.01
			],
			[
				"2007-11-14",
				18.01
			],
			[
				"2008-05-15",
				24.01
			],
			[
				"2008-11-06",
				27.01
			],
			[
				"2009-05-18",
				25.01
			],
			[
				"2009-10-21",
				14
			],
			[
				"2010-04-28",
				21.01
			]
		],
		"26504868": [
			[
				"2000-05-23",
				12
			],
			[
				"2000-11-22",
				19.01
			],
			[
				"2001-05-29",
				18.01
			],
			[
				"2001-10-16",
				22.01
			],
			[
				"2002-06-03",
				11
			],
			[
				"2002-11-05",
				13
			],
			[
				"2003-05-19",
				15.01
			],
			[
				"2003-11-12",
				17.01
			],
			[
				"2004-04-28",
				19.01
			],
			[
				"2004-11-15",
				20.01
			],
			[
				"2005-04-19",
				13
			],
			[
				"2006-11-16",
				16.01
			],
			[
				"2006-06-07",
				19.01
			],
			[
				"2010-09-27",
				17.01
			],
			[
				"2011-05-31",
				23.01
			],
			[
				"2011-10-25",
				22.01
			],
			[
				"2012-05-15",
				16.01
			],
			[
				"2012-11-07",
				21.01
			],
			[
				"2013-04-25",
				14
			],
			[
				"2013-11-11",
				20.01
			],
			[
				"2014-04-29",
				20.01
			],
			[
				"2014-11-10",
				20.01
			],
			[
				"2015-03-24",
				17.01
			],
			[
				"2015-10-07",
				19.01
			],
			[
				"2007-05-29",
				17.01
			],
			[
				"2007-11-14",
				16.01
			],
			[
				"2008-05-15",
				9
			],
			[
				"2008-11-06",
				17.01
			],
			[
				"2009-05-18",
				16.01
			],
			[
				"2009-10-21",
				22.01
			],
			[
				"2010-04-28",
				25.01
			]
		],
		"26504870": [
			[
				"2000-05-23",
				26.01
			],
			[
				"2000-11-22",
				17.01
			],
			[
				"2001-05-29",
				25.01
			],
			[
				"2001-10-16",
				22.01
			],
			[
				"2002-06-03",
				27.01
			],
			[
				"2002-11-05",
				23.01
			],
			[
				"2003-05-19",
				19.01
			],
			[
				"2003-11-12",
				17.01
			],
			[
				"2004-04-28",
				21.01
			],
			[
				"2004-11-15",
				16.01
			],
			[
				"2005-04-19",
				26.01
			],
			[
				"2006-11-16",
				19.01
			],
			[
				"2006-06-07",
				23.01
			],
			[
				"2010-09-27",
				22.01
			],
			[
				"2011-05-31",
				24.01
			],
			[
				"2011-10-25",
				22.01
			],
			[
				"2012-05-15",
				26.01
			],
			[
				"2012-11-07",
				23.01
			],
			[
				"2013-04-25",
				30.01
			],
			[
				"2013-11-11",
				28.01
			],
			[
				"2014-04-29",
				24.01
			],
			[
				"2014-11-10",
				23.01
			],
			[
				"2015-03-24",
				29.01
			],
			[
				"2015-10-07",
				22.01
			],
			[
				"2007-05-29",
				20.01
			],
			[
				"2007-11-14",
				24.01
			],
			[
				"2008-05-15",
				31.01
			],
			[
				"2008-11-06",
				19.01
			],
			[
				"2009-05-18",
				24.01
			],
			[
				"2009-10-21",
				19.01
			],
			[
				"2010-04-28",
				32.01
			]
		],
		"26525033": [
			[
				"2000-11-08",
				2.21
			],
			[
				"2002-07-17",
				2.21
			],
			[
				"2003-04-02",
				2.21
			],
			[
				"2004-03-12",
				2.21
			],
			[
				"2005-07-08",
				2.21
			],
			[
				"2006-04-12",
				2.21
			],
			[
				"2006-11-07",
				2.21
			],
			[
				"2007-06-22",
				2.21
			],
			[
				"2008-04-04",
				2.21
			],
			[
				"2013-06-27",
				2.21
			],
			[
				"2014-05-15",
				2.21
			],
			[
				"2015-07-14",
				1.33
			],
			[
				"2009-06-29",
				2.21
			],
			[
				"2010-06-09",
				2.21
			],
			[
				"2011-04-05",
				2.21
			],
			[
				"2012-06-21",
				2.21
			]
		],
		"26525045": [
			[
				"2000-07-11",
				2.21
			],
			[
				"2001-02-15",
				2.21
			],
			[
				"2001-10-25",
				19
			],
			[
				"2002-05-22",
				2.21
			],
			[
				"2002-08-21",
				5
			],
			[
				"2002-09-18",
				3.99
			],
			[
				"2003-03-21",
				17.14
			],
			[
				"2003-10-13",
				3.9
			],
			[
				"2004-02-27",
				2.21
			],
			[
				"2004-06-01",
				2.21
			],
			[
				"2006-05-24",
				2.21
			],
			[
				"2013-10-29",
				2.21
			],
			[
				"2015-10-28",
				2.88
			]
		],
		"26525057": [
			[
				"2000-07-11",
				2.21
			],
			[
				"2001-02-15",
				2.21
			],
			[
				"2002-05-22",
				2.21
			],
			[
				"2002-08-21",
				2.21
			],
			[
				"2003-03-21",
				2.21
			],
			[
				"2004-02-27",
				2.21
			],
			[
				"2005-07-21",
				2.21
			],
			[
				"2007-05-30",
				2.21
			],
			[
				"2008-08-25",
				2.3
			],
			[
				"2013-10-29",
				2.21
			],
			[
				"2014-07-23",
				1.33
			],
			[
				"2015-10-28",
				3.9
			],
			[
				"2009-07-09",
				2.3
			],
			[
				"2010-06-17",
				2.21
			],
			[
				"2006-05-24",
				2.21
			],
			[
				"2008-04-29",
				2.21
			],
			[
				"2011-07-05",
				2.21
			],
			[
				"2012-08-14",
				2.21
			]
		],
		"26525094": [
			[
				"2002-11-29",
				32.95
			],
			[
				"2003-04-17",
				31.44
			],
			[
				"2004-03-18",
				25.11
			],
			[
				"2005-07-15",
				17.27
			],
			[
				"2007-06-04",
				20.37
			],
			[
				"2013-07-18",
				16.39
			],
			[
				"2014-07-22",
				16.25
			],
			[
				"2015-09-09",
				18.29
			],
			[
				"2009-08-26",
				18.6
			],
			[
				"2006-06-12",
				26.13
			],
			[
				"2008-04-28",
				25.24
			],
			[
				"2010-07-22",
				23.03
			],
			[
				"2011-05-20",
				30.56
			],
			[
				"2012-08-02",
				27.01
			]
		],
		"26525112": [
			[
				"2010-08-05",
				4.4
			],
			[
				"2011-08-15",
				5.1
			],
			[
				"2012-08-15",
				3.6
			],
			[
				"2013-08-15",
				3.8
			],
			[
				"2014-08-20",
				6.2
			],
			[
				"2015-08-20",
				7.7
			],
			[
				"2006-08-10",
				4.1
			],
			[
				"2007-08-01",
				3.5
			],
			[
				"2008-08-04",
				5.7
			]
		],
		"26531021": [
			[
				"2001-11-14",
				26.88
			],
			[
				"2002-10-22",
				12.89
			],
			[
				"2003-03-12",
				9.3
			],
			[
				"2004-06-28",
				2.7
			],
			[
				"2005-07-06",
				21.26
			],
			[
				"2006-09-25",
				16.39
			],
			[
				"2007-06-25",
				13.73
			],
			[
				"2013-07-02",
				10.63
			],
			[
				"2014-06-24",
				21.48
			],
			[
				"2015-08-11",
				12.53
			],
			[
				"2011-04-18",
				8.41
			],
			[
				"2012-06-14",
				5.76
			]
		],
		"26531033": [
			[
				"2001-11-14",
				17.27
			],
			[
				"2002-10-22",
				8.64
			],
			[
				"2003-03-12",
				13.02
			],
			[
				"2004-06-28",
				7.71
			],
			[
				"2005-07-06",
				9.3
			],
			[
				"2006-09-25",
				8.86
			],
			[
				"2007-06-25",
				4.87
			],
			[
				"2013-07-02",
				7.09
			],
			[
				"2014-06-20",
				5.05
			],
			[
				"2015-08-11",
				7
			],
			[
				"2011-04-18",
				6.64
			],
			[
				"2012-06-14",
				5.76
			]
		],
		"26531045": [
			[
				"2001-11-14",
				9.88
			],
			[
				"2002-10-22",
				27.9
			],
			[
				"2003-03-12",
				19.04
			],
			[
				"2004-06-28",
				12.62
			],
			[
				"2005-07-06",
				9.3
			],
			[
				"2006-09-25",
				9.3
			],
			[
				"2007-06-25",
				14.17
			],
			[
				"2013-07-02",
				30.11
			],
			[
				"2014-06-20",
				21.43
			],
			[
				"2015-08-11",
				21.79
			],
			[
				"2011-04-18",
				19.04
			],
			[
				"2012-06-14",
				18.16
			]
		],
		"26531057": [
			[
				"2001-11-15",
				2.21
			],
			[
				"2002-10-09",
				2.21
			],
			[
				"2003-04-08",
				2.21
			],
			[
				"2004-06-29",
				2.21
			],
			[
				"2005-07-12",
				2.21
			],
			[
				"2006-10-02",
				2.21
			],
			[
				"2007-06-27",
				2.21
			],
			[
				"2008-12-08",
				2.21
			],
			[
				"2013-09-19",
				2.21
			],
			[
				"2014-07-03",
				1.51
			],
			[
				"2015-08-04",
				2.04
			],
			[
				"2009-10-19",
				2.21
			],
			[
				"2010-10-26",
				2.21
			],
			[
				"2011-05-25",
				4.87
			],
			[
				"2012-10-10",
				2.88
			]
		],
		"26531069": [
			[
				"2001-11-15",
				2.21
			],
			[
				"2002-10-09",
				2.21
			],
			[
				"2003-04-08",
				2.21
			],
			[
				"2004-06-29",
				2.21
			],
			[
				"2005-07-12",
				2.21
			],
			[
				"2006-10-02",
				2.21
			],
			[
				"2007-06-27",
				2.21
			],
			[
				"2008-12-08",
				2.21
			],
			[
				"2013-09-19",
				2.21
			],
			[
				"2014-07-03",
				1.33
			],
			[
				"2015-08-04",
				1.33
			],
			[
				"2009-10-19",
				2.21
			],
			[
				"2010-10-26",
				2.21
			],
			[
				"2011-05-25",
				2.21
			],
			[
				"2012-10-10",
				2.21
			]
		],
		"26531070": [
			[
				"2001-11-15",
				2.21
			],
			[
				"2002-10-09",
				2.21
			],
			[
				"2003-04-08",
				2.21
			],
			[
				"2004-06-29",
				2.21
			],
			[
				"2005-07-12",
				2.21
			],
			[
				"2006-10-02",
				2.21
			],
			[
				"2007-06-27",
				2.21
			],
			[
				"2008-12-08",
				2.21
			],
			[
				"2013-09-19",
				2.21
			],
			[
				"2014-07-03",
				1.33
			],
			[
				"2015-08-04",
				2.21
			],
			[
				"2009-10-19",
				2.21
			],
			[
				"2010-10-26",
				2.21
			],
			[
				"2011-05-25",
				2.21
			],
			[
				"2012-10-10",
				2.21
			]
		],
		"26531082": [
			[
				"2001-11-15",
				2.21
			],
			[
				"2002-10-09",
				2.21
			],
			[
				"2003-04-08",
				2.21
			],
			[
				"2004-06-29",
				2.21
			],
			[
				"2005-07-12",
				2.21
			],
			[
				"2006-10-02",
				2.21
			],
			[
				"2007-06-27",
				2.21
			],
			[
				"2008-12-08",
				2.21
			],
			[
				"2013-09-19",
				2.21
			],
			[
				"2014-07-03",
				2.79
			],
			[
				"2015-08-04",
				1.33
			],
			[
				"2009-10-19",
				2.21
			],
			[
				"2010-10-26",
				2.21
			],
			[
				"2011-05-25",
				2.21
			],
			[
				"2012-10-10",
				2.21
			]
		],
		"26531094": [
			[
				"2001-11-13",
				15.32
			],
			[
				"2002-10-08",
				28.74
			],
			[
				"2003-10-01",
				48.71
			],
			[
				"2004-07-05",
				16.52
			],
			[
				"2005-07-18",
				42.96
			],
			[
				"2006-09-27",
				70.86
			],
			[
				"2007-06-26",
				27.9
			],
			[
				"2008-12-03",
				75.29
			],
			[
				"2013-09-17",
				163.86
			],
			[
				"2014-07-15",
				66.87
			],
			[
				"2015-08-04",
				130.2
			],
			[
				"2009-10-20",
				84.14
			],
			[
				"2011-04-20",
				57.57
			],
			[
				"2012-07-31",
				84.14
			]
		],
		"26531100": [
			[
				"2001-11-13",
				89.46
			],
			[
				"2002-10-08",
				75.29
			],
			[
				"2003-10-01",
				110.27
			],
			[
				"2004-07-05",
				79.27
			],
			[
				"2005-07-18",
				141.71
			],
			[
				"2006-09-27",
				163.86
			],
			[
				"2007-06-26",
				163.86
			],
			[
				"2013-09-17",
				225.86
			],
			[
				"2014-07-15",
				193.53
			],
			[
				"2015-08-04",
				182.9
			],
			[
				"2011-04-20",
				168.29
			],
			[
				"2012-07-31",
				155
			]
		],
		"26531112": [
			[
				"2001-11-13",
				189.54
			],
			[
				"2002-10-08",
				105.4
			],
			[
				"2003-10-01",
				152.34
			],
			[
				"2004-07-05",
				155
			],
			[
				"2005-07-18",
				150.57
			],
			[
				"2006-09-27",
				217
			],
			[
				"2007-06-26",
				256.86
			],
			[
				"2013-09-17",
				190.43
			],
			[
				"2014-07-15",
				174.93
			],
			[
				"2015-08-04",
				135.07
			],
			[
				"2009-10-20",
				172.71
			],
			[
				"2008-12-03",
				243.57
			],
			[
				"2011-04-20",
				221.43
			],
			[
				"2012-07-31",
				208.14
			]
		],
		"26531124": [
			[
				"2001-11-13",
				175.37
			],
			[
				"2002-10-08",
				133.74
			],
			[
				"2003-10-01",
				152.79
			],
			[
				"2005-07-18",
				70.86
			],
			[
				"2006-09-27",
				88.57
			],
			[
				"2007-06-26",
				186
			],
			[
				"2013-09-17",
				48.71
			],
			[
				"2014-07-15",
				27.68
			],
			[
				"2015-08-04",
				14.61
			],
			[
				"2011-04-20",
				137.29
			],
			[
				"2012-07-31",
				43.4
			]
		],
		"26540174": [
			[
				"2001-11-28",
				174.93
			],
			[
				"2002-11-13",
				202.39
			],
			[
				"2003-11-05",
				238.26
			],
			[
				"2004-09-22",
				158.1
			],
			[
				"2005-07-05",
				181.57
			],
			[
				"2006-09-20",
				97.43
			],
			[
				"2007-07-11",
				88.57
			],
			[
				"2008-12-08",
				32.33
			],
			[
				"2013-10-08",
				75.29
			],
			[
				"2014-06-24",
				189.1
			],
			[
				"2015-09-29",
				116.03
			],
			[
				"2009-08-11",
				13.29
			],
			[
				"2010-08-10",
				39.41
			],
			[
				"2011-04-14",
				84.14
			],
			[
				"2012-08-28",
				75.29
			]
		],
		"26540186": [
			[
				"2001-11-28",
				2.21
			],
			[
				"2002-11-13",
				4.25
			],
			[
				"2003-11-05",
				2.21
			],
			[
				"2004-09-22",
				2.21
			],
			[
				"2005-07-05",
				2.21
			],
			[
				"2006-09-20",
				3.41
			],
			[
				"2007-07-11",
				2.21
			],
			[
				"2008-12-08",
				2.21
			],
			[
				"2013-10-08",
				2.21
			],
			[
				"2014-06-24",
				1.33
			],
			[
				"2015-09-29",
				2.39
			],
			[
				"2009-08-11",
				2.21
			],
			[
				"2010-08-10",
				2.21
			],
			[
				"2011-04-14",
				2.21
			],
			[
				"2012-08-28",
				2.21
			]
		],
		"26540198": [
			[
				"2001-11-28",
				53.59
			],
			[
				"2002-11-13",
				58.9
			],
			[
				"2003-11-05",
				52.26
			],
			[
				"2004-09-22",
				47.92
			],
			[
				"2005-07-05",
				53.14
			],
			[
				"2006-09-20",
				57.57
			],
			[
				"2007-07-11",
				53.14
			],
			[
				"2008-12-08",
				48.71
			],
			[
				"2013-10-08",
				44.29
			],
			[
				"2014-06-24",
				29.1
			],
			[
				"2015-09-29",
				34.81
			],
			[
				"2009-08-11",
				44.29
			],
			[
				"2010-08-10",
				44.29
			],
			[
				"2011-04-14",
				53.14
			],
			[
				"2012-08-28",
				48.71
			]
		],
		"26540204": [
			[
				"2001-11-28",
				55.8
			],
			[
				"2002-11-13",
				58.9
			],
			[
				"2003-11-05",
				61.56
			],
			[
				"2004-09-22",
				57.17
			],
			[
				"2005-07-05",
				62
			],
			[
				"2006-09-20",
				57.57
			],
			[
				"2007-07-11",
				53.14
			],
			[
				"2008-12-08",
				57.57
			],
			[
				"2013-10-08",
				48.71
			],
			[
				"2014-06-24",
				47.83
			],
			[
				"2015-09-29",
				53.14
			],
			[
				"2009-08-11",
				57.57
			],
			[
				"2010-08-10",
				53.14
			],
			[
				"2011-04-14",
				53.14
			],
			[
				"2012-08-28",
				53.14
			]
		],
		"26540216": [
			[
				"2002-10-23",
				2.21
			],
			[
				"2003-10-29",
				2.21
			],
			[
				"2004-07-07",
				2.21
			],
			[
				"2005-07-20",
				2.21
			],
			[
				"2006-08-09",
				2.21
			],
			[
				"2007-06-18",
				2.21
			],
			[
				"2008-12-02",
				2.21
			],
			[
				"2013-07-30",
				2.21
			],
			[
				"2014-05-22",
				2.21
			],
			[
				"2015-07-21",
				1.33
			],
			[
				"2009-09-18",
				2.21
			],
			[
				"2011-04-26",
				2.21
			]
		],
		"26540228": [
			[
				"2002-10-23",
				120.01
			],
			[
				"2003-10-29",
				35.78
			],
			[
				"2004-07-07",
				5.49
			],
			[
				"2005-07-20",
				2.7
			],
			[
				"2006-08-09",
				10.19
			],
			[
				"2007-06-18",
				16.39
			],
			[
				"2008-12-02",
				16.83
			],
			[
				"2013-07-30",
				17.71
			],
			[
				"2014-05-22",
				10.63
			],
			[
				"2015-07-21",
				4.61
			],
			[
				"2010-06-24",
				2.21
			],
			[
				"2011-04-26",
				21.7
			],
			[
				"2012-07-25",
				9.3
			]
		],
		"26540230": [
			[
				"2002-10-23",
				6.55
			],
			[
				"2003-10-29",
				16.43
			],
			[
				"2004-07-07",
				11.16
			],
			[
				"2005-07-20",
				2.21
			],
			[
				"2006-08-09",
				2.21
			],
			[
				"2007-06-18",
				2.21
			],
			[
				"2008-12-02",
				11.96
			],
			[
				"2013-07-30",
				2.21
			],
			[
				"2014-05-22",
				2.21
			],
			[
				"2015-07-21",
				1.33
			],
			[
				"2009-09-18",
				2.21
			],
			[
				"2010-06-24",
				2.21
			],
			[
				"2010-09-06",
				2.21
			],
			[
				"2011-04-26",
				24.36
			]
		],
		"26540241": [
			[
				"2002-10-23",
				2.21
			],
			[
				"2003-10-29",
				2.21
			],
			[
				"2004-07-07",
				2.21
			],
			[
				"2005-07-20",
				2.21
			],
			[
				"2006-08-09",
				2.21
			],
			[
				"2007-06-18",
				2.21
			],
			[
				"2008-12-02",
				2.21
			],
			[
				"2013-07-30",
				2.21
			],
			[
				"2014-05-22",
				2.21
			],
			[
				"2015-07-21",
				1.33
			],
			[
				"2009-09-18",
				2.21
			],
			[
				"2010-06-24",
				2.21
			],
			[
				"2011-04-26",
				2.21
			],
			[
				"2012-07-25",
				2.21
			]
		],
		"26540502": [
			[
				"2002-11-06",
				46.06
			],
			[
				"2004-07-06",
				160.31
			],
			[
				"2005-07-19",
				101.86
			],
			[
				"2007-06-20",
				110.71
			],
			[
				"2008-12-04",
				44.29
			],
			[
				"2015-08-06",
				19
			],
			[
				"2011-05-11",
				84.14
			]
		],
		"26540514": [
			[
				"2001-11-06",
				159.87
			],
			[
				"2002-11-06",
				147.47
			],
			[
				"2004-07-06",
				148.8
			],
			[
				"2005-07-19",
				110.71
			],
			[
				"2006-10-17",
				106.29
			],
			[
				"2007-06-20",
				115.14
			],
			[
				"2013-09-10",
				110.71
			],
			[
				"2014-07-01",
				126.66
			],
			[
				"2015-08-06",
				113.81
			],
			[
				"2009-10-05",
				101.86
			],
			[
				"2008-12-04",
				101.86
			],
			[
				"2010-09-07",
				97.43
			],
			[
				"2011-05-11",
				88.57
			],
			[
				"2012-10-17",
				84.14
			]
		],
		"26540526": [
			[
				"2001-11-06",
				56.69
			],
			[
				"2002-11-06",
				45.17
			],
			[
				"2004-07-06",
				69.09
			],
			[
				"2005-07-19",
				57.57
			],
			[
				"2006-10-17",
				44.29
			],
			[
				"2007-06-20",
				39.41
			],
			[
				"2008-12-04",
				32.77
			],
			[
				"2013-09-10",
				62
			],
			[
				"2014-07-01",
				96.99
			],
			[
				"2015-08-06",
				69.97
			],
			[
				"2009-10-05",
				44.29
			],
			[
				"2010-09-07",
				53.14
			],
			[
				"2011-05-11",
				48.71
			],
			[
				"2012-10-17",
				75.29
			]
		],
		"26541129": [
			[
				"2001-11-07",
				104.51
			],
			[
				"2002-11-12",
				112.49
			],
			[
				"2004-09-20",
				95.79
			],
			[
				"2005-07-25",
				84.14
			],
			[
				"2006-10-25",
				124
			],
			[
				"2007-07-03",
				115.14
			],
			[
				"2013-07-31",
				84.14
			],
			[
				"2015-09-29",
				167.4
			],
			[
				"2009-10-01",
				177.14
			],
			[
				"2010-09-06",
				124
			],
			[
				"2011-09-13",
				97.43
			],
			[
				"2012-09-04",
				97.43
			]
		],
		"26541130": [
			[
				"2001-11-07",
				121.34
			],
			[
				"2002-11-12",
				123.56
			],
			[
				"2004-09-20",
				124
			],
			[
				"2005-07-25",
				101.86
			],
			[
				"2006-10-25",
				115.14
			],
			[
				"2007-07-03",
				115.14
			],
			[
				"2008-12-09",
				141.71
			],
			[
				"2013-07-31",
				93
			],
			[
				"2014-08-12",
				148.36
			],
			[
				"2015-09-29",
				176.7
			],
			[
				"2009-10-01",
				230.29
			],
			[
				"2010-09-06",
				137.29
			],
			[
				"2011-09-13",
				119.57
			],
			[
				"2012-09-04",
				150.57
			]
		],
		"26541142": [
			[
				"2001-11-07",
				111.6
			],
			[
				"2002-11-12",
				116.03
			],
			[
				"2004-09-20",
				101.41
			],
			[
				"2005-07-25",
				119.57
			],
			[
				"2006-10-25",
				110.71
			],
			[
				"2007-07-03",
				124
			],
			[
				"2008-12-09",
				106.29
			],
			[
				"2013-07-31",
				97.43
			],
			[
				"2014-08-12",
				119.57
			],
			[
				"2015-09-29",
				121.34
			],
			[
				"2009-10-01",
				168.29
			],
			[
				"2010-09-06",
				19.49
			],
			[
				"2011-09-13",
				128.43
			],
			[
				"2012-09-04",
				141.71
			]
		],
		"26541154": [
			[
				"2001-11-07",
				29.63
			],
			[
				"2002-11-12",
				26.13
			],
			[
				"2004-09-20",
				38.48
			],
			[
				"2005-07-25",
				44.29
			],
			[
				"2006-10-25",
				33.66
			],
			[
				"2007-07-03",
				34.54
			],
			[
				"2008-12-09",
				32.33
			],
			[
				"2013-07-31",
				39.41
			],
			[
				"2014-08-12",
				31.75
			],
			[
				"2015-09-29",
				19.62
			],
			[
				"2009-10-01",
				39.86
			],
			[
				"2010-09-06",
				155
			],
			[
				"2011-09-13",
				19.93
			],
			[
				"2012-09-04",
				43.84
			]
		],
		"26541178": [
			[
				"2001-11-16",
				30.03
			],
			[
				"2004-09-29",
				23.12
			],
			[
				"2005-07-26",
				13.73
			],
			[
				"2006-09-18",
				18.16
			],
			[
				"2007-07-10",
				11.51
			],
			[
				"2013-07-08",
				27.46
			],
			[
				"2015-07-21",
				39.33
			],
			[
				"2009-09-22",
				48.71
			],
			[
				"2010-10-18",
				19.93
			],
			[
				"2011-05-03",
				15.06
			],
			[
				"2012-09-06",
				38.09
			]
		],
		"26541180": [
			[
				"2001-11-16",
				38.22
			],
			[
				"2004-09-29",
				36.14
			],
			[
				"2005-07-26",
				66.43
			],
			[
				"2006-09-18",
				32.77
			],
			[
				"2007-07-10",
				62
			],
			[
				"2013-07-08",
				29.67
			],
			[
				"2014-08-07",
				23.34
			],
			[
				"2015-07-21",
				21.39
			],
			[
				"2010-10-18",
				34.1
			],
			[
				"2011-05-03",
				42.07
			],
			[
				"2012-09-06",
				34.99
			]
		],
		"26541191": [
			[
				"2001-11-16",
				10.23
			],
			[
				"2004-09-29",
				3.9
			],
			[
				"2005-07-26",
				7.09
			],
			[
				"2006-09-18",
				9.3
			],
			[
				"2007-07-10",
				10.63
			],
			[
				"2013-07-08",
				11.51
			],
			[
				"2014-08-07",
				18.11
			],
			[
				"2015-07-21",
				14.7
			],
			[
				"2009-09-22",
				13.29
			],
			[
				"2010-10-18",
				11.07
			],
			[
				"2011-05-03",
				8.41
			],
			[
				"2012-09-06",
				17.71
			]
		],
		"26541208": [
			[
				"2001-11-16",
				25.02
			],
			[
				"2004-09-29",
				20.28
			],
			[
				"2005-07-26",
				32.33
			],
			[
				"2006-09-18",
				62
			],
			[
				"2007-07-10",
				31.89
			],
			[
				"2013-07-08",
				44.29
			],
			[
				"2014-08-07",
				38
			],
			[
				"2015-07-21",
				43.36
			],
			[
				"2009-09-22",
				41.63
			],
			[
				"2010-10-18",
				39.86
			],
			[
				"2011-05-03",
				38.09
			],
			[
				"2012-09-06",
				42.96
			]
		],
		"26541233": [
			[
				"2004-10-12",
				8.81
			],
			[
				"2006-10-23",
				5.31
			],
			[
				"2007-06-19",
				3.5
			],
			[
				"2013-06-27",
				2.92
			],
			[
				"2014-06-12",
				6.73
			],
			[
				"2015-08-11",
				4.69
			],
			[
				"2009-09-07",
				2.21
			],
			[
				"2010-06-15",
				3.68
			],
			[
				"2011-03-28",
				4.87
			],
			[
				"2012-06-12",
				2.21
			]
		],
		"26541245": [
			[
				"2004-10-12",
				7.4
			],
			[
				"2006-10-23",
				8.41
			],
			[
				"2007-06-19",
				3.32
			],
			[
				"2013-06-27",
				2.21
			],
			[
				"2014-06-12",
				1.9
			],
			[
				"2015-08-11",
				7.4
			],
			[
				"2009-09-07",
				11.96
			],
			[
				"2010-06-15",
				3.28
			],
			[
				"2011-03-28",
				2.21
			],
			[
				"2012-06-12",
				2.21
			]
		],
		"26541269": [
			[
				"2004-10-12",
				7.66
			],
			[
				"2006-10-23",
				10.19
			],
			[
				"2007-06-19",
				8.41
			],
			[
				"2013-06-27",
				5.76
			],
			[
				"2014-06-12",
				5.62
			],
			[
				"2015-08-11",
				4.74
			],
			[
				"2009-09-07",
				8.41
			],
			[
				"2010-06-15",
				10.19
			],
			[
				"2011-03-28",
				4.87
			],
			[
				"2012-06-12",
				5.76
			]
		],
		"26541294": [
			[
				"2004-10-12",
				6.51
			],
			[
				"2006-10-23",
				2.21
			],
			[
				"2007-06-19",
				7.97
			],
			[
				"2013-06-27",
				5.76
			],
			[
				"2014-06-12",
				8.06
			],
			[
				"2015-08-11",
				6.69
			],
			[
				"2009-09-07",
				8.86
			],
			[
				"2010-06-15",
				9.3
			],
			[
				"2011-03-28",
				7.09
			],
			[
				"2012-06-12",
				6.64
			]
		],
		"30000075": [
			[
				"2007-01-09",
				1.33
			],
			[
				"2008-04-09",
				1.33
			],
			[
				"2007-10-16",
				1.33
			],
			[
				"2014-01-16",
				1.33
			],
			[
				"2015-01-06",
				0.18
			],
			[
				"2016-01-19",
				0.13
			],
			[
				"2009-07-17",
				1.33
			],
			[
				"2010-08-02",
				1.33
			],
			[
				"2010-12-22",
				0.13
			],
			[
				"2012-01-20",
				0.13
			],
			[
				"2013-02-18",
				0.13
			]
		],
		"30100458": [
			[
				"2007-02-15",
				1.33
			],
			[
				"2007-10-31",
				1.33
			],
			[
				"2008-06-12",
				1.33
			],
			[
				"2013-04-23",
				1.33
			],
			[
				"2015-09-18",
				0.13
			],
			[
				"2010-02-03",
				1.33
			],
			[
				"2010-12-15",
				0.13
			],
			[
				"2012-01-23",
				0.13
			]
		],
		"30302055": [
			[
				"2007-02-20",
				24.4
			],
			[
				"2007-10-31",
				22.72
			],
			[
				"2008-08-01",
				21.3
			],
			[
				"2013-07-25",
				20.37
			],
			[
				"2014-09-17",
				21.48
			],
			[
				"2015-09-17",
				20.86
			],
			[
				"2010-07-27",
				21.79
			],
			[
				"2011-06-29",
				21.04
			],
			[
				"2012-12-05",
				21.26
			]
		],
		"30302079": [
			[
				"2007-02-20",
				31
			],
			[
				"2008-05-29",
				14.57
			],
			[
				"2013-07-25",
				25.24
			],
			[
				"2014-09-24",
				26.44
			],
			[
				"2015-12-16",
				26.08
			],
			[
				"2010-09-01",
				25.91
			],
			[
				"2011-12-14",
				22.36
			],
			[
				"2012-12-17",
				23.47
			]
		],
		"30302584": [
			[
				"2000-11-23",
				14.61
			],
			[
				"2001-01-08",
				17.27
			],
			[
				"2001-11-08",
				11.07
			],
			[
				"2002-01-28",
				13.29
			],
			[
				"2002-09-09",
				16.83
			],
			[
				"2003-04-28",
				12.4
			],
			[
				"2003-12-09",
				15.5
			],
			[
				"2004-02-26",
				10.5
			],
			[
				"2004-08-06",
				13.73
			],
			[
				"2005-01-10",
				13.06
			],
			[
				"2005-10-12",
				12
			],
			[
				"2006-05-22",
				11.87
			],
			[
				"2007-01-09",
				12.62
			],
			[
				"2007-10-09",
				14.04
			],
			[
				"2008-03-19",
				11.91
			],
			[
				"2013-05-14",
				12
			],
			[
				"2015-01-05",
				11.6
			],
			[
				"2016-01-19",
				9.74
			],
			[
				"2009-07-29",
				11.29
			],
			[
				"2010-08-02",
				12.89
			],
			[
				"2011-11-14",
				13.2
			],
			[
				"2012-09-17",
				12.18
			]
		],
		"30302626": [
			[
				"2000-02-08",
				1.73
			],
			[
				"2000-08-15",
				1.33
			],
			[
				"2001-01-05",
				1.33
			],
			[
				"2001-11-09",
				1.33
			],
			[
				"2002-01-25",
				1.33
			],
			[
				"2002-09-06",
				1.73
			],
			[
				"2003-06-18",
				1.33
			],
			[
				"2003-11-28",
				1.33
			],
			[
				"2004-02-27",
				2.44
			],
			[
				"2004-08-02",
				1.33
			],
			[
				"2005-01-17",
				2.04
			],
			[
				"2005-10-20",
				1.33
			],
			[
				"2006-08-16",
				1.33
			],
			[
				"2007-01-10",
				1.33
			],
			[
				"2007-09-20",
				1.33
			],
			[
				"2008-03-12",
				1.33
			],
			[
				"2013-04-30",
				1.33
			],
			[
				"2014-12-19",
				0.13
			],
			[
				"2015-09-07",
				0.13
			],
			[
				"2009-07-14",
				0.49
			],
			[
				"2010-07-26",
				1.33
			],
			[
				"2011-02-21",
				2.44
			],
			[
				"2011-12-01",
				0.13
			],
			[
				"2012-09-27",
				0.13
			]
		],
		"30302640": [
			[
				"2000-01-24",
				35.87
			],
			[
				"2000-10-12",
				31.44
			],
			[
				"2001-03-30",
				19.49
			],
			[
				"2001-11-14",
				32.77
			],
			[
				"2002-06-28",
				34.1
			],
			[
				"2003-07-04",
				29.23
			],
			[
				"2004-02-05",
				16.39
			],
			[
				"2004-10-20",
				21.57
			],
			[
				"2005-04-29",
				16.21
			],
			[
				"2007-01-15",
				11.78
			],
			[
				"2005-12-20",
				25.38
			],
			[
				"2007-11-27",
				22.81
			],
			[
				"2008-07-10",
				22.32
			],
			[
				"2013-07-10",
				24
			],
			[
				"2015-09-29",
				23.29
			],
			[
				"2003-01-27",
				28.79
			],
			[
				"2009-11-04",
				19.44
			],
			[
				"2010-09-17",
				20.11
			],
			[
				"2011-05-30",
				22.32
			],
			[
				"2012-11-27",
				23.07
			]
		],
		"30302699": [
			[
				"2003-06-25",
				1.33
			],
			[
				"2003-11-28",
				1.33
			],
			[
				"2004-03-01",
				1.33
			],
			[
				"2004-08-04",
				1.33
			],
			[
				"2005-01-17",
				1.37
			],
			[
				"2005-10-11",
				1.33
			],
			[
				"2006-08-16",
				1.33
			],
			[
				"2007-05-10",
				1.33
			],
			[
				"2007-10-01",
				1.33
			],
			[
				"2008-03-14",
				1.33
			],
			[
				"2013-04-30",
				1.33
			],
			[
				"2015-09-07",
				0.13
			],
			[
				"2010-11-05",
				1.33
			],
			[
				"2011-11-15",
				0.13
			],
			[
				"2012-09-27",
				0.13
			]
		],
		"30302742": [
			[
				"2003-07-04",
				1.99
			],
			[
				"2004-02-13",
				6.2
			],
			[
				"2004-09-15",
				5.27
			],
			[
				"2005-07-26",
				1.33
			],
			[
				"2006-10-06",
				1.33
			],
			[
				"2007-01-08",
				4.03
			],
			[
				"2008-01-14",
				3.19
			],
			[
				"2013-05-21",
				2.66
			],
			[
				"2014-01-27",
				1.59
			],
			[
				"2015-09-16",
				1.33
			],
			[
				"2005-11-30",
				7
			],
			[
				"2009-11-06",
				1.37
			],
			[
				"2010-09-17",
				0.93
			],
			[
				"2011-05-17",
				5.71
			],
			[
				"2012-09-25",
				0.4
			]
		],
		"30302778": [
			[
				"2007-01-04",
				1.33
			],
			[
				"2008-06-12",
				2.04
			],
			[
				"2013-04-23",
				1.33
			],
			[
				"2014-12-19",
				1.33
			],
			[
				"2015-03-13",
				1.33
			],
			[
				"2007-10-12",
				1.33
			],
			[
				"2010-02-02",
				0.13
			],
			[
				"2010-12-15",
				0.18
			],
			[
				"2012-01-23",
				0.27
			]
		],
		"30302810": [
			[
				"2003-06-27",
				113.37
			],
			[
				"2004-02-13",
				105.4
			],
			[
				"2004-09-17",
				95.66
			],
			[
				"2005-04-21",
				70.41
			],
			[
				"2006-09-07",
				93.89
			],
			[
				"2007-01-16",
				98.31
			],
			[
				"2007-10-12",
				113.37
			],
			[
				"2008-06-12",
				104.07
			],
			[
				"2013-07-05",
				159.43
			],
			[
				"2015-03-13",
				121.34
			],
			[
				"2005-12-02",
				93.89
			],
			[
				"2010-07-14",
				135.96
			],
			[
				"2011-02-21",
				143.49
			],
			[
				"2011-09-07",
				178.91
			],
			[
				"2012-12-14",
				158.1
			]
		],
		"30302821": [
			[
				"2003-06-25",
				30.56
			],
			[
				"2003-12-08",
				1.33
			],
			[
				"2004-03-02",
				7.88
			],
			[
				"2004-08-04",
				1.33
			],
			[
				"2005-01-17",
				1.33
			],
			[
				"2005-10-20",
				1.33
			],
			[
				"2006-08-16",
				1.33
			],
			[
				"2007-01-10",
				1.33
			],
			[
				"2007-10-08",
				1.33
			],
			[
				"2008-03-14",
				3.28
			],
			[
				"2013-04-30",
				7.26
			],
			[
				"2015-01-09",
				17.76
			],
			[
				"2009-07-14",
				0.62
			],
			[
				"2010-07-26",
				1.33
			],
			[
				"2011-02-21",
				15.81
			],
			[
				"2011-12-01",
				0.13
			],
			[
				"2012-09-27",
				0.84
			]
		],
		"30302857": [
			[
				"2003-06-27",
				10.19
			],
			[
				"2003-12-08",
				11.51
			],
			[
				"2004-02-27",
				10.19
			],
			[
				"2004-08-04",
				9.3
			],
			[
				"2005-01-18",
				11.29
			],
			[
				"2005-10-11",
				11.78
			],
			[
				"2006-08-14",
				10.27
			],
			[
				"2007-01-10",
				11.38
			],
			[
				"2007-10-08",
				11.16
			],
			[
				"2008-03-12",
				11.25
			],
			[
				"2014-01-16",
				4.92
			],
			[
				"2015-01-09",
				3.72
			],
			[
				"2016-01-19",
				4.43
			],
			[
				"2009-07-17",
				16.34
			],
			[
				"2010-07-26",
				14.39
			],
			[
				"2011-01-03",
				12.44
			],
			[
				"2012-01-20",
				5.18
			],
			[
				"2013-02-18",
				5
			]
		],
		"31040020": [
			[
				"2007-06-14",
				17.01
			],
			[
				"2013-05-27",
				14.66
			],
			[
				"2015-09-07",
				13.64
			],
			[
				"2010-09-02",
				20.86
			],
			[
				"2011-12-08",
				16.43
			],
			[
				"2012-12-19",
				22.14
			]
		],
		"31040032": [
			[
				"2007-06-19",
				45.61
			],
			[
				"2008-05-27",
				52.26
			],
			[
				"2013-07-11",
				40.3
			],
			[
				"2014-09-30",
				46.5
			],
			[
				"2015-09-14",
				32.82
			],
			[
				"2010-08-05",
				39.95
			],
			[
				"2012-10-31",
				40.34
			]
		],
		"31040093": [
			[
				"2007-06-19",
				49.16
			],
			[
				"2008-05-27",
				48.71
			],
			[
				"2013-07-11",
				48.71
			],
			[
				"2014-12-09",
				51.81
			],
			[
				"2015-09-15",
				50.04
			],
			[
				"2010-08-05",
				50.04
			],
			[
				"2011-06-21",
				50.93
			],
			[
				"2012-10-31",
				49.6
			]
		],
		"31040100": [
			[
				"2007-11-28",
				7.35
			],
			[
				"2007-06-19",
				9.57
			],
			[
				"2008-08-20",
				8.37
			],
			[
				"2013-05-27",
				10.54
			],
			[
				"2014-12-09",
				11.2
			],
			[
				"2015-09-15",
				13.02
			],
			[
				"2010-02-04",
				3.63
			],
			[
				"2011-02-23",
				9.83
			],
			[
				"2011-12-08",
				10.19
			],
			[
				"2012-12-19",
				2.48
			]
		],
		"32032006": [
			[
				"2007-01-16",
				19.84
			],
			[
				"2007-10-29",
				22.01
			],
			[
				"2008-08-21",
				17.09
			],
			[
				"2014-09-18",
				16.3
			],
			[
				"2015-12-11",
				13.51
			],
			[
				"2010-01-11",
				17.14
			],
			[
				"2011-01-18",
				20.37
			],
			[
				"2012-07-02",
				17.09
			]
		],
		"32032018": [
			[
				"2007-01-12",
				12.62
			],
			[
				"2007-10-16",
				10.41
			],
			[
				"2008-06-09",
				9.96
			],
			[
				"2014-09-23",
				6.95
			],
			[
				"2015-09-18",
				3.85
			],
			[
				"2009-12-04",
				10.89
			],
			[
				"2010-08-30",
				8.15
			],
			[
				"2011-06-16",
				7.93
			],
			[
				"2012-12-03",
				0.93
			]
		],
		"32032080": [
			[
				"2007-01-04",
				1.33
			],
			[
				"2007-10-24",
				1.33
			],
			[
				"2008-06-09",
				1.33
			],
			[
				"2013-04-23",
				1.33
			],
			[
				"2015-08-28",
				0.13
			],
			[
				"2009-12-04",
				1.33
			],
			[
				"2010-12-13",
				0.13
			],
			[
				"2010-08-30",
				0.13
			],
			[
				"2012-01-11",
				1.33
			]
		],
		"32032110": [
			[
				"2007-01-12",
				23.21
			],
			[
				"2007-10-26",
				15.99
			],
			[
				"2008-06-09",
				22.94
			],
			[
				"2013-07-01",
				30.56
			],
			[
				"2014-06-03",
				28.39
			],
			[
				"2015-08-28",
				24.27
			],
			[
				"2009-07-16",
				23.87
			],
			[
				"2010-08-31",
				23.91
			],
			[
				"2011-09-26",
				23.83
			],
			[
				"2012-09-24",
				27.59
			]
		],
		"32032171": [
			[
				"2007-01-12",
				104.07
			],
			[
				"2007-10-24",
				104.07
			],
			[
				"2008-06-09",
				91.23
			],
			[
				"2013-05-08",
				71.3
			],
			[
				"2014-01-10",
				72.19
			],
			[
				"2015-08-28",
				69.09
			],
			[
				"2009-12-04",
				74.84
			],
			[
				"2010-08-30",
				72.63
			],
			[
				"2011-06-16",
				76.61
			],
			[
				"2012-09-17",
				72.63
			]
		],
		"32032201": [
			[
				"2007-01-12",
				12.44
			],
			[
				"2007-10-24",
				11.91
			],
			[
				"2008-07-23",
				9.34
			],
			[
				"2013-11-19",
				11.6
			],
			[
				"2014-08-20",
				9.08
			],
			[
				"2015-09-29",
				7.4
			],
			[
				"2010-09-02",
				9.12
			],
			[
				"2011-12-19",
				3.1
			],
			[
				"2012-12-04",
				10.1
			]
		],
		"32032225": [
			[
				"2007-01-15",
				3.28
			],
			[
				"2007-10-29",
				4.83
			],
			[
				"2008-06-11",
				3.28
			],
			[
				"2014-01-06",
				3.06
			],
			[
				"2015-08-28",
				4.96
			],
			[
				"2010-01-11",
				2.61
			],
			[
				"2010-12-13",
				2.83
			],
			[
				"2012-01-11",
				2.75
			],
			[
				"2013-02-13",
				3.45
			]
		],
		"32032250": [
			[
				"2007-01-24",
				19.71
			],
			[
				"2007-10-29",
				20.5
			],
			[
				"2008-08-21",
				21.97
			],
			[
				"2013-07-05",
				19.93
			],
			[
				"2014-08-28",
				19.75
			],
			[
				"2015-09-14",
				18.38
			],
			[
				"2010-01-27",
				21.26
			],
			[
				"2011-01-18",
				19.26
			],
			[
				"2012-07-02",
				19.26
			]
		],
		"32502643": [
			[
				"2000-02-07",
				76.61
			],
			[
				"2000-08-16",
				72.63
			],
			[
				"2001-01-04",
				72.63
			],
			[
				"2001-07-16",
				62.44
			],
			[
				"2002-01-22",
				62.89
			],
			[
				"2002-09-05",
				66.43
			],
			[
				"2003-04-15",
				98.31
			],
			[
				"2004-01-13",
				59.34
			],
			[
				"2004-09-07",
				68.2
			],
			[
				"2004-12-16",
				61.11
			],
			[
				"2005-10-17",
				67.76
			],
			[
				"2006-09-07",
				90.34
			],
			[
				"2007-01-09",
				88.57
			],
			[
				"2008-05-21",
				91.67
			],
			[
				"2013-06-17",
				89.9
			],
			[
				"2013-09-19",
				101.86
			],
			[
				"2015-08-20",
				138.17
			],
			[
				"2016-01-06",
				146.14
			],
			[
				"2007-10-16",
				120.46
			],
			[
				"2009-07-29",
				86.8
			],
			[
				"2010-11-05",
				94.77
			],
			[
				"2011-05-24",
				101.41
			],
			[
				"2012-07-02",
				111.16
			]
		],
		"34608448": [
			[
				"2008-05-27",
				17.94
			],
			[
				"2008-07-31",
				19.53
			],
			[
				"2010-06-01",
				20.41
			],
			[
				"2010-10-28",
				20.11
			],
			[
				"2011-03-15",
				20.91
			],
			[
				"2011-08-23",
				30.61
			],
			[
				"2011-11-07",
				24.31
			],
			[
				"2012-03-13",
				26.01
			],
			[
				"2012-06-12",
				24.71
			],
			[
				"2012-09-25",
				25.31
			],
			[
				"2012-11-14",
				28.61
			],
			[
				"2013-04-09",
				26.41
			],
			[
				"2013-06-18",
				26.11
			],
			[
				"2013-09-24",
				28.91
			],
			[
				"2013-12-11",
				37.71
			],
			[
				"2013-07-11",
				25.11
			],
			[
				"2014-09-01",
				43.53
			],
			[
				"2015-09-15",
				29.85
			],
			[
				"2009-12-17",
				23.96
			],
			[
				"2010-08-27",
				20.46
			],
			[
				"2011-06-21",
				29.61
			],
			[
				"2012-10-31",
				22.14
			]
		],
		"34709010": [
			[
				"2007-02-15",
				27.46
			],
			[
				"2008-05-29",
				24.49
			],
			[
				"2010-06-30",
				27.11
			],
			[
				"2010-09-28",
				26.21
			],
			[
				"2010-12-07",
				22.01
			],
			[
				"2011-04-01",
				24.01
			],
			[
				"2011-08-05",
				24.01
			],
			[
				"2011-10-04",
				24.01
			],
			[
				"2011-12-19",
				21.01
			],
			[
				"2012-03-16",
				77.03
			],
			[
				"2012-06-27",
				24.01
			],
			[
				"2012-09-26",
				25.01
			],
			[
				"2012-12-17",
				21.01
			],
			[
				"2013-05-27",
				24.14
			],
			[
				"2014-09-24",
				21.3
			],
			[
				"2015-09-17",
				22.5
			],
			[
				"2010-07-13",
				31.18
			],
			[
				"2011-02-23",
				19.97
			],
			[
				"2012-12-10",
				26.93
			]
		],
		"36411450": [
			[
				"2000-02-08",
				49.16
			],
			[
				"2000-08-16",
				55.8
			],
			[
				"2001-01-08",
				51.81
			],
			[
				"2001-10-31",
				65.54
			],
			[
				"2002-01-28",
				56.69
			],
			[
				"2002-09-10",
				60.67
			],
			[
				"2003-04-29",
				42.51
			],
			[
				"2003-12-09",
				32.33
			],
			[
				"2004-02-27",
				20.19
			],
			[
				"2004-08-06",
				19.49
			],
			[
				"2005-01-14",
				20.28
			],
			[
				"2005-10-12",
				42.82
			],
			[
				"2006-05-22",
				36.23
			],
			[
				"2007-01-05",
				37.78
			],
			[
				"2007-10-09",
				43.67
			],
			[
				"2008-03-19",
				41.85
			],
			[
				"2013-05-14",
				25.2
			],
			[
				"2014-09-26",
				15.68
			],
			[
				"2015-10-01",
				36.8
			],
			[
				"2009-07-15",
				49.16
			],
			[
				"2010-08-02",
				30.2
			],
			[
				"2011-06-15",
				45.61
			],
			[
				"2012-09-21",
				27.55
			]
		],
		"36411589": [
			[
				"2007-01-05",
				10.94
			],
			[
				"2007-10-26",
				10.81
			],
			[
				"2008-08-01",
				10.01
			],
			[
				"2013-04-12",
				7.97
			],
			[
				"2014-02-05",
				9.12
			],
			[
				"2015-01-06",
				7.44
			],
			[
				"2009-07-15",
				7.97
			],
			[
				"2010-08-31",
				7.09
			],
			[
				"2011-03-22",
				7.71
			],
			[
				"2012-07-06",
				8.28
			]
		],
		"36411607": [
			[
				"2007-01-05",
				13.55
			],
			[
				"2007-10-26",
				15.63
			],
			[
				"2008-08-01",
				15.9
			],
			[
				"2013-04-12",
				17.18
			],
			[
				"2014-02-05",
				14.48
			],
			[
				"2015-06-30",
				11.69
			],
			[
				"2009-07-15",
				15.32
			],
			[
				"2010-08-31",
				15.41
			],
			[
				"2011-03-22",
				15.99
			],
			[
				"2012-07-06",
				16.25
			]
		],
		"36462068": [
			[
				"2007-01-09",
				1.33
			],
			[
				"2008-04-09",
				1.33
			],
			[
				"2007-10-26",
				1.77
			],
			[
				"2013-05-14",
				1.33
			],
			[
				"2015-06-30",
				1.11
			],
			[
				"2009-07-29",
				1.33
			],
			[
				"2010-07-28",
				1.33
			],
			[
				"2011-06-15",
				1.33
			],
			[
				"2012-09-17",
				0.66
			]
		],
		"36462408": [
			[
				"2007-11-28",
				17.05
			],
			[
				"2007-06-05",
				16.83
			],
			[
				"2008-08-20",
				16.39
			],
			[
				"2013-11-22",
				14.92
			],
			[
				"2014-09-26",
				15.72
			],
			[
				"2015-09-18",
				13.29
			],
			[
				"2010-02-04",
				16.3
			],
			[
				"2011-12-08",
				14.92
			],
			[
				"2012-12-14",
				15.19
			]
		],
		"36462615": [
			[
				"2000-06-06",
				1.2
			],
			[
				"2000-02-07",
				1.1
			],
			[
				"2009-09-16",
				1
			],
			[
				"2009-03-24",
				1
			],
			[
				"2008-09-16",
				1
			],
			[
				"2008-03-11",
				1
			],
			[
				"2007-09-11",
				1
			],
			[
				"2007-03-20",
				1
			],
			[
				"2006-09-26",
				1
			],
			[
				"2006-03-29",
				1
			],
			[
				"2005-09-20",
				1
			],
			[
				"2005-03-15",
				1
			],
			[
				"2004-09-27",
				1
			],
			[
				"2004-03-29",
				2
			],
			[
				"2003-09-18",
				1.3
			],
			[
				"2003-03-10",
				1.2
			],
			[
				"2002-11-13",
				1.1
			],
			[
				"2002-08-14",
				1.2
			],
			[
				"2002-05-22",
				1
			],
			[
				"2002-03-12",
				1
			],
			[
				"2001-10-31",
				1.2
			],
			[
				"2001-08-15",
				1
			],
			[
				"2001-05-16",
				2.6
			],
			[
				"2001-01-30",
				1
			],
			[
				"2000-11-08",
				1
			],
			[
				"2000-08-15",
				1
			],
			[
				"2011-09-27",
				1
			],
			[
				"2011-03-14",
				1
			],
			[
				"2010-09-08",
				1
			],
			[
				"2010-03-23",
				1
			],
			[
				"2014-03-25",
				1
			],
			[
				"2014-09-30",
				1
			],
			[
				"2013-09-17",
				1
			],
			[
				"2013-03-18",
				1
			],
			[
				"2012-09-18",
				1
			],
			[
				"2012-03-26",
				1
			],
			[
				"2015-09-09",
				1
			],
			[
				"2015-03-10",
				1
			]
		],
		"36462767": [
			[
				"2007-01-18",
				1.33
			],
			[
				"2008-01-14",
				1.33
			],
			[
				"2013-05-21",
				1.33
			],
			[
				"2015-09-16",
				0.13
			],
			[
				"2009-11-06",
				1.33
			],
			[
				"2010-08-27",
				0.13
			],
			[
				"2011-05-17",
				0.13
			],
			[
				"2012-09-25",
				0.44
			]
		],
		"36462780": [
			[
				"2007-01-18",
				1.33
			],
			[
				"2008-01-14",
				11.25
			],
			[
				"2014-11-18",
				2.26
			],
			[
				"2015-10-15",
				0.8
			],
			[
				"2010-07-14",
				10.67
			],
			[
				"2011-11-16",
				4.92
			],
			[
				"2012-12-11",
				1.46
			]
		],
		"36485779": [
			[
				"2000-01-27",
				1.33
			],
			[
				"2000-11-20",
				1.33
			],
			[
				"2001-03-21",
				1.33
			],
			[
				"2001-11-15",
				1.33
			],
			[
				"2002-07-16",
				1.33
			],
			[
				"2003-07-02",
				1.77
			],
			[
				"2004-03-02",
				1.33
			],
			[
				"2004-09-15",
				1.33
			],
			[
				"2005-04-28",
				1.33
			],
			[
				"2007-01-08",
				1.33
			],
			[
				"2007-11-27",
				1.33
			],
			[
				"2008-07-14",
				1.33
			],
			[
				"2013-09-23",
				1.33
			],
			[
				"2014-12-18",
				0.13
			],
			[
				"2015-04-17",
				0.13
			],
			[
				"2016-01-21",
				0.13
			],
			[
				"2003-02-07",
				1.33
			],
			[
				"2005-11-30",
				1.55
			],
			[
				"2009-11-04",
				1.33
			],
			[
				"2010-09-17",
				0.13
			],
			[
				"2011-05-30",
				0.13
			],
			[
				"2012-02-15",
				0.13
			],
			[
				"2013-02-13",
				0.13
			]
		],
		"36487491": [
			[
				"2003-07-02",
				13.73
			],
			[
				"2004-05-25",
				14.17
			],
			[
				"2004-09-15",
				14.7
			],
			[
				"2005-04-28",
				13.55
			],
			[
				"2007-01-08",
				9.65
			],
			[
				"2007-11-27",
				10.81
			],
			[
				"2008-07-14",
				10.27
			],
			[
				"2014-07-16",
				8.64
			],
			[
				"2015-03-02",
				9.61
			],
			[
				"2016-01-21",
				9.3
			],
			[
				"2005-09-23",
				12.71
			],
			[
				"2009-11-10",
				10.72
			],
			[
				"2010-11-23",
				9.74
			],
			[
				"2011-05-30",
				12.05
			],
			[
				"2012-05-30",
				10.67
			],
			[
				"2013-02-13",
				10.41
			]
		],
		"40061334": [
			[
				"2000-05-05",
				4.43
			],
			[
				"2000-09-14",
				4.43
			],
			[
				"2001-07-09",
				4.43
			],
			[
				"2001-10-09",
				4.43
			],
			[
				"2002-04-08",
				6.64
			],
			[
				"2002-07-09",
				8.41
			],
			[
				"2003-05-14",
				4.43
			],
			[
				"2003-07-14",
				4.43
			],
			[
				"2004-09-29",
				4.43
			],
			[
				"2005-05-31",
				7.53
			],
			[
				"2006-05-23",
				4.43
			],
			[
				"2007-05-07",
				4.43
			],
			[
				"2008-04-02",
				6.64
			],
			[
				"2008-06-26",
				6.64
			],
			[
				"2013-11-07",
				1.33
			],
			[
				"2014-07-31",
				1.33
			],
			[
				"2015-12-03",
				1.33
			],
			[
				"2009-09-15",
				4.43
			],
			[
				"2010-05-05",
				4.43
			],
			[
				"2011-04-12",
				4.43
			]
		],
		"40061383": [
			[
				"2000-06-08",
				52.7
			],
			[
				"2000-09-28",
				42.07
			],
			[
				"2001-06-05",
				44.29
			],
			[
				"2001-11-15",
				36.31
			],
			[
				"2002-04-03",
				47.39
			],
			[
				"2003-09-04",
				44.29
			],
			[
				"2004-05-19",
				36.76
			],
			[
				"2005-07-20",
				39.86
			],
			[
				"2006-08-02",
				38.53
			],
			[
				"2007-04-24",
				39.86
			],
			[
				"2008-03-03",
				41.19
			],
			[
				"2013-12-05",
				14.3
			],
			[
				"2014-07-30",
				26.75
			],
			[
				"2015-12-02",
				25.91
			],
			[
				"2009-10-06",
				40.3
			],
			[
				"2010-06-14",
				32.77
			],
			[
				"2011-04-12",
				29.67
			]
		],
		"40070130": [
			[
				"2000-05-04",
				50.93
			],
			[
				"2000-08-09",
				48.71
			],
			[
				"2001-05-30",
				45.17
			],
			[
				"2001-10-09",
				46.94
			],
			[
				"2002-04-08",
				44.73
			],
			[
				"2002-07-09",
				47.39
			],
			[
				"2004-09-27",
				50.93
			],
			[
				"2005-05-31",
				51.81
			],
			[
				"2006-06-27",
				46.94
			],
			[
				"2007-05-02",
				41.63
			],
			[
				"2008-03-04",
				38.97
			],
			[
				"2013-12-11",
				32.86
			],
			[
				"2014-07-29",
				39.33
			],
			[
				"2015-12-02",
				33.97
			],
			[
				"2003-07-15",
				45.17
			],
			[
				"2009-11-10",
				38.97
			],
			[
				"2010-07-20",
				40.3
			],
			[
				"2011-04-18",
				34.99
			]
		],
		"40071005": [
			[
				"2006-08-01",
				84.59
			],
			[
				"2007-06-19",
				94.33
			],
			[
				"2008-09-22",
				74.4
			],
			[
				"2013-12-04",
				64.66
			],
			[
				"2014-08-06",
				58.01
			],
			[
				"2015-11-23",
				75.29
			],
			[
				"2009-07-16",
				77.06
			],
			[
				"2010-07-20",
				68.2
			],
			[
				"2011-04-18",
				71.74
			]
		],
		"40100066": [
			[
				"2007-10-22",
				51.37
			],
			[
				"2008-06-19",
				45.17
			],
			[
				"2013-11-29",
				36.54
			],
			[
				"2014-08-22",
				37.07
			],
			[
				"2015-04-30",
				35.61
			],
			[
				"2009-10-13",
				43.4
			],
			[
				"2011-04-19",
				42.51
			]
		],
		"40100091": [
			[
				"2000-04-20",
				43.4
			],
			[
				"2000-10-05",
				44.29
			],
			[
				"2001-07-02",
				39.86
			],
			[
				"2002-07-19",
				38.09
			],
			[
				"2002-04-09",
				34.99
			],
			[
				"2003-04-01",
				35.87
			],
			[
				"2003-09-04",
				34.99
			],
			[
				"2004-06-14",
				31
			],
			[
				"2004-09-23",
				31
			],
			[
				"2005-04-20",
				34.1
			],
			[
				"2006-05-09",
				31.89
			],
			[
				"2007-03-26",
				30.56
			],
			[
				"2008-03-17",
				33.66
			],
			[
				"2013-10-29",
				26.7
			],
			[
				"2014-07-16",
				24.31
			],
			[
				"2015-04-29",
				24.93
			],
			[
				"2009-08-05",
				29.67
			],
			[
				"2010-05-05",
				27.9
			],
			[
				"2011-04-05",
				31.44
			]
		],
		"40200061": [
			[
				"2006-08-01",
				20.81
			],
			[
				"2007-06-28",
				42.51
			],
			[
				"2008-06-19",
				37.2
			],
			[
				"2013-11-19",
				32.06
			],
			[
				"2014-08-21",
				30.69
			],
			[
				"2015-10-20",
				20.33
			],
			[
				"2009-11-10",
				29.67
			],
			[
				"2011-04-20",
				30.56
			]
		],
		"40200504": [
			[
				"2006-11-30",
				70.02
			],
			[
				"2007-06-05",
				72.03
			],
			[
				"2008-05-05",
				122.04
			],
			[
				"2009-04-21",
				91.03
			],
			[
				"2010-03-02",
				107.04
			],
			[
				"2000-06-05",
				124.89
			],
			[
				"2000-09-28",
				178.91
			],
			[
				"2001-07-05",
				100.09
			],
			[
				"2002-07-19",
				91.23
			],
			[
				"2003-09-02",
				99.64
			],
			[
				"2004-07-22",
				61.56
			],
			[
				"2004-09-23",
				62
			],
			[
				"2005-09-13",
				97.87
			],
			[
				"2007-05-21",
				81.93
			],
			[
				"2008-06-25",
				101.86
			],
			[
				"2011-01-25",
				118.04
			],
			[
				"2012-01-03",
				92.03
			],
			[
				"2013-01-23",
				84.03
			],
			[
				"2014-01-14",
				49.02
			],
			[
				"2015-06-01",
				68.02
			],
			[
				"2014-10-09",
				22.81
			],
			[
				"2009-11-16",
				103.63
			],
			[
				"2010-06-14",
				94.33
			]
		],
		"40200905": [
			[
				"2000-04-07",
				27.46
			],
			[
				"2000-09-22",
				27.01
			],
			[
				"2001-04-20",
				22.14
			],
			[
				"2002-04-25",
				26.13
			],
			[
				"2003-05-20",
				36.31
			],
			[
				"2004-06-29",
				24.8
			],
			[
				"2004-07-15",
				26.13
			],
			[
				"2005-05-13",
				23.47
			],
			[
				"2006-06-13",
				20.81
			],
			[
				"2007-06-11",
				17.71
			],
			[
				"2008-04-17",
				20.37
			],
			[
				"2013-11-04",
				24.09
			],
			[
				"2014-08-19",
				20.68
			],
			[
				"2015-10-21",
				19.09
			],
			[
				"2009-07-29",
				30.56
			],
			[
				"2010-07-21",
				27.46
			],
			[
				"2011-05-02",
				23.03
			]
		],
		"40200929": [
			[
				"2000-04-07",
				23.47
			],
			[
				"2000-10-13",
				17.27
			],
			[
				"2001-04-20",
				16.83
			],
			[
				"2001-10-10",
				27.01
			],
			[
				"2002-06-03",
				17.27
			],
			[
				"2003-05-27",
				18.6
			],
			[
				"2004-07-12",
				10.63
			],
			[
				"2004-07-28",
				11.51
			],
			[
				"2005-08-02",
				13.29
			],
			[
				"2006-06-13",
				18.6
			],
			[
				"2007-06-28",
				11.07
			],
			[
				"2008-06-19",
				7.97
			],
			[
				"2014-08-20",
				9.12
			],
			[
				"2015-10-22",
				12.13
			],
			[
				"2009-10-13",
				13.29
			],
			[
				"2010-07-21",
				9.74
			],
			[
				"2011-05-02",
				11.96
			]
		],
		"40406015": [
			[
				"2004-09-22",
				46.5
			],
			[
				"2005-05-04",
				47.39
			],
			[
				"2006-05-10",
				42.96
			],
			[
				"2006-06-23",
				45.61
			],
			[
				"2007-04-10",
				47.83
			],
			[
				"2008-04-23",
				41.63
			],
			[
				"2013-08-19",
				38.97
			],
			[
				"2014-07-02",
				32.64
			],
			[
				"2015-06-23",
				32.73
			],
			[
				"2009-09-14",
				34.1
			],
			[
				"2010-07-06",
				32.33
			],
			[
				"2011-04-05",
				36.76
			]
		],
		"40507014": [
			[
				"2005-07-20",
				9.3
			],
			[
				"2005-09-08",
				9.3
			],
			[
				"2006-10-16",
				4.43
			],
			[
				"2006-09-13",
				5.76
			],
			[
				"2007-07-02",
				7.53
			],
			[
				"2007-06-06",
				9.74
			],
			[
				"2008-04-23",
				47.39
			],
			[
				"2013-10-16",
				1.33
			],
			[
				"2014-09-09",
				13.91
			],
			[
				"2015-11-13",
				9.21
			],
			[
				"2009-10-06",
				4.43
			],
			[
				"2010-07-22",
				4.43
			],
			[
				"2011-05-09",
				21.7
			]
		],
		"40606107": [
			[
				"2000-05-05",
				58.46
			],
			[
				"2000-08-10",
				62
			],
			[
				"2001-07-24",
				65.54
			],
			[
				"2002-04-03",
				48.71
			],
			[
				"2002-07-09",
				56.24
			],
			[
				"2003-05-14",
				53.59
			],
			[
				"2003-07-14",
				50.04
			],
			[
				"2004-07-22",
				52.26
			],
			[
				"2004-09-29",
				51.81
			],
			[
				"2005-05-31",
				69.09
			],
			[
				"2006-05-10",
				52.7
			],
			[
				"2007-03-22",
				51.81
			],
			[
				"2008-03-10",
				57.13
			],
			[
				"2013-12-06",
				45.61
			],
			[
				"2014-10-09",
				49.16
			],
			[
				"2015-12-01",
				39.15
			],
			[
				"2009-07-06",
				60.67
			],
			[
				"2010-08-05",
				51.81
			],
			[
				"2011-06-10",
				49.16
			]
		],
		"40607010": [
			[
				"2004-12-21",
				4.43
			],
			[
				"2005-05-04",
				4.43
			],
			[
				"2005-09-08",
				4.43
			],
			[
				"2006-09-06",
				4.43
			],
			[
				"2007-03-26",
				4.43
			],
			[
				"2008-03-31",
				4.43
			],
			[
				"2013-10-16",
				1.33
			],
			[
				"2014-09-09",
				1.33
			],
			[
				"2015-11-12",
				1.33
			],
			[
				"2009-07-06",
				4.43
			],
			[
				"2010-07-22",
				4.43
			],
			[
				"2011-05-09",
				4.43
			]
		],
		"42001006": [
			[
				"2006-12-05",
				6.9
			],
			[
				"2007-06-04",
				5.71
			],
			[
				"2008-05-07",
				1.6
			],
			[
				"2009-03-16",
				10.6
			],
			[
				"2010-03-04",
				8.5
			],
			[
				"2011-01-31",
				6.1
			],
			[
				"2012-06-29",
				17.51
			],
			[
				"2013-01-24",
				2.4
			],
			[
				"2014-01-20",
				2.5
			],
			[
				"2015-12-02",
				6.7
			],
			[
				"2010-06-23",
				13.2
			],
			[
				"2011-07-12",
				14.81
			],
			[
				"2012-11-27",
				19.51
			],
			[
				"2013-06-20",
				10.7
			],
			[
				"2013-11-26",
				8.2
			],
			[
				"2014-06-23",
				2.92
			],
			[
				"2014-11-20",
				6.5
			],
			[
				"2006-05-19",
				13.7
			],
			[
				"2007-11-28",
				7.7
			],
			[
				"2008-11-26",
				2.7
			],
			[
				"2000-07-10",
				20.01
			],
			[
				"2001-06-29",
				4.5
			],
			[
				"2003-08-12",
				10.3
			]
		],
		"42011097": [
			[
				"2006-11-28",
				82.03
			],
			[
				"2007-06-04",
				91.03
			],
			[
				"2008-05-07",
				68.02
			],
			[
				"2009-02-27",
				95.03
			],
			[
				"2010-03-04",
				98.03
			],
			[
				"2011-01-31",
				102.04
			],
			[
				"2012-06-13",
				62.02
			],
			[
				"2013-01-28",
				58.02
			],
			[
				"2014-01-13",
				59.02
			],
			[
				"2015-12-10",
				45.02
			],
			[
				"2006-05-18",
				88.03
			],
			[
				"2000-07-17",
				110.04
			],
			[
				"2003-08-11",
				95.03
			]
		],
		"42011358": [
			[
				"2006-11-27",
				19.61
			],
			[
				"2007-06-19",
				17.51
			],
			[
				"2008-05-08",
				17.01
			],
			[
				"2009-04-21",
				18.51
			],
			[
				"2010-04-01",
				15.41
			],
			[
				"2011-01-31",
				16.31
			],
			[
				"2012-01-05",
				16.21
			],
			[
				"2013-04-08",
				14.21
			],
			[
				"2014-01-16",
				15.51
			],
			[
				"2015-01-16",
				15.41
			],
			[
				"2001-07-24",
				20.31
			],
			[
				"2004-06-14",
				20.11
			]
		],
		"42013550": [
			[
				"2006-11-29",
				57.02
			],
			[
				"2007-06-13",
				51.02
			],
			[
				"2008-05-05",
				48.02
			],
			[
				"2009-04-22",
				55.02
			],
			[
				"2010-04-21",
				44.02
			],
			[
				"2011-01-25",
				47.02
			],
			[
				"2012-01-31",
				39.01
			],
			[
				"2013-04-02",
				47.02
			],
			[
				"2014-01-14",
				40.01
			],
			[
				"2015-01-15",
				37.01
			],
			[
				"2015-06-25",
				35.01
			],
			[
				"2010-03-08",
				47.02
			],
			[
				"2010-09-03",
				43.02
			],
			[
				"2011-08-03",
				47.02
			],
			[
				"2012-01-02",
				40.01
			],
			[
				"2012-07-24",
				49.02
			],
			[
				"2013-01-29",
				47.02
			],
			[
				"2013-07-04",
				41.01
			],
			[
				"2014-07-17",
				40.01
			],
			[
				"2005-02-22",
				65.02
			],
			[
				"2005-09-07",
				62.02
			],
			[
				"2006-03-22",
				53.02
			],
			[
				"2006-09-06",
				62.02
			],
			[
				"2007-03-22",
				50.02
			],
			[
				"2007-09-04",
				51.02
			],
			[
				"2008-02-28",
				52.02
			],
			[
				"2008-09-01",
				51.02
			],
			[
				"2009-02-16",
				50.02
			],
			[
				"2009-08-19",
				47.02
			],
			[
				"2000-02-07",
				78.03
			],
			[
				"2000-05-09",
				71.03
			],
			[
				"2000-08-07",
				73.03
			],
			[
				"2000-11-13",
				69.02
			],
			[
				"2001-02-12",
				71.03
			],
			[
				"2001-05-17",
				70.02
			],
			[
				"2001-07-26",
				70.02
			],
			[
				"2001-11-12",
				71.03
			],
			[
				"2002-02-26",
				72.03
			],
			[
				"2002-05-21",
				70.02
			],
			[
				"2002-08-22",
				69.02
			],
			[
				"2002-11-12",
				62.02
			],
			[
				"2003-03-12",
				68.02
			],
			[
				"2003-06-04",
				66.02
			],
			[
				"2003-09-04",
				74.03
			],
			[
				"2003-11-25",
				68.02
			],
			[
				"2004-03-16",
				67.02
			],
			[
				"2004-06-08",
				69.02
			],
			[
				"2004-06-21",
				72.03
			],
			[
				"2004-09-06",
				76.03
			]
		],
		"42013800": [
			[
				"2006-11-28",
				20.51
			],
			[
				"2007-06-21",
				20.61
			],
			[
				"2008-05-08",
				23.61
			],
			[
				"2009-04-20",
				24.01
			],
			[
				"2010-04-06",
				23.11
			],
			[
				"2011-01-25",
				25.01
			],
			[
				"2012-01-05",
				20.91
			],
			[
				"2013-04-02",
				22.01
			],
			[
				"2014-01-27",
				21.81
			],
			[
				"2015-01-15",
				19.51
			],
			[
				"2001-07-26",
				11.3
			],
			[
				"2004-06-16",
				18.51
			]
		],
		"42013987": [
			[
				"2006-11-27",
				16.81
			],
			[
				"2007-06-05",
				13.7
			],
			[
				"2008-05-06",
				14.21
			],
			[
				"2009-04-21",
				15.01
			],
			[
				"2010-04-01",
				13.2
			],
			[
				"2011-01-24",
				16.51
			],
			[
				"2012-01-03",
				16.71
			],
			[
				"2013-04-08",
				12
			],
			[
				"2014-01-13",
				13.3
			],
			[
				"2015-06-01",
				13.1
			],
			[
				"2001-07-24",
				14.61
			],
			[
				"2004-06-14",
				19.61
			]
		],
		"42014542": [
			[
				"2006-05-17",
				41.01
			],
			[
				"2006-05-17",
				41.01
			],
			[
				"2008-01-14",
				40.01
			],
			[
				"2008-05-06",
				43.02
			],
			[
				"2009-03-04",
				36.01
			],
			[
				"2010-03-03",
				41.01
			],
			[
				"2011-02-01",
				50.02
			],
			[
				"2012-06-12",
				42.01
			],
			[
				"2013-01-25",
				56.02
			],
			[
				"2014-01-15",
				37.01
			],
			[
				"2015-12-07",
				33.01
			],
			[
				"2000-08-14",
				44.02
			],
			[
				"2003-07-30",
				47.02
			]
		],
		"42016368": [
			[
				"2006-05-16",
				48.02
			],
			[
				"2006-05-16",
				48.02
			],
			[
				"2008-01-15",
				35.01
			],
			[
				"2008-05-06",
				38.01
			],
			[
				"2009-03-03",
				47.02
			],
			[
				"2010-03-03",
				50.02
			],
			[
				"2011-01-27",
				51.02
			],
			[
				"2012-06-12",
				64.02
			],
			[
				"2013-01-28",
				58.02
			],
			[
				"2014-01-15",
				42.01
			],
			[
				"2015-12-03",
				52.02
			],
			[
				"2000-08-14",
				60.02
			],
			[
				"2003-08-11",
				35.01
			]
		],
		"42016459": [
			[
				"2005-06-22",
				36.01
			],
			[
				"2005-06-22",
				36.01
			],
			[
				"2008-01-15",
				36.01
			],
			[
				"2008-05-14",
				56.02
			],
			[
				"2009-04-21",
				52.02
			],
			[
				"2010-03-03",
				23.91
			],
			[
				"2011-06-14",
				30.01
			],
			[
				"2012-06-04",
				47.02
			],
			[
				"2013-06-24",
				34.01
			],
			[
				"2014-04-24",
				60.02
			],
			[
				"2015-01-13",
				30.01
			],
			[
				"2002-09-09",
				43.02
			]
		],
		"42060564": [
			[
				"2008-01-15",
				146.05
			],
			[
				"2008-05-05",
				181.06
			],
			[
				"2009-04-21",
				179.06
			],
			[
				"2010-03-03",
				193.07
			],
			[
				"2011-01-31",
				222.08
			],
			[
				"2012-06-04",
				178.06
			],
			[
				"2013-01-28",
				157.06
			],
			[
				"2014-01-15",
				136.05
			],
			[
				"2015-01-15",
				106.04
			],
			[
				"2015-07-22",
				138.05
			],
			[
				"2008-02-07",
				218.08
			]
		],
		"42060620": [
			[
				"2006-11-28",
				18.11
			],
			[
				"2007-06-04",
				21.01
			],
			[
				"2008-05-08",
				26.01
			],
			[
				"2009-09-02",
				29.41
			],
			[
				"2010-03-02",
				31.01
			],
			[
				"2011-01-28",
				28.01
			],
			[
				"2012-06-13",
				24.11
			],
			[
				"2013-01-24",
				25.01
			],
			[
				"2014-01-20",
				20.61
			],
			[
				"2015-12-04",
				31.01
			],
			[
				"2005-01-24",
				15.91
			],
			[
				"2005-04-12",
				15.91
			],
			[
				"2005-10-25",
				17.21
			],
			[
				"2006-04-19",
				18.81
			],
			[
				"2006-05-23",
				18.81
			],
			[
				"2006-08-01",
				21.91
			],
			[
				"2000-02-22",
				19.01
			],
			[
				"2000-05-03",
				23.01
			],
			[
				"2000-08-02",
				23.01
			],
			[
				"2000-08-28",
				25.01
			],
			[
				"2000-11-08",
				24.01
			],
			[
				"2001-02-14",
				25.21
			],
			[
				"2001-05-15",
				20.51
			],
			[
				"2001-08-01",
				26.51
			],
			[
				"2001-10-30",
				30.01
			],
			[
				"2002-01-14",
				24.11
			],
			[
				"2002-04-30",
				20.21
			],
			[
				"2002-07-31",
				15.81
			],
			[
				"2002-10-29",
				17.41
			],
			[
				"2003-01-14",
				18.61
			],
			[
				"2003-04-07",
				15.91
			],
			[
				"2003-07-01",
				14.51
			],
			[
				"2003-07-17",
				0.05
			],
			[
				"2004-01-14",
				16.21
			],
			[
				"2004-03-30",
				18.91
			],
			[
				"2004-07-06",
				16.01
			],
			[
				"2004-10-11",
				15.81
			]
		],
		"42062329": [
			[
				"2006-11-29",
				2.36
			],
			[
				"2007-06-05",
				3.26
			],
			[
				"2008-05-05",
				18.61
			],
			[
				"2009-03-25",
				4
			],
			[
				"2010-03-22",
				1.1
			],
			[
				"2011-01-25",
				2.6
			],
			[
				"2012-06-19",
				0.29
			],
			[
				"2013-01-23",
				1.36
			],
			[
				"2014-01-14",
				2
			],
			[
				"2015-03-19",
				1.38
			],
			[
				"2015-09-17",
				1.4
			],
			[
				"2015-11-11",
				0.38
			],
			[
				"2010-09-15",
				2.1
			],
			[
				"2011-03-22",
				1.7
			],
			[
				"2011-09-21",
				0.6
			],
			[
				"2012-03-21",
				1.8
			],
			[
				"2012-09-24",
				0.05
			],
			[
				"2013-03-18",
				0.77
			],
			[
				"2013-09-12",
				0.05
			],
			[
				"2014-03-20",
				0.05
			],
			[
				"2014-09-22",
				0.36
			],
			[
				"2005-03-31",
				3.9
			],
			[
				"2005-09-20",
				1.7
			],
			[
				"2006-03-23",
				1.86
			],
			[
				"2006-05-31",
				1.79
			],
			[
				"2006-09-18",
				1.8
			],
			[
				"2007-03-21",
				3.46
			],
			[
				"2007-09-19",
				2.6
			],
			[
				"2008-03-27",
				14.91
			],
			[
				"2008-09-18",
				20.31
			],
			[
				"2009-09-30",
				3
			],
			[
				"2000-08-08",
				9.2
			],
			[
				"2001-10-09",
				7.5
			],
			[
				"2002-04-04",
				3.8
			],
			[
				"2002-09-24",
				3.6
			],
			[
				"2003-03-26",
				32.01
			],
			[
				"2003-08-14",
				2.21
			],
			[
				"2003-09-22",
				2.7
			],
			[
				"2004-04-06",
				3.18
			],
			[
				"2004-09-22",
				3.2
			]
		],
		"42063310": [
			[
				"2006-12-06",
				31.01
			],
			[
				"2007-06-14",
				37.01
			],
			[
				"2008-06-18",
				44.02
			],
			[
				"2009-05-05",
				43.02
			],
			[
				"2010-04-15",
				40.01
			],
			[
				"2011-02-16",
				34.01
			],
			[
				"2012-04-05",
				46.02
			],
			[
				"2013-04-10",
				36.01
			],
			[
				"2014-02-13",
				45.02
			],
			[
				"2015-03-10",
				34.01
			],
			[
				"2005-06-08",
				33.01
			],
			[
				"2006-02-28",
				27.01
			],
			[
				"2000-03-07",
				58.02
			],
			[
				"2001-07-19",
				44.02
			],
			[
				"2002-02-06",
				47.02
			],
			[
				"2003-03-27",
				38.01
			],
			[
				"2004-06-22",
				33.01
			]
		],
		"42063334": [
			[
				"2006-11-30",
				38.01
			],
			[
				"2007-06-14",
				45.02
			],
			[
				"2008-06-18",
				53.02
			],
			[
				"2009-05-15",
				46.02
			],
			[
				"2010-04-07",
				48.02
			],
			[
				"2011-02-24",
				54.02
			],
			[
				"2012-04-05",
				43.02
			],
			[
				"2013-04-11",
				46.02
			],
			[
				"2014-03-24",
				42.01
			],
			[
				"2015-03-24",
				49.02
			],
			[
				"2005-06-08",
				42.01
			],
			[
				"2006-03-02",
				34.01
			],
			[
				"2000-03-08",
				54.02
			],
			[
				"2001-07-17",
				49.02
			],
			[
				"2002-02-05",
				55.02
			],
			[
				"2003-04-03",
				50.02
			],
			[
				"2004-06-22",
				18.61
			]
		],
		"42063437": [
			[
				"2006-11-30",
				2.4
			],
			[
				"2007-06-05",
				2.2
			],
			[
				"2008-06-23",
				1.9
			],
			[
				"2009-07-02",
				11
			],
			[
				"2010-04-15",
				4.4
			],
			[
				"2011-02-18",
				18.61
			],
			[
				"2012-03-29",
				2.4
			],
			[
				"2013-04-18",
				4.3
			],
			[
				"2014-03-24",
				1.86
			],
			[
				"2015-04-22",
				1.23
			],
			[
				"2005-06-09",
				3.7
			],
			[
				"2006-02-28",
				4.43
			],
			[
				"2000-03-14",
				7.6
			],
			[
				"2001-07-19",
				0.95
			],
			[
				"2002-02-06",
				1.63
			],
			[
				"2003-04-02",
				1.45
			],
			[
				"2004-06-18",
				1.42
			]
		],
		"42063607": [
			[
				"2006-11-29",
				31.01
			],
			[
				"2007-06-20",
				29.61
			],
			[
				"2008-06-23",
				31.01
			],
			[
				"2009-05-07",
				30.01
			],
			[
				"2010-04-07",
				25.61
			],
			[
				"2011-02-14",
				30.01
			],
			[
				"2012-04-04",
				29.01
			],
			[
				"2013-04-05",
				28.01
			],
			[
				"2014-03-26",
				33.01
			],
			[
				"2015-03-11",
				23.31
			],
			[
				"2005-06-10",
				32.01
			],
			[
				"2006-03-01",
				30.01
			],
			[
				"2000-03-21",
				31.01
			],
			[
				"2001-07-23",
				36.01
			],
			[
				"2002-02-12",
				32.01
			],
			[
				"2003-04-01",
				42.01
			],
			[
				"2004-06-17",
				35.01
			]
		],
		"42063632": [
			[
				"2006-11-29",
				0.17
			],
			[
				"2007-06-20",
				0.05
			],
			[
				"2008-06-24",
				0.89
			],
			[
				"2009-05-07",
				3
			],
			[
				"2010-04-01",
				3.4
			],
			[
				"2011-02-10",
				4.4
			],
			[
				"2012-03-28",
				1.4
			],
			[
				"2013-04-04",
				1
			],
			[
				"2014-02-21",
				2.9
			],
			[
				"2015-03-10",
				1.89
			],
			[
				"2005-06-06",
				0.6
			],
			[
				"2006-03-07",
				12.3
			],
			[
				"2000-03-20",
				4.8
			],
			[
				"2001-07-23",
				1.06
			],
			[
				"2002-02-12",
				5
			],
			[
				"2003-03-26",
				1.33
			],
			[
				"2004-06-16",
				0.25
			]
		],
		"42063656": [
			[
				"2006-11-28",
				0.06
			],
			[
				"2007-06-21",
				0.05
			],
			[
				"2008-06-13",
				0.05
			],
			[
				"2009-05-04",
				0.05
			],
			[
				"2010-04-01",
				0.05
			],
			[
				"2011-02-10",
				0.05
			],
			[
				"2012-04-03",
				0.05
			],
			[
				"2013-07-05",
				0.05
			],
			[
				"2014-03-25",
				0.05
			],
			[
				"2015-03-12",
				0.05
			],
			[
				"2005-06-14",
				0.05
			],
			[
				"2006-03-10",
				0.05
			],
			[
				"2000-03-22",
				0.05
			],
			[
				"2001-07-24",
				0.05
			],
			[
				"2002-02-13",
				0.1
			],
			[
				"2003-03-26",
				0.05
			],
			[
				"2004-06-14",
				0.12
			]
		],
		"42063670": [
			[
				"2006-11-28",
				7
			],
			[
				"2007-06-21",
				7
			],
			[
				"2008-06-12",
				8.6
			],
			[
				"2009-08-21",
				5.6
			],
			[
				"2010-04-30",
				8
			],
			[
				"2011-02-10",
				16.71
			],
			[
				"2012-03-30",
				10.7
			],
			[
				"2013-04-04",
				10.2
			],
			[
				"2014-03-26",
				18.91
			],
			[
				"2015-03-12",
				12.3
			],
			[
				"2005-06-14",
				18.41
			],
			[
				"2006-03-10",
				11.4
			],
			[
				"2000-03-22",
				93.03
			],
			[
				"2001-07-24",
				77.03
			],
			[
				"2002-02-13",
				57.22
			],
			[
				"2003-04-01",
				72.03
			],
			[
				"2004-06-14",
				20.41
			]
		],
		"42063681": [
			[
				"2006-11-27",
				60.02
			],
			[
				"2007-06-25",
				54.02
			],
			[
				"2008-06-12",
				61.02
			],
			[
				"2009-05-04",
				37.01
			],
			[
				"2010-04-01",
				50.02
			],
			[
				"2011-02-10",
				56.02
			],
			[
				"2012-04-10",
				68.02
			],
			[
				"2013-04-02",
				62.02
			],
			[
				"2014-03-25",
				55.02
			],
			[
				"2015-03-13",
				49.02
			],
			[
				"2005-06-14",
				71.03
			],
			[
				"2006-03-09",
				70.02
			],
			[
				"2000-03-21",
				54.02
			],
			[
				"2001-07-24",
				75.03
			],
			[
				"2002-02-13",
				76.73
			],
			[
				"2003-03-31",
				70.02
			],
			[
				"2004-06-16",
				75.03
			]
		],
		"42063917": [
			[
				"2006-11-27",
				0.11
			],
			[
				"2007-06-05",
				0.21
			],
			[
				"2008-05-07",
				0.05
			],
			[
				"2009-04-20",
				0.05
			],
			[
				"2010-03-31",
				0.69
			],
			[
				"2011-01-24",
				0.97
			],
			[
				"2012-01-02",
				0.09
			],
			[
				"2013-04-08",
				0.05
			],
			[
				"2014-01-16",
				0.54
			],
			[
				"2015-01-15",
				0.15
			],
			[
				"2001-07-24",
				0.05
			],
			[
				"2004-06-14",
				0.98
			]
		],
		"42064697": [
			[
				"2006-11-28",
				11.7
			],
			[
				"2007-06-19",
				10.5
			],
			[
				"2008-05-08",
				10.8
			],
			[
				"2009-03-05",
				10
			],
			[
				"2010-03-04",
				10.6
			],
			[
				"2011-01-31",
				13.1
			],
			[
				"2012-06-26",
				9.6
			],
			[
				"2013-02-14",
				7.6
			],
			[
				"2014-01-20",
				20.21
			],
			[
				"2015-12-14",
				15.21
			],
			[
				"2006-05-23",
				10.4
			],
			[
				"2000-01-21",
				16.01
			],
			[
				"2000-07-18",
				14
			],
			[
				"2003-08-14",
				13.8
			]
		],
		"42065082": [
			[
				"2006-11-27",
				37.01
			],
			[
				"2007-06-04",
				37.01
			],
			[
				"2008-05-07",
				34.01
			],
			[
				"2009-03-02",
				35.01
			],
			[
				"2010-03-02",
				34.01
			],
			[
				"2011-01-28",
				34.01
			],
			[
				"2012-02-09",
				29.01
			],
			[
				"2013-01-25",
				34.01
			],
			[
				"2014-01-16",
				30.01
			],
			[
				"2015-12-07",
				45.02
			],
			[
				"2006-05-17",
				35.01
			],
			[
				"2000-11-23",
				35.01
			],
			[
				"2003-07-17",
				40.01
			]
		],
		"42065100": [
			[
				"2006-05-17",
				33.01
			],
			[
				"2006-05-17",
				33.01
			],
			[
				"2008-01-14",
				3.8
			],
			[
				"2008-05-07",
				4.1
			],
			[
				"2009-03-02",
				15.41
			],
			[
				"2010-03-02",
				12.2
			],
			[
				"2011-01-28",
				13.6
			],
			[
				"2012-02-10",
				21.01
			],
			[
				"2013-01-25",
				12.9
			],
			[
				"2014-01-16",
				20.01
			],
			[
				"2015-12-09",
				17.65
			],
			[
				"2000-10-19",
				34.01
			],
			[
				"2003-06-26",
				28.71
			]
		],
		"42065124": [
			[
				"2006-05-16",
				15.61
			],
			[
				"2006-05-16",
				15.61
			],
			[
				"2007-10-25",
				15.91
			],
			[
				"2007-10-25",
				15.91
			],
			[
				"2008-01-15",
				12.1
			],
			[
				"2008-05-06",
				14.21
			],
			[
				"2009-03-03",
				12.3
			],
			[
				"2010-03-23",
				12.7
			],
			[
				"2011-02-01",
				12.8
			],
			[
				"2012-06-12",
				13.1
			],
			[
				"2013-01-28",
				13.2
			],
			[
				"2014-01-15",
				14.91
			],
			[
				"2015-01-27",
				15.71
			],
			[
				"2015-03-17",
				16.01
			],
			[
				"2015-08-10",
				16.71
			],
			[
				"2015-09-21",
				16.01
			],
			[
				"2015-12-07",
				17.51
			],
			[
				"2010-07-28",
				14.11
			],
			[
				"2010-09-20",
				19.11
			],
			[
				"2010-10-28",
				15.31
			],
			[
				"2011-03-28",
				14.61
			],
			[
				"2011-05-04",
				15.71
			],
			[
				"2011-10-11",
				22.31
			],
			[
				"2012-03-22",
				13.6
			],
			[
				"2012-04-25",
				11.8
			],
			[
				"2012-09-19",
				14.51
			],
			[
				"2012-11-07",
				12.7
			],
			[
				"2013-03-20",
				13
			],
			[
				"2013-09-25",
				15.51
			],
			[
				"2013-10-24",
				15.71
			],
			[
				"2014-03-17",
				11
			],
			[
				"2014-09-18",
				12.8
			],
			[
				"2008-04-17",
				13.3
			],
			[
				"2008-10-29",
				12.68
			],
			[
				"2009-07-02",
				14.11
			],
			[
				"2009-09-23",
				14.41
			],
			[
				"2009-11-18",
				13.8
			],
			[
				"2000-11-23",
				23.01
			],
			[
				"2003-06-26",
				16.91
			]
		],
		"42065264": [
			[
				"2006-11-27",
				36.01
			],
			[
				"2007-06-04",
				52.02
			],
			[
				"2008-05-06",
				56.02
			],
			[
				"2009-03-06",
				34.01
			],
			[
				"2010-03-04",
				29.01
			],
			[
				"2011-01-24",
				31.01
			],
			[
				"2012-06-12",
				44.02
			],
			[
				"2013-01-24",
				47.02
			],
			[
				"2014-01-13",
				43.02
			],
			[
				"2015-12-09",
				45.02
			],
			[
				"2010-06-24",
				48.02
			],
			[
				"2011-07-13",
				40.01
			],
			[
				"2011-11-28",
				41.01
			],
			[
				"2012-11-21",
				59.02
			],
			[
				"2013-06-20",
				51.02
			],
			[
				"2013-11-19",
				47.02
			],
			[
				"2014-06-17",
				46.02
			],
			[
				"2006-05-18",
				54.02
			],
			[
				"2007-11-27",
				44.02
			],
			[
				"2008-12-03",
				43.02
			],
			[
				"2000-11-29",
				35.01
			],
			[
				"2003-08-12",
				63.02
			]
		],
		"42065343": [
			[
				"2006-05-16",
				86.03
			],
			[
				"2006-05-16",
				86.03
			],
			[
				"2008-01-15",
				78.03
			],
			[
				"2008-05-07",
				44.02
			],
			[
				"2009-03-03",
				22.01
			],
			[
				"2010-03-03",
				52.02
			],
			[
				"2011-02-01",
				66.02
			],
			[
				"2012-02-09",
				60.02
			],
			[
				"2013-01-28",
				72.03
			],
			[
				"2014-01-15",
				65.02
			],
			[
				"2015-12-03",
				54.02
			],
			[
				"2010-07-28",
				48.02
			],
			[
				"2000-11-23",
				63.02
			],
			[
				"2003-07-30",
				94.03
			]
		],
		"42065367": [
			[
				"2006-11-30",
				16.11
			],
			[
				"2007-06-05",
				19.41
			],
			[
				"2008-05-05",
				22.01
			],
			[
				"2009-03-26",
				22.01
			],
			[
				"2010-03-02",
				15.41
			],
			[
				"2011-01-28",
				14.61
			],
			[
				"2012-06-05",
				17.61
			],
			[
				"2013-01-23",
				8.2
			],
			[
				"2014-01-20",
				10.3
			],
			[
				"2015-11-11",
				12
			],
			[
				"2006-05-30",
				19.91
			],
			[
				"2000-08-24",
				22.01
			],
			[
				"2003-06-24",
				17.81
			]
		],
		"42065604": [
			[
				"2006-11-28",
				8.9
			],
			[
				"2007-06-04",
				11.9
			],
			[
				"2008-05-06",
				7.8
			],
			[
				"2009-02-27",
				8.6
			],
			[
				"2010-03-04",
				9.1
			],
			[
				"2011-01-31",
				11.2
			],
			[
				"2012-06-12",
				25.81
			],
			[
				"2013-01-29",
				23.61
			],
			[
				"2014-01-14",
				16.31
			],
			[
				"2015-12-14",
				11
			],
			[
				"2006-05-22",
				6.1
			],
			[
				"2000-11-17",
				7.3
			],
			[
				"2003-06-24",
				13.2
			]
		],
		"47077062": [
			[
				"2009-05-26",
				10.2
			],
			[
				"2008-11-18",
				6.7
			],
			[
				"2008-05-15",
				11.3
			],
			[
				"2000-05-24",
				14
			],
			[
				"2000-12-13",
				15.41
			],
			[
				"2001-05-08",
				12.4
			],
			[
				"2001-11-15",
				11.1
			],
			[
				"2002-08-07",
				12
			],
			[
				"2003-05-12",
				8.7
			],
			[
				"2003-11-06",
				9
			],
			[
				"2004-06-23",
				8.3
			],
			[
				"2004-11-30",
				8.4
			],
			[
				"2005-05-09",
				9.2
			],
			[
				"2005-11-10",
				10.9
			],
			[
				"2006-06-08",
				9.9
			],
			[
				"2006-11-06",
				9.8
			],
			[
				"2007-05-10",
				9.1
			],
			[
				"2010-05-17",
				8.9
			],
			[
				"2011-05-25",
				10.4
			],
			[
				"2010-11-10",
				11.6
			],
			[
				"2011-11-23",
				12
			],
			[
				"2013-11-20",
				10.6
			],
			[
				"2013-05-22",
				9.6
			],
			[
				"2012-11-21",
				9.5
			],
			[
				"2012-05-14",
				10.8
			],
			[
				"2014-05-14",
				9.6
			],
			[
				"2014-11-17",
				12.6
			],
			[
				"2015-11-11",
				10.2
			],
			[
				"2015-05-13",
				12.9
			]
		],
		"47200066": [
			[
				"2008-05-27",
				19.81
			],
			[
				"2008-10-21",
				19.81
			],
			[
				"2009-05-12",
				19.91
			],
			[
				"2009-10-27",
				19.61
			],
			[
				"2010-05-18",
				18.01
			],
			[
				"2001-04-04",
				20.01
			],
			[
				"2001-10-10",
				17.01
			],
			[
				"2000-04-18",
				17.01
			],
			[
				"2000-10-17",
				16.01
			],
			[
				"2002-04-11",
				16.01
			],
			[
				"2002-10-17",
				19.01
			],
			[
				"2003-07-16",
				20.01
			],
			[
				"2003-10-22",
				19.01
			],
			[
				"2004-05-05",
				19.01
			],
			[
				"2004-10-19",
				20.61
			],
			[
				"2005-05-10",
				18.81
			],
			[
				"2005-10-12",
				20.91
			],
			[
				"2006-05-11",
				19.31
			],
			[
				"2006-10-11",
				20.01
			],
			[
				"2007-05-08",
				20.21
			],
			[
				"2007-10-09",
				17.41
			],
			[
				"2010-10-27",
				19.91
			],
			[
				"2011-05-25",
				16.51
			],
			[
				"2011-10-25",
				19.71
			],
			[
				"2012-05-22",
				20.81
			],
			[
				"2012-11-13",
				21.11
			],
			[
				"2013-05-14",
				20.31
			],
			[
				"2013-10-30",
				27.31
			],
			[
				"2014-05-06",
				22.51
			],
			[
				"2014-09-23",
				21.11
			],
			[
				"2015-04-21",
				20.51
			],
			[
				"2015-09-08",
				24.41
			]
		],
		"47202063": [
			[
				"2008-05-28",
				12.7
			],
			[
				"2008-10-22",
				14.2
			],
			[
				"2008-11-27",
				11.6
			],
			[
				"2009-05-13",
				14.2
			],
			[
				"2009-10-28",
				13.8
			],
			[
				"2010-05-19",
				13.1
			],
			[
				"2001-10-11",
				11
			],
			[
				"2000-10-19",
				8
			],
			[
				"2001-04-05",
				11
			],
			[
				"2002-04-11",
				12
			],
			[
				"2002-10-17",
				12
			],
			[
				"2004-05-05",
				7.6
			],
			[
				"2004-10-20",
				10.5
			],
			[
				"2005-05-11",
				4.9
			],
			[
				"2006-01-31",
				5.5
			],
			[
				"2006-10-11",
				12
			],
			[
				"2007-05-09",
				10.8
			],
			[
				"2007-10-10",
				10.8
			],
			[
				"2010-10-28",
				12.5
			],
			[
				"2011-05-25",
				11.4
			],
			[
				"2011-10-26",
				11.1
			],
			[
				"2012-05-23",
				11.3
			],
			[
				"2012-11-14",
				10.5
			],
			[
				"2013-05-15",
				8.7
			],
			[
				"2013-10-30",
				4.1
			],
			[
				"2014-05-07",
				11.2
			],
			[
				"2014-09-24",
				10.4
			],
			[
				"2015-04-22",
				10.6
			],
			[
				"2015-09-09",
				10.1
			]
		],
		"59110168": [
			[
				"2000-08-29",
				46.94
			],
			[
				"2001-04-25",
				48.71
			],
			[
				"2002-07-15",
				46.5
			],
			[
				"2003-05-09",
				47.39
			],
			[
				"2004-05-11",
				48.71
			],
			[
				"2005-04-21",
				47.39
			],
			[
				"2006-03-20",
				37.64
			],
			[
				"2006-08-07",
				38.53
			],
			[
				"2007-03-22",
				36.31
			],
			[
				"2008-03-03",
				37.2
			],
			[
				"2013-06-07",
				26.44
			],
			[
				"2014-08-06",
				25.42
			],
			[
				"2015-06-17",
				27.68
			],
			[
				"2009-05-20",
				32.77
			],
			[
				"2010-04-23",
				30.56
			],
			[
				"2011-07-20",
				31
			]
		],
		"59110302": [
			[
				"2000-07-04",
				39.41
			],
			[
				"2001-05-03",
				34.99
			],
			[
				"2002-05-08",
				36.76
			],
			[
				"2003-04-07",
				37.64
			],
			[
				"2004-03-10",
				36.31
			],
			[
				"2005-02-24",
				34.1
			],
			[
				"2006-02-10",
				34.54
			],
			[
				"2007-03-09",
				31
			],
			[
				"2008-02-25",
				33.66
			],
			[
				"2013-06-27",
				34.54
			],
			[
				"2014-03-26",
				31.53
			],
			[
				"2015-05-06",
				30.07
			],
			[
				"2009-06-16",
				33.66
			],
			[
				"2010-04-23",
				32.33
			],
			[
				"2011-04-05",
				34.99
			],
			[
				"2012-08-14",
				33.21
			]
		],
		"59110340": [
			[
				"2006-03-21",
				18.16
			],
			[
				"2007-08-27",
				15.94
			],
			[
				"2008-03-03",
				16.39
			],
			[
				"2013-06-27",
				12.49
			],
			[
				"2014-08-06",
				11.87
			],
			[
				"2015-08-04",
				9.7
			],
			[
				"2009-06-29",
				16.39
			],
			[
				"2010-04-28",
				15.5
			],
			[
				"2011-07-20",
				11.07
			]
		],
		"59110363": [
			[
				"2013-09-04",
				2.86
			],
			[
				"2015-06-17",
				5.27
			],
			[
				"2011-10-27",
				5.76
			]
		],
		"59130015": [
			[
				"2000-05-08",
				2.21
			],
			[
				"2001-07-03",
				2.21
			],
			[
				"2002-04-26",
				2.21
			],
			[
				"2003-04-02",
				2.21
			],
			[
				"2004-06-29",
				2.21
			],
			[
				"2005-04-14",
				2.21
			],
			[
				"2006-03-02",
				2.21
			],
			[
				"2007-04-17",
				2.21
			],
			[
				"2010-02-02",
				0.89
			],
			[
				"2010-05-05",
				0.8
			],
			[
				"2010-08-10",
				1.02
			],
			[
				"2010-11-02",
				0.71
			],
			[
				"2011-02-01",
				0.89
			],
			[
				"2011-05-03",
				1.68
			],
			[
				"2011-08-02",
				0.09
			],
			[
				"2011-11-09",
				0.49
			],
			[
				"2012-02-14",
				0.71
			],
			[
				"2012-05-08",
				0.89
			],
			[
				"2012-08-08",
				1.02
			],
			[
				"2012-11-13",
				0.62
			],
			[
				"2013-02-05",
				0.49
			],
			[
				"2013-05-07",
				0.8
			],
			[
				"2013-08-06",
				0.71
			],
			[
				"2013-11-05",
				0.09
			],
			[
				"2013-06-20",
				1.33
			],
			[
				"2014-09-30",
				1.33
			],
			[
				"2015-10-20",
				1.33
			],
			[
				"2009-05-20",
				4.43
			],
			[
				"2010-05-10",
				4.43
			],
			[
				"2011-07-22",
				4.43
			]
		],
		"59130179": [
			[
				"2000-04-20",
				11.96
			],
			[
				"2000-11-13",
				10.63
			],
			[
				"2001-05-11",
				10.63
			],
			[
				"2002-09-24",
				15.94
			],
			[
				"2003-03-05",
				4.1
			],
			[
				"2003-09-02",
				3.6
			],
			[
				"2004-03-09",
				1.59
			],
			[
				"2004-09-14",
				15.94
			],
			[
				"2006-08-08",
				6.64
			],
			[
				"2005-03-24",
				11.96
			],
			[
				"2005-09-13",
				11.07
			],
			[
				"2007-04-17",
				8.41
			],
			[
				"2008-03-20",
				2.66
			],
			[
				"2010-03-26",
				2.48
			],
			[
				"2010-09-21",
				1.2
			],
			[
				"2011-03-11",
				1.5
			],
			[
				"2011-09-28",
				1.2
			],
			[
				"2011-12-01",
				1.4
			],
			[
				"2012-03-22",
				1
			],
			[
				"2012-09-25",
				2.4
			],
			[
				"2013-06-20",
				1.33
			],
			[
				"2014-09-01",
				1.33
			],
			[
				"2015-06-23",
				1.33
			],
			[
				"2007-04-02",
				5.7
			],
			[
				"2007-10-09",
				8
			],
			[
				"2008-03-18",
				3.7
			],
			[
				"2008-09-01",
				1.1
			],
			[
				"2009-08-10",
				4.43
			],
			[
				"2010-05-10",
				4.43
			],
			[
				"2011-07-22",
				4.43
			]
		],
		"59130430": [
			[
				"2006-08-08",
				2.21
			],
			[
				"2007-04-18",
				2.21
			],
			[
				"2008-03-04",
				2.21
			],
			[
				"2013-06-12",
				1.33
			],
			[
				"2014-07-28",
				1.33
			],
			[
				"2015-06-08",
				1.33
			],
			[
				"2009-06-30",
				4.43
			],
			[
				"2010-05-03",
				4.43
			],
			[
				"2011-07-19",
				4.43
			]
		],
		"59130441": [
			[
				"2001-07-05",
				27.46
			],
			[
				"2002-07-05",
				28.79
			],
			[
				"2003-09-26",
				45.61
			],
			[
				"2004-09-21",
				31.44
			],
			[
				"2005-04-20",
				48.71
			],
			[
				"2007-03-29",
				37.64
			],
			[
				"2008-04-07",
				29.23
			],
			[
				"2013-06-17",
				34.23
			],
			[
				"2014-08-04",
				35.3
			],
			[
				"2015-06-08",
				31.49
			],
			[
				"2009-08-05",
				25.69
			],
			[
				"2010-06-21",
				33.21
			],
			[
				"2011-08-19",
				46.5
			]
		],
		"59130465": [
			[
				"2006-08-09",
				2.21
			],
			[
				"2007-04-18",
				6.2
			],
			[
				"2008-03-04",
				4.87
			],
			[
				"2013-06-12",
				12
			],
			[
				"2014-08-05",
				12
			],
			[
				"2015-10-26",
				9.17
			],
			[
				"2009-06-30",
				4.43
			],
			[
				"2010-05-03",
				4.43
			],
			[
				"2011-07-19",
				4.43
			]
		],
		"59130556": [
			[
				"2000-05-15",
				6.64
			],
			[
				"2002-05-07",
				22.59
			],
			[
				"2003-03-28",
				2.21
			],
			[
				"2004-07-08",
				2.21
			],
			[
				"2005-04-20",
				4.87
			],
			[
				"2007-04-02",
				2.21
			],
			[
				"2008-03-05",
				2.21
			],
			[
				"2013-06-17",
				1.33
			],
			[
				"2014-08-04",
				1.33
			],
			[
				"2015-06-22",
				1.33
			],
			[
				"2010-05-11",
				4.43
			],
			[
				"2011-08-19",
				7.53
			]
		],
		"59130570": [
			[
				"2006-08-09",
				2.21
			],
			[
				"2007-04-18",
				2.21
			],
			[
				"2008-03-04",
				2.21
			],
			[
				"2013-06-12",
				1.33
			],
			[
				"2014-08-05",
				1.33
			],
			[
				"2015-07-07",
				1.33
			],
			[
				"2009-06-30",
				4.43
			],
			[
				"2010-05-03",
				4.43
			],
			[
				"2011-07-19",
				4.43
			]
		],
		"59130581": [
			[
				"2004-09-21",
				2.21
			],
			[
				"2005-04-20",
				3.54
			],
			[
				"2007-04-02",
				2.21
			],
			[
				"2008-03-05",
				2.21
			],
			[
				"2013-06-17",
				1.33
			],
			[
				"2014-09-01",
				1.33
			],
			[
				"2015-10-21",
				1.33
			],
			[
				"2009-08-05",
				4.43
			],
			[
				"2010-06-21",
				4.43
			],
			[
				"2011-08-19",
				4.43
			]
		],
		"59130600": [
			[
				"2000-05-09",
				2.21
			],
			[
				"2001-05-04",
				2.21
			],
			[
				"2002-06-20",
				2.21
			],
			[
				"2003-04-04",
				2.21
			],
			[
				"2004-06-28",
				2.21
			],
			[
				"2005-03-30",
				2.21
			],
			[
				"2006-03-01",
				2.21
			],
			[
				"2006-08-10",
				2.21
			],
			[
				"2007-03-27",
				2.21
			],
			[
				"2008-03-06",
				2.21
			],
			[
				"2013-06-24",
				1.33
			],
			[
				"2014-08-19",
				1.33
			],
			[
				"2015-06-22",
				1.33
			],
			[
				"2009-05-18",
				4.43
			],
			[
				"2010-05-11",
				4.43
			],
			[
				"2011-08-23",
				4.43
			]
		],
		"59130660": [
			[
				"2000-05-15",
				2.21
			],
			[
				"2001-04-27",
				2.21
			],
			[
				"2002-07-05",
				2.21
			],
			[
				"2003-09-26",
				2.21
			],
			[
				"2004-03-11",
				2.21
			],
			[
				"2005-04-18",
				2.21
			],
			[
				"2006-02-20",
				2.21
			],
			[
				"2006-08-09",
				2.21
			],
			[
				"2007-04-02",
				2.21
			],
			[
				"2008-03-05",
				2.21
			],
			[
				"2014-07-28",
				1.5
			],
			[
				"2015-03-24",
				1.33
			],
			[
				"2009-05-18",
				6.2
			],
			[
				"2010-07-21",
				4.43
			],
			[
				"2011-09-26",
				4.43
			],
			[
				"2012-08-14",
				1.33
			]
		],
		"59130714": [
			[
				"2006-08-17",
				25.69
			],
			[
				"2007-04-27",
				27.9
			],
			[
				"2008-04-01",
				29.67
			],
			[
				"2014-10-08",
				27.55
			],
			[
				"2015-10-26",
				20.15
			],
			[
				"2009-07-01",
				26.13
			],
			[
				"2010-06-21",
				23.91
			],
			[
				"2011-10-27",
				25.69
			]
		],
		"59130726": [
			[
				"2006-08-17",
				2.21
			],
			[
				"2007-10-16",
				2.21
			],
			[
				"2008-04-01",
				4.87
			],
			[
				"2014-10-08",
				1.33
			],
			[
				"2015-07-07",
				1.33
			],
			[
				"2009-07-01",
				4.43
			],
			[
				"2010-04-29",
				4.43
			],
			[
				"2011-08-23",
				4.43
			]
		],
		"59140185": [
			[
				"2000-08-18",
				28.79
			],
			[
				"2001-04-02",
				29.67
			],
			[
				"2002-04-16",
				30.56
			],
			[
				"2003-03-26",
				21.26
			],
			[
				"2004-04-29",
				30.11
			],
			[
				"2005-02-10",
				27.46
			],
			[
				"2006-02-06",
				21.7
			],
			[
				"2007-05-03",
				23.03
			],
			[
				"2008-03-11",
				20.81
			],
			[
				"2013-06-10",
				30.51
			],
			[
				"2014-08-13",
				33.79
			],
			[
				"2015-04-20",
				32.28
			],
			[
				"2009-05-11",
				24.8
			],
			[
				"2010-06-29",
				19.49
			],
			[
				"2011-07-18",
				25.69
			],
			[
				"2011-10-24",
				26.57
			]
		],
		"59140288": [
			[
				"2000-05-30",
				57.57
			],
			[
				"2001-03-19",
				55.36
			],
			[
				"2002-04-16",
				60.23
			],
			[
				"2003-03-26",
				58.46
			],
			[
				"2004-02-24",
				51.81
			],
			[
				"2005-02-16",
				50.49
			],
			[
				"2006-07-13",
				48.71
			],
			[
				"2007-04-27",
				38.97
			],
			[
				"2008-04-22",
				49.6
			],
			[
				"2013-06-10",
				41.01
			],
			[
				"2014-03-26",
				38.84
			],
			[
				"2015-03-23",
				45.61
			],
			[
				"2009-05-11",
				44.29
			],
			[
				"2010-04-30",
				41.63
			],
			[
				"2011-04-04",
				46.06
			],
			[
				"2012-08-14",
				42.07
			]
		],
		"59140331": [
			[
				"2005-03-15",
				14.17
			],
			[
				"2005-07-25",
				13.29
			],
			[
				"2006-03-30",
				13.73
			],
			[
				"2006-08-22",
				11.96
			],
			[
				"2007-07-04",
				11.96
			],
			[
				"2008-04-23",
				12.84
			],
			[
				"2014-10-21",
				11.2
			],
			[
				"2015-06-24",
				11.69
			],
			[
				"2009-07-21",
				12.84
			],
			[
				"2010-06-29",
				13.73
			],
			[
				"2011-10-24",
				12.84
			]
		],
		"59160068": [
			[
				"2000-09-11",
				2.21
			],
			[
				"2001-07-04",
				2.21
			],
			[
				"2003-07-07",
				2.21
			],
			[
				"2004-05-11",
				2.21
			],
			[
				"2005-04-07",
				2.21
			],
			[
				"2006-03-14",
				2.21
			],
			[
				"2007-04-16",
				2.21
			],
			[
				"2008-05-06",
				2.21
			],
			[
				"2013-06-18",
				1.33
			],
			[
				"2014-09-22",
				1.33
			],
			[
				"2015-06-15",
				1.33
			],
			[
				"2009-09-14",
				4.43
			],
			[
				"2010-07-16",
				4.43
			],
			[
				"2011-08-29",
				4.43
			]
		],
		"59160093": [
			[
				"2000-07-03",
				2.21
			],
			[
				"2001-10-26",
				2.21
			],
			[
				"2002-09-23",
				2.21
			],
			[
				"2004-05-11",
				2.21
			],
			[
				"2005-04-07",
				2.21
			],
			[
				"2006-02-23",
				2.21
			],
			[
				"2007-03-16",
				2.21
			],
			[
				"2008-03-07",
				2.21
			],
			[
				"2013-06-19",
				1.33
			],
			[
				"2014-09-22",
				1.33
			],
			[
				"2015-06-15",
				1.33
			],
			[
				"2009-08-04",
				4.43
			],
			[
				"2010-05-05",
				4.43
			],
			[
				"2011-08-29",
				4.43
			]
		],
		"59160123": [
			[
				"2000-07-03",
				2.21
			],
			[
				"2001-05-28",
				2.21
			],
			[
				"2002-06-14",
				2.21
			],
			[
				"2003-11-17",
				2.21
			],
			[
				"2004-09-22",
				2.21
			],
			[
				"2005-04-12",
				2.21
			],
			[
				"2006-03-08",
				2.21
			],
			[
				"2006-08-11",
				2.21
			],
			[
				"2007-04-19",
				2.21
			],
			[
				"2008-04-02",
				2.21
			],
			[
				"2013-06-24",
				1.33
			],
			[
				"2015-10-19",
				1.33
			],
			[
				"2010-05-05",
				4.43
			],
			[
				"2011-08-31",
				4.43
			]
		],
		"59160147": [
			[
				"2000-05-23",
				5.31
			],
			[
				"2001-08-08",
				2.21
			],
			[
				"2002-08-26",
				2.21
			],
			[
				"2003-07-11",
				2.21
			],
			[
				"2004-05-07",
				3.1
			],
			[
				"2005-04-12",
				2.21
			],
			[
				"2006-03-08",
				2.21
			],
			[
				"2007-04-19",
				2.21
			],
			[
				"2008-04-02",
				2.21
			],
			[
				"2013-06-19",
				3.01
			],
			[
				"2014-09-24",
				1.33
			],
			[
				"2015-06-09",
				1.33
			],
			[
				"2009-08-04",
				5.31
			],
			[
				"2010-05-05",
				4.43
			],
			[
				"2011-08-31",
				4.43
			]
		],
		"59160184": [
			[
				"2000-09-11",
				4.87
			],
			[
				"2001-08-20",
				6.2
			],
			[
				"2002-06-25",
				5.31
			],
			[
				"2003-07-04",
				5.31
			],
			[
				"2004-07-09",
				5.76
			],
			[
				"2005-04-27",
				4.87
			],
			[
				"2006-03-23",
				4.87
			],
			[
				"2006-08-11",
				6.64
			],
			[
				"2007-07-30",
				3.99
			],
			[
				"2008-06-20",
				3.54
			],
			[
				"2013-06-18",
				4.92
			],
			[
				"2014-09-24",
				5.14
			],
			[
				"2015-06-09",
				4.31
			],
			[
				"2009-06-29",
				6.2
			],
			[
				"2010-04-28",
				4.43
			],
			[
				"2011-08-31",
				4.43
			]
		],
		"59540187": [
			[
				"2000-07-04",
				2.66
			],
			[
				"2001-09-05",
				2.21
			],
			[
				"2002-05-15",
				3.99
			],
			[
				"2003-07-22",
				2.21
			],
			[
				"2004-04-27",
				2.66
			],
			[
				"2005-02-23",
				2.66
			],
			[
				"2006-03-22",
				2.21
			],
			[
				"2006-08-11",
				2.21
			],
			[
				"2007-03-02",
				6.2
			],
			[
				"2008-02-26",
				2.21
			],
			[
				"2013-08-02",
				1.33
			],
			[
				"2014-03-28",
				1.33
			],
			[
				"2015-03-24",
				1.33
			],
			[
				"2009-06-17",
				4.43
			],
			[
				"2010-05-27",
				4.43
			],
			[
				"2011-04-05",
				4.43
			],
			[
				"2012-07-25",
				1.33
			]
		],
		"59540308": [
			[
				"2000-09-08",
				85.91
			],
			[
				"2001-08-17",
				93
			],
			[
				"2003-07-22",
				56.24
			],
			[
				"2004-07-20",
				78.83
			],
			[
				"2005-04-22",
				36.76
			],
			[
				"2006-03-10",
				54.47
			],
			[
				"2007-04-04",
				20.37
			],
			[
				"2008-03-14",
				21.26
			],
			[
				"2013-06-07",
				29.49
			],
			[
				"2014-08-12",
				42.91
			],
			[
				"2015-08-18",
				46.94
			],
			[
				"2009-07-03",
				53.59
			],
			[
				"2010-07-21",
				56.69
			],
			[
				"2011-09-30",
				49.6
			]
		],
		"59540515": [
			[
				"2000-09-12",
				2.66
			],
			[
				"2001-05-18",
				6.2
			],
			[
				"2002-06-17",
				10.19
			],
			[
				"2003-06-30",
				2.21
			],
			[
				"2004-07-20",
				4.87
			],
			[
				"2005-06-15",
				3.1
			],
			[
				"2006-03-21",
				2.21
			],
			[
				"2007-07-16",
				2.66
			],
			[
				"2008-03-14",
				5.31
			],
			[
				"2013-06-06",
				1.72
			],
			[
				"2014-08-11",
				2.98
			],
			[
				"2015-06-16",
				6.86
			],
			[
				"2009-07-03",
				4.43
			],
			[
				"2010-05-19",
				7.09
			],
			[
				"2011-07-18",
				4.43
			]
		],
		"59540564": [
			[
				"2000-08-24",
				2.21
			],
			[
				"2001-06-13",
				2.21
			],
			[
				"2002-05-06",
				2.21
			],
			[
				"2003-05-23",
				2.21
			],
			[
				"2004-05-04",
				2.21
			],
			[
				"2005-04-22",
				2.21
			],
			[
				"2006-03-20",
				2.21
			],
			[
				"2007-03-22",
				2.21
			],
			[
				"2008-04-17",
				2.21
			],
			[
				"2013-06-06",
				1.33
			],
			[
				"2014-10-22",
				1.33
			],
			[
				"2015-10-19",
				1.33
			],
			[
				"2009-07-02",
				4.43
			],
			[
				"2010-05-19",
				4.43
			],
			[
				"2011-09-26",
				4.43
			]
		],
		"59540576": [
			[
				"2000-05-03",
				2.21
			],
			[
				"2001-06-13",
				2.21
			],
			[
				"2002-06-12",
				2.21
			],
			[
				"2004-02-25",
				2.21
			],
			[
				"2004-09-29",
				2.21
			],
			[
				"2005-02-23",
				2.21
			],
			[
				"2005-06-01",
				2.21
			],
			[
				"2005-06-17",
				2.21
			],
			[
				"2006-02-08",
				2.21
			],
			[
				"2007-03-02",
				2.21
			],
			[
				"2008-04-17",
				2.21
			],
			[
				"2013-09-04",
				1.33
			],
			[
				"2014-10-22",
				1.33
			],
			[
				"2015-05-06",
				1.33
			],
			[
				"2003-07-15",
				2.21
			],
			[
				"2009-06-17",
				4.43
			],
			[
				"2010-05-27",
				4.43
			],
			[
				"2011-04-29",
				4.43
			],
			[
				"2012-07-25",
				1.33
			]
		],
		"59540606": [
			[
				"2000-07-04",
				11.07
			],
			[
				"2001-05-18",
				16.83
			],
			[
				"2002-05-15",
				13.29
			],
			[
				"2003-06-24",
				2.21
			],
			[
				"2004-07-28",
				2.21
			],
			[
				"2005-06-17",
				2.21
			],
			[
				"2006-08-10",
				2.21
			],
			[
				"2007-08-31",
				2.21
			],
			[
				"2008-06-24",
				2.21
			],
			[
				"2013-06-10",
				1.33
			],
			[
				"2015-04-20",
				1.33
			],
			[
				"2009-07-02",
				4.43
			],
			[
				"2010-07-27",
				4.43
			],
			[
				"2011-08-30",
				4.43
			],
			[
				"2012-07-25",
				1.33
			]
		],
		"59540618": [
			[
				"2000-09-01",
				25.24
			],
			[
				"2001-04-02",
				42.96
			],
			[
				"2002-06-17",
				20.37
			],
			[
				"2003-06-24",
				21.26
			],
			[
				"2004-07-19",
				32.77
			],
			[
				"2005-07-07",
				25.24
			],
			[
				"2006-04-24",
				31.44
			],
			[
				"2007-03-28",
				35.87
			],
			[
				"2007-05-04",
				34.1
			],
			[
				"2008-03-19",
				34.1
			],
			[
				"2013-06-14",
				17.67
			],
			[
				"2014-08-26",
				32.59
			],
			[
				"2015-08-04",
				35.34
			],
			[
				"2009-09-14",
				23.03
			],
			[
				"2010-07-22",
				12.4
			],
			[
				"2011-08-30",
				27.9
			]
		],
		"59540643": [
			[
				"2000-11-27",
				6.2
			],
			[
				"2001-06-01",
				4.87
			],
			[
				"2002-04-29",
				4.43
			],
			[
				"2003-09-19",
				6.64
			],
			[
				"2004-02-16",
				6.64
			],
			[
				"2005-02-23",
				7.53
			],
			[
				"2006-02-08",
				5.76
			],
			[
				"2006-08-10",
				5.31
			],
			[
				"2007-03-02",
				6.2
			],
			[
				"2008-02-26",
				3.1
			],
			[
				"2013-06-26",
				2.88
			],
			[
				"2014-07-15",
				1.89
			],
			[
				"2015-03-23",
				4
			],
			[
				"2009-06-17",
				6.64
			],
			[
				"2010-05-27",
				6.64
			],
			[
				"2011-04-05",
				8.86
			],
			[
				"2012-07-23",
				3.1
			]
		],
		"59540734": [
			[
				"2002-04-29",
				39.86
			],
			[
				"2003-09-19",
				18.6
			],
			[
				"2004-02-25",
				18.6
			],
			[
				"2005-02-23",
				19.93
			],
			[
				"2006-02-08",
				35.87
			],
			[
				"2007-03-02",
				34.54
			],
			[
				"2008-02-26",
				29.67
			],
			[
				"2013-06-25",
				30.2
			],
			[
				"2014-07-08",
				17.45
			],
			[
				"2015-03-23",
				31
			],
			[
				"2009-06-17",
				25.24
			],
			[
				"2010-05-27",
				26.13
			],
			[
				"2011-04-05",
				27.9
			],
			[
				"2012-07-23",
				28.34
			]
		],
		"59540837": [
			[
				"2005-08-30",
				15.5
			],
			[
				"2006-03-22",
				16.83
			],
			[
				"2007-04-20",
				16.83
			],
			[
				"2008-06-24",
				15.06
			],
			[
				"2013-06-26",
				16.12
			],
			[
				"2014-07-08",
				14.61
			],
			[
				"2015-05-06",
				16.83
			],
			[
				"2009-07-03",
				20.81
			],
			[
				"2010-07-22",
				15.5
			],
			[
				"2011-08-30",
				16.39
			],
			[
				"2012-07-23",
				17.27
			]
		],
		"59620079": [
			[
				"2000-05-03",
				11.96
			],
			[
				"2001-06-20",
				13.29
			],
			[
				"2001-10-23",
				12.84
			],
			[
				"2002-05-31",
				12.84
			],
			[
				"2004-02-05",
				12.4
			],
			[
				"2004-09-28",
				12.84
			],
			[
				"2005-05-31",
				13.29
			],
			[
				"2006-02-14",
				12.4
			],
			[
				"2007-02-28",
				11.51
			],
			[
				"2007-07-13",
				12.4
			],
			[
				"2008-01-31",
				12.4
			],
			[
				"2013-06-21",
				12.75
			],
			[
				"2014-07-07",
				11.69
			],
			[
				"2015-03-30",
				12.13
			],
			[
				"2003-07-16",
				13.73
			],
			[
				"2009-06-25",
				16.83
			],
			[
				"2010-05-11",
				13.73
			],
			[
				"2011-04-04",
				13.29
			],
			[
				"2012-07-31",
				12.84
			]
		],
		"59620092": [
			[
				"2007-07-19",
				11.51
			],
			[
				"2008-06-25",
				11.51
			],
			[
				"2013-08-28",
				13.24
			],
			[
				"2014-07-15",
				12.22
			],
			[
				"2015-04-08",
				12.13
			],
			[
				"2009-07-09",
				12.4
			],
			[
				"2010-04-30",
				11.51
			],
			[
				"2011-09-05",
				12.84
			],
			[
				"2012-08-08",
				13.29
			]
		],
		"59620109": [
			[
				"2000-07-05",
				18.6
			],
			[
				"2001-06-12",
				17.27
			],
			[
				"2002-05-16",
				17.27
			],
			[
				"2003-05-13",
				17.71
			],
			[
				"2004-03-02",
				23.03
			],
			[
				"2005-03-14",
				14.61
			],
			[
				"2006-02-28",
				18.6
			],
			[
				"2006-08-15",
				21.7
			],
			[
				"2007-04-05",
				18.6
			],
			[
				"2008-04-18",
				19.93
			],
			[
				"2015-12-07",
				16.01
			],
			[
				"2013-08-28",
				16.61
			],
			[
				"2014-07-07",
				18.25
			],
			[
				"2015-03-30",
				16.39
			],
			[
				"2009-08-18",
				19.93
			],
			[
				"2010-07-29",
				19.93
			],
			[
				"2011-09-09",
				10.19
			],
			[
				"2012-08-08",
				12.84
			]
		],
		"59620134": [
			[
				"2000-05-29",
				25.24
			],
			[
				"2001-06-01",
				66.43
			],
			[
				"2003-04-09",
				39.86
			],
			[
				"2004-02-25",
				35.43
			],
			[
				"2005-06-01",
				46.5
			],
			[
				"2006-03-15",
				57.13
			],
			[
				"2007-03-13",
				38.97
			],
			[
				"2008-02-27",
				46.06
			],
			[
				"2013-06-25",
				42.51
			],
			[
				"2014-07-15",
				41.67
			],
			[
				"2015-03-30",
				15.94
			],
			[
				"2009-07-09",
				44.73
			],
			[
				"2010-07-15",
				55.8
			],
			[
				"2011-09-27",
				36.31
			],
			[
				"2012-08-08",
				43.4
			]
		],
		"59620183": [
			[
				"2000-07-05",
				25.69
			],
			[
				"2001-05-31",
				33.21
			],
			[
				"2003-04-10",
				31.44
			],
			[
				"2004-03-12",
				28.79
			],
			[
				"2005-06-24",
				27.46
			],
			[
				"2006-03-28",
				25.24
			],
			[
				"2007-05-07",
				27.01
			],
			[
				"2008-05-08",
				23.91
			],
			[
				"2013-06-26",
				21.3
			],
			[
				"2014-07-07",
				18.2
			],
			[
				"2015-03-16",
				22.01
			],
			[
				"2009-06-16",
				23.91
			],
			[
				"2010-07-27",
				17.71
			],
			[
				"2011-09-02",
				19.93
			],
			[
				"2012-07-31",
				21.26
			]
		],
		"59620201": [
			[
				"2000-06-08",
				33.21
			],
			[
				"2001-06-08",
				25.24
			],
			[
				"2003-05-22",
				36.31
			],
			[
				"2004-10-04",
				15.5
			],
			[
				"2005-04-11",
				16.83
			],
			[
				"2006-03-09",
				12.4
			],
			[
				"2007-05-21",
				18.6
			],
			[
				"2008-04-25",
				28.79
			],
			[
				"2013-07-11",
				37.24
			],
			[
				"2014-10-28",
				28.96
			],
			[
				"2015-09-09",
				24.14
			],
			[
				"2009-08-03",
				23.47
			],
			[
				"2010-06-25",
				32.77
			],
			[
				"2011-09-30",
				43.84
			]
		],
		"59620213": [
			[
				"2000-08-21",
				11.07
			],
			[
				"2001-05-17",
				10.63
			],
			[
				"2002-05-24",
				10.19
			],
			[
				"2003-05-13",
				10.63
			],
			[
				"2004-02-20",
				11.07
			],
			[
				"2005-05-31",
				11.96
			],
			[
				"2006-04-26",
				13.29
			],
			[
				"2007-04-25",
				16.39
			],
			[
				"2007-09-26",
				21.26
			],
			[
				"2008-06-16",
				25.24
			],
			[
				"2013-07-11",
				16.39
			],
			[
				"2014-03-12",
				16.61
			],
			[
				"2015-03-24",
				13.51
			],
			[
				"2009-07-07",
				25.69
			],
			[
				"2010-05-07",
				23.91
			],
			[
				"2011-04-04",
				22.14
			],
			[
				"2012-07-24",
				15.06
			]
		],
		"59620249": [
			[
				"2001-05-29",
				5.31
			],
			[
				"2002-06-06",
				5.76
			],
			[
				"2003-05-26",
				6.2
			],
			[
				"2004-03-31",
				7.09
			],
			[
				"2005-06-22",
				6.64
			],
			[
				"2006-03-24",
				7.53
			],
			[
				"2007-06-27",
				7.53
			],
			[
				"2008-07-16",
				7.53
			],
			[
				"2013-09-23",
				7.57
			],
			[
				"2014-07-14",
				7.71
			],
			[
				"2015-10-06",
				8.37
			],
			[
				"2009-11-30",
				7.97
			],
			[
				"2010-07-27",
				6.2
			],
			[
				"2011-09-27",
				6.64
			],
			[
				"2012-07-31",
				7.53
			]
		],
		"59620262": [
			[
				"2000-06-07",
				9.3
			],
			[
				"2001-05-17",
				10.63
			],
			[
				"2002-05-16",
				11.51
			],
			[
				"2003-05-13",
				11.07
			],
			[
				"2004-03-12",
				11.07
			],
			[
				"2005-08-30",
				11.96
			],
			[
				"2006-03-28",
				7.97
			],
			[
				"2006-08-15",
				11.07
			],
			[
				"2007-06-04",
				8.86
			],
			[
				"2008-07-22",
				7.53
			],
			[
				"2013-08-28",
				7.79
			],
			[
				"2015-04-08",
				4.74
			],
			[
				"2009-11-26",
				7.09
			]
		],
		"59620274": [
			[
				"2001-11-09",
				34.99
			],
			[
				"2002-07-22",
				36.76
			],
			[
				"2003-10-13",
				36.31
			],
			[
				"2004-07-13",
				38.53
			],
			[
				"2004-10-20",
				37.64
			],
			[
				"2005-02-11",
				40.3
			],
			[
				"2005-07-11",
				38.97
			],
			[
				"2006-03-31",
				40.74
			],
			[
				"2006-10-17",
				38.53
			],
			[
				"2007-09-12",
				39.41
			],
			[
				"2008-04-09",
				42.51
			],
			[
				"2013-09-05",
				34.23
			],
			[
				"2014-11-20",
				34.94
			],
			[
				"2015-10-05",
				33.04
			],
			[
				"2009-06-23",
				39.41
			],
			[
				"2010-04-26",
				38.53
			],
			[
				"2011-09-02",
				32.33
			]
		],
		"59620754": [
			[
				"2000-06-07",
				20.37
			],
			[
				"2001-05-17",
				25.69
			],
			[
				"2002-05-16",
				26.13
			],
			[
				"2003-12-17",
				15.06
			],
			[
				"2004-02-20",
				31.44
			],
			[
				"2005-05-31",
				25.69
			],
			[
				"2006-03-28",
				18.16
			],
			[
				"2006-09-04",
				21.7
			],
			[
				"2007-07-19",
				20.37
			],
			[
				"2007-09-25",
				26.57
			],
			[
				"2008-06-25",
				25.69
			],
			[
				"2013-07-11",
				18.29
			],
			[
				"2014-03-12",
				24.4
			],
			[
				"2015-09-30",
				13.15
			],
			[
				"2009-07-07",
				20.37
			],
			[
				"2010-05-06",
				23.03
			],
			[
				"2011-04-29",
				21.7
			],
			[
				"2012-07-24",
				17.71
			]
		],
		"59620821": [
			[
				"2000-05-29",
				6.64
			],
			[
				"2001-05-10",
				7.09
			],
			[
				"2002-06-10",
				8.86
			],
			[
				"2003-05-07",
				7.97
			],
			[
				"2004-02-16",
				7.53
			],
			[
				"2005-02-22",
				7.53
			],
			[
				"2006-02-07",
				7.53
			],
			[
				"2006-08-14",
				7.97
			],
			[
				"2007-07-26",
				7.53
			],
			[
				"2008-02-29",
				6.64
			],
			[
				"2013-06-25",
				8.81
			],
			[
				"2014-03-12",
				8.99
			],
			[
				"2015-03-16",
				8.02
			],
			[
				"2009-08-18",
				6.64
			],
			[
				"2010-05-12",
				7.97
			],
			[
				"2011-04-29",
				10.19
			],
			[
				"2012-07-23",
				8.86
			]
		],
		"59620869": [
			[
				"2000-02-25",
				11
			],
			[
				"2000-10-05",
				15.01
			],
			[
				"2011-03-22",
				18.31
			],
			[
				"2006-09-13",
				18.79
			],
			[
				"2006-11-15",
				21.63
			],
			[
				"2007-03-27",
				19.91
			],
			[
				"2007-10-23",
				18.51
			],
			[
				"2008-03-17",
				21.31
			],
			[
				"2008-10-21",
				22.71
			],
			[
				"2009-02-16",
				23.41
			],
			[
				"2009-10-19",
				23.11
			],
			[
				"2010-03-15",
				21.81
			],
			[
				"2010-10-18",
				19.71
			],
			[
				"2011-10-18",
				14.41
			],
			[
				"2012-02-21",
				17.61
			],
			[
				"2012-11-06",
				16.61
			],
			[
				"2013-02-19",
				16.41
			],
			[
				"2013-11-05",
				18.21
			],
			[
				"2014-11-04",
				15.71
			],
			[
				"2015-02-03",
				11.5
			]
		],
		"59620870": [
			[
				"2000-10-05",
				18.01
			],
			[
				"2000-02-25",
				16.01
			],
			[
				"2011-02-08",
				17.01
			],
			[
				"2006-09-07",
				17.51
			],
			[
				"2006-11-07",
				16.25
			],
			[
				"2007-03-20",
				17.61
			],
			[
				"2007-10-16",
				17.91
			],
			[
				"2008-02-25",
				18.51
			],
			[
				"2008-10-20",
				16.41
			],
			[
				"2009-02-03",
				18.11
			],
			[
				"2009-10-06",
				16.71
			],
			[
				"2010-02-16",
				18.21
			],
			[
				"2010-10-05",
				17.01
			],
			[
				"2011-10-04",
				16.01
			],
			[
				"2012-02-07",
				16.21
			],
			[
				"2012-11-20",
				15.01
			],
			[
				"2013-02-05",
				12.8
			],
			[
				"2013-11-18",
				14.31
			],
			[
				"2014-11-03",
				14
			],
			[
				"2015-02-02",
				15.01
			]
		],
		"59620936": [
			[
				"2001-05-17",
				4.87
			],
			[
				"2002-05-16",
				6.2
			],
			[
				"2003-12-10",
				10.63
			],
			[
				"2004-02-20",
				13.29
			],
			[
				"2005-03-14",
				15.5
			],
			[
				"2006-02-28",
				18.6
			],
			[
				"2007-04-05",
				19.49
			],
			[
				"2008-04-18",
				20.81
			],
			[
				"2013-11-05",
				11.38
			],
			[
				"2014-03-12",
				10.98
			],
			[
				"2015-03-16",
				11.25
			],
			[
				"2009-08-18",
				17.27
			],
			[
				"2010-07-29",
				7.53
			],
			[
				"2011-09-09",
				11.07
			],
			[
				"2012-07-24",
				8.41
			]
		],
		"59620950": [
			[
				"2000-05-02",
				3.54
			],
			[
				"2001-09-24",
				2.21
			],
			[
				"2002-08-30",
				2.21
			],
			[
				"2003-05-07",
				2.21
			],
			[
				"2004-08-25",
				2.21
			],
			[
				"2005-03-31",
				2.21
			],
			[
				"2006-03-16",
				2.21
			],
			[
				"2007-07-17",
				2.21
			],
			[
				"2008-05-09",
				2.21
			],
			[
				"2013-06-05",
				3.4
			],
			[
				"2014-07-22",
				4.43
			],
			[
				"2015-09-07",
				3.18
			],
			[
				"2009-07-06",
				4.43
			],
			[
				"2010-07-15",
				4.43
			],
			[
				"2011-09-27",
				4.43
			]
		],
		"59620985": [
			[
				"2000-12-06",
				10.19
			],
			[
				"2001-06-06",
				10.63
			],
			[
				"2002-04-29",
				9.74
			],
			[
				"2004-09-23",
				11.96
			],
			[
				"2005-04-15",
				10.63
			],
			[
				"2006-10-16",
				12.84
			],
			[
				"2007-08-30",
				9.74
			],
			[
				"2008-05-20",
				7.97
			],
			[
				"2013-06-05",
				10.32
			],
			[
				"2015-09-07",
				8.77
			],
			[
				"2009-07-06",
				11.96
			],
			[
				"2010-07-15",
				11.07
			],
			[
				"2011-08-24",
				13.73
			]
		],
		"59620997": [
			[
				"2000-11-27",
				8.41
			],
			[
				"2001-11-19",
				7.09
			],
			[
				"2002-06-26",
				8.41
			],
			[
				"2004-08-19",
				8.41
			],
			[
				"2005-04-15",
				10.19
			],
			[
				"2006-04-11",
				9.3
			],
			[
				"2006-08-16",
				9.3
			],
			[
				"2007-05-29",
				10.63
			],
			[
				"2008-03-17",
				11.51
			],
			[
				"2013-09-23",
				10.36
			],
			[
				"2014-11-25",
				8.02
			],
			[
				"2015-08-19",
				10.5
			],
			[
				"2009-07-21",
				10.63
			],
			[
				"2010-05-12",
				10.63
			],
			[
				"2011-08-24",
				11.07
			]
		],
		"59621072": [
			[
				"2001-08-31",
				23.47
			],
			[
				"2002-06-28",
				20.37
			],
			[
				"2003-10-15",
				23.91
			],
			[
				"2004-07-12",
				21.7
			],
			[
				"2004-10-25",
				23.47
			],
			[
				"2005-02-15",
				11.96
			],
			[
				"2005-07-11",
				21.7
			],
			[
				"2006-04-06",
				15.5
			],
			[
				"2006-09-26",
				21.26
			],
			[
				"2007-07-05",
				22.59
			],
			[
				"2008-05-21",
				21.7
			],
			[
				"2015-09-08",
				25.33
			]
		],
		"59621151": [
			[
				"2000-10-30",
				8.86
			],
			[
				"2001-09-10",
				34.1
			],
			[
				"2002-07-10",
				32.77
			],
			[
				"2004-09-30",
				32.33
			],
			[
				"2004-11-26",
				33.21
			],
			[
				"2005-03-23",
				31
			],
			[
				"2005-08-29",
				30.56
			],
			[
				"2006-03-13",
				33.21
			],
			[
				"2006-10-12",
				34.1
			],
			[
				"2007-09-17",
				31.89
			],
			[
				"2008-04-30",
				29.23
			],
			[
				"2013-09-05",
				18.47
			],
			[
				"2014-12-02",
				31.18
			],
			[
				"2015-10-07",
				30.29
			],
			[
				"2009-07-07",
				31.89
			],
			[
				"2010-05-06",
				29.23
			],
			[
				"2011-08-22",
				31.89
			]
		],
		"59621175": [
			[
				"2000-07-05",
				2.21
			],
			[
				"2001-09-05",
				2.21
			],
			[
				"2002-07-02",
				2.21
			],
			[
				"2003-07-25",
				2.66
			],
			[
				"2004-07-26",
				2.21
			],
			[
				"2004-10-27",
				2.21
			],
			[
				"2005-03-23",
				8.41
			],
			[
				"2005-08-03",
				2.21
			],
			[
				"2006-04-12",
				7.53
			],
			[
				"2007-09-13",
				5.76
			],
			[
				"2008-05-21",
				2.66
			],
			[
				"2014-11-10",
				1.33
			],
			[
				"2015-04-08",
				1.9
			],
			[
				"2009-06-25",
				4.87
			],
			[
				"2010-07-29",
				4.43
			],
			[
				"2011-08-22",
				4.43
			],
			[
				"2012-08-15",
				1.33
			]
		],
		"59621187": [
			[
				"2004-10-09",
				2.21
			],
			[
				"2006-12-08",
				2.21
			],
			[
				"2005-10-29",
				2.21
			],
			[
				"2008-07-16",
				5.31
			],
			[
				"2014-11-24",
				2.32
			],
			[
				"2015-10-06",
				3.08
			],
			[
				"2009-11-30",
				4.87
			],
			[
				"2010-07-22",
				4.43
			],
			[
				"2011-12-28",
				2.21
			],
			[
				"2012-08-15",
				2.66
			]
		],
		"59621199": [
			[
				"2004-10-09",
				7.09
			],
			[
				"2006-12-08",
				9.74
			],
			[
				"2005-10-29",
				8.86
			],
			[
				"2015-10-06",
				5.05
			]
		],
		"59621230": [
			[
				"2000-08-07",
				5.76
			],
			[
				"2001-08-09",
				7.97
			],
			[
				"2002-04-19",
				11.07
			],
			[
				"2003-05-21",
				11.07
			],
			[
				"2004-07-14",
				16.83
			],
			[
				"2004-10-09",
				3.99
			],
			[
				"2005-02-15",
				21.7
			],
			[
				"2005-07-28",
				17.71
			],
			[
				"2006-03-17",
				17.27
			],
			[
				"2006-10-12",
				11.07
			],
			[
				"2007-05-07",
				19.49
			],
			[
				"2008-04-14",
				23.47
			],
			[
				"2014-11-03",
				4.96
			],
			[
				"2015-09-09",
				2.43
			],
			[
				"2009-06-23",
				19.04
			],
			[
				"2010-04-26",
				29.23
			],
			[
				"2011-08-25",
				8.86
			]
		],
		"59621278": [
			[
				"2004-03-31",
				2.21
			],
			[
				"2005-07-01",
				2.21
			],
			[
				"2006-10-24",
				2.21
			],
			[
				"2007-09-18",
				2.21
			],
			[
				"2008-07-16",
				2.21
			],
			[
				"2013-09-23",
				1.33
			],
			[
				"2015-10-27",
				1.33
			],
			[
				"2000-12-08",
				2.21
			],
			[
				"2001-05-29",
				2.21
			],
			[
				"2002-06-11",
				2.21
			],
			[
				"2003-10-09",
				2.21
			],
			[
				"2009-09-23",
				4.43
			]
		],
		"59621280": [
			[
				"2001-09-14",
				8.86
			],
			[
				"2002-09-17",
				9.3
			],
			[
				"2003-05-27",
				8.86
			],
			[
				"2004-07-16",
				10.63
			],
			[
				"2004-10-22",
				8.41
			],
			[
				"2005-02-21",
				9.3
			],
			[
				"2005-08-09",
				11.51
			],
			[
				"2006-02-09",
				8.86
			],
			[
				"2006-09-22",
				8.41
			],
			[
				"2007-05-14",
				9.3
			],
			[
				"2008-03-12",
				8.41
			],
			[
				"2013-09-02",
				12.75
			],
			[
				"2014-12-16",
				17.8
			],
			[
				"2015-10-14",
				15.41
			],
			[
				"2009-06-24",
				10.63
			],
			[
				"2010-05-07",
				7.97
			],
			[
				"2011-09-05",
				9.74
			]
		],
		"59621291": [
			[
				"2001-10-22",
				36.76
			],
			[
				"2004-09-27",
				34.1
			],
			[
				"2004-11-19",
				35.43
			],
			[
				"2005-03-18",
				29.23
			],
			[
				"2005-05-30",
				29.23
			],
			[
				"2006-04-11",
				27.46
			],
			[
				"2006-08-14",
				31.44
			],
			[
				"2007-11-21",
				26.13
			],
			[
				"2008-04-18",
				27.46
			],
			[
				"2014-10-29",
				26.75
			],
			[
				"2015-08-31",
				24.93
			],
			[
				"2002-09-03",
				34.99
			],
			[
				"2003-07-16",
				36.31
			],
			[
				"2009-06-25",
				31.44
			],
			[
				"2010-04-30",
				26.57
			],
			[
				"2011-07-25",
				30.56
			]
		],
		"59621321": [
			[
				"2001-11-05",
				18.6
			],
			[
				"2002-04-19",
				19.93
			],
			[
				"2003-05-21",
				19.49
			],
			[
				"2004-07-14",
				19.49
			],
			[
				"2005-03-18",
				19.93
			],
			[
				"2006-04-28",
				19.49
			],
			[
				"2007-04-26",
				19.04
			],
			[
				"2008-04-15",
				20.37
			],
			[
				"2015-09-30",
				14.35
			]
		],
		"59621620": [
			[
				"2004-10-04",
				44.73
			],
			[
				"2004-11-23",
				44.73
			],
			[
				"2005-06-09",
				49.16
			],
			[
				"2005-09-06",
				43.4
			],
			[
				"2006-04-06",
				48.27
			],
			[
				"2006-10-18",
				40.3
			],
			[
				"2007-05-16",
				45.17
			],
			[
				"2008-06-16",
				44.29
			],
			[
				"2013-09-02",
				35.07
			],
			[
				"2014-11-18",
				33.92
			],
			[
				"2015-09-29",
				34.19
			],
			[
				"2009-08-03",
				43.84
			],
			[
				"2010-06-25",
				41.63
			],
			[
				"2011-08-25",
				40.3
			]
		],
		"60070109": [
			[
				"2000-05-04",
				115.14
			],
			[
				"2000-09-07",
				109.39
			],
			[
				"2001-08-06",
				103.63
			],
			[
				"2001-10-22",
				96.99
			],
			[
				"2002-09-17",
				47.83
			],
			[
				"2002-04-10",
				68.2
			],
			[
				"2003-05-21",
				90.34
			],
			[
				"2004-05-07",
				103.63
			],
			[
				"2004-06-07",
				101.86
			],
			[
				"2005-06-07",
				104.96
			],
			[
				"2005-10-24",
				94.77
			],
			[
				"2006-08-28",
				108.94
			],
			[
				"2006-09-25",
				102.3
			],
			[
				"2007-03-30",
				103.63
			],
			[
				"2007-06-15",
				103.63
			],
			[
				"2008-07-28",
				112.04
			],
			[
				"2013-06-07",
				85.91
			],
			[
				"2014-08-12",
				108.06
			],
			[
				"2015-12-17",
				111.16
			],
			[
				"2003-09-30",
				112.49
			],
			[
				"2009-05-15",
				96.54
			],
			[
				"2010-05-12",
				107.17
			],
			[
				"2011-05-05",
				101.86
			]
		],
		"60070298": [
			[
				"2000-04-03",
				4.43
			],
			[
				"2000-08-28",
				4.43
			],
			[
				"2001-07-02",
				4.43
			],
			[
				"2003-04-28",
				4.43
			],
			[
				"2004-07-13",
				4.43
			],
			[
				"2005-05-30",
				4.43
			],
			[
				"2006-09-07",
				4.43
			],
			[
				"2007-04-23",
				4.43
			],
			[
				"2008-04-21",
				4.43
			],
			[
				"2013-11-08",
				1.62
			],
			[
				"2014-07-21",
				1.33
			],
			[
				"2015-08-28",
				1.33
			],
			[
				"2002-05-23",
				4.43
			],
			[
				"2009-05-18",
				4.43
			],
			[
				"2010-05-03",
				4.43
			],
			[
				"2011-05-05",
				4.43
			]
		],
		"60070602": [
			[
				"2013-11-21",
				31.62
			],
			[
				"2014-08-29",
				29.89
			],
			[
				"2015-11-20",
				34.06
			]
		],
		"60071606": [
			[
				"2006-07-04",
				15.94
			],
			[
				"2007-05-29",
				16.39
			],
			[
				"2008-10-07",
				12.4
			],
			[
				"2013-06-07",
				22.94
			],
			[
				"2014-10-22",
				18.69
			],
			[
				"2015-12-07",
				18.95
			],
			[
				"2009-06-24",
				12.84
			],
			[
				"2010-06-21",
				11.96
			],
			[
				"2011-05-05",
				17.71
			]
		],
		"60080139": [
			[
				"2000-03-28",
				4.43
			],
			[
				"2000-08-30",
				4.43
			],
			[
				"2001-03-28",
				4.43
			],
			[
				"2001-10-04",
				4.43
			],
			[
				"2002-05-22",
				4.43
			],
			[
				"2003-06-24",
				4.43
			],
			[
				"2004-04-26",
				4.43
			],
			[
				"2005-08-31",
				4.43
			],
			[
				"2006-05-15",
				4.43
			],
			[
				"2007-05-09",
				4.43
			],
			[
				"2008-04-21",
				4.43
			],
			[
				"2013-10-07",
				1.33
			],
			[
				"2013-10-17",
				1.33
			],
			[
				"2014-09-05",
				1.62
			],
			[
				"2015-04-22",
				1.33
			],
			[
				"2009-05-18",
				4.43
			],
			[
				"2010-05-04",
				4.43
			],
			[
				"2011-04-07",
				4.43
			]
		],
		"60080280": [
			[
				"2000-03-31",
				11.51
			],
			[
				"2000-08-03",
				10.19
			],
			[
				"2001-03-30",
				15.06
			],
			[
				"2002-05-23",
				9.74
			],
			[
				"2003-06-03",
				13.29
			],
			[
				"2004-04-27",
				11.07
			],
			[
				"2005-08-31",
				5.31
			],
			[
				"2006-09-05",
				7.53
			],
			[
				"2007-06-15",
				5.76
			],
			[
				"2008-06-09",
				7.53
			],
			[
				"2013-12-12",
				5.23
			],
			[
				"2014-07-28",
				2.71
			],
			[
				"2015-10-28",
				1.71
			],
			[
				"2009-10-19",
				4.43
			],
			[
				"2010-05-04",
				10.19
			],
			[
				"2011-05-13",
				6.2
			]
		],
		"60081429": [
			[
				"2000-05-09",
				22.59
			],
			[
				"2000-08-29",
				40.3
			],
			[
				"2001-05-21",
				37.2
			],
			[
				"2002-04-05",
				30.56
			],
			[
				"2003-06-04",
				33.66
			],
			[
				"2004-06-21",
				30.56
			],
			[
				"2004-10-07",
				33.21
			],
			[
				"2005-10-10",
				32.33
			],
			[
				"2006-05-08",
				31
			],
			[
				"2007-02-20",
				29.67
			],
			[
				"2008-04-04",
				30.11
			],
			[
				"2015-12-03",
				27.15
			]
		],
		"60081430": [
			[
				"2000-05-09",
				14.17
			],
			[
				"2000-08-29",
				11.51
			],
			[
				"2001-04-24",
				8.86
			],
			[
				"2002-04-05",
				6.2
			],
			[
				"2003-06-24",
				11.96
			],
			[
				"2004-05-12",
				11.96
			],
			[
				"2005-10-10",
				21.26
			],
			[
				"2006-10-24",
				26.57
			],
			[
				"2006-08-31",
				26.13
			],
			[
				"2006-10-10",
				24.36
			],
			[
				"2007-06-22",
				20.37
			],
			[
				"2008-04-16",
				15.5
			],
			[
				"2013-06-05",
				16.65
			],
			[
				"2014-09-02",
				22.14
			],
			[
				"2015-04-28",
				19.44
			],
			[
				"2009-05-11",
				15.06
			],
			[
				"2010-06-28",
				13.29
			],
			[
				"2011-05-13",
				11.96
			]
		],
		"60082800": [
			[
				"2006-10-18",
				82.81
			],
			[
				"2007-09-11",
				78.39
			],
			[
				"2008-04-22",
				72.63
			],
			[
				"2014-07-24",
				79.27
			],
			[
				"2015-10-28",
				77.5
			],
			[
				"2009-11-30",
				65.54
			],
			[
				"2010-05-12",
				73.51
			],
			[
				"2011-05-06",
				75.73
			]
		],
		"60090248": [
			[
				"2000-05-18",
				8.86
			],
			[
				"2000-09-06",
				7.09
			],
			[
				"2001-04-30",
				10.19
			],
			[
				"2001-11-29",
				7.53
			],
			[
				"2002-08-20",
				4.87
			],
			[
				"2003-06-03",
				5.31
			],
			[
				"2004-05-03",
				7.09
			],
			[
				"2005-09-13",
				5.31
			],
			[
				"2007-10-24",
				7.53
			],
			[
				"2008-06-18",
				4.87
			],
			[
				"2014-07-23",
				8.99
			],
			[
				"2015-11-06",
				8.33
			],
			[
				"2009-07-01",
				8.41
			]
		],
		"60090340": [
			[
				"2000-03-29",
				39.86
			],
			[
				"2000-07-31",
				31.89
			],
			[
				"2001-04-26",
				52.26
			],
			[
				"2003-04-02",
				49.16
			],
			[
				"2004-05-17",
				42.07
			],
			[
				"2005-04-08",
				45.17
			],
			[
				"2006-04-12",
				35.87
			],
			[
				"2007-10-17",
				24.8
			],
			[
				"2008-06-03",
				29.67
			],
			[
				"2013-12-04",
				10.23
			],
			[
				"2014-07-23",
				10.27
			],
			[
				"2015-11-03",
				9.83
			],
			[
				"2002-04-24",
				44.73
			],
			[
				"2010-06-15",
				16.39
			],
			[
				"2011-06-15",
				12.4
			]
		],
		"60091101": [
			[
				"2000-05-18",
				7.97
			],
			[
				"2000-08-31",
				17.71
			],
			[
				"2001-05-29",
				7.97
			],
			[
				"2001-11-12",
				26.57
			],
			[
				"2002-04-24",
				19.04
			],
			[
				"2002-05-06",
				19.04
			],
			[
				"2004-05-03",
				25.24
			],
			[
				"2005-08-31",
				49.16
			],
			[
				"2006-07-06",
				25.24
			],
			[
				"2007-10-23",
				35.87
			],
			[
				"2008-07-29",
				36.31
			],
			[
				"2013-11-28",
				7.26
			],
			[
				"2014-07-22",
				11.69
			],
			[
				"2015-11-05",
				4.92
			],
			[
				"2009-06-23",
				28.79
			],
			[
				"2011-06-14",
				8.41
			]
		],
		"60092233": [
			[
				"2000-04-04",
				46.94
			],
			[
				"2000-08-08",
				25.69
			],
			[
				"2001-05-22",
				48.71
			],
			[
				"2001-11-21",
				29.67
			],
			[
				"2002-04-04",
				30.56
			],
			[
				"2002-07-15",
				40.74
			],
			[
				"2003-04-22",
				46.06
			],
			[
				"2004-04-21",
				48.71
			],
			[
				"2005-07-05",
				32.77
			],
			[
				"2005-08-22",
				39.41
			],
			[
				"2006-08-28",
				54.47
			],
			[
				"2006-09-25",
				49.6
			],
			[
				"2007-02-12",
				43.4
			],
			[
				"2007-11-26",
				52.7
			],
			[
				"2008-07-28",
				56.69
			],
			[
				"2013-06-06",
				43.09
			],
			[
				"2014-10-01",
				20.06
			],
			[
				"2015-12-01",
				20.33
			],
			[
				"2009-06-26",
				47.83
			],
			[
				"2010-08-02",
				54.47
			],
			[
				"2011-05-06",
				59.79
			]
		],
		"60100308": [
			[
				"2006-08-15",
				4.43
			],
			[
				"2007-10-17",
				4.43
			],
			[
				"2008-07-29",
				4.43
			],
			[
				"2013-10-30",
				1.33
			],
			[
				"2014-07-22",
				1.33
			],
			[
				"2015-11-19",
				1.33
			],
			[
				"2009-07-01",
				4.43
			],
			[
				"2010-06-17",
				4.43
			],
			[
				"2011-06-15",
				4.43
			]
		],
		"60100904": [
			[
				"2013-10-30",
				1.33
			],
			[
				"2014-07-22",
				1.33
			],
			[
				"2015-11-30",
				1.33
			],
			[
				"2009-11-23",
				4.43
			],
			[
				"2010-06-17",
				4.43
			]
		],
		"60102123": [
			[
				"2000-03-29",
				4.43
			],
			[
				"2000-07-31",
				4.43
			],
			[
				"2001-03-29",
				4.43
			],
			[
				"2002-04-11",
				5.76
			],
			[
				"2003-04-02",
				6.2
			],
			[
				"2004-05-17",
				5.76
			],
			[
				"2005-04-08",
				4.43
			],
			[
				"2006-09-07",
				4.43
			],
			[
				"2007-10-17",
				4.43
			],
			[
				"2008-07-01",
				4.43
			],
			[
				"2014-07-28",
				1.33
			],
			[
				"2015-11-24",
				6.86
			],
			[
				"2009-05-20",
				4.43
			],
			[
				"2010-06-15",
				4.43
			],
			[
				"2011-06-14",
				4.43
			]
		],
		"60102135": [
			[
				"2000-03-29",
				15.5
			],
			[
				"2000-07-31",
				9.74
			],
			[
				"2000-08-31",
				8.86
			],
			[
				"2001-04-26",
				6.64
			],
			[
				"2003-04-02",
				12.4
			],
			[
				"2004-05-17",
				9.3
			],
			[
				"2005-04-08",
				6.2
			],
			[
				"2006-09-07",
				4.43
			],
			[
				"2007-09-11",
				12.4
			],
			[
				"2008-07-01",
				4.43
			],
			[
				"2014-07-28",
				3.1
			],
			[
				"2015-11-25",
				2.93
			],
			[
				"2002-04-24",
				12.4
			],
			[
				"2009-05-20",
				5.76
			],
			[
				"2010-06-15",
				4.43
			],
			[
				"2011-06-14",
				4.43
			]
		],
		"60220028": [
			[
				"2000-05-03",
				153.67
			],
			[
				"2000-09-25",
				157.21
			],
			[
				"2001-07-30",
				188.66
			],
			[
				"2001-10-23",
				173.16
			],
			[
				"2002-07-24",
				206.37
			],
			[
				"2002-09-18",
				213.46
			],
			[
				"2003-03-31",
				216.56
			],
			[
				"2003-09-29",
				229.4
			],
			[
				"2004-04-16",
				216.56
			],
			[
				"2004-07-13",
				233.39
			],
			[
				"2004-06-09",
				221.43
			],
			[
				"2004-08-26",
				235.16
			],
			[
				"2005-04-01",
				221.43
			],
			[
				"2005-06-06",
				220.99
			],
			[
				"2005-08-16",
				204.6
			],
			[
				"2005-10-24",
				197.51
			],
			[
				"2006-06-19",
				183.79
			],
			[
				"2006-08-29",
				191.76
			],
			[
				"2007-05-11",
				177.14
			],
			[
				"2007-11-29",
				178.91
			],
			[
				"2008-04-08",
				195.3
			],
			[
				"2013-07-17",
				59.34
			],
			[
				"2014-10-07",
				71.3
			],
			[
				"2014-10-23",
				70.86
			],
			[
				"2015-01-30",
				77.94
			],
			[
				"2009-05-14",
				228.07
			],
			[
				"2009-11-09",
				245.34
			],
			[
				"2010-07-01",
				109.39
			],
			[
				"2012-08-17",
				51.37
			]
		],
		"60220478": [
			[
				"2000-05-30",
				4.43
			],
			[
				"2000-10-04",
				4.43
			],
			[
				"2001-06-19",
				4.43
			],
			[
				"2001-10-25",
				4.43
			],
			[
				"2002-06-19",
				4.43
			],
			[
				"2003-06-12",
				4.43
			],
			[
				"2004-05-07",
				4.43
			],
			[
				"2005-08-22",
				4.43
			],
			[
				"2006-05-22",
				4.43
			],
			[
				"2007-06-01",
				4.43
			],
			[
				"2008-05-08",
				4.43
			],
			[
				"2013-07-18",
				1.33
			],
			[
				"2014-10-01",
				3.37
			],
			[
				"2015-12-17",
				7.09
			],
			[
				"2009-07-02",
				4.43
			],
			[
				"2010-08-03",
				4.43
			],
			[
				"2012-08-20",
				1.33
			]
		],
		"60220697": [
			[
				"2000-06-07",
				42.96
			],
			[
				"2000-10-04",
				53.14
			],
			[
				"2001-06-19",
				33.66
			],
			[
				"2001-11-26",
				56.69
			],
			[
				"2002-08-08",
				44.29
			],
			[
				"2002-09-11",
				50.93
			],
			[
				"2002-06-19",
				28.34
			],
			[
				"2003-04-29",
				34.1
			],
			[
				"2004-04-20",
				34.54
			],
			[
				"2005-03-17",
				41.19
			],
			[
				"2006-09-28",
				39.41
			],
			[
				"2007-06-29",
				39.86
			],
			[
				"2007-06-01",
				42.51
			],
			[
				"2008-06-02",
				33.66
			],
			[
				"2013-12-04",
				27.37
			],
			[
				"2014-09-16",
				29.32
			],
			[
				"2015-11-25",
				34.99
			],
			[
				"2009-05-14",
				36.76
			],
			[
				"2010-06-30",
				22.14
			]
		],
		"60220867": [
			[
				"2000-05-15",
				8.41
			],
			[
				"2000-09-20",
				5.76
			],
			[
				"2001-06-11",
				8.86
			],
			[
				"2001-10-29",
				16.39
			],
			[
				"2002-07-24",
				28.79
			],
			[
				"2003-06-17",
				82.81
			],
			[
				"2004-04-16",
				51.81
			],
			[
				"2005-08-11",
				54.91
			],
			[
				"2006-06-19",
				76.17
			],
			[
				"2007-05-16",
				88.13
			],
			[
				"2008-04-03",
				115.14
			],
			[
				"2013-07-18",
				135.07
			],
			[
				"2014-09-30",
				152.79
			],
			[
				"2015-09-24",
				95.66
			],
			[
				"2009-10-15",
				129.31
			],
			[
				"2010-05-14",
				139.06
			],
			[
				"2012-08-17",
				169.17
			]
		],
		"60230058": [
			[
				"2000-05-30",
				67.31
			],
			[
				"2000-10-10",
				36.76
			],
			[
				"2001-05-15",
				104.07
			],
			[
				"2001-10-29",
				34.1
			],
			[
				"2002-07-22",
				27.46
			],
			[
				"2002-04-10",
				62.44
			],
			[
				"2003-04-09",
				37.64
			],
			[
				"2004-04-15",
				30.11
			],
			[
				"2005-03-23",
				45.61
			],
			[
				"2006-08-30",
				31.44
			],
			[
				"2007-05-16",
				23.91
			],
			[
				"2008-03-19",
				48.71
			],
			[
				"2013-08-02",
				93
			],
			[
				"2014-08-25",
				27.46
			],
			[
				"2014-10-22",
				38.09
			],
			[
				"2015-01-29",
				36.62
			],
			[
				"2009-06-25",
				51.81
			],
			[
				"2010-06-08",
				60.67
			],
			[
				"2011-06-01",
				12.4
			],
			[
				"2012-08-20",
				93.89
			]
		],
		"60230113": [
			[
				"2006-07-03",
				114.26
			],
			[
				"2007-04-25",
				117.36
			],
			[
				"2008-06-30",
				104.07
			],
			[
				"2013-11-13",
				151.46
			],
			[
				"2014-07-25",
				142.6
			],
			[
				"2015-06-22",
				147.03
			],
			[
				"2009-05-12",
				138.17
			],
			[
				"2010-06-22",
				127.99
			],
			[
				"2011-05-04",
				128.87
			]
		],
		"60230265": [
			[
				"2000-05-03",
				108.94
			],
			[
				"2000-10-10",
				69.53
			],
			[
				"2001-08-01",
				96.99
			],
			[
				"2001-10-24",
				80.6
			],
			[
				"2002-04-10",
				47.83
			],
			[
				"2003-04-09",
				56.69
			],
			[
				"2004-04-15",
				71.74
			],
			[
				"2004-06-08",
				115.14
			],
			[
				"2005-03-23",
				62.89
			],
			[
				"2005-06-08",
				83.26
			],
			[
				"2006-10-09",
				35.43
			],
			[
				"2006-08-30",
				43.4
			],
			[
				"2007-05-10",
				80.16
			],
			[
				"2007-11-29",
				42.96
			],
			[
				"2008-03-19",
				79.27
			],
			[
				"2013-07-18",
				139.5
			],
			[
				"2014-09-10",
				63.77
			],
			[
				"2015-12-08",
				29.63
			],
			[
				"2002-09-17",
				73.07
			],
			[
				"2003-09-30",
				43.84
			],
			[
				"2009-06-25",
				175.81
			],
			[
				"2010-06-08",
				175.81
			],
			[
				"2011-05-12",
				171.83
			],
			[
				"2012-08-16",
				113.37
			]
		],
		"60240027": [
			[
				"2006-08-03",
				4.43
			],
			[
				"2007-10-16",
				4.43
			],
			[
				"2008-09-15",
				4.43
			],
			[
				"2013-11-11",
				1.33
			],
			[
				"2014-09-17",
				1.33
			],
			[
				"2015-04-15",
				1.33
			],
			[
				"2009-05-13",
				4.43
			],
			[
				"2010-06-23",
				4.43
			],
			[
				"2011-05-27",
				4.43
			]
		],
		"60240040": [
			[
				"2006-08-03",
				103.19
			],
			[
				"2007-10-16",
				156.77
			],
			[
				"2008-09-15",
				103.63
			],
			[
				"2013-11-11",
				131.09
			],
			[
				"2014-09-17",
				111.6
			],
			[
				"2015-04-15",
				124.89
			],
			[
				"2009-05-13",
				104.07
			],
			[
				"2010-06-23",
				82.37
			],
			[
				"2011-05-27",
				95.66
			]
		],
		"60240052": [
			[
				"2006-07-25",
				4.43
			],
			[
				"2007-10-18",
				4.43
			],
			[
				"2008-09-23",
				4.43
			],
			[
				"2013-10-22",
				1.33
			],
			[
				"2014-10-16",
				1.33
			],
			[
				"2015-06-12",
				1.33
			],
			[
				"2009-07-21",
				4.43
			],
			[
				"2010-06-23",
				4.43
			]
		],
		"60240118": [
			[
				"2006-07-05",
				34.99
			],
			[
				"2007-10-18",
				19.04
			],
			[
				"2008-10-07",
				19.49
			],
			[
				"2013-11-05",
				4.52
			],
			[
				"2014-10-20",
				16.7
			],
			[
				"2015-04-16",
				16.16
			],
			[
				"2009-05-13",
				23.47
			],
			[
				"2010-06-10",
				6.2
			]
		],
		"60240120": [
			[
				"2000-04-26",
				4.43
			],
			[
				"2000-07-28",
				4.43
			],
			[
				"2001-04-02",
				4.43
			],
			[
				"2003-04-15",
				4.43
			],
			[
				"2004-04-14",
				4.43
			],
			[
				"2005-06-02",
				4.43
			],
			[
				"2006-04-06",
				4.43
			],
			[
				"2007-04-04",
				4.43
			],
			[
				"2008-03-11",
				4.43
			],
			[
				"2013-11-07",
				3.73
			],
			[
				"2014-09-01",
				3.76
			],
			[
				"2015-04-16",
				1.6
			],
			[
				"2002-04-02",
				4.43
			],
			[
				"2009-07-30",
				4.43
			],
			[
				"2010-06-10",
				4.43
			],
			[
				"2011-06-03",
				4.43
			]
		],
		"60240131": [
			[
				"2000-04-26",
				4.43
			],
			[
				"2000-07-28",
				4.43
			],
			[
				"2001-04-02",
				4.43
			],
			[
				"2003-08-04",
				4.43
			],
			[
				"2004-04-14",
				4.43
			],
			[
				"2005-04-12",
				4.43
			],
			[
				"2006-04-06",
				4.43
			],
			[
				"2007-04-04",
				4.43
			],
			[
				"2008-03-11",
				4.43
			],
			[
				"2013-11-06",
				1.33
			],
			[
				"2014-10-23",
				1.33
			],
			[
				"2015-05-18",
				1.33
			],
			[
				"2002-04-02",
				4.43
			],
			[
				"2009-07-02",
				4.43
			],
			[
				"2010-06-10",
				4.43
			],
			[
				"2011-06-03",
				4.43
			]
		],
		"60240155": [
			[
				"2004-12-01",
				14.17
			],
			[
				"2005-04-12",
				21.26
			],
			[
				"2005-08-05",
				18.16
			],
			[
				"2006-04-06",
				24.8
			],
			[
				"2006-08-21",
				18.16
			],
			[
				"2007-04-19",
				21.7
			],
			[
				"2007-11-14",
				13.73
			],
			[
				"2008-03-11",
				17.71
			],
			[
				"2014-10-21",
				20.19
			],
			[
				"2015-06-09",
				22.32
			],
			[
				"2009-07-02",
				4.43
			],
			[
				"2010-06-10",
				26.13
			],
			[
				"2011-06-03",
				10.19
			]
		],
		"60240246": [
			[
				"2000-05-02",
				6.2
			],
			[
				"2000-09-18",
				4.43
			],
			[
				"2001-08-06",
				4.43
			],
			[
				"2001-10-22",
				4.43
			],
			[
				"2002-07-24",
				4.43
			],
			[
				"2002-09-18",
				4.43
			],
			[
				"2003-03-31",
				8.86
			],
			[
				"2004-07-23",
				4.43
			],
			[
				"2004-06-07",
				4.43
			],
			[
				"2005-06-02",
				8.41
			],
			[
				"2005-08-30",
				4.43
			],
			[
				"2006-05-11",
				4.43
			],
			[
				"2006-09-11",
				4.43
			],
			[
				"2007-04-27",
				4.43
			],
			[
				"2007-11-14",
				4.87
			],
			[
				"2008-04-01",
				9.3
			],
			[
				"2008-05-06",
				4.87
			],
			[
				"2013-11-14",
				6.95
			],
			[
				"2014-10-13",
				1.33
			],
			[
				"2015-06-18",
				1.33
			],
			[
				"2003-09-30",
				4.43
			],
			[
				"2009-06-22",
				4.43
			],
			[
				"2010-07-05",
				4.43
			],
			[
				"2011-05-27",
				4.43
			]
		],
		"60240260": [
			[
				"2000-04-10",
				4.43
			],
			[
				"2000-09-18",
				4.43
			],
			[
				"2001-06-11",
				4.43
			],
			[
				"2002-07-18",
				4.43
			],
			[
				"2003-05-26",
				4.43
			],
			[
				"2004-04-16",
				4.43
			],
			[
				"2005-04-01",
				4.43
			],
			[
				"2006-09-11",
				4.43
			],
			[
				"2007-05-16",
				4.43
			],
			[
				"2008-04-03",
				4.43
			],
			[
				"2013-07-16",
				1.33
			],
			[
				"2014-10-08",
				1.33
			],
			[
				"2015-04-21",
				1.33
			],
			[
				"2009-10-15",
				4.43
			],
			[
				"2010-08-03",
				4.43
			],
			[
				"2011-06-01",
				4.43
			]
		],
		"60240295": [
			[
				"2000-05-03",
				60.67
			],
			[
				"2000-09-15",
				32.77
			],
			[
				"2001-07-30",
				46.06
			],
			[
				"2001-10-23",
				4.43
			],
			[
				"2002-07-24",
				69.09
			],
			[
				"2002-09-18",
				40.3
			],
			[
				"2003-03-31",
				56.24
			],
			[
				"2004-04-16",
				52.26
			],
			[
				"2004-06-09",
				75.29
			],
			[
				"2005-06-06",
				178.47
			],
			[
				"2005-08-30",
				83.7
			],
			[
				"2006-06-19",
				96.1
			],
			[
				"2006-08-29",
				34.1
			],
			[
				"2007-05-11",
				66.43
			],
			[
				"2007-11-29",
				69.97
			],
			[
				"2008-04-08",
				61.11
			],
			[
				"2013-07-17",
				52.7
			],
			[
				"2014-10-07",
				110.71
			],
			[
				"2015-09-16",
				20.11
			],
			[
				"2003-09-29",
				4.43
			],
			[
				"2009-11-09",
				41.19
			],
			[
				"2010-06-30",
				112.93
			],
			[
				"2011-06-01",
				55.36
			],
			[
				"2012-08-14",
				87.24
			]
		],
		"60240313": [
			[
				"2000-05-15",
				4.43
			],
			[
				"2000-09-20",
				4.43
			],
			[
				"2001-07-03",
				13.73
			],
			[
				"2003-05-26",
				19.49
			],
			[
				"2004-04-14",
				15.5
			],
			[
				"2005-06-02",
				4.43
			],
			[
				"2006-05-11",
				4.43
			],
			[
				"2007-04-04",
				16.83
			],
			[
				"2008-03-18",
				4.43
			],
			[
				"2013-10-23",
				1.33
			],
			[
				"2014-09-01",
				1.33
			],
			[
				"2015-04-21",
				1.33
			],
			[
				"2002-04-02",
				11.07
			],
			[
				"2009-07-21",
				4.43
			],
			[
				"2010-07-05",
				4.43
			]
		],
		"60240337": [
			[
				"2000-05-15",
				136.4
			],
			[
				"2000-09-21",
				135.96
			],
			[
				"2001-07-03",
				139.5
			],
			[
				"2001-11-20",
				148.8
			],
			[
				"2002-07-22",
				149.24
			],
			[
				"2002-07-16",
				151.9
			],
			[
				"2003-05-26",
				149.69
			],
			[
				"2004-07-13",
				140.83
			],
			[
				"2004-08-26",
				145.7
			],
			[
				"2005-04-01",
				147.91
			],
			[
				"2006-09-11",
				146.59
			],
			[
				"2007-05-08",
				141.27
			],
			[
				"2008-04-03",
				142.6
			],
			[
				"2013-07-16",
				155.44
			],
			[
				"2014-10-06",
				134.19
			],
			[
				"2015-06-10",
				126.66
			],
			[
				"2009-07-30",
				143.49
			],
			[
				"2010-08-03",
				138.17
			],
			[
				"2011-05-30",
				129.76
			],
			[
				"2012-08-17",
				148.36
			]
		],
		"60240374": [
			[
				"2000-11-10",
				23.47
			],
			[
				"2000-09-18",
				30.11
			],
			[
				"2001-06-11",
				48.71
			],
			[
				"2003-04-15",
				14.61
			],
			[
				"2004-05-12",
				14.17
			],
			[
				"2005-03-18",
				5.31
			],
			[
				"2006-08-21",
				4.43
			],
			[
				"2007-05-08",
				8.41
			],
			[
				"2008-04-08",
				14.61
			],
			[
				"2013-10-23",
				20.86
			],
			[
				"2014-10-08",
				13.11
			],
			[
				"2015-06-09",
				10.27
			],
			[
				"2002-08-20",
				21.26
			],
			[
				"2009-07-02",
				19.04
			],
			[
				"2010-07-07",
				11.96
			]
		],
		"60240386": [
			[
				"2000-04-10",
				8.41
			],
			[
				"2000-09-21",
				4.43
			],
			[
				"2001-04-25",
				4.43
			],
			[
				"2003-04-29",
				4.43
			],
			[
				"2004-04-29",
				4.43
			],
			[
				"2005-03-16",
				24.36
			],
			[
				"2006-05-04",
				23.91
			],
			[
				"2007-04-19",
				26.13
			],
			[
				"2008-03-18",
				27.01
			],
			[
				"2013-10-25",
				23.65
			],
			[
				"2014-10-17",
				26.88
			],
			[
				"2015-09-15",
				28.17
			],
			[
				"2002-04-26",
				4.43
			],
			[
				"2009-10-15",
				10.19
			],
			[
				"2010-07-07",
				25.69
			]
		],
		"60240398": [
			[
				"2000-04-10",
				4.43
			],
			[
				"2000-09-21",
				4.43
			],
			[
				"2001-04-25",
				4.43
			],
			[
				"2001-11-20",
				4.43
			],
			[
				"2002-07-18",
				4.43
			],
			[
				"2002-04-26",
				4.43
			],
			[
				"2003-04-15",
				4.43
			],
			[
				"2004-04-29",
				4.43
			],
			[
				"2004-07-23",
				4.43
			],
			[
				"2005-03-16",
				4.43
			],
			[
				"2006-05-04",
				4.43
			],
			[
				"2007-04-19",
				4.43
			],
			[
				"2008-03-18",
				4.43
			],
			[
				"2013-11-05",
				7.48
			],
			[
				"2014-10-20",
				1.6
			],
			[
				"2015-04-23",
				3.32
			],
			[
				"2009-10-15",
				4.43
			],
			[
				"2010-07-07",
				4.43
			]
		],
		"60240404": [
			[
				"2004-11-24",
				4.43
			],
			[
				"2005-03-14",
				4.43
			],
			[
				"2005-07-29",
				4.43
			],
			[
				"2006-08-17",
				4.43
			],
			[
				"2007-04-27",
				4.43
			],
			[
				"2008-05-06",
				4.43
			],
			[
				"2013-10-24",
				1.33
			],
			[
				"2014-10-10",
				1.33
			],
			[
				"2015-06-15",
				1.33
			],
			[
				"2009-06-22",
				4.43
			],
			[
				"2010-08-03",
				4.43
			],
			[
				"2011-05-30",
				4.43
			]
		],
		"60240416": [
			[
				"2004-11-24",
				4.43
			],
			[
				"2005-03-14",
				4.43
			],
			[
				"2005-07-29",
				4.43
			],
			[
				"2006-08-17",
				4.43
			],
			[
				"2007-04-27",
				4.43
			],
			[
				"2008-04-01",
				4.43
			],
			[
				"2013-10-24",
				1.33
			],
			[
				"2014-10-13",
				1.33
			],
			[
				"2015-06-15",
				1.33
			],
			[
				"2009-06-22",
				4.43
			],
			[
				"2010-07-05",
				4.43
			],
			[
				"2011-05-30",
				4.43
			]
		],
		"60240428": [
			[
				"2004-11-24",
				82.37
			],
			[
				"2005-03-14",
				100.09
			],
			[
				"2005-07-29",
				87.24
			],
			[
				"2006-05-11",
				81.04
			],
			[
				"2007-05-08",
				103.63
			],
			[
				"2008-04-01",
				127.99
			],
			[
				"2013-10-25",
				57.57
			],
			[
				"2014-10-10",
				44.11
			],
			[
				"2015-06-23",
				34.59
			],
			[
				"2009-06-22",
				64.66
			],
			[
				"2010-07-05",
				62
			]
		],
		"60240430": [
			[
				"2015-09-09",
				1.33
			]
		],
		"63111020": [
			[
				"2000-09-11",
				67.02
			],
			[
				"2001-05-02",
				60.02
			],
			[
				"2001-09-26",
				66.02
			],
			[
				"2002-05-13",
				80.03
			],
			[
				"2002-10-23",
				84.43
			],
			[
				"2003-04-28",
				78.03
			],
			[
				"2004-05-12",
				76.23
			],
			[
				"2004-10-04",
				77.83
			],
			[
				"2005-10-04",
				64.42
			],
			[
				"2005-05-11",
				83.33
			],
			[
				"2003-10-08",
				74.93
			],
			[
				"2006-04-10",
				62.12
			],
			[
				"2006-10-04",
				61.92
			],
			[
				"2007-04-11",
				63.02
			],
			[
				"2007-10-15",
				57.02
			],
			[
				"2009-05-18",
				51.72
			],
			[
				"2011-05-09",
				68.82
			],
			[
				"2010-10-04",
				49.62
			],
			[
				"2010-06-09",
				49.62
			],
			[
				"2009-09-21",
				44.02
			],
			[
				"2008-10-13",
				58.62
			],
			[
				"2008-05-05",
				47.82
			],
			[
				"2012-11-06",
				73.33
			],
			[
				"2013-04-23",
				69.92
			],
			[
				"2013-10-16",
				65.62
			],
			[
				"2014-04-07",
				67.22
			],
			[
				"2014-10-08",
				59.22
			],
			[
				"2015-04-21",
				61.52
			],
			[
				"2015-10-28",
				52.42
			]
		],
		"63451025": [
			[
				"2000-10-18",
				1
			],
			[
				"2000-03-14",
				3.6
			],
			[
				"2001-03-06",
				46.72
			],
			[
				"2001-10-09",
				1
			],
			[
				"2002-03-06",
				14.2
			],
			[
				"2002-10-09",
				1.7
			],
			[
				"2002-11-20",
				2.3
			],
			[
				"2003-06-04",
				3.7
			],
			[
				"2003-11-10",
				3.6
			],
			[
				"2004-10-06",
				0.5
			],
			[
				"2005-03-09",
				8.9
			],
			[
				"2006-03-06",
				3.5
			],
			[
				"2005-10-05",
				2.5
			],
			[
				"2006-10-16",
				1
			],
			[
				"2010-11-10",
				1
			],
			[
				"2011-10-31",
				1
			],
			[
				"2011-03-01",
				1
			],
			[
				"2012-04-04",
				1
			],
			[
				"2012-10-29",
				1
			],
			[
				"2014-04-23",
				1
			],
			[
				"2015-10-13",
				1
			],
			[
				"2008-10-06",
				1
			],
			[
				"2010-03-01",
				1
			],
			[
				"2008-03-13",
				1
			],
			[
				"2009-10-19",
				1
			],
			[
				"2009-03-17",
				1
			]
		],
		"68011210": [
			[
				"2000-04-12",
				8.3
			],
			[
				"2000-08-16",
				9.2
			],
			[
				"2001-04-11",
				9.5
			],
			[
				"2001-08-22",
				7.2
			],
			[
				"2002-04-10",
				9.8
			],
			[
				"2002-08-21",
				9.7
			],
			[
				"2003-04-09",
				10.8
			],
			[
				"2003-08-20",
				10.7
			],
			[
				"2004-04-28",
				10.4
			],
			[
				"2004-09-08",
				12.8
			],
			[
				"2005-04-27",
				11.2
			],
			[
				"2005-09-07",
				10
			],
			[
				"2006-03-29",
				10.5
			],
			[
				"2006-09-27",
				10.5
			],
			[
				"2011-09-28",
				11.2
			],
			[
				"2011-12-14",
				11.7
			],
			[
				"2012-09-26",
				12
			],
			[
				"2013-03-20",
				12.3
			],
			[
				"2013-09-18",
				12.3
			],
			[
				"2014-03-19",
				11.4
			],
			[
				"2015-03-18",
				13.1
			],
			[
				"2014-09-17",
				12
			],
			[
				"2015-09-16",
				13.5
			],
			[
				"2007-03-28",
				10.7
			],
			[
				"2007-09-26",
				10.9
			],
			[
				"2008-04-16",
				10.5
			],
			[
				"2008-09-24",
				11.2
			],
			[
				"2009-03-24",
				9.5
			],
			[
				"2009-09-30",
				11.4
			]
		],
		"70100214": [
			[
				"2013-08-08",
				13.46
			],
			[
				"2014-10-09",
				10.32
			],
			[
				"2015-04-27",
				3.81
			],
			[
				"2003-09-24",
				28.43
			],
			[
				"2004-05-17",
				21.17
			],
			[
				"2005-06-13",
				16.34
			],
			[
				"2007-07-16",
				17.8
			],
			[
				"2007-09-13",
				11.03
			],
			[
				"2008-07-24",
				13.46
			],
			[
				"2009-07-30",
				12.44
			],
			[
				"2010-07-05",
				12.58
			],
			[
				"2011-06-28",
				17.27
			]
		],
		"70134212": [
			[
				"2013-07-31",
				17.71
			],
			[
				"2014-02-12",
				24.53
			],
			[
				"2015-10-12",
				33.39
			],
			[
				"2003-09-24",
				31.18
			],
			[
				"2004-05-17",
				23.96
			],
			[
				"2005-06-14",
				18.25
			],
			[
				"2007-06-12",
				22.67
			],
			[
				"2007-09-12",
				20.73
			],
			[
				"2008-07-08",
				20.95
			],
			[
				"2009-07-22",
				24.89
			],
			[
				"2010-06-29",
				21.39
			],
			[
				"2011-05-25",
				19.93
			]
		],
		"70148715": [
			[
				"2014-08-28",
				29.18
			],
			[
				"2015-07-14",
				22.59
			],
			[
				"2007-06-11",
				28.34
			],
			[
				"2007-09-18",
				27.77
			],
			[
				"2008-07-22",
				24
			],
			[
				"2009-09-08",
				25.02
			],
			[
				"2010-06-08",
				25.24
			]
		],
		"70156116": [
			[
				"2013-08-05",
				1.33
			],
			[
				"2014-07-24",
				5.76
			],
			[
				"2015-06-09",
				1.95
			],
			[
				"2007-06-11",
				2.21
			],
			[
				"2007-09-17",
				6.91
			],
			[
				"2008-07-10",
				2.21
			],
			[
				"2009-07-24",
				2.21
			],
			[
				"2010-06-30",
				2.52
			]
		],
		"70157110": [
			[
				"2013-09-26",
				23.96
			],
			[
				"2014-08-14",
				24.45
			],
			[
				"2015-07-07",
				22.14
			],
			[
				"2007-09-28",
				22.76
			],
			[
				"2008-08-19",
				20.46
			],
			[
				"2009-08-26",
				20.55
			],
			[
				"2010-07-26",
				22.59
			]
		],
		"70168817": [
			[
				"2013-07-30",
				116.03
			],
			[
				"2014-07-22",
				123.56
			],
			[
				"2015-06-08",
				119.13
			],
			[
				"2000-09-18",
				112.04
			],
			[
				"2001-06-25",
				116.03
			],
			[
				"2002-09-23",
				108.06
			],
			[
				"2003-10-06",
				91.23
			],
			[
				"2004-06-14",
				110.71
			],
			[
				"2005-06-20",
				103.19
			],
			[
				"2006-10-04",
				111.6
			],
			[
				"2007-06-25",
				116.91
			],
			[
				"2007-09-13",
				123.11
			],
			[
				"2008-07-08",
				114.26
			],
			[
				"2009-07-22",
				116.91
			],
			[
				"2010-06-29",
				123.56
			]
		],
		"70187915": [
			[
				"2012-01-10",
				18.61
			],
			[
				"2013-07-23",
				22.71
			],
			[
				"2015-01-13",
				22.91
			],
			[
				"2014-07-15",
				21.21
			]
		],
		"70189110": [
			[
				"2013-05-24",
				41.14
			],
			[
				"2014-07-14",
				44.73
			],
			[
				"2015-04-23",
				43.58
			],
			[
				"2004-05-18",
				30.78
			],
			[
				"2005-06-14",
				36.76
			],
			[
				"2007-06-14",
				42.56
			],
			[
				"2007-09-12",
				36.14
			],
			[
				"2008-07-25",
				34.23
			],
			[
				"2009-08-17",
				35.12
			],
			[
				"2010-07-13",
				43.22
			],
			[
				"2011-07-07",
				40.3
			],
			[
				"2012-07-16",
				42.96
			]
		],
		"70196515": [
			[
				"2013-08-05",
				24.84
			],
			[
				"2014-07-17",
				23.91
			],
			[
				"2015-04-23",
				25.55
			],
			[
				"2000-07-10",
				31.04
			],
			[
				"2001-06-25",
				23.6
			],
			[
				"2002-07-22",
				31.71
			],
			[
				"2003-08-18",
				34.76
			],
			[
				"2004-05-19",
				27.77
			],
			[
				"2005-06-15",
				30.16
			],
			[
				"2006-10-04",
				25.07
			],
			[
				"2007-06-14",
				26.48
			],
			[
				"2007-09-17",
				25.95
			],
			[
				"2008-07-28",
				26.84
			],
			[
				"2009-08-11",
				25.42
			],
			[
				"2010-07-08",
				27.28
			],
			[
				"2011-06-29",
				22.14
			]
		],
		"70197313": [
			[
				"2013-05-28",
				14.53
			],
			[
				"2014-07-17",
				15.85
			],
			[
				"2015-04-30",
				13.24
			],
			[
				"2000-07-10",
				22.85
			],
			[
				"2001-06-25",
				20.55
			],
			[
				"2002-07-22",
				22.05
			],
			[
				"2003-08-18",
				22.94
			],
			[
				"2004-05-19",
				14.97
			],
			[
				"2005-06-15",
				17.09
			],
			[
				"2007-06-14",
				16.7
			],
			[
				"2007-09-13",
				15.9
			],
			[
				"2008-08-04",
				15.72
			],
			[
				"2009-08-17",
				16.3
			],
			[
				"2010-07-13",
				15.59
			]
		],
		"70197714": [
			[
				"2000-07-11",
				40.34
			],
			[
				"2001-06-26",
				35.96
			],
			[
				"2002-07-22",
				36.45
			],
			[
				"2003-09-01",
				34.9
			],
			[
				"2004-05-24",
				37.78
			],
			[
				"2005-06-16",
				35.3
			],
			[
				"2006-10-04",
				30.03
			],
			[
				"2012-01-10",
				30.61
			],
			[
				"2013-07-22",
				31.41
			],
			[
				"2015-01-12",
				27.81
			],
			[
				"2014-07-14",
				28.91
			]
		],
		"70197817": [
			[
				"2013-07-16",
				13.42
			],
			[
				"2014-07-18",
				15.99
			],
			[
				"2015-04-24",
				19.53
			],
			[
				"2000-09-18",
				27.86
			],
			[
				"2001-06-26",
				22.76
			],
			[
				"2002-09-23",
				23.07
			],
			[
				"2004-06-14",
				29.8
			],
			[
				"2005-06-22",
				16.78
			],
			[
				"2006-10-05",
				22.5
			],
			[
				"2007-06-14",
				18.42
			],
			[
				"2007-09-13",
				17.23
			],
			[
				"2008-07-18",
				15.32
			],
			[
				"2009-07-31",
				19
			],
			[
				"2010-06-09",
				20.77
			],
			[
				"2011-06-10",
				15.94
			]
		],
		"70197910": [
			[
				"2013-07-16",
				28.56
			],
			[
				"2014-07-18",
				29.94
			],
			[
				"2015-04-24",
				28.12
			],
			[
				"2000-05-04",
				36.49
			],
			[
				"2000-07-11",
				37.51
			],
			[
				"2001-06-26",
				31.62
			],
			[
				"2002-07-22",
				37.24
			],
			[
				"2003-09-01",
				39.41
			],
			[
				"2004-05-24",
				34.85
			],
			[
				"2005-06-16",
				29.76
			],
			[
				"2006-10-05",
				24.36
			],
			[
				"2007-06-14",
				25.15
			],
			[
				"2007-09-12",
				22.9
			],
			[
				"2008-07-18",
				17.98
			],
			[
				"2012-01-10",
				34.31
			],
			[
				"2013-07-22",
				26.61
			],
			[
				"2015-01-12",
				31.21
			],
			[
				"2014-07-14",
				32.91
			],
			[
				"2009-07-31",
				25.29
			],
			[
				"2010-07-15",
				27.1
			],
			[
				"2011-09-01",
				30.11
			]
		],
		"70198111": [
			[
				"2014-12-05",
				33.7
			],
			[
				"2015-08-19",
				35.87
			],
			[
				"2003-09-29",
				38.62
			],
			[
				"2004-05-25",
				26.75
			],
			[
				"2005-07-19",
				29.27
			],
			[
				"2007-06-11",
				28.34
			],
			[
				"2007-09-11",
				27.41
			],
			[
				"2008-07-22",
				31.53
			],
			[
				"2009-09-08",
				29.1
			],
			[
				"2010-06-08",
				24.76
			]
		],
		"70199619": [
			[
				"2013-07-01",
				40.65
			],
			[
				"2014-07-21",
				46.94
			],
			[
				"2015-04-29",
				44.73
			],
			[
				"2000-07-12",
				63.77
			],
			[
				"2001-06-27",
				45.17
			],
			[
				"2002-07-24",
				61.56
			],
			[
				"2003-08-20",
				54.03
			],
			[
				"2004-05-27",
				52.26
			],
			[
				"2005-06-17",
				48.27
			],
			[
				"2006-10-05",
				49.6
			],
			[
				"2007-06-12",
				50.04
			],
			[
				"2007-09-14",
				44.73
			],
			[
				"2008-07-10",
				46.5
			],
			[
				"2009-07-24",
				48.27
			],
			[
				"2010-06-30",
				50.93
			],
			[
				"2011-05-26",
				53.14
			],
			[
				"2012-07-17",
				47.83
			]
		],
		"70199814": [
			[
				"2013-09-03",
				24.09
			],
			[
				"2014-09-29",
				19.66
			],
			[
				"2015-08-20",
				17.85
			],
			[
				"2000-07-17",
				38.09
			],
			[
				"2001-06-28",
				32.82
			],
			[
				"2002-07-23",
				30.6
			],
			[
				"2003-08-20",
				31.04
			],
			[
				"2004-05-26",
				34.59
			],
			[
				"2005-06-27",
				25.42
			],
			[
				"2006-10-09",
				37.07
			],
			[
				"2007-06-19",
				41.89
			],
			[
				"2007-09-24",
				37.16
			],
			[
				"2008-07-24",
				38.26
			],
			[
				"2009-07-30",
				30.51
			],
			[
				"2010-07-05",
				29.41
			],
			[
				"2011-06-28",
				24.8
			]
		],
		"70200210": [
			[
				"2013-05-29",
				22.05
			],
			[
				"2014-07-17",
				21.7
			],
			[
				"2015-06-01",
				20.68
			],
			[
				"2007-06-12",
				22.23
			],
			[
				"2007-09-14",
				21.21
			],
			[
				"2008-07-10",
				23.87
			],
			[
				"2009-07-24",
				20.15
			],
			[
				"2010-06-30",
				24.93
			],
			[
				"2011-05-26",
				23.91
			],
			[
				"2012-07-17",
				22.45
			]
		],
		"70200518": [
			[
				"2013-07-01",
				13.06
			],
			[
				"2014-10-08",
				9.39
			],
			[
				"2015-08-10",
				8.5
			],
			[
				"2000-07-11",
				22.23
			],
			[
				"2001-06-29",
				20.77
			],
			[
				"2002-07-24",
				20.24
			],
			[
				"2003-08-21",
				25.77
			],
			[
				"2004-05-27",
				23.96
			],
			[
				"2005-06-28",
				21.52
			],
			[
				"2006-10-06",
				15.85
			],
			[
				"2007-06-19",
				14.66
			],
			[
				"2007-09-19",
				14.3
			],
			[
				"2008-07-29",
				11.91
			],
			[
				"2009-08-12",
				13.95
			],
			[
				"2010-07-19",
				14.08
			],
			[
				"2011-08-30",
				11.96
			]
		],
		"70200816": [
			[
				"2014-02-13",
				12.7
			],
			[
				"2015-08-12",
				15.41
			],
			[
				"2016-03-15",
				19.21
			]
		],
		"70201213": [
			[
				"2014-02-13",
				68.32
			],
			[
				"2015-08-12",
				68.02
			],
			[
				"2016-03-15",
				53.22
			]
		],
		"70201316": [
			[
				"2013-05-23",
				33.48
			],
			[
				"2014-07-16",
				43.13
			],
			[
				"2015-04-27",
				42.56
			],
			[
				"2016-04-04",
				37.2
			],
			[
				"2000-07-13",
				46.94
			],
			[
				"2001-07-09",
				52.26
			],
			[
				"2002-07-25",
				48.27
			],
			[
				"2003-08-22",
				47.83
			],
			[
				"2004-05-27",
				40.03
			],
			[
				"2005-06-28",
				36.67
			],
			[
				"2007-07-06",
				33.08
			],
			[
				"2007-09-17",
				37.51
			],
			[
				"2008-08-01",
				40.79
			],
			[
				"2009-08-10",
				37.33
			],
			[
				"2010-07-06",
				39.41
			],
			[
				"2011-06-08",
				39.41
			],
			[
				"2012-07-16",
				41.45
			]
		],
		"70201419": [
			[
				"2013-11-19",
				19.93
			],
			[
				"2014-07-17",
				24.62
			],
			[
				"2015-04-23",
				18.56
			],
			[
				"2016-04-05",
				19.04
			],
			[
				"2000-07-13",
				32.99
			],
			[
				"2001-07-02",
				28.65
			],
			[
				"2002-07-25",
				27.55
			],
			[
				"2003-08-22",
				24.76
			],
			[
				"2004-05-28",
				25.24
			],
			[
				"2005-06-28",
				25.64
			],
			[
				"2007-06-19",
				22.36
			],
			[
				"2007-09-17",
				22.32
			],
			[
				"2008-08-01",
				21.83
			],
			[
				"2009-08-17",
				20.81
			],
			[
				"2010-07-13",
				21.35
			],
			[
				"2011-07-07",
				19.93
			]
		],
		"70201810": [
			[
				"2013-05-22",
				27.24
			],
			[
				"2014-07-16",
				22.28
			],
			[
				"2015-04-28",
				25.29
			],
			[
				"2016-04-04",
				21.26
			],
			[
				"2000-07-14",
				38.17
			],
			[
				"2001-07-02",
				41.54
			],
			[
				"2002-08-01",
				42.87
			],
			[
				"2003-08-25",
				35.96
			],
			[
				"2004-06-01",
				31.71
			],
			[
				"2005-06-29",
				36.36
			],
			[
				"2007-06-19",
				28.61
			],
			[
				"2007-09-19",
				28.61
			],
			[
				"2008-08-05",
				31.62
			],
			[
				"2009-08-28",
				27.77
			],
			[
				"2010-07-23",
				27.01
			],
			[
				"2011-08-29",
				24.36
			]
		],
		"70202310": [
			[
				"2013-07-15",
				16.25
			],
			[
				"2014-10-23",
				12.8
			],
			[
				"2015-07-20",
				15.68
			],
			[
				"2000-07-20",
				20.68
			],
			[
				"2001-07-03",
				20.46
			],
			[
				"2002-09-02",
				24.18
			],
			[
				"2003-09-19",
				23.6
			],
			[
				"2004-06-02",
				21.39
			],
			[
				"2005-06-30",
				14.75
			],
			[
				"2007-06-20",
				14.3
			],
			[
				"2007-09-19",
				22.9
			],
			[
				"2008-08-15",
				15.46
			],
			[
				"2009-09-08",
				16.3
			],
			[
				"2010-06-09",
				13.29
			],
			[
				"2011-06-10",
				15.06
			]
		],
		"70202515": [
			[
				"2013-07-22",
				9.48
			],
			[
				"2014-07-30",
				2.61
			],
			[
				"2015-04-21",
				9.12
			],
			[
				"2016-04-11",
				8.41
			],
			[
				"2000-07-18",
				5.45
			],
			[
				"2001-07-04",
				15.68
			],
			[
				"2002-07-30",
				7.97
			],
			[
				"2003-08-26",
				4.21
			],
			[
				"2004-06-02",
				19.97
			],
			[
				"2005-07-18",
				15.72
			],
			[
				"2007-06-20",
				14.17
			],
			[
				"2007-09-19",
				24.93
			],
			[
				"2008-07-31",
				12
			],
			[
				"2009-08-14",
				6.42
			],
			[
				"2010-07-07",
				6.24
			],
			[
				"2011-07-08",
				3.63
			]
		],
		"70203416": [
			[
				"2013-07-17",
				148.8
			],
			[
				"2014-08-11",
				159.43
			],
			[
				"2015-05-26",
				147.91
			],
			[
				"2000-07-19",
				250.21
			],
			[
				"2001-07-05",
				224.97
			],
			[
				"2002-07-31",
				217.44
			],
			[
				"2003-08-28",
				177.59
			],
			[
				"2004-06-04",
				202.83
			],
			[
				"2005-07-04",
				219.21
			],
			[
				"2006-10-12",
				206.81
			],
			[
				"2007-06-18",
				209.91
			],
			[
				"2007-09-25",
				210.36
			],
			[
				"2008-07-07",
				198.4
			],
			[
				"2009-07-27",
				185.11
			],
			[
				"2000-03-29",
				234.71
			],
			[
				"2010-07-01",
				178.91
			],
			[
				"2011-06-07",
				168.29
			]
		],
		"70203817": [
			[
				"2013-07-08",
				196.63
			],
			[
				"2014-08-20",
				152.34
			],
			[
				"2015-05-28",
				162.53
			],
			[
				"2001-07-06",
				217.44
			],
			[
				"2002-08-02",
				211.69
			],
			[
				"2003-08-28",
				188.21
			],
			[
				"2004-06-07",
				155
			],
			[
				"2007-06-18",
				184.67
			],
			[
				"2007-09-25",
				209.03
			],
			[
				"2008-07-07",
				216.11
			],
			[
				"2009-07-27",
				170.94
			],
			[
				"2010-07-01",
				143.49
			],
			[
				"2011-06-07",
				141.71
			]
		],
		"70203910": [
			[
				"2013-07-18",
				16.74
			],
			[
				"2014-07-23",
				22.85
			],
			[
				"2015-04-20",
				18.95
			],
			[
				"2001-07-06",
				16.16
			],
			[
				"2002-08-02",
				16.7
			],
			[
				"2003-08-29",
				38.22
			],
			[
				"2004-06-07",
				18.95
			],
			[
				"2005-07-05",
				14.44
			],
			[
				"2006-10-12",
				12.13
			],
			[
				"2007-06-18",
				14.48
			],
			[
				"2007-09-25",
				9.34
			],
			[
				"2008-07-07",
				32.55
			],
			[
				"2009-07-27",
				8.86
			],
			[
				"2010-07-01",
				9.65
			],
			[
				"2011-06-07",
				19.04
			]
		],
		"70204214": [
			[
				"2013-05-27",
				12.09
			],
			[
				"2014-10-07",
				13.68
			],
			[
				"2015-06-02",
				13.2
			],
			[
				"2002-08-05",
				18.42
			],
			[
				"2003-08-29",
				18.73
			],
			[
				"2004-06-08",
				16.56
			],
			[
				"2005-07-05",
				15.23
			],
			[
				"2007-06-20",
				14.08
			],
			[
				"2007-09-26",
				14.57
			],
			[
				"2008-07-25",
				15.72
			],
			[
				"2009-08-10",
				15.99
			],
			[
				"2010-07-06",
				14.35
			],
			[
				"2011-06-08",
				16.39
			]
		],
		"70204410": [
			[
				"2013-07-11",
				21.66
			],
			[
				"2014-07-30",
				20.28
			],
			[
				"2015-04-28",
				22.5
			],
			[
				"2016-04-05",
				22.14
			],
			[
				"2003-09-23",
				30.51
			],
			[
				"2004-07-06",
				27.37
			],
			[
				"2007-06-20",
				27.32
			],
			[
				"2007-09-26",
				22.32
			],
			[
				"2008-07-31",
				27.01
			],
			[
				"2009-08-14",
				29.23
			],
			[
				"2010-07-07",
				27.37
			],
			[
				"2011-09-01",
				30.56
			]
		],
		"70205218": [
			[
				"2013-05-23",
				24.53
			],
			[
				"2014-07-30",
				23.56
			],
			[
				"2015-06-10",
				22.9
			],
			[
				"2004-07-06",
				31.49
			],
			[
				"2005-07-07",
				34.41
			],
			[
				"2007-06-21",
				30.91
			],
			[
				"2007-09-21",
				37.24
			],
			[
				"2008-07-25",
				28.61
			],
			[
				"2009-08-10",
				25.95
			],
			[
				"2010-07-06",
				22.1
			],
			[
				"2011-06-08",
				23.03
			]
		],
		"70270016": [
			[
				"2013-07-25",
				41.58
			],
			[
				"2014-07-31",
				38.75
			],
			[
				"2015-05-19",
				35.56
			],
			[
				"2000-09-18",
				57.13
			],
			[
				"2001-07-06",
				49.16
			],
			[
				"2002-09-23",
				56.69
			],
			[
				"2003-10-06",
				57.13
			],
			[
				"2004-06-14",
				50.93
			],
			[
				"2005-06-20",
				55.36
			],
			[
				"2006-10-16",
				47.39
			],
			[
				"2007-07-09",
				46.5
			],
			[
				"2007-09-21",
				51.37
			],
			[
				"2008-07-09",
				65.99
			],
			[
				"2009-07-23",
				55.36
			],
			[
				"2010-06-28",
				65.1
			],
			[
				"2011-05-24",
				53.14
			]
		],
		"70276018": [
			[
				"2013-08-01",
				32.59
			],
			[
				"2015-04-16",
				35.12
			],
			[
				"2016-03-29",
				35.87
			],
			[
				"2000-07-24",
				41.45
			],
			[
				"2001-07-09",
				44.24
			],
			[
				"2002-08-05",
				47.39
			],
			[
				"2003-09-03",
				40.61
			],
			[
				"2004-07-06",
				40.79
			],
			[
				"2005-07-08",
				39.1
			],
			[
				"2006-10-16",
				36.58
			],
			[
				"2007-09-21",
				38.17
			],
			[
				"2008-07-08",
				35.74
			],
			[
				"2010-10-08",
				37.71
			],
			[
				"2007-11-16",
				42.31
			],
			[
				"2006-11-13",
				31.91
			],
			[
				"2011-11-23",
				38.41
			],
			[
				"2009-11-13",
				44.52
			],
			[
				"2008-12-05",
				43.02
			],
			[
				"2009-07-22",
				39.02
			],
			[
				"2010-06-29",
				39.64
			],
			[
				"2011-05-25",
				36.31
			],
			[
				"2012-07-17",
				38.26
			]
		],
		"70276110": [
			[
				"2013-07-22",
				22.85
			],
			[
				"2014-08-21",
				23.16
			],
			[
				"2015-07-08",
				22.41
			],
			[
				"2004-07-07",
				19.66
			],
			[
				"2005-07-08",
				26.7
			],
			[
				"2006-10-17",
				30.82
			],
			[
				"2007-06-21",
				21.08
			],
			[
				"2007-09-21",
				25.6
			],
			[
				"2008-07-08",
				40.7
			],
			[
				"2009-07-22",
				18.38
			],
			[
				"2010-06-29",
				31
			],
			[
				"2011-05-25",
				17.27
			]
		],
		"70282511": [
			[
				"2012-01-09",
				10.5
			],
			[
				"2013-07-22",
				11.5
			],
			[
				"2015-01-12",
				10.7
			],
			[
				"2014-07-14",
				10.1
			]
		],
		"70282717": [
			[
				"2012-01-09",
				10
			],
			[
				"2013-07-22",
				25.21
			],
			[
				"2015-01-12",
				12
			],
			[
				"2014-07-14",
				15.81
			]
		],
		"70282810": [
			[
				"2012-01-09",
				17.41
			],
			[
				"2013-07-22",
				16.41
			],
			[
				"2015-01-12",
				16.61
			],
			[
				"2014-07-15",
				17.21
			]
		],
		"70283011": [
			[
				"2012-01-09",
				17.31
			],
			[
				"2013-07-22",
				18.61
			],
			[
				"2015-01-13",
				17.21
			],
			[
				"2014-07-15",
				17.91
			]
		],
		"70283618": [
			[
				"2013-09-23",
				13.6
			],
			[
				"2014-08-11",
				39.46
			],
			[
				"2015-06-19",
				40.92
			],
			[
				"2000-05-16",
				41.27
			],
			[
				"2000-10-13",
				35.69
			],
			[
				"2007-06-25",
				55.36
			],
			[
				"2007-09-18",
				32.46
			],
			[
				"2008-07-09",
				6.73
			],
			[
				"2009-07-23",
				20.81
			],
			[
				"2010-06-28",
				36.76
			],
			[
				"2011-05-24",
				23.03
			]
		],
		"70283813": [
			[
				"2013-11-21",
				33.13
			],
			[
				"2014-07-31",
				24.53
			],
			[
				"2015-06-03",
				21.88
			],
			[
				"2007-06-22",
				19.75
			],
			[
				"2007-09-27",
				18.64
			],
			[
				"2009-08-11",
				26
			],
			[
				"2008-07-28",
				22.41
			],
			[
				"2010-07-08",
				26.44
			],
			[
				"2011-06-29",
				25.24
			]
		],
		"70284015": [
			[
				"2013-07-23",
				1.33
			],
			[
				"2015-05-18",
				17.05
			],
			[
				"2009-08-11",
				2.21
			],
			[
				"2008-07-28",
				2.21
			],
			[
				"2010-07-08",
				3.19
			]
		],
		"70284118": [
			[
				"2013-07-23",
				32.33
			],
			[
				"2014-08-04",
				13.91
			],
			[
				"2015-06-03",
				19.71
			],
			[
				"2007-06-28",
				25.73
			],
			[
				"2007-09-27",
				38.57
			],
			[
				"2008-07-11",
				47.83
			],
			[
				"2009-08-21",
				16.16
			],
			[
				"2010-07-01",
				22.67
			]
		],
		"70284416": [
			[
				"2013-07-15",
				14.26
			],
			[
				"2014-08-12",
				17.09
			],
			[
				"2015-05-22",
				12.22
			],
			[
				"2000-07-18",
				21.79
			],
			[
				"2001-07-09",
				20.59
			],
			[
				"2002-08-06",
				24.71
			],
			[
				"2003-09-03",
				20.42
			],
			[
				"2004-07-07",
				16.65
			],
			[
				"2005-07-11",
				18.25
			],
			[
				"2007-06-27",
				16.43
			],
			[
				"2007-09-26",
				18.33
			],
			[
				"2008-08-15",
				18.51
			],
			[
				"2009-08-28",
				16.34
			],
			[
				"2010-07-23",
				15.5
			],
			[
				"2011-08-29",
				15.5
			]
		],
		"70284611": [
			[
				"2013-07-18",
				85.47
			],
			[
				"2014-07-29",
				112.49
			],
			[
				"2015-06-10",
				111.16
			],
			[
				"2004-07-07",
				110.71
			],
			[
				"2005-07-11",
				86.8
			],
			[
				"2006-10-26",
				71.3
			],
			[
				"2007-06-25",
				78.39
			],
			[
				"2007-09-25",
				64.21
			],
			[
				"2008-07-09",
				39.19
			],
			[
				"2009-07-23",
				36.76
			],
			[
				"2010-06-28",
				69.97
			],
			[
				"2011-05-24",
				57.57
			]
		],
		"70304257": [
			[
				"2014-12-10",
				77.06
			],
			[
				"2015-08-17",
				73.96
			],
			[
				"2000-02-08",
				60.23
			],
			[
				"2000-05-09",
				62.44
			],
			[
				"2000-07-20",
				61.11
			],
			[
				"2000-10-26",
				59.79
			],
			[
				"2001-01-25",
				60.23
			],
			[
				"2001-04-26",
				62.44
			],
			[
				"2001-07-26",
				62
			],
			[
				"2001-10-25",
				65.1
			],
			[
				"2002-08-01",
				62.89
			],
			[
				"2002-05-07",
				61.56
			],
			[
				"2002-11-21",
				58.9
			],
			[
				"2002-01-29",
				65.54
			],
			[
				"2003-01-28",
				59.79
			],
			[
				"2003-04-29",
				58.46
			],
			[
				"2003-07-29",
				63.33
			],
			[
				"2003-11-06",
				64.21
			],
			[
				"2004-01-29",
				61.56
			],
			[
				"2004-04-26",
				60.23
			],
			[
				"2004-07-29",
				59.34
			],
			[
				"2004-10-28",
				63.77
			],
			[
				"2005-01-25",
				61.56
			],
			[
				"2005-05-03",
				61.56
			],
			[
				"2005-07-26",
				62
			],
			[
				"2005-10-27",
				66.87
			],
			[
				"2007-07-09",
				60.23
			],
			[
				"2007-09-20",
				63.77
			],
			[
				"2007-01-03",
				65.54
			],
			[
				"2007-05-08",
				69.04
			],
			[
				"2007-07-23",
				68.02
			],
			[
				"2007-10-26",
				70.86
			],
			[
				"2008-01-24",
				70.02
			],
			[
				"2008-05-08",
				70.86
			],
			[
				"2008-07-30",
				67.31
			],
			[
				"2008-10-22",
				64.92
			],
			[
				"2010-01-25",
				63.53
			],
			[
				"2010-05-10",
				67.13
			],
			[
				"2010-07-19",
				69.23
			],
			[
				"2010-11-02",
				62.03
			],
			[
				"2011-01-24",
				15.11
			],
			[
				"2011-05-05",
				69.53
			],
			[
				"2011-07-28",
				68.64
			],
			[
				"2011-10-27",
				59.79
			],
			[
				"2012-01-26",
				68.2
			],
			[
				"2012-05-03",
				78.39
			],
			[
				"2012-07-26",
				77.06
			],
			[
				"2012-11-02",
				73.51
			],
			[
				"2012-11-13",
				80.16
			],
			[
				"2013-01-29",
				70.41
			],
			[
				"2013-06-17",
				77.94
			],
			[
				"2013-07-31",
				73.51
			],
			[
				"2013-10-30",
				77.5
			],
			[
				"2014-01-30",
				80.16
			],
			[
				"2014-05-12",
				75.73
			],
			[
				"2014-07-17",
				79.71
			],
			[
				"2014-10-14",
				83.26
			]
		],
		"70424019": [
			[
				"2011-04-05",
				13
			],
			[
				"2011-10-11",
				6
			],
			[
				"2012-04-02",
				12
			],
			[
				"2012-10-10",
				6
			],
			[
				"2013-04-09",
				15.01
			],
			[
				"2013-10-14",
				9
			],
			[
				"2014-04-08",
				10
			],
			[
				"2014-10-07",
				6
			],
			[
				"2015-04-14",
				20.01
			]
		],
		"70443208": [
			[
				"2000-02-07",
				18.01
			],
			[
				"2000-05-08",
				22.01
			],
			[
				"2001-10-08",
				21.01
			],
			[
				"2002-04-15",
				22.01
			],
			[
				"2007-06-11",
				15.01
			],
			[
				"2007-08-06",
				14
			],
			[
				"2007-09-03",
				22.01
			],
			[
				"2008-07-07",
				18.01
			],
			[
				"2007-01-15",
				14
			],
			[
				"2007-02-12",
				16.01
			],
			[
				"2007-03-12",
				16.01
			],
			[
				"2007-04-02",
				17.01
			],
			[
				"2007-05-07",
				16.01
			],
			[
				"2007-07-09",
				13
			],
			[
				"2008-10-13",
				12
			],
			[
				"2009-04-06",
				17.01
			],
			[
				"2009-10-05",
				12
			],
			[
				"2010-04-06",
				16.01
			],
			[
				"2010-10-04",
				14
			],
			[
				"2011-04-04",
				20.01
			],
			[
				"2011-10-10",
				20.01
			],
			[
				"2012-04-02",
				18.01
			],
			[
				"2012-10-08",
				13
			],
			[
				"2013-04-08",
				18.01
			],
			[
				"2013-10-14",
				17.01
			],
			[
				"2014-04-07",
				12
			],
			[
				"2014-10-06",
				11
			],
			[
				"2015-04-13",
				17.01
			]
		],
		"70465915": [
			[
				"2011-04-05",
				19.01
			],
			[
				"2011-10-11",
				18.01
			],
			[
				"2012-04-02",
				21.01
			],
			[
				"2012-10-10",
				12
			],
			[
				"2013-04-09",
				21.01
			],
			[
				"2013-10-14",
				17.01
			],
			[
				"2014-04-08",
				14
			],
			[
				"2014-10-07",
				7
			],
			[
				"2015-04-14",
				16.01
			]
		],
		"70466117": [
			[
				"2011-04-05",
				20.01
			],
			[
				"2011-10-11",
				31.01
			],
			[
				"2012-04-02",
				24.01
			],
			[
				"2012-10-10",
				22.01
			],
			[
				"2013-04-09",
				21.01
			],
			[
				"2013-10-14",
				18.01
			],
			[
				"2014-04-08",
				18.01
			],
			[
				"2014-10-07",
				34.01
			],
			[
				"2015-04-14",
				20.01
			]
		],
		"71100805": [
			[
				"2013-09-25",
				28.87
			],
			[
				"2014-08-19",
				27.72
			],
			[
				"2015-10-14",
				20.11
			],
			[
				"2007-06-26",
				32.68
			],
			[
				"2007-10-19",
				37.69
			],
			[
				"2008-08-25",
				31.27
			],
			[
				"2009-08-21",
				45.61
			],
			[
				"2010-07-20",
				46.5
			],
			[
				"2011-12-15",
				22.5
			]
		],
		"71200307": [
			[
				"2013-09-25",
				129.31
			],
			[
				"2014-08-19",
				131.09
			],
			[
				"2015-10-14",
				130.2
			],
			[
				"2007-06-26",
				170.5
			],
			[
				"2007-10-19",
				166.51
			],
			[
				"2008-08-25",
				147.03
			],
			[
				"2009-08-21",
				134.19
			],
			[
				"2010-07-20",
				148.8
			],
			[
				"2011-12-15",
				142.6
			]
		],
		"73311613": [
			[
				"2000-08-01",
				54.91
			],
			[
				"2001-07-31",
				57.57
			],
			[
				"2002-07-15",
				46.06
			],
			[
				"2003-09-15",
				59.34
			],
			[
				"2004-07-01",
				56.24
			],
			[
				"2005-07-25",
				57.57
			],
			[
				"2006-11-20",
				55.36
			],
			[
				"2013-06-04",
				49.02
			],
			[
				"2012-10-16",
				50.52
			],
			[
				"2015-06-18",
				50.82
			],
			[
				"2014-09-29",
				46.42
			]
		],
		"73506813": [
			[
				"2013-08-14",
				30.96
			],
			[
				"2014-08-06",
				30.11
			],
			[
				"2015-06-23",
				32.2
			],
			[
				"2000-08-02",
				35.21
			],
			[
				"2001-07-11",
				32.73
			],
			[
				"2002-07-18",
				31.35
			],
			[
				"2003-09-17",
				32.73
			],
			[
				"2005-07-15",
				38.09
			],
			[
				"2006-11-22",
				40.21
			],
			[
				"2007-07-16",
				41.85
			],
			[
				"2007-09-20",
				41.85
			],
			[
				"2008-07-14",
				33.13
			],
			[
				"2009-08-03",
				30.29
			],
			[
				"2010-06-21",
				27.81
			],
			[
				"2011-08-16",
				27.01
			]
		],
		"73508615": [
			[
				"2015-07-06",
				44.73
			],
			[
				"2000-08-03",
				49.6
			],
			[
				"2001-07-11",
				50.93
			],
			[
				"2002-07-18",
				48.27
			],
			[
				"2003-09-17",
				45.61
			],
			[
				"2005-07-15",
				40.96
			],
			[
				"2006-11-22",
				38.93
			],
			[
				"2007-07-10",
				43.27
			],
			[
				"2007-09-20",
				46.94
			],
			[
				"2008-07-14",
				41.5
			],
			[
				"2009-08-03",
				41.5
			],
			[
				"2010-06-21",
				42.65
			]
		],
		"73509310": [
			[
				"2000-08-03",
				13.51
			],
			[
				"2001-07-12",
				12.75
			],
			[
				"2002-07-18",
				18.25
			],
			[
				"2003-09-17",
				11.91
			],
			[
				"2004-07-13",
				17.85
			],
			[
				"2005-07-15",
				12.89
			],
			[
				"2006-11-22",
				17.85
			],
			[
				"2012-05-02",
				12.4
			],
			[
				"2013-10-14",
				13.1
			],
			[
				"2014-04-09",
				11.6
			],
			[
				"2015-10-01",
				11.3
			]
		],
		"73510312": [
			[
				"2013-08-14",
				17.23
			],
			[
				"2014-08-06",
				18.38
			],
			[
				"2015-06-11",
				16.65
			],
			[
				"2007-07-10",
				21.39
			],
			[
				"2007-10-01",
				19.35
			],
			[
				"2008-07-14",
				19.49
			],
			[
				"2009-08-03",
				16.16
			],
			[
				"2010-06-21",
				36.54
			],
			[
				"2011-08-16",
				17.71
			]
		],
		"73510919": [
			[
				"2000-08-03",
				33.61
			],
			[
				"2001-07-12",
				51.37
			],
			[
				"2002-07-18",
				28.74
			],
			[
				"2003-09-17",
				35.47
			],
			[
				"2004-07-13",
				21.66
			],
			[
				"2005-08-01",
				23.69
			],
			[
				"2006-11-22",
				19.4
			],
			[
				"2012-05-02",
				21.41
			],
			[
				"2013-10-14",
				25.61
			],
			[
				"2014-04-09",
				18.31
			],
			[
				"2015-10-05",
				22.41
			]
		],
		"73512515": [
			[
				"2000-08-02",
				19.66
			],
			[
				"2001-07-31",
				16.39
			],
			[
				"2002-07-15",
				19.49
			],
			[
				"2003-09-15",
				22.81
			],
			[
				"2004-07-05",
				22.85
			],
			[
				"2005-07-25",
				24.31
			],
			[
				"2006-11-20",
				24.31
			],
			[
				"2012-05-02",
				17.81
			],
			[
				"2013-10-15",
				17.11
			],
			[
				"2014-04-10",
				17.41
			],
			[
				"2015-10-05",
				18.41
			]
		],
		"73512618": [
			[
				"2013-08-13",
				40.83
			],
			[
				"2014-08-07",
				42.87
			],
			[
				"2015-06-11",
				44.02
			],
			[
				"2007-07-10",
				42.34
			],
			[
				"2007-10-01",
				42.07
			],
			[
				"2008-07-14",
				31.89
			],
			[
				"2009-08-03",
				34.99
			],
			[
				"2010-06-21",
				18.02
			],
			[
				"2011-08-15",
				33.21
			]
		],
		"73529217": [
			[
				"2013-07-24",
				48.71
			],
			[
				"2014-10-02",
				43.8
			],
			[
				"2015-08-13",
				44.73
			],
			[
				"2007-06-28",
				58.01
			],
			[
				"2007-10-01",
				61.11
			],
			[
				"2008-07-11",
				59.79
			],
			[
				"2009-07-28",
				59.79
			],
			[
				"2010-07-02",
				59.79
			],
			[
				"2011-05-27",
				57.57
			]
		],
		"73529412": [
			[
				"2013-07-24",
				39.15
			],
			[
				"2014-08-12",
				42.38
			],
			[
				"2015-07-13",
				42.74
			],
			[
				"2007-06-28",
				47.39
			],
			[
				"2007-10-01",
				45.61
			],
			[
				"2008-07-11",
				49.6
			],
			[
				"2009-07-28",
				46.94
			],
			[
				"2010-07-02",
				50.93
			],
			[
				"2011-05-27",
				44.29
			]
		],
		"73537410": [
			[
				"2013-08-21",
				30.96
			],
			[
				"2014-09-17",
				34.54
			],
			[
				"2015-07-02",
				32.2
			],
			[
				"2000-08-04",
				38.04
			],
			[
				"2001-07-12",
				35.74
			],
			[
				"2002-07-17",
				38.22
			],
			[
				"2003-09-18",
				37.42
			],
			[
				"2005-07-26",
				39.06
			],
			[
				"2007-07-10",
				34.72
			],
			[
				"2007-09-20",
				33.39
			],
			[
				"2008-07-16",
				30.11
			],
			[
				"2009-08-05",
				33.88
			],
			[
				"2010-06-23",
				36.58
			],
			[
				"2011-08-18",
				38.53
			]
		],
		"73542015": [
			[
				"2013-08-26",
				36.4
			],
			[
				"2014-08-05",
				32.46
			],
			[
				"2015-06-16",
				35.21
			],
			[
				"2002-04-25",
				44.73
			],
			[
				"2002-09-19",
				46.06
			],
			[
				"2003-03-31",
				44.73
			],
			[
				"2003-11-19",
				39.28
			],
			[
				"2007-07-16",
				38.57
			],
			[
				"2007-10-02",
				36.27
			],
			[
				"2008-07-16",
				32.86
			],
			[
				"2009-08-05",
				37.38
			],
			[
				"2010-06-23",
				37.11
			],
			[
				"2011-08-18",
				31.44
			]
		],
		"73546010": [
			[
				"2013-08-26",
				34.32
			],
			[
				"2014-08-05",
				31
			],
			[
				"2015-06-16",
				37.07
			],
			[
				"2002-04-22",
				24.58
			],
			[
				"2002-09-16",
				28.96
			],
			[
				"2003-03-24",
				25.24
			],
			[
				"2003-11-12",
				28.79
			],
			[
				"2007-07-16",
				41.58
			],
			[
				"2007-10-02",
				41.36
			],
			[
				"2009-08-04",
				41.23
			],
			[
				"2010-06-22",
				40.7
			],
			[
				"2011-08-17",
				34.54
			]
		],
		"73553815": [
			[
				"2013-08-13",
				24.45
			],
			[
				"2014-08-07",
				24.18
			],
			[
				"2015-06-11",
				22.32
			],
			[
				"2007-07-11",
				26.53
			],
			[
				"2007-10-02",
				27.99
			],
			[
				"2008-07-17",
				26.7
			],
			[
				"2009-08-06",
				27.41
			],
			[
				"2010-06-24",
				29.05
			],
			[
				"2011-08-19",
				27.01
			]
		],
		"73560110": [
			[
				"2013-08-26",
				45.61
			],
			[
				"2014-08-26",
				44.24
			],
			[
				"2015-07-01",
				39.33
			],
			[
				"2002-04-24",
				112.04
			],
			[
				"2002-09-18",
				110.27
			],
			[
				"2003-03-27",
				105.4
			],
			[
				"2003-11-17",
				101.86
			],
			[
				"2007-07-11",
				85.47
			],
			[
				"2007-10-04",
				85.03
			],
			[
				"2008-07-15",
				79.27
			],
			[
				"2009-08-04",
				77.94
			],
			[
				"2010-06-22",
				79.27
			],
			[
				"2011-08-17",
				62
			]
		],
		"73561915": [
			[
				"2013-08-19",
				38.71
			],
			[
				"2014-09-30",
				37.2
			],
			[
				"2015-06-30",
				36.4
			],
			[
				"2002-04-25",
				46.06
			],
			[
				"2002-09-19",
				48.27
			],
			[
				"2003-03-28",
				47.39
			],
			[
				"2003-11-18",
				46.5
			],
			[
				"2007-07-17",
				34.72
			],
			[
				"2007-10-04",
				36.31
			],
			[
				"2008-07-17",
				32.95
			],
			[
				"2009-08-06",
				35.03
			],
			[
				"2010-06-24",
				37.69
			],
			[
				"2011-08-19",
				33.66
			]
		],
		"73564217": [
			[
				"2013-08-22",
				28.83
			],
			[
				"2014-10-01",
				30.42
			],
			[
				"2015-07-03",
				28.3
			],
			[
				"2002-04-25",
				35.47
			],
			[
				"2002-09-30",
				31.71
			],
			[
				"2003-03-31",
				33.75
			],
			[
				"2003-11-20",
				35.25
			],
			[
				"2007-07-23",
				34.63
			],
			[
				"2007-10-04",
				33.21
			],
			[
				"2008-07-17",
				31.4
			],
			[
				"2009-08-06",
				32.95
			],
			[
				"2010-06-24",
				35.56
			],
			[
				"2011-08-19",
				31
			]
		],
		"73567012": [
			[
				"2013-08-20",
				48.71
			],
			[
				"2014-08-13",
				53.14
			],
			[
				"2015-06-22",
				46.06
			],
			[
				"2007-07-12",
				116.03
			],
			[
				"2007-10-04",
				112.04
			],
			[
				"2008-07-15",
				74.84
			],
			[
				"2009-08-04",
				97.43
			],
			[
				"2010-06-22",
				75.73
			],
			[
				"2011-08-17",
				84.14
			]
		],
		"73725500": [
			[
				"2013-10-11",
				14.66
			],
			[
				"2014-06-26",
				15.94
			],
			[
				"2015-03-23",
				16.65
			],
			[
				"2016-03-14",
				13.73
			],
			[
				"2000-08-16",
				13.82
			],
			[
				"2001-08-03",
				14.57
			],
			[
				"2002-08-20",
				15.28
			],
			[
				"2003-10-09",
				15.28
			],
			[
				"2004-07-19",
				16.92
			],
			[
				"2005-08-08",
				18.25
			],
			[
				"2007-08-13",
				18.82
			],
			[
				"2007-10-22",
				20.19
			],
			[
				"2008-08-26",
				17.05
			],
			[
				"2009-10-28",
				16.39
			],
			[
				"2010-11-04",
				14.61
			],
			[
				"2011-12-06",
				12.62
			]
		],
		"73725687": [
			[
				"2013-10-11",
				1.33
			],
			[
				"2014-06-16",
				1.33
			],
			[
				"2015-03-19",
				1.55
			],
			[
				"2016-03-14",
				1.64
			],
			[
				"2000-08-25",
				2.44
			],
			[
				"2001-08-03",
				2.21
			],
			[
				"2002-08-22",
				2.21
			],
			[
				"2003-10-09",
				2.21
			],
			[
				"2004-07-19",
				2.21
			],
			[
				"2005-08-08",
				2.21
			],
			[
				"2007-08-13",
				2.21
			],
			[
				"2008-08-26",
				2.21
			],
			[
				"2009-11-04",
				2.21
			],
			[
				"2007-10-22",
				2.21
			],
			[
				"2010-09-09",
				1.33
			],
			[
				"2011-11-21",
				1.37
			]
		],
		"73725780": [
			[
				"2013-10-11",
				17.49
			],
			[
				"2014-06-16",
				17.8
			],
			[
				"2015-03-23",
				17.54
			],
			[
				"2016-03-14",
				15.06
			],
			[
				"2000-08-16",
				20.81
			],
			[
				"2001-08-03",
				22.5
			],
			[
				"2002-08-20",
				21.21
			],
			[
				"2003-10-09",
				16.96
			],
			[
				"2004-08-04",
				20.5
			],
			[
				"2005-08-08",
				20.24
			],
			[
				"2007-08-13",
				19.75
			],
			[
				"2008-08-26",
				21.17
			],
			[
				"2009-11-04",
				17.14
			],
			[
				"2007-10-22",
				20.68
			],
			[
				"2010-09-09",
				19.49
			],
			[
				"2011-11-21",
				18.64
			]
		],
		"73725900": [
			[
				"2013-10-29",
				1.33
			],
			[
				"2014-06-11",
				1.33
			],
			[
				"2015-03-19",
				1.33
			],
			[
				"2016-03-23",
				1.33
			],
			[
				"2000-08-16",
				2.21
			],
			[
				"2001-08-03",
				2.21
			],
			[
				"2002-08-20",
				2.21
			],
			[
				"2003-10-10",
				6.78
			],
			[
				"2004-07-20",
				3.76
			],
			[
				"2005-08-10",
				2.21
			],
			[
				"2007-08-13",
				2.21
			],
			[
				"2008-08-26",
				2.21
			],
			[
				"2009-11-04",
				2.21
			],
			[
				"2007-10-22",
				2.21
			],
			[
				"2010-09-09",
				1.33
			],
			[
				"2011-11-21",
				0.66
			]
		],
		"73726000": [
			[
				"2013-10-29",
				12.31
			],
			[
				"2014-06-26",
				12.49
			],
			[
				"2015-03-24",
				13.11
			],
			[
				"2016-03-23",
				12.4
			],
			[
				"2000-09-19",
				9.7
			],
			[
				"2001-08-06",
				12.09
			],
			[
				"2002-09-25",
				12.62
			],
			[
				"2003-10-08",
				11.96
			],
			[
				"2004-06-15",
				10.81
			],
			[
				"2005-06-21",
				11.29
			],
			[
				"2007-08-14",
				11.34
			],
			[
				"2008-10-27",
				10.41
			],
			[
				"2009-10-28",
				11.96
			],
			[
				"2007-10-23",
				18.25
			],
			[
				"2010-08-25",
				4.25
			],
			[
				"2011-12-05",
				11.2
			]
		],
		"73726280": [
			[
				"2013-10-29",
				5.27
			],
			[
				"2014-09-24",
				1.77
			],
			[
				"2015-03-24",
				2.7
			],
			[
				"2016-03-08",
				6.64
			],
			[
				"2000-08-18",
				2.21
			],
			[
				"2001-08-06",
				2.21
			],
			[
				"2002-08-21",
				2.21
			],
			[
				"2003-10-10",
				3.76
			],
			[
				"2004-08-04",
				2.21
			],
			[
				"2005-08-10",
				2.21
			],
			[
				"2007-10-23",
				2.21
			],
			[
				"2008-10-30",
				3.99
			],
			[
				"2009-10-29",
				2.21
			],
			[
				"2011-07-12",
				1.33
			]
		],
		"73726382": [
			[
				"2013-12-09",
				17.18
			],
			[
				"2014-11-14",
				17.8
			],
			[
				"2015-12-18",
				17.49
			],
			[
				"2016-03-08",
				19.04
			],
			[
				"2000-08-18",
				20.19
			],
			[
				"2001-08-06",
				20.15
			],
			[
				"2002-09-03",
				21.04
			],
			[
				"2003-10-13",
				19.35
			],
			[
				"2004-08-04",
				20.24
			],
			[
				"2005-08-10",
				20.95
			],
			[
				"2007-08-14",
				20.5
			],
			[
				"2007-10-23",
				20.33
			],
			[
				"2008-10-27",
				18.51
			],
			[
				"2009-11-16",
				19.35
			],
			[
				"2010-11-11",
				18.16
			],
			[
				"2011-12-05",
				19.62
			]
		],
		"73726680": [
			[
				"2013-06-27",
				19.62
			],
			[
				"2014-11-14",
				16.43
			],
			[
				"2015-10-23",
				17.63
			],
			[
				"2016-03-23",
				17.71
			],
			[
				"2000-08-18",
				12.4
			],
			[
				"2001-08-07",
				12.13
			],
			[
				"2002-08-21",
				11.03
			],
			[
				"2003-10-13",
				11.91
			],
			[
				"2004-07-20",
				12
			],
			[
				"2005-08-12",
				14.88
			],
			[
				"2008-10-30",
				24.71
			],
			[
				"2009-11-16",
				30.96
			],
			[
				"2007-10-24",
				22.63
			],
			[
				"2010-11-04",
				23.91
			],
			[
				"2011-12-06",
				18.02
			]
		],
		"73727088": [
			[
				"2013-10-11",
				8.55
			],
			[
				"2014-06-06",
				9.03
			],
			[
				"2015-03-23",
				12.09
			],
			[
				"2000-08-15",
				8.9
			],
			[
				"2001-08-02",
				5.23
			],
			[
				"2002-08-21",
				18.38
			],
			[
				"2003-10-13",
				9.26
			],
			[
				"2004-07-21",
				9.21
			],
			[
				"2005-08-12",
				13.06
			],
			[
				"2007-08-15",
				21.97
			],
			[
				"2008-10-30",
				13.64
			],
			[
				"2009-10-29",
				8.59
			],
			[
				"2007-10-24",
				11.69
			],
			[
				"2010-08-25",
				14.61
			],
			[
				"2011-12-05",
				7.4
			]
		],
		"73727180": [
			[
				"2015-03-24",
				35.03
			],
			[
				"2000-08-15",
				29.98
			],
			[
				"2001-08-07",
				37.42
			],
			[
				"2002-08-21",
				20.06
			],
			[
				"2003-10-13",
				28.79
			],
			[
				"2004-07-21",
				32.06
			],
			[
				"2005-08-12",
				35.21
			],
			[
				"2007-08-15",
				34.72
			],
			[
				"2007-10-24",
				37.38
			],
			[
				"2008-10-30",
				27.37
			],
			[
				"2009-10-29",
				40.79
			],
			[
				"2010-08-25",
				35.43
			],
			[
				"2011-12-05",
				19.26
			]
		],
		"73727283": [
			[
				"2013-10-28",
				8.33
			],
			[
				"2014-10-31",
				9.61
			],
			[
				"2015-10-08",
				9.48
			],
			[
				"2000-08-22",
				6.33
			],
			[
				"2001-08-07",
				6.38
			],
			[
				"2003-10-14",
				6.11
			],
			[
				"2004-07-21",
				6.07
			],
			[
				"2005-08-17",
				7
			],
			[
				"2007-08-15",
				6.47
			],
			[
				"2007-10-18",
				6.78
			],
			[
				"2008-08-22",
				7.13
			],
			[
				"2009-10-07",
				7.62
			],
			[
				"2010-10-04",
				7.09
			],
			[
				"2011-12-13",
				7.93
			]
		],
		"73727301": [
			[
				"2013-10-14",
				2.35
			],
			[
				"2014-09-24",
				5.54
			],
			[
				"2015-03-25",
				14.35
			],
			[
				"2000-08-22",
				26.26
			],
			[
				"2001-08-07",
				15.9
			],
			[
				"2002-08-22",
				27.77
			],
			[
				"2003-10-14",
				16.39
			],
			[
				"2004-07-21",
				15.54
			],
			[
				"2005-08-17",
				2.21
			],
			[
				"2007-08-15",
				2.21
			],
			[
				"2008-08-22",
				2.21
			],
			[
				"2009-10-07",
				11.56
			],
			[
				"2007-10-18",
				2.21
			],
			[
				"2010-10-04",
				2.04
			],
			[
				"2011-12-13",
				7.79
			]
		],
		"73736806": [
			[
				"2000-03-15",
				5
			],
			[
				"2000-09-13",
				5.6
			],
			[
				"2001-03-23",
				5
			],
			[
				"2001-10-08",
				5
			],
			[
				"2002-03-11",
				5
			],
			[
				"2002-09-25",
				5
			],
			[
				"2003-04-03",
				5
			],
			[
				"2003-09-15",
				5
			],
			[
				"2004-04-08",
				5
			],
			[
				"2004-09-14",
				5
			],
			[
				"2005-04-21",
				5
			],
			[
				"2005-09-27",
				5
			],
			[
				"2006-04-26",
				5.6
			],
			[
				"2006-10-18",
				5
			],
			[
				"2007-05-02",
				5
			],
			[
				"2007-10-16",
				5
			],
			[
				"2008-04-09",
				5
			],
			[
				"2008-10-28",
				5
			],
			[
				"2009-04-21",
				5
			],
			[
				"2009-10-26",
				5
			],
			[
				"2010-04-29",
				5
			],
			[
				"2010-10-14",
				5.4
			],
			[
				"2011-04-27",
				5
			],
			[
				"2011-10-20",
				5.2
			],
			[
				"2012-04-17",
				5
			],
			[
				"2012-10-30",
				5.3
			],
			[
				"2013-04-15",
				5
			],
			[
				"2013-10-22",
				5
			],
			[
				"2014-04-14",
				5
			],
			[
				"2014-10-09",
				5
			],
			[
				"2015-04-09",
				5.3
			],
			[
				"2015-09-21",
				5
			]
		],
		"73737288": [
			[
				"2013-10-24",
				13.51
			],
			[
				"2014-11-06",
				40.83
			],
			[
				"2015-04-01",
				42.96
			],
			[
				"2016-03-24",
				41.19
			],
			[
				"2000-08-10",
				39.72
			],
			[
				"2001-07-26",
				40.17
			],
			[
				"2002-08-16",
				39.55
			],
			[
				"2003-09-25",
				40.96
			],
			[
				"2004-07-22",
				35.47
			],
			[
				"2005-08-15",
				37.95
			],
			[
				"2007-08-16",
				33.08
			],
			[
				"2008-10-20",
				37.51
			],
			[
				"2009-12-03",
				40.12
			],
			[
				"2007-10-25",
				35.87
			],
			[
				"2011-12-14",
				41.5
			]
		],
		"73737380": [
			[
				"2013-10-24",
				10.5
			],
			[
				"2014-07-15",
				8.9
			],
			[
				"2015-04-08",
				10.45
			],
			[
				"2000-08-14",
				16.47
			],
			[
				"2001-08-02",
				16.7
			],
			[
				"2002-08-19",
				14.17
			],
			[
				"2004-07-26",
				14.53
			],
			[
				"2005-08-16",
				15.94
			],
			[
				"2007-08-17",
				13.73
			],
			[
				"2008-10-16",
				11.43
			],
			[
				"2009-11-05",
				14.17
			],
			[
				"2007-10-29",
				13.95
			],
			[
				"2011-05-30",
				10.63
			]
		],
		"73738517": [
			[
				"2000-08-07",
				3.5
			],
			[
				"2002-08-06",
				2.21
			],
			[
				"2012-02-06",
				5.9
			],
			[
				"2013-08-05",
				5
			],
			[
				"2015-01-20",
				5
			],
			[
				"2014-07-22",
				5
			]
		],
		"73746710": [
			[
				"2013-07-11",
				21.61
			],
			[
				"2014-08-27",
				33.75
			],
			[
				"2015-07-31",
				27.37
			],
			[
				"2000-07-24",
				24.22
			],
			[
				"2001-07-17",
				25.91
			],
			[
				"2002-08-07",
				38.13
			],
			[
				"2003-09-04",
				39.72
			],
			[
				"2006-10-17",
				32.86
			],
			[
				"2007-06-27",
				32.46
			],
			[
				"2007-09-24",
				37.78
			],
			[
				"2008-07-25",
				34.59
			],
			[
				"2009-08-10",
				35.83
			],
			[
				"2010-07-06",
				37.51
			],
			[
				"2011-06-08",
				33.66
			]
		],
		"73751789": [
			[
				"2013-10-24",
				33.75
			],
			[
				"2014-11-06",
				33.35
			],
			[
				"2015-04-08",
				45.61
			],
			[
				"2000-08-14",
				25.29
			],
			[
				"2001-08-02",
				19.22
			],
			[
				"2002-08-19",
				19.53
			],
			[
				"2003-09-26",
				19.93
			],
			[
				"2004-07-26",
				27.15
			],
			[
				"2005-08-16",
				33.26
			],
			[
				"2007-08-17",
				39.5
			],
			[
				"2007-10-29",
				29.01
			],
			[
				"2008-10-16",
				29.85
			],
			[
				"2009-11-05",
				24.09
			],
			[
				"2011-05-30",
				22.59
			]
		],
		"73756507": [
			[
				"2000-03-15",
				15.01
			],
			[
				"2000-09-13",
				16.51
			],
			[
				"2001-03-23",
				15.71
			],
			[
				"2001-10-08",
				6.6
			],
			[
				"2002-03-11",
				14.31
			],
			[
				"2002-09-25",
				13.1
			],
			[
				"2003-04-03",
				14.61
			],
			[
				"2003-09-15",
				12.8
			],
			[
				"2004-04-08",
				15.31
			],
			[
				"2004-09-14",
				15.41
			],
			[
				"2005-04-21",
				16.11
			],
			[
				"2005-09-27",
				15.11
			],
			[
				"2006-04-26",
				16.51
			],
			[
				"2006-10-18",
				12.3
			],
			[
				"2007-05-02",
				16.01
			],
			[
				"2007-10-16",
				15.91
			],
			[
				"2008-04-09",
				15.41
			],
			[
				"2008-10-28",
				15.61
			],
			[
				"2009-04-21",
				14.71
			],
			[
				"2009-10-26",
				13.8
			],
			[
				"2010-04-29",
				15.31
			],
			[
				"2010-10-14",
				15.21
			],
			[
				"2011-04-27",
				14.61
			],
			[
				"2011-10-20",
				14.81
			],
			[
				"2012-04-17",
				13.8
			],
			[
				"2012-10-30",
				13.3
			],
			[
				"2013-04-15",
				13.3
			],
			[
				"2013-10-22",
				12.9
			],
			[
				"2014-04-14",
				13.3
			],
			[
				"2014-10-09",
				12.8
			],
			[
				"2015-04-09",
				13.8
			],
			[
				"2015-09-21",
				12.3
			]
		],
		"73756714": [
			[
				"2000-04-19",
				31.62
			],
			[
				"2000-09-11",
				26.88
			],
			[
				"2002-08-07",
				22.1
			],
			[
				"2003-09-05",
				23.83
			],
			[
				"2004-06-24",
				30.47
			],
			[
				"2005-08-02",
				27.72
			],
			[
				"2012-06-04",
				29.31
			],
			[
				"2013-10-30",
				28.31
			],
			[
				"2014-05-14",
				28.21
			],
			[
				"2015-10-22",
				28.81
			]
		],
		"73756817": [
			[
				"2013-08-20",
				18.87
			],
			[
				"2015-06-24",
				19.35
			],
			[
				"2000-05-11",
				26.79
			],
			[
				"2000-09-11",
				23.25
			],
			[
				"2001-07-18",
				21.79
			],
			[
				"2002-08-07",
				18.64
			],
			[
				"2003-09-05",
				20.42
			],
			[
				"2004-06-24",
				20.99
			],
			[
				"2005-08-02",
				26.97
			],
			[
				"2006-10-19",
				22.72
			],
			[
				"2007-06-27",
				25.24
			],
			[
				"2007-09-24",
				24.67
			],
			[
				"2008-07-21",
				25.55
			],
			[
				"2009-08-07",
				22.67
			],
			[
				"2010-06-25",
				23.83
			],
			[
				"2011-08-22",
				19.04
			]
		],
		"73757421": [
			[
				"2000-07-26",
				9.65
			],
			[
				"2000-04-12",
				10.89
			],
			[
				"2002-08-08",
				6.6
			],
			[
				"2003-09-08",
				5.58
			],
			[
				"2004-06-28",
				7.48
			],
			[
				"2005-07-22",
				6.82
			],
			[
				"2006-10-20",
				5.27
			],
			[
				"2013-03-13",
				10.1
			],
			[
				"2012-08-22",
				7.5
			],
			[
				"2015-03-12",
				9.8
			],
			[
				"2014-08-18",
				7.3
			]
		],
		"73757433": [
			[
				"2013-08-15",
				13.2
			],
			[
				"2014-08-13",
				15.01
			],
			[
				"2015-06-24",
				13.2
			],
			[
				"2000-07-26",
				12.67
			],
			[
				"2001-07-19",
				13.55
			],
			[
				"2000-04-12",
				13.2
			],
			[
				"2002-08-08",
				13.42
			],
			[
				"2003-09-08",
				12.89
			],
			[
				"2004-06-28",
				15.85
			],
			[
				"2005-07-22",
				16.92
			],
			[
				"2006-10-20",
				17.8
			],
			[
				"2007-07-17",
				17.85
			],
			[
				"2007-10-05",
				18.11
			],
			[
				"2008-07-21",
				5.31
			],
			[
				"2009-08-07",
				15.81
			],
			[
				"2010-06-25",
				15.32
			],
			[
				"2011-08-16",
				16.39
			]
		],
		"73757512": [
			[
				"2000-04-12",
				23.56
			],
			[
				"2000-08-07",
				23.38
			],
			[
				"2001-07-18",
				22.54
			],
			[
				"2002-08-09",
				21.43
			],
			[
				"2003-09-09",
				18.29
			],
			[
				"2004-06-28",
				21.35
			],
			[
				"2005-07-28",
				16.34
			],
			[
				"2006-10-20",
				19
			],
			[
				"2013-03-14",
				18.61
			],
			[
				"2012-08-23",
				17.71
			],
			[
				"2015-03-19",
				19.11
			],
			[
				"2014-08-19",
				19.21
			]
		],
		"73761308": [
			[
				"2001-09-26",
				2.21
			],
			[
				"2002-04-08",
				2.21
			],
			[
				"2002-10-01",
				2.21
			],
			[
				"2003-04-09",
				6.69
			],
			[
				"2004-06-17",
				1
			],
			[
				"2004-11-03",
				1
			],
			[
				"2003-05-26",
				1
			],
			[
				"2002-11-26",
				1
			],
			[
				"2002-08-06",
				1
			],
			[
				"2001-12-05",
				1
			],
			[
				"2009-05-04",
				6
			],
			[
				"2009-11-02",
				6
			],
			[
				"2007-06-11",
				6
			],
			[
				"2003-11-25",
				1
			],
			[
				"2010-05-04",
				6
			],
			[
				"2010-11-22",
				6
			],
			[
				"2011-05-16",
				5
			],
			[
				"2011-11-15",
				5
			],
			[
				"2012-06-14",
				5
			],
			[
				"2012-11-21",
				6
			],
			[
				"2013-05-14",
				6
			],
			[
				"2013-11-18",
				6
			],
			[
				"2014-05-05",
				6
			],
			[
				"2014-11-11",
				6
			],
			[
				"2015-05-19",
				6
			]
		],
		"73765211": [
			[
				"2013-09-20",
				45.61
			],
			[
				"2014-08-25",
				46.5
			],
			[
				"2015-07-15",
				59.34
			],
			[
				"2007-07-12",
				47.83
			],
			[
				"2007-10-05",
				36.76
			],
			[
				"2008-08-21",
				52.7
			],
			[
				"2009-09-09",
				59.79
			],
			[
				"2010-07-22",
				52.7
			],
			[
				"2011-08-22",
				57.57
			]
		],
		"73767610": [
			[
				"2013-08-09",
				21.43
			],
			[
				"2015-08-03",
				16.3
			],
			[
				"2002-10-09",
				30.03
			],
			[
				"2003-04-15",
				29.76
			],
			[
				"2003-11-07",
				28.08
			],
			[
				"2004-04-14",
				25.15
			],
			[
				"2007-07-12",
				21.83
			],
			[
				"2007-10-08",
				22.54
			],
			[
				"2008-07-30",
				22.23
			],
			[
				"2009-08-18",
				21.39
			],
			[
				"2010-07-15",
				20.86
			],
			[
				"2011-08-23",
				19.93
			]
		],
		"73770504": [
			[
				"2001-09-25",
				30.87
			],
			[
				"2002-04-08",
				31.13
			],
			[
				"2001-07-04",
				31.01
			],
			[
				"2002-10-01",
				30.03
			],
			[
				"2003-04-08",
				29.89
			],
			[
				"2004-06-17",
				28.01
			],
			[
				"2004-08-23",
				27.41
			],
			[
				"2004-11-03",
				26.79
			],
			[
				"2003-05-26",
				28.21
			],
			[
				"2002-11-26",
				29.61
			],
			[
				"2002-08-06",
				29.01
			],
			[
				"2007-11-05",
				26.51
			],
			[
				"2008-05-26",
				28.21
			],
			[
				"2008-11-03",
				27.11
			],
			[
				"2009-05-04",
				27.81
			],
			[
				"2009-11-02",
				28.81
			],
			[
				"2007-06-11",
				25.71
			],
			[
				"2006-11-27",
				24.71
			],
			[
				"2006-05-09",
				25.51
			],
			[
				"2005-05-10",
				27.61
			],
			[
				"2005-11-21",
				28.51
			],
			[
				"2003-11-25",
				27.61
			],
			[
				"2010-05-04",
				27.81
			],
			[
				"2010-11-22",
				27.01
			],
			[
				"2011-05-16",
				26.01
			],
			[
				"2011-11-15",
				21.01
			],
			[
				"2012-06-14",
				29.01
			],
			[
				"2012-11-12",
				29.01
			],
			[
				"2013-05-14",
				30.01
			],
			[
				"2013-11-18",
				30.01
			],
			[
				"2014-05-05",
				30.01
			],
			[
				"2014-11-11",
				31.01
			],
			[
				"2015-05-19",
				31.01
			]
		],
		"73770607": [
			[
				"2001-07-04",
				22.01
			],
			[
				"2004-06-17",
				18.31
			],
			[
				"2004-11-03",
				21.61
			],
			[
				"2003-05-26",
				20.19
			],
			[
				"2002-11-26",
				20.99
			],
			[
				"2002-08-06",
				21.01
			],
			[
				"2009-11-02",
				21.11
			],
			[
				"2009-05-04",
				21.31
			],
			[
				"2008-11-03",
				19.51
			],
			[
				"2008-05-26",
				21.11
			],
			[
				"2007-11-05",
				17.71
			],
			[
				"2007-06-13",
				16.31
			],
			[
				"2006-11-27",
				15.81
			],
			[
				"2006-05-09",
				16.51
			],
			[
				"2005-05-10",
				18.51
			],
			[
				"2005-11-21",
				18.11
			],
			[
				"2003-11-25",
				17.81
			],
			[
				"2010-05-04",
				21.31
			],
			[
				"2010-11-22",
				21.01
			],
			[
				"2011-05-16",
				20.01
			],
			[
				"2011-11-15",
				22.01
			],
			[
				"2012-06-14",
				21.01
			],
			[
				"2012-11-12",
				20.01
			],
			[
				"2013-05-14",
				21.01
			],
			[
				"2013-11-18",
				20.01
			],
			[
				"2014-05-05",
				21.01
			],
			[
				"2014-11-11",
				21.01
			],
			[
				"2015-05-19",
				24.01
			]
		],
		"73770802": [
			[
				"2001-07-04",
				25.51
			],
			[
				"2004-06-17",
				24.58
			],
			[
				"2004-11-03",
				25.2
			],
			[
				"2003-05-26",
				23.78
			],
			[
				"2002-11-26",
				24.4
			],
			[
				"2002-08-06",
				23.01
			],
			[
				"2009-11-02",
				26.41
			],
			[
				"2009-05-04",
				25.81
			],
			[
				"2008-11-03",
				24.71
			],
			[
				"2008-05-26",
				25.01
			],
			[
				"2007-11-05",
				28.61
			],
			[
				"2007-06-13",
				25.11
			],
			[
				"2006-11-27",
				24.91
			],
			[
				"2006-05-09",
				23.91
			],
			[
				"2005-05-10",
				25.41
			],
			[
				"2005-11-21",
				25.91
			],
			[
				"2003-11-25",
				24.31
			],
			[
				"2010-05-04",
				26.21
			],
			[
				"2010-11-22",
				28.01
			],
			[
				"2011-05-16",
				25.01
			],
			[
				"2011-11-15",
				30.01
			],
			[
				"2012-11-12",
				30.01
			],
			[
				"2013-05-14",
				30.01
			],
			[
				"2013-11-18",
				29.01
			],
			[
				"2014-05-05",
				29.01
			],
			[
				"2014-11-11",
				29.01
			],
			[
				"2015-05-19",
				27.01
			]
		],
		"73770905": [
			[
				"2001-09-26",
				30.29
			],
			[
				"2002-04-08",
				31.35
			],
			[
				"2002-10-01",
				32.64
			],
			[
				"2003-04-09",
				34.5
			],
			[
				"2004-11-03",
				29.31
			],
			[
				"2003-05-26",
				32.06
			],
			[
				"2002-11-26",
				32.15
			],
			[
				"2002-08-06",
				31.01
			],
			[
				"2009-11-02",
				32.91
			],
			[
				"2009-05-04",
				32.11
			],
			[
				"2008-11-03",
				28.71
			],
			[
				"2008-05-26",
				29.91
			],
			[
				"2007-11-05",
				28.81
			],
			[
				"2007-06-13",
				27.51
			],
			[
				"2006-11-27",
				27.51
			],
			[
				"2006-05-09",
				27.61
			],
			[
				"2005-05-10",
				31.01
			],
			[
				"2005-11-21",
				31.71
			],
			[
				"2004-01-22",
				32.11
			],
			[
				"2010-05-04",
				31.91
			],
			[
				"2010-11-22",
				31.01
			],
			[
				"2011-05-16",
				31.01
			],
			[
				"2011-11-15",
				40.01
			],
			[
				"2012-06-14",
				36.01
			],
			[
				"2012-11-12",
				37.01
			],
			[
				"2013-05-14",
				37.01
			],
			[
				"2013-11-18",
				36.01
			],
			[
				"2014-05-05",
				35.01
			],
			[
				"2014-11-11",
				37.01
			],
			[
				"2015-05-19",
				35.01
			]
		],
		"73774182": [
			[
				"2013-10-15",
				25.07
			],
			[
				"2013-12-02",
				28.12
			],
			[
				"2014-11-11",
				31.8
			],
			[
				"2015-04-02",
				29.41
			],
			[
				"2000-08-28",
				19.13
			],
			[
				"2001-08-08",
				19.57
			],
			[
				"2002-08-26",
				21.43
			],
			[
				"2003-10-15",
				20.86
			],
			[
				"2004-07-28",
				22.67
			],
			[
				"2005-08-18",
				23.38
			],
			[
				"2007-10-30",
				24.36
			],
			[
				"2008-10-15",
				24.31
			],
			[
				"2009-11-04",
				21.97
			],
			[
				"2010-09-16",
				21.7
			],
			[
				"2011-11-30",
				22.5
			]
		],
		"73774200": [
			[
				"2013-10-15",
				31.49
			],
			[
				"2014-11-11",
				31.18
			],
			[
				"2015-04-02",
				29.72
			],
			[
				"2000-08-28",
				31.75
			],
			[
				"2001-08-08",
				30.56
			],
			[
				"2002-08-26",
				30.96
			],
			[
				"2003-10-15",
				30.82
			],
			[
				"2004-07-29",
				32.73
			],
			[
				"2005-08-18",
				32.59
			],
			[
				"2007-08-23",
				31.4
			],
			[
				"2007-10-30",
				30.03
			],
			[
				"2008-10-15",
				31.22
			],
			[
				"2009-11-04",
				30.25
			],
			[
				"2010-09-16",
				29.67
			],
			[
				"2011-11-30",
				31.84
			]
		],
		"73774303": [
			[
				"2013-10-15",
				28.39
			],
			[
				"2014-11-11",
				26
			],
			[
				"2015-04-02",
				25.69
			],
			[
				"2000-09-20",
				26.57
			],
			[
				"2001-08-08",
				28.21
			],
			[
				"2002-09-25",
				28.87
			],
			[
				"2003-10-08",
				28.56
			],
			[
				"2004-06-15",
				29.18
			],
			[
				"2005-06-21",
				28.92
			],
			[
				"2007-10-30",
				27.72
			],
			[
				"2008-10-15",
				27.37
			],
			[
				"2009-11-04",
				28.65
			],
			[
				"2010-09-16",
				27.01
			],
			[
				"2011-11-30",
				28.74
			]
		],
		"73774480": [
			[
				"2013-10-15",
				18.42
			],
			[
				"2014-11-10",
				17.71
			],
			[
				"2015-04-10",
				19.44
			],
			[
				"2000-08-28",
				15.28
			],
			[
				"2001-08-08",
				15.72
			],
			[
				"2002-08-26",
				16.3
			],
			[
				"2003-09-30",
				16.21
			],
			[
				"2004-07-29",
				0
			],
			[
				"2005-08-18",
				17.71
			],
			[
				"2007-08-23",
				20.64
			],
			[
				"2007-10-30",
				19.18
			],
			[
				"2008-10-15",
				20.9
			],
			[
				"2009-11-04",
				17.09
			],
			[
				"2010-09-16",
				19.04
			],
			[
				"2011-11-30",
				17.49
			]
		],
		"73774686": [
			[
				"2013-10-21",
				17.71
			],
			[
				"2014-11-10",
				21.21
			],
			[
				"2015-04-10",
				21.26
			],
			[
				"2000-09-20",
				16.03
			],
			[
				"2001-08-09",
				16.25
			],
			[
				"2002-09-25",
				15.94
			],
			[
				"2004-06-15",
				15.72
			],
			[
				"2005-06-21",
				14.84
			],
			[
				"2007-08-24",
				12.93
			],
			[
				"2007-10-31",
				14.57
			],
			[
				"2008-10-13",
				16.34
			],
			[
				"2009-11-11",
				12.98
			],
			[
				"2003-10-08",
				15.28
			],
			[
				"2010-08-24",
				18.6
			],
			[
				"2011-12-01",
				17.49
			]
		],
		"73774789": [
			[
				"2014-12-01",
				3.76
			],
			[
				"2015-04-10",
				12.8
			],
			[
				"2000-08-21",
				7.04
			],
			[
				"2001-07-30",
				6.42
			],
			[
				"2002-08-27",
				3.37
			],
			[
				"2004-07-29",
				6.82
			],
			[
				"2005-08-22",
				6.24
			],
			[
				"2007-08-23",
				16.56
			],
			[
				"2007-10-31",
				4.92
			],
			[
				"2008-10-13",
				9.21
			],
			[
				"2009-11-11",
				16.7
			],
			[
				"2010-08-24",
				6.64
			]
		],
		"73774807": [
			[
				"2013-10-21",
				1.42
			],
			[
				"2014-11-04",
				12.71
			],
			[
				"2015-03-31",
				11.25
			],
			[
				"2000-08-21",
				2.57
			],
			[
				"2001-08-09",
				8.15
			],
			[
				"2002-08-27",
				8.5
			],
			[
				"2003-10-02",
				2.21
			],
			[
				"2004-07-27",
				8.72
			],
			[
				"2007-08-27",
				12.49
			],
			[
				"2007-10-31",
				5.54
			],
			[
				"2008-10-13",
				5.49
			],
			[
				"2009-11-11",
				23.96
			],
			[
				"2010-08-24",
				1.33
			],
			[
				"2011-12-01",
				1.64
			]
		],
		"73775289": [
			[
				"2013-10-23",
				20.11
			],
			[
				"2014-11-04",
				16.12
			],
			[
				"2015-03-31",
				13.77
			],
			[
				"2000-08-28",
				16.47
			],
			[
				"2001-08-10",
				18.56
			],
			[
				"2002-08-28",
				18.33
			],
			[
				"2003-10-01",
				19.57
			],
			[
				"2004-07-30",
				17.09
			],
			[
				"2005-08-22",
				17.14
			],
			[
				"2007-08-20",
				14.84
			],
			[
				"2007-10-26",
				17.01
			],
			[
				"2008-10-23",
				15.63
			],
			[
				"2009-10-12",
				20.02
			],
			[
				"2010-09-08",
				16.83
			],
			[
				"2011-11-16",
				18.78
			]
		],
		"73775381": [
			[
				"2013-12-02",
				17.32
			],
			[
				"2014-11-05",
				26.48
			],
			[
				"2015-03-30",
				22.81
			],
			[
				"2000-08-25",
				18.91
			],
			[
				"2001-08-10",
				17.89
			],
			[
				"2002-08-28",
				17.85
			],
			[
				"2003-10-01",
				18.56
			],
			[
				"2004-07-30",
				15.19
			],
			[
				"2005-08-23",
				14.75
			],
			[
				"2008-10-23",
				11.96
			]
		],
		"73775484": [
			[
				"2013-10-16",
				5.93
			],
			[
				"2014-11-18",
				8.02
			],
			[
				"2015-04-07",
				8.46
			],
			[
				"2016-03-23",
				7.53
			],
			[
				"2000-08-24",
				6.73
			],
			[
				"2002-09-04",
				7.48
			],
			[
				"2004-08-03",
				7
			],
			[
				"2005-08-24",
				7.31
			],
			[
				"2007-08-22",
				10.32
			],
			[
				"2007-11-02",
				13.42
			],
			[
				"2008-10-27",
				11.78
			],
			[
				"2009-11-04",
				13.29
			],
			[
				"2010-09-09",
				7.53
			],
			[
				"2011-11-21",
				6.24
			]
		],
		"73775605": [
			[
				"2013-10-16",
				1.86
			],
			[
				"2014-11-05",
				14.39
			],
			[
				"2015-04-07",
				5.36
			],
			[
				"2000-08-23",
				10.05
			],
			[
				"2001-08-15",
				7.93
			],
			[
				"2002-08-29",
				8.72
			],
			[
				"2003-10-16",
				9.57
			],
			[
				"2004-08-02",
				6.2
			],
			[
				"2005-08-23",
				4.87
			],
			[
				"2007-08-21",
				11.78
			],
			[
				"2007-11-05",
				6.33
			],
			[
				"2008-10-17",
				7
			],
			[
				"2009-12-01",
				11.43
			],
			[
				"2010-09-15",
				5.31
			],
			[
				"2011-11-23",
				9.21
			]
		],
		"73775708": [
			[
				"2013-10-16",
				12.27
			],
			[
				"2014-08-27",
				13.42
			],
			[
				"2015-04-07",
				10.85
			],
			[
				"2000-08-23",
				13.15
			],
			[
				"2001-08-13",
				15.32
			],
			[
				"2002-09-03",
				11.29
			],
			[
				"2003-10-16",
				16.56
			],
			[
				"2004-08-02",
				13.42
			],
			[
				"2005-08-24",
				12.31
			],
			[
				"2007-08-21",
				11.82
			],
			[
				"2007-11-06",
				12.22
			],
			[
				"2008-10-17",
				10.58
			],
			[
				"2009-12-02",
				11.16
			],
			[
				"2010-09-15",
				11.07
			],
			[
				"2011-11-23",
				9.52
			]
		],
		"73775885": [
			[
				"2013-10-16",
				15.37
			],
			[
				"2014-11-05",
				14.66
			],
			[
				"2015-04-07",
				14.13
			],
			[
				"2001-08-13",
				12.75
			],
			[
				"2002-08-29",
				14.57
			],
			[
				"2003-10-16",
				14.08
			],
			[
				"2004-08-02",
				17.71
			],
			[
				"2005-08-24",
				20.02
			],
			[
				"2007-08-21",
				24.4
			],
			[
				"2007-11-06",
				22.01
			],
			[
				"2008-10-17",
				20.33
			],
			[
				"2009-12-01",
				19.53
			],
			[
				"2010-09-15",
				16.83
			],
			[
				"2011-11-23",
				14.48
			]
		],
		"73779118": [
			[
				"2013-09-30",
				13.06
			],
			[
				"2015-05-20",
				11.29
			],
			[
				"2016-04-07",
				10.63
			],
			[
				"2001-11-20",
				20.28
			],
			[
				"2002-04-30",
				15.9
			],
			[
				"2002-10-22",
				22.19
			],
			[
				"2003-04-09",
				20.9
			],
			[
				"2007-07-13",
				20.55
			],
			[
				"2007-09-26",
				15.81
			],
			[
				"2008-08-05",
				15.94
			],
			[
				"2009-08-20",
				13.46
			],
			[
				"2010-07-14",
				17.76
			],
			[
				"2011-08-23",
				11.07
			]
		],
		"73779210": [
			[
				"2013-08-06",
				32.82
			],
			[
				"2014-10-13",
				38.09
			],
			[
				"2015-10-08",
				37.2
			],
			[
				"2016-04-12",
				34.1
			],
			[
				"2001-09-28",
				39.02
			],
			[
				"2002-04-08",
				35.78
			],
			[
				"2002-10-01",
				39.19
			],
			[
				"2003-04-08",
				37.51
			],
			[
				"2009-08-20",
				32.24
			],
			[
				"2010-07-14",
				38.09
			],
			[
				"2011-08-23",
				34.54
			]
		],
		"73779817": [
			[
				"2013-08-06",
				70.41
			],
			[
				"2014-08-27",
				98.76
			],
			[
				"2015-08-12",
				59.79
			],
			[
				"2016-04-12",
				62
			],
			[
				"2001-09-26",
				61.56
			],
			[
				"2002-04-09",
				61.11
			],
			[
				"2002-10-02",
				64.21
			],
			[
				"2003-04-10",
				62.44
			],
			[
				"2007-07-18",
				100.53
			],
			[
				"2007-10-08",
				101.86
			],
			[
				"2008-08-05",
				72.19
			],
			[
				"2009-08-20",
				67.31
			],
			[
				"2010-08-11",
				70.86
			],
			[
				"2011-09-01",
				57.57
			]
		],
		"73785015": [
			[
				"2013-08-12",
				21.12
			],
			[
				"2013-11-19",
				14.97
			],
			[
				"2014-08-08",
				16.87
			],
			[
				"2015-06-17",
				10.27
			],
			[
				"2000-07-26",
				19.4
			],
			[
				"2001-07-18",
				28.3
			],
			[
				"2002-08-09",
				30.11
			],
			[
				"2003-09-09",
				27.99
			],
			[
				"2004-06-28",
				21.04
			],
			[
				"2005-07-28",
				28.7
			],
			[
				"2006-10-20",
				22.81
			],
			[
				"2007-07-13",
				25.6
			],
			[
				"2007-10-05",
				25.42
			],
			[
				"2008-07-17",
				24.18
			],
			[
				"2009-08-06",
				21.3
			],
			[
				"2010-06-24",
				24.49
			],
			[
				"2011-08-19",
				23.03
			]
		],
		"73903206": [
			[
				"2013-10-15",
				21.08
			],
			[
				"2014-11-10",
				19.8
			],
			[
				"2015-10-13",
				21.35
			],
			[
				"2000-08-21",
				24.58
			],
			[
				"2001-08-08",
				26.62
			],
			[
				"2001-08-15",
				25.38
			],
			[
				"2002-08-26",
				26.75
			],
			[
				"2003-09-30",
				26.26
			],
			[
				"2004-07-29",
				25.6
			],
			[
				"2005-08-18",
				25.46
			],
			[
				"2007-08-23",
				23.47
			],
			[
				"2008-10-16",
				21.74
			],
			[
				"2009-11-05",
				22.81
			],
			[
				"2007-10-29",
				22.23
			],
			[
				"2011-05-30",
				23.03
			]
		],
		"76402710": [
			[
				"2000-08-08",
				25.95
			],
			[
				"2001-07-20",
				27.72
			],
			[
				"2002-09-02",
				22.5
			],
			[
				"2003-09-10",
				7.93
			],
			[
				"2004-07-23",
				5.09
			],
			[
				"2005-07-19",
				17.49
			],
			[
				"2006-10-23",
				20.64
			],
			[
				"2000-04-26",
				29.91
			],
			[
				"2000-10-23",
				25.91
			],
			[
				"2001-04-30",
				28.51
			],
			[
				"2001-11-05",
				32.91
			],
			[
				"2002-07-16",
				26.21
			],
			[
				"2002-10-30",
				21.81
			],
			[
				"2003-05-07",
				16.71
			],
			[
				"2003-11-18",
				9.9
			],
			[
				"2004-04-26",
				5.5
			],
			[
				"2004-10-21",
				3.7
			],
			[
				"2005-04-25",
				11.8
			],
			[
				"2005-10-28",
				19.51
			],
			[
				"2006-04-06",
				21.11
			],
			[
				"2006-10-23",
				23.71
			],
			[
				"2006-12-15",
				25.01
			],
			[
				"2007-01-31",
				22.21
			],
			[
				"2007-06-28",
				20.81
			],
			[
				"2007-04-24",
				22.41
			],
			[
				"2007-09-27",
				23.07
			],
			[
				"2014-10-29",
				13.46
			],
			[
				"2015-04-29",
				15.73
			],
			[
				"2015-11-17",
				29.36
			]
		],
		"76503410": [
			[
				"2013-09-17",
				86.36
			],
			[
				"2014-09-23",
				80.6
			],
			[
				"2015-05-12",
				72.63
			],
			[
				"2000-09-19",
				109.83
			],
			[
				"2001-07-20",
				112.49
			],
			[
				"2002-09-24",
				91.23
			],
			[
				"2003-10-07",
				68.2
			],
			[
				"2004-06-16",
				77.94
			],
			[
				"2005-06-22",
				82.81
			],
			[
				"2006-10-24",
				84.14
			],
			[
				"2007-06-29",
				101.86
			],
			[
				"2007-09-27",
				109.39
			],
			[
				"2008-07-10",
				104.51
			],
			[
				"2009-07-24",
				99.64
			],
			[
				"2010-06-30",
				79.71
			],
			[
				"2011-05-26",
				70.86
			]
		],
		"76544710": [
			[
				"2013-09-26",
				1.33
			],
			[
				"2015-07-29",
				1.33
			],
			[
				"2004-03-02",
				0.44
			],
			[
				"2004-09-22",
				0.22
			],
			[
				"2005-03-10",
				0.22
			],
			[
				"2005-09-16",
				0.22
			],
			[
				"2007-06-29",
				2.21
			],
			[
				"2007-10-09",
				2.21
			],
			[
				"2008-11-06",
				2.21
			],
			[
				"2007-03-21",
				1.11
			],
			[
				"2007-09-10",
				1.11
			],
			[
				"2008-03-04",
				0.22
			],
			[
				"2008-09-19",
				4.43
			],
			[
				"2010-03-09",
				0.44
			],
			[
				"2010-09-16",
				0.44
			],
			[
				"2011-03-15",
				1.33
			],
			[
				"2011-09-12",
				1.33
			],
			[
				"2012-03-16",
				1.33
			],
			[
				"2012-09-19",
				1.33
			],
			[
				"2013-03-18",
				1.33
			],
			[
				"2013-09-02",
				1.33
			],
			[
				"2009-09-08",
				2.21
			],
			[
				"2010-07-26",
				2.21
			],
			[
				"2011-08-31",
				1.33
			]
		],
		"76555112": [
			[
				"2013-09-12",
				52.7
			],
			[
				"2014-09-23",
				50.04
			],
			[
				"2015-07-14",
				49.16
			],
			[
				"2000-08-07",
				54.47
			],
			[
				"2001-07-23",
				56.24
			],
			[
				"2002-08-13",
				63.77
			],
			[
				"2003-09-11",
				59.34
			],
			[
				"2005-07-29",
				56.24
			],
			[
				"2006-10-24",
				46.94
			],
			[
				"2007-06-29",
				51.81
			],
			[
				"2007-10-09",
				50.93
			],
			[
				"2008-07-22",
				47.83
			],
			[
				"2008-08-19",
				46.06
			],
			[
				"2009-08-26",
				48.27
			],
			[
				"2010-07-09",
				52.7
			],
			[
				"2011-08-31",
				48.71
			]
		],
		"76632015": [
			[
				"2013-08-28",
				18.47
			],
			[
				"2014-09-19",
				15.9
			],
			[
				"2015-05-21",
				17.01
			],
			[
				"2007-07-02",
				19.22
			],
			[
				"2007-10-16",
				18.95
			],
			[
				"2008-07-11",
				20.81
			],
			[
				"2009-07-28",
				18.38
			],
			[
				"2010-07-20",
				4.87
			],
			[
				"2011-09-02",
				7.97
			]
		],
		"76672815": [
			[
				"2013-05-13",
				0.5
			],
			[
				"2014-04-15",
				0.5
			],
			[
				"2015-04-14",
				0.5
			],
			[
				"2012-04-25",
				0.5
			],
			[
				"2011-04-19",
				0.5
			],
			[
				"2010-04-14",
				0.5
			],
			[
				"2009-03-31",
				0.5
			],
			[
				"2008-04-02",
				0.5
			],
			[
				"2006-05-09",
				0.5
			]
		],
		"76727609": [
			[
				"2013-10-10",
				1.33
			],
			[
				"2014-10-24",
				1.33
			],
			[
				"2015-04-01",
				1.33
			],
			[
				"2016-03-24",
				1.33
			],
			[
				"2000-08-14",
				14.84
			],
			[
				"2001-07-26",
				11.96
			],
			[
				"2002-08-16",
				16.25
			],
			[
				"2003-09-25",
				15.72
			],
			[
				"2004-07-26",
				10.63
			],
			[
				"2005-08-15",
				5.93
			],
			[
				"2007-08-16",
				10.41
			],
			[
				"2009-12-03",
				5.67
			],
			[
				"2007-10-25",
				21.08
			],
			[
				"2011-06-01",
				3.19
			]
		],
		"76734985": [
			[
				"2013-10-10",
				67.76
			],
			[
				"2014-10-24",
				56.24
			],
			[
				"2015-04-01",
				52.26
			],
			[
				"2016-03-24",
				48.71
			],
			[
				"2000-08-10",
				77.06
			],
			[
				"2001-07-26",
				77.94
			],
			[
				"2002-08-16",
				79.71
			],
			[
				"2003-09-25",
				62.89
			],
			[
				"2005-08-15",
				71.74
			],
			[
				"2008-11-20",
				51.81
			],
			[
				"2009-12-03",
				70.86
			],
			[
				"2011-06-01",
				62
			]
		],
		"76737718": [
			[
				"2013-09-12",
				25.11
			],
			[
				"2014-09-16",
				49.16
			],
			[
				"2015-04-17",
				69.97
			],
			[
				"2007-07-03",
				18.73
			],
			[
				"2007-10-08",
				24.18
			],
			[
				"2008-08-25",
				18.16
			],
			[
				"2009-08-17",
				35.74
			],
			[
				"2010-08-11",
				35.87
			]
		],
		"76744218": [
			[
				"2000-07-31",
				29.14
			],
			[
				"2001-07-24",
				35.12
			],
			[
				"2003-09-12",
				29.49
			],
			[
				"2004-07-16",
				31.09
			],
			[
				"2005-07-29",
				29.45
			],
			[
				"2006-10-24",
				27.94
			],
			[
				"2012-06-05",
				19.91
			],
			[
				"2013-11-04",
				19.41
			],
			[
				"2014-05-15",
				19.11
			],
			[
				"2015-10-22",
				19.11
			]
		],
		"76769306": [
			[
				"2013-10-10",
				8.68
			],
			[
				"2014-11-17",
				2.08
			],
			[
				"2015-04-08",
				5.62
			],
			[
				"2000-08-14",
				2.21
			],
			[
				"2001-08-02",
				2.21
			],
			[
				"2002-08-19",
				12.58
			],
			[
				"2003-09-30",
				2.21
			],
			[
				"2004-07-26",
				2.21
			],
			[
				"2005-08-16",
				2.21
			],
			[
				"2007-08-17",
				13.29
			],
			[
				"2008-10-16",
				11.38
			],
			[
				"2009-11-05",
				2.21
			],
			[
				"2007-10-29",
				12.53
			],
			[
				"2011-05-30",
				1.33
			]
		],
		"76781010": [
			[
				"2013-09-12",
				20.02
			],
			[
				"2014-09-22",
				23.47
			],
			[
				"2015-07-21",
				22.54
			],
			[
				"2000-07-31",
				23.47
			],
			[
				"2001-07-30",
				26.84
			],
			[
				"2002-08-14",
				28.56
			],
			[
				"2003-09-23",
				25.95
			],
			[
				"2004-07-16",
				26.48
			],
			[
				"2005-07-28",
				20.9
			],
			[
				"2007-07-17",
				18.51
			],
			[
				"2007-10-10",
				17.63
			],
			[
				"2008-08-14",
				17.05
			],
			[
				"2009-09-11",
				22.23
			],
			[
				"2010-07-22",
				21.04
			],
			[
				"2011-08-31",
				15.94
			]
		],
		"76806420": [
			[
				"2013-09-24",
				19.26
			],
			[
				"2015-08-06",
				18.25
			],
			[
				"2007-10-09",
				15.85
			],
			[
				"2008-07-24",
				17.36
			],
			[
				"2013-04-02",
				15.31
			],
			[
				"2009-07-30",
				16.87
			],
			[
				"2010-07-05",
				18.16
			],
			[
				"2011-06-28",
				19.04
			]
		],
		"76809201": [
			[
				"2013-10-21",
				1.33
			],
			[
				"2014-11-04",
				1.33
			],
			[
				"2015-03-31",
				1.33
			],
			[
				"2016-03-02",
				1.59
			],
			[
				"2000-08-21",
				2.21
			],
			[
				"2001-08-09",
				2.21
			],
			[
				"2002-08-29",
				2.21
			],
			[
				"2003-10-02",
				2.21
			],
			[
				"2004-07-27",
				2.21
			],
			[
				"2005-08-22",
				2.21
			],
			[
				"2007-08-27",
				2.21
			],
			[
				"2007-10-31",
				2.21
			],
			[
				"2008-10-13",
				2.21
			],
			[
				"2009-11-11",
				2.21
			],
			[
				"2010-08-24",
				1.33
			],
			[
				"2011-12-01",
				1.06
			]
		],
		"76809304": [
			[
				"2013-10-23",
				1.33
			],
			[
				"2014-11-04",
				1.55
			],
			[
				"2015-03-31",
				2.26
			],
			[
				"2000-08-22",
				2.57
			],
			[
				"2001-08-09",
				2.21
			],
			[
				"2002-08-28",
				2.21
			],
			[
				"2003-10-01",
				3.28
			],
			[
				"2004-07-30",
				2.21
			],
			[
				"2005-08-22",
				2.52
			],
			[
				"2007-08-20",
				2.21
			],
			[
				"2008-10-23",
				4.83
			],
			[
				"2009-10-12",
				2.79
			],
			[
				"2007-10-26",
				2.48
			],
			[
				"2010-09-08",
				1.33
			],
			[
				"2011-11-16",
				1.95
			]
		],
		"76809407": [
			[
				"2014-12-08",
				9.03
			],
			[
				"2015-04-22",
				8.99
			],
			[
				"2000-08-23",
				14.44
			],
			[
				"2001-08-13",
				13.46
			],
			[
				"2002-08-28",
				14.61
			],
			[
				"2003-10-15",
				11.25
			],
			[
				"2004-07-30",
				0
			],
			[
				"2005-08-23",
				11.34
			]
		],
		"76809500": [
			[
				"2013-10-16",
				1.33
			],
			[
				"2014-11-05",
				7.66
			],
			[
				"2015-03-30",
				11.16
			],
			[
				"2000-08-23",
				7.66
			],
			[
				"2001-08-13",
				7.09
			],
			[
				"2002-08-29",
				8.99
			],
			[
				"2003-10-16",
				10.81
			],
			[
				"2004-08-02",
				9.3
			],
			[
				"2005-08-23",
				9.96
			],
			[
				"2007-08-21",
				10.45
			],
			[
				"2007-11-05",
				8.99
			],
			[
				"2008-10-17",
				8.77
			],
			[
				"2009-12-01",
				12.93
			],
			[
				"2010-09-15",
				9.74
			],
			[
				"2011-11-23",
				2.17
			]
		],
		"76811311": [
			[
				"2013-08-30",
				12.62
			],
			[
				"2014-09-26",
				15.68
			],
			[
				"2015-07-30",
				13.15
			],
			[
				"2002-10-15",
				13.06
			],
			[
				"2003-04-08",
				12.44
			],
			[
				"2003-11-06",
				15.46
			],
			[
				"2004-04-22",
				16.96
			],
			[
				"2007-07-03",
				16.96
			],
			[
				"2007-10-16",
				15.23
			],
			[
				"2008-07-30",
				12.44
			],
			[
				"2009-08-18",
				13.99
			],
			[
				"2010-07-15",
				15.06
			],
			[
				"2011-09-01",
				13.29
			]
		],
		"76815717": [
			[
				"2013-09-27",
				1.55
			],
			[
				"2014-09-25",
				1.33
			],
			[
				"2015-07-17",
				11.69
			],
			[
				"2001-01-10",
				3.1
			],
			[
				"2001-04-26",
				29.67
			],
			[
				"2001-07-05",
				41.63
			],
			[
				"2001-10-09",
				11.07
			],
			[
				"2002-07-02",
				36.76
			],
			[
				"2000-07-04",
				4.43
			],
			[
				"2000-10-10",
				2.66
			],
			[
				"2000-04-11",
				4.43
			],
			[
				"2002-01-16",
				8.86
			],
			[
				"2002-04-17",
				39.86
			],
			[
				"2000-01-18",
				7.75
			],
			[
				"2002-10-22",
				13.29
			],
			[
				"2003-01-14",
				9.74
			],
			[
				"2003-04-09",
				38.09
			],
			[
				"2003-07-16",
				27.9
			],
			[
				"2003-10-16",
				13.29
			],
			[
				"2004-01-06",
				8.86
			],
			[
				"2004-04-24",
				19.04
			],
			[
				"2004-07-06",
				19.93
			],
			[
				"2004-10-27",
				6.2
			],
			[
				"2005-01-11",
				12.84
			],
			[
				"2005-04-05",
				20.37
			],
			[
				"2005-07-06",
				8.86
			],
			[
				"2005-10-18",
				18.6
			],
			[
				"2007-07-13",
				5
			],
			[
				"2007-10-08",
				4.47
			],
			[
				"2007-01-08",
				9.74
			],
			[
				"2007-04-24",
				4.43
			],
			[
				"2007-07-04",
				4.07
			],
			[
				"2007-10-09",
				2.21
			],
			[
				"2008-02-12",
				4.43
			],
			[
				"2008-04-01",
				8.41
			],
			[
				"2008-07-02",
				24.36
			],
			[
				"2008-10-21",
				6.2
			],
			[
				"2010-01-20",
				3.99
			],
			[
				"2010-04-07",
				4.87
			],
			[
				"2010-07-06",
				10.19
			],
			[
				"2010-10-19",
				3.1
			],
			[
				"2011-01-11",
				2.21
			],
			[
				"2011-02-28",
				16.08
			],
			[
				"2011-04-05",
				57.57
			],
			[
				"2011-07-12",
				27.01
			],
			[
				"2011-11-04",
				10.63
			],
			[
				"2012-01-10",
				8.86
			],
			[
				"2012-04-03",
				6.2
			],
			[
				"2012-07-10",
				2.21
			],
			[
				"2012-10-09",
				4.87
			],
			[
				"2013-01-15",
				2.21
			],
			[
				"2013-04-17",
				2.21
			],
			[
				"2013-07-16",
				2.21
			],
			[
				"2013-10-15",
				2.21
			],
			[
				"2009-07-30",
				13.15
			],
			[
				"2008-07-24",
				24.49
			],
			[
				"2010-08-11",
				4.43
			],
			[
				"2011-06-28",
				27.01
			]
		],
		"76819310": [
			[
				"2013-08-28",
				16.43
			],
			[
				"2015-07-23",
				23.74
			],
			[
				"2007-10-15",
				15.41
			],
			[
				"2008-08-04",
				17.49
			],
			[
				"2009-08-18",
				17.4
			],
			[
				"2010-07-15",
				28.65
			],
			[
				"2011-09-05",
				19.04
			]
		],
		"76832314": [
			[
				"2014-10-21",
				64.66
			],
			[
				"2015-08-04",
				67.31
			],
			[
				"2000-08-09",
				134.63
			],
			[
				"2001-07-24",
				22.23
			],
			[
				"2002-08-15",
				3.9
			],
			[
				"2003-09-12",
				2.21
			],
			[
				"2004-07-28",
				0
			],
			[
				"2005-08-05",
				13.37
			],
			[
				"2007-07-23",
				96.54
			],
			[
				"2008-08-21",
				108.94
			],
			[
				"2009-09-09",
				99.2
			],
			[
				"2007-10-10",
				115.14
			],
			[
				"2010-07-22",
				10.45
			]
		],
		"76839217": [
			[
				"2013-08-23",
				8.55
			],
			[
				"2014-09-16",
				7.31
			],
			[
				"2015-05-13",
				7.13
			],
			[
				"2007-07-02",
				13.02
			],
			[
				"2007-10-16",
				13.11
			],
			[
				"2008-07-29",
				11.87
			],
			[
				"2009-08-12",
				8.81
			],
			[
				"2010-07-19",
				7.66
			],
			[
				"2011-08-30",
				6.2
			]
		],
		"76839916": [
			[
				"2014-12-03",
				1.33
			],
			[
				"2015-05-13",
				1.33
			]
		],
		"76840116": [
			[
				"2013-08-23",
				2.13
			],
			[
				"2014-09-16",
				25.77
			],
			[
				"2015-05-13",
				1.68
			],
			[
				"2007-07-02",
				52.26
			],
			[
				"2008-07-28",
				2.21
			],
			[
				"2009-08-11",
				4.34
			],
			[
				"2010-07-08",
				62
			],
			[
				"2011-06-29",
				14.17
			]
		],
		"76849211": [
			[
				"2000-02-29",
				23.29
			],
			[
				"2001-03-06",
				24.36
			],
			[
				"2001-08-15",
				22.28
			],
			[
				"2002-02-21",
				20.5
			],
			[
				"2002-08-28",
				23.78
			],
			[
				"2003-02-19",
				20.15
			],
			[
				"2003-08-29",
				21.26
			],
			[
				"2007-07-19",
				19.53
			],
			[
				"2007-10-10",
				17.09
			],
			[
				"2008-08-19",
				16.25
			],
			[
				"2013-03-20",
				18.82
			],
			[
				"2012-09-18",
				14.04
			],
			[
				"2013-09-19",
				16.81
			],
			[
				"2014-09-18",
				0.44
			],
			[
				"2010-03-02",
				13.73
			],
			[
				"2010-08-25",
				15.5
			],
			[
				"2011-02-28",
				14.17
			],
			[
				"2011-09-14",
				15.94
			],
			[
				"2012-03-20",
				17.45
			],
			[
				"2013-09-18",
				16.83
			],
			[
				"2014-03-25",
				16.52
			],
			[
				"2015-03-20",
				14.51
			],
			[
				"2015-12-18",
				17.21
			],
			[
				"2015-09-18",
				15.31
			],
			[
				"2009-09-11",
				16.52
			],
			[
				"2010-07-26",
				15.94
			]
		],
		"76866713": [
			[
				"2013-09-04",
				30.29
			],
			[
				"2014-09-22",
				22.9
			],
			[
				"2015-07-22",
				16.74
			],
			[
				"2007-07-04",
				37.02
			],
			[
				"2007-10-15",
				30.34
			],
			[
				"2008-07-23",
				33.7
			],
			[
				"2009-07-29",
				30.16
			],
			[
				"2010-07-12",
				22.63
			],
			[
				"2011-06-30",
				20.81
			]
		],
		"76886414": [
			[
				"2013-09-04",
				49.6
			],
			[
				"2014-09-22",
				41.67
			],
			[
				"2015-07-23",
				46.06
			],
			[
				"2000-04-25",
				47.83
			],
			[
				"2000-09-14",
				55.36
			],
			[
				"2007-07-04",
				47.83
			],
			[
				"2007-10-15",
				46.06
			],
			[
				"2008-08-14",
				43.58
			],
			[
				"2009-08-19",
				45.61
			],
			[
				"2010-07-21",
				47.83
			],
			[
				"2011-09-05",
				41.63
			]
		],
		"76929012": [
			[
				"2013-11-19",
				1.33
			],
			[
				"2014-09-18",
				1.33
			],
			[
				"2015-07-28",
				1.33
			],
			[
				"2007-07-04",
				2.21
			],
			[
				"2007-10-11",
				2.21
			],
			[
				"2008-07-23",
				2.21
			],
			[
				"2009-07-29",
				3.23
			],
			[
				"2010-07-12",
				2.21
			],
			[
				"2011-06-30",
				1.95
			]
		],
		"76929218": [
			[
				"2013-09-19",
				15.32
			],
			[
				"2014-09-18",
				16.03
			],
			[
				"2015-07-28",
				15.37
			],
			[
				"2007-07-04",
				18.87
			],
			[
				"2007-10-11",
				15.41
			],
			[
				"2008-07-23",
				15.68
			],
			[
				"2009-08-19",
				15.5
			],
			[
				"2010-07-12",
				15.81
			],
			[
				"2011-06-30",
				15.94
			]
		],
		"76929310": [
			[
				"2013-09-19",
				18.33
			],
			[
				"2014-09-18",
				18.87
			],
			[
				"2015-07-28",
				15.59
			],
			[
				"2007-07-05",
				18.78
			],
			[
				"2007-10-11",
				18.33
			],
			[
				"2008-08-14",
				19.4
			],
			[
				"2009-08-19",
				17.94
			],
			[
				"2010-07-12",
				19.13
			],
			[
				"2011-06-30",
				16.83
			]
		],
		"76931912": [
			[
				"2013-09-06",
				29.85
			],
			[
				"2014-09-18",
				37.24
			],
			[
				"2015-07-27",
				38.62
			],
			[
				"2000-04-26",
				36.09
			],
			[
				"2000-09-15",
				35.3
			],
			[
				"2007-07-05",
				34.99
			],
			[
				"2007-10-15",
				24.53
			],
			[
				"2008-08-14",
				27.37
			],
			[
				"2009-08-19",
				25.24
			],
			[
				"2010-07-21",
				28.43
			]
		],
		"76934019": [
			[
				"2013-09-11",
				3.5
			],
			[
				"2014-10-20",
				2.61
			],
			[
				"2015-08-11",
				2.21
			],
			[
				"2007-07-05",
				4.38
			],
			[
				"2007-10-17",
				3.94
			],
			[
				"2008-07-23",
				4.34
			],
			[
				"2009-09-09",
				3.23
			],
			[
				"2010-07-09",
				3.85
			],
			[
				"2011-09-05",
				3.06
			]
		],
		"76956805": [
			[
				"2013-10-10",
				21.48
			],
			[
				"2014-10-24",
				13.2
			],
			[
				"2015-04-01",
				21.52
			],
			[
				"2016-03-24",
				20.81
			],
			[
				"2007-07-19",
				22.67
			],
			[
				"2007-10-10",
				22.72
			],
			[
				"2008-10-20",
				21.92
			],
			[
				"2009-09-09",
				23.12
			],
			[
				"2010-12-01",
				20.81
			],
			[
				"2011-12-14",
				24.8
			]
		],
		"76965612": [
			[
				"2013-05-15",
				8.9
			],
			[
				"2013-10-02",
				7.8
			],
			[
				"2014-04-08",
				8.3
			],
			[
				"2015-04-08",
				9.4
			],
			[
				"2014-10-31",
				7.6
			]
		],
		"76981113": [
			[
				"2014-12-09",
				1.33
			],
			[
				"2015-08-14",
				1.33
			],
			[
				"2008-08-04",
				2.21
			],
			[
				"2009-08-18",
				2.21
			],
			[
				"2010-07-21",
				2.21
			]
		],
		"76987218": [
			[
				"2014-12-09",
				22.36
			],
			[
				"2015-08-17",
				8.06
			],
			[
				"2007-10-17",
				2.75
			],
			[
				"2008-07-31",
				7.44
			],
			[
				"2009-08-13",
				2.57
			],
			[
				"2010-07-23",
				5.31
			]
		],
		"76988399": [
			[
				"2013-10-14",
				17.58
			],
			[
				"2014-10-31",
				22.81
			],
			[
				"2015-03-26",
				14.88
			],
			[
				"2008-11-24",
				15.06
			],
			[
				"2009-11-27",
				16.43
			],
			[
				"2010-10-01",
				19.04
			],
			[
				"2011-12-14",
				15.5
			]
		],
		"76988491": [
			[
				"2013-10-28",
				11.51
			],
			[
				"2014-07-02",
				10.72
			],
			[
				"2015-03-26",
				15.23
			],
			[
				"2007-07-18",
				10.76
			],
			[
				"2007-10-18",
				10.45
			],
			[
				"2008-08-22",
				10.72
			],
			[
				"2009-12-08",
				10.81
			],
			[
				"2010-10-04",
				9.3
			],
			[
				"2011-12-13",
				10.1
			]
		],
		"76988594": [
			[
				"2013-10-14",
				8.19
			],
			[
				"2014-07-02",
				8.37
			],
			[
				"2015-03-25",
				9.03
			],
			[
				"2007-07-18",
				6.29
			],
			[
				"2007-11-06",
				6.55
			],
			[
				"2008-10-31",
				6.95
			],
			[
				"2009-10-07",
				7.31
			],
			[
				"2010-10-04",
				6.64
			],
			[
				"2011-12-13",
				7.62
			]
		],
		"76990280": [
			[
				"2014-07-14",
				26.44
			],
			[
				"2015-03-25",
				25.55
			],
			[
				"2007-07-18",
				35.16
			],
			[
				"2007-10-18",
				40.61
			],
			[
				"2008-08-22",
				30.82
			],
			[
				"2009-10-07",
				26.31
			],
			[
				"2010-10-01",
				44.29
			]
		],
		"80000046": [
			[
				"2013-07-12",
				42.07
			],
			[
				"2014-12-01",
				63.77
			],
			[
				"2015-09-30",
				74.4
			],
			[
				"2000-01-07",
				78.39
			],
			[
				"2000-11-16",
				78.39
			],
			[
				"2001-03-19",
				62.89
			],
			[
				"2001-10-17",
				59.79
			],
			[
				"2002-05-10",
				64.66
			],
			[
				"2003-03-05",
				73.07
			],
			[
				"2003-09-10",
				81.93
			],
			[
				"2004-02-16",
				87.69
			],
			[
				"2004-09-21",
				117.36
			],
			[
				"2005-04-05",
				110.71
			],
			[
				"2006-04-20",
				78.39
			],
			[
				"2006-12-15",
				75.29
			],
			[
				"2007-07-02",
				67.76
			],
			[
				"2008-05-20",
				52.7
			],
			[
				"2010-01-26",
				62
			],
			[
				"2011-01-19",
				62.89
			],
			[
				"2011-08-22",
				59.34
			],
			[
				"2012-09-10",
				42.78
			]
		],
		"80000113": [
			[
				"2015-09-01",
				16.87
			],
			[
				"2000-10-30",
				83.7
			],
			[
				"2000-12-18",
				154.56
			],
			[
				"2001-02-28",
				259.51
			],
			[
				"2001-09-27",
				44.24
			],
			[
				"2002-04-05",
				169.61
			],
			[
				"2003-07-29",
				38.09
			],
			[
				"2004-03-04",
				80.6
			],
			[
				"2004-10-01",
				66.87
			],
			[
				"2005-03-07",
				103.19
			],
			[
				"2006-01-17",
				93.44
			],
			[
				"2006-11-08",
				228.07
			],
			[
				"2007-07-24",
				57.13
			],
			[
				"2008-02-25",
				70.41
			],
			[
				"2003-02-14",
				122.23
			],
			[
				"2010-01-12",
				72.63
			],
			[
				"2011-01-12",
				48.27
			],
			[
				"2012-03-01",
				61.56
			],
			[
				"2013-02-05",
				53.59
			]
		],
		"80100612": [
			[
				"2014-09-09",
				108.94
			],
			[
				"2015-09-10",
				102.3
			],
			[
				"2000-04-05",
				94.77
			],
			[
				"2000-10-04",
				95.66
			],
			[
				"2001-02-08",
				96.99
			],
			[
				"2001-09-12",
				96.99
			],
			[
				"2002-03-25",
				80.6
			],
			[
				"2003-07-03",
				91.23
			],
			[
				"2004-04-20",
				95.66
			],
			[
				"2004-11-04",
				88.57
			],
			[
				"2005-04-15",
				89.46
			],
			[
				"2006-09-29",
				90.79
			],
			[
				"2007-08-31",
				87.69
			],
			[
				"2008-04-17",
				94.77
			],
			[
				"2003-01-24",
				91.23
			],
			[
				"2005-11-29",
				89.46
			],
			[
				"2009-11-10",
				89.01
			],
			[
				"2010-11-04",
				99.64
			],
			[
				"2012-10-01",
				118.24
			]
		],
		"80100697": [
			[
				"2013-05-02",
				96.99
			],
			[
				"2015-09-08",
				68.64
			],
			[
				"2000-10-25",
				111.6
			],
			[
				"2001-02-20",
				85.47
			],
			[
				"2001-09-21",
				125.33
			],
			[
				"2002-02-21",
				99.64
			],
			[
				"2003-07-24",
				108.94
			],
			[
				"2004-01-16",
				142.6
			],
			[
				"2004-10-11",
				139.06
			],
			[
				"2005-04-19",
				62.44
			],
			[
				"2006-01-05",
				89.01
			],
			[
				"2007-08-23",
				58.9
			],
			[
				"2008-03-05",
				101.86
			],
			[
				"2003-02-06",
				104.07
			],
			[
				"2006-11-03",
				115.59
			],
			[
				"2009-12-02",
				46.5
			],
			[
				"2010-11-10",
				58.9
			],
			[
				"2011-06-01",
				99.64
			],
			[
				"2012-10-26",
				88.13
			]
		],
		"80100806": [
			[
				"2015-09-09",
				88.57
			],
			[
				"2000-01-17",
				60.23
			],
			[
				"2000-10-23",
				62
			],
			[
				"2001-03-09",
				160.76
			],
			[
				"2001-04-23",
				65.54
			],
			[
				"2001-10-05",
				71.74
			],
			[
				"2002-04-12",
				59.34
			],
			[
				"2002-07-01",
				65.99
			],
			[
				"2003-02-26",
				60.23
			],
			[
				"2003-07-07",
				64.21
			],
			[
				"2004-03-31",
				66.87
			],
			[
				"2004-10-04",
				68.64
			],
			[
				"2005-03-14",
				65.1
			],
			[
				"2006-01-25",
				75.73
			],
			[
				"2006-10-11",
				73.96
			],
			[
				"2008-04-07",
				73.51
			],
			[
				"2007-07-26",
				73.96
			],
			[
				"2005-09-19",
				61.56
			],
			[
				"2009-12-16",
				71.3
			],
			[
				"2010-11-02",
				64.21
			],
			[
				"2011-08-18",
				57.13
			]
		],
		"80100818": [
			[
				"2014-09-15",
				60.23
			],
			[
				"2015-07-10",
				51.37
			],
			[
				"2007-09-07",
				46.5
			],
			[
				"2005-04-19",
				54.47
			],
			[
				"2008-03-10",
				54.47
			],
			[
				"2006-10-11",
				53.59
			],
			[
				"2010-11-10",
				56.69
			],
			[
				"2011-06-01",
				56.24
			],
			[
				"2012-10-02",
				58.01
			],
			[
				"2013-02-25",
				53.59
			]
		],
		"80100946": [
			[
				"2013-07-01",
				30.82
			],
			[
				"2014-05-27",
				20.5
			],
			[
				"2015-02-27",
				21.74
			],
			[
				"2000-02-09",
				11.51
			],
			[
				"2000-09-12",
				13.29
			],
			[
				"2001-01-19",
				9.3
			],
			[
				"2001-07-17",
				8.86
			],
			[
				"2002-01-14",
				11.07
			],
			[
				"2002-09-17",
				8.41
			],
			[
				"2003-06-11",
				13.11
			],
			[
				"2004-01-13",
				16.39
			],
			[
				"2004-11-26",
				52.26
			],
			[
				"2006-09-19",
				35.74
			],
			[
				"2007-08-31",
				51.81
			],
			[
				"2007-11-26",
				51.81
			],
			[
				"2008-07-09",
				38.66
			],
			[
				"2010-06-10",
				22.76
			],
			[
				"2011-05-18",
				21.92
			],
			[
				"2012-12-18",
				39.72
			]
		],
		"80200357": [
			[
				"2013-07-01",
				22.32
			],
			[
				"2014-12-11",
				16.65
			],
			[
				"2015-10-15",
				17.49
			],
			[
				"2000-03-03",
				30.11
			],
			[
				"2000-09-15",
				38.53
			],
			[
				"2001-01-25",
				45.17
			],
			[
				"2001-11-13",
				42.51
			],
			[
				"2002-01-23",
				40.74
			],
			[
				"2002-09-11",
				35.87
			],
			[
				"2003-06-12",
				34.41
			],
			[
				"2004-02-05",
				37.64
			],
			[
				"2004-10-26",
				31.58
			],
			[
				"2005-04-25",
				28.83
			],
			[
				"2005-11-02",
				22.72
			],
			[
				"2006-08-25",
				22.45
			],
			[
				"2007-10-10",
				20.99
			],
			[
				"2007-05-16",
				23.03
			],
			[
				"2008-06-09",
				19.26
			],
			[
				"2010-06-08",
				24.98
			],
			[
				"2010-12-13",
				23.12
			],
			[
				"2011-09-01",
				28.12
			],
			[
				"2012-09-24",
				23.83
			]
		],
		"80200734": [
			[
				"2006-11-30",
				27.01
			],
			[
				"2007-06-19",
				22.31
			],
			[
				"2008-05-05",
				27.31
			],
			[
				"2009-04-22",
				29.01
			],
			[
				"2010-03-02",
				34.01
			],
			[
				"2013-05-24",
				36.27
			],
			[
				"2014-12-17",
				33.92
			],
			[
				"2015-09-10",
				32.15
			],
			[
				"2000-04-05",
				40.3
			],
			[
				"2000-10-11",
				40.3
			],
			[
				"2001-02-08",
				40.74
			],
			[
				"2001-10-04",
				37.64
			],
			[
				"2002-03-25",
				35.87
			],
			[
				"2003-07-03",
				31
			],
			[
				"2004-04-26",
				29.67
			],
			[
				"2004-11-04",
				29.36
			],
			[
				"2005-04-15",
				23.91
			],
			[
				"2006-10-26",
				29.27
			],
			[
				"2007-07-12",
				23.96
			],
			[
				"2008-04-17",
				30.11
			],
			[
				"2011-01-25",
				35.01
			],
			[
				"2012-01-02",
				38.01
			],
			[
				"2013-01-23",
				41.01
			],
			[
				"2014-01-14",
				35.01
			],
			[
				"2015-01-16",
				32.01
			],
			[
				"2003-01-24",
				30.11
			],
			[
				"2005-11-29",
				26.84
			],
			[
				"2009-10-30",
				25.82
			],
			[
				"2010-11-23",
				34.28
			],
			[
				"2011-06-28",
				38.93
			],
			[
				"2012-12-07",
				38.93
			]
		],
		"80200758": [
			[
				"2013-04-25",
				70.41
			],
			[
				"2014-08-25",
				67.31
			],
			[
				"2015-05-22",
				62
			],
			[
				"2000-01-05",
				128.87
			],
			[
				"2000-11-10",
				137.29
			],
			[
				"2001-03-09",
				142.6
			],
			[
				"2001-10-15",
				133.74
			],
			[
				"2002-04-22",
				137.73
			],
			[
				"2003-09-01",
				127.54
			],
			[
				"2004-04-29",
				123.56
			],
			[
				"2004-08-10",
				126.21
			],
			[
				"2005-03-31",
				124.44
			],
			[
				"2006-03-06",
				109.83
			],
			[
				"2006-12-11",
				50.49
			],
			[
				"2007-08-14",
				72.19
			],
			[
				"2008-03-11",
				64.66
			],
			[
				"2003-02-24",
				136.4
			],
			[
				"2010-01-21",
				85.03
			],
			[
				"2011-02-22",
				76.17
			],
			[
				"2012-11-09",
				67.31
			]
		],
		"80200801": [
			[
				"2014-02-10",
				20.73
			],
			[
				"2015-03-17",
				21.08
			],
			[
				"2016-01-06",
				21.26
			],
			[
				"2000-02-02",
				31.44
			],
			[
				"2000-08-14",
				32.33
			],
			[
				"2001-01-03",
				38.97
			],
			[
				"2001-07-13",
				35.87
			],
			[
				"2002-01-18",
				38.09
			],
			[
				"2002-09-05",
				35.87
			],
			[
				"2003-04-14",
				38.97
			],
			[
				"2003-12-10",
				38.97
			],
			[
				"2004-03-23",
				35.87
			],
			[
				"2004-09-07",
				33.26
			],
			[
				"2004-12-16",
				32.33
			],
			[
				"2005-11-03",
				27.59
			],
			[
				"2006-08-21",
				24.84
			],
			[
				"2006-10-12",
				25.02
			],
			[
				"2007-09-17",
				21.57
			],
			[
				"2008-05-21",
				19.71
			],
			[
				"2010-07-14",
				22.72
			],
			[
				"2011-06-09",
				21.35
			],
			[
				"2012-08-27",
				22.1
			],
			[
				"2013-03-06",
				24.58
			]
		],
		"80200953": [
			[
				"2013-07-09",
				78.39
			],
			[
				"2014-08-12",
				78.83
			],
			[
				"2015-06-18",
				74.84
			],
			[
				"2016-01-26",
				79.71
			],
			[
				"2000-02-22",
				109.83
			],
			[
				"2000-08-30",
				110.71
			],
			[
				"2001-01-12",
				110.71
			],
			[
				"2001-08-24",
				106.29
			],
			[
				"2002-03-12",
				107.17
			],
			[
				"2003-05-21",
				104.51
			],
			[
				"2003-12-17",
				99.64
			],
			[
				"2004-04-14",
				96.54
			],
			[
				"2004-08-13",
				96.54
			],
			[
				"2004-12-09",
				96.54
			],
			[
				"2005-11-18",
				88.57
			],
			[
				"2006-08-29",
				87.24
			],
			[
				"2007-05-08",
				78.83
			],
			[
				"2007-11-16",
				74.84
			],
			[
				"2008-07-17",
				73.07
			],
			[
				"2008-11-03",
				73.07
			],
			[
				"2009-08-19",
				71.74
			],
			[
				"2010-09-07",
				73.51
			],
			[
				"2011-06-08",
				65.99
			],
			[
				"2012-10-29",
				74.84
			]
		],
		"80201520": [
			[
				"2014-09-25",
				74.4
			],
			[
				"2015-06-23",
				67.31
			],
			[
				"2000-03-08",
				58.01
			],
			[
				"2000-10-05",
				60.67
			],
			[
				"2001-01-31",
				60.67
			],
			[
				"2001-09-04",
				72.19
			],
			[
				"2002-02-05",
				66.43
			],
			[
				"2003-01-07",
				81.04
			],
			[
				"2003-06-16",
				86.36
			],
			[
				"2004-01-26",
				84.59
			],
			[
				"2004-09-08",
				92.56
			],
			[
				"2005-02-01",
				93.44
			],
			[
				"2006-09-21",
				91.67
			],
			[
				"2007-01-26",
				89.01
			],
			[
				"2007-11-30",
				91.67
			],
			[
				"2008-07-22",
				81.49
			],
			[
				"2005-12-01",
				95.21
			],
			[
				"2009-10-06",
				69.09
			],
			[
				"2010-09-30",
				71.3
			],
			[
				"2011-03-25",
				68.2
			],
			[
				"2012-01-24",
				68.64
			],
			[
				"2013-01-10",
				65.54
			]
		],
		"80201556": [
			[
				"2014-06-04",
				1.33
			],
			[
				"2015-10-14",
				0.13
			],
			[
				"2000-03-08",
				1.33
			],
			[
				"2000-09-25",
				1.33
			],
			[
				"2001-01-31",
				1.33
			],
			[
				"2001-09-04",
				1.33
			],
			[
				"2002-02-05",
				1.33
			],
			[
				"2003-06-16",
				1.33
			],
			[
				"2004-01-26",
				1.33
			],
			[
				"2004-09-08",
				1.33
			],
			[
				"2005-02-01",
				1.33
			],
			[
				"2006-10-09",
				1.33
			],
			[
				"2007-01-26",
				1.33
			],
			[
				"2007-11-30",
				1.33
			],
			[
				"2008-07-22",
				1.33
			],
			[
				"2003-01-20",
				1.33
			],
			[
				"2005-12-01",
				1.33
			],
			[
				"2009-10-26",
				0.13
			],
			[
				"2010-11-03",
				1.33
			],
			[
				"2011-03-21",
				0.18
			],
			[
				"2012-09-28",
				0.13
			],
			[
				"2013-03-04",
				0.44
			]
		],
		"80201570": [
			[
				"2014-01-31",
				247.56
			],
			[
				"2015-08-27",
				234.71
			],
			[
				"2000-03-07",
				178.91
			],
			[
				"2001-01-11",
				177.59
			],
			[
				"2001-07-10",
				198.4
			],
			[
				"2002-02-18",
				195.74
			],
			[
				"2002-07-02",
				179.36
			],
			[
				"2003-05-07",
				161.64
			],
			[
				"2003-07-08",
				201.94
			],
			[
				"2004-04-30",
				147.47
			],
			[
				"2004-10-06",
				186
			],
			[
				"2005-01-31",
				193.09
			],
			[
				"2006-09-06",
				193.53
			],
			[
				"2006-10-05",
				220.99
			],
			[
				"2007-05-11",
				231.17
			],
			[
				"2007-11-09",
				263.06
			],
			[
				"2008-07-30",
				293.17
			],
			[
				"2005-09-21",
				183.34
			],
			[
				"2009-08-10",
				249.77
			],
			[
				"2010-09-06",
				235.6
			],
			[
				"2011-05-31",
				257.3
			],
			[
				"2012-05-23",
				244.01
			],
			[
				"2013-03-21",
				242.24
			]
		],
		"80201581": [
			[
				"2013-07-30",
				115.14
			],
			[
				"2014-03-28",
				96.54
			],
			[
				"2015-08-27",
				104.51
			],
			[
				"2000-03-07",
				101.41
			],
			[
				"2001-01-11",
				128.43
			],
			[
				"2001-07-10",
				104.96
			],
			[
				"2002-02-18",
				138.17
			],
			[
				"2002-07-02",
				130.64
			],
			[
				"2003-05-08",
				127.54
			],
			[
				"2003-07-08",
				133.74
			],
			[
				"2004-04-30",
				123.56
			],
			[
				"2004-10-06",
				127.1
			],
			[
				"2005-04-04",
				118.69
			],
			[
				"2006-09-06",
				121.34
			],
			[
				"2007-01-22",
				113.37
			],
			[
				"2007-11-09",
				112.04
			],
			[
				"2008-05-28",
				105.4
			],
			[
				"2005-09-21",
				112.04
			]
		],
		"80201600": [
			[
				"2014-03-28",
				118.24
			],
			[
				"2015-08-27",
				112.04
			],
			[
				"2000-03-07",
				111.16
			],
			[
				"2001-01-11",
				109.83
			],
			[
				"2001-07-09",
				107.61
			],
			[
				"2002-02-18",
				113.37
			],
			[
				"2002-09-26",
				113.81
			],
			[
				"2003-05-08",
				114.7
			],
			[
				"2004-04-30",
				109.39
			],
			[
				"2004-10-25",
				116.47
			],
			[
				"2005-04-04",
				116.47
			],
			[
				"2006-09-11",
				115.59
			],
			[
				"2007-01-22",
				112.49
			],
			[
				"2007-11-09",
				123.56
			],
			[
				"2008-05-28",
				110.71
			],
			[
				"2005-11-23",
				116.03
			],
			[
				"2010-08-03",
				120.46
			],
			[
				"2011-05-31",
				115.14
			],
			[
				"2012-05-16",
				123.56
			],
			[
				"2013-03-08",
				121.34
			]
		],
		"80201611": [
			[
				"2013-06-28",
				95.66
			],
			[
				"2014-05-22",
				88.57
			],
			[
				"2015-09-04",
				103.63
			],
			[
				"2000-09-11",
				86.8
			],
			[
				"2001-01-17",
				95.21
			],
			[
				"2001-07-09",
				86.8
			],
			[
				"2002-02-19",
				104.96
			],
			[
				"2002-09-26",
				97.43
			],
			[
				"2003-05-08",
				91.67
			],
			[
				"2004-05-03",
				89.01
			],
			[
				"2004-10-25",
				85.47
			],
			[
				"2005-04-04",
				65.54
			],
			[
				"2006-09-11",
				96.1
			],
			[
				"2006-10-05",
				93.44
			],
			[
				"2007-05-11",
				96.54
			],
			[
				"2007-11-13",
				88.57
			],
			[
				"2008-05-28",
				73.96
			],
			[
				"2005-11-23",
				88.57
			],
			[
				"2009-08-17",
				112.49
			],
			[
				"2010-06-07",
				103.19
			],
			[
				"2011-05-31",
				84.59
			],
			[
				"2012-11-06",
				84.59
			]
		],
		"80201623": [
			[
				"2014-12-16",
				54.03
			],
			[
				"2015-08-31",
				54.47
			],
			[
				"2016-01-08",
				57.57
			],
			[
				"2000-02-03",
				53.14
			],
			[
				"2000-08-22",
				53.14
			],
			[
				"2001-01-24",
				53.14
			],
			[
				"2001-07-05",
				55.36
			],
			[
				"2002-01-07",
				57.13
			],
			[
				"2002-09-03",
				58.9
			],
			[
				"2004-01-12",
				53.59
			],
			[
				"2004-07-26",
				54.03
			],
			[
				"2004-12-07",
				53.59
			],
			[
				"2006-08-24",
				57.13
			],
			[
				"2007-01-23",
				56.69
			],
			[
				"2007-09-19",
				58.01
			],
			[
				"2008-06-04",
				62
			],
			[
				"2003-02-19",
				58.9
			],
			[
				"2005-09-22",
				54.03
			],
			[
				"2010-06-11",
				64.66
			],
			[
				"2011-03-18",
				61.11
			],
			[
				"2012-01-03",
				62.89
			],
			[
				"2013-01-07",
				61.56
			]
		],
		"80201714": [
			[
				"2014-05-12",
				13.86
			],
			[
				"2015-09-23",
				13.6
			],
			[
				"2000-02-04",
				19.93
			],
			[
				"2000-08-21",
				12.84
			],
			[
				"2001-01-04",
				17.27
			],
			[
				"2001-07-17",
				13.29
			],
			[
				"2002-01-10",
				9.3
			],
			[
				"2002-09-04",
				8.41
			],
			[
				"2003-04-30",
				9.3
			],
			[
				"2004-01-13",
				35.43
			],
			[
				"2004-10-08",
				28.96
			],
			[
				"2005-02-11",
				31.27
			],
			[
				"2005-11-07",
				30.34
			],
			[
				"2006-08-28",
				36.45
			],
			[
				"2007-01-23",
				30.03
			],
			[
				"2007-11-26",
				17.4
			],
			[
				"2008-07-09",
				14.04
			],
			[
				"2010-06-09",
				21.3
			],
			[
				"2011-01-04",
				16.56
			],
			[
				"2012-02-13",
				26.22
			],
			[
				"2013-01-28",
				18.29
			]
		],
		"80300285": [
			[
				"2013-05-08",
				1.33
			],
			[
				"2014-12-11",
				0.18
			],
			[
				"2015-02-23",
				0.62
			],
			[
				"2000-02-17",
				3.32
			],
			[
				"2000-09-12",
				9.3
			],
			[
				"2001-01-19",
				18.16
			],
			[
				"2001-08-29",
				1.51
			],
			[
				"2002-01-15",
				8.86
			],
			[
				"2002-09-16",
				7.53
			],
			[
				"2003-02-28",
				20.81
			],
			[
				"2004-01-21",
				6.55
			],
			[
				"2004-08-18",
				1.33
			],
			[
				"2004-12-15",
				1.33
			],
			[
				"2005-10-21",
				1.33
			],
			[
				"2006-08-28",
				1.33
			],
			[
				"2007-05-16",
				1.33
			],
			[
				"2007-11-22",
				1.33
			],
			[
				"2008-07-24",
				1.33
			],
			[
				"2010-06-09",
				10.05
			],
			[
				"2011-01-04",
				3.76
			]
		],
		"80300364": [
			[
				"2013-04-15",
				62
			],
			[
				"2014-05-23",
				74.84
			],
			[
				"2015-09-25",
				70.86
			],
			[
				"2016-01-27",
				84.14
			],
			[
				"2000-03-29",
				47.39
			],
			[
				"2000-09-26",
				39.86
			],
			[
				"2001-02-02",
				38.53
			],
			[
				"2001-09-07",
				34.99
			],
			[
				"2002-01-29",
				37.2
			],
			[
				"2002-07-03",
				23.03
			],
			[
				"2003-07-09",
				51.81
			],
			[
				"2004-04-15",
				59.79
			],
			[
				"2004-10-05",
				29.23
			],
			[
				"2004-12-28",
				40.52
			],
			[
				"2006-10-09",
				39.86
			],
			[
				"2007-05-23",
				46.5
			],
			[
				"2008-04-11",
				50.04
			],
			[
				"2008-07-30",
				46.94
			],
			[
				"2003-01-23",
				42.07
			],
			[
				"2005-09-20",
				32.9
			],
			[
				"2009-10-07",
				63.33
			],
			[
				"2010-05-31",
				54.03
			],
			[
				"2011-05-04",
				39.99
			],
			[
				"2012-08-31",
				72.19
			]
		],
		"80300376": [
			[
				"2014-09-25",
				73.07
			],
			[
				"2015-09-25",
				35.21
			],
			[
				"2016-01-27",
				36.31
			],
			[
				"2000-03-10",
				24.62
			],
			[
				"2000-09-26",
				25.11
			],
			[
				"2001-02-02",
				46.5
			],
			[
				"2001-09-07",
				22.59
			],
			[
				"2002-01-29",
				20.37
			],
			[
				"2003-06-24",
				29.01
			],
			[
				"2004-04-19",
				25.69
			],
			[
				"2004-09-13",
				25.86
			],
			[
				"2004-12-20",
				15.28
			],
			[
				"2006-09-28",
				27.63
			],
			[
				"2007-07-31",
				27.72
			],
			[
				"2008-04-11",
				23.47
			],
			[
				"2003-01-21",
				17.71
			],
			[
				"2005-12-08",
				24.71
			],
			[
				"2009-10-07",
				28.12
			],
			[
				"2010-09-16",
				33.7
			],
			[
				"2011-06-10",
				11.07
			],
			[
				"2012-09-14",
				32.68
			],
			[
				"2013-01-29",
				43
			]
		],
		"80300662": [
			[
				"2015-07-07",
				31.71
			],
			[
				"2000-03-03",
				15.46
			],
			[
				"2000-08-28",
				27.46
			],
			[
				"2001-01-18",
				14.61
			],
			[
				"2001-07-11",
				27.01
			],
			[
				"2002-02-13",
				30.11
			],
			[
				"2002-09-26",
				35.69
			],
			[
				"2003-05-09",
				23.03
			],
			[
				"2004-01-27",
				35.87
			],
			[
				"2004-07-29",
				31.89
			],
			[
				"2005-01-28",
				31.4
			],
			[
				"2006-09-05",
				28.7
			],
			[
				"2007-01-22",
				29.89
			],
			[
				"2008-04-10",
				44.29
			],
			[
				"2007-11-08",
				30.65
			],
			[
				"2005-11-22",
				31.62
			],
			[
				"2009-07-31",
				24.49
			],
			[
				"2010-08-03",
				31.49
			],
			[
				"2011-05-05",
				39.95
			],
			[
				"2012-01-16",
				31.8
			],
			[
				"2013-03-08",
				26.04
			]
		],
		"80300686": [
			[
				"2014-05-22",
				119.13
			],
			[
				"2015-10-14",
				112.49
			],
			[
				"2000-05-25",
				101.86
			],
			[
				"2000-09-11",
				108.94
			],
			[
				"2001-01-18",
				108.94
			],
			[
				"2001-07-09",
				111.16
			],
			[
				"2002-02-19",
				112.49
			],
			[
				"2002-07-02",
				109.39
			],
			[
				"2003-07-08",
				109.83
			],
			[
				"2004-05-03",
				110.27
			],
			[
				"2004-10-06",
				118.69
			],
			[
				"2005-01-28",
				121.79
			],
			[
				"2006-09-11",
				131.53
			],
			[
				"2006-10-05",
				126.66
			],
			[
				"2007-05-11",
				126.66
			],
			[
				"2007-11-13",
				124.89
			],
			[
				"2008-04-10",
				124
			],
			[
				"2005-09-21",
				121.34
			],
			[
				"2009-08-17",
				121.79
			],
			[
				"2010-09-08",
				124
			],
			[
				"2011-05-25",
				127.1
			],
			[
				"2012-06-18",
				128.43
			],
			[
				"2013-03-21",
				127.1
			]
		],
		"80300789": [
			[
				"2014-08-12",
				18.69
			],
			[
				"2015-08-31",
				32.77
			],
			[
				"2016-01-08",
				29.67
			],
			[
				"2000-02-03",
				56.24
			],
			[
				"2000-08-21",
				69.97
			],
			[
				"2001-01-25",
				67.31
			],
			[
				"2001-07-05",
				64.66
			],
			[
				"2002-01-10",
				79.27
			],
			[
				"2002-09-03",
				71.74
			],
			[
				"2003-05-06",
				69.09
			],
			[
				"2004-01-12",
				73.51
			],
			[
				"2004-07-26",
				70.86
			],
			[
				"2004-12-07",
				70.86
			],
			[
				"2005-11-04",
				66.87
			],
			[
				"2006-08-24",
				60.67
			],
			[
				"2007-01-23",
				55.36
			],
			[
				"2007-09-19",
				57.57
			],
			[
				"2008-06-04",
				48.27
			],
			[
				"2010-06-11",
				38.57
			],
			[
				"2011-03-18",
				37.33
			],
			[
				"2012-01-03",
				39.81
			],
			[
				"2013-01-07",
				28.79
			]
		],
		"80300911": [
			[
				"2013-06-27",
				44.73
			],
			[
				"2015-09-08",
				71.74
			],
			[
				"2000-01-21",
				81.93
			],
			[
				"2000-11-08",
				81.93
			],
			[
				"2001-03-15",
				84.14
			],
			[
				"2001-10-05",
				70.86
			],
			[
				"2002-04-02",
				88.57
			],
			[
				"2003-02-18",
				84.59
			],
			[
				"2003-08-06",
				75.29
			],
			[
				"2004-01-30",
				82.81
			],
			[
				"2004-08-05",
				84.14
			],
			[
				"2005-01-25",
				79.27
			],
			[
				"2006-03-07",
				79.27
			],
			[
				"2007-08-16",
				60.23
			],
			[
				"2008-11-11",
				51.37
			],
			[
				"2010-01-15",
				57.57
			],
			[
				"2011-01-05",
				58.46
			],
			[
				"2012-09-26",
				45.61
			]
		],
		"80300935": [
			[
				"2014-02-03",
				1.33
			],
			[
				"2015-09-01",
				0.13
			],
			[
				"2000-10-23",
				7.97
			],
			[
				"2001-03-02",
				8.41
			],
			[
				"2001-10-04",
				5.31
			],
			[
				"2002-04-11",
				12.84
			],
			[
				"2002-07-01",
				5.76
			],
			[
				"2003-02-17",
				13.73
			],
			[
				"2003-07-07",
				7.97
			],
			[
				"2004-04-26",
				7.97
			],
			[
				"2004-10-04",
				7.31
			],
			[
				"2005-03-08",
				11.07
			],
			[
				"2006-01-20",
				8.86
			],
			[
				"2006-10-11",
				10.5
			],
			[
				"2007-07-25",
				10.67
			],
			[
				"2008-03-06",
				11.96
			],
			[
				"2000-04-14",
				8.41
			],
			[
				"2005-09-19",
				5.93
			],
			[
				"2010-01-14",
				11.47
			],
			[
				"2011-08-22",
				0.13
			],
			[
				"2012-09-10",
				0.13
			],
			[
				"2013-01-11",
				0.13
			]
		],
		"80300947": [
			[
				"2013-04-11",
				38.17
			],
			[
				"2014-08-25",
				37.82
			],
			[
				"2015-08-24",
				31.31
			],
			[
				"2000-10-30",
				93.89
			],
			[
				"2001-02-28",
				63.77
			],
			[
				"2001-09-27",
				63.33
			],
			[
				"2002-04-05",
				57.57
			],
			[
				"2003-07-28",
				69.53
			],
			[
				"2004-03-11",
				55.36
			],
			[
				"2004-10-12",
				52.7
			],
			[
				"2005-03-09",
				64.21
			],
			[
				"2006-01-18",
				56.24
			],
			[
				"2006-11-08",
				58.01
			],
			[
				"2007-07-20",
				51.37
			],
			[
				"2008-03-04",
				50.49
			],
			[
				"2000-05-02",
				69.53
			],
			[
				"2003-02-14",
				79.27
			],
			[
				"2010-01-13",
				58.01
			],
			[
				"2011-01-17",
				43.36
			],
			[
				"2012-07-05",
				40.57
			]
		],
		"80300960": [
			[
				"2013-04-11",
				88.57
			],
			[
				"2014-09-16",
				95.66
			],
			[
				"2015-09-01",
				89.46
			],
			[
				"2000-11-02",
				80.6
			],
			[
				"2001-03-01",
				86.36
			],
			[
				"2001-10-04",
				83.26
			],
			[
				"2002-04-10",
				89.01
			],
			[
				"2003-02-18",
				87.69
			],
			[
				"2003-07-31",
				84.14
			],
			[
				"2004-03-10",
				84.14
			],
			[
				"2004-10-11",
				85.03
			],
			[
				"2005-03-14",
				85.47
			],
			[
				"2006-01-30",
				85.47
			],
			[
				"2006-11-10",
				91.23
			],
			[
				"2007-07-26",
				88.57
			],
			[
				"2008-08-25",
				89.46
			],
			[
				"2000-05-02",
				80.16
			],
			[
				"2010-01-18",
				93.89
			],
			[
				"2011-01-17",
				89.01
			],
			[
				"2012-07-05",
				92.11
			]
		],
		"80300996": [
			[
				"2014-05-16",
				37.91
			],
			[
				"2015-08-25",
				38.79
			],
			[
				"2016-01-07",
				33.21
			],
			[
				"2000-10-20",
				31.44
			],
			[
				"2001-02-20",
				31
			],
			[
				"2001-09-21",
				22.28
			],
			[
				"2002-04-02",
				32.33
			],
			[
				"2002-07-01",
				29.23
			],
			[
				"2003-07-07",
				34.99
			],
			[
				"2004-04-21",
				38.09
			],
			[
				"2004-10-04",
				28.48
			],
			[
				"2005-01-19",
				34.45
			],
			[
				"2006-01-04",
				34.1
			],
			[
				"2006-10-18",
				32.06
			],
			[
				"2007-07-27",
				31.31
			],
			[
				"2008-01-29",
				41.94
			],
			[
				"2008-11-10",
				43.53
			],
			[
				"2003-02-11",
				36.31
			],
			[
				"2005-09-20",
				37.02
			],
			[
				"2009-11-18",
				37.51
			],
			[
				"2010-09-15",
				42.91
			],
			[
				"2011-03-11",
				47.39
			],
			[
				"2012-05-31",
				41.98
			],
			[
				"2013-02-14",
				41.54
			]
		],
		"80301009": [
			[
				"2013-05-02",
				77.5
			],
			[
				"2015-10-12",
				65.1
			],
			[
				"2000-10-16",
				109.83
			],
			[
				"2001-02-19",
				115.14
			],
			[
				"2001-09-20",
				113.81
			],
			[
				"2002-02-22",
				118.69
			],
			[
				"2003-07-16",
				118.24
			],
			[
				"2004-01-14",
				115.59
			],
			[
				"2004-09-27",
				108.06
			],
			[
				"2005-01-26",
				115.59
			],
			[
				"2006-01-03",
				117.36
			],
			[
				"2007-07-17",
				109.83
			],
			[
				"2008-03-07",
				121.79
			],
			[
				"2000-04-10",
				120.46
			],
			[
				"2003-02-04",
				132.86
			],
			[
				"2006-10-27",
				108.5
			],
			[
				"2009-11-20",
				116.47
			],
			[
				"2010-08-04",
				107.61
			],
			[
				"2011-05-19",
				98.76
			],
			[
				"2012-10-26",
				80.6
			]
		],
		"80301010": [
			[
				"2013-05-02",
				78.39
			],
			[
				"2014-02-06",
				80.6
			],
			[
				"2015-06-17",
				53.59
			],
			[
				"2016-01-22",
				53.14
			],
			[
				"2000-04-10",
				64.66
			],
			[
				"2000-10-16",
				58.46
			],
			[
				"2001-02-19",
				44.73
			],
			[
				"2001-09-20",
				52.26
			],
			[
				"2002-02-22",
				32.33
			],
			[
				"2003-07-14",
				43.84
			],
			[
				"2004-01-14",
				68.64
			],
			[
				"2004-09-24",
				62.89
			],
			[
				"2005-01-26",
				39.95
			],
			[
				"2006-01-03",
				67.31
			],
			[
				"2007-07-17",
				62
			],
			[
				"2008-02-01",
				26.84
			],
			[
				"2003-02-04",
				39.86
			],
			[
				"2006-10-23",
				47.83
			],
			[
				"2009-11-20",
				64.66
			],
			[
				"2010-08-04",
				77.5
			],
			[
				"2011-05-19",
				62.89
			]
		],
		"80301022": [
			[
				"2015-08-25",
				58.46
			],
			[
				"2016-01-07",
				57.57
			],
			[
				"2000-04-10",
				56.69
			],
			[
				"2000-10-16",
				72.19
			],
			[
				"2001-02-19",
				69.53
			],
			[
				"2001-09-20",
				83.7
			],
			[
				"2002-02-22",
				75.29
			],
			[
				"2003-07-14",
				114.7
			],
			[
				"2004-01-14",
				95.21
			],
			[
				"2004-09-24",
				88.57
			],
			[
				"2005-01-26",
				93.44
			],
			[
				"2006-01-03",
				111.6
			],
			[
				"2006-10-23",
				97.43
			],
			[
				"2007-07-18",
				80.6
			],
			[
				"2008-03-07",
				85.91
			],
			[
				"2003-02-04",
				94.33
			],
			[
				"2009-12-02",
				53.59
			],
			[
				"2010-08-18",
				61.11
			],
			[
				"2011-02-24",
				47.39
			],
			[
				"2012-05-31",
				65.54
			],
			[
				"2013-02-14",
				49.6
			]
		],
		"80301034": [
			[
				"2014-02-06",
				1.33
			],
			[
				"2015-06-17",
				0.13
			],
			[
				"2000-04-07",
				1.33
			],
			[
				"2000-10-17",
				1.33
			],
			[
				"2001-02-16",
				1.33
			],
			[
				"2001-09-19",
				1.33
			],
			[
				"2002-02-20",
				1.33
			],
			[
				"2003-07-15",
				3.54
			],
			[
				"2004-04-21",
				1.33
			],
			[
				"2004-09-27",
				1.33
			],
			[
				"2005-01-11",
				1.33
			],
			[
				"2006-01-05",
				1.33
			],
			[
				"2007-07-18",
				1.33
			],
			[
				"2008-01-28",
				1.33
			],
			[
				"2003-02-10",
				1.9
			],
			[
				"2006-10-27",
				1.33
			],
			[
				"2009-11-19",
				1.33
			],
			[
				"2010-08-06",
				1.33
			],
			[
				"2011-03-10",
				0.31
			],
			[
				"2012-01-30",
				0.13
			],
			[
				"2013-02-20",
				0.13
			]
		],
		"80301060": [
			[
				"2014-05-16",
				97.87
			],
			[
				"2015-06-22",
				97.87
			],
			[
				"2000-01-28",
				186.44
			],
			[
				"2000-10-06",
				171.83
			],
			[
				"2001-02-12",
				181.13
			],
			[
				"2001-09-17",
				164.3
			],
			[
				"2002-03-15",
				166.96
			],
			[
				"2002-07-03",
				150.13
			],
			[
				"2003-07-09",
				140.83
			],
			[
				"2004-04-22",
				121.79
			],
			[
				"2004-10-05",
				99.2
			],
			[
				"2005-01-04",
				100.09
			],
			[
				"2006-01-06",
				92.11
			],
			[
				"2006-10-10",
				89.46
			],
			[
				"2007-06-06",
				93.89
			],
			[
				"2008-01-15",
				97.87
			],
			[
				"2003-01-30",
				150.57
			],
			[
				"2005-09-20",
				92.56
			],
			[
				"2009-11-05",
				97.87
			],
			[
				"2010-11-11",
				91.23
			],
			[
				"2011-06-30",
				91.67
			],
			[
				"2012-09-28",
				93.89
			],
			[
				"2013-03-20",
				98.76
			]
		],
		"80301150": [
			[
				"2015-08-31",
				5.71
			],
			[
				"2016-01-08",
				4.43
			],
			[
				"2000-02-23",
				27.1
			],
			[
				"2000-08-25",
				25.24
			],
			[
				"2000-12-18",
				21.7
			],
			[
				"2001-01-09",
				20.37
			],
			[
				"2001-07-12",
				23.03
			],
			[
				"2002-02-12",
				19.93
			],
			[
				"2002-09-25",
				18.2
			],
			[
				"2003-05-06",
				11.96
			],
			[
				"2004-01-22",
				15.1
			],
			[
				"2004-08-16",
				17.27
			],
			[
				"2005-03-17",
				13.99
			],
			[
				"2006-09-20",
				13.82
			],
			[
				"2007-05-25",
				10.36
			],
			[
				"2007-11-08",
				9.34
			],
			[
				"2008-08-04",
				7.44
			],
			[
				"2005-11-25",
				15.77
			],
			[
				"2009-07-31",
				7.09
			],
			[
				"2010-09-03",
				3.94
			],
			[
				"2011-03-17",
				5.89
			],
			[
				"2012-01-17",
				6.69
			],
			[
				"2013-03-21",
				4.61
			]
		],
		"80301277": [
			[
				"2013-05-08",
				1.33
			],
			[
				"2014-09-29",
				1.33
			],
			[
				"2015-06-18",
				0.13
			],
			[
				"2016-01-26",
				0.97
			],
			[
				"2000-02-18",
				5.49
			],
			[
				"2000-09-01",
				3.37
			],
			[
				"2001-01-15",
				6.64
			],
			[
				"2001-08-22",
				1.68
			],
			[
				"2002-03-11",
				7.09
			],
			[
				"2002-09-23",
				1.51
			],
			[
				"2003-05-23",
				2.48
			],
			[
				"2003-12-12",
				1.33
			],
			[
				"2004-03-08",
				8.41
			],
			[
				"2004-07-27",
				2.97
			],
			[
				"2004-12-08",
				4.43
			],
			[
				"2006-09-15",
				3.19
			],
			[
				"2007-01-25",
				6.95
			],
			[
				"2007-11-12",
				3.9
			],
			[
				"2008-07-15",
				3.81
			],
			[
				"2005-11-15",
				1.46
			],
			[
				"2009-08-18",
				0.35
			],
			[
				"2010-09-06",
				1.33
			],
			[
				"2011-06-22",
				0.18
			],
			[
				"2012-10-29",
				1.06
			]
		],
		"80301289": [
			[
				"2013-07-09",
				19.35
			],
			[
				"2014-06-16",
				19
			],
			[
				"2015-09-24",
				17.49
			],
			[
				"2000-02-17",
				26.79
			],
			[
				"2000-08-30",
				27.01
			],
			[
				"2000-12-18",
				26.13
			],
			[
				"2001-01-18",
				27.46
			],
			[
				"2001-08-28",
				27.46
			],
			[
				"2002-03-12",
				28.34
			],
			[
				"2002-09-17",
				27.01
			],
			[
				"2003-05-28",
				25.46
			],
			[
				"2004-04-01",
				21.26
			],
			[
				"2004-08-17",
				20.81
			],
			[
				"2004-12-09",
				22.36
			],
			[
				"2006-09-19",
				14.53
			],
			[
				"2007-06-11",
				21.52
			],
			[
				"2007-11-16",
				20.86
			],
			[
				"2008-07-18",
				18.11
			],
			[
				"2005-11-21",
				15.85
			],
			[
				"2009-08-19",
				29.94
			],
			[
				"2010-09-07",
				22.45
			],
			[
				"2011-06-08",
				23.34
			],
			[
				"2012-10-29",
				20.9
			]
		],
		"80301290": [
			[
				"2013-09-27",
				11.96
			],
			[
				"2014-03-17",
				10.54
			],
			[
				"2015-12-03",
				4.83
			],
			[
				"2000-02-16",
				25.91
			],
			[
				"2000-09-13",
				1.86
			],
			[
				"2001-01-22",
				3.81
			],
			[
				"2001-08-30",
				44.29
			],
			[
				"2002-01-16",
				49.6
			],
			[
				"2002-07-04",
				30.11
			],
			[
				"2003-06-11",
				21.66
			],
			[
				"2003-07-10",
				22.59
			],
			[
				"2004-01-21",
				60.23
			],
			[
				"2004-05-25",
				54.03
			],
			[
				"2004-10-07",
				48.27
			],
			[
				"2004-12-21",
				49.6
			],
			[
				"2006-09-12",
				13.15
			],
			[
				"2007-06-18",
				19.97
			],
			[
				"2007-11-22",
				14.48
			],
			[
				"2008-07-21",
				17.63
			],
			[
				"2008-11-05",
				12.8
			],
			[
				"2005-09-21",
				34.14
			],
			[
				"2009-08-21",
				27.24
			],
			[
				"2010-07-29",
				18.87
			],
			[
				"2011-05-05",
				23.96
			],
			[
				"2012-02-09",
				62
			],
			[
				"2013-01-28",
				26.53
			]
		],
		"80301307": [
			[
				"2013-09-25",
				10.76
			],
			[
				"2013-05-03",
				10.76
			],
			[
				"2014-01-10",
				11.2
			],
			[
				"2015-07-03",
				14.17
			],
			[
				"2000-01-24",
				19.49
			],
			[
				"2000-09-15",
				21.7
			],
			[
				"2000-11-28",
				20.11
			],
			[
				"2001-01-31",
				21.17
			],
			[
				"2001-11-13",
				17.71
			],
			[
				"2002-01-23",
				20.81
			],
			[
				"2002-09-11",
				41.19
			],
			[
				"2003-06-12",
				34.72
			],
			[
				"2004-01-29",
				20.68
			],
			[
				"2005-04-25",
				12.18
			],
			[
				"2005-11-02",
				11.87
			],
			[
				"2006-08-25",
				11.43
			],
			[
				"2007-10-10",
				10.45
			],
			[
				"2007-05-16",
				9.88
			],
			[
				"2008-06-09",
				10.5
			],
			[
				"2010-06-10",
				9.65
			],
			[
				"2011-06-16",
				11.38
			],
			[
				"2012-07-03",
				12.8
			]
		],
		"80301332": [
			[
				"2013-05-13",
				61.11
			],
			[
				"2014-03-31",
				65.1
			],
			[
				"2015-08-20",
				75.29
			],
			[
				"2000-05-24",
				54.91
			],
			[
				"2000-08-16",
				88.57
			],
			[
				"2000-11-21",
				62.44
			],
			[
				"2001-01-04",
				63.33
			],
			[
				"2001-07-17",
				55.36
			],
			[
				"2002-01-10",
				80.16
			],
			[
				"2002-07-04",
				68.2
			],
			[
				"2003-04-30",
				77.06
			],
			[
				"2003-07-10",
				70.41
			],
			[
				"2004-05-25",
				75.29
			],
			[
				"2004-10-07",
				74.4
			],
			[
				"2005-04-14",
				65.99
			],
			[
				"2006-08-28",
				74.4
			],
			[
				"2008-04-16",
				65.1
			],
			[
				"2007-07-04",
				58.46
			],
			[
				"2005-09-22",
				67.76
			],
			[
				"2010-11-22",
				89.9
			],
			[
				"2011-06-20",
				46.94
			],
			[
				"2012-09-03",
				51.37
			]
		],
		"80301344": [
			[
				"2013-05-13",
				19.35
			],
			[
				"2014-03-18",
				21.66
			],
			[
				"2015-07-03",
				20.11
			],
			[
				"2000-02-02",
				30.11
			],
			[
				"2000-08-14",
				24.8
			],
			[
				"2001-01-03",
				33.66
			],
			[
				"2001-07-16",
				38.53
			],
			[
				"2002-01-18",
				39.41
			],
			[
				"2002-09-05",
				35.43
			],
			[
				"2006-08-22",
				9.57
			],
			[
				"2007-05-16",
				9.57
			],
			[
				"2008-05-21",
				8.77
			],
			[
				"2008-11-05",
				2.57
			],
			[
				"2007-10-15",
				8.9
			],
			[
				"2009-12-03",
				3.5
			],
			[
				"2010-11-22",
				7.66
			],
			[
				"2011-06-20",
				10.23
			],
			[
				"2012-09-03",
				15.63
			]
		],
		"80301356": [
			[
				"2013-09-30",
				19.04
			],
			[
				"2014-02-10",
				20.46
			],
			[
				"2015-03-17",
				20.11
			],
			[
				"2000-11-21",
				20.37
			],
			[
				"2001-01-03",
				20.81
			],
			[
				"2001-07-13",
				25.24
			],
			[
				"2002-01-22",
				18.6
			],
			[
				"2002-07-04",
				20.81
			],
			[
				"2003-04-14",
				17.27
			],
			[
				"2003-07-10",
				17.71
			],
			[
				"2004-03-23",
				10.63
			],
			[
				"2004-10-07",
				11.2
			],
			[
				"2004-12-22",
				11.51
			],
			[
				"2006-08-21",
				15.85
			],
			[
				"2007-05-22",
				19.75
			],
			[
				"2008-05-21",
				19.8
			],
			[
				"2000-05-04",
				25.15
			],
			[
				"2005-09-22",
				13.51
			],
			[
				"2007-10-15",
				19.31
			],
			[
				"2010-06-08",
				15.41
			],
			[
				"2011-06-09",
				20.19
			],
			[
				"2012-08-27",
				14.44
			],
			[
				"2013-03-06",
				15.72
			]
		],
		"80301423": [
			[
				"2013-04-18",
				1.33
			],
			[
				"2014-08-21",
				0.13
			],
			[
				"2015-09-02",
				0.13
			],
			[
				"2000-11-15",
				1.33
			],
			[
				"2001-03-22",
				12.84
			],
			[
				"2001-10-25",
				1.33
			],
			[
				"2002-05-07",
				3.68
			],
			[
				"2003-03-27",
				3.28
			],
			[
				"2003-09-12",
				1.33
			],
			[
				"2004-02-24",
				20.15
			],
			[
				"2004-11-03",
				1.33
			],
			[
				"2005-04-11",
				3.14
			],
			[
				"2006-03-01",
				10.45
			],
			[
				"2006-10-12",
				1.33
			],
			[
				"2007-09-03",
				1.33
			],
			[
				"2008-05-26",
				1.33
			],
			[
				"2000-05-04",
				17.71
			],
			[
				"2010-07-12",
				0.13
			],
			[
				"2011-02-24",
				11.82
			],
			[
				"2011-08-03",
				0.13
			],
			[
				"2012-11-26",
				0.13
			]
		],
		"80301435": [
			[
				"2014-08-21",
				81.93
			],
			[
				"2015-09-02",
				65.1
			],
			[
				"2000-11-15",
				97.87
			],
			[
				"2001-03-22",
				77.94
			],
			[
				"2001-10-25",
				77.5
			],
			[
				"2002-05-07",
				62.44
			],
			[
				"2003-03-27",
				64.66
			],
			[
				"2003-09-12",
				66.87
			],
			[
				"2004-02-24",
				62.44
			],
			[
				"2004-11-03",
				60.67
			],
			[
				"2005-04-11",
				62
			],
			[
				"2006-03-01",
				71.3
			],
			[
				"2007-09-03",
				60.67
			],
			[
				"2008-05-26",
				73.07
			],
			[
				"2000-05-04",
				95.21
			],
			[
				"2006-10-12",
				62.89
			],
			[
				"2011-01-06",
				65.54
			],
			[
				"2010-07-12",
				62
			],
			[
				"2012-01-31",
				65.54
			],
			[
				"2013-01-24",
				66.43
			]
		],
		"80301460": [
			[
				"2015-09-28",
				31.18
			],
			[
				"2000-11-13",
				35.43
			],
			[
				"2001-03-20",
				53.14
			],
			[
				"2001-10-24",
				40.3
			],
			[
				"2002-04-26",
				62.89
			],
			[
				"2003-03-25",
				62
			],
			[
				"2003-09-11",
				50.49
			],
			[
				"2004-02-25",
				70.41
			],
			[
				"2004-11-02",
				38.4
			],
			[
				"2005-04-12",
				55.36
			],
			[
				"2006-03-08",
				48.71
			],
			[
				"2006-12-12",
				36.62
			],
			[
				"2007-09-06",
				35.21
			],
			[
				"2008-06-02",
				39.02
			],
			[
				"2000-05-03",
				42.29
			],
			[
				"2010-01-28",
				45.17
			],
			[
				"2011-01-20",
				32.2
			],
			[
				"2012-10-02",
				36.98
			],
			[
				"2013-03-01",
				39.28
			]
		],
		"80301484": [
			[
				"2014-06-25",
				26.17
			],
			[
				"2015-09-28",
				26.75
			],
			[
				"2000-11-14",
				119.57
			],
			[
				"2001-03-20",
				125.77
			],
			[
				"2001-10-24",
				109.83
			],
			[
				"2002-05-06",
				73.96
			],
			[
				"2003-03-25",
				76.61
			],
			[
				"2003-09-11",
				74.84
			],
			[
				"2004-02-25",
				68.64
			],
			[
				"2004-10-29",
				84.59
			],
			[
				"2005-04-12",
				86.8
			],
			[
				"2006-03-08",
				89.9
			],
			[
				"2006-12-12",
				62.44
			],
			[
				"2007-09-06",
				63.33
			],
			[
				"2008-06-02",
				38
			],
			[
				"2000-05-03",
				113.37
			],
			[
				"2005-09-19",
				75.73
			],
			[
				"2010-01-28",
				39.72
			],
			[
				"2011-01-20",
				42.47
			],
			[
				"2012-10-02",
				35.38
			],
			[
				"2013-03-01",
				35.34
			]
		],
		"80301496": [
			[
				"2014-06-13",
				1.95
			],
			[
				"2015-08-14",
				1.28
			],
			[
				"2000-11-14",
				1.95
			],
			[
				"2001-03-26",
				4.78
			],
			[
				"2001-10-24",
				1.9
			],
			[
				"2002-05-06",
				2.21
			],
			[
				"2003-03-25",
				2.97
			],
			[
				"2003-09-08",
				3.72
			],
			[
				"2004-02-17",
				1.77
			],
			[
				"2004-10-29",
				1.33
			],
			[
				"2005-04-18",
				2.66
			],
			[
				"2006-03-14",
				1.46
			],
			[
				"2006-12-14",
				1.59
			],
			[
				"2007-09-07",
				3.14
			],
			[
				"2008-06-02",
				1.33
			],
			[
				"2010-01-29",
				4.47
			],
			[
				"2011-01-19",
				3.54
			],
			[
				"2012-06-29",
				3.23
			],
			[
				"2013-01-24",
				2.79
			]
		],
		"80301502": [
			[
				"2013-06-24",
				52.26
			],
			[
				"2014-01-13",
				47.83
			],
			[
				"2015-09-03",
				50.04
			],
			[
				"2016-01-28",
				48.71
			],
			[
				"2000-01-04",
				53.14
			],
			[
				"2000-11-13",
				49.6
			],
			[
				"2001-03-14",
				41.63
			],
			[
				"2001-10-16",
				61.56
			],
			[
				"2002-04-26",
				63.33
			],
			[
				"2003-09-01",
				77.5
			],
			[
				"2004-04-29",
				75.29
			],
			[
				"2004-08-10",
				74.84
			],
			[
				"2005-03-31",
				69.97
			],
			[
				"2006-03-06",
				73.07
			],
			[
				"2006-12-11",
				68.2
			],
			[
				"2007-08-14",
				62
			],
			[
				"2008-08-06",
				61.11
			],
			[
				"2003-02-26",
				71.3
			],
			[
				"2010-01-21",
				61.11
			],
			[
				"2011-02-18",
				52.7
			],
			[
				"2012-09-26",
				24.36
			],
			[
				"2013-01-04",
				55.8
			]
		],
		"80301514": [
			[
				"2014-09-08",
				46.94
			],
			[
				"2015-03-16",
				52.7
			],
			[
				"2016-01-25",
				48.71
			],
			[
				"2000-01-04",
				26.13
			],
			[
				"2000-11-09",
				18.6
			],
			[
				"2001-03-14",
				14.17
			],
			[
				"2001-10-23",
				9.3
			],
			[
				"2002-04-23",
				11.56
			],
			[
				"2003-09-01",
				12.4
			],
			[
				"2004-04-27",
				13.73
			],
			[
				"2004-08-10",
				14.61
			],
			[
				"2005-03-31",
				17.01
			],
			[
				"2006-03-06",
				29.85
			],
			[
				"2006-12-11",
				35.69
			],
			[
				"2007-08-14",
				38.75
			],
			[
				"2008-03-11",
				41.81
			],
			[
				"2003-02-25",
				9.74
			],
			[
				"2010-01-20",
				34.54
			],
			[
				"2011-01-21",
				31.18
			],
			[
				"2012-01-09",
				24.71
			],
			[
				"2013-01-04",
				38.26
			]
		],
		"80301540": [
			[
				"2013-04-25",
				31
			],
			[
				"2014-12-15",
				24.62
			],
			[
				"2015-09-03",
				23.74
			],
			[
				"2016-01-25",
				23.47
			],
			[
				"2000-01-05",
				37.2
			],
			[
				"2000-11-09",
				35.87
			],
			[
				"2001-03-13",
				33.52
			],
			[
				"2001-10-16",
				28.34
			],
			[
				"2002-04-23",
				30.73
			],
			[
				"2003-08-05",
				24.18
			],
			[
				"2004-04-27",
				25.69
			],
			[
				"2004-08-09",
				25.24
			],
			[
				"2005-04-01",
				25.55
			],
			[
				"2006-03-03",
				26.04
			],
			[
				"2006-12-21",
				24.89
			],
			[
				"2007-08-13",
				25.64
			],
			[
				"2008-08-06",
				22.72
			],
			[
				"2003-02-25",
				27.46
			],
			[
				"2010-01-20",
				28.39
			],
			[
				"2011-02-22",
				26.62
			],
			[
				"2012-11-09",
				29.18
			]
		],
		"80301551": [
			[
				"2014-01-13",
				25.24
			],
			[
				"2015-03-16",
				25.55
			],
			[
				"2016-01-28",
				27.01
			],
			[
				"2000-01-04",
				37.64
			],
			[
				"2000-11-09",
				27.46
			],
			[
				"2001-03-14",
				25.69
			],
			[
				"2001-10-15",
				26.75
			],
			[
				"2002-04-22",
				25.42
			],
			[
				"2003-08-05",
				30.51
			],
			[
				"2004-04-27",
				27.46
			],
			[
				"2004-08-09",
				26.57
			],
			[
				"2005-04-01",
				24.76
			],
			[
				"2006-03-03",
				23.52
			],
			[
				"2006-12-21",
				27.55
			],
			[
				"2007-08-13",
				24.76
			],
			[
				"2008-03-11",
				24.67
			],
			[
				"2003-02-24",
				27.46
			],
			[
				"2010-01-19",
				25.73
			],
			[
				"2011-01-21",
				24.98
			],
			[
				"2012-01-09",
				24.71
			],
			[
				"2013-02-19",
				26.13
			]
		],
		"80301630": [
			[
				"2014-12-01",
				0.13
			],
			[
				"2015-09-30",
				0.13
			],
			[
				"2000-01-07",
				1.33
			],
			[
				"2000-11-17",
				1.33
			],
			[
				"2001-03-26",
				1.33
			],
			[
				"2001-10-17",
				1.33
			],
			[
				"2002-05-13",
				1.33
			],
			[
				"2003-03-05",
				1.33
			],
			[
				"2003-09-10",
				1.33
			],
			[
				"2004-02-16",
				1.33
			],
			[
				"2004-09-21",
				1.33
			],
			[
				"2005-04-05",
				1.33
			],
			[
				"2006-04-20",
				1.33
			],
			[
				"2006-12-15",
				1.33
			],
			[
				"2007-07-02",
				1.33
			],
			[
				"2008-05-20",
				1.33
			],
			[
				"2010-01-25",
				0.13
			],
			[
				"2011-01-11",
				0.13
			],
			[
				"2011-10-12",
				0.13
			],
			[
				"2012-09-04",
				0.13
			],
			[
				"2013-03-18",
				0.13
			]
		],
		"80301654": [
			[
				"2013-06-24",
				1.51
			],
			[
				"2015-01-07",
				23.78
			],
			[
				"2000-01-06",
				7.97
			],
			[
				"2000-11-16",
				9.74
			],
			[
				"2001-03-15",
				15.5
			],
			[
				"2001-10-18",
				7.53
			],
			[
				"2002-05-10",
				8.86
			],
			[
				"2003-03-24",
				6.82
			],
			[
				"2003-09-08",
				1.33
			],
			[
				"2004-02-17",
				36.31
			],
			[
				"2006-03-14",
				21.97
			],
			[
				"2006-12-14",
				5.76
			],
			[
				"2008-04-21",
				22.67
			],
			[
				"2007-07-02",
				4.61
			],
			[
				"2010-01-22",
				4.47
			],
			[
				"2011-01-07",
				3.99
			],
			[
				"2011-10-13",
				0.53
			],
			[
				"2012-09-04",
				1.15
			],
			[
				"2013-02-15",
				28.65
			]
		],
		"80301678": [
			[
				"2015-09-09",
				29.98
			],
			[
				"2000-01-20",
				23.91
			],
			[
				"2000-11-03",
				21.26
			],
			[
				"2001-03-08",
				31.89
			],
			[
				"2001-10-08",
				27.46
			],
			[
				"2002-04-15",
				39.33
			],
			[
				"2003-09-04",
				20.33
			],
			[
				"2004-03-31",
				19.49
			],
			[
				"2004-10-19",
				9.43
			],
			[
				"2005-03-15",
				15.9
			],
			[
				"2006-02-01",
				7.31
			],
			[
				"2006-12-06",
				10.23
			],
			[
				"2007-06-15",
				14.53
			],
			[
				"2008-04-08",
				24.58
			],
			[
				"2003-02-28",
				22.59
			],
			[
				"2010-01-19",
				26.44
			],
			[
				"2011-01-13",
				18.82
			],
			[
				"2012-01-19",
				21.43
			],
			[
				"2013-03-19",
				28.83
			]
		],
		"80301691": [
			[
				"2013-04-24",
				111.16
			],
			[
				"2015-09-09",
				68.64
			],
			[
				"2000-01-20",
				18.6
			],
			[
				"2000-11-02",
				27.9
			],
			[
				"2001-03-07",
				17.27
			],
			[
				"2001-10-09",
				8.41
			],
			[
				"2002-04-16",
				46.06
			],
			[
				"2003-02-28",
				34.99
			],
			[
				"2003-09-02",
				8.41
			],
			[
				"2004-03-22",
				26.57
			],
			[
				"2004-10-19",
				25.02
			],
			[
				"2005-03-15",
				5.85
			],
			[
				"2006-01-25",
				27.41
			],
			[
				"2006-11-10",
				27.55
			],
			[
				"2007-06-15",
				27.19
			],
			[
				"2008-04-07",
				52.7
			],
			[
				"2010-01-18",
				59.34
			],
			[
				"2011-01-13",
				90.79
			],
			[
				"2012-11-08",
				31.09
			]
		],
		"80301710": [
			[
				"2013-04-24",
				61.11
			],
			[
				"2015-09-11",
				63.33
			],
			[
				"2000-01-26",
				75.29
			],
			[
				"2000-11-06",
				59.79
			],
			[
				"2001-03-07",
				54.47
			],
			[
				"2001-10-09",
				57.13
			],
			[
				"2002-04-17",
				51.81
			],
			[
				"2003-03-24",
				45.61
			],
			[
				"2003-09-04",
				62.89
			],
			[
				"2004-02-12",
				60.67
			],
			[
				"2004-10-28",
				58.01
			],
			[
				"2005-03-30",
				62.89
			],
			[
				"2006-02-01",
				58.9
			],
			[
				"2006-12-06",
				58.9
			],
			[
				"2007-07-10",
				66.87
			],
			[
				"2008-03-18",
				69.53
			],
			[
				"2010-11-09",
				52.26
			],
			[
				"2011-06-06",
				62
			]
		],
		"80301721": [
			[
				"2014-06-06",
				108.94
			],
			[
				"2015-09-03",
				103.63
			],
			[
				"2016-03-08",
				75.29
			],
			[
				"2000-01-21",
				93
			],
			[
				"2000-11-08",
				96.54
			],
			[
				"2001-03-15",
				79.27
			],
			[
				"2001-10-05",
				102.74
			],
			[
				"2002-04-02",
				82.81
			],
			[
				"2003-02-20",
				90.79
			],
			[
				"2003-08-06",
				87.69
			],
			[
				"2004-01-30",
				100.09
			],
			[
				"2004-08-05",
				100.09
			],
			[
				"2005-01-25",
				81.49
			],
			[
				"2006-03-07",
				105.84
			],
			[
				"2007-08-16",
				92.56
			],
			[
				"2008-03-10",
				74.4
			],
			[
				"2006-10-13",
				108.06
			],
			[
				"2010-01-15",
				109.39
			],
			[
				"2011-01-05",
				94.33
			],
			[
				"2012-02-23",
				102.74
			],
			[
				"2013-02-19",
				94.33
			]
		],
		"80301794": [
			[
				"2015-10-02",
				111.16
			],
			[
				"2000-01-28",
				94.77
			],
			[
				"2000-10-09",
				93.89
			],
			[
				"2001-02-12",
				110.27
			],
			[
				"2001-09-17",
				55.8
			],
			[
				"2002-03-15",
				18.6
			],
			[
				"2003-02-03",
				21.7
			],
			[
				"2003-07-21",
				89.01
			],
			[
				"2004-01-09",
				114.26
			],
			[
				"2004-09-20",
				136.84
			],
			[
				"2005-01-05",
				128.87
			],
			[
				"2006-10-10",
				96.1
			],
			[
				"2007-05-21",
				98.76
			],
			[
				"2007-09-18",
				83.26
			],
			[
				"2005-12-22",
				95.21
			],
			[
				"2008-01-15",
				108.5
			],
			[
				"2009-11-05",
				101.86
			],
			[
				"2010-11-11",
				98.31
			],
			[
				"2011-05-27",
				100.97
			],
			[
				"2012-07-04",
				118.24
			],
			[
				"2013-03-20",
				131.53
			]
		],
		"80301800": [
			[
				"2013-05-24",
				51.37
			],
			[
				"2015-07-01",
				49.6
			],
			[
				"2000-01-31",
				86.8
			],
			[
				"2000-10-06",
				82.81
			],
			[
				"2001-02-13",
				84.59
			],
			[
				"2001-09-14",
				68.2
			],
			[
				"2002-03-13",
				62
			],
			[
				"2003-07-18",
				42.96
			],
			[
				"2004-01-08",
				48.71
			],
			[
				"2004-09-16",
				45.17
			],
			[
				"2005-01-04",
				46.06
			],
			[
				"2006-01-06",
				48.71
			],
			[
				"2006-10-17",
				46.06
			],
			[
				"2007-05-21",
				46.5
			],
			[
				"2008-01-17",
				39.19
			],
			[
				"2003-01-30",
				67.76
			],
			[
				"2009-11-11",
				52.7
			],
			[
				"2010-11-18",
				53.14
			],
			[
				"2011-07-01",
				36.58
			]
		],
		"80301848": [
			[
				"2015-10-02",
				39.99
			],
			[
				"2000-03-08",
				67.76
			],
			[
				"2000-09-19",
				108.5
			],
			[
				"2001-01-31",
				80.16
			],
			[
				"2001-09-04",
				71.3
			],
			[
				"2002-02-07",
				53.59
			],
			[
				"2003-01-08",
				47.39
			],
			[
				"2003-06-17",
				54.47
			],
			[
				"2004-02-02",
				68.2
			],
			[
				"2004-09-10",
				86.36
			],
			[
				"2005-02-04",
				135.96
			],
			[
				"2005-12-12",
				150.13
			],
			[
				"2006-09-25",
				136.84
			],
			[
				"2007-01-30",
				135.51
			],
			[
				"2008-01-11",
				106.73
			],
			[
				"2009-10-26",
				56.69
			],
			[
				"2010-11-03",
				29.01
			],
			[
				"2011-03-21",
				10.41
			],
			[
				"2012-01-25",
				20.02
			],
			[
				"2013-03-04",
				30.2
			]
		],
		"80301850": [
			[
				"2014-06-05",
				177.14
			],
			[
				"2015-07-07",
				156.33
			],
			[
				"2000-03-09",
				146.59
			],
			[
				"2000-09-25",
				99.64
			],
			[
				"2001-02-01",
				145.26
			],
			[
				"2001-09-03",
				72.63
			],
			[
				"2002-02-08",
				132.41
			],
			[
				"2002-10-28",
				96.99
			],
			[
				"2003-01-07",
				180.24
			],
			[
				"2003-08-01",
				11.96
			],
			[
				"2004-04-15",
				126.66
			],
			[
				"2004-09-09",
				143.04
			],
			[
				"2005-02-08",
				194.86
			],
			[
				"2006-09-22",
				141.71
			],
			[
				"2007-06-04",
				171.83
			],
			[
				"2007-11-29",
				178.91
			],
			[
				"2008-07-23",
				153.67
			],
			[
				"2005-12-15",
				169.17
			],
			[
				"2009-10-06",
				187.77
			],
			[
				"2010-09-30",
				146.59
			],
			[
				"2011-03-25",
				150.57
			],
			[
				"2012-01-24",
				179.36
			],
			[
				"2013-01-10",
				188.21
			]
		],
		"80301861": [
			[
				"2015-10-13",
				0.53
			],
			[
				"2000-03-30",
				11.96
			],
			[
				"2000-09-26",
				7.26
			],
			[
				"2001-02-02",
				14.17
			],
			[
				"2001-09-11",
				3.19
			],
			[
				"2002-01-29",
				25.24
			],
			[
				"2003-06-23",
				2.35
			],
			[
				"2004-04-15",
				3.76
			],
			[
				"2004-09-13",
				1.33
			],
			[
				"2004-12-27",
				10.76
			],
			[
				"2006-09-28",
				1.33
			],
			[
				"2007-07-31",
				1.33
			],
			[
				"2008-04-11",
				1.33
			],
			[
				"2003-01-22",
				7.09
			],
			[
				"2005-12-08",
				2.79
			],
			[
				"2009-10-09",
				1.33
			],
			[
				"2010-09-16",
				0.13
			],
			[
				"2011-06-10",
				1.33
			],
			[
				"2012-09-14",
				0.13
			],
			[
				"2013-01-29",
				0.49
			]
		],
		"80301873": [
			[
				"2013-05-07",
				34.9
			],
			[
				"2014-05-23",
				20.64
			],
			[
				"2015-10-13",
				23.03
			],
			[
				"2000-03-27",
				29.67
			],
			[
				"2000-10-04",
				27.01
			],
			[
				"2001-02-07",
				28.79
			],
			[
				"2001-09-11",
				24.36
			],
			[
				"2002-02-01",
				27.01
			],
			[
				"2002-07-03",
				29.67
			],
			[
				"2003-07-09",
				27.32
			],
			[
				"2004-04-19",
				21.26
			],
			[
				"2004-10-05",
				22.45
			],
			[
				"2004-12-29",
				20.46
			],
			[
				"2006-09-27",
				13.68
			],
			[
				"2007-05-23",
				14.22
			],
			[
				"2008-04-14",
				19.4
			],
			[
				"2008-11-03",
				12.93
			],
			[
				"2003-01-21",
				15.94
			],
			[
				"2005-09-20",
				14.53
			],
			[
				"2009-10-28",
				20.55
			],
			[
				"2010-06-01",
				13.73
			],
			[
				"2011-05-04",
				10.32
			],
			[
				"2012-08-31",
				36.49
			]
		],
		"80301885": [
			[
				"2013-05-07",
				2.44
			],
			[
				"2014-05-26",
				1.33
			],
			[
				"2015-04-17",
				77.94
			],
			[
				"2016-01-21",
				5.31
			],
			[
				"2000-04-05",
				6.2
			],
			[
				"2000-10-04",
				1.33
			],
			[
				"2001-02-08",
				7.53
			],
			[
				"2001-09-12",
				7.97
			],
			[
				"2002-03-25",
				9.74
			],
			[
				"2003-01-24",
				2.66
			],
			[
				"2003-06-26",
				4.3
			],
			[
				"2004-04-26",
				16.39
			],
			[
				"2004-11-04",
				3.5
			],
			[
				"2005-01-24",
				15.99
			],
			[
				"2006-09-29",
				2.88
			],
			[
				"2007-07-12",
				21.88
			],
			[
				"2008-04-17",
				13.42
			],
			[
				"2005-11-29",
				1.33
			],
			[
				"2009-10-30",
				1.33
			],
			[
				"2010-11-23",
				9.83
			],
			[
				"2011-06-28",
				5.23
			],
			[
				"2012-12-07",
				0.13
			]
		],
		"80301903": [
			[
				"2013-07-09",
				5
			],
			[
				"2014-06-12",
				8.55
			],
			[
				"2015-09-24",
				8.95
			],
			[
				"2000-02-24",
				7.53
			],
			[
				"2000-09-01",
				11.51
			],
			[
				"2001-01-17",
				5.76
			],
			[
				"2001-08-20",
				3.32
			],
			[
				"2002-02-28",
				4.43
			],
			[
				"2002-09-18",
				2.04
			],
			[
				"2003-05-23",
				2.57
			],
			[
				"2003-12-15",
				2.88
			],
			[
				"2004-04-14",
				2.61
			],
			[
				"2004-08-17",
				2.57
			],
			[
				"2004-12-20",
				1.33
			],
			[
				"2006-09-18",
				5.89
			],
			[
				"2007-06-11",
				8.37
			],
			[
				"2007-11-19",
				10.1
			],
			[
				"2008-08-07",
				15.28
			],
			[
				"2005-11-16",
				2.04
			],
			[
				"2009-08-20",
				17.23
			],
			[
				"2010-09-06",
				18.78
			],
			[
				"2011-06-22",
				8.41
			],
			[
				"2012-10-29",
				2.08
			]
		],
		"80302040": [
			[
				"2013-07-29",
				66.43
			],
			[
				"2015-11-27",
				66.87
			],
			[
				"2016-01-26",
				62
			],
			[
				"2000-02-18",
				56.69
			],
			[
				"2000-09-01",
				52.26
			],
			[
				"2001-01-16",
				52.7
			],
			[
				"2001-08-24",
				49.16
			],
			[
				"2002-03-11",
				39.41
			],
			[
				"2002-09-18",
				55.36
			],
			[
				"2003-05-22",
				42.96
			],
			[
				"2003-12-15",
				66.87
			],
			[
				"2004-03-08",
				58.46
			],
			[
				"2004-07-27",
				54.91
			],
			[
				"2004-12-08",
				54.03
			],
			[
				"2006-09-15",
				75.73
			],
			[
				"2007-01-25",
				67.31
			],
			[
				"2007-11-12",
				61.11
			],
			[
				"2008-07-16",
				58.01
			],
			[
				"2005-11-15",
				58.9
			],
			[
				"2010-06-01",
				76.61
			]
		],
		"80302063": [
			[
				"2013-04-15",
				29.67
			],
			[
				"2014-06-24",
				54.91
			],
			[
				"2015-11-19",
				48.27
			],
			[
				"2000-03-30",
				49.6
			],
			[
				"2000-09-28",
				44.29
			],
			[
				"2001-02-05",
				47.39
			],
			[
				"2001-09-10",
				43.84
			],
			[
				"2002-01-31",
				53.59
			],
			[
				"2003-06-24",
				54.47
			],
			[
				"2004-04-20",
				56.69
			],
			[
				"2004-09-14",
				56.69
			],
			[
				"2004-12-28",
				60.67
			],
			[
				"2006-09-28",
				56.24
			],
			[
				"2007-08-01",
				51.37
			],
			[
				"2008-04-15",
				46.94
			],
			[
				"2003-01-23",
				56.69
			],
			[
				"2005-12-05",
				58.9
			],
			[
				"2009-11-09",
				47.39
			],
			[
				"2010-11-24",
				51.37
			],
			[
				"2011-05-04",
				27.24
			],
			[
				"2012-08-31",
				39.55
			]
		],
		"80302154": [
			[
				"2013-04-19",
				159.43
			],
			[
				"2014-12-10",
				163.41
			],
			[
				"2015-06-23",
				154.11
			],
			[
				"2000-02-01",
				197.96
			],
			[
				"2000-10-05",
				198.4
			],
			[
				"2001-02-09",
				190.43
			],
			[
				"2001-09-18",
				180.24
			],
			[
				"2002-03-14",
				142.6
			],
			[
				"2003-07-17",
				162.09
			],
			[
				"2004-01-08",
				173.6
			],
			[
				"2004-09-16",
				144.81
			],
			[
				"2005-01-04",
				168.73
			],
			[
				"2005-12-22",
				185.56
			],
			[
				"2006-10-04",
				184.67
			],
			[
				"2007-08-02",
				172.71
			],
			[
				"2008-01-18",
				176.26
			],
			[
				"2003-01-29",
				158.1
			],
			[
				"2009-11-13",
				168.29
			],
			[
				"2010-11-24",
				176.26
			],
			[
				"2011-07-01",
				180.69
			],
			[
				"2012-11-08",
				175.37
			]
		],
		"80302166": [
			[
				"2014-12-10",
				11.16
			],
			[
				"2015-03-20",
				8.55
			],
			[
				"2000-01-31",
				36.76
			],
			[
				"2000-10-09",
				70.41
			],
			[
				"2001-02-12",
				44.29
			],
			[
				"2001-09-14",
				68.64
			],
			[
				"2002-03-13",
				59.34
			],
			[
				"2003-07-18",
				23.03
			],
			[
				"2006-10-10",
				3.9
			],
			[
				"2007-05-21",
				16.16
			],
			[
				"2007-09-18",
				9.21
			],
			[
				"2008-01-15",
				8.06
			],
			[
				"2003-02-03",
				20.81
			],
			[
				"2009-11-12",
				11.38
			],
			[
				"2010-11-11",
				12.58
			],
			[
				"2011-05-27",
				13.37
			],
			[
				"2012-07-04",
				15.01
			],
			[
				"2013-02-06",
				4.87
			]
		],
		"80302180": [
			[
				"2014-05-19",
				70.86
			],
			[
				"2015-03-20",
				62.89
			],
			[
				"2000-04-07",
				97.87
			],
			[
				"2000-10-17",
				81.04
			],
			[
				"2001-02-16",
				73.07
			],
			[
				"2001-09-19",
				93.44
			],
			[
				"2002-02-20",
				124.44
			],
			[
				"2003-02-10",
				96.99
			],
			[
				"2003-07-15",
				106.29
			],
			[
				"2004-01-15",
				124.44
			],
			[
				"2004-09-23",
				101.86
			],
			[
				"2005-01-11",
				95.21
			],
			[
				"2006-01-04",
				115.14
			],
			[
				"2007-07-18",
				87.69
			],
			[
				"2008-01-28",
				75.29
			],
			[
				"2006-10-18",
				120.01
			],
			[
				"2009-11-18",
				75.29
			],
			[
				"2010-09-15",
				77.94
			],
			[
				"2011-03-11",
				74.84
			],
			[
				"2012-06-01",
				82.37
			],
			[
				"2013-01-25",
				89.46
			]
		],
		"80302208": [
			[
				"2014-09-15",
				1.33
			],
			[
				"2015-08-26",
				0.4
			],
			[
				"2000-10-26",
				1.33
			],
			[
				"2001-02-22",
				1.33
			],
			[
				"2001-09-25",
				1.33
			],
			[
				"2002-03-27",
				1.33
			],
			[
				"2003-07-22",
				3.41
			],
			[
				"2004-01-28",
				1.33
			],
			[
				"2004-09-30",
				1.33
			],
			[
				"2005-02-09",
				1.33
			],
			[
				"2006-01-12",
				1.33
			],
			[
				"2006-11-07",
				1.33
			],
			[
				"2007-08-22",
				1.33
			],
			[
				"2008-01-23",
				1.33
			],
			[
				"2003-02-12",
				4.03
			],
			[
				"2009-11-30",
				1.33
			],
			[
				"2010-09-14",
				0.13
			],
			[
				"2011-03-09",
				0.13
			],
			[
				"2012-01-04",
				0.13
			],
			[
				"2013-01-09",
				0.13
			]
		],
		"80302518": [
			[
				"2014-08-28",
				36.31
			],
			[
				"2015-01-12",
				31.58
			],
			[
				"2016-03-07",
				35.43
			],
			[
				"2000-02-11",
				47.83
			],
			[
				"2000-09-13",
				46.94
			],
			[
				"2001-01-22",
				50.49
			],
			[
				"2001-08-29",
				50.93
			],
			[
				"2002-01-16",
				51.37
			],
			[
				"2002-09-12",
				52.7
			],
			[
				"2003-06-10",
				56.24
			],
			[
				"2004-01-19",
				52.7
			],
			[
				"2004-08-18",
				52.7
			],
			[
				"2004-12-14",
				54.47
			],
			[
				"2006-09-12",
				50.04
			],
			[
				"2007-06-18",
				49.6
			],
			[
				"2007-11-22",
				46.94
			],
			[
				"2008-07-28",
				46.06
			],
			[
				"2005-11-08",
				53.59
			],
			[
				"2009-08-21",
				42.6
			],
			[
				"2010-07-29",
				39.37
			],
			[
				"2011-01-04",
				40.52
			],
			[
				"2012-02-13",
				36.89
			],
			[
				"2013-01-28",
				33.92
			]
		],
		"80302520": [
			[
				"2013-05-07",
				74.4
			],
			[
				"2014-06-24",
				59.34
			],
			[
				"2015-12-03",
				50.04
			],
			[
				"2000-03-30",
				113.81
			],
			[
				"2000-10-04",
				101.86
			],
			[
				"2001-02-05",
				113.81
			],
			[
				"2001-09-11",
				99.64
			],
			[
				"2002-02-01",
				111.16
			],
			[
				"2003-06-26",
				95.21
			],
			[
				"2004-04-20",
				73.96
			],
			[
				"2004-09-14",
				69.97
			],
			[
				"2004-12-29",
				64.66
			],
			[
				"2006-09-29",
				82.37
			],
			[
				"2007-07-31",
				84.59
			],
			[
				"2008-04-15",
				81.49
			],
			[
				"2003-01-23",
				100.09
			],
			[
				"2005-12-05",
				70.86
			],
			[
				"2009-10-09",
				75.29
			],
			[
				"2010-11-25",
				75.73
			],
			[
				"2011-08-19",
				85.47
			],
			[
				"2012-09-20",
				75.73
			]
		],
		"80302543": [
			[
				"2015-08-24",
				93.44
			],
			[
				"2000-10-31",
				106.29
			],
			[
				"2001-03-01",
				104.96
			],
			[
				"2001-10-01",
				110.27
			],
			[
				"2002-04-10",
				112.93
			],
			[
				"2003-07-31",
				101.86
			],
			[
				"2004-03-10",
				112.04
			],
			[
				"2004-10-12",
				106.73
			],
			[
				"2005-03-09",
				107.17
			],
			[
				"2006-01-18",
				114.7
			],
			[
				"2006-11-09",
				120.46
			],
			[
				"2007-07-25",
				108.06
			],
			[
				"2008-03-04",
				104.51
			],
			[
				"2003-02-14",
				114.26
			],
			[
				"2010-01-12",
				93.89
			],
			[
				"2011-01-12",
				88.57
			],
			[
				"2012-03-01",
				106.29
			],
			[
				"2013-02-05",
				95.66
			]
		],
		"80302555": [
			[
				"2015-08-24",
				158.99
			],
			[
				"2000-11-02",
				152.79
			],
			[
				"2001-03-01",
				152.79
			],
			[
				"2001-10-01",
				161.2
			],
			[
				"2002-04-10",
				180.24
			],
			[
				"2003-02-18",
				162.97
			],
			[
				"2003-07-28",
				160.76
			],
			[
				"2004-03-10",
				166.96
			],
			[
				"2004-10-11",
				176.7
			],
			[
				"2005-03-09",
				183.79
			],
			[
				"2006-01-18",
				178.47
			],
			[
				"2006-11-08",
				201.5
			],
			[
				"2007-07-25",
				180.24
			],
			[
				"2008-03-04",
				183.34
			],
			[
				"2000-05-02",
				162.09
			],
			[
				"2010-01-13",
				155
			],
			[
				"2011-01-14",
				135.51
			],
			[
				"2012-01-02",
				137.29
			],
			[
				"2013-01-11",
				169.17
			]
		],
		"80302646": [
			[
				"2014-01-17",
				55.8
			],
			[
				"2015-06-15",
				46.06
			],
			[
				"2016-01-22",
				53.14
			],
			[
				"2000-10-16",
				51.81
			],
			[
				"2001-02-21",
				58.46
			],
			[
				"2001-09-24",
				51.37
			],
			[
				"2002-02-25",
				48.27
			],
			[
				"2003-07-14",
				44.73
			],
			[
				"2004-01-15",
				31.44
			],
			[
				"2003-02-11",
				43.4
			],
			[
				"2004-09-29",
				44.73
			],
			[
				"2005-01-19",
				34.9
			],
			[
				"2006-01-03",
				51.81
			],
			[
				"2006-10-23",
				40.03
			],
			[
				"2007-07-17",
				43.27
			],
			[
				"2008-01-29",
				49.6
			],
			[
				"2009-12-01",
				45.17
			],
			[
				"2010-11-08",
				57.13
			],
			[
				"2011-05-16",
				57.13
			],
			[
				"2012-03-02",
				51.37
			],
			[
				"2013-01-08",
				49.6
			]
		],
		"80302660": [
			[
				"2013-04-08",
				52.7
			],
			[
				"2014-09-16",
				23.12
			],
			[
				"2015-09-02",
				26.22
			],
			[
				"2000-11-15",
				103.63
			],
			[
				"2001-03-22",
				51.37
			],
			[
				"2001-10-25",
				77.5
			],
			[
				"2002-05-07",
				92.11
			],
			[
				"2003-03-27",
				81.04
			],
			[
				"2003-09-12",
				62.89
			],
			[
				"2004-02-24",
				49.16
			],
			[
				"2004-11-03",
				40.17
			],
			[
				"2005-04-11",
				36.23
			],
			[
				"2006-03-01",
				31.44
			],
			[
				"2006-12-20",
				33.21
			],
			[
				"2007-09-03",
				38.35
			],
			[
				"2008-05-26",
				36.62
			],
			[
				"2000-05-04",
				91.23
			],
			[
				"2010-01-29",
				28.48
			],
			[
				"2011-01-06",
				45.61
			],
			[
				"2012-06-28",
				55.8
			]
		],
		"80302762": [
			[
				"2013-04-19",
				59.34
			],
			[
				"2014-11-25",
				51.37
			],
			[
				"2015-08-26",
				52.26
			],
			[
				"2000-05-22",
				151.9
			],
			[
				"2000-10-06",
				143.93
			],
			[
				"2001-02-13",
				144.37
			],
			[
				"2001-09-18",
				144.37
			],
			[
				"2002-03-15",
				136.4
			],
			[
				"2003-07-17",
				100.97
			],
			[
				"2004-01-09",
				84.59
			],
			[
				"2004-09-16",
				78.39
			],
			[
				"2005-01-06",
				72.63
			],
			[
				"2006-03-02",
				67.76
			],
			[
				"2006-10-04",
				72.19
			],
			[
				"2007-05-21",
				75.29
			],
			[
				"2008-01-17",
				68.64
			],
			[
				"2008-11-10",
				79.71
			],
			[
				"2003-02-05",
				109.83
			],
			[
				"2009-11-12",
				80.16
			],
			[
				"2010-11-18",
				79.27
			],
			[
				"2011-06-30",
				82.81
			],
			[
				"2012-11-08",
				64.21
			]
		],
		"80302798": [
			[
				"2014-12-08",
				39.81
			],
			[
				"2015-09-04",
				40.7
			],
			[
				"2000-02-21",
				75.29
			],
			[
				"2001-01-15",
				68.2
			],
			[
				"2001-08-23",
				64.66
			],
			[
				"2002-02-28",
				66.43
			],
			[
				"2002-09-24",
				58.9
			],
			[
				"2003-05-26",
				58.46
			],
			[
				"2003-12-12",
				60.67
			],
			[
				"2004-04-13",
				53.14
			],
			[
				"2004-08-11",
				54.47
			],
			[
				"2004-12-10",
				53.59
			],
			[
				"2006-08-30",
				48.71
			],
			[
				"2007-06-11",
				45.61
			],
			[
				"2007-11-15",
				39.15
			],
			[
				"2008-07-15",
				42.2
			],
			[
				"2005-11-17",
				50.04
			],
			[
				"2009-08-18",
				44.15
			],
			[
				"2010-09-08",
				44.73
			],
			[
				"2011-05-25",
				45.61
			],
			[
				"2012-06-18",
				46.5
			],
			[
				"2013-03-07",
				51.81
			]
		],
		"80302944": [
			[
				"2013-04-17",
				46.94
			],
			[
				"2014-05-28",
				50.49
			],
			[
				"2015-08-19",
				40.03
			],
			[
				"2000-04-06",
				68.2
			],
			[
				"2000-10-10",
				72.63
			],
			[
				"2001-02-14",
				79.27
			],
			[
				"2001-09-13",
				69.53
			],
			[
				"2002-03-18",
				71.74
			],
			[
				"2003-06-13",
				68.64
			],
			[
				"2004-02-04",
				27.77
			],
			[
				"2004-10-14",
				66.43
			],
			[
				"2005-01-07",
				64.21
			],
			[
				"2006-01-10",
				62
			],
			[
				"2006-10-16",
				54.91
			],
			[
				"2007-08-20",
				59.34
			],
			[
				"2008-01-23",
				50.93
			],
			[
				"2003-01-28",
				72.19
			],
			[
				"2009-11-13",
				43.98
			],
			[
				"2010-11-22",
				28.96
			],
			[
				"2011-05-20",
				31
			],
			[
				"2012-12-03",
				50.04
			]
		],
		"80302981": [
			[
				"2014-07-16",
				1.33
			],
			[
				"2015-02-27",
				1.42
			],
			[
				"2000-02-18",
				1.33
			],
			[
				"2000-09-11",
				1.46
			],
			[
				"2001-01-16",
				1.33
			],
			[
				"2001-08-20",
				1.33
			],
			[
				"2002-03-11",
				1.9
			],
			[
				"2002-09-18",
				1.42
			],
			[
				"2003-05-22",
				2.08
			],
			[
				"2003-12-15",
				1.95
			],
			[
				"2004-04-01",
				1.86
			],
			[
				"2004-07-27",
				1.33
			],
			[
				"2004-12-13",
				1.33
			],
			[
				"2006-09-18",
				1.33
			],
			[
				"2007-01-25",
				1.33
			],
			[
				"2007-11-19",
				1.33
			],
			[
				"2008-07-16",
				1.33
			],
			[
				"2005-11-16",
				1.33
			],
			[
				"2009-08-20",
				0.4
			],
			[
				"2010-09-08",
				0.13
			],
			[
				"2011-05-25",
				1.9
			],
			[
				"2012-06-21",
				2.75
			],
			[
				"2013-03-07",
				3.45
			]
		],
		"80303080": [
			[
				"2013-06-28",
				1.33
			],
			[
				"2014-09-19",
				1.33
			],
			[
				"2015-09-23",
				0.13
			],
			[
				"2007-10-12",
				1.33
			],
			[
				"2008-06-11",
				1.33
			],
			[
				"2000-03-01",
				1.33
			],
			[
				"2000-09-15",
				1.33
			],
			[
				"2001-01-31",
				1.33
			],
			[
				"2001-11-13",
				1.33
			],
			[
				"2002-01-23",
				1.33
			],
			[
				"2002-09-10",
				1.33
			],
			[
				"2003-06-12",
				1.82
			],
			[
				"2004-02-10",
				1.33
			],
			[
				"2004-10-08",
				1.33
			],
			[
				"2005-04-21",
				1.33
			],
			[
				"2005-11-03",
				1.33
			],
			[
				"2006-08-25",
				1.33
			],
			[
				"2007-05-14",
				1.33
			],
			[
				"2009-07-16",
				1.33
			],
			[
				"2010-11-22",
				0.13
			],
			[
				"2011-05-18",
				0.13
			],
			[
				"2012-12-18",
				1.33
			]
		],
		"80303183": [
			[
				"2013-06-27",
				103.19
			],
			[
				"2015-09-08",
				107.61
			],
			[
				"2016-03-08",
				106.29
			],
			[
				"2007-09-07",
				92.56
			],
			[
				"2008-11-11",
				83.26
			],
			[
				"2006-10-13",
				100.97
			],
			[
				"2010-01-22",
				98.76
			],
			[
				"2011-02-18",
				94.77
			],
			[
				"2012-09-26",
				105.84
			]
		],
		"80303201": [
			[
				"2015-08-26",
				77.06
			],
			[
				"2001-12-06",
				56.24
			],
			[
				"2002-04-11",
				58.9
			],
			[
				"2003-02-17",
				48.71
			],
			[
				"2003-07-24",
				65.1
			],
			[
				"2005-03-08",
				21.74
			],
			[
				"2006-01-20",
				24.8
			],
			[
				"2006-11-09",
				25.6
			],
			[
				"2007-07-20",
				17.4
			],
			[
				"2008-03-06",
				26.48
			],
			[
				"2010-01-14",
				73.51
			],
			[
				"2010-12-21",
				74.4
			],
			[
				"2012-01-02",
				73.07
			],
			[
				"2013-02-20",
				71.3
			]
		],
		"80303237": [
			[
				"2014-01-17",
				36.98
			],
			[
				"2015-08-25",
				36.4
			],
			[
				"2016-01-07",
				36.76
			],
			[
				"2001-12-06",
				47.39
			],
			[
				"2002-02-25",
				46.5
			],
			[
				"2003-07-15",
				53.59
			],
			[
				"2004-01-15",
				50.04
			],
			[
				"2003-02-11",
				52.7
			],
			[
				"2004-09-29",
				49.6
			],
			[
				"2005-01-19",
				44.11
			],
			[
				"2006-01-04",
				44.06
			],
			[
				"2007-07-27",
				52.7
			],
			[
				"2008-01-29",
				50.04
			],
			[
				"2006-10-27",
				38.88
			],
			[
				"2009-11-17",
				47.83
			],
			[
				"2010-11-08",
				45.61
			],
			[
				"2011-05-16",
				42.47
			],
			[
				"2012-03-02",
				41.54
			],
			[
				"2013-01-08",
				37.82
			]
		],
		"80303262": [
			[
				"2013-05-08",
				24.49
			],
			[
				"2013-09-24",
				22.59
			],
			[
				"2014-09-29",
				32.9
			],
			[
				"2015-11-27",
				26.84
			],
			[
				"2016-03-07",
				33.66
			],
			[
				"2001-12-12",
				35.87
			],
			[
				"2002-01-21",
				35.87
			],
			[
				"2002-09-16",
				33.21
			],
			[
				"2003-06-11",
				39.5
			],
			[
				"2004-02-10",
				34.1
			],
			[
				"2004-08-19",
				38.53
			],
			[
				"2004-12-15",
				37.91
			],
			[
				"2006-09-08",
				37.55
			],
			[
				"2007-05-14",
				35.3
			],
			[
				"2007-11-26",
				33.7
			],
			[
				"2008-07-09",
				29.41
			],
			[
				"2005-11-14",
				36.49
			],
			[
				"2010-06-09",
				30.69
			],
			[
				"2011-05-18",
				32.46
			],
			[
				"2012-12-18",
				27.55
			]
		],
		"80303316": [
			[
				"2015-09-11",
				117.8
			],
			[
				"2000-01-21",
				121.34
			],
			[
				"2000-11-06",
				142.6
			],
			[
				"2001-03-09",
				65.1
			],
			[
				"2001-04-23",
				157.21
			],
			[
				"2001-10-09",
				174.04
			],
			[
				"2002-04-12",
				199.29
			],
			[
				"2003-07-31",
				154.11
			],
			[
				"2004-03-31",
				119.57
			],
			[
				"2004-10-19",
				122.67
			],
			[
				"2005-03-14",
				124.89
			],
			[
				"2006-01-25",
				171.39
			],
			[
				"2006-11-10",
				174.04
			],
			[
				"2008-04-07",
				151.46
			],
			[
				"2007-06-15",
				176.26
			],
			[
				"2008-08-05",
				138.61
			],
			[
				"2003-02-28",
				152.79
			],
			[
				"2009-12-16",
				144.37
			],
			[
				"2010-11-02",
				131.53
			],
			[
				"2011-08-18",
				118.24
			],
			[
				"2012-09-07",
				127.1
			],
			[
				"2013-02-25",
				129.76
			]
		],
		"80303328": [
			[
				"2015-03-27",
				15.85
			],
			[
				"2000-01-26",
				204.16
			],
			[
				"2000-05-23",
				12.84
			],
			[
				"2000-10-26",
				1.33
			],
			[
				"2001-02-22",
				45.61
			],
			[
				"2001-09-25",
				3.01
			],
			[
				"2002-03-27",
				81.93
			],
			[
				"2003-07-22",
				2.35
			],
			[
				"2004-01-28",
				174.04
			],
			[
				"2004-09-30",
				1.42
			],
			[
				"2005-03-11",
				46.5
			],
			[
				"2006-01-12",
				6.69
			],
			[
				"2006-11-07",
				2.7
			],
			[
				"2007-08-22",
				2.92
			],
			[
				"2008-01-28",
				98.76
			],
			[
				"2003-02-12",
				143.49
			],
			[
				"2009-11-30",
				21.7
			],
			[
				"2010-09-14",
				3.85
			],
			[
				"2011-03-09",
				77.5
			],
			[
				"2012-01-04",
				25.51
			],
			[
				"2013-01-09",
				16.87
			]
		],
		"80303330": [
			[
				"2013-04-17",
				37.2
			],
			[
				"2014-05-15",
				32.73
			],
			[
				"2015-10-12",
				32.02
			],
			[
				"2000-01-27",
				40.3
			],
			[
				"2000-10-26",
				35.87
			],
			[
				"2001-02-14",
				30.56
			],
			[
				"2001-09-13",
				25.69
			],
			[
				"2002-03-18",
				28.79
			],
			[
				"2003-07-22",
				29.67
			],
			[
				"2004-02-04",
				69.97
			],
			[
				"2004-10-14",
				25.38
			],
			[
				"2005-01-07",
				27.86
			],
			[
				"2006-01-10",
				26.88
			],
			[
				"2007-08-20",
				29.01
			],
			[
				"2008-01-23",
				30.69
			],
			[
				"2003-01-28",
				30.11
			],
			[
				"2006-10-16",
				28.21
			],
			[
				"2009-11-17",
				33.88
			],
			[
				"2010-11-22",
				26.79
			],
			[
				"2011-05-20",
				58.46
			],
			[
				"2012-09-18",
				39.68
			]
		],
		"80303353": [
			[
				"2014-09-18",
				23.69
			],
			[
				"2015-10-14",
				26.93
			],
			[
				"2001-12-11",
				65.1
			],
			[
				"2002-03-12",
				65.1
			],
			[
				"2002-09-19",
				69.09
			],
			[
				"2003-05-21",
				75.29
			],
			[
				"2003-12-17",
				74.4
			],
			[
				"2004-04-13",
				72.19
			],
			[
				"2004-08-13",
				70.86
			],
			[
				"2004-12-09",
				68.64
			],
			[
				"2006-08-29",
				58.46
			],
			[
				"2007-05-08",
				45.17
			],
			[
				"2007-11-16",
				43.22
			],
			[
				"2008-07-17",
				37.07
			],
			[
				"2005-11-17",
				65.1
			],
			[
				"2009-08-18",
				35.83
			],
			[
				"2010-09-07",
				33.79
			],
			[
				"2011-06-08",
				39.15
			],
			[
				"2012-06-21",
				43.8
			],
			[
				"2013-03-07",
				33.88
			]
		],
		"80303377": [
			[
				"2014-09-09",
				39.86
			],
			[
				"2015-11-19",
				2.3
			],
			[
				"2001-12-07",
				4.25
			],
			[
				"2002-02-01",
				1.33
			],
			[
				"2003-01-22",
				1.37
			],
			[
				"2004-04-19",
				8.41
			],
			[
				"2004-09-13",
				3.85
			],
			[
				"2004-12-27",
				2.61
			],
			[
				"2007-07-19",
				3.41
			],
			[
				"2008-08-22",
				3.99
			],
			[
				"2005-12-05",
				3.54
			],
			[
				"2010-08-03",
				5.09
			],
			[
				"2011-12-09",
				4.3
			],
			[
				"2012-09-14",
				5.05
			],
			[
				"2013-01-29",
				3.19
			]
		],
		"80303389": [
			[
				"2013-05-03",
				1.33
			],
			[
				"2015-10-13",
				0.13
			],
			[
				"2006-10-09",
				1.33
			],
			[
				"2007-07-31",
				1.33
			],
			[
				"2008-04-15",
				1.33
			],
			[
				"2009-11-09",
				1.33
			],
			[
				"2010-11-25",
				0.13
			],
			[
				"2011-08-19",
				0.13
			],
			[
				"2012-09-19",
				0.13
			]
		],
		"80303390": [
			[
				"2014-05-19",
				45.17
			],
			[
				"2015-07-01",
				42.07
			],
			[
				"2001-12-06",
				77.5
			],
			[
				"2002-02-20",
				69.97
			],
			[
				"2004-01-16",
				58.01
			],
			[
				"2004-09-23",
				55.36
			],
			[
				"2005-01-11",
				58.46
			],
			[
				"2006-01-04",
				58.46
			],
			[
				"2007-07-27",
				54.47
			],
			[
				"2008-01-28",
				55.8
			],
			[
				"2006-10-18",
				55.36
			],
			[
				"2009-11-19",
				53.14
			],
			[
				"2010-08-06",
				54.91
			],
			[
				"2011-03-10",
				44.73
			],
			[
				"2012-06-01",
				50.04
			],
			[
				"2013-01-25",
				47.83
			]
		],
		"80303407": [
			[
				"2013-04-08",
				38.44
			],
			[
				"2014-06-25",
				54.03
			],
			[
				"2015-01-07",
				59.79
			],
			[
				"2006-12-20",
				77.06
			],
			[
				"2007-07-10",
				157.21
			],
			[
				"2008-04-21",
				74.84
			],
			[
				"2010-01-26",
				48.27
			],
			[
				"2011-01-07",
				25.86
			],
			[
				"2012-06-29",
				96.54
			]
		],
		"80303420": [
			[
				"2015-09-11",
				62
			],
			[
				"2003-09-04",
				44.29
			],
			[
				"2004-02-12",
				74.84
			],
			[
				"2004-10-21",
				78.83
			],
			[
				"2005-04-19",
				79.71
			],
			[
				"2006-01-30",
				77.06
			],
			[
				"2006-11-20",
				74.4
			],
			[
				"2007-07-10",
				69.53
			],
			[
				"2008-03-18",
				56.24
			],
			[
				"2010-11-09",
				65.99
			],
			[
				"2011-06-06",
				65.54
			],
			[
				"2012-08-24",
				65.1
			],
			[
				"2013-03-19",
				70.41
			]
		],
		"80303559": [
			[
				"2013-04-18",
				29.27
			],
			[
				"2015-09-30",
				25.95
			],
			[
				"2007-07-16",
				54.91
			],
			[
				"2008-08-05",
				27.94
			],
			[
				"2010-01-25",
				44.29
			],
			[
				"2011-01-11",
				36.89
			],
			[
				"2011-08-03",
				31
			],
			[
				"2012-11-26",
				39.99
			]
		],
		"80303614": [
			[
				"2014-06-23",
				30.2
			],
			[
				"2015-09-23",
				27.15
			],
			[
				"2005-01-18",
				32.11
			],
			[
				"2007-05-22",
				26.17
			],
			[
				"2008-03-17",
				26.62
			],
			[
				"2008-11-05",
				27.19
			],
			[
				"2009-12-03",
				29.94
			],
			[
				"2010-06-02",
				26.31
			],
			[
				"2011-06-09",
				29.18
			],
			[
				"2012-08-27",
				25.51
			],
			[
				"2013-03-06",
				21.83
			]
		],
		"80303638": [
			[
				"2013-07-10",
				1.33
			],
			[
				"2014-09-19",
				1.33
			],
			[
				"2015-09-10",
				0.13
			],
			[
				"2005-01-24",
				1.33
			],
			[
				"2007-07-12",
				1.33
			],
			[
				"2008-08-21",
				1.33
			],
			[
				"2010-11-04",
				1.33
			],
			[
				"2011-11-30",
				0.13
			],
			[
				"2012-12-11",
				1.33
			]
		],
		"81150040": [
			[
				"2013-07-23",
				16.83
			],
			[
				"2015-09-04",
				14.7
			],
			[
				"2000-02-29",
				2.79
			],
			[
				"2000-08-23",
				3.45
			],
			[
				"2001-01-10",
				4.43
			],
			[
				"2001-07-12",
				4.87
			],
			[
				"2002-02-13",
				4.43
			],
			[
				"2002-10-28",
				4.43
			],
			[
				"2003-05-05",
				4.87
			],
			[
				"2004-01-22",
				3.94
			],
			[
				"2004-07-29",
				3.76
			],
			[
				"2005-03-10",
				1.55
			],
			[
				"2006-09-20",
				2.48
			],
			[
				"2007-05-25",
				6.2
			],
			[
				"2007-11-05",
				8.55
			],
			[
				"2008-08-04",
				7
			],
			[
				"2005-11-25",
				1.33
			],
			[
				"2009-08-10",
				5.4
			],
			[
				"2010-09-03",
				4.12
			],
			[
				"2011-03-17",
				4.56
			],
			[
				"2012-01-17",
				5.54
			]
		],
		"86452010": [
			[
				"2007-10-10",
				14
			],
			[
				"2007-04-18",
				29.21
			],
			[
				"2008-04-09",
				30.31
			],
			[
				"2006-09-27",
				32.31
			],
			[
				"2008-10-15",
				30.71
			],
			[
				"2009-10-07",
				32.01
			],
			[
				"2009-04-22",
				28.11
			],
			[
				"2000-10-25",
				31.01
			],
			[
				"2000-04-26",
				32.01
			],
			[
				"2001-10-02",
				28.01
			],
			[
				"2001-04-24",
				30.01
			],
			[
				"2002-10-15",
				36.41
			],
			[
				"2002-04-09",
				34.01
			],
			[
				"2003-10-01",
				35.01
			],
			[
				"2003-04-01",
				36.41
			],
			[
				"2004-10-20",
				29.91
			],
			[
				"2004-04-14",
				42.92
			],
			[
				"2005-04-20",
				21.21
			],
			[
				"2006-04-19",
				29.51
			],
			[
				"2011-10-12",
				26.81
			],
			[
				"2011-04-06",
				21.01
			],
			[
				"2010-10-20",
				23.31
			],
			[
				"2010-04-14",
				28.11
			],
			[
				"2012-10-24",
				21.81
			],
			[
				"2012-05-09",
				26.91
			],
			[
				"2013-10-16",
				17.41
			],
			[
				"2013-04-10",
				17.61
			],
			[
				"2014-10-09",
				15.31
			],
			[
				"2014-04-08",
				15.91
			],
			[
				"2015-10-07",
				17.81
			],
			[
				"2015-03-31",
				15.21
			]
		],
		"86452216": [
			[
				"2008-03-13",
				12
			],
			[
				"2007-09-18",
				21.01
			],
			[
				"2007-03-13",
				16.01
			],
			[
				"2008-09-09",
				13
			],
			[
				"2009-03-16",
				15.01
			],
			[
				"2009-09-15",
				13
			],
			[
				"2002-11-13",
				14
			],
			[
				"2004-09-30",
				19.01
			],
			[
				"2005-03-17",
				15.01
			],
			[
				"2006-09-13",
				9
			],
			[
				"2006-03-13",
				11
			],
			[
				"2010-09-22",
				13
			],
			[
				"2010-03-23",
				9
			],
			[
				"2011-03-22",
				14
			],
			[
				"2011-09-06",
				21.01
			],
			[
				"2012-03-20",
				17.01
			],
			[
				"2012-09-18",
				22.01
			],
			[
				"2014-03-18",
				15.01
			],
			[
				"2013-09-17",
				16.01
			],
			[
				"2013-03-19",
				18.01
			],
			[
				"2014-09-23",
				14
			],
			[
				"2015-03-17",
				16.01
			],
			[
				"2015-09-22",
				17.01
			]
		],
		"86454328": [
			[
				"2007-11-07",
				2.6
			],
			[
				"2007-08-29",
				3.1
			],
			[
				"2007-07-04",
				2.7
			],
			[
				"2007-05-02",
				2
			],
			[
				"2007-02-28",
				2.6
			],
			[
				"2007-01-03",
				2.6
			],
			[
				"2008-02-27",
				1.9
			],
			[
				"2008-10-29",
				3.1
			],
			[
				"2009-04-29",
				3.6
			],
			[
				"2009-10-28",
				2.9
			],
			[
				"2010-03-03",
				2.6
			],
			[
				"2000-11-21",
				2.6
			],
			[
				"2000-09-27",
				4
			],
			[
				"2000-07-19",
				3.6
			],
			[
				"2000-05-04",
				4.5
			],
			[
				"2001-11-19",
				4.1
			],
			[
				"2001-09-20",
				3.2
			],
			[
				"2001-07-17",
				4.5
			],
			[
				"2001-05-03",
				4.4
			],
			[
				"2002-11-26",
				4.3
			],
			[
				"2002-09-27",
				4.7
			],
			[
				"2002-07-24",
				3.1
			],
			[
				"2002-05-08",
				4.6
			],
			[
				"2002-02-18",
				4.4
			],
			[
				"2003-12-10",
				4.1
			],
			[
				"2003-11-05",
				4
			],
			[
				"2003-10-15",
				3.9
			],
			[
				"2003-08-12",
				5.2
			],
			[
				"2003-06-17",
				4.8
			],
			[
				"2003-04-16",
				6.4
			],
			[
				"2003-03-25",
				4.7
			],
			[
				"2003-01-15",
				4.1
			],
			[
				"2004-11-16",
				1.8
			],
			[
				"2004-09-01",
				3.5
			],
			[
				"2004-07-07",
				3.2
			],
			[
				"2004-05-05",
				3.4
			],
			[
				"2004-03-03",
				4
			],
			[
				"2004-01-07",
				4
			],
			[
				"2005-05-11",
				1.7
			],
			[
				"2005-03-02",
				2.3
			],
			[
				"2005-01-05",
				2.8
			],
			[
				"2006-11-08",
				3
			],
			[
				"2006-05-03",
				3.4
			],
			[
				"2006-03-01",
				3.1
			],
			[
				"2006-01-04",
				2.4
			],
			[
				"2010-10-27",
				2.9
			],
			[
				"2011-03-01",
				5.6
			],
			[
				"2012-02-28",
				5
			],
			[
				"2012-10-30",
				5
			],
			[
				"2014-01-16",
				5
			],
			[
				"2013-02-26",
				5
			],
			[
				"2015-02-24",
				5
			],
			[
				"2014-11-06",
				5
			],
			[
				"2015-10-27",
				5
			],
			[
				"2016-02-23",
				5
			]
		],
		"86530550": [
			[
				"2007-11-21",
				4.5
			],
			[
				"2007-07-16",
				5.8
			],
			[
				"2007-02-06",
				5.9
			],
			[
				"2006-11-14",
				4.2
			],
			[
				"2006-07-18",
				6.6
			],
			[
				"2006-04-03",
				6.9
			],
			[
				"2006-03-07",
				7.3
			],
			[
				"2005-11-16",
				7
			],
			[
				"2005-07-05",
				6.2
			],
			[
				"2005-03-08",
				7.5
			],
			[
				"2004-11-16",
				8.8
			],
			[
				"2004-07-14",
				8.8
			],
			[
				"2004-03-02",
				9
			],
			[
				"2003-11-11",
				8.5
			],
			[
				"2003-07-08",
				8
			],
			[
				"2003-05-08",
				1
			],
			[
				"2003-02-25",
				9
			],
			[
				"2009-11-05",
				8.6
			],
			[
				"2009-07-16",
				6.9
			],
			[
				"2009-03-04",
				4.5
			],
			[
				"2008-11-20",
				5.9
			],
			[
				"2008-07-24",
				5.6
			],
			[
				"2008-03-11",
				2.6
			],
			[
				"2000-09-19",
				9.4
			],
			[
				"2000-06-20",
				8.8
			],
			[
				"2000-02-08",
				7.7
			],
			[
				"2001-09-19",
				11
			],
			[
				"2001-06-19",
				11
			],
			[
				"2001-03-07",
				7.2
			],
			[
				"2002-08-28",
				9.1
			],
			[
				"2002-06-18",
				12
			],
			[
				"2002-02-12",
				8.2
			],
			[
				"2011-03-08",
				7.9
			],
			[
				"2011-07-05",
				8.3
			],
			[
				"2011-11-17",
				8.4
			],
			[
				"2012-03-08",
				8.2
			],
			[
				"2012-07-19",
				7.5
			],
			[
				"2012-11-15",
				8.4
			],
			[
				"2013-07-18",
				5.6
			],
			[
				"2013-03-05",
				8.5
			],
			[
				"2013-11-27",
				5.8
			],
			[
				"2014-07-03",
				8
			],
			[
				"2014-11-05",
				7.56
			],
			[
				"2015-06-18",
				9.18
			],
			[
				"2015-11-18",
				9.94
			]
		],
		"86532649": [
			[
				"2007-11-21",
				4.9
			],
			[
				"2007-07-16",
				6.4
			],
			[
				"2007-03-06",
				4.7
			],
			[
				"2006-11-14",
				5
			],
			[
				"2006-07-20",
				10.9
			],
			[
				"2006-03-07",
				7.3
			],
			[
				"2005-11-16",
				4.9
			],
			[
				"2005-07-07",
				6.6
			],
			[
				"2005-03-10",
				6.7
			],
			[
				"2004-11-16",
				6.9
			],
			[
				"2004-07-14",
				6.6
			],
			[
				"2004-03-02",
				5.1
			],
			[
				"2003-11-11",
				6.7
			],
			[
				"2003-07-08",
				6.7
			],
			[
				"2003-05-15",
				7
			],
			[
				"2003-02-25",
				7.7
			],
			[
				"2009-11-05",
				3.1
			],
			[
				"2009-07-16",
				3
			],
			[
				"2009-03-04",
				3.3
			],
			[
				"2008-11-17",
				4.4
			],
			[
				"2008-07-17",
				4
			],
			[
				"2008-03-11",
				4.9
			],
			[
				"2000-09-19",
				9.3
			],
			[
				"2000-06-20",
				9.2
			],
			[
				"2000-02-08",
				8.8
			],
			[
				"2001-09-19",
				9.2
			],
			[
				"2001-06-19",
				11
			],
			[
				"2001-02-28",
				9.3
			],
			[
				"2002-08-28",
				6.7
			],
			[
				"2002-06-18",
				8.6
			],
			[
				"2002-04-26",
				7.4
			],
			[
				"2002-02-12",
				9.3
			],
			[
				"2011-03-08",
				3.4
			],
			[
				"2011-07-26",
				3
			],
			[
				"2011-11-22",
				2.4
			],
			[
				"2012-03-08",
				2.1
			],
			[
				"2012-07-17",
				2.5
			],
			[
				"2012-11-13",
				2.5
			],
			[
				"2013-07-09",
				2.1
			],
			[
				"2013-03-06",
				2.4
			],
			[
				"2013-11-28",
				1.8
			],
			[
				"2014-07-03",
				3.4
			],
			[
				"2014-11-06",
				3.11
			],
			[
				"2015-06-23",
				2.94
			],
			[
				"2015-11-19",
				2.99
			]
		],
		"86541377": [
			[
				"2006-10-24",
				45.32
			],
			[
				"2006-04-11",
				44.32
			],
			[
				"2007-10-15",
				42.82
			],
			[
				"2007-04-03",
				45.82
			],
			[
				"2008-09-24",
				43.32
			],
			[
				"2008-03-11",
				43.82
			],
			[
				"2009-10-06",
				39.81
			],
			[
				"2009-03-10",
				40.91
			],
			[
				"2000-06-27",
				42.01
			],
			[
				"2000-05-18",
				43.02
			],
			[
				"2000-04-11",
				43.02
			],
			[
				"2000-03-20",
				41.01
			],
			[
				"2000-02-17",
				40.01
			],
			[
				"2000-01-19",
				42.01
			],
			[
				"2001-12-05",
				47.02
			],
			[
				"2001-11-26",
				47.02
			],
			[
				"2001-10-17",
				43.02
			],
			[
				"2001-09-24",
				43.02
			],
			[
				"2001-08-08",
				42.01
			],
			[
				"2001-07-10",
				43.02
			],
			[
				"2001-06-18",
				42.01
			],
			[
				"2001-05-14",
				44.02
			],
			[
				"2001-04-18",
				44.02
			],
			[
				"2001-03-12",
				43.02
			],
			[
				"2001-02-08",
				41.01
			],
			[
				"2001-01-17",
				42.01
			],
			[
				"2002-10-28",
				51.02
			],
			[
				"2002-07-16",
				50.02
			],
			[
				"2002-06-04",
				50.02
			],
			[
				"2002-02-25",
				49.02
			],
			[
				"2002-01-28",
				49.02
			],
			[
				"2003-06-03",
				50.62
			],
			[
				"2003-02-25",
				45.02
			],
			[
				"2004-11-11",
				49.92
			],
			[
				"2004-03-23",
				46.72
			],
			[
				"2004-02-03",
				47.22
			],
			[
				"2005-11-08",
				46.22
			],
			[
				"2005-04-19",
				50.22
			],
			[
				"2010-05-20",
				39.91
			],
			[
				"2011-11-29",
				39.31
			],
			[
				"2012-10-15",
				39.21
			],
			[
				"2012-03-28",
				39.11
			],
			[
				"2013-11-26",
				36.81
			],
			[
				"2013-03-13",
				37.11
			],
			[
				"2014-11-04",
				34.41
			],
			[
				"2014-03-13",
				33.11
			],
			[
				"2015-10-15",
				34.01
			],
			[
				"2015-03-26",
				34.31
			]
		],
		"86551863": [
			[
				"2007-09-25",
				66.22
			],
			[
				"2008-10-07",
				72.63
			],
			[
				"2007-03-07",
				35.91
			],
			[
				"2009-04-01",
				44.82
			],
			[
				"2009-10-15",
				85.33
			],
			[
				"2000-10-16",
				66.62
			],
			[
				"2000-06-26",
				68.02
			],
			[
				"2001-10-29",
				73.63
			],
			[
				"2001-06-18",
				65.32
			],
			[
				"2002-02-18",
				46.92
			],
			[
				"2006-03-14",
				51.02
			],
			[
				"2005-10-05",
				63.92
			],
			[
				"2005-03-01",
				41.61
			],
			[
				"2004-10-12",
				60.92
			],
			[
				"2004-03-16",
				61.62
			],
			[
				"2010-03-16",
				47.32
			],
			[
				"2010-11-03",
				78.03
			],
			[
				"2011-05-17",
				95.83
			],
			[
				"2011-06-06",
				94.73
			],
			[
				"2011-06-14",
				92.73
			],
			[
				"2011-06-20",
				85.33
			],
			[
				"2011-11-22",
				89.83
			],
			[
				"2012-05-31",
				75.73
			],
			[
				"2012-10-11",
				78.73
			],
			[
				"2013-05-07",
				57.02
			],
			[
				"2013-10-17",
				66.42
			],
			[
				"2014-06-05",
				59.42
			],
			[
				"2014-10-09",
				56.72
			],
			[
				"2015-05-07",
				57.32
			],
			[
				"2015-10-08",
				71.43
			]
		],
		"86568371": [
			[
				"2007-03-07",
				22.71
			],
			[
				"2007-09-25",
				25.81
			],
			[
				"2008-10-07",
				25.01
			],
			[
				"2009-03-03",
				23.01
			],
			[
				"2009-09-17",
				22.81
			],
			[
				"2002-07-08",
				27.01
			],
			[
				"2002-02-18",
				26.71
			],
			[
				"2010-04-13",
				22.51
			],
			[
				"2010-11-03",
				26.21
			],
			[
				"2011-04-13",
				27.31
			],
			[
				"2011-10-25",
				25.91
			],
			[
				"2012-05-24",
				24.91
			],
			[
				"2012-10-11",
				25.41
			],
			[
				"2013-11-07",
				23.61
			],
			[
				"2014-06-12",
				21.81
			],
			[
				"2013-05-23",
				24.21
			],
			[
				"2014-10-23",
				22.71
			],
			[
				"2015-05-21",
				22.71
			],
			[
				"2015-10-22",
				20.91
			]
		],
		"86573470": [
			[
				"2006-09-12",
				56.42
			],
			[
				"2006-05-10",
				54.82
			],
			[
				"2007-11-06",
				60.42
			],
			[
				"2007-03-29",
				60.62
			],
			[
				"2008-10-01",
				58.32
			],
			[
				"2008-03-06",
				59.52
			],
			[
				"2009-09-30",
				60.02
			],
			[
				"2009-03-05",
				59.22
			],
			[
				"2000-07-19",
				53.02
			],
			[
				"2000-06-26",
				51.02
			],
			[
				"2000-05-25",
				55.02
			],
			[
				"2000-04-13",
				53.02
			],
			[
				"2000-03-13",
				55.02
			],
			[
				"2000-02-16",
				54.02
			],
			[
				"2000-01-18",
				50.02
			],
			[
				"2001-12-04",
				53.02
			],
			[
				"2001-11-21",
				51.02
			],
			[
				"2001-10-15",
				51.02
			],
			[
				"2001-09-10",
				51.02
			],
			[
				"2001-08-20",
				51.02
			],
			[
				"2001-08-07",
				52.02
			],
			[
				"2001-07-03",
				53.02
			],
			[
				"2001-05-31",
				53.02
			],
			[
				"2001-04-19",
				53.02
			],
			[
				"2001-03-19",
				49.02
			],
			[
				"2001-02-07",
				51.02
			],
			[
				"2001-01-15",
				46.02
			],
			[
				"2002-09-09",
				52.02
			],
			[
				"2002-08-07",
				52.02
			],
			[
				"2002-06-03",
				54.02
			],
			[
				"2002-02-20",
				54.02
			],
			[
				"2003-07-02",
				52.22
			],
			[
				"2004-12-01",
				60.92
			],
			[
				"2004-02-18",
				51.72
			],
			[
				"2004-02-03",
				52.62
			],
			[
				"2005-11-15",
				54.82
			],
			[
				"2005-04-28",
				58.82
			],
			[
				"2010-10-14",
				61.42
			],
			[
				"2010-04-15",
				61.22
			],
			[
				"2011-11-30",
				61.22
			],
			[
				"2011-02-17",
				60.32
			],
			[
				"2012-10-15",
				59.92
			],
			[
				"2012-03-27",
				60.82
			],
			[
				"2013-11-14",
				56.22
			],
			[
				"2013-03-14",
				60.52
			],
			[
				"2014-11-13",
				55.02
			],
			[
				"2014-03-14",
				55.02
			],
			[
				"2015-10-20",
				55.72
			],
			[
				"2015-02-10",
				55.52
			]
		],
		"86573974": [
			[
				"2006-11-08",
				86.33
			],
			[
				"2006-06-08",
				87.73
			],
			[
				"2007-10-25",
				93.63
			],
			[
				"2007-03-15",
				93.83
			],
			[
				"2008-10-09",
				89.73
			],
			[
				"2008-02-28",
				88.73
			],
			[
				"2009-09-24",
				84.73
			],
			[
				"2009-03-12",
				85.03
			],
			[
				"2001-09-03",
				95.03
			],
			[
				"2001-03-07",
				100.04
			],
			[
				"2002-09-04",
				102.04
			],
			[
				"2002-03-18",
				103.04
			],
			[
				"2003-06-05",
				104.14
			],
			[
				"2004-10-28",
				98.23
			],
			[
				"2004-03-23",
				94.63
			],
			[
				"2005-11-16",
				93.03
			],
			[
				"2005-04-27",
				99.74
			],
			[
				"2010-10-07",
				79.33
			],
			[
				"2010-04-13",
				80.13
			],
			[
				"2011-10-13",
				77.93
			],
			[
				"2011-02-09",
				77.33
			],
			[
				"2012-10-30",
				76.23
			],
			[
				"2012-04-11",
				73.13
			],
			[
				"2013-11-28",
				58.62
			],
			[
				"2013-03-21",
				72.13
			],
			[
				"2014-12-04",
				64.92
			],
			[
				"2014-02-06",
				71.03
			],
			[
				"2015-10-20",
				67.82
			],
			[
				"2015-02-11",
				67.92
			]
		],
		"86573986": [
			[
				"2006-11-08",
				95.83
			],
			[
				"2006-06-08",
				92.13
			],
			[
				"2007-10-25",
				92.03
			],
			[
				"2007-03-15",
				98.33
			],
			[
				"2008-10-09",
				80.13
			],
			[
				"2008-02-28",
				88.73
			],
			[
				"2009-09-24",
				74.73
			],
			[
				"2009-03-12",
				79.23
			],
			[
				"2001-09-03",
				101.04
			],
			[
				"2001-03-07",
				46.02
			],
			[
				"2002-09-04",
				109.04
			],
			[
				"2002-03-18",
				111.04
			],
			[
				"2003-06-05",
				111.94
			],
			[
				"2004-10-28",
				110.94
			],
			[
				"2004-03-23",
				103.44
			],
			[
				"2005-11-16",
				95.73
			],
			[
				"2005-04-27",
				104.94
			],
			[
				"2010-10-07",
				69.42
			],
			[
				"2010-04-13",
				72.23
			],
			[
				"2011-10-13",
				69.42
			],
			[
				"2011-02-09",
				71.43
			],
			[
				"2012-04-11",
				65.62
			],
			[
				"2013-11-28",
				53.52
			],
			[
				"2013-03-26",
				66.62
			],
			[
				"2014-12-04",
				56.02
			],
			[
				"2014-02-06",
				65.02
			],
			[
				"2015-10-21",
				61.92
			],
			[
				"2015-02-11",
				60.52
			]
		],
		"86591459": [
			[
				"2009-03-25",
				15.31
			],
			[
				"2008-12-15",
				1
			],
			[
				"2008-04-09",
				20.51
			],
			[
				"2007-08-22",
				13.8
			],
			[
				"2007-03-28",
				9
			],
			[
				"2006-09-06",
				12.1
			],
			[
				"2006-04-25",
				10.9
			],
			[
				"2005-08-31",
				9
			],
			[
				"2005-04-20",
				9
			],
			[
				"2004-04-06",
				8
			],
			[
				"2003-08-14",
				8.9
			],
			[
				"2003-04-29",
				7
			],
			[
				"2002-11-11",
				10.6
			],
			[
				"2002-04-23",
				8.2
			],
			[
				"2001-11-13",
				7
			],
			[
				"2001-04-25",
				5
			],
			[
				"2000-10-18",
				9
			],
			[
				"2000-05-09",
				9
			],
			[
				"2010-10-06",
				20.01
			],
			[
				"2011-04-04",
				17.01
			],
			[
				"2009-10-01",
				22.11
			],
			[
				"2013-10-14",
				25.11
			],
			[
				"2013-04-04",
				22.71
			],
			[
				"2012-10-22",
				9.4
			],
			[
				"2012-04-25",
				18.51
			],
			[
				"2011-10-05",
				24.41
			],
			[
				"2014-05-27",
				21.21
			],
			[
				"2015-11-16",
				28.21
			],
			[
				"2015-04-28",
				26.01
			],
			[
				"2014-11-12",
				24.11
			]
		],
		"86592786": [
			[
				"2007-11-27",
				116.04
			],
			[
				"2008-11-04",
				105.04
			],
			[
				"2008-03-18",
				112.04
			],
			[
				"2007-07-09",
				105.04
			],
			[
				"2007-04-17",
				110.04
			],
			[
				"2009-04-21",
				106.04
			],
			[
				"2009-11-17",
				113.04
			],
			[
				"2010-04-28",
				116.04
			],
			[
				"2000-11-15",
				149.05
			],
			[
				"2000-08-30",
				145.05
			],
			[
				"2000-04-05",
				137.05
			],
			[
				"2001-11-14",
				106.04
			],
			[
				"2001-08-22",
				123.04
			],
			[
				"2001-04-25",
				151.05
			],
			[
				"2002-11-20",
				94.23
			],
			[
				"2002-08-21",
				97.03
			],
			[
				"2002-05-15",
				100.04
			],
			[
				"2003-11-26",
				111.04
			],
			[
				"2003-08-27",
				97.13
			],
			[
				"2003-05-21",
				103.04
			],
			[
				"2004-12-01",
				117.04
			],
			[
				"2004-07-21",
				130.05
			],
			[
				"2004-03-15",
				134.05
			],
			[
				"2006-11-21",
				111.04
			],
			[
				"2006-07-25",
				121.04
			],
			[
				"2010-10-13",
				119.04
			],
			[
				"2011-04-13",
				123.04
			],
			[
				"2011-10-18",
				123.04
			],
			[
				"2012-03-27",
				127.05
			],
			[
				"2012-10-10",
				124.04
			],
			[
				"2013-11-12",
				124.04
			],
			[
				"2013-05-07",
				143.05
			],
			[
				"2014-11-26",
				119.34
			],
			[
				"2014-08-06",
				111.44
			],
			[
				"2014-05-19",
				122.84
			],
			[
				"2014-02-17",
				119.14
			],
			[
				"2015-05-21",
				121.24
			],
			[
				"2015-11-04",
				117.34
			],
			[
				"2015-02-05",
				121.74
			]
		],
		"86594606": [
			[
				"2007-11-26",
				57.62
			],
			[
				"2008-11-03",
				58.42
			],
			[
				"2008-03-17",
				60.52
			],
			[
				"2007-07-10",
				60.42
			],
			[
				"2007-04-16",
				62.42
			],
			[
				"2009-04-20",
				49.92
			],
			[
				"2009-11-16",
				53.52
			],
			[
				"2010-04-26",
				50.02
			],
			[
				"2000-11-14",
				73.03
			],
			[
				"2000-08-29",
				76.03
			],
			[
				"2000-04-04",
				64.02
			],
			[
				"2001-11-13",
				68.02
			],
			[
				"2001-08-21",
				63.02
			],
			[
				"2001-04-24",
				58.02
			],
			[
				"2002-11-19",
				71.33
			],
			[
				"2002-08-20",
				72.03
			],
			[
				"2002-05-14",
				67.02
			],
			[
				"2003-11-25",
				73.03
			],
			[
				"2003-08-26",
				69.12
			],
			[
				"2003-05-20",
				66.92
			],
			[
				"2004-11-30",
				65.92
			],
			[
				"2004-07-20",
				68.52
			],
			[
				"2004-03-16",
				73.63
			],
			[
				"2006-11-20",
				56.82
			],
			[
				"2006-07-26",
				62.12
			],
			[
				"2010-10-12",
				54.62
			],
			[
				"2011-04-11",
				55.02
			],
			[
				"2011-10-17",
				49.42
			],
			[
				"2012-03-26",
				58.52
			],
			[
				"2012-10-09",
				50.62
			],
			[
				"2013-11-11",
				49.92
			],
			[
				"2013-05-06",
				56.12
			],
			[
				"2014-11-24",
				54.12
			],
			[
				"2014-08-04",
				50.52
			],
			[
				"2014-05-12",
				51.32
			],
			[
				"2014-02-10",
				53.72
			],
			[
				"2015-05-18",
				45.92
			],
			[
				"2015-11-09",
				49.52
			],
			[
				"2015-02-02",
				54.42
			]
		],
		"86600485": [
			[
				"2014-11-20",
				0.13
			],
			[
				"2015-11-23",
				0.05
			],
			[
				"2012-06-18",
				0.05
			],
			[
				"2006-06-06",
				0.11
			],
			[
				"2009-03-18",
				0.15
			],
			[
				"2000-03-09",
				0.05
			],
			[
				"2000-08-21",
				0.05
			],
			[
				"2003-08-13",
				0.05
			]
		],
		"86600643": [
			[
				"2014-11-20",
				16.52
			],
			[
				"2015-11-30",
				15.71
			],
			[
				"2012-06-18",
				12.4
			],
			[
				"2006-06-02",
				22.91
			],
			[
				"2009-03-18",
				21.31
			],
			[
				"2000-03-10",
				38.01
			],
			[
				"2000-08-22",
				32.01
			],
			[
				"2003-08-13",
				27.61
			]
		],
		"86612025": [
			[
				"2007-11-13",
				1
			],
			[
				"2007-07-02",
				5.5
			],
			[
				"2007-02-28",
				1
			],
			[
				"2008-03-06",
				4.4
			],
			[
				"2008-11-17",
				1
			],
			[
				"2008-07-07",
				6.9
			],
			[
				"2009-03-02",
				6
			],
			[
				"2009-07-06",
				8.2
			],
			[
				"2009-11-24",
				4.9
			],
			[
				"2010-03-29",
				4.3
			],
			[
				"2010-02-02",
				1.1
			],
			[
				"2000-10-17",
				13
			],
			[
				"2000-06-27",
				15.01
			],
			[
				"2000-02-14",
				16.01
			],
			[
				"2001-11-21",
				1
			],
			[
				"2001-07-25",
				9.2
			],
			[
				"2001-03-12",
				15.01
			],
			[
				"2002-11-25",
				1
			],
			[
				"2002-07-09",
				6
			],
			[
				"2003-11-24",
				4.5
			],
			[
				"2003-07-16",
				1.7
			],
			[
				"2003-03-11",
				3.1
			],
			[
				"2004-11-17",
				3.1
			],
			[
				"2004-07-26",
				8.3
			],
			[
				"2004-03-17",
				11.7
			],
			[
				"2005-12-13",
				2.1
			],
			[
				"2005-11-28",
				5.1
			],
			[
				"2005-07-12",
				2.9
			],
			[
				"2005-03-03",
				5.3
			],
			[
				"2006-11-16",
				1.2
			],
			[
				"2006-07-11",
				8.1
			],
			[
				"2006-03-02",
				3.5
			],
			[
				"2010-07-12",
				4.2
			],
			[
				"2010-10-25",
				2.9
			],
			[
				"2011-03-03",
				4.3
			],
			[
				"2011-07-25",
				5.9
			],
			[
				"2011-10-24",
				4.1
			],
			[
				"2012-03-05",
				2.9
			],
			[
				"2012-07-02",
				3.6
			],
			[
				"2013-09-25",
				2.6
			],
			[
				"2013-07-02",
				3.9
			],
			[
				"2013-03-04",
				5.6
			],
			[
				"2012-10-17",
				3.4
			],
			[
				"2014-09-23",
				6.18
			],
			[
				"2014-07-07",
				5.1
			],
			[
				"2014-03-10",
				8.2
			],
			[
				"2015-03-09",
				7.42
			],
			[
				"2015-10-13",
				5.08
			],
			[
				"2015-07-08",
				4.18
			]
		],
		"86621555": [
			[
				"2009-02-17",
				48.82
			],
			[
				"2008-09-03",
				51.72
			],
			[
				"2008-06-23",
				55.82
			],
			[
				"2008-02-25",
				54.62
			],
			[
				"2007-09-19",
				55.52
			],
			[
				"2007-06-26",
				57.02
			],
			[
				"2007-03-05",
				53.72
			],
			[
				"2006-09-19",
				56.62
			],
			[
				"2006-06-21",
				52.62
			],
			[
				"2006-02-20",
				51.72
			],
			[
				"2005-09-19",
				56.82
			],
			[
				"2005-06-27",
				62.92
			],
			[
				"2005-03-08",
				61.92
			],
			[
				"2004-09-08",
				56.92
			],
			[
				"2004-05-05",
				53.22
			],
			[
				"2004-03-22",
				55.12
			],
			[
				"2009-06-25",
				51.62
			],
			[
				"2009-09-23",
				50.32
			],
			[
				"2010-03-16",
				51.72
			],
			[
				"2000-10-04",
				68.02
			],
			[
				"2000-05-29",
				65.02
			],
			[
				"2000-02-01",
				69.02
			],
			[
				"2001-10-09",
				58.02
			],
			[
				"2001-06-11",
				65.02
			],
			[
				"2001-02-06",
				63.02
			],
			[
				"2002-06-12",
				59.02
			],
			[
				"2002-02-05",
				55.02
			],
			[
				"2003-09-29",
				54.52
			],
			[
				"2003-06-04",
				53.42
			],
			[
				"2003-02-26",
				58.02
			],
			[
				"2010-09-21",
				55.82
			],
			[
				"2010-06-28",
				53.12
			],
			[
				"2011-02-09",
				54.32
			],
			[
				"2011-06-28",
				53.52
			],
			[
				"2011-10-06",
				51.82
			],
			[
				"2012-02-27",
				53.62
			],
			[
				"2012-06-25",
				52.12
			],
			[
				"2012-11-07",
				49.82
			],
			[
				"2013-09-24",
				50.02
			],
			[
				"2013-06-10",
				47.92
			],
			[
				"2013-03-05",
				52.32
			],
			[
				"2014-06-23",
				53.92
			],
			[
				"2014-02-24",
				46.72
			],
			[
				"2014-09-16",
				51.42
			],
			[
				"2015-06-08",
				48.32
			],
			[
				"2015-03-03",
				50.32
			],
			[
				"2015-09-28",
				52.52
			]
		],
		"86621567": [
			[
				"2009-02-20",
				61.62
			],
			[
				"2008-09-03",
				53.42
			],
			[
				"2008-06-05",
				59.92
			],
			[
				"2008-02-25",
				52.92
			],
			[
				"2007-09-19",
				60.52
			],
			[
				"2007-06-26",
				61.22
			],
			[
				"2007-03-05",
				53.12
			],
			[
				"2006-09-19",
				58.62
			],
			[
				"2006-06-21",
				52.02
			],
			[
				"2006-02-20",
				55.82
			],
			[
				"2005-09-19",
				59.42
			],
			[
				"2005-07-06",
				50.92
			],
			[
				"2005-03-08",
				52.12
			],
			[
				"2004-09-08",
				56.02
			],
			[
				"2004-05-05",
				55.72
			],
			[
				"2004-02-18",
				61.02
			],
			[
				"2009-06-25",
				60.72
			],
			[
				"2009-09-23",
				54.12
			],
			[
				"2010-03-02",
				67.12
			],
			[
				"2000-11-22",
				45.02
			],
			[
				"2000-11-14",
				53.02
			],
			[
				"2000-10-04",
				55.02
			],
			[
				"2000-05-29",
				45.02
			],
			[
				"2000-02-01",
				46.02
			],
			[
				"2001-10-09",
				49.02
			],
			[
				"2001-06-11",
				46.02
			],
			[
				"2001-02-06",
				48.02
			],
			[
				"2002-06-12",
				53.02
			],
			[
				"2002-02-05",
				53.02
			],
			[
				"2003-09-29",
				54.82
			],
			[
				"2003-06-04",
				55.82
			],
			[
				"2003-02-26",
				52.72
			],
			[
				"2010-09-21",
				66.12
			],
			[
				"2010-07-06",
				65.72
			],
			[
				"2011-02-09",
				65.22
			],
			[
				"2011-06-28",
				65.12
			],
			[
				"2011-10-06",
				64.92
			],
			[
				"2012-02-27",
				65.32
			],
			[
				"2012-06-25",
				65.52
			],
			[
				"2012-11-07",
				64.52
			],
			[
				"2013-09-24",
				64.02
			],
			[
				"2013-06-10",
				63.82
			],
			[
				"2013-02-25",
				62.72
			],
			[
				"2014-06-23",
				62.52
			],
			[
				"2014-02-24",
				61.72
			],
			[
				"2014-09-16",
				60.92
			],
			[
				"2015-06-08",
				58.42
			],
			[
				"2015-02-23",
				57.72
			],
			[
				"2015-09-28",
				59.62
			]
		],
		"86625081": [
			[
				"2008-04-29",
				12
			],
			[
				"2007-04-24",
				15.51
			],
			[
				"2008-10-14",
				13.6
			],
			[
				"2009-04-21",
				14.11
			],
			[
				"2009-10-27",
				13.4
			],
			[
				"2010-04-28",
				13.2
			],
			[
				"2002-05-06",
				18.41
			],
			[
				"2002-10-23",
				17.91
			],
			[
				"2004-04-20",
				14.41
			],
			[
				"2004-10-27",
				11
			],
			[
				"2005-04-19",
				5.2
			],
			[
				"2005-06-17",
				14.71
			],
			[
				"2005-10-18",
				14.91
			],
			[
				"2006-04-24",
				15.51
			],
			[
				"2006-10-17",
				13.7
			],
			[
				"2007-10-15",
				5.2
			],
			[
				"2010-11-24",
				10.8
			],
			[
				"2011-04-27",
				12.1
			],
			[
				"2011-10-17",
				10.3
			],
			[
				"2012-04-23",
				8.4
			],
			[
				"2012-10-22",
				9.6
			],
			[
				"2013-04-23",
				9.5
			],
			[
				"2013-10-22",
				8.8
			],
			[
				"2014-04-28",
				9.4
			],
			[
				"2014-10-21",
				9.2
			],
			[
				"2015-04-27",
				9.1
			],
			[
				"2015-10-20",
				10.3
			]
		],
		"86625123": [
			[
				"2008-04-29",
				11.7
			],
			[
				"2007-04-24",
				14
			],
			[
				"2008-10-14",
				14.91
			],
			[
				"2009-04-21",
				13.8
			],
			[
				"2009-10-27",
				14.31
			],
			[
				"2010-04-28",
				14.51
			],
			[
				"2002-06-04",
				7.9
			],
			[
				"2004-04-20",
				11.3
			],
			[
				"2004-01-15",
				13.1
			],
			[
				"2004-07-14",
				15.81
			],
			[
				"2004-10-27",
				17.01
			],
			[
				"2005-01-10",
				15.31
			],
			[
				"2005-04-19",
				16.11
			],
			[
				"2005-10-18",
				13.5
			],
			[
				"2006-04-24",
				10.4
			],
			[
				"2006-10-17",
				11.8
			],
			[
				"2007-10-15",
				10.7
			],
			[
				"2010-11-24",
				15.01
			],
			[
				"2011-04-27",
				14
			],
			[
				"2011-10-17",
				15.01
			],
			[
				"2012-04-23",
				13.8
			],
			[
				"2012-10-22",
				10.4
			],
			[
				"2013-06-17",
				11.2
			],
			[
				"2013-10-22",
				9.4
			],
			[
				"2014-04-28",
				8.6
			],
			[
				"2003-06-05",
				15.31
			],
			[
				"2003-11-04",
				11.6
			],
			[
				"2014-10-21",
				17.21
			],
			[
				"2015-04-27",
				12.3
			],
			[
				"2015-10-20",
				10.9
			]
		],
		"91112000": [
			[
				"2015-06-24",
				1.33
			],
			[
				"2006-03-16",
				0.66
			],
			[
				"2006-08-30",
				0.66
			],
			[
				"2007-02-28",
				0.66
			],
			[
				"2008-02-11",
				0.66
			],
			[
				"2009-04-23",
				0.66
			],
			[
				"2010-05-17",
				0.66
			],
			[
				"2011-11-29",
				0.66
			]
		],
		"91120100": [
			[
				"2014-12-16",
				1.33
			],
			[
				"2015-06-24",
				1.33
			],
			[
				"2007-02-20",
				0.66
			],
			[
				"2008-02-11",
				0.66
			],
			[
				"2009-03-23",
				0.66
			],
			[
				"2010-05-17",
				0.66
			],
			[
				"2011-11-29",
				0.66
			]
		],
		"91120202": [
			[
				"2013-11-12",
				1.33
			],
			[
				"2014-12-16",
				32.02
			],
			[
				"2015-06-17",
				1.33
			],
			[
				"2006-02-16",
				0.66
			],
			[
				"2006-10-25",
				0.66
			],
			[
				"2007-02-21",
				0.66
			],
			[
				"2008-02-06",
				0.66
			],
			[
				"2009-03-23",
				0.66
			],
			[
				"2010-08-04",
				0.66
			],
			[
				"2011-05-02",
				0.66
			]
		],
		"91130608": [
			[
				"2013-12-10",
				1.33
			],
			[
				"2014-12-09",
				1.33
			],
			[
				"2015-06-17",
				1.33
			],
			[
				"2000-11-28",
				2.21
			],
			[
				"2001-09-05",
				0.44
			],
			[
				"2002-11-18",
				1.33
			],
			[
				"2004-01-07",
				0.44
			],
			[
				"2005-02-15",
				0.89
			],
			[
				"2005-12-06",
				0.66
			],
			[
				"2006-02-15",
				0.66
			],
			[
				"2006-11-29",
				0.66
			],
			[
				"2007-02-21",
				0.66
			],
			[
				"2008-02-06",
				0.66
			],
			[
				"2009-04-22",
				0.66
			],
			[
				"2010-04-15",
				0.66
			],
			[
				"2011-03-22",
				0.66
			]
		],
		"91130700": [
			[
				"2013-11-07",
				6.78
			],
			[
				"2014-04-01",
				1.59
			],
			[
				"2015-06-17",
				1.33
			],
			[
				"2000-12-11",
				13.73
			],
			[
				"2001-09-05",
				10.19
			],
			[
				"2002-11-18",
				6.2
			],
			[
				"2004-01-07",
				6.64
			],
			[
				"2005-02-15",
				0.89
			],
			[
				"2006-03-20",
				3.32
			],
			[
				"2006-11-23",
				4.21
			],
			[
				"2007-03-01",
				1.51
			],
			[
				"2008-02-12",
				0.66
			],
			[
				"2009-03-25",
				4.43
			],
			[
				"2005-12-07",
				5.05
			],
			[
				"2010-08-04",
				0.66
			],
			[
				"2011-03-24",
				0.66
			]
		],
		"91130803": [
			[
				"2013-11-04",
				1.33
			],
			[
				"2014-12-02",
				1.33
			],
			[
				"2015-06-23",
				2.44
			],
			[
				"2006-03-15",
				0.8
			],
			[
				"2006-08-23",
				0.84
			],
			[
				"2007-03-01",
				0.8
			],
			[
				"2008-02-11",
				0.97
			],
			[
				"2009-04-20",
				1.99
			],
			[
				"2010-04-15",
				1.02
			],
			[
				"2011-03-22",
				1.33
			]
		],
		"91130906": [
			[
				"2013-11-07",
				14.92
			],
			[
				"2014-12-02",
				10.05
			],
			[
				"2015-06-23",
				12.58
			],
			[
				"2000-11-29",
				25.24
			],
			[
				"2001-09-05",
				23.03
			],
			[
				"2002-11-18",
				22.14
			],
			[
				"2004-01-07",
				17.71
			],
			[
				"2005-02-15",
				18.16
			],
			[
				"2005-12-07",
				17.76
			],
			[
				"2006-10-17",
				17.36
			],
			[
				"2007-03-05",
				16.34
			],
			[
				"2008-02-07",
				14.84
			],
			[
				"2009-04-20",
				16.03
			],
			[
				"2010-04-15",
				18.38
			],
			[
				"2011-03-28",
				16.43
			]
		],
		"91131005": [
			[
				"2013-11-07",
				1.33
			],
			[
				"2014-12-01",
				4.43
			],
			[
				"2015-06-23",
				3.19
			],
			[
				"2006-03-23",
				7.53
			],
			[
				"2006-08-23",
				4.65
			],
			[
				"2007-03-05",
				7.71
			],
			[
				"2007-10-18",
				0.66
			],
			[
				"2008-02-12",
				7.4
			],
			[
				"2009-03-24",
				5.49
			],
			[
				"2010-05-05",
				4.38
			],
			[
				"2011-03-24",
				4.56
			]
		],
		"91131406": [
			[
				"2014-12-02",
				1.33
			],
			[
				"2015-10-12",
				1.33
			],
			[
				"2000-11-29",
				0.44
			],
			[
				"2001-09-25",
				0.44
			],
			[
				"2002-11-21",
				0.44
			],
			[
				"2004-01-08",
				0.44
			],
			[
				"2005-03-15",
				0.44
			],
			[
				"2005-12-07",
				0.66
			],
			[
				"2006-02-15",
				0.66
			],
			[
				"2007-02-21",
				0.66
			],
			[
				"2008-02-07",
				0.66
			],
			[
				"2006-11-29",
				0.66
			],
			[
				"2010-07-12",
				0.66
			],
			[
				"2011-03-28",
				0.66
			]
		],
		"91132204": [
			[
				"2013-11-07",
				1.33
			],
			[
				"2014-12-01",
				1.33
			],
			[
				"2015-10-12",
				1.33
			],
			[
				"2006-02-20",
				0.66
			],
			[
				"2006-08-31",
				0.66
			],
			[
				"2008-02-14",
				0.66
			],
			[
				"2010-08-03",
				0.66
			],
			[
				"2011-03-28",
				0.66
			]
		],
		"91133002": [
			[
				"2014-11-03",
				1.33
			],
			[
				"2015-12-03",
				1.33
			],
			[
				"2006-03-15",
				0.66
			],
			[
				"2006-09-06",
				0.66
			],
			[
				"2007-03-06",
				0.66
			],
			[
				"2008-02-14",
				0.66
			],
			[
				"2010-08-31",
				0.66
			],
			[
				"2011-07-25",
				0.66
			]
		],
		"91133300": [
			[
				"2014-11-03",
				1.33
			],
			[
				"2015-10-14",
				1.33
			],
			[
				"2006-10-25",
				0.66
			],
			[
				"2007-03-06",
				0.66
			],
			[
				"2007-07-04",
				0.07
			],
			[
				"2008-02-13",
				0.66
			],
			[
				"2009-03-25",
				0.66
			],
			[
				"2010-08-03",
				0.66
			],
			[
				"2011-07-25",
				0.66
			]
		],
		"91133609": [
			[
				"2013-11-04",
				46.94
			],
			[
				"2014-11-03",
				35.34
			],
			[
				"2015-10-26",
				38.44
			],
			[
				"2000-10-26",
				60.23
			],
			[
				"2001-09-25",
				49.6
			],
			[
				"2002-11-21",
				54.03
			],
			[
				"2004-01-06",
				35.43
			],
			[
				"2005-03-15",
				47.83
			],
			[
				"2005-11-28",
				30.91
			],
			[
				"2006-10-10",
				17.45
			],
			[
				"2007-02-27",
				21.48
			],
			[
				"2008-02-18",
				36.58
			],
			[
				"2009-04-22",
				20.02
			],
			[
				"2010-04-28",
				41.41
			],
			[
				"2011-08-10",
				41.54
			]
		],
		"91135000": [
			[
				"2013-12-17",
				34.32
			],
			[
				"2014-08-11",
				27.46
			],
			[
				"2015-11-09",
				27.9
			],
			[
				"2000-09-13",
				38.53
			],
			[
				"2001-12-19",
				33.21
			],
			[
				"2003-03-27",
				32.33
			],
			[
				"2003-12-02",
				39.86
			],
			[
				"2004-10-27",
				39.41
			],
			[
				"2005-10-25",
				37.29
			],
			[
				"2006-05-16",
				32.59
			],
			[
				"2007-05-15",
				41.1
			],
			[
				"2008-04-17",
				31.27
			],
			[
				"2006-12-20",
				35.83
			],
			[
				"2009-07-02",
				33.75
			],
			[
				"2010-07-26",
				33.39
			],
			[
				"2011-04-06",
				30.38
			]
		],
		"91135102": [
			[
				"2015-10-19",
				24.45
			],
			[
				"2006-05-16",
				23.34
			],
			[
				"2007-05-15",
				24.27
			],
			[
				"2008-04-17",
				26.04
			],
			[
				"2008-11-17",
				26.26
			],
			[
				"2009-07-02",
				23.29
			],
			[
				"2010-09-16",
				23.12
			],
			[
				"2011-04-06",
				23.69
			]
		],
		"91140900": [
			[
				"2013-11-04",
				1.33
			],
			[
				"2014-10-30",
				1.33
			],
			[
				"2015-09-03",
				1.33
			],
			[
				"2006-02-21",
				0.66
			],
			[
				"2006-08-31",
				0.66
			],
			[
				"2007-02-26",
				0.66
			],
			[
				"2008-02-18",
				0.66
			],
			[
				"2009-03-03",
				0.66
			],
			[
				"2010-08-02",
				0.66
			],
			[
				"2011-05-25",
				0.66
			]
		],
		"91141102": [
			[
				"2013-11-07",
				11.03
			],
			[
				"2015-09-03",
				84.14
			],
			[
				"2000-11-29",
				0.44
			],
			[
				"2001-09-06",
				0.89
			],
			[
				"2002-11-21",
				49.6
			],
			[
				"2004-02-10",
				47.83
			],
			[
				"2006-03-15",
				7.97
			],
			[
				"2006-11-23",
				8.1
			],
			[
				"2007-02-26",
				5.54
			],
			[
				"2008-02-14",
				106.73
			],
			[
				"2009-03-02",
				20.68
			],
			[
				"2010-08-02",
				89.9
			],
			[
				"2010-10-05",
				69.09
			],
			[
				"2011-05-25",
				73.07
			]
		],
		"91143100": [
			[
				"2013-09-26",
				26.35
			],
			[
				"2014-11-11",
				23.96
			],
			[
				"2015-11-09",
				24.4
			],
			[
				"2000-09-13",
				34.99
			],
			[
				"2001-12-19",
				31.44
			],
			[
				"2003-12-02",
				27.46
			],
			[
				"2004-10-28",
				26.57
			],
			[
				"2005-11-02",
				23.43
			],
			[
				"2006-05-16",
				23.29
			],
			[
				"2007-05-15",
				24.76
			],
			[
				"2008-04-17",
				26.57
			],
			[
				"2006-12-20",
				23.12
			],
			[
				"2009-07-02",
				27.5
			],
			[
				"2009-10-22",
				27.63
			],
			[
				"2010-07-26",
				28.39
			],
			[
				"2011-04-12",
				26.88
			]
		],
		"91161150": [
			[
				"2013-10-28",
				52.26
			],
			[
				"2014-07-09",
				51.37
			],
			[
				"2015-06-15",
				58.46
			],
			[
				"2006-03-29",
				72.19
			],
			[
				"2006-09-07",
				64.66
			],
			[
				"2007-03-13",
				84.59
			],
			[
				"2008-02-28",
				78.39
			],
			[
				"2009-03-26",
				77.94
			],
			[
				"2010-06-28",
				64.66
			],
			[
				"2011-04-28",
				62
			]
		],
		"91161253": [
			[
				"2013-10-28",
				63.33
			],
			[
				"2015-10-20",
				69.97
			],
			[
				"2006-03-29",
				53.59
			],
			[
				"2006-09-07",
				60.23
			],
			[
				"2008-03-03",
				65.54
			],
			[
				"2008-10-22",
				59.34
			],
			[
				"2009-03-26",
				52.26
			],
			[
				"2011-04-28",
				73.96
			]
		],
		"91161356": [
			[
				"2014-07-16",
				24.93
			],
			[
				"2014-08-11",
				24.62
			],
			[
				"2015-05-28",
				26.53
			],
			[
				"2006-03-29",
				25.38
			],
			[
				"2006-09-07",
				25.6
			],
			[
				"2008-03-03",
				32.06
			],
			[
				"2008-10-22",
				26.26
			],
			[
				"2009-03-26",
				24.58
			],
			[
				"2010-06-28",
				26.39
			],
			[
				"2011-04-27",
				26.93
			]
		],
		"91162002": [
			[
				"2013-12-10",
				1.33
			],
			[
				"2014-10-28",
				1.33
			],
			[
				"2015-05-28",
				1.33
			],
			[
				"2015-10-21",
				1.33
			],
			[
				"2000-11-22",
				0.44
			],
			[
				"2001-08-29",
				0.44
			],
			[
				"2002-12-03",
				0.44
			],
			[
				"2004-01-21",
				0.44
			],
			[
				"2005-03-16",
				0.44
			],
			[
				"2006-05-17",
				0.66
			],
			[
				"2006-10-24",
				0.66
			],
			[
				"2007-03-06",
				0.66
			],
			[
				"2008-02-21",
				0.66
			],
			[
				"2009-03-10",
				0.66
			],
			[
				"2005-12-20",
				0.66
			],
			[
				"2010-07-20",
				0.66
			],
			[
				"2010-11-08",
				0.66
			],
			[
				"2011-05-03",
				0.66
			]
		],
		"91163705": [
			[
				"2015-06-15",
				42.74
			],
			[
				"2006-03-30",
				43.22
			],
			[
				"2006-09-11",
				38.31
			],
			[
				"2007-06-27",
				48.27
			],
			[
				"2008-02-28",
				31.75
			],
			[
				"2009-05-25",
				27.46
			],
			[
				"2010-08-30",
				34.23
			],
			[
				"2011-04-27",
				32.2
			]
		],
		"91164916": [
			[
				"2013-07-01",
				1.33
			],
			[
				"2014-10-28",
				1.33
			],
			[
				"2015-06-22",
				1.33
			],
			[
				"2000-10-04",
				0.44
			],
			[
				"2000-11-16",
				0.44
			],
			[
				"2000-12-07",
				0.89
			],
			[
				"2001-10-17",
				0.44
			],
			[
				"2002-06-26",
				0.44
			],
			[
				"2002-12-04",
				0.89
			],
			[
				"2004-01-15",
				1.33
			],
			[
				"2004-09-27",
				0.44
			],
			[
				"2005-02-21",
				0.44
			],
			[
				"2005-06-14",
				0.44
			],
			[
				"2005-12-14",
				0.66
			],
			[
				"2006-05-17",
				0.66
			],
			[
				"2007-03-08",
				0.66
			],
			[
				"2008-02-25",
				0.66
			],
			[
				"2009-03-10",
				0.66
			],
			[
				"2010-07-20",
				21.57
			],
			[
				"2011-08-03",
				0.66
			]
		],
		"91165908": [
			[
				"2013-10-28",
				1.33
			],
			[
				"2014-10-28",
				1.33
			],
			[
				"2015-10-20",
				3.14
			],
			[
				"2000-10-04",
				6.64
			],
			[
				"2000-11-16",
				4.87
			],
			[
				"2001-09-03",
				1.33
			],
			[
				"2002-12-04",
				2.66
			],
			[
				"2004-01-15",
				8.86
			],
			[
				"2005-02-21",
				4.43
			],
			[
				"2005-12-14",
				1.73
			],
			[
				"2006-05-22",
				4.74
			],
			[
				"2006-10-24",
				3.94
			],
			[
				"2007-03-08",
				2.7
			],
			[
				"2008-02-27",
				1.28
			],
			[
				"2009-07-28",
				0.66
			],
			[
				"2010-09-13",
				2.66
			],
			[
				"2011-05-24",
				0.66
			]
		],
		"91166603": [
			[
				"2013-10-28",
				90.34
			],
			[
				"2014-11-13",
				85.03
			],
			[
				"2015-06-22",
				96.1
			],
			[
				"2000-11-20",
				77.06
			],
			[
				"2002-12-02",
				74.84
			],
			[
				"2004-01-19",
				69.09
			],
			[
				"2005-03-14",
				86.8
			],
			[
				"2006-04-03",
				95.21
			],
			[
				"2007-03-12",
				97.87
			],
			[
				"2008-03-04",
				94.77
			],
			[
				"2006-11-28",
				81.49
			],
			[
				"2009-07-15",
				84.14
			],
			[
				"2005-12-15",
				78.39
			],
			[
				"2010-07-08",
				98.31
			],
			[
				"2011-05-24",
				75.29
			]
		],
		"91167309": [
			[
				"2015-10-21",
				10.81
			],
			[
				"2000-10-11",
				7.97
			],
			[
				"2003-03-17",
				8.41
			],
			[
				"2004-11-02",
				17.27
			],
			[
				"2005-11-21",
				18.42
			],
			[
				"2006-05-22",
				15.46
			],
			[
				"2008-04-22",
				9.65
			],
			[
				"2008-11-13",
				10.36
			],
			[
				"2009-07-09",
				9.92
			],
			[
				"2010-06-30",
				14.75
			],
			[
				"2011-04-13",
				17.4
			]
		],
		"91167504": [
			[
				"2015-09-29",
				17.4
			],
			[
				"2003-05-07",
				14.61
			],
			[
				"2003-12-08",
				13.73
			],
			[
				"2004-11-11",
				13.29
			],
			[
				"2006-01-11",
				16.3
			],
			[
				"2006-05-22",
				20.73
			],
			[
				"2007-05-09",
				23.47
			],
			[
				"2008-08-27",
				16.3
			],
			[
				"2008-12-15",
				22.14
			],
			[
				"2009-07-09",
				14.35
			],
			[
				"2010-06-30",
				11.69
			],
			[
				"2011-04-13",
				19.13
			]
		],
		"91174909": [
			[
				"2015-12-01",
				30.29
			],
			[
				"2000-09-21",
				28.34
			],
			[
				"2001-12-11",
				30.11
			],
			[
				"2003-03-18",
				28.79
			],
			[
				"2003-12-08",
				24.36
			],
			[
				"2004-10-21",
				28.34
			],
			[
				"2005-10-19",
				26.57
			],
			[
				"2006-05-30",
				27.94
			],
			[
				"2006-11-16",
				25.91
			],
			[
				"2007-05-22",
				29.54
			],
			[
				"2009-07-08",
				25.55
			],
			[
				"2008-04-16",
				28.61
			],
			[
				"2010-07-06",
				24.62
			],
			[
				"2011-03-29",
				25.15
			]
		],
		"91175008": [
			[
				"2015-11-10",
				22.45
			],
			[
				"2000-09-21",
				27.9
			],
			[
				"2003-03-18",
				27.9
			],
			[
				"2003-11-25",
				23.03
			],
			[
				"2005-04-27",
				33.61
			],
			[
				"2005-10-19",
				23.21
			],
			[
				"2006-05-30",
				32.2
			],
			[
				"2006-11-20",
				31.8
			],
			[
				"2007-05-22",
				37.2
			],
			[
				"2009-07-08",
				22.9
			],
			[
				"2008-04-16",
				29.76
			],
			[
				"2010-07-06",
				29.23
			],
			[
				"2011-03-29",
				36.93
			]
		],
		"94110013": [
			[
				"2014-10-06",
				1.33
			],
			[
				"2015-09-22",
				1.33
			],
			[
				"2000-09-11",
				0.44
			],
			[
				"2002-12-18",
				0.44
			],
			[
				"2004-01-13",
				0.44
			],
			[
				"2005-12-05",
				0.66
			],
			[
				"2006-06-06",
				0.66
			],
			[
				"2007-02-20",
				0.66
			],
			[
				"2008-07-08",
				0.66
			],
			[
				"2009-04-29",
				2.39
			],
			[
				"2010-07-12",
				0.66
			],
			[
				"2010-10-07",
				0.66
			],
			[
				"2011-05-17",
				0.66
			]
		],
		"94110219": [
			[
				"2013-08-14",
				16.12
			],
			[
				"2014-10-06",
				12.09
			],
			[
				"2015-04-13",
				16.96
			],
			[
				"2006-08-24",
				17.8
			],
			[
				"2008-07-03",
				15.32
			],
			[
				"2009-08-05",
				11.6
			],
			[
				"2010-07-15",
				17.01
			],
			[
				"2011-05-26",
				18.56
			]
		],
		"94120330": [
			[
				"2013-08-19",
				5.18
			],
			[
				"2015-05-26",
				32.02
			],
			[
				"2006-03-28",
				27.9
			],
			[
				"2006-09-13",
				23.21
			],
			[
				"2007-03-15",
				31.84
			],
			[
				"2009-10-21",
				12.13
			],
			[
				"2008-07-03",
				15.19
			],
			[
				"2010-07-27",
				22.67
			],
			[
				"2011-11-17",
				17.98
			]
		],
		"94120341": [
			[
				"2013-07-01",
				46.94
			],
			[
				"2014-05-12",
				43.4
			],
			[
				"2015-04-13",
				41.01
			],
			[
				"2006-03-09",
				45.17
			],
			[
				"2006-09-12",
				47.39
			],
			[
				"2007-02-06",
				46.06
			],
			[
				"2008-03-05",
				45.61
			],
			[
				"2009-03-12",
				43.09
			],
			[
				"2010-04-29",
				46.06
			],
			[
				"2011-03-09",
				46.5
			]
		],
		"94120353": [
			[
				"2015-04-13",
				42.03
			],
			[
				"2006-03-09",
				37.42
			],
			[
				"2006-09-13",
				37.64
			],
			[
				"2007-02-06",
				41.41
			],
			[
				"2008-03-05",
				39.15
			],
			[
				"2009-03-12",
				48.27
			],
			[
				"2010-04-29",
				41.41
			],
			[
				"2011-03-09",
				42.25
			]
		],
		"94120365": [
			[
				"2014-05-07",
				1.33
			],
			[
				"2015-04-16",
				1.33
			],
			[
				"2006-05-29",
				0.66
			],
			[
				"2006-09-14",
				0.66
			],
			[
				"2007-02-07",
				1.24
			],
			[
				"2008-07-08",
				0.66
			],
			[
				"2009-04-29",
				0.66
			],
			[
				"2010-04-21",
				1.06
			],
			[
				"2011-04-04",
				0.84
			]
		],
		"94120377": [
			[
				"2015-10-13",
				1.33
			],
			[
				"2006-05-29",
				0.66
			],
			[
				"2006-09-14",
				0.66
			],
			[
				"2007-03-01",
				0.66
			],
			[
				"2008-07-08",
				0.66
			],
			[
				"2009-08-05",
				0.66
			],
			[
				"2010-05-05",
				0.66
			]
		],
		"94120390": [
			[
				"2013-07-01",
				51.37
			],
			[
				"2015-04-16",
				35.87
			],
			[
				"2006-06-06",
				35.21
			],
			[
				"2006-09-06",
				32.15
			],
			[
				"2007-02-07",
				30.51
			],
			[
				"2008-02-21",
				30.38
			],
			[
				"2009-03-17",
				36.45
			],
			[
				"2010-04-21",
				41.36
			],
			[
				"2011-03-15",
				38.75
			]
		],
		"94130590": [
			[
				"2013-08-26",
				35.65
			],
			[
				"2014-11-20",
				34.81
			],
			[
				"2015-04-08",
				35.12
			],
			[
				"2002-03-08",
				45.02
			],
			[
				"2005-03-18",
				39.01
			],
			[
				"2005-09-16",
				42.01
			],
			[
				"2007-12-13",
				37.69
			],
			[
				"2008-07-16",
				35.34
			],
			[
				"2008-11-04",
				35.74
			],
			[
				"2009-07-27",
				34.72
			],
			[
				"2010-07-14",
				34.63
			]
		],
		"94130619": [
			[
				"2008-05-09",
				39.01
			],
			[
				"2009-05-22",
				38.01
			],
			[
				"2013-08-26",
				36.62
			],
			[
				"2014-11-20",
				34.1
			],
			[
				"2015-05-04",
				34.23
			],
			[
				"2004-06-04",
				40.01
			],
			[
				"2005-06-03",
				41.01
			],
			[
				"2006-05-05",
				40.01
			],
			[
				"2007-05-03",
				37.01
			],
			[
				"2007-12-13",
				30.51
			],
			[
				"2011-05-03",
				37.01
			],
			[
				"2012-05-18",
				35.01
			],
			[
				"2008-07-16",
				36.05
			],
			[
				"2008-11-04",
				36.8
			],
			[
				"2009-07-27",
				34.68
			],
			[
				"2010-07-14",
				35.47
			],
			[
				"2011-12-12",
				35.16
			]
		],
		"94130656": [
			[
				"2009-10-16",
				12
			],
			[
				"2013-08-26",
				13.24
			],
			[
				"2014-11-20",
				14.75
			],
			[
				"2015-05-04",
				14.7
			],
			[
				"2005-04-15",
				14
			],
			[
				"2005-10-14",
				13
			],
			[
				"2006-04-10",
				14
			],
			[
				"2006-10-04",
				12
			],
			[
				"2007-04-05",
				14
			],
			[
				"2007-12-13",
				17.94
			],
			[
				"2010-10-20",
				13
			],
			[
				"2011-05-03",
				14
			],
			[
				"2011-11-15",
				13
			],
			[
				"2012-04-20",
				13
			],
			[
				"2014-05-28",
				14
			],
			[
				"2010-07-27",
				12.84
			]
		],
		"94130700": [
			[
				"2015-04-01",
				47.83
			],
			[
				"2007-02-05",
				51.37
			],
			[
				"2007-10-16",
				47.83
			],
			[
				"2008-03-05",
				46.94
			],
			[
				"2009-03-12",
				43.53
			],
			[
				"2010-07-29",
				38.26
			],
			[
				"2011-03-21",
				45.17
			]
		],
		"94130711": [
			[
				"2013-07-03",
				40.39
			],
			[
				"2014-05-06",
				35.03
			],
			[
				"2015-04-01",
				39.95
			],
			[
				"2007-02-05",
				43.44
			],
			[
				"2007-10-16",
				46.5
			],
			[
				"2008-02-21",
				47.83
			],
			[
				"2009-03-24",
				42.78
			],
			[
				"2010-08-03",
				43.13
			],
			[
				"2011-03-16",
				43.36
			]
		],
		"94130723": [
			[
				"2013-07-03",
				42.43
			],
			[
				"2014-05-06",
				39.77
			],
			[
				"2015-04-01",
				47.83
			],
			[
				"2007-02-05",
				47.83
			],
			[
				"2008-02-21",
				46.06
			],
			[
				"2009-04-22",
				44.73
			],
			[
				"2010-04-28",
				46.06
			],
			[
				"2011-03-16",
				42.96
			]
		],
		"94130735": [
			[
				"2013-07-04",
				41.72
			],
			[
				"2014-05-12",
				39.19
			],
			[
				"2015-04-01",
				43.22
			],
			[
				"2007-02-05",
				50.04
			],
			[
				"2007-10-16",
				50.04
			],
			[
				"2008-03-05",
				48.27
			],
			[
				"2008-10-22",
				44.73
			],
			[
				"2009-03-12",
				46.5
			],
			[
				"2010-07-29",
				43.44
			],
			[
				"2011-03-21",
				47.39
			]
		],
		"94140017": [
			[
				"2008-06-04",
				1
			],
			[
				"2009-05-06",
				1
			],
			[
				"2015-05-07",
				1.33
			],
			[
				"2002-02-14",
				1
			],
			[
				"2003-06-23",
				1
			],
			[
				"2004-05-05",
				1
			],
			[
				"2005-05-04",
				1
			],
			[
				"2006-06-06",
				1
			],
			[
				"2007-05-03",
				1
			],
			[
				"2010-06-07",
				1
			],
			[
				"2011-12-13",
				1
			],
			[
				"2012-06-14",
				1
			],
			[
				"2013-05-15",
				1
			],
			[
				"2014-06-11",
				1
			],
			[
				"2009-10-21",
				0.66
			],
			[
				"2010-07-19",
				0.66
			],
			[
				"2011-12-08",
				0.66
			]
		],
		"94140042": [
			[
				"2013-08-19",
				1.33
			],
			[
				"2014-11-20",
				4.65
			],
			[
				"2015-04-09",
				1.33
			],
			[
				"2000-08-23",
				0.89
			],
			[
				"2001-09-18",
				0.44
			],
			[
				"2002-10-17",
				0.44
			],
			[
				"2003-11-26",
				0.44
			],
			[
				"2005-11-17",
				1.11
			],
			[
				"2006-05-10",
				0.66
			],
			[
				"2006-10-17",
				0.66
			],
			[
				"2007-10-16",
				0.66
			],
			[
				"2008-05-06",
				0.66
			],
			[
				"2009-05-25",
				0.66
			],
			[
				"2010-07-28",
				0.84
			],
			[
				"2011-03-21",
				0.66
			]
		],
		"94140170": [
			[
				"2008-04-07",
				14
			],
			[
				"2008-11-07",
				13
			],
			[
				"2009-11-13",
				16.01
			],
			[
				"2014-11-20",
				12.22
			],
			[
				"2015-04-08",
				13.37
			],
			[
				"2004-06-04",
				9
			],
			[
				"2005-12-21",
				12
			],
			[
				"2006-11-03",
				11
			],
			[
				"2007-11-26",
				13
			],
			[
				"2010-11-19",
				14
			],
			[
				"2011-12-09",
				12
			],
			[
				"2010-07-27",
				12.13
			],
			[
				"2009-11-10",
				14.48
			],
			[
				"2011-12-01",
				11.2
			]
		],
		"94140224": [
			[
				"2014-11-20",
				31
			],
			[
				"2015-05-07",
				34.1
			],
			[
				"2002-08-29",
				41.63
			],
			[
				"2003-08-18",
				30.11
			],
			[
				"2004-05-12",
				42.51
			],
			[
				"2005-05-23",
				42.51
			],
			[
				"2006-02-15",
				41.63
			],
			[
				"2007-03-27",
				40.74
			]
		],
		"94140236": [
			[
				"2013-08-22",
				1.33
			],
			[
				"2015-04-08",
				8.9
			],
			[
				"2002-08-29",
				8.41
			],
			[
				"2003-08-25",
				8.86
			],
			[
				"2004-05-12",
				7.97
			],
			[
				"2005-05-23",
				7.97
			],
			[
				"2006-02-15",
				5.31
			],
			[
				"2007-03-27",
				4.87
			],
			[
				"2010-11-09",
				4.21
			]
		],
		"94140248": [
			[
				"2013-07-04",
				38.22
			],
			[
				"2014-05-05",
				40.34
			],
			[
				"2015-04-09",
				41.98
			],
			[
				"2006-03-07",
				38.66
			],
			[
				"2006-09-12",
				35.07
			],
			[
				"2007-02-06",
				37.69
			],
			[
				"2008-02-12",
				37.33
			],
			[
				"2009-03-16",
				40.03
			],
			[
				"2010-07-28",
				36.31
			],
			[
				"2011-03-10",
				37.33
			]
		],
		"94140250": [
			[
				"2013-07-03",
				36.54
			],
			[
				"2014-05-05",
				34.85
			],
			[
				"2014-11-20",
				37.24
			],
			[
				"2015-04-09",
				39.06
			],
			[
				"2006-03-07",
				39.99
			],
			[
				"2006-09-20",
				36.45
			],
			[
				"2007-02-06",
				38.84
			],
			[
				"2008-02-12",
				37.6
			],
			[
				"2009-03-16",
				38.26
			],
			[
				"2010-07-29",
				35.3
			],
			[
				"2011-03-10",
				37.86
			]
		],
		"94150023": [
			[
				"2013-06-27",
				39.5
			],
			[
				"2014-05-12",
				31.58
			],
			[
				"2015-09-04",
				42.82
			],
			[
				"2000-08-23",
				52.26
			],
			[
				"2001-09-13",
				46.94
			],
			[
				"2002-10-17",
				47.83
			],
			[
				"2003-11-20",
				59.79
			],
			[
				"2004-11-18",
				44.73
			],
			[
				"2005-12-12",
				48.27
			],
			[
				"2006-06-20",
				39.28
			],
			[
				"2007-02-08",
				46.06
			],
			[
				"2006-12-06",
				41.14
			],
			[
				"2009-03-31",
				51.81
			],
			[
				"2008-05-06",
				43.13
			],
			[
				"2010-08-30",
				86.36
			],
			[
				"2011-03-14",
				42.69
			]
		],
		"94150084": [
			[
				"2013-11-25",
				1.33
			],
			[
				"2015-05-07",
				3.85
			],
			[
				"2007-06-27",
				1.82
			],
			[
				"2007-10-22",
				0.66
			],
			[
				"2008-12-15",
				5.31
			],
			[
				"2008-07-16",
				0.66
			],
			[
				"2009-07-16",
				0.66
			],
			[
				"2010-11-08",
				0.66
			],
			[
				"2011-05-03",
				0.66
			]
		],
		"94150096": [
			[
				"2013-08-20",
				1.33
			],
			[
				"2015-05-07",
				1.33
			],
			[
				"2000-08-22",
				3.1
			],
			[
				"2001-09-18",
				0.89
			],
			[
				"2002-11-04",
				2.21
			],
			[
				"2003-11-26",
				1.33
			],
			[
				"2004-11-25",
				0.89
			],
			[
				"2006-04-24",
				0.66
			],
			[
				"2007-02-19",
				0.66
			],
			[
				"2008-03-10",
				0.75
			],
			[
				"2006-12-07",
				1.28
			],
			[
				"2009-07-15",
				0.66
			],
			[
				"2005-12-19",
				1.59
			],
			[
				"2010-05-10",
				0.66
			],
			[
				"2011-04-28",
				0.66
			]
		],
		"94150175": [
			[
				"2008-10-15",
				7
			],
			[
				"2009-10-21",
				8
			],
			[
				"2000-04-07",
				5
			],
			[
				"2000-10-25",
				4
			],
			[
				"2001-04-11",
				5
			],
			[
				"2001-10-10",
				5
			],
			[
				"2002-04-10",
				5
			],
			[
				"2002-10-21",
				5
			],
			[
				"2003-04-09",
				6
			],
			[
				"2003-10-22",
				6
			],
			[
				"2004-04-06",
				6
			],
			[
				"2004-10-07",
				5
			],
			[
				"2005-04-05",
				5
			],
			[
				"2005-10-31",
				5
			],
			[
				"2006-10-31",
				7
			],
			[
				"2007-10-18",
				7
			],
			[
				"2010-11-10",
				6
			],
			[
				"2011-04-07",
				6
			],
			[
				"2011-10-31",
				6
			],
			[
				"2012-04-17",
				5
			],
			[
				"2012-10-09",
				6
			],
			[
				"2013-04-24",
				6
			],
			[
				"2013-10-29",
				5.7
			],
			[
				"2014-04-15",
				5.1
			],
			[
				"2014-10-28",
				5.7
			],
			[
				"2015-10-27",
				6.3
			],
			[
				"2010-09-28",
				6.69
			],
			[
				"2011-11-21",
				6.33
			]
		],
		"94150242": [
			[
				"2008-04-21",
				1
			],
			[
				"2008-10-13",
				1
			],
			[
				"2009-04-14",
				1
			],
			[
				"2009-10-12",
				1
			],
			[
				"2015-12-14",
				1.33
			],
			[
				"2000-04-20",
				1
			],
			[
				"2001-04-27",
				1
			],
			[
				"2002-04-29",
				1
			],
			[
				"2003-04-28",
				1
			],
			[
				"2004-04-29",
				1
			],
			[
				"2004-10-29",
				1
			],
			[
				"2005-04-20",
				1
			],
			[
				"2006-04-18",
				1
			],
			[
				"2006-10-09",
				1
			],
			[
				"2007-04-16",
				1
			],
			[
				"2007-10-08",
				1
			],
			[
				"2010-04-19",
				1
			],
			[
				"2010-10-11",
				1
			],
			[
				"2011-04-11",
				1
			],
			[
				"2011-10-05",
				1
			],
			[
				"2012-04-10",
				1
			],
			[
				"2012-10-15",
				1
			],
			[
				"2013-04-02",
				1
			],
			[
				"2013-10-28",
				1
			],
			[
				"2014-04-14",
				1
			],
			[
				"2014-10-06",
				1
			],
			[
				"2015-04-13",
				1
			],
			[
				"2015-10-19",
				1
			],
			[
				"2011-12-15",
				0.66
			]
		],
		"94150448": [
			[
				"2008-12-16",
				23.01
			],
			[
				"2009-12-28",
				21.01
			],
			[
				"2015-12-15",
				17.4
			],
			[
				"2001-09-26",
				20.01
			],
			[
				"2007-12-18",
				20.01
			],
			[
				"2011-02-15",
				18.01
			],
			[
				"2011-12-22",
				27.01
			],
			[
				"2013-01-08",
				19.01
			],
			[
				"2015-12-22",
				16.01
			],
			[
				"2010-11-08",
				23.69
			],
			[
				"2011-12-12",
				11.34
			]
		],
		"94150450": [
			[
				"2014-05-13",
				6.6
			],
			[
				"2013-07-18",
				3.14
			],
			[
				"2015-09-04",
				4.78
			],
			[
				"2006-05-08",
				4.07
			],
			[
				"2007-07-03",
				15.77
			],
			[
				"2007-10-17",
				7.17
			],
			[
				"2008-07-09",
				10.19
			],
			[
				"2009-07-16",
				5.27
			],
			[
				"2010-11-25",
				8.95
			],
			[
				"2011-04-27",
				7.62
			]
		],
		"94150461": [
			[
				"2013-07-18",
				3.06
			],
			[
				"2014-10-01",
				2.04
			],
			[
				"2015-12-14",
				5.62
			],
			[
				"2006-09-21",
				4.25
			],
			[
				"2007-07-25",
				3.68
			],
			[
				"2007-10-30",
				8.68
			],
			[
				"2008-07-09",
				1.15
			],
			[
				"2009-07-29",
				2.21
			],
			[
				"2010-06-08",
				3.1
			],
			[
				"2011-04-27",
				6.91
			]
		],
		"94160041": [
			[
				"2008-05-20",
				39.01
			],
			[
				"2008-06-03",
				37.01
			],
			[
				"2008-06-16",
				37.01
			],
			[
				"2008-04-23",
				46.02
			],
			[
				"2008-05-05",
				38.01
			],
			[
				"2008-07-03",
				34.01
			],
			[
				"2008-07-31",
				36.01
			],
			[
				"2008-08-14",
				39.01
			],
			[
				"2008-07-15",
				35.01
			],
			[
				"2008-10-01",
				38.01
			],
			[
				"2009-04-06",
				41.01
			],
			[
				"2009-11-16",
				55.02
			],
			[
				"2010-03-30",
				56.02
			],
			[
				"2014-10-08",
				41.58
			],
			[
				"2015-10-28",
				42.96
			],
			[
				"2000-04-11",
				38.01
			],
			[
				"2000-10-10",
				36.01
			],
			[
				"2001-04-23",
				38.01
			],
			[
				"2001-10-18",
				39.01
			],
			[
				"2002-04-30",
				41.01
			],
			[
				"2002-10-22",
				37.01
			],
			[
				"2003-04-08",
				39.01
			],
			[
				"2003-10-24",
				46.02
			],
			[
				"2004-04-02",
				43.02
			],
			[
				"2004-10-12",
				45.02
			],
			[
				"2005-04-05",
				55.02
			],
			[
				"2005-10-13",
				42.01
			],
			[
				"2006-04-11",
				40.01
			],
			[
				"2006-10-04",
				37.01
			],
			[
				"2007-04-11",
				39.01
			],
			[
				"2007-09-17",
				40.01
			],
			[
				"2007-09-24",
				38.01
			],
			[
				"2007-10-01",
				58.02
			],
			[
				"2007-10-10",
				41.01
			],
			[
				"2007-10-16",
				41.01
			],
			[
				"2007-10-30",
				39.01
			],
			[
				"2007-10-24",
				33.01
			],
			[
				"2007-11-07",
				44.02
			],
			[
				"2007-11-12",
				64.02
			],
			[
				"2007-11-21",
				50.02
			],
			[
				"2007-11-06",
				42.01
			],
			[
				"2007-12-19",
				48.02
			],
			[
				"2007-11-27",
				41.01
			],
			[
				"2007-12-05",
				46.02
			],
			[
				"2007-12-10",
				52.02
			],
			[
				"2008-01-16",
				41.01
			],
			[
				"2008-02-14",
				45.02
			],
			[
				"2008-01-30",
				48.02
			],
			[
				"2008-03-12",
				40.01
			],
			[
				"2010-10-12",
				46.02
			],
			[
				"2011-04-07",
				38.01
			],
			[
				"2011-10-10",
				43.02
			],
			[
				"2012-10-01",
				39.01
			],
			[
				"2012-04-16",
				39.01
			],
			[
				"2013-04-11",
				45.02
			],
			[
				"2013-10-17",
				52.02
			],
			[
				"2014-04-02",
				40.01
			],
			[
				"2014-10-08",
				41.01
			],
			[
				"2015-10-05",
				39.01
			],
			[
				"2009-05-25",
				36.45
			],
			[
				"2010-08-30",
				68.2
			],
			[
				"2011-08-03",
				35.87
			]
		],
		"94160077": [
			[
				"2013-06-27",
				36.54
			],
			[
				"2014-10-08",
				46.94
			],
			[
				"2015-05-26",
				30.47
			],
			[
				"2000-08-22",
				36.31
			],
			[
				"2001-09-13",
				33.66
			],
			[
				"2002-10-17",
				45.61
			],
			[
				"2003-11-20",
				54.03
			],
			[
				"2004-11-29",
				52.26
			],
			[
				"2005-12-13",
				44.73
			],
			[
				"2006-03-27",
				42.56
			],
			[
				"2007-02-08",
				46.5
			],
			[
				"2007-07-25",
				40.88
			],
			[
				"2008-03-10",
				45.61
			],
			[
				"2009-03-16",
				49.16
			],
			[
				"2010-05-10",
				43.53
			],
			[
				"2011-04-27",
				36.85
			]
		],
		"94160089": [
			[
				"2008-06-17",
				41.01
			],
			[
				"2009-05-27",
				39.01
			],
			[
				"2013-12-05",
				39.41
			],
			[
				"2014-11-20",
				37.64
			],
			[
				"2015-05-05",
				38.35
			],
			[
				"2016-03-07",
				36.76
			],
			[
				"2000-06-07",
				45.02
			],
			[
				"2001-07-06",
				44.02
			],
			[
				"2002-06-06",
				43.02
			],
			[
				"2003-08-20",
				40.01
			],
			[
				"2004-05-26",
				43.02
			],
			[
				"2005-05-18",
				40.01
			],
			[
				"2006-06-26",
				41.01
			],
			[
				"2007-07-16",
				38.01
			],
			[
				"2010-06-30",
				42.01
			],
			[
				"2011-07-26",
				38.01
			],
			[
				"2012-05-22",
				40.01
			],
			[
				"2013-06-18",
				43.02
			],
			[
				"2014-04-04",
				38.01
			],
			[
				"2009-10-21",
				38.26
			],
			[
				"2010-06-29",
				38.53
			]
		],
		"94160090": [
			[
				"2008-04-07",
				16.01
			],
			[
				"2008-05-14",
				16.01
			],
			[
				"2008-06-04",
				16.01
			],
			[
				"2008-09-08",
				16.01
			],
			[
				"2008-07-09",
				16.01
			],
			[
				"2008-08-04",
				16.01
			],
			[
				"2008-10-06",
				16.01
			],
			[
				"2008-12-10",
				16.01
			],
			[
				"2008-11-11",
				16.01
			],
			[
				"2009-03-10",
				18.01
			],
			[
				"2009-02-04",
				17.01
			],
			[
				"2009-01-07",
				16.01
			],
			[
				"2009-06-04",
				17.01
			],
			[
				"2009-04-07",
				16.01
			],
			[
				"2009-05-06",
				16.01
			],
			[
				"2009-09-03",
				17.01
			],
			[
				"2009-07-14",
				17.01
			],
			[
				"2009-08-04",
				17.01
			],
			[
				"2009-12-02",
				17.01
			],
			[
				"2009-10-06",
				17.01
			],
			[
				"2009-11-03",
				17.01
			],
			[
				"2010-02-15",
				17.01
			],
			[
				"2010-03-04",
				18.01
			],
			[
				"2010-01-05",
				17.01
			],
			[
				"2014-11-20",
				17.63
			],
			[
				"2015-05-05",
				17.32
			],
			[
				"2000-01-24",
				15.01
			],
			[
				"2000-02-03",
				15.01
			],
			[
				"2000-03-08",
				15.01
			],
			[
				"2000-04-18",
				15.01
			],
			[
				"2000-05-23",
				15.01
			],
			[
				"2000-06-13",
				15.01
			],
			[
				"2000-07-24",
				15.01
			],
			[
				"2000-08-10",
				15.01
			],
			[
				"2000-09-18",
				15.01
			],
			[
				"2000-10-23",
				14
			],
			[
				"2000-11-09",
				15.01
			],
			[
				"2000-12-11",
				16.01
			],
			[
				"2001-01-22",
				16.01
			],
			[
				"2001-02-15",
				16.01
			],
			[
				"2001-03-12",
				16.01
			],
			[
				"2001-04-25",
				15.01
			],
			[
				"2001-05-17",
				15.01
			],
			[
				"2001-06-26",
				15.01
			],
			[
				"2001-07-19",
				15.01
			],
			[
				"2001-08-14",
				15.01
			],
			[
				"2001-09-10",
				15.01
			],
			[
				"2001-10-12",
				16.01
			],
			[
				"2001-11-12",
				16.01
			],
			[
				"2001-12-12",
				16.01
			],
			[
				"2002-01-08",
				15.01
			],
			[
				"2002-02-12",
				14
			],
			[
				"2002-03-12",
				16.01
			],
			[
				"2002-04-09",
				15.01
			],
			[
				"2002-05-06",
				15.01
			],
			[
				"2002-06-11",
				15.01
			],
			[
				"2002-07-11",
				15.01
			],
			[
				"2002-08-09",
				16.01
			],
			[
				"2002-09-12",
				15.01
			],
			[
				"2002-11-22",
				15.01
			],
			[
				"2002-10-29",
				15.01
			],
			[
				"2002-12-06",
				16.01
			],
			[
				"2003-02-27",
				15.01
			],
			[
				"2003-03-25",
				15.01
			],
			[
				"2003-06-30",
				17.01
			],
			[
				"2003-04-29",
				17.01
			],
			[
				"2003-05-19",
				15.01
			],
			[
				"2003-07-29",
				16.01
			],
			[
				"2003-08-18",
				16.01
			],
			[
				"2003-09-29",
				16.01
			],
			[
				"2003-10-22",
				16.01
			],
			[
				"2003-11-11",
				17.01
			],
			[
				"2003-12-10",
				16.01
			],
			[
				"2004-01-06",
				16.01
			],
			[
				"2004-02-09",
				17.01
			],
			[
				"2004-03-09",
				16.01
			],
			[
				"2004-04-05",
				16.01
			],
			[
				"2004-05-05",
				16.01
			],
			[
				"2004-06-02",
				16.01
			],
			[
				"2004-07-05",
				17.01
			],
			[
				"2004-08-02",
				17.01
			],
			[
				"2004-09-06",
				16.01
			],
			[
				"2004-10-07",
				16.01
			],
			[
				"2004-11-16",
				17.01
			],
			[
				"2004-12-14",
				17.01
			],
			[
				"2005-01-05",
				17.01
			],
			[
				"2005-02-14",
				16.01
			],
			[
				"2005-03-09",
				18.01
			],
			[
				"2005-04-06",
				19.01
			],
			[
				"2005-05-04",
				19.01
			],
			[
				"2005-06-14",
				18.01
			],
			[
				"2005-07-05",
				21.01
			],
			[
				"2005-08-02",
				16.01
			],
			[
				"2005-09-06",
				18.01
			],
			[
				"2005-11-09",
				16.01
			],
			[
				"2005-10-11",
				19.01
			],
			[
				"2005-12-06",
				16.01
			],
			[
				"2006-01-04",
				17.01
			],
			[
				"2006-02-07",
				17.01
			],
			[
				"2006-03-14",
				16.01
			],
			[
				"2006-04-04",
				15.01
			],
			[
				"2006-05-04",
				17.01
			],
			[
				"2006-06-06",
				16.01
			],
			[
				"2006-09-12",
				16.01
			],
			[
				"2006-07-04",
				16.01
			],
			[
				"2006-08-09",
				16.01
			],
			[
				"2006-10-09",
				16.01
			],
			[
				"2006-11-08",
				16.01
			],
			[
				"2006-12-05",
				17.01
			],
			[
				"2007-03-07",
				17.01
			],
			[
				"2007-02-06",
				17.01
			],
			[
				"2007-01-04",
				17.01
			],
			[
				"2007-06-05",
				17.01
			],
			[
				"2007-05-03",
				16.01
			],
			[
				"2007-04-12",
				16.01
			],
			[
				"2007-08-02",
				17.01
			],
			[
				"2007-08-24",
				17.01
			],
			[
				"2007-07-03",
				17.01
			],
			[
				"2007-11-08",
				16.01
			],
			[
				"2007-10-02",
				16.01
			],
			[
				"2007-12-10",
				17.01
			],
			[
				"2008-03-05",
				17.01
			],
			[
				"2008-01-07",
				18.01
			],
			[
				"2008-02-06",
				16.01
			],
			[
				"2010-04-06",
				17.01
			],
			[
				"2010-05-10",
				17.01
			],
			[
				"2010-06-07",
				17.01
			],
			[
				"2010-09-06",
				17.01
			],
			[
				"2010-07-07",
				16.01
			],
			[
				"2010-08-02",
				17.01
			],
			[
				"2010-10-06",
				16.01
			],
			[
				"2010-12-06",
				17.01
			],
			[
				"2011-02-14",
				17.01
			],
			[
				"2011-03-03",
				17.01
			],
			[
				"2011-04-04",
				18.01
			],
			[
				"2011-06-20",
				17.01
			],
			[
				"2011-05-02",
				16.01
			],
			[
				"2011-09-22",
				16.01
			],
			[
				"2011-07-21",
				16.01
			],
			[
				"2011-08-29",
				16.01
			],
			[
				"2011-11-21",
				16.01
			],
			[
				"2011-11-28",
				16.01
			],
			[
				"2011-12-14",
				16.01
			],
			[
				"2011-10-20",
				16.01
			],
			[
				"2011-11-15",
				16.01
			],
			[
				"2012-01-18",
				17.01
			],
			[
				"2012-02-07",
				18.01
			],
			[
				"2012-03-06",
				17.01
			],
			[
				"2012-04-12",
				17.01
			],
			[
				"2012-05-07",
				17.01
			],
			[
				"2012-06-14",
				17.01
			],
			[
				"2012-07-04",
				18.01
			],
			[
				"2012-08-07",
				16.01
			],
			[
				"2012-09-11",
				16.01
			],
			[
				"2012-10-04",
				16.01
			],
			[
				"2013-02-11",
				18.01
			],
			[
				"2012-11-07",
				16.01
			],
			[
				"2013-03-06",
				18.01
			],
			[
				"2013-01-08",
				17.01
			],
			[
				"2012-12-10",
				16.01
			],
			[
				"2013-06-13",
				18.01
			],
			[
				"2013-07-16",
				19.01
			],
			[
				"2013-08-19",
				18.01
			],
			[
				"2013-05-15",
				18.01
			],
			[
				"2013-09-12",
				17.01
			],
			[
				"2013-10-16",
				13
			],
			[
				"2013-11-25",
				17.01
			],
			[
				"2013-12-16",
				17.01
			],
			[
				"2014-01-21",
				18.01
			],
			[
				"2014-02-19",
				18.01
			],
			[
				"2014-03-17",
				17.01
			],
			[
				"2014-04-14",
				17.01
			],
			[
				"2014-05-12",
				17.01
			],
			[
				"2014-06-11",
				16.01
			],
			[
				"2014-09-10",
				17.01
			],
			[
				"2014-07-09",
				16.01
			],
			[
				"2014-08-19",
				17.01
			],
			[
				"2015-01-14",
				18.01
			],
			[
				"2014-10-20",
				17.01
			],
			[
				"2014-11-19",
				18.01
			],
			[
				"2015-07-15",
				17.01
			],
			[
				"2015-08-13",
				17.01
			],
			[
				"2015-09-08",
				17.01
			],
			[
				"2015-10-07",
				16.01
			],
			[
				"2015-11-17",
				16.01
			],
			[
				"2015-12-09",
				16.01
			],
			[
				"2009-07-28",
				16.65
			],
			[
				"2010-06-29",
				16.83
			],
			[
				"2011-12-08",
				15.23
			]
		],
		"94160107": [
			[
				"2008-09-22",
				16.01
			],
			[
				"2009-09-15",
				17.01
			],
			[
				"2014-11-24",
				16.43
			],
			[
				"2015-04-29",
				14.7
			],
			[
				"2000-03-08",
				19.01
			],
			[
				"2000-06-13",
				16.01
			],
			[
				"2000-09-29",
				15.01
			],
			[
				"2000-12-11",
				16.01
			],
			[
				"2001-03-12",
				16.01
			],
			[
				"2001-06-26",
				16.01
			],
			[
				"2001-09-10",
				15.01
			],
			[
				"2001-12-12",
				17.01
			],
			[
				"2002-03-12",
				19.01
			],
			[
				"2002-06-11",
				16.01
			],
			[
				"2002-09-12",
				16.01
			],
			[
				"2002-12-06",
				17.01
			],
			[
				"2003-09-17",
				16.01
			],
			[
				"2004-08-18",
				17.01
			],
			[
				"2005-09-21",
				18.01
			],
			[
				"2006-09-13",
				16.01
			],
			[
				"2007-09-18",
				17.01
			],
			[
				"2010-09-07",
				16.01
			],
			[
				"2011-09-26",
				16.01
			],
			[
				"2012-08-14",
				16.01
			],
			[
				"2012-09-12",
				16.01
			],
			[
				"2012-10-02",
				16.01
			],
			[
				"2013-03-19",
				17.01
			],
			[
				"2012-11-13",
				17.01
			],
			[
				"2013-01-28",
				17.01
			],
			[
				"2013-02-19",
				17.01
			],
			[
				"2012-12-07",
				16.01
			],
			[
				"2013-04-17",
				17.01
			],
			[
				"2013-05-14",
				17.01
			],
			[
				"2013-06-12",
				17.01
			],
			[
				"2013-07-09",
				16.01
			],
			[
				"2013-08-20",
				16.01
			],
			[
				"2013-09-18",
				16.01
			],
			[
				"2013-10-21",
				16.01
			],
			[
				"2013-12-12",
				16.01
			],
			[
				"2014-01-23",
				17.01
			],
			[
				"2014-02-20",
				16.01
			],
			[
				"2014-03-10",
				16.01
			],
			[
				"2014-04-17",
				16.01
			],
			[
				"2014-05-14",
				16.01
			],
			[
				"2014-06-24",
				16.01
			],
			[
				"2014-08-28",
				16.01
			],
			[
				"2014-09-18",
				16.01
			],
			[
				"2014-07-24",
				16.01
			],
			[
				"2015-01-22",
				17.01
			],
			[
				"2014-10-16",
				16.01
			],
			[
				"2014-11-14",
				16.01
			],
			[
				"2015-07-23",
				17.01
			],
			[
				"2015-08-20",
				17.01
			],
			[
				"2015-09-24",
				16.01
			],
			[
				"2015-10-29",
				16.01
			],
			[
				"2015-11-19",
				16.01
			],
			[
				"2015-12-17",
				16.01
			],
			[
				"2008-07-21",
				16.34
			],
			[
				"2009-07-16",
				16.12
			],
			[
				"2010-09-01",
				10.41
			],
			[
				"2011-05-18",
				16.21
			]
		],
		"94160170": [
			[
				"2008-09-22",
				33.01
			],
			[
				"2009-09-15",
				32.01
			],
			[
				"2013-10-01",
				34.59
			],
			[
				"2014-11-24",
				36.89
			],
			[
				"2015-09-23",
				33.61
			],
			[
				"2000-02-03",
				28.01
			],
			[
				"2000-08-10",
				28.01
			],
			[
				"2001-02-15",
				38.01
			],
			[
				"2001-08-14",
				28.01
			],
			[
				"2002-02-12",
				39.01
			],
			[
				"2002-08-09",
				40.01
			],
			[
				"2003-09-17",
				33.01
			],
			[
				"2007-09-18",
				38.01
			],
			[
				"2010-06-29",
				31.01
			],
			[
				"2010-09-07",
				32.01
			],
			[
				"2011-03-02",
				34.01
			],
			[
				"2011-09-26",
				32.01
			],
			[
				"2011-12-22",
				37.01
			],
			[
				"2013-03-19",
				39.01
			],
			[
				"2013-09-18",
				34.01
			],
			[
				"2014-03-10",
				35.01
			],
			[
				"2014-09-18",
				35.01
			],
			[
				"2015-09-24",
				34.01
			],
			[
				"2010-09-01",
				30.38
			],
			[
				"2011-05-18",
				32.28
			]
		],
		"94160193": [
			[
				"2008-06-17",
				39.01
			],
			[
				"2009-05-27",
				41.01
			],
			[
				"2014-11-20",
				42.51
			],
			[
				"2015-04-23",
				44.29
			],
			[
				"2000-06-07",
				32.01
			],
			[
				"2001-07-06",
				30.01
			],
			[
				"2002-06-06",
				29.01
			],
			[
				"2003-08-20",
				32.01
			],
			[
				"2004-05-26",
				35.01
			],
			[
				"2005-05-18",
				36.01
			],
			[
				"2006-06-26",
				37.01
			],
			[
				"2007-07-16",
				34.01
			],
			[
				"2010-06-30",
				45.02
			],
			[
				"2011-07-26",
				42.01
			],
			[
				"2012-05-22",
				44.02
			],
			[
				"2013-06-18",
				48.02
			],
			[
				"2014-04-04",
				44.02
			]
		],
		"94160314": [
			[
				"2013-12-05",
				48.27
			],
			[
				"2014-05-05",
				41.23
			],
			[
				"2015-09-04",
				54.91
			],
			[
				"2006-03-30",
				38.17
			],
			[
				"2006-09-11",
				34.72
			],
			[
				"2007-02-19",
				45.17
			],
			[
				"2008-02-12",
				43.89
			],
			[
				"2009-03-16",
				48.71
			],
			[
				"2010-04-20",
				42.78
			],
			[
				"2011-03-14",
				43.31
			]
		],
		"94160466": [
			[
				"2008-09-18",
				7
			],
			[
				"2009-09-17",
				8
			],
			[
				"2013-11-18",
				9.7
			],
			[
				"2014-11-27",
				9.57
			],
			[
				"2015-09-21",
				3.68
			],
			[
				"2004-09-09",
				6
			],
			[
				"2005-09-19",
				7
			],
			[
				"2006-09-21",
				7
			],
			[
				"2007-09-27",
				9
			],
			[
				"2010-09-27",
				9
			],
			[
				"2011-09-16",
				12
			],
			[
				"2012-09-26",
				9
			],
			[
				"2013-05-28",
				10
			],
			[
				"2014-05-20",
				8.9
			],
			[
				"2010-09-15",
				8.77
			],
			[
				"2011-11-16",
				8.72
			]
		],
		"94160594": [
			[
				"2015-12-15",
				8.68
			],
			[
				"2003-10-22",
				8
			],
			[
				"2003-10-21",
				8
			],
			[
				"2003-04-09",
				8
			],
			[
				"2010-09-28",
				7.62
			],
			[
				"2011-11-21",
				7.09
			]
		],
		"94160661": [
			[
				"2014-12-01",
				8.81
			],
			[
				"2015-05-06",
				9.08
			],
			[
				"2002-04-09",
				7
			],
			[
				"2010-09-28",
				9.92
			],
			[
				"2011-11-21",
				9.21
			]
		],
		"94170083": [
			[
				"2014-04-29",
				2.35
			],
			[
				"2014-11-20",
				12.93
			],
			[
				"2015-04-23",
				17.94
			],
			[
				"2006-03-09",
				17.63
			],
			[
				"2006-09-19",
				12.8
			],
			[
				"2007-02-13",
				18.78
			],
			[
				"2008-03-04",
				19.49
			],
			[
				"2009-03-31",
				19
			],
			[
				"2010-06-30",
				12.36
			]
		],
		"94170101": [
			[
				"2008-11-04",
				22.01
			],
			[
				"2009-10-06",
				20.01
			],
			[
				"2009-11-17",
				21.01
			],
			[
				"2013-12-04",
				19.22
			],
			[
				"2014-11-20",
				18.02
			],
			[
				"2015-04-10",
				19
			],
			[
				"2000-05-25",
				19.01
			],
			[
				"2000-11-28",
				19.49
			],
			[
				"2001-05-03",
				17.01
			],
			[
				"2001-10-18",
				19.04
			],
			[
				"2002-05-07",
				19.01
			],
			[
				"2002-06-24",
				19.04
			],
			[
				"2002-11-04",
				18.6
			],
			[
				"2003-11-24",
				19.93
			],
			[
				"2003-05-05",
				18.01
			],
			[
				"2004-09-21",
				11.07
			],
			[
				"2004-05-11",
				21.01
			],
			[
				"2005-05-09",
				24.01
			],
			[
				"2005-06-15",
				20.15
			],
			[
				"2005-11-10",
				19.84
			],
			[
				"2006-04-24",
				20.59
			],
			[
				"2006-11-29",
				21.01
			],
			[
				"2006-12-07",
				20.64
			],
			[
				"2007-11-14",
				20.01
			],
			[
				"2010-10-04",
				21.01
			],
			[
				"2010-11-02",
				20.01
			],
			[
				"2011-11-09",
				21.01
			],
			[
				"2012-10-18",
				20.01
			],
			[
				"2012-11-08",
				20.01
			],
			[
				"2013-11-13",
				21.01
			],
			[
				"2014-05-08",
				18.01
			],
			[
				"2015-10-07",
				20.01
			],
			[
				"2015-11-04",
				21.01
			],
			[
				"2009-10-07",
				19.97
			],
			[
				"2010-06-07",
				19.35
			],
			[
				"2011-05-17",
				19.44
			]
		],
		"94170253": [
			[
				"2010-03-24",
				17.01
			],
			[
				"2014-11-24",
				7.4
			],
			[
				"2015-04-28",
				7.79
			],
			[
				"2000-03-07",
				10
			],
			[
				"2001-03-05",
				9
			],
			[
				"2002-03-04",
				10
			],
			[
				"2003-03-27",
				8
			],
			[
				"2004-03-25",
				8
			],
			[
				"2005-03-23",
				6
			],
			[
				"2006-04-06",
				11
			],
			[
				"2007-03-28",
				11
			],
			[
				"2008-03-19",
				16.01
			]
		],
		"94170319": [
			[
				"2008-10-09",
				17.01
			],
			[
				"2009-10-06",
				16.01
			],
			[
				"2013-12-04",
				8.77
			],
			[
				"2014-11-20",
				8.64
			],
			[
				"2015-04-10",
				8.46
			],
			[
				"2000-10-10",
				10
			],
			[
				"2001-10-15",
				9
			],
			[
				"2002-10-17",
				9
			],
			[
				"2003-10-06",
				9
			],
			[
				"2004-10-18",
				10
			],
			[
				"2005-11-24",
				11
			],
			[
				"2006-11-29",
				13
			],
			[
				"2007-11-14",
				16.01
			],
			[
				"2010-10-04",
				14
			],
			[
				"2011-04-08",
				14
			],
			[
				"2011-10-06",
				11
			],
			[
				"2012-10-18",
				10
			],
			[
				"2013-10-02",
				9.3
			],
			[
				"2014-10-16",
				8.6
			],
			[
				"2015-10-07",
				9
			],
			[
				"2010-09-15",
				13.64
			],
			[
				"2011-09-22",
				11.16
			]
		],
		"94170320": [
			[
				"2008-11-04",
				16.01
			],
			[
				"2009-11-17",
				16.01
			],
			[
				"2009-10-06",
				15.01
			],
			[
				"2015-04-10",
				15.37
			],
			[
				"2000-05-25",
				21.01
			],
			[
				"2001-05-03",
				16.01
			],
			[
				"2002-05-07",
				16.01
			],
			[
				"2003-05-05",
				17.01
			],
			[
				"2004-05-11",
				19.01
			],
			[
				"2005-05-09",
				20.01
			],
			[
				"2006-11-29",
				20.01
			],
			[
				"2007-11-14",
				13
			],
			[
				"2008-02-05",
				16.01
			],
			[
				"2010-10-04",
				17.01
			],
			[
				"2010-11-02",
				19.01
			],
			[
				"2011-11-09",
				18.01
			],
			[
				"2012-10-18",
				16.01
			],
			[
				"2013-10-02",
				16.01
			],
			[
				"2014-10-16",
				13
			],
			[
				"2015-10-07",
				14
			],
			[
				"2009-10-07",
				15.59
			],
			[
				"2010-06-07",
				17.58
			],
			[
				"2011-05-17",
				16.92
			]
		],
		"94170332": [
			[
				"2008-05-27",
				21.01
			],
			[
				"2008-11-04",
				24.01
			],
			[
				"2009-05-05",
				22.01
			],
			[
				"2009-07-15",
				23.01
			],
			[
				"2009-11-17",
				27.01
			],
			[
				"2010-02-08",
				25.01
			],
			[
				"2000-05-25",
				21.01
			],
			[
				"2000-10-10",
				23.01
			],
			[
				"2001-05-03",
				23.01
			],
			[
				"2001-10-15",
				23.01
			],
			[
				"2002-05-07",
				22.01
			],
			[
				"2002-10-17",
				20.01
			],
			[
				"2003-05-05",
				18.01
			],
			[
				"2003-10-06",
				23.01
			],
			[
				"2004-05-11",
				23.01
			],
			[
				"2004-10-18",
				25.01
			],
			[
				"2005-05-09",
				24.01
			],
			[
				"2005-11-24",
				22.01
			],
			[
				"2006-05-02",
				24.01
			],
			[
				"2007-05-23",
				22.01
			],
			[
				"2007-11-15",
				24.01
			],
			[
				"2010-05-04",
				25.01
			],
			[
				"2010-11-02",
				24.01
			],
			[
				"2011-05-06",
				24.01
			],
			[
				"2011-10-28",
				27.01
			],
			[
				"2012-05-24",
				24.01
			],
			[
				"2012-11-08",
				25.01
			],
			[
				"2013-05-21",
				28.01
			],
			[
				"2013-11-13",
				25.01
			],
			[
				"2014-05-08",
				24.01
			],
			[
				"2014-11-11",
				26.01
			],
			[
				"2015-05-07",
				24.01
			],
			[
				"2015-11-04",
				25.01
			],
			[
				"2010-06-07",
				24.31
			],
			[
				"2011-03-30",
				23.07
			]
		],
		"94170344": [
			[
				"2013-08-13",
				8.33
			],
			[
				"2015-04-28",
				8.41
			],
			[
				"2006-05-23",
				5.93
			],
			[
				"2006-09-05",
				3.9
			],
			[
				"2007-03-14",
				3.63
			],
			[
				"2008-03-11",
				9.26
			],
			[
				"2009-09-03",
				9.08
			],
			[
				"2010-04-26",
				4.07
			],
			[
				"2011-03-17",
				11.6
			]
		],
		"94170356": [
			[
				"2013-08-13",
				4.38
			],
			[
				"2015-09-24",
				4.47
			],
			[
				"2006-05-23",
				4.52
			],
			[
				"2007-03-14",
				3.94
			],
			[
				"2007-08-20",
				4.07
			],
			[
				"2008-03-11",
				3.68
			],
			[
				"2009-09-03",
				4.16
			],
			[
				"2010-04-26",
				4.07
			]
		],
		"94170368": [
			[
				"2014-11-27",
				1.86
			],
			[
				"2015-09-21",
				1.77
			],
			[
				"2003-06-16",
				3.3
			],
			[
				"2004-05-26",
				3.9
			],
			[
				"2002-05-27",
				2.8
			],
			[
				"2001-05-16",
				3.7
			],
			[
				"2000-05-30",
				3
			],
			[
				"2005-06-27",
				4.8
			],
			[
				"2006-05-16",
				3
			]
		],
		"94170435": [
			[
				"2013-06-27",
				5.27
			],
			[
				"2014-11-20",
				12.27
			],
			[
				"2015-04-10",
				16.08
			],
			[
				"2006-05-31",
				14.04
			],
			[
				"2006-09-19",
				6.02
			],
			[
				"2007-02-14",
				13.06
			],
			[
				"2008-07-21",
				6.02
			],
			[
				"2009-09-17",
				7.93
			],
			[
				"2010-04-19",
				9.92
			],
			[
				"2011-04-27",
				8.28
			]
		],
		"94170459": [
			[
				"2013-07-03",
				36.31
			],
			[
				"2014-05-05",
				31.62
			],
			[
				"2014-10-08",
				41.58
			],
			[
				"2015-04-15",
				42.51
			],
			[
				"2006-12-11",
				37.82
			],
			[
				"2007-02-08",
				43.13
			],
			[
				"2007-08-20",
				43.93
			],
			[
				"2008-02-18",
				41.1
			],
			[
				"2008-11-12",
				36.18
			],
			[
				"2009-03-31",
				41.27
			],
			[
				"2010-04-20",
				40.83
			],
			[
				"2011-03-16",
				35.38
			]
		],
		"94180027": [
			[
				"2008-04-17",
				28.01
			],
			[
				"2008-10-16",
				27.01
			],
			[
				"2009-10-09",
				28.01
			],
			[
				"2014-11-27",
				26.97
			],
			[
				"2015-04-14",
				24.53
			],
			[
				"2000-04-14",
				26.01
			],
			[
				"2000-10-26",
				29.01
			],
			[
				"2000-12-14",
				30.01
			],
			[
				"2001-04-23",
				29.01
			],
			[
				"2001-09-11",
				29.01
			],
			[
				"2002-04-16",
				25.01
			],
			[
				"2002-10-01",
				28.01
			],
			[
				"2003-04-03",
				25.01
			],
			[
				"2003-10-07",
				27.01
			],
			[
				"2004-05-10",
				28.01
			],
			[
				"2004-10-19",
				30.01
			],
			[
				"2005-04-18",
				32.01
			],
			[
				"2005-10-17",
				29.01
			],
			[
				"2006-04-06",
				28.01
			],
			[
				"2006-10-19",
				28.01
			],
			[
				"2007-04-18",
				27.01
			],
			[
				"2007-10-16",
				28.01
			],
			[
				"2010-04-20",
				27.01
			],
			[
				"2010-10-18",
				27.01
			],
			[
				"2012-12-12",
				27.01
			],
			[
				"2012-12-14",
				26.01
			],
			[
				"2013-04-17",
				28.01
			],
			[
				"2013-10-16",
				27.01
			],
			[
				"2010-04-14",
				25.91
			],
			[
				"2011-12-06",
				27.1
			]
		],
		"94180052": [
			[
				"2014-12-01",
				16.3
			],
			[
				"2015-05-06",
				5.89
			],
			[
				"2002-11-07",
				9
			],
			[
				"2003-11-13",
				7
			],
			[
				"2010-11-10",
				6.16
			]
		],
		"94180106": [
			[
				"2008-11-11",
				26.01
			],
			[
				"2010-03-09",
				28.01
			],
			[
				"2013-12-02",
				10.32
			],
			[
				"2014-11-27",
				14.08
			],
			[
				"2015-04-14",
				15.9
			],
			[
				"2000-05-26",
				21.01
			],
			[
				"2001-05-15",
				20.01
			],
			[
				"2002-05-08",
				17.01
			],
			[
				"2003-05-06",
				20.01
			],
			[
				"2004-05-10",
				22.01
			],
			[
				"2005-05-10",
				30.01
			],
			[
				"2006-05-03",
				22.01
			],
			[
				"2007-05-24",
				17.01
			],
			[
				"2011-04-20",
				19.01
			],
			[
				"2012-12-14",
				9
			],
			[
				"2012-11-22",
				9
			],
			[
				"2013-05-14",
				16.01
			],
			[
				"2009-09-07",
				13.37
			],
			[
				"2010-04-14",
				26.35
			],
			[
				"2011-05-25",
				16.92
			]
		],
		"94180118": [
			[
				"2008-04-08",
				22.01
			],
			[
				"2013-12-04",
				21.39
			],
			[
				"2014-11-20",
				21.12
			],
			[
				"2000-10-10",
				21.01
			],
			[
				"2001-10-15",
				20.01
			],
			[
				"2002-10-17",
				21.01
			],
			[
				"2003-10-07",
				22.01
			],
			[
				"2004-10-19",
				23.01
			],
			[
				"2005-11-24",
				21.01
			],
			[
				"2006-11-29",
				21.01
			],
			[
				"2007-10-02",
				21.01
			],
			[
				"2010-04-08",
				23.01
			],
			[
				"2011-04-08",
				22.01
			],
			[
				"2012-04-13",
				22.01
			],
			[
				"2013-10-02",
				22.01
			],
			[
				"2014-09-02",
				21.01
			],
			[
				"2015-10-07",
				21.01
			],
			[
				"2010-04-19",
				22.1
			],
			[
				"2011-09-22",
				21.52
			]
		],
		"94180120": [
			[
				"2008-09-05",
				27.01
			],
			[
				"2009-10-09",
				26.01
			],
			[
				"2013-06-27",
				23.29
			],
			[
				"2014-11-27",
				27.01
			],
			[
				"2015-04-14",
				25.82
			],
			[
				"2000-09-19",
				29.01
			],
			[
				"2001-09-11",
				27.01
			],
			[
				"2002-08-14",
				27.01
			],
			[
				"2003-09-09",
				26.01
			],
			[
				"2004-09-20",
				29.01
			],
			[
				"2005-09-13",
				33.01
			],
			[
				"2006-09-20",
				28.01
			],
			[
				"2007-09-12",
				29.01
			],
			[
				"2010-04-20",
				25.01
			],
			[
				"2010-10-18",
				25.01
			],
			[
				"2011-04-20",
				25.01
			],
			[
				"2009-09-07",
				25.95
			],
			[
				"2010-04-14",
				24.09
			],
			[
				"2011-05-25",
				24.58
			]
		],
		"94190094": [
			[
				"2010-03-09",
				60.02
			],
			[
				"2013-12-02",
				54.03
			],
			[
				"2015-09-30",
				47.83
			],
			[
				"2000-08-29",
				57.02
			],
			[
				"2001-08-21",
				56.02
			],
			[
				"2006-05-09",
				62.44
			],
			[
				"2006-09-19",
				59.34
			],
			[
				"2007-11-29",
				65.99
			],
			[
				"2008-07-21",
				59.79
			],
			[
				"2009-09-07",
				60.23
			],
			[
				"2010-05-19",
				62.89
			],
			[
				"2011-05-25",
				57.13
			]
		],
		"94190173": [
			[
				"2008-04-11",
				48.02
			],
			[
				"2008-08-14",
				48.02
			],
			[
				"2008-07-10",
				47.02
			],
			[
				"2008-09-05",
				49.02
			],
			[
				"2008-11-11",
				44.02
			],
			[
				"2008-10-16",
				47.02
			],
			[
				"2009-03-25",
				44.02
			],
			[
				"2009-01-29",
				49.02
			],
			[
				"2009-02-11",
				49.02
			],
			[
				"2009-04-21",
				46.02
			],
			[
				"2009-06-26",
				50.02
			],
			[
				"2009-05-13",
				49.02
			],
			[
				"2009-08-25",
				45.02
			],
			[
				"2009-09-15",
				48.02
			],
			[
				"2009-07-29",
				49.02
			],
			[
				"2009-12-10",
				49.02
			],
			[
				"2009-10-09",
				47.02
			],
			[
				"2009-11-10",
				49.02
			],
			[
				"2010-03-09",
				49.02
			],
			[
				"2010-01-12",
				49.02
			],
			[
				"2010-02-12",
				50.02
			],
			[
				"2014-11-27",
				40.7
			],
			[
				"2015-04-14",
				46.94
			],
			[
				"2000-05-17",
				55.8
			],
			[
				"2000-10-26",
				53.02
			],
			[
				"2001-02-13",
				50.02
			],
			[
				"2001-10-25",
				58.02
			],
			[
				"2002-02-27",
				55.02
			],
			[
				"2002-10-01",
				54.02
			],
			[
				"2003-03-13",
				56.02
			],
			[
				"2003-07-15",
				58.02
			],
			[
				"2004-03-08",
				54.02
			],
			[
				"2004-10-19",
				53.02
			],
			[
				"2005-02-21",
				50.02
			],
			[
				"2006-03-09",
				50.02
			],
			[
				"2006-01-10",
				49.02
			],
			[
				"2006-02-07",
				50.02
			],
			[
				"2006-04-06",
				51.02
			],
			[
				"2006-09-20",
				50.02
			],
			[
				"2007-06-13",
				49.02
			],
			[
				"2007-04-18",
				49.02
			],
			[
				"2007-05-24",
				49.02
			],
			[
				"2007-08-22",
				49.02
			],
			[
				"2007-09-12",
				48.02
			],
			[
				"2007-10-16",
				51.02
			],
			[
				"2007-11-27",
				46.02
			],
			[
				"2008-01-17",
				48.02
			],
			[
				"2008-03-06",
				48.02
			],
			[
				"2008-02-14",
				47.02
			],
			[
				"2010-04-20",
				49.02
			],
			[
				"2010-06-15",
				46.02
			],
			[
				"2011-04-20",
				47.02
			],
			[
				"2009-10-29",
				48.71
			],
			[
				"2010-05-19",
				45.17
			],
			[
				"2011-12-06",
				43.31
			]
		],
		"98120414": [
			[
				"2015-06-24",
				1.33
			],
			[
				"2007-03-05",
				1
			],
			[
				"2007-06-26",
				1
			],
			[
				"2007-09-03",
				1.02
			],
			[
				"2007-12-05",
				1
			],
			[
				"2008-06-25",
				1
			],
			[
				"2008-09-22",
				1
			],
			[
				"2008-12-12",
				1
			],
			[
				"2005-02-11",
				0.89
			],
			[
				"2005-05-12",
				4.43
			],
			[
				"2005-08-11",
				1.33
			],
			[
				"2005-11-09",
				1
			],
			[
				"2006-06-01",
				1.02
			],
			[
				"2006-03-15",
				0.89
			],
			[
				"2006-11-20",
				1.02
			],
			[
				"2006-08-29",
				1.02
			],
			[
				"2000-03-23",
				13.29
			],
			[
				"2000-06-15",
				13.29
			],
			[
				"2000-09-28",
				13.29
			],
			[
				"2000-12-19",
				3.1
			],
			[
				"2001-03-19",
				31
			],
			[
				"2001-04-19",
				31
			],
			[
				"2001-06-21",
				3.1
			],
			[
				"2001-09-26",
				34.99
			],
			[
				"2001-12-17",
				3.1
			],
			[
				"2002-04-09",
				4.43
			],
			[
				"2002-07-12",
				0.89
			],
			[
				"2002-09-27",
				0.89
			],
			[
				"2002-12-19",
				0.89
			],
			[
				"2003-02-12",
				2.21
			],
			[
				"2003-05-14",
				0.89
			],
			[
				"2003-08-14",
				0.89
			],
			[
				"2003-11-11",
				0.89
			],
			[
				"2004-02-11",
				0.89
			],
			[
				"2004-05-11",
				0.89
			],
			[
				"2004-08-19",
				0.89
			],
			[
				"2004-11-23",
				0.89
			],
			[
				"2010-03-18",
				1
			],
			[
				"2010-06-08",
				1
			],
			[
				"2010-09-29",
				1
			],
			[
				"2011-01-17",
				1
			],
			[
				"2011-03-03",
				1
			],
			[
				"2011-05-19",
				1
			],
			[
				"2011-08-16",
				1
			],
			[
				"2011-12-05",
				1
			],
			[
				"2012-03-08",
				1
			],
			[
				"2012-06-05",
				1
			],
			[
				"2012-09-28",
				1
			],
			[
				"2012-12-19",
				1
			],
			[
				"2013-03-18",
				1
			],
			[
				"2013-06-06",
				1
			],
			[
				"2013-10-24",
				1
			],
			[
				"2013-12-18",
				1
			]
		],
		"99580044": [
			[
				"2008-07-04",
				23.01
			],
			[
				"2009-01-09",
				22.01
			],
			[
				"2009-07-03",
				23.01
			],
			[
				"2010-01-22",
				22.01
			],
			[
				"2015-05-04",
				22.59
			],
			[
				"2000-08-28",
				27.01
			],
			[
				"2001-09-19",
				26.13
			],
			[
				"2002-01-03",
				25.01
			],
			[
				"2002-10-24",
				26.13
			],
			[
				"2003-11-26",
				25.69
			],
			[
				"2004-10-27",
				24.36
			],
			[
				"2005-01-28",
				24.01
			],
			[
				"2005-10-26",
				22.85
			],
			[
				"2005-11-18",
				22.01
			],
			[
				"2006-02-03",
				23.01
			],
			[
				"2006-07-21",
				24.01
			],
			[
				"2006-11-15",
				22.81
			],
			[
				"2007-01-04",
				22.01
			],
			[
				"2007-07-13",
				23.01
			],
			[
				"2008-01-18",
				22.01
			],
			[
				"2010-12-01",
				22.01
			],
			[
				"2010-07-23",
				23.01
			],
			[
				"2011-01-11",
				21.01
			],
			[
				"2011-08-09",
				23.01
			],
			[
				"2012-01-13",
				21.01
			],
			[
				"2012-07-27",
				23.01
			],
			[
				"2013-07-05",
				26.01
			],
			[
				"2014-07-23",
				22.01
			],
			[
				"2015-07-29",
				23.01
			],
			[
				"2006-12-12",
				22.32
			],
			[
				"2009-07-27",
				22.41
			],
			[
				"2010-07-19",
				21.74
			],
			[
				"2011-04-06",
				22.28
			]
		],
		"99580093": [
			[
				"2013-11-18",
				30.6
			],
			[
				"2015-02-27",
				29.72
			],
			[
				"2000-08-24",
				16.39
			],
			[
				"2001-09-25",
				23.03
			],
			[
				"2002-10-30",
				20.37
			],
			[
				"2003-12-03",
				17.71
			],
			[
				"2004-11-24",
				23.03
			],
			[
				"2005-10-11",
				15.63
			],
			[
				"2006-04-26",
				19.13
			],
			[
				"2006-11-22",
				21.7
			],
			[
				"2007-03-19",
				20.95
			],
			[
				"2009-07-30",
				23.6
			],
			[
				"2010-06-08",
				22.45
			],
			[
				"2011-11-16",
				27.59
			]
		],
		"99580111": [
			[
				"2014-10-01",
				9.92
			],
			[
				"2015-06-11",
				9.79
			],
			[
				"2000-08-24",
				5.76
			],
			[
				"2001-09-25",
				3.54
			],
			[
				"2002-10-23",
				4.43
			],
			[
				"2003-12-03",
				4.87
			],
			[
				"2005-12-13",
				5.31
			],
			[
				"2006-04-25",
				8.19
			],
			[
				"2006-11-22",
				8.9
			],
			[
				"2007-07-03",
				10.98
			],
			[
				"2009-07-29",
				22.85
			],
			[
				"2010-04-22",
				18.51
			],
			[
				"2011-11-30",
				12.71
			]
		],
		"99580123": [
			[
				"2014-05-13",
				17.14
			],
			[
				"2015-09-21",
				18.11
			],
			[
				"2000-08-31",
				15.94
			],
			[
				"2001-10-22",
				13.73
			],
			[
				"2002-10-23",
				14.61
			],
			[
				"2003-12-01",
				15.5
			],
			[
				"2005-01-11",
				14.17
			],
			[
				"2005-10-20",
				14.3
			],
			[
				"2006-04-27",
				15.5
			],
			[
				"2006-11-21",
				14.79
			],
			[
				"2007-07-03",
				15.99
			],
			[
				"2009-07-30",
				14.88
			],
			[
				"2010-04-22",
				16.52
			],
			[
				"2011-11-16",
				17.89
			]
		],
		"99580172": [
			[
				"2008-07-22",
				22.01
			],
			[
				"2009-04-09",
				22.01
			],
			[
				"2009-10-13",
				21.01
			],
			[
				"2015-09-24",
				20.24
			],
			[
				"2001-04-09",
				23.01
			],
			[
				"2002-04-11",
				22.01
			],
			[
				"2005-07-14",
				26.01
			],
			[
				"2006-07-19",
				21.01
			],
			[
				"2007-07-12",
				22.01
			],
			[
				"2010-04-13",
				22.01
			],
			[
				"2010-07-26",
				22.01
			],
			[
				"2011-04-12",
				22.01
			],
			[
				"2012-04-24",
				20.01
			],
			[
				"2008-09-10",
				21.79
			],
			[
				"2010-07-21",
				20.73
			],
			[
				"2009-10-20",
				20.5
			]
		],
		"99580184": [
			[
				"2014-12-01",
				8.19
			],
			[
				"2015-05-06",
				8.95
			],
			[
				"2001-09-18",
				6.2
			],
			[
				"2002-10-30",
				6.2
			],
			[
				"2003-12-04",
				8.41
			],
			[
				"2004-11-24",
				6.64
			],
			[
				"2006-04-26",
				8.02
			],
			[
				"2005-10-27",
				8.15
			],
			[
				"2002-04-09",
				8
			],
			[
				"2007-10-23",
				8.5
			],
			[
				"2008-07-10",
				8.46
			],
			[
				"2010-10-18",
				9.03
			],
			[
				"2011-11-21",
				7.66
			]
		],
		"99580202": [
			[
				"2014-10-01",
				5.49
			],
			[
				"2015-06-11",
				3.9
			],
			[
				"2015-09-30",
				3.32
			],
			[
				"2000-08-24",
				4.87
			],
			[
				"2003-03-26",
				3.1
			],
			[
				"2003-11-25",
				3.1
			],
			[
				"2005-03-17",
				3.59
			],
			[
				"2005-10-11",
				3.59
			],
			[
				"2006-04-25",
				4.43
			],
			[
				"2006-11-22",
				3.81
			],
			[
				"2007-03-19",
				3.81
			],
			[
				"2008-07-09",
				4.43
			],
			[
				"2009-07-29",
				3.94
			],
			[
				"2010-04-22",
				4.34
			],
			[
				"2011-11-30",
				2.75
			]
		],
		"99580251": [
			[
				"2014-12-01",
				7.48
			],
			[
				"2015-05-06",
				7.66
			],
			[
				"2000-08-24",
				4.43
			],
			[
				"2001-09-18",
				3.54
			],
			[
				"2002-10-30",
				3.54
			],
			[
				"2004-02-04",
				5.76
			],
			[
				"2004-11-24",
				5.76
			],
			[
				"2006-04-26",
				6.95
			],
			[
				"2008-12-16",
				9.52
			],
			[
				"2008-09-04",
				8.81
			],
			[
				"2005-10-27",
				5.14
			],
			[
				"2010-11-08",
				8.19
			]
		],
		"99780112": [
			[
				"2015-04-13",
				17.71
			],
			[
				"2000-10-12",
				1.33
			],
			[
				"2003-05-05",
				0.44
			],
			[
				"2004-01-12",
				0.44
			],
			[
				"2004-11-22",
				0.44
			],
			[
				"2005-11-24",
				0.44
			],
			[
				"2006-10-11",
				0.66
			],
			[
				"2007-06-28",
				0.66
			],
			[
				"2008-07-15",
				0.66
			],
			[
				"2009-03-11",
				4.92
			],
			[
				"2010-04-13",
				0.66
			],
			[
				"2011-09-07",
				0.66
			]
		],
		"100120015": [
			[
				"2013-05-02",
				19.93
			],
			[
				"2014-07-16",
				10.81
			],
			[
				"2015-10-22",
				18.11
			],
			[
				"2000-07-07",
				17.27
			],
			[
				"2002-11-21",
				16.3
			],
			[
				"2005-04-21",
				19.04
			],
			[
				"2006-10-11",
				20.37
			],
			[
				"2007-07-19",
				11.07
			],
			[
				"2009-10-21",
				15.94
			],
			[
				"2010-06-21",
				15.94
			],
			[
				"2008-06-12",
				11.51
			],
			[
				"2011-06-06",
				12.84
			],
			[
				"2012-08-11",
				16.39
			]
		],
		"100120180": [
			[
				"2013-05-02",
				2.21
			],
			[
				"2014-07-16",
				1.33
			],
			[
				"2015-09-23",
				3.63
			],
			[
				"2000-07-07",
				2.21
			],
			[
				"2002-11-21",
				2.21
			],
			[
				"2005-10-21",
				2.21
			],
			[
				"2005-04-21",
				2.21
			],
			[
				"2006-10-11",
				2.21
			],
			[
				"2007-07-19",
				2.21
			],
			[
				"2008-06-12",
				2.21
			],
			[
				"2009-10-21",
				2.21
			],
			[
				"2010-06-21",
				2.21
			],
			[
				"2011-06-08",
				2.21
			],
			[
				"2012-10-09",
				2.21
			]
		],
		"100120258": [
			[
				"2013-07-18",
				31.89
			],
			[
				"2014-08-20",
				27.46
			],
			[
				"2015-10-05",
				11.12
			],
			[
				"2005-06-27",
				11.07
			],
			[
				"2006-09-19",
				12.4
			],
			[
				"2007-07-04",
				13.73
			],
			[
				"2008-12-01",
				5.31
			],
			[
				"2009-10-27",
				17.71
			],
			[
				"2010-06-08",
				25.24
			],
			[
				"2011-09-06",
				16.83
			],
			[
				"2012-08-07",
				28.79
			]
		],
		"100135020": [
			[
				"2013-04-22",
				31
			],
			[
				"2014-02-11",
				27.9
			],
			[
				"2015-06-24",
				26.88
			],
			[
				"2016-03-23",
				25.69
			],
			[
				"2000-07-04",
				19.04
			],
			[
				"2000-10-12",
				46.5
			],
			[
				"2001-01-29",
				42.96
			],
			[
				"2001-04-18",
				41.81
			],
			[
				"2002-06-07",
				22.63
			],
			[
				"2002-11-07",
				17.71
			],
			[
				"2004-06-21",
				30.51
			],
			[
				"2005-06-28",
				23.91
			],
			[
				"2005-08-29",
				27.01
			],
			[
				"2006-10-06",
				27.01
			],
			[
				"2007-08-06",
				22.14
			],
			[
				"2008-06-19",
				27.9
			],
			[
				"2009-10-13",
				31
			],
			[
				"2010-06-02",
				29.67
			],
			[
				"2003-09-25",
				18.42
			],
			[
				"2011-09-01",
				25.24
			],
			[
				"2012-10-09",
				35.43
			]
		],
		"100135031": [
			[
				"2013-05-06",
				62.89
			],
			[
				"2014-04-23",
				68.64
			],
			[
				"2015-04-13",
				54.47
			],
			[
				"2000-01-12",
				94.33
			],
			[
				"2001-01-24",
				80.6
			],
			[
				"2002-05-17",
				65.1
			],
			[
				"2002-10-24",
				79.71
			],
			[
				"2005-06-28",
				84.14
			],
			[
				"2006-08-07",
				75.29
			],
			[
				"2006-09-06",
				75.29
			],
			[
				"2007-08-01",
				79.71
			],
			[
				"2009-09-24",
				62
			],
			[
				"2008-08-01",
				62
			],
			[
				"2010-09-29",
				79.71
			],
			[
				"2011-06-30",
				62
			],
			[
				"2012-07-17",
				62
			]
		],
		"100135067": [
			[
				"2013-04-30",
				11.51
			],
			[
				"2014-04-08",
				13.29
			],
			[
				"2015-04-08",
				12.31
			],
			[
				"2000-06-27",
				2.21
			],
			[
				"2002-10-24",
				20.73
			],
			[
				"2005-05-24",
				10.19
			],
			[
				"2006-07-28",
				14.17
			],
			[
				"2007-08-01",
				17.71
			],
			[
				"2008-07-10",
				25.24
			],
			[
				"2009-11-12",
				13.29
			],
			[
				"2010-08-25",
				16.83
			],
			[
				"2011-07-19",
				15.06
			],
			[
				"2012-07-03",
				15.5
			]
		],
		"100135158": [
			[
				"2013-04-30",
				2.21
			],
			[
				"2014-04-08",
				2.21
			],
			[
				"2015-04-08",
				1.33
			],
			[
				"2006-12-01",
				2.21
			],
			[
				"2007-08-08",
				2.21
			],
			[
				"2009-10-13",
				2.21
			],
			[
				"2010-10-12",
				2.21
			],
			[
				"2011-09-14",
				2.21
			],
			[
				"2012-10-15",
				2.21
			]
		],
		"100135213": [
			[
				"2013-04-30",
				67.76
			],
			[
				"2014-02-12",
				63.33
			],
			[
				"2015-04-08",
				69.53
			],
			[
				"2000-04-27",
				103.63
			],
			[
				"2000-10-12",
				115.14
			],
			[
				"2001-01-30",
				112.93
			],
			[
				"2001-04-18",
				98.31
			],
			[
				"2002-06-07",
				94.77
			],
			[
				"2002-10-01",
				102.3
			],
			[
				"2002-10-24",
				100.09
			],
			[
				"2004-06-24",
				70.86
			],
			[
				"2005-05-24",
				75.29
			],
			[
				"2005-08-29",
				75.29
			],
			[
				"2006-09-06",
				75.29
			],
			[
				"2007-08-07",
				70.86
			],
			[
				"2009-09-03",
				84.14
			],
			[
				"2003-09-25",
				93
			],
			[
				"2008-07-24",
				75.29
			],
			[
				"2010-05-05",
				66.43
			],
			[
				"2011-09-01",
				84.14
			],
			[
				"2012-05-31",
				79.71
			]
		],
		"100135468": [
			[
				"2013-07-11",
				35.43
			],
			[
				"2014-07-14",
				33.88
			],
			[
				"2015-03-31",
				31.97
			],
			[
				"2003-03-05",
				32.15
			],
			[
				"2005-06-22",
				24.8
			],
			[
				"2006-10-10",
				34.54
			],
			[
				"2007-07-09",
				30.11
			],
			[
				"2009-11-18",
				36.31
			],
			[
				"2008-04-21",
				27.46
			],
			[
				"2010-11-15",
				48.71
			],
			[
				"2011-11-10",
				42.07
			],
			[
				"2012-10-18",
				35.43
			]
		],
		"100135559": [
			[
				"2010-04-02",
				2
			],
			[
				"2010-08-22",
				2
			],
			[
				"2013-05-06",
				2.21
			],
			[
				"2014-02-12",
				2.21
			],
			[
				"2015-04-09",
				1.33
			],
			[
				"2000-06-27",
				41.19
			],
			[
				"2001-01-30",
				46.5
			],
			[
				"2002-11-07",
				2.21
			],
			[
				"2003-08-31",
				21.71
			],
			[
				"2003-03-16",
				2
			],
			[
				"2002-08-12",
				39.71
			],
			[
				"2004-08-22",
				19.41
			],
			[
				"2005-08-30",
				2.21
			],
			[
				"2006-08-06",
				2
			],
			[
				"2006-03-28",
				2
			],
			[
				"2006-09-01",
				2.21
			],
			[
				"2007-03-11",
				2
			],
			[
				"2007-08-05",
				5.76
			],
			[
				"2007-07-25",
				3.14
			],
			[
				"2008-03-29",
				6.7
			],
			[
				"2008-06-26",
				12.84
			],
			[
				"2008-08-19",
				3.5
			],
			[
				"2009-03-29",
				2
			],
			[
				"2009-08-23",
				2
			],
			[
				"2005-03-23",
				2
			],
			[
				"2013-04-09",
				2.21
			],
			[
				"2013-08-22",
				1.99
			],
			[
				"2009-09-02",
				4.43
			],
			[
				"2010-10-12",
				2.21
			],
			[
				"2011-06-30",
				2.21
			],
			[
				"2012-07-11",
				2.21
			]
		],
		"100135560": [
			[
				"2013-04-30",
				19.93
			],
			[
				"2014-04-23",
				17.27
			],
			[
				"2015-04-08",
				19.71
			],
			[
				"2002-12-05",
				17.85
			],
			[
				"2005-05-17",
				20.37
			],
			[
				"2006-09-06",
				22.14
			],
			[
				"2007-08-07",
				18.6
			],
			[
				"2008-07-10",
				25.24
			],
			[
				"2009-09-02",
				21.26
			],
			[
				"2010-05-05",
				23.47
			],
			[
				"2011-04-11",
				27.46
			],
			[
				"2012-07-03",
				19.93
			]
		],
		"100135596": [
			[
				"2013-04-25",
				34.54
			],
			[
				"2014-04-08",
				38.09
			],
			[
				"2015-04-09",
				17.4
			],
			[
				"2000-04-27",
				132.86
			],
			[
				"2002-12-05",
				177.14
			],
			[
				"2005-05-24",
				212.57
			],
			[
				"2006-07-26",
				141.71
			],
			[
				"2007-07-25",
				48.71
			],
			[
				"2009-09-02",
				15.5
			],
			[
				"2008-07-24",
				84.14
			],
			[
				"2010-08-25",
				62
			],
			[
				"2011-09-01",
				48.71
			],
			[
				"2012-07-11",
				79.71
			]
		],
		"100135602": [
			[
				"2013-05-06",
				2.21
			],
			[
				"2014-04-08",
				5.31
			],
			[
				"2015-04-09",
				4.61
			],
			[
				"2000-06-27",
				16.39
			],
			[
				"2002-12-05",
				7.31
			],
			[
				"2005-04-28",
				8.41
			],
			[
				"2006-07-26",
				3.54
			],
			[
				"2007-07-26",
				7.09
			],
			[
				"2008-07-10",
				3.85
			],
			[
				"2009-09-02",
				12.84
			],
			[
				"2012-08-09",
				4.07
			]
		],
		"100135614": [
			[
				"2013-09-12",
				44.29
			],
			[
				"2014-08-28",
				45.17
			],
			[
				"2015-04-23",
				50.04
			],
			[
				"2003-03-04",
				55.8
			],
			[
				"2005-06-21",
				48.71
			],
			[
				"2006-10-16",
				53.14
			],
			[
				"2007-06-12",
				53.14
			],
			[
				"2009-11-18",
				43.84
			],
			[
				"2008-06-03",
				42.96
			],
			[
				"2010-11-02",
				48.71
			],
			[
				"2012-07-02",
				53.14
			]
		],
		"100135626": [
			[
				"2013-04-25",
				135.07
			],
			[
				"2014-02-12",
				39.86
			],
			[
				"2015-04-09",
				108.5
			],
			[
				"2000-04-27",
				39.86
			],
			[
				"2005-05-24",
				21.26
			],
			[
				"2006-09-06",
				11.96
			],
			[
				"2007-08-06",
				6.2
			],
			[
				"2008-07-03",
				31.44
			],
			[
				"2009-09-24",
				14.17
			],
			[
				"2010-09-30",
				14.61
			],
			[
				"2011-08-25",
				15.94
			],
			[
				"2012-08-09",
				11.51
			]
		],
		"100135640": [
			[
				"2013-04-25",
				2.21
			],
			[
				"2014-04-16",
				2.21
			],
			[
				"2015-04-16",
				1.33
			],
			[
				"2006-08-01",
				2.21
			],
			[
				"2005-05-24",
				2.21
			],
			[
				"2005-11-24",
				2.21
			],
			[
				"2007-08-06",
				2.21
			],
			[
				"2009-09-24",
				2.21
			],
			[
				"2008-07-24",
				2.21
			],
			[
				"2010-09-30",
				2.21
			],
			[
				"2011-04-11",
				2.21
			],
			[
				"2012-09-13",
				2.21
			]
		],
		"100135651": [
			[
				"2013-04-25",
				313.54
			],
			[
				"2014-04-16",
				301.14
			],
			[
				"2015-04-16",
				281.21
			],
			[
				"2005-05-24",
				159.43
			],
			[
				"2006-10-06",
				190.43
			],
			[
				"2007-08-06",
				398.57
			],
			[
				"2009-09-03",
				261.29
			],
			[
				"2008-07-24",
				487.14
			],
			[
				"2010-08-25",
				261.29
			],
			[
				"2011-04-11",
				225.86
			],
			[
				"2012-09-13",
				256.86
			]
		],
		"100140014": [
			[
				"2013-04-24",
				34.54
			],
			[
				"2014-10-23",
				32.86
			],
			[
				"2015-09-17",
				32.2
			],
			[
				"2000-06-26",
				53.14
			],
			[
				"2001-01-29",
				47.83
			],
			[
				"2002-11-07",
				48.27
			],
			[
				"2005-05-24",
				44.29
			],
			[
				"2006-10-06",
				40.74
			],
			[
				"2007-11-14",
				42.96
			],
			[
				"2009-11-11",
				41.19
			],
			[
				"2008-07-25",
				41.63
			],
			[
				"2010-09-30",
				37.2
			],
			[
				"2011-08-25",
				33.66
			],
			[
				"2012-08-09",
				34.99
			]
		],
		"100140087": [
			[
				"2013-05-13",
				72.19
			],
			[
				"2014-04-01",
				81.49
			],
			[
				"2015-03-17",
				84.14
			],
			[
				"2000-05-03",
				93
			],
			[
				"2001-02-13",
				69.97
			],
			[
				"2002-11-14",
				70.86
			],
			[
				"2005-06-01",
				62
			],
			[
				"2006-10-06",
				66.43
			],
			[
				"2008-07-02",
				62
			],
			[
				"2009-09-23",
				66.43
			],
			[
				"2010-06-10",
				66.43
			],
			[
				"2011-09-20",
				75.29
			],
			[
				"2012-10-11",
				79.71
			]
		],
		"100140312": [
			[
				"2013-05-13",
				2.21
			],
			[
				"2014-02-18",
				2.21
			],
			[
				"2015-03-26",
				1.33
			],
			[
				"2000-07-05",
				2.21
			],
			[
				"2001-02-13",
				2.21
			],
			[
				"2002-11-14",
				2.21
			],
			[
				"2005-06-01",
				2.21
			],
			[
				"2006-09-01",
				2.21
			],
			[
				"2007-10-01",
				2.21
			],
			[
				"2008-07-02",
				2.21
			],
			[
				"2009-10-06",
				2.21
			],
			[
				"2010-06-10",
				2.21
			],
			[
				"2011-07-13",
				2.21
			],
			[
				"2012-10-11",
				2.21
			]
		],
		"100140324": [
			[
				"2013-05-22",
				14.17
			],
			[
				"2014-02-18",
				11.51
			],
			[
				"2015-06-02",
				15.15
			],
			[
				"2000-07-04",
				40.74
			],
			[
				"2000-10-13",
				53.14
			],
			[
				"2001-01-31",
				22.14
			],
			[
				"2001-04-19",
				23.43
			],
			[
				"2002-10-10",
				124.89
			],
			[
				"2002-11-14",
				111.6
			],
			[
				"2004-06-24",
				20.15
			],
			[
				"2005-05-19",
				15.94
			],
			[
				"2005-09-02",
				26.13
			],
			[
				"2006-09-01",
				84.14
			],
			[
				"2007-10-15",
				6.64
			],
			[
				"2008-06-26",
				62
			],
			[
				"2009-09-11",
				48.71
			],
			[
				"2003-09-25",
				113.81
			],
			[
				"2010-10-07",
				35.87
			],
			[
				"2011-07-13",
				28.34
			],
			[
				"2012-05-31",
				9.74
			]
		],
		"100140350": [
			[
				"2013-04-23",
				17.71
			],
			[
				"2014-04-16",
				36.31
			],
			[
				"2015-03-17",
				8.9
			],
			[
				"2000-05-03",
				2.21
			],
			[
				"2001-01-31",
				2.21
			],
			[
				"2002-11-14",
				2.21
			],
			[
				"2005-06-01",
				11.51
			],
			[
				"2006-07-28",
				2.21
			],
			[
				"2007-10-01",
				2.21
			],
			[
				"2008-07-02",
				2.21
			],
			[
				"2009-09-24",
				2.21
			],
			[
				"2010-06-10",
				2.21
			],
			[
				"2011-09-20",
				2.21
			],
			[
				"2012-09-19",
				2.21
			]
		],
		"100140683": [
			[
				"2013-05-14",
				152.79
			],
			[
				"2014-02-18",
				113.81
			],
			[
				"2015-05-21",
				84.59
			],
			[
				"2000-07-05",
				66.43
			],
			[
				"2000-10-13",
				79.71
			],
			[
				"2001-02-14",
				154.11
			],
			[
				"2001-04-19",
				140.39
			],
			[
				"2002-10-10",
				88.57
			],
			[
				"2002-11-14",
				119.57
			],
			[
				"2004-06-22",
				149.69
			],
			[
				"2007-10-17",
				88.57
			],
			[
				"2008-07-17",
				239.14
			],
			[
				"2009-08-27",
				124
			],
			[
				"2003-09-24",
				67.76
			],
			[
				"2010-09-01",
				199.29
			],
			[
				"2011-07-06",
				119.57
			],
			[
				"2012-08-13",
				79.71
			]
		],
		"100140749": [
			[
				"2013-04-24",
				137.29
			],
			[
				"2014-03-25",
				145.26
			],
			[
				"2015-04-16",
				144.37
			],
			[
				"2000-06-26",
				185.11
			],
			[
				"2000-10-13",
				168.29
			],
			[
				"2001-01-30",
				173.6
			],
			[
				"2001-04-19",
				180.69
			],
			[
				"2002-11-07",
				154.56
			],
			[
				"2004-06-24",
				136.4
			],
			[
				"2005-06-01",
				146.14
			],
			[
				"2005-09-02",
				137.29
			],
			[
				"2006-10-06",
				150.57
			],
			[
				"2007-07-26",
				141.71
			],
			[
				"2008-07-02",
				137.29
			],
			[
				"2009-09-23",
				128.43
			],
			[
				"2003-09-25",
				137.29
			],
			[
				"2010-09-08",
				132.86
			],
			[
				"2011-09-14",
				124
			],
			[
				"2012-09-19",
				124
			]
		],
		"100140750": [
			[
				"2013-05-06",
				2.21
			],
			[
				"2014-03-25",
				2.21
			],
			[
				"2015-04-16",
				1.33
			],
			[
				"2000-05-03",
				2.21
			],
			[
				"2001-01-30",
				2.21
			],
			[
				"2002-11-07",
				2.21
			],
			[
				"2005-06-28",
				2.21
			],
			[
				"2006-09-06",
				2.21
			],
			[
				"2007-07-26",
				2.21
			],
			[
				"2008-07-03",
				2.21
			],
			[
				"2009-09-03",
				4.12
			],
			[
				"2010-08-25",
				2.21
			],
			[
				"2011-09-14",
				2.21
			],
			[
				"2012-10-15",
				2.21
			]
		],
		"100140762": [
			[
				"2013-05-13",
				22.59
			],
			[
				"2014-03-25",
				30.11
			],
			[
				"2015-04-16",
				34.41
			],
			[
				"2007-11-14",
				7.97
			],
			[
				"2008-07-03",
				15.94
			],
			[
				"2009-11-12",
				8.86
			],
			[
				"2010-09-08",
				11.96
			],
			[
				"2011-07-21",
				8.86
			],
			[
				"2012-05-31",
				14.61
			]
		],
		"100140774": [
			[
				"2013-05-13",
				3.81
			],
			[
				"2014-02-12",
				2.21
			],
			[
				"2015-04-16",
				3.28
			],
			[
				"2000-05-03",
				3.32
			],
			[
				"2005-06-28",
				2.3
			],
			[
				"2006-07-26",
				2.21
			],
			[
				"2007-07-26",
				2.21
			],
			[
				"2008-07-03",
				2.21
			],
			[
				"2009-09-03",
				2.21
			],
			[
				"2010-09-29",
				2.21
			],
			[
				"2011-08-25",
				2.21
			],
			[
				"2012-10-15",
				3.94
			]
		],
		"100140865": [
			[
				"2013-04-23",
				2.21
			],
			[
				"2014-02-11",
				2.21
			],
			[
				"2015-07-01",
				1.33
			],
			[
				"2000-06-26",
				2.21
			],
			[
				"2001-01-31",
				2.21
			],
			[
				"2002-11-07",
				2.21
			],
			[
				"2005-05-19",
				2.21
			],
			[
				"2006-10-06",
				2.21
			],
			[
				"2007-08-08",
				2.21
			],
			[
				"2009-09-23",
				2.21
			],
			[
				"2010-09-08",
				2.21
			],
			[
				"2011-07-19",
				2.21
			],
			[
				"2012-07-17",
				2.21
			]
		],
		"100140920": [
			[
				"2013-04-23",
				2.21
			],
			[
				"2014-04-01",
				3.19
			],
			[
				"2015-06-24",
				5.27
			],
			[
				"2016-03-23",
				1.42
			],
			[
				"2005-05-19",
				2.21
			],
			[
				"2006-12-01",
				2.21
			],
			[
				"2007-10-15",
				2.21
			],
			[
				"2008-07-17",
				2.21
			],
			[
				"2009-09-23",
				2.21
			],
			[
				"2010-09-08",
				2.21
			],
			[
				"2011-07-19",
				2.21
			],
			[
				"2012-07-11",
				2.21
			]
		],
		"100141328": [
			[
				"2013-05-14",
				2.21
			],
			[
				"2014-04-02",
				2.21
			],
			[
				"2015-05-21",
				1.33
			],
			[
				"2000-07-06",
				2.21
			],
			[
				"2005-05-12",
				2.21
			],
			[
				"2006-09-01",
				2.21
			],
			[
				"2007-05-11",
				2.21
			],
			[
				"2009-09-11",
				2.21
			],
			[
				"2008-07-25",
				2.21
			],
			[
				"2010-09-01",
				2.21
			],
			[
				"2011-06-09",
				2.21
			],
			[
				"2012-09-14",
				2.21
			]
		],
		"100141365": [
			[
				"2013-05-22",
				2.21
			],
			[
				"2014-04-01",
				2.21
			],
			[
				"2015-06-02",
				1.33
			],
			[
				"2000-07-04",
				2.21
			],
			[
				"2005-05-19",
				2.21
			],
			[
				"2006-09-01",
				5.76
			],
			[
				"2007-11-14",
				2.21
			],
			[
				"2008-06-26",
				3.68
			],
			[
				"2009-10-06",
				2.21
			],
			[
				"2010-09-23",
				2.21
			],
			[
				"2011-07-13",
				2.21
			],
			[
				"2012-10-11",
				2.21
			]
		],
		"100141377": [
			[
				"2013-05-21",
				2.21
			],
			[
				"2014-04-01",
				2.21
			],
			[
				"2015-06-02",
				1.33
			],
			[
				"2000-07-04",
				2.21
			],
			[
				"2005-05-12",
				4.07
			],
			[
				"2006-09-01",
				2.21
			],
			[
				"2007-05-11",
				2.21
			],
			[
				"2008-06-26",
				2.21
			],
			[
				"2009-10-06",
				2.21
			],
			[
				"2010-09-23",
				2.21
			],
			[
				"2011-07-13",
				2.21
			],
			[
				"2012-10-11",
				2.21
			]
		],
		"100141389": [
			[
				"2013-04-24",
				30.11
			],
			[
				"2014-02-11",
				26.57
			],
			[
				"2015-09-17",
				30.82
			],
			[
				"2006-12-01",
				38.53
			],
			[
				"2007-08-08",
				36.76
			],
			[
				"2009-09-23",
				38.53
			],
			[
				"2008-07-25",
				29.67
			],
			[
				"2010-09-30",
				37.2
			],
			[
				"2011-07-21",
				27.46
			],
			[
				"2012-07-03",
				32.77
			]
		],
		"100150020": [
			[
				"2013-05-14",
				2.21
			],
			[
				"2014-03-26",
				2.21
			],
			[
				"2015-05-19",
				1.33
			],
			[
				"2000-10-13",
				2.21
			],
			[
				"2001-02-14",
				2.21
			],
			[
				"2001-04-19",
				3.9
			],
			[
				"2002-10-10",
				2.21
			],
			[
				"2002-11-08",
				2.21
			],
			[
				"2004-06-22",
				2.21
			],
			[
				"2005-05-04",
				2.21
			],
			[
				"2005-08-29",
				2.21
			],
			[
				"2006-08-30",
				2.21
			],
			[
				"2007-05-11",
				2.21
			],
			[
				"2008-07-17",
				2.21
			],
			[
				"2009-08-27",
				2.66
			],
			[
				"2003-09-24",
				2.21
			],
			[
				"2010-09-01",
				2.21
			],
			[
				"2011-07-06",
				2.21
			],
			[
				"2012-08-13",
				2.21
			]
		],
		"100150032": [
			[
				"2013-05-15",
				2.21
			],
			[
				"2014-04-02",
				2.21
			],
			[
				"2015-05-12",
				1.33
			],
			[
				"2001-02-22",
				2.21
			],
			[
				"2002-11-08",
				2.21
			],
			[
				"2005-05-04",
				2.21
			],
			[
				"2006-08-30",
				2.21
			],
			[
				"2007-10-15",
				2.83
			],
			[
				"2008-06-13",
				4.43
			],
			[
				"2009-11-10",
				2.21
			],
			[
				"2006-08-08",
				2.21
			],
			[
				"2010-10-07",
				2.21
			],
			[
				"2011-06-09",
				2.21
			],
			[
				"2012-07-04",
				2.21
			]
		],
		"100150287": [
			[
				"2013-05-21",
				2.21
			],
			[
				"2014-04-02",
				2.21
			],
			[
				"2015-05-12",
				2.21
			],
			[
				"2000-07-06",
				2.21
			],
			[
				"2001-02-14",
				2.21
			],
			[
				"2002-11-08",
				2.21
			],
			[
				"2005-05-04",
				2.21
			],
			[
				"2006-08-02",
				2.21
			],
			[
				"2006-08-30",
				2.21
			],
			[
				"2007-05-10",
				2.21
			],
			[
				"2008-06-20",
				2.21
			],
			[
				"2009-08-27",
				2.21
			],
			[
				"2010-07-07",
				2.21
			],
			[
				"2011-06-09",
				2.21
			],
			[
				"2012-05-29",
				2.21
			]
		],
		"100150329": [
			[
				"2013-05-15",
				2.21
			],
			[
				"2014-04-02",
				2.21
			],
			[
				"2015-05-12",
				1.33
			],
			[
				"2005-05-04",
				2.21
			],
			[
				"2006-08-02",
				2.21
			],
			[
				"2006-08-30",
				2.21
			],
			[
				"2007-05-10",
				2.21
			],
			[
				"2009-09-11",
				48.71
			],
			[
				"2008-06-13",
				2.21
			],
			[
				"2010-07-07",
				2.21
			],
			[
				"2011-09-22",
				2.21
			],
			[
				"2012-05-29",
				2.21
			]
		],
		"100150640": [
			[
				"2013-05-21",
				2.21
			],
			[
				"2014-03-26",
				2.21
			],
			[
				"2015-05-19",
				1.33
			],
			[
				"2000-07-05",
				2.21
			],
			[
				"2002-11-14",
				2.21
			],
			[
				"2005-05-04",
				2.21
			],
			[
				"2006-08-02",
				2.21
			],
			[
				"2006-08-30",
				2.21
			],
			[
				"2007-05-10",
				2.21
			],
			[
				"2008-06-20",
				2.21
			],
			[
				"2009-11-10",
				2.21
			],
			[
				"2010-07-07",
				2.21
			],
			[
				"2011-07-06",
				2.21
			],
			[
				"2012-09-14",
				2.21
			]
		],
		"100151085": [
			[
				"2013-05-21",
				2.21
			],
			[
				"2014-03-26",
				2.21
			],
			[
				"2015-07-01",
				1.33
			],
			[
				"2000-07-05",
				2.52
			],
			[
				"2001-04-04",
				2.21
			],
			[
				"2002-11-08",
				2.21
			],
			[
				"2005-05-19",
				2.21
			],
			[
				"2006-09-01",
				2.21
			],
			[
				"2007-05-11",
				2.21
			],
			[
				"2008-06-20",
				4.87
			],
			[
				"2009-11-11",
				2.21
			],
			[
				"2010-09-23",
				5.76
			],
			[
				"2011-09-22",
				7.97
			],
			[
				"2012-07-04",
				10.19
			],
			[
				"2012-09-14",
				7.53
			]
		],
		"100151140": [
			[
				"2013-05-14",
				3.5
			],
			[
				"2014-03-26",
				6.64
			],
			[
				"2015-05-21",
				3.63
			],
			[
				"2008-06-20",
				2.21
			],
			[
				"2009-10-06",
				2.21
			],
			[
				"2010-09-23",
				9.3
			],
			[
				"2011-07-06",
				2.21
			],
			[
				"2012-08-13",
				2.21
			]
		],
		"100160025": [
			[
				"2013-06-26",
				18.6
			],
			[
				"2014-05-06",
				14.17
			],
			[
				"2015-06-30",
				31.18
			],
			[
				"2005-05-12",
				29.67
			],
			[
				"2006-10-12",
				24.36
			],
			[
				"2007-07-27",
				11.96
			],
			[
				"2008-06-19",
				20.37
			],
			[
				"2009-10-22",
				23.03
			],
			[
				"2010-06-09",
				27.46
			],
			[
				"2011-07-07",
				27.9
			],
			[
				"2012-08-03",
				23.91
			]
		],
		"100700238": [
			[
				"2000-04-12",
				40.81
			],
			[
				"2000-10-17",
				48.82
			],
			[
				"2001-04-24",
				51.02
			],
			[
				"2001-10-10",
				57.02
			],
			[
				"2002-04-03",
				62.02
			],
			[
				"2002-11-12",
				57.02
			],
			[
				"2003-04-15",
				46.02
			],
			[
				"2004-04-21",
				45.02
			],
			[
				"2003-11-19",
				42.01
			],
			[
				"2004-10-21",
				46.02
			],
			[
				"2005-04-20",
				48.02
			],
			[
				"2005-10-19",
				39.01
			],
			[
				"2006-04-26",
				45.02
			],
			[
				"2007-04-18",
				47.02
			],
			[
				"2007-10-17",
				49.02
			],
			[
				"2008-04-17",
				49.02
			],
			[
				"2008-10-15",
				48.02
			],
			[
				"2006-11-03",
				45.02
			],
			[
				"2009-04-16",
				45.02
			],
			[
				"2009-10-21",
				45.02
			],
			[
				"2010-04-22",
				47.02
			],
			[
				"2010-10-21",
				46.02
			],
			[
				"2012-10-25",
				44.02
			],
			[
				"2012-04-18",
				48.02
			],
			[
				"2013-10-16",
				44.02
			],
			[
				"2013-04-17",
				39.01
			],
			[
				"2014-10-07",
				44.02
			],
			[
				"2014-04-16",
				40.01
			],
			[
				"2015-10-22",
				47.02
			],
			[
				"2015-04-21",
				51.02
			]
		],
		"100700512": [
			[
				"2000-03-16",
				77.03
			],
			[
				"2000-11-08",
				74.03
			],
			[
				"2001-04-09",
				70.02
			],
			[
				"2001-10-17",
				73.03
			],
			[
				"2002-10-14",
				68.02
			],
			[
				"2002-05-08",
				65.02
			],
			[
				"2003-04-14",
				69.02
			],
			[
				"2003-11-06",
				60.02
			],
			[
				"2004-04-02",
				81.03
			],
			[
				"2004-10-04",
				52.02
			],
			[
				"2005-04-18",
				55.02
			],
			[
				"2005-10-18",
				72.03
			],
			[
				"2006-04-10",
				73.03
			],
			[
				"2006-11-20",
				66.02
			],
			[
				"2007-04-16",
				72.03
			],
			[
				"2008-04-15",
				67.02
			],
			[
				"2008-10-27",
				74.03
			],
			[
				"2009-04-15",
				73.03
			],
			[
				"2009-10-12",
				6
			],
			[
				"2010-04-26",
				68.02
			],
			[
				"2010-10-11",
				64.02
			],
			[
				"2012-10-30",
				70.02
			],
			[
				"2012-04-16",
				76.03
			],
			[
				"2013-09-30",
				68.02
			],
			[
				"2013-04-15",
				69.02
			],
			[
				"2014-09-29",
				68.02
			],
			[
				"2014-04-14",
				72.03
			],
			[
				"2015-10-19",
				68.02
			],
			[
				"2015-05-26",
				70.02
			]
		],
		"100700550": [
			[
				"2000-03-16",
				12
			],
			[
				"2000-11-08",
				14
			],
			[
				"2001-04-09",
				13
			],
			[
				"2001-10-17",
				13
			],
			[
				"2002-10-14",
				6
			],
			[
				"2002-05-08",
				2
			],
			[
				"2003-04-14",
				9
			],
			[
				"2003-11-06",
				12
			],
			[
				"2004-04-02",
				22.01
			],
			[
				"2004-10-04",
				10
			],
			[
				"2005-04-18",
				6
			],
			[
				"2005-10-18",
				13
			],
			[
				"2006-04-10",
				1
			],
			[
				"2006-11-20",
				1
			],
			[
				"2007-10-15",
				10
			],
			[
				"2008-04-15",
				13
			],
			[
				"2008-10-27",
				18.01
			],
			[
				"2009-04-15",
				18.01
			],
			[
				"2009-10-12",
				18.01
			],
			[
				"2010-04-26",
				10
			],
			[
				"2010-10-11",
				14
			],
			[
				"2012-10-30",
				17.01
			],
			[
				"2012-04-16",
				17.01
			],
			[
				"2013-09-30",
				13
			],
			[
				"2013-04-15",
				16.01
			],
			[
				"2014-09-29",
				18.01
			],
			[
				"2014-04-14",
				17.01
			],
			[
				"2015-10-19",
				16.01
			],
			[
				"2015-05-26",
				14
			]
		],
		"100701255": [
			[
				"2000-03-13",
				9
			],
			[
				"2000-10-02",
				7
			],
			[
				"2001-03-05",
				4
			],
			[
				"2001-09-10",
				7
			],
			[
				"2002-03-11",
				3
			],
			[
				"2006-03-20",
				2
			],
			[
				"2002-09-16",
				2
			],
			[
				"2006-09-07",
				5
			],
			[
				"2005-09-12",
				6
			],
			[
				"2005-03-29",
				4
			],
			[
				"2003-09-08",
				6
			],
			[
				"2004-09-13",
				4
			],
			[
				"2004-03-15",
				6.2
			],
			[
				"2003-03-17",
				11
			],
			[
				"2007-03-12",
				2
			],
			[
				"2007-09-24",
				4
			],
			[
				"2008-03-31",
				7
			],
			[
				"2008-09-08",
				5
			],
			[
				"2009-03-09",
				3
			],
			[
				"2009-09-14",
				5
			],
			[
				"2010-03-22",
				1
			],
			[
				"2010-09-20",
				1
			],
			[
				"2012-09-10",
				2
			],
			[
				"2012-03-12",
				2
			],
			[
				"2013-09-09",
				1
			],
			[
				"2013-04-08",
				1
			],
			[
				"2014-09-15",
				2
			],
			[
				"2014-03-31",
				2
			],
			[
				"2015-09-28",
				1
			],
			[
				"2015-03-02",
				2
			]
		],
		"100701541": [
			[
				"2000-04-12",
				1
			],
			[
				"2000-10-18",
				1
			],
			[
				"2001-04-26",
				0.5
			],
			[
				"2001-11-06",
				1.4
			],
			[
				"2002-04-03",
				0.5
			],
			[
				"2002-11-12",
				0.5
			],
			[
				"2007-04-18",
				1
			],
			[
				"2007-10-17",
				1
			],
			[
				"2008-10-15",
				1
			],
			[
				"2006-04-26",
				1
			],
			[
				"2006-11-03",
				1
			],
			[
				"2009-10-21",
				1
			],
			[
				"2010-04-22",
				1
			],
			[
				"2010-10-21",
				1
			],
			[
				"2012-10-25",
				1
			],
			[
				"2012-04-18",
				1
			],
			[
				"2013-10-16",
				1
			],
			[
				"2013-04-17",
				1
			],
			[
				"2014-10-07",
				1
			],
			[
				"2014-04-16",
				1
			],
			[
				"2015-10-22",
				1
			],
			[
				"2015-06-17",
				1
			]
		],
		"100702119": [
			[
				"2000-04-07",
				36.01
			],
			[
				"2000-09-06",
				35.01
			],
			[
				"2001-03-02",
				35.01
			],
			[
				"2001-09-06",
				39.01
			],
			[
				"2002-10-02",
				37.01
			],
			[
				"2003-03-12",
				36.01
			],
			[
				"2003-09-11",
				39.01
			],
			[
				"2004-03-16",
				32.01
			],
			[
				"2004-09-07",
				32.01
			],
			[
				"2005-03-22",
				34.01
			],
			[
				"2005-09-02",
				31.01
			],
			[
				"2006-03-22",
				31.01
			],
			[
				"2006-09-06",
				31.01
			],
			[
				"2007-03-26",
				29.01
			],
			[
				"2007-10-08",
				31.01
			],
			[
				"2008-04-22",
				32.01
			],
			[
				"2008-10-08",
				29.01
			],
			[
				"2009-04-29",
				29.01
			],
			[
				"2009-10-20",
				30.01
			],
			[
				"2010-05-19",
				30.01
			],
			[
				"2012-05-23",
				29.01
			],
			[
				"2013-11-12",
				28.01
			],
			[
				"2013-05-22",
				29.01
			],
			[
				"2015-05-11",
				31.01
			]
		],
		"100702533": [
			[
				"2000-04-14",
				5
			],
			[
				"2000-10-12",
				5
			],
			[
				"2001-04-11",
				12
			],
			[
				"2001-10-11",
				3
			],
			[
				"2002-04-04",
				7
			],
			[
				"2004-05-27",
				3.4
			],
			[
				"2005-05-25",
				8
			],
			[
				"2004-11-03",
				1
			],
			[
				"2003-10-29",
				7
			],
			[
				"2003-04-10",
				5
			],
			[
				"2002-10-17",
				1
			],
			[
				"2005-11-10",
				2
			],
			[
				"2007-05-31",
				1
			],
			[
				"2009-10-13",
				5
			],
			[
				"2014-10-09",
				3
			],
			[
				"2014-06-18",
				1
			],
			[
				"2015-10-08",
				4
			]
		],
		"100703331": [
			[
				"2000-04-06",
				11
			],
			[
				"2002-04-11",
				11
			],
			[
				"2004-09-30",
				12
			],
			[
				"2004-09-30",
				12
			],
			[
				"2007-11-08",
				15.01
			],
			[
				"2008-04-10",
				15.01
			],
			[
				"2006-04-25",
				15.01
			],
			[
				"2009-11-12",
				14
			],
			[
				"2010-04-27",
				15.01
			],
			[
				"2012-05-03",
				11
			],
			[
				"2013-11-21",
				10
			],
			[
				"2014-05-13",
				13
			],
			[
				"2015-10-27",
				12
			]
		],
		"100705121": [
			[
				"2000-03-02",
				1
			],
			[
				"2000-10-27",
				1
			],
			[
				"2001-04-05",
				1
			],
			[
				"2001-10-30",
				1
			],
			[
				"2002-10-23",
				1
			],
			[
				"2005-10-06",
				1
			],
			[
				"2005-05-04",
				1
			],
			[
				"2006-04-05",
				1
			],
			[
				"2003-11-10",
				1
			],
			[
				"2003-04-29",
				1
			],
			[
				"2004-10-28",
				1
			],
			[
				"2004-05-28",
				1
			],
			[
				"2002-04-04",
				1
			],
			[
				"2006-10-06",
				1
			],
			[
				"2007-04-17",
				1
			],
			[
				"2007-10-25",
				1
			],
			[
				"2008-04-22",
				1
			],
			[
				"2008-10-06",
				1
			],
			[
				"2009-04-27",
				1
			],
			[
				"2009-10-19",
				1
			],
			[
				"2010-04-15",
				1
			],
			[
				"2010-10-27",
				1
			],
			[
				"2012-10-17",
				1
			],
			[
				"2012-04-30",
				1
			],
			[
				"2013-09-25",
				1
			],
			[
				"2013-04-09",
				1
			],
			[
				"2014-10-29",
				1
			],
			[
				"2014-05-05",
				1
			],
			[
				"2015-10-13",
				1
			],
			[
				"2015-04-15",
				2
			]
		],
		"100705170": [
			[
				"2000-03-02",
				1
			],
			[
				"2000-10-27",
				1
			],
			[
				"2001-04-05",
				1
			],
			[
				"2001-10-30",
				1
			],
			[
				"2002-10-23",
				1
			],
			[
				"2005-10-06",
				1
			],
			[
				"2006-04-05",
				1
			],
			[
				"2003-11-10",
				1
			],
			[
				"2003-04-29",
				1
			],
			[
				"2004-10-28",
				1
			],
			[
				"2004-05-28",
				1
			],
			[
				"2005-05-04",
				1
			],
			[
				"2002-04-04",
				1
			],
			[
				"2006-10-06",
				1
			],
			[
				"2007-04-17",
				1
			],
			[
				"2007-10-25",
				1
			],
			[
				"2008-04-22",
				1
			],
			[
				"2008-10-06",
				1
			],
			[
				"2009-04-27",
				1
			],
			[
				"2009-10-19",
				1
			],
			[
				"2010-04-15",
				1
			],
			[
				"2010-10-27",
				1
			],
			[
				"2012-10-17",
				1
			],
			[
				"2012-04-30",
				1
			],
			[
				"2013-09-25",
				1
			],
			[
				"2013-04-09",
				1
			],
			[
				"2014-10-29",
				1
			],
			[
				"2014-05-05",
				1
			],
			[
				"2015-10-13",
				1
			],
			[
				"2015-04-15",
				1
			]
		],
		"100706617": [
			[
				"2000-03-29",
				1
			],
			[
				"2000-10-31",
				1
			],
			[
				"2001-04-23",
				1
			],
			[
				"2001-10-23",
				1
			],
			[
				"2002-10-15",
				1
			],
			[
				"2003-11-20",
				1
			],
			[
				"2005-05-12",
				1
			],
			[
				"2005-11-23",
				1
			],
			[
				"2006-05-18",
				1
			],
			[
				"2007-05-03",
				1
			],
			[
				"2007-11-07",
				1
			],
			[
				"2008-04-29",
				2
			],
			[
				"2008-10-16",
				1
			],
			[
				"2009-05-07",
				1
			],
			[
				"2009-10-22",
				1
			],
			[
				"2010-04-29",
				1
			],
			[
				"2010-11-11",
				1
			],
			[
				"2012-11-13",
				1
			],
			[
				"2012-04-24",
				1
			],
			[
				"2013-10-31",
				1
			],
			[
				"2013-06-07",
				1
			],
			[
				"2014-10-14",
				1
			],
			[
				"2014-06-12",
				1
			],
			[
				"2015-11-10",
				1
			],
			[
				"2015-05-19",
				1
			]
		],
		"100706680": [
			[
				"2000-03-29",
				13
			],
			[
				"2000-10-31",
				16.01
			],
			[
				"2001-04-23",
				16.01
			],
			[
				"2001-10-23",
				20.01
			],
			[
				"2002-10-15",
				16.01
			],
			[
				"2003-11-20",
				18.01
			],
			[
				"2005-05-12",
				17.01
			],
			[
				"2005-11-23",
				21.01
			],
			[
				"2006-05-18",
				18.01
			],
			[
				"2007-05-03",
				19.01
			],
			[
				"2007-11-07",
				19.01
			],
			[
				"2008-04-29",
				20.01
			],
			[
				"2010-04-29",
				18.01
			],
			[
				"2010-11-11",
				16.01
			],
			[
				"2012-11-13",
				15.01
			],
			[
				"2012-04-24",
				15.01
			],
			[
				"2013-10-31",
				17.01
			],
			[
				"2013-06-07",
				28.01
			],
			[
				"2014-10-14",
				20.01
			],
			[
				"2014-06-12",
				22.01
			],
			[
				"2015-11-10",
				20.01
			],
			[
				"2015-05-19",
				19.01
			]
		],
		"100706940": [
			[
				"2003-11-20",
				1
			],
			[
				"2005-05-12",
				1
			],
			[
				"2005-11-23",
				1
			],
			[
				"2006-05-18",
				1
			],
			[
				"2007-05-03",
				1
			],
			[
				"2006-10-31",
				1
			],
			[
				"2007-11-07",
				1
			],
			[
				"2008-04-29",
				1
			],
			[
				"2008-10-16",
				1
			],
			[
				"2010-04-29",
				1
			],
			[
				"2010-11-11",
				1
			],
			[
				"2012-11-13",
				1
			],
			[
				"2012-04-24",
				1
			],
			[
				"2013-10-31",
				1
			],
			[
				"2013-06-07",
				1
			],
			[
				"2014-10-14",
				1
			],
			[
				"2014-06-12",
				1
			],
			[
				"2015-11-10",
				1
			],
			[
				"2015-05-19",
				1
			]
		],
		"100707543": [
			[
				"2000-04-07",
				39.01
			],
			[
				"2000-09-06",
				41.01
			],
			[
				"2001-03-03",
				42.01
			],
			[
				"2001-09-06",
				44.02
			],
			[
				"2002-03-06",
				40.01
			],
			[
				"2002-10-02",
				36.01
			],
			[
				"2003-03-12",
				36.01
			],
			[
				"2003-09-11",
				46.02
			],
			[
				"2004-03-16",
				39.01
			],
			[
				"2004-09-07",
				41.01
			],
			[
				"2005-03-22",
				44.02
			],
			[
				"2005-09-02",
				41.01
			],
			[
				"2006-03-22",
				41.01
			],
			[
				"2006-09-06",
				40.01
			],
			[
				"2007-03-26",
				39.01
			],
			[
				"2007-10-08",
				40.01
			],
			[
				"2008-04-22",
				41.01
			],
			[
				"2008-10-08",
				38.01
			],
			[
				"2009-04-29",
				38.01
			],
			[
				"2009-10-20",
				36.01
			],
			[
				"2010-05-19",
				34.01
			],
			[
				"2010-11-10",
				33.01
			],
			[
				"2012-10-10",
				32.01
			],
			[
				"2012-05-23",
				31.01
			],
			[
				"2013-11-12",
				28.01
			],
			[
				"2013-05-22",
				28.01
			],
			[
				"2014-10-28",
				22.01
			],
			[
				"2014-06-16",
				22.01
			],
			[
				"2015-10-16",
				20.01
			],
			[
				"2015-05-11",
				20.01
			]
		],
		"100720341": [
			[
				"2000-03-29",
				35.01
			],
			[
				"2000-09-27",
				35.01
			],
			[
				"2001-03-21",
				34.01
			],
			[
				"2001-09-21",
				32.01
			],
			[
				"2002-03-14",
				29.01
			],
			[
				"2002-09-25",
				37.01
			],
			[
				"2003-03-20",
				41.01
			],
			[
				"2003-09-25",
				41.01
			],
			[
				"2004-03-23",
				35.01
			],
			[
				"2004-09-27",
				35.01
			],
			[
				"2005-03-23",
				32.01
			],
			[
				"2006-03-29",
				29.01
			],
			[
				"2006-09-28",
				35.01
			],
			[
				"2007-03-27",
				35.01
			],
			[
				"2006-01-09",
				38.01
			],
			[
				"2006-02-20",
				35.01
			],
			[
				"2006-07-26",
				36.01
			],
			[
				"2006-10-25",
				37.01
			],
			[
				"2007-04-23",
				36.01
			],
			[
				"2007-05-31",
				36.01
			],
			[
				"2007-07-31",
				36.01
			],
			[
				"2007-01-29",
				35.01
			],
			[
				"2007-08-30",
				32.01
			],
			[
				"2007-10-24",
				33.01
			],
			[
				"2007-09-26",
				33.01
			],
			[
				"2008-04-23",
				39.01
			],
			[
				"2008-02-21",
				38.01
			],
			[
				"2008-03-26",
				37.01
			],
			[
				"2008-01-28",
				33.01
			],
			[
				"2008-05-19",
				34.01
			],
			[
				"2008-06-26",
				31.01
			],
			[
				"2008-10-24",
				38.01
			],
			[
				"2008-09-22",
				37.01
			],
			[
				"2008-08-25",
				36.01
			],
			[
				"2008-11-26",
				38.01
			],
			[
				"2008-12-15",
				43.02
			],
			[
				"2009-01-12",
				35.01
			],
			[
				"2009-02-10",
				35.01
			],
			[
				"2009-04-21",
				35.01
			],
			[
				"2009-05-15",
				35.01
			],
			[
				"2009-03-24",
				37.01
			],
			[
				"2009-07-31",
				38.01
			],
			[
				"2009-08-27",
				37.01
			],
			[
				"2009-11-10",
				38.01
			],
			[
				"2009-12-07",
				32.01
			],
			[
				"2009-06-19",
				33.01
			],
			[
				"2009-09-29",
				36.01
			],
			[
				"2009-10-22",
				35.01
			],
			[
				"2010-05-18",
				36.01
			],
			[
				"2010-02-22",
				34.01
			],
			[
				"2010-01-25",
				33.01
			],
			[
				"2010-04-09",
				44.02
			],
			[
				"2010-07-26",
				33.01
			],
			[
				"2010-09-21",
				34.01
			],
			[
				"2010-08-24",
				34.01
			],
			[
				"2010-06-28",
				31.01
			],
			[
				"2010-10-15",
				34.01
			],
			[
				"2010-12-06",
				37.01
			],
			[
				"2010-11-19",
				37.01
			],
			[
				"2012-12-05",
				37.01
			],
			[
				"2012-11-12",
				34.01
			],
			[
				"2012-10-10",
				35.01
			],
			[
				"2012-09-26",
				35.01
			],
			[
				"2012-08-06",
				36.01
			],
			[
				"2012-07-13",
				34.01
			],
			[
				"2012-06-25",
				36.01
			],
			[
				"2012-05-25",
				36.01
			],
			[
				"2012-04-16",
				38.01
			],
			[
				"2012-03-12",
				39.01
			],
			[
				"2012-02-27",
				39.01
			],
			[
				"2012-01-24",
				40.01
			],
			[
				"2013-11-18",
				33.01
			],
			[
				"2013-10-09",
				30.01
			],
			[
				"2013-09-16",
				30.01
			],
			[
				"2013-08-12",
				31.01
			],
			[
				"2013-07-01",
				32.01
			],
			[
				"2013-06-03",
				32.01
			],
			[
				"2013-05-08",
				32.01
			],
			[
				"2013-04-10",
				32.01
			],
			[
				"2013-03-19",
				33.01
			],
			[
				"2013-02-21",
				33.01
			],
			[
				"2013-01-10",
				35.01
			],
			[
				"2014-11-18",
				31.01
			],
			[
				"2014-10-23",
				32.01
			],
			[
				"2014-09-18",
				31.01
			],
			[
				"2014-08-05",
				33.01
			],
			[
				"2014-07-08",
				33.01
			],
			[
				"2014-05-06",
				32.01
			],
			[
				"2014-04-14",
				32.01
			],
			[
				"2014-03-24",
				34.01
			],
			[
				"2014-02-18",
				33.01
			],
			[
				"2014-01-13",
				33.01
			],
			[
				"2015-12-11",
				30.01
			],
			[
				"2015-11-26",
				30.01
			],
			[
				"2015-10-20",
				27.01
			],
			[
				"2015-09-24",
				29.01
			],
			[
				"2015-08-10",
				32.01
			],
			[
				"2015-07-13",
				30.01
			],
			[
				"2015-06-05",
				29.01
			],
			[
				"2015-05-12",
				29.01
			],
			[
				"2015-04-13",
				28.01
			],
			[
				"2015-03-26",
				29.01
			],
			[
				"2015-02-23",
				28.01
			]
		],
		"100721217": [
			[
				"2000-04-13",
				1
			],
			[
				"2000-10-12",
				2
			],
			[
				"2001-04-11",
				1
			],
			[
				"2001-10-11",
				1
			],
			[
				"2002-04-04",
				1
			],
			[
				"2004-05-27",
				1
			],
			[
				"2005-05-25",
				1
			],
			[
				"2006-11-14",
				1
			],
			[
				"2006-05-30",
				1
			],
			[
				"2005-11-10",
				1
			],
			[
				"2004-11-03",
				1
			],
			[
				"2003-10-29",
				1
			],
			[
				"2008-03-27",
				1
			],
			[
				"2008-10-14",
				1
			],
			[
				"2007-05-31",
				1
			],
			[
				"2007-10-10",
				1
			],
			[
				"2009-03-17",
				1
			],
			[
				"2009-10-13",
				1
			],
			[
				"2010-05-05",
				1
			],
			[
				"2010-10-05",
				1
			],
			[
				"2012-10-09",
				1
			],
			[
				"2012-04-10",
				1
			],
			[
				"2013-10-23",
				1
			],
			[
				"2013-04-29",
				1
			],
			[
				"2014-10-09",
				1
			],
			[
				"2014-04-22",
				1
			],
			[
				"2015-11-13",
				1
			],
			[
				"2015-04-16",
				1
			]
		],
		"100730024": [
			[
				"2000-02-29",
				53.02
			],
			[
				"2000-09-13",
				50.02
			],
			[
				"2001-03-14",
				49.02
			],
			[
				"2001-09-19",
				48.02
			],
			[
				"2002-03-13",
				50.02
			],
			[
				"2002-09-18",
				46.02
			],
			[
				"2002-03-13",
				50.02
			],
			[
				"2003-09-04",
				47.82
			],
			[
				"2003-03-11",
				54.12
			],
			[
				"2004-09-15",
				41.41
			],
			[
				"2004-03-16",
				47.52
			],
			[
				"2005-09-29",
				32.71
			],
			[
				"2005-04-06",
				37.21
			],
			[
				"2013-04-18",
				34.71
			],
			[
				"2013-10-08",
				32.71
			],
			[
				"2011-04-11",
				47.02
			],
			[
				"2011-10-20",
				33.41
			],
			[
				"2014-04-08",
				30.71
			],
			[
				"2014-10-21",
				26.71
			],
			[
				"2015-04-22",
				26.21
			],
			[
				"2015-10-20",
				27.41
			]
		],
		"100730050": [
			[
				"2002-10-16",
				20.01
			],
			[
				"2002-04-18",
				30.01
			],
			[
				"2006-10-20",
				25.01
			],
			[
				"2006-04-21",
				27.01
			],
			[
				"2005-11-23",
				28.01
			],
			[
				"2005-04-08",
				28.01
			],
			[
				"2004-11-11",
				24.01
			],
			[
				"2004-04-29",
				28.01
			],
			[
				"2003-10-29",
				28.01
			],
			[
				"2003-04-02",
				34.01
			],
			[
				"2001-09-13",
				29.01
			],
			[
				"2001-04-09",
				26.01
			],
			[
				"2000-09-14",
				25.01
			],
			[
				"2000-04-13",
				22.01
			],
			[
				"2008-03-14",
				21.01
			],
			[
				"2008-09-11",
				19.01
			],
			[
				"2007-04-25",
				24.01
			],
			[
				"2007-10-05",
				25.01
			],
			[
				"2009-04-21",
				19.01
			],
			[
				"2010-04-23",
				19.01
			],
			[
				"2010-10-22",
				17.01
			],
			[
				"2012-10-12",
				15.01
			],
			[
				"2012-04-23",
				16.01
			],
			[
				"2013-10-17",
				13
			],
			[
				"2013-04-29",
				14
			],
			[
				"2014-10-30",
				13
			],
			[
				"2014-04-22",
				13
			],
			[
				"2015-11-23",
				12
			],
			[
				"2015-04-24",
				13
			]
		],
		"100730103": [
			[
				"2000-03-01",
				28.01
			],
			[
				"2000-09-14",
				25.01
			],
			[
				"2001-03-15",
				26.01
			],
			[
				"2001-09-19",
				35.01
			],
			[
				"2002-03-13",
				29.01
			],
			[
				"2002-03-13",
				29.01
			],
			[
				"2003-09-04",
				33.01
			],
			[
				"2003-03-11",
				30.61
			],
			[
				"2004-09-15",
				30.91
			],
			[
				"2004-03-16",
				33.01
			],
			[
				"2005-09-29",
				32.31
			],
			[
				"2005-04-06",
				30.41
			],
			[
				"2013-04-18",
				31.21
			],
			[
				"2013-10-08",
				31.71
			],
			[
				"2011-04-11",
				36.91
			],
			[
				"2011-10-20",
				32.51
			],
			[
				"2014-04-08",
				33.11
			],
			[
				"2014-10-21",
				32.41
			],
			[
				"2015-04-22",
				30.51
			],
			[
				"2015-10-20",
				32.41
			]
		],
		"100731296": [
			[
				"2000-04-13",
				40.01
			],
			[
				"2000-10-12",
				34.01
			],
			[
				"2001-04-11",
				31.01
			],
			[
				"2001-10-11",
				34.01
			],
			[
				"2002-04-04",
				33.01
			],
			[
				"2004-05-27",
				38.01
			],
			[
				"2005-05-25",
				27.01
			],
			[
				"2006-11-14",
				30.01
			],
			[
				"2006-05-30",
				35.01
			],
			[
				"2005-11-10",
				44.02
			],
			[
				"2004-11-03",
				40.01
			],
			[
				"2003-10-29",
				34.01
			],
			[
				"2003-04-10",
				38.01
			],
			[
				"2002-10-17",
				34.01
			],
			[
				"2008-03-27",
				41.01
			],
			[
				"2008-10-14",
				43.02
			],
			[
				"2007-05-31",
				33.01
			],
			[
				"2007-10-10",
				40.01
			],
			[
				"2009-10-13",
				36.01
			],
			[
				"2010-05-05",
				36.01
			],
			[
				"2010-10-05",
				32.01
			],
			[
				"2012-04-10",
				41.01
			],
			[
				"2013-10-23",
				37.01
			],
			[
				"2013-04-29",
				37.01
			],
			[
				"2014-10-09",
				36.01
			],
			[
				"2014-04-22",
				37.01
			],
			[
				"2015-10-08",
				36.01
			],
			[
				"2015-04-16",
				34.01
			]
		],
		"100731478": [
			[
				"2013-04-22",
				47.83
			],
			[
				"2014-02-11",
				50.49
			],
			[
				"2015-06-24",
				35.07
			],
			[
				"2008-07-18",
				48.71
			],
			[
				"2009-11-12",
				44.29
			],
			[
				"2010-06-02",
				48.71
			],
			[
				"2011-09-20",
				44.29
			],
			[
				"2012-09-19",
				30.11
			]
		],
		"100740029": [
			[
				"2000-11-09",
				34.01
			],
			[
				"2002-11-12",
				36.01
			],
			[
				"2005-11-15",
				36.01
			],
			[
				"2003-10-14",
				34.01
			],
			[
				"2008-01-08",
				35.01
			],
			[
				"2008-04-14",
				37.01
			],
			[
				"2008-07-08",
				32.01
			],
			[
				"2008-10-06",
				37.01
			],
			[
				"2008-12-11",
				37.01
			],
			[
				"2009-05-11",
				36.01
			],
			[
				"2009-11-09",
				34.01
			],
			[
				"2010-05-10",
				34.01
			],
			[
				"2010-11-08",
				34.01
			],
			[
				"2013-11-11",
				35.01
			],
			[
				"2014-11-10",
				32.01
			],
			[
				"2014-05-12",
				35.01
			],
			[
				"2015-11-09",
				32.01
			],
			[
				"2015-05-11",
				32.01
			]
		],
		"100740522": [
			[
				"2000-05-09",
				42.01
			],
			[
				"2000-10-17",
				45.02
			],
			[
				"2001-05-08",
				45.02
			],
			[
				"2001-10-16",
				47.02
			],
			[
				"2002-11-14",
				45.02
			],
			[
				"2006-05-11",
				40.01
			],
			[
				"2003-11-19",
				40.01
			],
			[
				"2006-11-07",
				40.01
			],
			[
				"2005-11-22",
				47.02
			],
			[
				"2005-05-31",
				48.02
			],
			[
				"2004-11-10",
				44.02
			],
			[
				"2004-06-02",
				49.02
			],
			[
				"2003-05-08",
				38.01
			],
			[
				"2002-05-16",
				42.01
			],
			[
				"2008-04-17",
				54.02
			],
			[
				"2008-10-28",
				52.02
			],
			[
				"2009-06-17",
				44.02
			],
			[
				"2009-11-03",
				38.01
			],
			[
				"2007-12-14",
				47.02
			],
			[
				"2007-05-22",
				45.02
			],
			[
				"2007-11-15",
				49.02
			],
			[
				"2010-05-04",
				43.02
			],
			[
				"2010-06-22",
				43.02
			],
			[
				"2010-09-14",
				49.02
			],
			[
				"2010-11-03",
				48.02
			],
			[
				"2012-10-23",
				51.02
			],
			[
				"2012-09-12",
				45.02
			],
			[
				"2012-06-26",
				45.02
			],
			[
				"2012-04-17",
				51.02
			],
			[
				"2012-04-03",
				52.02
			],
			[
				"2012-01-11",
				50.02
			],
			[
				"2013-10-29",
				51.02
			],
			[
				"2013-09-17",
				52.02
			],
			[
				"2013-06-25",
				54.02
			],
			[
				"2013-05-28",
				54.02
			],
			[
				"2013-04-02",
				48.02
			],
			[
				"2013-01-08",
				53.02
			],
			[
				"2014-10-30",
				52.02
			],
			[
				"2014-09-16",
				60.02
			],
			[
				"2014-06-24",
				57.02
			],
			[
				"2014-04-01",
				41.01
			],
			[
				"2014-01-07",
				45.02
			],
			[
				"2015-06-24",
				62.02
			],
			[
				"2015-03-31",
				58.02
			],
			[
				"2015-01-07",
				39.01
			]
		],
		"100741010": [
			[
				"2000-10-17",
				24.01
			],
			[
				"2000-05-09",
				34.01
			],
			[
				"2001-05-08",
				22.01
			],
			[
				"2001-10-15",
				20.01
			],
			[
				"2002-11-14",
				22.01
			],
			[
				"2004-11-10",
				14
			],
			[
				"2003-11-13",
				24.01
			],
			[
				"2006-05-11",
				13
			],
			[
				"2002-05-16",
				22.01
			],
			[
				"2006-11-07",
				10
			],
			[
				"2005-11-22",
				10
			],
			[
				"2007-05-22",
				33.01
			],
			[
				"2007-11-14",
				19.01
			],
			[
				"2003-05-08",
				22.01
			],
			[
				"2008-04-17",
				23.01
			],
			[
				"2008-10-28",
				17.01
			],
			[
				"2009-11-03",
				22.01
			],
			[
				"2009-06-17",
				27.01
			],
			[
				"2010-05-04",
				15.01
			],
			[
				"2010-11-04",
				13
			],
			[
				"2012-12-13",
				11
			],
			[
				"2012-04-17",
				13
			],
			[
				"2013-10-29",
				7
			],
			[
				"2013-05-28",
				9
			],
			[
				"2014-10-30",
				9
			],
			[
				"2014-06-24",
				7
			],
			[
				"2015-03-31",
				6
			]
		],
		"100741654": [
			[
				"2000-05-09",
				33.01
			],
			[
				"2000-10-17",
				31.01
			],
			[
				"2001-05-08",
				30.01
			],
			[
				"2001-10-16",
				31.01
			],
			[
				"2002-11-14",
				33.01
			],
			[
				"2006-11-07",
				30.01
			],
			[
				"2006-05-11",
				29.01
			],
			[
				"2005-11-22",
				30.01
			],
			[
				"2004-11-10",
				27.01
			],
			[
				"2004-06-02",
				30.01
			],
			[
				"2003-11-13",
				28.01
			],
			[
				"2003-05-08",
				29.01
			],
			[
				"2002-05-16",
				30.01
			],
			[
				"2007-05-22",
				30.01
			],
			[
				"2007-11-14",
				29.01
			],
			[
				"2008-04-17",
				33.01
			],
			[
				"2008-10-28",
				32.01
			],
			[
				"2009-06-17",
				31.01
			],
			[
				"2009-11-04",
				43.02
			],
			[
				"2010-05-04",
				30.01
			],
			[
				"2010-11-03",
				31.01
			],
			[
				"2012-10-23",
				30.01
			],
			[
				"2012-04-17",
				32.01
			],
			[
				"2013-10-29",
				28.01
			],
			[
				"2013-05-28",
				29.01
			],
			[
				"2014-10-30",
				30.01
			],
			[
				"2014-06-24",
				32.01
			],
			[
				"2015-03-31",
				30.01
			]
		],
		"100742208": [
			[
				"2000-10-18",
				1
			],
			[
				"2000-05-09",
				1
			],
			[
				"2001-10-15",
				1
			],
			[
				"2001-05-08",
				1
			],
			[
				"2002-11-20",
				1
			],
			[
				"2002-05-16",
				1
			],
			[
				"2006-05-11",
				1
			],
			[
				"2005-11-22",
				1
			],
			[
				"2005-05-31",
				1
			],
			[
				"2004-08-05",
				1
			],
			[
				"2004-06-02",
				1
			],
			[
				"2003-11-13",
				11
			],
			[
				"2003-05-08",
				1
			],
			[
				"2006-11-07",
				1
			],
			[
				"2007-05-22",
				1
			],
			[
				"2007-11-15",
				1
			],
			[
				"2008-11-11",
				1
			],
			[
				"2009-11-03",
				1
			],
			[
				"2009-06-17",
				1
			],
			[
				"2010-05-04",
				2
			],
			[
				"2010-11-04",
				1
			],
			[
				"2012-12-13",
				1
			],
			[
				"2013-10-30",
				1
			],
			[
				"2014-10-30",
				1
			],
			[
				"2014-07-11",
				1
			],
			[
				"2015-03-31",
				1
			]
		],
		"100742427": [
			[
				"2000-03-23",
				10
			],
			[
				"2001-03-15",
				3
			],
			[
				"2002-03-14",
				11
			],
			[
				"2006-04-04",
				10
			],
			[
				"2006-11-22",
				11
			],
			[
				"2007-10-23",
				13
			],
			[
				"2010-06-01",
				8.6
			],
			[
				"2009-10-26",
				12
			],
			[
				"2008-05-14",
				13
			],
			[
				"2008-10-28",
				12
			],
			[
				"2009-05-11",
				14
			],
			[
				"2010-10-21",
				7.8
			],
			[
				"2011-05-18",
				7.2
			],
			[
				"2011-11-10",
				7.5
			],
			[
				"2012-05-15",
				6.2
			],
			[
				"2012-11-15",
				6.6
			],
			[
				"2013-05-16",
				6.7
			],
			[
				"2013-11-07",
				6.4
			],
			[
				"2014-05-21",
				5.8
			],
			[
				"2015-05-05",
				6.8
			],
			[
				"2014-11-06",
				9.7
			],
			[
				"2015-11-05",
				9.8
			]
		],
		"100744412": [
			[
				"2000-03-23",
				1
			],
			[
				"2001-03-15",
				1
			],
			[
				"2001-12-13",
				1
			],
			[
				"2002-03-14",
				1
			],
			[
				"2002-07-29",
				1
			],
			[
				"2006-11-22",
				0.2
			],
			[
				"2007-10-22",
				0.4
			],
			[
				"2008-05-13",
				2.1
			],
			[
				"2008-10-28",
				0.6
			],
			[
				"2009-05-14",
				4.5
			],
			[
				"2009-10-26",
				1.7
			],
			[
				"2010-10-20",
				1.4
			],
			[
				"2011-05-17",
				2.2
			],
			[
				"2011-11-09",
				0.9
			],
			[
				"2012-05-10",
				1.1
			],
			[
				"2012-11-14",
				1.5
			],
			[
				"2013-05-15",
				4.2
			],
			[
				"2013-11-06",
				1.4
			],
			[
				"2014-05-21",
				2.8
			],
			[
				"2015-05-06",
				4.6
			],
			[
				"2014-11-05",
				2.4
			],
			[
				"2015-11-04",
				1
			]
		],
		"100746410": [
			[
				"2000-03-23",
				36.01
			],
			[
				"2000-09-22",
				41.01
			],
			[
				"2001-03-15",
				37.01
			],
			[
				"2001-09-27",
				38.01
			],
			[
				"2002-03-14",
				39.01
			],
			[
				"2002-09-26",
				43.02
			],
			[
				"2008-03-17",
				20.01
			],
			[
				"2008-05-14",
				36.01
			],
			[
				"2010-05-31",
				33.01
			],
			[
				"2009-10-28",
				34.01
			],
			[
				"2009-05-14",
				38.01
			],
			[
				"2008-10-29",
				40.01
			],
			[
				"2010-10-21",
				33.01
			],
			[
				"2011-05-18",
				35.01
			],
			[
				"2011-11-10",
				39.01
			],
			[
				"2012-05-15",
				39.01
			],
			[
				"2012-11-14",
				36.01
			],
			[
				"2013-05-16",
				37.01
			],
			[
				"2013-11-06",
				35.01
			],
			[
				"2014-05-23",
				36.01
			],
			[
				"2015-05-06",
				35.01
			],
			[
				"2014-11-06",
				36.01
			],
			[
				"2015-11-04",
				39.01
			]
		],
		"100748454": [
			[
				"2013-05-02",
				30.56
			],
			[
				"2014-04-29",
				33.21
			],
			[
				"2015-02-12",
				37.2
			],
			[
				"2016-02-17",
				34.1
			],
			[
				"2001-05-07",
				27.81
			],
			[
				"2001-11-05",
				31.01
			],
			[
				"2000-05-02",
				29.01
			],
			[
				"2000-10-31",
				37.01
			],
			[
				"2002-05-07",
				29.01
			],
			[
				"2002-11-05",
				28.01
			],
			[
				"2003-05-07",
				29.01
			],
			[
				"2003-11-03",
				34.01
			],
			[
				"2004-05-04",
				30.01
			],
			[
				"2004-11-04",
				38.01
			],
			[
				"2005-05-10",
				28.01
			],
			[
				"2005-11-07",
				33.01
			],
			[
				"2006-05-08",
				23.01
			],
			[
				"2006-11-08",
				30.01
			],
			[
				"2006-10-11",
				31.44
			],
			[
				"2007-10-17",
				28.34
			],
			[
				"2008-06-12",
				29.23
			],
			[
				"2008-05-06",
				31.01
			],
			[
				"2008-11-05",
				27.01
			],
			[
				"2009-05-05",
				27.01
			],
			[
				"2009-11-04",
				30.01
			],
			[
				"2010-05-04",
				25.01
			],
			[
				"2010-11-01",
				28.01
			],
			[
				"2011-05-03",
				26.01
			],
			[
				"2011-11-07",
				35.01
			],
			[
				"2012-05-07",
				37.01
			],
			[
				"2012-11-05",
				37.01
			],
			[
				"2013-05-06",
				32.01
			],
			[
				"2013-12-09",
				34.01
			],
			[
				"2014-05-05",
				33.01
			],
			[
				"2014-11-03",
				33.01
			],
			[
				"2009-10-13",
				34.99
			],
			[
				"2008-08-20",
				33.66
			],
			[
				"2010-06-02",
				29.67
			],
			[
				"2011-06-16",
				31
			],
			[
				"2012-08-04",
				34.54
			]
		],
		"100750059": [
			[
				"2001-05-07",
				23.01
			],
			[
				"2001-11-05",
				23.01
			],
			[
				"2002-11-04",
				18.01
			],
			[
				"2002-05-06",
				15.01
			],
			[
				"2003-05-06",
				20.01
			],
			[
				"2006-04-07",
				20.01
			],
			[
				"2004-04-05",
				20.01
			],
			[
				"2005-04-01",
				15.01
			],
			[
				"2006-10-13",
				11
			],
			[
				"2005-10-11",
				14
			],
			[
				"2004-10-11",
				12
			],
			[
				"2008-04-29",
				17.01
			],
			[
				"2008-10-20",
				14
			],
			[
				"2007-05-07",
				19.01
			],
			[
				"2007-10-22",
				22.01
			],
			[
				"2009-10-05",
				12
			],
			[
				"2010-04-23",
				19.01
			],
			[
				"2010-10-18",
				13
			],
			[
				"2012-10-22",
				14
			],
			[
				"2012-04-19",
				19.01
			],
			[
				"2013-11-05",
				17.01
			],
			[
				"2013-05-06",
				16.01
			],
			[
				"2014-10-20",
				15.01
			],
			[
				"2014-04-28",
				15.01
			],
			[
				"2015-10-12",
				15.01
			],
			[
				"2015-04-20",
				18.01
			]
		],
		"100760156": [
			[
				"2000-03-22",
				7
			],
			[
				"2000-11-07",
				10
			],
			[
				"2001-03-27",
				7
			],
			[
				"2001-09-24",
				8
			],
			[
				"2002-03-19",
				6
			],
			[
				"2002-09-18",
				7
			],
			[
				"2003-11-12",
				8
			],
			[
				"2004-09-09",
				8
			],
			[
				"2004-04-06",
				1
			],
			[
				"2005-03-31",
				6
			],
			[
				"2008-09-11",
				4
			],
			[
				"2008-03-18",
				3
			],
			[
				"2009-04-02",
				4
			],
			[
				"2009-09-09",
				6
			],
			[
				"2010-03-31",
				7
			],
			[
				"2010-11-16",
				7
			],
			[
				"2012-09-25",
				8
			],
			[
				"2012-04-12",
				7
			],
			[
				"2013-10-24",
				5
			],
			[
				"2013-04-25",
				6
			],
			[
				"2014-09-23",
				7
			],
			[
				"2014-03-20",
				8
			],
			[
				"2015-10-05",
				7
			],
			[
				"2015-04-14",
				6
			]
		],
		"100760168": [
			[
				"2000-11-07",
				1
			],
			[
				"2001-09-24",
				1
			],
			[
				"2002-09-18",
				2
			],
			[
				"2003-11-12",
				1
			],
			[
				"2004-09-09",
				1
			],
			[
				"2008-09-11",
				1
			],
			[
				"2009-09-09",
				1
			],
			[
				"2010-11-16",
				1
			],
			[
				"2012-09-25",
				1
			],
			[
				"2013-10-24",
				1
			],
			[
				"2014-09-23",
				1
			],
			[
				"2015-10-05",
				1
			]
		],
		"100761161": [
			[
				"2000-11-07",
				22.01
			],
			[
				"2001-06-20",
				22.01
			],
			[
				"2001-09-24",
				28.01
			],
			[
				"2002-03-19",
				32.01
			],
			[
				"2002-09-18",
				26.01
			],
			[
				"2003-11-12",
				21.01
			],
			[
				"2004-09-09",
				18.01
			],
			[
				"2003-03-18",
				23.01
			],
			[
				"2004-04-06",
				30.01
			],
			[
				"2005-03-31",
				20.01
			],
			[
				"2005-09-22",
				21.01
			],
			[
				"2008-09-11",
				19.01
			],
			[
				"2008-03-18",
				21.01
			],
			[
				"2009-09-09",
				18.01
			],
			[
				"2009-04-02",
				21.01
			],
			[
				"2010-03-31",
				25.01
			],
			[
				"2010-11-16",
				26.01
			],
			[
				"2012-09-25",
				18.01
			],
			[
				"2012-04-12",
				20.01
			],
			[
				"2013-10-24",
				17.01
			],
			[
				"2013-04-25",
				21.01
			],
			[
				"2014-09-23",
				16.01
			],
			[
				"2014-03-20",
				18.01
			],
			[
				"2015-10-05",
				21.01
			],
			[
				"2015-04-14",
				21.01
			]
		],
		"100761410": [
			[
				"2000-03-01",
				1
			],
			[
				"2000-09-04",
				1
			],
			[
				"2001-03-06",
				1
			],
			[
				"2001-10-08",
				1
			],
			[
				"2006-03-22",
				1
			],
			[
				"2006-09-01",
				1
			],
			[
				"2007-03-28",
				1
			],
			[
				"2007-09-25",
				1
			],
			[
				"2008-09-25",
				1
			],
			[
				"2008-03-19",
				1
			],
			[
				"2009-09-02",
				1
			],
			[
				"2009-03-18",
				1
			],
			[
				"2010-03-11",
				1
			],
			[
				"2010-09-08",
				1
			],
			[
				"2012-11-13",
				1
			],
			[
				"2012-05-08",
				1
			],
			[
				"2013-10-21",
				1
			],
			[
				"2013-04-26",
				1
			],
			[
				"2014-05-06",
				1
			],
			[
				"2015-11-04",
				1
			],
			[
				"2015-01-15",
				1
			],
			[
				"2015-01-14",
				1
			]
		],
		"100761616": [
			[
				"2000-03-22",
				75.03
			],
			[
				"2001-03-28",
				80.03
			],
			[
				"2002-03-20",
				67.02
			],
			[
				"2003-03-18",
				68.02
			],
			[
				"2004-04-06",
				75.03
			],
			[
				"2005-03-31",
				59.02
			],
			[
				"2008-03-18",
				60.02
			],
			[
				"2009-04-02",
				61.02
			],
			[
				"2010-03-31",
				60.02
			],
			[
				"2012-04-12",
				62.02
			],
			[
				"2013-04-25",
				53.02
			],
			[
				"2014-03-20",
				54.02
			],
			[
				"2015-04-14",
				53.02
			]
		],
		"100790318": [
			[
				"2000-03-20",
				7
			],
			[
				"2000-10-10",
				7
			],
			[
				"2001-06-11",
				7
			],
			[
				"2001-11-08",
				7
			],
			[
				"2002-05-16",
				7
			],
			[
				"2002-11-13",
				7
			],
			[
				"2003-03-24",
				7
			],
			[
				"2003-11-18",
				7
			],
			[
				"2004-05-05",
				7
			],
			[
				"2004-11-08",
				8
			],
			[
				"2005-05-11",
				7
			],
			[
				"2005-11-08",
				8
			],
			[
				"2006-11-14",
				8
			],
			[
				"2006-05-15",
				8
			],
			[
				"2007-03-26",
				8
			],
			[
				"2007-11-12",
				8
			],
			[
				"2008-03-26",
				7
			],
			[
				"2008-10-13",
				8
			],
			[
				"2009-05-11",
				8
			],
			[
				"2009-09-28",
				8
			],
			[
				"2010-04-26",
				8
			],
			[
				"2010-11-02",
				10
			],
			[
				"2011-05-09",
				8
			],
			[
				"2011-11-02",
				8
			],
			[
				"2012-05-14",
				8
			],
			[
				"2012-10-15",
				8
			],
			[
				"2013-06-04",
				9
			],
			[
				"2013-11-12",
				10
			],
			[
				"2014-04-10",
				9
			],
			[
				"2014-11-13",
				9
			],
			[
				"2015-05-19",
				8
			],
			[
				"2015-11-10",
				9
			]
		],
		"100791554": [
			[
				"2000-03-30",
				32.01
			],
			[
				"2000-10-16",
				48.02
			],
			[
				"2001-05-14",
				68.02
			],
			[
				"2002-11-15",
				48.02
			],
			[
				"2015-10-28",
				37.01
			]
		],
		"104004046": [
			[
				"2013-04-30",
				60.23
			],
			[
				"2014-04-08",
				49.16
			],
			[
				"2015-04-09",
				51.37
			],
			[
				"2001-12-12",
				52.26
			],
			[
				"2002-06-11",
				52.7
			],
			[
				"2002-09-04",
				69.53
			],
			[
				"2002-11-28",
				74.4
			],
			[
				"2003-09-10",
				35.07
			],
			[
				"2004-09-14",
				43.62
			],
			[
				"2005-10-24",
				44.29
			],
			[
				"2006-09-06",
				2.21
			],
			[
				"2007-08-08",
				44.29
			],
			[
				"2003-03-06",
				77.94
			],
			[
				"2012-09-13",
				2.21
			]
		],
		"106500028": [
			[
				"2013-05-27",
				28.34
			],
			[
				"2014-02-04",
				35.87
			],
			[
				"2015-02-12",
				33.88
			],
			[
				"2016-01-26",
				33.66
			],
			[
				"2000-08-31",
				34.99
			],
			[
				"2000-10-12",
				34.54
			],
			[
				"2001-04-18",
				31.89
			],
			[
				"2003-09-23",
				32.06
			],
			[
				"2004-06-21",
				23.65
			],
			[
				"2005-06-24",
				30.56
			],
			[
				"2005-08-30",
				30.56
			],
			[
				"2005-04-21",
				29.23
			],
			[
				"2006-10-11",
				30.56
			],
			[
				"2007-06-14",
				31
			],
			[
				"2008-06-12",
				32.33
			],
			[
				"2009-10-15",
				34.54
			],
			[
				"2008-08-14",
				31
			],
			[
				"2010-09-15",
				32.33
			],
			[
				"2011-06-16",
				30.56
			],
			[
				"2012-06-27",
				29.23
			]
		],
		"106500041": [
			[
				"2000-12-14",
				31.01
			],
			[
				"2000-10-05",
				32.01
			],
			[
				"2001-05-14",
				32.01
			],
			[
				"2001-10-22",
				33.01
			],
			[
				"2006-10-30",
				28.01
			],
			[
				"2007-04-26",
				32.01
			],
			[
				"2007-09-28",
				30.01
			],
			[
				"2008-04-08",
				31.01
			],
			[
				"2008-10-23",
				31.01
			],
			[
				"2009-04-24",
				30.01
			],
			[
				"2009-09-22",
				27.01
			],
			[
				"2010-04-28",
				30.01
			],
			[
				"2010-09-10",
				29.01
			],
			[
				"2012-09-21",
				27.01
			],
			[
				"2012-05-02",
				29.01
			],
			[
				"2013-12-09",
				26.01
			],
			[
				"2013-05-16",
				26.01
			],
			[
				"2014-12-15",
				25.01
			],
			[
				"2014-05-20",
				27.01
			],
			[
				"2015-11-24",
				25.01
			],
			[
				"2015-05-26",
				26.01
			]
		],
		"106500053": [
			[
				"2013-05-02",
				3.01
			],
			[
				"2015-02-25",
				14.66
			],
			[
				"2016-02-17",
				14.61
			],
			[
				"2000-07-10",
				15.94
			],
			[
				"2002-11-21",
				15.94
			],
			[
				"2005-04-28",
				15.94
			],
			[
				"2005-06-24",
				17.27
			],
			[
				"2006-10-19",
				14.61
			],
			[
				"2007-07-13",
				15.5
			],
			[
				"2008-05-19",
				16.83
			],
			[
				"2010-06-21",
				15.06
			],
			[
				"2011-06-08",
				15.06
			],
			[
				"2012-04-25",
				14.17
			]
		],
		"106501100": [
			[
				"2000-05-08",
				33.01
			],
			[
				"2000-11-13",
				30.01
			],
			[
				"2001-10-01",
				29.01
			],
			[
				"2002-04-23",
				28.01
			],
			[
				"2002-10-21",
				31.01
			],
			[
				"2003-03-20",
				31.01
			],
			[
				"2003-12-01",
				27.01
			],
			[
				"2004-03-16",
				34.01
			],
			[
				"2004-09-28",
				29.01
			],
			[
				"2005-09-26",
				26.01
			],
			[
				"2006-11-09",
				28.01
			],
			[
				"2006-06-07",
				31.01
			],
			[
				"2007-03-19",
				31.01
			],
			[
				"2007-11-15",
				31.01
			],
			[
				"2008-05-08",
				29.01
			],
			[
				"2008-10-23",
				28.01
			],
			[
				"2009-05-04",
				25.01
			],
			[
				"2009-10-13",
				26.01
			],
			[
				"2010-03-23",
				33.01
			],
			[
				"2010-09-30",
				30.01
			],
			[
				"2011-05-03",
				23.01
			],
			[
				"2011-11-07",
				26.01
			],
			[
				"2012-04-16",
				28.01
			],
			[
				"2012-11-21",
				26.01
			],
			[
				"2013-04-23",
				28.01
			],
			[
				"2013-11-18",
				24.01
			],
			[
				"2014-05-21",
				28.01
			],
			[
				"2014-11-17",
				26.01
			],
			[
				"2015-03-30",
				28.01
			],
			[
				"2015-10-14",
				27.01
			]
		],
		"106501926": [
			[
				"2000-03-22",
				22.01
			],
			[
				"2001-06-13",
				26.01
			],
			[
				"2002-05-16",
				22.01
			],
			[
				"2002-11-12",
				15.01
			],
			[
				"2003-03-25",
				18.01
			],
			[
				"2004-06-16",
				21.01
			],
			[
				"2006-05-22",
				22.01
			],
			[
				"2007-03-26",
				20.01
			],
			[
				"2007-11-12",
				18.01
			],
			[
				"2008-05-20",
				22.01
			],
			[
				"2008-10-13",
				21.01
			],
			[
				"2009-05-11",
				21.01
			],
			[
				"2009-09-28",
				21.01
			],
			[
				"2010-04-27",
				21.01
			],
			[
				"2010-11-02",
				20.01
			],
			[
				"2011-05-09",
				21.01
			],
			[
				"2011-11-02",
				20.01
			],
			[
				"2012-04-04",
				21.01
			],
			[
				"2012-04-12",
				21.01
			],
			[
				"2012-04-18",
				21.01
			],
			[
				"2012-04-26",
				21.01
			],
			[
				"2012-05-02",
				21.01
			],
			[
				"2012-05-14",
				20.01
			],
			[
				"2012-06-12",
				19.01
			],
			[
				"2012-07-02",
				21.01
			],
			[
				"2012-08-01",
				21.01
			],
			[
				"2012-09-03",
				19.01
			],
			[
				"2012-10-02",
				19.01
			],
			[
				"2012-10-16",
				21.01
			],
			[
				"2012-11-19",
				21.01
			],
			[
				"2012-12-03",
				20.01
			],
			[
				"2013-01-14",
				20.01
			],
			[
				"2013-02-04",
				21.01
			],
			[
				"2013-03-04",
				21.01
			],
			[
				"2013-04-02",
				21.01
			],
			[
				"2013-05-06",
				21.01
			],
			[
				"2013-06-11",
				20.01
			],
			[
				"2013-07-02",
				21.01
			],
			[
				"2013-08-05",
				18.01
			],
			[
				"2013-09-03",
				21.01
			],
			[
				"2013-10-07",
				21.01
			],
			[
				"2013-11-04",
				20.01
			],
			[
				"2013-11-13",
				21.01
			],
			[
				"2013-12-02",
				22.01
			],
			[
				"2014-01-06",
				22.01
			],
			[
				"2014-02-04",
				20.01
			],
			[
				"2014-03-03",
				20.01
			],
			[
				"2014-04-01",
				21.01
			],
			[
				"2014-04-08",
				20.01
			],
			[
				"2014-08-11",
				22.01
			],
			[
				"2014-09-16",
				21.01
			],
			[
				"2014-10-07",
				21.01
			],
			[
				"2014-11-05",
				20.01
			],
			[
				"2014-11-12",
				21.01
			],
			[
				"2014-12-02",
				20.01
			],
			[
				"2015-01-05",
				19.01
			],
			[
				"2015-02-10",
				19.01
			],
			[
				"2015-03-02",
				20.01
			],
			[
				"2015-04-01",
				20.01
			],
			[
				"2015-05-04",
				21.01
			],
			[
				"2015-05-18",
				19.01
			],
			[
				"2015-06-08",
				21.01
			],
			[
				"2015-07-01",
				21.01
			],
			[
				"2015-08-04",
				21.01
			],
			[
				"2015-09-03",
				21.01
			],
			[
				"2015-10-19",
				21.01
			]
		],
		"106501987": [
			[
				"2000-03-20",
				7
			],
			[
				"2001-06-11",
				5
			],
			[
				"2002-05-14",
				6
			],
			[
				"2003-03-24",
				6
			],
			[
				"2004-05-04",
				5
			],
			[
				"2004-11-08",
				5
			],
			[
				"2006-05-15",
				5
			],
			[
				"2007-03-26",
				7
			],
			[
				"2007-11-12",
				5
			],
			[
				"2008-05-20",
				5
			],
			[
				"2008-10-13",
				5
			],
			[
				"2009-05-11",
				5
			],
			[
				"2009-09-28",
				5
			],
			[
				"2010-04-26",
				5
			],
			[
				"2010-11-02",
				5
			],
			[
				"2011-05-09",
				5
			],
			[
				"2011-11-02",
				5
			],
			[
				"2012-05-14",
				5
			],
			[
				"2012-10-15",
				5
			],
			[
				"2013-06-04",
				6
			],
			[
				"2013-11-13",
				7
			],
			[
				"2014-04-09",
				5
			],
			[
				"2014-11-12",
				6
			],
			[
				"2015-05-18",
				5
			],
			[
				"2015-10-28",
				5
			]
		],
		"106502025": [
			[
				"2000-05-03",
				1
			],
			[
				"2000-11-08",
				8
			],
			[
				"2001-04-23",
				18.01
			],
			[
				"2001-10-12",
				6
			],
			[
				"2003-10-14",
				18.01
			],
			[
				"2004-10-12",
				8
			],
			[
				"2005-04-22",
				14
			],
			[
				"2005-10-04",
				18.01
			],
			[
				"2010-05-10",
				15.01
			],
			[
				"2010-10-04",
				12
			],
			[
				"2009-04-27",
				19.01
			],
			[
				"2009-10-26",
				19.01
			],
			[
				"2008-04-14",
				18.01
			],
			[
				"2008-10-13",
				16.01
			],
			[
				"2012-10-08",
				14
			],
			[
				"2012-04-25",
				17.01
			],
			[
				"2013-11-18",
				16.01
			],
			[
				"2013-04-22",
				13
			],
			[
				"2014-10-06",
				19.01
			],
			[
				"2014-04-07",
				12
			],
			[
				"2015-10-06",
				18.01
			]
		],
		"106502062": [
			[
				"2000-05-03",
				7
			],
			[
				"2000-11-08",
				6
			],
			[
				"2001-04-23",
				12
			],
			[
				"2001-10-12",
				5
			],
			[
				"2002-10-22",
				6.4
			],
			[
				"2003-10-14",
				7
			],
			[
				"2004-10-12",
				6
			],
			[
				"2010-05-10",
				8
			],
			[
				"2010-10-04",
				6
			],
			[
				"2009-04-27",
				10
			],
			[
				"2009-10-26",
				5
			],
			[
				"2008-10-13",
				7
			],
			[
				"2008-04-14",
				14
			],
			[
				"2012-04-25",
				7
			],
			[
				"2013-11-18",
				9
			],
			[
				"2013-04-24",
				8
			],
			[
				"2014-10-01",
				5
			],
			[
				"2014-04-07",
				7
			],
			[
				"2015-10-06",
				7
			],
			[
				"2015-04-13",
				12
			]
		],
		"106502130": [
			[
				"2000-05-03",
				12
			],
			[
				"2000-11-08",
				11
			],
			[
				"2001-04-23",
				11
			],
			[
				"2001-10-12",
				12
			],
			[
				"2002-10-22",
				11
			],
			[
				"2003-10-14",
				13
			],
			[
				"2006-05-05",
				12
			],
			[
				"2006-10-04",
				11
			],
			[
				"2007-04-13",
				11
			],
			[
				"2007-10-09",
				11
			],
			[
				"2004-10-12",
				12
			],
			[
				"2005-04-22",
				8.9
			],
			[
				"2005-10-04",
				10
			],
			[
				"2008-04-14",
				12
			],
			[
				"2008-10-13",
				12
			],
			[
				"2009-04-27",
				12
			],
			[
				"2009-10-26",
				11
			],
			[
				"2010-05-10",
				11
			],
			[
				"2010-10-04",
				11
			],
			[
				"2012-10-08",
				11
			],
			[
				"2012-04-25",
				12
			],
			[
				"2013-11-18",
				13
			],
			[
				"2013-04-22",
				12
			],
			[
				"2014-10-06",
				15.01
			],
			[
				"2014-04-07",
				15.01
			],
			[
				"2015-10-06",
				15.01
			],
			[
				"2015-04-13",
				15.01
			]
		],
		"106502165": [
			[
				"2000-05-03",
				10
			],
			[
				"2000-11-08",
				11
			],
			[
				"2001-04-23",
				11
			],
			[
				"2001-10-12",
				12
			],
			[
				"2002-10-22",
				13
			],
			[
				"2004-04-27",
				11
			],
			[
				"2004-10-12",
				11
			],
			[
				"2005-04-22",
				8.4
			],
			[
				"2005-10-04",
				10
			],
			[
				"2006-05-05",
				13
			],
			[
				"2006-10-04",
				13
			],
			[
				"2007-04-13",
				14
			],
			[
				"2007-10-09",
				13
			],
			[
				"2008-10-13",
				13
			],
			[
				"2008-04-14",
				13
			],
			[
				"2009-04-27",
				13
			],
			[
				"2009-10-26",
				12
			],
			[
				"2010-05-10",
				13
			],
			[
				"2010-10-04",
				11
			],
			[
				"2012-10-08",
				12
			],
			[
				"2013-11-18",
				14
			],
			[
				"2013-04-22",
				12
			],
			[
				"2014-10-06",
				15.01
			],
			[
				"2014-04-07",
				15.01
			],
			[
				"2015-10-06",
				14
			],
			[
				"2015-04-13",
				14
			]
		],
		"106502219": [
			[
				"2000-04-06",
				18.01
			],
			[
				"2000-09-20",
				16.01
			],
			[
				"2001-04-19",
				16.01
			],
			[
				"2001-10-09",
				17.01
			],
			[
				"2002-10-10",
				15.01
			],
			[
				"2007-03-19",
				17.01
			],
			[
				"2006-09-14",
				17.01
			],
			[
				"2006-03-21",
				18.01
			],
			[
				"2005-09-06",
				16.01
			],
			[
				"2005-03-30",
				17.01
			],
			[
				"2004-09-28",
				14
			],
			[
				"2004-04-20",
				16.01
			],
			[
				"2003-10-06",
				14
			],
			[
				"2003-04-29",
				16.01
			],
			[
				"2006-08-31",
				16.01
			],
			[
				"2008-01-31",
				20.01
			],
			[
				"2008-02-29",
				19.01
			],
			[
				"2008-03-31",
				20.01
			],
			[
				"2008-05-30",
				21.01
			],
			[
				"2008-07-31",
				22.01
			],
			[
				"2008-09-23",
				20.01
			],
			[
				"2008-09-30",
				20.01
			],
			[
				"2008-10-31",
				19.01
			],
			[
				"2008-04-30",
				20.01
			],
			[
				"2008-11-28",
				20.01
			],
			[
				"2008-06-30",
				19.01
			],
			[
				"2008-08-29",
				21.01
			],
			[
				"2009-02-27",
				17.01
			],
			[
				"2009-03-31",
				18.01
			],
			[
				"2009-04-30",
				19.01
			],
			[
				"2009-06-30",
				17.01
			],
			[
				"2009-03-17",
				18.01
			],
			[
				"2009-05-29",
				18.01
			],
			[
				"2009-01-30",
				17.01
			],
			[
				"2009-09-30",
				18.01
			],
			[
				"2009-10-30",
				16.01
			],
			[
				"2009-08-31",
				18.01
			],
			[
				"2009-07-31",
				19.01
			],
			[
				"2009-09-01",
				17.01
			],
			[
				"2009-11-30",
				16.01
			],
			[
				"2010-03-30",
				19.01
			],
			[
				"2010-04-12",
				21.01
			],
			[
				"2010-04-30",
				19.01
			],
			[
				"2010-03-03",
				17.01
			],
			[
				"2010-01-04",
				20.01
			],
			[
				"2010-02-26",
				21.01
			],
			[
				"2010-05-31",
				18.01
			],
			[
				"2010-01-29",
				17.01
			],
			[
				"2010-03-19",
				18.01
			],
			[
				"2010-06-29",
				17.01
			],
			[
				"2010-08-31",
				4
			],
			[
				"2010-07-30",
				18.01
			],
			[
				"2010-09-06",
				19.01
			],
			[
				"2010-09-30",
				16.01
			],
			[
				"2010-11-30",
				18.01
			],
			[
				"2010-11-02",
				17.01
			],
			[
				"2012-11-30",
				15.01
			],
			[
				"2012-10-31",
				14
			],
			[
				"2012-09-28",
				14
			],
			[
				"2012-08-31",
				15.01
			],
			[
				"2012-07-31",
				15.01
			],
			[
				"2012-05-31",
				15.01
			],
			[
				"2012-05-02",
				17.01
			],
			[
				"2012-04-02",
				16.01
			],
			[
				"2012-03-30",
				16.01
			],
			[
				"2012-02-29",
				16.01
			],
			[
				"2012-01-31",
				15.01
			],
			[
				"2012-01-02",
				13
			],
			[
				"2013-12-30",
				16.01
			],
			[
				"2013-11-29",
				16.01
			],
			[
				"2013-11-05",
				17.01
			],
			[
				"2013-09-30",
				15.01
			],
			[
				"2013-09-02",
				16.01
			],
			[
				"2013-07-31",
				16.01
			],
			[
				"2013-07-01",
				16.01
			],
			[
				"2013-06-03",
				16.01
			],
			[
				"2013-04-30",
				15.01
			],
			[
				"2013-03-28",
				15.01
			],
			[
				"2013-03-14",
				14
			],
			[
				"2013-02-28",
				15.01
			],
			[
				"2013-01-31",
				14
			],
			[
				"2013-01-02",
				15.01
			],
			[
				"2014-12-01",
				14
			],
			[
				"2014-11-03",
				14
			],
			[
				"2014-09-29",
				14
			],
			[
				"2014-09-02",
				15.01
			],
			[
				"2014-07-31",
				15.01
			],
			[
				"2014-06-30",
				15.01
			],
			[
				"2014-05-28",
				15.01
			],
			[
				"2014-04-30",
				15.01
			],
			[
				"2014-04-01",
				16.01
			],
			[
				"2014-03-20",
				16.01
			],
			[
				"2014-02-28",
				16.01
			],
			[
				"2014-01-31",
				16.01
			],
			[
				"2015-11-30",
				14
			],
			[
				"2015-10-30",
				14
			],
			[
				"2015-10-01",
				14
			],
			[
				"2015-08-27",
				15.01
			],
			[
				"2015-07-30",
				14
			],
			[
				"2015-06-30",
				15.01
			],
			[
				"2015-06-01",
				15.01
			],
			[
				"2015-04-30",
				14
			],
			[
				"2015-04-08",
				14
			],
			[
				"2015-03-31",
				14
			],
			[
				"2015-02-27",
				14
			],
			[
				"2015-01-30",
				14
			]
		],
		"106502300": [
			[
				"2000-04-05",
				11
			],
			[
				"2000-09-06",
				6
			],
			[
				"2001-03-02",
				6
			],
			[
				"2001-09-06",
				9
			],
			[
				"2002-03-06",
				13
			],
			[
				"2002-10-02",
				11
			],
			[
				"2008-04-22",
				15.01
			],
			[
				"2008-01-17",
				9
			],
			[
				"2006-03-22",
				8
			],
			[
				"2007-03-26",
				11
			],
			[
				"2006-09-06",
				6
			],
			[
				"2007-01-08",
				6
			],
			[
				"2009-04-29",
				9
			],
			[
				"2009-01-07",
				5
			],
			[
				"2010-01-27",
				9
			],
			[
				"2010-05-19",
				9
			],
			[
				"2012-05-23",
				6
			],
			[
				"2012-01-05",
				5
			],
			[
				"2013-05-22",
				8
			],
			[
				"2013-01-16",
				7
			],
			[
				"2014-06-16",
				6
			],
			[
				"2014-01-07",
				7
			],
			[
				"2015-05-11",
				11
			],
			[
				"2015-01-07",
				8
			]
		],
		"106502335": [
			[
				"2000-05-09",
				20.01
			],
			[
				"2000-11-14",
				21.01
			],
			[
				"2001-05-16",
				19.01
			],
			[
				"2001-10-08",
				17.01
			],
			[
				"2002-05-13",
				18.01
			],
			[
				"2002-11-11",
				19.01
			],
			[
				"2003-03-25",
				18.01
			],
			[
				"2003-11-11",
				19.01
			],
			[
				"2004-03-15",
				17.01
			],
			[
				"2004-09-28",
				17.01
			],
			[
				"2005-09-28",
				18.01
			],
			[
				"2005-04-21",
				18.01
			],
			[
				"2006-07-06",
				17.01
			],
			[
				"2007-10-01",
				21.01
			],
			[
				"2008-10-23",
				17.01
			],
			[
				"2009-03-26",
				17.01
			],
			[
				"2009-10-19",
				17.01
			],
			[
				"2010-09-28",
				16.01
			],
			[
				"2011-04-27",
				16.01
			],
			[
				"2011-10-26",
				17.01
			],
			[
				"2012-05-08",
				16.01
			],
			[
				"2012-11-06",
				16.01
			],
			[
				"2013-05-28",
				17.01
			],
			[
				"2013-11-07",
				16.01
			],
			[
				"2014-04-22",
				16.01
			],
			[
				"2015-04-20",
				17.01
			],
			[
				"2015-10-15",
				16.01
			]
		],
		"106502359": [
			[
				"2002-05-14",
				1
			],
			[
				"2002-11-11",
				1
			],
			[
				"2003-03-17",
				1
			],
			[
				"2003-11-11",
				1
			],
			[
				"2004-03-15",
				1
			],
			[
				"2004-09-27",
				1
			],
			[
				"2005-09-28",
				1
			],
			[
				"2005-04-21",
				1
			],
			[
				"2006-11-13",
				1
			],
			[
				"2006-05-03",
				1
			],
			[
				"2007-03-21",
				1
			],
			[
				"2007-10-01",
				1
			],
			[
				"2008-05-19",
				1
			],
			[
				"2008-10-29",
				1
			],
			[
				"2009-03-26",
				1
			],
			[
				"2009-10-19",
				1
			],
			[
				"2010-04-12",
				1
			],
			[
				"2010-09-28",
				1
			],
			[
				"2011-04-27",
				1
			],
			[
				"2011-10-26",
				1
			],
			[
				"2012-05-08",
				1
			],
			[
				"2012-11-06",
				1
			],
			[
				"2013-05-28",
				1
			],
			[
				"2013-11-14",
				1
			],
			[
				"2014-05-20",
				1
			],
			[
				"2014-11-19",
				1
			],
			[
				"2015-05-05",
				1
			],
			[
				"2015-10-13",
				1
			]
		],
		"106502372": [
			[
				"2000-05-09",
				3
			],
			[
				"2001-05-16",
				1
			],
			[
				"2001-10-08",
				1
			],
			[
				"2002-05-13",
				1
			],
			[
				"2002-11-11",
				1
			],
			[
				"2003-03-17",
				1
			],
			[
				"2003-11-11",
				1
			],
			[
				"2004-03-16",
				1
			],
			[
				"2004-09-27",
				1
			],
			[
				"2004-11-29",
				1
			],
			[
				"2005-09-27",
				1
			],
			[
				"2005-04-20",
				1
			],
			[
				"2006-11-13",
				1
			],
			[
				"2006-05-02",
				1
			],
			[
				"2007-03-21",
				1
			],
			[
				"2007-10-01",
				1
			],
			[
				"2008-05-19",
				1
			],
			[
				"2008-10-23",
				1
			],
			[
				"2009-03-26",
				1
			],
			[
				"2009-10-19",
				1
			],
			[
				"2010-04-12",
				1
			],
			[
				"2010-09-28",
				1
			],
			[
				"2011-04-27",
				1
			],
			[
				"2011-10-26",
				1
			],
			[
				"2012-05-08",
				1
			],
			[
				"2012-11-06",
				1
			],
			[
				"2013-05-28",
				1
			],
			[
				"2013-11-14",
				1
			],
			[
				"2014-05-20",
				1
			],
			[
				"2014-11-19",
				1
			],
			[
				"2015-05-05",
				1
			],
			[
				"2015-10-13",
				1
			]
		],
		"106502402": [
			[
				"2000-03-16",
				24.01
			],
			[
				"2000-09-14",
				23.01
			],
			[
				"2001-03-21",
				28.01
			],
			[
				"2001-09-05",
				34.01
			],
			[
				"2002-03-13",
				24.01
			],
			[
				"2002-09-03",
				22.01
			],
			[
				"2003-09-25",
				20.01
			],
			[
				"2003-03-17",
				22.01
			],
			[
				"2004-10-06",
				16.01
			],
			[
				"2004-03-18",
				21.01
			],
			[
				"2005-09-26",
				18.01
			],
			[
				"2005-03-16",
				21.01
			],
			[
				"2006-03-23",
				20.01
			],
			[
				"2006-09-18",
				18.01
			],
			[
				"2007-04-03",
				18.01
			],
			[
				"2007-09-24",
				17.01
			],
			[
				"2008-04-25",
				18.01
			],
			[
				"2008-09-15",
				20.01
			],
			[
				"2009-04-21",
				19.01
			],
			[
				"2009-09-07",
				19.01
			],
			[
				"2010-04-09",
				18.01
			],
			[
				"2010-09-07",
				19.01
			],
			[
				"2012-10-01",
				17.01
			],
			[
				"2012-05-07",
				19.01
			],
			[
				"2013-09-24",
				17.01
			],
			[
				"2013-04-24",
				17.01
			],
			[
				"2014-09-23",
				18.01
			],
			[
				"2014-04-02",
				20.01
			],
			[
				"2015-09-28",
				19.01
			],
			[
				"2015-05-21",
				20.01
			]
		],
		"106502426": [
			[
				"2000-05-10",
				33.01
			],
			[
				"2000-11-15",
				27.01
			],
			[
				"2001-05-16",
				30.01
			],
			[
				"2001-10-08",
				29.01
			],
			[
				"2002-05-13",
				34.01
			],
			[
				"2002-11-11",
				30.01
			],
			[
				"2003-03-17",
				33.01
			],
			[
				"2003-11-11",
				26.01
			],
			[
				"2004-03-15",
				31.01
			],
			[
				"2004-09-27",
				25.01
			],
			[
				"2005-09-27",
				24.01
			],
			[
				"2005-04-20",
				29.01
			],
			[
				"2006-11-13",
				24.01
			],
			[
				"2006-05-02",
				29.01
			],
			[
				"2007-03-21",
				28.01
			],
			[
				"2007-10-01",
				28.01
			],
			[
				"2008-05-19",
				30.01
			],
			[
				"2008-10-29",
				24.01
			],
			[
				"2009-03-26",
				26.01
			],
			[
				"2009-10-19",
				25.01
			],
			[
				"2010-04-12",
				31.01
			],
			[
				"2010-09-28",
				33.01
			],
			[
				"2011-04-27",
				30.01
			],
			[
				"2011-10-26",
				29.01
			],
			[
				"2012-05-08",
				31.01
			],
			[
				"2012-11-06",
				25.01
			],
			[
				"2013-05-28",
				30.01
			],
			[
				"2013-11-14",
				27.01
			],
			[
				"2014-05-20",
				27.01
			],
			[
				"2014-11-19",
				27.01
			],
			[
				"2015-05-05",
				33.01
			],
			[
				"2015-10-13",
				26.01
			]
		],
		"106502463": [
			[
				"2000-03-16",
				19.01
			],
			[
				"2000-09-14",
				21.01
			],
			[
				"2001-03-21",
				21.01
			],
			[
				"2001-09-05",
				22.01
			],
			[
				"2002-03-13",
				19.01
			],
			[
				"2002-09-03",
				20.01
			],
			[
				"2003-09-25",
				22.01
			],
			[
				"2003-03-17",
				23.01
			],
			[
				"2004-10-06",
				17.01
			],
			[
				"2004-03-18",
				22.01
			],
			[
				"2005-03-16",
				20.01
			],
			[
				"2005-09-26",
				18.01
			],
			[
				"2006-09-18",
				18.01
			],
			[
				"2006-03-23",
				20.01
			],
			[
				"2007-04-03",
				21.01
			],
			[
				"2007-09-24",
				20.01
			],
			[
				"2008-02-08",
				21.01
			],
			[
				"2008-04-03",
				23.01
			],
			[
				"2008-09-15",
				22.01
			],
			[
				"2009-02-06",
				5
			],
			[
				"2009-09-07",
				19.01
			],
			[
				"2010-02-02",
				20.01
			],
			[
				"2010-04-09",
				21.01
			],
			[
				"2010-09-07",
				21.01
			],
			[
				"2009-04-21",
				21.01
			],
			[
				"2012-10-01",
				20.01
			],
			[
				"2012-05-07",
				20.01
			],
			[
				"2012-02-22",
				19.01
			],
			[
				"2013-09-24",
				20.01
			],
			[
				"2013-02-20",
				19.01
			],
			[
				"2014-09-23",
				19.01
			],
			[
				"2014-04-02",
				21.01
			],
			[
				"2015-09-28",
				19.01
			],
			[
				"2015-05-21",
				4
			],
			[
				"2015-02-25",
				19.01
			]
		],
		"106502475": [
			[
				"2000-03-16",
				30.01
			],
			[
				"2000-09-14",
				31.01
			],
			[
				"2001-03-21",
				31.01
			],
			[
				"2001-09-05",
				31.01
			],
			[
				"2002-03-13",
				32.01
			],
			[
				"2002-09-03",
				29.01
			],
			[
				"2003-09-25",
				14
			],
			[
				"2003-03-17",
				29.01
			],
			[
				"2004-03-18",
				31.01
			],
			[
				"2004-10-06",
				24.01
			],
			[
				"2005-09-26",
				27.01
			],
			[
				"2005-03-16",
				31.01
			],
			[
				"2006-09-18",
				27.01
			],
			[
				"2006-03-23",
				28.01
			],
			[
				"2007-04-03",
				30.01
			],
			[
				"2007-05-24",
				26.01
			],
			[
				"2007-09-24",
				29.01
			],
			[
				"2008-09-15",
				30.01
			],
			[
				"2008-04-03",
				30.01
			],
			[
				"2009-05-26",
				29.01
			],
			[
				"2009-04-21",
				31.01
			],
			[
				"2009-09-07",
				30.01
			],
			[
				"2010-04-22",
				29.01
			],
			[
				"2010-05-27",
				29.01
			],
			[
				"2010-09-07",
				29.01
			],
			[
				"2012-10-01",
				29.01
			],
			[
				"2012-05-07",
				30.01
			],
			[
				"2013-09-24",
				28.01
			],
			[
				"2013-04-24",
				12
			],
			[
				"2014-09-23",
				29.01
			],
			[
				"2014-05-19",
				30.01
			],
			[
				"2014-04-02",
				30.01
			],
			[
				"2015-09-28",
				29.01
			],
			[
				"2015-05-21",
				28.01
			],
			[
				"2015-02-25",
				28.01
			]
		],
		"106502517": [
			[
				"2000-03-16",
				1
			],
			[
				"2000-09-14",
				1
			],
			[
				"2001-03-21",
				2
			],
			[
				"2001-09-05",
				1
			],
			[
				"2002-03-13",
				1
			],
			[
				"2002-09-03",
				2
			],
			[
				"2003-03-17",
				1
			],
			[
				"2003-09-25",
				1
			],
			[
				"2004-03-18",
				1
			],
			[
				"2004-10-06",
				1
			],
			[
				"2005-03-16",
				1
			],
			[
				"2005-09-26",
				1
			],
			[
				"2006-03-23",
				1
			],
			[
				"2006-09-18",
				1
			],
			[
				"2010-04-09",
				2
			],
			[
				"2010-09-07",
				1
			],
			[
				"2009-04-21",
				1
			],
			[
				"2009-09-07",
				1
			],
			[
				"2008-04-03",
				1
			],
			[
				"2008-09-15",
				1
			],
			[
				"2012-10-01",
				1
			],
			[
				"2012-05-07",
				1
			],
			[
				"2013-09-24",
				1
			],
			[
				"2013-04-24",
				1
			],
			[
				"2014-09-23",
				1
			],
			[
				"2014-04-02",
				1
			],
			[
				"2015-09-28",
				1
			],
			[
				"2015-05-21",
				1
			]
		],
		"106502566": [
			[
				"2000-03-30",
				23.01
			],
			[
				"2000-10-16",
				33.01
			],
			[
				"2002-11-15",
				31.01
			],
			[
				"2013-06-27",
				37.01
			],
			[
				"2015-10-28",
				33.01
			]
		],
		"106502578": [
			[
				"2000-11-08",
				1
			],
			[
				"2001-03-28",
				5
			],
			[
				"2000-03-22",
				6
			],
			[
				"2001-09-25",
				1
			],
			[
				"2002-03-20",
				8
			],
			[
				"2002-09-18",
				7
			],
			[
				"2003-03-18",
				7
			],
			[
				"2008-03-18",
				5
			],
			[
				"2008-09-11",
				1
			],
			[
				"2010-03-31",
				2
			],
			[
				"2010-11-16",
				1
			],
			[
				"2012-09-25",
				1
			],
			[
				"2013-10-24",
				1
			],
			[
				"2013-04-26",
				1
			],
			[
				"2014-09-23",
				1
			],
			[
				"2014-03-20",
				1
			],
			[
				"2015-10-05",
				1
			],
			[
				"2015-04-14",
				4
			]
		],
		"106502633": [
			[
				"2000-04-12",
				2
			],
			[
				"2000-09-11",
				2
			],
			[
				"2001-09-03",
				3
			],
			[
				"2004-09-08",
				1
			],
			[
				"2004-04-23",
				2
			],
			[
				"2003-09-23",
				1
			],
			[
				"2002-09-16",
				1
			],
			[
				"2002-05-13",
				1
			],
			[
				"2006-09-21",
				1
			],
			[
				"2006-10-13",
				1
			],
			[
				"2008-04-29",
				2
			],
			[
				"2008-10-20",
				1
			],
			[
				"2006-04-07",
				1
			],
			[
				"2007-05-07",
				1
			],
			[
				"2009-04-30",
				1
			],
			[
				"2009-10-05",
				1
			],
			[
				"2010-04-23",
				1
			],
			[
				"2010-07-16",
				1
			],
			[
				"2010-10-18",
				1
			],
			[
				"2012-10-22",
				1
			],
			[
				"2012-07-09",
				1
			],
			[
				"2013-11-05",
				1
			],
			[
				"2013-07-12",
				1
			],
			[
				"2013-05-06",
				1
			],
			[
				"2014-10-20",
				1
			],
			[
				"2015-10-12",
				1
			],
			[
				"2015-07-03",
				2
			],
			[
				"2015-04-20",
				1
			]
		],
		"106503613": [
			[
				"2000-03-29",
				1
			],
			[
				"2000-09-27",
				2
			],
			[
				"2001-03-12",
				1
			],
			[
				"2001-09-21",
				6
			],
			[
				"2002-03-14",
				4
			],
			[
				"2002-09-25",
				18.01
			],
			[
				"2002-09-25",
				18.01
			],
			[
				"2002-09-25",
				18.01
			],
			[
				"2003-09-25",
				2
			],
			[
				"2003-03-20",
				3
			],
			[
				"2003-09-25",
				2
			],
			[
				"2004-09-27",
				1
			],
			[
				"2004-03-23",
				1
			],
			[
				"2005-03-23",
				1
			],
			[
				"2007-03-27",
				1
			],
			[
				"2006-03-29",
				1
			],
			[
				"2006-09-28",
				1
			],
			[
				"2007-09-26",
				1
			],
			[
				"2008-03-26",
				1
			],
			[
				"2008-09-22",
				1
			],
			[
				"2009-03-24",
				11
			],
			[
				"2009-09-29",
				1
			],
			[
				"2010-03-25",
				1
			],
			[
				"2010-09-21",
				2
			],
			[
				"2015-09-24",
				1
			],
			[
				"2015-03-26",
				1
			]
		],
		"106503649": [
			[
				"2000-03-01",
				20.01
			],
			[
				"2000-09-13",
				9
			],
			[
				"2001-03-14",
				21.01
			],
			[
				"2001-09-19",
				8
			],
			[
				"2002-03-13",
				19.01
			],
			[
				"2002-09-18",
				11
			],
			[
				"2002-03-13",
				19.01
			],
			[
				"2003-09-04",
				5.2
			],
			[
				"2003-03-11",
				9.3
			],
			[
				"2004-09-15",
				5.9
			],
			[
				"2004-03-16",
				12.4
			],
			[
				"2005-09-29",
				5.3
			],
			[
				"2005-04-06",
				8.4
			],
			[
				"2013-04-18",
				13.8
			],
			[
				"2013-10-08",
				9.1
			],
			[
				"2011-04-11",
				16.41
			],
			[
				"2011-10-20",
				7.9
			],
			[
				"2014-04-08",
				13.3
			],
			[
				"2014-10-21",
				11.9
			],
			[
				"2015-04-22",
				12.8
			],
			[
				"2015-10-20",
				6.6
			]
		],
		"106503730": [
			[
				"2000-04-18",
				15.61
			],
			[
				"2000-10-18",
				4.65
			],
			[
				"2001-04-25",
				16.01
			],
			[
				"2001-10-23",
				11
			],
			[
				"2002-04-03",
				17.01
			],
			[
				"2002-11-12",
				16.01
			],
			[
				"2013-10-16",
				12
			],
			[
				"2014-10-07",
				13
			],
			[
				"2014-04-16",
				12
			],
			[
				"2015-04-21",
				19.01
			]
		],
		"106503820": [
			[
				"2000-03-13",
				26.01
			],
			[
				"2000-10-02",
				24.01
			],
			[
				"2001-03-05",
				23.01
			],
			[
				"2001-09-10",
				5
			],
			[
				"2002-03-11",
				24.01
			],
			[
				"2002-09-16",
				14
			],
			[
				"2006-03-20",
				21.01
			],
			[
				"2006-09-07",
				22.01
			],
			[
				"2005-09-12",
				20.01
			],
			[
				"2005-03-29",
				20.01
			],
			[
				"2004-09-13",
				21.01
			],
			[
				"2004-03-15",
				22.01
			],
			[
				"2003-09-08",
				28.01
			],
			[
				"2003-03-17",
				23.01
			],
			[
				"2015-09-28",
				3
			],
			[
				"2015-03-02",
				3
			]
		],
		"106503959": [
			[
				"2000-04-03",
				1
			],
			[
				"2000-10-05",
				1
			],
			[
				"2001-04-02",
				1
			],
			[
				"2001-10-22",
				1
			],
			[
				"2002-10-01",
				1
			],
			[
				"2007-04-04",
				1
			],
			[
				"2006-05-04",
				1
			],
			[
				"2005-10-19",
				1
			],
			[
				"2005-04-20",
				1
			],
			[
				"2004-11-10",
				1
			],
			[
				"2004-04-14",
				1
			],
			[
				"2003-11-03",
				1
			],
			[
				"2003-04-03",
				1
			],
			[
				"2007-11-05",
				1
			],
			[
				"2008-04-02",
				1
			],
			[
				"2008-10-17",
				1
			],
			[
				"2009-10-15",
				1
			],
			[
				"2009-04-07",
				1
			],
			[
				"2010-05-04",
				1
			],
			[
				"2010-11-10",
				1
			],
			[
				"2012-11-13",
				1
			],
			[
				"2012-05-08",
				1
			],
			[
				"2013-10-21",
				1
			],
			[
				"2013-04-16",
				1
			],
			[
				"2014-11-11",
				1
			],
			[
				"2014-05-06",
				1
			],
			[
				"2015-04-14",
				2
			]
		],
		"106503960": [
			[
				"2000-04-03",
				1
			],
			[
				"2000-10-05",
				1
			],
			[
				"2001-04-02",
				1
			],
			[
				"2001-10-22",
				1
			],
			[
				"2002-10-01",
				6
			],
			[
				"2007-04-04",
				1
			],
			[
				"2006-10-23",
				1
			],
			[
				"2006-05-04",
				1
			],
			[
				"2005-10-19",
				6
			],
			[
				"2004-11-10",
				1
			],
			[
				"2004-04-14",
				1
			],
			[
				"2003-11-03",
				1
			],
			[
				"2003-04-03",
				2
			],
			[
				"2007-11-05",
				1
			],
			[
				"2008-04-02",
				1
			],
			[
				"2008-10-17",
				1
			],
			[
				"2009-04-07",
				1
			],
			[
				"2009-10-15",
				1
			],
			[
				"2010-05-04",
				2
			],
			[
				"2010-11-10",
				1
			],
			[
				"2012-11-13",
				1
			],
			[
				"2012-05-08",
				1
			],
			[
				"2013-10-21",
				1
			],
			[
				"2013-04-16",
				1
			],
			[
				"2014-11-11",
				1
			],
			[
				"2014-05-06",
				1
			],
			[
				"2015-04-14",
				1
			]
		],
		"106503984": [
			[
				"2000-04-03",
				2
			],
			[
				"2000-10-05",
				2
			],
			[
				"2001-04-02",
				2
			],
			[
				"2001-10-22",
				3
			],
			[
				"2002-10-01",
				2
			],
			[
				"2007-04-04",
				2
			],
			[
				"2006-10-23",
				1
			],
			[
				"2006-05-04",
				2
			],
			[
				"2005-10-19",
				1
			],
			[
				"2005-04-20",
				6
			],
			[
				"2004-11-10",
				1
			],
			[
				"2004-04-14",
				1
			],
			[
				"2003-11-03",
				6
			],
			[
				"2003-04-03",
				4
			],
			[
				"2007-11-05",
				2
			],
			[
				"2008-04-02",
				1
			],
			[
				"2008-10-17",
				2
			],
			[
				"2009-04-07",
				2
			],
			[
				"2009-10-15",
				2
			],
			[
				"2010-05-04",
				2
			],
			[
				"2010-11-10",
				1
			],
			[
				"2012-11-13",
				1
			],
			[
				"2012-05-08",
				1
			],
			[
				"2013-10-21",
				1
			],
			[
				"2013-04-16",
				1
			],
			[
				"2014-11-11",
				2
			],
			[
				"2014-05-06",
				2
			],
			[
				"2015-04-14",
				2
			]
		],
		"106505014": [
			[
				"2000-12-14",
				27.01
			],
			[
				"2000-10-05",
				34.01
			],
			[
				"2001-05-14",
				41.01
			],
			[
				"2001-10-22",
				33.01
			],
			[
				"2006-04-28",
				31.01
			],
			[
				"2006-10-30",
				29.01
			],
			[
				"2007-04-26",
				33.01
			],
			[
				"2007-09-24",
				34.01
			],
			[
				"2008-04-08",
				30.01
			],
			[
				"2008-10-23",
				27.01
			],
			[
				"2009-04-24",
				30.01
			],
			[
				"2009-09-22",
				27.01
			],
			[
				"2010-04-28",
				33.01
			],
			[
				"2010-09-10",
				57.02
			],
			[
				"2010-09-30",
				27.01
			],
			[
				"2012-09-21",
				29.01
			],
			[
				"2012-05-02",
				32.01
			],
			[
				"2013-12-09",
				31.01
			],
			[
				"2013-05-16",
				32.01
			],
			[
				"2014-12-15",
				29.01
			],
			[
				"2014-05-20",
				33.01
			],
			[
				"2015-11-24",
				30.01
			],
			[
				"2015-05-26",
				34.01
			]
		],
		"106505117": [
			[
				"2000-04-06",
				30.01
			],
			[
				"2000-09-20",
				26.01
			],
			[
				"2001-04-19",
				9
			],
			[
				"2001-10-09",
				27.01
			],
			[
				"2002-10-15",
				25.01
			],
			[
				"2007-03-19",
				24.01
			],
			[
				"2006-09-14",
				24.01
			],
			[
				"2006-03-21",
				25.01
			],
			[
				"2005-09-06",
				22.01
			],
			[
				"2005-03-30",
				32.01
			],
			[
				"2004-10-19",
				21.01
			],
			[
				"2003-10-06",
				24.01
			],
			[
				"2003-04-29",
				27.01
			],
			[
				"2006-02-28",
				30.01
			],
			[
				"2006-03-31",
				44.02
			],
			[
				"2006-04-27",
				25.01
			],
			[
				"2006-05-31",
				25.01
			],
			[
				"2006-01-31",
				26.01
			],
			[
				"2006-08-31",
				44.02
			],
			[
				"2006-09-28",
				34.01
			],
			[
				"2006-06-29",
				25.01
			],
			[
				"2006-07-31",
				26.01
			],
			[
				"2006-11-30",
				24.01
			],
			[
				"2006-10-31",
				37.01
			],
			[
				"2007-01-02",
				40.01
			],
			[
				"2007-01-31",
				35.01
			],
			[
				"2007-02-28",
				25.01
			],
			[
				"2007-04-27",
				26.01
			],
			[
				"2007-03-30",
				26.01
			],
			[
				"2007-05-31",
				25.01
			],
			[
				"2007-09-14",
				24.01
			],
			[
				"2007-09-28",
				28.01
			],
			[
				"2007-10-31",
				39.01
			],
			[
				"2007-11-30",
				29.01
			],
			[
				"2007-06-29",
				26.01
			],
			[
				"2007-07-30",
				25.01
			],
			[
				"2007-08-31",
				25.01
			],
			[
				"2007-12-27",
				26.01
			],
			[
				"2008-03-17",
				30.01
			],
			[
				"2008-03-31",
				28.01
			],
			[
				"2008-01-31",
				25.01
			],
			[
				"2008-04-30",
				32.01
			],
			[
				"2008-08-29",
				45.02
			],
			[
				"2008-05-30",
				32.01
			],
			[
				"2008-09-23",
				30.01
			],
			[
				"2008-09-30",
				30.01
			],
			[
				"2008-02-29",
				36.01
			],
			[
				"2008-10-31",
				29.01
			],
			[
				"2008-11-28",
				29.01
			],
			[
				"2008-06-30",
				36.01
			],
			[
				"2008-07-31",
				34.01
			],
			[
				"2009-03-31",
				32.01
			],
			[
				"2009-05-29",
				32.01
			],
			[
				"2009-07-31",
				33.01
			],
			[
				"2009-01-30",
				26.01
			],
			[
				"2009-03-17",
				30.01
			],
			[
				"2009-04-30",
				31.01
			],
			[
				"2009-06-30",
				30.01
			],
			[
				"2009-11-30",
				28.01
			],
			[
				"2009-08-31",
				30.01
			],
			[
				"2009-10-30",
				28.01
			],
			[
				"2009-09-01",
				31.01
			],
			[
				"2009-09-30",
				31.01
			],
			[
				"2010-03-03",
				30.01
			],
			[
				"2010-03-30",
				31.01
			],
			[
				"2010-01-04",
				28.01
			],
			[
				"2010-01-29",
				29.01
			],
			[
				"2010-02-26",
				30.01
			],
			[
				"2010-05-31",
				30.01
			],
			[
				"2010-04-30",
				31.01
			],
			[
				"2010-06-29",
				28.01
			],
			[
				"2010-11-02",
				31.01
			],
			[
				"2010-11-30",
				31.01
			],
			[
				"2010-07-30",
				27.01
			],
			[
				"2010-08-31",
				30.01
			],
			[
				"2010-09-06",
				31.01
			],
			[
				"2010-09-30",
				27.01
			],
			[
				"2009-02-27",
				28.01
			],
			[
				"2012-11-30",
				30.01
			],
			[
				"2012-10-31",
				28.01
			],
			[
				"2012-09-28",
				29.01
			],
			[
				"2012-08-31",
				29.01
			],
			[
				"2012-07-31",
				29.01
			],
			[
				"2012-06-29",
				30.01
			],
			[
				"2012-05-31",
				30.01
			],
			[
				"2012-05-02",
				31.01
			],
			[
				"2012-04-02",
				31.01
			],
			[
				"2012-03-30",
				31.01
			],
			[
				"2012-02-29",
				31.01
			],
			[
				"2012-01-31",
				30.01
			],
			[
				"2012-01-02",
				26.01
			],
			[
				"2013-11-29",
				30.01
			],
			[
				"2013-11-04",
				29.01
			],
			[
				"2013-09-30",
				28.01
			],
			[
				"2013-09-02",
				29.01
			],
			[
				"2013-07-31",
				29.01
			],
			[
				"2013-07-01",
				29.01
			],
			[
				"2013-06-03",
				29.01
			],
			[
				"2013-04-30",
				28.01
			],
			[
				"2013-03-28",
				30.01
			],
			[
				"2013-03-14",
				29.01
			],
			[
				"2013-02-28",
				29.01
			],
			[
				"2013-01-31",
				29.01
			],
			[
				"2013-01-02",
				30.01
			],
			[
				"2014-12-01",
				29.01
			],
			[
				"2014-11-03",
				28.01
			],
			[
				"2014-09-29",
				28.01
			],
			[
				"2014-09-02",
				29.01
			],
			[
				"2014-07-31",
				29.01
			],
			[
				"2014-06-30",
				36.01
			],
			[
				"2014-05-28",
				31.01
			],
			[
				"2014-04-30",
				30.01
			],
			[
				"2014-04-01",
				31.01
			],
			[
				"2014-03-20",
				30.01
			],
			[
				"2014-02-28",
				30.01
			],
			[
				"2014-01-31",
				30.01
			],
			[
				"2015-11-30",
				28.01
			],
			[
				"2015-10-02",
				34.01
			],
			[
				"2015-08-27",
				28.01
			],
			[
				"2015-07-30",
				27.01
			],
			[
				"2015-06-30",
				34.01
			],
			[
				"2015-06-01",
				28.01
			],
			[
				"2015-04-30",
				28.01
			],
			[
				"2015-04-08",
				27.01
			],
			[
				"2015-03-31",
				27.01
			],
			[
				"2015-02-27",
				20.01
			],
			[
				"2015-01-30",
				22.01
			]
		],
		"106505129": [
			[
				"2000-04-06",
				20.01
			],
			[
				"2000-09-20",
				20.01
			],
			[
				"2001-04-19",
				21.01
			],
			[
				"2001-10-09",
				21.01
			],
			[
				"2002-10-10",
				17.01
			],
			[
				"2007-03-19",
				21.01
			],
			[
				"2006-09-14",
				17.01
			],
			[
				"2006-03-21",
				21.01
			],
			[
				"2005-09-06",
				16.01
			],
			[
				"2005-03-30",
				18.01
			],
			[
				"2004-09-28",
				16.01
			],
			[
				"2003-10-06",
				18.01
			],
			[
				"2003-04-29",
				18.01
			],
			[
				"2004-04-20",
				17.01
			],
			[
				"2006-08-31",
				18.01
			],
			[
				"2007-09-14",
				19.01
			],
			[
				"2008-04-30",
				23.01
			],
			[
				"2008-01-31",
				19.01
			],
			[
				"2008-07-31",
				21.01
			],
			[
				"2008-08-29",
				20.01
			],
			[
				"2008-09-23",
				19.01
			],
			[
				"2008-10-31",
				20.01
			],
			[
				"2008-02-29",
				18.01
			],
			[
				"2008-03-17",
				18.01
			],
			[
				"2008-03-31",
				21.01
			],
			[
				"2008-05-30",
				19.01
			],
			[
				"2008-06-30",
				18.01
			],
			[
				"2008-11-28",
				20.01
			],
			[
				"2009-03-31",
				22.01
			],
			[
				"2009-04-30",
				21.01
			],
			[
				"2009-02-27",
				20.01
			],
			[
				"2009-03-17",
				22.01
			],
			[
				"2009-01-30",
				19.01
			],
			[
				"2009-05-29",
				20.01
			],
			[
				"2009-06-30",
				19.01
			],
			[
				"2009-08-31",
				17.01
			],
			[
				"2009-09-30",
				22.01
			],
			[
				"2009-11-30",
				20.01
			],
			[
				"2009-10-30",
				19.01
			],
			[
				"2009-07-31",
				20.01
			],
			[
				"2009-09-01",
				19.01
			],
			[
				"2010-01-04",
				20.01
			],
			[
				"2010-03-03",
				22.01
			],
			[
				"2010-03-30",
				20.01
			],
			[
				"2010-01-29",
				20.01
			],
			[
				"2010-02-26",
				19.01
			],
			[
				"2010-05-31",
				18.01
			],
			[
				"2010-04-30",
				19.01
			],
			[
				"2010-06-29",
				17.01
			],
			[
				"2010-07-30",
				17.01
			],
			[
				"2010-11-02",
				18.01
			],
			[
				"2010-08-31",
				18.01
			],
			[
				"2010-09-06",
				19.01
			],
			[
				"2010-09-30",
				19.01
			],
			[
				"2010-11-30",
				19.01
			],
			[
				"2008-09-30",
				20.01
			],
			[
				"2012-11-30",
				19.01
			],
			[
				"2012-10-31",
				17.01
			],
			[
				"2012-09-28",
				18.01
			],
			[
				"2012-08-31",
				18.01
			],
			[
				"2012-07-31",
				17.01
			],
			[
				"2012-06-29",
				18.01
			],
			[
				"2012-05-31",
				17.01
			],
			[
				"2012-05-02",
				19.01
			],
			[
				"2012-04-02",
				18.01
			],
			[
				"2012-03-30",
				18.01
			],
			[
				"2012-02-29",
				20.01
			],
			[
				"2012-01-31",
				19.01
			],
			[
				"2013-11-29",
				19.01
			],
			[
				"2013-11-05",
				19.01
			],
			[
				"2013-09-30",
				17.01
			],
			[
				"2013-09-02",
				18.01
			],
			[
				"2013-07-31",
				17.01
			],
			[
				"2013-07-01",
				26.01
			],
			[
				"2013-06-03",
				18.01
			],
			[
				"2013-04-30",
				17.01
			],
			[
				"2013-03-28",
				18.01
			],
			[
				"2013-03-14",
				18.01
			],
			[
				"2013-02-28",
				18.01
			],
			[
				"2013-01-31",
				18.01
			],
			[
				"2013-01-02",
				20.01
			],
			[
				"2014-12-01",
				19.01
			],
			[
				"2014-11-03",
				19.01
			],
			[
				"2014-09-29",
				18.01
			],
			[
				"2014-09-02",
				19.01
			],
			[
				"2014-07-31",
				19.01
			],
			[
				"2014-06-30",
				18.01
			],
			[
				"2014-05-28",
				19.01
			],
			[
				"2014-04-30",
				18.01
			],
			[
				"2014-04-01",
				19.01
			],
			[
				"2014-03-20",
				19.01
			],
			[
				"2014-02-28",
				19.01
			],
			[
				"2014-01-31",
				18.01
			],
			[
				"2013-12-30",
				20.01
			],
			[
				"2015-11-30",
				20.01
			],
			[
				"2015-10-30",
				19.01
			],
			[
				"2015-10-01",
				19.01
			],
			[
				"2015-08-27",
				19.01
			],
			[
				"2015-07-30",
				19.01
			],
			[
				"2015-06-30",
				19.01
			],
			[
				"2015-06-01",
				18.01
			],
			[
				"2015-04-30",
				19.01
			],
			[
				"2015-04-08",
				19.01
			],
			[
				"2015-03-31",
				13
			],
			[
				"2015-02-27",
				19.01
			],
			[
				"2015-01-30",
				20.01
			]
		],
		"106505154": [
			[
				"2000-04-06",
				25.01
			],
			[
				"2000-09-20",
				27.01
			],
			[
				"2001-04-19",
				28.01
			],
			[
				"2001-10-09",
				29.01
			],
			[
				"2002-10-15",
				24.01
			],
			[
				"2007-03-19",
				25.01
			],
			[
				"2006-09-14",
				25.01
			],
			[
				"2006-03-21",
				27.01
			],
			[
				"2005-09-06",
				24.01
			],
			[
				"2005-03-30",
				24.01
			],
			[
				"2004-04-20",
				20.01
			],
			[
				"2004-09-28",
				22.01
			],
			[
				"2003-10-06",
				22.01
			],
			[
				"2003-04-29",
				21.01
			],
			[
				"2006-01-31",
				29.01
			],
			[
				"2006-03-31",
				27.01
			],
			[
				"2006-04-27",
				27.01
			],
			[
				"2006-05-31",
				25.01
			],
			[
				"2006-02-28",
				30.01
			],
			[
				"2006-09-28",
				26.01
			],
			[
				"2006-08-31",
				25.01
			],
			[
				"2006-10-31",
				25.01
			],
			[
				"2006-05-18",
				26.01
			],
			[
				"2006-06-29",
				25.01
			],
			[
				"2006-07-31",
				26.01
			],
			[
				"2006-11-30",
				28.01
			],
			[
				"2007-04-27",
				24.01
			],
			[
				"2007-01-31",
				18.01
			],
			[
				"2007-02-28",
				20.01
			],
			[
				"2007-03-30",
				25.01
			],
			[
				"2007-05-31",
				24.01
			],
			[
				"2007-01-02",
				27.01
			],
			[
				"2007-06-29",
				25.01
			],
			[
				"2007-07-30",
				23.01
			],
			[
				"2007-08-31",
				26.01
			],
			[
				"2007-07-10",
				24.01
			],
			[
				"2007-09-28",
				27.01
			],
			[
				"2007-11-30",
				25.01
			],
			[
				"2007-12-27",
				23.01
			],
			[
				"2007-10-31",
				26.01
			],
			[
				"2008-03-17",
				23.01
			],
			[
				"2008-01-31",
				22.01
			],
			[
				"2008-04-30",
				24.01
			],
			[
				"2008-05-30",
				23.01
			],
			[
				"2008-08-29",
				23.01
			],
			[
				"2008-09-23",
				24.01
			],
			[
				"2008-09-30",
				24.01
			],
			[
				"2008-06-30",
				22.01
			],
			[
				"2008-10-31",
				24.01
			],
			[
				"2008-02-29",
				21.01
			],
			[
				"2008-03-31",
				22.01
			],
			[
				"2008-11-28",
				27.01
			],
			[
				"2008-07-31",
				24.01
			],
			[
				"2009-06-30",
				22.01
			],
			[
				"2009-07-31",
				24.01
			],
			[
				"2009-02-27",
				24.01
			],
			[
				"2009-05-29",
				23.01
			],
			[
				"2009-01-30",
				22.01
			],
			[
				"2009-03-17",
				24.01
			],
			[
				"2009-03-31",
				25.01
			],
			[
				"2009-04-30",
				23.01
			],
			[
				"2009-08-31",
				23.01
			],
			[
				"2009-09-01",
				23.01
			],
			[
				"2009-09-30",
				24.01
			],
			[
				"2009-11-30",
				24.01
			],
			[
				"2009-10-30",
				24.01
			],
			[
				"2010-01-04",
				23.01
			],
			[
				"2010-01-29",
				23.01
			],
			[
				"2010-06-29",
				21.01
			],
			[
				"2010-03-03",
				23.01
			],
			[
				"2010-03-30",
				23.01
			],
			[
				"2010-04-30",
				23.01
			],
			[
				"2010-02-26",
				22.01
			],
			[
				"2010-05-31",
				21.01
			],
			[
				"2010-07-30",
				21.01
			],
			[
				"2010-08-31",
				24.01
			],
			[
				"2010-09-06",
				24.01
			],
			[
				"2010-09-30",
				22.01
			],
			[
				"2010-09-20",
				25.01
			],
			[
				"2010-11-02",
				22.01
			],
			[
				"2010-11-30",
				22.01
			],
			[
				"2012-11-30",
				25.01
			],
			[
				"2012-10-31",
				24.01
			],
			[
				"2012-09-28",
				24.01
			],
			[
				"2012-08-31",
				24.01
			],
			[
				"2012-07-31",
				22.01
			],
			[
				"2012-06-29",
				23.01
			],
			[
				"2012-05-31",
				23.01
			],
			[
				"2012-05-02",
				24.01
			],
			[
				"2012-04-02",
				23.01
			],
			[
				"2012-03-30",
				22.01
			],
			[
				"2012-02-29",
				24.01
			],
			[
				"2012-01-31",
				23.01
			],
			[
				"2012-01-02",
				22.01
			],
			[
				"2013-11-29",
				24.01
			],
			[
				"2013-11-04",
				24.01
			],
			[
				"2013-09-30",
				23.01
			],
			[
				"2013-09-02",
				23.01
			],
			[
				"2013-07-31",
				23.01
			],
			[
				"2013-07-01",
				23.01
			],
			[
				"2013-06-03",
				23.01
			],
			[
				"2013-04-30",
				23.01
			],
			[
				"2013-03-28",
				23.01
			],
			[
				"2013-03-14",
				23.01
			],
			[
				"2013-02-28",
				22.01
			],
			[
				"2013-01-31",
				24.01
			],
			[
				"2013-01-02",
				26.01
			],
			[
				"2014-12-01",
				24.01
			],
			[
				"2014-11-03",
				23.01
			],
			[
				"2014-09-29",
				24.01
			],
			[
				"2014-09-02",
				24.01
			],
			[
				"2014-07-31",
				24.01
			],
			[
				"2014-06-30",
				24.01
			],
			[
				"2014-05-28",
				26.01
			],
			[
				"2014-04-30",
				24.01
			],
			[
				"2014-04-01",
				25.01
			],
			[
				"2014-03-20",
				25.01
			],
			[
				"2014-02-28",
				25.01
			],
			[
				"2014-01-31",
				25.01
			],
			[
				"2013-12-30",
				25.01
			],
			[
				"2015-11-30",
				24.01
			],
			[
				"2015-10-30",
				24.01
			],
			[
				"2015-10-01",
				24.01
			],
			[
				"2015-08-27",
				24.01
			],
			[
				"2015-07-30",
				24.01
			],
			[
				"2015-06-30",
				24.01
			],
			[
				"2015-06-01",
				24.01
			],
			[
				"2015-04-30",
				23.01
			],
			[
				"2015-04-08",
				23.01
			],
			[
				"2015-03-31",
				23.01
			],
			[
				"2015-02-27",
				23.01
			],
			[
				"2015-01-30",
				22.01
			]
		],
		"106505166": [
			[
				"2000-04-06",
				40.01
			],
			[
				"2000-09-20",
				38.01
			],
			[
				"2001-04-19",
				39.01
			],
			[
				"2001-10-09",
				38.01
			],
			[
				"2002-10-15",
				36.01
			],
			[
				"2007-03-19",
				33.01
			],
			[
				"2006-09-14",
				30.01
			],
			[
				"2006-03-21",
				31.01
			],
			[
				"2005-09-06",
				27.01
			],
			[
				"2005-04-18",
				31.01
			],
			[
				"2004-09-28",
				27.01
			],
			[
				"2004-04-20",
				29.01
			],
			[
				"2003-10-06",
				32.01
			],
			[
				"2003-04-29",
				35.01
			],
			[
				"2006-08-31",
				30.01
			],
			[
				"2007-09-14",
				31.01
			],
			[
				"2008-02-29",
				36.01
			],
			[
				"2008-01-31",
				35.01
			],
			[
				"2008-03-17",
				35.01
			],
			[
				"2008-03-31",
				36.01
			],
			[
				"2008-04-30",
				36.01
			],
			[
				"2008-05-30",
				35.01
			],
			[
				"2008-06-30",
				30.01
			],
			[
				"2008-09-30",
				34.01
			],
			[
				"2008-07-31",
				36.01
			],
			[
				"2008-10-31",
				33.01
			],
			[
				"2008-11-28",
				35.01
			],
			[
				"2008-08-29",
				33.01
			],
			[
				"2008-09-23",
				34.01
			],
			[
				"2009-01-30",
				31.01
			],
			[
				"2009-03-17",
				33.01
			],
			[
				"2009-03-31",
				36.01
			],
			[
				"2009-04-30",
				33.01
			],
			[
				"2009-06-30",
				31.01
			],
			[
				"2009-07-31",
				32.01
			],
			[
				"2009-05-29",
				31.01
			],
			[
				"2009-02-27",
				32.01
			],
			[
				"2009-09-01",
				30.01
			],
			[
				"2009-11-30",
				31.01
			],
			[
				"2009-10-30",
				29.01
			],
			[
				"2009-08-31",
				30.01
			],
			[
				"2009-09-30",
				31.01
			],
			[
				"2010-01-29",
				32.01
			],
			[
				"2010-03-03",
				32.01
			],
			[
				"2010-03-30",
				33.01
			],
			[
				"2010-04-30",
				31.01
			],
			[
				"2010-01-04",
				30.01
			],
			[
				"2010-02-26",
				32.01
			],
			[
				"2010-06-29",
				27.01
			],
			[
				"2010-05-31",
				29.01
			],
			[
				"2010-09-30",
				27.01
			],
			[
				"2010-11-02",
				30.01
			],
			[
				"2010-09-06",
				30.01
			],
			[
				"2010-07-30",
				27.01
			],
			[
				"2010-08-31",
				30.01
			],
			[
				"2010-11-30",
				29.01
			],
			[
				"2012-11-30",
				30.01
			],
			[
				"2012-10-31",
				28.01
			],
			[
				"2012-09-28",
				28.01
			],
			[
				"2012-08-31",
				29.01
			],
			[
				"2012-07-31",
				28.01
			],
			[
				"2012-06-29",
				29.01
			],
			[
				"2012-05-31",
				29.01
			],
			[
				"2012-05-02",
				31.01
			],
			[
				"2012-04-02",
				32.01
			],
			[
				"2012-03-30",
				30.01
			],
			[
				"2012-02-29",
				32.01
			],
			[
				"2012-01-31",
				34.01
			],
			[
				"2012-01-02",
				31.01
			],
			[
				"2013-11-29",
				29.01
			],
			[
				"2013-11-04",
				28.01
			],
			[
				"2013-09-30",
				27.01
			],
			[
				"2013-09-02",
				28.01
			],
			[
				"2013-07-31",
				29.01
			],
			[
				"2013-07-01",
				29.01
			],
			[
				"2013-06-03",
				30.01
			],
			[
				"2013-04-30",
				29.01
			],
			[
				"2013-03-28",
				31.01
			],
			[
				"2013-03-14",
				29.01
			],
			[
				"2013-02-28",
				31.01
			],
			[
				"2013-01-31",
				31.01
			],
			[
				"2013-01-02",
				34.01
			],
			[
				"2014-12-01",
				27.01
			],
			[
				"2014-11-03",
				28.01
			],
			[
				"2014-09-29",
				28.01
			],
			[
				"2014-09-02",
				28.01
			],
			[
				"2014-07-31",
				28.01
			],
			[
				"2014-06-30",
				28.01
			],
			[
				"2014-05-28",
				36.01
			],
			[
				"2014-04-30",
				29.01
			],
			[
				"2014-04-01",
				30.01
			],
			[
				"2014-03-20",
				29.01
			],
			[
				"2014-02-28",
				30.01
			],
			[
				"2014-01-31",
				30.01
			],
			[
				"2013-12-30",
				33.01
			],
			[
				"2015-11-30",
				29.01
			],
			[
				"2015-10-30",
				27.01
			],
			[
				"2015-10-02",
				28.01
			],
			[
				"2015-08-27",
				28.01
			],
			[
				"2015-07-30",
				28.01
			],
			[
				"2015-06-30",
				27.01
			],
			[
				"2015-06-01",
				29.01
			],
			[
				"2015-04-30",
				28.01
			],
			[
				"2015-04-08",
				29.01
			],
			[
				"2015-03-31",
				28.01
			],
			[
				"2015-02-27",
				28.01
			],
			[
				"2015-01-30",
				27.01
			]
		],
		"106505178": [
			[
				"2000-04-06",
				28.01
			],
			[
				"2000-09-20",
				28.01
			],
			[
				"2001-04-19",
				27.01
			],
			[
				"2001-10-09",
				29.01
			],
			[
				"2002-10-10",
				26.01
			],
			[
				"2007-03-19",
				25.01
			],
			[
				"2006-09-14",
				23.01
			],
			[
				"2006-03-21",
				24.01
			],
			[
				"2005-09-06",
				23.01
			],
			[
				"2005-03-30",
				24.01
			],
			[
				"2004-12-06",
				30.01
			],
			[
				"2004-11-30",
				29.01
			],
			[
				"2004-09-28",
				25.01
			],
			[
				"2004-04-20",
				24.01
			],
			[
				"2003-10-06",
				27.01
			],
			[
				"2003-04-29",
				27.01
			],
			[
				"2006-08-31",
				24.01
			],
			[
				"2008-01-31",
				24.01
			],
			[
				"2008-02-29",
				19.01
			],
			[
				"2008-03-17",
				24.01
			],
			[
				"2008-04-30",
				26.01
			],
			[
				"2008-09-30",
				29.01
			],
			[
				"2008-08-29",
				27.01
			],
			[
				"2008-10-31",
				28.01
			],
			[
				"2008-03-31",
				27.01
			],
			[
				"2008-05-30",
				27.01
			],
			[
				"2008-06-30",
				24.01
			],
			[
				"2008-07-31",
				17.01
			],
			[
				"2008-09-23",
				29.01
			],
			[
				"2008-11-28",
				28.01
			],
			[
				"2009-02-27",
				26.01
			],
			[
				"2009-04-30",
				23.01
			],
			[
				"2009-01-30",
				21.01
			],
			[
				"2009-03-17",
				13
			],
			[
				"2009-03-31",
				27.01
			],
			[
				"2009-05-29",
				17.01
			],
			[
				"2009-09-30",
				27.01
			],
			[
				"2009-08-31",
				27.01
			],
			[
				"2009-07-31",
				27.01
			],
			[
				"2009-09-01",
				27.01
			],
			[
				"2009-11-30",
				25.01
			],
			[
				"2009-06-30",
				25.01
			],
			[
				"2009-10-30",
				26.01
			],
			[
				"2010-01-29",
				25.01
			],
			[
				"2010-04-30",
				26.01
			],
			[
				"2010-05-31",
				24.01
			],
			[
				"2010-06-29",
				23.01
			],
			[
				"2010-02-26",
				26.01
			],
			[
				"2010-03-03",
				24.01
			],
			[
				"2010-03-30",
				25.01
			],
			[
				"2010-01-04",
				26.01
			],
			[
				"2010-09-06",
				26.01
			],
			[
				"2010-07-30",
				21.01
			],
			[
				"2010-08-31",
				26.01
			],
			[
				"2010-11-02",
				26.01
			],
			[
				"2010-09-30",
				23.01
			],
			[
				"2010-11-30",
				26.01
			],
			[
				"2012-11-30",
				27.01
			],
			[
				"2012-10-31",
				26.01
			],
			[
				"2012-09-28",
				26.01
			],
			[
				"2012-08-31",
				27.01
			],
			[
				"2012-07-31",
				27.01
			],
			[
				"2012-06-29",
				27.01
			],
			[
				"2012-05-31",
				27.01
			],
			[
				"2012-05-02",
				28.01
			],
			[
				"2012-04-02",
				29.01
			],
			[
				"2012-03-30",
				29.01
			],
			[
				"2012-02-29",
				28.01
			],
			[
				"2012-01-31",
				28.01
			],
			[
				"2012-01-02",
				25.01
			],
			[
				"2013-11-29",
				26.01
			],
			[
				"2013-11-04",
				26.01
			],
			[
				"2013-09-30",
				25.01
			],
			[
				"2013-09-02",
				25.01
			],
			[
				"2013-07-31",
				15.01
			],
			[
				"2013-07-01",
				26.01
			],
			[
				"2013-06-03",
				26.01
			],
			[
				"2013-04-30",
				25.01
			],
			[
				"2013-03-28",
				26.01
			],
			[
				"2013-03-14",
				24.01
			],
			[
				"2013-02-28",
				26.01
			],
			[
				"2013-01-31",
				26.01
			],
			[
				"2013-01-02",
				28.01
			],
			[
				"2014-12-01",
				27.01
			],
			[
				"2014-11-03",
				26.01
			],
			[
				"2014-09-29",
				26.01
			],
			[
				"2014-09-02",
				27.01
			],
			[
				"2014-07-31",
				27.01
			],
			[
				"2014-07-16",
				26.01
			],
			[
				"2014-06-30",
				56.02
			],
			[
				"2014-05-28",
				28.01
			],
			[
				"2014-04-30",
				26.01
			],
			[
				"2014-04-01",
				27.01
			],
			[
				"2014-03-20",
				27.01
			],
			[
				"2014-02-28",
				27.01
			],
			[
				"2014-01-31",
				27.01
			],
			[
				"2013-12-30",
				26.01
			],
			[
				"2015-11-30",
				27.01
			],
			[
				"2015-10-30",
				27.01
			],
			[
				"2015-10-01",
				28.01
			],
			[
				"2015-08-27",
				28.01
			],
			[
				"2015-07-30",
				28.01
			],
			[
				"2015-06-30",
				28.01
			],
			[
				"2015-06-01",
				28.01
			],
			[
				"2015-04-30",
				29.01
			],
			[
				"2015-04-08",
				28.01
			],
			[
				"2015-03-31",
				28.01
			],
			[
				"2015-02-27",
				28.01
			],
			[
				"2015-01-30",
				28.01
			]
		],
		"106505180": [
			[
				"2000-04-06",
				36.01
			],
			[
				"2000-09-20",
				37.01
			],
			[
				"2001-04-19",
				35.01
			],
			[
				"2001-10-09",
				32.01
			],
			[
				"2002-10-10",
				28.01
			],
			[
				"2007-03-19",
				34.01
			],
			[
				"2006-09-14",
				35.01
			],
			[
				"2006-03-21",
				36.01
			],
			[
				"2005-09-06",
				33.01
			],
			[
				"2005-04-18",
				31.01
			],
			[
				"2004-09-28",
				29.01
			],
			[
				"2004-04-20",
				26.01
			],
			[
				"2003-10-06",
				30.01
			],
			[
				"2003-04-29",
				31.01
			],
			[
				"2010-03-03",
				38.01
			],
			[
				"2010-04-30",
				39.01
			],
			[
				"2010-03-30",
				41.01
			],
			[
				"2010-01-04",
				35.01
			],
			[
				"2010-01-29",
				38.01
			],
			[
				"2010-02-26",
				40.01
			],
			[
				"2010-05-31",
				38.01
			],
			[
				"2010-06-29",
				35.01
			],
			[
				"2010-08-31",
				39.01
			],
			[
				"2010-09-30",
				31.01
			],
			[
				"2010-09-06",
				36.01
			],
			[
				"2010-11-02",
				37.01
			],
			[
				"2010-11-30",
				40.01
			],
			[
				"2010-07-30",
				35.01
			],
			[
				"2009-06-30",
				38.01
			],
			[
				"2009-03-17",
				36.01
			],
			[
				"2009-04-30",
				39.01
			],
			[
				"2009-07-31",
				40.01
			],
			[
				"2009-02-27",
				35.01
			],
			[
				"2009-01-30",
				36.01
			],
			[
				"2009-03-31",
				40.01
			],
			[
				"2009-05-29",
				38.01
			],
			[
				"2009-09-30",
				40.01
			],
			[
				"2009-10-30",
				39.01
			],
			[
				"2009-08-31",
				39.01
			],
			[
				"2009-11-30",
				36.01
			],
			[
				"2009-09-01",
				39.01
			],
			[
				"2008-02-29",
				38.01
			],
			[
				"2008-04-30",
				38.01
			],
			[
				"2008-03-31",
				39.01
			],
			[
				"2008-01-31",
				36.01
			],
			[
				"2008-03-17",
				36.01
			],
			[
				"2008-05-30",
				38.01
			],
			[
				"2008-06-30",
				33.01
			],
			[
				"2008-08-29",
				38.01
			],
			[
				"2008-09-23",
				40.01
			],
			[
				"2008-09-30",
				40.01
			],
			[
				"2008-10-31",
				40.01
			],
			[
				"2008-07-31",
				41.01
			],
			[
				"2008-11-28",
				41.01
			],
			[
				"2012-11-30",
				44.02
			],
			[
				"2012-10-31",
				44.02
			],
			[
				"2012-09-28",
				45.02
			],
			[
				"2012-08-31",
				45.02
			],
			[
				"2012-07-31",
				46.02
			],
			[
				"2012-06-29",
				46.02
			],
			[
				"2012-05-31",
				45.02
			],
			[
				"2012-05-02",
				46.02
			],
			[
				"2012-04-02",
				46.02
			],
			[
				"2012-03-30",
				46.02
			],
			[
				"2012-02-29",
				46.02
			],
			[
				"2012-01-31",
				45.02
			],
			[
				"2012-01-02",
				41.01
			],
			[
				"2013-11-29",
				45.02
			],
			[
				"2013-11-04",
				46.02
			],
			[
				"2013-09-30",
				44.02
			],
			[
				"2013-09-02",
				46.02
			],
			[
				"2013-07-31",
				46.02
			],
			[
				"2013-07-01",
				45.02
			],
			[
				"2013-06-03",
				44.02
			],
			[
				"2013-04-30",
				45.02
			],
			[
				"2013-03-28",
				47.02
			],
			[
				"2013-03-14",
				45.02
			],
			[
				"2013-02-28",
				46.02
			],
			[
				"2013-01-31",
				46.02
			],
			[
				"2013-01-02",
				46.02
			],
			[
				"2014-12-01",
				43.02
			],
			[
				"2014-11-03",
				42.01
			],
			[
				"2014-09-29",
				44.02
			],
			[
				"2014-09-02",
				47.02
			],
			[
				"2014-07-31",
				33.01
			],
			[
				"2014-07-16",
				41.01
			],
			[
				"2014-06-30",
				36.01
			],
			[
				"2014-05-28",
				51.02
			],
			[
				"2014-04-30",
				48.02
			],
			[
				"2014-04-01",
				50.02
			],
			[
				"2014-03-20",
				49.02
			],
			[
				"2014-02-28",
				50.02
			],
			[
				"2014-01-31",
				49.02
			],
			[
				"2014-01-09",
				46.02
			],
			[
				"2013-12-30",
				45.02
			],
			[
				"2015-11-30",
				39.01
			],
			[
				"2015-10-30",
				39.01
			],
			[
				"2015-10-01",
				44.02
			],
			[
				"2015-08-27",
				47.02
			],
			[
				"2015-07-30",
				47.02
			],
			[
				"2015-06-30",
				47.02
			],
			[
				"2015-06-01",
				47.02
			],
			[
				"2015-04-30",
				47.02
			],
			[
				"2015-04-08",
				46.02
			],
			[
				"2015-03-31",
				44.02
			],
			[
				"2015-02-27",
				45.02
			],
			[
				"2015-01-30",
				45.02
			]
		],
		"106505233": [
			[
				"2000-05-10",
				11
			],
			[
				"2000-11-15",
				11
			],
			[
				"2002-04-23",
				11
			],
			[
				"2002-11-12",
				11
			],
			[
				"2003-03-20",
				11
			],
			[
				"2003-12-01",
				11
			],
			[
				"2004-03-18",
				11
			],
			[
				"2004-09-28",
				11
			],
			[
				"2005-09-26",
				11
			],
			[
				"2005-04-27",
				11
			],
			[
				"2006-11-09",
				11
			],
			[
				"2006-05-10",
				11
			],
			[
				"2007-03-20",
				11
			],
			[
				"2007-11-15",
				11
			],
			[
				"2008-05-08",
				10
			],
			[
				"2008-10-23",
				11
			],
			[
				"2009-05-05",
				11
			],
			[
				"2009-10-13",
				12
			],
			[
				"2010-03-23",
				12
			],
			[
				"2010-10-27",
				11
			],
			[
				"2011-05-04",
				11
			],
			[
				"2011-11-07",
				11
			],
			[
				"2012-05-21",
				12
			],
			[
				"2012-10-29",
				11
			],
			[
				"2013-06-06",
				11
			],
			[
				"2013-10-24",
				11
			],
			[
				"2014-03-31",
				11
			],
			[
				"2014-10-30",
				11
			],
			[
				"2015-03-25",
				11
			],
			[
				"2015-10-08",
				18.01
			]
		],
		"106505312": [
			[
				"2002-11-28",
				18.01
			],
			[
				"2003-03-26",
				17.01
			],
			[
				"2003-11-13",
				20.01
			],
			[
				"2004-05-05",
				18.01
			],
			[
				"2004-11-10",
				21.01
			],
			[
				"2005-04-27",
				18.01
			],
			[
				"2005-10-20",
				22.01
			],
			[
				"2006-10-25",
				21.01
			],
			[
				"2006-05-04",
				26.01
			],
			[
				"2007-03-22",
				24.01
			],
			[
				"2007-10-08",
				28.01
			],
			[
				"2008-04-16",
				19.01
			],
			[
				"2008-11-12",
				23.01
			],
			[
				"2009-05-12",
				20.01
			],
			[
				"2009-10-20",
				22.01
			],
			[
				"2010-03-25",
				25.01
			],
			[
				"2010-10-27",
				22.01
			],
			[
				"2011-05-17",
				19.01
			],
			[
				"2011-11-10",
				22.01
			],
			[
				"2012-05-29",
				20.01
			],
			[
				"2012-10-23",
				15.01
			],
			[
				"2013-04-08",
				19.01
			],
			[
				"2013-10-21",
				21.01
			],
			[
				"2014-03-27",
				20.01
			],
			[
				"2014-10-29",
				14
			],
			[
				"2015-04-15",
				23.01
			],
			[
				"2015-10-29",
				19.01
			]
		],
		"106505439": [
			[
				"2000-05-11",
				32.01
			],
			[
				"2000-11-10",
				35.01
			],
			[
				"2001-11-15",
				50.02
			],
			[
				"2001-03-16",
				34.01
			],
			[
				"2002-03-12",
				31.01
			],
			[
				"2002-11-11",
				35.01
			],
			[
				"2005-04-11",
				39.01
			],
			[
				"2005-11-14",
				35.01
			],
			[
				"2003-03-10",
				32.01
			],
			[
				"2003-10-13",
				31.01
			],
			[
				"2006-10-18",
				31.01
			],
			[
				"2007-04-02",
				33.01
			],
			[
				"2007-09-19",
				30.01
			],
			[
				"2008-04-14",
				29.01
			],
			[
				"2008-10-06",
				31.01
			],
			[
				"2008-12-11",
				33.01
			],
			[
				"2009-11-09",
				29.01
			],
			[
				"2010-05-10",
				27.01
			],
			[
				"2010-11-08",
				31.01
			],
			[
				"2012-11-12",
				29.01
			],
			[
				"2012-05-14",
				27.01
			],
			[
				"2013-11-11",
				28.01
			],
			[
				"2013-05-17",
				28.01
			],
			[
				"2014-11-10",
				28.01
			],
			[
				"2014-05-12",
				28.01
			],
			[
				"2015-11-09",
				28.01
			],
			[
				"2015-05-11",
				28.01
			]
		],
		"106505452": [
			[
				"2000-02-23",
				46.02
			],
			[
				"2000-09-13",
				50.02
			],
			[
				"2000-11-09",
				50.02
			],
			[
				"2002-12-09",
				54.02
			],
			[
				"2005-11-15",
				53.02
			],
			[
				"2003-01-06",
				51.02
			],
			[
				"2003-04-11",
				51.02
			],
			[
				"2003-10-14",
				52.02
			],
			[
				"2006-10-19",
				51.02
			],
			[
				"2007-07-17",
				51.02
			],
			[
				"2007-10-29",
				55.02
			],
			[
				"2007-09-19",
				54.02
			],
			[
				"2008-04-14",
				56.02
			],
			[
				"2008-10-06",
				57.02
			],
			[
				"2008-07-08",
				52.02
			],
			[
				"2010-05-10",
				53.02
			],
			[
				"2010-11-08",
				55.02
			],
			[
				"2013-11-11",
				53.02
			],
			[
				"2014-11-10",
				54.02
			],
			[
				"2014-05-12",
				55.02
			],
			[
				"2015-09-14",
				50.02
			]
		],
		"106505520": [
			[
				"2000-04-11",
				13
			],
			[
				"2000-09-12",
				13
			],
			[
				"2001-04-03",
				14
			],
			[
				"2002-09-24",
				13
			],
			[
				"2007-03-15",
				12
			],
			[
				"2009-03-10",
				13
			],
			[
				"2010-03-04",
				13
			],
			[
				"2012-03-20",
				13
			],
			[
				"2013-03-21",
				12
			],
			[
				"2014-03-05",
				12
			],
			[
				"2015-04-21",
				13
			]
		],
		"106505853": [
			[
				"2000-04-11",
				20.01
			],
			[
				"2000-09-12",
				20.01
			],
			[
				"2001-04-03",
				21.01
			],
			[
				"2001-09-11",
				21.01
			],
			[
				"2002-09-24",
				10
			],
			[
				"2006-03-29",
				22.01
			],
			[
				"2006-11-22",
				17.01
			],
			[
				"2007-03-15",
				23.01
			],
			[
				"2013-03-21",
				24.01
			],
			[
				"2014-04-29",
				20.01
			],
			[
				"2014-03-05",
				24.01
			],
			[
				"2015-04-21",
				23.01
			]
		],
		"106505877": [
			[
				"2000-04-11",
				15.01
			],
			[
				"2000-09-12",
				16.01
			],
			[
				"2001-04-03",
				15.01
			],
			[
				"2001-09-11",
				14
			],
			[
				"2002-09-24",
				14
			],
			[
				"2006-03-29",
				15.01
			],
			[
				"2006-11-22",
				13
			],
			[
				"2007-03-15",
				13
			],
			[
				"2007-09-20",
				13
			],
			[
				"2008-04-17",
				13
			],
			[
				"2008-10-22",
				15.01
			],
			[
				"2009-03-10",
				12
			],
			[
				"2009-09-17",
				14
			],
			[
				"2010-03-04",
				12
			],
			[
				"2010-09-16",
				13
			],
			[
				"2012-09-18",
				12
			],
			[
				"2012-03-20",
				13
			],
			[
				"2013-11-07",
				12
			],
			[
				"2013-03-21",
				11
			],
			[
				"2014-11-04",
				11
			],
			[
				"2014-04-29",
				12
			],
			[
				"2015-09-21",
				12
			],
			[
				"2015-04-21",
				12
			]
		],
		"106506020": [
			[
				"2000-05-02",
				24.01
			],
			[
				"2000-09-21",
				23.01
			],
			[
				"2001-04-17",
				23.01
			],
			[
				"2001-10-04",
				23.01
			],
			[
				"2002-10-14",
				23.01
			],
			[
				"2002-04-11",
				19.01
			],
			[
				"2005-11-08",
				17.01
			],
			[
				"2005-04-04",
				18.01
			],
			[
				"2004-10-18",
				19.01
			],
			[
				"2004-05-04",
				20.01
			],
			[
				"2003-11-06",
				18.01
			],
			[
				"2003-04-02",
				21.01
			],
			[
				"2007-04-19",
				20.01
			],
			[
				"2006-10-16",
				19.01
			],
			[
				"2006-04-11",
				20.01
			],
			[
				"2007-10-09",
				21.01
			],
			[
				"2008-04-01",
				20.01
			],
			[
				"2008-09-19",
				22.01
			],
			[
				"2008-10-24",
				20.01
			],
			[
				"2009-04-08",
				22.01
			],
			[
				"2009-10-19",
				21.01
			],
			[
				"2010-04-13",
				21.01
			],
			[
				"2010-10-22",
				19.01
			],
			[
				"2012-10-25",
				18.01
			],
			[
				"2012-04-18",
				20.01
			],
			[
				"2013-11-18",
				19.01
			],
			[
				"2013-04-23",
				17.01
			],
			[
				"2014-10-29",
				18.01
			],
			[
				"2014-04-24",
				18.01
			],
			[
				"2015-10-15",
				17.01
			],
			[
				"2015-04-09",
				18.01
			]
		],
		"106506031": [
			[
				"2000-05-02",
				23.01
			],
			[
				"2000-09-21",
				21.01
			],
			[
				"2001-04-17",
				28.01
			],
			[
				"2001-10-04",
				24.01
			],
			[
				"2002-04-11",
				21.01
			],
			[
				"2005-11-08",
				12
			],
			[
				"2005-04-04",
				17.01
			],
			[
				"2004-10-18",
				17.01
			],
			[
				"2004-05-04",
				22.01
			],
			[
				"2003-11-06",
				15.01
			],
			[
				"2003-04-02",
				20.01
			],
			[
				"2007-04-19",
				20.01
			],
			[
				"2006-10-16",
				18.01
			],
			[
				"2006-04-11",
				17.01
			],
			[
				"2007-10-09",
				21.01
			],
			[
				"2008-04-01",
				16.01
			],
			[
				"2008-10-09",
				17.01
			],
			[
				"2009-04-08",
				20.01
			],
			[
				"2009-10-19",
				14
			],
			[
				"2010-04-13",
				13
			],
			[
				"2010-10-22",
				14
			],
			[
				"2012-10-25",
				28.01
			],
			[
				"2012-04-18",
				16.01
			],
			[
				"2013-11-18",
				14
			],
			[
				"2013-04-23",
				16.01
			],
			[
				"2014-10-29",
				17.01
			],
			[
				"2014-04-24",
				14
			],
			[
				"2015-10-15",
				13
			],
			[
				"2015-04-09",
				13
			]
		],
		"106506043": [
			[
				"2000-05-02",
				10
			],
			[
				"2000-09-21",
				8
			],
			[
				"2001-04-17",
				10
			],
			[
				"2001-10-04",
				9
			],
			[
				"2002-10-14",
				10
			],
			[
				"2002-04-11",
				8
			],
			[
				"2005-11-08",
				8
			],
			[
				"2005-04-04",
				7
			],
			[
				"2004-10-18",
				8
			],
			[
				"2004-05-04",
				9
			],
			[
				"2003-11-06",
				7
			],
			[
				"2003-04-02",
				13
			],
			[
				"2007-04-19",
				7
			],
			[
				"2006-10-16",
				8
			],
			[
				"2006-04-11",
				10
			],
			[
				"2007-10-09",
				12
			],
			[
				"2008-10-09",
				9
			],
			[
				"2008-04-01",
				11
			],
			[
				"2009-04-08",
				11
			],
			[
				"2009-10-19",
				9
			],
			[
				"2010-04-13",
				11
			],
			[
				"2010-10-22",
				9
			],
			[
				"2012-10-25",
				9
			],
			[
				"2012-04-18",
				9
			],
			[
				"2013-11-18",
				10
			],
			[
				"2013-04-23",
				9
			],
			[
				"2014-10-29",
				10
			],
			[
				"2014-04-24",
				10
			],
			[
				"2015-10-15",
				9
			],
			[
				"2015-04-09",
				11
			]
		],
		"106506067": [
			[
				"2000-05-02",
				39.01
			],
			[
				"2000-09-21",
				37.01
			],
			[
				"2001-04-17",
				38.01
			],
			[
				"2001-10-04",
				48.02
			],
			[
				"2002-10-14",
				60.02
			],
			[
				"2002-05-08",
				45.02
			],
			[
				"2005-10-24",
				30.01
			],
			[
				"2005-04-04",
				55.02
			],
			[
				"2004-10-18",
				31.01
			],
			[
				"2004-05-04",
				56.02
			],
			[
				"2003-11-06",
				33.01
			],
			[
				"2003-04-02",
				57.02
			],
			[
				"2007-04-19",
				45.02
			],
			[
				"2006-10-16",
				33.01
			],
			[
				"2006-04-11",
				49.02
			],
			[
				"2007-12-13",
				34.01
			],
			[
				"2008-04-01",
				46.02
			],
			[
				"2008-10-09",
				36.01
			],
			[
				"2009-04-08",
				51.02
			],
			[
				"2009-10-19",
				35.01
			],
			[
				"2010-04-13",
				38.01
			],
			[
				"2010-10-22",
				32.01
			],
			[
				"2012-10-25",
				36.01
			],
			[
				"2012-04-18",
				62.02
			],
			[
				"2013-12-13",
				34.01
			],
			[
				"2013-11-18",
				53.02
			],
			[
				"2013-04-23",
				59.02
			],
			[
				"2014-10-29",
				53.02
			],
			[
				"2014-04-24",
				35.01
			],
			[
				"2015-10-15",
				33.01
			],
			[
				"2015-04-09",
				48.02
			]
		],
		"106506079": [
			[
				"2000-05-02",
				12
			],
			[
				"2000-09-21",
				13
			],
			[
				"2001-04-17",
				18.01
			],
			[
				"2001-10-04",
				11
			],
			[
				"2002-10-14",
				10
			],
			[
				"2002-04-11",
				12
			],
			[
				"2005-10-24",
				10
			],
			[
				"2005-04-04",
				13
			],
			[
				"2004-10-18",
				8
			],
			[
				"2004-05-04",
				8
			],
			[
				"2003-11-06",
				6
			],
			[
				"2003-04-02",
				9
			],
			[
				"2007-04-19",
				5
			],
			[
				"2006-10-16",
				7
			],
			[
				"2006-04-11",
				14
			],
			[
				"2007-10-09",
				6
			],
			[
				"2008-04-01",
				7
			],
			[
				"2008-10-09",
				3
			],
			[
				"2009-04-08",
				6
			],
			[
				"2009-10-19",
				4
			],
			[
				"2010-04-13",
				7
			],
			[
				"2010-10-22",
				5
			],
			[
				"2012-10-25",
				4
			],
			[
				"2012-04-18",
				5
			],
			[
				"2013-11-18",
				6
			],
			[
				"2013-04-23",
				5
			],
			[
				"2014-10-29",
				5
			],
			[
				"2014-04-24",
				5
			],
			[
				"2015-10-15",
				5
			],
			[
				"2015-04-09",
				9
			]
		],
		"106506080": [
			[
				"2000-05-02",
				25.01
			],
			[
				"2000-09-21",
				25.01
			],
			[
				"2001-04-17",
				24.01
			],
			[
				"2001-10-04",
				18.01
			],
			[
				"2002-10-14",
				23.01
			],
			[
				"2002-04-11",
				23.01
			],
			[
				"2005-10-24",
				23.01
			],
			[
				"2005-04-04",
				20.01
			],
			[
				"2004-10-18",
				23.01
			],
			[
				"2004-05-04",
				23.01
			],
			[
				"2003-11-06",
				22.01
			],
			[
				"2003-04-02",
				22.01
			],
			[
				"2007-04-19",
				20.01
			],
			[
				"2006-10-16",
				22.01
			],
			[
				"2006-04-11",
				22.01
			],
			[
				"2007-10-09",
				24.01
			],
			[
				"2008-10-09",
				22.01
			],
			[
				"2008-04-01",
				23.01
			],
			[
				"2009-04-08",
				23.01
			],
			[
				"2009-10-19",
				23.01
			],
			[
				"2010-04-13",
				21.01
			],
			[
				"2010-10-22",
				20.01
			],
			[
				"2012-10-25",
				20.01
			],
			[
				"2012-04-18",
				21.01
			],
			[
				"2013-11-18",
				21.01
			],
			[
				"2013-04-23",
				18.01
			],
			[
				"2014-10-29",
				21.01
			],
			[
				"2014-04-24",
				21.01
			],
			[
				"2015-10-15",
				19.01
			],
			[
				"2015-04-09",
				17.01
			]
		],
		"106506109": [
			[
				"2000-05-02",
				45.02
			],
			[
				"2000-09-21",
				52.02
			],
			[
				"2001-04-17",
				56.02
			],
			[
				"2001-10-04",
				49.02
			],
			[
				"2002-10-14",
				49.02
			],
			[
				"2002-04-11",
				43.02
			],
			[
				"2005-10-24",
				37.01
			],
			[
				"2005-04-04",
				42.01
			],
			[
				"2004-10-18",
				49.02
			],
			[
				"2004-05-04",
				49.02
			],
			[
				"2003-11-06",
				46.02
			],
			[
				"2003-04-02",
				42.01
			],
			[
				"2007-04-19",
				37.01
			],
			[
				"2006-10-16",
				39.01
			],
			[
				"2006-04-11",
				44.02
			],
			[
				"2007-10-09",
				48.02
			],
			[
				"2008-04-01",
				44.02
			],
			[
				"2008-10-09",
				41.01
			],
			[
				"2009-04-08",
				44.02
			],
			[
				"2009-10-19",
				38.01
			],
			[
				"2010-04-13",
				40.01
			],
			[
				"2010-10-22",
				64.02
			],
			[
				"2012-10-25",
				36.01
			],
			[
				"2012-04-18",
				37.01
			],
			[
				"2013-12-13",
				38.01
			],
			[
				"2013-11-18",
				36.01
			],
			[
				"2013-04-23",
				36.01
			],
			[
				"2013-02-19",
				41.01
			],
			[
				"2014-10-29",
				42.01
			],
			[
				"2014-06-06",
				39.01
			],
			[
				"2015-10-15",
				38.01
			],
			[
				"2015-04-09",
				44.02
			]
		],
		"106506110": [
			[
				"2000-05-02",
				17.01
			],
			[
				"2000-09-21",
				12
			],
			[
				"2001-04-17",
				13
			],
			[
				"2001-10-04",
				13
			],
			[
				"2002-10-14",
				14
			],
			[
				"2003-11-06",
				9
			],
			[
				"2003-04-02",
				16.01
			],
			[
				"2004-10-18",
				12
			],
			[
				"2004-05-04",
				12
			],
			[
				"2005-11-08",
				11
			],
			[
				"2005-04-04",
				9
			],
			[
				"2006-10-16",
				10
			],
			[
				"2006-04-11",
				11
			],
			[
				"2008-05-15",
				18.01
			],
			[
				"2007-10-09",
				15.01
			],
			[
				"2007-04-19",
				14
			],
			[
				"2012-07-16",
				10
			],
			[
				"2014-02-10",
				28.01
			],
			[
				"2015-07-27",
				11
			]
		],
		"106506195": [
			[
				"2000-11-08",
				1
			],
			[
				"2001-03-28",
				1
			],
			[
				"2001-09-25",
				1
			],
			[
				"2002-03-20",
				4
			],
			[
				"2002-10-02",
				1
			],
			[
				"2003-11-12",
				1
			],
			[
				"2003-03-18",
				1
			],
			[
				"2004-09-09",
				1
			],
			[
				"2004-04-06",
				1
			],
			[
				"2005-03-31",
				2
			],
			[
				"2008-03-18",
				1
			],
			[
				"2008-09-11",
				1
			],
			[
				"2009-04-02",
				1
			],
			[
				"2009-09-09",
				1
			],
			[
				"2010-03-31",
				1
			],
			[
				"2010-11-16",
				1
			],
			[
				"2012-10-18",
				1
			],
			[
				"2012-04-12",
				1
			],
			[
				"2013-10-24",
				1
			],
			[
				"2013-04-26",
				1
			],
			[
				"2014-09-23",
				1
			],
			[
				"2014-03-20",
				1
			],
			[
				"2015-10-05",
				1
			],
			[
				"2015-04-14",
				1
			]
		],
		"106506547": [
			[
				"2000-05-10",
				2
			],
			[
				"2000-11-14",
				1
			],
			[
				"2002-05-14",
				5
			],
			[
				"2002-11-11",
				4
			],
			[
				"2003-03-17",
				4
			],
			[
				"2003-11-11",
				2
			],
			[
				"2004-03-15",
				4
			],
			[
				"2004-09-27",
				2
			],
			[
				"2005-09-27",
				2
			],
			[
				"2005-04-20",
				4
			],
			[
				"2006-11-13",
				2
			],
			[
				"2006-05-03",
				3
			],
			[
				"2007-03-21",
				13
			],
			[
				"2007-10-01",
				3
			],
			[
				"2008-05-19",
				4
			],
			[
				"2008-10-29",
				2
			],
			[
				"2009-03-26",
				9
			],
			[
				"2009-10-19",
				1
			],
			[
				"2010-04-12",
				4
			],
			[
				"2010-09-28",
				2
			],
			[
				"2011-04-27",
				3
			],
			[
				"2011-10-26",
				1
			],
			[
				"2012-05-08",
				2
			],
			[
				"2012-11-06",
				1
			],
			[
				"2013-05-28",
				3
			],
			[
				"2013-11-14",
				6
			],
			[
				"2014-05-20",
				5
			],
			[
				"2014-11-19",
				6
			],
			[
				"2015-05-05",
				5
			],
			[
				"2015-10-13",
				2
			]
		],
		"106520015": [
			[
				"2013-05-13",
				47.83
			],
			[
				"2015-04-13",
				39.9
			],
			[
				"2000-01-12",
				32.77
			],
			[
				"2000-10-12",
				41.63
			],
			[
				"2001-01-24",
				61.56
			],
			[
				"2001-04-18",
				62.44
			],
			[
				"2002-05-17",
				50.04
			],
			[
				"2002-10-01",
				38.75
			],
			[
				"2002-10-24",
				34.85
			],
			[
				"2003-09-23",
				30.29
			],
			[
				"2004-06-21",
				50.04
			],
			[
				"2005-06-28",
				48.71
			],
			[
				"2005-08-29",
				62
			],
			[
				"2006-08-07",
				37.2
			],
			[
				"2006-09-06",
				40.74
			],
			[
				"2007-08-01",
				48.71
			],
			[
				"2008-08-01",
				35.87
			]
		],
		"106520027": [
			[
				"2013-05-13",
				3.72
			],
			[
				"2014-04-23",
				3.32
			],
			[
				"2015-04-13",
				2.79
			],
			[
				"2000-01-12",
				5.31
			],
			[
				"2001-01-24",
				3.54
			],
			[
				"2002-05-17",
				5.45
			],
			[
				"2002-10-24",
				14.66
			],
			[
				"2005-06-28",
				48.71
			],
			[
				"2006-08-07",
				6.2
			],
			[
				"2006-09-06",
				53.14
			],
			[
				"2007-08-01",
				5.31
			],
			[
				"2009-09-24",
				3.01
			],
			[
				"2008-08-01",
				62
			],
			[
				"2010-09-29",
				2.61
			],
			[
				"2011-06-30",
				2.39
			],
			[
				"2012-07-17",
				6.2
			]
		],
		"106520040": [
			[
				"2013-05-15",
				2.21
			],
			[
				"2014-04-02",
				2.21
			],
			[
				"2015-05-12",
				1.82
			],
			[
				"2001-02-22",
				2.21
			],
			[
				"2002-11-08",
				2.21
			],
			[
				"2005-05-04",
				2.21
			],
			[
				"2006-08-08",
				2.21
			],
			[
				"2006-08-30",
				2.21
			],
			[
				"2007-05-10",
				2.21
			],
			[
				"2008-06-13",
				2.21
			],
			[
				"2009-11-10",
				2.21
			],
			[
				"2010-10-07",
				2.21
			],
			[
				"2011-06-09",
				2.21
			],
			[
				"2012-07-04",
				2.21
			]
		],
		"106520052": [
			[
				"2013-05-15",
				2.21
			],
			[
				"2014-04-02",
				2.21
			],
			[
				"2015-05-12",
				1.33
			],
			[
				"2000-07-06",
				2.21
			],
			[
				"2000-10-13",
				2.21
			],
			[
				"2001-04-19",
				2.21
			],
			[
				"2002-10-10",
				2.21
			],
			[
				"2004-06-22",
				2.21
			],
			[
				"2005-05-04",
				2.21
			],
			[
				"2005-08-29",
				2.21
			],
			[
				"2006-08-08",
				2.21
			],
			[
				"2007-05-10",
				2.21
			],
			[
				"2008-06-13",
				2.21
			],
			[
				"2009-09-11",
				2.21
			],
			[
				"2003-09-24",
				2.21
			],
			[
				"2010-07-07",
				2.21
			],
			[
				"2011-09-22",
				2.21
			],
			[
				"2012-05-29",
				2.21
			]
		],
		"106525165": [
			[
				"2013-08-19",
				11.51
			],
			[
				"2014-07-15",
				12.58
			],
			[
				"2015-10-22",
				8.46
			],
			[
				"2000-11-30",
				15.06
			],
			[
				"2002-11-21",
				18.78
			],
			[
				"2005-04-28",
				10.63
			],
			[
				"2006-10-19",
				7.97
			],
			[
				"2007-07-13",
				7.53
			],
			[
				"2008-04-18",
				9.74
			],
			[
				"2008-07-31",
				10.63
			],
			[
				"2010-10-13",
				15.5
			],
			[
				"2011-07-27",
				14.61
			],
			[
				"2012-08-11",
				11.96
			]
		],
		"106530021": [
			[
				"2013-07-11",
				84.14
			],
			[
				"2015-03-31",
				128.43
			],
			[
				"2003-03-05",
				105.4
			],
			[
				"2005-06-22",
				128.43
			],
			[
				"2006-10-10",
				124
			],
			[
				"2007-07-09",
				101.86
			],
			[
				"2009-11-18",
				106.29
			],
			[
				"2008-04-21",
				110.71
			],
			[
				"2011-11-10",
				115.14
			],
			[
				"2012-10-18",
				115.14
			]
		],
		"106530033": [
			[
				"2013-07-11",
				106.29
			],
			[
				"2014-07-14",
				110.27
			],
			[
				"2015-03-31",
				103.19
			],
			[
				"2005-06-22",
				115.14
			],
			[
				"2006-10-10",
				97.43
			],
			[
				"2007-07-09",
				70.86
			],
			[
				"2009-11-18",
				88.57
			],
			[
				"2008-04-21",
				79.71
			],
			[
				"2010-11-15",
				101.86
			],
			[
				"2011-11-10",
				141.71
			],
			[
				"2012-10-18",
				101.86
			]
		],
		"106530045": [
			[
				"2013-07-11",
				84.14
			],
			[
				"2014-07-14",
				86.8
			],
			[
				"2015-03-31",
				77.5
			],
			[
				"2003-03-05",
				120.9
			],
			[
				"2005-06-22",
				66.43
			],
			[
				"2006-10-10",
				53.14
			],
			[
				"2007-07-09",
				48.71
			],
			[
				"2009-11-18",
				79.71
			],
			[
				"2008-04-21",
				62
			],
			[
				"2010-11-15",
				70.86
			],
			[
				"2011-11-10",
				132.86
			],
			[
				"2012-10-18",
				79.71
			]
		],
		"106530057": [
			[
				"2013-07-11",
				66.43
			],
			[
				"2014-07-14",
				62.44
			],
			[
				"2015-03-31",
				46.94
			],
			[
				"2005-06-22",
				53.14
			],
			[
				"2006-10-10",
				48.71
			],
			[
				"2007-07-09",
				44.29
			],
			[
				"2009-11-18",
				70.86
			],
			[
				"2003-03-05",
				62.44
			],
			[
				"2008-04-21",
				48.71
			],
			[
				"2010-11-15",
				70.86
			],
			[
				"2011-11-10",
				93
			],
			[
				"2012-10-18",
				66.43
			]
		],
		"106530203": [
			[
				"2013-09-12",
				132.86
			],
			[
				"2014-08-28",
				109.39
			],
			[
				"2015-04-23",
				101.86
			],
			[
				"2003-03-04",
				118.24
			],
			[
				"2005-06-21",
				101.86
			],
			[
				"2006-10-16",
				124
			],
			[
				"2007-06-12",
				97.43
			],
			[
				"2009-11-18",
				79.71
			],
			[
				"2008-06-03",
				106.29
			],
			[
				"2010-11-02",
				110.71
			],
			[
				"2011-09-21",
				132.86
			],
			[
				"2012-07-02",
				119.57
			]
		],
		"106530215": [
			[
				"2013-09-12",
				48.71
			],
			[
				"2014-08-28",
				50.49
			],
			[
				"2015-04-23",
				50.04
			],
			[
				"2003-03-04",
				60.23
			],
			[
				"2005-06-21",
				62
			],
			[
				"2006-10-16",
				70.86
			],
			[
				"2007-06-12",
				62
			],
			[
				"2009-11-18",
				48.71
			],
			[
				"2008-06-03",
				66.43
			],
			[
				"2010-11-02",
				62
			],
			[
				"2012-07-02",
				62
			]
		],
		"106530239": [
			[
				"2013-09-12",
				48.71
			],
			[
				"2014-08-28",
				48.71
			],
			[
				"2015-04-23",
				49.16
			],
			[
				"2003-03-04",
				58.01
			],
			[
				"2005-06-21",
				53.14
			],
			[
				"2006-10-16",
				57.57
			],
			[
				"2007-06-12",
				53.14
			],
			[
				"2009-11-18",
				42.96
			],
			[
				"2008-06-03",
				48.71
			],
			[
				"2010-11-02",
				53.14
			],
			[
				"2011-09-21",
				53.14
			],
			[
				"2012-07-02",
				53.14
			]
		],
		"106530288": [
			[
				"2013-07-18",
				101.86
			],
			[
				"2014-08-20",
				140.39
			],
			[
				"2015-10-05",
				142.16
			],
			[
				"2005-06-27",
				194.86
			],
			[
				"2006-09-19",
				115.14
			],
			[
				"2007-07-04",
				93
			],
			[
				"2008-12-01",
				97.43
			],
			[
				"2009-10-27",
				97.43
			],
			[
				"2010-06-08",
				93
			],
			[
				"2011-09-06",
				62
			],
			[
				"2012-08-07",
				93
			]
		],
		"106530290": [
			[
				"2013-07-18",
				42.96
			],
			[
				"2014-08-20",
				44.29
			],
			[
				"2015-10-05",
				34.19
			],
			[
				"2005-06-27",
				110.71
			],
			[
				"2006-09-19",
				62
			],
			[
				"2007-07-04",
				93
			],
			[
				"2008-12-01",
				79.71
			],
			[
				"2009-10-27",
				70.86
			],
			[
				"2010-06-08",
				48.71
			],
			[
				"2011-09-06",
				79.71
			],
			[
				"2012-08-07",
				62
			]
		],
		"106530306": [
			[
				"2013-07-18",
				48.71
			],
			[
				"2014-08-20",
				51.37
			],
			[
				"2015-10-05",
				29.98
			],
			[
				"2005-06-27",
				53.14
			],
			[
				"2006-09-19",
				53.14
			],
			[
				"2007-07-04",
				48.71
			],
			[
				"2008-12-01",
				44.29
			],
			[
				"2009-10-27",
				57.57
			],
			[
				"2010-06-08",
				53.14
			],
			[
				"2011-09-06",
				39.86
			],
			[
				"2012-08-07",
				40.74
			]
		],
		"106530318": [
			[
				"2013-07-18",
				70.86
			],
			[
				"2014-08-20",
				65.54
			],
			[
				"2015-10-05",
				36.85
			],
			[
				"2005-06-27",
				48.71
			],
			[
				"2006-09-19",
				57.57
			],
			[
				"2007-07-04",
				41.19
			],
			[
				"2008-12-01",
				38.09
			],
			[
				"2009-10-27",
				57.57
			],
			[
				"2010-06-08",
				43.4
			],
			[
				"2011-09-06",
				48.71
			],
			[
				"2012-08-07",
				75.29
			]
		],
		"106530320": [
			[
				"2013-07-18",
				31.89
			],
			[
				"2014-08-20",
				34.59
			],
			[
				"2015-10-05",
				23.38
			],
			[
				"2005-06-27",
				13.29
			],
			[
				"2006-09-19",
				23.03
			],
			[
				"2007-07-04",
				11.96
			],
			[
				"2008-12-01",
				4.87
			],
			[
				"2009-10-27",
				25.24
			],
			[
				"2010-06-08",
				17.71
			],
			[
				"2011-09-06",
				13.29
			],
			[
				"2012-08-07",
				34.1
			]
		],
		"110040107": [
			[
				"2013-08-26",
				2.14
			],
			[
				"2014-08-07",
				1.33
			],
			[
				"2015-12-02",
				9.08
			],
			[
				"2000-10-25",
				1.2
			],
			[
				"2001-05-09",
				36.27
			],
			[
				"2001-11-13",
				0.22
			],
			[
				"2002-06-04",
				15.85
			],
			[
				"2002-08-30",
				1.9
			],
			[
				"2003-04-15",
				17.85
			],
			[
				"2004-11-09",
				2.3
			],
			[
				"2005-05-09",
				0.22
			],
			[
				"2006-08-17",
				0.58
			],
			[
				"2007-05-03",
				31.27
			],
			[
				"2008-10-07",
				0.22
			],
			[
				"2003-09-15",
				0.62
			],
			[
				"2005-10-05",
				0.22
			],
			[
				"2008-05-09",
				0.27
			],
			[
				"2009-06-09",
				4.43
			],
			[
				"2010-05-11",
				4.43
			],
			[
				"2011-05-06",
				4.43
			],
			[
				"2012-06-04",
				1.33
			]
		],
		"110040132": [
			[
				"2013-08-21",
				1.33
			],
			[
				"2014-07-30",
				1.33
			],
			[
				"2015-08-25",
				1.33
			],
			[
				"2006-08-17",
				0.62
			],
			[
				"2007-05-02",
				0.27
			],
			[
				"2008-05-09",
				0.49
			],
			[
				"2009-05-28",
				4.43
			],
			[
				"2010-05-11",
				4.43
			],
			[
				"2011-04-27",
				4.43
			],
			[
				"2012-05-25",
				1.33
			]
		],
		"110040144": [
			[
				"2013-08-21",
				1.33
			],
			[
				"2014-07-30",
				1.33
			],
			[
				"2015-09-02",
				1.33
			],
			[
				"2006-08-17",
				0.22
			],
			[
				"2007-05-02",
				0.22
			],
			[
				"2008-05-09",
				0.49
			],
			[
				"2009-05-28",
				4.43
			],
			[
				"2010-05-11",
				4.43
			],
			[
				"2011-04-27",
				4.43
			],
			[
				"2012-05-25",
				1.33
			]
		],
		"110040156": [
			[
				"2013-08-23",
				69.09
			],
			[
				"2014-08-15",
				35.43
			],
			[
				"2015-09-01",
				39.02
			],
			[
				"2000-05-18",
				71.74
			],
			[
				"2000-10-17",
				67.76
			],
			[
				"2001-05-21",
				71.74
			],
			[
				"2001-10-24",
				97.43
			],
			[
				"2002-05-31",
				74.4
			],
			[
				"2002-09-17",
				72.19
			],
			[
				"2003-04-11",
				94.77
			],
			[
				"2003-10-23",
				83.26
			],
			[
				"2004-04-20",
				84.59
			],
			[
				"2004-11-09",
				102.74
			],
			[
				"2005-10-27",
				88.57
			],
			[
				"2005-05-09",
				101.86
			],
			[
				"2007-04-26",
				104.51
			],
			[
				"2006-08-15",
				82.81
			],
			[
				"2008-09-11",
				67.31
			],
			[
				"2008-05-06",
				68.64
			],
			[
				"2009-05-27",
				82.81
			],
			[
				"2010-05-12",
				79.71
			],
			[
				"2011-04-19",
				78.83
			],
			[
				"2012-05-29",
				57.13
			]
		],
		"110040181": [
			[
				"2013-07-01",
				3.94
			],
			[
				"2015-12-02",
				3.88
			],
			[
				"2000-05-17",
				16.61
			],
			[
				"2000-10-24",
				8.06
			],
			[
				"2001-05-09",
				11.2
			],
			[
				"2001-10-22",
				4.87
			],
			[
				"2002-05-03",
				10.76
			],
			[
				"2002-08-27",
				3.1
			],
			[
				"2003-04-01",
				14.53
			],
			[
				"2003-09-11",
				3.94
			],
			[
				"2004-06-28",
				6.51
			],
			[
				"2004-11-19",
				3.23
			],
			[
				"2005-10-05",
				3.28
			],
			[
				"2005-05-18",
				10.14
			],
			[
				"2007-05-02",
				4.25
			],
			[
				"2006-08-10",
				3.72
			],
			[
				"2008-09-11",
				3.28
			],
			[
				"2008-05-07",
				12.58
			],
			[
				"2009-06-26",
				20.37
			],
			[
				"2010-05-31",
				8.86
			],
			[
				"2011-04-21",
				17.27
			],
			[
				"2012-06-04",
				3.54
			]
		],
		"110040200": [
			[
				"2013-06-17",
				127.54
			],
			[
				"2014-08-13",
				141.27
			],
			[
				"2015-12-03",
				124.44
			],
			[
				"2000-05-22",
				21.57
			],
			[
				"2000-10-24",
				75.73
			],
			[
				"2001-05-11",
				54.03
			],
			[
				"2001-05-07",
				13.24
			],
			[
				"2001-08-21",
				127.54
			],
			[
				"2001-10-23",
				150.13
			],
			[
				"2002-04-29",
				48.71
			],
			[
				"2002-06-03",
				58.46
			],
			[
				"2002-10-28",
				138.61
			],
			[
				"2002-08-29",
				128.43
			],
			[
				"2003-03-31",
				26.39
			],
			[
				"2003-09-16",
				149.69
			],
			[
				"2003-06-05",
				50.93
			],
			[
				"2003-10-27",
				137.73
			],
			[
				"2004-04-19",
				35.52
			],
			[
				"2004-06-29",
				81.49
			],
			[
				"2004-10-12",
				118.24
			],
			[
				"2004-12-01",
				124
			],
			[
				"2005-12-06",
				128.43
			],
			[
				"2005-05-30",
				63.77
			],
			[
				"2005-04-13",
				27.5
			],
			[
				"2006-08-08",
				120.46
			],
			[
				"2006-11-30",
				120.46
			],
			[
				"2008-06-04",
				73.96
			],
			[
				"2008-09-08",
				85.03
			],
			[
				"2000-03-07",
				5.93
			],
			[
				"2000-10-10",
				77.06
			],
			[
				"2005-10-04",
				126.21
			],
			[
				"2007-05-04",
				53.14
			],
			[
				"2008-05-14",
				31.53
			],
			[
				"2009-06-24",
				102.3
			],
			[
				"2010-06-02",
				62.44
			],
			[
				"2011-05-09",
				77.5
			],
			[
				"2012-06-18",
				113.37
			]
		],
		"110040223": [
			[
				"2013-08-23",
				1.33
			],
			[
				"2014-08-01",
				1.33
			],
			[
				"2015-09-02",
				1.33
			],
			[
				"2000-05-18",
				0.44
			],
			[
				"2000-10-17",
				0.27
			],
			[
				"2001-05-21",
				0.22
			],
			[
				"2001-10-24",
				1.24
			],
			[
				"2002-05-03",
				1.2
			],
			[
				"2002-09-20",
				0.22
			],
			[
				"2003-04-14",
				1.28
			],
			[
				"2003-11-05",
				0.27
			],
			[
				"2004-04-21",
				0.27
			],
			[
				"2004-10-19",
				0.22
			],
			[
				"2005-11-07",
				0.22
			],
			[
				"2005-05-09",
				0.22
			],
			[
				"2007-04-26",
				0.93
			],
			[
				"2006-08-15",
				0.27
			],
			[
				"2008-09-04",
				0.22
			],
			[
				"2008-05-05",
				0.35
			],
			[
				"2009-05-26",
				4.43
			],
			[
				"2010-05-12",
				4.43
			],
			[
				"2011-04-19",
				4.43
			],
			[
				"2012-05-29",
				1.33
			]
		],
		"110040247": [
			[
				"2013-08-07",
				1.33
			],
			[
				"2014-08-06",
				1.33
			],
			[
				"2015-12-10",
				1.33
			],
			[
				"2003-11-25",
				0.4
			],
			[
				"2004-06-03",
				0.22
			],
			[
				"2004-11-30",
				0.53
			],
			[
				"2005-11-07",
				11.47
			],
			[
				"2005-05-02",
				1.33
			],
			[
				"2006-10-23",
				0.66
			],
			[
				"2007-09-03",
				5.93
			],
			[
				"2008-07-22",
				1.15
			],
			[
				"2009-08-12",
				4.43
			],
			[
				"2010-08-10",
				4.43
			],
			[
				"2011-07-06",
				4.43
			],
			[
				"2012-07-12",
				1.33
			]
		],
		"110040259": [
			[
				"2013-08-01",
				1.33
			],
			[
				"2014-09-11",
				1.33
			],
			[
				"2015-04-30",
				1.33
			],
			[
				"2007-07-04",
				0.22
			],
			[
				"2008-08-04",
				0.31
			],
			[
				"2009-08-28",
				4.43
			],
			[
				"2010-07-22",
				4.43
			],
			[
				"2011-07-14",
				4.43
			],
			[
				"2012-07-03",
				1.33
			]
		],
		"110040260": [
			[
				"2013-07-29",
				1.33
			],
			[
				"2014-09-15",
				1.33
			],
			[
				"2015-11-09",
				1.33
			],
			[
				"2007-07-05",
				1.33
			],
			[
				"2008-08-07",
				0.22
			],
			[
				"2009-09-02",
				4.43
			],
			[
				"2010-07-26",
				4.43
			],
			[
				"2011-10-25",
				4.43
			],
			[
				"2012-07-03",
				1.33
			]
		],
		"110040284": [
			[
				"2013-08-15",
				1.42
			],
			[
				"2014-09-03",
				1.71
			],
			[
				"2015-05-12",
				1.57
			],
			[
				"2007-07-05",
				21.39
			],
			[
				"2008-08-08",
				7.88
			],
			[
				"2009-09-02",
				6.2
			],
			[
				"2010-07-29",
				4.43
			],
			[
				"2011-10-25",
				4.43
			],
			[
				"2012-07-12",
				3.1
			]
		],
		"110050010": [
			[
				"2013-09-05",
				1.33
			],
			[
				"2014-09-18",
				1.33
			],
			[
				"2015-03-13",
				1.33
			],
			[
				"2006-08-24",
				0.89
			],
			[
				"2007-06-15",
				2.52
			],
			[
				"2007-11-21",
				0.66
			],
			[
				"2008-05-28",
				3.01
			],
			[
				"2009-05-15",
				6.2
			],
			[
				"2010-06-14",
				5.76
			],
			[
				"2011-05-12",
				4.43
			],
			[
				"2012-07-31",
				3.54
			]
		],
		"110050071": [
			[
				"2013-09-02",
				1.33
			],
			[
				"2014-09-17",
				3.87
			],
			[
				"2015-04-13",
				2.51
			],
			[
				"2000-05-19",
				2.35
			],
			[
				"2000-10-26",
				7.97
			],
			[
				"2001-05-07",
				11.91
			],
			[
				"2001-11-07",
				1.42
			],
			[
				"2002-05-07",
				4.07
			],
			[
				"2002-09-03",
				2.92
			],
			[
				"2003-04-24",
				2.75
			],
			[
				"2004-06-28",
				1.15
			],
			[
				"2004-11-19",
				0.4
			],
			[
				"2005-05-23",
				1.55
			],
			[
				"2006-09-05",
				0.22
			],
			[
				"2007-06-06",
				4.61
			],
			[
				"2003-09-15",
				0.22
			],
			[
				"2005-10-12",
				0.22
			],
			[
				"2008-07-08",
				2.61
			],
			[
				"2009-06-18",
				4.43
			],
			[
				"2010-07-30",
				4.43
			],
			[
				"2011-07-05",
				4.43
			],
			[
				"2012-07-11",
				1.33
			]
		],
		"110050095": [
			[
				"2013-08-19",
				1.33
			],
			[
				"2014-09-18",
				1.33
			],
			[
				"2015-04-13",
				1.33
			],
			[
				"2000-05-24",
				0.22
			],
			[
				"2000-11-20",
				1.51
			],
			[
				"2001-11-05",
				0.22
			],
			[
				"2001-05-31",
				0.22
			],
			[
				"2002-05-29",
				1.15
			],
			[
				"2002-09-03",
				1.02
			],
			[
				"2003-11-12",
				0.22
			],
			[
				"2004-05-26",
				0.22
			],
			[
				"2004-11-11",
				0.22
			],
			[
				"2005-10-24",
				0.22
			],
			[
				"2005-04-25",
				0.22
			],
			[
				"2006-09-04",
				2.13
			],
			[
				"2007-06-04",
				0.22
			],
			[
				"2008-07-07",
				0.22
			],
			[
				"2009-06-16",
				4.43
			],
			[
				"2010-07-27",
				4.43
			],
			[
				"2011-06-20",
				4.43
			],
			[
				"2012-08-15",
				1.33
			]
		],
		"110050113": [
			[
				"2014-11-19",
				1.33
			],
			[
				"2015-09-08",
				1.33
			],
			[
				"2006-08-21",
				0.53
			],
			[
				"2007-06-14",
				0.22
			],
			[
				"2008-05-30",
				0.22
			],
			[
				"2009-06-08",
				4.43
			],
			[
				"2010-06-11",
				4.43
			],
			[
				"2011-05-12",
				4.43
			],
			[
				"2012-07-13",
				1.33
			]
		],
		"110050125": [
			[
				"2013-08-26",
				114.26
			],
			[
				"2014-08-13",
				81.49
			],
			[
				"2015-11-04",
				69.09
			],
			[
				"2000-05-19",
				81.04
			],
			[
				"2000-10-16",
				138.17
			],
			[
				"2001-05-17",
				99.64
			],
			[
				"2001-11-16",
				127.1
			],
			[
				"2002-05-31",
				101.41
			],
			[
				"2002-09-18",
				116.47
			],
			[
				"2003-04-15",
				139.5
			],
			[
				"2003-10-30",
				138.17
			],
			[
				"2004-04-21",
				112.93
			],
			[
				"2004-11-08",
				122.67
			],
			[
				"2005-11-02",
				107.61
			],
			[
				"2005-05-04",
				135.51
			],
			[
				"2006-08-16",
				108.06
			],
			[
				"2007-06-13",
				39.81
			],
			[
				"2008-10-10",
				127.1
			],
			[
				"2008-05-30",
				62.89
			],
			[
				"2009-06-09",
				144.37
			],
			[
				"2010-06-11",
				86.8
			],
			[
				"2011-05-11",
				42.07
			],
			[
				"2012-07-13",
				73.51
			]
		],
		"110050137": [
			[
				"2013-08-19",
				2.44
			],
			[
				"2014-10-20",
				1.33
			],
			[
				"2015-04-14",
				1.33
			],
			[
				"2006-09-04",
				1.02
			],
			[
				"2007-06-05",
				0.22
			],
			[
				"2008-07-08",
				0.22
			],
			[
				"2009-06-17",
				4.43
			],
			[
				"2010-07-21",
				4.43
			],
			[
				"2011-06-20",
				4.43
			],
			[
				"2012-07-12",
				1.33
			]
		],
		"110050149": [
			[
				"2013-09-03",
				1.33
			],
			[
				"2014-10-08",
				1.33
			],
			[
				"2015-09-07",
				1.33
			],
			[
				"2006-08-21",
				1.73
			],
			[
				"2007-06-12",
				0.22
			],
			[
				"2008-06-05",
				0.22
			],
			[
				"2009-06-08",
				4.43
			],
			[
				"2010-07-01",
				4.43
			],
			[
				"2011-04-28",
				4.43
			],
			[
				"2012-06-19",
				1.33
			]
		],
		"110050150": [
			[
				"2013-07-30",
				1.33
			],
			[
				"2014-10-06",
				1.33
			],
			[
				"2015-09-28",
				1.33
			],
			[
				"2007-07-06",
				0.22
			],
			[
				"2008-08-13",
				0.22
			],
			[
				"2009-09-03",
				4.43
			],
			[
				"2010-07-21",
				4.43
			],
			[
				"2011-10-07",
				4.43
			],
			[
				"2012-06-22",
				1.33
			]
		],
		"110060064": [
			[
				"2013-07-22",
				1.33
			],
			[
				"2014-10-28",
				1.33
			],
			[
				"2015-12-08",
				3.31
			],
			[
				"2000-06-19",
				1.99
			],
			[
				"2000-10-26",
				2.7
			],
			[
				"2001-05-14",
				1.9
			],
			[
				"2001-11-23",
				0.22
			],
			[
				"2002-06-05",
				2.66
			],
			[
				"2002-08-30",
				1.06
			],
			[
				"2003-09-17",
				0.62
			],
			[
				"2003-05-07",
				4.56
			],
			[
				"2004-11-03",
				0.22
			],
			[
				"2004-07-01",
				2.13
			],
			[
				"2005-04-22",
				2.83
			],
			[
				"2006-08-29",
				0.22
			],
			[
				"2008-11-04",
				0.27
			],
			[
				"2005-10-07",
				0.22
			],
			[
				"2007-05-10",
				0.22
			],
			[
				"2008-06-18",
				5.45
			],
			[
				"2009-07-14",
				4.43
			],
			[
				"2010-07-14",
				4.43
			],
			[
				"2011-06-06",
				4.43
			],
			[
				"2012-06-27",
				1.33
			]
		],
		"110060090": [
			[
				"2013-07-05",
				121.79
			],
			[
				"2014-12-15",
				112.93
			],
			[
				"2015-11-24",
				116.47
			],
			[
				"2006-08-30",
				132.41
			],
			[
				"2007-05-09",
				139.06
			],
			[
				"2007-11-19",
				133.3
			],
			[
				"2008-11-05",
				131.97
			],
			[
				"2008-06-10",
				119.57
			],
			[
				"2009-07-09",
				133.74
			],
			[
				"2010-07-14",
				139.06
			],
			[
				"2011-06-08",
				103.63
			],
			[
				"2012-06-28",
				140.83
			]
		],
		"110060155": [
			[
				"2013-10-10",
				4.56
			],
			[
				"2014-12-16",
				56.24
			],
			[
				"2015-11-13",
				1.33
			],
			[
				"2006-10-10",
				20.24
			],
			[
				"2007-07-25",
				10.27
			],
			[
				"2003-06-24",
				1.73
			],
			[
				"2003-12-01",
				0.93
			],
			[
				"2008-07-21",
				1.24
			],
			[
				"2009-07-28",
				4.43
			],
			[
				"2010-08-18",
				26.57
			],
			[
				"2011-06-09",
				20.81
			],
			[
				"2012-06-26",
				1.33
			]
		],
		"110060210": [
			[
				"2013-07-22",
				9.12
			],
			[
				"2015-11-09",
				8.59
			],
			[
				"2006-08-29",
				8.72
			],
			[
				"2007-05-08",
				11.2
			],
			[
				"2007-11-23",
				47.83
			],
			[
				"2008-11-04",
				5.71
			],
			[
				"2008-06-11",
				19.8
			],
			[
				"2009-07-10",
				10.63
			],
			[
				"2010-06-30",
				11.07
			],
			[
				"2011-05-30",
				27.9
			],
			[
				"2012-06-27",
				18.6
			]
		],
		"110060234": [
			[
				"2013-07-22",
				10.94
			],
			[
				"2014-11-20",
				19.26
			],
			[
				"2015-11-17",
				22.59
			],
			[
				"2000-06-19",
				16.7
			],
			[
				"2000-11-13",
				29.05
			],
			[
				"2001-05-29",
				30.78
			],
			[
				"2001-11-08",
				60.23
			],
			[
				"2002-06-05",
				42.07
			],
			[
				"2002-10-22",
				30.2
			],
			[
				"2003-05-07",
				37.42
			],
			[
				"2003-11-13",
				32.68
			],
			[
				"2004-05-24",
				39.55
			],
			[
				"2004-10-27",
				27.99
			],
			[
				"2005-04-22",
				27.77
			],
			[
				"2006-08-29",
				22.72
			],
			[
				"2007-05-08",
				29.41
			],
			[
				"2005-11-18",
				14.35
			],
			[
				"2008-11-04",
				0.31
			],
			[
				"2008-06-11",
				24.36
			],
			[
				"2009-07-10",
				7.09
			],
			[
				"2010-06-30",
				6.64
			],
			[
				"2011-05-30",
				19.04
			],
			[
				"2012-06-27",
				7.53
			]
		],
		"110070045": [
			[
				"2013-09-27",
				1.33
			],
			[
				"2014-12-17",
				1.33
			],
			[
				"2015-11-12",
				1.33
			],
			[
				"2002-06-03",
				1.15
			],
			[
				"2003-04-10",
				0.31
			],
			[
				"2003-11-24",
				0.49
			],
			[
				"2004-05-19",
				0.31
			],
			[
				"2004-10-13",
				0.22
			],
			[
				"2005-10-26",
				0.22
			],
			[
				"2005-04-21",
				0.44
			],
			[
				"2006-09-12",
				0.22
			],
			[
				"2007-07-24",
				0.62
			],
			[
				"2002-10-08",
				0.93
			],
			[
				"2008-07-15",
				0.22
			],
			[
				"2009-07-24",
				4.43
			],
			[
				"2010-08-11",
				4.43
			],
			[
				"2011-10-12",
				4.43
			],
			[
				"2012-06-21",
				1.33
			]
		],
		"110070057": [
			[
				"2014-12-17",
				120.46
			],
			[
				"2015-11-12",
				163.41
			],
			[
				"2000-06-19",
				118.69
			],
			[
				"2000-10-18",
				132.41
			],
			[
				"2001-05-29",
				140.83
			],
			[
				"2001-11-08",
				161.64
			],
			[
				"2002-06-03",
				187.77
			],
			[
				"2003-04-10",
				56.69
			],
			[
				"2003-11-07",
				23.56
			],
			[
				"2004-05-19",
				40.39
			],
			[
				"2004-10-13",
				35.03
			],
			[
				"2005-10-26",
				36.23
			],
			[
				"2005-04-21",
				28.17
			],
			[
				"2006-09-12",
				31.27
			],
			[
				"2007-07-25",
				26.53
			],
			[
				"2002-09-20",
				82.81
			],
			[
				"2008-07-15",
				106.29
			],
			[
				"2009-07-28",
				83.7
			],
			[
				"2010-08-12",
				113.81
			],
			[
				"2011-10-12",
				166.96
			],
			[
				"2012-06-21",
				210.8
			]
		],
		"110070094": [
			[
				"2013-07-24",
				135.96
			],
			[
				"2014-08-12",
				105.4
			],
			[
				"2015-12-08",
				146.59
			],
			[
				"2000-03-07",
				63.77
			],
			[
				"2000-06-15",
				59.34
			],
			[
				"2000-10-18",
				64.66
			],
			[
				"2001-05-11",
				59.34
			],
			[
				"2001-05-15",
				58.46
			],
			[
				"2001-08-22",
				58.9
			],
			[
				"2001-11-21",
				81.04
			],
			[
				"2002-05-06",
				57.13
			],
			[
				"2002-04-30",
				65.1
			],
			[
				"2002-10-29",
				61.11
			],
			[
				"2003-03-31",
				57.57
			],
			[
				"2003-09-11",
				67.31
			],
			[
				"2003-06-05",
				59.34
			],
			[
				"2003-10-27",
				72.19
			],
			[
				"2004-04-19",
				57.13
			],
			[
				"2004-06-29",
				93.44
			],
			[
				"2004-10-11",
				86.36
			],
			[
				"2004-12-01",
				81.04
			],
			[
				"2005-05-30",
				101.41
			],
			[
				"2005-04-13",
				90.79
			],
			[
				"2006-08-07",
				69.53
			],
			[
				"2006-11-07",
				71.74
			],
			[
				"2008-09-05",
				92.56
			],
			[
				"2000-10-11",
				71.3
			],
			[
				"2002-08-29",
				62
			],
			[
				"2005-10-04",
				88.13
			],
			[
				"2005-12-05",
				79.71
			],
			[
				"2007-04-25",
				78.39
			],
			[
				"2008-04-29",
				88.57
			],
			[
				"2009-07-03",
				88.57
			],
			[
				"2010-06-10",
				99.2
			],
			[
				"2011-06-08",
				95.21
			],
			[
				"2012-06-26",
				91.67
			]
		],
		"110070148": [
			[
				"2013-07-02",
				81.93
			],
			[
				"2014-12-03",
				107.61
			],
			[
				"2015-12-01",
				98.76
			],
			[
				"2000-03-07",
				78.39
			],
			[
				"2000-06-20",
				31.27
			],
			[
				"2000-10-11",
				67.31
			],
			[
				"2000-10-24",
				58.9
			],
			[
				"2001-05-14",
				43.09
			],
			[
				"2001-08-21",
				0.22
			],
			[
				"2001-05-15",
				43.75
			],
			[
				"2001-11-14",
				25.02
			],
			[
				"2002-05-29",
				46.94
			],
			[
				"2002-04-29",
				54.91
			],
			[
				"2002-10-28",
				143.93
			],
			[
				"2003-03-28",
				50.93
			],
			[
				"2003-09-11",
				0.22
			],
			[
				"2003-09-16",
				0.84
			],
			[
				"2003-06-06",
				46.06
			],
			[
				"2004-04-19",
				57.13
			],
			[
				"2004-06-29",
				70.41
			],
			[
				"2004-10-12",
				12.62
			],
			[
				"2004-11-24",
				43.71
			],
			[
				"2005-04-13",
				90.79
			],
			[
				"2005-05-30",
				82.81
			],
			[
				"2006-08-07",
				2.21
			],
			[
				"2006-11-30",
				34.68
			],
			[
				"2007-05-10",
				72.63
			],
			[
				"2008-09-10",
				50.49
			],
			[
				"2002-08-28",
				81.93
			],
			[
				"2005-10-05",
				5.54
			],
			[
				"2005-12-06",
				82.81
			],
			[
				"2008-05-27",
				81.04
			],
			[
				"2009-07-02",
				67.76
			],
			[
				"2010-05-26",
				102.3
			],
			[
				"2011-04-28",
				52.26
			],
			[
				"2012-05-24",
				82.81
			]
		],
		"110070173": [
			[
				"2013-08-21",
				1.64
			],
			[
				"2014-08-27",
				1.33
			],
			[
				"2015-08-24",
				1.33
			],
			[
				"2006-08-17",
				0.22
			],
			[
				"2007-05-02",
				0.22
			],
			[
				"2008-05-09",
				0.22
			],
			[
				"2009-05-28",
				4.43
			],
			[
				"2010-05-11",
				4.43
			],
			[
				"2011-04-27",
				4.43
			],
			[
				"2012-05-25",
				1.33
			]
		],
		"110070227": [
			[
				"2013-09-02",
				6.24
			],
			[
				"2015-06-26",
				6.47
			],
			[
				"2000-05-19",
				46.5
			],
			[
				"2000-11-21",
				49.16
			],
			[
				"2001-05-31",
				9.83
			],
			[
				"2001-11-07",
				15.68
			],
			[
				"2002-05-23",
				4.52
			],
			[
				"2002-10-21",
				8.68
			],
			[
				"2003-04-16",
				5.4
			],
			[
				"2003-11-05",
				8.46
			],
			[
				"2004-04-22",
				9.88
			],
			[
				"2004-11-10",
				23.34
			],
			[
				"2005-05-13",
				4.47
			],
			[
				"2006-08-21",
				7.71
			],
			[
				"2007-06-06",
				6.38
			],
			[
				"2005-11-17",
				5.71
			],
			[
				"2008-07-09",
				7.75
			],
			[
				"2009-06-18",
				15.5
			],
			[
				"2010-07-30",
				9.74
			],
			[
				"2011-07-11",
				4.43
			],
			[
				"2012-07-11",
				3.54
			]
		],
		"110070288": [
			[
				"2013-08-15",
				6.47
			],
			[
				"2015-07-22",
				6.86
			],
			[
				"2000-11-22",
				39.86
			],
			[
				"2001-05-31",
				28.61
			],
			[
				"2001-11-16",
				31.89
			],
			[
				"2002-05-23",
				18.6
			],
			[
				"2002-10-21",
				16.47
			],
			[
				"2003-04-09",
				14.44
			],
			[
				"2003-11-11",
				24.4
			],
			[
				"2004-04-21",
				28.08
			],
			[
				"2004-11-19",
				36.85
			],
			[
				"2005-12-19",
				44.15
			],
			[
				"2005-05-23",
				32.59
			],
			[
				"2006-08-21",
				24.45
			],
			[
				"2007-06-13",
				18.73
			],
			[
				"2008-10-08",
				17.58
			],
			[
				"2008-06-09",
				16.87
			],
			[
				"2009-06-05",
				20.81
			],
			[
				"2010-05-25",
				16.39
			],
			[
				"2011-05-04",
				12.4
			],
			[
				"2012-05-31",
				7.97
			]
		],
		"110070409": [
			[
				"2013-07-31",
				1.33
			],
			[
				"2015-11-11",
				1.33
			],
			[
				"2006-09-12",
				0.22
			],
			[
				"2007-07-19",
				1.59
			],
			[
				"2008-07-15",
				0.4
			],
			[
				"2009-07-24",
				4.43
			],
			[
				"2010-08-11",
				4.43
			],
			[
				"2011-10-12",
				4.43
			],
			[
				"2012-07-05",
				1.33
			]
		],
		"110070422": [
			[
				"2015-11-18",
				1.33
			],
			[
				"2006-10-10",
				1.24
			],
			[
				"2007-07-25",
				0.4
			],
			[
				"2007-11-15",
				1.33
			],
			[
				"2003-07-02",
				1.77
			],
			[
				"2003-12-09",
				3.14
			],
			[
				"2008-07-23",
				0.22
			],
			[
				"2009-07-27",
				4.43
			],
			[
				"2010-09-06",
				5.76
			],
			[
				"2011-10-18",
				4.43
			],
			[
				"2012-07-05",
				1.33
			]
		],
		"110070513": [
			[
				"2015-11-24",
				1.33
			],
			[
				"2003-07-02",
				1.51
			],
			[
				"2003-12-09",
				0.22
			],
			[
				"2004-05-19",
				0.44
			],
			[
				"2004-10-13",
				0.22
			],
			[
				"2005-10-26",
				0.35
			],
			[
				"2005-04-21",
				0.22
			],
			[
				"2006-09-12",
				0.4
			],
			[
				"2007-07-19",
				0.22
			],
			[
				"2008-07-23",
				0.44
			],
			[
				"2009-07-28",
				4.43
			],
			[
				"2010-08-12",
				4.43
			],
			[
				"2011-10-26",
				4.43
			],
			[
				"2012-07-10",
				1.33
			]
		],
		"110070525": [
			[
				"2013-07-31",
				1.33
			],
			[
				"2014-11-26",
				1.33
			],
			[
				"2015-11-17",
				1.33
			],
			[
				"2004-12-09",
				0.22
			],
			[
				"2005-04-21",
				2.48
			],
			[
				"2006-11-23",
				0.97
			],
			[
				"2007-07-26",
				0.53
			],
			[
				"2007-11-23",
				0.84
			],
			[
				"2005-11-29",
				0.22
			],
			[
				"2008-07-23",
				0.22
			],
			[
				"2009-07-21",
				6.2
			],
			[
				"2010-08-12",
				4.43
			],
			[
				"2011-10-18",
				4.43
			],
			[
				"2012-07-05",
				1.33
			]
		],
		"110070537": [
			[
				"2013-07-31",
				1.33
			],
			[
				"2015-11-12",
				3.81
			],
			[
				"2005-12-21",
				0.8
			],
			[
				"2006-11-22",
				2.21
			],
			[
				"2007-07-26",
				0.44
			],
			[
				"2008-07-24",
				0.22
			],
			[
				"2009-07-21",
				4.43
			],
			[
				"2010-09-06",
				4.43
			],
			[
				"2011-10-26",
				4.43
			],
			[
				"2012-07-09",
				1.33
			]
		],
		"110070549": [
			[
				"2013-07-31",
				1.33
			],
			[
				"2014-11-25",
				1.33
			],
			[
				"2015-11-12",
				1.33
			],
			[
				"2006-11-22",
				0.31
			],
			[
				"2007-07-26",
				0.22
			],
			[
				"2005-12-21",
				0.22
			],
			[
				"2008-07-24",
				0.27
			],
			[
				"2009-07-21",
				4.43
			],
			[
				"2010-09-06",
				4.43
			],
			[
				"2011-10-26",
				4.43
			],
			[
				"2012-07-09",
				1.33
			]
		],
		"110151057": [
			[
				"2013-08-22",
				16.03
			],
			[
				"2015-11-12",
				11.29
			],
			[
				"2006-11-17",
				15.19
			],
			[
				"2008-09-03",
				12.4
			],
			[
				"2007-07-24",
				9.34
			],
			[
				"2009-10-05",
				17.71
			],
			[
				"2010-07-09",
				11.07
			],
			[
				"2011-11-17",
				13.73
			],
			[
				"2012-08-07",
				19.49
			]
		],
		"110151094": [
			[
				"2013-08-22",
				1.33
			],
			[
				"2015-11-03",
				1.33
			],
			[
				"2007-06-27",
				33.52
			],
			[
				"2008-07-10",
				0.53
			],
			[
				"2009-07-01",
				4.43
			],
			[
				"2010-07-09",
				4.43
			],
			[
				"2012-08-07",
				1.33
			]
		],
		"110200020": [
			[
				"2013-07-03",
				1.33
			],
			[
				"2014-07-23",
				1.33
			],
			[
				"2015-10-28",
				1.33
			],
			[
				"2000-05-23",
				0.22
			],
			[
				"2000-10-26",
				0.22
			],
			[
				"2001-05-09",
				0.22
			],
			[
				"2001-10-23",
				0.84
			],
			[
				"2002-05-08",
				1.15
			],
			[
				"2003-09-16",
				0.75
			],
			[
				"2003-04-14",
				1.24
			],
			[
				"2004-06-29",
				0.22
			],
			[
				"2004-10-19",
				0.22
			],
			[
				"2005-05-17",
				0.22
			],
			[
				"2006-08-09",
				0.22
			],
			[
				"2007-06-18",
				0.22
			],
			[
				"2002-08-30",
				1.02
			],
			[
				"2005-10-07",
				0.22
			],
			[
				"2008-05-16",
				0.22
			],
			[
				"2009-07-08",
				4.43
			],
			[
				"2010-06-07",
				4.43
			],
			[
				"2011-05-26",
				4.43
			],
			[
				"2012-07-25",
				1.33
			]
		],
		"110200056": [
			[
				"2013-09-17",
				1.33
			],
			[
				"2014-08-28",
				1.33
			],
			[
				"2015-10-29",
				1.33
			],
			[
				"2006-08-24",
				35.69
			],
			[
				"2007-06-26",
				0.53
			],
			[
				"2007-11-14",
				0.58
			],
			[
				"2008-11-12",
				0.44
			],
			[
				"2008-06-18",
				0.89
			],
			[
				"2009-05-25",
				4.43
			],
			[
				"2010-06-21",
				4.43
			],
			[
				"2011-06-17",
				4.43
			],
			[
				"2012-08-02",
				1.33
			]
		],
		"110200070": [
			[
				"2013-09-04",
				55.36
			],
			[
				"2014-10-30",
				54.03
			],
			[
				"2015-11-02",
				49.6
			],
			[
				"2000-05-30",
				69.97
			],
			[
				"2000-11-14",
				73.96
			],
			[
				"2001-06-05",
				65.54
			],
			[
				"2001-11-13",
				68.2
			],
			[
				"2002-05-27",
				54.47
			],
			[
				"2003-04-17",
				54.03
			],
			[
				"2003-11-11",
				69.53
			],
			[
				"2004-07-15",
				71.3
			],
			[
				"2004-11-08",
				83.7
			],
			[
				"2005-11-02",
				76.17
			],
			[
				"2005-05-04",
				71.74
			],
			[
				"2006-08-16",
				86.8
			],
			[
				"2007-06-15",
				42.12
			],
			[
				"2008-10-10",
				0.22
			],
			[
				"2002-09-19",
				50.93
			],
			[
				"2008-05-28",
				69.53
			],
			[
				"2009-06-10",
				72.63
			],
			[
				"2010-06-14",
				63.77
			],
			[
				"2011-05-12",
				52.26
			],
			[
				"2012-07-31",
				48.71
			]
		],
		"110200081": [
			[
				"2013-09-04",
				92.56
			],
			[
				"2014-10-30",
				144.81
			],
			[
				"2015-11-02",
				141.71
			],
			[
				"2006-08-18",
				76.61
			],
			[
				"2007-06-14",
				127.1
			],
			[
				"2008-05-29",
				138.17
			],
			[
				"2009-06-10",
				154.56
			],
			[
				"2010-06-16",
				138.17
			],
			[
				"2011-05-26",
				109.39
			],
			[
				"2012-08-01",
				70.86
			]
		],
		"110200093": [
			[
				"2014-11-05",
				75.73
			],
			[
				"2015-11-02",
				56.24
			],
			[
				"2006-08-16",
				34.1
			],
			[
				"2007-06-15",
				65.1
			],
			[
				"2008-05-29",
				57.57
			],
			[
				"2009-06-15",
				67.31
			],
			[
				"2010-06-08",
				84.59
			],
			[
				"2011-05-11",
				77.5
			]
		],
		"110200100": [
			[
				"2013-07-04",
				21.61
			],
			[
				"2014-11-11",
				2.54
			],
			[
				"2015-10-30",
				2.17
			],
			[
				"2000-05-23",
				21.88
			],
			[
				"2000-11-17",
				7.84
			],
			[
				"2001-06-29",
				5.23
			],
			[
				"2001-10-23",
				16.08
			],
			[
				"2002-05-08",
				1.15
			],
			[
				"2003-05-06",
				3.1
			],
			[
				"2003-11-10",
				0.22
			],
			[
				"2004-04-23",
				2.66
			],
			[
				"2004-10-18",
				178.03
			],
			[
				"2005-11-04",
				34.85
			],
			[
				"2005-05-11",
				12.67
			],
			[
				"2007-05-07",
				15.63
			],
			[
				"2006-08-09",
				10.41
			],
			[
				"2008-09-09",
				111.6
			],
			[
				"2002-09-23",
				67.31
			],
			[
				"2008-05-16",
				7.84
			],
			[
				"2009-07-07",
				34.1
			],
			[
				"2010-06-07",
				23.91
			],
			[
				"2011-06-09",
				7.09
			],
			[
				"2012-07-25",
				41.19
			]
		],
		"110200123": [
			[
				"2013-09-05",
				108.5
			],
			[
				"2014-08-21",
				69.97
			],
			[
				"2015-11-03",
				97.43
			],
			[
				"2000-05-30",
				47.83
			],
			[
				"2000-10-25",
				32.28
			],
			[
				"2001-05-10",
				54.03
			],
			[
				"2001-11-26",
				65.1
			],
			[
				"2002-06-20",
				41.05
			],
			[
				"2003-09-17",
				43.44
			],
			[
				"2003-04-17",
				71.3
			],
			[
				"2004-11-08",
				96.99
			],
			[
				"2004-06-30",
				60.23
			],
			[
				"2005-06-22",
				70.86
			],
			[
				"2006-08-18",
				61.11
			],
			[
				"2007-06-20",
				59.34
			],
			[
				"2008-10-14",
				63.77
			],
			[
				"2002-08-28",
				27.72
			],
			[
				"2005-10-12",
				64.66
			],
			[
				"2008-05-29",
				78.39
			],
			[
				"2009-06-10",
				69.97
			],
			[
				"2010-06-14",
				92.11
			],
			[
				"2011-05-12",
				81.49
			],
			[
				"2012-07-31",
				150.13
			]
		],
		"110200135": [
			[
				"2014-10-30",
				95.21
			],
			[
				"2015-12-08",
				81.93
			],
			[
				"2006-08-24",
				78.39
			],
			[
				"2006-11-29",
				73.96
			],
			[
				"2007-06-26",
				79.27
			],
			[
				"2007-11-14",
				78.39
			],
			[
				"2008-06-18",
				83.26
			],
			[
				"2009-05-25",
				80.6
			],
			[
				"2010-06-23",
				116.03
			],
			[
				"2011-06-17",
				79.71
			],
			[
				"2012-08-02",
				120.01
			]
		],
		"110200159": [
			[
				"2013-09-04",
				1.33
			],
			[
				"2014-11-03",
				1.33
			],
			[
				"2015-03-11",
				1.33
			],
			[
				"2006-08-23",
				0.31
			],
			[
				"2006-12-01",
				0.22
			],
			[
				"2007-06-20",
				0.22
			],
			[
				"2008-10-15",
				0.22
			],
			[
				"2007-11-15",
				0.27
			],
			[
				"2003-06-24",
				1.73
			],
			[
				"2003-12-08",
				0.27
			],
			[
				"2008-05-15",
				0.22
			],
			[
				"2009-05-15",
				4.43
			],
			[
				"2010-06-16",
				4.43
			],
			[
				"2011-05-23",
				4.43
			],
			[
				"2012-07-26",
				1.33
			]
		],
		"110200160": [
			[
				"2013-06-18",
				370.67
			],
			[
				"2014-11-03",
				101.86
			],
			[
				"2015-12-08",
				120.9
			],
			[
				"2000-06-26",
				14.57
			],
			[
				"2000-11-16",
				22.36
			],
			[
				"2001-05-30",
				37.78
			],
			[
				"2001-11-19",
				14.66
			],
			[
				"2002-05-27",
				26.97
			],
			[
				"2003-04-24",
				28.61
			],
			[
				"2003-10-23",
				5.31
			],
			[
				"2004-05-14",
				21.39
			],
			[
				"2004-11-05",
				28.39
			],
			[
				"2005-11-24",
				35.07
			],
			[
				"2005-05-20",
				143.04
			],
			[
				"2007-06-22",
				46.06
			],
			[
				"2006-08-23",
				139.06
			],
			[
				"2008-11-07",
				73.51
			],
			[
				"2002-09-12",
				17.45
			],
			[
				"2008-05-28",
				45.61
			],
			[
				"2009-05-15",
				140.83
			],
			[
				"2010-06-21",
				174.93
			],
			[
				"2011-05-26",
				89.01
			],
			[
				"2012-08-13",
				102.74
			]
		],
		"110200172": [
			[
				"2013-09-19",
				23.07
			],
			[
				"2014-11-04",
				5.31
			],
			[
				"2015-03-13",
				40.61
			],
			[
				"2003-12-04",
				0.62
			],
			[
				"2004-11-05",
				0.44
			],
			[
				"2004-06-08",
				14.61
			],
			[
				"2005-05-20",
				23.6
			],
			[
				"2006-08-23",
				4.16
			],
			[
				"2007-06-21",
				22.45
			],
			[
				"2008-10-15",
				5.31
			],
			[
				"2005-11-23",
				0.22
			],
			[
				"2008-05-26",
				0.53
			],
			[
				"2009-05-13",
				31.44
			],
			[
				"2010-06-16",
				34.54
			],
			[
				"2011-05-23",
				27.9
			],
			[
				"2012-07-26",
				18.16
			]
		],
		"110200184": [
			[
				"2013-10-14",
				45.17
			],
			[
				"2014-11-04",
				32.99
			],
			[
				"2015-03-12",
				34.94
			],
			[
				"2006-08-23",
				0.97
			],
			[
				"2007-06-22",
				43.89
			],
			[
				"2008-05-26",
				27.1
			],
			[
				"2009-05-14",
				52.26
			],
			[
				"2010-06-17",
				21.26
			],
			[
				"2011-05-23",
				57.13
			],
			[
				"2012-07-30",
				73.51
			]
		],
		"110200196": [
			[
				"2013-06-18",
				1.33
			],
			[
				"2015-04-01",
				1.33
			],
			[
				"2000-06-26",
				0.22
			],
			[
				"2000-11-16",
				1.02
			],
			[
				"2001-06-01",
				0.58
			],
			[
				"2001-11-12",
				0.22
			],
			[
				"2002-05-22",
				1.2
			],
			[
				"2003-04-22",
				1.28
			],
			[
				"2003-10-23",
				0.53
			],
			[
				"2004-05-14",
				0.35
			],
			[
				"2004-10-26",
				0.22
			],
			[
				"2005-05-19",
				0.22
			],
			[
				"2006-09-01",
				0.22
			],
			[
				"2007-06-21",
				0.58
			],
			[
				"2005-11-23",
				0.22
			],
			[
				"2008-10-15",
				0.22
			],
			[
				"2002-09-18",
				0.4
			],
			[
				"2008-05-15",
				0.27
			],
			[
				"2009-05-13",
				4.43
			],
			[
				"2010-06-17",
				4.43
			],
			[
				"2011-05-23",
				4.43
			],
			[
				"2012-08-13",
				1.33
			]
		],
		"110200214": [
			[
				"2013-06-18",
				85.47
			],
			[
				"2014-07-22",
				52.7
			],
			[
				"2015-03-30",
				180.24
			],
			[
				"2000-07-10",
				0.71
			],
			[
				"2000-10-25",
				1.11
			],
			[
				"2001-05-10",
				2.52
			],
			[
				"2001-11-12",
				0.89
			],
			[
				"2002-05-22",
				14.66
			],
			[
				"2003-04-22",
				72.19
			],
			[
				"2004-10-26",
				19.13
			],
			[
				"2004-06-30",
				27.32
			],
			[
				"2005-05-19",
				52.7
			],
			[
				"2006-08-31",
				38.84
			],
			[
				"2007-06-21",
				58.9
			],
			[
				"2008-11-10",
				71.74
			],
			[
				"2002-08-28",
				24.84
			],
			[
				"2003-09-15",
				86.8
			],
			[
				"2005-10-12",
				18.42
			],
			[
				"2008-05-15",
				100.09
			],
			[
				"2009-05-14",
				58.46
			],
			[
				"2010-06-17",
				45.61
			],
			[
				"2011-05-24",
				73.07
			],
			[
				"2012-07-30",
				35.87
			]
		],
		"110200226": [
			[
				"2013-10-14",
				16.39
			],
			[
				"2015-03-26",
				30.16
			],
			[
				"2002-05-22",
				91.23
			],
			[
				"2002-06-04",
				1.82
			],
			[
				"2003-04-22",
				1.59
			],
			[
				"2003-12-04",
				0.31
			],
			[
				"2004-06-08",
				0.75
			],
			[
				"2004-10-26",
				1.64
			],
			[
				"2005-05-19",
				0.93
			],
			[
				"2006-08-31",
				1.86
			],
			[
				"2007-06-21",
				1.24
			],
			[
				"2007-11-21",
				1.02
			],
			[
				"2005-11-23",
				1.06
			],
			[
				"2008-11-10",
				2.97
			],
			[
				"2002-09-19",
				0.44
			],
			[
				"2008-05-26",
				0.44
			],
			[
				"2009-05-14",
				4.43
			],
			[
				"2011-05-24",
				4.43
			],
			[
				"2012-07-30",
				8.41
			]
		],
		"110200238": [
			[
				"2013-09-18",
				1.33
			],
			[
				"2015-04-01",
				4.74
			],
			[
				"2006-09-01",
				26.97
			],
			[
				"2006-12-01",
				37.33
			],
			[
				"2007-06-22",
				28.48
			],
			[
				"2007-11-21",
				36.09
			],
			[
				"2008-11-07",
				1.95
			],
			[
				"2003-06-17",
				29.23
			],
			[
				"2003-12-08",
				42.51
			],
			[
				"2008-06-16",
				4.21
			],
			[
				"2009-05-19",
				4.43
			],
			[
				"2010-06-28",
				4.43
			],
			[
				"2011-06-15",
				5.31
			],
			[
				"2012-08-09",
				3.1
			]
		],
		"110200251": [
			[
				"2013-09-12",
				218.77
			],
			[
				"2015-12-08",
				183.79
			],
			[
				"2006-08-24",
				104.51
			],
			[
				"2007-06-26",
				111.6
			],
			[
				"2003-06-17",
				111.6
			],
			[
				"2003-12-03",
				77.94
			],
			[
				"2008-06-13",
				103.63
			],
			[
				"2009-05-18",
				143.04
			],
			[
				"2010-07-16",
				127.54
			],
			[
				"2011-06-17",
				121.34
			],
			[
				"2012-08-21",
				131.09
			]
		],
		"110200287": [
			[
				"2013-10-10",
				7
			],
			[
				"2015-03-24",
				18.11
			],
			[
				"2006-11-21",
				15.06
			],
			[
				"2007-06-28",
				3.14
			],
			[
				"2008-07-14",
				6.86
			],
			[
				"2009-07-17",
				22.59
			],
			[
				"2010-09-02",
				16.83
			],
			[
				"2011-11-14",
				8.86
			],
			[
				"2012-08-22",
				12.4
			]
		],
		"110200305": [
			[
				"2013-09-12",
				1.33
			],
			[
				"2015-03-12",
				1.33
			],
			[
				"2000-06-26",
				7.62
			],
			[
				"2000-11-16",
				7.71
			],
			[
				"2001-05-30",
				12.05
			],
			[
				"2001-11-12",
				3.63
			],
			[
				"2002-05-27",
				3.41
			],
			[
				"2003-04-24",
				3.63
			],
			[
				"2003-10-23",
				5
			],
			[
				"2004-05-14",
				0.75
			],
			[
				"2004-11-05",
				0.22
			],
			[
				"2005-11-24",
				0.22
			],
			[
				"2005-05-20",
				0.22
			],
			[
				"2006-08-23",
				0.89
			],
			[
				"2007-06-20",
				0.71
			],
			[
				"2008-10-14",
				0.8
			],
			[
				"2002-09-18",
				5.23
			],
			[
				"2008-05-28",
				0.49
			],
			[
				"2009-05-13",
				4.43
			],
			[
				"2010-06-21",
				4.43
			],
			[
				"2011-05-24",
				11.07
			],
			[
				"2012-07-31",
				19.04
			]
		],
		"110200329": [
			[
				"2014-07-24",
				1.33
			],
			[
				"2015-03-18",
				1.33
			],
			[
				"2000-05-23",
				0.27
			],
			[
				"2000-11-14",
				1.02
			],
			[
				"2001-06-01",
				0.22
			],
			[
				"2001-11-13",
				0.22
			],
			[
				"2002-05-03",
				1.15
			],
			[
				"2003-06-24",
				1.28
			],
			[
				"2003-11-26",
				0.22
			],
			[
				"2004-05-25",
				0.66
			],
			[
				"2004-10-21",
				0.22
			],
			[
				"2005-12-01",
				0.22
			],
			[
				"2005-05-18",
				0.22
			],
			[
				"2006-09-06",
				0.22
			],
			[
				"2007-08-20",
				0.22
			],
			[
				"2002-09-12",
				1.11
			],
			[
				"2008-07-14",
				0.22
			],
			[
				"2009-08-19",
				4.43
			],
			[
				"2010-09-01",
				4.43
			],
			[
				"2011-11-14",
				4.43
			],
			[
				"2012-08-22",
				1.33
			]
		],
		"110200330": [
			[
				"2014-07-22",
				187.77
			],
			[
				"2015-03-17",
				145.26
			],
			[
				"2003-06-17",
				141.27
			],
			[
				"2004-07-05",
				126.66
			],
			[
				"2004-10-21",
				109.39
			],
			[
				"2005-04-20",
				131.53
			],
			[
				"2006-09-01",
				130.64
			],
			[
				"2007-06-29",
				129.76
			],
			[
				"2008-11-11",
				126.21
			],
			[
				"2005-12-02",
				149.24
			],
			[
				"2008-06-16",
				124
			],
			[
				"2009-05-19",
				166.96
			],
			[
				"2010-06-28",
				159.43
			],
			[
				"2011-06-15",
				110.71
			],
			[
				"2012-08-09",
				186.44
			]
		],
		"110200342": [
			[
				"2013-09-26",
				1.33
			],
			[
				"2015-03-19",
				1.33
			],
			[
				"2003-07-01",
				1.82
			],
			[
				"2003-12-04",
				0.22
			],
			[
				"2004-05-25",
				0.22
			],
			[
				"2004-10-20",
				1.73
			],
			[
				"2005-12-02",
				0.27
			],
			[
				"2005-05-17",
				0.22
			],
			[
				"2006-09-11",
				0.22
			],
			[
				"2007-08-13",
				0.22
			],
			[
				"2008-09-02",
				0.4
			],
			[
				"2009-09-10",
				4.43
			],
			[
				"2010-08-18",
				4.43
			],
			[
				"2011-10-06",
				4.43
			],
			[
				"2012-08-23",
				1.33
			]
		],
		"110200354": [
			[
				"2013-09-23",
				2.12
			],
			[
				"2015-03-23",
				1.33
			],
			[
				"2006-11-21",
				3.5
			],
			[
				"2007-08-13",
				0.22
			],
			[
				"2008-09-01",
				0.22
			],
			[
				"2009-09-09",
				4.43
			],
			[
				"2010-08-16",
				4.43
			],
			[
				"2011-10-05",
				4.43
			],
			[
				"2012-07-24",
				1.33
			]
		],
		"110200366": [
			[
				"2013-09-26",
				35.03
			],
			[
				"2015-03-24",
				25.82
			],
			[
				"2003-07-01",
				13.15
			],
			[
				"2003-12-03",
				14.17
			],
			[
				"2004-07-05",
				17.01
			],
			[
				"2004-10-20",
				15.59
			],
			[
				"2005-12-02",
				17.54
			],
			[
				"2005-05-17",
				17.8
			],
			[
				"2006-09-11",
				17.54
			],
			[
				"2007-08-10",
				15.5
			],
			[
				"2008-09-01",
				21.83
			],
			[
				"2009-09-09",
				23.91
			],
			[
				"2010-08-18",
				24.36
			],
			[
				"2011-10-05",
				26.57
			],
			[
				"2012-07-24",
				28.79
			]
		],
		"110200378": [
			[
				"2013-10-16",
				2.6
			],
			[
				"2015-03-19",
				1.33
			],
			[
				"2003-11-26",
				0.4
			],
			[
				"2004-05-25",
				0.66
			],
			[
				"2004-10-21",
				0.35
			],
			[
				"2005-12-01",
				0.8
			],
			[
				"2005-05-18",
				0.4
			],
			[
				"2006-09-06",
				2.39
			],
			[
				"2007-08-16",
				1.77
			],
			[
				"2008-09-02",
				0.53
			],
			[
				"2009-09-10",
				4.43
			],
			[
				"2010-08-20",
				4.43
			],
			[
				"2011-10-06",
				4.43
			],
			[
				"2012-08-23",
				1.33
			]
		],
		"110200380": [
			[
				"2013-07-25",
				76.61
			],
			[
				"2015-03-18",
				93.44
			],
			[
				"2004-05-25",
				86.8
			],
			[
				"2004-10-20",
				56.69
			],
			[
				"2005-12-01",
				46.06
			],
			[
				"2005-05-18",
				76.17
			],
			[
				"2006-09-06",
				68.2
			],
			[
				"2007-08-13",
				77.94
			],
			[
				"2008-09-02",
				16.61
			],
			[
				"2009-09-10",
				57.13
			],
			[
				"2010-08-20",
				69.53
			]
		],
		"110200391": [
			[
				"2013-09-23",
				32.24
			],
			[
				"2015-03-20",
				18.16
			],
			[
				"2007-08-10",
				0.22
			],
			[
				"2008-09-01",
				13.02
			],
			[
				"2009-09-09",
				18.6
			],
			[
				"2010-08-18",
				18.16
			],
			[
				"2011-10-05",
				21.7
			],
			[
				"2012-07-24",
				20.81
			]
		],
		"110200408": [
			[
				"2013-07-04",
				78.83
			],
			[
				"2015-10-29",
				202.83
			],
			[
				"2003-12-02",
				167.4
			],
			[
				"2004-06-07",
				178.03
			],
			[
				"2004-10-19",
				165.63
			],
			[
				"2005-12-06",
				123.11
			],
			[
				"2005-05-17",
				115.14
			],
			[
				"2006-08-10",
				164.3
			],
			[
				"2007-06-18",
				116.91
			],
			[
				"2007-11-13",
				170.94
			],
			[
				"2008-10-09",
				232.06
			],
			[
				"2008-05-19",
				185.11
			],
			[
				"2009-07-08",
				248
			],
			[
				"2010-06-23",
				248
			],
			[
				"2011-04-29",
				258.19
			],
			[
				"2012-07-24",
				194.41
			]
		],
		"110200410": [
			[
				"2013-09-17",
				22.23
			],
			[
				"2015-12-01",
				78.39
			],
			[
				"2006-11-16",
				6.78
			],
			[
				"2007-08-17",
				18.47
			],
			[
				"2007-11-13",
				68.2
			],
			[
				"2005-12-20",
				46.06
			],
			[
				"2008-07-28",
				11.69
			],
			[
				"2009-08-18",
				15.06
			],
			[
				"2010-08-20",
				15.5
			],
			[
				"2011-11-16",
				12.84
			],
			[
				"2012-08-21",
				24.36
			]
		],
		"110200445": [
			[
				"2013-10-10",
				45.61
			],
			[
				"2015-12-01",
				27.37
			],
			[
				"2007-08-16",
				38.35
			],
			[
				"2008-07-25",
				6.16
			],
			[
				"2009-08-19",
				37.64
			],
			[
				"2010-09-01",
				73.07
			],
			[
				"2011-11-14",
				60.67
			],
			[
				"2012-08-23",
				46.5
			]
		],
		"110200457": [
			[
				"2013-09-11",
				57.13
			],
			[
				"2014-07-25",
				33.13
			],
			[
				"2015-12-08",
				32.28
			],
			[
				"2007-08-24",
				15.59
			],
			[
				"2008-07-28",
				46.5
			],
			[
				"2009-08-21",
				57.57
			],
			[
				"2010-08-31",
				51.81
			],
			[
				"2011-11-18",
				62.89
			],
			[
				"2012-08-21",
				53.14
			]
		],
		"110200469": [
			[
				"2013-09-11",
				2.38
			],
			[
				"2015-11-24",
				6.69
			],
			[
				"2007-08-20",
				0.22
			],
			[
				"2008-07-25",
				0.22
			],
			[
				"2009-08-21",
				4.43
			],
			[
				"2010-08-31",
				4.43
			],
			[
				"2011-11-16",
				4.43
			],
			[
				"2012-08-02",
				1.33
			]
		],
		"110200470": [
			[
				"2013-09-23",
				1.33
			],
			[
				"2015-05-05",
				1.33
			],
			[
				"2007-08-23",
				0.71
			],
			[
				"2008-09-03",
				0.31
			],
			[
				"2009-09-10",
				4.43
			],
			[
				"2010-08-31",
				4.43
			],
			[
				"2011-10-06",
				4.43
			],
			[
				"2012-07-25",
				2.66
			]
		],
		"110200482": [
			[
				"2013-07-25",
				13.82
			],
			[
				"2015-11-24",
				15.85
			],
			[
				"2007-08-23",
				11.2
			],
			[
				"2008-08-01",
				7.26
			],
			[
				"2009-07-07",
				12.4
			],
			[
				"2010-06-07",
				11.51
			],
			[
				"2011-06-09",
				9.74
			],
			[
				"2012-07-25",
				13.73
			]
		],
		"110210050": [
			[
				"2013-08-05",
				1.33
			],
			[
				"2015-05-06",
				1.33
			],
			[
				"2004-12-07",
				0.49
			],
			[
				"2005-04-14",
				0.22
			],
			[
				"2006-10-19",
				0.22
			],
			[
				"2007-07-13",
				0.22
			],
			[
				"2008-08-19",
				0.22
			],
			[
				"2008-08-29",
				0.58
			],
			[
				"2005-10-13",
				0.22
			],
			[
				"2010-07-05",
				4.43
			],
			[
				"2011-11-15",
				4.43
			],
			[
				"2012-08-08",
				1.33
			]
		],
		"110210062": [
			[
				"2013-08-07",
				1.33
			],
			[
				"2015-09-29",
				1.33
			],
			[
				"2000-05-29",
				2.48
			],
			[
				"2000-11-24",
				0.4
			],
			[
				"2001-05-18",
				0.62
			],
			[
				"2001-10-29",
				1.02
			],
			[
				"2002-05-06",
				1.28
			],
			[
				"2003-04-03",
				1.06
			],
			[
				"2003-10-24",
				4.92
			],
			[
				"2004-06-02",
				0.22
			],
			[
				"2004-10-22",
				0.58
			],
			[
				"2005-10-25",
				0.62
			],
			[
				"2005-04-14",
				0.22
			],
			[
				"2006-10-20",
				1.55
			],
			[
				"2007-07-13",
				4.16
			],
			[
				"2008-08-20",
				2.3
			],
			[
				"2002-09-25",
				0.22
			],
			[
				"2009-08-07",
				4.43
			],
			[
				"2010-07-05",
				4.43
			],
			[
				"2011-05-27",
				4.43
			],
			[
				"2012-06-12",
				1.33
			]
		],
		"110210074": [
			[
				"2013-06-17",
				1.33
			],
			[
				"2015-09-17",
				1.33
			],
			[
				"2000-05-29",
				0.31
			],
			[
				"2000-10-13",
				0.22
			],
			[
				"2001-05-22",
				0.22
			],
			[
				"2001-10-30",
				0.75
			],
			[
				"2002-05-06",
				1.2
			],
			[
				"2002-10-25",
				1.24
			],
			[
				"2003-10-24",
				0.4
			],
			[
				"2003-04-07",
				0.22
			],
			[
				"2004-05-11",
				0.22
			],
			[
				"2004-10-22",
				0.22
			],
			[
				"2005-10-26",
				0.22
			],
			[
				"2005-04-14",
				0.22
			],
			[
				"2006-10-11",
				0.22
			],
			[
				"2007-07-13",
				1.15
			],
			[
				"2008-08-28",
				0.22
			],
			[
				"2008-08-19",
				0.22
			],
			[
				"2009-08-06",
				4.43
			],
			[
				"2010-06-15",
				4.43
			],
			[
				"2011-05-27",
				4.43
			],
			[
				"2012-06-01",
				1.33
			]
		],
		"110210086": [
			[
				"2013-08-05",
				1.33
			],
			[
				"2015-09-29",
				1.33
			],
			[
				"2000-06-15",
				0.66
			],
			[
				"2000-10-13",
				1.59
			],
			[
				"2001-05-16",
				0.22
			],
			[
				"2001-11-09",
				1.55
			],
			[
				"2002-04-30",
				0.62
			],
			[
				"2003-04-03",
				0.97
			],
			[
				"2003-10-24",
				1.46
			],
			[
				"2004-05-11",
				0.71
			],
			[
				"2004-10-22",
				0.58
			],
			[
				"2005-10-25",
				1.06
			],
			[
				"2005-04-20",
				0.53
			],
			[
				"2006-10-12",
				1.9
			],
			[
				"2007-07-17",
				1.55
			],
			[
				"2008-08-20",
				0.31
			],
			[
				"2002-09-25",
				0.75
			],
			[
				"2009-08-06",
				4.43
			],
			[
				"2010-06-18",
				4.43
			],
			[
				"2011-05-27",
				4.43
			],
			[
				"2012-06-01",
				1.33
			]
		],
		"110210130": [
			[
				"2013-06-25",
				1.33
			],
			[
				"2015-11-02",
				1.33
			],
			[
				"2000-06-15",
				1.33
			],
			[
				"2000-10-13",
				1.77
			],
			[
				"2001-05-18",
				0.89
			],
			[
				"2001-10-29",
				0.84
			],
			[
				"2002-06-17",
				1.59
			],
			[
				"2003-10-24",
				10.85
			],
			[
				"2003-04-07",
				0.22
			],
			[
				"2004-05-11",
				7.71
			],
			[
				"2004-10-25",
				1.64
			],
			[
				"2005-10-25",
				1.86
			],
			[
				"2005-04-20",
				5.49
			],
			[
				"2006-10-11",
				1.28
			],
			[
				"2007-05-11",
				5
			],
			[
				"2002-09-25",
				1.55
			],
			[
				"2008-06-19",
				2.7
			],
			[
				"2009-06-19",
				8.41
			],
			[
				"2010-05-19",
				4.43
			],
			[
				"2011-05-02",
				4.43
			],
			[
				"2012-06-12",
				1.33
			]
		],
		"110210177": [
			[
				"2013-06-28",
				33.88
			],
			[
				"2015-10-29",
				37.02
			],
			[
				"2004-06-09",
				31.35
			],
			[
				"2004-10-25",
				30.47
			],
			[
				"2005-04-15",
				33.88
			],
			[
				"2006-10-19",
				16.96
			],
			[
				"2007-05-11",
				24.84
			],
			[
				"2005-10-13",
				29.36
			],
			[
				"2008-06-23",
				14.26
			],
			[
				"2009-07-13",
				19.49
			],
			[
				"2010-06-09",
				27.9
			],
			[
				"2011-05-03",
				30.56
			],
			[
				"2012-06-13",
				25.24
			]
		],
		"110210189": [
			[
				"2013-08-07",
				1.33
			],
			[
				"2015-05-08",
				1.33
			],
			[
				"2004-12-03",
				0.22
			],
			[
				"2005-04-15",
				0.22
			],
			[
				"2006-10-19",
				0.22
			],
			[
				"2007-06-19",
				0.22
			],
			[
				"2005-10-13",
				0.22
			],
			[
				"2008-06-23",
				0.22
			],
			[
				"2009-09-11",
				4.43
			],
			[
				"2010-07-06",
				4.43
			],
			[
				"2011-10-27",
				4.43
			],
			[
				"2012-06-13",
				1.33
			]
		],
		"110210190": [
			[
				"2013-06-19",
				186.44
			],
			[
				"2015-11-18",
				152.34
			],
			[
				"2004-12-03",
				184.67
			],
			[
				"2005-10-25",
				166.96
			],
			[
				"2005-04-20",
				133.74
			],
			[
				"2006-10-12",
				159.87
			],
			[
				"2007-05-14",
				116.91
			],
			[
				"2008-06-24",
				115.14
			],
			[
				"2009-06-19",
				167.84
			],
			[
				"2010-05-19",
				114.26
			],
			[
				"2011-05-13",
				126.21
			],
			[
				"2012-06-13",
				173.16
			]
		],
		"110210207": [
			[
				"2013-06-21",
				16.92
			],
			[
				"2015-11-16",
				21.39
			],
			[
				"2004-12-08",
				14.57
			],
			[
				"2005-11-11",
				9.88
			],
			[
				"2005-04-26",
				15.23
			],
			[
				"2006-11-02",
				7.93
			],
			[
				"2007-05-16",
				14.84
			],
			[
				"2008-07-01",
				7.66
			],
			[
				"2009-06-23",
				9.74
			],
			[
				"2010-05-20",
				15.06
			],
			[
				"2011-05-25",
				12.84
			],
			[
				"2012-06-20",
				18.16
			]
		],
		"110210219": [
			[
				"2013-06-26",
				1.33
			],
			[
				"2015-09-30",
				1.33
			],
			[
				"2004-12-08",
				0.53
			],
			[
				"2005-04-26",
				0.22
			],
			[
				"2006-11-06",
				0.22
			],
			[
				"2007-07-17",
				0.22
			],
			[
				"2008-08-29",
				0.4
			],
			[
				"2005-11-11",
				0.22
			],
			[
				"2009-08-10",
				4.43
			],
			[
				"2010-07-02",
				4.43
			],
			[
				"2011-06-21",
				4.43
			],
			[
				"2012-06-20",
				1.33
			]
		],
		"110220092": [
			[
				"2013-06-21",
				1.33
			],
			[
				"2014-12-08",
				1.33
			],
			[
				"2015-11-05",
				1.33
			],
			[
				"2006-11-02",
				3.45
			],
			[
				"2007-05-16",
				1.06
			],
			[
				"2008-07-01",
				0.44
			],
			[
				"2010-05-10",
				4.43
			],
			[
				"2011-05-05",
				4.43
			],
			[
				"2012-06-15",
				1.33
			]
		],
		"110220109": [
			[
				"2013-06-21",
				100.53
			],
			[
				"2014-12-04",
				90.34
			],
			[
				"2015-11-05",
				89.46
			],
			[
				"2000-05-29",
				72.19
			],
			[
				"2000-10-27",
				46.94
			],
			[
				"2000-10-11",
				50.93
			],
			[
				"2001-05-15",
				116.47
			],
			[
				"2001-05-23",
				110.71
			],
			[
				"2001-08-23",
				85.47
			],
			[
				"2001-10-30",
				74.84
			],
			[
				"2002-04-30",
				96.54
			],
			[
				"2002-06-17",
				69.09
			],
			[
				"2002-10-29",
				104.07
			],
			[
				"2003-03-31",
				94.33
			],
			[
				"2003-09-12",
				90.34
			],
			[
				"2003-06-06",
				50.93
			],
			[
				"2003-12-10",
				46.94
			],
			[
				"2004-04-19",
				91.23
			],
			[
				"2004-06-28",
				76.61
			],
			[
				"2004-10-12",
				75.73
			],
			[
				"2004-12-02",
				58.9
			],
			[
				"2005-12-05",
				79.71
			],
			[
				"2005-04-13",
				82.81
			],
			[
				"2005-05-30",
				71.74
			],
			[
				"2006-08-07",
				69.09
			],
			[
				"2006-11-02",
				61.11
			],
			[
				"2007-05-16",
				83.26
			],
			[
				"2008-07-01",
				66.43
			],
			[
				"2000-03-07",
				98.76
			],
			[
				"2002-09-16",
				101.41
			],
			[
				"2005-10-05",
				79.71
			],
			[
				"2009-06-23",
				71.74
			],
			[
				"2010-05-10",
				87.24
			],
			[
				"2011-05-05",
				78.39
			],
			[
				"2012-06-15",
				76.61
			]
		],
		"110220365": [
			[
				"2013-06-26",
				10.67
			],
			[
				"2014-11-05",
				1.33
			],
			[
				"2015-11-06",
				1.33
			],
			[
				"2006-11-02",
				0.27
			],
			[
				"2007-06-01",
				0.22
			],
			[
				"2007-11-20",
				10.89
			],
			[
				"2008-07-01",
				9.61
			],
			[
				"2009-06-23",
				7.53
			],
			[
				"2010-05-10",
				11.96
			],
			[
				"2011-05-05",
				19.93
			],
			[
				"2012-06-15",
				25.24
			]
		],
		"110220390": [
			[
				"2013-07-26",
				76.61
			],
			[
				"2014-12-05",
				53.14
			],
			[
				"2015-09-10",
				46.06
			],
			[
				"2006-11-03",
				113.81
			],
			[
				"2007-07-10",
				113.81
			],
			[
				"2008-08-15",
				113.81
			],
			[
				"2009-09-07",
				78.39
			],
			[
				"2010-07-12",
				103.63
			],
			[
				"2011-07-15",
				100.53
			],
			[
				"2012-06-14",
				94.77
			]
		],
		"110220419": [
			[
				"2013-07-26",
				35.52
			],
			[
				"2014-12-08",
				59.34
			],
			[
				"2015-09-11",
				58.9
			],
			[
				"2006-10-24",
				10.05
			],
			[
				"2007-07-10",
				47.83
			],
			[
				"2008-08-15",
				46.94
			],
			[
				"2009-08-31",
				41.63
			],
			[
				"2010-07-12",
				42.07
			],
			[
				"2011-07-15",
				57.13
			],
			[
				"2012-06-20",
				59.79
			]
		],
		"110220791": [
			[
				"2013-06-24",
				223.2
			],
			[
				"2014-10-28",
				216.11
			],
			[
				"2015-12-07",
				178.47
			],
			[
				"2000-05-25",
				305.57
			],
			[
				"2000-10-12",
				248.89
			],
			[
				"2001-05-22",
				238.26
			],
			[
				"2001-10-30",
				251.1
			],
			[
				"2002-05-28",
				206.81
			],
			[
				"2003-05-08",
				214.79
			],
			[
				"2003-11-04",
				197.96
			],
			[
				"2004-05-17",
				263.5
			],
			[
				"2004-11-17",
				231.61
			],
			[
				"2005-04-27",
				280.33
			],
			[
				"2006-12-13",
				192.64
			],
			[
				"2007-05-29",
				196.63
			],
			[
				"2005-11-10",
				220.99
			],
			[
				"2002-09-16",
				197.96
			],
			[
				"2008-07-03",
				208.59
			],
			[
				"2009-06-29",
				263.06
			],
			[
				"2010-05-28",
				253.31
			],
			[
				"2011-05-10",
				172.27
			],
			[
				"2012-06-14",
				219.66
			]
		],
		"110220808": [
			[
				"2013-06-24",
				59.79
			],
			[
				"2014-10-28",
				30.42
			],
			[
				"2015-12-07",
				18.42
			],
			[
				"2006-10-24",
				12.53
			],
			[
				"2007-05-29",
				46.06
			],
			[
				"2008-07-03",
				50.93
			],
			[
				"2009-06-29",
				50.93
			],
			[
				"2010-05-28",
				50.04
			],
			[
				"2011-05-10",
				45.61
			],
			[
				"2012-06-14",
				31.89
			]
		],
		"110220870": [
			[
				"2013-06-19",
				42.56
			],
			[
				"2014-10-30",
				38.44
			],
			[
				"2015-11-24",
				61.56
			],
			[
				"2000-06-28",
				49.6
			],
			[
				"2000-10-19",
				44.73
			],
			[
				"2001-05-08",
				27.01
			],
			[
				"2001-10-30",
				30.34
			],
			[
				"2002-06-17",
				22.1
			],
			[
				"2003-09-12",
				40.48
			],
			[
				"2003-07-02",
				35.43
			],
			[
				"2004-10-25",
				36.23
			],
			[
				"2004-07-01",
				36.54
			],
			[
				"2005-04-15",
				27.72
			],
			[
				"2006-10-20",
				40.43
			],
			[
				"2007-05-14",
				46.5
			],
			[
				"2007-11-12",
				55.8
			],
			[
				"2008-06-25",
				43.75
			],
			[
				"2002-09-02",
				24.05
			],
			[
				"2005-10-06",
				36.05
			],
			[
				"2009-07-13",
				77.94
			],
			[
				"2010-06-09",
				69.97
			],
			[
				"2011-05-03",
				49.16
			],
			[
				"2012-07-20",
				54.47
			]
		],
		"110220882": [
			[
				"2013-06-26",
				1.42
			],
			[
				"2014-10-30",
				1.33
			],
			[
				"2015-11-06",
				1.33
			],
			[
				"2006-11-06",
				5.36
			],
			[
				"2007-05-31",
				0.27
			],
			[
				"2007-11-20",
				11.12
			],
			[
				"2008-06-25",
				0.27
			],
			[
				"2009-06-22",
				4.43
			],
			[
				"2010-05-21",
				4.43
			],
			[
				"2011-04-26",
				4.43
			],
			[
				"2012-07-20",
				1.33
			]
		],
		"110220924": [
			[
				"2013-08-07",
				9.92
			],
			[
				"2014-11-05",
				5.98
			],
			[
				"2015-10-27",
				3.52
			],
			[
				"2004-12-03",
				3.37
			],
			[
				"2005-04-15",
				1.99
			],
			[
				"2006-10-19",
				2.97
			],
			[
				"2007-05-11",
				2.35
			],
			[
				"2005-10-13",
				3.9
			],
			[
				"2008-06-23",
				3.14
			],
			[
				"2009-07-20",
				4.43
			],
			[
				"2010-06-10",
				4.43
			],
			[
				"2011-05-03",
				4.43
			],
			[
				"2012-07-20",
				7.97
			]
		],
		"110240029": [
			[
				"2013-08-27",
				1.33
			],
			[
				"2014-11-10",
				1.33
			],
			[
				"2015-06-16",
				1.33
			],
			[
				"2000-05-24",
				0.22
			],
			[
				"2000-11-20",
				1.02
			],
			[
				"2001-05-30",
				0.22
			],
			[
				"2001-11-14",
				0.22
			],
			[
				"2002-05-07",
				1.15
			],
			[
				"2003-05-09",
				1.11
			],
			[
				"2003-11-12",
				0.22
			],
			[
				"2004-05-26",
				0.27
			],
			[
				"2004-11-11",
				0.22
			],
			[
				"2005-10-24",
				0.22
			],
			[
				"2005-04-25",
				0.22
			],
			[
				"2006-11-08",
				0.27
			],
			[
				"2007-07-12",
				0.22
			],
			[
				"2008-07-31",
				0.22
			],
			[
				"2002-09-26",
				0.22
			],
			[
				"2009-09-01",
				4.43
			],
			[
				"2010-07-21",
				4.43
			],
			[
				"2011-10-10",
				4.43
			],
			[
				"2012-07-17",
				1.33
			]
		],
		"110240121": [
			[
				"2013-08-01",
				1.81
			],
			[
				"2014-10-31",
				1.33
			],
			[
				"2015-09-14",
				1.33
			],
			[
				"2006-10-23",
				2.04
			],
			[
				"2007-07-09",
				0.22
			],
			[
				"2008-08-06",
				0.22
			],
			[
				"2009-08-27",
				4.43
			],
			[
				"2010-07-07",
				4.43
			],
			[
				"2011-07-13",
				4.43
			],
			[
				"2012-07-17",
				1.33
			]
		],
		"110240133": [
			[
				"2013-06-19",
				8.55
			],
			[
				"2015-05-13",
				1.33
			],
			[
				"2000-05-26",
				24.05
			],
			[
				"2000-10-12",
				20.86
			],
			[
				"2001-11-14",
				12.05
			],
			[
				"2001-05-16",
				13.95
			],
			[
				"2002-05-28",
				7.84
			],
			[
				"2003-04-23",
				13.64
			],
			[
				"2003-11-04",
				10.36
			],
			[
				"2004-05-17",
				7
			],
			[
				"2004-12-07",
				0.22
			],
			[
				"2005-04-26",
				4.3
			],
			[
				"2006-10-25",
				11.96
			],
			[
				"2007-07-09",
				9.88
			],
			[
				"2005-11-11",
				13.29
			],
			[
				"2008-08-06",
				10.67
			],
			[
				"2002-09-27",
				14.97
			],
			[
				"2009-08-27",
				9.3
			],
			[
				"2010-07-07",
				18.16
			],
			[
				"2011-07-13",
				4.43
			],
			[
				"2012-07-17",
				20.37
			]
		],
		"110240145": [
			[
				"2013-06-24",
				30.16
			],
			[
				"2014-12-03",
				21.12
			],
			[
				"2015-09-16",
				21.08
			],
			[
				"2000-06-16",
				84.59
			],
			[
				"2000-10-19",
				43.75
			],
			[
				"2001-05-08",
				71.74
			],
			[
				"2001-11-09",
				55.8
			],
			[
				"2002-05-28",
				74.4
			],
			[
				"2003-09-12",
				73.07
			],
			[
				"2003-05-08",
				76.61
			],
			[
				"2004-06-28",
				73.96
			],
			[
				"2004-11-17",
				66.87
			],
			[
				"2005-04-27",
				80.6
			],
			[
				"2006-11-03",
				89.01
			],
			[
				"2007-07-09",
				81.93
			],
			[
				"2008-08-12",
				83.7
			],
			[
				"2002-09-02",
				73.96
			],
			[
				"2005-10-06",
				68.2
			],
			[
				"2009-08-31",
				111.6
			],
			[
				"2010-07-07",
				62.44
			],
			[
				"2011-10-11",
				39.41
			],
			[
				"2012-08-14",
				43.84
			]
		],
		"110240169": [
			[
				"2013-08-01",
				1.33
			],
			[
				"2014-12-05",
				1.36
			],
			[
				"2015-11-17",
				1.33
			],
			[
				"2007-07-04",
				0.31
			],
			[
				"2008-08-12",
				0.4
			],
			[
				"2009-09-07",
				4.43
			],
			[
				"2010-07-20",
				4.43
			],
			[
				"2011-10-11",
				4.43
			],
			[
				"2012-08-03",
				1.33
			]
		],
		"110240194": [
			[
				"2013-08-30",
				1.33
			],
			[
				"2014-12-02",
				1.33
			],
			[
				"2015-06-08",
				1.33
			],
			[
				"2000-10-12",
				0.66
			],
			[
				"2000-06-16",
				2.48
			],
			[
				"2001-05-23",
				4.34
			],
			[
				"2001-11-09",
				0.4
			],
			[
				"2002-05-28",
				3.59
			],
			[
				"2002-10-09",
				0.97
			],
			[
				"2003-05-08",
				3.23
			],
			[
				"2003-11-04",
				0.4
			],
			[
				"2004-06-02",
				6.24
			],
			[
				"2004-11-17",
				3.19
			],
			[
				"2005-04-27",
				9.39
			],
			[
				"2006-11-03",
				0.22
			],
			[
				"2007-05-30",
				2.17
			],
			[
				"2005-11-10",
				1.11
			],
			[
				"2008-07-04",
				1.9
			],
			[
				"2009-07-06",
				4.43
			],
			[
				"2010-07-20",
				4.43
			],
			[
				"2011-10-13",
				4.43
			],
			[
				"2012-08-03",
				1.77
			]
		],
		"110250035": [
			[
				"2013-08-13",
				1.95
			],
			[
				"2014-12-11",
				1.33
			],
			[
				"2015-11-20",
				2.76
			],
			[
				"2006-11-07",
				0.75
			],
			[
				"2007-07-30",
				0.8
			],
			[
				"2003-06-25",
				0.62
			],
			[
				"2003-12-01",
				0.84
			],
			[
				"2008-07-18",
				0.27
			],
			[
				"2009-07-31",
				4.43
			],
			[
				"2010-08-27",
				4.43
			],
			[
				"2011-10-20",
				4.43
			],
			[
				"2012-08-10",
				1.33
			]
		],
		"110250060": [
			[
				"2013-07-24",
				1.33
			],
			[
				"2015-11-18",
				1.33
			],
			[
				"2006-09-14",
				4.12
			],
			[
				"2007-07-27",
				5
			],
			[
				"2008-07-16",
				0.97
			],
			[
				"2009-07-29",
				4.43
			],
			[
				"2010-08-19",
				8.86
			],
			[
				"2011-10-17",
				4.43
			],
			[
				"2012-07-27",
				6.64
			]
		],
		"110250072": [
			[
				"2013-07-24",
				55.8
			],
			[
				"2014-12-15",
				40.08
			],
			[
				"2015-11-25",
				38.62
			],
			[
				"2006-10-09",
				100.97
			],
			[
				"2007-07-27",
				48.27
			],
			[
				"2007-11-23",
				43.93
			],
			[
				"2008-07-17",
				41.05
			],
			[
				"2009-07-29",
				49.16
			],
			[
				"2010-08-30",
				51.37
			],
			[
				"2011-10-17",
				47.39
			],
			[
				"2012-07-27",
				55.8
			]
		],
		"110250114": [
			[
				"2013-07-24",
				1.33
			],
			[
				"2015-11-25",
				1.33
			],
			[
				"2006-09-14",
				0.27
			],
			[
				"2007-08-01",
				1.82
			],
			[
				"2008-07-16",
				0.22
			],
			[
				"2009-08-05",
				4.43
			],
			[
				"2010-08-19",
				4.43
			],
			[
				"2011-10-19",
				4.43
			],
			[
				"2012-08-06",
				2.66
			]
		],
		"110250126": [
			[
				"2013-09-27",
				1.33
			],
			[
				"2015-11-26",
				1.33
			],
			[
				"2006-09-14",
				0.22
			],
			[
				"2007-08-01",
				0.31
			],
			[
				"2008-07-16",
				0.22
			],
			[
				"2009-07-29",
				4.43
			],
			[
				"2010-08-19",
				4.43
			],
			[
				"2011-10-17",
				4.43
			],
			[
				"2012-07-27",
				1.33
			]
		],
		"110250140": [
			[
				"2015-11-24",
				6.95
			],
			[
				"2006-09-14",
				15.23
			],
			[
				"2007-07-31",
				4.43
			],
			[
				"2008-07-17",
				2.48
			],
			[
				"2009-07-30",
				4.43
			],
			[
				"2010-08-24",
				4.43
			],
			[
				"2011-10-20",
				4.43
			],
			[
				"2012-08-06",
				7.53
			]
		],
		"110260314": [
			[
				"2013-08-26",
				1.33
			],
			[
				"2014-08-19",
				1.33
			],
			[
				"2015-08-27",
				1.33
			],
			[
				"2007-04-26",
				0.62
			],
			[
				"2006-08-15",
				1.82
			],
			[
				"2007-11-15",
				1.33
			],
			[
				"2008-05-07",
				0.22
			],
			[
				"2009-05-27",
				4.43
			],
			[
				"2010-05-12",
				4.43
			],
			[
				"2011-04-29",
				4.43
			],
			[
				"2012-05-29",
				1.33
			]
		],
		"110260340": [
			[
				"2013-08-26",
				1.33
			],
			[
				"2014-08-18",
				1.33
			],
			[
				"2015-08-26",
				1.33
			],
			[
				"2007-04-27",
				0.62
			],
			[
				"2006-08-15",
				3.72
			],
			[
				"2008-05-05",
				0.22
			],
			[
				"2009-05-27",
				44.73
			],
			[
				"2010-05-12",
				4.43
			],
			[
				"2011-04-29",
				4.43
			],
			[
				"2012-07-26",
				1.33
			]
		],
		"110280015": [
			[
				"2013-09-02",
				117.8
			],
			[
				"2014-08-25",
				113.81
			],
			[
				"2015-07-02",
				74.4
			],
			[
				"2003-11-25",
				93
			],
			[
				"2004-06-04",
				90.34
			],
			[
				"2004-11-18",
				91.67
			],
			[
				"2005-11-03",
				89.01
			],
			[
				"2005-06-23",
				92.56
			],
			[
				"2006-11-10",
				87.69
			],
			[
				"2007-07-11",
				104.07
			],
			[
				"2008-07-29",
				58.9
			],
			[
				"2009-09-01",
				81.49
			],
			[
				"2010-08-09",
				91.23
			],
			[
				"2011-07-11",
				104.51
			],
			[
				"2012-07-23",
				133.3
			]
		],
		"110280027": [
			[
				"2013-08-28",
				89.46
			],
			[
				"2014-11-13",
				85.03
			],
			[
				"2015-06-17",
				86.8
			],
			[
				"2003-11-25",
				85.03
			],
			[
				"2004-06-04",
				84.14
			],
			[
				"2004-11-18",
				80.16
			],
			[
				"2005-11-03",
				78.83
			],
			[
				"2005-06-24",
				81.93
			],
			[
				"2006-11-10",
				78.39
			],
			[
				"2007-07-11",
				85.47
			],
			[
				"2008-07-29",
				83.7
			],
			[
				"2009-10-07",
				89.9
			],
			[
				"2010-08-09",
				96.99
			],
			[
				"2011-07-11",
				94.33
			],
			[
				"2012-07-23",
				84.59
			]
		],
		"110290021": [
			[
				"2013-08-28",
				1.33
			],
			[
				"2015-07-14",
				1.33
			],
			[
				"2003-12-02",
				0.44
			],
			[
				"2004-06-08",
				2.39
			],
			[
				"2004-11-12",
				0.22
			],
			[
				"2005-11-08",
				0.22
			],
			[
				"2005-05-24",
				0.22
			],
			[
				"2006-08-22",
				0.22
			],
			[
				"2007-06-12",
				0.4
			],
			[
				"2008-11-06",
				0.4
			],
			[
				"2008-06-03",
				0.22
			],
			[
				"2009-05-18",
				4.43
			],
			[
				"2010-05-25",
				4.43
			],
			[
				"2011-05-04",
				4.43
			],
			[
				"2012-05-31",
				1.33
			]
		],
		"110290045": [
			[
				"2013-06-20",
				94.33
			],
			[
				"2014-10-23",
				93.89
			],
			[
				"2015-01-28",
				92.11
			],
			[
				"2004-06-04",
				67.31
			],
			[
				"2004-11-12",
				64.66
			],
			[
				"2005-11-08",
				67.31
			],
			[
				"2005-05-24",
				58.46
			],
			[
				"2006-11-14",
				74.84
			],
			[
				"2007-07-12",
				81.49
			],
			[
				"2009-08-12",
				77.5
			],
			[
				"2010-08-09",
				96.54
			],
			[
				"2011-07-08",
				89.46
			],
			[
				"2012-08-13",
				85.03
			]
		],
		"110310019": [
			[
				"2013-08-06",
				85.47
			],
			[
				"2015-11-10",
				86.8
			],
			[
				"2000-11-30",
				81.04
			],
			[
				"2000-07-12",
				54.03
			],
			[
				"2001-11-26",
				79.27
			],
			[
				"2001-08-23",
				76.17
			],
			[
				"2002-06-21",
				77.06
			],
			[
				"2003-11-06",
				46.5
			],
			[
				"2003-04-23",
				89.46
			],
			[
				"2005-07-11",
				83.26
			],
			[
				"2006-01-09",
				73.07
			],
			[
				"2006-12-14",
				36.23
			],
			[
				"2007-08-14",
				85.03
			],
			[
				"2008-08-05",
				58.46
			],
			[
				"2009-10-06",
				41.63
			],
			[
				"2010-08-24",
				60.67
			],
			[
				"2011-10-28",
				30.56
			],
			[
				"2012-08-30",
				73.96
			]
		],
		"110310317": [
			[
				"2013-08-01",
				3.43
			],
			[
				"2015-09-23",
				2.32
			],
			[
				"2000-07-12",
				2.7
			],
			[
				"2000-11-23",
				2.79
			],
			[
				"2001-06-20",
				3.63
			],
			[
				"2001-11-21",
				3.59
			],
			[
				"2002-06-20",
				5
			],
			[
				"2003-05-08",
				4.34
			],
			[
				"2003-12-10",
				2.7
			],
			[
				"2004-06-02",
				3.45
			],
			[
				"2004-12-08",
				2.66
			],
			[
				"2005-04-27",
				3.72
			],
			[
				"2006-11-03",
				2.83
			],
			[
				"2007-07-10",
				3.14
			],
			[
				"2005-11-10",
				2.21
			],
			[
				"2008-08-18",
				2.08
			],
			[
				"2002-10-10",
				4.25
			],
			[
				"2009-09-11",
				4.43
			],
			[
				"2010-07-23",
				4.43
			],
			[
				"2011-10-13",
				4.43
			],
			[
				"2012-08-24",
				3.1
			]
		],
		"110320062": [
			[
				"2013-06-25",
				1.33
			],
			[
				"2015-06-24",
				1.33
			],
			[
				"2000-06-16",
				0.44
			],
			[
				"2000-11-23",
				1.55
			],
			[
				"2001-05-28",
				0.22
			],
			[
				"2001-10-26",
				0.71
			],
			[
				"2002-05-29",
				1.24
			],
			[
				"2003-05-09",
				1.55
			],
			[
				"2003-12-10",
				4.12
			],
			[
				"2004-05-17",
				0.58
			],
			[
				"2004-11-23",
				0.27
			],
			[
				"2005-05-02",
				0.22
			],
			[
				"2006-09-04",
				0.22
			],
			[
				"2007-05-30",
				0.22
			],
			[
				"2005-11-21",
				0.22
			],
			[
				"2002-09-26",
				0.22
			],
			[
				"2008-07-04",
				0.22
			],
			[
				"2009-06-17",
				4.43
			],
			[
				"2010-07-19",
				4.43
			],
			[
				"2011-07-04",
				4.43
			],
			[
				"2012-08-14",
				1.33
			],
			[
				"2012-07-18",
				1.33
			]
		],
		"110320104": [
			[
				"2013-08-20",
				1.33
			],
			[
				"2015-06-25",
				1.33
			],
			[
				"2000-05-24",
				0.22
			],
			[
				"2000-11-20",
				1.06
			],
			[
				"2001-05-28",
				0.22
			],
			[
				"2001-10-26",
				0.71
			],
			[
				"2002-05-29",
				1.15
			],
			[
				"2003-05-09",
				1.06
			],
			[
				"2003-11-12",
				0.22
			],
			[
				"2004-05-26",
				0.22
			],
			[
				"2004-11-11",
				0.22
			],
			[
				"2005-10-24",
				0.27
			],
			[
				"2005-04-25",
				0.22
			],
			[
				"2006-09-04",
				0.22
			],
			[
				"2007-06-05",
				0.22
			],
			[
				"2002-09-26",
				0.22
			],
			[
				"2008-07-07",
				0.22
			],
			[
				"2009-06-17",
				4.43
			],
			[
				"2010-07-27",
				4.43
			],
			[
				"2011-06-20",
				4.43
			],
			[
				"2012-07-17",
				1.33
			]
		],
		"110340024": [
			[
				"2013-08-20",
				16.3
			],
			[
				"2014-11-28",
				8.06
			],
			[
				"2015-04-14",
				6.2
			],
			[
				"2006-09-05",
				1.9
			],
			[
				"2007-05-30",
				9.57
			],
			[
				"2008-07-04",
				17.49
			],
			[
				"2009-06-17",
				15.5
			],
			[
				"2010-07-29",
				14.61
			],
			[
				"2011-07-04",
				8.41
			],
			[
				"2012-07-18",
				8.41
			]
		],
		"110340036": [
			[
				"2013-08-19",
				1.33
			],
			[
				"2015-06-25",
				1.33
			],
			[
				"2006-11-08",
				0.22
			],
			[
				"2007-06-04",
				0.22
			],
			[
				"2008-07-07",
				0.22
			],
			[
				"2009-06-16",
				4.43
			],
			[
				"2010-07-27",
				4.43
			],
			[
				"2011-06-20",
				4.43
			],
			[
				"2012-08-15",
				1.33
			]
		],
		"113014016": [
			[
				"2013-07-22",
				1.33
			],
			[
				"2015-11-17",
				1.33
			],
			[
				"2006-11-20",
				1.2
			],
			[
				"2007-05-09",
				0.8
			],
			[
				"2007-11-19",
				0.97
			],
			[
				"2008-06-12",
				0.22
			],
			[
				"2009-07-10",
				4.43
			],
			[
				"2010-07-15",
				4.43
			],
			[
				"2011-05-30",
				4.43
			],
			[
				"2012-07-10",
				1.33
			]
		],
		"113409096": [
			[
				"2006-10-27",
				1.55
			],
			[
				"2007-04-18",
				1
			],
			[
				"2008-04-16",
				1
			],
			[
				"2010-04-21",
				1
			],
			[
				"2009-04-23",
				1
			],
			[
				"2011-04-27",
				1
			],
			[
				"2012-03-27",
				1
			],
			[
				"2013-04-19",
				1
			],
			[
				"2015-04-20",
				1
			],
			[
				"2014-04-07",
				1
			]
		],
		"113409102": [
			[
				"2006-11-06",
				2.44
			],
			[
				"2007-04-18",
				1
			],
			[
				"2008-04-16",
				1
			],
			[
				"2010-04-21",
				1
			],
			[
				"2009-04-23",
				1
			],
			[
				"2011-04-27",
				1
			],
			[
				"2012-03-27",
				1
			],
			[
				"2013-04-10",
				1
			],
			[
				"2015-04-16",
				1
			],
			[
				"2014-03-31",
				1
			]
		],
		"113409151": [
			[
				"2006-11-06",
				21.35
			],
			[
				"2007-04-25",
				26.41
			],
			[
				"2008-04-15",
				64.42
			],
			[
				"2011-04-18",
				38.01
			],
			[
				"2010-04-21",
				57.32
			],
			[
				"2009-04-23",
				59.62
			],
			[
				"2012-03-27",
				53.62
			],
			[
				"2013-04-19",
				30.71
			],
			[
				"2015-04-20",
				33.71
			]
		],
		"113409163": [
			[
				"2006-12-13",
				37.29
			],
			[
				"2007-04-25",
				27.91
			],
			[
				"2008-04-15",
				38.31
			],
			[
				"2011-04-18",
				40.32
			],
			[
				"2010-04-21",
				54.22
			],
			[
				"2009-04-23",
				45.72
			],
			[
				"2012-03-27",
				40.71
			],
			[
				"2013-04-19",
				39.61
			],
			[
				"2014-04-07",
				39.71
			],
			[
				"2015-04-20",
				39.41
			]
		],
		"113710185": [
			[
				"2013-08-27",
				22.85
			],
			[
				"2015-06-29",
				14.84
			],
			[
				"2006-11-09",
				29.76
			],
			[
				"2007-06-05",
				5.85
			],
			[
				"2008-07-09",
				7.35
			],
			[
				"2009-06-18",
				30.11
			],
			[
				"2010-07-30",
				22.59
			],
			[
				"2011-07-05",
				6.2
			],
			[
				"2012-07-11",
				24.36
			]
		],
		"118021035": [
			[
				"2000-05-16",
				1
			],
			[
				"2001-05-03",
				1
			],
			[
				"2001-08-28",
				1
			],
			[
				"2002-05-14",
				1
			],
			[
				"2002-10-09",
				1
			],
			[
				"2003-05-16",
				1
			],
			[
				"2003-10-15",
				1
			],
			[
				"2004-05-26",
				1
			],
			[
				"2004-11-09",
				1
			],
			[
				"2005-04-12",
				1
			],
			[
				"2005-10-25",
				1
			],
			[
				"2006-10-24",
				1
			],
			[
				"2007-03-26",
				1
			],
			[
				"2007-10-22",
				1
			],
			[
				"2008-03-25",
				1
			],
			[
				"2008-10-07",
				1.02
			],
			[
				"2010-04-20",
				1.99
			],
			[
				"2010-10-18",
				1.02
			],
			[
				"2011-04-04",
				1
			],
			[
				"2012-04-23",
				1
			],
			[
				"2011-10-06",
				1
			],
			[
				"2012-10-23",
				1
			],
			[
				"2009-10-02",
				1
			],
			[
				"2013-04-24",
				1
			],
			[
				"2013-10-08",
				2.5
			],
			[
				"2014-04-08",
				1
			],
			[
				"2014-10-07",
				1
			],
			[
				"2015-04-21",
				3
			],
			[
				"2015-09-29",
				1
			]
		],
		"118021047": [
			[
				"2000-05-16",
				1
			],
			[
				"2000-10-24",
				1
			],
			[
				"2001-05-03",
				1
			],
			[
				"2001-08-29",
				1
			],
			[
				"2002-05-15",
				1
			],
			[
				"2002-10-09",
				2
			],
			[
				"2003-05-15",
				1
			],
			[
				"2003-10-15",
				1
			],
			[
				"2004-05-26",
				1
			],
			[
				"2004-11-09",
				1
			],
			[
				"2005-04-13",
				1
			],
			[
				"2005-10-26",
				1
			],
			[
				"2006-10-24",
				4
			],
			[
				"2007-03-27",
				1.2
			],
			[
				"2007-10-23",
				1.5
			],
			[
				"2008-03-26",
				1.68
			],
			[
				"2008-10-07",
				1.59
			],
			[
				"2010-04-22",
				2.7
			],
			[
				"2010-10-19",
				1.99
			],
			[
				"2011-04-04",
				2
			],
			[
				"2011-10-06",
				2.4
			],
			[
				"2012-04-24",
				2.5
			],
			[
				"2012-10-23",
				2.4
			],
			[
				"2009-10-01",
				1.8
			],
			[
				"2013-04-25",
				2.5
			],
			[
				"2013-10-08",
				18.01
			],
			[
				"2014-04-08",
				1.8
			],
			[
				"2014-10-07",
				2.6
			],
			[
				"2015-04-21",
				3
			],
			[
				"2015-09-29",
				2.7
			]
		],
		"118052020": [
			[
				"2000-05-16",
				4
			],
			[
				"2000-10-24",
				6
			],
			[
				"2001-05-02",
				7
			],
			[
				"2001-08-28",
				6
			],
			[
				"2002-05-14",
				5
			],
			[
				"2002-10-09",
				5
			],
			[
				"2003-05-15",
				5
			],
			[
				"2003-10-14",
				5
			],
			[
				"2004-05-25",
				7
			],
			[
				"2004-11-09",
				10
			],
			[
				"2005-04-12",
				6
			],
			[
				"2005-10-26",
				7
			],
			[
				"2006-10-24",
				11
			],
			[
				"2007-03-26",
				8
			],
			[
				"2006-05-02",
				1.02
			],
			[
				"2007-10-23",
				10.98
			],
			[
				"2008-03-26",
				7.9
			],
			[
				"2008-10-07",
				8
			],
			[
				"2005-04-15",
				6
			],
			[
				"2004-05-21",
				7
			],
			[
				"2010-04-20",
				7.71
			],
			[
				"2010-10-20",
				8.02
			],
			[
				"2011-04-04",
				9
			],
			[
				"2011-10-06",
				11
			],
			[
				"2012-04-23",
				8.2
			],
			[
				"2012-10-23",
				8.1
			],
			[
				"2013-04-24",
				5.1
			],
			[
				"2013-10-08",
				8.1
			],
			[
				"2014-04-08",
				9.2
			],
			[
				"2014-10-07",
				8.7
			],
			[
				"2015-04-21",
				6.9
			],
			[
				"2015-09-30",
				7.2
			]
		],
		"118052056": [
			[
				"2000-05-16",
				41.01
			],
			[
				"2000-10-24",
				76.03
			],
			[
				"2001-08-28",
				79.03
			],
			[
				"2001-05-02",
				74.03
			],
			[
				"2002-05-14",
				80.03
			],
			[
				"2002-10-09",
				81.03
			],
			[
				"2003-05-15",
				70.02
			],
			[
				"2003-10-14",
				67.02
			],
			[
				"2004-05-25",
				78.03
			],
			[
				"2004-11-09",
				66.02
			],
			[
				"2005-04-12",
				64.02
			],
			[
				"2005-10-26",
				64.02
			],
			[
				"2006-10-24",
				60.02
			],
			[
				"2007-03-27",
				78.03
			],
			[
				"2004-05-21",
				78.03
			],
			[
				"2006-05-02",
				49.02
			],
			[
				"2007-10-23",
				78.03
			],
			[
				"2008-03-26",
				77.03
			],
			[
				"2008-10-08",
				82.03
			],
			[
				"2005-04-15",
				64.02
			],
			[
				"2010-04-20",
				80.33
			],
			[
				"2010-10-20",
				79.05
			],
			[
				"2011-04-05",
				71.03
			],
			[
				"2011-10-06",
				52.02
			],
			[
				"2012-04-23",
				77.03
			],
			[
				"2012-10-24",
				74.03
			],
			[
				"2013-04-24",
				73.03
			],
			[
				"2013-10-08",
				49.02
			],
			[
				"2014-04-08",
				50.02
			],
			[
				"2014-10-07",
				49.02
			],
			[
				"2015-04-21",
				49.55
			],
			[
				"2015-09-30",
				34.01
			]
		],
		"118054831": [
			[
				"2000-05-15",
				6
			],
			[
				"2000-10-24",
				9
			],
			[
				"2001-08-29",
				10
			],
			[
				"2001-05-02",
				9
			],
			[
				"2002-05-14",
				7
			],
			[
				"2002-10-09",
				8
			],
			[
				"2003-05-15",
				7
			],
			[
				"2003-10-14",
				7
			],
			[
				"2004-05-25",
				7
			],
			[
				"2004-11-09",
				10
			],
			[
				"2005-04-12",
				7
			],
			[
				"2005-10-27",
				7
			],
			[
				"2006-10-25",
				10
			],
			[
				"2007-03-26",
				7.5
			],
			[
				"2005-04-15",
				7
			],
			[
				"2004-05-21",
				7
			],
			[
				"2006-05-03",
				7
			],
			[
				"2008-03-25",
				8.1
			],
			[
				"2008-10-08",
				10
			],
			[
				"2010-04-22",
				9.79
			],
			[
				"2010-10-20",
				9.39
			],
			[
				"2011-04-05",
				9.2
			],
			[
				"2011-10-10",
				9.8
			],
			[
				"2012-10-24",
				9.8
			],
			[
				"2013-04-25",
				8.7
			],
			[
				"2013-10-08",
				9.7
			],
			[
				"2014-04-08",
				9.8
			],
			[
				"2014-10-07",
				9.7
			],
			[
				"2015-04-21",
				9.11
			],
			[
				"2015-09-30",
				7.7
			]
		],
		"118260042": [
			[
				"2000-04-19",
				76.03
			],
			[
				"2000-10-17",
				100.04
			],
			[
				"2001-04-19",
				72.03
			],
			[
				"2001-10-16",
				58.02
			],
			[
				"2002-04-25",
				43.02
			],
			[
				"2002-10-22",
				44.02
			],
			[
				"2003-04-15",
				58.02
			],
			[
				"2003-10-16",
				40.01
			],
			[
				"2004-04-22",
				79.03
			],
			[
				"2005-04-21",
				46.92
			],
			[
				"2006-05-15",
				37.01
			],
			[
				"2005-04-21",
				46.92
			],
			[
				"2006-05-15",
				37.01
			],
			[
				"2007-05-08",
				41.61
			],
			[
				"2008-04-10",
				46.52
			],
			[
				"2010-04-27",
				53.22
			],
			[
				"2009-04-22",
				42.21
			],
			[
				"2011-04-20",
				40.22
			],
			[
				"2012-03-28",
				42.12
			],
			[
				"2013-04-15",
				38.51
			],
			[
				"2014-04-08",
				39.51
			],
			[
				"2015-04-22",
				31.91
			]
		],
		"118262099": [
			[
				"2000-04-19",
				13
			],
			[
				"2000-10-17",
				14
			],
			[
				"2001-04-19",
				7.9
			],
			[
				"2001-10-16",
				10
			],
			[
				"2002-04-25",
				9.6
			],
			[
				"2002-10-22",
				12
			],
			[
				"2003-04-15",
				15.01
			],
			[
				"2003-10-16",
				12
			],
			[
				"2004-04-22",
				18.01
			],
			[
				"2004-10-24",
				16.21
			],
			[
				"2005-04-18",
				17.31
			],
			[
				"2005-11-09",
				18.71
			],
			[
				"2006-05-02",
				18.21
			],
			[
				"2006-05-02",
				18.21
			],
			[
				"2007-04-25",
				16.81
			],
			[
				"2008-04-08",
				11.5
			],
			[
				"2011-04-07",
				21.61
			],
			[
				"2010-04-19",
				19.81
			],
			[
				"2009-04-07",
				17.91
			],
			[
				"2004-10-27",
				16.21
			],
			[
				"2012-03-26",
				17.21
			],
			[
				"2013-04-22",
				13.8
			],
			[
				"2014-04-01",
				18.21
			],
			[
				"2015-04-22",
				16.81
			]
		],
		"118610247": [
			[
				"2000-04-17",
				28.01
			],
			[
				"2000-10-24",
				24.01
			],
			[
				"2001-05-14",
				42.01
			],
			[
				"2001-11-19",
				22.01
			],
			[
				"2002-10-18",
				32.01
			],
			[
				"2002-05-21",
				28.71
			],
			[
				"2003-04-14",
				34.91
			],
			[
				"2003-10-27",
				35.91
			],
			[
				"2004-05-10",
				26.21
			],
			[
				"2004-11-08",
				19.31
			],
			[
				"2005-04-20",
				28.81
			],
			[
				"2005-11-15",
				30.91
			],
			[
				"2006-04-24",
				36.01
			],
			[
				"2006-10-24",
				31.61
			],
			[
				"2007-05-07",
				70.12
			],
			[
				"2004-11-09",
				19.31
			],
			[
				"2008-04-08",
				32.91
			],
			[
				"2007-10-09",
				37.82
			],
			[
				"2009-04-15",
				41.01
			],
			[
				"2008-10-09",
				26.31
			],
			[
				"2009-10-15",
				7.31
			],
			[
				"2010-04-15",
				32.02
			],
			[
				"2010-10-19",
				12
			],
			[
				"2011-05-04",
				15.01
			],
			[
				"2011-11-03",
				11
			],
			[
				"2012-04-17",
				37.02
			],
			[
				"2012-10-17",
				25.01
			],
			[
				"2013-04-24",
				33.01
			],
			[
				"2013-10-07",
				23.01
			],
			[
				"2014-04-17",
				22.01
			],
			[
				"2015-04-16",
				30.01
			],
			[
				"2014-10-08",
				27.01
			],
			[
				"2015-10-21",
				24.01
			]
		],
		"118731026": [
			[
				"2008-04-23",
				24.51
			],
			[
				"2008-10-23",
				27.01
			],
			[
				"2006-02-14",
				24.01
			],
			[
				"2006-10-10",
				15.11
			],
			[
				"2006-04-05",
				23.61
			],
			[
				"2007-04-19",
				27.21
			],
			[
				"2007-10-24",
				23.61
			],
			[
				"2010-04-14",
				14
			],
			[
				"2010-10-28",
				26.01
			],
			[
				"2009-04-22",
				24.01
			],
			[
				"2009-10-15",
				25.01
			],
			[
				"2011-04-13",
				22.01
			],
			[
				"2011-10-05",
				24.01
			],
			[
				"2012-04-26",
				18.01
			],
			[
				"2012-10-24",
				26.01
			],
			[
				"2000-11-09",
				28.01
			],
			[
				"2000-04-06",
				19.01
			],
			[
				"2003-05-14",
				28.01
			],
			[
				"2001-11-27",
				4
			],
			[
				"2002-04-24",
				24.61
			],
			[
				"2001-04-10",
				22.01
			],
			[
				"2000-01-18",
				22.01
			],
			[
				"2015-10-07",
				21.01
			],
			[
				"2015-04-14",
				19.01
			],
			[
				"2014-10-09",
				23.01
			],
			[
				"2014-04-23",
				21.01
			],
			[
				"2005-04-21",
				22.41
			],
			[
				"2004-05-26",
				22.31
			],
			[
				"2003-11-20",
				25.01
			]
		],
		"118841038": [
			[
				"2003-04-08",
				1
			],
			[
				"2004-10-06",
				1
			],
			[
				"2007-04-18",
				1
			],
			[
				"2007-10-04",
				1
			],
			[
				"2010-04-07",
				1
			],
			[
				"2010-04-07",
				1
			],
			[
				"2008-05-21",
				1
			],
			[
				"2008-10-08",
				1
			],
			[
				"2009-06-17",
				1
			],
			[
				"2009-11-11",
				1
			],
			[
				"2010-10-05",
				1
			],
			[
				"2011-04-20",
				1
			],
			[
				"2011-10-25",
				1
			],
			[
				"2013-04-03",
				1
			],
			[
				"2012-05-22",
				1
			],
			[
				"2012-10-15",
				1
			],
			[
				"2013-10-10",
				1
			],
			[
				"2014-10-14",
				1
			],
			[
				"2014-04-29",
				1
			],
			[
				"2015-04-23",
				1
			],
			[
				"2015-10-27",
				1
			]
		],
		"119011049": [
			[
				"2014-11-10",
				1.33
			],
			[
				"2015-12-09",
				1.33
			],
			[
				"2000-07-11",
				0.22
			],
			[
				"2000-11-27",
				0.22
			],
			[
				"2001-06-28",
				1.06
			],
			[
				"2001-11-20",
				1.02
			],
			[
				"2002-06-11",
				1.37
			],
			[
				"2002-12-05",
				1.11
			],
			[
				"2003-04-10",
				1.46
			],
			[
				"2003-10-30",
				0.22
			],
			[
				"2004-06-03",
				0.22
			],
			[
				"2004-11-18",
				0.22
			],
			[
				"2005-06-21",
				0.4
			],
			[
				"2006-09-11",
				0.22
			],
			[
				"2007-09-03",
				0.22
			],
			[
				"2005-11-18",
				0.22
			],
			[
				"2008-07-30",
				0.22
			],
			[
				"2009-08-07",
				4.43
			],
			[
				"2010-09-03",
				4.43
			],
			[
				"2011-11-17",
				4.43
			],
			[
				"2012-06-29",
				1.33
			]
		],
		"129660024": [
			[
				"2008-05-21",
				19.01
			],
			[
				"2008-11-19",
				18.01
			],
			[
				"2009-08-11",
				18.01
			],
			[
				"2013-08-27",
				18.6
			],
			[
				"2014-07-23",
				16.61
			],
			[
				"2015-08-03",
				16.61
			],
			[
				"2000-10-25",
				18.16
			],
			[
				"2001-08-22",
				18.6
			],
			[
				"2002-09-25",
				17.71
			],
			[
				"2003-09-15",
				19.93
			],
			[
				"2004-05-28",
				18.6
			],
			[
				"2005-06-02",
				19.04
			],
			[
				"2005-07-20",
				18.6
			],
			[
				"2002-04-17",
				20.01
			],
			[
				"2002-07-17",
				20.01
			],
			[
				"2003-05-28",
				19.01
			],
			[
				"2003-11-26",
				19.01
			],
			[
				"2004-05-26",
				19.01
			],
			[
				"2005-05-25",
				21.01
			],
			[
				"2001-07-17",
				20.01
			],
			[
				"2001-10-17",
				19.01
			],
			[
				"2000-07-18",
				21.01
			],
			[
				"2001-01-17",
				20.01
			],
			[
				"2000-10-11",
				20.01
			],
			[
				"2000-04-03",
				21.01
			],
			[
				"2000-01-19",
				20.01
			],
			[
				"2006-08-23",
				18.16
			],
			[
				"2006-05-24",
				19.01
			],
			[
				"2006-10-02",
				19.01
			],
			[
				"2005-07-05",
				22.01
			],
			[
				"2005-11-22",
				18.01
			],
			[
				"2007-07-26",
				18.6
			],
			[
				"2008-06-18",
				18.6
			],
			[
				"2010-05-26",
				19.01
			],
			[
				"2011-05-04",
				19.01
			],
			[
				"2011-11-03",
				18.01
			],
			[
				"2012-05-30",
				19.01
			],
			[
				"2013-05-22",
				18.01
			],
			[
				"2013-11-13",
				18.01
			],
			[
				"2014-06-03",
				17.01
			],
			[
				"2014-11-13",
				16.01
			],
			[
				"2015-11-25",
				17.01
			],
			[
				"2009-07-30",
				19.04
			],
			[
				"2010-06-22",
				17.27
			],
			[
				"2011-05-09",
				18.6
			],
			[
				"2012-08-02",
				18.6
			]
		],
		"129660048": [
			[
				"2013-07-03",
				11.96
			],
			[
				"2014-07-23",
				17.89
			],
			[
				"2015-04-27",
				7.62
			],
			[
				"2002-08-27",
				2.21
			],
			[
				"2003-05-16",
				2.21
			],
			[
				"2004-03-16",
				6.2
			],
			[
				"2005-03-11",
				7.09
			],
			[
				"2006-08-02",
				3.99
			],
			[
				"2007-06-25",
				7.53
			],
			[
				"2008-06-12",
				6.2
			],
			[
				"2009-09-21",
				6.64
			],
			[
				"2010-06-23",
				7.97
			],
			[
				"2011-05-09",
				7.97
			],
			[
				"2012-08-02",
				8.86
			]
		],
		"129660050": [
			[
				"2008-05-07",
				16.01
			],
			[
				"2008-11-05",
				22.01
			],
			[
				"2009-05-12",
				22.01
			],
			[
				"2009-11-04",
				22.01
			],
			[
				"2013-07-03",
				21.7
			],
			[
				"2014-08-14",
				18.87
			],
			[
				"2015-07-08",
				20.95
			],
			[
				"2000-11-02",
				24.36
			],
			[
				"2001-08-22",
				24.36
			],
			[
				"2002-09-30",
				24.36
			],
			[
				"2003-09-15",
				24.8
			],
			[
				"2004-03-17",
				24.36
			],
			[
				"2005-05-02",
				24.8
			],
			[
				"2002-04-17",
				28.01
			],
			[
				"2002-11-20",
				24.01
			],
			[
				"2003-05-09",
				26.01
			],
			[
				"2003-11-24",
				23.01
			],
			[
				"2004-05-12",
				26.01
			],
			[
				"2004-11-24",
				25.01
			],
			[
				"2001-04-12",
				26.01
			],
			[
				"2000-11-16",
				26.01
			],
			[
				"2000-05-11",
				26.01
			],
			[
				"2006-08-03",
				22.59
			],
			[
				"2006-11-08",
				23.01
			],
			[
				"2006-05-04",
				25.01
			],
			[
				"2005-05-11",
				28.01
			],
			[
				"2005-11-17",
				24.01
			],
			[
				"2007-09-20",
				24.36
			],
			[
				"2008-07-02",
				25.69
			],
			[
				"2010-05-12",
				21.01
			],
			[
				"2010-11-10",
				22.01
			],
			[
				"2011-05-30",
				22.01
			],
			[
				"2012-01-25",
				22.01
			],
			[
				"2012-05-16",
				22.01
			],
			[
				"2012-11-07",
				21.01
			],
			[
				"2013-05-02",
				22.01
			],
			[
				"2013-11-06",
				22.01
			],
			[
				"2014-05-07",
				21.01
			],
			[
				"2014-11-05",
				22.01
			],
			[
				"2015-05-08",
				21.01
			],
			[
				"2015-11-11",
				21.01
			],
			[
				"2009-08-06",
				20.37
			],
			[
				"2010-06-23",
				23.91
			],
			[
				"2011-05-09",
				23.03
			],
			[
				"2012-08-02",
				22.14
			]
		],
		"129660073": [
			[
				"2013-07-01",
				6.51
			],
			[
				"2014-07-14",
				6.47
			],
			[
				"2015-04-21",
				6.95
			],
			[
				"2000-08-08",
				7.09
			],
			[
				"2001-09-06",
				6.2
			],
			[
				"2002-09-16",
				6.2
			],
			[
				"2003-11-26",
				7.09
			],
			[
				"2004-03-17",
				8.86
			],
			[
				"2005-06-02",
				8.86
			],
			[
				"2006-12-08",
				11.96
			],
			[
				"2007-06-25",
				12.4
			],
			[
				"2008-09-19",
				10.19
			],
			[
				"2009-08-17",
				8.86
			],
			[
				"2010-05-31",
				7.97
			],
			[
				"2011-09-06",
				7.53
			],
			[
				"2012-08-03",
				8.86
			]
		],
		"129660097": [
			[
				"2013-08-26",
				6.69
			],
			[
				"2014-09-29",
				5.93
			],
			[
				"2015-05-04",
				7.04
			],
			[
				"2000-12-05",
				7.09
			],
			[
				"2001-11-07",
				6.64
			],
			[
				"2002-08-29",
				6.64
			],
			[
				"2003-12-17",
				9.74
			],
			[
				"2004-05-27",
				8.86
			],
			[
				"2005-06-14",
				7.97
			],
			[
				"2006-07-14",
				7.09
			],
			[
				"2007-08-31",
				9.3
			],
			[
				"2008-07-23",
				5.76
			],
			[
				"2009-08-17",
				7.09
			],
			[
				"2010-07-06",
				6.64
			],
			[
				"2011-09-01",
				7.53
			],
			[
				"2012-08-01",
				7.53
			]
		],
		"129660103": [
			[
				"2013-07-02",
				11.03
			],
			[
				"2014-07-16",
				12.13
			],
			[
				"2015-05-11",
				9.26
			],
			[
				"2000-11-10",
				9.74
			],
			[
				"2001-09-20",
				10.63
			],
			[
				"2002-08-29",
				9.74
			],
			[
				"2003-09-18",
				7.53
			],
			[
				"2004-05-27",
				11.51
			],
			[
				"2005-04-04",
				12.4
			],
			[
				"2006-08-18",
				12.4
			],
			[
				"2007-07-18",
				11.96
			],
			[
				"2008-01-28",
				14.17
			],
			[
				"2009-08-11",
				11.96
			],
			[
				"2010-06-30",
				11.51
			],
			[
				"2011-09-01",
				13.29
			],
			[
				"2012-08-01",
				11.96
			]
		],
		"129660139": [
			[
				"2013-07-31",
				1.42
			],
			[
				"2014-07-14",
				1.33
			],
			[
				"2015-04-27",
				1.33
			],
			[
				"2000-10-16",
				2.21
			],
			[
				"2001-06-11",
				2.21
			],
			[
				"2002-09-16",
				2.21
			],
			[
				"2003-10-08",
				2.66
			],
			[
				"2004-03-17",
				2.21
			],
			[
				"2005-03-11",
				2.21
			],
			[
				"2006-07-14",
				2.21
			],
			[
				"2007-07-25",
				2.21
			],
			[
				"2008-06-23",
				2.21
			],
			[
				"2009-06-18",
				4.43
			],
			[
				"2010-05-31",
				4.43
			],
			[
				"2011-05-02",
				4.43
			],
			[
				"2012-07-30",
				1.33
			]
		],
		"129660176": [
			[
				"2014-10-27",
				21.26
			],
			[
				"2015-08-05",
				19.97
			],
			[
				"2000-09-27",
				17.71
			],
			[
				"2001-05-07",
				18.6
			],
			[
				"2001-11-02",
				20.81
			],
			[
				"2002-09-11",
				20.81
			],
			[
				"2003-09-24",
				19.93
			],
			[
				"2004-05-24",
				21.26
			],
			[
				"2004-10-14",
				20.37
			],
			[
				"2005-04-28",
				19.49
			],
			[
				"2005-09-23",
				19.93
			],
			[
				"2006-10-19",
				19.04
			],
			[
				"2007-09-20",
				16.83
			],
			[
				"2007-11-20",
				20.37
			],
			[
				"2008-05-05",
				17.27
			],
			[
				"2008-09-11",
				18.6
			],
			[
				"2006-05-16",
				19.04
			],
			[
				"2009-08-12",
				18.6
			],
			[
				"2010-06-24",
				18.6
			],
			[
				"2011-10-26",
				17.27
			]
		],
		"129660188": [
			[
				"2013-07-03",
				29.54
			],
			[
				"2014-07-23",
				28.12
			],
			[
				"2015-08-17",
				27.86
			],
			[
				"2000-10-25",
				26.57
			],
			[
				"2001-10-29",
				29.23
			],
			[
				"2002-09-25",
				26.13
			],
			[
				"2003-09-29",
				27.9
			],
			[
				"2004-10-07",
				30.11
			],
			[
				"2005-04-25",
				30.56
			],
			[
				"2006-09-15",
				27.9
			],
			[
				"2007-09-21",
				30.11
			],
			[
				"2008-07-02",
				29.23
			],
			[
				"2009-08-17",
				28.79
			],
			[
				"2010-06-23",
				28.79
			],
			[
				"2011-09-29",
				28.79
			]
		],
		"129660190": [
			[
				"2014-11-11",
				16.39
			],
			[
				"2015-07-20",
				18.73
			],
			[
				"2001-09-27",
				15.06
			],
			[
				"2004-10-18",
				16.83
			],
			[
				"2005-04-25",
				14.61
			],
			[
				"2006-09-20",
				16.39
			],
			[
				"2007-09-18",
				18.16
			],
			[
				"2008-07-14",
				15.06
			],
			[
				"2002-09-30",
				2.21
			],
			[
				"2009-08-06",
				18.6
			],
			[
				"2010-07-06",
				18.6
			],
			[
				"2011-09-07",
				12.84
			]
		],
		"129660206": [
			[
				"2014-08-27",
				15.72
			],
			[
				"2015-07-15",
				13.2
			],
			[
				"2000-09-26",
				36.31
			],
			[
				"2001-05-09",
				33.21
			],
			[
				"2001-11-07",
				32.33
			],
			[
				"2002-09-10",
				35.87
			],
			[
				"2003-09-25",
				33.66
			],
			[
				"2004-05-25",
				28.34
			],
			[
				"2004-10-11",
				26.13
			],
			[
				"2005-06-14",
				23.03
			],
			[
				"2005-09-22",
				24.36
			],
			[
				"2006-09-11",
				20.81
			],
			[
				"2006-10-19",
				22.59
			],
			[
				"2007-09-19",
				16.83
			],
			[
				"2007-10-17",
				17.27
			],
			[
				"2008-06-18",
				16.83
			],
			[
				"2008-09-12",
				18.16
			],
			[
				"2009-07-30",
				19.04
			],
			[
				"2010-06-22",
				16.83
			],
			[
				"2011-09-29",
				21.26
			]
		],
		"129660220": [
			[
				"2013-08-27",
				16.3
			],
			[
				"2014-08-28",
				12
			],
			[
				"2015-08-17",
				12.84
			],
			[
				"2000-09-26",
				11.07
			],
			[
				"2001-05-09",
				12.84
			],
			[
				"2001-11-02",
				11.96
			],
			[
				"2002-09-10",
				15.5
			],
			[
				"2003-09-22",
				15.94
			],
			[
				"2004-05-24",
				13.29
			],
			[
				"2004-10-26",
				12.4
			],
			[
				"2005-04-26",
				13.73
			],
			[
				"2005-09-19",
				13.29
			],
			[
				"2006-09-20",
				14.17
			],
			[
				"2007-08-21",
				13.73
			],
			[
				"2007-11-20",
				14.17
			],
			[
				"2008-05-05",
				14.61
			],
			[
				"2008-09-11",
				15.06
			],
			[
				"2006-05-16",
				14.17
			],
			[
				"2009-07-29",
				15.5
			],
			[
				"2010-05-20",
				13.29
			],
			[
				"2011-09-07",
				12.84
			]
		],
		"129660231": [
			[
				"2013-07-02",
				14.75
			],
			[
				"2014-07-16",
				19.13
			],
			[
				"2015-05-11",
				12.13
			],
			[
				"2006-09-05",
				11.51
			],
			[
				"2007-07-27",
				14.17
			],
			[
				"2008-07-23",
				8.86
			],
			[
				"2009-08-11",
				11.07
			],
			[
				"2010-06-30",
				9.3
			],
			[
				"2011-05-13",
				8.86
			],
			[
				"2012-08-03",
				14.17
			]
		],
		"129660255": [
			[
				"2013-07-02",
				9.65
			],
			[
				"2014-07-16",
				10.14
			],
			[
				"2015-05-11",
				8.24
			],
			[
				"2006-09-05",
				9.3
			],
			[
				"2007-07-27",
				9.3
			],
			[
				"2008-07-23",
				7.53
			],
			[
				"2009-08-11",
				8.41
			],
			[
				"2010-06-30",
				8.41
			],
			[
				"2011-05-13",
				7.09
			],
			[
				"2012-08-03",
				10.63
			]
		],
		"129660279": [
			[
				"2013-07-01",
				31.35
			],
			[
				"2014-11-13",
				28.17
			],
			[
				"2015-07-21",
				29.01
			],
			[
				"2000-12-05",
				34.1
			],
			[
				"2001-10-29",
				32.33
			],
			[
				"2002-09-11",
				32.77
			],
			[
				"2003-09-22",
				32.33
			],
			[
				"2004-10-07",
				32.33
			],
			[
				"2005-04-26",
				32.77
			],
			[
				"2006-09-15",
				31
			],
			[
				"2007-08-21",
				25.69
			],
			[
				"2008-07-22",
				29.67
			],
			[
				"2009-07-29",
				29.23
			],
			[
				"2010-05-20",
				28.34
			],
			[
				"2011-09-28",
				27.46
			]
		],
		"129660553": [
			[
				"2013-08-26",
				8.5
			],
			[
				"2014-09-29",
				8.24
			],
			[
				"2015-10-13",
				9.52
			],
			[
				"2006-09-05",
				8.86
			],
			[
				"2007-07-27",
				8.41
			],
			[
				"2008-06-12",
				7.97
			],
			[
				"2009-08-12",
				7.97
			],
			[
				"2010-06-24",
				8.86
			],
			[
				"2011-05-13",
				7.53
			],
			[
				"2012-08-01",
				8.41
			]
		],
		"129660577": [
			[
				"2013-08-27",
				18.11
			],
			[
				"2014-07-21",
				15.46
			],
			[
				"2015-10-14",
				16.96
			],
			[
				"2006-09-07",
				18.16
			],
			[
				"2007-05-03",
				15.5
			],
			[
				"2008-06-30",
				17.27
			],
			[
				"2009-08-19",
				16.83
			],
			[
				"2010-07-30",
				16.83
			],
			[
				"2011-09-01",
				11.96
			]
		],
		"129660589": [
			[
				"2013-07-31",
				1.33
			],
			[
				"2014-07-21",
				1.33
			],
			[
				"2015-04-21",
				1.33
			],
			[
				"2006-09-06",
				2.21
			],
			[
				"2007-07-25",
				2.21
			],
			[
				"2008-06-30",
				2.21
			],
			[
				"2009-06-18",
				4.43
			],
			[
				"2010-05-31",
				4.43
			],
			[
				"2011-05-02",
				4.43
			],
			[
				"2012-07-30",
				1.33
			]
		],
		"129660590": [
			[
				"2013-07-31",
				11.38
			],
			[
				"2014-07-21",
				10.14
			],
			[
				"2015-04-21",
				10.54
			],
			[
				"2006-09-06",
				9.74
			],
			[
				"2007-07-25",
				11.07
			],
			[
				"2008-06-26",
				10.63
			],
			[
				"2009-08-19",
				14.61
			],
			[
				"2010-07-30",
				11.07
			],
			[
				"2011-05-02",
				12.84
			],
			[
				"2012-07-30",
				13.73
			]
		],
		"129661004": [
			[
				"2013-08-26",
				13.37
			],
			[
				"2014-09-29",
				11.2
			],
			[
				"2015-07-08",
				11.2
			],
			[
				"2006-09-07",
				14.17
			],
			[
				"2007-06-27",
				15.5
			],
			[
				"2008-06-23",
				15.5
			],
			[
				"2009-06-18",
				15.94
			],
			[
				"2010-07-20",
				12.84
			],
			[
				"2011-05-09",
				15.5
			],
			[
				"2012-08-09",
				12.84
			]
		],
		"129700022": [
			[
				"2013-07-23",
				6.24
			],
			[
				"2014-03-13",
				1.33
			],
			[
				"2015-05-04",
				3.76
			],
			[
				"2000-10-18",
				3.99
			],
			[
				"2001-09-20",
				3.1
			],
			[
				"2003-09-18",
				3.99
			],
			[
				"2004-04-02",
				4.43
			],
			[
				"2005-06-28",
				4.87
			],
			[
				"2007-06-26",
				4.43
			],
			[
				"2008-06-10",
				5.76
			],
			[
				"2002-10-08",
				3.99
			],
			[
				"2006-08-01",
				3.1
			],
			[
				"2009-07-22",
				7.09
			],
			[
				"2010-07-01",
				7.53
			],
			[
				"2011-04-26",
				7.97
			],
			[
				"2012-07-18",
				4.43
			]
		],
		"129700034": [
			[
				"2007-04-16",
				17.01
			],
			[
				"2008-06-09",
				17.01
			],
			[
				"2009-01-26",
				16.01
			],
			[
				"2013-07-22",
				16.43
			],
			[
				"2014-03-10",
				17.63
			],
			[
				"2015-04-14",
				17.49
			],
			[
				"2000-11-08",
				14.17
			],
			[
				"2001-09-04",
				15.94
			],
			[
				"2002-09-26",
				15.06
			],
			[
				"2003-09-17",
				9.74
			],
			[
				"2004-09-24",
				9.3
			],
			[
				"2005-03-10",
				16.39
			],
			[
				"2005-08-22",
				13
			],
			[
				"2006-07-14",
				6.2
			],
			[
				"2006-08-24",
				13.29
			],
			[
				"2002-11-11",
				13
			],
			[
				"2000-08-15",
				18.01
			],
			[
				"2001-07-30",
				19.01
			],
			[
				"2007-08-23",
				11.51
			],
			[
				"2008-07-17",
				15.06
			],
			[
				"2009-09-18",
				13.73
			],
			[
				"2010-07-30",
				15.5
			],
			[
				"2011-08-18",
				14.17
			],
			[
				"2012-08-07",
				15.5
			]
		],
		"129700058": [
			[
				"2013-07-24",
				6.29
			],
			[
				"2014-03-11",
				5.85
			],
			[
				"2015-04-28",
				4.33
			],
			[
				"2000-11-08",
				6.64
			],
			[
				"2001-08-29",
				6.64
			],
			[
				"2002-10-01",
				7.09
			],
			[
				"2003-09-16",
				8.41
			],
			[
				"2004-03-29",
				9.3
			],
			[
				"2005-06-29",
				7.09
			],
			[
				"2006-08-21",
				11.51
			],
			[
				"2007-08-22",
				5.31
			],
			[
				"2008-04-28",
				7.53
			],
			[
				"2009-06-26",
				9.3
			],
			[
				"2010-07-12",
				5.76
			],
			[
				"2011-05-10",
				4.43
			],
			[
				"2012-07-16",
				2.21
			]
		],
		"129700071": [
			[
				"2013-07-25",
				3.83
			],
			[
				"2014-03-24",
				27.9
			],
			[
				"2015-04-13",
				22.59
			],
			[
				"2000-10-31",
				18.16
			],
			[
				"2001-10-31",
				19.49
			],
			[
				"2002-09-24",
				15.5
			],
			[
				"2003-09-16",
				18.16
			],
			[
				"2004-03-22",
				27.46
			],
			[
				"2005-06-30",
				13.73
			],
			[
				"2006-04-25",
				18.6
			],
			[
				"2007-08-22",
				24.8
			],
			[
				"2008-07-04",
				17.71
			],
			[
				"2009-09-17",
				4.87
			],
			[
				"2010-06-01",
				5.31
			],
			[
				"2011-04-28",
				4.87
			],
			[
				"2012-07-17",
				4.43
			]
		],
		"129700083": [
			[
				"2013-07-30",
				3.1
			],
			[
				"2014-03-05",
				3.61
			],
			[
				"2015-03-31",
				5.05
			],
			[
				"2000-11-08",
				5.76
			],
			[
				"2001-08-29",
				5.76
			],
			[
				"2002-10-01",
				5.76
			],
			[
				"2003-10-06",
				6.64
			],
			[
				"2004-04-01",
				7.09
			],
			[
				"2005-05-04",
				5.76
			],
			[
				"2006-08-04",
				5.76
			],
			[
				"2007-06-28",
				5.31
			],
			[
				"2008-06-11",
				3.99
			],
			[
				"2009-08-07",
				4.43
			],
			[
				"2010-07-02",
				4.43
			],
			[
				"2011-05-12",
				4.43
			],
			[
				"2012-07-18",
				5.31
			]
		],
		"129700125": [
			[
				"2013-07-16",
				13.73
			],
			[
				"2014-03-06",
				15.41
			],
			[
				"2015-04-15",
				14.48
			],
			[
				"2000-09-20",
				10.63
			],
			[
				"2001-09-04",
				12.4
			],
			[
				"2002-09-26",
				3.1
			],
			[
				"2003-05-19",
				7.53
			],
			[
				"2004-04-02",
				10.19
			],
			[
				"2005-03-10",
				12.4
			],
			[
				"2006-08-24",
				15.5
			],
			[
				"2007-07-24",
				13.73
			],
			[
				"2008-07-14",
				12.84
			],
			[
				"2009-09-21",
				13.73
			],
			[
				"2010-07-19",
				14.61
			],
			[
				"2011-05-11",
				14.17
			],
			[
				"2012-08-07",
				14.17
			]
		],
		"129700186": [
			[
				"2013-07-30",
				1.53
			],
			[
				"2014-03-11",
				2.9
			],
			[
				"2015-10-27",
				2.91
			],
			[
				"2001-10-31",
				2.66
			],
			[
				"2002-09-24",
				2.66
			],
			[
				"2003-11-26",
				2.66
			],
			[
				"2004-04-01",
				3.54
			],
			[
				"2005-07-06",
				2.66
			],
			[
				"2006-08-25",
				2.66
			],
			[
				"2007-06-28",
				8.41
			],
			[
				"2008-06-11",
				8.41
			],
			[
				"2010-07-02",
				4.43
			],
			[
				"2011-05-12",
				4.43
			],
			[
				"2012-08-07",
				3.1
			]
		],
		"129700198": [
			[
				"2013-07-16",
				9.3
			],
			[
				"2014-07-24",
				7.31
			],
			[
				"2015-07-08",
				6.91
			],
			[
				"2000-09-26",
				6.2
			],
			[
				"2001-05-07",
				6.64
			],
			[
				"2001-10-30",
				7.09
			],
			[
				"2002-09-10",
				6.2
			],
			[
				"2003-09-24",
				5.31
			],
			[
				"2004-03-29",
				6.64
			],
			[
				"2004-05-25",
				7.09
			],
			[
				"2005-06-21",
				10.19
			],
			[
				"2005-09-19",
				7.53
			],
			[
				"2006-04-27",
				9.3
			],
			[
				"2006-10-20",
				8.41
			],
			[
				"2007-06-05",
				8.86
			],
			[
				"2007-09-28",
				9.74
			],
			[
				"2008-04-03",
				9.74
			],
			[
				"2008-09-19",
				9.74
			],
			[
				"2009-09-18",
				11.96
			],
			[
				"2010-07-20",
				10.19
			],
			[
				"2011-09-06",
				13.29
			],
			[
				"2012-08-09",
				11.07
			]
		],
		"129700216": [
			[
				"2013-07-16",
				1.33
			],
			[
				"2014-07-24",
				1.33
			],
			[
				"2015-10-12",
				1.33
			],
			[
				"2000-12-06",
				2.21
			],
			[
				"2001-09-06",
				2.21
			],
			[
				"2002-10-01",
				2.21
			],
			[
				"2003-09-17",
				2.21
			],
			[
				"2004-03-24",
				2.21
			],
			[
				"2005-06-21",
				2.21
			],
			[
				"2006-10-20",
				2.21
			],
			[
				"2007-06-05",
				2.21
			],
			[
				"2008-09-19",
				2.21
			],
			[
				"2006-04-27",
				2.21
			],
			[
				"2009-09-18",
				4.43
			],
			[
				"2010-07-20",
				4.43
			],
			[
				"2011-09-06",
				4.43
			],
			[
				"2012-08-09",
				1.33
			]
		],
		"129700230": [
			[
				"2013-07-15",
				9.88
			],
			[
				"2014-03-05",
				10.45
			],
			[
				"2015-03-31",
				9.57
			],
			[
				"2001-08-29",
				8.41
			],
			[
				"2002-09-16",
				9.74
			],
			[
				"2003-05-19",
				10.19
			],
			[
				"2004-04-02",
				12.84
			],
			[
				"2005-06-28",
				12.84
			],
			[
				"2006-08-01",
				12.4
			],
			[
				"2007-06-26",
				15.94
			],
			[
				"2008-06-10",
				15.94
			],
			[
				"2009-07-22",
				14.61
			],
			[
				"2010-07-19",
				11.96
			],
			[
				"2011-04-26",
				12.4
			],
			[
				"2012-07-27",
				10.19
			]
		],
		"129700241": [
			[
				"2013-07-17",
				1.33
			],
			[
				"2014-03-04",
				1.33
			],
			[
				"2015-04-07",
				1.33
			],
			[
				"2000-10-31",
				2.21
			],
			[
				"2001-10-31",
				2.21
			],
			[
				"2002-09-24",
				2.21
			],
			[
				"2003-09-16",
				2.21
			],
			[
				"2004-06-01",
				2.21
			],
			[
				"2005-05-04",
				2.21
			],
			[
				"2006-08-04",
				2.21
			],
			[
				"2007-08-20",
				2.21
			],
			[
				"2008-07-18",
				2.21
			],
			[
				"2009-09-17",
				4.43
			],
			[
				"2010-06-01",
				4.43
			],
			[
				"2011-08-18",
				4.43
			],
			[
				"2012-07-27",
				1.33
			]
		],
		"129700289": [
			[
				"2013-07-29",
				10.1
			],
			[
				"2014-03-13",
				10.63
			],
			[
				"2015-04-15",
				9.39
			],
			[
				"2006-09-12",
				7.09
			],
			[
				"2007-05-15",
				8.41
			],
			[
				"2008-07-18",
				8.86
			],
			[
				"2009-06-19",
				11.07
			],
			[
				"2010-06-02",
				9.74
			],
			[
				"2011-04-27",
				10.63
			],
			[
				"2012-07-26",
				11.51
			]
		],
		"129700290": [
			[
				"2013-07-23",
				10.58
			],
			[
				"2014-03-05",
				11.2
			],
			[
				"2015-03-31",
				9.79
			],
			[
				"2006-09-14",
				8.86
			],
			[
				"2007-06-29",
				11.96
			],
			[
				"2008-06-10",
				12.4
			],
			[
				"2009-08-07",
				12.84
			],
			[
				"2010-07-01",
				12.4
			],
			[
				"2011-04-26",
				12.4
			],
			[
				"2012-07-18",
				11.96
			]
		],
		"129700307": [
			[
				"2013-07-22",
				1.33
			],
			[
				"2014-03-10",
				1.84
			],
			[
				"2015-04-14",
				2.79
			],
			[
				"2006-09-18",
				2.21
			],
			[
				"2007-06-05",
				3.99
			],
			[
				"2008-07-03",
				2.21
			],
			[
				"2009-06-19",
				4.43
			],
			[
				"2010-06-02",
				4.43
			],
			[
				"2011-04-27",
				4.43
			],
			[
				"2012-07-27",
				1.33
			]
		],
		"129700319": [
			[
				"2013-07-17",
				7.75
			],
			[
				"2014-03-04",
				6.16
			],
			[
				"2015-04-28",
				5.71
			],
			[
				"2006-09-14",
				7.09
			],
			[
				"2007-06-29",
				6.64
			],
			[
				"2008-07-04",
				8.86
			],
			[
				"2009-09-22",
				12.84
			],
			[
				"2010-07-23",
				7.97
			],
			[
				"2011-05-12",
				7.09
			],
			[
				"2012-09-18",
				7.09
			]
		],
		"129700320": [
			[
				"2013-11-05",
				6.16
			],
			[
				"2014-03-20",
				6.16
			],
			[
				"2015-04-07",
				3.72
			],
			[
				"2007-03-01",
				4.87
			],
			[
				"2009-11-24",
				6.64
			],
			[
				"2011-12-19",
				4.87
			],
			[
				"2012-07-17",
				2.21
			]
		],
		"129700514": [
			[
				"2013-07-23",
				11.56
			],
			[
				"2014-08-11",
				12.89
			],
			[
				"2015-08-26",
				10.41
			],
			[
				"2002-10-08",
				11.07
			],
			[
				"2003-05-19",
				12.4
			],
			[
				"2004-10-08",
				15.06
			],
			[
				"2005-10-19",
				14.17
			],
			[
				"2006-08-23",
				12.4
			],
			[
				"2007-08-20",
				11.96
			],
			[
				"2008-04-03",
				11.96
			],
			[
				"2009-07-22",
				13.73
			],
			[
				"2010-07-01",
				14.17
			],
			[
				"2011-08-18",
				8.86
			]
		],
		"129700710": [
			[
				"2013-07-15",
				9.08
			],
			[
				"2014-08-25",
				8.46
			],
			[
				"2014-03-06",
				14.22
			],
			[
				"2015-08-26",
				8.33
			],
			[
				"2001-09-04",
				10.19
			],
			[
				"2002-09-16",
				9.3
			],
			[
				"2003-05-19",
				9.3
			],
			[
				"2004-10-08",
				11.07
			],
			[
				"2005-03-10",
				15.06
			],
			[
				"2006-08-24",
				11.07
			],
			[
				"2007-07-24",
				11.07
			],
			[
				"2008-04-03",
				16.39
			],
			[
				"2009-09-21",
				11.51
			],
			[
				"2010-07-19",
				11.96
			],
			[
				"2011-04-27",
				16.39
			],
			[
				"2012-07-26",
				10.63
			]
		],
		"129700733": [
			[
				"2013-07-22",
				8.15
			],
			[
				"2014-03-10",
				8.77
			],
			[
				"2015-04-14",
				9.43
			],
			[
				"2004-03-24",
				10.19
			],
			[
				"2005-03-22",
				10.19
			],
			[
				"2006-09-11",
				8.41
			],
			[
				"2007-05-15",
				7.97
			],
			[
				"2008-07-03",
				7.97
			],
			[
				"2010-07-02",
				7.09
			],
			[
				"2011-05-11",
				7.53
			],
			[
				"2012-08-13",
				7.97
			]
		],
		"129700757": [
			[
				"2013-07-24",
				4.52
			],
			[
				"2014-03-24",
				5.8
			],
			[
				"2015-04-13",
				7.48
			],
			[
				"2004-03-22",
				6.2
			],
			[
				"2005-06-29",
				4.87
			],
			[
				"2006-04-25",
				7.09
			],
			[
				"2007-03-01",
				9.3
			],
			[
				"2008-05-20",
				7.53
			],
			[
				"2009-09-22",
				6.2
			],
			[
				"2010-07-12",
				4.43
			],
			[
				"2011-05-10",
				5.31
			],
			[
				"2012-08-13",
				5.76
			]
		],
		"129700770": [
			[
				"2013-07-25",
				3.74
			],
			[
				"2014-03-24",
				4.33
			],
			[
				"2015-04-13",
				5.54
			],
			[
				"2004-03-22",
				4.87
			],
			[
				"2005-06-30",
				3.99
			],
			[
				"2006-04-25",
				6.64
			],
			[
				"2007-09-28",
				4.87
			],
			[
				"2008-07-04",
				4.87
			],
			[
				"2009-09-17",
				4.43
			],
			[
				"2010-06-01",
				4.87
			],
			[
				"2011-04-28",
				4.87
			],
			[
				"2012-07-17",
				3.1
			]
		],
		"129700782": [
			[
				"2013-07-30",
				5.58
			],
			[
				"2014-10-07",
				5.4
			],
			[
				"2015-10-13",
				6.38
			],
			[
				"2007-07-23",
				7.09
			],
			[
				"2005-10-17",
				4.87
			],
			[
				"2008-03-18",
				6.2
			],
			[
				"2006-05-22",
				6.2
			],
			[
				"2009-07-20",
				6.2
			],
			[
				"2010-05-04",
				5.76
			],
			[
				"2011-08-11",
				7.53
			]
		],
		"129700812": [
			[
				"2013-07-18",
				9.83
			],
			[
				"2014-03-11",
				12.8
			],
			[
				"2015-04-15",
				14.17
			],
			[
				"2008-07-17",
				10.63
			],
			[
				"2009-06-19",
				13.73
			],
			[
				"2010-06-02",
				11.96
			],
			[
				"2011-05-11",
				10.63
			],
			[
				"2012-07-26",
				12.4
			]
		],
		"210404530": [
			[
				"2010-11-16",
				56.68
			],
			[
				"2011-03-15",
				58.9
			],
			[
				"2011-06-28",
				58.9
			],
			[
				"2011-07-27",
				59.78
			],
			[
				"2011-09-19",
				60.22
			],
			[
				"2011-11-09",
				58.01
			],
			[
				"2012-03-12",
				61.55
			],
			[
				"2012-05-29",
				58.01
			],
			[
				"2012-07-16",
				60.67
			],
			[
				"2012-08-27",
				60.67
			],
			[
				"2012-11-20",
				59.34
			],
			[
				"2013-03-25",
				62.44
			],
			[
				"2013-07-29",
				63.32
			],
			[
				"2013-09-09",
				65.54
			],
			[
				"2013-11-12",
				65.98
			],
			[
				"2014-04-07",
				62
			],
			[
				"2014-04-28",
				65.54
			],
			[
				"2014-06-16",
				62.44
			],
			[
				"2014-07-22",
				62.44
			],
			[
				"2014-11-17",
				63.32
			],
			[
				"2015-03-16",
				64.21
			],
			[
				"2015-06-08",
				66.86
			],
			[
				"2015-09-14",
				66.86
			],
			[
				"2015-11-03",
				69.08
			],
			[
				"2000-03-20",
				51.42
			],
			[
				"2000-11-14",
				48.71
			],
			[
				"2000-07-18",
				53.62
			],
			[
				"2000-11-07",
				49.62
			],
			[
				"2001-01-30",
				52.22
			],
			[
				"2001-03-12",
				52.72
			],
			[
				"2001-07-12",
				55.82
			],
			[
				"2001-11-12",
				54.42
			],
			[
				"2002-03-05",
				58.02
			],
			[
				"2003-03-10",
				54.42
			],
			[
				"2003-07-14",
				60.62
			],
			[
				"2003-11-24",
				55.82
			],
			[
				"2005-04-05",
				56.22
			],
			[
				"2004-03-02",
				56.22
			],
			[
				"2004-07-06",
				54.92
			],
			[
				"2004-11-22",
				57.12
			],
			[
				"2002-10-15",
				53.59
			],
			[
				"2005-07-05",
				55.82
			],
			[
				"2005-11-03",
				54.42
			],
			[
				"2006-03-13",
				54.92
			],
			[
				"2006-07-11",
				55.82
			],
			[
				"2007-03-12",
				56.72
			],
			[
				"2007-07-11",
				57.52
			],
			[
				"2007-11-12",
				53.62
			],
			[
				"2008-07-15",
				63.32
			],
			[
				"2008-11-10",
				61.12
			],
			[
				"2008-03-04",
				55.82
			],
			[
				"2009-03-17",
				53.62
			],
			[
				"2009-07-06",
				57.12
			],
			[
				"2009-11-16",
				56.22
			],
			[
				"2010-03-08",
				53.62
			],
			[
				"2010-07-13",
				55.8
			],
			[
				"2008-09-24",
				60.67
			]
		],
		"210404553": [
			[
				"2010-08-16",
				75.73
			],
			[
				"2010-09-22",
				73.07
			],
			[
				"2010-11-16",
				77.5
			],
			[
				"2011-03-15",
				81.48
			],
			[
				"2011-06-28",
				81.04
			],
			[
				"2011-07-27",
				76.61
			],
			[
				"2011-09-19",
				80.6
			],
			[
				"2011-11-09",
				88.57
			],
			[
				"2012-03-12",
				92.99
			],
			[
				"2012-05-29",
				91.66
			],
			[
				"2012-07-16",
				85.47
			],
			[
				"2012-08-27",
				83.7
			],
			[
				"2012-11-20",
				91.22
			],
			[
				"2013-03-25",
				94.32
			],
			[
				"2013-07-29",
				84.58
			],
			[
				"2013-09-09",
				87.68
			],
			[
				"2013-11-12",
				84.58
			],
			[
				"2014-04-07",
				92.55
			],
			[
				"2014-04-28",
				91.22
			],
			[
				"2014-06-16",
				87.68
			],
			[
				"2014-07-22",
				89.89
			],
			[
				"2014-11-17",
				83.25
			],
			[
				"2015-03-16",
				82.37
			],
			[
				"2015-06-08",
				86.35
			],
			[
				"2015-09-14",
				89.89
			],
			[
				"2015-11-03",
				87.68
			],
			[
				"2000-03-20",
				63.32
			],
			[
				"2000-11-07",
				61.52
			],
			[
				"2002-03-05",
				64.22
			],
			[
				"2003-11-24",
				57.52
			],
			[
				"2005-04-05",
				66.82
			],
			[
				"2004-03-02",
				58.92
			],
			[
				"2004-07-06",
				61.12
			],
			[
				"2004-11-22",
				64.62
			],
			[
				"2005-07-05",
				66.02
			],
			[
				"2005-11-03",
				65.52
			],
			[
				"2006-03-13",
				69.12
			],
			[
				"2006-07-11",
				65.12
			],
			[
				"2007-03-12",
				72.63
			],
			[
				"2007-07-11",
				71.33
			],
			[
				"2007-11-12",
				70.83
			],
			[
				"2008-07-15",
				77.53
			],
			[
				"2008-11-10",
				73.03
			],
			[
				"2008-03-04",
				74.43
			],
			[
				"2009-03-17",
				71.33
			],
			[
				"2009-07-06",
				69.52
			],
			[
				"2009-11-16",
				65.52
			],
			[
				"2010-03-08",
				66.82
			],
			[
				"2010-07-13",
				70.86
			],
			[
				"2008-09-24",
				74.4
			]
		],
		"210404711": [
			[
				"2010-11-15",
				78.83
			],
			[
				"2011-04-04",
				78.83
			],
			[
				"2011-07-19",
				79.71
			],
			[
				"2011-11-16",
				80.6
			],
			[
				"2012-04-10",
				81.93
			],
			[
				"2012-07-25",
				77.94
			],
			[
				"2012-11-12",
				79.27
			],
			[
				"2013-10-01",
				91.43
			],
			[
				"2013-07-16",
				82.37
			],
			[
				"2013-12-16",
				78.83
			],
			[
				"2014-04-01",
				82.37
			],
			[
				"2014-07-16",
				79.27
			],
			[
				"2014-12-15",
				79.71
			],
			[
				"2015-04-28",
				80.16
			],
			[
				"2015-08-03",
				81.93
			],
			[
				"2015-11-23",
				83.25
			],
			[
				"2001-10-11",
				73.07
			],
			[
				"2000-03-20",
				78.83
			],
			[
				"2000-04-11",
				79.27
			],
			[
				"2000-06-26",
				70.86
			],
			[
				"2000-07-10",
				85.03
			],
			[
				"2000-09-18",
				77.06
			],
			[
				"2000-11-13",
				78.83
			],
			[
				"2000-11-20",
				86.36
			],
			[
				"2001-01-22",
				81.93
			],
			[
				"2001-06-11",
				70.86
			],
			[
				"2001-09-17",
				71.74
			],
			[
				"2001-11-26",
				71.3
			],
			[
				"2002-01-21",
				73.07
			],
			[
				"2002-04-29",
				88.57
			],
			[
				"2002-06-10",
				72.63
			],
			[
				"2002-07-29",
				88.13
			],
			[
				"2003-03-24",
				75.73
			],
			[
				"2003-04-03",
				79.71
			],
			[
				"2003-05-19",
				80.6
			],
			[
				"2003-07-21",
				73.96
			],
			[
				"2005-04-06",
				78.43
			],
			[
				"2004-04-13",
				80.63
			],
			[
				"2004-07-05",
				81.03
			],
			[
				"2004-11-08",
				82.83
			],
			[
				"2005-07-04",
				78.43
			],
			[
				"2006-04-10",
				80.63
			],
			[
				"2006-07-17",
				79.73
			],
			[
				"2006-10-24",
				85.91
			],
			[
				"2007-04-23",
				83.23
			],
			[
				"2007-07-09",
				83.23
			],
			[
				"2007-05-14",
				83.26
			],
			[
				"2007-11-19",
				80.13
			],
			[
				"2008-07-02",
				87.23
			],
			[
				"2008-11-25",
				80.63
			],
			[
				"2008-04-02",
				79.23
			],
			[
				"2009-04-28",
				80.13
			],
			[
				"2009-07-01",
				80.63
			],
			[
				"2009-11-23",
				81.53
			],
			[
				"2010-06-01",
				80.63
			],
			[
				"2013-04-02",
				80.6
			],
			[
				"2013-05-06",
				80.33
			]
		],
		"215988711": [
			[
				"2010-10-08",
				73.93
			],
			[
				"2011-10-17",
				71.03
			],
			[
				"2012-10-09",
				53.42
			],
			[
				"2013-10-10",
				77.73
			],
			[
				"2014-10-09",
				80.53
			],
			[
				"2015-10-13",
				76.93
			],
			[
				"2003-07-28",
				76.13
			],
			[
				"2004-04-30",
				91.63
			],
			[
				"2005-05-04",
				84.13
			],
			[
				"2006-04-10",
				87.23
			]
		],
		"216000051": [
			[
				"2012-08-21",
				0.2
			],
			[
				"2013-08-05",
				0.2
			],
			[
				"2014-08-25",
				0.2
			],
			[
				"2015-08-31",
				0.89
			]
		],
		"218086015": [
			[
				"2012-02-29",
				2.5
			],
			[
				"2015-04-08",
				2.5
			],
			[
				"2015-10-19",
				0.7
			],
			[
				"2000-09-01",
				40.61
			],
			[
				"2000-06-30",
				47.82
			],
			[
				"2000-04-27",
				46.62
			],
			[
				"2000-02-25",
				43.02
			],
			[
				"2001-08-20",
				49.32
			],
			[
				"2001-02-05",
				49.22
			],
			[
				"2002-02-20",
				49.02
			],
			[
				"2003-08-25",
				50.22
			],
			[
				"2003-02-26",
				49.22
			],
			[
				"2004-02-05",
				66.32
			],
			[
				"2005-08-26",
				9
			],
			[
				"2005-07-04",
				52.52
			],
			[
				"2006-02-08",
				48.02
			],
			[
				"2006-08-21",
				27.31
			],
			[
				"2007-02-13",
				14.71
			]
		],
		"218129415": [
			[
				"2010-10-07",
				15.81
			],
			[
				"2011-10-13",
				15.71
			],
			[
				"2012-10-12",
				15.71
			],
			[
				"2013-10-14",
				17.71
			],
			[
				"2014-10-13",
				15.51
			],
			[
				"2015-10-15",
				16.71
			]
		],
		"218149517": [
			[
				"2010-04-20",
				0.5
			],
			[
				"2010-10-06",
				0.5
			],
			[
				"2011-04-07",
				0.5
			],
			[
				"2011-10-12",
				0.7
			],
			[
				"2012-04-13",
				0.5
			],
			[
				"2012-10-11",
				0.5
			],
			[
				"2013-04-15",
				0.5
			],
			[
				"2013-10-08",
				0.5
			],
			[
				"2014-04-30",
				0.5
			],
			[
				"2014-10-07",
				0.9
			],
			[
				"2015-04-08",
				0.5
			],
			[
				"2015-10-16",
				0.5
			],
			[
				"2004-09-29",
				0.5
			],
			[
				"2000-09-22",
				0.5
			],
			[
				"2000-03-10",
				0.5
			],
			[
				"2001-09-21",
				0.5
			],
			[
				"2001-03-13",
				0.5
			],
			[
				"2002-09-03",
				0.5
			],
			[
				"2002-03-20",
				0.5
			],
			[
				"2003-09-19",
				0.5
			],
			[
				"2003-03-21",
				0.5
			],
			[
				"2004-03-19",
				0.5
			],
			[
				"2005-03-18",
				0.9
			],
			[
				"2005-09-21",
				0.5
			],
			[
				"2006-03-13",
				0.5
			],
			[
				"2006-09-20",
				0.5
			],
			[
				"2007-03-21",
				0.5
			],
			[
				"2007-10-03",
				0.5
			],
			[
				"2008-04-09",
				0.5
			],
			[
				"2008-10-15",
				0.5
			],
			[
				"2009-04-15",
				0.5
			],
			[
				"2009-10-14",
				0.5
			]
		],
		"218175917": [
			[
				"2011-10-12",
				0.5
			],
			[
				"2013-10-08",
				1.1
			],
			[
				"2014-10-07",
				0.5
			],
			[
				"2015-10-16",
				0.5
			],
			[
				"2004-09-29",
				0.5
			],
			[
				"2000-09-22",
				0.5
			],
			[
				"2000-03-31",
				0.5
			],
			[
				"2001-09-21",
				0.5
			],
			[
				"2001-03-13",
				0.5
			],
			[
				"2001-01-26",
				0.5
			],
			[
				"2002-09-03",
				0.5
			],
			[
				"2003-09-19",
				0.5
			],
			[
				"2003-03-21",
				0.5
			],
			[
				"2004-03-19",
				0.5
			],
			[
				"2005-03-18",
				2.5
			],
			[
				"2005-09-21",
				0.5
			],
			[
				"2006-03-13",
				0.5
			],
			[
				"2006-09-20",
				0.5
			],
			[
				"2007-03-21",
				0.5
			],
			[
				"2007-10-03",
				0.5
			],
			[
				"2008-04-09",
				0.5
			]
		],
		"218209319": [
			[
				"2010-10-06",
				0.6
			],
			[
				"2011-06-08",
				0.2
			],
			[
				"2011-10-12",
				0.5
			],
			[
				"2012-08-14",
				0.2
			],
			[
				"2012-10-08",
				0.5
			],
			[
				"2013-10-24",
				0.2
			],
			[
				"2013-10-07",
				0.5
			],
			[
				"2014-09-09",
				0.2
			],
			[
				"2014-10-06",
				0.6
			],
			[
				"2015-10-14",
				0.5
			],
			[
				"2015-11-09",
				0.89
			],
			[
				"2003-07-29",
				0.2
			],
			[
				"2004-03-04",
				0.2
			],
			[
				"2005-03-21",
				0.2
			],
			[
				"2006-10-19",
				0.2
			],
			[
				"2007-02-01",
				0.2
			],
			[
				"2014-08-15",
				0.13
			],
			[
				"2007-11-08",
				0.2
			],
			[
				"2008-06-19",
				0.2
			],
			[
				"2008-11-21",
				0.2
			],
			[
				"2009-05-13",
				0.2
			]
		],
		"218218618": [
			[
				"2010-10-06",
				0.5
			],
			[
				"2011-07-27",
				0.2
			],
			[
				"2011-10-12",
				0.5
			],
			[
				"2012-08-30",
				0.2
			],
			[
				"2012-10-08",
				0.5
			],
			[
				"2013-10-07",
				1.2
			],
			[
				"2014-10-06",
				0.9
			],
			[
				"2015-10-14",
				0.5
			],
			[
				"2003-05-13",
				0.2
			],
			[
				"2003-11-06",
				0.2
			],
			[
				"2004-03-05",
				0.2
			],
			[
				"2004-10-05",
				0.2
			],
			[
				"2005-03-24",
				0.2
			],
			[
				"2005-09-13",
				0.2
			],
			[
				"2006-03-13",
				0.2
			],
			[
				"2006-10-26",
				0.2
			],
			[
				"2006-12-20",
				0.2
			],
			[
				"2007-01-30",
				0.2
			],
			[
				"2007-11-08",
				0.2
			],
			[
				"2008-06-19",
				0.2
			],
			[
				"2008-11-12",
				0.2
			],
			[
				"2009-05-29",
				0.2
			]
		],
		"218219210": [
			[
				"2012-08-13",
				26.75
			],
			[
				"2013-04-25",
				26.79
			],
			[
				"2014-07-07",
				26.66
			],
			[
				"2015-07-30",
				26.62
			],
			[
				"2003-02-19",
				30.31
			],
			[
				"2004-03-03",
				32.01
			],
			[
				"2005-02-17",
				30.91
			],
			[
				"2006-02-22",
				25.81
			],
			[
				"2007-02-12",
				21.81
			],
			[
				"2007-09-04",
				21.31
			],
			[
				"2008-06-23",
				25.11
			],
			[
				"2008-09-22",
				23.81
			],
			[
				"2009-04-24",
				23.21
			],
			[
				"2010-01-28",
				21.7
			]
		],
		"218413518": [
			[
				"2010-12-16",
				53.14
			],
			[
				"2011-10-17",
				53.32
			],
			[
				"2012-07-24",
				57.57
			],
			[
				"2012-10-09",
				84.73
			],
			[
				"2013-05-23",
				65.54
			],
			[
				"2013-10-10",
				63.02
			],
			[
				"2014-09-25",
				60.22
			],
			[
				"2014-10-09",
				59.32
			],
			[
				"2015-10-13",
				62.32
			],
			[
				"2015-12-01",
				62.88
			],
			[
				"2003-05-13",
				60.22
			],
			[
				"2004-03-16",
				65.12
			],
			[
				"2005-06-09",
				65.12
			],
			[
				"2006-03-16",
				58.42
			],
			[
				"2007-02-02",
				52.72
			],
			[
				"2007-10-05",
				50.52
			],
			[
				"2008-06-24",
				49.62
			],
			[
				"2008-11-05",
				51.42
			],
			[
				"2009-02-11",
				52.72
			]
		],
		"218639016": [
			[
				"2010-10-06",
				82.93
			],
			[
				"2011-05-30",
				75.73
			],
			[
				"2011-10-12",
				81.23
			],
			[
				"2012-10-08",
				82.23
			],
			[
				"2013-07-30",
				85.02
			],
			[
				"2013-10-07",
				82.33
			],
			[
				"2014-08-29",
				80.16
			],
			[
				"2014-10-06",
				81.83
			],
			[
				"2015-07-14",
				85.02
			],
			[
				"2015-10-14",
				84.63
			],
			[
				"2006-05-22",
				74.83
			],
			[
				"2007-03-07",
				75.73
			],
			[
				"2007-08-07",
				74.43
			],
			[
				"2007-10-16",
				73.93
			],
			[
				"2008-04-23",
				72.23
			],
			[
				"2008-08-21",
				79.23
			],
			[
				"2008-11-20",
				84.13
			],
			[
				"2009-05-29",
				83.73
			]
		],
		"218642817": [
			[
				"2010-10-07",
				24.11
			],
			[
				"2011-10-18",
				34.01
			],
			[
				"2012-10-08",
				15.41
			],
			[
				"2013-10-07",
				33.21
			],
			[
				"2014-10-14",
				8.8
			],
			[
				"2015-10-14",
				31.21
			],
			[
				"2000-05-31",
				34.61
			],
			[
				"2001-12-11",
				26.91
			],
			[
				"2002-05-22",
				22.41
			],
			[
				"2003-09-17",
				15.41
			],
			[
				"2004-11-15",
				24.21
			],
			[
				"2005-06-08",
				29.01
			],
			[
				"2008-11-18",
				33.51
			]
		],
		"218643615": [
			[
				"2010-10-07",
				11.3
			],
			[
				"2011-10-18",
				15.51
			],
			[
				"2012-10-08",
				6.1
			],
			[
				"2013-10-07",
				17.91
			],
			[
				"2014-10-14",
				23.21
			],
			[
				"2015-10-14",
				24.21
			],
			[
				"2000-09-27",
				21.61
			],
			[
				"2001-09-12",
				17.01
			],
			[
				"2002-09-26",
				34.21
			],
			[
				"2003-09-02",
				31.61
			],
			[
				"2005-09-23",
				16.21
			],
			[
				"2006-09-05",
				21.91
			],
			[
				"2007-10-04",
				15.61
			],
			[
				"2008-10-14",
				24.61
			],
			[
				"2009-10-15",
				25.31
			]
		],
		"218673917": [
			[
				"2010-10-07",
				26.11
			],
			[
				"2011-10-13",
				27.11
			],
			[
				"2012-03-08",
				28.03
			],
			[
				"2012-10-12",
				29.01
			],
			[
				"2013-04-29",
				27.5
			],
			[
				"2013-10-14",
				47.22
			],
			[
				"2014-10-13",
				28.21
			],
			[
				"2015-10-15",
				29.71
			],
			[
				"2006-08-03",
				23.81
			],
			[
				"2007-02-08",
				24.01
			],
			[
				"2009-04-29",
				25.31
			]
		],
		"218676414": [
			[
				"2000-05-15",
				0.2
			],
			[
				"2001-03-28",
				0.2
			],
			[
				"2001-08-30",
				0.2
			],
			[
				"2002-03-08",
				0.2
			],
			[
				"2002-08-29",
				0.2
			],
			[
				"2003-04-16",
				0.2
			],
			[
				"2003-08-20",
				0.2
			],
			[
				"2004-03-16",
				0.2
			],
			[
				"2004-09-30",
				0.2
			],
			[
				"2005-02-15",
				0.2
			],
			[
				"2005-07-20",
				0.2
			],
			[
				"2006-01-10",
				0.2
			],
			[
				"2006-08-07",
				0.2
			],
			[
				"2007-01-10",
				0.2
			],
			[
				"2007-11-22",
				0.2
			],
			[
				"2008-07-11",
				0.2
			],
			[
				"2008-09-15",
				0.2
			],
			[
				"2009-07-10",
				0.2
			],
			[
				"2010-03-11",
				0.2
			],
			[
				"2010-10-07",
				0.5
			],
			[
				"2011-10-13",
				0.5
			],
			[
				"2012-10-12",
				0.5
			],
			[
				"2013-10-14",
				0.5
			],
			[
				"2014-10-13",
				0.5
			],
			[
				"2015-10-15",
				0.5
			]
		],
		"218677315": [
			[
				"2010-04-09",
				11.3
			],
			[
				"2011-04-14",
				10.7
			],
			[
				"2011-10-18",
				8.5
			],
			[
				"2012-04-30",
				9.2
			],
			[
				"2012-10-08",
				14.61
			],
			[
				"2013-04-30",
				15.81
			],
			[
				"2013-10-07",
				16.31
			],
			[
				"2014-05-14",
				18.31
			],
			[
				"2014-10-14",
				13.3
			],
			[
				"2015-04-09",
				18.81
			],
			[
				"2015-10-14",
				21.81
			],
			[
				"2004-09-22",
				20.71
			],
			[
				"2005-03-04",
				22.91
			],
			[
				"2000-10-04",
				39.01
			],
			[
				"2000-02-28",
				40.01
			],
			[
				"2001-09-12",
				30.51
			],
			[
				"2001-03-02",
				33.91
			],
			[
				"2002-09-26",
				30.01
			],
			[
				"2002-03-06",
				30.81
			],
			[
				"2003-08-05",
				26.61
			],
			[
				"2003-03-12",
				29.71
			],
			[
				"2004-03-04",
				25.81
			],
			[
				"2005-09-19",
				21.21
			],
			[
				"2006-03-21",
				22.71
			],
			[
				"2006-09-29",
				21.11
			],
			[
				"2007-03-07",
				20.01
			],
			[
				"2007-10-04",
				15.31
			],
			[
				"2008-04-17",
				13.9
			],
			[
				"2008-10-14",
				14
			],
			[
				"2009-03-30",
				13.3
			],
			[
				"2009-10-15",
				13.9
			]
		],
		"219078117": [
			[
				"2012-03-08",
				29.49
			],
			[
				"2013-05-03",
				27.15
			],
			[
				"2014-04-08",
				37.24
			],
			[
				"2015-07-10",
				39.54
			],
			[
				"2000-01-14",
				43.32
			],
			[
				"2001-03-13",
				41.81
			],
			[
				"2001-09-20",
				40.21
			],
			[
				"2002-02-25",
				41.41
			],
			[
				"2002-09-17",
				39.01
			],
			[
				"2003-09-25",
				32.91
			],
			[
				"2004-03-09",
				31.31
			],
			[
				"2004-10-04",
				32.41
			],
			[
				"2005-03-08",
				30.71
			],
			[
				"2005-09-12",
				30.11
			],
			[
				"2006-02-14",
				32.81
			],
			[
				"2006-08-03",
				32.31
			],
			[
				"2007-02-12",
				33.11
			],
			[
				"2007-10-18",
				33.81
			],
			[
				"2008-07-10",
				38.81
			],
			[
				"2009-06-26",
				38.31
			],
			[
				"2010-02-04",
				37.15
			]
		],
		"219080215": [
			[
				"2014-05-06",
				72.63
			],
			[
				"2015-07-07",
				95.21
			],
			[
				"2000-01-17",
				66.42
			],
			[
				"2001-03-13",
				27.91
			],
			[
				"2001-09-20",
				7.1
			],
			[
				"2002-02-25",
				10.9
			],
			[
				"2002-09-09",
				92.13
			],
			[
				"2003-05-13",
				100.04
			],
			[
				"2003-09-29",
				98.74
			],
			[
				"2004-02-25",
				37.81
			],
			[
				"2004-10-15",
				21.81
			],
			[
				"2005-02-21",
				52.22
			],
			[
				"2005-08-29",
				55.32
			],
			[
				"2006-02-15",
				77.53
			],
			[
				"2006-08-02",
				66.82
			],
			[
				"2007-02-02",
				28.61
			],
			[
				"2007-10-18",
				69.12
			],
			[
				"2008-06-23",
				84.63
			],
			[
				"2008-09-15",
				92.13
			],
			[
				"2010-03-05",
				47.39
			]
		],
		"219278519": [
			[
				"2011-06-07",
				0.2
			],
			[
				"2012-08-16",
				0.2
			],
			[
				"2013-10-22",
				0.2
			],
			[
				"2014-09-09",
				0.2
			],
			[
				"2015-11-09",
				0.89
			],
			[
				"2003-03-10",
				0.2
			],
			[
				"2004-02-20",
				0.2
			],
			[
				"2005-03-22",
				0.2
			],
			[
				"2005-07-12",
				0.2
			],
			[
				"2005-08-23",
				0.2
			],
			[
				"2005-09-15",
				0.2
			],
			[
				"2005-10-27",
				0.2
			],
			[
				"2005-11-16",
				0.2
			],
			[
				"2005-12-14",
				0.2
			],
			[
				"2006-01-16",
				0.2
			],
			[
				"2006-02-15",
				0.2
			],
			[
				"2006-03-15",
				0.2
			],
			[
				"2006-04-12",
				0.2
			],
			[
				"2006-05-15",
				0.2
			],
			[
				"2006-06-13",
				0.2
			],
			[
				"2006-07-18",
				0.2
			],
			[
				"2006-08-16",
				0.2
			],
			[
				"2006-09-14",
				0.2
			],
			[
				"2006-10-24",
				0.2
			],
			[
				"2006-11-13",
				0.2
			],
			[
				"2006-12-15",
				0.2
			],
			[
				"2007-01-22",
				0.2
			],
			[
				"2007-02-01",
				1.9
			],
			[
				"2007-02-07",
				0.2
			],
			[
				"2007-02-13",
				0.2
			],
			[
				"2007-03-14",
				0.2
			],
			[
				"2007-04-23",
				0.2
			],
			[
				"2007-05-16",
				0.2
			],
			[
				"2007-06-21",
				0.2
			],
			[
				"2007-07-23",
				0.2
			],
			[
				"2007-08-22",
				0.2
			],
			[
				"2007-10-22",
				0.2
			],
			[
				"2007-11-13",
				0.2
			],
			[
				"2007-12-06",
				0.2
			],
			[
				"2008-01-14",
				0.2
			],
			[
				"2008-02-07",
				0.2
			],
			[
				"2008-03-17",
				0.2
			],
			[
				"2008-04-11",
				0.2
			],
			[
				"2008-05-07",
				0.2
			],
			[
				"2008-06-19",
				0.2
			],
			[
				"2008-07-14",
				0.2
			],
			[
				"2008-08-28",
				0.2
			],
			[
				"2008-09-15",
				0.2
			],
			[
				"2008-10-14",
				0.2
			],
			[
				"2008-11-17",
				0.2
			],
			[
				"2008-12-11",
				0.2
			],
			[
				"2009-01-13",
				0.2
			],
			[
				"2009-02-16",
				0.2
			],
			[
				"2009-03-16",
				0.2
			],
			[
				"2009-04-14",
				0.2
			],
			[
				"2009-05-18",
				0.2
			],
			[
				"2009-06-17",
				0.2
			],
			[
				"2009-07-17",
				0.2
			],
			[
				"2009-08-19",
				0.2
			],
			[
				"2009-09-21",
				0.2
			],
			[
				"2009-10-13",
				0.2
			]
		],
		"219282018": [
			[
				"2011-05-25",
				0.2
			],
			[
				"2012-08-30",
				0.2
			],
			[
				"2013-07-29",
				0.2
			],
			[
				"2014-08-28",
				0.2
			],
			[
				"2015-07-09",
				0.89
			],
			[
				"2003-05-07",
				0.2
			],
			[
				"2004-03-08",
				0.2
			],
			[
				"2005-06-01",
				0.2
			],
			[
				"2006-03-31",
				0.2
			],
			[
				"2007-02-05",
				0.2
			],
			[
				"2007-10-10",
				0.2
			],
			[
				"2008-04-24",
				0.2
			],
			[
				"2008-11-21",
				0.2
			],
			[
				"2009-05-11",
				0.2
			]
		],
		"219478314": [
			[
				"2012-03-14",
				44.29
			],
			[
				"2013-05-23",
				56.68
			],
			[
				"2014-09-23",
				52.26
			],
			[
				"2015-11-30",
				54.47
			],
			[
				"2006-01-25",
				27.31
			],
			[
				"2006-12-21",
				49.12
			],
			[
				"2007-02-28",
				40.21
			],
			[
				"2007-08-08",
				47.82
			],
			[
				"2008-06-16",
				47.82
			],
			[
				"2008-09-08",
				50.02
			],
			[
				"2009-02-12",
				33.71
			]
		],
		"219480618": [
			[
				"2011-01-06",
				49.6
			],
			[
				"2012-03-14",
				65.98
			],
			[
				"2013-05-23",
				65.54
			],
			[
				"2014-09-24",
				61.55
			],
			[
				"2015-12-09",
				59.34
			],
			[
				"2003-04-30",
				62.92
			],
			[
				"2003-08-29",
				62.92
			],
			[
				"2004-03-15",
				60.62
			],
			[
				"2004-10-05",
				62.02
			],
			[
				"2005-04-07",
				64.22
			],
			[
				"2005-08-29",
				66.42
			],
			[
				"2000-01-27",
				69.12
			],
			[
				"2000-08-15",
				74.83
			],
			[
				"2001-01-11",
				75.73
			],
			[
				"2001-07-24",
				75.73
			],
			[
				"2002-05-07",
				75.33
			],
			[
				"2002-10-28",
				69.92
			],
			[
				"2006-03-16",
				63.72
			],
			[
				"2006-09-20",
				66.02
			],
			[
				"2006-12-21",
				71.73
			],
			[
				"2007-01-25",
				66.02
			],
			[
				"2007-08-30",
				64.62
			],
			[
				"2008-06-04",
				64.62
			],
			[
				"2008-09-08",
				66.42
			],
			[
				"2009-02-12",
				64.22
			]
		],
		"219482410": [
			[
				"2010-05-04",
				2.21
			],
			[
				"2011-08-04",
				4.83
			],
			[
				"2013-08-27",
				12.04
			],
			[
				"2014-03-27",
				1.81
			],
			[
				"2015-08-19",
				9.78
			],
			[
				"2003-05-22",
				18.51
			],
			[
				"2004-03-25",
				16.71
			],
			[
				"2005-04-26",
				5.9
			],
			[
				"2006-05-31",
				7.7
			],
			[
				"2006-12-11",
				2.8
			],
			[
				"2007-01-29",
				3.5
			],
			[
				"2007-07-23",
				2
			],
			[
				"2008-05-27",
				1
			],
			[
				"2008-09-11",
				0.9
			],
			[
				"2009-02-27",
				0.2
			]
		],
		"219483218": [
			[
				"2012-07-26",
				164.74
			],
			[
				"2013-05-07",
				170.49
			],
			[
				"2014-10-07",
				177.57
			],
			[
				"2015-12-08",
				187.77
			],
			[
				"2003-05-06",
				169.16
			],
			[
				"2003-09-17",
				142.55
			],
			[
				"2004-03-15",
				150.55
			],
			[
				"2004-10-05",
				155.46
			],
			[
				"2005-03-31",
				157.66
			],
			[
				"2005-08-30",
				170.06
			],
			[
				"2006-03-17",
				170.46
			],
			[
				"2006-09-20",
				172.26
			],
			[
				"2007-01-25",
				158.56
			],
			[
				"2007-10-05",
				172.66
			],
			[
				"2008-06-24",
				64.22
			],
			[
				"2008-08-29",
				175.36
			],
			[
				"2009-02-12",
				171.86
			]
		],
		"219486219": [
			[
				"2010-10-21",
				72.19
			],
			[
				"2011-08-31",
				70.86
			],
			[
				"2013-06-05",
				81.48
			],
			[
				"2014-07-03",
				83.25
			],
			[
				"2015-03-26",
				78.83
			],
			[
				"2015-12-02",
				74.4
			],
			[
				"2001-11-13",
				54.42
			],
			[
				"2002-02-05",
				54.42
			],
			[
				"2003-07-28",
				53.12
			],
			[
				"2004-03-15",
				53.62
			],
			[
				"2005-05-19",
				53.62
			],
			[
				"2000-03-20",
				47.42
			],
			[
				"2000-04-20",
				50.92
			],
			[
				"2007-04-18",
				57.12
			],
			[
				"2007-08-28",
				56.72
			],
			[
				"2007-10-16",
				47.42
			],
			[
				"2008-07-03",
				59.82
			],
			[
				"2008-09-15",
				56.72
			],
			[
				"2009-03-17",
				54.42
			]
		],
		"219602013": [
			[
				"2010-08-04",
				2.3
			],
			[
				"2012-04-23",
				2.3
			],
			[
				"2013-04-29",
				5.44
			],
			[
				"2014-08-28",
				1.73
			],
			[
				"2015-10-19",
				0.89
			],
			[
				"2003-04-23",
				8.5
			],
			[
				"2003-08-28",
				2.6
			],
			[
				"2004-03-19",
				6.7
			],
			[
				"2004-11-18",
				3.9
			],
			[
				"2005-04-07",
				6.9
			],
			[
				"2005-09-21",
				3.3
			],
			[
				"2006-03-20",
				3.1
			],
			[
				"2006-09-12",
				3.5
			],
			[
				"2007-02-28",
				3.1
			],
			[
				"2007-11-07",
				2.3
			],
			[
				"2008-06-24",
				12.8
			],
			[
				"2008-10-09",
				2.4
			],
			[
				"2009-04-16",
				4.1
			]
		],
		"219602610": [
			[
				"2012-04-11",
				0.2
			],
			[
				"2013-04-30",
				0.2
			],
			[
				"2014-04-17",
				0.2
			],
			[
				"2015-06-25",
				0.89
			],
			[
				"2003-04-10",
				0.2
			],
			[
				"2003-09-15",
				0.2
			],
			[
				"2004-02-18",
				0.2
			],
			[
				"2004-10-11",
				0.2
			],
			[
				"2005-04-26",
				0.2
			],
			[
				"2005-08-30",
				0.2
			],
			[
				"2006-02-02",
				0.2
			],
			[
				"2006-07-21",
				0.2
			],
			[
				"2007-02-02",
				0.2
			],
			[
				"2007-09-04",
				0.2
			],
			[
				"2008-06-23",
				0.2
			],
			[
				"2008-09-26",
				0.2
			],
			[
				"2009-04-29",
				0.2
			],
			[
				"2010-02-08",
				0.2
			]
		],
		"219602712": [
			[
				"2011-09-12",
				199.72
			],
			[
				"2013-05-13",
				181.12
			],
			[
				"2014-06-05",
				167.84
			],
			[
				"2015-06-08",
				165.18
			],
			[
				"2003-02-11",
				131.55
			],
			[
				"2004-01-08",
				123.54
			],
			[
				"2005-07-13",
				142.55
			],
			[
				"2006-02-02",
				121.74
			],
			[
				"2007-01-23",
				123.14
			],
			[
				"2007-08-23",
				149.25
			],
			[
				"2008-05-15",
				165.66
			],
			[
				"2008-09-16",
				171.86
			],
			[
				"2009-04-07",
				168.26
			],
			[
				"2010-01-27",
				163.85
			]
		],
		"219602815": [
			[
				"2011-09-13",
				230.72
			],
			[
				"2013-05-13",
				235.14
			],
			[
				"2014-06-18",
				211.23
			],
			[
				"2015-06-08",
				182.89
			],
			[
				"2003-02-10",
				262.19
			],
			[
				"2004-01-09",
				251.99
			],
			[
				"2004-08-03",
				235.18
			],
			[
				"2005-01-18",
				212.08
			],
			[
				"2005-07-13",
				233.78
			],
			[
				"2006-01-31",
				240.49
			],
			[
				"2006-09-22",
				230.68
			],
			[
				"2007-01-23",
				217.88
			],
			[
				"2007-08-23",
				214.38
			],
			[
				"2000-04-14",
				212.58
			],
			[
				"2000-09-25",
				210.37
			],
			[
				"2001-07-12",
				236.48
			],
			[
				"2002-06-11",
				283.4
			],
			[
				"2008-05-15",
				200.57
			],
			[
				"2008-09-16",
				195.27
			],
			[
				"2009-04-07",
				169.16
			],
			[
				"2010-01-27",
				185.55
			]
		],
		"219602918": [
			[
				"2013-05-14",
				1.64
			],
			[
				"2014-06-05",
				0.2
			],
			[
				"2015-06-10",
				0.89
			],
			[
				"2003-02-10",
				1
			],
			[
				"2004-01-09",
				0.2
			],
			[
				"2004-08-03",
				0.2
			],
			[
				"2005-01-18",
				0.2
			],
			[
				"2005-07-12",
				0.2
			],
			[
				"2006-01-31",
				0.2
			],
			[
				"2007-01-23",
				0.2
			],
			[
				"2007-08-23",
				0.2
			],
			[
				"2008-11-04",
				0.2
			],
			[
				"2009-04-07",
				6.7
			],
			[
				"2010-01-27",
				1.86
			]
		],
		"219603017": [
			[
				"2011-09-13",
				7.13
			],
			[
				"2013-05-14",
				8.06
			],
			[
				"2014-06-18",
				8.72
			],
			[
				"2015-06-02",
				10.23
			],
			[
				"2003-02-10",
				26.31
			],
			[
				"2004-01-09",
				16.71
			],
			[
				"2004-08-03",
				25.61
			],
			[
				"2005-01-18",
				22.01
			],
			[
				"2005-07-12",
				20.91
			],
			[
				"2006-01-31",
				18.11
			],
			[
				"2007-01-29",
				13.6
			],
			[
				"2007-08-23",
				9.4
			],
			[
				"2008-06-05",
				11.9
			],
			[
				"2008-11-04",
				7.8
			],
			[
				"2009-04-07",
				12.1
			],
			[
				"2010-01-27",
				9.83
			]
		],
		"219606614": [
			[
				"2011-05-25",
				3.9
			],
			[
				"2012-08-27",
				1.64
			],
			[
				"2013-08-08",
				2.57
			],
			[
				"2014-08-26",
				0.89
			],
			[
				"2015-07-08",
				4.91
			],
			[
				"2000-05-05",
				6.2
			],
			[
				"2001-03-13",
				6
			],
			[
				"2002-05-07",
				9.2
			],
			[
				"2003-05-07",
				4.5
			],
			[
				"2004-05-12",
				5.8
			],
			[
				"2005-06-01",
				5.3
			],
			[
				"2007-10-10",
				2.7
			],
			[
				"2008-04-24",
				7.1
			],
			[
				"2008-11-20",
				4.7
			],
			[
				"2009-05-11",
				5.3
			]
		],
		"219671114": [
			[
				"2011-07-20",
				74.4
			],
			[
				"2012-08-28",
				92.55
			],
			[
				"2013-08-06",
				92.99
			],
			[
				"2014-08-05",
				91.66
			],
			[
				"2015-03-23",
				85.02
			],
			[
				"2015-11-25",
				81.93
			],
			[
				"2006-01-24",
				84.13
			],
			[
				"2006-09-25",
				79.73
			],
			[
				"2007-01-31",
				81.03
			],
			[
				"2007-07-31",
				81.53
			],
			[
				"2008-11-06",
				75.73
			],
			[
				"2009-04-23",
				79.73
			]
		],
		"219671813": [
			[
				"2011-01-10",
				3.81
			],
			[
				"2012-10-15",
				1.51
			],
			[
				"2013-08-20",
				11.2
			],
			[
				"2014-10-06",
				10.49
			],
			[
				"2015-08-17",
				13.94
			],
			[
				"2000-02-03",
				1.2
			],
			[
				"2000-07-18",
				2.6
			],
			[
				"2001-01-22",
				2
			],
			[
				"2001-08-06",
				0.2
			],
			[
				"2002-06-11",
				0.2
			],
			[
				"2002-10-30",
				0.2
			],
			[
				"2003-05-15",
				0.2
			],
			[
				"2003-10-23",
				0.2
			],
			[
				"2004-03-30",
				2.1
			],
			[
				"2004-10-12",
				0.2
			],
			[
				"2005-04-13",
				6.3
			],
			[
				"2005-09-27",
				0.2
			],
			[
				"2007-08-14",
				0.2
			],
			[
				"2008-05-26",
				0.2
			],
			[
				"2008-10-09",
				3.3
			],
			[
				"2009-04-14",
				5.9
			]
		],
		"219671916": [
			[
				"2012-12-18",
				66.42
			],
			[
				"2013-04-08",
				112.48
			],
			[
				"2014-09-22",
				100.09
			],
			[
				"2015-10-05",
				149.23
			],
			[
				"2000-04-13",
				74.83
			],
			[
				"2002-01-14",
				83.23
			],
			[
				"2003-06-17",
				85.03
			],
			[
				"2005-09-23",
				80.13
			],
			[
				"2006-04-20",
				74.43
			],
			[
				"2007-02-05",
				81.93
			],
			[
				"2007-11-07",
				79.23
			],
			[
				"2008-11-13",
				73.93
			],
			[
				"2009-04-17",
				71.33
			]
		],
		"219674310": [
			[
				"2012-08-09",
				0.2
			],
			[
				"2013-12-09",
				0.2
			],
			[
				"2014-07-31",
				1.15
			],
			[
				"2015-12-21",
				2.43
			],
			[
				"2000-03-22",
				11.5
			],
			[
				"2001-12-05",
				5.1
			],
			[
				"2002-07-12",
				6.3
			],
			[
				"2003-06-11",
				8.4
			],
			[
				"2004-04-16",
				3.8
			],
			[
				"2005-05-10",
				7
			],
			[
				"2007-09-21",
				1.9
			],
			[
				"2008-06-03",
				0.2
			],
			[
				"2008-09-29",
				0.2
			],
			[
				"2009-03-25",
				0.2
			]
		],
		"219675119": [
			[
				"2011-07-28",
				0.2
			],
			[
				"2013-04-04",
				0.2
			],
			[
				"2014-09-29",
				0.2
			],
			[
				"2015-12-15",
				0.89
			],
			[
				"2003-04-02",
				0.2
			],
			[
				"2005-09-26",
				0.2
			],
			[
				"2007-11-12",
				0.2
			],
			[
				"2008-07-07",
				0.2
			],
			[
				"2008-11-13",
				0.2
			],
			[
				"2009-05-28",
				0.2
			]
		],
		"219971614": [
			[
				"2010-05-31",
				86.8
			],
			[
				"2011-08-09",
				94.32
			],
			[
				"2012-07-17",
				82.81
			],
			[
				"2013-08-26",
				104.96
			],
			[
				"2014-05-12",
				108.94
			],
			[
				"2015-09-23",
				74.84
			],
			[
				"2003-05-20",
				65.12
			],
			[
				"2003-09-30",
				71.33
			],
			[
				"2004-03-30",
				79.73
			],
			[
				"2004-09-20",
				80.63
			],
			[
				"2005-04-19",
				81.93
			],
			[
				"2005-10-13",
				88.53
			],
			[
				"2006-05-11",
				90.33
			],
			[
				"2006-10-17",
				83.23
			],
			[
				"2006-12-11",
				76.13
			],
			[
				"2007-01-29",
				80.13
			],
			[
				"2007-09-24",
				85.43
			],
			[
				"2008-05-28",
				86.83
			],
			[
				"2008-09-09",
				84.13
			],
			[
				"2009-07-13",
				90.33
			]
		],
		"219971912": [
			[
				"2010-11-04",
				13.1
			],
			[
				"2011-07-26",
				13.5
			],
			[
				"2012-05-07",
				0.2
			],
			[
				"2013-06-13",
				13.24
			],
			[
				"2014-06-23",
				11.07
			],
			[
				"2015-11-26",
				11.11
			],
			[
				"2003-05-20",
				0.2
			],
			[
				"2003-10-22",
				4.3
			],
			[
				"2004-03-04",
				13.7
			],
			[
				"2004-08-23",
				9.2
			],
			[
				"2005-05-04",
				15.31
			],
			[
				"2005-09-21",
				12.9
			],
			[
				"2006-04-10",
				13.1
			],
			[
				"2006-10-06",
				13.9
			],
			[
				"2007-01-24",
				13.9
			],
			[
				"2007-09-20",
				11.4
			],
			[
				"2008-07-03",
				15.21
			],
			[
				"2009-03-16",
				14.81
			]
		],
		"219972011": [
			[
				"2011-08-08",
				139.94
			],
			[
				"2012-05-07",
				153.66
			],
			[
				"2013-05-27",
				132.85
			],
			[
				"2014-07-17",
				99.2
			],
			[
				"2015-12-09",
				125.32
			],
			[
				"2003-01-21",
				40.31
			],
			[
				"2003-09-08",
				110.24
			],
			[
				"2004-03-09",
				111.64
			],
			[
				"2004-08-23",
				91.23
			],
			[
				"2005-05-03",
				20.11
			],
			[
				"2005-09-20",
				19.71
			],
			[
				"2006-03-31",
				19.61
			],
			[
				"2006-10-09",
				33.51
			],
			[
				"2006-12-13",
				32.41
			],
			[
				"2007-01-23",
				32.71
			],
			[
				"2007-08-28",
				35.11
			],
			[
				"2008-07-03",
				37.61
			],
			[
				"2008-09-15",
				38.41
			],
			[
				"2009-03-17",
				73.93
			],
			[
				"2010-02-23",
				107.17
			]
		],
		"219972310": [
			[
				"2010-06-09",
				0.2
			],
			[
				"2011-08-16",
				0.2
			],
			[
				"2012-07-12",
				0.2
			],
			[
				"2014-05-15",
				0.2
			],
			[
				"2015-09-01",
				0.89
			],
			[
				"2003-06-05",
				0.2
			],
			[
				"2004-09-22",
				0.2
			],
			[
				"2005-06-02",
				0.2
			],
			[
				"2006-05-16",
				0.2
			],
			[
				"2006-12-11",
				0.2
			],
			[
				"2007-01-29",
				0.2
			],
			[
				"2008-05-28",
				0.2
			],
			[
				"2008-09-09",
				0.2
			],
			[
				"2009-03-26",
				0.2
			]
		],
		"219974214": [
			[
				"2010-06-07",
				69.96
			],
			[
				"2011-08-08",
				79.27
			],
			[
				"2012-07-11",
				85.91
			],
			[
				"2013-08-27",
				92.11
			],
			[
				"2014-05-14",
				91.66
			],
			[
				"2015-09-04",
				85.47
			],
			[
				"2000-05-08",
				66.82
			],
			[
				"2000-10-27",
				66.42
			],
			[
				"2001-04-02",
				65.52
			],
			[
				"2001-10-18",
				67.72
			],
			[
				"2002-06-19",
				66.02
			],
			[
				"2002-10-21",
				64.62
			],
			[
				"2003-05-19",
				61.12
			],
			[
				"2003-09-30",
				67.32
			],
			[
				"2004-03-29",
				62.92
			],
			[
				"2004-09-27",
				64.62
			],
			[
				"2005-04-19",
				59.82
			],
			[
				"2005-10-13",
				59.32
			],
			[
				"2008-05-28",
				59.32
			],
			[
				"2008-09-09",
				73.93
			],
			[
				"2009-04-15",
				66.42
			]
		],
		"219974317": [
			[
				"2010-10-26",
				22.54
			],
			[
				"2011-07-28",
				22.5
			],
			[
				"2012-05-14",
				23.6
			],
			[
				"2013-05-29",
				24.36
			],
			[
				"2014-06-24",
				22.41
			],
			[
				"2015-11-23",
				22.19
			],
			[
				"2000-03-16",
				23.01
			],
			[
				"2001-02-20",
				21.31
			],
			[
				"2002-02-04",
				23.11
			],
			[
				"2003-05-23",
				21.81
			],
			[
				"2004-01-23",
				21.81
			],
			[
				"2005-05-12",
				22.41
			],
			[
				"2007-09-20",
				20.61
			],
			[
				"2008-07-03",
				21.81
			],
			[
				"2009-03-17",
				21.81
			]
		],
		"219976417": [
			[
				"2011-08-10",
				15.37
			],
			[
				"2012-05-09",
				16.57
			],
			[
				"2013-06-13",
				29.63
			],
			[
				"2014-06-23",
				23.25
			],
			[
				"2015-12-08",
				17.41
			],
			[
				"2000-03-10",
				50.02
			],
			[
				"2000-09-08",
				42.82
			],
			[
				"2001-02-16",
				53.12
			],
			[
				"2001-11-08",
				34.91
			],
			[
				"2002-01-28",
				33.21
			],
			[
				"2002-07-23",
				56.22
			],
			[
				"2003-09-11",
				46.92
			],
			[
				"2003-12-10",
				37.71
			],
			[
				"2004-03-11",
				44.22
			],
			[
				"2004-11-02",
				43.82
			],
			[
				"2005-05-09",
				61.12
			],
			[
				"2005-09-21",
				48.32
			],
			[
				"2007-04-19",
				51.82
			],
			[
				"2007-08-28",
				46.52
			],
			[
				"2007-10-17",
				45.22
			],
			[
				"2009-03-16",
				24.91
			],
			[
				"2009-04-01",
				24.31
			],
			[
				"2009-10-06",
				18.12
			]
		],
		"278331427": [
			[
				"2010-10-05",
				0.5
			],
			[
				"2011-10-11",
				0.7
			],
			[
				"2012-10-09",
				0.5
			],
			[
				"2013-11-18",
				0.5
			],
			[
				"2014-10-17",
				0.5
			],
			[
				"2015-10-13",
				0.5
			],
			[
				"2000-12-01",
				0.5
			],
			[
				"2001-11-14",
				1.2
			],
			[
				"2006-11-10",
				0.5
			],
			[
				"2007-10-16",
				2.8
			],
			[
				"2008-10-17",
				0.5
			],
			[
				"2009-10-13",
				0.5
			]
		],
		"278345323": [
			[
				"2010-04-06",
				0.5
			],
			[
				"2010-11-03",
				0.5
			],
			[
				"2011-05-03",
				0.5
			],
			[
				"2011-12-21",
				0.5
			],
			[
				"2012-04-27",
				1.1
			],
			[
				"2012-10-22",
				0.5
			],
			[
				"2013-04-24",
				0.5
			],
			[
				"2013-11-27",
				0.5
			],
			[
				"2014-04-24",
				0.5
			],
			[
				"2014-10-22",
				0.5
			],
			[
				"2015-03-23",
				0.5
			],
			[
				"2015-10-27",
				0.5
			],
			[
				"2004-05-13",
				0.5
			],
			[
				"2000-12-06",
				0.5
			],
			[
				"2000-05-18",
				1
			],
			[
				"2001-11-13",
				0.5
			],
			[
				"2001-06-08",
				0.5
			],
			[
				"2002-11-18",
				2
			],
			[
				"2002-05-08",
				0.5
			],
			[
				"2003-11-04",
				0.5
			],
			[
				"2003-05-13",
				0.5
			],
			[
				"2004-10-25",
				0.5
			],
			[
				"2005-04-13",
				0.5
			],
			[
				"2005-10-06",
				0.5
			],
			[
				"2006-05-18",
				0.5
			],
			[
				"2006-10-25",
				2.4
			],
			[
				"2007-04-26",
				2.8
			],
			[
				"2007-10-09",
				0.5
			],
			[
				"2008-04-02",
				0.5
			],
			[
				"2008-10-28",
				0.5
			],
			[
				"2009-04-30",
				0.5
			],
			[
				"2009-11-09",
				0.5
			]
		],
		"278346613": [
			[
				"2010-04-09",
				0.6
			],
			[
				"2010-10-05",
				0.6
			],
			[
				"2011-05-16",
				0.5
			],
			[
				"2011-10-11",
				0.5
			],
			[
				"2012-04-16",
				0.6
			],
			[
				"2012-10-09",
				0.8
			],
			[
				"2013-04-11",
				3.6
			],
			[
				"2013-10-22",
				0.5
			],
			[
				"2014-04-25",
				1
			],
			[
				"2014-10-17",
				0.8
			],
			[
				"2015-04-01",
				0.8
			],
			[
				"2015-10-13",
				0.5
			],
			[
				"2004-01-05",
				0.5
			],
			[
				"2004-05-14",
				0.5
			],
			[
				"2004-12-17",
				0.5
			],
			[
				"2000-12-07",
				0.5
			],
			[
				"2001-11-19",
				0.5
			],
			[
				"2001-06-08",
				0.7
			],
			[
				"2002-11-22",
				0.5
			],
			[
				"2002-04-30",
				0.5
			],
			[
				"2003-05-23",
				0.5
			],
			[
				"2005-06-07",
				0.5
			],
			[
				"2005-11-22",
				0.5
			],
			[
				"2006-04-21",
				0.5
			],
			[
				"2006-11-14",
				0.5
			],
			[
				"2007-05-14",
				0.5
			],
			[
				"2007-10-16",
				0.5
			],
			[
				"2008-04-23",
				0.5
			],
			[
				"2008-10-17",
				0.5
			],
			[
				"2009-04-17",
				0.5
			],
			[
				"2009-10-13",
				0.5
			]
		],
		"278506616": [
			[
				"2011-10-10",
				0.5
			],
			[
				"2012-10-10",
				0.5
			],
			[
				"2013-10-09",
				0.5
			],
			[
				"2014-10-08",
				0.5
			],
			[
				"2015-10-15",
				0.5
			],
			[
				"2013-10-09",
				1.33
			],
			[
				"2014-10-08",
				1.33
			],
			[
				"2015-10-15",
				1.33
			],
			[
				"2009-10-16",
				2.21
			],
			[
				"2010-10-04",
				1.33
			],
			[
				"2011-10-10",
				0.44
			],
			[
				"2012-10-10",
				1.33
			]
		],
		"278534910": [
			[
				"2010-10-04",
				0.5
			],
			[
				"2011-10-10",
				0.5
			],
			[
				"2012-10-10",
				0.5
			],
			[
				"2013-10-09",
				0.5
			],
			[
				"2014-10-08",
				0.5
			],
			[
				"2015-10-15",
				0.5
			],
			[
				"2013-10-09",
				1.33
			],
			[
				"2014-10-08",
				1.33
			],
			[
				"2015-10-15",
				1.33
			],
			[
				"2000-10-24",
				0.5
			],
			[
				"2001-08-09",
				0.5
			],
			[
				"2002-09-19",
				0.5
			],
			[
				"2003-10-20",
				0.5
			],
			[
				"2004-08-10",
				0.5
			],
			[
				"2005-08-04",
				0.5
			],
			[
				"2006-07-28",
				0.5
			],
			[
				"2007-10-19",
				0.5
			],
			[
				"2008-10-13",
				0.5
			],
			[
				"2009-10-12",
				0.5
			],
			[
				"2009-10-16",
				2.21
			],
			[
				"2010-10-04",
				1.33
			],
			[
				"2011-10-10",
				0.66
			],
			[
				"2012-10-10",
				1.33
			]
		],
		"278536610": [
			[
				"2010-10-04",
				9
			],
			[
				"2011-10-10",
				1.8
			],
			[
				"2012-10-10",
				0.5
			],
			[
				"2013-10-09",
				1
			],
			[
				"2014-10-08",
				0.5
			],
			[
				"2015-10-15",
				0.5
			],
			[
				"2013-10-09",
				1.33
			],
			[
				"2014-10-08",
				3.54
			],
			[
				"2015-10-15",
				1.33
			],
			[
				"2000-10-24",
				0.8
			],
			[
				"2001-08-29",
				0.5
			],
			[
				"2009-10-16",
				2.21
			],
			[
				"2010-10-04",
				8.86
			],
			[
				"2011-10-10",
				1.28
			],
			[
				"2012-10-10",
				1.33
			]
		],
		"278540910": [
			[
				"2010-10-04",
				0.5
			],
			[
				"2011-10-10",
				0.5
			],
			[
				"2012-10-10",
				0.5
			],
			[
				"2013-10-10",
				0.5
			],
			[
				"2014-10-08",
				0.5
			],
			[
				"2015-10-12",
				2.3
			],
			[
				"2000-08-10",
				0.5
			],
			[
				"2001-08-10",
				5
			],
			[
				"2002-07-09",
				5
			],
			[
				"2003-08-06",
				1.6
			],
			[
				"2004-08-03",
				0.5
			],
			[
				"2005-08-01",
				0.5
			],
			[
				"2006-07-31",
				0.5
			],
			[
				"2007-10-15",
				0.5
			],
			[
				"2008-11-21",
				4.6
			],
			[
				"2009-09-12",
				0.5
			]
		],
		"278541010": [
			[
				"2010-10-04",
				0.5
			],
			[
				"2011-10-10",
				0.5
			],
			[
				"2012-10-10",
				0.5
			],
			[
				"2013-06-10",
				0.5
			],
			[
				"2014-10-08",
				0.5
			],
			[
				"2015-10-12",
				0.5
			],
			[
				"2000-08-10",
				0.5
			],
			[
				"2001-08-08",
				5
			],
			[
				"2002-08-06",
				5
			],
			[
				"2003-08-07",
				0.5
			],
			[
				"2004-08-03",
				0.5
			],
			[
				"2005-08-01",
				0.5
			],
			[
				"2006-07-31",
				0.5
			],
			[
				"2007-10-15",
				0.5
			],
			[
				"2008-11-05",
				0.2
			],
			[
				"2008-10-13",
				0.5
			],
			[
				"2009-09-12",
				0.5
			]
		],
		"278543418": [
			[
				"2010-10-04",
				0.5
			],
			[
				"2011-10-10",
				0.5
			],
			[
				"2012-10-10",
				0.5
			],
			[
				"2013-10-11",
				0.5
			],
			[
				"2014-10-08",
				0.5
			],
			[
				"2015-10-13",
				0.5
			],
			[
				"2000-10-09",
				1.4
			],
			[
				"2001-08-10",
				10
			],
			[
				"2002-07-22",
				5
			],
			[
				"2003-08-06",
				1.5
			],
			[
				"2004-08-04",
				0.5
			],
			[
				"2005-08-02",
				0.5
			],
			[
				"2006-08-01",
				0.5
			],
			[
				"2007-10-15",
				0.5
			],
			[
				"2008-11-05",
				0.2
			],
			[
				"2008-11-06",
				0.5
			]
		],
		"278766511": [
			[
				"2010-10-05",
				1.6
			],
			[
				"2011-10-11",
				1.2
			],
			[
				"2012-10-09",
				0.5
			],
			[
				"2013-11-12",
				0.9
			],
			[
				"2014-10-17",
				1.1
			],
			[
				"2015-10-13",
				1.7
			]
		],
		"279371810": [
			[
				"2010-07-22",
				57.13
			],
			[
				"2011-09-19",
				56.68
			],
			[
				"2012-03-13",
				55.36
			],
			[
				"2014-06-25",
				49.6
			],
			[
				"2015-06-05",
				53.14
			],
			[
				"2000-07-20",
				63.32
			],
			[
				"2001-02-09",
				71.73
			],
			[
				"2002-05-31",
				76.63
			],
			[
				"2003-01-31",
				66.02
			],
			[
				"2004-02-11",
				60.22
			],
			[
				"2005-03-21",
				65.12
			],
			[
				"2006-03-08",
				66.82
			],
			[
				"2007-09-07",
				68.22
			],
			[
				"2008-04-22",
				67.72
			],
			[
				"2008-06-16",
				69.12
			],
			[
				"2008-11-07",
				65.52
			]
		],
		"279375610": [
			[
				"2010-07-28",
				5.84
			],
			[
				"2011-09-20",
				9.74
			],
			[
				"2012-03-20",
				8.46
			],
			[
				"2013-05-13",
				8.94
			],
			[
				"2014-06-30",
				6.68
			],
			[
				"2015-06-19",
				7.22
			],
			[
				"2000-08-09",
				14.44
			],
			[
				"2001-07-23",
				21.88
			],
			[
				"2002-08-15",
				17.67
			],
			[
				"2003-09-22",
				11.16
			],
			[
				"2004-07-16",
				7.57
			],
			[
				"2005-08-04",
				12.18
			],
			[
				"2006-10-25",
				12.36
			],
			[
				"2007-09-07",
				12.1
			],
			[
				"2008-06-18",
				11.7
			],
			[
				"2008-11-07",
				9.9
			],
			[
				"2009-04-30",
				8.3
			],
			[
				"2010-06-08",
				6.51
			]
		],
		"279470617": [
			[
				"2010-12-16",
				108.5
			],
			[
				"2011-07-05",
				107.17
			],
			[
				"2012-07-19",
				86.35
			],
			[
				"2013-06-20",
				90.78
			],
			[
				"2014-05-22",
				93.44
			],
			[
				"2014-06-24",
				97.42
			],
			[
				"2015-06-23",
				113.37
			],
			[
				"2000-09-05",
				104.04
			],
			[
				"2001-10-01",
				124.44
			],
			[
				"2002-07-31",
				116.04
			],
			[
				"2003-09-29",
				86.33
			],
			[
				"2004-03-31",
				82.33
			],
			[
				"2005-05-03",
				99.24
			],
			[
				"2007-11-13",
				109.34
			],
			[
				"2008-05-29",
				139.45
			],
			[
				"2008-10-07",
				146.15
			],
			[
				"2009-04-16",
				139.45
			]
		],
		"279480015": [
			[
				"2012-07-24",
				69.52
			],
			[
				"2013-06-05",
				78.38
			],
			[
				"2014-10-07",
				74.4
			],
			[
				"2015-12-11",
				73.07
			],
			[
				"2003-05-13",
				67.32
			],
			[
				"2003-09-17",
				65.12
			],
			[
				"2004-03-16",
				64.62
			],
			[
				"2004-10-05",
				64.62
			],
			[
				"2005-04-07",
				62.42
			],
			[
				"2005-08-30",
				64.62
			],
			[
				"2006-03-14",
				62.02
			],
			[
				"2006-09-07",
				65.52
			],
			[
				"2006-12-13",
				62.42
			],
			[
				"2007-01-25",
				66.02
			],
			[
				"2008-06-24",
				64.22
			],
			[
				"2009-02-12",
				66.02
			]
		],
		"279483910": [
			[
				"2012-07-25",
				44.73
			],
			[
				"2013-12-19",
				42.29
			],
			[
				"2014-07-22",
				38.26
			],
			[
				"2015-12-16",
				37.81
			],
			[
				"2000-04-20",
				40.51
			],
			[
				"2000-10-17",
				25.11
			],
			[
				"2001-02-28",
				37.11
			],
			[
				"2001-11-27",
				47.42
			],
			[
				"2002-06-20",
				42.82
			],
			[
				"2002-10-18",
				41.41
			],
			[
				"2003-06-13",
				45.62
			],
			[
				"2003-11-07",
				49.62
			],
			[
				"2004-04-21",
				47.42
			],
			[
				"2004-11-04",
				45.62
			],
			[
				"2005-05-18",
				44.32
			],
			[
				"2005-11-23",
				47.42
			],
			[
				"2007-09-21",
				47.82
			],
			[
				"2008-06-03",
				49.62
			],
			[
				"2008-09-25",
				49.12
			],
			[
				"2009-03-23",
				41.01
			]
		],
		"288066613": [
			[
				"2012-11-16",
				37.77
			],
			[
				"2013-07-15",
				38.7
			],
			[
				"2014-03-20",
				33.61
			],
			[
				"2015-05-04",
				22.1
			],
			[
				"2007-12-05",
				29.01
			],
			[
				"2008-06-27",
				33.31
			],
			[
				"2010-01-26",
				35.34
			],
			[
				"2003-04-04",
				32.71
			],
			[
				"2003-08-27",
				35.51
			],
			[
				"2004-04-08",
				41.51
			],
			[
				"2004-09-08",
				42.42
			],
			[
				"2005-03-18",
				40.41
			],
			[
				"2005-09-14",
				37.31
			],
			[
				"2006-02-06",
				30.71
			],
			[
				"2006-09-25",
				28.11
			],
			[
				"2007-04-25",
				25.51
			]
		],
		"288067411": [
			[
				"2010-08-05",
				2.12
			],
			[
				"2011-02-09",
				1.77
			],
			[
				"2012-01-24",
				0.2
			],
			[
				"2013-03-04",
				0.2
			],
			[
				"2014-02-25",
				0.2
			],
			[
				"2015-01-26",
				0.89
			],
			[
				"2007-11-26",
				50.02
			],
			[
				"2008-07-08",
				38.61
			],
			[
				"2008-09-09",
				26.71
			],
			[
				"2009-07-29",
				9.2
			],
			[
				"2003-03-21",
				44.22
			],
			[
				"2003-07-30",
				34.21
			],
			[
				"2004-01-12",
				46.02
			],
			[
				"2004-07-30",
				54.92
			],
			[
				"2005-02-15",
				32.11
			],
			[
				"2005-06-22",
				27.31
			],
			[
				"2006-02-14",
				26.31
			],
			[
				"2006-09-21",
				24.01
			],
			[
				"2007-01-12",
				42.92
			]
		],
		"288193416": [
			[
				"2010-10-05",
				10.4
			],
			[
				"2011-10-11",
				10.6
			],
			[
				"2012-10-09",
				7.3
			],
			[
				"2013-10-08",
				9.6
			],
			[
				"2014-10-14",
				6.5
			],
			[
				"2015-10-16",
				13.1
			],
			[
				"2014-12-16",
				7.04
			],
			[
				"2000-03-28",
				15.41
			],
			[
				"2000-09-14",
				14.81
			],
			[
				"2001-02-20",
				12.6
			],
			[
				"2001-08-02",
				22.81
			],
			[
				"2002-01-09",
				17.11
			],
			[
				"2002-07-26",
				20.41
			],
			[
				"2003-02-05",
				21.01
			],
			[
				"2003-07-17",
				27.81
			],
			[
				"2004-02-04",
				22.51
			],
			[
				"2004-08-19",
				17.81
			],
			[
				"2005-03-03",
				15.01
			],
			[
				"2005-08-25",
				12.4
			],
			[
				"2006-03-09",
				9.4
			],
			[
				"2008-11-10",
				7.13
			]
		],
		"288194214": [
			[
				"2010-10-05",
				68.12
			],
			[
				"2011-10-11",
				22.01
			],
			[
				"2012-10-09",
				67.12
			],
			[
				"2013-10-08",
				65.52
			],
			[
				"2014-10-14",
				63.12
			],
			[
				"2015-10-16",
				72.03
			],
			[
				"2000-03-17",
				87.23
			],
			[
				"2001-08-22",
				67.72
			],
			[
				"2002-01-10",
				67.72
			],
			[
				"2003-03-11",
				69.12
			],
			[
				"2004-02-04",
				59.32
			],
			[
				"2005-08-03",
				64.62
			],
			[
				"2006-03-09",
				59.82
			],
			[
				"2008-11-10",
				60.67
			]
		],
		"288194317": [
			[
				"2010-10-05",
				23.81
			],
			[
				"2011-05-11",
				19.89
			],
			[
				"2011-10-11",
				50.92
			],
			[
				"2012-10-09",
				19.51
			],
			[
				"2013-04-16",
				12.31
			],
			[
				"2013-10-08",
				6.7
			],
			[
				"2014-03-13",
				8.46
			],
			[
				"2014-10-14",
				5.4
			],
			[
				"2015-06-22",
				7.17
			],
			[
				"2015-10-16",
				2.8
			],
			[
				"2008-04-18",
				17.51
			],
			[
				"2008-09-18",
				23.71
			],
			[
				"2009-03-18",
				13.4
			],
			[
				"2010-01-25",
				15.42
			],
			[
				"2003-01-17",
				24.21
			],
			[
				"2003-07-15",
				30.91
			],
			[
				"2004-02-16",
				28.51
			],
			[
				"2004-08-17",
				34.71
			],
			[
				"2005-02-21",
				24.81
			],
			[
				"2005-07-21",
				26.21
			],
			[
				"2006-02-13",
				22.51
			],
			[
				"2006-09-20",
				29.41
			],
			[
				"2007-01-16",
				27.51
			],
			[
				"2007-08-21",
				23.91
			],
			[
				"2008-11-10",
				24.49
			]
		],
		"289077217": [
			[
				"2012-04-16",
				54.91
			],
			[
				"2013-04-23",
				45.17
			],
			[
				"2014-07-03",
				36.97
			],
			[
				"2015-07-30",
				44.29
			],
			[
				"2008-06-23",
				52.22
			],
			[
				"2008-11-11",
				51.42
			],
			[
				"2009-04-29",
				47.42
			],
			[
				"2010-02-25",
				35.03
			],
			[
				"2003-03-07",
				38.21
			],
			[
				"2003-10-07",
				32.41
			],
			[
				"2004-02-26",
				28.31
			],
			[
				"2004-11-08",
				23.91
			],
			[
				"2005-06-01",
				29.21
			],
			[
				"2005-09-22",
				31.91
			],
			[
				"2006-02-16",
				38.11
			],
			[
				"2007-01-22",
				49.12
			],
			[
				"2007-09-05",
				51.42
			]
		],
		"289079512": [
			[
				"2011-08-04",
				36.84
			],
			[
				"2012-10-08",
				81.93
			],
			[
				"2013-06-18",
				84.14
			],
			[
				"2014-03-17",
				47.83
			],
			[
				"2015-04-30",
				54.03
			],
			[
				"2007-11-09",
				55.32
			],
			[
				"2008-09-08",
				37.81
			],
			[
				"2009-06-03",
				37.31
			],
			[
				"2009-06-05",
				37.11
			],
			[
				"2010-01-28",
				53.14
			],
			[
				"2000-03-14",
				46.02
			],
			[
				"2000-09-19",
				48.72
			],
			[
				"2001-05-16",
				46.92
			],
			[
				"2001-09-12",
				46.92
			],
			[
				"2001-10-23",
				46.52
			],
			[
				"2002-02-21",
				47.42
			],
			[
				"2002-09-10",
				48.72
			],
			[
				"2003-05-13",
				47.82
			],
			[
				"2005-04-11",
				43.92
			],
			[
				"2005-09-15",
				46.02
			],
			[
				"2006-02-20",
				45.62
			],
			[
				"2006-09-26",
				50.52
			],
			[
				"2007-01-12",
				54.92
			]
		],
		"289086516": [
			[
				"2010-07-27",
				104.07
			],
			[
				"2012-02-27",
				110.71
			],
			[
				"2013-04-09",
				111.6
			],
			[
				"2014-02-11",
				110.71
			],
			[
				"2015-02-26",
				112.48
			],
			[
				"2015-03-24",
				110.27
			],
			[
				"2015-11-16",
				112.92
			],
			[
				"2007-11-27",
				99.24
			],
			[
				"2008-05-21",
				110.74
			],
			[
				"2008-09-09",
				109.84
			],
			[
				"2009-07-22",
				108.04
			],
			[
				"2000-02-23",
				113.84
			],
			[
				"2000-08-23",
				130.65
			],
			[
				"2001-04-25",
				128.45
			],
			[
				"2001-10-23",
				137.25
			],
			[
				"2002-03-05",
				139.45
			],
			[
				"2002-08-27",
				134.65
			],
			[
				"2003-03-20",
				127.05
			],
			[
				"2003-07-30",
				111.64
			],
			[
				"2004-01-14",
				120.44
			],
			[
				"2004-07-29",
				126.64
			],
			[
				"2005-03-08",
				112.04
			],
			[
				"2005-07-26",
				121.74
			],
			[
				"2006-03-14",
				119.14
			],
			[
				"2006-09-05",
				116.94
			],
			[
				"2006-09-25",
				114.24
			],
			[
				"2007-01-12",
				118.24
			]
		],
		"289193515": [
			[
				"2012-10-16",
				18.38
			],
			[
				"2013-06-17",
				15.5
			],
			[
				"2014-03-17",
				10.05
			],
			[
				"2015-05-21",
				10.67
			],
			[
				"2007-11-09",
				20.61
			],
			[
				"2008-09-05",
				13.4
			],
			[
				"2009-06-03",
				14.31
			],
			[
				"2009-06-12",
				13.6
			],
			[
				"2000-01-14",
				66.42
			],
			[
				"2001-05-16",
				23.61
			],
			[
				"2001-09-19",
				63.72
			],
			[
				"2002-03-14",
				29.21
			],
			[
				"2002-09-10",
				40.11
			],
			[
				"2003-03-11",
				29.61
			],
			[
				"2003-07-16",
				57.12
			],
			[
				"2004-02-09",
				51.42
			],
			[
				"2004-09-03",
				21.61
			],
			[
				"2005-03-07",
				22.71
			],
			[
				"2005-08-19",
				32.71
			],
			[
				"2005-08-25",
				33.01
			],
			[
				"2006-03-08",
				37.21
			],
			[
				"2006-09-26",
				42.72
			],
			[
				"2006-12-06",
				44.72
			],
			[
				"2007-01-15",
				47.82
			]
		],
		"289194611": [
			[
				"2011-08-05",
				33.61
			],
			[
				"2012-10-16",
				28.34
			],
			[
				"2013-06-17",
				22.63
			],
			[
				"2014-03-17",
				27.1
			],
			[
				"2015-05-21",
				23.47
			],
			[
				"2007-10-23",
				26.51
			],
			[
				"2008-09-05",
				27.51
			],
			[
				"2009-05-29",
				32.91
			],
			[
				"2010-03-12",
				37.28
			],
			[
				"2000-03-20",
				35.91
			],
			[
				"2000-08-17",
				29.51
			],
			[
				"2001-05-17",
				29.41
			],
			[
				"2001-09-19",
				43.32
			],
			[
				"2002-03-14",
				34.41
			],
			[
				"2002-09-09",
				41.31
			],
			[
				"2003-02-05",
				36.91
			],
			[
				"2003-07-15",
				44.32
			],
			[
				"2004-02-09",
				37.51
			],
			[
				"2004-09-03",
				27.81
			],
			[
				"2005-03-07",
				24.11
			],
			[
				"2005-08-02",
				30.21
			],
			[
				"2006-03-08",
				28.31
			],
			[
				"2006-09-26",
				26.71
			],
			[
				"2007-01-15",
				29.11
			]
		],
		"289194714": [
			[
				"2010-04-29",
				27.15
			],
			[
				"2011-05-09",
				26.79
			],
			[
				"2012-11-14",
				32.5
			],
			[
				"2013-04-16",
				34.14
			],
			[
				"2014-03-06",
				31.71
			],
			[
				"2015-06-02",
				34.94
			],
			[
				"2007-10-23",
				23.51
			],
			[
				"2008-09-08",
				27.81
			],
			[
				"2009-05-25",
				26.41
			],
			[
				"2000-01-12",
				11.9
			],
			[
				"2000-07-11",
				28.41
			],
			[
				"2001-05-18",
				34.51
			],
			[
				"2001-09-26",
				49.62
			],
			[
				"2002-03-15",
				54.42
			],
			[
				"2002-09-10",
				31.71
			],
			[
				"2003-04-14",
				35.21
			],
			[
				"2003-08-21",
				32.31
			],
			[
				"2004-02-11",
				25.11
			],
			[
				"2004-09-06",
				26.51
			],
			[
				"2005-02-25",
				22.91
			],
			[
				"2005-07-26",
				20.51
			],
			[
				"2006-02-21",
				16.91
			],
			[
				"2006-09-28",
				19.61
			],
			[
				"2007-01-16",
				22.61
			]
		],
		"289194910": [
			[
				"2010-07-28",
				21.83
			],
			[
				"2013-06-24",
				28.87
			],
			[
				"2014-06-23",
				30.91
			],
			[
				"2015-05-18",
				29.32
			],
			[
				"2008-06-18",
				30.21
			],
			[
				"2008-11-12",
				26.21
			],
			[
				"2009-05-27",
				26.41
			],
			[
				"2000-02-11",
				32.51
			],
			[
				"2000-08-09",
				33.51
			],
			[
				"2001-02-08",
				30.41
			],
			[
				"2001-11-06",
				33.01
			],
			[
				"2002-05-22",
				32.41
			],
			[
				"2002-10-22",
				30.01
			],
			[
				"2003-03-18",
				27.51
			],
			[
				"2003-10-10",
				26.31
			],
			[
				"2004-03-16",
				25.41
			],
			[
				"2004-09-15",
				27.61
			],
			[
				"2005-03-23",
				25.51
			],
			[
				"2005-09-26",
				26.51
			],
			[
				"2006-03-07",
				24.11
			],
			[
				"2007-09-17",
				24.31
			]
		],
		"289195019": [
			[
				"2013-04-24",
				0.2
			],
			[
				"2014-07-03",
				0.2
			],
			[
				"2015-07-06",
				0.89
			],
			[
				"2007-09-05",
				0.2
			],
			[
				"2008-06-17",
				0.2
			],
			[
				"2008-11-11",
				0.2
			],
			[
				"2009-06-05",
				0.2
			]
		],
		"289195810": [
			[
				"2011-05-09",
				29.67
			],
			[
				"2012-11-14",
				34.63
			],
			[
				"2013-04-16",
				43.09
			],
			[
				"2014-03-17",
				33.39
			],
			[
				"2015-05-18",
				36.66
			],
			[
				"2008-04-18",
				50.92
			],
			[
				"2008-09-18",
				23.31
			],
			[
				"2009-03-18",
				59.32
			],
			[
				"2010-01-25",
				51.81
			],
			[
				"2000-01-06",
				58.42
			],
			[
				"2000-07-10",
				32.71
			],
			[
				"2001-01-03",
				49.12
			],
			[
				"2001-07-12",
				31.61
			],
			[
				"2002-01-25",
				53.12
			],
			[
				"2002-07-05",
				27.31
			],
			[
				"2003-01-30",
				49.62
			],
			[
				"2003-07-16",
				20.91
			],
			[
				"2004-03-12",
				37.21
			],
			[
				"2004-09-07",
				33.41
			],
			[
				"2005-02-22",
				49.62
			],
			[
				"2005-07-28",
				23.91
			],
			[
				"2006-02-16",
				35.51
			],
			[
				"2007-08-21",
				27.91
			]
		],
		"289196413": [
			[
				"2011-07-14",
				0.2
			],
			[
				"2013-04-17",
				0.2
			],
			[
				"2014-03-18",
				0.2
			],
			[
				"2015-05-18",
				0.89
			],
			[
				"2008-04-22",
				0.2
			],
			[
				"2008-09-19",
				0.2
			],
			[
				"2009-03-18",
				0.2
			],
			[
				"2002-04-09",
				0.2
			],
			[
				"2004-09-08",
				0.2
			],
			[
				"2005-07-27",
				0.2
			],
			[
				"2007-08-22",
				0.2
			]
		]
	};

/***/ }),
/* 43 */
/***/ (function(module, exports) {

	module.exports = {
		"": [
			{
				"mstnr": "219606614",
				"date": "2015-07-08",
				"value": 4.91,
				"mstbez": "Flossd. 10"
			},
			{
				"mstnr": "219675119",
				"date": "2015-12-15",
				"value": 0.89,
				"mstbez": "Wildnis"
			}
		],
		"Beelen": {
			"stations": [
				{
					"mstnr": "110060234",
					"date": "2015-11-17",
					"value": 22.59,
					"mstbez": "VI/23 -BEELEN-"
				}
			],
			"plz": "48361"
		},
		"Hamm": {
			"stations": [
				{
					"mstnr": "91120202",
					"date": "2015-06-17",
					"value": 1.33,
					"mstbez": "Hamm Lerche ML 21"
				},
				{
					"mstnr": "91130700",
					"date": "2015-06-17",
					"value": 1.33,
					"mstbez": "Hamm-Mark ML4"
				},
				{
					"mstnr": "91130608",
					"date": "2015-06-17",
					"value": 1.33,
					"mstbez": "Rhynern ML44"
				},
				{
					"mstnr": "91130803",
					"date": "2015-06-23",
					"value": 2.44,
					"mstbez": "Allen ML58"
				},
				{
					"mstnr": "91130906",
					"date": "2015-06-23",
					"value": 12.58,
					"mstbez": "Osttünnen ML46"
				},
				{
					"mstnr": "94120377",
					"date": "2015-10-13",
					"value": 1.33,
					"mstbez": "Bockum-Höv HA-IC-14"
				},
				{
					"mstnr": "91131406",
					"date": "2015-10-12",
					"value": 1.33,
					"mstbez": "Süddinker ML57"
				},
				{
					"mstnr": "91132204",
					"date": "2015-10-12",
					"value": 1.33,
					"mstbez": "Norddinker ML70"
				},
				{
					"mstnr": "94120365",
					"date": "2015-04-16",
					"value": 1.33,
					"mstbez": "Quelle Halloh-Park"
				},
				{
					"mstnr": "94120390",
					"date": "2015-04-16",
					"value": 35.87,
					"mstbez": "Quelle Geinegge"
				},
				{
					"mstnr": "91131005",
					"date": "2015-06-23",
					"value": 3.19,
					"mstbez": "Ostwennemar ML41"
				}
			],
			"plz": "59065"
		},
		"Leichlingen (Rhld.)": {
			"stations": [
				{
					"mstnr": "76734985",
					"date": "2015-04-01",
					"value": 52.26,
					"mstbez": "PGHM.WELTERSB. SS"
				},
				{
					"mstnr": "76727609",
					"date": "2015-04-01",
					"value": 1.33,
					"mstbez": "KRONENBG. LEICHL EB"
				}
			],
			"plz": "42799"
		},
		"Kirchlengern": {
			"stations": [
				{
					"mstnr": "106506195",
					"date": "2015-04-14",
					"value": 1,
					"mstbez": "HB 2 BR  HAEVER EWB"
				},
				{
					"mstnr": "106502578",
					"date": "2015-10-05",
					"value": 1,
					"mstbez": "SPRA2 BR SPRADOW"
				},
				{
					"mstnr": "106502578",
					"date": "2015-04-14",
					"value": 4,
					"mstbez": "SPRA2 BR SPRADOW"
				},
				{
					"mstnr": "106506195",
					"date": "2015-10-05",
					"value": 1,
					"mstbez": "HB 2 BR  HAEVER EWB"
				}
			],
			"plz": "32278"
		},
		"Bad Münstereifel": {
			"stations": [
				{
					"mstnr": "10307229",
					"date": "2015-04-15",
					"value": 18.82,
					"mstbez": "Arloff P 5.2 neu"
				},
				{
					"mstnr": "10407297",
					"date": "2015-07-01",
					"value": 18.96,
					"mstbez": "Engelbertus-Brunnen"
				},
				{
					"mstnr": "10407297",
					"date": "2015-10-14",
					"value": 18.78,
					"mstbez": "Engelbertus-Brunnen"
				},
				{
					"mstnr": "10409993",
					"date": "2015-06-18",
					"value": 11.07,
					"mstbez": "Krausquelle"
				},
				{
					"mstnr": "10410004",
					"date": "2015-12-10",
					"value": 10.94,
					"mstbez": "Lachbachquelle"
				},
				{
					"mstnr": "10307217",
					"date": "2015-04-15",
					"value": 77.06,
					"mstbez": "Arloff  P 5.1"
				}
			],
			"plz": "53902"
		},
		"Elsdorf": {
			"stations": [
				{
					"mstnr": "278766511",
					"date": "2015-10-13",
					"value": 1.7,
					"mstbez": "Nördl. Esch"
				}
			],
			"plz": "50189"
		},
		"Frechen": {
			"stations": [
				{
					"mstnr": "278506616",
					"date": "2015-10-15",
					"value": 1.33,
					"mstbez": "Kippe Benzelrath"
				},
				{
					"mstnr": "70148715",
					"date": "2015-07-14",
					"value": 22.59,
					"mstbez": "LGD KOENIGSDF.NEU"
				},
				{
					"mstnr": "278506616",
					"date": "2015-10-15",
					"value": 0.5,
					"mstbez": "Kippe Benzelrath"
				}
			],
			"plz": "50226"
		},
		"Spenge": {
			"stations": [
				{
					"mstnr": "100160025",
					"date": "2015-06-30",
					"value": 31.18,
					"mstbez": "LF 2 Spenge Werther"
				}
			],
			"plz": "32139"
		},
		"Bornheim": {
			"stations": [
				{
					"mstnr": "70199619",
					"date": "2015-04-29",
					"value": 44.73,
					"mstbez": "LGD HERSEL RP 4n"
				},
				{
					"mstnr": "70200210",
					"date": "2015-06-01",
					"value": 20.68,
					"mstbez": "LGD HERSEL RP 5n"
				},
				{
					"mstnr": "70200816",
					"date": "2015-08-12",
					"value": 15.41,
					"mstbez": "LGD Widdig GEW 115"
				},
				{
					"mstnr": "70201213",
					"date": "2015-08-12",
					"value": 68.02,
					"mstbez": "LGD Widdig GEW 132"
				},
				{
					"mstnr": "70203416",
					"date": "2015-05-26",
					"value": 147.91,
					"mstbez": "LGD BORNHEIM B4/99"
				},
				{
					"mstnr": "70203817",
					"date": "2015-05-28",
					"value": 162.53,
					"mstbez": "LGD Sechtem Plantag"
				},
				{
					"mstnr": "70203910",
					"date": "2015-04-20",
					"value": 18.95,
					"mstbez": "LGD Bornh. Sportpl."
				}
			],
			"plz": "53332"
		},
		"Kalletal": {
			"stations": [
				{
					"mstnr": "106506020",
					"date": "2015-04-09",
					"value": 18.01,
					"mstbez": "KLUED BR LUEDENHAUS"
				},
				{
					"mstnr": "106506079",
					"date": "2015-10-15",
					"value": 5,
					"mstbez": "KWEST BR WESTORF"
				},
				{
					"mstnr": "106506067",
					"date": "2015-04-09",
					"value": 48.02,
					"mstbez": "KHELL BR HELLBERG"
				},
				{
					"mstnr": "100748454",
					"date": "2015-02-12",
					"value": 37.2,
					"mstbez": "KS 5 QU  Kalld.Satl"
				},
				{
					"mstnr": "106506043",
					"date": "2015-10-15",
					"value": 9,
					"mstbez": "KSTEM BR STEMMEN"
				},
				{
					"mstnr": "106506043",
					"date": "2015-04-09",
					"value": 11,
					"mstbez": "KSTEM BR STEMMEN"
				},
				{
					"mstnr": "106506031",
					"date": "2015-04-09",
					"value": 13,
					"mstbez": "KVARE BR VARENHOLZ"
				},
				{
					"mstnr": "106506067",
					"date": "2015-10-15",
					"value": 33.01,
					"mstbez": "KHELL BR HELLBERG"
				},
				{
					"mstnr": "106506080",
					"date": "2015-10-15",
					"value": 19.01,
					"mstbez": "KBROS BR BROSEN"
				},
				{
					"mstnr": "106506079",
					"date": "2015-04-09",
					"value": 9,
					"mstbez": "KWEST BR WESTORF"
				},
				{
					"mstnr": "106506080",
					"date": "2015-04-09",
					"value": 17.01,
					"mstbez": "KBROS BR BROSEN"
				},
				{
					"mstnr": "106506109",
					"date": "2015-10-15",
					"value": 38.01,
					"mstbez": "KTALL BR TALLE"
				},
				{
					"mstnr": "106506109",
					"date": "2015-04-09",
					"value": 44.02,
					"mstbez": "KTALL BR TALLE"
				},
				{
					"mstnr": "106506110",
					"date": "2015-07-27",
					"value": 11,
					"mstbez": "HOHN BR  WBV HOHENH"
				},
				{
					"mstnr": "106506031",
					"date": "2015-10-15",
					"value": 13,
					"mstbez": "KVARE BR VARENHOLZ"
				},
				{
					"mstnr": "106506020",
					"date": "2015-10-15",
					"value": 17.01,
					"mstbez": "KLUED BR LUEDENHAUS"
				}
			],
			"plz": "32689"
		},
		"Meerbusch": {
			"stations": [
				{
					"mstnr": "86594606",
					"date": "2015-11-09",
					"value": 49.52,
					"mstbez": "E BG Osterath Br.1"
				},
				{
					"mstnr": "86594606",
					"date": "2015-02-02",
					"value": 54.42,
					"mstbez": "E BG Osterath Br.1"
				},
				{
					"mstnr": "80301307",
					"date": "2015-07-03",
					"value": 14.17,
					"mstbez": "LANK LATUM"
				},
				{
					"mstnr": "86551863",
					"date": "2015-10-08",
					"value": 71.43,
					"mstbez": "E Rheinfähre HBr.1"
				},
				{
					"mstnr": "86551863",
					"date": "2015-05-07",
					"value": 57.32,
					"mstbez": "E Rheinfähre HBr.1"
				},
				{
					"mstnr": "86594606",
					"date": "2015-05-18",
					"value": 45.92,
					"mstbez": "E BG Osterath Br.1"
				},
				{
					"mstnr": "80200357",
					"date": "2015-10-15",
					"value": 17.49,
					"mstbez": "MEERERBUSCH   Nr 88"
				}
			],
			"plz": "40667"
		},
		"Wermelskirchen": {
			"stations": [
				{
					"mstnr": "73737380",
					"date": "2015-04-08",
					"value": 10.45,
					"mstbez": "WG GROSSFRENKHSN QF"
				},
				{
					"mstnr": "76832314",
					"date": "2015-08-04",
					"value": 67.31,
					"mstbez": "SW WERMELSK. B 1"
				}
			],
			"plz": "42929"
		},
		"Nörvenich": {
			"stations": [
				{
					"mstnr": "10200691",
					"date": "2015-04-23",
					"value": 110.27,
					"mstbez": "ISWEILER NR.290"
				},
				{
					"mstnr": "219483218",
					"date": "2015-12-08",
					"value": 187.77,
					"mstbez": "Nörvenich 2"
				},
				{
					"mstnr": "219482410",
					"date": "2015-08-19",
					"value": 9.78,
					"mstbez": "Bubenheim"
				},
				{
					"mstnr": "219480618",
					"date": "2015-12-09",
					"value": 59.34,
					"mstbez": "Eschw.Ue.F"
				}
			],
			"plz": "52388"
		},
		"Rietberg": {
			"stations": [
				{
					"mstnr": "21000610",
					"date": "2015-10-28",
					"value": 18.2,
					"mstbez": "657LGD Neuenkirchen"
				},
				{
					"mstnr": "20104030",
					"date": "2015-10-15",
					"value": 1.33,
					"mstbez": "IB/3A LGD Bokel"
				}
			],
			"plz": "33397"
		},
		"Lüdinghausen": {
			"stations": [
				{
					"mstnr": "110210130",
					"date": "2015-11-02",
					"value": 1.33,
					"mstbez": "ST.GEB/13-LUEDINGHS"
				},
				{
					"mstnr": "110210190",
					"date": "2015-11-18",
					"value": 152.34,
					"mstbez": "ST.GEB/19 Leversum"
				},
				{
					"mstnr": "110220870",
					"date": "2015-11-24",
					"value": 61.56,
					"mstbez": "HS/87 EMKUMER MARK"
				}
			],
			"plz": "59348"
		},
		"Schwerte": {
			"stations": [
				{
					"mstnr": "99780112",
					"date": "2015-04-13",
					"value": 17.71,
					"mstbez": "TB Baumschule Kay"
				}
			],
			"plz": "58239"
		},
		"Südlohn": {
			"stations": [
				{
					"mstnr": "60240260",
					"date": "2015-04-21",
					"value": 1.33,
					"mstbez": "AH/26 -SUEDLOHN-"
				}
			],
			"plz": "46354"
		},
		"Iserlohn": {
			"stations": [
				{
					"mstnr": "59620183",
					"date": "2015-03-16",
					"value": 22.01,
					"mstbez": "MEDICE_B"
				},
				{
					"mstnr": "59621280",
					"date": "2015-10-14",
					"value": 15.41,
					"mstbez": "Kreishaus"
				},
				{
					"mstnr": "59621291",
					"date": "2015-08-31",
					"value": 24.93,
					"mstbez": "Ahm"
				},
				{
					"mstnr": "59621151",
					"date": "2015-10-07",
					"value": 30.29,
					"mstbez": "Musikschule"
				},
				{
					"mstnr": "59621230",
					"date": "2015-09-09",
					"value": 2.43,
					"mstbez": "Griesenbrauck P5"
				},
				{
					"mstnr": "59620870",
					"date": "2015-02-02",
					"value": 15.01,
					"mstbez": "Iser.Krug von Nidda"
				},
				{
					"mstnr": "59620869",
					"date": "2015-02-03",
					"value": 11.5,
					"mstbez": "Iserl.Wermingsertal"
				},
				{
					"mstnr": "59621321",
					"date": "2015-09-30",
					"value": 14.35,
					"mstbez": "Pater und Nonne"
				}
			],
			"plz": "58636"
		},
		"Herdecke": {
			"stations": [
				{
					"mstnr": "59540187",
					"date": "2015-03-24",
					"value": 1.33,
					"mstbez": "Gut Schede"
				}
			],
			"plz": "58313"
		},
		"Herford": {
			"stations": [
				{
					"mstnr": "100742208",
					"date": "2015-03-31",
					"value": 1,
					"mstbez": "HB 4 BR  AM HOCHBEH"
				},
				{
					"mstnr": "100741010",
					"date": "2015-03-31",
					"value": 6,
					"mstbez": "HF RMW Brunnenstr"
				}
			],
			"plz": "32052"
		},
		"Remscheid": {
			"stations": [
				{
					"mstnr": "30302079",
					"date": "2015-12-16",
					"value": 26.08,
					"mstbez": "Rem-Erdelenstraße"
				},
				{
					"mstnr": "34709010",
					"date": "2015-09-17",
					"value": 22.5,
					"mstbez": "Dep. Diehl GWM 1"
				}
			],
			"plz": "42853"
		},
		"Schalksmühle": {
			"stations": [
				{
					"mstnr": "59620997",
					"date": "2015-08-19",
					"value": 10.5,
					"mstbez": "Lauenscheid"
				}
			],
			"plz": "58579"
		},
		"Bergisch Gladbach": {
			"stations": [
				{
					"mstnr": "76866713",
					"date": "2015-07-22",
					"value": 16.74,
					"mstbez": "RBK ALTABL.STELLA 1"
				},
				{
					"mstnr": "76931912",
					"date": "2015-07-27",
					"value": 38.62,
					"mstbez": "RBK ALTABL.TH-FLI 1"
				},
				{
					"mstnr": "76886414",
					"date": "2015-07-23",
					"value": 46.06,
					"mstbez": "RBK ALTABL. NUSSB.1"
				},
				{
					"mstnr": "76929012",
					"date": "2015-07-28",
					"value": 1.33,
					"mstbez": "ZANDERS BGL 2/98"
				},
				{
					"mstnr": "76929218",
					"date": "2015-07-28",
					"value": 15.37,
					"mstbez": "ZANDERS BGL 4/98"
				},
				{
					"mstnr": "76819310",
					"date": "2015-07-23",
					"value": 23.74,
					"mstbez": "RBK ALTABL.B2/1"
				}
			],
			"plz": "51465"
		},
		"Bonn": {
			"stations": [
				{
					"mstnr": "70204214",
					"date": "2015-06-02",
					"value": 13.2,
					"mstbez": "LGD Beuel Bergweg"
				},
				{
					"mstnr": "76632015",
					"date": "2015-05-21",
					"value": 17.01,
					"mstbez": "BN Altabl. BP 72"
				},
				{
					"mstnr": "76839217",
					"date": "2015-05-13",
					"value": 7.13,
					"mstbez": "BN ALTABL. BP 78"
				},
				{
					"mstnr": "76839916",
					"date": "2015-05-13",
					"value": 1.33,
					"mstbez": "BN Altabl. BP 85"
				},
				{
					"mstnr": "76840116",
					"date": "2015-05-13",
					"value": 1.68,
					"mstbez": "BN Altabl. BP 87"
				},
				{
					"mstnr": "70134212",
					"date": "2015-10-12",
					"value": 33.39,
					"mstbez": "LGD BN KREUZKIRCHE"
				},
				{
					"mstnr": "70196515",
					"date": "2015-04-23",
					"value": 25.55,
					"mstbez": "LGD OBERKASSEL"
				},
				{
					"mstnr": "70284118",
					"date": "2015-06-03",
					"value": 19.71,
					"mstbez": "LGD BN WALDAU"
				},
				{
					"mstnr": "70284015",
					"date": "2015-05-18",
					"value": 17.05,
					"mstbez": "LGD BN KOTTENF. 4"
				},
				{
					"mstnr": "70283813",
					"date": "2015-06-03",
					"value": 21.88,
					"mstbez": "LGD BN VENNE"
				},
				{
					"mstnr": "70276110",
					"date": "2015-07-08",
					"value": 22.41,
					"mstbez": "LGD BN-MEHLEM"
				},
				{
					"mstnr": "70276018",
					"date": "2015-04-16",
					"value": 35.12,
					"mstbez": "LGD BN-RUENGSDORF"
				},
				{
					"mstnr": "70270016",
					"date": "2015-05-19",
					"value": 35.56,
					"mstbez": "LGD LESSENICH"
				},
				{
					"mstnr": "70205218",
					"date": "2015-06-10",
					"value": 22.9,
					"mstbez": "LGD Beuel Kreuz BAB"
				}
			],
			"plz": "53111"
		},
		"Willich": {
			"stations": [
				{
					"mstnr": "80302040",
					"date": "2015-11-27",
					"value": 66.87,
					"mstbez": "VENNHEIDE"
				},
				{
					"mstnr": "80302518",
					"date": "2015-01-12",
					"value": 31.58,
					"mstbez": "WILLICH   FESTPLATZ"
				},
				{
					"mstnr": "80301290",
					"date": "2015-12-03",
					"value": 4.83,
					"mstbez": "DICKERHEIDE     277"
				},
				{
					"mstnr": "80302981",
					"date": "2015-02-27",
					"value": 1.42,
					"mstbez": "ANRATH          375"
				},
				{
					"mstnr": "86592786",
					"date": "2015-05-21",
					"value": 121.24,
					"mstbez": "WW FELLERHÖFE  E VI"
				},
				{
					"mstnr": "86592786",
					"date": "2015-11-04",
					"value": 117.34,
					"mstbez": "WW FELLERHÖFE  E VI"
				},
				{
					"mstnr": "86592786",
					"date": "2015-02-05",
					"value": 121.74,
					"mstbez": "WW FELLERHÖFE  E VI"
				}
			],
			"plz": "47877"
		},
		"Oberhausen": {
			"stations": [
				{
					"mstnr": "40406015",
					"date": "2015-06-23",
					"value": 32.73,
					"mstbez": "Bremenkampstr"
				},
				{
					"mstnr": "40100091",
					"date": "2015-04-29",
					"value": 24.93,
					"mstbez": "LANDWEHR"
				}
			],
			"plz": "46045"
		},
		"Preußisch Oldendorf": {
			"stations": [
				{
					"mstnr": "100706680",
					"date": "2015-05-19",
					"value": 19.01,
					"mstbez": "HE 10 BR HEDEM"
				},
				{
					"mstnr": "100706940",
					"date": "2015-11-10",
					"value": 1,
					"mstbez": "HE 6A BR HEDEM"
				},
				{
					"mstnr": "100701255",
					"date": "2015-03-02",
					"value": 2,
					"mstbez": "HA 4  BR HARLINGHSN"
				},
				{
					"mstnr": "100706940",
					"date": "2015-05-19",
					"value": 1,
					"mstbez": "HE 6A BR HEDEM"
				},
				{
					"mstnr": "100701255",
					"date": "2015-09-28",
					"value": 1,
					"mstbez": "HA 4  BR HARLINGHSN"
				},
				{
					"mstnr": "100706680",
					"date": "2015-11-10",
					"value": 20.01,
					"mstbez": "HE 10 BR HEDEM"
				},
				{
					"mstnr": "106503820",
					"date": "2015-03-02",
					"value": 3,
					"mstbez": "BO 1 TB  BOERNINGHS"
				},
				{
					"mstnr": "106503820",
					"date": "2015-09-28",
					"value": 3,
					"mstbez": "BO 1 TB  BOERNINGHS"
				}
			],
			"plz": "32361"
		},
		"Viersen": {
			"stations": [
				{
					"mstnr": "80201581",
					"date": "2015-08-27",
					"value": 104.51,
					"mstbez": "SCHMALENEND 201"
				},
				{
					"mstnr": "80303353",
					"date": "2015-10-14",
					"value": 26.93,
					"mstbez": "VIERSEN KÖRNER  398"
				},
				{
					"mstnr": "80200953",
					"date": "2015-06-18",
					"value": 74.84,
					"mstbez": "BOCKERT         183"
				},
				{
					"mstnr": "80301277",
					"date": "2015-06-18",
					"value": 0.13,
					"mstbez": "CLOERATH        275"
				},
				{
					"mstnr": "80302798",
					"date": "2015-09-04",
					"value": 40.7,
					"mstbez": "SÜCHTELN        350"
				},
				{
					"mstnr": "80201600",
					"date": "2015-08-27",
					"value": 112.04,
					"mstbez": "RÖHLENEND 203"
				}
			],
			"plz": "41747"
		},
		"Issum": {
			"stations": [
				{
					"mstnr": "80302208",
					"date": "2015-08-26",
					"value": 0.4,
					"mstbez": "SECKELSHEIDE"
				},
				{
					"mstnr": "80303328",
					"date": "2015-03-27",
					"value": 15.85,
					"mstbez": "ISSUM           395"
				}
			],
			"plz": "47661"
		},
		"Gütersloh": {
			"stations": [
				{
					"mstnr": "26541142",
					"date": "2015-09-29",
					"value": 121.34,
					"mstbez": "769-7,0m ML Pavenst"
				},
				{
					"mstnr": "21000268",
					"date": "2015-10-28",
					"value": 3.99,
					"mstbez": "622.2M Avenwedde"
				},
				{
					"mstnr": "26541129",
					"date": "2015-09-29",
					"value": 167.4,
					"mstbez": "769-4,0m MLPavenst"
				},
				{
					"mstnr": "21000347",
					"date": "2015-10-15",
					"value": 80.6,
					"mstbez": "630             LGD"
				},
				{
					"mstnr": "26525057",
					"date": "2015-10-28",
					"value": 3.9,
					"mstbez": "622.3 T Avenwedde"
				},
				{
					"mstnr": "21000426",
					"date": "2015-10-28",
					"value": 1.33,
					"mstbez": "638             SwG"
				},
				{
					"mstnr": "26525045",
					"date": "2015-10-28",
					"value": 2.88,
					"mstbez": "622.1 F Avenwedde"
				},
				{
					"mstnr": "26541130",
					"date": "2015-09-29",
					"value": 176.7,
					"mstbez": "769-5,5m ML Pavenst"
				},
				{
					"mstnr": "20102082",
					"date": "2015-10-15",
					"value": 2.61,
					"mstbez": "II/11 A  Gütersloh"
				},
				{
					"mstnr": "26490997",
					"date": "2015-05-20",
					"value": 13.6,
					"mstbez": "BR10a    Spexard"
				},
				{
					"mstnr": "26541154",
					"date": "2015-09-29",
					"value": 19.62,
					"mstbez": "769-9,0m ML Pavenst"
				},
				{
					"mstnr": "21001789",
					"date": "2015-09-29",
					"value": 1.33,
					"mstbez": "769 ML Pavenstaedt"
				}
			],
			"plz": "33330"
		},
		"Hallenberg": {
			"stations": [
				{
					"mstnr": "94170356",
					"date": "2015-09-24",
					"value": 4.47,
					"mstbez": "Quelle Hude"
				},
				{
					"mstnr": "94170344",
					"date": "2015-04-28",
					"value": 8.41,
					"mstbez": "Quelle Mertensborn"
				},
				{
					"mstnr": "99580172",
					"date": "2015-09-24",
					"value": 20.24,
					"mstbez": "TB Struth"
				}
			],
			"plz": "59969"
		},
		"Geseke": {
			"stations": [
				{
					"mstnr": "91166603",
					"date": "2015-06-22",
					"value": 96.1,
					"mstbez": "Bruecke OL 739"
				},
				{
					"mstnr": "94170459",
					"date": "2015-04-15",
					"value": 42.51,
					"mstbez": "Geseker Spring"
				},
				{
					"mstnr": "91165908",
					"date": "2015-10-20",
					"value": 3.14,
					"mstbez": "Mönninghausen OL730"
				},
				{
					"mstnr": "91164916",
					"date": "2015-06-22",
					"value": 1.33,
					"mstbez": "Bönninghausen neu"
				}
			],
			"plz": "59590"
		},
		"Pulheim": {
			"stations": [
				{
					"mstnr": "70198111",
					"date": "2015-08-19",
					"value": 35.87,
					"mstbez": "LGD GEYEN"
				},
				{
					"mstnr": "279375610",
					"date": "2015-06-19",
					"value": 7.22,
					"mstbez": "Stommbusch II"
				},
				{
					"mstnr": "73560110",
					"date": "2015-07-01",
					"value": 39.33,
					"mstbez": "Sinnersdorf 671"
				}
			],
			"plz": "50259"
		},
		"Hopsten": {
			"stations": [
				{
					"mstnr": "110200196",
					"date": "2015-04-01",
					"value": 1.33,
					"mstbez": "TE/19 -HOPSTEN-"
				},
				{
					"mstnr": "110200214",
					"date": "2015-03-30",
					"value": 180.24,
					"mstbez": "TE/21 -SCHALE-"
				},
				{
					"mstnr": "110200226",
					"date": "2015-03-26",
					"value": 30.16,
					"mstbez": "TE/22 -HALVERDE-"
				}
			],
			"plz": "48496"
		},
		"Geldern": {
			"stations": [
				{
					"mstnr": "86612025",
					"date": "2015-10-13",
					"value": 5.08,
					"mstbez": "E WW GELDERN Br.IV"
				},
				{
					"mstnr": "80303237",
					"date": "2015-08-25",
					"value": 36.4,
					"mstbez": "SPORTPLATZ      386"
				},
				{
					"mstnr": "86612025",
					"date": "2015-07-08",
					"value": 4.18,
					"mstbez": "E WW GELDERN Br.IV"
				},
				{
					"mstnr": "80302180",
					"date": "2015-03-20",
					"value": 62.89,
					"mstbez": "HOHEN-HOLTAPPEL"
				},
				{
					"mstnr": "86612025",
					"date": "2015-03-09",
					"value": 7.42,
					"mstbez": "E WW GELDERN Br.IV"
				},
				{
					"mstnr": "80303330",
					"date": "2015-10-12",
					"value": 32.02,
					"mstbez": "VERNUM          396"
				},
				{
					"mstnr": "80300996",
					"date": "2015-08-25",
					"value": 38.79,
					"mstbez": "NIERSKANAL      247"
				},
				{
					"mstnr": "80303390",
					"date": "2015-07-01",
					"value": 42.07,
					"mstbez": "WALBECK WALD    402"
				}
			],
			"plz": "47608"
		},
		"Warburg": {
			"stations": [
				{
					"mstnr": "26501454",
					"date": "2015-10-21",
					"value": 19.01,
					"mstbez": "QU Scherfede"
				},
				{
					"mstnr": "26501302",
					"date": "2015-05-20",
					"value": 17.01,
					"mstbez": "BR 1   Warburg-Kern"
				},
				{
					"mstnr": "26501302",
					"date": "2015-10-21",
					"value": 12,
					"mstbez": "BR 1   Warburg-Kern"
				},
				{
					"mstnr": "26501405",
					"date": "2015-10-21",
					"value": 17.01,
					"mstbez": "BR Bonenburg"
				},
				{
					"mstnr": "26501417",
					"date": "2015-05-20",
					"value": 25.01,
					"mstbez": "BR Ossendorf"
				},
				{
					"mstnr": "26501417",
					"date": "2015-10-21",
					"value": 15.01,
					"mstbez": "BR Ossendorf"
				},
				{
					"mstnr": "26501429",
					"date": "2015-05-20",
					"value": 21.01,
					"mstbez": "BR Germete"
				},
				{
					"mstnr": "26501405",
					"date": "2015-05-20",
					"value": 15.01,
					"mstbez": "BR Bonenburg"
				},
				{
					"mstnr": "26501429",
					"date": "2015-10-21",
					"value": 17.01,
					"mstbez": "BR Germete"
				},
				{
					"mstnr": "26501430",
					"date": "2015-05-20",
					"value": 45.02,
					"mstbez": "BR Welda"
				},
				{
					"mstnr": "26501430",
					"date": "2015-10-21",
					"value": 44.02,
					"mstbez": "BR Welda"
				},
				{
					"mstnr": "26501491",
					"date": "2015-10-21",
					"value": 7,
					"mstbez": "TB Noerde"
				},
				{
					"mstnr": "26501491",
					"date": "2015-05-20",
					"value": 8,
					"mstbez": "TB Noerde"
				},
				{
					"mstnr": "26501454",
					"date": "2015-05-20",
					"value": 19.01,
					"mstbez": "QU Scherfede"
				},
				{
					"mstnr": "26501480",
					"date": "2015-10-21",
					"value": 1,
					"mstbez": "B3 Schwarzbachtal"
				},
				{
					"mstnr": "26501480",
					"date": "2015-05-20",
					"value": 1,
					"mstbez": "B3 Schwarzbachtal"
				}
			],
			"plz": "34414"
		},
		"Schwalmtal": {
			"stations": [
				{
					"mstnr": "80201611",
					"date": "2015-09-04",
					"value": 103.63,
					"mstbez": "RENNEPERSTR. 212"
				},
				{
					"mstnr": "80300662",
					"date": "2015-07-07",
					"value": 31.71,
					"mstbez": "HEIDWEIHER 209"
				},
				{
					"mstnr": "80300686",
					"date": "2015-10-14",
					"value": 112.49,
					"mstbez": "VOGELSRATH 211"
				}
			],
			"plz": "41366"
		},
		"Kranenburg": {
			"stations": [
				{
					"mstnr": "80301502",
					"date": "2015-09-03",
					"value": 50.04,
					"mstbez": "SCHOTTHEIDE     298"
				},
				{
					"mstnr": "80301484",
					"date": "2015-09-28",
					"value": 26.75,
					"mstbez": "MEHR            296"
				},
				{
					"mstnr": "80301460",
					"date": "2015-09-28",
					"value": 31.18,
					"mstbez": "NIEL            294"
				},
				{
					"mstnr": "80301540",
					"date": "2015-09-03",
					"value": 23.74,
					"mstbez": "KARTENSP.WEG    302"
				},
				{
					"mstnr": "80301514",
					"date": "2015-03-16",
					"value": 52.7,
					"mstbez": "GRAFWEGEN       299"
				}
			],
			"plz": "47559"
		},
		"Werl": {
			"stations": [
				{
					"mstnr": "91133609",
					"date": "2015-10-26",
					"value": 38.44,
					"mstbez": "Büderich ML62"
				},
				{
					"mstnr": "94130711",
					"date": "2015-04-01",
					"value": 39.95,
					"mstbez": "Quelle Büderich"
				},
				{
					"mstnr": "94130735",
					"date": "2015-04-01",
					"value": 43.22,
					"mstbez": "Quelle Westönnen"
				},
				{
					"mstnr": "94130723",
					"date": "2015-04-01",
					"value": 47.83,
					"mstbez": "Quelle Kurpark Werl"
				},
				{
					"mstnr": "94130700",
					"date": "2015-04-01",
					"value": 47.83,
					"mstbez": "Quelle Hs Westrich"
				}
			],
			"plz": "59457"
		},
		"Niederkassel": {
			"stations": [
				{
					"mstnr": "70200518",
					"date": "2015-08-10",
					"value": 8.5,
					"mstbez": "LGD MONDORF 1/93"
				},
				{
					"mstnr": "70100214",
					"date": "2015-04-27",
					"value": 3.81,
					"mstbez": "LGD N'KASSEL DEA 3"
				},
				{
					"mstnr": "70197817",
					"date": "2015-04-24",
					"value": 19.53,
					"mstbez": "LGD STOCKEM"
				},
				{
					"mstnr": "70202310",
					"date": "2015-07-20",
					"value": 15.68,
					"mstbez": "LGD MONDORF RP 7n"
				},
				{
					"mstnr": "70197714",
					"date": "2015-01-12",
					"value": 27.81,
					"mstbez": "LGD Uckendf. KSWerk"
				}
			],
			"plz": "53859"
		},
		"Erkrath": {
			"stations": [
				{
					"mstnr": "30302810",
					"date": "2015-03-13",
					"value": 121.34,
					"mstbez": "Erkr-Niermannsweg"
				},
				{
					"mstnr": "30100458",
					"date": "2015-09-18",
					"value": 0.13,
					"mstbez": "Erkr-Morper Allee"
				}
			],
			"plz": "40699"
		},
		"Köln": {
			"stations": [
				{
					"mstnr": "73537410",
					"date": "2015-07-02",
					"value": 32.2,
					"mstbez": "GEW KOELN 570"
				},
				{
					"mstnr": "73512618",
					"date": "2015-06-11",
					"value": 44.02,
					"mstbez": "526 HOENIN"
				},
				{
					"mstnr": "73542015",
					"date": "2015-06-16",
					"value": 35.21,
					"mstbez": "HEIMERSDORF 597"
				},
				{
					"mstnr": "76981113",
					"date": "2015-08-14",
					"value": 1.33,
					"mstbez": "RSK Wahner H. WH11"
				},
				{
					"mstnr": "73785015",
					"date": "2015-06-17",
					"value": 10.27,
					"mstbez": "RGW KOELN WA 032"
				},
				{
					"mstnr": "76965612",
					"date": "2015-04-08",
					"value": 9.4,
					"mstbez": "K ALTABL. A 1652"
				},
				{
					"mstnr": "76934019",
					"date": "2015-08-11",
					"value": 2.21,
					"mstbez": "K ALTABL. A 520"
				},
				{
					"mstnr": "73553815",
					"date": "2015-06-11",
					"value": 22.32,
					"mstbez": "BRAUNSFELD 156 A"
				},
				{
					"mstnr": "73738517",
					"date": "2015-01-20",
					"value": 5,
					"mstbez": "RGW ZD 505"
				},
				{
					"mstnr": "76555112",
					"date": "2015-07-14",
					"value": 49.16,
					"mstbez": "MUELHENS K 6 R1"
				},
				{
					"mstnr": "73561915",
					"date": "2015-06-30",
					"value": 36.4,
					"mstbez": "GEW KOELN 681"
				},
				{
					"mstnr": "73564217",
					"date": "2015-07-03",
					"value": 28.3,
					"mstbez": "GEW KOELN 702"
				},
				{
					"mstnr": "73567012",
					"date": "2015-06-22",
					"value": 46.06,
					"mstbez": "GEW Köln 373A-tief"
				},
				{
					"mstnr": "76744218",
					"date": "2015-10-22",
					"value": 19.11,
					"mstbez": "BASF K-Mülh. 1"
				},
				{
					"mstnr": "73546010",
					"date": "2015-06-16",
					"value": 37.07,
					"mstbez": "THENHOVEN 622"
				},
				{
					"mstnr": "73512515",
					"date": "2015-10-05",
					"value": 18.41,
					"mstbez": "GEW KOELN 525"
				},
				{
					"mstnr": "76806420",
					"date": "2015-08-06",
					"value": 18.25,
					"mstbez": "K ALTABL. A 15b"
				},
				{
					"mstnr": "73510312",
					"date": "2015-06-11",
					"value": 16.65,
					"mstbez": "KOELN  503"
				},
				{
					"mstnr": "73509310",
					"date": "2015-10-01",
					"value": 11.3,
					"mstbez": "WEISS  483"
				},
				{
					"mstnr": "73508615",
					"date": "2015-07-06",
					"value": 44.73,
					"mstbez": "UNI   141A"
				},
				{
					"mstnr": "70157110",
					"date": "2015-07-07",
					"value": 22.14,
					"mstbez": "LGD K-NIEHL IND.STR"
				},
				{
					"mstnr": "70199814",
					"date": "2015-08-20",
					"value": 17.85,
					"mstbez": "LGD K-NEUBRUECK2/92"
				},
				{
					"mstnr": "73756714",
					"date": "2015-10-22",
					"value": 28.81,
					"mstbez": "RGW Köln HÖ 036"
				},
				{
					"mstnr": "73756817",
					"date": "2015-06-24",
					"value": 19.35,
					"mstbez": "RGW Köln Hö 044"
				},
				{
					"mstnr": "73757421",
					"date": "2015-03-12",
					"value": 9.8,
					"mstbez": "RGW Köln WE 061 MW"
				},
				{
					"mstnr": "73757433",
					"date": "2015-06-24",
					"value": 13.2,
					"mstbez": "RGW Köln WE 061 UW"
				},
				{
					"mstnr": "73757512",
					"date": "2015-03-19",
					"value": 19.11,
					"mstbez": "RGW Köln WE 101"
				},
				{
					"mstnr": "73311613",
					"date": "2015-06-18",
					"value": 50.82,
					"mstbez": "VERSICK453"
				},
				{
					"mstnr": "73506813",
					"date": "2015-06-23",
					"value": 32.2,
					"mstbez": "KLETT  431"
				},
				{
					"mstnr": "73510919",
					"date": "2015-10-05",
					"value": 22.41,
					"mstbez": "WEISS  510"
				}
			],
			"plz": "50667"
		},
		"Lage": {
			"stations": [
				{
					"mstnr": "100742427",
					"date": "2015-05-05",
					"value": 6.8,
					"mstbez": "LH 2  BR HARDISSEN"
				},
				{
					"mstnr": "100742427",
					"date": "2015-11-05",
					"value": 9.8,
					"mstbez": "LH 2  BR HARDISSEN"
				},
				{
					"mstnr": "100744412",
					"date": "2015-05-06",
					"value": 4.6,
					"mstbez": "LEA 1 BR EHR_ARMKMP"
				},
				{
					"mstnr": "100744412",
					"date": "2015-11-04",
					"value": 1,
					"mstbez": "LEA 1 BR EHR_ARMKMP"
				},
				{
					"mstnr": "100746410",
					"date": "2015-05-06",
					"value": 35.01,
					"mstbez": "LHEID BR HEIDEN LAG"
				},
				{
					"mstnr": "100746410",
					"date": "2015-11-04",
					"value": 39.01,
					"mstbez": "LHEID BR HEIDEN LAG"
				}
			],
			"plz": "32791"
		},
		"Burscheid": {
			"stations": [
				{
					"mstnr": "73737288",
					"date": "2015-04-01",
					"value": 42.96,
					"mstbez": "WG GROSSHAMBERG QF"
				}
			],
			"plz": "51399"
		},
		"Alsdorf": {
			"stations": [
				{
					"mstnr": "10202808",
					"date": "2015-06-10",
					"value": 35.03,
					"mstbez": "Alsdorf-Zopp"
				}
			],
			"plz": "52477"
		},
		"Willebadessen": {
			"stations": [
				{
					"mstnr": "26501820",
					"date": "2015-10-07",
					"value": 30.01,
					"mstbez": "BR Niesen"
				},
				{
					"mstnr": "26504870",
					"date": "2015-10-07",
					"value": 22.01,
					"mstbez": "BR Peckelsheim"
				},
				{
					"mstnr": "26504870",
					"date": "2015-03-24",
					"value": 29.01,
					"mstbez": "BR Peckelsheim"
				},
				{
					"mstnr": "26504868",
					"date": "2015-10-07",
					"value": 19.01,
					"mstbez": "TB Helmern"
				},
				{
					"mstnr": "26504868",
					"date": "2015-03-24",
					"value": 17.01,
					"mstbez": "TB Helmern"
				},
				{
					"mstnr": "26504820",
					"date": "2015-10-07",
					"value": 20.01,
					"mstbez": "BR Loewen"
				},
				{
					"mstnr": "26501820",
					"date": "2015-03-24",
					"value": 27.01,
					"mstbez": "BR Niesen"
				},
				{
					"mstnr": "26504820",
					"date": "2015-03-24",
					"value": 27.01,
					"mstbez": "BR Loewen"
				},
				{
					"mstnr": "26501818",
					"date": "2015-10-07",
					"value": 10,
					"mstbez": "BR Willebadessen"
				},
				{
					"mstnr": "26501818",
					"date": "2015-03-24",
					"value": 9,
					"mstbez": "BR Willebadessen"
				}
			],
			"plz": "34439"
		},
		"Baesweiler": {
			"stations": [
				{
					"mstnr": "218642817",
					"date": "2015-10-14",
					"value": 31.21,
					"mstbez": "Baesweiler"
				},
				{
					"mstnr": "10202791",
					"date": "2015-03-12",
					"value": 89.01,
					"mstbez": "LOVERICH"
				}
			],
			"plz": "52499"
		},
		"Münster": {
			"stations": [
				{
					"mstnr": "118731026",
					"date": "2015-04-14",
					"value": 19.01,
					"mstbez": "WW.KINDERH.ALT-VK02"
				},
				{
					"mstnr": "110060155",
					"date": "2015-11-13",
					"value": 1.33,
					"mstbez": "VI/15 MS - WERSE"
				},
				{
					"mstnr": "119011049",
					"date": "2015-12-09",
					"value": 1.33,
					"mstbez": "Stadt MS T 18 F"
				},
				{
					"mstnr": "118731026",
					"date": "2015-10-07",
					"value": 21.01,
					"mstbez": "WW.KINDERH.ALT-VK02"
				}
			],
			"plz": "48143"
		},
		"Ahaus": {
			"stations": [
				{
					"mstnr": "60240052",
					"date": "2015-06-12",
					"value": 1.33,
					"mstbez": "AH/5 -ALSTAETTE-"
				},
				{
					"mstnr": "60240430",
					"date": "2015-09-09",
					"value": 1.33,
					"mstbez": "AH/43 Quantwick"
				},
				{
					"mstnr": "60240313",
					"date": "2015-04-21",
					"value": 1.33,
					"mstbez": "AH/31 -SABSTAETTE-"
				}
			],
			"plz": "48683"
		},
		"Bünde": {
			"stations": [
				{
					"mstnr": "100760168",
					"date": "2015-10-05",
					"value": 1,
					"mstbez": "BA 5A BR AHLE"
				},
				{
					"mstnr": "100760156",
					"date": "2015-04-14",
					"value": 6,
					"mstbez": "BA 13ABR AHLE"
				},
				{
					"mstnr": "100760156",
					"date": "2015-10-05",
					"value": 7,
					"mstbez": "BA 13ABR AHLE"
				},
				{
					"mstnr": "100761161",
					"date": "2015-04-14",
					"value": 21.01,
					"mstbez": "BH 7  BR HABIGHORST"
				},
				{
					"mstnr": "100761161",
					"date": "2015-10-05",
					"value": 21.01,
					"mstbez": "BH 7  BR HABIGHORST"
				},
				{
					"mstnr": "100761616",
					"date": "2015-04-14",
					"value": 53.02,
					"mstbez": "BB 1  BR BILLERKE"
				}
			],
			"plz": "32257"
		},
		"Westerkappeln": {
			"stations": [
				{
					"mstnr": "110200380",
					"date": "2015-03-18",
					"value": 93.44,
					"mstbez": "TE/38 LOTTE DÜTE"
				},
				{
					"mstnr": "110200445",
					"date": "2015-12-01",
					"value": 27.37,
					"mstbez": "TE/44 Wallenbrock"
				},
				{
					"mstnr": "110200329",
					"date": "2015-03-18",
					"value": 1.33,
					"mstbez": "TE/32 WESTERKAPPELN"
				},
				{
					"mstnr": "110200287",
					"date": "2015-03-24",
					"value": 18.11,
					"mstbez": "TE/28 NIEDERSEESTE"
				}
			],
			"plz": "49492"
		},
		"Schieder-Schwalenberg": {
			"stations": [
				{
					"mstnr": "106505233",
					"date": "2015-10-08",
					"value": 18.01,
					"mstbez": "TB Glockenpohl"
				},
				{
					"mstnr": "106505233",
					"date": "2015-03-25",
					"value": 11,
					"mstbez": "TB Glockenpohl"
				}
			],
			"plz": "32816"
		},
		"Sankt Augustin": {
			"stations": [
				{
					"mstnr": "70201419",
					"date": "2015-04-23",
					"value": 18.56,
					"mstbez": "LGD NPLEIS Hauptstr"
				},
				{
					"mstnr": "70201810",
					"date": "2015-04-28",
					"value": 25.29,
					"mstbez": "LGD HANGEL.FRIEDHOF"
				},
				{
					"mstnr": "70201316",
					"date": "2015-04-27",
					"value": 42.56,
					"mstbez": "LGD Menden Siegstr."
				},
				{
					"mstnr": "70189110",
					"date": "2015-04-23",
					"value": 43.58,
					"mstbez": "LGD MENDEN neu"
				},
				{
					"mstnr": "70284416",
					"date": "2015-05-22",
					"value": 12.22,
					"mstbez": "LGD ST.AUGUSTIN JZ"
				}
			],
			"plz": "53757"
		},
		"Velbert": {
			"stations": [
				{
					"mstnr": "34608448",
					"date": "2015-09-15",
					"value": 29.85,
					"mstbez": "Industriestr.GWM2n"
				}
			],
			"plz": "42551"
		},
		"Kirchhundem": {
			"stations": [
				{
					"mstnr": "129660103",
					"date": "2015-05-11",
					"value": 9.26,
					"mstbez": "Liemscheid"
				},
				{
					"mstnr": "129660097",
					"date": "2015-05-04",
					"value": 7.04,
					"mstbez": "Lechtmecke"
				},
				{
					"mstnr": "129660553",
					"date": "2015-10-13",
					"value": 9.52,
					"mstbez": "Silberg"
				},
				{
					"mstnr": "129660255",
					"date": "2015-05-11",
					"value": 8.24,
					"mstbez": "Wolbecke"
				},
				{
					"mstnr": "129660231",
					"date": "2015-05-11",
					"value": 12.13,
					"mstbez": "Laubhagen"
				}
			],
			"plz": "57399"
		},
		"Hagen": {
			"stations": [
				{
					"mstnr": "59140331",
					"date": "2015-06-24",
					"value": 11.69,
					"mstbez": "Hünenpforte"
				},
				{
					"mstnr": "59140288",
					"date": "2015-03-23",
					"value": 45.61,
					"mstbez": "Linnuferquelle"
				},
				{
					"mstnr": "59140185",
					"date": "2015-04-20",
					"value": 32.28,
					"mstbez": "INMET B7"
				}
			],
			"plz": "58095"
		},
		"Neuenrade": {
			"stations": [
				{
					"mstnr": "59620936",
					"date": "2015-03-16",
					"value": 11.25,
					"mstbez": "Hönnequelle"
				},
				{
					"mstnr": "59620109",
					"date": "2015-12-07",
					"value": 16.01,
					"mstbez": "Friedrichstal Br.II"
				},
				{
					"mstnr": "59620262",
					"date": "2015-04-08",
					"value": 4.74,
					"mstbez": "VOSSECKE"
				},
				{
					"mstnr": "59620109",
					"date": "2015-03-30",
					"value": 16.39,
					"mstbez": "Friedrichstal Br.II"
				}
			],
			"plz": "58809"
		},
		"Velen": {
			"stations": [
				{
					"mstnr": "60240295",
					"date": "2015-09-16",
					"value": 20.11,
					"mstbez": "AH/29 -HOLTHAUSEN-"
				}
			],
			"plz": "46342"
		},
		"Kamen": {
			"stations": [
				{
					"mstnr": "91112000",
					"date": "2015-06-24",
					"value": 1.33,
					"mstbez": "Westick ML 6"
				},
				{
					"mstnr": "91120100",
					"date": "2015-06-24",
					"value": 1.33,
					"mstbez": "Kamener Kreuz ML 22"
				},
				{
					"mstnr": "98120414",
					"date": "2015-06-24",
					"value": 1.33,
					"mstbez": "Dep. Kamen-H-W GWT1"
				}
			],
			"plz": "59174"
		},
		"Düren": {
			"stations": [
				{
					"mstnr": "10201026",
					"date": "2015-05-06",
					"value": 20.64,
					"mstbez": "LENDERSDORF NR 5"
				},
				{
					"mstnr": "10406426",
					"date": "2015-05-06",
					"value": 9.48,
					"mstbez": "Overhuesallee P 12"
				},
				{
					"mstnr": "219671813",
					"date": "2015-08-17",
					"value": 13.94,
					"mstbez": "Birgel"
				},
				{
					"mstnr": "10406426",
					"date": "2015-08-17",
					"value": 7.39,
					"mstbez": "Overhuesallee P 12"
				}
			],
			"plz": "52349"
		},
		"Nordkirchen": {
			"stations": [
				{
					"mstnr": "110210050",
					"date": "2015-05-06",
					"value": 1.33,
					"mstbez": "St.G/5 ALTENDORF"
				},
				{
					"mstnr": "110210062",
					"date": "2015-09-29",
					"value": 1.33,
					"mstbez": "ST.GEB/6Nordkirchen"
				}
			],
			"plz": "59394"
		},
		"Inden": {
			"stations": [
				{
					"mstnr": "219602013",
					"date": "2015-10-19",
					"value": 0.89,
					"mstbez": "Pier 13"
				}
			],
			"plz": "52459"
		},
		"Marienheide": {
			"stations": [
				{
					"mstnr": "73774789",
					"date": "2015-04-10",
					"value": 12.8,
					"mstbez": "MARIENHEIDE QUELLE"
				},
				{
					"mstnr": "73774686",
					"date": "2015-04-10",
					"value": 21.26,
					"mstbez": "WG SCHOENEBORN QU"
				}
			],
			"plz": "51709"
		},
		"Menden (Sauerland)": {
			"stations": [
				{
					"mstnr": "59620201",
					"date": "2015-09-09",
					"value": 24.14,
					"mstbez": "HALIG010"
				},
				{
					"mstnr": "59621620",
					"date": "2015-09-29",
					"value": 34.19,
					"mstbez": "Asbeck"
				}
			],
			"plz": "58706"
		},
		"Jülich": {
			"stations": [
				{
					"mstnr": "216000051",
					"date": "2015-08-31",
					"value": 0.89,
					"mstbez": "Br. ZF Juelich"
				},
				{
					"mstnr": "10202201",
					"date": "2015-05-20",
					"value": 27.68,
					"mstbez": "FZJ Nr. 25"
				},
				{
					"mstnr": "219278519",
					"date": "2015-11-09",
					"value": 0.89,
					"mstbez": "Jülich Ii"
				}
			],
			"plz": "52428"
		},
		"Siegburg": {
			"stations": [
				{
					"mstnr": "70202515",
					"date": "2015-04-21",
					"value": 9.12,
					"mstbez": "LGD KALDAUEN MUEHLE"
				},
				{
					"mstnr": "70204410",
					"date": "2015-04-28",
					"value": 22.5,
					"mstbez": "LGD Siegb. Berl.Pl."
				},
				{
					"mstnr": "76987218",
					"date": "2015-08-17",
					"value": 8.06,
					"mstbez": "RSK ALTABL.8630-043"
				}
			],
			"plz": "53721"
		},
		"Billerbeck": {
			"stations": [
				{
					"mstnr": "110310019",
					"date": "2015-11-10",
					"value": 86.8,
					"mstbez": "BOMBECK 01"
				},
				{
					"mstnr": "110240133",
					"date": "2015-05-13",
					"value": 1.33,
					"mstbez": "AH/13 BILLERBECK"
				},
				{
					"mstnr": "110240121",
					"date": "2015-09-14",
					"value": 1.33,
					"mstbez": "AH/12 BILLERBECK"
				},
				{
					"mstnr": "110040260",
					"date": "2015-11-09",
					"value": 1.33,
					"mstbez": "IV/26 AULENDORF"
				}
			],
			"plz": "48727"
		},
		"Lemgo": {
			"stations": [
				{
					"mstnr": "106505178",
					"date": "2015-08-27",
					"value": 28.01,
					"mstbez": "LEMAT BR PIEPENBORN"
				},
				{
					"mstnr": "106505178",
					"date": "2015-10-01",
					"value": 28.01,
					"mstbez": "LEMAT BR PIEPENBORN"
				},
				{
					"mstnr": "106505178",
					"date": "2015-10-30",
					"value": 27.01,
					"mstbez": "LEMAT BR PIEPENBORN"
				},
				{
					"mstnr": "106505178",
					"date": "2015-11-30",
					"value": 27.01,
					"mstbez": "LEMAT BR PIEPENBORN"
				},
				{
					"mstnr": "106505166",
					"date": "2015-01-30",
					"value": 27.01,
					"mstbez": "LEENT TB ENTRUP LEM"
				},
				{
					"mstnr": "106505166",
					"date": "2015-02-27",
					"value": 28.01,
					"mstbez": "LEENT TB ENTRUP LEM"
				},
				{
					"mstnr": "106505166",
					"date": "2015-04-08",
					"value": 29.01,
					"mstbez": "LEENT TB ENTRUP LEM"
				},
				{
					"mstnr": "106505166",
					"date": "2015-04-30",
					"value": 28.01,
					"mstbez": "LEENT TB ENTRUP LEM"
				},
				{
					"mstnr": "106505166",
					"date": "2015-06-01",
					"value": 29.01,
					"mstbez": "LEENT TB ENTRUP LEM"
				},
				{
					"mstnr": "106505166",
					"date": "2015-06-30",
					"value": 27.01,
					"mstbez": "LEENT TB ENTRUP LEM"
				},
				{
					"mstnr": "106505166",
					"date": "2015-07-30",
					"value": 28.01,
					"mstbez": "LEENT TB ENTRUP LEM"
				},
				{
					"mstnr": "106505166",
					"date": "2015-08-27",
					"value": 28.01,
					"mstbez": "LEENT TB ENTRUP LEM"
				},
				{
					"mstnr": "106505166",
					"date": "2015-10-02",
					"value": 28.01,
					"mstbez": "LEENT TB ENTRUP LEM"
				},
				{
					"mstnr": "106505166",
					"date": "2015-10-30",
					"value": 27.01,
					"mstbez": "LEENT TB ENTRUP LEM"
				},
				{
					"mstnr": "106505166",
					"date": "2015-11-30",
					"value": 29.01,
					"mstbez": "LEENT TB ENTRUP LEM"
				},
				{
					"mstnr": "106505166",
					"date": "2015-03-31",
					"value": 28.01,
					"mstbez": "LEENT TB ENTRUP LEM"
				},
				{
					"mstnr": "106505178",
					"date": "2015-07-30",
					"value": 28.01,
					"mstbez": "LEMAT BR PIEPENBORN"
				},
				{
					"mstnr": "106505178",
					"date": "2015-06-30",
					"value": 28.01,
					"mstbez": "LEMAT BR PIEPENBORN"
				},
				{
					"mstnr": "106505154",
					"date": "2015-01-30",
					"value": 22.01,
					"mstbez": "LUERD QU LUERDISSEN"
				},
				{
					"mstnr": "106505180",
					"date": "2015-02-27",
					"value": 45.02,
					"mstbez": "LESTU BR STUCKEN LE"
				},
				{
					"mstnr": "106505180",
					"date": "2015-03-31",
					"value": 44.02,
					"mstbez": "LESTU BR STUCKEN LE"
				},
				{
					"mstnr": "106505117",
					"date": "2015-11-30",
					"value": 28.01,
					"mstbez": "MATO2 BR MATORF LEM"
				},
				{
					"mstnr": "106505180",
					"date": "2015-04-08",
					"value": 46.02,
					"mstbez": "LESTU BR STUCKEN LE"
				},
				{
					"mstnr": "106505180",
					"date": "2015-04-30",
					"value": 47.02,
					"mstbez": "LESTU BR STUCKEN LE"
				},
				{
					"mstnr": "106505180",
					"date": "2015-06-01",
					"value": 47.02,
					"mstbez": "LESTU BR STUCKEN LE"
				},
				{
					"mstnr": "106505180",
					"date": "2015-06-30",
					"value": 47.02,
					"mstbez": "LESTU BR STUCKEN LE"
				},
				{
					"mstnr": "106505180",
					"date": "2015-07-30",
					"value": 47.02,
					"mstbez": "LESTU BR STUCKEN LE"
				},
				{
					"mstnr": "106505117",
					"date": "2015-08-27",
					"value": 28.01,
					"mstbez": "MATO2 BR MATORF LEM"
				},
				{
					"mstnr": "106505180",
					"date": "2015-08-27",
					"value": 47.02,
					"mstbez": "LESTU BR STUCKEN LE"
				},
				{
					"mstnr": "106505180",
					"date": "2015-10-01",
					"value": 44.02,
					"mstbez": "LESTU BR STUCKEN LE"
				},
				{
					"mstnr": "106505180",
					"date": "2015-10-30",
					"value": 39.01,
					"mstbez": "LESTU BR STUCKEN LE"
				},
				{
					"mstnr": "106505180",
					"date": "2015-11-30",
					"value": 39.01,
					"mstbez": "LESTU BR STUCKEN LE"
				},
				{
					"mstnr": "106505178",
					"date": "2015-02-27",
					"value": 28.01,
					"mstbez": "LEMAT BR PIEPENBORN"
				},
				{
					"mstnr": "106505178",
					"date": "2015-03-31",
					"value": 28.01,
					"mstbez": "LEMAT BR PIEPENBORN"
				},
				{
					"mstnr": "106505178",
					"date": "2015-04-08",
					"value": 28.01,
					"mstbez": "LEMAT BR PIEPENBORN"
				},
				{
					"mstnr": "106505178",
					"date": "2015-04-30",
					"value": 29.01,
					"mstbez": "LEMAT BR PIEPENBORN"
				},
				{
					"mstnr": "106505178",
					"date": "2015-06-01",
					"value": 28.01,
					"mstbez": "LEMAT BR PIEPENBORN"
				},
				{
					"mstnr": "106505117",
					"date": "2015-10-02",
					"value": 34.01,
					"mstbez": "MATO2 BR MATORF LEM"
				},
				{
					"mstnr": "106505154",
					"date": "2015-02-27",
					"value": 23.01,
					"mstbez": "LUERD QU LUERDISSEN"
				},
				{
					"mstnr": "106502219",
					"date": "2015-02-27",
					"value": 14,
					"mstbez": "MAI 1 BR MAIBOLTE"
				},
				{
					"mstnr": "106505117",
					"date": "2015-03-31",
					"value": 27.01,
					"mstbez": "MATO2 BR MATORF LEM"
				},
				{
					"mstnr": "106505129",
					"date": "2015-10-01",
					"value": 19.01,
					"mstbez": "EICHE BR EICHEN LEM"
				},
				{
					"mstnr": "106505129",
					"date": "2015-10-30",
					"value": 19.01,
					"mstbez": "EICHE BR EICHEN LEM"
				},
				{
					"mstnr": "106505117",
					"date": "2015-04-30",
					"value": 28.01,
					"mstbez": "MATO2 BR MATORF LEM"
				},
				{
					"mstnr": "106505117",
					"date": "2015-04-08",
					"value": 27.01,
					"mstbez": "MATO2 BR MATORF LEM"
				},
				{
					"mstnr": "106502219",
					"date": "2015-10-30",
					"value": 14,
					"mstbez": "MAI 1 BR MAIBOLTE"
				},
				{
					"mstnr": "106505180",
					"date": "2015-01-30",
					"value": 45.02,
					"mstbez": "LESTU BR STUCKEN LE"
				},
				{
					"mstnr": "106502219",
					"date": "2015-10-01",
					"value": 14,
					"mstbez": "MAI 1 BR MAIBOLTE"
				},
				{
					"mstnr": "106505129",
					"date": "2015-11-30",
					"value": 20.01,
					"mstbez": "EICHE BR EICHEN LEM"
				},
				{
					"mstnr": "106502219",
					"date": "2015-08-27",
					"value": 15.01,
					"mstbez": "MAI 1 BR MAIBOLTE"
				},
				{
					"mstnr": "106502219",
					"date": "2015-07-30",
					"value": 14,
					"mstbez": "MAI 1 BR MAIBOLTE"
				},
				{
					"mstnr": "106505117",
					"date": "2015-01-30",
					"value": 22.01,
					"mstbez": "MATO2 BR MATORF LEM"
				},
				{
					"mstnr": "106502219",
					"date": "2015-06-30",
					"value": 15.01,
					"mstbez": "MAI 1 BR MAIBOLTE"
				},
				{
					"mstnr": "106502219",
					"date": "2015-06-01",
					"value": 15.01,
					"mstbez": "MAI 1 BR MAIBOLTE"
				},
				{
					"mstnr": "106502219",
					"date": "2015-04-30",
					"value": 14,
					"mstbez": "MAI 1 BR MAIBOLTE"
				},
				{
					"mstnr": "106502219",
					"date": "2015-04-08",
					"value": 14,
					"mstbez": "MAI 1 BR MAIBOLTE"
				},
				{
					"mstnr": "106505117",
					"date": "2015-02-27",
					"value": 20.01,
					"mstbez": "MATO2 BR MATORF LEM"
				},
				{
					"mstnr": "106502219",
					"date": "2015-03-31",
					"value": 14,
					"mstbez": "MAI 1 BR MAIBOLTE"
				},
				{
					"mstnr": "106505129",
					"date": "2015-08-27",
					"value": 19.01,
					"mstbez": "EICHE BR EICHEN LEM"
				},
				{
					"mstnr": "106502219",
					"date": "2015-11-30",
					"value": 14,
					"mstbez": "MAI 1 BR MAIBOLTE"
				},
				{
					"mstnr": "106505117",
					"date": "2015-06-01",
					"value": 28.01,
					"mstbez": "MATO2 BR MATORF LEM"
				},
				{
					"mstnr": "106505129",
					"date": "2015-07-30",
					"value": 19.01,
					"mstbez": "EICHE BR EICHEN LEM"
				},
				{
					"mstnr": "106505154",
					"date": "2015-04-30",
					"value": 23.01,
					"mstbez": "LUERD QU LUERDISSEN"
				},
				{
					"mstnr": "106505154",
					"date": "2015-06-01",
					"value": 24.01,
					"mstbez": "LUERD QU LUERDISSEN"
				},
				{
					"mstnr": "106505154",
					"date": "2015-06-30",
					"value": 24.01,
					"mstbez": "LUERD QU LUERDISSEN"
				},
				{
					"mstnr": "106505154",
					"date": "2015-07-30",
					"value": 24.01,
					"mstbez": "LUERD QU LUERDISSEN"
				},
				{
					"mstnr": "106505154",
					"date": "2015-08-27",
					"value": 24.01,
					"mstbez": "LUERD QU LUERDISSEN"
				},
				{
					"mstnr": "106505154",
					"date": "2015-10-01",
					"value": 24.01,
					"mstbez": "LUERD QU LUERDISSEN"
				},
				{
					"mstnr": "106505117",
					"date": "2015-07-30",
					"value": 27.01,
					"mstbez": "MATO2 BR MATORF LEM"
				},
				{
					"mstnr": "106505117",
					"date": "2015-06-30",
					"value": 34.01,
					"mstbez": "MATO2 BR MATORF LEM"
				},
				{
					"mstnr": "106505154",
					"date": "2015-03-31",
					"value": 23.01,
					"mstbez": "LUERD QU LUERDISSEN"
				},
				{
					"mstnr": "106505154",
					"date": "2015-10-30",
					"value": 24.01,
					"mstbez": "LUERD QU LUERDISSEN"
				},
				{
					"mstnr": "106505129",
					"date": "2015-01-30",
					"value": 20.01,
					"mstbez": "EICHE BR EICHEN LEM"
				},
				{
					"mstnr": "106505129",
					"date": "2015-02-27",
					"value": 19.01,
					"mstbez": "EICHE BR EICHEN LEM"
				},
				{
					"mstnr": "106505129",
					"date": "2015-03-31",
					"value": 13,
					"mstbez": "EICHE BR EICHEN LEM"
				},
				{
					"mstnr": "106505129",
					"date": "2015-04-08",
					"value": 19.01,
					"mstbez": "EICHE BR EICHEN LEM"
				},
				{
					"mstnr": "106505129",
					"date": "2015-04-30",
					"value": 19.01,
					"mstbez": "EICHE BR EICHEN LEM"
				},
				{
					"mstnr": "106505129",
					"date": "2015-06-01",
					"value": 18.01,
					"mstbez": "EICHE BR EICHEN LEM"
				},
				{
					"mstnr": "106502219",
					"date": "2015-01-30",
					"value": 14,
					"mstbez": "MAI 1 BR MAIBOLTE"
				},
				{
					"mstnr": "106505129",
					"date": "2015-06-30",
					"value": 19.01,
					"mstbez": "EICHE BR EICHEN LEM"
				},
				{
					"mstnr": "106505154",
					"date": "2015-11-30",
					"value": 24.01,
					"mstbez": "LUERD QU LUERDISSEN"
				},
				{
					"mstnr": "106505154",
					"date": "2015-04-08",
					"value": 23.01,
					"mstbez": "LUERD QU LUERDISSEN"
				},
				{
					"mstnr": "106505178",
					"date": "2015-01-30",
					"value": 28.01,
					"mstbez": "LEMAT BR PIEPENBORN"
				}
			],
			"plz": "32657"
		},
		"Wadersloh": {
			"stations": [
				{
					"mstnr": "110151057",
					"date": "2015-11-12",
					"value": 11.29,
					"mstbez": "WA/5 DIESTEDDE"
				},
				{
					"mstnr": "110151094",
					"date": "2015-11-03",
					"value": 1.33,
					"mstbez": "WA/9  LIESBORN"
				}
			],
			"plz": "59329"
		},
		"Roetgen": {
			"stations": [
				{
					"mstnr": "10409671",
					"date": "2015-11-24",
					"value": 3.99,
					"mstbez": "Großquelle"
				}
			],
			"plz": "52159"
		},
		"Engelskirchen": {
			"stations": [
				{
					"mstnr": "76809304",
					"date": "2015-03-31",
					"value": 2.26,
					"mstbez": "Fischbach Ründer.B"
				},
				{
					"mstnr": "73775289",
					"date": "2015-03-31",
					"value": 13.77,
					"mstbez": "WG REMERSCHEID"
				}
			],
			"plz": "51766"
		},
		"Stolberg (Rhld.)": {
			"stations": [
				{
					"mstnr": "10421427",
					"date": "2015-06-10",
					"value": 23.51,
					"mstbez": "Mariaschacht P6"
				},
				{
					"mstnr": "10421373",
					"date": "2015-06-10",
					"value": 27.71,
					"mstbez": "Mariaschacht P1a"
				},
				{
					"mstnr": "10407340",
					"date": "2015-05-18",
					"value": 8.5,
					"mstbez": "WGA Mariaschacht"
				},
				{
					"mstnr": "10407340",
					"date": "2015-06-08",
					"value": 9.4,
					"mstbez": "WGA Mariaschacht"
				},
				{
					"mstnr": "10421373",
					"date": "2015-08-26",
					"value": 23.71,
					"mstbez": "Mariaschacht P1a"
				},
				{
					"mstnr": "10421403",
					"date": "2015-08-26",
					"value": 4.7,
					"mstbez": "Mariaschacht P4"
				},
				{
					"mstnr": "10421403",
					"date": "2015-06-10",
					"value": 4.6,
					"mstbez": "Mariaschacht P4"
				},
				{
					"mstnr": "10421397",
					"date": "2015-06-10",
					"value": 24.21,
					"mstbez": "Mariaschacht P3"
				},
				{
					"mstnr": "10421397",
					"date": "2015-08-26",
					"value": 24.11,
					"mstbez": "Mariaschacht P3"
				},
				{
					"mstnr": "10407340",
					"date": "2015-07-01",
					"value": 9.1,
					"mstbez": "WGA Mariaschacht"
				},
				{
					"mstnr": "10303650",
					"date": "2015-06-01",
					"value": 7,
					"mstbez": "Rüst Bundesbahn3/9"
				},
				{
					"mstnr": "10421415",
					"date": "2015-06-10",
					"value": 144.05,
					"mstbez": "Mariaschacht P5"
				},
				{
					"mstnr": "10407340",
					"date": "2015-07-13",
					"value": 9.1,
					"mstbez": "WGA Mariaschacht"
				},
				{
					"mstnr": "10407340",
					"date": "2015-11-09",
					"value": 7.9,
					"mstbez": "WGA Mariaschacht"
				},
				{
					"mstnr": "10421415",
					"date": "2015-08-26",
					"value": 114.04,
					"mstbez": "Mariaschacht P5"
				},
				{
					"mstnr": "10407340",
					"date": "2015-08-10",
					"value": 8.5,
					"mstbez": "WGA Mariaschacht"
				},
				{
					"mstnr": "10421439",
					"date": "2015-08-26",
					"value": 10.1,
					"mstbez": "Mariaschacht P7"
				},
				{
					"mstnr": "10421439",
					"date": "2015-06-10",
					"value": 25.31,
					"mstbez": "Mariaschacht P7"
				},
				{
					"mstnr": "10421427",
					"date": "2015-08-26",
					"value": 25.41,
					"mstbez": "Mariaschacht P6"
				},
				{
					"mstnr": "10407340",
					"date": "2015-09-14",
					"value": 8,
					"mstbez": "WGA Mariaschacht"
				},
				{
					"mstnr": "10407340",
					"date": "2015-07-08",
					"value": 8.7,
					"mstbez": "WGA Mariaschacht"
				},
				{
					"mstnr": "16001813",
					"date": "2015-11-23",
					"value": 20.37,
					"mstbez": "DALLI-WERKE BR.III"
				},
				{
					"mstnr": "10407339",
					"date": "2015-07-01",
					"value": 4.2,
					"mstbez": "NachtigFetisschacht"
				},
				{
					"mstnr": "10407340",
					"date": "2015-04-13",
					"value": 9.4,
					"mstbez": "WGA Mariaschacht"
				},
				{
					"mstnr": "10407339",
					"date": "2015-05-18",
					"value": 3.3,
					"mstbez": "NachtigFetisschacht"
				},
				{
					"mstnr": "10407339",
					"date": "2015-04-13",
					"value": 5.9,
					"mstbez": "NachtigFetisschacht"
				},
				{
					"mstnr": "10407339",
					"date": "2015-03-16",
					"value": 4,
					"mstbez": "NachtigFetisschacht"
				},
				{
					"mstnr": "10407339",
					"date": "2015-02-23",
					"value": 3.8,
					"mstbez": "NachtigFetisschacht"
				},
				{
					"mstnr": "10407339",
					"date": "2015-02-09",
					"value": 7.4,
					"mstbez": "NachtigFetisschacht"
				},
				{
					"mstnr": "10407339",
					"date": "2015-01-12",
					"value": 14.31,
					"mstbez": "NachtigFetisschacht"
				},
				{
					"mstnr": "10407339",
					"date": "2015-07-08",
					"value": 4.2,
					"mstbez": "NachtigFetisschacht"
				},
				{
					"mstnr": "10407339",
					"date": "2015-06-08",
					"value": 4.4,
					"mstbez": "NachtigFetisschacht"
				},
				{
					"mstnr": "10407339",
					"date": "2015-07-13",
					"value": 5.5,
					"mstbez": "NachtigFetisschacht"
				},
				{
					"mstnr": "10407339",
					"date": "2015-08-10",
					"value": 4.1,
					"mstbez": "NachtigFetisschacht"
				},
				{
					"mstnr": "10407340",
					"date": "2015-10-12",
					"value": 8.5,
					"mstbez": "WGA Mariaschacht"
				},
				{
					"mstnr": "10407339",
					"date": "2015-10-12",
					"value": 4.5,
					"mstbez": "NachtigFetisschacht"
				},
				{
					"mstnr": "10407340",
					"date": "2015-03-16",
					"value": 10.6,
					"mstbez": "WGA Mariaschacht"
				},
				{
					"mstnr": "10407340",
					"date": "2015-02-23",
					"value": 9.3,
					"mstbez": "WGA Mariaschacht"
				},
				{
					"mstnr": "10407340",
					"date": "2015-02-09",
					"value": 8.7,
					"mstbez": "WGA Mariaschacht"
				},
				{
					"mstnr": "10407340",
					"date": "2015-12-14",
					"value": 8.2,
					"mstbez": "WGA Mariaschacht"
				},
				{
					"mstnr": "10421361",
					"date": "2015-08-26",
					"value": 4.7,
					"mstbez": "Mariaschacht P1"
				},
				{
					"mstnr": "10407339",
					"date": "2015-09-14",
					"value": 4.2,
					"mstbez": "NachtigFetisschacht"
				},
				{
					"mstnr": "10407340",
					"date": "2015-01-12",
					"value": 8.8,
					"mstbez": "WGA Mariaschacht"
				},
				{
					"mstnr": "10421361",
					"date": "2015-06-10",
					"value": 7.2,
					"mstbez": "Mariaschacht P1"
				},
				{
					"mstnr": "10407339",
					"date": "2015-12-14",
					"value": 4.4,
					"mstbez": "NachtigFetisschacht"
				},
				{
					"mstnr": "10407339",
					"date": "2015-11-09",
					"value": 4,
					"mstbez": "NachtigFetisschacht"
				}
			],
			"plz": "52222"
		},
		"Witten": {
			"stations": [
				{
					"mstnr": "59540515",
					"date": "2015-06-16",
					"value": 6.86,
					"mstbez": "WITTEN BEO 3"
				},
				{
					"mstnr": "59540308",
					"date": "2015-08-18",
					"value": 46.94,
					"mstbez": "BQ III Stockumerstr"
				}
			],
			"plz": "58452"
		},
		"Leverkusen": {
			"stations": [
				{
					"mstnr": "76781010",
					"date": "2015-07-21",
					"value": 22.54,
					"mstbez": "GANSER LEV PII"
				},
				{
					"mstnr": "76849211",
					"date": "2015-12-18",
					"value": 17.21,
					"mstbez": "DN SCHLEBUSCH 1"
				},
				{
					"mstnr": "76849211",
					"date": "2015-03-20",
					"value": 14.51,
					"mstbez": "DN SCHLEBUSCH 1"
				},
				{
					"mstnr": "73765211",
					"date": "2015-07-15",
					"value": 59.34,
					"mstbez": "EVL LEV 65"
				},
				{
					"mstnr": "76849211",
					"date": "2015-09-18",
					"value": 15.31,
					"mstbez": "DN SCHLEBUSCH 1"
				},
				{
					"mstnr": "76956805",
					"date": "2015-04-01",
					"value": 21.52,
					"mstbez": "Westermann Lev EB 9"
				}
			],
			"plz": "51373"
		},
		"Brilon": {
			"stations": [
				{
					"mstnr": "94170319",
					"date": "2015-10-07",
					"value": 9,
					"mstbez": "Quelle Butterkopf"
				},
				{
					"mstnr": "94170320",
					"date": "2015-04-10",
					"value": 15.37,
					"mstbez": "Br Scharfenberg"
				},
				{
					"mstnr": "94170332",
					"date": "2015-05-07",
					"value": 24.01,
					"mstbez": "Br Alme 2"
				},
				{
					"mstnr": "94170332",
					"date": "2015-11-04",
					"value": 25.01,
					"mstbez": "Br Alme 2"
				},
				{
					"mstnr": "94170435",
					"date": "2015-04-10",
					"value": 16.08,
					"mstbez": "Que Am Plattenberg"
				},
				{
					"mstnr": "94170319",
					"date": "2015-04-10",
					"value": 8.46,
					"mstbez": "Quelle Butterkopf"
				},
				{
					"mstnr": "91174909",
					"date": "2015-12-01",
					"value": 30.29,
					"mstbez": "Brilon LederkeOL748"
				},
				{
					"mstnr": "94170320",
					"date": "2015-10-07",
					"value": 14,
					"mstbez": "Br Scharfenberg"
				},
				{
					"mstnr": "94180118",
					"date": "2015-10-07",
					"value": 21.01,
					"mstbez": "Steinbornquelle"
				},
				{
					"mstnr": "94170101",
					"date": "2015-04-10",
					"value": 19,
					"mstbez": "Quelle Altenbüren"
				},
				{
					"mstnr": "91175008",
					"date": "2015-11-10",
					"value": 22.45,
					"mstbez": "Steinbruch Weiken"
				},
				{
					"mstnr": "94170101",
					"date": "2015-11-04",
					"value": 21.01,
					"mstbez": "Quelle Altenbüren"
				},
				{
					"mstnr": "94170101",
					"date": "2015-10-07",
					"value": 20.01,
					"mstbez": "Quelle Altenbüren"
				}
			],
			"plz": "59929"
		},
		"Herzogenrath": {
			"stations": [
				{
					"mstnr": "10203862",
					"date": "2015-04-09",
					"value": 114.7,
					"mstbez": "Wefelen 2"
				},
				{
					"mstnr": "10202810",
					"date": "2015-04-09",
					"value": 176.26,
					"mstbez": "HERBACH"
				}
			],
			"plz": "52134"
		},
		"Hörstel": {
			"stations": [
				{
					"mstnr": "110200160",
					"date": "2015-12-08",
					"value": 120.9,
					"mstbez": "TE/16 -UTHUISEN-"
				},
				{
					"mstnr": "110200159",
					"date": "2015-03-11",
					"value": 1.33,
					"mstbez": "TE/15 -HOERSTEL-"
				},
				{
					"mstnr": "110200184",
					"date": "2015-03-12",
					"value": 34.94,
					"mstbez": "TE/18 -DREIERWALDE-"
				},
				{
					"mstnr": "110200172",
					"date": "2015-03-13",
					"value": 40.61,
					"mstbez": "TE/17 -OSTENWALDE-"
				},
				{
					"mstnr": "110200305",
					"date": "2015-03-12",
					"value": 1.33,
					"mstbez": "TE/30 DREIERWALDE"
				},
				{
					"mstnr": "110200070",
					"date": "2015-11-02",
					"value": 49.6,
					"mstbez": "TE/7 -RIESENBECK-"
				},
				{
					"mstnr": "110200081",
					"date": "2015-11-02",
					"value": 141.71,
					"mstbez": "TE/8 -BEVERGERN-"
				},
				{
					"mstnr": "110050010",
					"date": "2015-03-13",
					"value": 1.33,
					"mstbez": "V/1 -BEVERGERN-"
				}
			],
			"plz": "48477"
		},
		"Gescher": {
			"stations": [
				{
					"mstnr": "60220867",
					"date": "2015-09-24",
					"value": 95.66,
					"mstbez": "HS/86 -TUNGERLOH-"
				}
			],
			"plz": "48712"
		},
		"Übach-Palenberg": {
			"stations": [
				{
					"mstnr": "10201518",
					"date": "2015-10-15",
					"value": 73.96,
					"mstbez": "SCHERPENSEEL"
				}
			],
			"plz": "52531"
		},
		"Borken": {
			"stations": [
				{
					"mstnr": "60230113",
					"date": "2015-06-22",
					"value": 147.03,
					"mstbez": "BO/11 BORKENWIRTHE"
				}
			],
			"plz": "46325"
		},
		"Hille": {
			"stations": [
				{
					"mstnr": "100140312",
					"date": "2015-03-26",
					"value": 1.33,
					"mstbez": "WG 24A   GEESTMOORD"
				},
				{
					"mstnr": "100707543",
					"date": "2015-05-11",
					"value": 20.01,
					"mstbez": "WR 4  BR ROTHENUFFN"
				},
				{
					"mstnr": "100707543",
					"date": "2015-10-16",
					"value": 20.01,
					"mstbez": "WR 4  BR ROTHENUFFN"
				},
				{
					"mstnr": "100703331",
					"date": "2015-10-27",
					"value": 12,
					"mstbez": "SU 13A BR SUEDHEMM"
				},
				{
					"mstnr": "100140350",
					"date": "2015-03-17",
					"value": 8.9,
					"mstbez": "WG 16    WESTERHOF"
				},
				{
					"mstnr": "100140087",
					"date": "2015-03-17",
					"value": 84.14,
					"mstbez": "SU 79    WG 9/SUEDH"
				}
			],
			"plz": "32479"
		},
		"Waldfeucht": {
			"stations": [
				{
					"mstnr": "10403127",
					"date": "2015-06-01",
					"value": 82.81,
					"mstbez": "Waldfeucht  P 2"
				}
			],
			"plz": "52525"
		},
		"Kleve": {
			"stations": [
				{
					"mstnr": "80303407",
					"date": "2015-01-07",
					"value": 59.79,
					"mstbez": "KLEVE WARBEYEN  403"
				},
				{
					"mstnr": "80301496",
					"date": "2015-08-14",
					"value": 1.28,
					"mstbez": "RINDERN SCHULE  297"
				},
				{
					"mstnr": "80301654",
					"date": "2015-01-07",
					"value": 23.78,
					"mstbez": "KELLEN          313"
				},
				{
					"mstnr": "80200758",
					"date": "2015-05-22",
					"value": 62,
					"mstbez": "REICHSWALD      162"
				}
			],
			"plz": "47533"
		},
		"Möhnesee": {
			"stations": [
				{
					"mstnr": "94140224",
					"date": "2015-05-07",
					"value": 34.1,
					"mstbez": "Quelle Delecke"
				},
				{
					"mstnr": "94140017",
					"date": "2015-05-07",
					"value": 1.33,
					"mstbez": "Br Neuhaus"
				}
			],
			"plz": "59519"
		},
		"Kerken": {
			"stations": [
				{
					"mstnr": "80302944",
					"date": "2015-08-19",
					"value": 40.03,
					"mstbez": "HOOG POELYCK    371"
				}
			],
			"plz": "47647"
		},
		"Jüchen": {
			"stations": [
				{
					"mstnr": "288066613",
					"date": "2015-05-04",
					"value": 22.1,
					"mstbez": "Hoppers"
				}
			],
			"plz": "41363"
		},
		"Tecklenburg": {
			"stations": [
				{
					"mstnr": "118052056",
					"date": "2015-09-30",
					"value": 34.01,
					"mstbez": "W.BROCHTERBECK-VK05"
				},
				{
					"mstnr": "118052056",
					"date": "2015-04-21",
					"value": 49.55,
					"mstbez": "W.BROCHTERBECK-VK05"
				},
				{
					"mstnr": "110200056",
					"date": "2015-10-29",
					"value": 1.33,
					"mstbez": "TE/5 HORSTMERSCH"
				},
				{
					"mstnr": "110200342",
					"date": "2015-03-19",
					"value": 1.33,
					"mstbez": "TE/34 Habichtswald"
				},
				{
					"mstnr": "118052020",
					"date": "2015-09-30",
					"value": 7.2,
					"mstbez": "W.BROCHTERBECK-VK02"
				},
				{
					"mstnr": "110200354",
					"date": "2015-03-23",
					"value": 1.33,
					"mstbez": "TE/35 Leeden-Butke"
				},
				{
					"mstnr": "110200366",
					"date": "2015-03-24",
					"value": 25.82,
					"mstbez": "TE/36 LEEDEN MagStr"
				},
				{
					"mstnr": "118052020",
					"date": "2015-04-21",
					"value": 6.9,
					"mstbez": "W.BROCHTERBECK-VK02"
				}
			],
			"plz": "49545"
		},
		"Grefrath": {
			"stations": [
				{
					"mstnr": "80300376",
					"date": "2015-09-25",
					"value": 35.21,
					"mstbez": "MÜLHAUSEN   Nr00/91"
				}
			],
			"plz": "47929"
		},
		"Lippstadt": {
			"stations": [
				{
					"mstnr": "91162002",
					"date": "2015-10-21",
					"value": 1.33,
					"mstbez": "Rebbeke OL 52"
				},
				{
					"mstnr": "91162002",
					"date": "2015-05-28",
					"value": 1.33,
					"mstbez": "Rebbeke OL 52"
				},
				{
					"mstnr": "94150084",
					"date": "2015-05-07",
					"value": 3.85,
					"mstbez": "Br Firma Mehling"
				},
				{
					"mstnr": "94150096",
					"date": "2015-05-07",
					"value": 1.33,
					"mstbez": "Br 1 Firma Lange"
				}
			],
			"plz": "59555"
		},
		"Sundern (Sauerland)": {
			"stations": [
				{
					"mstnr": "99580044",
					"date": "2015-05-04",
					"value": 22.59,
					"mstbez": "TB Enkhausen_1"
				},
				{
					"mstnr": "91135000",
					"date": "2015-11-09",
					"value": 27.9,
					"mstbez": "Sundern-Stockum"
				},
				{
					"mstnr": "99580044",
					"date": "2015-07-29",
					"value": 23.01,
					"mstbez": "TB Enkhausen_1"
				},
				{
					"mstnr": "94130619",
					"date": "2015-05-04",
					"value": 34.23,
					"mstbez": "Quelle Hövel"
				},
				{
					"mstnr": "94130656",
					"date": "2015-05-04",
					"value": 14.7,
					"mstbez": "Quelle Hüttebrüchen"
				},
				{
					"mstnr": "94140170",
					"date": "2015-04-08",
					"value": 13.37,
					"mstbez": "Qu Meinkenbracht"
				},
				{
					"mstnr": "91143100",
					"date": "2015-11-09",
					"value": 24.4,
					"mstbez": "Oberröhre B1/92"
				},
				{
					"mstnr": "91135102",
					"date": "2015-10-19",
					"value": 24.45,
					"mstbez": "Sundern-Seidfeld"
				}
			],
			"plz": "59846"
		},
		"Wachtberg": {
			"stations": [
				{
					"mstnr": "71100805",
					"date": "2015-10-14",
					"value": 20.11,
					"mstbez": "ADENDORF ZBR 457"
				},
				{
					"mstnr": "71200307",
					"date": "2015-10-14",
					"value": 130.2,
					"mstbez": "FRITZDORF ZBR 491"
				}
			],
			"plz": "53343"
		},
		"Reken": {
			"stations": [
				{
					"mstnr": "60220697",
					"date": "2015-11-25",
					"value": 34.99,
					"mstbez": "HS/69 -HUELSTEN-"
				}
			],
			"plz": "48734"
		},
		"Hemer": {
			"stations": [
				{
					"mstnr": "59620274",
					"date": "2015-10-05",
					"value": 33.04,
					"mstbez": "Deilinghofen 1"
				},
				{
					"mstnr": "59620079",
					"date": "2015-03-30",
					"value": 12.13,
					"mstbez": "URBECKE"
				},
				{
					"mstnr": "59621072",
					"date": "2015-09-08",
					"value": 25.33,
					"mstbez": "Felsenmeer"
				},
				{
					"mstnr": "59621175",
					"date": "2015-04-08",
					"value": 1.9,
					"mstbez": "Balver Weg TB IIa"
				}
			],
			"plz": "58675"
		},
		"Detmold": {
			"stations": [
				{
					"mstnr": "106501987",
					"date": "2015-10-28",
					"value": 5,
					"mstbez": "BERL1 QU BERLEBECK"
				},
				{
					"mstnr": "106501987",
					"date": "2015-05-18",
					"value": 5,
					"mstbez": "BERL1 QU BERLEBECK"
				},
				{
					"mstnr": "106501926",
					"date": "2015-10-19",
					"value": 21.01,
					"mstbez": "KLUE4 BR KLUET DETM"
				},
				{
					"mstnr": "106502359",
					"date": "2015-05-05",
					"value": 1,
					"mstbez": "MASSB BR MASSBRUCH"
				},
				{
					"mstnr": "100790318",
					"date": "2015-05-19",
					"value": 8,
					"mstbez": "HEID1 BR HEIDENTAL"
				},
				{
					"mstnr": "106500053",
					"date": "2015-02-25",
					"value": 14.66,
					"mstbez": "PIV33 QU PIVITSHEID"
				},
				{
					"mstnr": "106501926",
					"date": "2015-01-05",
					"value": 19.01,
					"mstbez": "KLUE4 BR KLUET DETM"
				},
				{
					"mstnr": "106501926",
					"date": "2015-02-10",
					"value": 19.01,
					"mstbez": "KLUE4 BR KLUET DETM"
				},
				{
					"mstnr": "106501926",
					"date": "2015-03-02",
					"value": 20.01,
					"mstbez": "KLUE4 BR KLUET DETM"
				},
				{
					"mstnr": "100790318",
					"date": "2015-11-10",
					"value": 9,
					"mstbez": "HEID1 BR HEIDENTAL"
				},
				{
					"mstnr": "106501926",
					"date": "2015-04-01",
					"value": 20.01,
					"mstbez": "KLUE4 BR KLUET DETM"
				},
				{
					"mstnr": "106501926",
					"date": "2015-05-04",
					"value": 21.01,
					"mstbez": "KLUE4 BR KLUET DETM"
				},
				{
					"mstnr": "106501926",
					"date": "2015-05-18",
					"value": 19.01,
					"mstbez": "KLUE4 BR KLUET DETM"
				},
				{
					"mstnr": "106506547",
					"date": "2015-05-05",
					"value": 5,
					"mstbez": "OBERS BR OBERSCHHGN"
				},
				{
					"mstnr": "106506547",
					"date": "2015-10-13",
					"value": 2,
					"mstbez": "OBERS BR OBERSCHHGN"
				},
				{
					"mstnr": "106502359",
					"date": "2015-10-13",
					"value": 1,
					"mstbez": "MASSB BR MASSBRUCH"
				},
				{
					"mstnr": "106501926",
					"date": "2015-07-01",
					"value": 21.01,
					"mstbez": "KLUE4 BR KLUET DETM"
				},
				{
					"mstnr": "106501926",
					"date": "2015-08-04",
					"value": 21.01,
					"mstbez": "KLUE4 BR KLUET DETM"
				},
				{
					"mstnr": "106501926",
					"date": "2015-09-03",
					"value": 21.01,
					"mstbez": "KLUE4 BR KLUET DETM"
				},
				{
					"mstnr": "106501926",
					"date": "2015-06-08",
					"value": 21.01,
					"mstbez": "KLUE4 BR KLUET DETM"
				}
			],
			"plz": "32756"
		},
		"Steinhagen": {
			"stations": [
				{
					"mstnr": "20103177",
					"date": "2015-07-15",
					"value": 1.33,
					"mstbez": "III/4AF Brockhagen"
				},
				{
					"mstnr": "21001777",
					"date": "2015-07-15",
					"value": 9.34,
					"mstbez": "768F            LGD"
				},
				{
					"mstnr": "21001765",
					"date": "2015-07-15",
					"value": 75.29,
					"mstbez": "768 T         LGD"
				},
				{
					"mstnr": "20103165",
					"date": "2015-07-15",
					"value": 1.33,
					"mstbez": "III/4AT Brockhagen"
				},
				{
					"mstnr": "20781246",
					"date": "2015-10-16",
					"value": 18.01,
					"mstbez": "BR 4 Patthorst"
				},
				{
					"mstnr": "20781246",
					"date": "2015-06-18",
					"value": 22.01,
					"mstbez": "BR 4 Patthorst"
				},
				{
					"mstnr": "20781246",
					"date": "2015-03-11",
					"value": 21.01,
					"mstbez": "BR 4 Patthorst"
				},
				{
					"mstnr": "20103037",
					"date": "2015-07-15",
					"value": 14.92,
					"mstbez": "III/3LGD Ordelheide"
				},
				{
					"mstnr": "20781246",
					"date": "2015-02-13",
					"value": 21.01,
					"mstbez": "BR 4 Patthorst"
				}
			],
			"plz": "33803"
		},
		"Steinheim": {
			"stations": [
				{
					"mstnr": "26503219",
					"date": "2015-10-26",
					"value": 28.01,
					"mstbez": "Br Eichholz"
				},
				{
					"mstnr": "26503219",
					"date": "2015-03-25",
					"value": 38.01,
					"mstbez": "Br Eichholz"
				}
			],
			"plz": "32839"
		},
		"Rheinberg": {
			"stations": [
				{
					"mstnr": "42011358",
					"date": "2015-01-16",
					"value": 15.41,
					"mstbez": "LINEG_1276H"
				},
				{
					"mstnr": "42063917",
					"date": "2015-01-15",
					"value": 0.15,
					"mstbez": "LINEG_2593"
				},
				{
					"mstnr": "42001006",
					"date": "2015-12-02",
					"value": 6.7,
					"mstbez": "LINEG_131"
				},
				{
					"mstnr": "42014542",
					"date": "2015-12-07",
					"value": 33.01,
					"mstbez": "LINEG_1597"
				},
				{
					"mstnr": "42013987",
					"date": "2015-06-01",
					"value": 13.1,
					"mstbez": "LINEG_1541"
				},
				{
					"mstnr": "42065082",
					"date": "2015-12-07",
					"value": 45.02,
					"mstbez": "LINEG_2702"
				}
			],
			"plz": "47495"
		},
		"Brüggen": {
			"stations": [
				{
					"mstnr": "81150040",
					"date": "2015-09-04",
					"value": 14.7,
					"mstbez": "WEISSEN STEIN 877"
				}
			],
			"plz": "41379"
		},
		"Greven": {
			"stations": [
				{
					"mstnr": "110040181",
					"date": "2015-12-02",
					"value": 3.88,
					"mstbez": "IV/18-FLUGH.MS-OS.N"
				},
				{
					"mstnr": "110070148",
					"date": "2015-12-01",
					"value": 98.76,
					"mstbez": "VII/14-WESTERODE-"
				},
				{
					"mstnr": "110040144",
					"date": "2015-09-02",
					"value": 1.33,
					"mstbez": "IV/14 -RECKENFELD-"
				}
			],
			"plz": "48268"
		},
		"Recke": {
			"stations": [
				{
					"mstnr": "110200238",
					"date": "2015-04-01",
					"value": 4.74,
					"mstbez": "TE/23 - RECKE -"
				}
			],
			"plz": "49509"
		},
		"Xanten": {
			"stations": [
				{
					"mstnr": "42016459",
					"date": "2015-01-13",
					"value": 30.01,
					"mstbez": "LINEG_1767"
				},
				{
					"mstnr": "47077062",
					"date": "2015-11-11",
					"value": 10.2,
					"mstbez": "Xanten-Wardt Br. G"
				},
				{
					"mstnr": "47077062",
					"date": "2015-05-13",
					"value": 12.9,
					"mstbez": "Xanten-Wardt Br. G"
				},
				{
					"mstnr": "42060564",
					"date": "2015-01-15",
					"value": 106.04,
					"mstbez": "LINEG_2211-2H"
				},
				{
					"mstnr": "42060564",
					"date": "2015-07-22",
					"value": 138.05,
					"mstbez": "LINEG_2211-2H"
				}
			],
			"plz": "46509"
		},
		"Ennigerloh": {
			"stations": [
				{
					"mstnr": "110070513",
					"date": "2015-11-24",
					"value": 1.33,
					"mstbez": "VII/51 BEESENBERG"
				}
			],
			"plz": "59320"
		},
		"Königswinter": {
			"stations": [
				{
					"mstnr": "73761308",
					"date": "2015-05-19",
					"value": 6,
					"mstbez": "WBV THOMASBERG EB 6"
				},
				{
					"mstnr": "73770504",
					"date": "2015-05-19",
					"value": 31.01,
					"mstbez": "WBV THOMASBERG EB 1"
				},
				{
					"mstnr": "73779817",
					"date": "2015-08-12",
					"value": 59.79,
					"mstbez": "WBV THOMASBERG P 15"
				},
				{
					"mstnr": "73779210",
					"date": "2015-10-08",
					"value": 37.2,
					"mstbez": "WBV THOMASBERG P 9"
				},
				{
					"mstnr": "73779118",
					"date": "2015-05-20",
					"value": 11.29,
					"mstbez": "WBV THOMASBERG P 8"
				},
				{
					"mstnr": "73770802",
					"date": "2015-05-19",
					"value": 27.01,
					"mstbez": "WBV THOMASBERG EB 4"
				},
				{
					"mstnr": "73770905",
					"date": "2015-05-19",
					"value": 35.01,
					"mstbez": "WBV THOMASBERG EB 5"
				},
				{
					"mstnr": "73727283",
					"date": "2015-10-08",
					"value": 9.48,
					"mstbez": "WLV QUIRRENBACH QF"
				},
				{
					"mstnr": "76988594",
					"date": "2015-03-25",
					"value": 9.03,
					"mstbez": "Kloster Heisterb.QF"
				},
				{
					"mstnr": "76990280",
					"date": "2015-03-25",
					"value": 25.55,
					"mstbez": "VVS Siebengeb. QF"
				},
				{
					"mstnr": "73770607",
					"date": "2015-05-19",
					"value": 24.01,
					"mstbez": "WBV THOMASBERG EB 2"
				},
				{
					"mstnr": "76988491",
					"date": "2015-03-26",
					"value": 15.23,
					"mstbez": "Wintermühlenhof QF"
				}
			],
			"plz": "53639"
		},
		"Enger": {
			"stations": [
				{
					"mstnr": "106503959",
					"date": "2015-04-14",
					"value": 2,
					"mstbez": "HI 6 BR  HIDDENHAUS"
				},
				{
					"mstnr": "100761410",
					"date": "2015-01-15",
					"value": 1,
					"mstbez": "CONLE BR ENGER CONL"
				},
				{
					"mstnr": "100761410",
					"date": "2015-11-04",
					"value": 1,
					"mstbez": "CONLE BR ENGER CONL"
				},
				{
					"mstnr": "100761410",
					"date": "2015-01-14",
					"value": 1,
					"mstbez": "CONLE BR ENGER CONL"
				}
			],
			"plz": "32130"
		},
		"Waltrop": {
			"stations": [
				{
					"mstnr": "60100904",
					"date": "2015-11-30",
					"value": 1.33,
					"mstbez": "RWI 59"
				},
				{
					"mstnr": "60100308",
					"date": "2015-11-19",
					"value": 1.33,
					"mstbez": "RWI 51"
				}
			],
			"plz": "45731"
		},
		"Nordwalde": {
			"stations": [
				{
					"mstnr": "110040132",
					"date": "2015-08-25",
					"value": 1.33,
					"mstbez": "IV/13 -RECKENFELD-"
				},
				{
					"mstnr": "110070173",
					"date": "2015-08-24",
					"value": 1.33,
					"mstbez": "VII/17 -RECKENFELD-"
				}
			],
			"plz": "48356"
		},
		"Soest": {
			"stations": [
				{
					"mstnr": "94140248",
					"date": "2015-04-09",
					"value": 41.98,
					"mstbez": "Qu Am großen Teich"
				},
				{
					"mstnr": "94140250",
					"date": "2015-04-09",
					"value": 39.06,
					"mstbez": "Quelle Ampen"
				},
				{
					"mstnr": "94140042",
					"date": "2015-04-09",
					"value": 1.33,
					"mstbez": "Br Firma Pfingsten"
				}
			],
			"plz": "59494"
		},
		"Linnich": {
			"stations": [
				{
					"mstnr": "10408381",
					"date": "2015-10-19",
					"value": 40.38,
					"mstbez": "Linnich Br 630 Rohw"
				},
				{
					"mstnr": "10408381",
					"date": "2015-04-27",
					"value": 44.73,
					"mstbez": "Linnich Br 630 Rohw"
				},
				{
					"mstnr": "219282018",
					"date": "2015-07-09",
					"value": 0.89,
					"mstbez": "Pickartzhof"
				},
				{
					"mstnr": "16003706",
					"date": "2015-03-26",
					"value": 18.25,
					"mstbez": "SIG Combiblock,Br.I"
				}
			],
			"plz": "52441"
		},
		"Höxter": {
			"stations": [
				{
					"mstnr": "20751011",
					"date": "2015-03-10",
					"value": 28.81,
					"mstbez": "KAPEBHORI"
				},
				{
					"mstnr": "20751011",
					"date": "2015-09-15",
					"value": 27.51,
					"mstbez": "KAPEBHORI"
				},
				{
					"mstnr": "20752349",
					"date": "2015-03-04",
					"value": 25.81,
					"mstbez": "SCHEB004"
				},
				{
					"mstnr": "26500115",
					"date": "2015-02-12",
					"value": 19.09,
					"mstbez": "Q11A Ottbergen"
				},
				{
					"mstnr": "20752349",
					"date": "2015-09-01",
					"value": 27.81,
					"mstbez": "SCHEB004"
				},
				{
					"mstnr": "20753019",
					"date": "2015-03-10",
					"value": 27.91,
					"mstbez": "BRUEBII"
				},
				{
					"mstnr": "20790624",
					"date": "2015-03-10",
					"value": 29.91,
					"mstbez": "INDWBALBII"
				},
				{
					"mstnr": "20790624",
					"date": "2015-09-15",
					"value": 29.11,
					"mstbez": "INDWBALBII"
				},
				{
					"mstnr": "20753019",
					"date": "2015-09-15",
					"value": 21.01,
					"mstbez": "BRUEBII"
				},
				{
					"mstnr": "20791410",
					"date": "2015-09-01",
					"value": 44.32,
					"mstbez": "OTTBBOTTBE"
				},
				{
					"mstnr": "20791215",
					"date": "2015-03-04",
					"value": 11.1,
					"mstbez": "BOSSBBOSSE"
				},
				{
					"mstnr": "20791215",
					"date": "2015-09-01",
					"value": 16.51,
					"mstbez": "BOSSBBOSSE"
				},
				{
					"mstnr": "20791410",
					"date": "2015-03-04",
					"value": 43.72,
					"mstbez": "OTTBBOTTBE"
				},
				{
					"mstnr": "20791318",
					"date": "2015-09-01",
					"value": 25.01,
					"mstbez": "LUETBARTES"
				},
				{
					"mstnr": "20791318",
					"date": "2015-03-04",
					"value": 26.71,
					"mstbez": "LUETBARTES"
				}
			],
			"plz": "37671"
		},
		"Coesfeld": {
			"stations": [
				{
					"mstnr": "110220419",
					"date": "2015-09-11",
					"value": 58.9,
					"mstbez": "HS/41-COE.STOCKUM-"
				},
				{
					"mstnr": "110220390",
					"date": "2015-09-10",
					"value": 46.06,
					"mstbez": "HS/39 -COE. GOXEL-"
				},
				{
					"mstnr": "110220365",
					"date": "2015-11-06",
					"value": 1.33,
					"mstbez": "HS/36 LETTER BRUCH"
				},
				{
					"mstnr": "110240145",
					"date": "2015-09-16",
					"value": 21.08,
					"mstbez": "AH/14 COE.M.GAUPEL"
				},
				{
					"mstnr": "110310317",
					"date": "2015-09-23",
					"value": 2.32,
					"mstbez": "COE./31 -COESFELD-"
				},
				{
					"mstnr": "110220808",
					"date": "2015-12-07",
					"value": 18.42,
					"mstbez": "HS/80 COE.FLAMSCHEN"
				},
				{
					"mstnr": "113409096",
					"date": "2015-04-20",
					"value": 1,
					"mstbez": "COESFELD 09"
				},
				{
					"mstnr": "113409102",
					"date": "2015-04-16",
					"value": 1,
					"mstbez": "COESFELD 10"
				},
				{
					"mstnr": "113409151",
					"date": "2015-04-20",
					"value": 33.71,
					"mstbez": "COESFELD 15"
				},
				{
					"mstnr": "113409163",
					"date": "2015-04-20",
					"value": 39.41,
					"mstbez": "COESFELD 16"
				},
				{
					"mstnr": "118260042",
					"date": "2015-04-22",
					"value": 31.91,
					"mstbez": "WW.LETTE-VFP.04"
				},
				{
					"mstnr": "110220791",
					"date": "2015-12-07",
					"value": 178.47,
					"mstbez": "HS/79 -FLAMSCHEN-"
				},
				{
					"mstnr": "118262099",
					"date": "2015-04-22",
					"value": 16.81,
					"mstbez": "WW.LETTE-HUMB.-VK09"
				}
			],
			"plz": "48653"
		},
		"Monheim": {
			"stations": [
				{
					"mstnr": "36411589",
					"date": "2015-01-06",
					"value": 7.44,
					"mstbez": "VWW LANGENFELD P41"
				}
			],
			"plz": "40789"
		},
		"Nettetal": {
			"stations": [
				{
					"mstnr": "80201570",
					"date": "2015-08-27",
					"value": 234.71,
					"mstbez": "FLOTHEND 200"
				},
				{
					"mstnr": "80201520",
					"date": "2015-06-23",
					"value": 67.31,
					"mstbez": "VENLOER-HEIDE 195"
				},
				{
					"mstnr": "80301850",
					"date": "2015-07-07",
					"value": 156.33,
					"mstbez": "MODELLFLUGPLATZ 333"
				}
			],
			"plz": "41334"
		},
		"Drolshagen": {
			"stations": [
				{
					"mstnr": "129660577",
					"date": "2015-10-14",
					"value": 16.96,
					"mstbez": "Herpel"
				},
				{
					"mstnr": "129660590",
					"date": "2015-04-21",
					"value": 10.54,
					"mstbez": "Heimicke"
				}
			],
			"plz": "57489"
		},
		"Rüthen": {
			"stations": [
				{
					"mstnr": "94160090",
					"date": "2015-12-09",
					"value": 16.01,
					"mstbez": "Lörmecke-Quelle"
				},
				{
					"mstnr": "94160090",
					"date": "2015-11-17",
					"value": 16.01,
					"mstbez": "Lörmecke-Quelle"
				},
				{
					"mstnr": "94160193",
					"date": "2015-04-23",
					"value": 44.29,
					"mstbez": "Quelle Stallmeister"
				},
				{
					"mstnr": "94160090",
					"date": "2015-10-07",
					"value": 16.01,
					"mstbez": "Lörmecke-Quelle"
				},
				{
					"mstnr": "94160090",
					"date": "2015-07-15",
					"value": 17.01,
					"mstbez": "Lörmecke-Quelle"
				},
				{
					"mstnr": "94160090",
					"date": "2015-08-13",
					"value": 17.01,
					"mstbez": "Lörmecke-Quelle"
				},
				{
					"mstnr": "94160090",
					"date": "2015-01-14",
					"value": 18.01,
					"mstbez": "Lörmecke-Quelle"
				},
				{
					"mstnr": "94160090",
					"date": "2015-05-05",
					"value": 17.32,
					"mstbez": "Lörmecke-Quelle"
				},
				{
					"mstnr": "94160089",
					"date": "2015-05-05",
					"value": 38.35,
					"mstbez": "Quelle Rißnei"
				},
				{
					"mstnr": "91167309",
					"date": "2015-10-21",
					"value": 10.81,
					"mstbez": "Kallenhardt Ost"
				},
				{
					"mstnr": "91167504",
					"date": "2015-09-29",
					"value": 17.4,
					"mstbez": "Kallenhardt DEKRA"
				},
				{
					"mstnr": "94170083",
					"date": "2015-04-23",
					"value": 17.94,
					"mstbez": "Que Kneblinghausen"
				},
				{
					"mstnr": "94160090",
					"date": "2015-09-08",
					"value": 17.01,
					"mstbez": "Lörmecke-Quelle"
				}
			],
			"plz": "59602"
		},
		"Rommerskirchen": {
			"stations": [
				{
					"mstnr": "289194910",
					"date": "2015-05-18",
					"value": 29.32,
					"mstbez": "Anstel   3"
				}
			],
			"plz": "41569"
		},
		"Erndtebrück": {
			"stations": [
				{
					"mstnr": "129700058",
					"date": "2015-04-28",
					"value": 4.33,
					"mstbez": "Zinse"
				}
			],
			"plz": "57339"
		},
		"Hattingen": {
			"stations": [
				{
					"mstnr": "59540576",
					"date": "2015-05-06",
					"value": 1.33,
					"mstbez": "BAERWINKEL"
				},
				{
					"mstnr": "59540564",
					"date": "2015-10-19",
					"value": 1.33,
					"mstbez": "HATTINGEN 17"
				}
			],
			"plz": "45525"
		},
		"Kaarst": {
			"stations": [
				{
					"mstnr": "86452216",
					"date": "2015-09-22",
					"value": 17.01,
					"mstbez": "E DRIESCH D904"
				},
				{
					"mstnr": "80300285",
					"date": "2015-02-23",
					"value": 0.62,
					"mstbez": "BÜTTGEN-SPORTPL.190"
				},
				{
					"mstnr": "80301332",
					"date": "2015-08-20",
					"value": 75.29,
					"mstbez": "DREILINDENHOF   281"
				},
				{
					"mstnr": "86452216",
					"date": "2015-03-17",
					"value": 16.01,
					"mstbez": "E DRIESCH D904"
				}
			],
			"plz": "41564"
		},
		"Telgte": {
			"stations": [
				{
					"mstnr": "118841038",
					"date": "2015-04-23",
					"value": 1,
					"mstbez": "WW.TELGTE-VK03"
				},
				{
					"mstnr": "118841038",
					"date": "2015-10-27",
					"value": 1,
					"mstbez": "WW.TELGTE-VK03"
				}
			],
			"plz": "48291"
		},
		"Balve": {
			"stations": [
				{
					"mstnr": "59620213",
					"date": "2015-03-24",
					"value": 13.51,
					"mstbez": "BINOLEN"
				},
				{
					"mstnr": "59620754",
					"date": "2015-09-30",
					"value": 13.15,
					"mstbez": "Orle"
				}
			],
			"plz": "58802"
		},
		"Altena": {
			"stations": [
				{
					"mstnr": "59620092",
					"date": "2015-04-08",
					"value": 12.13,
					"mstbez": "Springer Quelle"
				}
			],
			"plz": "58762"
		},
		"Oelde": {
			"stations": [
				{
					"mstnr": "110070537",
					"date": "2015-11-12",
					"value": 3.81,
					"mstbez": "VII/53 LETTE"
				},
				{
					"mstnr": "110070549",
					"date": "2015-11-12",
					"value": 1.33,
					"mstbez": "VII/54 OELDE"
				}
			],
			"plz": "59302"
		},
		"Freudenberg": {
			"stations": [
				{
					"mstnr": "129700812",
					"date": "2015-04-15",
					"value": 14.17,
					"mstbez": "Heisbergquelle"
				}
			],
			"plz": "57258"
		},
		"Bielefeld": {
			"stations": [
				{
					"mstnr": "23061870",
					"date": "2015-09-09",
					"value": 2.17,
					"mstbez": "575.1  - 98/2   W 1"
				},
				{
					"mstnr": "23061881",
					"date": "2015-05-20",
					"value": 8.2,
					"mstbez": "575.3  - 98/2   W 1"
				},
				{
					"mstnr": "20104042",
					"date": "2015-09-22",
					"value": 45.17,
					"mstbez": "206 A Tief - 94/4.2"
				},
				{
					"mstnr": "20104054",
					"date": "2015-09-22",
					"value": 42.87,
					"mstbez": "205F   - 94/4.1 LGD"
				},
				{
					"mstnr": "23063075",
					"date": "2015-09-29",
					"value": 25.29,
					"mstbez": "178 ML          W 2"
				},
				{
					"mstnr": "23062861",
					"date": "2015-07-29",
					"value": 20.46,
					"mstbez": "66F    - 97/23  W 2"
				},
				{
					"mstnr": "23062850",
					"date": "2015-07-29",
					"value": 10.01,
					"mstbez": "66     - 97/23  W 2"
				},
				{
					"mstnr": "23002785",
					"date": "2015-09-09",
					"value": 16.01,
					"mstbez": "W02 12A Sennest-Wes"
				},
				{
					"mstnr": "23061881",
					"date": "2015-09-09",
					"value": 8.81,
					"mstbez": "575.3  - 98/2   W 1"
				},
				{
					"mstnr": "21000153",
					"date": "2015-10-15",
					"value": 5.49,
					"mstbez": "613 LGD Ummeln"
				},
				{
					"mstnr": "23061870",
					"date": "2015-05-20",
					"value": 4.3,
					"mstbez": "575.1  - 98/2   W 1"
				},
				{
					"mstnr": "26540204",
					"date": "2015-09-29",
					"value": 53.14,
					"mstbez": "178-19,5m ML"
				},
				{
					"mstnr": "26525094",
					"date": "2015-09-09",
					"value": 18.29,
					"mstbez": "575.2 W1 Sennestadt"
				},
				{
					"mstnr": "26540174",
					"date": "2015-09-29",
					"value": 116.03,
					"mstbez": "178- 3,0m ML"
				},
				{
					"mstnr": "26540186",
					"date": "2015-09-29",
					"value": 2.39,
					"mstbez": "178-11,5m ML"
				},
				{
					"mstnr": "26540198",
					"date": "2015-09-29",
					"value": 34.81,
					"mstbez": "178-15,5m ML"
				}
			],
			"plz": "33602"
		},
		"Lienen": {
			"stations": [
				{
					"mstnr": "110200482",
					"date": "2015-11-24",
					"value": 15.85,
					"mstbez": "TE/48 Lienen Bad"
				},
				{
					"mstnr": "110200100",
					"date": "2015-10-30",
					"value": 2.17,
					"mstbez": "TE/10 -KATTENVENNE-"
				}
			],
			"plz": "49536"
		},
		"Bad Laasphe": {
			"stations": [
				{
					"mstnr": "129700290",
					"date": "2015-03-31",
					"value": 9.79,
					"mstbez": "Ilsequelle"
				},
				{
					"mstnr": "129700782",
					"date": "2015-10-13",
					"value": 6.38,
					"mstbez": "Niederlaasphe"
				},
				{
					"mstnr": "129700083",
					"date": "2015-03-31",
					"value": 5.05,
					"mstbez": "Im Grund"
				},
				{
					"mstnr": "129700186",
					"date": "2015-10-27",
					"value": 2.91,
					"mstbez": "Gonderbach"
				}
			],
			"plz": "57334"
		},
		"Lüdenscheid": {
			"stations": [
				{
					"mstnr": "59621199",
					"date": "2015-10-06",
					"value": 5.05,
					"mstbez": "Homert SGV alt"
				},
				{
					"mstnr": "59621187",
					"date": "2015-10-06",
					"value": 3.08,
					"mstbez": "Homert SGV neu"
				}
			],
			"plz": "58507"
		},
		"Schermbeck": {
			"stations": [
				{
					"mstnr": "40070130",
					"date": "2015-12-02",
					"value": 33.97,
					"mstbez": "1 07 030 - HS 111"
				},
				{
					"mstnr": "40071005",
					"date": "2015-11-23",
					"value": 75.29,
					"mstbez": "0 07 100 - HS 115"
				}
			],
			"plz": "46514"
		},
		"Krefeld": {
			"stations": [
				{
					"mstnr": "86600485",
					"date": "2015-11-23",
					"value": 0.05,
					"mstbez": "SWK P 446F"
				},
				{
					"mstnr": "86600643",
					"date": "2015-11-30",
					"value": 15.71,
					"mstbez": "SWK P 462"
				},
				{
					"mstnr": "86568371",
					"date": "2015-10-22",
					"value": 20.91,
					"mstbez": "E In der Elt VHB 2"
				},
				{
					"mstnr": "80301885",
					"date": "2015-04-17",
					"value": 77.94,
					"mstbez": "HÜLS  PARKPL.   336"
				},
				{
					"mstnr": "80100612",
					"date": "2015-09-10",
					"value": 102.3,
					"mstbez": "HÜLS STEEG      022"
				},
				{
					"mstnr": "80303638",
					"date": "2015-09-10",
					"value": 0.13,
					"mstbez": "SCHWANENMARKT KREF."
				},
				{
					"mstnr": "80200734",
					"date": "2015-01-16",
					"value": 32.01,
					"mstbez": "VENNICKEL 160"
				},
				{
					"mstnr": "86568371",
					"date": "2015-05-21",
					"value": 22.71,
					"mstbez": "E In der Elt VHB 2"
				},
				{
					"mstnr": "80200734",
					"date": "2015-09-10",
					"value": 32.15,
					"mstbez": "VENNICKEL 160"
				}
			],
			"plz": "47803"
		},
		"Legden": {
			"stations": [
				{
					"mstnr": "60240374",
					"date": "2015-06-09",
					"value": 10.27,
					"mstbez": "AH/37 -WEHR-"
				}
			],
			"plz": "48739"
		},
		"Niederkrüchten": {
			"stations": [
				{
					"mstnr": "80301150",
					"date": "2015-08-31",
					"value": 5.71,
					"mstbez": "ELMPTER BRUCH   263"
				}
			],
			"plz": "41372"
		},
		"Bad Oeynhausen": {
			"stations": [
				{
					"mstnr": "106502633",
					"date": "2015-07-03",
					"value": 2,
					"mstbez": "WITT BR  DIA WITTE"
				},
				{
					"mstnr": "100750059",
					"date": "2015-04-20",
					"value": 18.01,
					"mstbez": "RE 5  BR REHME OEYN"
				},
				{
					"mstnr": "106502633",
					"date": "2015-10-12",
					"value": 1,
					"mstbez": "WITT BR  DIA WITTE"
				},
				{
					"mstnr": "106502633",
					"date": "2015-04-20",
					"value": 1,
					"mstbez": "WITT BR  DIA WITTE"
				},
				{
					"mstnr": "100750059",
					"date": "2015-10-12",
					"value": 15.01,
					"mstbez": "RE 5  BR REHME OEYN"
				}
			],
			"plz": "32545"
		},
		"Hellenthal": {
			"stations": [
				{
					"mstnr": "10409920",
					"date": "2015-04-16",
					"value": 4.83,
					"mstbez": "Lorenzsiefen-Quelle"
				}
			],
			"plz": "53940"
		},
		"Wülfrath": {
			"stations": [
				{
					"mstnr": "31040093",
					"date": "2015-09-15",
					"value": 50.04,
					"mstbez": "Wül-Silberberg B18"
				},
				{
					"mstnr": "31040032",
					"date": "2015-09-14",
					"value": 32.82,
					"mstbez": "Wül-Rohdenhaus FP2"
				},
				{
					"mstnr": "31040100",
					"date": "2015-09-15",
					"value": 13.02,
					"mstbez": "Wül-Dornap P15"
				}
			],
			"plz": "42489"
		},
		"Troisdorf": {
			"stations": [
				{
					"mstnr": "70282511",
					"date": "2015-01-12",
					"value": 10.7,
					"mstbez": "LGD Troisdf. NH 1"
				},
				{
					"mstnr": "73767610",
					"date": "2015-08-03",
					"value": 16.3,
					"mstbez": "SW TROISD ESCH 24"
				},
				{
					"mstnr": "70282717",
					"date": "2015-01-12",
					"value": 12,
					"mstbez": "LGD Troisdf. NH 3"
				},
				{
					"mstnr": "70282810",
					"date": "2015-01-12",
					"value": 16.61,
					"mstbez": "LGD Troisdf. NH 4"
				},
				{
					"mstnr": "70283011",
					"date": "2015-01-13",
					"value": 17.21,
					"mstbez": "LGD Troisdf. NH 6"
				},
				{
					"mstnr": "76811311",
					"date": "2015-07-30",
					"value": 13.15,
					"mstbez": "RSK ALTABL. 124/B1"
				},
				{
					"mstnr": "70187915",
					"date": "2015-01-13",
					"value": 22.91,
					"mstbez": "LGD TROISDORF RP 12"
				},
				{
					"mstnr": "76737718",
					"date": "2015-04-17",
					"value": 69.97,
					"mstbez": "SW TROISD AGGER P7"
				},
				{
					"mstnr": "70197910",
					"date": "2015-01-12",
					"value": 31.21,
					"mstbez": "LGD Troisdf.-Spich"
				},
				{
					"mstnr": "76815717",
					"date": "2015-07-17",
					"value": 11.69,
					"mstbez": "HUELS TROISD 01.1"
				},
				{
					"mstnr": "70197313",
					"date": "2015-04-30",
					"value": 13.24,
					"mstbez": "LGD TROISD.-BERGHM."
				},
				{
					"mstnr": "70197910",
					"date": "2015-04-24",
					"value": 28.12,
					"mstbez": "LGD Troisdf.-Spich"
				}
			],
			"plz": "53840"
		},
		"Salzkotten": {
			"stations": [
				{
					"mstnr": "24170148",
					"date": "2015-04-15",
					"value": 25.01,
					"mstbez": "BR 3    Salzkotten"
				},
				{
					"mstnr": "24170150",
					"date": "2015-10-05",
					"value": 21.43,
					"mstbez": "Hederquelle"
				},
				{
					"mstnr": "24170148",
					"date": "2015-10-14",
					"value": 22.01,
					"mstbez": "BR 3    Salzkotten"
				},
				{
					"mstnr": "24170173",
					"date": "2015-10-14",
					"value": 34.01,
					"mstbez": "BR 4    Salzkotten"
				},
				{
					"mstnr": "21171403",
					"date": "2015-10-07",
					"value": 46.06,
					"mstbez": "OL 289 Thüle"
				},
				{
					"mstnr": "21173709",
					"date": "2015-11-03",
					"value": 1.33,
					"mstbez": "OL 361"
				},
				{
					"mstnr": "24170150",
					"date": "2015-03-18",
					"value": 25.73,
					"mstbez": "Hederquelle"
				},
				{
					"mstnr": "24170173",
					"date": "2015-04-15",
					"value": 36.01,
					"mstbez": "BR 4    Salzkotten"
				}
			],
			"plz": "33154"
		},
		"Ascheberg": {
			"stations": [
				{
					"mstnr": "110250114",
					"date": "2015-11-25",
					"value": 1.33,
					"mstbez": "BERGB 11-FORSTHOEV-"
				},
				{
					"mstnr": "110250072",
					"date": "2015-11-25",
					"value": 38.62,
					"mstbez": "BERGB 7-NORDICK-"
				},
				{
					"mstnr": "110250060",
					"date": "2015-11-18",
					"value": 1.33,
					"mstbez": "BERGB 6-NORDICK-"
				}
			],
			"plz": "59387"
		},
		"Everswinkel": {
			"stations": [
				{
					"mstnr": "110070422",
					"date": "2015-11-18",
					"value": 1.33,
					"mstbez": "VII/42 WETTENDORF"
				}
			],
			"plz": "48351"
		},
		"Marl": {
			"stations": [
				{
					"mstnr": "60081430",
					"date": "2015-04-28",
					"value": 19.44,
					"mstbez": "HS 131"
				},
				{
					"mstnr": "60081429",
					"date": "2015-12-03",
					"value": 27.15,
					"mstbez": "HS 130"
				}
			],
			"plz": "45768"
		},
		"Haan": {
			"stations": [
				{
					"mstnr": "31040020",
					"date": "2015-09-07",
					"value": 13.64,
					"mstbez": "Haan-Gruiten P38"
				},
				{
					"mstnr": "36462408",
					"date": "2015-09-18",
					"value": 13.29,
					"mstbez": "Stadtw.Haan BQ 9"
				}
			],
			"plz": "42781"
		},
		"Drensteinfurt": {
			"stations": [
				{
					"mstnr": "110250035",
					"date": "2015-11-20",
					"value": 2.76,
					"mstbez": "BERGB.3-D.BAUERSCHT"
				},
				{
					"mstnr": "110250126",
					"date": "2015-11-26",
					"value": 1.33,
					"mstbez": "BERGB.12-MERSCH-"
				},
				{
					"mstnr": "110250140",
					"date": "2015-11-24",
					"value": 6.95,
					"mstbez": "BERGB 14-WALSTEDDE-"
				}
			],
			"plz": "48317"
		},
		"Rheine": {
			"stations": [
				{
					"mstnr": "110200093",
					"date": "2015-11-02",
					"value": 56.24,
					"mstbez": "TE/9 -HEINE-"
				},
				{
					"mstnr": "110200123",
					"date": "2015-11-03",
					"value": 97.43,
					"mstbez": "TE/12 -RODDE-"
				}
			],
			"plz": "48431"
		},
		"Werther (Westf.)": {
			"stations": [
				{
					"mstnr": "26503153",
					"date": "2015-03-09",
					"value": 9,
					"mstbez": "BR Rotingdorfer Str"
				},
				{
					"mstnr": "26503153",
					"date": "2015-09-07",
					"value": 12,
					"mstbez": "BR Rotingdorfer Str"
				}
			],
			"plz": "33824"
		},
		"Tönisvorst": {
			"stations": [
				{
					"mstnr": "80301903",
					"date": "2015-09-24",
					"value": 8.95,
					"mstbez": "VORST           338"
				},
				{
					"mstnr": "80301873",
					"date": "2015-10-13",
					"value": 23.03,
					"mstbez": "FORSTWALD STOFF.335"
				}
			],
			"plz": "47918"
		},
		"Monschau": {
			"stations": [
				{
					"mstnr": "10410235",
					"date": "2015-02-18",
					"value": 10.01,
					"mstbez": "Breiterscheid Qu."
				},
				{
					"mstnr": "10410247",
					"date": "2015-10-28",
					"value": 10.98,
					"mstbez": "Kranzbruch-Quelle"
				}
			],
			"plz": "52156"
		},
		"Paderborn": {
			"stations": [
				{
					"mstnr": "21175706",
					"date": "2015-10-08",
					"value": 27.41,
					"mstbez": "OL 125  Sande"
				},
				{
					"mstnr": "24180166",
					"date": "2015-03-18",
					"value": 28.65,
					"mstbez": "Qu Maspern-Pader"
				},
				{
					"mstnr": "24180403",
					"date": "2015-08-10",
					"value": 25.01,
					"mstbez": "BR Marx -TN2-Dr-Mer"
				},
				{
					"mstnr": "24180439",
					"date": "2015-08-18",
					"value": 10,
					"mstbez": "Teich PH TN3-WestfK"
				},
				{
					"mstnr": "24180439",
					"date": "2015-10-01",
					"value": 11,
					"mstbez": "Teich PH TN3-WestfK"
				},
				{
					"mstnr": "24180452",
					"date": "2015-03-05",
					"value": 6,
					"mstbez": "Padulus-Quelle"
				},
				{
					"mstnr": "21175603",
					"date": "2015-10-08",
					"value": 1.33,
					"mstbez": "OL 123  Sande"
				},
				{
					"mstnr": "24180762",
					"date": "2015-10-27",
					"value": 35.16,
					"mstbez": "Br Buergerpark TN11"
				},
				{
					"mstnr": "24180452",
					"date": "2015-09-24",
					"value": 7,
					"mstbez": "Padulus-Quelle"
				},
				{
					"mstnr": "23163495",
					"date": "2015-10-27",
					"value": 15.01,
					"mstbez": "TB 12   Diebesweg"
				},
				{
					"mstnr": "21175809",
					"date": "2015-10-08",
					"value": 1.33,
					"mstbez": "OL 127 Sande Niggen"
				},
				{
					"mstnr": "21176103",
					"date": "2015-10-08",
					"value": 3.14,
					"mstbez": "OL 130  Bentfeld"
				},
				{
					"mstnr": "21184306",
					"date": "2015-10-27",
					"value": 24.76,
					"mstbez": "PB2T    Paderborn"
				},
				{
					"mstnr": "24180853",
					"date": "2015-12-03",
					"value": 44.02,
					"mstbez": "PB 4     Wewer"
				},
				{
					"mstnr": "23163239",
					"date": "2015-03-04",
					"value": 4,
					"mstbez": "TB Habichtssee"
				},
				{
					"mstnr": "23163239",
					"date": "2015-09-24",
					"value": 4,
					"mstbez": "TB Habichtssee"
				}
			],
			"plz": "33098"
		},
		"Espelkamp": {
			"stations": [
				{
					"mstnr": "100140324",
					"date": "2015-06-02",
					"value": 15.15,
					"mstbez": "WG 34    FROTHEIM"
				},
				{
					"mstnr": "100705170",
					"date": "2015-10-13",
					"value": 1,
					"mstbez": "ES 7  BR ESPELKAMP"
				},
				{
					"mstnr": "100141328",
					"date": "2015-05-21",
					"value": 1.33,
					"mstbez": "WG 51N   IM STRANGE"
				},
				{
					"mstnr": "100141365",
					"date": "2015-06-02",
					"value": 1.33,
					"mstbez": "WF 2    FROTHEIM"
				},
				{
					"mstnr": "100141377",
					"date": "2015-06-02",
					"value": 1.33,
					"mstbez": "WF 3    ESPELKAMP"
				},
				{
					"mstnr": "100705121",
					"date": "2015-10-13",
					"value": 1,
					"mstbez": "ES 2  BR ESPELKAMP"
				},
				{
					"mstnr": "100705170",
					"date": "2015-04-15",
					"value": 1,
					"mstbez": "ES 7  BR ESPELKAMP"
				},
				{
					"mstnr": "100705121",
					"date": "2015-04-15",
					"value": 2,
					"mstbez": "ES 2  BR ESPELKAMP"
				}
			],
			"plz": "32339"
		},
		"Finnentrop": {
			"stations": [
				{
					"mstnr": "129660206",
					"date": "2015-07-15",
					"value": 13.2,
					"mstbez": "Schönholthausen I"
				},
				{
					"mstnr": "129660188",
					"date": "2015-08-17",
					"value": 27.86,
					"mstbez": "Heggen"
				},
				{
					"mstnr": "129660024",
					"date": "2015-11-25",
					"value": 17.01,
					"mstbez": "Müllen"
				},
				{
					"mstnr": "129660024",
					"date": "2015-08-03",
					"value": 16.61,
					"mstbez": "Müllen"
				}
			],
			"plz": "57413"
		},
		"Lippetal": {
			"stations": [
				{
					"mstnr": "91141102",
					"date": "2015-09-03",
					"value": 84.14,
					"mstbez": "Niederbauer ML1"
				},
				{
					"mstnr": "91140900",
					"date": "2015-09-03",
					"value": 1.33,
					"mstbez": "Lippb Frölich ML102"
				}
			],
			"plz": "59510"
		},
		"Leopoldshöhe": {
			"stations": [
				{
					"mstnr": "106505312",
					"date": "2015-10-29",
					"value": 19.01,
					"mstbez": "ASEM1 BR ASEMISSEN"
				},
				{
					"mstnr": "106505312",
					"date": "2015-04-15",
					"value": 23.01,
					"mstbez": "ASEM1 BR ASEMISSEN"
				}
			],
			"plz": "33818"
		},
		"Saerbeck": {
			"stations": [
				{
					"mstnr": "110040156",
					"date": "2015-09-01",
					"value": 39.02,
					"mstbez": "IV/15 -MIDDENDORF-"
				},
				{
					"mstnr": "110040223",
					"date": "2015-09-02",
					"value": 1.33,
					"mstbez": "IV/22 SAERBECK"
				},
				{
					"mstnr": "110260340",
					"date": "2015-08-26",
					"value": 1.33,
					"mstbez": "EMS/34 SAERBECK 4"
				}
			],
			"plz": "48369"
		},
		"Selfkant": {
			"stations": [
				{
					"mstnr": "219603017",
					"date": "2015-06-02",
					"value": 10.23,
					"mstbez": "Tueddern"
				},
				{
					"mstnr": "219602918",
					"date": "2015-06-10",
					"value": 0.89,
					"mstbez": "Isenbruch"
				},
				{
					"mstnr": "219602815",
					"date": "2015-06-08",
					"value": 182.89,
					"mstbez": "Schalbruch"
				},
				{
					"mstnr": "219602712",
					"date": "2015-06-08",
					"value": 165.18,
					"mstbez": "Havert"
				}
			],
			"plz": "52538"
		},
		"Nettersheim": {
			"stations": [
				{
					"mstnr": "10407212",
					"date": "2015-06-18",
					"value": 13,
					"mstbez": "MARMAGEN QUELLE"
				},
				{
					"mstnr": "10407212",
					"date": "2015-12-14",
					"value": 12.3,
					"mstbez": "MARMAGEN QUELLE"
				},
				{
					"mstnr": "10409270",
					"date": "2015-03-05",
					"value": 15.19,
					"mstbez": "Sülchesbachquelle"
				},
				{
					"mstnr": "10409270",
					"date": "2015-12-09",
					"value": 14.84,
					"mstbez": "Sülchesbachquelle"
				},
				{
					"mstnr": "10409270",
					"date": "2015-08-31",
					"value": 15.64,
					"mstbez": "Sülchesbachquelle"
				},
				{
					"mstnr": "10409270",
					"date": "2015-04-27",
					"value": 14.62,
					"mstbez": "Sülchesbachquelle"
				},
				{
					"mstnr": "10409488",
					"date": "2015-03-05",
					"value": 30.6,
					"mstbez": "Erftquelle"
				},
				{
					"mstnr": "10409154",
					"date": "2015-03-05",
					"value": 20.28,
					"mstbez": "WESPELQUELLE"
				},
				{
					"mstnr": "10409154",
					"date": "2015-11-16",
					"value": 20.15,
					"mstbez": "WESPELQUELLE"
				},
				{
					"mstnr": "10410053",
					"date": "2015-03-05",
					"value": 20.19,
					"mstbez": "Brumbachquelle"
				},
				{
					"mstnr": "10409154",
					"date": "2015-03-24",
					"value": 19.36,
					"mstbez": "WESPELQUELLE"
				},
				{
					"mstnr": "10409646",
					"date": "2015-04-16",
					"value": 18.25,
					"mstbez": "Römerquelle"
				}
			],
			"plz": "53947"
		},
		"Mülheim a.d. Ruhr": {
			"stations": [
				{
					"mstnr": "40607010",
					"date": "2015-11-12",
					"value": 1.33,
					"mstbez": "Mühlenbergheide"
				},
				{
					"mstnr": "40507014",
					"date": "2015-11-13",
					"value": 9.21,
					"mstbez": "Kölner Str."
				}
			],
			"plz": "45468"
		},
		"Schleiden": {
			"stations": [
				{
					"mstnr": "10410211",
					"date": "2015-11-17",
					"value": 10.81,
					"mstbez": "Kradenbachquelle"
				},
				{
					"mstnr": "10410077",
					"date": "2015-10-28",
					"value": 0.13,
					"mstbez": "Heilsteinquelle"
				},
				{
					"mstnr": "10407194",
					"date": "2015-10-13",
					"value": 7.09,
					"mstbez": "SEEBRICHT QUELLE"
				}
			],
			"plz": "53937"
		},
		"Extertal": {
			"stations": [
				{
					"mstnr": "106502463",
					"date": "2015-05-21",
					"value": 4,
					"mstbez": "ROTT  BR ROTT EXTER"
				},
				{
					"mstnr": "106502463",
					"date": "2015-02-25",
					"value": 19.01,
					"mstbez": "ROTT  BR ROTT EXTER"
				},
				{
					"mstnr": "106502463",
					"date": "2015-09-28",
					"value": 19.01,
					"mstbez": "ROTT  BR ROTT EXTER"
				},
				{
					"mstnr": "106502402",
					"date": "2015-05-21",
					"value": 20.01,
					"mstbez": "GÖSTR BR GÖSTRUP EX"
				},
				{
					"mstnr": "106502517",
					"date": "2015-05-21",
					"value": 1,
					"mstbez": "ASM 4 BR ASMISS EXT"
				},
				{
					"mstnr": "106502517",
					"date": "2015-09-28",
					"value": 1,
					"mstbez": "ASM 4 BR ASMISS EXT"
				},
				{
					"mstnr": "106502402",
					"date": "2015-09-28",
					"value": 19.01,
					"mstbez": "GÖSTR BR GÖSTRUP EX"
				},
				{
					"mstnr": "106502475",
					"date": "2015-02-25",
					"value": 28.01,
					"mstbez": "ALMEN BR ALMENA"
				},
				{
					"mstnr": "106502475",
					"date": "2015-05-21",
					"value": 28.01,
					"mstbez": "ALMEN BR ALMENA"
				},
				{
					"mstnr": "106502475",
					"date": "2015-09-28",
					"value": 29.01,
					"mstbez": "ALMEN BR ALMENA"
				}
			],
			"plz": "32699"
		},
		"Gelsenkirchen": {
			"stations": [
				{
					"mstnr": "60080139",
					"date": "2015-04-22",
					"value": 1.33,
					"mstbez": "HS 125"
				},
				{
					"mstnr": "60080280",
					"date": "2015-10-28",
					"value": 1.71,
					"mstbez": "RWI 101"
				}
			],
			"plz": "45879"
		},
		"Dorsten": {
			"stations": [
				{
					"mstnr": "60070602",
					"date": "2015-11-20",
					"value": 34.06,
					"mstbez": "HS 116 A"
				},
				{
					"mstnr": "60070109",
					"date": "2015-12-17",
					"value": 111.16,
					"mstbez": "HS 18"
				},
				{
					"mstnr": "60071606",
					"date": "2015-12-07",
					"value": 18.95,
					"mstbez": "HS 9"
				}
			],
			"plz": "46284"
		},
		"Erkelenz": {
			"stations": [
				{
					"mstnr": "10201531",
					"date": "2015-03-16",
					"value": 15.19,
					"mstbez": "LENTHOLT"
				},
				{
					"mstnr": "10201415",
					"date": "2015-10-06",
					"value": 77.06,
					"mstbez": "Matzerath Br. 201"
				},
				{
					"mstnr": "10201415",
					"date": "2015-04-07",
					"value": 79.71,
					"mstbez": "Matzerath Br. 201"
				},
				{
					"mstnr": "10201282",
					"date": "2015-05-13",
					"value": 47.39,
					"mstbez": "OERATH"
				},
				{
					"mstnr": "219078117",
					"date": "2015-07-10",
					"value": 39.54,
					"mstbez": "Erkelenz 2"
				},
				{
					"mstnr": "218086015",
					"date": "2015-04-08",
					"value": 2.5,
					"mstbez": "Golkrath"
				},
				{
					"mstnr": "218086015",
					"date": "2015-10-19",
					"value": 0.7,
					"mstbez": "Golkrath"
				}
			],
			"plz": "41812"
		},
		"Bad Sassendorf": {
			"stations": [
				{
					"mstnr": "94150023",
					"date": "2015-09-04",
					"value": 42.82,
					"mstbez": "Ahse-Quelle"
				}
			],
			"plz": "59505"
		},
		"Verl": {
			"stations": [
				{
					"mstnr": "26540526",
					"date": "2015-08-06",
					"value": 69.97,
					"mstbez": "I/8C-6,0m ML    LGD"
				},
				{
					"mstnr": "26540514",
					"date": "2015-08-06",
					"value": 113.81,
					"mstbez": "I/8C-4,0m ML    LGD"
				},
				{
					"mstnr": "26540502",
					"date": "2015-08-06",
					"value": 19,
					"mstbez": "I/8C-1,8m ML    LGD"
				},
				{
					"mstnr": "20101120",
					"date": "2015-08-06",
					"value": 271.03,
					"mstbez": "I/8C ML Oesterwiehe"
				},
				{
					"mstnr": "26492064",
					"date": "2015-10-28",
					"value": 2.7,
					"mstbez": "MUEHB006"
				},
				{
					"mstnr": "21000300",
					"date": "2015-09-23",
					"value": 34.68,
					"mstbez": "626             LGD"
				},
				{
					"mstnr": "26492064",
					"date": "2015-03-24",
					"value": 1.2,
					"mstbez": "MUEHB006"
				}
			],
			"plz": "33415"
		},
		"Werne": {
			"stations": [
				{
					"mstnr": "94110013",
					"date": "2015-09-22",
					"value": 1.33,
					"mstbez": "Schulze-Froning"
				}
			],
			"plz": "59368"
		},
		"Lengerich": {
			"stations": [
				{
					"mstnr": "118054831",
					"date": "2015-09-30",
					"value": 7.7,
					"mstbez": "W.BROCHTERBECK-HO03"
				},
				{
					"mstnr": "118054831",
					"date": "2015-04-21",
					"value": 9.11,
					"mstbez": "W.BROCHTERBECK-HO03"
				},
				{
					"mstnr": "110200470",
					"date": "2015-05-05",
					"value": 1.33,
					"mstbez": "TE/47 SCHOLLBRUCH"
				},
				{
					"mstnr": "110200408",
					"date": "2015-10-29",
					"value": 202.83,
					"mstbez": "TE/40 Wechte"
				},
				{
					"mstnr": "110200391",
					"date": "2015-03-20",
					"value": 18.16,
					"mstbez": "TE/39 LEEDEN GUTST"
				},
				{
					"mstnr": "110200020",
					"date": "2015-10-28",
					"value": 1.33,
					"mstbez": "TE/2 -HOHNE-"
				}
			],
			"plz": "49525"
		},
		"Vreden": {
			"stations": [
				{
					"mstnr": "60240416",
					"date": "2015-06-15",
					"value": 1.33,
					"mstbez": "AH/41-AMMELOE-"
				},
				{
					"mstnr": "60240404",
					"date": "2015-06-15",
					"value": 1.33,
					"mstbez": "AH/40-WENNEWICK-"
				},
				{
					"mstnr": "60240246",
					"date": "2015-06-18",
					"value": 1.33,
					"mstbez": "AH/24 -VREDEN-"
				},
				{
					"mstnr": "60240428",
					"date": "2015-06-23",
					"value": 34.59,
					"mstbez": "AH/42-ZWILLBROCK-"
				}
			],
			"plz": "48691"
		},
		"Heinsberg (Rhld.)": {
			"stations": [
				{
					"mstnr": "10424167",
					"date": "2015-03-18",
					"value": 0.89,
					"mstbez": "Kirchhoven Br11Rohw"
				},
				{
					"mstnr": "16000614",
					"date": "2015-05-07",
					"value": 12,
					"mstbez": "IPO P 2 Nord"
				},
				{
					"mstnr": "16000651",
					"date": "2015-05-07",
					"value": 8.64,
					"mstbez": "IPO P 2 Ost"
				},
				{
					"mstnr": "16000997",
					"date": "2015-04-20",
					"value": 100.09,
					"mstbez": "IPO P5 Süd neu"
				},
				{
					"mstnr": "10403048",
					"date": "2015-10-15",
					"value": 5.85,
					"mstbez": "Kirchhoven  PB 13"
				},
				{
					"mstnr": "10424120",
					"date": "2015-03-18",
					"value": 0.89,
					"mstbez": "Kirchhoven B10Rohw"
				},
				{
					"mstnr": "219671114",
					"date": "2015-03-23",
					"value": 85.02,
					"mstbez": "Selsten"
				},
				{
					"mstnr": "219671114",
					"date": "2015-11-25",
					"value": 81.93,
					"mstbez": "Selsten"
				},
				{
					"mstnr": "10403978",
					"date": "2015-03-18",
					"value": 27.46,
					"mstbez": "Kirchhoven Br7 Rohw"
				},
				{
					"mstnr": "10403978",
					"date": "2015-11-17",
					"value": 30.91,
					"mstbez": "Kirchhoven Br7 Rohw"
				},
				{
					"mstnr": "10424210",
					"date": "2015-03-18",
					"value": 0.89,
					"mstbez": "Kirchhoven Br5 Rohw"
				}
			],
			"plz": "52525"
		},
		"Niederzier": {
			"stations": [
				{
					"mstnr": "10407121",
					"date": "2015-10-05",
					"value": 75.03,
					"mstbez": "FZJ Flachbrunnen 2"
				},
				{
					"mstnr": "210404711",
					"date": "2015-08-03",
					"value": 81.93,
					"mstbez": "Hambach Fl. Br.I"
				},
				{
					"mstnr": "10204003",
					"date": "2015-05-11",
					"value": 11,
					"mstbez": "Niederzier"
				},
				{
					"mstnr": "10407121",
					"date": "2015-05-11",
					"value": 70.02,
					"mstbez": "FZJ Flachbrunnen 2"
				},
				{
					"mstnr": "10201117",
					"date": "2015-05-11",
					"value": 66.02,
					"mstbez": "Niederzier Nr. 14"
				},
				{
					"mstnr": "10201117",
					"date": "2015-03-19",
					"value": 65.54,
					"mstbez": "Niederzier Nr. 14"
				},
				{
					"mstnr": "210404711",
					"date": "2015-04-28",
					"value": 80.16,
					"mstbez": "Hambach Fl. Br.I"
				},
				{
					"mstnr": "210404711",
					"date": "2015-11-23",
					"value": 83.25,
					"mstbez": "Hambach Fl. Br.I"
				},
				{
					"mstnr": "10202663",
					"date": "2015-05-11",
					"value": 61.02,
					"mstbez": "FZJ Nr. 64"
				},
				{
					"mstnr": "10202341",
					"date": "2015-05-11",
					"value": 38.01,
					"mstbez": "FZJ Nr. 40"
				},
				{
					"mstnr": "10408411",
					"date": "2015-04-21",
					"value": 60.32,
					"mstbez": "ELLEN BR. 2"
				},
				{
					"mstnr": "10408411",
					"date": "2015-10-28",
					"value": 58.9,
					"mstbez": "ELLEN BR. 2"
				},
				{
					"mstnr": "10202330",
					"date": "2015-10-05",
					"value": 1,
					"mstbez": "FZJ Nr. 39"
				},
				{
					"mstnr": "10408411",
					"date": "2015-04-21",
					"value": 59.34,
					"mstbez": "ELLEN BR. 2"
				},
				{
					"mstnr": "10202675",
					"date": "2015-05-11",
					"value": 35.01,
					"mstbez": "FZJ Nr. 65"
				}
			],
			"plz": "52382"
		},
		"Dülmen": {
			"stations": [
				{
					"mstnr": "110220109",
					"date": "2015-11-05",
					"value": 89.46,
					"mstbez": "HS/10 MERFELD"
				},
				{
					"mstnr": "110210219",
					"date": "2015-09-30",
					"value": 1.33,
					"mstbez": "ST.GEB.21 EMPTE"
				},
				{
					"mstnr": "110210207",
					"date": "2015-11-16",
					"value": 21.39,
					"mstbez": "ST.GEB/20 Börnste"
				},
				{
					"mstnr": "110220092",
					"date": "2015-11-05",
					"value": 1.33,
					"mstbez": "HS/9-MERFELD-"
				},
				{
					"mstnr": "110220882",
					"date": "2015-11-06",
					"value": 1.33,
					"mstbez": "HS/88 HAUSDUELMEN"
				}
			],
			"plz": "48249"
		},
		"Marsberg": {
			"stations": [
				{
					"mstnr": "94180027",
					"date": "2015-04-14",
					"value": 24.53,
					"mstbez": "Quelle Am Hagen"
				},
				{
					"mstnr": "94180106",
					"date": "2015-04-14",
					"value": 15.9,
					"mstbez": "Quelle Giershagen"
				},
				{
					"mstnr": "94180120",
					"date": "2015-04-14",
					"value": 25.82,
					"mstbez": "Que Helminghausen"
				},
				{
					"mstnr": "94190173",
					"date": "2015-04-14",
					"value": 46.94,
					"mstbez": "TB Gut Forst 1"
				},
				{
					"mstnr": "94190094",
					"date": "2015-09-30",
					"value": 47.83,
					"mstbez": "Paulinenquelle"
				}
			],
			"plz": "34431"
		},
		"Medebach": {
			"stations": [
				{
					"mstnr": "94170253",
					"date": "2015-04-28",
					"value": 7.79,
					"mstbez": "Que Kuckucksloch"
				}
			],
			"plz": "59964"
		},
		"Gangelt": {
			"stations": [
				{
					"mstnr": "10203588",
					"date": "2015-06-10",
					"value": 8.19,
					"mstbez": "Gangelt-Niederbusch"
				},
				{
					"mstnr": "10403590",
					"date": "2015-11-24",
					"value": 31.13,
					"mstbez": "WW Gangelt Br. V"
				},
				{
					"mstnr": "10403590",
					"date": "2015-07-28",
					"value": 33.21,
					"mstbez": "WW Gangelt Br. V"
				},
				{
					"mstnr": "10403528",
					"date": "2015-03-09",
					"value": 20.19,
					"mstbez": "TEVEREN NATO P1A"
				},
				{
					"mstnr": "10403590",
					"date": "2015-04-21",
					"value": 31.44,
					"mstbez": "WW Gangelt Br. V"
				}
			],
			"plz": "52538"
		},
		"Senden": {
			"stations": [
				{
					"mstnr": "110210074",
					"date": "2015-09-17",
					"value": 1.33,
					"mstbez": "ST.GEB/7 VENNE"
				},
				{
					"mstnr": "110210086",
					"date": "2015-09-29",
					"value": 1.33,
					"mstbez": "St.G/8 SENDEN"
				}
			],
			"plz": "48308"
		},
		"Emsdetten": {
			"stations": [
				{
					"mstnr": "110050125",
					"date": "2015-11-04",
					"value": 69.09,
					"mstbez": "V/12 -ISENDORF-"
				},
				{
					"mstnr": "110260314",
					"date": "2015-08-27",
					"value": 1.33,
					"mstbez": "EMS/31 Hembergen 1"
				},
				{
					"mstnr": "110040107",
					"date": "2015-12-02",
					"value": 9.08,
					"mstbez": "IV/10 EMSDETTEN"
				}
			],
			"plz": "48282"
		},
		"Erftstadt": {
			"stations": [
				{
					"mstnr": "279470617",
					"date": "2015-06-23",
					"value": 113.37,
					"mstbez": "Br.Hoverhf"
				}
			],
			"plz": "50374"
		},
		"Gladbeck": {
			"stations": [
				{
					"mstnr": "60070298",
					"date": "2015-08-28",
					"value": 1.33,
					"mstbez": "RWI 22"
				}
			],
			"plz": "45964"
		},
		"Delbrück": {
			"stations": [
				{
					"mstnr": "21150023",
					"date": "2015-08-04",
					"value": 1.86,
					"mstbez": "OL 102 ML Ostenland"
				},
				{
					"mstnr": "21150035",
					"date": "2015-08-04",
					"value": 1.33,
					"mstbez": "103 ML  OL Leste"
				},
				{
					"mstnr": "23161437",
					"date": "2015-10-20",
					"value": 131.05,
					"mstbez": "43      Boker Heide"
				},
				{
					"mstnr": "26531082",
					"date": "2015-08-04",
					"value": 1.33,
					"mstbez": "OL102-12,0mMLOstenl"
				},
				{
					"mstnr": "26531070",
					"date": "2015-08-04",
					"value": 2.21,
					"mstbez": "OL102- 8,0mMLOstenl"
				},
				{
					"mstnr": "26531094",
					"date": "2015-08-04",
					"value": 130.2,
					"mstbez": "103- 2,0m ML OL"
				},
				{
					"mstnr": "26531069",
					"date": "2015-08-04",
					"value": 1.33,
					"mstbez": "OL102- 5,0mMLOstenl"
				},
				{
					"mstnr": "26531057",
					"date": "2015-08-04",
					"value": 2.04,
					"mstbez": "OL102-2,5m MLOstenl"
				},
				{
					"mstnr": "23160925",
					"date": "2015-04-23",
					"value": 12,
					"mstbez": "HFB 2 Boker Heide"
				},
				{
					"mstnr": "23160925",
					"date": "2015-10-20",
					"value": 12,
					"mstbez": "HFB 2 Boker Heide"
				},
				{
					"mstnr": "23160949",
					"date": "2015-05-20",
					"value": 26.01,
					"mstbez": "HFB 4 Boker Heide"
				},
				{
					"mstnr": "23160949",
					"date": "2015-10-29",
					"value": 24.01,
					"mstbez": "HFB 4 Boker Heide"
				},
				{
					"mstnr": "23161437",
					"date": "2015-04-23",
					"value": 101.04,
					"mstbez": "43      Boker Heide"
				},
				{
					"mstnr": "21172810",
					"date": "2015-10-08",
					"value": 5.8,
					"mstbez": "OL 270N"
				},
				{
					"mstnr": "26531100",
					"date": "2015-08-04",
					"value": 182.9,
					"mstbez": "103_ 4,0m Ml OL"
				},
				{
					"mstnr": "21161501",
					"date": "2015-11-03",
					"value": 16.47,
					"mstbez": "OL 31 Westenholz"
				},
				{
					"mstnr": "26531124",
					"date": "2015-08-04",
					"value": 14.61,
					"mstbez": "103- 9,0m ML OL"
				},
				{
					"mstnr": "26531112",
					"date": "2015-08-04",
					"value": 135.07,
					"mstbez": "103- 6,0m ML OL"
				}
			],
			"plz": "33129"
		},
		"Metelen": {
			"stations": [
				{
					"mstnr": "110050095",
					"date": "2015-04-13",
					"value": 1.33,
					"mstbez": "V/9 BHF METELEN"
				},
				{
					"mstnr": "110340036",
					"date": "2015-06-25",
					"value": 1.33,
					"mstbez": "ST/3-V.PARK METELEN"
				}
			],
			"plz": "48629"
		},
		"Solingen": {
			"stations": [
				{
					"mstnr": "30302055",
					"date": "2015-09-17",
					"value": 20.86,
					"mstbez": "Soli-Ketzberger Str"
				}
			],
			"plz": "42651"
		},
		"Lotte": {
			"stations": [
				{
					"mstnr": "110200378",
					"date": "2015-03-19",
					"value": 1.33,
					"mstbez": "TE/37 WERSEN"
				}
			],
			"plz": "49504"
		},
		"Haltern": {
			"stations": [
				{
					"mstnr": "60092233",
					"date": "2015-12-01",
					"value": 20.33,
					"mstbez": "HS/70 -STRUENKEDE-"
				}
			],
			"plz": "45721"
		},
		"Wegberg": {
			"stations": [
				{
					"mstnr": "10201312",
					"date": "2015-03-16",
					"value": 67.31,
					"mstbez": "Arsbeck Bussardweg"
				},
				{
					"mstnr": "10200710",
					"date": "2015-05-13",
					"value": 1.33,
					"mstbez": "DALHEIM 6 EICHEN 4"
				},
				{
					"mstnr": "218129415",
					"date": "2015-10-15",
					"value": 16.71,
					"mstbez": "Wildenrath"
				},
				{
					"mstnr": "10205561",
					"date": "2015-03-16",
					"value": 0.4,
					"mstbez": "ARSBECK PE 7  4\""
				},
				{
					"mstnr": "10407649",
					"date": "2015-04-07",
					"value": 81.48,
					"mstbez": "UEVEKOVEN BR. 101"
				},
				{
					"mstnr": "10407649",
					"date": "2015-10-06",
					"value": 81.48,
					"mstbez": "UEVEKOVEN BR. 101"
				}
			],
			"plz": "41844"
		},
		"Mönchengladbach": {
			"stations": [
				{
					"mstnr": "86541377",
					"date": "2015-10-15",
					"value": 34.01,
					"mstbez": "E Hoppbruch Br.15"
				},
				{
					"mstnr": "289077217",
					"date": "2015-07-30",
					"value": 44.29,
					"mstbez": "Wanlo"
				},
				{
					"mstnr": "289086516",
					"date": "2015-03-24",
					"value": 110.27,
					"mstbez": "Hehn"
				},
				{
					"mstnr": "289086516",
					"date": "2015-11-16",
					"value": 112.92,
					"mstbez": "Hehn"
				},
				{
					"mstnr": "288067411",
					"date": "2015-01-26",
					"value": 0.89,
					"mstbez": "Rheindahlen"
				},
				{
					"mstnr": "289086516",
					"date": "2015-02-26",
					"value": 112.48,
					"mstbez": "Hehn"
				},
				{
					"mstnr": "86541377",
					"date": "2015-03-26",
					"value": 34.31,
					"mstbez": "E Hoppbruch Br.15"
				},
				{
					"mstnr": "86573470",
					"date": "2015-02-10",
					"value": 55.52,
					"mstbez": "E Rheindahlen Br.3"
				},
				{
					"mstnr": "86573470",
					"date": "2015-10-20",
					"value": 55.72,
					"mstbez": "E Rheindahlen Br.3"
				},
				{
					"mstnr": "86573974",
					"date": "2015-10-20",
					"value": 67.82,
					"mstbez": "E GATZWEILER Hor.1"
				},
				{
					"mstnr": "86573974",
					"date": "2015-02-11",
					"value": 67.92,
					"mstbez": "E GATZWEILER Hor.1"
				},
				{
					"mstnr": "86573986",
					"date": "2015-10-21",
					"value": 61.92,
					"mstbez": "E GATZWEILER Hor.2"
				},
				{
					"mstnr": "86573986",
					"date": "2015-02-11",
					"value": 60.52,
					"mstbez": "E GATZWEILER Hor.2"
				},
				{
					"mstnr": "80300789",
					"date": "2015-08-31",
					"value": 32.77,
					"mstbez": "HOLTMÜHLE 223"
				},
				{
					"mstnr": "80201623",
					"date": "2015-08-31",
					"value": 54.47,
					"mstbez": "LELOH WALD 218"
				},
				{
					"mstnr": "80301289",
					"date": "2015-09-24",
					"value": 17.49,
					"mstbez": "EICKEN          276"
				}
			],
			"plz": "41061"
		},
		"Eitorf": {
			"stations": [
				{
					"mstnr": "73727180",
					"date": "2015-03-24",
					"value": 35.03,
					"mstbez": "BOHLSCHEID EITORF"
				},
				{
					"mstnr": "73727088",
					"date": "2015-03-23",
					"value": 12.09,
					"mstbez": "DICKERSBACH QF"
				}
			],
			"plz": "53783"
		},
		"Goch": {
			"stations": [
				{
					"mstnr": "80301721",
					"date": "2015-09-03",
					"value": 103.63,
					"mstbez": "FLUGPLATZ       320"
				},
				{
					"mstnr": "86621555",
					"date": "2015-03-03",
					"value": 50.32,
					"mstbez": "E SW Kleve Br.9"
				},
				{
					"mstnr": "86621567",
					"date": "2015-09-28",
					"value": 59.62,
					"mstbez": "E SW Kleve Br.5"
				},
				{
					"mstnr": "80300911",
					"date": "2015-09-08",
					"value": 71.74,
					"mstbez": "HASSUM          239"
				},
				{
					"mstnr": "86621555",
					"date": "2015-09-28",
					"value": 52.52,
					"mstbez": "E SW Kleve Br.9"
				},
				{
					"mstnr": "86621567",
					"date": "2015-06-08",
					"value": 58.42,
					"mstbez": "E SW Kleve Br.5"
				},
				{
					"mstnr": "80301551",
					"date": "2015-03-16",
					"value": 25.55,
					"mstbez": "GRUNEWALD       303"
				},
				{
					"mstnr": "86621567",
					"date": "2015-02-23",
					"value": 57.72,
					"mstbez": "E SW Kleve Br.5"
				},
				{
					"mstnr": "86621555",
					"date": "2015-06-08",
					"value": 48.32,
					"mstbez": "E SW Kleve Br.9"
				},
				{
					"mstnr": "80303183",
					"date": "2015-09-08",
					"value": 107.61,
					"mstbez": "ERVSCHERWEG     381"
				},
				{
					"mstnr": "80100818",
					"date": "2015-07-10",
					"value": 51.37,
					"mstbez": "GOCH SCHULE     034"
				},
				{
					"mstnr": "80100806",
					"date": "2015-09-09",
					"value": 88.57,
					"mstbez": "PFALZDORF       033"
				}
			],
			"plz": "47574"
		},
		"Blankenheim": {
			"stations": [
				{
					"mstnr": "10410030",
					"date": "2015-09-17",
					"value": 8.68,
					"mstbez": "Zehnbachquelle"
				},
				{
					"mstnr": "10409610",
					"date": "2015-12-10",
					"value": 15.19,
					"mstbez": "Leukersbergquelle"
				},
				{
					"mstnr": "10409609",
					"date": "2015-11-17",
					"value": 4.07,
					"mstbez": "Schalkseifenquelle"
				},
				{
					"mstnr": "10409580",
					"date": "2015-11-17",
					"value": 11.2,
					"mstbez": "Wolfhäuschenquelle"
				},
				{
					"mstnr": "10410089",
					"date": "2015-11-17",
					"value": 5.23,
					"mstbez": "Singelsbendenquelle"
				},
				{
					"mstnr": "10409014",
					"date": "2015-06-18",
					"value": 18.87,
					"mstbez": "Ahrquelle"
				},
				{
					"mstnr": "10409919",
					"date": "2015-03-09",
					"value": 54.47,
					"mstbez": "Behnenbachquelle"
				},
				{
					"mstnr": "10407467",
					"date": "2015-09-17",
					"value": 22.81,
					"mstbez": "Alendorf-Quelle"
				},
				{
					"mstnr": "10410193",
					"date": "2015-03-09",
					"value": 15.1,
					"mstbez": "Vellerhofquelle"
				},
				{
					"mstnr": "10403814",
					"date": "2015-09-17",
					"value": 7.97,
					"mstbez": "Brunnen Seidenbach"
				},
				{
					"mstnr": "10409403",
					"date": "2015-09-17",
					"value": 5.49,
					"mstbez": "Klausbachquelle"
				}
			],
			"plz": "53945"
		},
		"Rheda-Wiedenbrück": {
			"stations": [
				{
					"mstnr": "20002129",
					"date": "2015-07-22",
					"value": 60.23,
					"mstbez": "II/12           NRE"
				},
				{
					"mstnr": "20781878",
					"date": "2015-03-23",
					"value": 5.3,
					"mstbez": "WIEDG023F"
				},
				{
					"mstnr": "20781532",
					"date": "2015-03-25",
					"value": 1.8,
					"mstbez": "WIEDB014"
				},
				{
					"mstnr": "26491448",
					"date": "2015-03-11",
					"value": 1,
					"mstbez": "BR 2 Sudheide"
				},
				{
					"mstnr": "20781532",
					"date": "2015-10-27",
					"value": 2,
					"mstbez": "WIEDB014"
				}
			],
			"plz": "33378"
		},
		"Kreuztal": {
			"stations": [
				{
					"mstnr": "129700216",
					"date": "2015-10-12",
					"value": 1.33,
					"mstbez": "Rütting II"
				},
				{
					"mstnr": "129700198",
					"date": "2015-07-08",
					"value": 6.91,
					"mstbez": "Bruchstollen"
				}
			],
			"plz": "57223"
		},
		"Olsberg": {
			"stations": [
				{
					"mstnr": "99580111",
					"date": "2015-06-11",
					"value": 9.79,
					"mstbez": "Quelle Im Kämpen"
				},
				{
					"mstnr": "99580202",
					"date": "2015-06-11",
					"value": 3.9,
					"mstbez": "TB Olsberger Hütte"
				},
				{
					"mstnr": "99580202",
					"date": "2015-09-30",
					"value": 3.32,
					"mstbez": "TB Olsberger Hütte"
				}
			],
			"plz": "59939"
		},
		"Ratingen": {
			"stations": [
				{
					"mstnr": "36462780",
					"date": "2015-10-15",
					"value": 0.8,
					"mstbez": "SW Rati Homberg H32"
				},
				{
					"mstnr": "30302742",
					"date": "2015-09-16",
					"value": 1.33,
					"mstbez": "Rati-Lintorf-Süd"
				},
				{
					"mstnr": "36462615",
					"date": "2015-03-10",
					"value": 1,
					"mstbez": "Broichhofstr.-Br. 2"
				},
				{
					"mstnr": "36462615",
					"date": "2015-09-09",
					"value": 1,
					"mstbez": "Broichhofstr.-Br. 2"
				}
			],
			"plz": "40878"
		},
		"Uedem": {
			"stations": [
				{
					"mstnr": "80300960",
					"date": "2015-09-01",
					"value": 89.46,
					"mstbez": "HOLLEN       HY 244"
				},
				{
					"mstnr": "80302555",
					"date": "2015-08-24",
					"value": 158.99,
					"mstbez": "UEDEM    GRILLPLATZ"
				},
				{
					"mstnr": "80000113",
					"date": "2015-09-01",
					"value": 16.87,
					"mstbez": "UEDEMERFELD   Nr 05"
				},
				{
					"mstnr": "80302543",
					"date": "2015-08-24",
					"value": 93.44,
					"mstbez": "UEDEM       KEPPELN"
				},
				{
					"mstnr": "80300947",
					"date": "2015-08-24",
					"value": 31.31,
					"mstbez": "UEDEM        HY 242"
				}
			],
			"plz": "47589"
		},
		"Rosendahl": {
			"stations": [
				{
					"mstnr": "110240194",
					"date": "2015-06-08",
					"value": 1.33,
					"mstbez": "AH/19 -HEGERORT-"
				},
				{
					"mstnr": "110240169",
					"date": "2015-11-17",
					"value": 1.33,
					"mstbez": "AH/16 Osterwick"
				}
			],
			"plz": "48720"
		},
		"Nieheim": {
			"stations": [
				{
					"mstnr": "26504327",
					"date": "2015-07-13",
					"value": 38.01,
					"mstbez": "BR Sommersell"
				},
				{
					"mstnr": "26504327",
					"date": "2015-08-04",
					"value": 38.01,
					"mstbez": "BR Sommersell"
				},
				{
					"mstnr": "26504327",
					"date": "2015-09-22",
					"value": 37.01,
					"mstbez": "BR Sommersell"
				},
				{
					"mstnr": "26504388",
					"date": "2015-05-11",
					"value": 19.01,
					"mstbez": "TB Entrup"
				},
				{
					"mstnr": "26504327",
					"date": "2015-10-26",
					"value": 36.01,
					"mstbez": "BR Sommersell"
				},
				{
					"mstnr": "26504327",
					"date": "2015-11-05",
					"value": 37.01,
					"mstbez": "BR Sommersell"
				},
				{
					"mstnr": "26504327",
					"date": "2015-12-02",
					"value": 37.01,
					"mstbez": "BR Sommersell"
				},
				{
					"mstnr": "26504388",
					"date": "2015-10-26",
					"value": 16.01,
					"mstbez": "TB Entrup"
				},
				{
					"mstnr": "26504352",
					"date": "2015-05-11",
					"value": 19.01,
					"mstbez": "T1 Holzhsn-Schule"
				},
				{
					"mstnr": "26504327",
					"date": "2015-05-11",
					"value": 39.01,
					"mstbez": "BR Sommersell"
				},
				{
					"mstnr": "26504339",
					"date": "2015-05-11",
					"value": 25.01,
					"mstbez": "QU Erwitzen"
				},
				{
					"mstnr": "26504327",
					"date": "2015-02-09",
					"value": 38.01,
					"mstbez": "BR Sommersell"
				},
				{
					"mstnr": "26504339",
					"date": "2015-10-26",
					"value": 25.01,
					"mstbez": "QU Erwitzen"
				},
				{
					"mstnr": "26504327",
					"date": "2015-03-03",
					"value": 34.01,
					"mstbez": "BR Sommersell"
				},
				{
					"mstnr": "26504352",
					"date": "2015-10-26",
					"value": 14,
					"mstbez": "T1 Holzhsn-Schule"
				},
				{
					"mstnr": "26504327",
					"date": "2015-04-07",
					"value": 37.01,
					"mstbez": "BR Sommersell"
				},
				{
					"mstnr": "26504327",
					"date": "2015-06-08",
					"value": 39.01,
					"mstbez": "BR Sommersell"
				},
				{
					"mstnr": "26504327",
					"date": "2015-01-08",
					"value": 37.01,
					"mstbez": "BR Sommersell"
				}
			],
			"plz": "33039"
		},
		"Dormagen": {
			"stations": [
				{
					"mstnr": "80301356",
					"date": "2015-03-17",
					"value": 20.11,
					"mstbez": "HORREM   BAHN   283"
				},
				{
					"mstnr": "80200801",
					"date": "2015-03-17",
					"value": 21.08,
					"mstbez": "NIEVENHEIM      167"
				},
				{
					"mstnr": "86454328",
					"date": "2015-10-27",
					"value": 5,
					"mstbez": "E Chorbusch Br.1"
				},
				{
					"mstnr": "86452010",
					"date": "2015-03-31",
					"value": 15.21,
					"mstbez": "E Br.7 20-107-03"
				},
				{
					"mstnr": "86452010",
					"date": "2015-10-07",
					"value": 17.81,
					"mstbez": "E Br.7 20-107-03"
				},
				{
					"mstnr": "80303614",
					"date": "2015-09-23",
					"value": 27.15,
					"mstbez": "DORMAGEN-ZONS PR-P1"
				},
				{
					"mstnr": "86454328",
					"date": "2015-02-24",
					"value": 5,
					"mstbez": "E Chorbusch Br.1"
				}
			],
			"plz": "41539"
		},
		"Wassenberg": {
			"stations": [
				{
					"mstnr": "10407522",
					"date": "2015-04-08",
					"value": 61.55,
					"mstbez": "Wassenberg Br. 503"
				},
				{
					"mstnr": "218676414",
					"date": "2015-10-15",
					"value": 0.5,
					"mstbez": "Effeld"
				},
				{
					"mstnr": "10202821",
					"date": "2015-03-26",
					"value": 80.6,
					"mstbez": "Orsbeck"
				},
				{
					"mstnr": "10306237",
					"date": "2015-05-11",
					"value": 38.66,
					"mstbez": "Ophoven, GwMst. 1"
				},
				{
					"mstnr": "10407522",
					"date": "2015-10-07",
					"value": 63.32,
					"mstbez": "Wassenberg Br. 503"
				},
				{
					"mstnr": "10306237",
					"date": "2015-10-26",
					"value": 38.53,
					"mstbez": "Ophoven, GwMst. 1"
				}
			],
			"plz": "41849"
		},
		"Gronau (Westf.)": {
			"stations": [
				{
					"mstnr": "60240040",
					"date": "2015-04-15",
					"value": 124.89,
					"mstbez": "AH/4 -Gronau-"
				},
				{
					"mstnr": "60240027",
					"date": "2015-04-15",
					"value": 1.33,
					"mstbez": "AH/2 - FUECHTE -"
				}
			],
			"plz": "48599"
		},
		"Bad Lippspringe": {
			"stations": [
				{
					"mstnr": "23163227",
					"date": "2015-03-09",
					"value": 3,
					"mstbez": "TB 45   Paderborn"
				},
				{
					"mstnr": "21184008",
					"date": "2015-12-03",
					"value": 46.06,
					"mstbez": "OL 121  Lippspringe"
				},
				{
					"mstnr": "24180920",
					"date": "2015-03-19",
					"value": 19.97,
					"mstbez": "Lippe-Quelle"
				},
				{
					"mstnr": "24180919",
					"date": "2015-03-19",
					"value": 23.69,
					"mstbez": "Jordanquelle"
				},
				{
					"mstnr": "23163227",
					"date": "2015-09-29",
					"value": 3,
					"mstbez": "TB 45   Paderborn"
				}
			],
			"plz": "33175"
		},
		"Waldbröl": {
			"stations": [
				{
					"mstnr": "73775484",
					"date": "2015-04-07",
					"value": 8.46,
					"mstbez": "WG ROELEFELD"
				}
			],
			"plz": "51545"
		},
		"Horstmar": {
			"stations": [
				{
					"mstnr": "110340024",
					"date": "2015-04-14",
					"value": 6.2,
					"mstbez": "ST/2-HALTERNER MARK"
				},
				{
					"mstnr": "110320062",
					"date": "2015-06-24",
					"value": 1.33,
					"mstbez": "LEER"
				}
			],
			"plz": "48612"
		},
		"Neuenkirchen": {
			"stations": [
				{
					"mstnr": "110070227",
					"date": "2015-06-26",
					"value": 6.47,
					"mstbez": "VII/22 SANKT-ARNOLD"
				},
				{
					"mstnr": "118610247",
					"date": "2015-10-21",
					"value": 24.01,
					"mstbez": "WW.OFFLUM-VF24"
				},
				{
					"mstnr": "110050113",
					"date": "2015-09-08",
					"value": 1.33,
					"mstbez": "V/11 -MESUM-"
				},
				{
					"mstnr": "110290021",
					"date": "2015-07-14",
					"value": 1.33,
					"mstbez": "RH/2 LANDERSUM"
				},
				{
					"mstnr": "113710185",
					"date": "2015-06-29",
					"value": 14.84,
					"mstbez": "ST OCHTRUP 019"
				},
				{
					"mstnr": "118610247",
					"date": "2015-04-16",
					"value": 30.01,
					"mstbez": "WW.OFFLUM-VF24"
				},
				{
					"mstnr": "110290045",
					"date": "2015-01-28",
					"value": 92.11,
					"mstbez": "RH/4 SUTRUM"
				},
				{
					"mstnr": "110280027",
					"date": "2015-06-17",
					"value": 86.8,
					"mstbez": "NK/2-NEUENKIRCHEN S"
				},
				{
					"mstnr": "110280015",
					"date": "2015-07-02",
					"value": 74.4,
					"mstbez": "NK/1 NEUENKIRCHEN_T"
				}
			],
			"plz": "48485"
		},
		"Korschenbroich": {
			"stations": [
				{
					"mstnr": "80201714",
					"date": "2015-09-23",
					"value": 13.6,
					"mstbez": "KORSCHENBR.SPORTPL."
				},
				{
					"mstnr": "80100946",
					"date": "2015-02-27",
					"value": 21.74,
					"mstbez": "FRAGENHÜTTE   Nr024"
				}
			],
			"plz": "41352"
		},
		"Welver": {
			"stations": [
				{
					"mstnr": "91133300",
					"date": "2015-10-14",
					"value": 1.33,
					"mstbez": "Vellinghausen ML72"
				},
				{
					"mstnr": "91133002",
					"date": "2015-12-03",
					"value": 1.33,
					"mstbez": "Klotingen ML75"
				}
			],
			"plz": "59514"
		},
		"Horn-Bad Meinberg": {
			"stations": [
				{
					"mstnr": "106502372",
					"date": "2015-10-13",
					"value": 1,
					"mstbez": "LEOP2 BR SILBERMUEH"
				},
				{
					"mstnr": "106502426",
					"date": "2015-05-05",
					"value": 33.01,
					"mstbez": "HUBE1 BR HUBERTUS"
				},
				{
					"mstnr": "106502335",
					"date": "2015-10-15",
					"value": 16.01,
					"mstbez": "VELDR QU VELDROM"
				},
				{
					"mstnr": "106502335",
					"date": "2015-04-20",
					"value": 17.01,
					"mstbez": "VELDR QU VELDROM"
				},
				{
					"mstnr": "106502426",
					"date": "2015-10-13",
					"value": 26.01,
					"mstbez": "HUBE1 BR HUBERTUS"
				},
				{
					"mstnr": "106502372",
					"date": "2015-05-05",
					"value": 1,
					"mstbez": "LEOP2 BR SILBERMUEH"
				}
			],
			"plz": "32805"
		},
		"Harsewinkel": {
			"stations": [
				{
					"mstnr": "20782925",
					"date": "2015-04-23",
					"value": 32.01,
					"mstbez": "GO 2    Golf Harsew"
				},
				{
					"mstnr": "20781052",
					"date": "2015-11-16",
					"value": 11,
					"mstbez": "BR 5 Harsewinkel"
				},
				{
					"mstnr": "20781052",
					"date": "2015-04-21",
					"value": 12,
					"mstbez": "BR 5 Harsewinkel"
				},
				{
					"mstnr": "20103062",
					"date": "2015-07-14",
					"value": 40.52,
					"mstbez": "III/6.2 Harsewinkel"
				},
				{
					"mstnr": "20782925",
					"date": "2015-07-14",
					"value": 28.92,
					"mstbez": "GO 2    Golf Harsew"
				},
				{
					"mstnr": "20103074",
					"date": "2015-07-14",
					"value": 29.76,
					"mstbez": "III/7           LGD"
				}
			],
			"plz": "33428"
		},
		"Attendorn": {
			"stations": [
				{
					"mstnr": "129660190",
					"date": "2015-07-20",
					"value": 18.73,
					"mstbez": "Ennest"
				},
				{
					"mstnr": "129660176",
					"date": "2015-08-05",
					"value": 19.97,
					"mstbez": "Silbecke"
				},
				{
					"mstnr": "129660050",
					"date": "2015-11-11",
					"value": 21.01,
					"mstbez": "Repetalquellen 1-5"
				},
				{
					"mstnr": "129660050",
					"date": "2015-05-08",
					"value": 21.01,
					"mstbez": "Repetalquellen 1-5"
				},
				{
					"mstnr": "129660050",
					"date": "2015-07-08",
					"value": 20.95,
					"mstbez": "Repetalquellen 1-5"
				},
				{
					"mstnr": "129660048",
					"date": "2015-04-27",
					"value": 7.62,
					"mstbez": "Vogelrute"
				},
				{
					"mstnr": "129660220",
					"date": "2015-08-17",
					"value": 12.84,
					"mstbez": "Niederhelden I"
				},
				{
					"mstnr": "129660279",
					"date": "2015-07-21",
					"value": 29.01,
					"mstbez": "Niederhelden II"
				}
			],
			"plz": "57439"
		},
		"Odenthal": {
			"stations": [
				{
					"mstnr": "76769306",
					"date": "2015-04-08",
					"value": 5.62,
					"mstbez": "MAYER ODENTHAL EB"
				}
			],
			"plz": "51519"
		},
		"Kalkar": {
			"stations": [
				{
					"mstnr": "80301710",
					"date": "2015-09-11",
					"value": 63.33,
					"mstbez": "APPELDORN       319"
				},
				{
					"mstnr": "86625123",
					"date": "2015-04-27",
					"value": 12.3,
					"mstbez": "OMOEB006"
				},
				{
					"mstnr": "80303420",
					"date": "2015-09-11",
					"value": 62,
					"mstbez": "OP DE WACHT     405"
				},
				{
					"mstnr": "86625123",
					"date": "2015-10-20",
					"value": 10.9,
					"mstbez": "OMOEB006"
				},
				{
					"mstnr": "86625081",
					"date": "2015-04-27",
					"value": 9.1,
					"mstbez": "MARIB002"
				},
				{
					"mstnr": "86625081",
					"date": "2015-10-20",
					"value": 10.3,
					"mstbez": "MARIB002"
				}
			],
			"plz": "47546"
		},
		"Recklinghausen": {
			"stations": [
				{
					"mstnr": "60090248",
					"date": "2015-11-06",
					"value": 8.33,
					"mstbez": "HS 128"
				},
				{
					"mstnr": "60082800",
					"date": "2015-10-28",
					"value": 77.5,
					"mstbez": "HS 35"
				}
			],
			"plz": "45657"
		},
		"Langenfeld (Rhld.)": {
			"stations": [
				{
					"mstnr": "36411607",
					"date": "2015-06-30",
					"value": 11.69,
					"mstbez": "VWW LANGENFELD P25"
				},
				{
					"mstnr": "36411450",
					"date": "2015-10-01",
					"value": 36.8,
					"mstbez": "VWW LANGENFELD P30"
				},
				{
					"mstnr": "30302584",
					"date": "2015-01-05",
					"value": 11.6,
					"mstbez": "Lang-Heinenbusch"
				}
			],
			"plz": "40764"
		},
		"Castrop-Rauxel": {
			"stations": [
				{
					"mstnr": "60102135",
					"date": "2015-11-25",
					"value": 2.93,
					"mstbez": "RWI 113"
				},
				{
					"mstnr": "60102123",
					"date": "2015-11-24",
					"value": 6.86,
					"mstbez": "RWI 112"
				},
				{
					"mstnr": "60090340",
					"date": "2015-11-03",
					"value": 9.83,
					"mstbez": "RWI 106"
				}
			],
			"plz": "44575"
		},
		"Ibbenbüren": {
			"stations": [
				{
					"mstnr": "110200330",
					"date": "2015-03-17",
					"value": 145.26,
					"mstbez": "TE/33 Schlickelde"
				},
				{
					"mstnr": "110200410",
					"date": "2015-12-01",
					"value": 78.39,
					"mstbez": "TE/41 Bockraden"
				},
				{
					"mstnr": "118021047",
					"date": "2015-04-21",
					"value": 3,
					"mstbez": "WW.IBBENBLEHEN-VK04"
				},
				{
					"mstnr": "118021047",
					"date": "2015-09-29",
					"value": 2.7,
					"mstbez": "WW.IBBENBLEHEN-VK04"
				},
				{
					"mstnr": "110200457",
					"date": "2015-12-08",
					"value": 32.28,
					"mstbez": "TE/45 Püsselbüren"
				},
				{
					"mstnr": "118021035",
					"date": "2015-04-21",
					"value": 3,
					"mstbez": "WW.IBBENBLEHEN-VK03"
				},
				{
					"mstnr": "110200469",
					"date": "2015-11-24",
					"value": 6.69,
					"mstbez": "TE/46 Laggenbeck"
				},
				{
					"mstnr": "110200135",
					"date": "2015-12-08",
					"value": 81.93,
					"mstbez": "TE/13-LAGGENBECK-"
				},
				{
					"mstnr": "110200251",
					"date": "2015-12-08",
					"value": 183.79,
					"mstbez": "TE/25 IBBENBUEREN"
				},
				{
					"mstnr": "118021035",
					"date": "2015-09-29",
					"value": 1,
					"mstbez": "WW.IBBENBLEHEN-VK03"
				}
			],
			"plz": "49477"
		},
		"Herzebrock-Clarholz": {
			"stations": [
				{
					"mstnr": "26490766",
					"date": "2015-02-02",
					"value": 1,
					"mstbez": "VB 4    Quenhorn"
				},
				{
					"mstnr": "26490742",
					"date": "2015-02-02",
					"value": 7.1,
					"mstbez": "HO 2    Quenhorn"
				}
			],
			"plz": "33442"
		},
		"Schöppingen": {
			"stations": [
				{
					"mstnr": "60240398",
					"date": "2015-04-23",
					"value": 3.32,
					"mstbez": "AH/39 -HAVERBECK-"
				},
				{
					"mstnr": "60240118",
					"date": "2015-04-16",
					"value": 16.16,
					"mstbez": "AH/11 SCHOEPPINGEN"
				},
				{
					"mstnr": "60240386",
					"date": "2015-09-15",
					"value": 28.17,
					"mstbez": "AH/38 -HEVEN-"
				}
			],
			"plz": "48624"
		},
		"Porta Westfalica": {
			"stations": [
				{
					"mstnr": "106503649",
					"date": "2015-10-20",
					"value": 6.6,
					"mstbez": "PNAM2 TB NAMMEN"
				},
				{
					"mstnr": "106503649",
					"date": "2015-04-22",
					"value": 12.8,
					"mstbez": "PNAM2 TB NAMMEN"
				},
				{
					"mstnr": "100731478",
					"date": "2015-06-24",
					"value": 35.07,
					"mstbez": "MH1109   HUXHOEHE"
				},
				{
					"mstnr": "100731296",
					"date": "2015-04-16",
					"value": 34.01,
					"mstbez": "MH 8 HORIHUXH-MACKE"
				},
				{
					"mstnr": "100730024",
					"date": "2015-10-20",
					"value": 27.41,
					"mstbez": "PS 12ABR EISBERGEN"
				},
				{
					"mstnr": "100730103",
					"date": "2015-10-20",
					"value": 32.41,
					"mstbez": "PS 5  BR SPRENGELWG"
				},
				{
					"mstnr": "100730103",
					"date": "2015-04-22",
					"value": 30.51,
					"mstbez": "PS 5  BR SPRENGELWG"
				},
				{
					"mstnr": "100730050",
					"date": "2015-04-24",
					"value": 13,
					"mstbez": "VE3-10BR VE-KLINKE"
				},
				{
					"mstnr": "100730050",
					"date": "2015-11-23",
					"value": 12,
					"mstbez": "VE3-10BR VE-KLINKE"
				},
				{
					"mstnr": "100730024",
					"date": "2015-04-22",
					"value": 26.21,
					"mstbez": "PS 12ABR EISBERGEN"
				},
				{
					"mstnr": "100731296",
					"date": "2015-10-08",
					"value": 36.01,
					"mstbez": "MH 8 HORIHUXH-MACKE"
				}
			],
			"plz": "32457"
		},
		"Altenberge": {
			"stations": [
				{
					"mstnr": "110040247",
					"date": "2015-12-10",
					"value": 1.33,
					"mstbez": "IV/24 WALTRUP"
				},
				{
					"mstnr": "110040284",
					"date": "2015-05-12",
					"value": 1.57,
					"mstbez": "IV/28 Hornbrock"
				}
			],
			"plz": "48341"
		},
		"Wetter (Ruhr)": {
			"stations": [
				{
					"mstnr": "59540618",
					"date": "2015-08-04",
					"value": 35.34,
					"mstbez": "WETTER 18/2"
				},
				{
					"mstnr": "59540606",
					"date": "2015-04-20",
					"value": 1.33,
					"mstbez": "FREIB. WETTER"
				}
			],
			"plz": "58300"
		},
		"Geilenkirchen": {
			"stations": [
				{
					"mstnr": "10403474",
					"date": "2015-03-09",
					"value": 44.06,
					"mstbez": "TEVEREN NATO BR. I"
				}
			],
			"plz": "52511"
		},
		"Augustdorf": {
			"stations": [
				{
					"mstnr": "106525165",
					"date": "2015-10-22",
					"value": 8.46,
					"mstbez": "I/3T Augustdorf"
				},
				{
					"mstnr": "20104546",
					"date": "2015-09-08",
					"value": 12.2,
					"mstbez": "TB 5            W55"
				},
				{
					"mstnr": "20104546",
					"date": "2015-03-09",
					"value": 12.3,
					"mstbez": "TB 5            W55"
				}
			],
			"plz": "32832"
		},
		"Heimbach": {
			"stations": [
				{
					"mstnr": "10203254",
					"date": "2015-05-11",
					"value": 61.55,
					"mstbez": "VLATTEN FLACH"
				},
				{
					"mstnr": "10203254",
					"date": "2015-08-10",
					"value": 58.01,
					"mstbez": "VLATTEN FLACH"
				},
				{
					"mstnr": "10203266",
					"date": "2015-05-11",
					"value": 29.14,
					"mstbez": "VLATTEN TIEF"
				}
			],
			"plz": "52396"
		},
		"Hückeswagen": {
			"stations": [
				{
					"mstnr": "73774303",
					"date": "2015-04-02",
					"value": 25.69,
					"mstbez": "WG KORMANNSHSN. EB"
				}
			],
			"plz": "42499"
		},
		"Versmold": {
			"stations": [
				{
					"mstnr": "21001730",
					"date": "2015-07-02",
					"value": 82.37,
					"mstbez": "602FA LGD Bockhorst"
				},
				{
					"mstnr": "21001728",
					"date": "2015-07-02",
					"value": 1.33,
					"mstbez": "602 A LGD Bockhorst"
				},
				{
					"mstnr": "21001698",
					"date": "2015-07-14",
					"value": 1.33,
					"mstbez": "763             LGD"
				},
				{
					"mstnr": "26540241",
					"date": "2015-07-21",
					"value": 1.33,
					"mstbez": "607- 5,5m ML"
				},
				{
					"mstnr": "21000086",
					"date": "2015-07-21",
					"value": 1.33,
					"mstbez": "607 T ML Peckeloh"
				},
				{
					"mstnr": "21001790",
					"date": "2015-07-21",
					"value": 30.38,
					"mstbez": "770ML Siedinghausen"
				},
				{
					"mstnr": "26541191",
					"date": "2015-07-21",
					"value": 14.7,
					"mstbez": "770-11,0m ML"
				},
				{
					"mstnr": "20104315",
					"date": "2015-07-14",
					"value": 146.59,
					"mstbez": "VI/5 M Versmold"
				},
				{
					"mstnr": "20104303",
					"date": "2015-06-30",
					"value": 69.09,
					"mstbez": "VI/4 LGD"
				},
				{
					"mstnr": "26541208",
					"date": "2015-07-21",
					"value": 43.36,
					"mstbez": "770-14,0m ML"
				},
				{
					"mstnr": "26540228",
					"date": "2015-07-21",
					"value": 4.61,
					"mstbez": "607- 3,0m ML"
				},
				{
					"mstnr": "26541180",
					"date": "2015-07-21",
					"value": 21.39,
					"mstbez": "770- 8,0m ML"
				},
				{
					"mstnr": "26540216",
					"date": "2015-07-21",
					"value": 1.33,
					"mstbez": "607- 2,0m ML"
				},
				{
					"mstnr": "20060208",
					"date": "2015-07-02",
					"value": 2.97,
					"mstbez": "VI/20   VERSMOLD"
				},
				{
					"mstnr": "26525033",
					"date": "2015-07-14",
					"value": 1.33,
					"mstbez": "VI/5 T Versmold"
				},
				{
					"mstnr": "26540230",
					"date": "2015-07-21",
					"value": 1.33,
					"mstbez": "607- 4,0m ML"
				},
				{
					"mstnr": "26541178",
					"date": "2015-07-21",
					"value": 39.33,
					"mstbez": "770- 4,0m ML"
				}
			],
			"plz": "33775"
		},
		"Hilden": {
			"stations": [
				{
					"mstnr": "30302626",
					"date": "2015-09-07",
					"value": 0.13,
					"mstbez": "Hild-Verw.schule"
				},
				{
					"mstnr": "30302699",
					"date": "2015-09-07",
					"value": 0.13,
					"mstbez": "Hild-Stadtwald-West"
				},
				{
					"mstnr": "30302857",
					"date": "2015-01-09",
					"value": 3.72,
					"mstbez": "Hild-Auf dem Sand"
				},
				{
					"mstnr": "30302821",
					"date": "2015-01-09",
					"value": 17.76,
					"mstbez": "Hild-Stadtwald-Süd"
				}
			],
			"plz": "40721"
		},
		"Hövelhof": {
			"stations": [
				{
					"mstnr": "26531021",
					"date": "2015-08-11",
					"value": 12.53,
					"mstbez": "101- 5,0m ML OL"
				},
				{
					"mstnr": "26531033",
					"date": "2015-08-11",
					"value": 7,
					"mstbez": "101- 9,0m ML OL"
				},
				{
					"mstnr": "26531045",
					"date": "2015-08-11",
					"value": 21.79,
					"mstbez": "101-14,0m ML OL"
				},
				{
					"mstnr": "21150011",
					"date": "2015-08-11",
					"value": 3.63,
					"mstbez": "OL101ML Staumuehle"
				},
				{
					"mstnr": "23006456",
					"date": "2015-09-10",
					"value": 3.5,
					"mstbez": "W13 05  Suedfassung"
				}
			],
			"plz": "33161"
		},
		"Straelen": {
			"stations": [
				{
					"mstnr": "80302166",
					"date": "2015-03-20",
					"value": 8.55,
					"mstbez": "AUWEL HOLT"
				},
				{
					"mstnr": "80302154",
					"date": "2015-06-23",
					"value": 154.11,
					"mstbez": "BOEKHOLT HILDEBRAND"
				},
				{
					"mstnr": "80302762",
					"date": "2015-08-26",
					"value": 52.26,
					"mstbez": "STRAELEN        B58"
				},
				{
					"mstnr": "80301794",
					"date": "2015-10-02",
					"value": 111.16,
					"mstbez": "FOSSA           327"
				},
				{
					"mstnr": "80301060",
					"date": "2015-06-22",
					"value": 97.87,
					"mstbez": "EHRENMAL     HY 254"
				},
				{
					"mstnr": "80201556",
					"date": "2015-10-14",
					"value": 0.13,
					"mstbez": "FLOOTSMÜHLE     198"
				},
				{
					"mstnr": "80301800",
					"date": "2015-07-01",
					"value": 49.6,
					"mstbez": "STADTHALLE      328"
				}
			],
			"plz": "47638"
		},
		"Sendenhorst": {
			"stations": [
				{
					"mstnr": "110070094",
					"date": "2015-12-08",
					"value": 146.59,
					"mstbez": "VII/9 -ALBERSLOH-"
				},
				{
					"mstnr": "110070045",
					"date": "2015-11-12",
					"value": 1.33,
					"mstbez": "VII/4-SENDH.-HARDT-"
				},
				{
					"mstnr": "110070057",
					"date": "2015-11-12",
					"value": 163.41,
					"mstbez": "VII/5 -SENDENHORST-"
				}
			],
			"plz": "48324"
		},
		"Bad Honnef": {
			"stations": [
				{
					"mstnr": "73746710",
					"date": "2015-07-31",
					"value": 27.37,
					"mstbez": "BAD HONNEF AG 3"
				},
				{
					"mstnr": "76988399",
					"date": "2015-03-26",
					"value": 14.88,
					"mstbez": "Forsths.Servat.hof"
				}
			],
			"plz": "53604"
		},
		"Bad Driburg": {
			"stations": [
				{
					"mstnr": "26502884",
					"date": "2015-06-09",
					"value": 12,
					"mstbez": "QU Poembsen"
				},
				{
					"mstnr": "26500139",
					"date": "2015-02-25",
					"value": 17.4,
					"mstbez": "Q 23 NEUENH NETHE"
				},
				{
					"mstnr": "26502926",
					"date": "2015-10-20",
					"value": 6,
					"mstbez": "B3 Weissenborn"
				},
				{
					"mstnr": "26502926",
					"date": "2015-06-09",
					"value": 7,
					"mstbez": "B3 Weissenborn"
				},
				{
					"mstnr": "26502902",
					"date": "2015-10-20",
					"value": 12,
					"mstbez": "QU Katzohl-Quelle"
				},
				{
					"mstnr": "26502902",
					"date": "2015-06-09",
					"value": 13,
					"mstbez": "QU Katzohl-Quelle"
				},
				{
					"mstnr": "26502896",
					"date": "2015-10-20",
					"value": 4,
					"mstbez": "QU Langeland"
				},
				{
					"mstnr": "26500012",
					"date": "2015-02-25",
					"value": 17.14,
					"mstbez": "Q 25 Antonius Neuh"
				},
				{
					"mstnr": "26502884",
					"date": "2015-10-20",
					"value": 11,
					"mstbez": "QU Poembsen"
				},
				{
					"mstnr": "26502896",
					"date": "2015-06-09",
					"value": 5,
					"mstbez": "QU Langeland"
				}
			],
			"plz": "33014"
		},
		"Würselen": {
			"stations": [
				{
					"mstnr": "10409695",
					"date": "2015-02-09",
					"value": 22.1,
					"mstbez": "Gouleyquelle"
				},
				{
					"mstnr": "219671916",
					"date": "2015-10-05",
					"value": 149.23,
					"mstbez": "Merzbrück"
				}
			],
			"plz": "52146"
		},
		"Dörentrup": {
			"stations": [
				{
					"mstnr": "106500041",
					"date": "2015-11-24",
					"value": 25.01,
					"mstbez": "HIL42 QU DOERENTRUP"
				},
				{
					"mstnr": "106500041",
					"date": "2015-05-26",
					"value": 26.01,
					"mstbez": "HIL42 QU DOERENTRUP"
				},
				{
					"mstnr": "106505014",
					"date": "2015-05-26",
					"value": 34.01,
					"mstbez": "HUMF2 BR HUMFELD"
				},
				{
					"mstnr": "106505014",
					"date": "2015-11-24",
					"value": 30.01,
					"mstbez": "HUMF2 BR HUMFELD"
				}
			],
			"plz": "32694"
		},
		"Marienmünster": {
			"stations": [
				{
					"mstnr": "26504613",
					"date": "2015-10-13",
					"value": 52.02,
					"mstbez": "TB Voerden"
				},
				{
					"mstnr": "26500036",
					"date": "2015-02-12",
					"value": 37.2,
					"mstbez": "Q 55 Bredenborn"
				},
				{
					"mstnr": "26504625",
					"date": "2015-10-13",
					"value": 37.01,
					"mstbez": "TB Altenbergen"
				},
				{
					"mstnr": "26502264",
					"date": "2015-10-13",
					"value": 8,
					"mstbez": "BR Loewendorf Neu"
				},
				{
					"mstnr": "26502264",
					"date": "2015-04-14",
					"value": 7,
					"mstbez": "BR Loewendorf Neu"
				},
				{
					"mstnr": "26504613",
					"date": "2015-04-14",
					"value": 50.02,
					"mstbez": "TB Voerden"
				},
				{
					"mstnr": "26504625",
					"date": "2015-04-14",
					"value": 35.01,
					"mstbez": "TB Altenbergen"
				}
			],
			"plz": "37696"
		},
		"Grevenbroich": {
			"stations": [
				{
					"mstnr": "289194611",
					"date": "2015-05-21",
					"value": 23.47,
					"mstbez": "Langwaden"
				},
				{
					"mstnr": "289193515",
					"date": "2015-05-21",
					"value": 10.67,
					"mstbez": "Huelchrath"
				},
				{
					"mstnr": "289194714",
					"date": "2015-06-02",
					"value": 34.94,
					"mstbez": "Neukirch.2"
				},
				{
					"mstnr": "289079512",
					"date": "2015-04-30",
					"value": 54.03,
					"mstbez": "Kapellen"
				},
				{
					"mstnr": "289195019",
					"date": "2015-07-06",
					"value": 0.89,
					"mstbez": "Neurath 2"
				},
				{
					"mstnr": "288193416",
					"date": "2015-10-16",
					"value": 13.1,
					"mstbez": "Wevelinghoven"
				},
				{
					"mstnr": "288194214",
					"date": "2015-10-16",
					"value": 72.03,
					"mstbez": "Neubrück"
				}
			],
			"plz": "41515"
		},
		"Alfter": {
			"stations": [
				{
					"mstnr": "70284611",
					"date": "2015-06-10",
					"value": 111.16,
					"mstbez": "LGD Alfter ALTABL."
				},
				{
					"mstnr": "73529217",
					"date": "2015-08-13",
					"value": 44.73,
					"mstbez": "GEM. ALFTER 6"
				}
			],
			"plz": "53347"
		},
		"Meschede": {
			"stations": [
				{
					"mstnr": "94150448",
					"date": "2015-12-15",
					"value": 17.4,
					"mstbez": "Stollen  Wehrstapel"
				},
				{
					"mstnr": "94150448",
					"date": "2015-12-22",
					"value": 16.01,
					"mstbez": "Stollen  Wehrstapel"
				},
				{
					"mstnr": "94150461",
					"date": "2015-12-14",
					"value": 5.62,
					"mstbez": "Que 2129 Plackweg"
				}
			],
			"plz": "59872"
		},
		"Warendorf": {
			"stations": [
				{
					"mstnr": "113014016",
					"date": "2015-11-17",
					"value": 1.33,
					"mstbez": "WW WARENDORF Br 6"
				},
				{
					"mstnr": "110070525",
					"date": "2015-11-17",
					"value": 1.33,
					"mstbez": "VII/52 HOLTRUP"
				},
				{
					"mstnr": "110060090",
					"date": "2015-11-24",
					"value": 116.47,
					"mstbez": "VI/9 GROEBLINGEN"
				}
			],
			"plz": "48231"
		},
		"Bad Berleburg": {
			"stations": [
				{
					"mstnr": "129700770",
					"date": "2015-04-13",
					"value": 5.54,
					"mstbez": "Truftetal"
				},
				{
					"mstnr": "129700241",
					"date": "2015-04-07",
					"value": 1.33,
					"mstbez": "Leisebach"
				},
				{
					"mstnr": "129700319",
					"date": "2015-04-28",
					"value": 5.71,
					"mstbez": "Sombornquelle"
				},
				{
					"mstnr": "129700320",
					"date": "2015-04-07",
					"value": 3.72,
					"mstbez": "Weidetalquelle"
				},
				{
					"mstnr": "129700757",
					"date": "2015-04-13",
					"value": 7.48,
					"mstbez": "Girkhausen"
				},
				{
					"mstnr": "129700071",
					"date": "2015-04-13",
					"value": 22.59,
					"mstbez": "Herrenwiese"
				}
			],
			"plz": "57319"
		},
		"Minden": {
			"stations": [
				{
					"mstnr": "106502300",
					"date": "2015-01-07",
					"value": 8,
					"mstbez": "LUT36 QU LUTTERN"
				},
				{
					"mstnr": "100135020",
					"date": "2015-06-24",
					"value": 26.88,
					"mstbez": "PH1002   PAEPINGHSN"
				},
				{
					"mstnr": "100140014",
					"date": "2015-09-17",
					"value": 32.2,
					"mstbez": "WG 2     MINDEN"
				},
				{
					"mstnr": "100140749",
					"date": "2015-04-16",
					"value": 144.37,
					"mstbez": "WG 68    BARTLING"
				},
				{
					"mstnr": "106502300",
					"date": "2015-05-11",
					"value": 11,
					"mstbez": "LUT36 QU LUTTERN"
				},
				{
					"mstnr": "100721217",
					"date": "2015-11-13",
					"value": 1,
					"mstbez": "MM HORI  MEISSEN"
				},
				{
					"mstnr": "100140865",
					"date": "2015-07-01",
					"value": 1.33,
					"mstbez": "WG 80    SUEDFRIEDH"
				},
				{
					"mstnr": "100140920",
					"date": "2015-06-24",
					"value": 5.27,
					"mstbez": "BN 1     BASTAUNIED"
				},
				{
					"mstnr": "100721217",
					"date": "2015-04-16",
					"value": 1,
					"mstbez": "MM HORI  MEISSEN"
				},
				{
					"mstnr": "100141389",
					"date": "2015-09-17",
					"value": 30.82,
					"mstbez": "WG 89    Nordfriedh"
				},
				{
					"mstnr": "100702119",
					"date": "2015-05-11",
					"value": 31.01,
					"mstbez": "WH 1+2 BR HADDENH"
				},
				{
					"mstnr": "100702533",
					"date": "2015-10-08",
					"value": 4,
					"mstbez": "MP 11B BR PORTASTRS"
				}
			],
			"plz": "32423"
		},
		"Erwitte": {
			"stations": [
				{
					"mstnr": "94160041",
					"date": "2015-10-28",
					"value": 42.96,
					"mstbez": "Quelle Eikeloh"
				},
				{
					"mstnr": "94160314",
					"date": "2015-09-04",
					"value": 54.91,
					"mstbez": "Quelle Bullerloch"
				},
				{
					"mstnr": "94160077",
					"date": "2015-05-26",
					"value": 30.47,
					"mstbez": "Mühlenteichquelle"
				},
				{
					"mstnr": "91161150",
					"date": "2015-06-15",
					"value": 58.46,
					"mstbez": "Erwitte GWB 1"
				},
				{
					"mstnr": "94160041",
					"date": "2015-10-05",
					"value": 39.01,
					"mstbez": "Quelle Eikeloh"
				},
				{
					"mstnr": "91163705",
					"date": "2015-06-15",
					"value": 42.74,
					"mstbez": "Pöppelsche Eikeloh"
				},
				{
					"mstnr": "91161356",
					"date": "2015-05-28",
					"value": 26.53,
					"mstbez": "Grasweg Eikeloh"
				},
				{
					"mstnr": "91161253",
					"date": "2015-10-20",
					"value": 69.97,
					"mstbez": "Erwitte GWB 3"
				}
			],
			"plz": "59597"
		},
		"Oerlinghausen": {
			"stations": [
				{
					"mstnr": "26495028",
					"date": "2015-03-19",
					"value": 19.49,
					"mstbez": "Qu Brandsmuehle"
				},
				{
					"mstnr": "106502062",
					"date": "2015-04-13",
					"value": 12,
					"mstbez": "HELL3 BR HELLE"
				},
				{
					"mstnr": "106502025",
					"date": "2015-10-06",
					"value": 18.01,
					"mstbez": "HELP9 BR HELPUP"
				},
				{
					"mstnr": "106502165",
					"date": "2015-04-13",
					"value": 14,
					"mstbez": "BR 10 Wistinghausen"
				},
				{
					"mstnr": "106502165",
					"date": "2015-10-06",
					"value": 14,
					"mstbez": "BR 10 Wistinghausen"
				},
				{
					"mstnr": "106502130",
					"date": "2015-04-13",
					"value": 15.01,
					"mstbez": "BR 6 OeS Oehr.Senne"
				},
				{
					"mstnr": "106502130",
					"date": "2015-10-06",
					"value": 15.01,
					"mstbez": "BR 6 OeS Oehr.Senne"
				},
				{
					"mstnr": "106502062",
					"date": "2015-10-06",
					"value": 7,
					"mstbez": "HELL3 BR HELLE"
				}
			],
			"plz": "33813"
		},
		"Brakel": {
			"stations": [
				{
					"mstnr": "22520156",
					"date": "2015-07-16",
					"value": 11.69,
					"mstbez": "He1     Herste"
				},
				{
					"mstnr": "26500140",
					"date": "2015-02-25",
					"value": 30.65,
					"mstbez": "Q 18 Gehrden"
				},
				{
					"mstnr": "26502185",
					"date": "2015-11-03",
					"value": 26.01,
					"mstbez": "BR Schmechten"
				},
				{
					"mstnr": "20790302",
					"date": "2015-05-28",
					"value": 40.01,
					"mstbez": "BR Riesel -Nethetal"
				},
				{
					"mstnr": "26504212",
					"date": "2015-05-28",
					"value": 44.02,
					"mstbez": "TB Gehrden"
				},
				{
					"mstnr": "26504261",
					"date": "2015-11-03",
					"value": 40.01,
					"mstbez": "QU Erkeln"
				},
				{
					"mstnr": "26504261",
					"date": "2015-05-28",
					"value": 39.01,
					"mstbez": "QU Erkeln"
				},
				{
					"mstnr": "26502173",
					"date": "2015-05-28",
					"value": 46.02,
					"mstbez": "BR Boekendorf"
				},
				{
					"mstnr": "26504212",
					"date": "2015-02-09",
					"value": 35.01,
					"mstbez": "TB Gehrden"
				},
				{
					"mstnr": "26504212",
					"date": "2015-11-03",
					"value": 33.01,
					"mstbez": "TB Gehrden"
				},
				{
					"mstnr": "20790302",
					"date": "2015-11-03",
					"value": 31.01,
					"mstbez": "BR Riesel -Nethetal"
				},
				{
					"mstnr": "26502185",
					"date": "2015-05-28",
					"value": 23.01,
					"mstbez": "BR Schmechten"
				},
				{
					"mstnr": "26502173",
					"date": "2015-11-03",
					"value": 31.01,
					"mstbez": "BR Boekendorf"
				}
			],
			"plz": "33034"
		},
		"Oer-Erkenschwick": {
			"stations": [
				{
					"mstnr": "68011210",
					"date": "2015-09-16",
					"value": 13.5,
					"mstbez": "WW.HALTERNHAARD-B21"
				},
				{
					"mstnr": "68011210",
					"date": "2015-03-18",
					"value": 13.1,
					"mstbez": "WW.HALTERNHAARD-B21"
				},
				{
					"mstnr": "60091101",
					"date": "2015-11-05",
					"value": 4.92,
					"mstbez": "HS 84"
				}
			],
			"plz": "45739"
		},
		"Ahlen": {
			"stations": [
				{
					"mstnr": "110070409",
					"date": "2015-11-11",
					"value": 1.33,
					"mstbez": "VII/40-VORHELM-"
				}
			],
			"plz": "59227"
		},
		"Unna": {
			"stations": [
				{
					"mstnr": "94120353",
					"date": "2015-04-13",
					"value": 42.03,
					"mstbez": "Jacobsqu Billmerich"
				},
				{
					"mstnr": "94120341",
					"date": "2015-04-13",
					"value": 41.01,
					"mstbez": "Quelle Hemmerde"
				}
			],
			"plz": "59423"
		},
		"Schlangen": {
			"stations": [
				{
					"mstnr": "26525112",
					"date": "2015-08-20",
					"value": 7.7,
					"mstbez": "58.2 Haustenbeck"
				}
			],
			"plz": "33189"
		},
		"Ochtrup": {
			"stations": [
				{
					"mstnr": "110240029",
					"date": "2015-06-16",
					"value": 1.33,
					"mstbez": "Ah/2 Ochtrup"
				}
			],
			"plz": "48607"
		},
		"Arnsberg": {
			"stations": [
				{
					"mstnr": "94130590",
					"date": "2015-04-08",
					"value": 35.12,
					"mstbez": "Quelle Biber"
				},
				{
					"mstnr": "94140236",
					"date": "2015-04-08",
					"value": 8.9,
					"mstbez": "Que Kl Schmalenau"
				},
				{
					"mstnr": "94150242",
					"date": "2015-10-19",
					"value": 1,
					"mstbez": "Br Lattenberg"
				},
				{
					"mstnr": "94150242",
					"date": "2015-12-14",
					"value": 1.33,
					"mstbez": "Br Lattenberg"
				},
				{
					"mstnr": "94150242",
					"date": "2015-04-13",
					"value": 1,
					"mstbez": "Br Lattenberg"
				}
			],
			"plz": "59759"
		},
		"Hiddenhausen": {
			"stations": [
				{
					"mstnr": "106503984",
					"date": "2015-04-14",
					"value": 2,
					"mstbez": "HI 1A BR HIDDENHAUS"
				},
				{
					"mstnr": "106503960",
					"date": "2015-04-14",
					"value": 1,
					"mstbez": "HI 8 BR  HIDDENHAUS"
				}
			],
			"plz": "32120"
		},
		"Moers": {
			"stations": [
				{
					"mstnr": "42013550",
					"date": "2015-06-25",
					"value": 35.01,
					"mstbez": "LINEG_1498H"
				},
				{
					"mstnr": "42011097",
					"date": "2015-12-10",
					"value": 45.02,
					"mstbez": "LINEG_1251"
				},
				{
					"mstnr": "42013550",
					"date": "2015-01-15",
					"value": 37.01,
					"mstbez": "LINEG_1498H"
				},
				{
					"mstnr": "42064697",
					"date": "2015-12-14",
					"value": 15.21,
					"mstbez": "LINEG_2663H"
				}
			],
			"plz": "47441"
		},
		"Wesseling": {
			"stations": [
				{
					"mstnr": "76503410",
					"date": "2015-05-12",
					"value": 72.63,
					"mstbez": "ROW WESSEL M15 R 1"
				},
				{
					"mstnr": "70168817",
					"date": "2015-06-08",
					"value": 119.13,
					"mstbez": "LGD DICKOPSHOF"
				}
			],
			"plz": "50389"
		},
		"Rahden": {
			"stations": [
				{
					"mstnr": "100150287",
					"date": "2015-05-12",
					"value": 2.21,
					"mstbez": "AU 212   HARTLAGE"
				},
				{
					"mstnr": "100150329",
					"date": "2015-05-12",
					"value": 1.33,
					"mstbez": "AU 214T  LEDEBUR"
				},
				{
					"mstnr": "100150032",
					"date": "2015-05-12",
					"value": 1.33,
					"mstbez": "AU 103T  STROEHEN"
				},
				{
					"mstnr": "100150640",
					"date": "2015-05-19",
					"value": 1.33,
					"mstbez": "AU 324   SIELHORST"
				},
				{
					"mstnr": "100151085",
					"date": "2015-07-01",
					"value": 1.33,
					"mstbez": "AU 507 Stellerdamm"
				},
				{
					"mstnr": "100700512",
					"date": "2015-10-19",
					"value": 68.02,
					"mstbez": "WE 1  BR WEHE RAHDN"
				},
				{
					"mstnr": "100700512",
					"date": "2015-05-26",
					"value": 70.02,
					"mstbez": "WE 1  BR WEHE RAHDN"
				},
				{
					"mstnr": "100700550",
					"date": "2015-10-19",
					"value": 16.01,
					"mstbez": "WE 5A BR WEHE RAHDN"
				},
				{
					"mstnr": "100700550",
					"date": "2015-05-26",
					"value": 14,
					"mstbez": "WE 5A BR WEHE RAHDN"
				},
				{
					"mstnr": "106520052",
					"date": "2015-05-12",
					"value": 1.33,
					"mstbez": "AU214F LEDEBUR neu"
				},
				{
					"mstnr": "106520040",
					"date": "2015-05-12",
					"value": 1.82,
					"mstbez": "AU103M   STROEHEN"
				}
			],
			"plz": "32369"
		},
		"Radevormwald": {
			"stations": [
				{
					"mstnr": "73774182",
					"date": "2015-04-02",
					"value": 29.41,
					"mstbez": "WLV OENKFELD EB"
				},
				{
					"mstnr": "73774200",
					"date": "2015-04-02",
					"value": 29.72,
					"mstbez": "WLV REMLINGRADE EB"
				}
			],
			"plz": "42477"
		},
		"Heek": {
			"stations": [
				{
					"mstnr": "60240131",
					"date": "2015-05-18",
					"value": 1.33,
					"mstbez": "AH/13 -WICHUM-"
				},
				{
					"mstnr": "60240120",
					"date": "2015-04-16",
					"value": 1.6,
					"mstbez": "AH/12 -HELMERT-"
				},
				{
					"mstnr": "60240155",
					"date": "2015-06-09",
					"value": 22.32,
					"mstbez": "AH/15-AVERBECK-"
				}
			],
			"plz": "48619"
		},
		"Steinfurt": {
			"stations": [
				{
					"mstnr": "110320104",
					"date": "2015-06-25",
					"value": 1.33,
					"mstbez": "Me/2 METELEN"
				},
				{
					"mstnr": "110050149",
					"date": "2015-09-07",
					"value": 1.33,
					"mstbez": "V/14 BORGHORST NORD"
				},
				{
					"mstnr": "110070288",
					"date": "2015-07-22",
					"value": 6.86,
					"mstbez": "VII/28 HOLLICH.FELD"
				},
				{
					"mstnr": "110050137",
					"date": "2015-04-14",
					"value": 1.33,
					"mstbez": "V/13 -SELLEN-"
				},
				{
					"mstnr": "110050150",
					"date": "2015-09-28",
					"value": 1.33,
					"mstbez": "V/15  STEINF. BAGNO"
				},
				{
					"mstnr": "110050071",
					"date": "2015-04-13",
					"value": 2.51,
					"mstbez": "V/7 WETTRINGEN"
				}
			],
			"plz": "48565"
		},
		"Rheinbach": {
			"stations": [
				{
					"mstnr": "76402710",
					"date": "2015-11-17",
					"value": 29.36,
					"mstbez": "KWR MP 1 Alte Waage"
				},
				{
					"mstnr": "279483910",
					"date": "2015-12-16",
					"value": 37.81,
					"mstbez": "Rheinbach2"
				},
				{
					"mstnr": "73529412",
					"date": "2015-07-13",
					"value": 42.74,
					"mstbez": "GEM. ALFTER 8"
				},
				{
					"mstnr": "76402710",
					"date": "2015-04-29",
					"value": 15.73,
					"mstbez": "KWR MP 1 Alte Waage"
				}
			],
			"plz": "53359"
		},
		"Lügde": {
			"stations": [
				{
					"mstnr": "106505877",
					"date": "2015-04-21",
					"value": 12,
					"mstbez": "LUKOE BR KOETERBERG"
				},
				{
					"mstnr": "106500028",
					"date": "2015-02-12",
					"value": 33.88,
					"mstbez": "LUEG4 QU LUEGDE"
				},
				{
					"mstnr": "106505877",
					"date": "2015-09-21",
					"value": 12,
					"mstbez": "LUKOE BR KOETERBERG"
				},
				{
					"mstnr": "106505853",
					"date": "2015-04-21",
					"value": 23.01,
					"mstbez": "LUWOE BR WOERDERFEL"
				},
				{
					"mstnr": "106505520",
					"date": "2015-04-21",
					"value": 13,
					"mstbez": "HARZB QU HARZBERG"
				}
			],
			"plz": "32676"
		},
		"Wünnenberg": {
			"stations": [
				{
					"mstnr": "24170070",
					"date": "2015-07-14",
					"value": 44.02,
					"mstbez": "QU 1 Leiberg Bueren"
				},
				{
					"mstnr": "24170070",
					"date": "2015-12-15",
					"value": 48.02,
					"mstbez": "QU 1 Leiberg Bueren"
				},
				{
					"mstnr": "24170070",
					"date": "2015-06-17",
					"value": 47.02,
					"mstbez": "QU 1 Leiberg Bueren"
				},
				{
					"mstnr": "24170070",
					"date": "2015-05-27",
					"value": 48.02,
					"mstbez": "QU 1 Leiberg Bueren"
				},
				{
					"mstnr": "24170070",
					"date": "2015-11-04",
					"value": 44.02,
					"mstbez": "QU 1 Leiberg Bueren"
				}
			],
			"plz": "33181"
		},
		"Wipperfürth": {
			"stations": [
				{
					"mstnr": "73774480",
					"date": "2015-04-10",
					"value": 19.44,
					"mstbez": "WBV OHL QUELLE II"
				},
				{
					"mstnr": "73903206",
					"date": "2015-10-13",
					"value": 21.35,
					"mstbez": "WG EGEN TB"
				}
			],
			"plz": "51688"
		},
		"Alpen": {
			"stations": [
				{
					"mstnr": "42065100",
					"date": "2015-12-09",
					"value": 17.65,
					"mstbez": "LINEG_2704"
				},
				{
					"mstnr": "42065124",
					"date": "2015-01-27",
					"value": 15.71,
					"mstbez": "LINEG_2706"
				},
				{
					"mstnr": "42065124",
					"date": "2015-03-17",
					"value": 16.01,
					"mstbez": "LINEG_2706"
				},
				{
					"mstnr": "42065124",
					"date": "2015-08-10",
					"value": 16.71,
					"mstbez": "LINEG_2706"
				},
				{
					"mstnr": "42065124",
					"date": "2015-09-21",
					"value": 16.01,
					"mstbez": "LINEG_2706"
				},
				{
					"mstnr": "42065124",
					"date": "2015-12-07",
					"value": 17.51,
					"mstbez": "LINEG_2706"
				},
				{
					"mstnr": "40100066",
					"date": "2015-04-30",
					"value": 35.61,
					"mstbez": "GRUENTHAL NR 7"
				}
			],
			"plz": "46519"
		},
		"Meinerzhagen": {
			"stations": [
				{
					"mstnr": "59621278",
					"date": "2015-10-27",
					"value": 1.33,
					"mstbez": "BUSCHHOEH"
				},
				{
					"mstnr": "59620821",
					"date": "2015-03-16",
					"value": 8.02,
					"mstbez": "Volmequelle"
				},
				{
					"mstnr": "76809407",
					"date": "2015-04-22",
					"value": 8.99,
					"mstbez": "CONTEX EB"
				}
			],
			"plz": "58540"
		},
		"Netphen": {
			"stations": [
				{
					"mstnr": "129700230",
					"date": "2015-03-31",
					"value": 9.57,
					"mstbez": "Siegquelle"
				},
				{
					"mstnr": "129700022",
					"date": "2015-05-04",
					"value": 3.76,
					"mstbez": "Gräbener"
				},
				{
					"mstnr": "129700514",
					"date": "2015-08-26",
					"value": 10.41,
					"mstbez": "Niedernetphen"
				}
			],
			"plz": "57250"
		},
		"Dinslaken": {
			"stations": [
				{
					"mstnr": "40061334",
					"date": "2015-12-03",
					"value": 1.33,
					"mstbez": "RAYMANNSGRUND 171"
				}
			],
			"plz": "46535"
		},
		"Kall": {
			"stations": [
				{
					"mstnr": "10407200",
					"date": "2015-10-13",
					"value": 5.27,
					"mstbez": "Dropestollen"
				},
				{
					"mstnr": "10409658",
					"date": "2015-04-16",
					"value": 29.05,
					"mstbez": "Pferdekopfquelle"
				},
				{
					"mstnr": "10409865",
					"date": "2015-04-16",
					"value": 13.64,
					"mstbez": "Hermann-Josef-Quell"
				},
				{
					"mstnr": "10409038",
					"date": "2015-03-05",
					"value": 52.7,
					"mstbez": "Schevenquelle"
				},
				{
					"mstnr": "10408216",
					"date": "2015-12-14",
					"value": 15.01,
					"mstbez": "WW Kall, Br. 1"
				},
				{
					"mstnr": "10408216",
					"date": "2015-06-18",
					"value": 15.01,
					"mstbez": "WW Kall, Br. 1"
				},
				{
					"mstnr": "11006985",
					"date": "2015-09-07",
					"value": 2.26,
					"mstbez": "Kall Zus"
				}
			],
			"plz": "53925"
		},
		"Düsseldorf": {
			"stations": [
				{
					"mstnr": "32502643",
					"date": "2015-08-20",
					"value": 138.17,
					"mstbez": "UWB-Ddorf 00213"
				},
				{
					"mstnr": "32032250",
					"date": "2015-09-14",
					"value": 18.38,
					"mstbez": "UWB-Ddorf 13243"
				},
				{
					"mstnr": "32032080",
					"date": "2015-08-28",
					"value": 0.13,
					"mstbez": "UWB-Ddorf 00814"
				},
				{
					"mstnr": "36462068",
					"date": "2015-06-30",
					"value": 1.11,
					"mstbez": "WW Baumberg Pegel11"
				},
				{
					"mstnr": "32032225",
					"date": "2015-08-28",
					"value": 4.96,
					"mstbez": "UWB-Ddorf 01290"
				},
				{
					"mstnr": "32032110",
					"date": "2015-08-28",
					"value": 24.27,
					"mstbez": "UWB-Ddorf 00865"
				},
				{
					"mstnr": "32032018",
					"date": "2015-09-18",
					"value": 3.85,
					"mstbez": "UWB-Ddorf 00582"
				},
				{
					"mstnr": "36485779",
					"date": "2015-04-17",
					"value": 0.13,
					"mstbez": "SW DUISBURG P419a"
				},
				{
					"mstnr": "32032171",
					"date": "2015-08-28",
					"value": 69.09,
					"mstbez": "UWB-Ddorf 01253"
				},
				{
					"mstnr": "30302640",
					"date": "2015-09-29",
					"value": 23.29,
					"mstbez": "Düss-Mühlenweg"
				},
				{
					"mstnr": "36487491",
					"date": "2015-03-02",
					"value": 9.61,
					"mstbez": "SW Duisburg 2M303a"
				},
				{
					"mstnr": "30000075",
					"date": "2015-01-06",
					"value": 0.18,
					"mstbez": "Düss-Schloß Garath"
				},
				{
					"mstnr": "30302778",
					"date": "2015-03-13",
					"value": 1.33,
					"mstbez": "Düss-Kikweg 1"
				},
				{
					"mstnr": "32032006",
					"date": "2015-12-11",
					"value": 13.51,
					"mstbez": "UWB-Ddorf 00572"
				},
				{
					"mstnr": "32032201",
					"date": "2015-09-29",
					"value": 7.4,
					"mstbez": "UWB-Ddorf 01285"
				}
			],
			"plz": "40213"
		},
		"Winterberg": {
			"stations": [
				{
					"mstnr": "94160466",
					"date": "2015-09-21",
					"value": 3.68,
					"mstbez": "Quelle Elftert"
				},
				{
					"mstnr": "94170368",
					"date": "2015-09-21",
					"value": 1.77,
					"mstbez": "Quelle Große Heide"
				},
				{
					"mstnr": "99580123",
					"date": "2015-09-21",
					"value": 18.11,
					"mstbez": "Que In den Steinen"
				}
			],
			"plz": "59955"
		},
		"Reichshof": {
			"stations": [
				{
					"mstnr": "73775708",
					"date": "2015-04-07",
					"value": 10.85,
					"mstbez": "WG ODENSPIEL"
				},
				{
					"mstnr": "73775885",
					"date": "2015-04-07",
					"value": 14.13,
					"mstbez": "WG HAHNBUCHE QU."
				}
			],
			"plz": "51580"
		},
		"Merzenich": {
			"stations": [
				{
					"mstnr": "218413518",
					"date": "2015-10-13",
					"value": 62.32,
					"mstbez": "Golzheim"
				},
				{
					"mstnr": "219478314",
					"date": "2015-11-30",
					"value": 54.47,
					"mstbez": "Distelrath"
				},
				{
					"mstnr": "218413518",
					"date": "2015-12-01",
					"value": 62.88,
					"mstbez": "Golzheim"
				}
			],
			"plz": "52399"
		},
		"Sassenberg": {
			"stations": [
				{
					"mstnr": "20782317",
					"date": "2015-04-13",
					"value": 10,
					"mstbez": "BR 1A   Fuechtorf"
				},
				{
					"mstnr": "110060064",
					"date": "2015-12-08",
					"value": 3.31,
					"mstbez": "VI/6 -DACKMAR-"
				},
				{
					"mstnr": "110060210",
					"date": "2015-11-09",
					"value": 8.59,
					"mstbez": "VI/21 -DACKMAR-"
				}
			],
			"plz": "48336"
		},
		"Neuss": {
			"stations": [
				{
					"mstnr": "288194317",
					"date": "2015-10-16",
					"value": 2.8,
					"mstbez": "Minkel"
				},
				{
					"mstnr": "288194317",
					"date": "2015-06-22",
					"value": 7.17,
					"mstbez": "Minkel"
				},
				{
					"mstnr": "289196413",
					"date": "2015-05-18",
					"value": 0.89,
					"mstbez": "Gnadental"
				},
				{
					"mstnr": "80301344",
					"date": "2015-07-03",
					"value": 20.11,
					"mstbez": "UEDESHEIM       282"
				},
				{
					"mstnr": "80303080",
					"date": "2015-09-23",
					"value": 0.13,
					"mstbez": "WEISSENBERG     377"
				},
				{
					"mstnr": "80303262",
					"date": "2015-11-27",
					"value": 26.84,
					"mstbez": "DAIMLERSTRASSE  389"
				},
				{
					"mstnr": "289195810",
					"date": "2015-05-18",
					"value": 36.66,
					"mstbez": "Hoisten"
				}
			],
			"plz": "41460"
		},
		"Bad Salzuflen": {
			"stations": [
				{
					"mstnr": "106530288",
					"date": "2015-10-05",
					"value": 142.16,
					"mstbez": "BS 1 ML  -05,50 NOR"
				},
				{
					"mstnr": "100741654",
					"date": "2015-03-31",
					"value": 30.01,
					"mstbez": "HSTE4 BR STEINB-QG"
				},
				{
					"mstnr": "106530290",
					"date": "2015-10-05",
					"value": 34.19,
					"mstbez": "BS 1 ML  -08,00 NOR"
				},
				{
					"mstnr": "100740522",
					"date": "2015-01-07",
					"value": 39.01,
					"mstbez": "HB 2  BR BEGATAL"
				},
				{
					"mstnr": "106530320",
					"date": "2015-10-05",
					"value": 23.38,
					"mstbez": "BS 1 ML  -15,50 NOR"
				},
				{
					"mstnr": "100740522",
					"date": "2015-03-31",
					"value": 58.02,
					"mstbez": "HB 2  BR BEGATAL"
				},
				{
					"mstnr": "100120180",
					"date": "2015-09-23",
					"value": 3.63,
					"mstbez": "BS 17    RETZEN"
				},
				{
					"mstnr": "100740522",
					"date": "2015-06-24",
					"value": 62.02,
					"mstbez": "HB 2  BR BEGATAL"
				},
				{
					"mstnr": "106530318",
					"date": "2015-10-05",
					"value": 36.85,
					"mstbez": "BS 1 ML  -13,00 NOR"
				},
				{
					"mstnr": "106530306",
					"date": "2015-10-05",
					"value": 29.98,
					"mstbez": "BS 1 ML  -10,50 NOR"
				},
				{
					"mstnr": "100120258",
					"date": "2015-10-05",
					"value": 11.12,
					"mstbez": "BS 1 ML  NORDHEIDE"
				},
				{
					"mstnr": "100120015",
					"date": "2015-10-22",
					"value": 18.11,
					"mstbez": "BS 1     KNETTERHDE"
				},
				{
					"mstnr": "100740029",
					"date": "2015-11-09",
					"value": 32.01,
					"mstbez": "LORM2 BR LORENZMEIE"
				},
				{
					"mstnr": "100740029",
					"date": "2015-05-11",
					"value": 32.01,
					"mstbez": "LORM2 BR LORENZMEIE"
				},
				{
					"mstnr": "106505452",
					"date": "2015-09-14",
					"value": 50.02,
					"mstbez": "STOP2 BR STOPPEL"
				},
				{
					"mstnr": "106505439",
					"date": "2015-11-09",
					"value": 28.01,
					"mstbez": "SZ 1 BR  SCHULZ EHR"
				},
				{
					"mstnr": "106505439",
					"date": "2015-05-11",
					"value": 28.01,
					"mstbez": "SZ 1 BR  SCHULZ EHR"
				}
			],
			"plz": "32105"
		},
		"Schmallenberg": {
			"stations": [
				{
					"mstnr": "94160661",
					"date": "2015-05-06",
					"value": 9.08,
					"mstbez": "Quellen Westernah"
				},
				{
					"mstnr": "94180052",
					"date": "2015-05-06",
					"value": 5.89,
					"mstbez": "Que Im Ruthen"
				},
				{
					"mstnr": "99580251",
					"date": "2015-05-06",
					"value": 7.66,
					"mstbez": "Quelle Schanze"
				},
				{
					"mstnr": "99580184",
					"date": "2015-05-06",
					"value": 8.95,
					"mstbez": "Ludwigsquellen"
				},
				{
					"mstnr": "94160594",
					"date": "2015-12-15",
					"value": 8.68,
					"mstbez": "Jacobsquellen"
				},
				{
					"mstnr": "94150175",
					"date": "2015-10-27",
					"value": 6.3,
					"mstbez": "SBr Latroptal"
				}
			],
			"plz": "57392"
		},
		"Schloß Holte-Stukenbrock": {
			"stations": [
				{
					"mstnr": "23007114",
					"date": "2015-09-15",
					"value": 4.7,
					"mstbez": "W18 11A Furlbach"
				},
				{
					"mstnr": "21001352",
					"date": "2015-10-22",
					"value": 8.86,
					"mstbez": "729             LGD"
				},
				{
					"mstnr": "26541269",
					"date": "2015-08-11",
					"value": 4.74,
					"mstbez": "252-13,0m ML    W18"
				},
				{
					"mstnr": "26541245",
					"date": "2015-08-11",
					"value": 7.4,
					"mstbez": "252- 7,0m ML    W18"
				},
				{
					"mstnr": "21000440",
					"date": "2015-10-22",
					"value": 13.2,
					"mstbez": "640             LGD"
				},
				{
					"mstnr": "26541294",
					"date": "2015-08-11",
					"value": 6.69,
					"mstbez": "252 ML  W18"
				},
				{
					"mstnr": "26541233",
					"date": "2015-08-11",
					"value": 4.69,
					"mstbez": "252- 4,5m ML    W18"
				}
			],
			"plz": "33758"
		},
		"Dahlem": {
			"stations": [
				{
					"mstnr": "10200411",
					"date": "2015-03-19",
					"value": 5.93,
					"mstbez": "SCHMIDTHEIM NR.65"
				},
				{
					"mstnr": "10410041",
					"date": "2015-08-12",
					"value": 20.46,
					"mstbez": "Klosterquelle"
				},
				{
					"mstnr": "10408241",
					"date": "2015-10-13",
					"value": 7.79,
					"mstbez": "WASSERDELL MISCHW."
				},
				{
					"mstnr": "10410090",
					"date": "2015-06-18",
					"value": 11.34,
					"mstbez": "Gertrudenquelle"
				},
				{
					"mstnr": "10409622",
					"date": "2015-12-10",
					"value": 12.53,
					"mstbez": "Ursprungsquelle"
				},
				{
					"mstnr": "10408241",
					"date": "2015-05-05",
					"value": 8.3,
					"mstbez": "WASSERDELL MISCHW."
				},
				{
					"mstnr": "10407431",
					"date": "2015-10-13",
					"value": 10.85,
					"mstbez": "EB Hammerhütte Che"
				},
				{
					"mstnr": "10408241",
					"date": "2015-12-17",
					"value": 8.8,
					"mstbez": "WASSERDELL MISCHW."
				},
				{
					"mstnr": "10408230",
					"date": "2015-10-13",
					"value": 10.58,
					"mstbez": "WASSERDELL BRUNNEN"
				},
				{
					"mstnr": "10407479",
					"date": "2015-09-17",
					"value": 6.42,
					"mstbez": "QUELLE WALDORF"
				}
			],
			"plz": "53949"
		},
		"Kierspe": {
			"stations": [
				{
					"mstnr": "59620950",
					"date": "2015-09-07",
					"value": 3.18,
					"mstbez": "Flachbr.Umspannwerk"
				},
				{
					"mstnr": "59620985",
					"date": "2015-09-07",
					"value": 8.77,
					"mstbez": "Kierspe Rathaus"
				}
			],
			"plz": "58566"
		},
		"Breckerfeld": {
			"stations": [
				{
					"mstnr": "59540734",
					"date": "2015-03-23",
					"value": 31,
					"mstbez": "Baumeister"
				},
				{
					"mstnr": "59540643",
					"date": "2015-03-23",
					"value": 4,
					"mstbez": "Hasenkehr"
				}
			],
			"plz": "58339"
		},
		"Bergheim": {
			"stations": [
				{
					"mstnr": "278346613",
					"date": "2015-04-01",
					"value": 0.8,
					"mstbez": "Oberaußem"
				},
				{
					"mstnr": "278331427",
					"date": "2015-10-13",
					"value": 0.5,
					"mstbez": "Kippe Fischbach"
				},
				{
					"mstnr": "279371810",
					"date": "2015-06-05",
					"value": 53.14,
					"mstbez": "Rheidt"
				},
				{
					"mstnr": "278345323",
					"date": "2015-10-27",
					"value": 0.5,
					"mstbez": "Tgb. Fortuna"
				},
				{
					"mstnr": "278345323",
					"date": "2015-03-23",
					"value": 0.5,
					"mstbez": "Tgb. Fortuna"
				},
				{
					"mstnr": "278346613",
					"date": "2015-10-13",
					"value": 0.5,
					"mstbez": "Oberaußem"
				}
			],
			"plz": "50126"
		},
		"Hünxe": {
			"stations": [
				{
					"mstnr": "47202063",
					"date": "2015-04-22",
					"value": 10.6,
					"mstbez": "Vinkel Schw. Br.26"
				},
				{
					"mstnr": "47202063",
					"date": "2015-09-09",
					"value": 10.1,
					"mstbez": "Vinkel Schw. Br.26"
				}
			],
			"plz": "46569"
		},
		"Euskirchen": {
			"stations": [
				{
					"mstnr": "219486219",
					"date": "2015-12-02",
					"value": 74.4,
					"mstbez": "Kessenich 3"
				},
				{
					"mstnr": "219486219",
					"date": "2015-03-26",
					"value": 78.83,
					"mstbez": "Kessenich 3"
				},
				{
					"mstnr": "16001606",
					"date": "2015-09-07",
					"value": 106.73,
					"mstbez": "Br. Heres"
				},
				{
					"mstnr": "11050020",
					"date": "2015-08-10",
					"value": 2.21,
					"mstbez": "Burg Veynau Zus 347"
				},
				{
					"mstnr": "219674310",
					"date": "2015-12-21",
					"value": 2.43,
					"mstbez": "Flamersheim"
				},
				{
					"mstnr": "219976417",
					"date": "2015-12-08",
					"value": 17.41,
					"mstbez": "Euenheim 1"
				},
				{
					"mstnr": "219972011",
					"date": "2015-12-09",
					"value": 125.32,
					"mstbez": "Owichter."
				},
				{
					"mstnr": "11050093",
					"date": "2015-05-20",
					"value": 74.84,
					"mstbez": "Schweinheim Zus 409"
				},
				{
					"mstnr": "219971912",
					"date": "2015-11-26",
					"value": 11.11,
					"mstbez": "Elsig"
				}
			],
			"plz": "53879"
		},
		"Blomberg": {
			"stations": [
				{
					"mstnr": "106501100",
					"date": "2015-03-30",
					"value": 28.01,
					"mstbez": "ROTHB QU ROTHENBORN"
				},
				{
					"mstnr": "106501100",
					"date": "2015-10-14",
					"value": 27.01,
					"mstbez": "ROTHB QU ROTHENBORN"
				}
			],
			"plz": "32825"
		},
		"Simmerath": {
			"stations": [
				{
					"mstnr": "10407777",
					"date": "2015-11-26",
					"value": 9.88,
					"mstbez": "WGA Pleushütte"
				},
				{
					"mstnr": "10410132",
					"date": "2015-02-18",
					"value": 17.36,
					"mstbez": "Brommersbach-Quelle"
				},
				{
					"mstnr": "10409968",
					"date": "2015-02-18",
					"value": 30.2,
					"mstbez": "Michelsbach-Quelle"
				}
			],
			"plz": "52152"
		},
		"Hennef (Sieg)": {
			"stations": [
				{
					"mstnr": "70466117",
					"date": "2015-04-14",
					"value": 20.01,
					"mstbez": "WTV HENNEF Mc007"
				},
				{
					"mstnr": "70424019",
					"date": "2015-04-14",
					"value": 20.01,
					"mstbez": "WTV 303 Nb004"
				},
				{
					"mstnr": "73727301",
					"date": "2015-03-25",
					"value": 14.35,
					"mstbez": "HOMMERICHER HOF EB"
				},
				{
					"mstnr": "70443208",
					"date": "2015-04-13",
					"value": 17.01,
					"mstbez": "WTV HB2 Mb008"
				},
				{
					"mstnr": "70465915",
					"date": "2015-04-14",
					"value": 16.01,
					"mstbez": "WTV HENNEF Mb007"
				}
			],
			"plz": "53773"
		},
		"Lennestadt": {
			"stations": [
				{
					"mstnr": "129661004",
					"date": "2015-07-08",
					"value": 11.2,
					"mstbez": "Elspetal"
				}
			],
			"plz": "57368"
		},
		"Siegen": {
			"stations": [
				{
					"mstnr": "129700307",
					"date": "2015-04-14",
					"value": 2.79,
					"mstbez": "Sangquelle"
				},
				{
					"mstnr": "129700710",
					"date": "2015-08-26",
					"value": 8.33,
					"mstbez": "Einheitsstraße"
				},
				{
					"mstnr": "129700125",
					"date": "2015-04-15",
					"value": 14.48,
					"mstbez": "Siegthalerfabrik"
				},
				{
					"mstnr": "129700034",
					"date": "2015-04-14",
					"value": 17.49,
					"mstbez": "Pützhorn"
				},
				{
					"mstnr": "129700289",
					"date": "2015-04-15",
					"value": 9.39,
					"mstbez": "Gosenbachquelle"
				}
			],
			"plz": "57072"
		},
		"Herscheid": {
			"stations": [
				{
					"mstnr": "59620249",
					"date": "2015-10-06",
					"value": 8.37,
					"mstbez": "HERVEL"
				}
			],
			"plz": "58849"
		},
		"Stadtlohn": {
			"stations": [
				{
					"mstnr": "60240337",
					"date": "2015-06-10",
					"value": 126.66,
					"mstbez": "AH/33 -WENDFELD-"
				},
				{
					"mstnr": "63451025",
					"date": "2015-10-13",
					"value": 1,
					"mstbez": "WW.HUNDEWICK VM-05"
				}
			],
			"plz": "48703"
		},
		"Vlotho": {
			"stations": [
				{
					"mstnr": "106502566",
					"date": "2015-10-28",
					"value": 33.01,
					"mstbez": "VLWBG QU WINTERBG 1"
				},
				{
					"mstnr": "100791554",
					"date": "2015-10-28",
					"value": 37.01,
					"mstbez": "VLWS5 TB WESERSTRAS"
				}
			],
			"plz": "32602"
		},
		"Burbach": {
			"stations": [
				{
					"mstnr": "129700733",
					"date": "2015-04-14",
					"value": 9.43,
					"mstbez": "Gambach"
				}
			],
			"plz": "57299"
		},
		"Wesel": {
			"stations": [
				{
					"mstnr": "40200061",
					"date": "2015-10-20",
					"value": 20.33,
					"mstbez": "BISLICH NR 28"
				},
				{
					"mstnr": "40200905",
					"date": "2015-10-21",
					"value": 19.09,
					"mstbez": "BERGEN 177"
				},
				{
					"mstnr": "40200929",
					"date": "2015-10-22",
					"value": 12.13,
					"mstbez": "WESTERHEIDE 179"
				},
				{
					"mstnr": "42065343",
					"date": "2015-12-03",
					"value": 54.02,
					"mstbez": "LINEG_2727"
				},
				{
					"mstnr": "47200066",
					"date": "2015-09-08",
					"value": 24.41,
					"mstbez": "Haus Aap Br.15"
				},
				{
					"mstnr": "42016368",
					"date": "2015-12-03",
					"value": 52.02,
					"mstbez": "LINEG_1758"
				},
				{
					"mstnr": "47200066",
					"date": "2015-04-21",
					"value": 20.51,
					"mstbez": "Haus Aap Br.15"
				}
			],
			"plz": "46483"
		},
		"Holzwickede": {
			"stations": [
				{
					"mstnr": "94110219",
					"date": "2015-04-13",
					"value": 16.96,
					"mstbez": "Br Freibad Schöne"
				}
			],
			"plz": "59439"
		},
		"Bocholt": {
			"stations": [
				{
					"mstnr": "63111020",
					"date": "2015-10-28",
					"value": 52.42,
					"mstbez": "WW.LIEDERN-P08"
				},
				{
					"mstnr": "63111020",
					"date": "2015-04-21",
					"value": 61.52,
					"mstbez": "WW.LIEDERN-P08"
				},
				{
					"mstnr": "60230265",
					"date": "2015-12-08",
					"value": 29.63,
					"mstbez": "BO/26 -SPORK-"
				},
				{
					"mstnr": "60230058",
					"date": "2015-01-29",
					"value": 36.62,
					"mstbez": "BO/4 A -LOWICK-"
				}
			],
			"plz": "46395"
		},
		"Kerpen": {
			"stations": [
				{
					"mstnr": "279480015",
					"date": "2015-12-11",
					"value": 73.07,
					"mstbez": "Blatzheim2"
				},
				{
					"mstnr": "70304257",
					"date": "2015-08-17",
					"value": 73.96,
					"mstbez": "HAUS FORST 1/1994"
				},
				{
					"mstnr": "76672815",
					"date": "2015-04-14",
					"value": 0.5,
					"mstbez": "WW Sindorf Br V 277"
				},
				{
					"mstnr": "278541010",
					"date": "2015-10-12",
					"value": 0.5,
					"mstbez": "Kippe Berrenrath"
				},
				{
					"mstnr": "278543418",
					"date": "2015-10-13",
					"value": 0.5,
					"mstbez": "Weiler Berrenr."
				}
			],
			"plz": "50171"
		},
		"Mechernich": {
			"stations": [
				{
					"mstnr": "10409129",
					"date": "2015-11-18",
					"value": 74.4,
					"mstbez": "Mehlenb. Quelle 2D"
				},
				{
					"mstnr": "10409683",
					"date": "2015-04-16",
					"value": 81.04,
					"mstbez": "Rißdorfquelle"
				},
				{
					"mstnr": "10409105",
					"date": "2015-11-25",
					"value": 58.45,
					"mstbez": "Quelle Dützbenden"
				},
				{
					"mstnr": "10409105",
					"date": "2015-07-08",
					"value": 66.42,
					"mstbez": "Quelle Dützbenden"
				},
				{
					"mstnr": "10409105",
					"date": "2015-04-22",
					"value": 67.31,
					"mstbez": "Quelle Dützbenden"
				},
				{
					"mstnr": "11006936",
					"date": "2015-11-19",
					"value": 8.46,
					"mstbez": "Breitenbenden Zus"
				},
				{
					"mstnr": "10409087",
					"date": "2015-11-12",
					"value": 20.81,
					"mstbez": "Urfey Römerqu. 2"
				},
				{
					"mstnr": "10409129",
					"date": "2015-04-28",
					"value": 74.4,
					"mstbez": "Mehlenb. Quelle 2D"
				},
				{
					"mstnr": "11007023",
					"date": "2015-08-10",
					"value": 52.26,
					"mstbez": "Vussem Zus"
				},
				{
					"mstnr": "10409312",
					"date": "2015-06-17",
					"value": 37.37,
					"mstbez": "HAUSERBD. HAUPTFAS."
				},
				{
					"mstnr": "10409312",
					"date": "2015-10-27",
					"value": 35.87,
					"mstbez": "HAUSERBD. HAUPTFAS."
				},
				{
					"mstnr": "10203217",
					"date": "2015-06-15",
					"value": 37.86,
					"mstbez": "BLEIBUIR FLACH"
				},
				{
					"mstnr": "10203230",
					"date": "2015-06-15",
					"value": 77.5,
					"mstbez": "GLEHN FLACH"
				},
				{
					"mstnr": "10404338",
					"date": "2015-06-17",
					"value": 3.28,
					"mstbez": "Düttling Br. 3"
				},
				{
					"mstnr": "10404338",
					"date": "2015-10-27",
					"value": 3.59,
					"mstbez": "Düttling Br. 3"
				},
				{
					"mstnr": "10409129",
					"date": "2015-07-29",
					"value": 78.83,
					"mstbez": "Mehlenb. Quelle 2D"
				}
			],
			"plz": "53894"
		},
		"Kevelaer": {
			"stations": [
				{
					"mstnr": "80301010",
					"date": "2015-06-17",
					"value": 53.59,
					"mstbez": "ALTWETTENER WEG 249"
				},
				{
					"mstnr": "80301009",
					"date": "2015-10-12",
					"value": 65.1,
					"mstbez": "SCHULE       HY 248"
				},
				{
					"mstnr": "80302646",
					"date": "2015-06-15",
					"value": 46.06,
					"mstbez": "HOENSLAERSMÜHLE"
				},
				{
					"mstnr": "80301022",
					"date": "2015-08-25",
					"value": 58.46,
					"mstbez": "SCHRAEVELEN     250"
				},
				{
					"mstnr": "80301034",
					"date": "2015-06-17",
					"value": 0.13,
					"mstbez": "KLEINKEVELAER   251"
				}
			],
			"plz": "47623"
		},
		"Bestwig": {
			"stations": [
				{
					"mstnr": "99580093",
					"date": "2015-02-27",
					"value": 29.72,
					"mstbez": "Quelle Bestwig"
				}
			],
			"plz": "59909"
		},
		"Schwelm": {
			"stations": [
				{
					"mstnr": "59540837",
					"date": "2015-05-06",
					"value": 16.83,
					"mstbez": "Spedition Schulte"
				}
			],
			"plz": "58332"
		},
		"Emmerich": {
			"stations": [
				{
					"mstnr": "86532649",
					"date": "2015-11-19",
					"value": 2.99,
					"mstbez": "E WW VRASSELT EIII"
				},
				{
					"mstnr": "86532649",
					"date": "2015-06-23",
					"value": 2.94,
					"mstbez": "E WW VRASSELT EIII"
				},
				{
					"mstnr": "86530550",
					"date": "2015-06-18",
					"value": 9.18,
					"mstbez": "E WW EMMERICH EI"
				},
				{
					"mstnr": "86530550",
					"date": "2015-11-18",
					"value": 9.94,
					"mstbez": "E WW EMMERICH EI"
				},
				{
					"mstnr": "80301630",
					"date": "2015-09-30",
					"value": 0.13,
					"mstbez": "AUTOBAHN        311"
				},
				{
					"mstnr": "80301435",
					"date": "2015-09-02",
					"value": 65.1,
					"mstbez": "KA ELTEN        291"
				},
				{
					"mstnr": "80301423",
					"date": "2015-09-02",
					"value": 0.13,
					"mstbez": "SCHLOSSHOF      290"
				},
				{
					"mstnr": "80000046",
					"date": "2015-09-30",
					"value": 74.4,
					"mstbez": "EMMERICH      Nr 18"
				},
				{
					"mstnr": "80302660",
					"date": "2015-09-02",
					"value": 26.22,
					"mstbez": "ELTEN"
				}
			],
			"plz": "46446"
		},
		"Hürth": {
			"stations": [
				{
					"mstnr": "76544710",
					"date": "2015-07-29",
					"value": 1.33,
					"mstbez": "Deponie Ville 11"
				},
				{
					"mstnr": "278540910",
					"date": "2015-10-12",
					"value": 2.3,
					"mstbez": "Kippe Berrenrath"
				},
				{
					"mstnr": "278536610",
					"date": "2015-10-15",
					"value": 1.33,
					"mstbez": "Gotteshuelfe"
				},
				{
					"mstnr": "278536610",
					"date": "2015-10-15",
					"value": 0.5,
					"mstbez": "Gotteshuelfe"
				},
				{
					"mstnr": "278534910",
					"date": "2015-10-15",
					"value": 0.5,
					"mstbez": "Ki.Gotteshuelfe"
				},
				{
					"mstnr": "278534910",
					"date": "2015-10-15",
					"value": 1.33,
					"mstbez": "Ki.Gotteshuelfe"
				},
				{
					"mstnr": "70283618",
					"date": "2015-06-19",
					"value": 40.92,
					"mstbez": "LGD Hürth-Kalsch."
				}
			],
			"plz": "50354"
		},
		"Langenberg": {
			"stations": [
				{
					"mstnr": "20104224",
					"date": "2015-11-03",
					"value": 1.33,
					"mstbez": "49              LGD"
				}
			],
			"plz": "33449"
		},
		"Titz": {
			"stations": [
				{
					"mstnr": "218219210",
					"date": "2015-07-30",
					"value": 26.62,
					"mstbez": "Katzem"
				},
				{
					"mstnr": "218209319",
					"date": "2015-11-09",
					"value": 0.89,
					"mstbez": "Müntz"
				},
				{
					"mstnr": "218209319",
					"date": "2015-10-14",
					"value": 0.5,
					"mstbez": "Müntz"
				},
				{
					"mstnr": "218218618",
					"date": "2015-10-14",
					"value": 0.5,
					"mstbez": "Kirchtroisdorf"
				}
			],
			"plz": "52445"
		},
		"Dortmund": {
			"stations": [
				{
					"mstnr": "59130600",
					"date": "2015-06-22",
					"value": 1.33,
					"mstbez": "Huckarde 3II"
				},
				{
					"mstnr": "59130015",
					"date": "2015-10-20",
					"value": 1.33,
					"mstbez": "HOESCH DO BR.T4"
				},
				{
					"mstnr": "59130726",
					"date": "2015-07-07",
					"value": 1.33,
					"mstbez": "Buschmühle"
				},
				{
					"mstnr": "59130714",
					"date": "2015-10-26",
					"value": 20.15,
					"mstbez": "Martener Hellweg"
				},
				{
					"mstnr": "59130660",
					"date": "2015-03-24",
					"value": 1.33,
					"mstbez": "TIERGARTEN DO"
				},
				{
					"mstnr": "59130581",
					"date": "2015-10-21",
					"value": 1.33,
					"mstbez": "DO-Wickede RWI 1"
				},
				{
					"mstnr": "59130570",
					"date": "2015-07-07",
					"value": 1.33,
					"mstbez": "DO-Kurl RWI 2"
				},
				{
					"mstnr": "59130179",
					"date": "2015-06-23",
					"value": 1.33,
					"mstbez": "DO-Nordost P02/I"
				},
				{
					"mstnr": "59130556",
					"date": "2015-06-22",
					"value": 1.33,
					"mstbez": "DO-Grevel RWI 80"
				},
				{
					"mstnr": "59130465",
					"date": "2015-10-26",
					"value": 9.17,
					"mstbez": "DO-Eving RWI 5"
				},
				{
					"mstnr": "59130441",
					"date": "2015-06-08",
					"value": 31.49,
					"mstbez": "DO-Holthausen RWI26"
				},
				{
					"mstnr": "59130430",
					"date": "2015-06-08",
					"value": 1.33,
					"mstbez": "DO-Schwiergh. RWI25"
				}
			],
			"plz": "44135"
		},
		"Altenbeken": {
			"stations": [
				{
					"mstnr": "24190068",
					"date": "2015-10-26",
					"value": 14,
					"mstbez": "QU Apuhl-Quelle"
				},
				{
					"mstnr": "24180968",
					"date": "2015-12-03",
					"value": 16.52,
					"mstbez": "PB10 BadL Steinbeke"
				},
				{
					"mstnr": "24190068",
					"date": "2015-05-28",
					"value": 15.01,
					"mstbez": "QU Apuhl-Quelle"
				}
			],
			"plz": "33184"
		},
		"Hückelhoven": {
			"stations": [
				{
					"mstnr": "218673917",
					"date": "2015-10-15",
					"value": 29.71,
					"mstbez": "Brachelen"
				},
				{
					"mstnr": "219080215",
					"date": "2015-07-07",
					"value": 95.21,
					"mstbez": "Ratheim"
				},
				{
					"mstnr": "218149517",
					"date": "2015-04-08",
					"value": 0.5,
					"mstbez": "Baal"
				},
				{
					"mstnr": "218149517",
					"date": "2015-10-16",
					"value": 0.5,
					"mstbez": "Baal"
				},
				{
					"mstnr": "11002268",
					"date": "2015-03-26",
					"value": 50.93,
					"mstbez": "Brachelen Sp Pl"
				},
				{
					"mstnr": "219602610",
					"date": "2015-06-25",
					"value": 0.89,
					"mstbez": "Hilfarth"
				},
				{
					"mstnr": "218175917",
					"date": "2015-10-16",
					"value": 0.5,
					"mstbez": "Scherresbruch"
				}
			],
			"plz": "41836"
		},
		"Windeck": {
			"stations": [
				{
					"mstnr": "73725500",
					"date": "2015-03-23",
					"value": 16.65,
					"mstbez": "WBV WILBERHOFEN EB"
				},
				{
					"mstnr": "73725900",
					"date": "2015-03-19",
					"value": 1.33,
					"mstbez": "GUT OMMEROTH EB"
				},
				{
					"mstnr": "73725687",
					"date": "2015-03-19",
					"value": 1.55,
					"mstbez": "WBV GeilshsnStollen"
				},
				{
					"mstnr": "73725780",
					"date": "2015-03-23",
					"value": 17.54,
					"mstbez": "GEM.WINDECK"
				}
			],
			"plz": "51570"
		},
		"Büren": {
			"stations": [
				{
					"mstnr": "24180063",
					"date": "2015-10-05",
					"value": 26.13,
					"mstbez": "BR Boeddeken Bueren"
				}
			],
			"plz": "33142"
		},
		"Aachen, Stadt": {
			"stations": [
				{
					"mstnr": "10409701",
					"date": "2015-02-24",
					"value": 30.38,
					"mstbez": "Schlabergquell Hahn"
				},
				{
					"mstnr": "10203199",
					"date": "2015-03-12",
					"value": 45.61,
					"mstbez": "Ürsfeld"
				},
				{
					"mstnr": "10407388",
					"date": "2015-10-26",
					"value": 10.1,
					"mstbez": "EICHER STOLLEN"
				},
				{
					"mstnr": "10409051",
					"date": "2015-02-09",
					"value": 13.02,
					"mstbez": "Siebenquellen Süd"
				},
				{
					"mstnr": "10203187",
					"date": "2015-03-12",
					"value": 58.46,
					"mstbez": "Vetschau,Autobahnbr"
				},
				{
					"mstnr": "10407390",
					"date": "2015-04-15",
					"value": 2,
					"mstbez": "REICHSWALD BR. 1"
				},
				{
					"mstnr": "10407390",
					"date": "2015-10-27",
					"value": 2,
					"mstbez": "REICHSWALD BR. 1"
				},
				{
					"mstnr": "10409142",
					"date": "2015-02-09",
					"value": 16.7,
					"mstbez": "Siebenquellen Nord"
				},
				{
					"mstnr": "16003998",
					"date": "2015-02-11",
					"value": 23.96,
					"mstbez": "AC GOLF-CLUB BR/Peg"
				},
				{
					"mstnr": "10407406",
					"date": "2015-04-14",
					"value": 2.9,
					"mstbez": "BRANDENBURG_Brunnen"
				},
				{
					"mstnr": "10407406",
					"date": "2015-10-27",
					"value": 2,
					"mstbez": "BRANDENBURG_Brunnen"
				},
				{
					"mstnr": "10407418",
					"date": "2015-04-15",
					"value": 16.91,
					"mstbez": "SCHMITHOF Brunnen"
				},
				{
					"mstnr": "10300570",
					"date": "2015-03-23",
					"value": 6.78,
					"mstbez": "AACHEN KLINIKUM 7"
				},
				{
					"mstnr": "10407418",
					"date": "2015-10-26",
					"value": 16.21,
					"mstbez": "SCHMITHOF Brunnen"
				},
				{
					"mstnr": "10407388",
					"date": "2015-04-15",
					"value": 12.8,
					"mstbez": "EICHER STOLLEN"
				}
			],
			"plz": "52062"
		},
		"Kürten": {
			"stations": [
				{
					"mstnr": "76929310",
					"date": "2015-07-28",
					"value": 15.59,
					"mstbez": "ZANDERS BGL 5/98"
				},
				{
					"mstnr": "76809201",
					"date": "2015-03-31",
					"value": 1.33,
					"mstbez": "TUFFI SUELZ-EB"
				},
				{
					"mstnr": "73751789",
					"date": "2015-04-08",
					"value": 45.61,
					"mstbez": "WVS SUSEWIND QF"
				},
				{
					"mstnr": "73756507",
					"date": "2015-04-09",
					"value": 13.8,
					"mstbez": "WBV BECHEN EB I"
				},
				{
					"mstnr": "73756507",
					"date": "2015-09-21",
					"value": 12.3,
					"mstbez": "WBV BECHEN EB I"
				},
				{
					"mstnr": "73736806",
					"date": "2015-09-21",
					"value": 5,
					"mstbez": "WBV BECHEN EB V"
				},
				{
					"mstnr": "73736806",
					"date": "2015-04-09",
					"value": 5.3,
					"mstbez": "WBV BECHEN EB V"
				}
			],
			"plz": "51515"
		},
		"Stemwede": {
			"stations": [
				{
					"mstnr": "100140683",
					"date": "2015-05-21",
					"value": 84.59,
					"mstbez": "WG 62    BUTENBOHM"
				},
				{
					"mstnr": "100150020",
					"date": "2015-05-19",
					"value": 1.33,
					"mstbez": "AU 401   OPPENWEHE"
				},
				{
					"mstnr": "100151140",
					"date": "2015-05-21",
					"value": 3.63,
					"mstbez": "AU 512   SATLAGE"
				}
			],
			"plz": "32351"
		},
		"Warstein": {
			"stations": [
				{
					"mstnr": "94150450",
					"date": "2015-09-04",
					"value": 4.78,
					"mstbez": "Quelle Am Saukopf"
				},
				{
					"mstnr": "94160107",
					"date": "2015-10-29",
					"value": 16.01,
					"mstbez": "Bullerteichquelle"
				},
				{
					"mstnr": "94160107",
					"date": "2015-08-20",
					"value": 17.01,
					"mstbez": "Bullerteichquelle"
				},
				{
					"mstnr": "94160107",
					"date": "2015-09-24",
					"value": 16.01,
					"mstbez": "Bullerteichquelle"
				},
				{
					"mstnr": "94160107",
					"date": "2015-07-23",
					"value": 17.01,
					"mstbez": "Bullerteichquelle"
				},
				{
					"mstnr": "94160170",
					"date": "2015-09-23",
					"value": 33.61,
					"mstbez": "Br WLK Warstein"
				},
				{
					"mstnr": "94160107",
					"date": "2015-12-17",
					"value": 16.01,
					"mstbez": "Bullerteichquelle"
				},
				{
					"mstnr": "94160107",
					"date": "2015-04-29",
					"value": 14.7,
					"mstbez": "Bullerteichquelle"
				},
				{
					"mstnr": "94160170",
					"date": "2015-09-24",
					"value": 34.01,
					"mstbez": "Br WLK Warstein"
				},
				{
					"mstnr": "94160107",
					"date": "2015-11-19",
					"value": 16.01,
					"mstbez": "Bullerteichquelle"
				},
				{
					"mstnr": "94160107",
					"date": "2015-01-22",
					"value": 17.01,
					"mstbez": "Bullerteichquelle"
				}
			],
			"plz": "59581"
		},
		"Nideggen": {
			"stations": [
				{
					"mstnr": "10409397",
					"date": "2015-11-12",
					"value": 10.19,
					"mstbez": "Embken Quelle 6"
				},
				{
					"mstnr": "10409324",
					"date": "2015-06-08",
					"value": 50.49,
					"mstbez": "Quelle Gödersheim"
				},
				{
					"mstnr": "10409324",
					"date": "2015-03-16",
					"value": 46.06,
					"mstbez": "Quelle Gödersheim"
				},
				{
					"mstnr": "10409385",
					"date": "2015-03-16",
					"value": 8.06,
					"mstbez": "Embken Quelle 5"
				},
				{
					"mstnr": "10409385",
					"date": "2015-06-08",
					"value": 8.32,
					"mstbez": "Embken Quelle 5"
				},
				{
					"mstnr": "10409956",
					"date": "2015-02-18",
					"value": 34.81,
					"mstbez": "Eselbach-Quelle"
				},
				{
					"mstnr": "10409324",
					"date": "2015-11-03",
					"value": 46.5,
					"mstbez": "Quelle Gödersheim"
				},
				{
					"mstnr": "10409397",
					"date": "2015-06-08",
					"value": 12.04,
					"mstbez": "Embken Quelle 6"
				},
				{
					"mstnr": "10409397",
					"date": "2015-11-03",
					"value": 9.25,
					"mstbez": "Embken Quelle 6"
				},
				{
					"mstnr": "10203436",
					"date": "2015-04-23",
					"value": 62.44,
					"mstbez": "Nideggen,Pegel Tief"
				},
				{
					"mstnr": "10409348",
					"date": "2015-11-03",
					"value": 27.06,
					"mstbez": "Quelle Mühlbachtal"
				},
				{
					"mstnr": "10409385",
					"date": "2015-11-03",
					"value": 8.77,
					"mstbez": "Embken Quelle 5"
				},
				{
					"mstnr": "10409324",
					"date": "2015-11-12",
					"value": 43.75,
					"mstbez": "Quelle Gödersheim"
				},
				{
					"mstnr": "10409397",
					"date": "2015-03-16",
					"value": 10.31,
					"mstbez": "Embken Quelle 6"
				},
				{
					"mstnr": "10409336",
					"date": "2015-03-16",
					"value": 33.7,
					"mstbez": "Quelle Hohlbachtal"
				},
				{
					"mstnr": "10409336",
					"date": "2015-06-08",
					"value": 35.16,
					"mstbez": "Quelle Hohlbachtal"
				},
				{
					"mstnr": "10409336",
					"date": "2015-11-03",
					"value": 34.01,
					"mstbez": "Quelle Hohlbachtal"
				},
				{
					"mstnr": "10409348",
					"date": "2015-03-16",
					"value": 27.19,
					"mstbez": "Quelle Mühlbachtal"
				},
				{
					"mstnr": "10409348",
					"date": "2015-06-08",
					"value": 26.39,
					"mstbez": "Quelle Mühlbachtal"
				}
			],
			"plz": "52385"
		},
		"Herne": {
			"stations": [
				{
					"mstnr": "59160184",
					"date": "2015-06-09",
					"value": 4.31,
					"mstbez": "THYSSEN GE BR 7/II"
				},
				{
					"mstnr": "59160147",
					"date": "2015-06-09",
					"value": 1.33,
					"mstbez": "Herne 206"
				},
				{
					"mstnr": "59160123",
					"date": "2015-10-19",
					"value": 1.33,
					"mstbez": "Herne 198"
				},
				{
					"mstnr": "59160093",
					"date": "2015-06-15",
					"value": 1.33,
					"mstbez": "Herne 157"
				},
				{
					"mstnr": "59160068",
					"date": "2015-06-15",
					"value": 1.33,
					"mstbez": "Herne G1/21"
				}
			],
			"plz": "44623"
		},
		"Duisburg": {
			"stations": [
				{
					"mstnr": "42063681",
					"date": "2015-03-13",
					"value": 49.02,
					"mstbez": "LINEG_2570H"
				},
				{
					"mstnr": "42063670",
					"date": "2015-03-12",
					"value": 12.3,
					"mstbez": "LINEG_2569H"
				},
				{
					"mstnr": "42063656",
					"date": "2015-03-12",
					"value": 0.05,
					"mstbez": "LINEG_2567H"
				},
				{
					"mstnr": "42063632",
					"date": "2015-03-10",
					"value": 1.89,
					"mstbez": "LINEG_2565H"
				},
				{
					"mstnr": "42063607",
					"date": "2015-03-11",
					"value": 23.31,
					"mstbez": "LINEG_2562H"
				},
				{
					"mstnr": "42063437",
					"date": "2015-04-22",
					"value": 1.23,
					"mstbez": "LINEG_2549H"
				},
				{
					"mstnr": "42063334",
					"date": "2015-03-24",
					"value": 49.02,
					"mstbez": "LINEG_2539H"
				},
				{
					"mstnr": "42063310",
					"date": "2015-03-10",
					"value": 34.01,
					"mstbez": "LINEG_2537H"
				},
				{
					"mstnr": "40061383",
					"date": "2015-12-02",
					"value": 25.91,
					"mstbez": "DUISSERN NR 53"
				},
				{
					"mstnr": "40606107",
					"date": "2015-12-01",
					"value": 39.15,
					"mstbez": "Sermer Str."
				},
				{
					"mstnr": "42013800",
					"date": "2015-01-15",
					"value": 19.51,
					"mstbez": "LINEG_1523"
				}
			],
			"plz": "47051"
		},
		"Borchen": {
			"stations": [
				{
					"mstnr": "24180026",
					"date": "2015-03-18",
					"value": 25.51,
					"mstbez": "QU Gellinghausen"
				},
				{
					"mstnr": "24180087",
					"date": "2015-03-18",
					"value": 30.96,
					"mstbez": "Storchenquelle"
				},
				{
					"mstnr": "24180865",
					"date": "2015-10-07",
					"value": 33.7,
					"mstbez": "PB 5     Borchen"
				}
			],
			"plz": "33178"
		},
		"Bedburg-Hau": {
			"stations": [
				{
					"mstnr": "80301691",
					"date": "2015-09-09",
					"value": 68.64,
					"mstbez": "SCHNEPPENBAUM   317"
				},
				{
					"mstnr": "80301678",
					"date": "2015-09-09",
					"value": 29.98,
					"mstbez": "HUISBERDEN      315"
				},
				{
					"mstnr": "80303316",
					"date": "2015-09-11",
					"value": 117.8,
					"mstbez": "LOUISENDORF     394"
				}
			],
			"plz": "47551"
		},
		"Bergneustadt": {
			"stations": [
				{
					"mstnr": "76809500",
					"date": "2015-03-30",
					"value": 11.16,
					"mstbez": "ITT AUTOM.BERGNEUST"
				},
				{
					"mstnr": "73775605",
					"date": "2015-04-07",
					"value": 5.36,
					"mstbez": "WG NEUENOTHE"
				}
			],
			"plz": "51702"
		},
		"Heiden": {
			"stations": [
				{
					"mstnr": "60220028",
					"date": "2015-01-30",
					"value": 77.94,
					"mstbez": "HS/2 -NORDICK-"
				}
			],
			"plz": "46359"
		},
		"Langerwehe": {
			"stations": [
				{
					"mstnr": "10408782",
					"date": "2015-05-04",
					"value": 4.2,
					"mstbez": "WENAU BR. 3 Rohw."
				}
			],
			"plz": "52379"
		},
		"Neukirchen-Vluyn": {
			"stations": [
				{
					"mstnr": "42065367",
					"date": "2015-11-11",
					"value": 12,
					"mstbez": "LINEG_2729-1"
				},
				{
					"mstnr": "40200504",
					"date": "2015-06-01",
					"value": 68.02,
					"mstbez": "NEUKIRCHEN NR 121"
				},
				{
					"mstnr": "42062329",
					"date": "2015-03-19",
					"value": 1.38,
					"mstbez": "LINEG_2442"
				},
				{
					"mstnr": "42062329",
					"date": "2015-09-17",
					"value": 1.4,
					"mstbez": "LINEG_2442"
				},
				{
					"mstnr": "42062329",
					"date": "2015-11-11",
					"value": 0.38,
					"mstbez": "LINEG_2442"
				}
			],
			"plz": "47506"
		},
		"Zülpich": {
			"stations": [
				{
					"mstnr": "215988711",
					"date": "2015-10-13",
					"value": 76.93,
					"mstbez": "Duerschev"
				},
				{
					"mstnr": "219974317",
					"date": "2015-11-23",
					"value": 22.19,
					"mstbez": "Enzen    2"
				},
				{
					"mstnr": "10409415",
					"date": "2015-02-24",
					"value": 77.94,
					"mstbez": "Aldericusquelle"
				}
			],
			"plz": "53909"
		},
		"Halver": {
			"stations": [
				{
					"mstnr": "59620134",
					"date": "2015-03-30",
					"value": 15.94,
					"mstbez": "LANGLOTZ"
				}
			],
			"plz": "58553"
		},
		"Olfen": {
			"stations": [
				{
					"mstnr": "110210189",
					"date": "2015-05-08",
					"value": 1.33,
					"mstbez": "ST.GEB/18 Sülsen"
				},
				{
					"mstnr": "110210177",
					"date": "2015-10-29",
					"value": 37.02,
					"mstbez": "ST.GEB/17 -OLFEN-"
				},
				{
					"mstnr": "110220924",
					"date": "2015-10-27",
					"value": 3.52,
					"mstbez": "HS/92 EVERSUM"
				}
			],
			"plz": "59399"
		},
		"Borgholzhausen": {
			"stations": [
				{
					"mstnr": "26502392",
					"date": "2015-03-23",
					"value": 1,
					"mstbez": "T1 Hamlingdorf"
				},
				{
					"mstnr": "26502392",
					"date": "2015-09-21",
					"value": 1,
					"mstbez": "T1 Hamlingdorf"
				},
				{
					"mstnr": "20161517",
					"date": "2015-06-30",
					"value": 19.62,
					"mstbez": "W 9     Werth Barnh"
				},
				{
					"mstnr": "20104327",
					"date": "2015-06-30",
					"value": 8.77,
					"mstbez": "VI/8 LGD BHH Casum"
				}
			],
			"plz": "33829"
		},
		"Olpe": {
			"stations": [
				{
					"mstnr": "129660073",
					"date": "2015-04-21",
					"value": 6.95,
					"mstbez": "Dornbusch"
				}
			],
			"plz": "57462"
		},
		"Lindlar": {
			"stations": [
				{
					"mstnr": "73774807",
					"date": "2015-03-31",
					"value": 11.25,
					"mstbez": "WVG Schmitzhöhe EB"
				}
			],
			"plz": "51789"
		},
		"Gummersbach": {
			"stations": [
				{
					"mstnr": "73775381",
					"date": "2015-03-30",
					"value": 22.81,
					"mstbez": "WG WASSERFUHR"
				}
			],
			"plz": "51643"
		},
		"Vettweiß": {
			"stations": [
				{
					"mstnr": "219974214",
					"date": "2015-09-04",
					"value": 85.47,
					"mstbez": "Kettenheim"
				},
				{
					"mstnr": "219972310",
					"date": "2015-09-01",
					"value": 0.89,
					"mstbez": "Ginnick  2"
				},
				{
					"mstnr": "210404553",
					"date": "2015-11-03",
					"value": 87.68,
					"mstbez": "Lüxheim Br. 6"
				},
				{
					"mstnr": "210404553",
					"date": "2015-09-14",
					"value": 89.89,
					"mstbez": "Lüxheim Br. 6"
				},
				{
					"mstnr": "210404553",
					"date": "2015-06-08",
					"value": 86.35,
					"mstbez": "Lüxheim Br. 6"
				},
				{
					"mstnr": "210404530",
					"date": "2015-03-16",
					"value": 64.21,
					"mstbez": "Lüxheim Br. 4"
				},
				{
					"mstnr": "210404553",
					"date": "2015-03-16",
					"value": 82.37,
					"mstbez": "Lüxheim Br. 6"
				},
				{
					"mstnr": "210404530",
					"date": "2015-09-14",
					"value": 66.86,
					"mstbez": "Lüxheim Br. 4"
				},
				{
					"mstnr": "210404530",
					"date": "2015-06-08",
					"value": 66.86,
					"mstbez": "Lüxheim Br. 4"
				},
				{
					"mstnr": "219971614",
					"date": "2015-09-23",
					"value": 74.84,
					"mstbez": "Sievernich"
				},
				{
					"mstnr": "11005154",
					"date": "2015-08-24",
					"value": 85.91,
					"mstbez": "Jakobwülles Zus693"
				},
				{
					"mstnr": "210404530",
					"date": "2015-11-03",
					"value": 69.08,
					"mstbez": "Lüxheim Br. 4"
				}
			],
			"plz": "52391"
		},
		"Aldenhoven": {
			"stations": [
				{
					"mstnr": "218639016",
					"date": "2015-07-14",
					"value": 85.02,
					"mstbez": "Duerboslar"
				},
				{
					"mstnr": "218639016",
					"date": "2015-10-14",
					"value": 84.63,
					"mstbez": "Duerboslar"
				}
			],
			"plz": "52457"
		},
		"Laer": {
			"stations": [
				{
					"mstnr": "110040259",
					"date": "2015-04-30",
					"value": 1.33,
					"mstbez": "IV/25 LAER Parkpl."
				}
			],
			"plz": "48366"
		},
		"Wachtendonk": {
			"stations": [
				{
					"mstnr": "80301848",
					"date": "2015-10-02",
					"value": 39.99,
					"mstbez": "SCHARENBERG     332"
				}
			],
			"plz": "47669"
		},
		"Ruppichteroth": {
			"stations": [
				{
					"mstnr": "73726280",
					"date": "2015-03-24",
					"value": 2.7,
					"mstbez": "WLV VELKEN QF"
				},
				{
					"mstnr": "73726382",
					"date": "2015-12-18",
					"value": 17.49,
					"mstbez": "HUWIL-WERKE"
				},
				{
					"mstnr": "73726000",
					"date": "2015-03-24",
					"value": 13.11,
					"mstbez": "IFANG EB"
				},
				{
					"mstnr": "73726680",
					"date": "2015-10-23",
					"value": 17.63,
					"mstbez": "GIESSELBACH QF"
				}
			],
			"plz": "53809"
		},
		"Kamp-Lintfort": {
			"stations": [
				{
					"mstnr": "42060620",
					"date": "2015-12-04",
					"value": 31.01,
					"mstbez": "LINEG_2216H"
				},
				{
					"mstnr": "42065604",
					"date": "2015-12-14",
					"value": 11,
					"mstbez": "LINEG_2748-1H"
				},
				{
					"mstnr": "42065264",
					"date": "2015-12-09",
					"value": 45.02,
					"mstbez": "LINEG_2719"
				}
			],
			"plz": "47475"
		},
		"Fröndenberg": {
			"stations": [
				{
					"mstnr": "94120330",
					"date": "2015-05-26",
					"value": 32.02,
					"mstbez": "KA Frömern"
				}
			],
			"plz": "58730"
		},
		"Lübbecke": {
			"stations": [
				{
					"mstnr": "100706617",
					"date": "2015-05-19",
					"value": 1,
					"mstbez": "HE 3  BR HEDEM"
				},
				{
					"mstnr": "100701541",
					"date": "2015-06-17",
					"value": 1,
					"mstbez": "LG 3  BR GEHLENBECK"
				},
				{
					"mstnr": "100700238",
					"date": "2015-10-22",
					"value": 47.02,
					"mstbez": "LK 3  BR LUEBBECKE"
				},
				{
					"mstnr": "100700238",
					"date": "2015-04-21",
					"value": 51.02,
					"mstbez": "LK 3  BR LUEBBECKE"
				},
				{
					"mstnr": "106503730",
					"date": "2015-04-21",
					"value": 19.01,
					"mstbez": "BLAS3 QU BLASHEI1-5"
				},
				{
					"mstnr": "100701541",
					"date": "2015-10-22",
					"value": 1,
					"mstbez": "LG 3  BR GEHLENBECK"
				},
				{
					"mstnr": "100706617",
					"date": "2015-11-10",
					"value": 1,
					"mstbez": "HE 3  BR HEDEM"
				}
			],
			"plz": "32312"
		},
		"Heiligenhaus": {
			"stations": [
				{
					"mstnr": "36462767",
					"date": "2015-09-16",
					"value": 0.13,
					"mstbez": "SW Rati. Homberg H9"
				}
			],
			"plz": "42579"
		},
		"Brühl": {
			"stations": [
				{
					"mstnr": "70156116",
					"date": "2015-06-09",
					"value": 1.95,
					"mstbez": "LGD PINGSDORF NEU"
				}
			],
			"plz": "50321"
		},
		"Kempen": {
			"stations": [
				{
					"mstnr": "86591459",
					"date": "2015-11-16",
					"value": 28.21,
					"mstbez": "E St.Hubert Br.1"
				},
				{
					"mstnr": "80302520",
					"date": "2015-12-03",
					"value": 50.04,
					"mstbez": "KEMPEN KINDERGARTEN"
				},
				{
					"mstnr": "80302063",
					"date": "2015-11-19",
					"value": 48.27,
					"mstbez": "KAMPERLINGS"
				},
				{
					"mstnr": "80301861",
					"date": "2015-10-13",
					"value": 0.53,
					"mstbez": "WALL SCHULE     334"
				},
				{
					"mstnr": "86591459",
					"date": "2015-04-28",
					"value": 26.01,
					"mstbez": "E St.Hubert Br.1"
				},
				{
					"mstnr": "80303377",
					"date": "2015-11-19",
					"value": 2.3,
					"mstbez": "KEMPEN  BADEZENTRUM"
				},
				{
					"mstnr": "80303389",
					"date": "2015-10-13",
					"value": 0.13,
					"mstbez": "ST.HUBERT    SCHULE"
				},
				{
					"mstnr": "80300364",
					"date": "2015-09-25",
					"value": 70.86,
					"mstbez": "STEVESHOF"
				}
			],
			"plz": "47906"
		},
		"Raesfeld": {
			"stations": [
				{
					"mstnr": "60220478",
					"date": "2015-12-17",
					"value": 7.09,
					"mstbez": "HS/47 -OESTRICH-"
				}
			],
			"plz": "46348"
		},
		"Halle (Westf.)": {
			"stations": [
				{
					"mstnr": "20780370",
					"date": "2015-09-01",
					"value": 2,
					"mstbez": "BR 7 Bokel"
				},
				{
					"mstnr": "21000049",
					"date": "2015-07-02",
					"value": 34.59,
					"mstbez": "603 LGD Halle"
				},
				{
					"mstnr": "20780369",
					"date": "2015-03-05",
					"value": 27.01,
					"mstbez": "BR 6A Tatenhausen"
				}
			],
			"plz": "33790"
		},
		"Weeze": {
			"stations": [
				{
					"mstnr": "80303201",
					"date": "2015-08-26",
					"value": 77.06,
					"mstbez": "MARIENWASSERWEG 383"
				},
				{
					"mstnr": "80100697",
					"date": "2015-09-08",
					"value": 68.64,
					"mstbez": "WEEZE GUT HEES   01"
				},
				{
					"mstnr": "80300935",
					"date": "2015-09-01",
					"value": 0.13,
					"mstbez": "SCHILBERGSHOF   241"
				}
			],
			"plz": "47652"
		},
		"Ostbevern": {
			"stations": [
				{
					"mstnr": "110040200",
					"date": "2015-12-03",
					"value": 124.44,
					"mstbez": "IV/20 -OSTBEVERN-"
				}
			],
			"plz": "48346"
		},
		"Lichtenau": {
			"stations": [
				{
					"mstnr": "24190032",
					"date": "2015-10-20",
					"value": 15.01,
					"mstbez": "QU Altenautal-Blind"
				},
				{
					"mstnr": "24190123",
					"date": "2015-10-20",
					"value": 15.01,
					"mstbez": "SM Herbram Br1,2,4"
				},
				{
					"mstnr": "24190251",
					"date": "2015-05-27",
					"value": 14,
					"mstbez": "Br Kleinenbg-Lichte"
				},
				{
					"mstnr": "24190147",
					"date": "2015-05-27",
					"value": 2,
					"mstbez": "B2 Blankenrode"
				},
				{
					"mstnr": "24190147",
					"date": "2015-10-20",
					"value": 2,
					"mstbez": "B2 Blankenrode"
				},
				{
					"mstnr": "21190707",
					"date": "2015-10-07",
					"value": 19.04,
					"mstbez": "OL744 Licht Hakenb"
				},
				{
					"mstnr": "24190123",
					"date": "2015-05-27",
					"value": 18.01,
					"mstbez": "SM Herbram Br1,2,4"
				},
				{
					"mstnr": "24190251",
					"date": "2015-10-20",
					"value": 13,
					"mstbez": "Br Kleinenbg-Lichte"
				}
			],
			"plz": "33165"
		},
		"Eschweiler": {
			"stations": [
				{
					"mstnr": "10301574",
					"date": "2015-03-23",
					"value": 25.51,
					"mstbez": "Eschwlr. Ringofen1"
				},
				{
					"mstnr": "10409063",
					"date": "2015-12-18",
					"value": 37.73,
					"mstbez": "Quelle Kinzweiler"
				},
				{
					"mstnr": "10404491",
					"date": "2015-09-14",
					"value": 2.7,
					"mstbez": "Hastenrath  Br. 6"
				},
				{
					"mstnr": "218643615",
					"date": "2015-10-14",
					"value": 24.21,
					"mstbez": "Tgb. Inden"
				},
				{
					"mstnr": "218677315",
					"date": "2015-10-14",
					"value": 21.81,
					"mstbez": "Frenz"
				},
				{
					"mstnr": "218677315",
					"date": "2015-04-09",
					"value": 18.81,
					"mstbez": "Frenz"
				},
				{
					"mstnr": "10404491",
					"date": "2015-05-18",
					"value": 0.5,
					"mstbez": "Hastenrath  Br. 6"
				},
				{
					"mstnr": "10404491",
					"date": "2015-12-14",
					"value": 0.5,
					"mstbez": "Hastenrath  Br. 6"
				}
			],
			"plz": "52249"
		},
		"Rees": {
			"stations": [
				{
					"mstnr": "80303559",
					"date": "2015-09-30",
					"value": 25.95,
					"mstbez": "MILLINGEN HAUPTSTR"
				}
			],
			"plz": "46459"
		},
		"Bochum": {
			"stations": [
				{
					"mstnr": "59110302",
					"date": "2015-05-06",
					"value": 30.07,
					"mstbez": "FIEGE"
				},
				{
					"mstnr": "59110340",
					"date": "2015-08-04",
					"value": 9.7,
					"mstbez": "Hermannshöhe"
				},
				{
					"mstnr": "59110363",
					"date": "2015-06-17",
					"value": 5.27,
					"mstbez": "Dahlhausen92_03"
				},
				{
					"mstnr": "59110168",
					"date": "2015-06-17",
					"value": 27.68,
					"mstbez": "B3 Paul Müller Str"
				}
			],
			"plz": "44787"
		},
		"Petershagen": {
			"stations": [
				{
					"mstnr": "106530033",
					"date": "2015-03-31",
					"value": 103.19,
					"mstbez": "PHG43 -8,0m ML"
				},
				{
					"mstnr": "106530021",
					"date": "2015-03-31",
					"value": 128.43,
					"mstbez": "PHG43 -6,0m ML"
				},
				{
					"mstnr": "106530045",
					"date": "2015-03-31",
					"value": 77.5,
					"mstbez": "PHG43-10,0m ML"
				},
				{
					"mstnr": "104004046",
					"date": "2015-04-09",
					"value": 51.37,
					"mstbez": "K 7.1 M  SAD Münhg"
				},
				{
					"mstnr": "106503613",
					"date": "2015-03-26",
					"value": 1,
					"mstbez": "OV 2 BR  OVENSTAEDT"
				},
				{
					"mstnr": "106530057",
					"date": "2015-03-31",
					"value": 46.94,
					"mstbez": "PHG43-12,0m ML"
				},
				{
					"mstnr": "106520027",
					"date": "2015-04-13",
					"value": 2.79,
					"mstbez": "PH1003T Im TIMPEN"
				},
				{
					"mstnr": "106520015",
					"date": "2015-04-13",
					"value": 39.9,
					"mstbez": "PH1003F Im TIMPEN"
				},
				{
					"mstnr": "106530239",
					"date": "2015-04-23",
					"value": 49.16,
					"mstbez": "PH46N-10,0m ML"
				},
				{
					"mstnr": "106530203",
					"date": "2015-04-23",
					"value": 101.86,
					"mstbez": "PH46N -5,0m ML"
				},
				{
					"mstnr": "106503613",
					"date": "2015-09-24",
					"value": 1,
					"mstbez": "OV 2 BR  OVENSTAEDT"
				},
				{
					"mstnr": "106530215",
					"date": "2015-04-23",
					"value": 50.04,
					"mstbez": "PH46N -6,5m ML"
				},
				{
					"mstnr": "100135626",
					"date": "2015-04-09",
					"value": 108.5,
					"mstbez": "PH 25N   OVENSTAEDT"
				},
				{
					"mstnr": "100135559",
					"date": "2015-04-09",
					"value": 1.33,
					"mstbez": "PH 40A   BIERD FELD"
				},
				{
					"mstnr": "100135560",
					"date": "2015-04-08",
					"value": 19.71,
					"mstbez": "PH 7N    ROEHDEN"
				},
				{
					"mstnr": "100720341",
					"date": "2015-02-23",
					"value": 28.01,
					"mstbez": "PW 4 BR  WIETERSHM"
				},
				{
					"mstnr": "100720341",
					"date": "2015-03-26",
					"value": 29.01,
					"mstbez": "PW 4 BR  WIETERSHM"
				},
				{
					"mstnr": "100720341",
					"date": "2015-04-13",
					"value": 28.01,
					"mstbez": "PW 4 BR  WIETERSHM"
				},
				{
					"mstnr": "100720341",
					"date": "2015-05-12",
					"value": 29.01,
					"mstbez": "PW 4 BR  WIETERSHM"
				},
				{
					"mstnr": "100720341",
					"date": "2015-06-05",
					"value": 29.01,
					"mstbez": "PW 4 BR  WIETERSHM"
				},
				{
					"mstnr": "100720341",
					"date": "2015-10-20",
					"value": 27.01,
					"mstbez": "PW 4 BR  WIETERSHM"
				},
				{
					"mstnr": "100720341",
					"date": "2015-07-13",
					"value": 30.01,
					"mstbez": "PW 4 BR  WIETERSHM"
				},
				{
					"mstnr": "100720341",
					"date": "2015-09-24",
					"value": 29.01,
					"mstbez": "PW 4 BR  WIETERSHM"
				},
				{
					"mstnr": "100135596",
					"date": "2015-04-09",
					"value": 17.4,
					"mstbez": "PH 28N   HAEVERN"
				},
				{
					"mstnr": "100135602",
					"date": "2015-04-09",
					"value": 4.61,
					"mstbez": "PH 34N   JOESSEN"
				},
				{
					"mstnr": "100135614",
					"date": "2015-04-23",
					"value": 50.04,
					"mstbez": "PH46N -ML WIET HEID"
				},
				{
					"mstnr": "100720341",
					"date": "2015-12-11",
					"value": 30.01,
					"mstbez": "PW 4 BR  WIETERSHM"
				},
				{
					"mstnr": "100135640",
					"date": "2015-04-16",
					"value": 1.33,
					"mstbez": "WF 1T   OVENSTAEDT"
				},
				{
					"mstnr": "100135651",
					"date": "2015-04-16",
					"value": 281.21,
					"mstbez": "WF 1F   OVENSTAEDT"
				},
				{
					"mstnr": "100720341",
					"date": "2015-08-10",
					"value": 32.01,
					"mstbez": "PW 4 BR  WIETERSHM"
				},
				{
					"mstnr": "100140750",
					"date": "2015-04-16",
					"value": 1.33,
					"mstbez": "WG 69    FRIEDEWALD"
				},
				{
					"mstnr": "100135468",
					"date": "2015-03-31",
					"value": 31.97,
					"mstbez": "PH 43 ML FRILLE"
				},
				{
					"mstnr": "100720341",
					"date": "2015-11-26",
					"value": 30.01,
					"mstbez": "PW 4 BR  WIETERSHM"
				},
				{
					"mstnr": "100140762",
					"date": "2015-04-16",
					"value": 34.41,
					"mstbez": "WG 70    TAPPENAU"
				},
				{
					"mstnr": "100135213",
					"date": "2015-04-08",
					"value": 69.53,
					"mstbez": "PH 18    GRO HEERSE"
				},
				{
					"mstnr": "100135158",
					"date": "2015-04-08",
					"value": 1.33,
					"mstbez": "PH 12    HEIMSEN"
				},
				{
					"mstnr": "100135031",
					"date": "2015-04-13",
					"value": 54.47,
					"mstbez": "PH1003M  IM TIMPEN"
				},
				{
					"mstnr": "100140774",
					"date": "2015-04-16",
					"value": 3.28,
					"mstbez": "WG 71    MAASLINGEN"
				},
				{
					"mstnr": "100135067",
					"date": "2015-04-08",
					"value": 12.31,
					"mstbez": "PH 3n    VORB KANAL"
				}
			],
			"plz": "32469"
		},
		"Wenden": {
			"stations": [
				{
					"mstnr": "129660589",
					"date": "2015-04-21",
					"value": 1.33,
					"mstbez": "Tuckerschlade"
				},
				{
					"mstnr": "129660139",
					"date": "2015-04-27",
					"value": 1.33,
					"mstbez": "Muhr I"
				}
			],
			"plz": "57482"
		},
		"Borgentreich": {
			"stations": [
				{
					"mstnr": "22520223",
					"date": "2015-07-16",
					"value": 76.61,
					"mstbez": "Bo4 Borgentreich"
				}
			],
			"plz": "34434"
		}
	};

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	module.exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 18.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n<svg version=\"1.1\" id=\"Align_bottom\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\"\n\t y=\"0px\" viewBox=\"0 0 20 20\" enable-background=\"new 0 0 20 20\" xml:space=\"preserve\">\n<path d=\"M13,11h-2V3H9v8H7l3,3L13,11z M17.4,15H2.6C2.048,15,2,15.447,2,16c0,0.553,0.048,1,0.6,1H17.4c0.552,0,0.6-0.447,0.6-1\n\tC18,15.447,17.952,15,17.4,15z\"/>\n</svg>\n"

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	module.exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 18.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n<svg version=\"1.1\" id=\"Align_top\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 20 20\" enable-background=\"new 0 0 20 20\" xml:space=\"preserve\">\n<path d=\"M10,6L7,9h2v8h2V9h2L10,6z M18,4c0-0.553-0.048-1-0.6-1H2.6C2.048,3,2,3.447,2,4c0,0.553,0.048,1,0.6,1H17.4\n\tC17.952,5,18,4.553,18,4z\"/>\n</svg>\n"

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	module.exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 18.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n<svg version=\"1.1\" id=\"Arrow_long_down\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\"\n\t y=\"0px\" viewBox=\"0 0 20 20\" enable-background=\"new 0 0 20 20\" xml:space=\"preserve\">\n<path d=\"M10,19.25L4.5,14H8V1h4v13h3.5L10,19.25z\"/>\n</svg>\n"

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	module.exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 18.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n<svg version=\"1.1\" id=\"Arrow_long_up\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\"\n\t y=\"0px\" viewBox=\"0 0 20 20\" enable-background=\"new 0 0 20 20\" xml:space=\"preserve\">\n<path d=\"M10,0.75L15.5,6H12v13H8V6H4.5L10,0.75z\"/>\n</svg>\n"

/***/ }),
/* 48 */
/***/ (function(module, exports) {

	module.exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 18.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n<svg version=\"1.1\" id=\"Cycle\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 20 20\" enable-background=\"new 0 0 20 20\" xml:space=\"preserve\">\n<path d=\"M5.516,14.224c-2.262-2.432-2.222-6.244,0.128-8.611c0.962-0.969,2.164-1.547,3.414-1.736L8.989,1.8\n\tC7.234,2.013,5.537,2.796,4.192,4.151c-3.149,3.17-3.187,8.289-0.123,11.531l-1.741,1.752l5.51,0.301l-0.015-5.834L5.516,14.224z\n\t M12.163,2.265l0.015,5.834l2.307-2.322c2.262,2.434,2.222,6.246-0.128,8.611c-0.961,0.969-2.164,1.547-3.414,1.736l0.069,2.076\n\tc1.755-0.213,3.452-0.996,4.798-2.35c3.148-3.172,3.186-8.291,0.122-11.531l1.741-1.754L12.163,2.265z\"/>\n</svg>\n"

/***/ }),
/* 49 */
/***/ (function(module, exports) {

	module.exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\r\n<!-- Generator: Adobe Illustrator 18.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\r\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\r\n<svg version=\"1.1\" id=\"Info_circled\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\"\r\n\t y=\"0px\" viewBox=\"0 0 20 20\" enable-background=\"new 0 0 20 20\" xml:space=\"preserve\">\r\n<path d=\"M10,0.4c-5.303,0-9.601,4.298-9.601,9.6c0,5.303,4.298,9.601,9.601,9.601c5.301,0,9.6-4.298,9.6-9.601\r\n\tC19.6,4.698,15.301,0.4,10,0.4z M10.896,3.866c0.936,0,1.211,0.543,1.211,1.164c0,0.775-0.62,1.492-1.679,1.492\r\n\tc-0.886,0-1.308-0.445-1.282-1.182C9.146,4.719,9.665,3.866,10.896,3.866z M8.498,15.75c-0.64,0-1.107-0.389-0.66-2.094l0.733-3.025\r\n\tc0.127-0.484,0.148-0.678,0-0.678c-0.191,0-1.022,0.334-1.512,0.664L6.74,10.094c1.555-1.299,3.343-2.061,4.108-2.061\r\n\tc0.64,0,0.746,0.756,0.427,1.92l-0.84,3.18c-0.149,0.562-0.085,0.756,0.064,0.756c0.192,0,0.82-0.232,1.438-0.719l0.362,0.486\r\n\tC10.786,15.168,9.137,15.75,8.498,15.75z\"/>\r\n</svg>\r\n"

/***/ }),
/* 50 */
/***/ (function(module, exports) {

	module.exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\r\n<!-- Generator: Adobe Illustrator 18.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\r\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\r\n<svg version=\"1.1\" id=\"Squared_cross\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\"\r\n\t y=\"0px\" viewBox=\"0 0 20 20\" enable-background=\"new 0 0 20 20\" xml:space=\"preserve\">\r\n<path d=\"M16,2H4C2.9,2,2,2.9,2,4v12c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2V4C18,2.9,17.1,2,16,2z M13.061,14.789L10,11.729\r\n\tl-3.061,3.06l-1.729-1.728L8.271,10L5.211,6.939l1.729-1.729L10,8.271l3.059-3.061l1.729,1.729L11.729,10l3.06,3.061L13.061,14.789z\r\n\t\"/>\r\n</svg>\r\n"

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle-85bb64a2b33d06665a5e.js